import { GraphQLClient } from "graphql-request";
import * as Dom from "graphql-request/dist/types.dom";
import { print } from "graphql";
import gql from "graphql-tag";
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  IdempotencyKey: any;
  UnsignedInt: any;
};

/** Informational fields included in an ACH transfer. */
export type AchDescriptor = {
  __typename?: "ACHDescriptor";
  /** Company entered value for the type of ACH. */
  companyEntryDescription?: Maybe<Scalars["String"]>;
  /** Receiver’s identification number set by the bank initiating the ACH entry. */
  individualIdentificationNumber?: Maybe<Scalars["String"]>;
  /**
   * Receiver’s individual name set by the bank initiating the ACH entry.
   *
   * This could be a person or a business.
   */
  individualName?: Maybe<Scalars["String"]>;
};

/** Input for fields describing an ACH transfer. */
export type AchDescriptorInput = {
  /**
   * Company entered value for the type of ACH.
   *
   * It can be at most 10 characters. The characters should be alphanumeric.
   */
  companyEntryDescription: Scalars["String"];
  /**
   * Receiver’s identification number set by the bank initiating the ACH entry.
   *
   * This can be at most 15 characters. The characters should be alphanumeric.
   */
  individualIdentificationNumber?: InputMaybe<Scalars["String"]>;
  /**
   * Receiver’s individual name set by the bank initiating the ACH entry.
   *
   * This could be a person or a business. It can be at most 22 characters. The characters should be alphanumeric.
   */
  individualName: Scalars["String"];
};

/**
 * The connection type for ACH Transaction.
 * Deprecated.
 */
export type AchTransactionConnection = {
  __typename?: "ACHTransactionConnection";
  /**
   * A list of edges.
   * @deprecated ACHTransactionConnection is deprecated in favor of IntegratorInitiatedACHTransferConnection and/or ExternallyInitiatedACHTransferConnection.
   */
  edges?: Maybe<Array<AchTransactionEdge>>;
  /**
   * Information about the current page.
   * @deprecated ACHTransactionConnection is deprecated in favor of IntegratorInitiatedACHTransferConnection and/or ExternallyInitiatedACHTransferConnection.
   */
  pageInfo: PageInfo;
};

/**
 * The edge type for a ACH Transaction.
 * Deprecated.
 */
export type AchTransactionEdge = {
  __typename?: "ACHTransactionEdge";
  /**
   * The cursor for this edge for use in pagination.
   * @deprecated ACHTransactionEdge is deprecated in favor of IntegratorInitiatedACHTransferEdge and/or ExternallyInitiatedACHTransferEdge.
   */
  cursor: Scalars["String"];
  /**
   * The ACH Transaction.
   * @deprecated ACHTransactionEdge is deprecated in favor of IntegratorInitiatedACHTransferEdge and/or ExternallyInitiatedACHTransferEdge.
   */
  node?: Maybe<AchTransactionEdgeNode>;
};

export type AchTransactionEdgeNode =
  | IntegratorInitiatedFundsDepositAchTransfer
  | IntegratorInitiatedFundsWithdrawalAchTransfer
  | SecureCardBalanceRepaymentAchTransfer
  | SecureDepositAchTransfer;

/** A financial event that represents an ACH transfer. */
export type AchTransferEvent = {
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** Company entered value for the type of ACH. */
  companyEntryDescription?: Maybe<Scalars["String"]>;
  /**
   * The Company Identifier is a 10-position alphameric code used to identify an Originator of the ACH transaction. It may begin with an ANSI one-digit Identification Code Designator (ICD), followed by the Identification Number.
   *
   * |`Identification Code Designator (ICD)`    | `ANSI Identification Number` | Example                                                                         |
   * | ---------------------------------------- | ---------------------------- | ------------------------------------------------------------------------------- |
   * |`IRS Employer Identification Number (EIN)`| 1                            | 1234567890 for an Originator with 234567890 EIN                                 |
   * |`Data Universal Numbering Systems (DUNS)` | 3                            | 30008016958 for an Originator with 0008016958 DUNS                              |
   * |`User Assigned Number`                    | 9                            | 9111111111 for an Originator with 111111111 under assigned Identification Number|
   */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /** The name of the company that initiated the ACH transfer. */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the transfer in operations. */
  id: Scalars["ID"];
  /** The date this transaction was returned, in ISO 8601 format. */
  returnDate?: Maybe<Scalars["String"]>;
  /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
  settlementDate?: Maybe<Scalars["String"]>;
};

/** Status of an integrator initiated ACH transfer that has been generated by Highnote. */
export enum AchTransferStatus {
  /** You requested to cancel the transfer. */
  CANCELED = "CANCELED",
  /** The transfer failed. Additional details are available in ACHTransferStatusCode. */
  FAILED = "FAILED",
  /** A transfer request has been initiated. */
  INITIATED = "INITIATED",
  /** The transfer has successfully been processed by the bank and funds are available. */
  PROCESSED = "PROCESSED",
  /** The transfer is processing at Highnote and at the bank, but funds are not available yet. */
  PROCESSING = "PROCESSING",
  /** The transfer has been returned by the bank. */
  RETURNED = "RETURNED",
}

/** Details about the status of the ACH transfer. */
export type AchTransferStatusDetails =
  | FailureAchTransferStatus
  | NonFailureAchTransferStatus;

/** Additional details regarding a FAILED or RETURNED transfer. */
export enum AchTransferStatusReasonCode {
  /** R11 - The `fromFinancialAccount` and `toFinancialAccount` do not belong to the same product. */
  ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT = "ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT",
  /** R16 - The account is frozen. */
  ACCOUNT_FROZEN = "ACCOUNT_FROZEN",
  /** R11 - Loading funds via ACH is not supported by this program. */
  ACH_LOAD_NOT_SUPPORTED = "ACH_LOAD_NOT_SUPPORTED",
  /** R19 - There is an error in the amount field. */
  AMOUNT_FIELD_ERROR = "AMOUNT_FIELD_ERROR",
  /** R07 - The Authorization was revoked by Customer. */
  AUTHORIZATION_REVOKED_BY_CUSTOMER = "AUTHORIZATION_REVOKED_BY_CUSTOMER",
  /** R11 - The account does not have the required corporate bank account feature enabled. */
  CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED = "CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED",
  /** The amount of the transfer does not match the currency of the Highnote account. */
  CURRENCY_MISMATCH_WITH_HIGHNOTE_ACCOUNT = "CURRENCY_MISMATCH_WITH_HIGHNOTE_ACCOUNT",
  /** R24 - Resulted in a Duplicate Entry. */
  DUPLICATE_ENTRY = "DUPLICATE_ENTRY",
  /** R11 - The transfer is not in accordance with the terms of the authorization. */
  ENTRY_NOT_IN_ACCORDANCE_WITH_TERMS_OF_AUTHORIZATION = "ENTRY_NOT_IN_ACCORDANCE_WITH_TERMS_OF_AUTHORIZATION",
  /** R02 - The external account has been closed. */
  EXTERNAL_ACCOUNT_CLOSED = "EXTERNAL_ACCOUNT_CLOSED",
  /** R03 - No matching external account was found. */
  EXTERNAL_ACCOUNT_NOT_FOUND = "EXTERNAL_ACCOUNT_NOT_FOUND",
  /** R02 - The Highnote account has been closed. */
  HIGHNOTE_ACCOUNT_CLOSED = "HIGHNOTE_ACCOUNT_CLOSED",
  /** R03 - No matching Highnote account was found. */
  HIGHNOTE_ACCOUNT_NOT_FOUND = "HIGHNOTE_ACCOUNT_NOT_FOUND",
  /** R18 - Has an Improper Effective entry date. */
  IMPROPER_EFFECTIVE_ENTRY_DATE = "IMPROPER_EFFECTIVE_ENTRY_DATE",
  /** R01 - This was a debit from an en external account did not have enough funds. */
  INSUFFICIENT_FUNDS_IN_EXTERNAL_ACCOUNT = "INSUFFICIENT_FUNDS_IN_EXTERNAL_ACCOUNT",
  /** R01 - This was a debit from an account at Highnote which did not have enough funds. */
  INSUFFICIENT_FUNDS_IN_HIGHNOTE_ACCOUNT = "INSUFFICIENT_FUNDS_IN_HIGHNOTE_ACCOUNT",
  /** There is an internal error with the transfer. */
  INTERNAL_ERROR = "INTERNAL_ERROR",
  /** R04 - Has an Invalid Account Number. */
  INVALID_ACCOUNT_NUMBER = "INVALID_ACCOUNT_NUMBER",
  /** R21 - Has an Invalid Company ID Number. */
  INVALID_COMPANY_ID_NUMBER = "INVALID_COMPANY_ID_NUMBER",
  /** R22 - Has an Invalid Individual ID Number. */
  INVALID_INDIVIDUAL_ID_NUMBER = "INVALID_INDIVIDUAL_ID_NUMBER",
  /** R20 - Is a Non Transactional Account. */
  NON_TRANSACTION_ACCOUNT = "NON_TRANSACTION_ACCOUNT",
  /** R08 - The Payment was stopped. */
  PAYMENT_STOPPED = "PAYMENT_STOPPED",
  /** R11 - The account does not have the required payroll advance feature enabled. */
  PAYROLL_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED",
  /** R11 - The account does not have the required payroll employer advance feature enabled. */
  PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED",
  /** R06 - Funds were returned per OFDI Request. */
  RETURNED_PER_ODFI_REQUEST = "RETURNED_PER_ODFI_REQUEST",
  /** R11 - The account does not have the required secure card feature enabled. */
  SECURE_CARD_FEATURE_NOT_ENABLED = "SECURE_CARD_FEATURE_NOT_ENABLED",
  /** R29 - The Transaction was not Authorized By Account Holder. */
  TRANSACTION_NOT_AUTHORIZED_BY_ACCOUNT_HOLDER = "TRANSACTION_NOT_AUTHORIZED_BY_ACCOUNT_HOLDER",
  /** R11 - The transfer amount is below the minimum amount to reload. */
  TRANSFER_AMOUNT_BELOW_MIN_RELOAD_LIMIT = "TRANSFER_AMOUNT_BELOW_MIN_RELOAD_LIMIT",
  /** R11 - The transfer exceeds maximum the load limit. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_LOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_LOAD_LIMIT",
  /** R11 - The transfer exceeds the maximum reload limit. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_RELOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_RELOAD_LIMIT",
  /** R05 - Is an Unauthorized Debit to Consumer Account Using Corporate SEC Code. */
  UNAUTHORIZED_CONSUMER_DEBIT_USING_CORPORATE_SEC_CODE = "UNAUTHORIZED_CONSUMER_DEBIT_USING_CORPORATE_SEC_CODE",
  /** R10 - Is an Unauthorized, Improper, Ineligible, or Incomplete Transaction. */
  UNAUTHORIZED_IMPROPER_INELIGIBLE_OR_INCOMPLETE_TRANSACTION = "UNAUTHORIZED_IMPROPER_INELIGIBLE_OR_INCOMPLETE_TRANSACTION",
  /** R09 - Transaction represents Uncollected Funds. */
  UNCOLLECTED_FUNDS = "UNCOLLECTED_FUNDS",
}

/** Details of an API Key. */
export type ApiKey = Node & {
  __typename?: "APIKey";
  /** The date and time, in ISO 8601 format, the API Key was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID */
  id: Scalars["ID"];
  /** Non-redacted, secret value. Will only be present after the initial call to create the API Key. */
  key?: Maybe<Scalars["String"]>;
  /** Name given to the API Key. */
  name?: Maybe<Scalars["String"]>;
  /** Redacted, or masked, secret value. */
  redactedKey?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the API Key was revoked. */
  revokedAt?: Maybe<Scalars["String"]>;
};

/** The connection type for APIKey. */
export type ApiKeyConnection = {
  __typename?: "APIKeyConnection";
  /** A list of edges. */
  edges?: Maybe<Array<ApiKeyEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for an APIKey. */
export type ApiKeyEdge = {
  __typename?: "APIKeyEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The API key. */
  node?: Maybe<ApiKey>;
};

/** Location details for an ATM (Automated Teller Machine). */
export type AtmLocation = {
  __typename?: "ATMLocation";
  /** The physical address of the ATM. */
  address?: Maybe<Address>;
  /** The coordinates of the ATM. */
  coordinates?: Maybe<Coordinates>;
  /** A description representing details about the ATM. */
  description?: Maybe<Scalars["String"]>;
  /** The relative distance of the ATM. */
  distance?: Maybe<Distance>;
  /** Features available at the ATM. */
  features?: Maybe<Array<AtmLocationFeature>>;
  /** Details about the ATM location logo. */
  logo?: Maybe<AtmLocationLogoDetails>;
  /** The name of the ATM. */
  name?: Maybe<Scalars["String"]>;
};

/** Brands of different ATM providers. */
export enum AtmLocationBrand {
  /** An ATM that is powered by Money Pass. */
  MONEY_PASS = "MONEY_PASS",
}

/** Features available at an ATM Location. */
export enum AtmLocationFeature {
  /** The ATM is accessible. */
  ACCESSIBLE = "ACCESSIBLE",
  /** The ATM can accept monetary deposits. */
  DEPOSIT_AVAILABLE = "DEPOSIT_AVAILABLE",
  /** The ATM is open 24 hours a day. */
  OPEN_24_HOURS = "OPEN_24_HOURS",
}

/** Filters the ATM Locations by available features per location. */
export type AtmLocationFilterInput = {
  includes?: InputMaybe<Array<AtmLocationFeature>>;
};

/** Details about the ATM location Logo. */
export type AtmLocationLogoDetails = {
  __typename?: "ATMLocationLogoDetails";
  /** The brand of the ATM location. */
  brand?: Maybe<AtmLocationBrand>;
};

/** Details to search for ATM Locations by Radius. */
export type AtmLocationRadiusInput = {
  coordinates: CoordinatesInput;
  distance: DistanceInput;
};

/** Details to search for ATM Locations by Viewport. */
export type AtmLocationViewportInput = {
  coordinates: ViewportCoordinatesInput;
};

/** A result of ATM locations for a Payment Card. */
export type AtmLocations = {
  __typename?: "ATMLocations";
  /** A list of ATM locations. */
  atmLocations?: Maybe<Array<AtmLocation>>;
};

/** Code representing the result of AVS address verification */
export enum AvsResponseCode {
  /** The address provided on the authorization matched the address on file for the Cardholder. */
  MATCH = "MATCH",
  /**
   * The check was not performed.
   *
   * Typically, this happens when an address is provided on the authorization, but we are unable to locate the same value in our vault.
   */
  NOT_PERFORMED = "NOT_PERFORMED",
  /** The address was not provided during authorization. */
  NOT_PROVIDED = "NOT_PROVIDED",
  /** The address provided on the authorization did not match an address on file for the Cardholder. */
  NO_MATCH = "NO_MATCH",
}

/** Input for filtering AVS response code */
export type AvsResponseCodeFilterInput = {
  /** Value matches the provided AVS response code */
  equals?: InputMaybe<AvsResponseCode>;
  /** Value does not match any of the provided AVS response code */
  excludes?: InputMaybe<Array<AvsResponseCode>>;
  /** Value exactly matches all of the provided AVS response code */
  includes?: InputMaybe<Array<AvsResponseCode>>;
  /** Value does not match the provided AVS response code */
  notEquals?: InputMaybe<AvsResponseCode>;
};

/** The input to accept an extended `AccountHolderCardProductApplicationOffer` on an `AccountHolderCardProductApplication` */
export type AcceptAccountHolderCardProductApplicationOfferInput = {
  /** Global ID of the `AccountHolderCardProductApplication` */
  applicationId: Scalars["ID"];
  /** The AccountHolder's consent and acceptance to the offer agreement. */
  consentAgreement: ConsentInput;
  /** The ID of the `AccountHolderCardProductApplicationOffer` to accept. */
  offerId: Scalars["ID"];
};

/** The Accepted Counter Offer input */
export type AcceptCounterOfferInput = {
  /** The AccountHolder's consent and acceptance to the counter offer agreement. */
  consentAgreement: ConsentInput;
  /** The ID of the offer to accept. */
  offerIdentifier: Scalars["String"];
};

/** The error type surfaced when you do not have permissions to access a field. */
export type AccessDeniedError = {
  __typename?: "AccessDeniedError";
  /** A human-readable message detailing the error. */
  message: Scalars["String"];
};

/**
 * All the possible states that could prevent a `FinancialAccount` from being
 * closed.
 */
export enum AccountClosureBlocker {
  /**
   * The account holder has funds remaining on their `FinancialAccount` and money
   * is due to the account holder. Required ledgers on the account must be $0 for
   * the `FinancialAccount` to close.
   */
  ACCOUNT_BALANCE_PAYABLE = "ACCOUNT_BALANCE_PAYABLE",
  /**
   * The account holder has funds remaining on their `FinancialAccount` and money
   * is owed by the account holder. Required ledgers on the account must be $0 for
   * the `FinancialAccount` to close.
   */
  ACCOUNT_BALANCE_RECEIVABLE = "ACCOUNT_BALANCE_RECEIVABLE",
  /** The `FinancialAccount` has one or more active authorized user financial accounts. */
  ACTIVE_AUTHORIZED_USER_ACCOUNTS = "ACTIVE_AUTHORIZED_USER_ACCOUNTS",
  /** The `FinancialAccount` has an active Military Lending Act notice. */
  ACTIVE_MLA = "ACTIVE_MLA",
  /**
   * The `FinancialAccount` has an active `PaymentCard`. All `PaymentCard`s
   * associated with the `FinancialAccount` should have a `PaymentCardStatus` of
   * `SUSPENDED` or `CLOSED`.
   */
  ACTIVE_PAYMENT_CARD = "ACTIVE_PAYMENT_CARD",
  /** The `FinancialAccount` has an active Servicemembers Civil Relief Act notice. */
  ACTIVE_SCRA = "ACTIVE_SCRA",
  /**
   * There is no `ExternalFinancialAccount` available to transfer funds out to.
   * The `owner` of the `FinancialAccount` must have at least one value in
   * its `externalFinancialAccounts` field.
   *
   * This is currently only supported for `USPersonAccountHolder` and
   * `USBusinessAccountHolder` type owners.
   */
  NO_EXTERNAL_FINANCIAL_ACCOUNT = "NO_EXTERNAL_FINANCIAL_ACCOUNT",
  /**
   * The line of credit for this `FinancialAccount` has not been closed.
   * The 'ACCOUNT_HOLDER_CREDIT_LIMIT' `Ledger` has a non-zero balance.
   */
  OPEN_LINE_OF_CREDIT = "OPEN_LINE_OF_CREDIT",
  /** The `FinancialAccount` has an outstanding payroll advance. There is a nonzero balance on the `PAYROLL_ADVANCE_PAYABLE` ledger. */
  PAYROLL_ADVANCE_PAYABLE = "PAYROLL_ADVANCE_PAYABLE",
  /**
   * There is a pending authorization on the `FinancialAccount`. At least one of
   * the 'AUTH', 'DEPOSIT_AUTH', 'REFUND_AUTH', or 'FEE_AUTH' `Ledger`s has a non
   * zero balance.
   */
  PENDING_AUTHORIZATION = "PENDING_AUTHORIZATION",
  /**
   * The `FinancialAccount` has a pending `ElectronicFundsTransfer` in progress.
   * Accounts can be closed when all transfers are in a terminal state, such as
   * `PROCESSED` or `FAILED`.
   */
  PENDING_TRANSFER = "PENDING_TRANSFER",
  /**
   * The `FinancialAccount` has a pseudo balance.
   * There is a non-zero balance on one of the following ledgers: `PSEUDO_CASH`, `PSEUDO_AVAILABLE_CASH`, `PSEUDO_AVAILABLE_CREDIT`, `PSEUDO_CREDIT_OUTSTANDING`.
   */
  PSEUDO_BALANCE = "PSEUDO_BALANCE",
  /**
   * There is a risk hold on an `ElectronicFundsTransfer` associated with this `FinancialAccount`.
   * The 'RISK_HOLD' `Ledger` has a non-zero balance.
   */
  RISK_HOLD = "RISK_HOLD",
  /**
   * There is a scheduled `ElectronicFundsTransfer` on the account. The
   * `ElectronicFundsTransfer` could be either a one time transfer or a recurring
   * transfer.
   */
  SCHEDULED_TRANSFER = "SCHEDULED_TRANSFER",
}

/** Account holder types */
export type AccountHolder =
  | Organization
  | UsBusinessAccountHolder
  | UsPersonAccountHolder;

/** An uploaded document for an application */
export type AccountHolderApplicationDocument = Node & {
  __typename?: "AccountHolderApplicationDocument";
  /** The date and time, in ISO 8601 format, this `application document` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The given reasons for the file review status. */
  fileReviewReasons?: Maybe<Array<ApplicationDocumentReviewReason>>;
  /** The ID of the document uploaded */
  id: Scalars["ID"];
  /** Revisions on the applicant's document */
  revisions?: Maybe<Array<Maybe<AccountHolderApplicationDocumentRevision>>>;
  /** The status of the document uploaded by the applicant */
  status?: Maybe<ApplicationDocumentUploadStatus>;
  /** The document type uploaded */
  type?: Maybe<DocumentType>;
  /** The date and time, in ISO 8601 format, this `application document` was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** A revision of an uploaded document for an application */
export type AccountHolderApplicationDocumentRevision = {
  __typename?: "AccountHolderApplicationDocumentRevision";
  /** The date and time, in ISO 8601 format, this `application document revision` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The given reasons for the file review status. */
  fileReviewReasons?: Maybe<Array<ApplicationDocumentReviewReason>>;
  /** The status of the document uploaded by the applicant */
  status?: Maybe<ApplicationDocumentUploadStatus>;
  /** The document type uploaded */
  type?: Maybe<DocumentType>;
  /** The date and time, in ISO 8601 format, this `application document revision` was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** A context describing the impact of a `DocumentType` presented on the `USAccountHolderApplicationDocumentUploadSession` to the `AccountHolderVerificationResultCode`s */
export type AccountHolderApplicationDocumentToVerificationResultCodeContext = {
  __typename?: "AccountHolderApplicationDocumentToVerificationResultCodeContext";
  /** A list of entries representing the `DocumentType` to `AccountHolderVerificationResultCode` mapping. */
  entries?: Maybe<
    Array<AccountHolderApplicationDocumentToVerificationResultCodeEntry>
  >;
};

/** An entry providing a list of `AccountHolderVerificationResultCode`s that a `DocumentType` would address. */
export type AccountHolderApplicationDocumentToVerificationResultCodeEntry = {
  __typename?: "AccountHolderApplicationDocumentToVerificationResultCodeEntry";
  /** A requested `DocumentType` */
  document?: Maybe<DocumentType>;
  /** A list of `AccountHolderVerificationResultCode`s */
  verificationResultCodes?: Maybe<Array<AccountHolderVerificationResultCode>>;
};

/** Return types for an account holder application document upload session */
export type AccountHolderApplicationDocumentUploadSession =
  UsAccountHolderApplicationDocumentUploadSession;

/** A document upload session context for an Account Holder's Application */
export type AccountHolderApplicationDocumentUploadSessionContext = {
  __typename?: "AccountHolderApplicationDocumentUploadSessionContext";
  /** A context representing the relationship between the documents requested to be uploaded and the `AccountHolderVerificationResultCode`s presented during the Application process. */
  documentVerificationResultCodeContext?: Maybe<AccountHolderApplicationDocumentToVerificationResultCodeContext>;
  /** A context representing the relationship between the `AccountHolderVerificationResultCode`s presented during the Application process and the documents requested. */
  verificationResultCodeDocumentContext?: Maybe<AccountHolderApplicationVerificationResultCodeToDocumentContext>;
};

/** A document upload for an account holder application */
export type AccountHolderApplicationRequiredDocument = {
  __typename?: "AccountHolderApplicationRequiredDocument";
  /** The date and time, in ISO 8601 format, this `application document` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** A document upload session */
  documentUploadSession?: Maybe<AccountHolderApplicationDocumentUploadSession>;
  /**
   * A reference identifier for the account holder application document session
   * **Note: ** This is not a Global ID
   */
  referenceIdentifier?: Maybe<Scalars["ID"]>;
  /** The status of the application's document upload session */
  status?: Maybe<ApplicationDocumentUploadSessionStatus>;
  /** The date and time, in ISO 8601 format, this `application document` was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** Documents submitted for the application */
  uploadedDocuments?: Maybe<Array<Maybe<ApplicationDocument>>>;
};

/** A type representing a state of the account holder application. */
export type AccountHolderApplicationState = {
  __typename?: "AccountHolderApplicationState";
  /** Status of application. */
  status: AccountHolderApplicationStatusCode;
};

/** Inputs for filtering Application Status data. */
export type AccountHolderApplicationStateInput = {
  /** Value matches the provided Application Status */
  equals?: InputMaybe<AccountHolderApplicationStatusCode>;
  /** Value does not match any of the provided Application Status */
  excludes?: InputMaybe<Array<AccountHolderApplicationStatusCode>>;
  /** Value exactly matches any of the provided Application Status */
  includes?: InputMaybe<Array<AccountHolderApplicationStatusCode>>;
  /** Value does not match the provided Application Status */
  notEquals?: InputMaybe<AccountHolderApplicationStatusCode>;
};

/** High-level account holder application states. */
export enum AccountHolderApplicationStatusCode {
  /** The application was approved. */
  APPROVED = "APPROVED",
  /** The application was closed. */
  CLOSED = "CLOSED",
  /** The application was denied. */
  DENIED = "DENIED",
  /** The application requires further review. */
  IN_REVIEW = "IN_REVIEW",
  /** The application is currently being processed. */
  PENDING = "PENDING",
}

/** A context describing the impact of a `AccountHolderVerificationResultCode` on the requested `DocumentType`s presented on the `USAccountHolderApplicationDocumentUploadSession` */
export type AccountHolderApplicationVerificationResultCodeToDocumentContext = {
  __typename?: "AccountHolderApplicationVerificationResultCodeToDocumentContext";
  /** A list of entries representing the `AccountHolderVerificationResultCode` to `DocumentType` mapping. */
  entries?: Maybe<
    Array<AccountHolderApplicationVerificationResultCodeToDocumentEntry>
  >;
};

/** An entry providing a list of `DocumentType`s that address the `AccountHolderVerificationResultCode` */
export type AccountHolderApplicationVerificationResultCodeToDocumentEntry = {
  __typename?: "AccountHolderApplicationVerificationResultCodeToDocumentEntry";
  /** A list of `DocumentType` */
  documents?: Maybe<Array<DocumentType>>;
  /** The `AccountHolderVerificationResultCode` on the `AccountHolderCardProductApplication` */
  verificationResultCode?: Maybe<AccountHolderVerificationResultCode>;
};

/** An AccountHolderCardProductApplication. */
export type AccountHolderCardProductApplication = Node & {
  __typename?: "AccountHolderCardProductApplication";
  /** The account holder's data at the time of application. */
  accountHolderSnapshot?: Maybe<AccountHolderSnapshot>;
  /** A prioritized list of Adverse Action Reasons explaining the Application Deal. */
  adverseActionReasons?: Maybe<Array<AdverseActionReason>>;
  /**
   * Optional application-level configuration provided by the applicant at the start of the application,
   * such as billing cycle preferences.
   */
  applicationConfiguration?: Maybe<ApplicationConfiguration>;
  /** The Denial Reason for an Application */
  applicationDenialReason?: Maybe<ApplicationDenialReason>;
  /** Past states of the application */
  applicationHistory?: Maybe<AccountHolderCardProductApplicationSnapshotConnection>;
  /** The current state of the application. */
  applicationState?: Maybe<AccountHolderApplicationState>;
  /** The workflows this application must go through before reaching the APPROVED state */
  applicationWorkflows?: Maybe<Array<ProductApplicationWorkflow>>;
  /** The Card Product to which the account holder is applying. */
  cardProduct?: Maybe<CardProduct>;
  /** The date and time, in ISO 8601 format, the application was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Fields that were verified in response to a fraud alert on the applicant's credit report. Only present in the case of a fraud alert. */
  creditReportFraudAlertVerificationResult?: Maybe<CreditReportFraudAlertVerificationResult>;
  /** The date and time, in ISO 8601 format, the application was decisioned. */
  decisionedAt?: Maybe<Scalars["String"]>;
  /** The approximate date and time, in ISO 8601 format, the application is set to expire if not decisioned. */
  expiresAt?: Maybe<Scalars["String"]>;
  /**
   * The financial accounts associated with this account holder application.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  financialAccounts?: Maybe<FinancialAccountConnection>;
  /** All global notes for this `AccountHolderCardProductApplication`. */
  globalNotes?: Maybe<GlobalNoteConnectionPayload>;
  /** Global ID used to reference the application in operations. */
  id: Scalars["ID"];
  /**
   * A paginated list of `AccountHolderCardProductApplicationOffer` associated with the `AccountHolderCardProductApplication`
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  offers?: Maybe<AccountHolderCardProductApplicationOfferConnection>;
  /**
   * Previous editions of this application that have since been replaced through the reevaluation process
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  previousApplications?: Maybe<PreviousProductApplicationConnection>;
  /** Indicates the number of reevaluations this application has gone through */
  reevaluationEdition?: Maybe<Scalars["UnsignedInt"]>;
  /**
   * If a reevaluation has taken place, this will be the application that existed prior to this one.
   * Otherwise this will be undefined.
   */
  sourceApplication?: Maybe<AccountHolderCardProductApplication>;
  /** The date and time, in ISO 8601 format, the application was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** An AccountHolderCardProductApplication. */
export type AccountHolderCardProductApplicationApplicationHistoryArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** An AccountHolderCardProductApplication. */
export type AccountHolderCardProductApplicationFinancialAccountsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<AccountHolderFinancialAccountsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** An AccountHolderCardProductApplication. */
export type AccountHolderCardProductApplicationGlobalNotesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** An AccountHolderCardProductApplication. */
export type AccountHolderCardProductApplicationOffersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<AccountHolderCardProductApplicationOfferFilterByInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** An AccountHolderCardProductApplication. */
export type AccountHolderCardProductApplicationPreviousApplicationsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<PreviousProductApplicationFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The connection type for AccountHolderCardProductApplication. */
export type AccountHolderCardProductApplicationConnection = {
  __typename?: "AccountHolderCardProductApplicationConnection";
  /** A list of edges. */
  edges?: Maybe<Array<AccountHolderCardProductApplicationEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for an `AccountHolderCardProductApplication`. */
export type AccountHolderCardProductApplicationEdge = {
  __typename?: "AccountHolderCardProductApplicationEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The account holder card product application. */
  node?: Maybe<AccountHolderCardProductApplication>;
};

/** An Offer associated with an `AccountHolderCardProductApplication`. */
export type AccountHolderCardProductApplicationOffer = Node & {
  __typename?: "AccountHolderCardProductApplicationOffer";
  /** The offer category */
  category?: Maybe<CardProductApplicationOfferCategory>;
  /** The global ID used to reference the `AccountHolderCardProductApplicationOffer`. */
  id: Scalars["ID"];
  /** The offer name. */
  name?: Maybe<Scalars["String"]>;
  /** The offer status. */
  status?: Maybe<CardProductApplicationOfferStatus>;
};

/** The connection type for `AccountHolderCardProductApplicationOffer`. */
export type AccountHolderCardProductApplicationOfferConnection = {
  __typename?: "AccountHolderCardProductApplicationOfferConnection";
  /** A list of edges. */
  edges?: Maybe<Array<AccountHolderCardProductApplicationOfferEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** An edge for `AccountHolderCardProductApplicationOffer` */
export type AccountHolderCardProductApplicationOfferEdge = {
  __typename?: "AccountHolderCardProductApplicationOfferEdge";
  /** The cursor for this edge for use in pagination. */
  cursor?: Maybe<Scalars["String"]>;
  /** The node representing an `AccountHolderCardProductApplicationOffer`. */
  node?: Maybe<AccountHolderCardProductApplicationOffer>;
};

/** Input to filter a paginated search for `AccountHolderCardProductApplicationOffer`. */
export type AccountHolderCardProductApplicationOfferFilterByInput = {
  /** A offer status filter input */
  offerStatus: CardProductApplicationOfferStatusFilterInput;
};

/** The response type for updating `AccountHolderCardProductApplicationOffer` on an `AccountHolderCardProductApplication`. */
export type AccountHolderCardProductApplicationOffersPayload =
  | AccessDeniedError
  | AccountHolderCardProductApplication
  | UserError;

/** An AccountHolderCardProductApplicationSnapshot. */
export type AccountHolderCardProductApplicationSnapshot = {
  __typename?: "AccountHolderCardProductApplicationSnapshot";
  /** The account holder's data at the time of application. */
  accountHolderSnapshot?: Maybe<AccountHolderSnapshot>;
  /** A list of Adverse Action Reasons explaining the Application Denial. */
  adverseActionReasons?: Maybe<Array<AdverseActionReason>>;
  /** The current state of the application. */
  applicationState: AccountHolderApplicationState;
  /** The Card Product to which the account holder is applying. */
  cardProduct?: Maybe<CardProduct>;
  /** The date and time, in ISO 8601 format, the application was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the application was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The connection type for AccountHolderCardProductApplicationSnapshot. */
export type AccountHolderCardProductApplicationSnapshotConnection = {
  __typename?: "AccountHolderCardProductApplicationSnapshotConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AccountHolderCardProductApplicationSnapshotEdge>>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for an AccountHolderCardProductApplicationSnapshot. */
export type AccountHolderCardProductApplicationSnapshotEdge = {
  __typename?: "AccountHolderCardProductApplicationSnapshotEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The Account Holder Card Product Application Snapshot. */
  node?: Maybe<AccountHolderCardProductApplicationSnapshot>;
};

/** The connection type for AccountHolder. */
export type AccountHolderConnection = {
  __typename?: "AccountHolderConnection";
  /** A list of edges. */
  edges?: Maybe<Array<AccountHolderEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for an `AccountHolder`. */
export type AccountHolderEdge = {
  __typename?: "AccountHolderEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The account holder. */
  node?: Maybe<AccountHolder>;
};

/** Inputs for filtering business account holder data. */
export type AccountHolderFinancialAccountsFilterInput = {
  /** The id of the card product associated with a Financial Account */
  cardProductId?: InputMaybe<StringFilterInput>;
  /** The date and time, in ISO 8601 format, the Financial Account was created. */
  createdAt?: InputMaybe<TimestampFilterInput>;
  /** The `CustomFields` associated with the Financial Account. */
  customFields?: InputMaybe<CustomFieldsFilterInput>;
  /** The externalId associated with a Financial Account */
  externalId?: InputMaybe<StringFilterInput>;
  /** The list of features for a Financial Account. */
  features?: InputMaybe<FinancialAccountFeatureTypeFilterInput>;
  /**
   * Used to search using the Highnote `SearchQueryLanguage`.
   * Cannot be used in conjunction with other filters.
   */
  searchQueryLanguage?: InputMaybe<SearchQueryLanguageInput>;
  /** The date and time, in ISO 8601 format, the Financial Account was last updated. */
  updatedAt?: InputMaybe<TimestampFilterInput>;
};

/** Interface representing the common fields related to an account holder's identity risk score */
export type AccountHolderIdentityRiskScore = {
  /** The date and time, in ISO 8601 format, when the risk decision was made */
  determinedAt?: Maybe<Scalars["String"]>;
  /** The severity of the risk */
  riskLevel?: Maybe<IdentityRiskLevel>;
};

/** Inputs for filtering Payment Card data for Account Holder. */
export type AccountHolderPaymentCardsFilterInput = {
  bin?: InputMaybe<StringFilterInput>;
  cardNetwork?: InputMaybe<PaymentCardNetworkFilterInput>;
  cardProductId?: InputMaybe<IdFilterInput>;
  createDate?: InputMaybe<TimestampFilterInput>;
  customFields?: InputMaybe<CustomFieldsFilterInput>;
  expirationDate?: InputMaybe<TimestampFilterInput>;
  formFactor?: InputMaybe<CardFormFactorFilterInput>;
  last4?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<PaymentCardStatusFilterInput>;
  updateDate?: InputMaybe<TimestampFilterInput>;
};

/**
 * Represents the provisioning process for an account holder.
 *
 * This type includes information about the provisioning request, its current and next actions, outcomes, and timestamps, as well as the sequence of workflow actions involved.
 */
export type AccountHolderProvisioning = Node & {
  __typename?: "AccountHolderProvisioning";
  /** The account holder associated with this provisioning request. This field provides details about the account holder being provisioned. */
  accountHolder?: Maybe<AccountHolder>;
  /** The date and time when this provisioning request was created, represented in ISO 8601 format. This timestamp indicates when the record was initially created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The current action being executed in the provisioning workflow. This field provides details about the ongoing action in the provisioning process. */
  currentAction?: Maybe<AccountHolderProvisioningWorkflowAction>;
  /** A unique identifier for this provisioning instance. This field helps to uniquely identify and reference a specific provisioning request. */
  id: Scalars["ID"];
  /** A UUIDv4 string used to uniquely identify requests. This field ensures that duplicate requests are not processed more than once and provides idempotency for the request. */
  idempotencyKey?: Maybe<Scalars["IdempotencyKey"]>;
  /** The next action to be performed in the provisioning workflow. This field specifies what action is scheduled to follow the current one. */
  nextAction?: Maybe<AccountHolderProvisioningWorkflowAction>;
  /** The outcome of the provisioning process. This field provides details about the result of the provisioning, including any errors or completion status. */
  outcome?: Maybe<AccountHolderProvisioningOutcome>;
  /** The date and time when this provisioning request was last updated, represented in ISO 8601 format. This timestamp reflects the most recent modification to the record. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** A list of workflow actions associated with this provisioning request. This field includes all actions performed or scheduled during the provisioning process. */
  workflowActions?: Maybe<Array<AccountHolderProvisioningWorkflowAction>>;
};

/**
 * Union type representing the different types of nodes involved in account holder provisioning actions.
 *
 * This union can include various result types, such as account applications, financial accounts, payment cards, or workflow action outcomes.
 */
export type AccountHolderProvisioningActionNode =
  | AccountHolderCardProductApplication
  | FinancialAccount
  | InterFinancialAccountTransfer
  | PaymentCard
  | UserError
  | WorkflowActionResultOutcome;

/**
 * Represents the outcome of the account holder provisioning process.
 *
 * It includes both the current status of the process and the specific reason or result of that status.
 */
export type AccountHolderProvisioningOutcome = {
  __typename?: "AccountHolderProvisioningOutcome";
  /** The current status of the provisioning process, such as whether it is in progress, completed, or in error. */
  status?: Maybe<AccountHolderProvisioningStatus>;
};

/**
 * Represents the different statuses that an account holder provisioning process can be in, from initiation to completion.
 *
 * Each status reflects a specific stage of the process, including potential error handling and review.
 */
export enum AccountHolderProvisioningStatus {
  /** The provisioning process has been successfully completed. */
  COMPLETED = "COMPLETED",
  /** An error occurred during the provisioning process. Further action may be required to resolve the issue. */
  ERROR = "ERROR",
  /** The provisioning process has been initiated but has not yet started. */
  INITIATED = "INITIATED",
  /** The provisioning process is currently in progress. */
  IN_PROGRESS = "IN_PROGRESS",
  /** The provisioning process has been rejected due to an issue encountered during processing, preventing its completion. */
  REJECTED = "REJECTED",
}

/**
 * Represents an action in the workflow for provisioning an account holder.
 *
 * This type includes details about the action performed, its outcome, associated inputs, the order of execution, and related nodes.
 */
export type AccountHolderProvisioningWorkflowAction = Node & {
  __typename?: "AccountHolderProvisioningWorkflowAction";
  /** The `AccountHolderProvisioning` this action belongs to. */
  accountHolderProvisioning?: Maybe<AccountHolderProvisioning>;
  /** The specific action being performed in the provisioning workflow. This field specifies the type of provisioning action executed, such as creating an application or setting a credit limit. */
  action?: Maybe<ProvisionAccountHolderAction>;
  /** Input related to the provisioning action. This field contains details about the input parameters used for the action, such as application details or configuration settings. */
  actionInput?: Maybe<ProvisionAccountHolderActionDetail>;
  /** The order in which the action was executed within the workflow. This field specifies the sequence of the action to maintain the correct processing order. */
  executionOrder?: Maybe<Scalars["UnsignedInt"]>;
  /** Globally unique ID to fetch a Node. This field provides a unique identifier for the node, allowing for its retrieval and reference. */
  id: Scalars["ID"];
  /** The node associated with the provisioning action. This field can be one of several types, including account applications, financial accounts, payment cards, or workflow action results, providing additional context about the action. */
  node?: Maybe<AccountHolderProvisioningActionNode>;
  /** The outcome of the provisioning workflow action. This field provides details about the result of the action, indicating whether it was successful or encountered issues. */
  outcome?: Maybe<AccountHolderProvisioningWorkflowActionDetail>;
};

/**
 * Represents the outcome of the account holder provisioning process.
 * It includes both the current status of the process and the specific reason or result of that status.
 */
export type AccountHolderProvisioningWorkflowActionDetail = {
  __typename?: "AccountHolderProvisioningWorkflowActionDetail";
  /** The current status of the provisioning process, such as whether it is in progress, completed, or in error. */
  status?: Maybe<AccountHolderProvisioningWorkflowActionStatus>;
};

/**
 * Represents the different statuses that an account holder provisioning process can be in, from initiation to completion.
 *
 * Each status reflects a specific stage of the process, including potential error handling and review.
 */
export enum AccountHolderProvisioningWorkflowActionStatus {
  /** The provisioning process has been successfully completed. */
  COMPLETED = "COMPLETED",
  /** An error occurred during the provisioning process. Further action may be required to resolve the issue. */
  ERROR = "ERROR",
  /** The provisioning process has been initiated but has not yet started. */
  INITIATED = "INITIATED",
  /** The provisioning process is currently in progress. */
  IN_PROGRESS = "IN_PROGRESS",
  /** The action was part of the provisioning process but was not executed. */
  NOT_EXECUTED = "NOT_EXECUTED",
}

/** A list of account holder risk scores */
export type AccountHolderRiskScore = {
  __typename?: "AccountHolderRiskScore";
  /** The ID used to reference the risk scores */
  id: Scalars["ID"];
  /** A list of identity risk scores from all the possible vendors */
  identityRiskScores?: Maybe<Array<AccountHolderIdentityRiskScore>>;
};

/** High-level account holder risk verification states. */
export enum AccountHolderRiskVerificationStatusCode {
  /** The account holder was denied. See the results of the risk verification for more details. */
  DENIED = "DENIED",
  /** The account holder is currently undergoing manual review. */
  IN_REVIEW = "IN_REVIEW",
  /** The account holder passed the risk verification requirements. */
  PASSED = "PASSED",
  /** The account holder is currently being verified. */
  PENDING = "PENDING",
}

/** A snapshot of an account holder's data at time of application. */
export type AccountHolderSnapshot =
  | BusinessProductApplicantSnapshot
  | UsBusinessAccountHolderSnapshot
  | UsPersonAccountHolderSnapshot;

/** Type representing a verification attempt on an Account Holder. Not all attempts are successful. */
export type AccountHolderVerification = {
  __typename?: "AccountHolderVerification";
  /** A list of Adverse Action Reasons explaining the Application Denial. */
  adverseActionReasons?: Maybe<Array<AdverseActionReason>>;
  /** The reason for the current status of the verification attempt. */
  reason?: Maybe<AccountHolderVerificationStatusReasonCode>;
  /** Requested Updates to the Identity */
  requestedUpdates?: Maybe<Array<RequestedIdentityUpdate>>;
  /** Documents required to support manual verification of the application. */
  requiredDocuments?: Maybe<
    Array<Maybe<AccountHolderApplicationRequiredDocument>>
  >;
  /** Results from the verification attempt. */
  results?: Maybe<Array<AccountHolderVerificationResult>>;
  /** A list of risk scores associated with the account holder. */
  riskScores?: Maybe<AccountHolderRiskScore>;
  /** Current status of the risk verification attempt. */
  riskStatus?: Maybe<AccountHolderRiskVerificationStatusCode>;
  /** Current status of the verification attempt. */
  status?: Maybe<AccountHolderVerificationStatusCode>;
};

/** Type representing one result on a verification. */
export type AccountHolderVerificationResult = {
  __typename?: "AccountHolderVerificationResult";
  /** The specific result of a verification requirement. */
  code?: Maybe<AccountHolderVerificationResultCode>;
  /** A description for the resulting code of a verification requirement. */
  description?: Maybe<Scalars["String"]>;
};

/** The verification attempt results. */
export enum AccountHolderVerificationResultCode {
  /** The account holder's address was able to be verified. */
  ADDRESS_MATCH = "ADDRESS_MATCH",
  /** The account holder's address could not be verified as provided. */
  ADDRESS_MISMATCH = "ADDRESS_MISMATCH",
  /** The account holder's address has previously been found to be part of previous fraudulent activity. */
  ADDRESS_WARNING = "ADDRESS_WARNING",
  /** The business name provided matches a registered business name (Applicable to Business Onboarding). */
  BUSINESS_NAME_MATCH = "BUSINESS_NAME_MATCH",
  /** The business name provided does not match a registered business name (Applicable to Business Onboarding). */
  BUSINESS_NAME_MISMATCH = "BUSINESS_NAME_MISMATCH",
  /** The overall verification score for the business was below the passing limit. */
  BUSINESS_VERIFICATION_SCORE_FAILED = "BUSINESS_VERIFICATION_SCORE_FAILED",
  /** The business data was verified and overall verification score was above the passing. */
  BUSINESS_VERIFICATION_SCORE_PASSED = "BUSINESS_VERIFICATION_SCORE_PASSED",
  /** The account holder may be verified but was denied due to fraudulent activity. */
  DENIED_FRAUD = "DENIED_FRAUD",
  /** The account holder could not be verified with the information provided. */
  DENIED_KYC = "DENIED_KYC",
  /** The account holder's device has been previously flagged for fraudulent activity. */
  DEVICE_WARNING = "DEVICE_WARNING",
  /** The account holder's date of birth was able to be verified. */
  DOB_MATCH = "DOB_MATCH",
  /** The account holder's date of birth may have been accidentally miskeyed. */
  DOB_MISKEY = "DOB_MISKEY",
  /** The date of birth provided does not match the date of birth of the account holder. */
  DOB_MISMATCH = "DOB_MISMATCH",
  /** The account holder's email has previously been found to be part of previous fraudulent activity. */
  EMAIL_WARNING = "EMAIL_WARNING",
  /** The business must provide a document to verify their employer identification number (Applicable to Business Onboarding). */
  FEIN_DOCUMENT_REQUIRED = "FEIN_DOCUMENT_REQUIRED",
  /** The business' provided employer identification number matches their registered employer identification number (Applicable to Business Onboarding). */
  FEIN_MATCH = "FEIN_MATCH",
  /** The business' provided employer identification number does not match their registered employer identification number (Applicable to Business Onboarding). */
  FEIN_MISMATCH = "FEIN_MISMATCH",
  /** The account holder's device has not been used in the past. */
  FOREIGN_DEVICE = "FOREIGN_DEVICE",
  /** The account holder is being reviewed. */
  FRAUD_REVIEW = "FRAUD_REVIEW",
  /** The account holder has been previously reported for fraud and has repeated fraudulent activity. This is a high risk warning. */
  FRAUD_RISK = "FRAUD_RISK",
  /** The account holder's data provided has resulted in suspected fraudulent activity. This is a medium risk warning. */
  FRAUD_WARNING = "FRAUD_WARNING",
  /** High probability of synthetic fraud. */
  HIGH_ABUSE_SCORE = "HIGH_ABUSE_SCORE",
  /** High probability of third party fraud. */
  HIGH_THEFT_SCORE = "HIGH_THEFT_SCORE",
  /** The account holder's data has been verified and is not associated with prior fraudulent activity. */
  KYC_FRAUD_PASS = "KYC_FRAUD_PASS",
  /** The account holder's data was unable to be fully verified. */
  KYC_WARNING = "KYC_WARNING",
  /** Low probability of synthetic fraud. */
  LOW_ABUSE_SCORE = "LOW_ABUSE_SCORE",
  /** Low probability of third party fraud. */
  LOW_THEFT_SCORE = "LOW_THEFT_SCORE",
  /** Moderate probability of synthetic fraud. */
  MEDIUM_ABUSE_SCORE = "MEDIUM_ABUSE_SCORE",
  /** Moderate probability of third party fraud. */
  MEDIUM_THEFT_SCORE = "MEDIUM_THEFT_SCORE",
  /** The account holder's name was able to be verified. */
  NAME_MATCH = "NAME_MATCH",
  /** The name provided does not match any known names for the account holder. */
  NAME_MISMATCH = "NAME_MISMATCH",
  /** The business data was found to be listed in the Treasury's OFAC list. */
  OFAC_MATCH = "OFAC_MATCH",
  /** The account holder's phone number was able to be verified. */
  PHONE_MATCH = "PHONE_MATCH",
  /** The phone number provided does not match any known phone numbers for the account holder. */
  PHONE_MISMATCH = "PHONE_MISMATCH",
  /** The primary authorized person is verified as representative of the business. */
  REPRESENTATIVE_MATCH = "REPRESENTATIVE_MATCH",
  /** The primary authorized person could not be verified as representative of the business. */
  REPRESENTATIVE_MISMATCH = "REPRESENTATIVE_MISMATCH",
  /** The business has an active registration with the Secretary of State (SOS). */
  SOS_ACTIVE = "SOS_ACTIVE",
  /** The business has registered with the Secretary of State (SOS), but does not have an active filing. */
  SOS_INACTIVE = "SOS_INACTIVE",
  /** The business has an active and registered Secretary of State (SOS) filing. The business address provided matches the Secretary of State (SOS) registration address. */
  SOS_MATCH = "SOS_MATCH",
  /** The business could not be verified with the Secretary of State (SOS). */
  SOS_MISMATCH = "SOS_MISMATCH",
  /** The business' registration with the Secretary of State (SOS) has been flagged or the filing status is unknown */
  SOS_UNKNOWN = "SOS_UNKNOWN",
  /** The account holder's social security number was able to be verified. */
  SSN_MATCH = "SSN_MATCH",
  /** The account holder's social security number may have been accidentally miskeyed. */
  SSN_MISKEY = "SSN_MISKEY",
  /** The account holder's social security number could not be verified as provided. */
  SSN_MISMATCH = "SSN_MISMATCH",
  /** The Social Security Number provided is associated with multiple identities. */
  SSN_MULTI_IDENTITY = "SSN_MULTI_IDENTITY",
  /** The social security number has been previously flagged for fraudulent activity. */
  SSN_WARNING = "SSN_WARNING",
  /** The account holder is currently on an active watchlist. */
  WATCHLIST_HIT = "WATCHLIST_HIT",
  /** The account holder is currently on an active watchlist. */
  WATCHLIST_WARNING = "WATCHLIST_WARNING",
}

/** High-level account holder verification states. */
export enum AccountHolderVerificationStatusCode {
  /** The account holder was denied. See the results of the verification for more details. */
  DENIED = "DENIED",
  /** The account holder passed the verification requirements. */
  PASSED = "PASSED",
  /** The account holder is currently being verified. */
  PENDING = "PENDING",
}

/** The specific reason for being in an account holder verification state. */
export enum AccountHolderVerificationStatusReasonCode {
  /** The account holder was denied. See the results of the verification for more details. */
  DENIED = "DENIED",
  /** Documents are needed to verify the account holder. */
  DOCUMENT_UPLOAD_REQUIRED = "DOCUMENT_UPLOAD_REQUIRED",
  /** An identity update has been requested to correct the information provided on the application. */
  IDENTITY_UPDATE_REQUESTED = "IDENTITY_UPDATE_REQUESTED",
  /** The account holder is currently being reviewed. */
  IN_REVIEW = "IN_REVIEW",
  /** The account holder is required to answer automated questions to complete verification. */
  KBA_REQUIRED = "KBA_REQUIRED",
  /** The account holder passed the verification requirements. */
  PASSED = "PASSED",
  /** The account holder is currently being verified. */
  PENDING = "PENDING",
  /** A manual review of the account holder is required to continue the verification process. */
  REVIEW_REQUIRED = "REVIEW_REQUIRED",
}

/** Represents a relationship between two financial accounts. */
export type AccountRelationship = Node & {
  __typename?: "AccountRelationship";
  /** The status of this account relationship. */
  accountRelationshipStatus?: Maybe<AccountRelationshipStatus>;
  /** The type of this account relationship. */
  accountRelationshipType?: Maybe<AccountRelationshipType>;
  /** The source financial account in this relationship. */
  fromFinancialAccount?: Maybe<FinancialAccount>;
  /** Global ID used to reference the Account Relationship in operations. */
  id: Scalars["ID"];
  /** The target financial account in this relationship. */
  toFinancialAccount?: Maybe<FinancialAccount>;
};

/** The status of an account relationship. */
export enum AccountRelationshipStatus {
  /** The account relationship is active. */
  ACTIVE = "ACTIVE",
  /** The account relationship is inactive. */
  INACTIVE = "INACTIVE",
}

/** The type of an account relationship. */
export enum AccountRelationshipType {
  /** Merchant Cash Advance relationship. */
  MERCHANT_CASH_ADVANCE = "MERCHANT_CASH_ADVANCE",
  /** Visa Flexible Credential relationship. */
  VISA_FLEXIBLE_CREDENTIAL = "VISA_FLEXIBLE_CREDENTIAL",
}

/** Account Review */
export type AccountReview = {
  /** The date and time, in ISO 8601 format, this was closed. */
  closedAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, this was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The Global ID of the `FinancialAccount` in review. */
  financialAccountId: Scalars["ID"];
  /** The Global ID of this `AccountReview`. */
  id: Scalars["ID"];
  /** The date and time, in ISO 8601 format, this was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The connection type for an `AccountReview`. */
export type AccountReviewConnection = {
  __typename?: "AccountReviewConnection";
  /** A list of edges. */
  edges?: Maybe<Array<AccountReviewEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The payload for listing `AccountReview`s for a `FinancialAccount`. */
export type AccountReviewConnectionPayload =
  | AccessDeniedError
  | AccountReviewConnection
  | UserError;

/** The edge type for an `AccountReview`. */
export type AccountReviewEdge = {
  __typename?: "AccountReviewEdge";
  /** The cursor for this edge to use in pagination. */
  cursor: Scalars["String"];
  /** The `AccountReview`. */
  node?: Maybe<AccountReview>;
};

/** A Spend Control rule that allows or blocks authorizations based on the `Account` used for the transaction. */
export type AccountSpendRule = Node &
  SpendRule & {
    __typename?: "AccountSpendRule";
    /** The `Account` IDs to allow during authorizations. */
    allowed?: Maybe<Array<Scalars["ID"]>>;
    /** The `Account` IDs to block during authorizations. */
    blocked?: Maybe<Array<Scalars["ID"]>>;
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the `AccountSpendRule` in operations. */
    id: Scalars["ID"];
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/** A Spend Control rule that allows or blocks authorizations based on the `Account` used for the transaction. */
export type AccountSpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The result of applying an `AccountSpendRule` to an event. */
export type AccountSpendRuleResult = SpendRuleResult & {
  __typename?: "AccountSpendRuleResult";
  /** The attached level. */
  attachedLevel?: Maybe<AttachedLevel>;
  /** A message describing the result. */
  message?: Maybe<Scalars["String"]>;
  /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
  recommendation?: Maybe<SpendRuleRecommendation>;
  /** The spend rule attached at the time of the event. */
  spendRule?: Maybe<AccountSpendRule>;
  /** The ID of the `Account` used in the event. */
  valuesTested?: Maybe<Array<Scalars["ID"]>>;
};

/** The `AccountStatusActiveEvent` notifies when an `FinancialAccount` is set to the Active Status. */
export type AccountStatusActiveEvent = AccountStatusEvent &
  Node & {
    __typename?: "AccountStatusActiveEvent";
    /** The name of this `FinancialAccount`. */
    accountName?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, this event was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /**
     * Externally provided ID (255 character limit) that can be used to refer to the issued payment card's' financial account.
     * This ID is unique per organization and tenant. If not provided, Highnote will generate an ID (ten digit, Base58, all caps).
     */
    externalId?: Maybe<Scalars["String"]>;
    /** The ID of the `FinancialAccount` that has changed status. */
    id: Scalars["ID"];
  };

/** The `AccountStatusClosedEvent` notifies when an `FinancialAccount` is set to the Closed Status. */
export type AccountStatusClosedEvent = AccountStatusEvent &
  Node & {
    __typename?: "AccountStatusClosedEvent";
    /** The name of this `FinancialAccount`. */
    accountName?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, this event was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /**
     * Externally provided ID (255 character limit) that can be used to refer to the issued payment card's' financial account.
     * This ID is unique per organization and tenant. If not provided, Highnote will generate an ID (ten digit, Base58, all caps).
     */
    externalId?: Maybe<Scalars["String"]>;
    /** The ID of the `FinancialAccount` that has changed status. */
    id: Scalars["ID"];
  };

export type AccountStatusEvent = {
  /** The name of this `FinancialAccount`. */
  accountName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, this event was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /**
   * Externally provided ID (255 character limit) that can be used to refer to the issued payment card's' financial account.
   * This ID is unique per organization and tenant. If not provided, Highnote will generate an ID (ten digit, Base58, all caps).
   */
  externalId?: Maybe<Scalars["String"]>;
  /** The ID of the `FinancialAccount` that has changed status. */
  id: Scalars["ID"];
};

/** The `AccountStatusPendingClosureEvent` notifies when an `FinancialAccount` is set to the Pending Closure Status. */
export type AccountStatusPendingClosureEvent = AccountStatusEvent &
  Node & {
    __typename?: "AccountStatusPendingClosureEvent";
    /** The name of this `FinancialAccount`. */
    accountName?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, this event was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /**
     * Externally provided ID (255 character limit) that can be used to refer to the issued payment card's' financial account.
     * This ID is unique per organization and tenant. If not provided, Highnote will generate an ID (ten digit, Base58, all caps).
     */
    externalId?: Maybe<Scalars["String"]>;
    /** The ID of the `FinancialAccount` that has changed status. */
    id: Scalars["ID"];
  };

/** The `AccountStatusSuspendedEvent` notifies when an `FinancialAccount` is set to the Suspended Status. */
export type AccountStatusSuspendedEvent = AccountStatusEvent &
  Node & {
    __typename?: "AccountStatusSuspendedEvent";
    /** The name of this `FinancialAccount`. */
    accountName?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, this event was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /**
     * Externally provided ID (255 character limit) that can be used to refer to the issued payment card's' financial account.
     * This ID is unique per organization and tenant. If not provided, Highnote will generate an ID (ten digit, Base58, all caps).
     */
    externalId?: Maybe<Scalars["String"]>;
    /** The ID of the `FinancialAccount` that has changed status. */
    id: Scalars["ID"];
  };

/** The `AccountStatusUnderReviewEvent` notifies when an `FinancialAccount` is set to the Under Review Status. */
export type AccountStatusUnderReviewEvent = AccountStatusEvent &
  Node & {
    __typename?: "AccountStatusUnderReviewEvent";
    /** The name of this `FinancialAccount`. */
    accountName?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, this event was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /**
     * Externally provided ID (255 character limit) that can be used to refer to the issued payment card's' financial account.
     * This ID is unique per organization and tenant. If not provided, Highnote will generate an ID (ten digit, Base58, all caps).
     */
    externalId?: Maybe<Scalars["String"]>;
    /** The ID of the `FinancialAccount` that has changed status. */
    id: Scalars["ID"];
  };

/** A Spend Control rule that blocks transactions if the number of transactions on the account is above a configured threshold. */
export type AccountTransactionCountSpendRule = Node &
  SpendRule & {
    __typename?: "AccountTransactionCountSpendRule";
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the `AccountTransactionCountSpendRule` in operations. */
    id: Scalars["ID"];
    /** The maximum number of transactions allowed for an account before transactions are declined. */
    maximumAccountTransactionCount?: Maybe<Scalars["UnsignedInt"]>;
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/** A Spend Control rule that blocks transactions if the number of transactions on the account is above a configured threshold. */
export type AccountTransactionCountSpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The result of applying a `AccountTransactionCountSpendRule` to an event. */
export type AccountTransactionCountSpendRuleResult = SpendRuleResult & {
  __typename?: "AccountTransactionCountSpendRuleResult";
  /** The current number of transactions on the account at the time of evaluation. */
  accountTransactionCount?: Maybe<Scalars["UnsignedInt"]>;
  /** The attached level. */
  attachedLevel?: Maybe<AttachedLevel>;
  /** A message describing the result. */
  message?: Maybe<Scalars["String"]>;
  /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
  recommendation?: Maybe<SpendRuleRecommendation>;
  /** The spend rule attached at the time of the event. */
  spendRule?: Maybe<AccountTransactionCountSpendRule>;
};

/** Represents the direction funds are moving in an accounting context. */
export enum AccountingDirection {
  /** Indicates a credit. The money is moving into an account. */
  CREDIT = "CREDIT",
  /** Indicates a debit. The money is moving out of an account. */
  DEBIT = "DEBIT",
}

/** The interest and fees that an account has accumulated. */
export type AccumulatedAccountInterestAndFees = {
  __typename?: "AccumulatedAccountInterestAndFees";
  /** The fee credit balance that has accumulated year to date, across all balance types. */
  yearToDateAccumulatedFeesCredit?: Maybe<Amount>;
  /** The fee debit balance that has accumulated year to date, across all balance types. */
  yearToDateAccumulatedFeesDebit?: Maybe<Amount>;
  /** The interest credit balance that has accumulated year to date, across all balance types. */
  yearToDateAccumulatedInterestCredit?: Maybe<Amount>;
  /** The interest debit balance that has accumulated year to date, across all balance types. */
  yearToDateAccumulatedInterestDebit?: Maybe<Amount>;
};

/** Whether or not the Financial Account is a Non Verified account */
export type AchCapableFinancialAccountFeature = FinancialAccountFeature & {
  __typename?: "AchCapableFinancialAccountFeature";
  /** The date and time, in ISO 8601 format, the feature was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective from. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective through. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Whether or not the feature is enabled for the Financial Account. */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** The date and time, in ISO 8601 format, the feature was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The AchExternallyInitatedDepositFailedEvent event will be triggered when processing an incoming NACHA file transaction has failed. */
export type AchExternallyInitatedDepositFailedEvent =
  AchExternallyInitatedEvent &
    Node & {
      __typename?: "AchExternallyInitatedDepositFailedEvent";
      /** The amount of the transfer. */
      amount?: Maybe<Amount>;
      /** Company entered value for the type of ACH. */
      companyEntryDescription?: Maybe<Scalars["String"]>;
      /**
       * The Company Identifier is a 10-position alphameric code used to identify an Originator of the ACH transaction. It may begin with an ANSI one-digit Identification Code Designator (ICD), followed by the Identification Number.
       *
       * |`Identification Code Designator (ICD)`    | `ANSI Identification Number` | Example                                                                         |
       * | ---------------------------------------- | ---------------------------- | ------------------------------------------------------------------------------- |
       * |`IRS Employer Identification Number (EIN)`| 1                            | 1234567890 for an Originator with 234567890 EIN                                 |
       * |`Data Universal Numbering Systems (DUNS)` | 3                            | 30008016958 for an Originator with 0008016958 DUNS                              |
       * |`User Assigned Number`                    | 9                            | 9111111111 for an Originator with 111111111 under assigned Identification Number|
       */
      companyIdentifier?: Maybe<Scalars["String"]>;
      /** The name of the company that initiated the ACH transfer. */
      companyName?: Maybe<Scalars["String"]>;
      /** The date and time, in ISO 8601 format, the transfer was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** Additional details about why an AchExternallyInitatedDeposit failed. */
      externallyInitatedDepositACHReasonCode?: Maybe<ExternallyInitiatedAchStatusReasonCode>;
      /** The ID of the financial account receiving funds. */
      financialAccountId?: Maybe<Scalars["ID"]>;
      /** The ID of the transaction event. This `id` can be used to later retrieve details of this `AchExternallyInitatedDepositFailedEvent` or correlate it with other events on this `Transaction`. */
      id: Scalars["ID"];
      /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
      settlementDate?: Maybe<Scalars["String"]>;
      /** The ID of the Electronic Funds Transfer that trigger this event. */
      transactionId?: Maybe<Scalars["ID"]>;
      /**
       * The status of the ACH transfer.
       * @deprecated use externallyInitatedDepositACHReasonCode instead
       */
      transferStatus?: Maybe<AchTransferStatusDetails>;
      /** The date and time, in ISO 8601 format, the transfer was last updated. */
      updatedAt?: Maybe<Scalars["String"]>;
    };

/** The AchExternallyInitatedDepositProcessedEvent event will be triggered when an incoming NACHA file transaction has been processed. */
export type AchExternallyInitatedDepositProcessedEvent =
  AchExternallyInitatedEvent &
    Node & {
      __typename?: "AchExternallyInitatedDepositProcessedEvent";
      /** The amount of the transfer. */
      amount?: Maybe<Amount>;
      /** Company entered value for the type of ACH. */
      companyEntryDescription?: Maybe<Scalars["String"]>;
      /**
       * The Company Identifier is a 10-position alphameric code used to identify an Originator of the ACH transaction. It may begin with an ANSI one-digit Identification Code Designator (ICD), followed by the Identification Number.
       *
       * |`Identification Code Designator (ICD)`    | `ANSI Identification Number` | Example                                                                         |
       * | ---------------------------------------- | ---------------------------- | ------------------------------------------------------------------------------- |
       * |`IRS Employer Identification Number (EIN)`| 1                            | 1234567890 for an Originator with 234567890 EIN                                 |
       * |`Data Universal Numbering Systems (DUNS)` | 3                            | 30008016958 for an Originator with 0008016958 DUNS                              |
       * |`User Assigned Number`                    | 9                            | 9111111111 for an Originator with 111111111 under assigned Identification Number|
       */
      companyIdentifier?: Maybe<Scalars["String"]>;
      /** The name of the company that initiated the ACH transfer. */
      companyName?: Maybe<Scalars["String"]>;
      /** The date and time, in ISO 8601 format, the transfer was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** The ID of the financial account receiving funds. */
      financialAccountId?: Maybe<Scalars["ID"]>;
      /** The ID of the transaction event. This `id` can be used to later retrieve details of this `AchExternallyInitatedDepositProcessedEvent` or correlate it with other events on this `Transaction`. */
      id: Scalars["ID"];
      /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
      settlementDate?: Maybe<Scalars["String"]>;
      /** The ID of the Electronic Funds Transfer that trigger this event. */
      transactionId?: Maybe<Scalars["ID"]>;
      /**
       * The status of the ACH transfer.
       * @deprecated transfer status only needed for failed or returned events
       */
      transferStatus?: Maybe<AchTransferStatusDetails>;
      /** The date and time, in ISO 8601 format, the transfer was last updated. */
      updatedAt?: Maybe<Scalars["String"]>;
    };

/** The AchExternallyInitatedDepositReceivedEvent event will be triggered when an incoming NACHA file transaction has been received. */
export type AchExternallyInitatedDepositReceivedEvent =
  AchExternallyInitatedEvent &
    Node & {
      __typename?: "AchExternallyInitatedDepositReceivedEvent";
      /** The amount of the transfer. */
      amount?: Maybe<Amount>;
      /** Company entered value for the type of ACH. */
      companyEntryDescription?: Maybe<Scalars["String"]>;
      /**
       * The Company Identifier is a 10-position alphameric code used to identify an Originator of the ACH transaction. It may begin with an ANSI one-digit Identification Code Designator (ICD), followed by the Identification Number.
       *
       * |`Identification Code Designator (ICD)`    | `ANSI Identification Number` | Example                                                                         |
       * | ---------------------------------------- | ---------------------------- | ------------------------------------------------------------------------------- |
       * |`IRS Employer Identification Number (EIN)`| 1                            | 1234567890 for an Originator with 234567890 EIN                                 |
       * |`Data Universal Numbering Systems (DUNS)` | 3                            | 30008016958 for an Originator with 0008016958 DUNS                              |
       * |`User Assigned Number`                    | 9                            | 9111111111 for an Originator with 111111111 under assigned Identification Number|
       */
      companyIdentifier?: Maybe<Scalars["String"]>;
      /** The name of the company that initiated the ACH transfer. */
      companyName?: Maybe<Scalars["String"]>;
      /** The date and time, in ISO 8601 format, the transfer was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** The ID of the financial account receiving funds. */
      financialAccountId?: Maybe<Scalars["ID"]>;
      /** The ID of the transaction event. This `id` can be used to later retrieve details of this `AchExternallyInitatedDepositReceivedEvent` or correlate it with other events on this `Transaction`. */
      id: Scalars["ID"];
      /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
      settlementDate?: Maybe<Scalars["String"]>;
      /** The ID of the Electronic Funds Transfer that trigger this event. */
      transactionId?: Maybe<Scalars["ID"]>;
      /**
       * The status of the ACH transfer.
       * @deprecated transfer status only needed for failed or returned events
       */
      transferStatus?: Maybe<AchTransferStatusDetails>;
      /** The date and time, in ISO 8601 format, the transfer was last updated. */
      updatedAt?: Maybe<Scalars["String"]>;
    };

export type AchExternallyInitatedEvent = {
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** Company entered value for the type of ACH. */
  companyEntryDescription?: Maybe<Scalars["String"]>;
  /**
   * The Company Identifier is a 10-position alphameric code used to identify an Originator of the ACH transaction. It may begin with an ANSI one-digit Identification Code Designator (ICD), followed by the Identification Number.
   *
   * |`Identification Code Designator (ICD)`    | `ANSI Identification Number` | Example                                                                         |
   * | ---------------------------------------- | ---------------------------- | ------------------------------------------------------------------------------- |
   * |`IRS Employer Identification Number (EIN)`| 1                            | 1234567890 for an Originator with 234567890 EIN                                 |
   * |`Data Universal Numbering Systems (DUNS)` | 3                            | 30008016958 for an Originator with 0008016958 DUNS                              |
   * |`User Assigned Number`                    | 9                            | 9111111111 for an Originator with 111111111 under assigned Identification Number|
   */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /** The name of the company that initiated the ACH transfer. */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the financial account receiving funds. */
  financialAccountId?: Maybe<Scalars["ID"]>;
  /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
  settlementDate?: Maybe<Scalars["String"]>;
  /** The ID of the Electronic Funds Transfer that trigger this event. */
  transactionId?: Maybe<Scalars["ID"]>;
  /**
   * The status of the ACH transfer.
   * @deprecated transfer status only needed for failed or returned events
   */
  transferStatus?: Maybe<AchTransferStatusDetails>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The AchExternallyInitiatedWithdrawalFailedEvent event will be triggered when processing an incoming NACHA file transaction has failed. */
export type AchExternallyInitiatedWithdrawalFailedEvent =
  AchExternallyInitatedEvent &
    Node & {
      __typename?: "AchExternallyInitiatedWithdrawalFailedEvent";
      /** The amount of the transfer. */
      amount?: Maybe<Amount>;
      /** Company entered value for the type of ACH. */
      companyEntryDescription?: Maybe<Scalars["String"]>;
      /**
       * The Company Identifier is a 10-position alphameric code used to identify an Originator of the ACH transaction. It may begin with an ANSI one-digit Identification Code Designator (ICD), followed by the Identification Number.
       *
       * |`Identification Code Designator (ICD)`    | `ANSI Identification Number` | Example                                                                         |
       * | ---------------------------------------- | ---------------------------- | ------------------------------------------------------------------------------- |
       * |`IRS Employer Identification Number (EIN)`| 1                            | 1234567890 for an Originator with 234567890 EIN                                 |
       * |`Data Universal Numbering Systems (DUNS)` | 3                            | 30008016958 for an Originator with 0008016958 DUNS                              |
       * |`User Assigned Number`                    | 9                            | 9111111111 for an Originator with 111111111 under assigned Identification Number|
       */
      companyIdentifier?: Maybe<Scalars["String"]>;
      /** The name of the company that initiated the ACH transfer. */
      companyName?: Maybe<Scalars["String"]>;
      /** The date and time, in ISO 8601 format, the transfer was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** Additional details about why an AchExternallyInitiatedWithdrawal failed. */
      externallyInitiatedWithdrawalACHReasonCode?: Maybe<ExternallyInitiatedAchStatusReasonCode>;
      /** The ID of the Financial account that is the source of the funds. */
      financialAccountId?: Maybe<Scalars["ID"]>;
      /** The ID of the transaction event. This `id` can be used to later retrieve details of this `AchExternallyWithdrawalDepositFailedEvent` or correlate it with other events on this `Transaction`. */
      id: Scalars["ID"];
      /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
      settlementDate?: Maybe<Scalars["String"]>;
      /** The ID of the Electronic Funds Transfer that trigger this event. */
      transactionId?: Maybe<Scalars["ID"]>;
      /**
       * The status of the ACH transfer.
       * @deprecated use ExternallyInitiatedWithdrawalAchReasonCode instead
       */
      transferStatus?: Maybe<AchTransferStatusDetails>;
      /** The date and time, in ISO 8601 format, the transfer was last updated. */
      updatedAt?: Maybe<Scalars["String"]>;
    };

/** The AchExternallyInitiatedWithdrawalProcessedEvent event will be triggered when an incoming NACHA file transaction has been processed. */
export type AchExternallyInitiatedWithdrawalProcessedEvent =
  AchExternallyInitatedEvent &
    Node & {
      __typename?: "AchExternallyInitiatedWithdrawalProcessedEvent";
      /** The amount of the transfer. */
      amount?: Maybe<Amount>;
      /** Company entered value for the type of ACH. */
      companyEntryDescription?: Maybe<Scalars["String"]>;
      /**
       * The Company Identifier is a 10-position alphameric code used to identify an Originator of the ACH transaction. It may begin with an ANSI one-digit Identification Code Designator (ICD), followed by the Identification Number.
       *
       * |`Identification Code Designator (ICD)`    | `ANSI Identification Number` | Example                                                                         |
       * | ---------------------------------------- | ---------------------------- | ------------------------------------------------------------------------------- |
       * |`IRS Employer Identification Number (EIN)`| 1                            | 1234567890 for an Originator with 234567890 EIN                                 |
       * |`Data Universal Numbering Systems (DUNS)` | 3                            | 30008016958 for an Originator with 0008016958 DUNS                              |
       * |`User Assigned Number`                    | 9                            | 9111111111 for an Originator with 111111111 under assigned Identification Number|
       */
      companyIdentifier?: Maybe<Scalars["String"]>;
      /** The name of the company that initiated the ACH transfer. */
      companyName?: Maybe<Scalars["String"]>;
      /** The date and time, in ISO 8601 format, the transfer was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** The ID of the Financial account that is the source of the funds. */
      financialAccountId?: Maybe<Scalars["ID"]>;
      /** The ID of the transaction event. This `id` can be used to later retrieve details of this `AchExternallyInitiatedWithdrawalProcessedEvent` or correlate it with other events on this `Transaction`. */
      id: Scalars["ID"];
      /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
      settlementDate?: Maybe<Scalars["String"]>;
      /** The ID of the Electronic Funds Transfer that trigger this event. */
      transactionId?: Maybe<Scalars["ID"]>;
      /**
       * The status of the ACH transfer.
       * @deprecated transfer status only needed for failed or returned events
       */
      transferStatus?: Maybe<AchTransferStatusDetails>;
      /** The date and time, in ISO 8601 format, the transfer was last updated. */
      updatedAt?: Maybe<Scalars["String"]>;
    };

/** The AchExternallyInitiatedWithdrawalReceivedEvent event will be triggered when an incoming NACHA file transaction has been received. */
export type AchExternallyInitiatedWithdrawalReceivedEvent =
  AchExternallyInitatedEvent &
    Node & {
      __typename?: "AchExternallyInitiatedWithdrawalReceivedEvent";
      /** The amount of the transfer. */
      amount?: Maybe<Amount>;
      /** Company entered value for the type of ACH. */
      companyEntryDescription?: Maybe<Scalars["String"]>;
      /**
       * The Company Identifier is a 10-position alphameric code used to identify an Originator of the ACH transaction. It may begin with an ANSI one-digit Identification Code Designator (ICD), followed by the Identification Number.
       *
       * |`Identification Code Designator (ICD)`    | `ANSI Identification Number` | Example                                                                         |
       * | ---------------------------------------- | ---------------------------- | ------------------------------------------------------------------------------- |
       * |`IRS Employer Identification Number (EIN)`| 1                            | 1234567890 for an Originator with 234567890 EIN                                 |
       * |`Data Universal Numbering Systems (DUNS)` | 3                            | 30008016958 for an Originator with 0008016958 DUNS                              |
       * |`User Assigned Number`                    | 9                            | 9111111111 for an Originator with 111111111 under assigned Identification Number|
       */
      companyIdentifier?: Maybe<Scalars["String"]>;
      /** The name of the company that initiated the ACH transfer. */
      companyName?: Maybe<Scalars["String"]>;
      /** The date and time, in ISO 8601 format, the transfer was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** The ID of the Financial account that is the source of the funds. */
      financialAccountId?: Maybe<Scalars["ID"]>;
      /** The ID of the transaction event. This `id` can be used to later retrieve details of this `AchExternallyInitiatedWithdrawalReceivedEvent` or correlate it with other events on this `Transaction`. */
      id: Scalars["ID"];
      /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
      settlementDate?: Maybe<Scalars["String"]>;
      /** The ID of the Electronic Funds Transfer that trigger this event. */
      transactionId?: Maybe<Scalars["ID"]>;
      /**
       * The status of the ACH transfer.
       * @deprecated transfer status only needed for failed or returned events
       */
      transferStatus?: Maybe<AchTransferStatusDetails>;
      /** The date and time, in ISO 8601 format, the transfer was last updated. */
      updatedAt?: Maybe<Scalars["String"]>;
    };

/**
 * The financial account sending funds. This can be a Highnote `FinancialAccount`
 * or a verified external financial account (`ExternalFinancialBankAccount`).
 */
export type AchFromFinancialAccount =
  | ExternalFinancialBankAccount
  | FinancialAccount;

/** The `AchHoldAddedEvent` notifies when an ach transaction is put on hold. */
export type AchHoldAddedEvent = AchHoldEvent &
  Node & {
    __typename?: "AchHoldAddedEvent";
    /** The company identifier. */
    companyIdentifier?: Maybe<Scalars["String"]>;
    /** The company name. */
    companyName?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the ach transaction was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The previous hold status. */
    fromStatus?: Maybe<AchHoldStatus>;
    /** The hold type. */
    holdType?: Maybe<AchHoldType>;
    /** The global ID to reference the `AchHoldAddedEvent`. */
    id: Scalars["ID"];
    /** The account that the money is going to. Will not exist for non-originating debit transactions. */
    receivingAccountId?: Maybe<Scalars["ID"]>;
    /** The account that the money is going out of. Will not exist for non-originating credit transactions. */
    sourceAccountId?: Maybe<Scalars["ID"]>;
    /** The ID of the ACH Transaction related to this event. */
    transactionId?: Maybe<Scalars["ID"]>;
    /** The date and time, in ISO 8601 format, the ach transaction was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

export type AchHoldEvent = {
  /** The company identifier. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /** The company name. */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the ach transaction was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The previous hold status. */
  fromStatus?: Maybe<AchHoldStatus>;
  /** The hold type. */
  holdType?: Maybe<AchHoldType>;
  /** The global ID to reference this event. */
  id: Scalars["ID"];
  /** The account that the money is going to. Will not exist for non-originating debit transactions. */
  receivingAccountId?: Maybe<Scalars["ID"]>;
  /** The account that the money is going out of. Will not exist for non-originating credit transactions. */
  sourceAccountId?: Maybe<Scalars["ID"]>;
  /** The ID of the ACH Transaction related to this event. */
  transactionId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the ach transaction was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The `AchHoldRemovedEvent` notifies when the hold on an ach transaction is removed. */
export type AchHoldRemovedEvent = AchHoldEvent &
  Node & {
    __typename?: "AchHoldRemovedEvent";
    /** The company identifier. */
    companyIdentifier?: Maybe<Scalars["String"]>;
    /** The company name. */
    companyName?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the ach transaction was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The previous hold status. */
    fromStatus?: Maybe<AchHoldStatus>;
    /** The hold type. */
    holdType?: Maybe<AchHoldType>;
    /** The global ID to reference the `AchHoldRemovedEvent`. */
    id: Scalars["ID"];
    /** The account that the money is going to. Will not exist for non-originating debit transactions. */
    receivingAccountId?: Maybe<Scalars["ID"]>;
    /** The account that the money is going out of. Will not exist for non-originating credit transactions. */
    sourceAccountId?: Maybe<Scalars["ID"]>;
    /** The ID of the ACH Transaction related to this event. */
    transactionId?: Maybe<Scalars["ID"]>;
    /** The date and time, in ISO 8601 format, the ach transaction was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** The hold status of an ACH. */
export enum AchHoldStatus {
  /** ACH Transaction had a hold but it has been removed. */
  HOLD_REMOVED = "HOLD_REMOVED",
  /** ACH Transaction is not on hold. */
  NO_HOLDS = "NO_HOLDS",
  /** ACH Transaction is on hold. */
  ON_HOLD = "ON_HOLD",
}

/** Input for filtering by `AchTransferPurpose`. */
export type AchHoldStatusFilterInput = {
  equals?: InputMaybe<AchHoldStatus>;
  excludes?: InputMaybe<Array<AchHoldStatus>>;
  includes?: InputMaybe<Array<AchHoldStatus>>;
  notEquals?: InputMaybe<AchHoldStatus>;
};

/** The hold type of an ACH. */
export enum AchHoldType {
  /** ACH Transaction is on hold or had a hold because it was flagged for risk review */
  RISK = "RISK",
  /** UNSPECIFIED */
  UNSPECIFIED = "UNSPECIFIED",
}

/**
 * The financial account receiving funds. This can be a Highnote `FinancialAccount`
 * or a verified or non-verified external financial account (`ExternalFinancialBankAccount` or `NonVerifiedExternalUSFinancialBankAccount`).
 */
export type AchToFinancialAccount =
  | ExternalFinancialBankAccount
  | FinancialAccount
  | NonVerifiedExternalUsFinancialBankAccount;

/**
 * The base details of an `OriginatedAchTransfer` or `NonOriginatedAchTransfer`.
 *
 * An `OriginatedAchTransfer` is initiated by Highnote.
 * It can `PUSH` funds from a Highnote `FinancialAccount` to an external financial institution
 * or `PULL` funds from an external financial institution to a Highnote `FinancialAccount`.
 *
 * A `NonOriginatedAchTransfer` is initiated by an external financial institution.
 * It can `PULL` funds from a Highnote `FinancialAccount` to an external financial institution
 * or `PUSH` funds from an external financial institution to a Highnote `FinancialAccount`.
 */
export type AchTransfer = {
  /** The monetary amount to transfer. */
  amount?: Maybe<Amount>;
  /** The `CardProduct` associated with the Highnote `FinancialAccount`. */
  cardProduct?: Maybe<CardProduct>;
  /**
   * Provides the receiving financial institution with information about the nature or purpose of the transaction.
   * Examples include "ACCTVERIFY". "PAYROLL", "PAYMENT", etc.
   *
   * Maximum length: 10 characters.
   */
  companyEntryDescription?: Maybe<Scalars["String"]>;
  /** The ID of the company that initiated the transfer. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /** The name of the company that initiated the transfer. */
  companyName?: Maybe<Scalars["String"]>;
  /**
   * The date and time the transfer was initiated (`OriginatedAchTransfer`) or received (`NonOriginatedAchTransfer`),
   * in ISO 8601 format, e.g. 2024-01-01T00:00:00.000Z.
   */
  createdAt?: Maybe<Scalars["String"]>;
  /**
   * The date and time the transfer failed by Highnote, in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z.
   *
   * A failed transfer is not sent to the external financial institution.
   */
  failedAt?: Maybe<Scalars["String"]>;
  /**
   * The hold status of the transfer.
   *
   * Funds from an `OriginatedAchTransfer` `PULL` or a `NonOriginatedAchTransfer` `PUSH` are not available to spend while the transfer is `ON_HOLD`.
   * An `OriginatedAchTransfer` `PUSH` is not sent to the external financial institution while the transfer is `ON_HOLD`.
   *
   * This field is currently restricted to administrators.
   */
  holdStatus?: Maybe<AchHoldStatus>;
  /**
   * The hold type of the transfer.
   *
   * This field is currently restricted to administrators.
   */
  holdType?: Maybe<AchHoldType>;
  /** Global ID used to reference the `AchTransfer`. */
  id: Scalars["ID"];
  /**
   * Receiver’s identification number. This could be a person or a business.
   *
   * Maximum length: 15 characters.
   */
  individualIdentificationNumber?: Maybe<Scalars["String"]>;
  /**
   * Receiver’s individual name. This could be a person or a business.
   *
   * Maximum length: 22 characters.
   */
  individualName?: Maybe<Scalars["String"]>;
  /**
   * The date and time the hold status last changed, in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z.
   *
   * Funds from an `OriginatedAchTransfer` `PULL` or a `NonOriginatedAchTransfer` `PUSH` are not available to spend while the transfer is `ON_HOLD`.
   * An `OriginatedAchTransfer` `PUSH` is not sent to the external financial institution while the transfer is `ON_HOLD`.
   *
   * This field is currently restricted to administrators.
   */
  lastHoldStatusChangedAt?: Maybe<Scalars["String"]>;
  /** The ledgers affected by the transfer. */
  ledgers?: Maybe<Array<Ledger>>;
  /**
   * Contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   *
   * Maximum length: 80 characters.
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
  /** The purpose of the transfer, e.g. deposit. */
  purpose?: Maybe<AchTransferPurpose>;
  /**
   * The impact of the transfer on the Highnote `FinancialAccount`.
   * Negative means a reduction of funds on the Highnote `FinancialAccount`.
   * Positive means an increase of funds on the Highnote `FinancialAccount`.
   */
  sign?: Maybe<AchTransferSign>;
  /** Additional details about why the transfer failed. This is only applicable when the transfer status is `FAILED` or `RETURNED`. */
  statusFailureReason?: Maybe<AchTransferStatusFailureReason>;
  /**
   * A unique 15 digit number assigned  by the originator when the transfer is in the `PROCESSING` state.
   * It is used is used to identify the transfer in the ACH network.
   */
  traceNumber?: Maybe<Scalars["String"]>;
  /**
   * The direction of the transfer, `PUSH` or `PULL`, from the perspective of the originating financial institution.
   *
   * For an `OriginatedAchTransfer`, `PUSH` means pushing funds from a Highnote `FinancialAccount` to an external financial account and
   * `PULL` means pulling funds from an external financial account to a Highnote `FinancialAccount`.
   *
   * For a `NonOriginatedAchTransfer`, `PUSH` means pushing funds from an external financial account to a Highnote `FinancialAccount` and
   * `PULL` means pulling funds from a Highnote `FinancialAccount` to an external financial account.
   */
  type?: Maybe<AchTransferType>;
  /** The date and time the transfer details were last updated, in ISO 8601 format, e.g. 2024-01-01T00:00:00.000Z. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/**
 * The base details of an `OriginatedAchTransfer` or `NonOriginatedAchTransfer`.
 *
 * An `OriginatedAchTransfer` is initiated by Highnote.
 * It can `PUSH` funds from a Highnote `FinancialAccount` to an external financial institution
 * or `PULL` funds from an external financial institution to a Highnote `FinancialAccount`.
 *
 * A `NonOriginatedAchTransfer` is initiated by an external financial institution.
 * It can `PULL` funds from a Highnote `FinancialAccount` to an external financial institution
 * or `PUSH` funds from an external financial institution to a Highnote `FinancialAccount`.
 */
export type AchTransferLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** An event that occurs when an `OriginatedAchTransfer` or `NonOriginatedTransfer` has a hold added by Highnote. */
export type AchTransferHoldAddedEvent = Node & {
  __typename?: "AchTransferHoldAddedEvent";
  /** The previous hold status. */
  fromHoldStatus?: Maybe<AchHoldStatus>;
  /** The previous hold type. */
  fromHoldType?: Maybe<AchHoldType>;
  /** The date the transfer hold was added by Highnote, in ISO 8601 format, e.g. 2024-01-01T00:00:00.000Z. */
  holdStatusAddedAt?: Maybe<Scalars["String"]>;
  /** Uniquely identifies the `AchTransferHoldAddedEvent`. */
  id: Scalars["ID"];
  /** Detains about the ACH transfer that had a hold added by Highnote. */
  transfer: AchTransfer;
};

/** An event that occurs when an `OriginatedAchTransfer` or `NonOriginatedTransfer` has a hold removed by Highnote. */
export type AchTransferHoldRemovedEvent = Node & {
  __typename?: "AchTransferHoldRemovedEvent";
  /** The previous hold status. */
  fromHoldStatus?: Maybe<AchHoldStatus>;
  /** The previous hold type. */
  fromHoldType?: Maybe<AchHoldType>;
  /** The date the transfer hold was removed by Highnote, in ISO 8601 format, e.g. 2024-01-01T00:00:00.000Z. */
  holdStatusRemovedAt?: Maybe<Scalars["String"]>;
  /** Uniquely identifies the `AchTransferHoldRemovedEvent`. */
  id: Scalars["ID"];
  /** Detains about the ACH transfer that had a hold removed by Highnote. */
  transfer: AchTransfer;
};

/** The purpose of the `AchTransfer`. */
export enum AchTransferPurpose {
  /** The `AchTransfer` is a deposit to a Highnote `FinancialAccount`. */
  DEPOSIT = "DEPOSIT",
  /** The `AchTransfer` is a disbursement from a network settlement to a merchant account. */
  MERCHANT_DISBURSEMENT = "MERCHANT_DISBURSEMENT",
  /** The `AchTransfer` is a merchant payout. */
  MERCHANT_PAYOUT = "MERCHANT_PAYOUT",
  /** The `AchTransfer` is a disbursement from a Highnote `FinancialAccount` to a merchant funding account. */
  MERCHANT_PUSH_PAYMENT_FUNDING = "MERCHANT_PUSH_PAYMENT_FUNDING",
  /** The `AchTransfer` is a payroll transfer. */
  PAYROLL = "PAYROLL",
  /** The `AchTransfer` is a card balance repayment. */
  REPAYMENT = "REPAYMENT",
  /** The `AchTransfer` is a secured deposit. */
  SECURED_DEPOSIT = "SECURED_DEPOSIT",
  /** The `AchTransfer` is a withdrawal from a Highnote `FinancialAccount`. */
  WITHDRAWAL = "WITHDRAWAL",
}

/** Input for filtering by `AchTransferPurpose`. */
export type AchTransferPurposeFilterInput = {
  equals?: InputMaybe<AchTransferPurpose>;
  excludes?: InputMaybe<Array<AchTransferPurpose>>;
  includes?: InputMaybe<Array<AchTransferPurpose>>;
  notEquals?: InputMaybe<AchTransferPurpose>;
};

/** The impact of the `AchTransfer` on the Highnote `FinancialAccount`. */
export enum AchTransferSign {
  /** The `AchTransfer` yields an decrease of funds on the Highnote `FinancialAccount`. */
  NEGATIVE = "NEGATIVE",
  /** The `AchTransfer` yields an increase of funds on the Highnote `FinancialAccount`. */
  POSITIVE = "POSITIVE",
}

/** Input for filtering by `AchTransferPurpose`. */
export type AchTransferSignFilterInput = {
  equals?: InputMaybe<AchTransferSign>;
  excludes?: InputMaybe<Array<AchTransferSign>>;
  includes?: InputMaybe<Array<AchTransferSign>>;
  notEquals?: InputMaybe<AchTransferSign>;
};

/** Additional details regarding a `FAILED` or `RETURNED` `AchTransfer`. */
export enum AchTransferStatusFailureReason {
  /** R11 - The `fromFinancialAccount` and `toFinancialAccount` do not belong to the same product. */
  ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT = "ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT",
  /** R11 - The account does not support ACH. */
  ACH_CAPABLE_BANK_ACCOUNT_FEATURE_NOT_ENABLED = "ACH_CAPABLE_BANK_ACCOUNT_FEATURE_NOT_ENABLED",
  /** R11 - Loading funds via ACH is not supported. */
  ACH_LOAD_NOT_ALLOWED_BY_PROGRAM = "ACH_LOAD_NOT_ALLOWED_BY_PROGRAM",
  /** R25 - The addenda record is invalid. */
  ADDENDA_ERROR = "ADDENDA_ERROR",
  /** R19 - There is an error in the amount field. */
  AMOUNT_FIELD_ERROR = "AMOUNT_FIELD_ERROR",
  /** R07 - The Authorization was revoked by Customer. */
  AUTHORIZATION_REVOKED_BY_CUSTOMER = "AUTHORIZATION_REVOKED_BY_CUSTOMER",
  /** R11 - The account does not have the required balance constraint feature enabled. */
  BALANCE_CONSTRAIN_FEATURE_NOT_ENABLED = "BALANCE_CONSTRAIN_FEATURE_NOT_ENABLED",
  /** R15 - The beneficiary or account holder is deceased. */
  BENEFICIARY_OR_ACCOUNT_HOLDER_DECEASED = "BENEFICIARY_OR_ACCOUNT_HOLDER_DECEASED",
  /** R12 - The receiving financial institution was acquired by another financial institution */
  BRANCH_SOLD_TO_ANOTHER_DFI = "BRANCH_SOLD_TO_ANOTHER_DFI",
  /** R11 - The account does not have the required card funding account feature enabled. */
  CARD_FUNDING_ACCOUNT_FEATURE_NOT_ENABLED = "CARD_FUNDING_ACCOUNT_FEATURE_NOT_ENABLED",
  /** R11 - The account does not have the required charge card feature enabled. */
  CHARGE_CARD_FEATURE_NOT_ENABLED = "CHARGE_CARD_FEATURE_NOT_ENABLED",
  /** R11 - The account does not have the required credit pay in full credit card feature enabled. */
  COMMERCIAL_CREDIT_PAY_IN_FULL_CREDIT_CARD_FEATURE_NOT_ENABLED = "COMMERCIAL_CREDIT_PAY_IN_FULL_CREDIT_CARD_FEATURE_NOT_ENABLED",
  /** R11 - The account does not have the required commercial pay in full account feature enabled. */
  COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED = "COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED",
  /** R11 - The account does not have the required corporate bank account feature enabled. */
  CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED = "CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED",
  /** R74 - The RDFI is returning a corrected entry. */
  CORRECTED_RETURN = "CORRECTED_RETURN",
  /** R11 - The account does not have the required credit card feature enabled. */
  CREDIT_CARD_FEATURE_NOT_ENABLED = "CREDIT_CARD_FEATURE_NOT_ENABLED",
  /** R23 - The receiver has refused the credit entry. */
  CREDIT_ENTRY_REFUSED_BY_THE_RECEIVER = "CREDIT_ENTRY_REFUSED_BY_THE_RECEIVER",
  /** R11 - The credit limit is not set on the account. */
  CREDIT_LIMIT_NOT_SET_ON_ACCOUNT = "CREDIT_LIMIT_NOT_SET_ON_ACCOUNT",
  /** R11 - The account does not have the required DDA feature enabled. */
  DDA_FEATURE_NOT_ENABLED = "DDA_FEATURE_NOT_ENABLED",
  /** R11 - The account does not have the required debit card feature enabled. */
  DEBIT_CARD_FEATURE_NOT_ENABLED = "DEBIT_CARD_FEATURE_NOT_ENABLED",
  /** R11 - The account does not have the required direct merchant settlement feature enabled. */
  DIRECT_MERCHANT_SETTLEMENT_FEATURE_NOT_ENABLED = "DIRECT_MERCHANT_SETTLEMENT_FEATURE_NOT_ENABLED",
  /** R47 - The RDFI received a duplicate enrollment for the same transaction. */
  DUPLICATE_ENROLLMENT = "DUPLICATE_ENROLLMENT",
  /** R24 - The RDFI received a duplicate entry for the same transaction. */
  DUPLICATE_ENTRY = "DUPLICATE_ENTRY",
  /** R67 - The RDFI received a duplicate return for the same transaction. */
  DUPLICATE_RETURN = "DUPLICATE_RETURN",
  /** R11 - The transfer is not in accordance with the terms of the authorization. */
  ENTRY_NOT_IN_ACCORDANCE_WITH_TERMS_OF_AUTHORIZATION = "ENTRY_NOT_IN_ACCORDANCE_WITH_TERMS_OF_AUTHORIZATION",
  /** R84 - The entry was not processed by the gateway. */
  ENTRY_NOT_PROCESSED_BY_GATEWAY = "ENTRY_NOT_PROCESSED_BY_GATEWAY",
  /** R62 - Funds cannot be pulled from receiving account. */
  ERRONEOUS_OR_REVERSING_DEBIT = "ERRONEOUS_OR_REVERSING_DEBIT",
  /** R02 - The external account has been closed. */
  EXTERNAL_ACCOUNT_CLOSED = "EXTERNAL_ACCOUNT_CLOSED",
  /** R16 - The external financial account is frozen. */
  EXTERNAL_ACCOUNT_FROZEN = "EXTERNAL_ACCOUNT_FROZEN",
  /** R03 - No matching external account was found. */
  EXTERNAL_ACCOUNT_NOT_FOUND = "EXTERNAL_ACCOUNT_NOT_FOUND",
  /** R69 - The entry contains multiple errors. */
  FIELD_ERRORS = "FIELD_ERRORS",
  /** R17 - The transaction contains invalid fields initiated under questionable circumstances */
  FILE_RECORD_EDIT_CRITERIA = "FILE_RECORD_EDIT_CRITERIA",
  /** R11 - The account does not have the required fleet feature enabled. */
  FLEET_FEATURE_NOT_ENABLED = "FLEET_FEATURE_NOT_ENABLED",
  /** R83 - The foreign receiving DFI is unable to settle the transaction. */
  FOREIGN_RECEIVING_DFI_UNABLE_TO_SETTLE = "FOREIGN_RECEIVING_DFI_UNABLE_TO_SETTLE",
  /** R11 - The account does not have the required funding account feature enabled. */
  FUNDING_ACCOUNT_FEATURE_NOT_ENABLED = "FUNDING_ACCOUNT_FEATURE_NOT_ENABLED",
  /** R11 - The account does not have the required funding card feature enabled. */
  FUNDING_CARD_NOT_SUPPORTED = "FUNDING_CARD_NOT_SUPPORTED",
  /** R02 - The Highnote `FinancialAccount` has been closed. */
  HIGHNOTE_ACCOUNT_CLOSED = "HIGHNOTE_ACCOUNT_CLOSED",
  /** R11 - The account does not have the required Highnote account feature enabled. */
  HIGHNOTE_ACCOUNT_FEATURE_NOT_ENABLED = "HIGHNOTE_ACCOUNT_FEATURE_NOT_ENABLED",
  /** R16 - The Highnote `FinancialAccount` is frozen. */
  HIGHNOTE_ACCOUNT_FROZEN = "HIGHNOTE_ACCOUNT_FROZEN",
  /** R03 - No matching Highnote `FinancialAccount` was found. */
  HIGHNOTE_ACCOUNT_NOT_FOUND = "HIGHNOTE_ACCOUNT_NOT_FOUND",
  /** R80 - The IAT entry was coded incorrectly. */
  IAT_ENTRY_CODING_ERRORS = "IAT_ENTRY_CODING_ERRORS",
  /** R18 - Has an Improper Effective entry date. */
  IMPROPER_EFFECTIVE_ENTRY_DATE = "IMPROPER_EFFECTIVE_ENTRY_DATE",
  /** R39 - The source document for the transaction is invalid. */
  IMPROPER_SOURCE_DOCUMENT_OR_SOURCE_DOCUMENT_PRESENTED_FOR_PAYMENT = "IMPROPER_SOURCE_DOCUMENT_OR_SOURCE_DOCUMENT_PRESENTED_FOR_PAYMENT",
  /** R11 - The account does not have the required income account feature enabled. */
  INCOME_ACCOUNT_FEATURE_NOT_ENABLED = "INCOME_ACCOUNT_FEATURE_NOT_ENABLED",
  /** R85 - The outbound international payment was coded incorrectly by the ODFI. */
  INCORRECTLY_CODED_OUTBOUND_INTERNATIONAL_PAYMENT = "INCORRECTLY_CODED_OUTBOUND_INTERNATIONAL_PAYMENT",
  /** R01 - This was a debit from an en external account did not have enough funds. */
  INSUFFICIENT_FUNDS_IN_EXTERNAL_ACCOUNT = "INSUFFICIENT_FUNDS_IN_EXTERNAL_ACCOUNT",
  /** R01 - This was a debit from an account at Highnote which did not have enough funds. */
  INSUFFICIENT_FUNDS_IN_HIGHNOTE_ACCOUNT = "INSUFFICIENT_FUNDS_IN_HIGHNOTE_ACCOUNT",
  /** There is an internal error with the transfer. */
  INTERNAL_ERROR = "INTERNAL_ERROR",
  /** R13 - The provided ACH routing number is invalid. */
  INVALID_ACH_ROUTING_NUMBER = "INVALID_ACH_ROUTING_NUMBER",
  /** R21 - Has an Invalid Company ID Number. */
  INVALID_COMPANY_ID_NUMBER = "INVALID_COMPANY_ID_NUMBER",
  /** R43 - The DFI account number provided is invalid. */
  INVALID_DFI_ACCOUNT_NUMBER = "INVALID_DFI_ACCOUNT_NUMBER",
  /** R04 - The external financial account has an invalid account number. */
  INVALID_EXTERNAL_ACCOUNT_NUMBER = "INVALID_EXTERNAL_ACCOUNT_NUMBER",
  /** R82 - The foreign receiving DFI identification is invalid. */
  INVALID_FOREIGN_RECEIVING_DFI_IDENTIFICATION = "INVALID_FOREIGN_RECEIVING_DFI_IDENTIFICATION",
  /** R04 - The Highnote `FinancialAccount` has an invalid account number. */
  INVALID_HIGHNOTE_ACCOUNT_NUMBER = "INVALID_HIGHNOTE_ACCOUNT_NUMBER",
  /** R22 - Has an Invalid Individual ID Number. */
  INVALID_INDIVIDUAL_ID_NUMBER = "INVALID_INDIVIDUAL_ID_NUMBER",
  /** R44 - The individual ID number or identification number provided is invalid. */
  INVALID_INDIVIDUAL_ID_NUMBER_OR_IDENTIFICATION_NUMBER = "INVALID_INDIVIDUAL_ID_NUMBER_OR_IDENTIFICATION_NUMBER",
  /** R45 - The individual name or company name provided is invalid. */
  INVALID_INDIVIDUAL_NAME_OR_COMPANY_NAME = "INVALID_INDIVIDUAL_NAME_OR_COMPANY_NAME",
  /** R46 - The representative payee indicator is invalid. */
  INVALID_REPRESENTATIVE_PAYEE_INDICATOR = "INVALID_REPRESENTATIVE_PAYEE_INDICATOR",
  /** R41 - The transaction code provided is invalid. */
  INVALID_TRANSACTION_CODE = "INVALID_TRANSACTION_CODE",
  /** R53 - Both the item and the ACH entry have been presented for payment. */
  ITEM_AND_RCK_ENTRY_PRESENTED_FOR_PAYMENT = "ITEM_AND_RCK_ENTRY_PRESENTED_FOR_PAYMENT",
  /** R51 - The item is ineligible for RCK processing; the required notice was not provided. */
  ITEM_RELATED_TO_RCK_ENTRY_IS_INELIGIBLE_OR_RCK_ENTRY_IS_IMPROPER = "ITEM_RELATED_TO_RCK_ENTRY_IS_INELIGIBLE_OR_RCK_ENTRY_IS_IMPROPER",
  /** R11 - The account does not have the required JIT feature enabled. */
  JIT_FEATURE_NOT_ENABLED = "JIT_FEATURE_NOT_ENABLED",
  /** R34 - The RDFI’s participation in the ACH system is limited. */
  LIMITED_PARTICIPATION_DFI = "LIMITED_PARTICIPATION_DFI",
  /** R26 - A mandatory field is invalid. */
  MANDATORY_FIELD_ERROR = "MANDATORY_FIELD_ERROR",
  /** R71 - The dishonored return entry was misrouted. */
  MISROUTED_DISHONORED_RETURN = "MISROUTED_DISHONORED_RETURN",
  /** R61 - The RDFI is returning an entry that was misrouted to them. */
  MISROUTED_RETURN = "MISROUTED_RETURN",
  /** R11 - The account does not have the required negative balance reserve feature enabled. */
  NEGATIVE_BALANCE_RESERVE_FEATURE_NOT_ENABLED = "NEGATIVE_BALANCE_RESERVE_FEATURE_NOT_ENABLED",
  /** R77 - The RDFI does not accept R62 dishonored return entries. */
  NON_ACCEPTANCE_OF_R62_DISHONORED_RETURN = "NON_ACCEPTANCE_OF_R62_DISHONORED_RETURN",
  /** R81 - The RDFI does not participate in the IAT program. */
  NON_PARTICIPANT_IN_IAT_PROGRAM = "NON_PARTICIPANT_IN_IAT_PROGRAM",
  /** R20 - Is a Non Transactional Account. */
  NON_TRANSACTION_ACCOUNT = "NON_TRANSACTION_ACCOUNT",
  /** R11 - The account does not have the required non-verified bank account feature enabled. */
  NON_VERIFIED_BANK_ACCOUNT_FEATURE_NOT_ENABLED = "NON_VERIFIED_BANK_ACCOUNT_FEATURE_NOT_ENABLED",
  /** R76 - No errors were found in the return entry. */
  NO_ERRORS_FOUND = "NO_ERRORS_FOUND",
  /** R11 - The program does not support ACH origination. */
  ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT = "ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT",
  /** R11 - The account does not have the required partial funding feature enabled. */
  PARTIAL_FUNDING_FEATURE_NOT_ENABLED = "PARTIAL_FUNDING_FEATURE_NOT_ENABLED",
  /** R08 - The Payment was stopped. */
  PAYMENT_STOPPED = "PAYMENT_STOPPED",
  /** R11 - The account does not have the required payroll advance feature enabled. */
  PAYROLL_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED",
  /** R11 - The account does not have the required payroll employer advance feature enabled. */
  PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED",
  /** R31 - The corporate receiver authorized the return of the entry. */
  PERMISSIBLE_RETURN_ENTRY = "PERMISSIBLE_RETURN_ENTRY",
  /** R70 - The RDFI chose not to accept a permissible return entry or the return was not requested by the ODFI. */
  PERMISSIBLE_RETURN_ENTRY_NOT_ACCEPTED_OR_RETURN_NOT_REQUESTED_BY_ODFI = "PERMISSIBLE_RETURN_ENTRY_NOT_ACCEPTED_OR_RETURN_NOT_REQUESTED_BY_ODFI",
  /** R11 - The account does not have the required points rewards feature enabled. */
  POINT_REWARDS_FEATURE_NOT_ENABLED = "POINT_REWARDS_FEATURE_NOT_ENABLED",
  /** R11 - The account does not have the required prepaid card feature enabled. */
  PREPAID_CARD_FEATURE_NOT_ENABLED = "PREPAID_CARD_FEATURE_NOT_ENABLED",
  /** R11 - The account does not have the required preprinted card feature enabled. */
  PREPRINTED_CARD_FEATURE_NOT_ENABLED = "PREPRINTED_CARD_FEATURE_NOT_ENABLED",
  /** R11 - The account does not have the required product funding feature enabled. */
  PRODUCT_FUNDING_FEATURE_NOT_ENABLED = "PRODUCT_FUNDING_FEATURE_NOT_ENABLED",
  /** R11 - The account does not have the required product reserve feature enabled. */
  PRODUCT_RESERVE_FEATURE_NOT_ENABLED = "PRODUCT_RESERVE_FEATURE_NOT_ENABLED",
  /** R11 - The account does not have the required product secured deposit feature enabled. */
  PRODUCT_SECURED_DEPOSIT_ACCOUNT_NOT_ENABLED = "PRODUCT_SECURED_DEPOSIT_ACCOUNT_NOT_ENABLED",
  /** R32 - The RDFI is not able to settle the transaction. */
  RDFI_NON_SETTLEMENT = "RDFI_NON_SETTLEMENT",
  /** R30 - The RDFI does not participate in check truncation program. */
  RDFI_NOT_A_PARTICIPANT_IN_CHECK_TRUNCATION_PROGRAM = "RDFI_NOT_A_PARTICIPANT_IN_CHECK_TRUNCATION_PROGRAM",
  /** R11 - The account does not have the required repayment account feature enabled. */
  REPAYMENT_ACCOUNT_FEATURE_NOT_ENABLED = "REPAYMENT_ACCOUNT_FEATURE_NOT_ENABLED",
  /** R86 - Repayment account not present on product */
  REPAYMENT_ACCOUNT_NOT_PRESENT_ON_PRODUCT = "REPAYMENT_ACCOUNT_NOT_PRESENT_ON_PRODUCT",
  /** R14 - The representative payee is deceased or unable to continue in that capacity. */
  REPRESENTATIVE_PAYEE_DECEASED_OR_UNABLE_TO_CONTINUE_IN_THAT_CAPACITY = "REPRESENTATIVE_PAYEE_DECEASED_OR_UNABLE_TO_CONTINUE_IN_THAT_CAPACITY",
  /** R06 - Funds were returned per ODFI Request. */
  RETURNED_PER_ODFI_REQUEST = "RETURNED_PER_ODFI_REQUEST",
  /** R75 - The return entry is not a duplicate of an earlier return. */
  RETURN_NOT_A_DUPLICATE = "RETURN_NOT_A_DUPLICATE",
  /** R40 - The ENR entry is being returned by federal government agency. */
  RETURN_OF_ENR_ENTRY_BY_FEDERAL_GOVERNMENT_AGENCY = "RETURN_OF_ENR_ENTRY_BY_FEDERAL_GOVERNMENT_AGENCY",
  /** R36 - The transaction is an improper credit entry according to NACHA rules. */
  RETURN_OF_IMPROPER_CREDIT_ENTRY = "RETURN_OF_IMPROPER_CREDIT_ENTRY",
  /** R35 - The transaction is an improper debit entry according to NACHA rules. */
  RETURN_OF_IMPROPER_DEBIT_ENTRY = "RETURN_OF_IMPROPER_DEBIT_ENTRY",
  /** R33 - The RDFI is returning an XCK (destroyed check) entry. */
  RETURN_OF_XCK_ENTRY = "RETURN_OF_XCK_ENTRY",
  /** R11 - The account does not have the required revolving card feature enabled. */
  REVOLVING_CARD_FEATURE_NOT_ENABLED = "REVOLVING_CARD_FEATURE_NOT_ENABLED",
  /** R28 - The routing number provided contains an invalid check digit. */
  ROUTING_NUMBER_CHECK_DIGIT_ERROR = "ROUTING_NUMBER_CHECK_DIGIT_ERROR",
  /** R42 - The routing number or check digit is invalid. */
  ROUTING_NUMBER_OR_CHECK_DIGIT_ERROR = "ROUTING_NUMBER_OR_CHECK_DIGIT_ERROR",
  /** R11 - The account does not have the required secured credit card feature enabled. */
  SECURED_CREDIT_CARD_FEATURE_NOT_ENABLED = "SECURED_CREDIT_CARD_FEATURE_NOT_ENABLED",
  /** R11 - The account does not have the required secured deposit feature enabled. */
  SECURED_DEPOSIT_ACCOUNT_NOT_ENABLED = "SECURED_DEPOSIT_ACCOUNT_NOT_ENABLED",
  /** R11 - The account does not have the required secure card feature enabled. */
  SECURE_CARD_FEATURE_NOT_ENABLED = "SECURE_CARD_FEATURE_NOT_ENABLED",
  /** R37 - The source document for the transaction was presented for payment. */
  SOURCE_DOCUMENT_PRESENTED_FOR_PAYMENT = "SOURCE_DOCUMENT_PRESENTED_FOR_PAYMENT",
  /** R50 - State law prohibits the RDFI from accepting RCK entries. */
  STATE_LAW_AFFECTING_RCK_ACCEPTANCE = "STATE_LAW_AFFECTING_RCK_ACCEPTANCE",
  /** R52 - The receiver requested a stop payment on the item. */
  STOP_PAYMENT_ON_ITEM_RELATED_TO_RCK_ENTRY = "STOP_PAYMENT_ON_ITEM_RELATED_TO_RCK_ENTRY",
  /** R38 - A stop payment was placed on the source document of the transaction. */
  STOP_PAYMENT_ON_SOURCE_DOCUMENT = "STOP_PAYMENT_ON_SOURCE_DOCUMENT",
  /** R73 - The RDFI received a timely original return entry. */
  TIMELY_ORIGINAL_RETURN = "TIMELY_ORIGINAL_RETURN",
  /** R27 - The trace number provided is invalid. */
  TRACE_NUMBER_ERROR = "TRACE_NUMBER_ERROR",
  /** R29 - The Transaction was not Authorized By Account Holder. */
  TRANSACTION_NOT_AUTHORIZED_BY_ACCOUNT_HOLDER = "TRANSACTION_NOT_AUTHORIZED_BY_ACCOUNT_HOLDER",
  /** R11 - The transfer was rejected by the originating partner bank. */
  TRANSACTION_REJECTED_BY_PARTNER_BANK = "TRANSACTION_REJECTED_BY_PARTNER_BANK",
  /** R11 - The transfer amount is below the minimum program reload limit. */
  TRANSFER_AMOUNT_BELOW_MIN_PROGRAM_RELOAD_LIMIT = "TRANSFER_AMOUNT_BELOW_MIN_PROGRAM_RELOAD_LIMIT",
  /** R11 - The transfer amount exceeds the maximum program load limit. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT",
  /** R11 - The transfer amount exceeds the maximum program reload limit. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_RELOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_RELOAD_LIMIT",
  /** R11 - The transfer amount is negative. */
  TRANSFER_AMOUNT_IS_NEGATIVE = "TRANSFER_AMOUNT_IS_NEGATIVE",
  /** R11 - The transfer amount is negative or zero. */
  TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO = "TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO",
  /** R11 - The product does not support transfer between provided accounts. */
  TRANSFER_NOT_SUPPORTED_ON_PRODUCT = "TRANSFER_NOT_SUPPORTED_ON_PRODUCT",
  /** R05 - Is an Unauthorized Debit to Consumer Account Using Corporate SEC Code. */
  UNAUTHORIZED_CONSUMER_DEBIT_USING_CORPORATE_SEC_CODE = "UNAUTHORIZED_CONSUMER_DEBIT_USING_CORPORATE_SEC_CODE",
  /** R10 - Is an Unauthorized, Improper, Ineligible, or Incomplete Transaction. */
  UNAUTHORIZED_IMPROPER_INELIGIBLE_OR_INCOMPLETE_TRANSACTION = "UNAUTHORIZED_IMPROPER_INELIGIBLE_OR_INCOMPLETE_TRANSACTION",
  /** R09 - Transaction represents Uncollected Funds. */
  UNCOLLECTED_FUNDS = "UNCOLLECTED_FUNDS",
  /** R72 - The dishonored return entry was received after the deadline. */
  UNTIMELY_DISHONORED_RETURN = "UNTIMELY_DISHONORED_RETURN",
  /** R68 - The return was received after the deadline. */
  UNTIMELY_RETURN = "UNTIMELY_RETURN",
  /** R11 - The account does not have the required verified bank account feature enabled. */
  VERIFIED_BANK_ACCOUNT_FEATURE_NOT_ENABLED = "VERIFIED_BANK_ACCOUNT_FEATURE_NOT_ENABLED",
}

/** Input for filtering by `AchTransferPurpose`. */
export type AchTransferStatusFailureReasonFilterInput = {
  equals?: InputMaybe<AchTransferStatusFailureReason>;
  excludes?: InputMaybe<Array<AchTransferStatusFailureReason>>;
  includes?: InputMaybe<Array<AchTransferStatusFailureReason>>;
  notEquals?: InputMaybe<AchTransferStatusFailureReason>;
};

/** The type of the `AchTransfer`. */
export enum AchTransferType {
  /** The `AchTransfer` is a pull transfer. This means pulling funds from the receiving financial institution to the originating financial institution. */
  PULL = "PULL",
  /** The `AchTransfer` is a push transfer. This means pushing funds from the originating financial institution to the receiving financial institution. */
  PUSH = "PUSH",
}

/** Input for filtering by `AchTransferType`. */
export type AchTransferTypeFilterInput = {
  equals?: InputMaybe<AchTransferType>;
  excludes?: InputMaybe<Array<AchTransferType>>;
  includes?: InputMaybe<Array<AchTransferType>>;
  notEquals?: InputMaybe<AchTransferType>;
};

/** The Card Processing Network that will process a payment */
export enum AcquirerNetwork {
  /** American Express */
  AMERICAN_EXPRESS = "AMERICAN_EXPRESS",
  /** Discover */
  DISCOVER = "DISCOVER",
  /** Highnote payment processing */
  HIGHNOTE = "HIGHNOTE",
  /** Interlink Network */
  INTERLINK = "INTERLINK",
  /** Maestro */
  MAESTRO = "MAESTRO",
  /** Mastercard */
  MASTERCARD = "MASTERCARD",
  /** MNGS Discover */
  MNGS_DISCOVER = "MNGS_DISCOVER",
  /** MNGS Pulse */
  MNGS_PULSE = "MNGS_PULSE",
  /** American Express via Payroc */
  PAYROC_AMERICAN_EXPRESS = "PAYROC_AMERICAN_EXPRESS",
  /** Pulse */
  PULSE = "PULSE",
  /** Visa Network */
  VISA = "VISA",
}

/** Input for specifying an externally stored credential on file. */
export type AcquiringExternalCredentialOnFileInput = {
  /**
   * Indicates that the `PaymentCardInput` will be stored externally, after
   * the `PaymentCardInput` has been used in this transaction successfully.
   *
   * Required, except when `networkTransactionIdentifier` is provided.
   */
  intendToStore?: InputMaybe<Scalars["Boolean"]>;
  /**
   * The network transaction id to use for this transaction.
   *
   * Required, except when `intendToStore` is `false`.
   */
  networkTransactionIdentifier?: InputMaybe<Scalars["String"]>;
};

/** The brand which the payment card belongs to. */
export enum AcquiringPaymentCardBrand {
  /** The payment card belongs to the American Express brand. */
  AMERICAN_EXPRESS = "AMERICAN_EXPRESS",
  /** The payment card belongs to the Diners Club brand. */
  DINERS_CLUB = "DINERS_CLUB",
  /** The payment card belongs to the Discover brand. */
  DISCOVER = "DISCOVER",
  /** The payment card belongs to the JCB brand. */
  JCB = "JCB",
  /** The payment card belongs to the Maestro brand. */
  MAESTRO = "MAESTRO",
  /** The payment card belongs to the Mastercard brand. */
  MASTERCARD = "MASTERCARD",
  /** The payment card belongs to the UnionPay brand. */
  UNIONPAY = "UNIONPAY",
  /** The payment card brand is unknown. */
  UNKNOWN = "UNKNOWN",
  /** The payment card belongs to the Visa brand. */
  VISA = "VISA",
}

/** Enum representing the different ways that a payment has been initiated. */
export enum AcquiringPaymentInitiator {
  /** The payment method was submitted to the merchant with an agreement to use the payment method for installment payments. */
  CUSTOMER_INITIATED_INSTALLMENT_FIRST = "CUSTOMER_INITIATED_INSTALLMENT_FIRST",
  /** The payment method was submitted to the merchant with an agreement to store the payment method for recurring payments. */
  CUSTOMER_INITIATED_RECURRING_FIRST = "CUSTOMER_INITIATED_RECURRING_FIRST",
  /** The payment method was submitted to the merchant over mail order, or telephone. */
  CUSTOMER_INITIATED_VIA_MAIL_ORDER_OR_TELEPHONE_ORDER = "CUSTOMER_INITIATED_VIA_MAIL_ORDER_OR_TELEPHONE_ORDER",
  /** The payment method was submitted to the merchant on the web. */
  CUSTOMER_INITIATED_VIA_WEB = "CUSTOMER_INITIATED_VIA_WEB",
  /** The merchant is using a customer's stored payment method and the payment is for installment payments. */
  MERCHANT_INITIATED_INSTALLMENT = "MERCHANT_INITIATED_INSTALLMENT",
  /**
   * The merchant is using a customer's stored payment method and the payment is recurring.
   *
   * An example of this is paying for a subscription.
   */
  MERCHANT_INITIATED_RECURRING = "MERCHANT_INITIATED_RECURRING",
  /**
   * The merchant is using a customer's stored payment method and the payment is recurring.
   *
   * An example of this is paying for a subscription.
   * @deprecated use MERCHANT_INITIATED_RECURRING
   */
  MERCHANT_INITIATED_TRANSACTION_RECURRING = "MERCHANT_INITIATED_TRANSACTION_RECURRING",
  /**
   * The merchant is using a customer's stored payment method and the payment is unscheduled.
   *
   * An example of when to use this would be reloading a balance or collecting payment after conditions have been met to take payment.
   * @deprecated use MERCHANT_INITIATED_UNSCHEDULED
   */
  MERCHANT_INITIATED_TRANSACTION_UNSCHEDULED = "MERCHANT_INITIATED_TRANSACTION_UNSCHEDULED",
  /**
   * The merchant is using a customer's stored payment method and the payment is unscheduled.
   *
   * An example of when to use this would be reloading a balance or collecting payment after conditions have been met to take payment.
   */
  MERCHANT_INITIATED_UNSCHEDULED = "MERCHANT_INITIATED_UNSCHEDULED",
}

/** Acquiring provider */
export enum AcquiringProviderType {
  /** Cross River Bank */
  CRB = "CRB",
  /** Highnote */
  HIGHNOTE = "HIGHNOTE",
  /** Payroc */
  PAYROC = "PAYROC",
}

/** Input fields for activating a `CreditPlan` for a `CardProduct`. */
export type ActivateCardProductCreditPlanInput = {
  /** The date this plan starts to be in effect for new `FinancialAccount`s, in YYYY-MM-DD (ISO 8601 RFC 3339) date format. For example, `2023-01-15`. Must be in the future. Must be unique across similar `CreditPlan`s for this `CardProduct`. Optional; if not included, the `CreditPlan` will be active immediately and this value will be set to the current date. */
  effectiveFromDate?: InputMaybe<Scalars["Date"]>;
  /** The date this plan stops being in effect for new `FinancialAccount`s, in YYYY-MM-DD (ISO 8601 RFC 3339) date format. For example, `2023-01-15`. Optional; if not included, the plan is treated as indefinite, with no set ending. */
  effectiveThroughDate?: InputMaybe<Scalars["Date"]>;
  /** Global id for the `CardProduct` */
  id: Scalars["ID"];
};

/** Types that can be returned for `ActivateCardProductCreditPlan`. */
export type ActivateCardProductCreditPlanPayload =
  | AccessDeniedError
  | CreditPlan
  | UserError;

/** The input to activate a `CollaborativeAuthorizationEndpoint`. */
export type ActivateCollaborativeAuthorizationEndpointInput = {
  /** The Global ID of the `CollaborativeAuthorizationEndpoint` to activate. */
  endpointId: Scalars["ID"];
};

/** The return types when activating a `CollaborativeAuthorizationEndpoint`. */
export type ActivateCollaborativeAuthorizationEndpointPayload =
  | AccessDeniedError
  | CollaborativeAuthorizationEndpoint
  | UserError;

/** Input for activating an `InstallmentAgreement` for a `Transaction` by providing a `TransactionEvent`. */
export type ActivateInstallmentAgreementForTransactionEventInput = {
  /** The `AuthorizationAndClearEvent` or `ClearingEvent` associated with the `Transaction` to convert into installments. */
  cardTransactionEventId: Scalars["ID"];
  /** The unique identifier for the `CreditPlan` to use to convert this `Transaction` into installments. */
  creditPlanId: Scalars["ID"];
};

/** Types which can be returned when converting a `Transaction` into an `InstallmentAgreement`. */
export type ActivateInstallmentAgreementForTransactionEventPayload =
  | AccessDeniedError
  | InstallmentAgreement
  | UserError;

/** The input to activate a notification target. */
export type ActivateNotificationTargetInput = {
  targetId: Scalars["ID"];
};

/** The return types when activating a notification target. */
export type ActivateNotificationTargetPayload =
  | AccessDeniedError
  | UserError
  | WebhookNotificationTarget;

/** The details of the Payment Card to activate. */
export type ActivatePaymentCardInput = {
  /** The ID of the Payment Card to activate. */
  paymentCardId: Scalars["ID"];
};

/** The return types when activating a Payment Card. */
export type ActivatePaymentCardPayload =
  | AccessDeniedError
  | PaymentCard
  | UserError;

/** The input to add a new `CollaborativeAuthorizationEndpoint`. */
export type AddCollaborativeAuthorizationEndpointInput = {
  /**
   * A name for the `CollaborativeAuthorizationEndpoint`.
   *
   * Must be between 1 and 255 characters.
   */
  name: Scalars["String"];
  /**
   * A valid URI to send collaborative authorization requests. The protocol _must be included_ and is required to be `https`.
   *
   * Example: `https://mywebhook.com`
   */
  uri: Scalars["String"];
};

/** The return types when adding a `CollaborativeAuthorizationEndpoint`. */
export type AddCollaborativeAuthorizationEndpointPayload =
  | AccessDeniedError
  | CollaborativeAuthorizationEndpoint
  | UserError;

/** The details to add the bank account for account holder. */
export type AddExternalBankAccountFromTokenInput = {
  /** The Global ID of the account holder for whom bank account is added. */
  accountHolderId: Scalars["ID"];
  /** The external token that can be used to fetch bank account details of account holder. */
  externalToken: ExternalTokenInput;
};

/** The external financial account created while adding bank account for account holder. */
export type AddExternalBankAccountFromTokenPayload =
  | AccessDeniedError
  | ExternalFinancialBankAccount
  | UserError;

/** The details needed in order to add an external bank account via Finicity. */
export type AddExternalBankAccountVerifiedThroughFinicityInput = {
  /** The Global ID of the account holder for whom bank account is added. */
  accountHolderId: Scalars["ID"];
  /** The type of bank account (Checking or Savings) */
  bankAccountType: BankAccountType;
  /** The external token that can be used to fetch bank account details of account holder. */
  externalToken: ExternalTokenFinicityInput;
  /** The account name from the institution that Finicity's Get Customer Account API must return. */
  name: Scalars["String"];
};

/** The details needed in order to add an external bank account via Plaid. */
export type AddExternalBankAccountVerifiedThroughPlaidInput = {
  /** The Global ID of the account holder for whom bank account is added. */
  accountHolderId: Scalars["ID"];
  /** The external token that can be used to fetch bank account details of account holder. */
  externalToken: ExternalTokenInput;
};

/** The input type to add an external bank account via a Third Party and Plaid. */
export type AddExternalBankAccountVerifiedThroughPlaidUsingThirdPartyProcessorTokenInput =
  {
    /** The Global identifier of the relevant account holder. */
    accountHolderId: Scalars["ID"];
    /** The card product associated with this request. This mutation is only usable for specific products within the `CONSUMER_CREDIT` vertical. */
    cardProductId: Scalars["ID"];
    /** The Highnote processor token provided by Plaid. */
    externalToken: ExternalTokenInput;
    /** The Third Party processor token provided by Plaid. */
    thirdPartyProcessorToken: ExternalTokenInput;
  };

/** The details to add funds to a Payment Card. */
export type AddFundsToPaymentCardInput = {
  /** The amount to add to the Payment Card. */
  amount: AmountInput;
  /** A description of the transfer for later reference. */
  memo?: InputMaybe<Scalars["String"]>;
  /** The ID of the Payment Card to add funds. */
  paymentCardId: Scalars["ID"];
};

/**
 * The return types when adding funds to a payment card.
 *
 * WARNING: Transfer is deprecated. ElectronicFundsTransfer should be used instead.
 */
export type AddFundsToPaymentCardPayload =
  | AccessDeniedError
  | Transfer
  | UserError;

/** The information of the US bank account to be added to an account holder that can only be transferred to */
export type AddNonVerifiedExternalUsFinancialBankAccountInput = {
  /** The identifier of an Account holder */
  accountHolderId: Scalars["ID"];
  /** The account number of the bank account */
  accountNumber: Scalars["String"];
  /** The type of bank account (Checking or Savings) */
  bankAccountType: BankAccountType;
  /** An optional nick name for the bank account */
  name?: InputMaybe<Scalars["String"]>;
  /** The routing number of the bank account */
  routingNumber: Scalars["String"];
};

/**
 * Response type for adding a non verified bank account.
 * Will return the last four digits of the account and it's name
 */
export type AddNonVerifiedExternalUsFinancialBankAccountPayload =
  | AccessDeniedError
  | NonVerifiedExternalUsFinancialBankAccount
  | UserError;

export type AddPaymentCardDigitalWalletTokenApplePayDevicePushProvisioningPayload =

    | AccessDeniedError
    | PaymentCardDigitalWalletTokenApplePayDevicePushProvisioning
    | UserError;

export type AddPaymentCardDigitalWalletTokenGooglePayPushProvisioningPayload =
  | AccessDeniedError
  | PaymentCardDigitalWalletTokenGooglePayPushProvisioning
  | UserError;

/** Input to Provision a `PaymentCard` to an Apple Pay Eligible Device via Push Provisioning. */
export type AddPaymentCardToApplePayByDevicePushProvisioningInput = {
  /** A Base64-encoded list of certificates. */
  certificates: Array<Scalars["String"]>;
  /** Specifies the type of device which is initiating the provisioning. */
  deviceType: PaymentCardDigitalWalletDeviceType;
  /** A Base64-encoded, one-time use nonce generated by Apple’s servers. */
  nonce: Scalars["String"];
  /** A Base64-encoded device and account specific signature of the nonce. */
  nonceSignature: Scalars["String"];
  /** The ID of the payment card to be push provisioned. */
  paymentCardId: Scalars["ID"];
};

/** Input to Provision a `PaymentCard` to a Google Pay Eligible Device via Push Provisioning. */
export type AddPaymentCardToGooglePayByDevicePushProvisioningInput = {
  /** Specifies the type of device which is initiating the provisioning. */
  deviceType: PaymentCardDigitalWalletDeviceType;
  /** Display Name describes the Payment Card in the user interface. Highnote can return this value in the response which the Subscriber’s mobile app can override before calling pushTokenize on the wallet app. If not provided, Highnote will leverage the name of the product. */
  displayName?: InputMaybe<Scalars["String"]>;
  /** The ID of the payment card to be push provisioned. */
  paymentCardId: Scalars["ID"];
  /** Token provisioning wallet details. */
  walletDetails?: InputMaybe<WalletDetailsInput>;
};

/** The input to add subscriptions to a notification target. */
export type AddSubscriptionsToNotificationTargetInput = {
  /** The event names to receive notifications about. */
  subscriptions: Array<NotificationEventName>;
  /** Target Id */
  targetId: Scalars["ID"];
};

/** The return types when adding subscriptions to a notification target. */
export type AddSubscriptionsToNotificationTargetPayload =
  | AccessDeniedError
  | UserError
  | WebhookNotificationTarget;

/** Add a relationship to a `UserDefinedFieldDefinition`. */
export type AddUserDefinedFieldDefinitionRelationshipInput = {
  /** The ID of the field definition to update. */
  id: Scalars["ID"];
  /** The relationship type that applies to the `UserDefinedFieldDefinition`. */
  relationshipType?: InputMaybe<UserDefinedFieldDefinitionRelationshipType>;
};

/** The input to add a new webhook notification target. */
export type AddWebhookNotificationTargetInput = {
  /**
   * The email address to which target deactivation emails are sent.
   * This data is only stored in the live environment. Deactivation emails are not sent in the test environment.
   */
  email?: InputMaybe<Scalars["String"]>;
  /**
   * A name for the target.
   *
   * Must be between 1 and 255 characters.
   */
  name: Scalars["String"];
  /** The event names to receive notifications about. */
  subscriptions: Array<NotificationEventName>;
  /**
   * A valid URI to send notifications. The protocol _must be included_ and is required to be `https`.
   *
   * Example: `https://mywebhook.com`
   */
  uri: Scalars["String"];
};

/** The return types when adding webhook notification targets. */
export type AddWebhookNotificationTargetPayload =
  | AccessDeniedError
  | UserError
  | WebhookNotificationTarget;

/** Additional network transaction data. */
export type AdditionalNetworkData = MastercardData | VisaData;

export type AdditionalTransactionData = {
  /** Globally unique id of a `AdditionalTransactionData`. */
  id: Scalars["ID"];
};

/** Type representing the parts of an address. */
export type Address = {
  __typename?: "Address";
  /** The three letter country code where the address resides. */
  countryCodeAlpha3?: Maybe<Scalars["String"]>;
  /** Additional data about the address, e.g. apartment, unit, floor, or place name. */
  extendedAddress?: Maybe<Scalars["String"]>;
  /** The locality of the address (e.g. town, city) */
  locality?: Maybe<Scalars["String"]>;
  /** The postal code of the address. */
  postalCode?: Maybe<Scalars["String"]>;
  /** A region for the address. */
  region?: Maybe<Scalars["String"]>;
  /** The number and street of the address. */
  streetAddress?: Maybe<Scalars["String"]>;
};

/** Possible address components. */
export enum AddressComponent {
  /** The country code where the address resides. */
  COUNTRY_CODE_ALPHA_3 = "COUNTRY_CODE_ALPHA_3",
  /** Additional data about the address, e.g. apartment or unit number. */
  EXTENDED_ADDRESS = "EXTENDED_ADDRESS",
  /** The locality of the address, e.g. town or city. */
  LOCALITY = "LOCALITY",
  /** The postal code of the address. */
  POSTAL_CODE = "POSTAL_CODE",
  /** A region for the address, e.g. state or province. */
  REGION = "REGION",
  /** The number and street of the address. */
  STREET_ADDRESS = "STREET_ADDRESS",
}

/** The delivery status of a validated address, as determined by USPS Delivery Point Validation (DPV). */
export enum AddressDeliveryStatus {
  /** The address delivery point is confirmed. */
  CONFIRMED = "CONFIRMED",
  /** The address delivery point information is not available. */
  NOT_AVAILABLE = "NOT_AVAILABLE",
  /** The primary address delivery point is confirmed, but the secondary address (e.g., apartment or unit) is missing or not confirmed. */
  PARTIAL = "PARTIAL",
  /** The address delivery point could not be confirmed. */
  UNCONFIRMED = "UNCONFIRMED",
}

/** Input for filtering by Address. */
export type AddressFilterInput = {
  countryCodeAlpha3?: InputMaybe<Iso3166Alpha3Country>;
  extendedAddress?: InputMaybe<StringFilterInput>;
  locality?: InputMaybe<StringFilterInput>;
  postalCode?: InputMaybe<StringFilterInput>;
  region?: InputMaybe<StringFilterInput>;
  streetAddress?: InputMaybe<StringFilterInput>;
};

/** `Address` validation result type returned when address is incomplete. */
export type AddressIncompleteResult = {
  __typename?: "AddressIncompleteResult";
  /** List of address components that are missing. */
  componentsMissing?: Maybe<Array<AddressComponent>>;
  /** The address as provided to `validateAddress`. */
  provided?: Maybe<Address>;
};

/** Input representing the parts of an address. */
export type AddressInput = {
  /** The [three letter country code](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3) where the address resides. */
  countryCodeAlpha3: Scalars["String"];
  /**
   * Additional data about the address, e.g. apartment, unit, floor, or place name.
   *
   * The validation for the `extendedAddress` uses the following regex pattern `^[a-zA-Z\d',. \-#]+(([',. \-#\/][a-zA-Z \d])?[a-zA-Z.]*)*$`.
   *
   * It checks for numeric string with special characters and whitespace.
   */
  extendedAddress?: InputMaybe<Scalars["String"]>;
  /**
   * The locality of the address (e.g. town, city)
   *
   * The validation for the `locality` uses the following regex pattern `^['\p{L}]+(?:[ \p{L},'-:])*$`.
   *
   * It checks to ensure it begins with a single quote or any letter, followed by whitespace, commas, single quote, any letter, or character in this set '()*+,-./0123456789: .
   */
  locality: Scalars["String"];
  /** The postal code of the address.  The value can include 5 numbers only or a hyphen - and 4 numbers */
  postalCode: Scalars["String"];
  /** A region for the address based on the two letter state [IS0 3166 standard](https://en.wikipedia.org/wiki/ISO_3166-2:US), including districts and outlying areas. */
  region: Scalars["String"];
  /**
   * The number and street of the address.
   *
   * The validation for the `address` uses the following regex pattern `^\s*\S+(?:\s+\S+){1,3}`.
   *
   * This pattern matches two to four groups of non-whitespace characters. These can include special characters like dashes or slashes. For example, 'Cozy Cottage', '200 Lake Rd', '123 Second Street NW', and '111 1/2 Center Street' all match.
   *
   * When the field is used for creating an application, it will also validate that a PO Box is not included using this regex pattern `^(?:((\S([^pPOo])+)|(?:[0-9]+)))\s(?:[0-9A-Za-z\.]|[^\S\r\n])+$`.
   *
   * When the field is used for creating a physical payment card order or physical payment card group order, it will also support mailing to a PO Box using this regex pattern `^(?:(?:(?:\S[^pPOo\r\n]+)|(?:[0-9\/#]+)))\s(?:[0-9A-Za-z\.]|[^\S\r\n])+$|^\b[P|p]*(?:OST|ost)*\.*\s*[O|o|0]*(?:ffice|FFICE)*\.*\s*[B|b][O|o|0][X|x]\s[0-9A-Za-z]+\b$`.
   */
  streetAddress: Scalars["String"];
};

/** `Address` validation result type returned when address is invalid. */
export type AddressInvalidResult = {
  __typename?: "AddressInvalidResult";
  /** List of address components that are invalid. */
  componentsInvalid?: Maybe<Array<AddressComponent>>;
  /** The address as provided to `validateAddress`. */
  provided?: Maybe<Address>;
};

/** The intended scope of a validated address token. */
export enum AddressTokenScope {
  /** The token can be used multiple times. */
  MULTI_USE = "MULTI_USE",
  /**
   * Represents a single-use token for accessing a Customer Attribute.
   *
   * Description: The generated token can only be used once. After the token is either consumed in an API call or has expired,
   * it becomes invalid.
   *
   * Constraints:
   * - Single-use only — a token cannot be reused.
   * - A new token must be generated once the previous token is used or expires.
   * - Tokens are required to access Customer Attributes in other APIs.
   *
   * Example:
   * 1. Generate a token for a Customer Attribute.
   * 2. Use the token in a downstream API request.
   * 3. Once used or expired, generate a new token before making another request.
   */
  SINGLE_USE = "SINGLE_USE",
}

/** `Address` validation result type returned when address is validated without any changes. */
export type AddressValidatedResult = {
  __typename?: "AddressValidatedResult";
  /** The validated address token. */
  token?: Maybe<ValidatedAddressToken>;
};

/** `Address` validation result type returned when address is validated with changes. */
export type AddressValidatedWithChangesResult = {
  __typename?: "AddressValidatedWithChangesResult";
  /** List of address components that were changed. */
  componentsChanged?: Maybe<Array<AddressComponent>>;
  /** The validated address token. */
  token?: Maybe<ValidatedAddressToken>;
};

/** Types which can be returned for `validateAddress` outcome. */
export type AddressValidationOutcome =
  | AddressIncompleteResult
  | AddressInvalidResult
  | AddressValidatedResult
  | AddressValidatedWithChangesResult;

/** Result of `validatedAddress`. */
export type AddressValidationResult = {
  __typename?: "AddressValidationResult";
  /** Outcome of the address validation. */
  outcome?: Maybe<AddressValidationOutcome>;
};

/** A Adjustment Event for a transaction. */
export type AdjustmentEvent = Node &
  TransactionEvent & {
    __typename?: "AdjustmentEvent";
    /**
     * The direction funds are moving in the perspective of the cardholder.
     *
     * * when DEBIT, funds are moving out of the cardholder's account
     * * when CREDIT, funds are moving into the cardholder's account
     */
    accountingDirection?: Maybe<AccountingDirection>;
    /** Network specific transaction data. */
    additionalNetworkData?: Maybe<AdditionalNetworkData>;
    /** The `Amount` approved for this `AdjustmentEvent` and posted in the settlement currency. Does not include fees. */
    approvedAmount?: Maybe<Amount>;
    /** The `CardProduct` associated to this `AdjustmentEvent`. */
    cardProduct?: Maybe<CardProduct>;
    /** The date and time, in ISO 8601 format, this `AdjustmentEvent` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The `Amount` available to spend after this transaction event. */
    currentFinancialAccountAvailableToSpendAmount?: Maybe<Amount>;
    /** Maximum balance allowed for the card account at the time of this transaction event */
    currentFinancialAccountMaximumBalanceAmount?: Maybe<Amount>;
    /** The ID of the transaction event. */
    id: Scalars["ID"];
    /** Not used for this `AdjustmentEvent` */
    merchantDetails?: Maybe<MerchantDetails>;
    /**
     * The response code from the card network (e.g. Mastercard).
     * @deprecated Use responseCode instead
     */
    networkResponseCode?: Maybe<Scalars["String"]>;
    /**
     * The transaction ID from the card network (e.g. Mastercard).
     * @deprecated No longer supported
     */
    networkTransactionId?: Maybe<Scalars["ID"]>;
    /** The `PaymentCard` associated to this `AdjustmentEvent`. */
    paymentCard?: Maybe<PaymentCard>;
    /** A snapshot of the `PaymentCard` at the time of the `AdjustmentEvent`. */
    paymentCardSnapshot?: Maybe<PaymentCardSnapshot>;
    /** The Point Of Service Details. */
    pointOfServiceDetails?: Maybe<PointOfServiceDetails>;
    /** The Highnote response code. */
    responseCode?: Maybe<TransactionEventResponseCode>;
    /** The `Transaction` for this event. */
    transaction?: Maybe<Transaction>;
    /** Represents the customer transaction type being processed. */
    transactionProcessingType?: Maybe<CardTransactionProcessingType>;
  };

/** Organization that an Admin Agent can access. */
export type AdminAgentOrganization = Node & {
  __typename?: "AdminAgentOrganization";
  /** Detailed information about the organization */
  businessDetail?: Maybe<BusinessDetail>;
  /** ID of the Organization */
  id: Scalars["ID"];
  /** Details of the Organization */
  profile: OrganizationProfile;
  /** ID of the Tenant */
  tenantId: Scalars["ID"];
};

/** Reasons behind adverse actions for credit underwriting. */
export enum AdverseActionCode {
  /** Bankruptcy */
  BANKRUPTCY = "BANKRUPTCY",
  /** Collections action or judgment */
  COLLECTIONS = "COLLECTIONS",
  /** The cardholder is deceased. */
  DECEASED = "DECEASED",
  /** Delinquent past or present credit obligations */
  DELINQUENT_CREDIT_OBLIGATIONS = "DELINQUENT_CREDIT_OBLIGATIONS",
  /** Applicant has excessive debt obligations */
  EXCESSIVE_DEBT_OBLIGATIONS = "EXCESSIVE_DEBT_OBLIGATIONS",
  /** The cardholder has excessive payment obligations in relation to their income. */
  EXCESSIVE_OBLIGATIONS_TO_INCOME = "EXCESSIVE_OBLIGATIONS_TO_INCOME",
  /** High credit utilization ratio */
  HIGH_UTILIZATION = "HIGH_UTILIZATION",
  /** Incomplete company or owners’ identity information */
  INCOMPLETE_IDENTITY_INFORMATION = "INCOMPLETE_IDENTITY_INFORMATION",
  /** Applicant cash or liquid balances are insufficient to support the credit request. */
  INSUFFICIENT_CASH_BALANCES = "INSUFFICIENT_CASH_BALANCES",
  /** Income insufficient for the amount of credit requested */
  INSUFFICIENT_INCOME = "INSUFFICIENT_INCOME",
  /** Applicant revenue does not meet the minimum required threshold. */
  INSUFFICIENT_REVENUE = "INSUFFICIENT_REVENUE",
  /** Length of employment is limited or unstable */
  LENGTH_OF_EMPLOYMENT = "LENGTH_OF_EMPLOYMENT",
  /** Length of time at residence is limited or unstable */
  LENGTH_OF_RESIDENCE = "LENGTH_OF_RESIDENCE",
  /** Does not meet lien position requirement */
  LIEN_POSITION = "LIEN_POSITION",
  /** Applicant has limited credit references or history */
  LIMITED_CREDIT_EXPERIENCE = "LIMITED_CREDIT_EXPERIENCE",
  /** Applicant credit score does not meet the minimum score requirements */
  MIN_CREDIT_SCORE = "MIN_CREDIT_SCORE",
  /** Does not meet the minimum length of business incorporation */
  MIN_YEARS_INCORPORATION = "MIN_YEARS_INCORPORATION",
  /** Too many accounts opened recently */
  RECENT_CREDIT_ACCOUNTS = "RECENT_CREDIT_ACCOUNTS",
  /** Too many recent credit applications */
  RECENT_CREDIT_APPLICATIONS = "RECENT_CREDIT_APPLICATIONS",
  /** Unable to verify applicant's credit references */
  UNABLE_TO_VERIFY_CREDIT_REFERENCES = "UNABLE_TO_VERIFY_CREDIT_REFERENCES",
  /** Unable to verify applicant's employment */
  UNABLE_TO_VERIFY_EMPLOYMENT = "UNABLE_TO_VERIFY_EMPLOYMENT",
  /** Unable to verify the Account Holder's identity. */
  UNABLE_TO_VERIFY_IDENTITY = "UNABLE_TO_VERIFY_IDENTITY",
  /** Unable to verify applicant’s income */
  UNABLE_TO_VERIFY_INCOME = "UNABLE_TO_VERIFY_INCOME",
  /** We do not offer credit to this industry */
  UNACCEPTED_BUSINESS_INDUSTRY = "UNACCEPTED_BUSINESS_INDUSTRY",
  /** The account holder has withdrawn their card product application */
  WITHDRAWN = "WITHDRAWN",
}

/** Inputs values for possible reasons for behind adverse actions for credit underwriting. */
export enum AdverseActionCodeInput {
  /** Bankruptcy */
  BANKRUPTCY = "BANKRUPTCY",
  /** Collections action or judgment */
  COLLECTIONS = "COLLECTIONS",
  /** Delinquent past or present credit obligations */
  DELINQUENT_CREDIT_OBLIGATIONS = "DELINQUENT_CREDIT_OBLIGATIONS",
  /** Applicant has excessive debt obligations */
  EXCESSIVE_DEBT_OBLIGATIONS = "EXCESSIVE_DEBT_OBLIGATIONS",
  /** Applicant has excessive payment obligations in relation to their income */
  EXCESSIVE_OBLIGATIONS_TO_INCOME = "EXCESSIVE_OBLIGATIONS_TO_INCOME",
  /** High credit utilization ratio */
  HIGH_UTILIZATION = "HIGH_UTILIZATION",
  /** Incomplete company or owners’ identity information */
  INCOMPLETE_IDENTITY_INFORMATION = "INCOMPLETE_IDENTITY_INFORMATION",
  /** Applicant cash or liquid balances are insufficient to support the credit request. */
  INSUFFICIENT_CASH_BALANCES = "INSUFFICIENT_CASH_BALANCES",
  /** Income insufficient for the amount of credit requested */
  INSUFFICIENT_INCOME = "INSUFFICIENT_INCOME",
  /** Applicant revenue does not meet the minimum required threshold. */
  INSUFFICIENT_REVENUE = "INSUFFICIENT_REVENUE",
  /** Length of employment is limited or unstable */
  LENGTH_OF_EMPLOYMENT = "LENGTH_OF_EMPLOYMENT",
  /** Length of time at residence is limited or unstable */
  LENGTH_OF_RESIDENCE = "LENGTH_OF_RESIDENCE",
  /** Does not meet lien position requirement */
  LIEN_POSITION = "LIEN_POSITION",
  /** Applicant has limited credit references or history */
  LIMITED_CREDIT_EXPERIENCE = "LIMITED_CREDIT_EXPERIENCE",
  /** Applicant credit score does not meet the minimum score requirements */
  MIN_CREDIT_SCORE = "MIN_CREDIT_SCORE",
  /** Does not meet the minimum length of business incorporation */
  MIN_YEARS_INCORPORATION = "MIN_YEARS_INCORPORATION",
  /** Too many accounts opened recently */
  RECENT_CREDIT_ACCOUNTS = "RECENT_CREDIT_ACCOUNTS",
  /** Too many recent credit applications */
  RECENT_CREDIT_APPLICATIONS = "RECENT_CREDIT_APPLICATIONS",
  /** Unable to verify applicant's credit references */
  UNABLE_TO_VERIFY_CREDIT_REFERENCES = "UNABLE_TO_VERIFY_CREDIT_REFERENCES",
  /** Unable to verify applicant's employment */
  UNABLE_TO_VERIFY_EMPLOYMENT = "UNABLE_TO_VERIFY_EMPLOYMENT",
  /** Unable to verify the Account Holder's identity. */
  UNABLE_TO_VERIFY_IDENTITY = "UNABLE_TO_VERIFY_IDENTITY",
  /** Unable to verify applicant’s income */
  UNABLE_TO_VERIFY_INCOME = "UNABLE_TO_VERIFY_INCOME",
  /** We do not offer credit to this industry */
  UNACCEPTED_BUSINESS_INDUSTRY = "UNACCEPTED_BUSINESS_INDUSTRY",
  /** The account holder has withdrawn their card product application */
  WITHDRAWN = "WITHDRAWN",
}

/** An explanation given as to why the application was denied. */
export type AdverseActionReason = {
  __typename?: "AdverseActionReason";
  /** The reason why the application was denied. */
  code?: Maybe<AdverseActionCode>;
  /** A human friendly description for the `code`. */
  description?: Maybe<Scalars["String"]>;
};

/** An explanation given as to why the application was denied. */
export type AdverseActionReasonInput = {
  /** The reason why the application was denied. */
  code: AdverseActionCodeInput;
};

/** Methods for advertising a business. */
export enum AdvertisingMethod {
  /** Catalog and/or publications */
  CATALOG_PUBLICATIONS = "CATALOG_PUBLICATIONS",
  /** Internet */
  INTERNET = "INTERNET",
  /** Mass/Direct mail */
  MASS_DIRECT_MAIL = "MASS_DIRECT_MAIL",
  /** Telemarketing */
  TELEMARKETING = "TELEMARKETING",
  /** Word of mouth */
  WORD_OF_MOUTH = "WORD_OF_MOUTH",
  /** Yellow pages */
  YELLOW_PAGES = "YELLOW_PAGES",
}

/** Details about an advice message for a transaction. */
export type AdviceDetail = {
  __typename?: "AdviceDetail";
  /** The provided response code provided by advice message. */
  responseCode?: Maybe<TransactionAdviceEventResponseCode>;
};

/** An internal or external financial account. */
export type AllFinancialAccount =
  | ExternalFinancialBankAccount
  | FinancialAccount
  | NonVerifiedExternalUsFinancialBankAccount;

/** Monetary amount where the currency is used to express the expectations for the number of decimal places. See [ISO Standard Currency Codes](https://en.wikipedia.org/wiki/ISO_4217#Active_codes) for more information. */
export type Amount = {
  __typename?: "Amount";
  /**
   * Three-character [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217) currency code
   *
   * **Examples:** `"USD", "EUR", "GBP"`
   */
  currencyCode?: Maybe<Scalars["String"]>;
  /**
   * The number of decimal places for this `Amount`. This value is used to determine the decimal place for the `value` field.
   * This value will always be at least the number of decimal places for the `currencyCode` provided.
   * Standard transactions use 2 decimal places (cents), while interchange fees, splits, and percentage-based calculations may use up to 6 decimal places for sub-cent precision.
   *
   * **Examples:**
   * A value of `1099`, a currencyCode of `USD`, and a decimalPlaces of `2` as a string representation would be $10.99.
   * A value of `1099`, a currencyCode of `USD`, and a decimalPlaces of `3` as a string representation would be $1.099.
   */
  decimalPlaces?: Maybe<Scalars["UnsignedInt"]>;
  /**
   * Value of the amount as an integer. The number of decimal places [varies by currency](https://en.wikipedia.org/wiki/ISO_4217#Active_codes) so the value will be an integer accounting for the minor units.
   *
   * For example, a US dollar value of $10.99 will be returned as `1099`. A US dollar value of $10 will be returned as `1000`.
   *
   * Currencies with zero decimal places (such as `JPY`) or those with more than 2 (such as `JOD`) will be returned as `1099` and `10990` respectively.
   *
   * | Currency | Value
   * | --- | --- |
   * | USD | 1099 |
   * | JPY | 1099 |
   * | JOD | 10990 |
   */
  value?: Maybe<Scalars["UnsignedInt"]>;
};

/** The logical condition which compares amount in account holder activity. */
export type AmountFeeCondition = {
  __typename?: "AmountFeeCondition";
  /** The fee charge condition comparison operator. */
  operator?: Maybe<FeeChargeOperator>;
  /** The amount value against which amount in account holder activity is compared. */
  value?: Maybe<AmountFeeConditionValue>;
};

/** Amount Condition value. */
export type AmountFeeConditionValue = {
  __typename?: "AmountFeeConditionValue";
  /** The fee charge condition amount used with AMOUNT condition type. */
  amount?: Maybe<Amount>;
  /**
   * The fee charge condition maximum amount used with AMOUNT condition type.
   * Used with BETWEEN condition operator.
   */
  maximumAmount?: Maybe<Amount>;
};

export type AmountImpact = {
  __typename?: "AmountImpact";
  /** The `Amount` for this entry. */
  amount?: Maybe<Amount>;
  /**
   * Indicates how this amount impacts the account balance.
   * * DEBIT decreases the balance.
   * * CREDIT increases the balance.
   */
  impact?: Maybe<AccountingDirection>;
};

/** Monetary amount where the currency is used to express the expectations for the number of decimal places. See [ISO Standard Currency Codes](https://en.wikipedia.org/wiki/ISO_4217#Active_codes) for more information. */
export type AmountInput = {
  /**
   * Three-character [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217) currency code
   *
   * **Examples:** `"USD", "EUR", "GBP"`
   */
  currencyCode: Iso4217Alpha3SupportedCurrency;
  /**
   * Value of the amount as an integer. The number of decimal places [varies by currency](https://en.wikipedia.org/wiki/ISO_4217#Active_codes) so the value should be an integer accounting for the minor units.
   *
   * For example, a US dollar value of $10.99 should be provided as `1099`. A US dollar value of $10 should be provided as `1000`.
   *
   * Currencies with zero decimal places (such as `JPY`) or those with more than 2 (such as `JOD`) should be provided as `1099` and `10990` respectively.
   *
   * | Currency | Value
   * | --- | --- |
   * | USD | 1099 |
   * | JPY | 1099 |
   * | JOD | 10990 |
   */
  value: Scalars["UnsignedInt"];
};

/** A `CheckRule` that will put a check on hold if the amount is exceeded. */
export type AmountLimitCheckRule = Node & {
  __typename?: "AmountLimitCheckRule";
  /** The date and time, in ISO 8601 format, the rule was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the `AmountLimitCheckRule` in operations. */
  id: Scalars["ID"];
  /** The maximum amount to allow for a check. */
  maximumAmount?: Maybe<Amount>;
  /** The name assigned to the rule. */
  name?: Maybe<Scalars["String"]>;
  /** The list of revisions for this check rule. */
  revisions?: Maybe<CheckRuleConnection>;
  /** The date and time, in ISO 8601 format, the rule was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
  version?: Maybe<Scalars["String"]>;
};

/** A `CheckRule` that will put a check on hold if the amount is exceeded. */
export type AmountLimitCheckRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** An `InterFinancialAccountTransferRule` that will result in the decline of an inter financial account transfer if the maximum amount is exceeded. */
export type AmountLimitInterFinancialAccountTransferRule =
  InterFinancialAccountTransferRule &
    Node & {
      __typename?: "AmountLimitInterFinancialAccountTransferRule";
      /** The date and time, in ISO 8601 format, the transfer rule was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** Global ID used to reference the `AmountLimitInterFinancialAccountTransferRule` in operations. */
      id: Scalars["ID"];
      /** Indicates the account type to monitor. */
      interFinancialAccountTransferAccountType?: Maybe<InterFinancialAccountTransferAccountType>;
      /** The maximum amount to allow for an inter financial account transfer. */
      maximumAmount?: Maybe<Amount>;
      /** The name assigned to the rule. */
      name?: Maybe<Scalars["String"]>;
      /** The list of revisions for this transfer rule. */
      revisions?: Maybe<InterFinancialAccountTransferRuleConnection>;
      /** The date and time, in ISO 8601 format, the transfer rule was last updated. */
      updatedAt?: Maybe<Scalars["String"]>;
      /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
      version?: Maybe<Scalars["String"]>;
    };

/** An `InterFinancialAccountTransferRule` that will result in the decline of an inter financial account transfer if the maximum amount is exceeded. */
export type AmountLimitInterFinancialAccountTransferRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Result of `AmountLimitInterFinancialAccountTransferRule` */
export type AmountLimitInterFinancialAccountTransferRuleResult =
  InterFinancialAccountTransferRuleResult & {
    __typename?: "AmountLimitInterFinancialAccountTransferRuleResult";
    /** Amount limit inter financial account transfer rule */
    interFinancialAccountTransferRule?: Maybe<AmountLimitInterFinancialAccountTransferRule>;
    /** A message describing the result. */
    message?: Maybe<Scalars["String"]>;
    /** A status representing the result of the rule’s evaluation. */
    status?: Maybe<InterFinancialAccountTransferRuleResultStatus>;
  };

/** A Spend Control rule that limits the dollar amount during authorizations. */
export type AmountLimitSpendRule = Node &
  SpendRule & {
    __typename?: "AmountLimitSpendRule";
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the Merchant Category Spend Rule in operations. */
    id: Scalars["ID"];
    /** The maximum amount to allow for a single authorization. */
    maximumAmount?: Maybe<Amount>;
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/** A Spend Control rule that limits the dollar amount during authorizations. */
export type AmountLimitSpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The result of applying an amount limit spend rule to an event. */
export type AmountLimitSpendRuleResult = SpendRuleResult & {
  __typename?: "AmountLimitSpendRuleResult";
  /** The attached level. */
  attachedLevel?: Maybe<AttachedLevel>;
  /** A message describing the result. */
  message?: Maybe<Scalars["String"]>;
  /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
  recommendation?: Maybe<SpendRuleRecommendation>;
  /** The spend rule attached at the time of the event. */
  spendRule?: Maybe<AmountLimitSpendRule>;
  /** The tested amounts of the event. */
  valuesTested?: Maybe<Array<Amount>>;
};

/** The range type for `Amount`. */
export type AmountRange = {
  __typename?: "AmountRange";
  /** The maximum value (exclusive). */
  maximumExclusive?: Maybe<Amount>;
  /** The maximum value (inclusive). */
  maximumInclusive?: Maybe<Amount>;
  /** The minimum value (exclusive). */
  minimumExclusive?: Maybe<Amount>;
  /** The minimum value (inclusive). */
  minimumInclusive?: Maybe<Amount>;
};

/** A strategy for allowing amount calculation. Only one of the strategies below should be requested. */
export type AmountStrategyInput = {
  /** A calculated balance amount */
  balanceAmountType?: InputMaybe<TransferBalanceAmountCode>;
  /** An amount to be transferred */
  transferAmount?: InputMaybe<AmountInput>;
};

/**
 * JSON Web Signature (JWS) structure for Apple Pay Web Push Provisioning.
 * Field names follow Apple's JWS specification requirements.
 */
export type AppleWebPushProvisioningJws = {
  __typename?: "AppleWebPushProvisioningJWS";
  /** Unprotected header containing additional information. */
  header: AppleWebPushProvisioningJwsHeader;
  /** Base64URL-encoded payload. */
  payload: Scalars["String"];
  /** Base64URL-encoded protected header. */
  protected: Scalars["String"];
  /** Base64URL-encoded signature. */
  signature: Scalars["String"];
};

/** JWS header for Apple Pay Web Push Provisioning. */
export type AppleWebPushProvisioningJwsHeader = {
  __typename?: "AppleWebPushProvisioningJWSHeader";
  /** Key identifier used for signature verification. */
  kid: Scalars["String"];
};

/** Apple Pay Web Push Provisioning token response. */
export type AppleWebPushProvisioningToken = {
  __typename?: "AppleWebPushProvisioningToken";
  /** The token expiration time in ISO 8601 format. */
  expiresAt: Scalars["String"];
  /** The JSON Web Signature (JWS) object containing the provisioning token. */
  jws: AppleWebPushProvisioningJws;
  /** The provisioning session state identifier. */
  state: Scalars["String"];
};

/** The applicable rule user type for which a rule will be evaluated. */
export enum ApplicableRuleUserType {
  /** The associated rule will be evaluated for the authorized user. */
  AUTHORIZED_USER = "AUTHORIZED_USER",
}

/** Application-level configuration provided by the applicant at the start of the application. */
export type ApplicationConfiguration = {
  __typename?: "ApplicationConfiguration";
  /** Optional override of the billing cycle configuration requested by the applicant. */
  applicantBillingCycleOverride?: Maybe<BillingCycleOverride>;
};

/** Application-level configuration provided by the applicant at the start of the application. */
export type ApplicationConfigurationInput = {
  /** Optional override of the billing cycle configuration requested by the applicant. */
  applicantBillingCycleOverride?: InputMaybe<BillingCycleOverrideInput>;
};

/** A contract on an `ApplicationProduct` */
export type ApplicationContract = Node & {
  __typename?: "ApplicationContract";
  /** The date and time, in ISO 8601 format, when the contract starts. */
  effectiveStartDate?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, through which this contract is valid. */
  effectiveThroughDate?: Maybe<Scalars["String"]>;
  /** The Global ID of the contract. */
  id: Scalars["ID"];
  /** The settlement currencies permitted for this offer */
  permittedSettlementCurrencies?: Maybe<Array<Iso4217Alpha3CurrencyCode>>;
  /**
   * The payment network specific merchant category codes allowed
   * mcc, network, supported payment methods
   */
  processingCapabilities?: Maybe<Array<ProcessingCapability>>;
  /** The associated Product. */
  product?: Maybe<ApplicationProduct>;
};

/** The connection type for `ApplicationContract`. */
export type ApplicationContractConnection = {
  __typename?: "ApplicationContractConnection";
  /** A list of edges. */
  edges?: Maybe<Array<ApplicationContractEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The return types when querying a paginated list of `ApplicationContract`; */
export type ApplicationContractConnectionPayload =
  | AccessDeniedError
  | ApplicationContractConnection
  | UserError;

/** The edge type for `ApplicationContract`. */
export type ApplicationContractEdge = {
  __typename?: "ApplicationContractEdge";
  /** The cursor for this edge for use in pagination. */
  cursor?: Maybe<Scalars["String"]>;
  /** The `ApplicationContract`. */
  node?: Maybe<ApplicationContract>;
};

/** Inputs for filtering `ApplictionContract`. */
export type ApplicationContractFilterInput = {
  /** The id of the product associated to the `ApplictionContract`. */
  productId?: InputMaybe<StringFilterInput>;
};

/** Application denial reasons. */
export enum ApplicationDenialReason {
  /** The Application was denied due to the inability to decision on the Application within the timeframe as defined in the cardholder agreement due to missing information. */
  DENIED_DUE_TO_APPLICATION_INACTIVITY = "DENIED_DUE_TO_APPLICATION_INACTIVITY",
  /** The Application was denied due to other factors. */
  DENIED_DUE_TO_OTHER = "DENIED_DUE_TO_OTHER",
}

/** Return types for an account holder application document */
export type ApplicationDocument = AccountHolderApplicationDocument;

/** "Possible reasons for an `AccountHolderApplicationDocument`'s `ApplicationDocumentUploadStatus`" */
export enum ApplicationDocumentReviewReason {
  /** The document uploaded is a blank document. */
  BLANK_DOCUMENT = "BLANK_DOCUMENT",
  /** The document uploaded is a duplicate of a previously uploaded document. */
  DUPLICATE_DOCUMENT = "DUPLICATE_DOCUMENT",
  /** The document uploaded is outdated or expired. */
  EXPIRED_DOCUMENT = "EXPIRED_DOCUMENT",
  /** The document uploaded is blurry or uneasy to read. */
  ILLEGIBLE_DOCUMENT = "ILLEGIBLE_DOCUMENT",
  /** The document uploaded does not meet the necessary business or person verification requirements */
  INCORRECT_DOCUMENT = "INCORRECT_DOCUMENT",
  /** The document uploaded is not a full or complete document - there may be missing information. */
  PARTIAL_DOCUMENT = "PARTIAL_DOCUMENT",
  /** The document uploaded could not have its authenticity verified. */
  UNACCEPTABLE_DOCUMENT = "UNACCEPTABLE_DOCUMENT",
}

/** A status for an applicant's document upload session */
export enum ApplicationDocumentUploadSessionStatus {
  /** The document upload session is created but has not been initiated. */
  CREATED = "CREATED",
  /**
   * A session has expired due to inactivity. A session can result in an expired state if it is never transitioned to submitted.
   * Files can no longer be attached to the application's document upload session.
   *
   * **Note: ** This is a terminal state.
   */
  EXPIRED = "EXPIRED",
  /**
   * A review has been submitted by a Highnote Agent and the review of the files are complete. A decision has been made for the application's status.
   *
   * **Note: ** This is a terminal state.
   */
  SUBMITTED = "SUBMITTED",
}

/** A status for a document uploaded by the applicant */
export enum ApplicationDocumentUploadStatus {
  /** The document has been approved by a Highnote Agent */
  APPROVED = "APPROVED",
  /** The document has been denied by a Highnote Agent */
  DENIED = "DENIED",
  /** The document is in review by a Highnote Agent */
  IN_REVIEW = "IN_REVIEW",
  /** The document has been uploaded by the applicant and is awaiting verification processing */
  UPLOADED = "UPLOADED",
}

/** Used to resolve the Product for an `ProductApplication`. */
export type ApplicationProduct = CardProduct;

/** The input type for approving a credit limit decrease for a `CreditLimitChangeRequest`. */
export type ApproveCreditLimitDecreaseInput = {
  /** If needed, please provide any adverse action reasons for the deny. */
  adverseActionReasons: Array<AdverseActionCodeInput>;
  /** The identifier for the `CreditLimitChangeRequest` to approve. */
  creditLimitChangeRequestId: Scalars["ID"];
  /** Details collected about the customer, such as their current debt obligations and annual income. */
  customerDetails?: InputMaybe<CreditLimitChangeRequestCustomerDetailsInput>;
  /** The credit limit after the review. */
  updatedCreditLimit?: InputMaybe<AmountInput>;
};

/** The input type for approving a credit limit increase for a `CreditLimitChangeRequest`. */
export type ApproveCreditLimitIncreaseInput = {
  /** The identifier for the `CreditLimitChangeRequest` to approve. */
  creditLimitChangeRequestId: Scalars["ID"];
  /** Details collected about the customer, such as their current debt obligations and annual income. */
  customerDetails?: InputMaybe<CreditLimitChangeRequestCustomerDetailsInput>;
  /** The credit limit after the review. */
  updatedCreditLimit: AmountInput;
};

/** The input for approving a credit-based `AccountHolderCardProductApplication`. */
export type ApproveCreditProductApplicationUnderwritingInput = {
  /** Global id of the application */
  applicationId: Scalars["ID"];
  /**
   * The date and time, in ISO 8601 format, marking when the underwriting decision was made.
   * For example, `2023-01-01T22:00:00.000Z`.
   */
  decisionDate: Scalars["String"];
  /** Standard purchase credit limit */
  standardPurchaseCreditLimit: AmountInput;
};

/** The response type for approving a credit-product `AccountHolderCardProductApplication`. */
export type ApproveCreditProductApplicationUnderwritingPayload =
  | AccessDeniedError
  | AccountHolderCardProductApplication
  | UserError;

/** Input values for `assignPaymentCardToFinancialAccount` */
export type AssignPaymentCardToFinancialAccountInput = {
  /** The ID of the `FinancialAccount` to assign the `PaymentCard` to. */
  assignToFinancialAccountId: Scalars["ID"];
  /**
   * A value to distinguish unique assignPaymentCardToFinancialAccount request.
   *
   * This helps prevent duplicate cards from being assigned. If a failure happens and it is unclear
   * if the assignment of a card went through, it is safe to repeat the request with the same idempotency key. If the
   * card gas already been assigned to the `assignToFinancialAccountId`, the request will be deduped and the original
   * response will be returned instead.
   *
   * **Minimum length:** 10 characters
   * **Maximum length:** 255 characters
   */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /** Options for the newly assigned Payment Card. */
  options: AssignPaymentCardToFinancialAccountOptionsInput;
  /** The ID of the `PaymentCard` to assign to a `FinancialAccount`. */
  paymentCardId: Scalars["ID"];
};

/** Options for assigning a `PaymentCard` to a `FinancialAccount`. */
export type AssignPaymentCardToFinancialAccountOptionsInput = {
  /**
   * Whether or not to activate the card when assigned to a `FinancialAccount`.
   * If **not** activated on assignment, the card must be activated separately before use.
   */
  activateOnAssignment: Scalars["Boolean"];
};

/** The return types for `assignPaymentCardToFinancialAccount` */
export type AssignPaymentCardToFinancialAccountPayload =
  | AccessDeniedError
  | PaymentCard
  | UserError;

/** The result of the ATM Locations. */
export type AtmLocationsResult = AtmLocations | AccessDeniedError | UserError;

/** The details of the `VelocityRule` to attach to the `CardProduct` */
export type AttachCardProductVelocityRuleInput = {
  /** The Global ID of the `CardProduct` to attach the `VelocityRule`. */
  cardProductId: Scalars["ID"];
  /** The details of the `VelocityRule` to attach to the `CardProduct`. */
  velocityRule: VelocityRuleInput;
};

/** The return types when attaching a `VelocityRule` to a `CardProduct`. */
export type AttachCardProductVelocityRulePayload =
  | AccessDeniedError
  | UserError
  | VelocityRuleAssociation;

/** Input for attaching a fee to a `CreditPlan`. */
export type AttachFeeToCreditPlanInput = {
  /** The unique identifier for the `CreditPlan` to attach this `FeeSchedule` to. This must be of `CreditBalanceType` `INSTALLMENT`. */
  creditPlanId: Scalars["ID"];
  /** The fee configuration to attach to this `CreditPlan`. */
  fee?: InputMaybe<CreditPlanFeeInput>;
};

/** Types which can be returned when attaching a `FeeSchedule` to a `CreditPlan`. */
export type AttachFeeToCreditPlanPayload =
  | AccessDeniedError
  | CreditPlan
  | UserError;

/** The details of the `VelocityRule` to attach to the `PaymentCard` */
export type AttachPaymentCardVelocityRuleInput = {
  /** The Global ID of the `PaymentCard` to attach the `VelocityRule`. */
  paymentCardId: Scalars["ID"];
  /** The details of the `VelocityRule` to attach to the `PaymentCard`. */
  velocityRule: VelocityRuleInput;
};

/** The return types when attaching a `VelocityRule` to a `PaymentCard`. */
export type AttachPaymentCardVelocityRulePayload =
  | AccessDeniedError
  | UserError
  | VelocityRuleAssociation;

/** The details of the realtime risk rule to attach to the Card Product. */
export type AttachRealtimeRiskRuleToCardProductInput = {
  /** The Global ID of the Card Product to attach the realtime risk rule. */
  cardProductId: Scalars["ID"];
  /** The details of the realtime risk rule to attach to the Card Product. */
  riskRule: AttachRiskRuleInput;
};

/** The return types when attaching a realtime risk rule to a card product. */
export type AttachRealtimeRiskRuleToCardProductPayload =
  | AccessDeniedError
  | CardProduct
  | UserError;

/** The details of the realtime risk rule to attach to the Financial Account. */
export type AttachRealtimeRiskRuleToFinancialAccountInput = {
  /** The Global ID of the Financial Account to attach the realtime risk rule. */
  financialAccountId: Scalars["ID"];
  /** The details of the realtime risk rule to attach to the Financial Account. */
  riskRule: AttachRiskRuleInput;
};

/** The return types when attaching a realtime risk rule to a financial account. */
export type AttachRealtimeRiskRuleToFinancialAccountPayload =
  | AccessDeniedError
  | FinancialAccount
  | UserError;

/** The details of the realtime risk rule to attach to the Payment Card. */
export type AttachRealtimeRiskRuleToPaymentCardInput = {
  /** The Global ID of the Payment Card to attach the realtime risk rule. */
  paymentCardId: Scalars["ID"];
  /** The details of the realtime risk rule to attach to the Payment Card. */
  riskRule: AttachRiskRuleInput;
};

/** The return types when attaching a realtime risk rule to a payment card. */
export type AttachRealtimeRiskRuleToPaymentCardPayload =
  | AccessDeniedError
  | PaymentCard
  | UserError;

/** Input to attach `RewardEarnRule` to `CardProduct`. */
export type AttachRewardEarnRuleToProductInput = {
  /** `CardProduct` id to attach to. */
  cardProductId: Scalars["ID"];
  /** The date and time in ISO 8601 format, representing when the attachment should begin taking effect. This should be a date in the future.  Optional; if left blank this field will default to the timestamp when the mutation was called. */
  effectiveFrom?: InputMaybe<Scalars["String"]>;
  /** The date and time in ISO 8601 format, representing when the attachment should stop taking effect. This should be a date in the future. Leaving this field blank will result in the attachment remaining in effect indefinitely. */
  effectiveThrough?: InputMaybe<Scalars["String"]>;
  /** `RewardEarnRule` to attach. */
  rewardRule: RewardRuleAttachmentInput;
};

/** Types which can be returned for Attach Mcc reward earn rule. */
export type AttachRewardEarnRuleToProductPayload =
  | AccessDeniedError
  | RewardRuleProductAttachment
  | UserError;

/** Attach `RewardRedemptionConfiguration` to `CardProduct`. */
export type AttachRewardRedemptionConfigurationToProductInput = {
  /** `CardProduct` id to attach to. */
  cardProductId: Scalars["ID"];
  /** The date and time in ISO 8601 format, when the attachment should begin taking effect. This should be a date in the future. Optional; leaving this field blank will default it to the timestamp when the mutation was called. */
  effectiveFrom?: InputMaybe<Scalars["String"]>;
  /** The date and time in ISO 8601 format, when the attachment should stop taking effect. This should be a date in the future. Optional; leaving this field blank will result in the attachment remaining in effect indefinitely. */
  effectiveThrough?: InputMaybe<Scalars["String"]>;
  /** `RewardRedemptionConfiguration` to attach to. */
  redemptionConfiguration: RewardRedemptionConfigurationAttachmentInput;
};

/** Types which can be returned for attaching `RewardRedemptionConfiguration` to `CardProduct`. */
export type AttachRewardRedemptionConfigurationToProductPayload =
  | AccessDeniedError
  | RewardRedemptionConfigurationProductAttachment
  | UserError;

/** The details of the risk rule to attach. */
export type AttachRiskRuleInput = {
  /** The Global ID of the risk rule to attach. */
  id: Scalars["ID"];
  /**
   * The version of the risk rule to attach.
   *
   * To always use the latest version, set `version` to `LATEST`.
   */
  version: Scalars["String"];
};

/** The details of the spend rule to attach. */
export type AttachSpendRuleInput = {
  /** The Global ID of the Spend Rule to attach. */
  id: Scalars["ID"];
  /**
   * The version of the spend rule to attach.
   *
   * To always use the latest version, set `version` to `LATEST`.
   */
  version: Scalars["String"];
};

/** The details of the spend rule to attach to the Card Product */
export type AttachSpendRuleToCardProductInput = {
  /** The Global ID of the Card Product to attach the spend rule. */
  cardProductId: Scalars["ID"];
  /** The details of the spend rule to attach to the Card Product. */
  spendRule: AttachSpendRuleInput;
};

/** The return types when attaching a spend control rule to a card product. */
export type AttachSpendRuleToCardProductPayload =
  | AccessDeniedError
  | CardProduct
  | UserError;

/** The details of the spend rule to attach to the Payment Card */
export type AttachSpendRuleToFinancialAccountInput = {
  /** The Global ID of the Payment Card to attach the spend rule. */
  financialAccountId: Scalars["ID"];
  /** The details of the spend rule to attach to the Payment Card. */
  spendRule: AttachSpendRuleInput;
};

/** The return types when attaching a `SpendRule` to a `FinancialAccount`. */
export type AttachSpendRuleToFinancialAccountPayload =
  | AccessDeniedError
  | FinancialAccount
  | UserError;

/** The details of the spend rule to attach to the Payment Card */
export type AttachSpendRuleToPaymentCardInput = {
  /** The Global ID of the Payment Card to attach the spend rule. */
  paymentCardId: Scalars["ID"];
  /** The details of the spend rule to attach to the Payment Card. */
  spendRule: AttachSpendRuleInput;
};

/** The return types when attaching a spend control rule to a payment card. */
export type AttachSpendRuleToPaymentCardPayload =
  | AccessDeniedError
  | PaymentCard
  | UserError;

/** The details of the `VelocityRule` to attach to the `FinancialAccount` */
export type AttachVelocityRuleToFinancialAccountInput = {
  /** The Global ID of the `FinancialAccount` to attach the `VelocityRule`. */
  financialAccountId: Scalars["ID"];
  /** The details of the `VelocityRule` to attach to the `FinancialAccount`. */
  velocityRule: VelocityRuleInput;
};

/** The return types when attaching a `VelocityRule` to a `FinancialAccount`. */
export type AttachVelocityRuleToFinancialAccountPayload =
  | AccessDeniedError
  | FinancialAccount
  | UserError;

/** The Attached Level. */
export enum AttachedLevel {
  /** ACCOUNT */
  ACCOUNT = "ACCOUNT",
  /** CARD */
  CARD = "CARD",
  /** PLATFORM */
  PLATFORM = "PLATFORM",
  /** PRODUCT */
  PRODUCT = "PRODUCT",
  /** UNSPECIFIED */
  UNSPECIFIED = "UNSPECIFIED",
}

/** A Authorization and Clear Event for a transaction. */
export type AuthorizationAndClearEvent = Node &
  TransactionEvent & {
    __typename?: "AuthorizationAndClearEvent";
    /** ID of the account holder for the card account. */
    accountHolderId?: Maybe<Scalars["ID"]>;
    /**
     * The direction funds are moving in the perspective of the cardholder.
     *
     * * when DEBIT, funds are moving out of the cardholder's account
     * * when CREDIT, funds are moving into the cardholder's account
     */
    accountingDirection?: Maybe<AccountingDirection>;
    /** Network specific transaction data. */
    additionalNetworkData?: Maybe<AdditionalNetworkData>;
    /** Determines whether this event is an advice. */
    advice?: Maybe<Scalars["Boolean"]>;
    /** Details if event is an advice. */
    adviceDetail?: Maybe<AdviceDetail>;
    /** The `Amount` approved for this `AuthorizationAndClearEvent` and posted in the settlement currency. Does not include fees. */
    approvedAmount?: Maybe<Amount>;
    /** Code representing the result of AVS address verification. */
    avsResponseCode?: Maybe<AvsResponseCode>;
    /** The details of the `CardDigitalWalletToken` at the time of this `AuthorizationAndClearEvent` event. */
    cardDigitalWalletTokenDetails?: Maybe<CardDigitalWalletTokenDetails>;
    /** The `CardProduct` associated to this `AuthorizationAndClearEvent`. */
    cardProduct?: Maybe<CardProduct>;
    /** The `Amount` of cashback requested. */
    cashbackAmount?: Maybe<Amount>;
    /** Details if transaction supported collaborative auth. */
    collaborativeAuthorizationDetails?: Maybe<CollaborativeAuthorizationDetails>;
    /** The date and time, in ISO 8601 format, this `AuthorizationAndClearEvent` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /**
     * Conversion rate applied to the requestedAmount to get the requestedAmountInSettlementCurrency for this `AuthorizationAndClearEvent`.
     *
     * Can be up to 7 decimal places, e.g. 1.2345678.
     */
    currencyConversionRate?: Maybe<Scalars["Float"]>;
    /** `Amount` available to spend after this transaction event. */
    currentFinancialAccountAvailableToSpendAmount?: Maybe<Amount>;
    /** Maximum balance allowed for the card account at the time of this transaction event. */
    currentFinancialAccountMaximumBalanceAmount?: Maybe<Amount>;
    /** Code representing the result of CVV (security code) verification. */
    cvvResponseCode?: Maybe<CvvResponseCode>;
    /** Disputes on this `AuthorizationAndClearEvent`. */
    disputes?: Maybe<Array<PaymentCardTransactionDispute>>;
    /** Fees applied to the transaction, if any. */
    fees?: Maybe<Array<TransactionFee>>;
    /** The ID of the transaction event. */
    id: Scalars["ID"];
    /** The details about the merchant who requested the authorization and clear. */
    merchantDetails?: Maybe<MerchantDetails>;
    /**
     * The response code from the card network (e.g. Mastercard).
     * @deprecated Use responseCode instead
     */
    networkResponseCode?: Maybe<Scalars["String"]>;
    /**
     * The transaction ID from the card network (e.g. Mastercard).
     * @deprecated No longer supported
     */
    networkTransactionId?: Maybe<Scalars["ID"]>;
    /** The original `Amount` of the `AuthorizationAndClearEvent`. */
    originalAmount?: Maybe<Amount>;
    /** Determines whether this authorization and clear was approved for partial or full amount. */
    partial?: Maybe<Scalars["Boolean"]>;
    /** The `PaymentCard` associated to this `AuthorizationAndClearEvent`. */
    paymentCard?: Maybe<PaymentCard>;
    /** A snapshot of the `PaymentCard` at the time of the `AuthorizationAndClearEvent`. */
    paymentCardSnapshot?: Maybe<PaymentCardSnapshot>;
    /** Code representing the result of PIN verification. */
    pinResponseCode?: Maybe<PinResponseCode>;
    /** The Point Of Service Details. */
    pointOfServiceDetails?: Maybe<PointOfServiceDetails>;
    /** Code representing the result of AVS postal code verification. */
    postalCodeResponseCode?: Maybe<PostalCodeResponseCode>;
    /** The `Amount` requested to be approved for this `AuthorizationAndClearEvent`. */
    requestedAmount?: Maybe<Amount>;
    /** The `Amount` requested to be approved for this `AuthorizationAndClearEvent` converted to the settlement currency. */
    requestedAmountInSettlementCurrency?: Maybe<Amount>;
    /** The Highnote response code. */
    responseCode?: Maybe<TransactionEventResponseCode>;
    /** The triggered spend rules and the results for the authorization and clear. */
    spendRuleResults?: Maybe<SpendRuleResultConnection>;
    /** The `Transaction` for this event. */
    transaction?: Maybe<Transaction>;
    /** Represents the customer transaction type being processed. */
    transactionProcessingType?: Maybe<CardTransactionProcessingType>;
  };

/** A Authorization and Clear Event for a transaction. */
export type AuthorizationAndClearEventSpendRuleResultsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** An AuthorizationEvent for a transaction. */
export type AuthorizationEvent = Node &
  TransactionEvent & {
    __typename?: "AuthorizationEvent";
    /**
     * The direction funds are moving in the perspective of the cardholder.
     *
     * * when DEBIT, funds are moving out of the cardholder's account
     * * when CREDIT, funds are moving into the cardholder's account
     */
    accountingDirection?: Maybe<AccountingDirection>;
    /** Network specific transaction data. */
    additionalNetworkData?: Maybe<AdditionalNetworkData>;
    /** Additional transaction data for this transaction */
    additionalTransactionData?: Maybe<Array<AdditionalTransactionData>>;
    /** Determines whether this event is an advice. */
    advice?: Maybe<Scalars["Boolean"]>;
    /** Details if event is an advice. */
    adviceDetail?: Maybe<AdviceDetail>;
    /** The `Amount` approved for this `AuthorizationEvent` and posted in the settlement currency. Does not include fees. */
    approvedAmount?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, the authorization will expire. */
    authorizationExpiration?: Maybe<Scalars["String"]>;
    /** Code representing the result of AVS address verification. */
    avsResponseCode?: Maybe<AvsResponseCode>;
    /** The details of the `CardDigitalWalletToken` at the time of this `AuthorizationEvent` event. */
    cardDigitalWalletTokenDetails?: Maybe<CardDigitalWalletTokenDetails>;
    /** The `CardProduct` associated to this `AuthorizationEvent`. */
    cardProduct?: Maybe<CardProduct>;
    /** The `Amount` of cashback requested. */
    cashbackAmount?: Maybe<Amount>;
    /** Details if transaction supported collaborative auth */
    collaborativeAuthorizationDetails?: Maybe<CollaborativeAuthorizationDetails>;
    /** The date and time, in ISO 8601 format, this `AuthorizationEvent` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /**
     * Conversion rate applied to the requestedAmount to get the requestedAmountConvertedToSettlementCurrency for this `AuthorizationEvent`.
     *
     * Can be up to 7 decimal places, e.g. 1.2345678.
     */
    currencyConversionRate?: Maybe<Scalars["Float"]>;
    /** The `Amount` available to spend after this transaction event. */
    currentFinancialAccountAvailableToSpendAmount?: Maybe<Amount>;
    /** Maximum balance allowed for the card account at the time of this transaction event */
    currentFinancialAccountMaximumBalanceAmount?: Maybe<Amount>;
    /** Code representing the result of CVV (security code) verification. */
    cvvResponseCode?: Maybe<CvvResponseCode>;
    /** Fees applied to the transaction, if any. */
    fees?: Maybe<Array<TransactionFee>>;
    /** The ID of the transaction event. This `id` can be used to later retrieve details of this `AuthorizationEvent` or correlate it with other events on this `Transaction`. */
    id: Scalars["ID"];
    /** The details about the merchant who requested the authorization. */
    merchantDetails?: Maybe<MerchantDetails>;
    /**
     * The response code from the card network (e.g. Mastercard).
     * @deprecated Use responseCode instead
     */
    networkResponseCode?: Maybe<Scalars["String"]>;
    /**
     * The transaction ID from the card network (e.g. Mastercard).
     * @deprecated No longer supported
     */
    networkTransactionId?: Maybe<Scalars["ID"]>;
    /** The original `Amount` of this `AuthorizationEvent`. */
    originalAmount?: Maybe<Amount>;
    /** Determines whether this authorization was approved for partial or full amount. */
    partial?: Maybe<Scalars["Boolean"]>;
    /** The `PaymentCard` associated to this `AuthorizationEvent`. */
    paymentCard?: Maybe<PaymentCard>;
    /** A snapshot of the `PaymentCard` at the time of the `AuthorizationEvent`. */
    paymentCardSnapshot?: Maybe<PaymentCardSnapshot>;
    /** Code representing the result of PIN verification. */
    pinResponseCode?: Maybe<PinResponseCode>;
    /** The Point Of Service Details. */
    pointOfServiceDetails?: Maybe<PointOfServiceDetails>;
    /** Code representing the result of AVS postal code verification. */
    postalCodeResponseCode?: Maybe<PostalCodeResponseCode>;
    /** The `Amount` requested to be approved for this `AuthorizationEvent` and displayed in the transaction's (local) currency. Does not include fees. */
    requestedAmount?: Maybe<Amount>;
    /** The `Amount` requested to be approved for this `AuthorizationEvent` converted to the settlement currency. */
    requestedAmountInSettlementCurrency?: Maybe<Amount>;
    /** The Highnote response code. */
    responseCode?: Maybe<TransactionEventResponseCode>;
    /** The triggered spend rules and the results for the authorization. */
    spendRuleResults?: Maybe<SpendRuleResultConnection>;
    /** The `Transaction` for this event. */
    transaction?: Maybe<Transaction>;
    /**
     * ID of the transaction
     * @deprecated Use transaction instead
     */
    transactionId?: Maybe<Scalars["ID"]>;
    /** Represents the customer transaction type being processed. */
    transactionProcessingType?: Maybe<CardTransactionProcessingType>;
  };

/** An AuthorizationEvent for a transaction. */
export type AuthorizationEventSpendRuleResultsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Input for authorizing a `NetworkToken`. */
export type AuthorizeNetworkTokenInput = {
  /** The amount to authorize. */
  amount: AmountInput;
  /** The cardHolder to associate the `NetworkToken` with. */
  cardHolder?: InputMaybe<CardHolderInput>;
  /**
   * Optional contract ID to use for this transaction.
   *
   * If not provided, the default contract ID will be used.
   *
   * DEPRECATED: This field is no longer needed. If you currently are using `contractId` contact Highnote for details on switching to `merchantAcceptorId`.
   */
  contractId?: InputMaybe<Scalars["ID"]>;
  /** Indicates that the `PaymentCardInput` is stored externally. */
  externalCredentialOnFile?: InputMaybe<AcquiringExternalCredentialOnFileInput>;
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /** Installment payment information for merchant-managed installment payments. */
  installmentPayment?: InputMaybe<MerchantManagedInstallmentPaymentInput>;
  /**
   * Optional merchant acceptor ID for this transaction.
   *
   * This is used to identify the specific merchant location or terminal accepting the payment.
   */
  merchantAcceptorId?: InputMaybe<Scalars["ID"]>;
  /** Optional Merchant descriptor information for this transaction. */
  merchantDescriptor?: InputMaybe<MerchantDescriptorInput>;
  /** The `NetworkToken` to authorize. */
  networkToken: NetworkTokenInput;
  /**
   * How the payment was initiated.
   * If the payment was initiated by the customer, include the way in which payment details were given (i.e. via the web, over the phone, by mail, etc).
   * If the payment was merchant initiated, define the reason for the payment (i.e. recurring, installment, etc).
   */
  paymentInitiator?: InputMaybe<AcquiringPaymentInitiator>;
};

/** Result of authorizing a `NetworkToken`. */
export type AuthorizeNetworkTokenPayload =
  | AccessDeniedError
  | CardAuthorizationStepSummary
  | UserError;

/** Input for authorizing a `PaymentCard`. */
export type AuthorizePaymentCardInput = {
  /** The amount to authorize. */
  amount: AmountInput;
  /** The cardHolder to associate the `PaymentCard` with. */
  cardHolder?: InputMaybe<CardHolderInput>;
  /**
   * Optional contract ID to use for this transaction.
   *
   * If not provided, the default contract ID will be used.
   *
   * DEPRECATED: This field is no longer needed. If you currently are using `contractId` contact Highnote for details on switching to `merchantAcceptorId`.
   */
  contractId?: InputMaybe<Scalars["ID"]>;
  /** Indicates that the `PaymentCardInput` is stored externally. */
  externalCredentialOnFile?: InputMaybe<AcquiringExternalCredentialOnFileInput>;
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /** Installment payment information for merchant-managed installment payments. */
  installmentPayment?: InputMaybe<MerchantManagedInstallmentPaymentInput>;
  /**
   * Optional merchant acceptor ID for this transaction.
   *
   * This is used to identify the specific merchant location or terminal accepting the payment.
   */
  merchantAcceptorId?: InputMaybe<Scalars["ID"]>;
  /** Optional Merchant descriptor information for this transaction. */
  merchantDescriptor?: InputMaybe<MerchantDescriptorInput>;
  /** The `PaymentCard` to authorize. */
  paymentCard: PaymentCardInput;
  /**
   * How the payment was initiated.
   * If the payment was initiated by the customer, include the way in which payment details were given (i.e. via the web, over the phone, by mail, etc).
   * If the payment was merchant initiated, define the reason for the payment (i.e. recurring, installment, etc).
   */
  paymentInitiator?: InputMaybe<AcquiringPaymentInitiator>;
};

/** Result of authorizing a `PaymentCard`. */
export type AuthorizePaymentCardPayload =
  | AccessDeniedError
  | CardAuthorizationStepSummary
  | UserError;

/** Input for authorizing a `PaymentMethodToken`. */
export type AuthorizePaymentMethodTokenInput = {
  /** The amount to authorize. */
  amount: AmountInput;
  /**
   * Optional contract ID to use for this transaction.
   *
   * If not provided, the default contract ID will be used.
   *
   * DEPRECATED: This field is no longer needed. If you currently are using `contractId` contact Highnote for details on switching to `merchantAcceptorId`.
   */
  contractId?: InputMaybe<Scalars["ID"]>;
  /** Indicates that the `PaymentMethodToken` is stored externally. */
  externalCredentialOnFile?: InputMaybe<AcquiringExternalCredentialOnFileInput>;
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /** Installment payment information for merchant-managed installment payments. */
  installmentPayment?: InputMaybe<MerchantManagedInstallmentPaymentInput>;
  /**
   * Optional merchant acceptor ID for this transaction.
   *
   * This is used to identify the specific merchant location or terminal accepting the payment.
   */
  merchantAcceptorId?: InputMaybe<Scalars["ID"]>;
  /** Optional Merchant descriptor information for this transaction. */
  merchantDescriptor?: InputMaybe<MerchantDescriptorInput>;
  /**
   * How the payment was initiated.
   * If the payment was initiated by the customer, include the way in which payment details were given (i.e. via the web, over the phone, by mail, etc).
   * If the payment was merchant initiated, define the reason for the payment (i.e. recurring, installment, etc).
   */
  paymentInitiator?: InputMaybe<AcquiringPaymentInitiator>;
  /** The `PaymentMethodToken` to authorize. */
  paymentMethodTokenId: Scalars["ID"];
};

/** Result of authorizing a payment method token. */
export type AuthorizePaymentMethodTokenPayload =
  | AccessDeniedError
  | CardAuthorizationStepSummary
  | UserError;

/** Represents an authorized relationship where the account holder is a person. */
export type AuthorizedAccountHolderPersonRelationship = {
  __typename?: "AuthorizedAccountHolderPersonRelationship";
  /** The individual granted authorization. */
  authorizedPerson?: Maybe<AuthorizedPersonRelationship>;
};

/** Represents all possible types of authorized account holder relationships, whether a person or business. */
export type AuthorizedAccountHolderRelationship =
  AuthorizedAccountHolderPersonRelationship;

/** A paginated list of authorized account holder relationships. */
export type AuthorizedAccountHolderRelationshipConnection = {
  __typename?: "AuthorizedAccountHolderRelationshipConnection";
  /** A list of edges representing authorized account holder relationships. */
  edges?: Maybe<Array<AuthorizedAccountHolderRelationshipEdge>>;
  /** Pagination metadata for navigating through results. */
  pageInfo: PageInfo;
};

/** An edge in the authorized account holder relationship connection. */
export type AuthorizedAccountHolderRelationshipEdge = {
  __typename?: "AuthorizedAccountHolderRelationshipEdge";
  /** A pagination cursor for this edge. */
  cursor: Scalars["String"];
  /** The authorized account holder relationship represented by this edge. */
  node?: Maybe<AuthorizedAccountHolderRelationship>;
};

/** The status of an authorized account holder relationship. */
export enum AuthorizedAccountHolderRelationshipStatus {
  /** The relationship is currently active and valid. */
  ACTIVE = "ACTIVE",
  /** The relationship is inactive or has been revoked. */
  INACTIVE = "INACTIVE",
}

/** Person authorized to act on behalf of the business. */
export type AuthorizedPerson = {
  /** The default physical address of the authorized person. */
  homeAddress?: Maybe<Address>;
  /** The authorized person's name. */
  name?: Maybe<Name>;
};

/** Represents an individual account holder who has been granted authorization. */
export type AuthorizedPersonAccountHolder = {
  __typename?: "AuthorizedPersonAccountHolder";
  /** The individual account holder who is authorized. */
  accountHolder?: Maybe<PersonAccountHolder>;
  /**
   * The status of the authorized account holder relationship.
   * This indicates whether the relationship is currently active or inactive.
   */
  status?: Maybe<AuthorizedAccountHolderRelationshipStatus>;
};

/** Represents the types of individuals that can be an authorized party. */
export type AuthorizedPersonRelationship =
  | AuthorizedPersonAccountHolder
  | AuthorizedPersonUser;

/** Represents a user who has been granted authorization. */
export type AuthorizedPersonUser = {
  __typename?: "AuthorizedPersonUser";
  /** The user designated as an authorized individual. */
  authorizedUser?: Maybe<PersonAuthorizedUser>;
  /**
   * The status of the authorized account holder relationship.
   * This indicates whether the relationship is currently active or inactive.
   */
  status?: Maybe<AuthorizedAccountHolderRelationshipStatus>;
};

/** Whether or not the `FinancialAccount` is for an authorized user. */
export type AuthorizedUserAccountFeature = FinancialAccountFeature & {
  __typename?: "AuthorizedUserAccountFeature";
  /** The date and time, in ISO 8601 format, the feature was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective from. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective through. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Whether or not the feature is enabled for the `FinancialAccount`. */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** A reference to the primary account holder. */
  primaryAccountAccountHolderParty?: Maybe<AccountHolder>;
  /** The `FinancialAccount` of primary account holder. */
  primaryAccountHolderAccount?: Maybe<FinancialAccount>;
  /** The date and time, in ISO 8601 format, the feature was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** A type representing a state of the authorized user application. */
export type AuthorizedUserApplicationState = {
  __typename?: "AuthorizedUserApplicationState";
  /** Status of application. */
  status: AuthorizedUserApplicationStatusCode;
};

/** High-level authorized user application states. */
export enum AuthorizedUserApplicationStatusCode {
  /** The application was approved. */
  APPROVED = "APPROVED",
  /** The application was closed. */
  CLOSED = "CLOSED",
  /** The application was denied. */
  DENIED = "DENIED",
  /** The application requires further review. */
  IN_REVIEW = "IN_REVIEW",
  /** The application is currently being processed. */
  PENDING = "PENDING",
}

/** An AuthorizedUserCardProductApplication. */
export type AuthorizedUserCardProductApplication = Node & {
  __typename?: "AuthorizedUserCardProductApplication";
  /** The linked Account Holder Application to which authorized user is applying. */
  accountHolderCardProductApplication?: Maybe<AccountHolderCardProductApplication>;
  /** A prioritized list of Adverse Action Reasons explaining the Application Deal. */
  adverseActionReasons?: Maybe<Array<AdverseActionReason>>;
  /** The Denial Reason for an Application */
  applicationDenialReason?: Maybe<ApplicationDenialReason>;
  /** Past states of the application */
  applicationHistory?: Maybe<AuthorizedUserCardProductApplicationSnapshotConnection>;
  /** The current state of the application. */
  applicationState?: Maybe<AuthorizedUserApplicationState>;
  /** The workflows this application must go through before reaching the APPROVED state */
  applicationWorkflows?: Maybe<Array<ProductApplicationWorkflow>>;
  /** The authorized user's data at the time of application. */
  authorizedUserSnapshot?: Maybe<AuthorizedUserSnapshot>;
  /** The date and time, in ISO 8601 format, the application was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The Financial Account to which the account holder is applying. */
  financialAccount?: Maybe<FinancialAccount>;
  /** Global ID used to reference the application in operations. */
  id: Scalars["ID"];
  /** The date and time, in ISO 8601 format, the application was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** An AuthorizedUserCardProductApplication. */
export type AuthorizedUserCardProductApplicationApplicationHistoryArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The connection type for AuthorizedUserCardProductApplication. */
export type AuthorizedUserCardProductApplicationConnection = {
  __typename?: "AuthorizedUserCardProductApplicationConnection";
  /** A list of edges. */
  edges?: Maybe<Array<AuthorizedUserCardProductApplicationEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for AuthorizedUserCardProductApplication. */
export type AuthorizedUserCardProductApplicationEdge = {
  __typename?: "AuthorizedUserCardProductApplicationEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The account holder card product application. */
  node?: Maybe<AuthorizedUserCardProductApplication>;
};

/** An AuthorizedUserCardProductApplicationSnapshot. */
export type AuthorizedUserCardProductApplicationSnapshot = {
  __typename?: "AuthorizedUserCardProductApplicationSnapshot";
  /** The linked Account Holder Application to which authorized user is applying. */
  accountHolderCardProductApplication?: Maybe<AccountHolderCardProductApplication>;
  /** A list of Adverse Action Reasons explaining the Application Denial. */
  adverseActionReasons?: Maybe<Array<AdverseActionReason>>;
  /** The current state of the application. */
  applicationState: AuthorizedUserApplicationState;
  /** The authorized user's data at the time of application. */
  authorizedUserSnapshot?: Maybe<AuthorizedUserSnapshot>;
  /** The date and time, in ISO 8601 format, the application was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The Financial Account to which the account holder is applying. */
  financialAccount?: Maybe<FinancialAccount>;
  /** The date and time, in ISO 8601 format, the application was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The connection type for AuthorizedUserCardProductApplicationSnapshot. */
export type AuthorizedUserCardProductApplicationSnapshotConnection = {
  __typename?: "AuthorizedUserCardProductApplicationSnapshotConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AuthorizedUserCardProductApplicationSnapshotEdge>>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for an AuthorizedUserCardProductApplicationSnapshot. */
export type AuthorizedUserCardProductApplicationSnapshotEdge = {
  __typename?: "AuthorizedUserCardProductApplicationSnapshotEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The Authorized User Card Product Application Snapshot. */
  node?: Maybe<AuthorizedUserCardProductApplicationSnapshot>;
};

/** Whether or not the `CardProduct` supports Authorized Users. */
export type AuthorizedUserCardProductFeature = CardProductFeature &
  ProductFeature & {
    __typename?: "AuthorizedUserCardProductFeature";
    /** The date and time, in ISO 8601 format, the feature was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective from. */
    effectiveFrom?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective through. */
    effectiveThrough?: Maybe<Scalars["String"]>;
    /** Whether or not the feature is enabled for the `CardProduct`. */
    enabled?: Maybe<Scalars["Boolean"]>;
    /** The date and time, in ISO 8601 format, the feature was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** The connection type for AuthorizedUser. */
export type AuthorizedUserConnection = {
  __typename?: "AuthorizedUserConnection";
  /** A list of edges. */
  edges?: Maybe<Array<AuthorizedUserEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for AuthorizedUser. */
export type AuthorizedUserEdge = {
  __typename?: "AuthorizedUserEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The Authorized User. */
  node?: Maybe<UsPersonAuthorizedUser>;
};

/** Inputs for filtering Payment Card data for Authorized User. */
export type AuthorizedUserPaymentCardsFilterInput = {
  bin?: InputMaybe<StringFilterInput>;
  cardNetwork?: InputMaybe<PaymentCardNetworkFilterInput>;
  cardProductId?: InputMaybe<IdFilterInput>;
  createDate?: InputMaybe<TimestampFilterInput>;
  expirationDate?: InputMaybe<TimestampFilterInput>;
  formFactor?: InputMaybe<CardFormFactorFilterInput>;
  last4?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<PaymentCardStatusFilterInput>;
  updateDate?: InputMaybe<TimestampFilterInput>;
};

/** A snapshot of an authorized user's data at time of application. */
export type AuthorizedUserSnapshot =
  | UsPersonAccountHolderSnapshot
  | UsPersonAuthorizedUserSnapshot;

/** A Balance Inquiry Event for a transaction. */
export type BalanceInquiryEvent = Node &
  TransactionEvent & {
    __typename?: "BalanceInquiryEvent";
    /**
     * The direction funds are moving in the perspective of the cardholder.
     *
     * * when DEBIT, funds are moving out of the cardholder's account
     * * when CREDIT, funds are moving into the cardholder's account
     */
    accountingDirection?: Maybe<AccountingDirection>;
    /** Network specific transaction data. */
    additionalNetworkData?: Maybe<AdditionalNetworkData>;
    /** The `Amount` approved for this `BalanceInquiryEvent` and posted in the settlement currency. Does not include fees. */
    approvedAmount?: Maybe<Amount>;
    /** Code representing the result of AVS address verification. */
    avsResponseCode?: Maybe<AvsResponseCode>;
    /** The details of the `CardDigitalWalletToken` at the time of the `BalanceInquiryEvent` event. */
    cardDigitalWalletTokenDetails?: Maybe<CardDigitalWalletTokenDetails>;
    /** The `CardProduct` associated to this `BalanceInquiryEvent`. */
    cardProduct?: Maybe<CardProduct>;
    /** The date and time, in ISO 8601 format, this `BalanceInquiryEvent` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** `Amount` available to spend after this transaction event. */
    currentFinancialAccountAvailableToSpendAmount?: Maybe<Amount>;
    /** Maximum balance allowed for the card account at the time of this transaction event. */
    currentFinancialAccountMaximumBalanceAmount?: Maybe<Amount>;
    /** Code representing the result of CVV (security code) verification */
    cvvResponseCode?: Maybe<CvvResponseCode>;
    /** The ID of the transaction event. */
    id: Scalars["ID"];
    /** The details about the merchant who requested the balance inquiry. */
    merchantDetails?: Maybe<MerchantDetails>;
    /**
     * The response code from the card network (e.g. Mastercard).
     * @deprecated Use responseCode instead
     */
    networkResponseCode?: Maybe<Scalars["String"]>;
    /**
     * The transaction ID from the card network (e.g. Mastercard).
     * @deprecated No longer supported
     */
    networkTransactionId?: Maybe<Scalars["ID"]>;
    /** The original `Amount` of the `BalanceInquiryEvent`. */
    originalAmount?: Maybe<Amount>;
    /** The `PaymentCard` associated to this `BalanceInquiryEvent`. */
    paymentCard?: Maybe<PaymentCard>;
    /** A snapshot of the `PaymentCard` at the time of the `BalanceInquiryEvent`. */
    paymentCardSnapshot?: Maybe<PaymentCardSnapshot>;
    /** Code representing the result of PIN verification. */
    pinResponseCode?: Maybe<PinResponseCode>;
    /** The Point Of Service Details. */
    pointOfServiceDetails?: Maybe<PointOfServiceDetails>;
    /** Code representing the result of AVS postal code verification. */
    postalCodeResponseCode?: Maybe<PostalCodeResponseCode>;
    /** The `Amount` requested to be approved for this `BalanceInquiryEvent`. */
    requestedAmount?: Maybe<Amount>;
    /** The Highnote response code. */
    responseCode?: Maybe<TransactionEventResponseCode>;
    /** The triggered spend rules and the results for the balance inquiry. */
    spendRuleResults?: Maybe<SpendRuleResultConnection>;
    /** The `Transaction` for this event. */
    transaction?: Maybe<Transaction>;
    /** Represents the customer transaction type being processed. */
    transactionProcessingType?: Maybe<CardTransactionProcessingType>;
  };

/** A Balance Inquiry Event for a transaction. */
export type BalanceInquiryEventSpendRuleResultsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Plan and statement entries are based on specific balance type. */
export enum BalanceType {
  /** Plan and statement entries are based on the PURCHASE balance Type. */
  PURCHASE = "PURCHASE",
}

/** Type of bank accounts. */
export enum BankAccountType {
  /** Checking bank account. */
  CHECKING = "CHECKING",
  /** Saving bank account. */
  SAVINGS = "SAVINGS",
}

/** The details about the backing bank. */
export type BankDetails = {
  __typename?: "BankDetails";
  /** The address of the financial institution. */
  address?: Maybe<Address>;
  /** The name of the financial institution. */
  name?: Maybe<BankName>;
};

/** The possible bank names. */
export enum BankName {
  /** The value representing CFSB. */
  CFSB_BANK = "CFSB_BANK",
  /** The value representing Cross River Bank. */
  CROSS_RIVER_BANK = "CROSS_RIVER_BANK",
  /** The value representing Sutton Bank. */
  SUTTON_BANK = "SUTTON_BANK",
}

/** The provider that Highnote uses to verify bank accounts. */
export enum BankVerificationProvider {
  /** FINICITY */
  FINICITY = "FINICITY",
  /** PLAID */
  PLAID = "PLAID",
  /** PLAID_RESELLER */
  PLAID_RESELLER = "PLAID_RESELLER",
  /** SIMULATED */
  SIMULATED = "SIMULATED",
  /** UNSPECIFIED */
  UNSPECIFIED = "UNSPECIFIED",
}

/** A billing cycle for a credit product. */
export type BillingCycle = {
  __typename?: "BillingCycle";
  /** The amount delinquent, including any interest or fees, at the close of this cycle. */
  amountDelinquent?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The delinquency state of this `FinancialAccount` for this cycle, as of now. Can be CURRENT, DELINQUENT, or CLOSING. */
  currentCycleState?: Maybe<CurrentFinancialAccountDelinquencyState>;
  /** A list of repayments applied to this billing cycle. Please note that only the first 20 repayments for a cycle will be returned. */
  repayments?: Maybe<Array<CreditRepaymentStatementApplication>>;
  /** A list of `DelinquencyStateTransition`s that overlap with this `BillingCycle`. */
  stateTransitionHistory?: Maybe<Array<Maybe<DelinquencyStateTransition>>>;
  /** The statement for this `BillingCycle`. */
  statement?: Maybe<FinancialAccountStatement>;
  /** If the `BillingCycle` has a terminal state of DELINQUENT or CLOSING, the number of days since the delinquency started. If the `BillingCycle` has a terminal state of CURRENT, this value is 0. */
  totalDaysDelinquent?: Maybe<Scalars["UnsignedInt"]>;
  /** The date and time, in ISO 8601 format, this was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Billing cycle configuration for account */
export type BillingCycleConfiguration = {
  __typename?: "BillingCycleConfiguration";
  /**
   * Billing cycle end day of the month.
   *
   * Min: 4
   * Max: 24
   */
  billingCycleEndDayOfMonth?: Maybe<Scalars["Int"]>;
  /**
   * Billing cycle start day of the month. The billing cycle starts the day the Financial Account is created.
   *
   * The `billingCycleStartDayOfMonth` range is between 1 and 31.
   */
  billingCycleStartDayOfMonth?: Maybe<Scalars["Int"]>;
  /** The date and time, in ISO 8601 format, from which the billing cycle configuration is valid. */
  from?: Maybe<Scalars["String"]>;
  /** Global Id used to reference this billing configuration. */
  id: Scalars["ID"];
  /**
   * Payment due day of the month.
   *
   * Min: 1
   * Max: 21
   */
  paymentDueDayOfMonth?: Maybe<Scalars["Int"]>;
  /** The date and time, in ISO 8601 format, through which the billing cycle configuration is valid. */
  through?: Maybe<Scalars["String"]>;
  /** The anticipated configuration values for the next upcoming billing cycle. */
  upcomingBillingCycleConfiguration?: Maybe<UpcomingBillingCycleConfiguration>;
};

/** The connection type for a `BillingCycle`. */
export type BillingCycleConnection = {
  __typename?: "BillingCycleConnection";
  /** A list of edges. */
  edges?: Maybe<Array<BillingCycleEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a `BillingCycle`. */
export type BillingCycleEdge = {
  __typename?: "BillingCycleEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The `BillingCycle`. */
  node?: Maybe<BillingCycle>;
};

/** The input type for filtering `BillingCycle`. */
export type BillingCycleFilterInput = {
  /**
   * This filter input accepts a `TimestampFilterInputRange` including a `start` and `end` timestamp in ISO 8601 format.
   * It returns any cycles where the period start or period end is within the provided range (inclusive).
   *
   * For example, if the provided range is `2023-01-15` to `2023-02-01` it would return a cycle with
   * a period start of `2023-01-01` and a period end of `2023-02-01`, in addition to a cycle with period start of `2023-02-01` and a
   * period end of `2023-03-01`.
   */
  statementPeriodStartOrEndBetween?: InputMaybe<TimestampFilterInputRange>;
};

/** An override of the default billing cycle type. */
export type BillingCycleOverride = {
  __typename?: "BillingCycleOverride";
  /**
   * Specifies the billing cycle type to override the default behavior.
   * If not provided, the system will use the default billing cycle associated with the product or account.
   */
  billingCycleType?: Maybe<BillingCycleType>;
  /**
   * Specifies the billing grace period in days to override the default behavior.
   *
   * These are the valid value ranges:
   * `CHARGE` products:
   * 0 to 90 days
   *
   * `REVOLVING` and `PAY_IN_FULL` products:
   * Weekly cycle: 0 to 5 days
   * Biweekly cycle: 0 to 10 days
   * Monthly cycle: 0 to 25 days
   *
   * Note: values are inclusive, and capped at the max. (eg, if 91 days is provided for a `CHARGE` product, it will be set to 90 days).
   * If not provided, the system will use the default billing cycle associated with the product.
   */
  billingGracePeriod?: Maybe<Scalars["UnsignedInt"]>;
};

/** An override of the default billing cycle type. */
export type BillingCycleOverrideInput = {
  /**
   * Specifies the billing cycle type to override the default behavior.
   * If not provided, the system will use the default billing cycle associated with the product or account.
   */
  billingCycleType?: InputMaybe<BillingCycleType>;
  /**
   * Specifies the billing grace period in days to override the default behavior.
   *
   * These are the valid value ranges:
   * `CHARGE` products:
   * 0 to 90 days
   *
   * `REVOLVING` and `PAY_IN_FULL` products:
   * Weekly cycle: 0 to 5 days
   * Biweekly cycle: 0 to 10 days
   * Monthly cycle: 0 to 25 days
   *
   * Note: values are inclusive, and capped at the max. (eg, if 91 days is provided for a `CHARGE` product, it will be set to 90 days).
   *
   * If not provided, the system will use the default billing cycle associated with the product.
   */
  billingGracePeriod?: InputMaybe<Scalars["UnsignedInt"]>;
};

/** Whether statement cycles are `WEEKLY`, `BIWEEKLY`, or `MONTHLY`. */
export enum BillingCycleType {
  BIWEEKLY = "BIWEEKLY",
  MONTHLY = "MONTHLY",
  WEEKLY = "WEEKLY",
}

/** Boolean value type */
export type BooleanFilterInput = {
  equals: Scalars["Boolean"];
};

/** A `Business` including profile details such as name and address, and service details such as account holder and merchant details. */
export type Business = Node & {
  __typename?: "Business";
  /** The profile details for the `Business`. */
  businessProfile?: Maybe<BusinessProfileDetail>;
  /** The date and time, in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) format, the `Business` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the `Business`. */
  id: Scalars["ID"];
  /** The date and time, in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) format, the `Business` was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The base fields for all BusinessAccountHolders (regardless of region or snapshot). */
export type BusinessAccountHolder = {
  /** Information about the business. */
  businessProfile?: Maybe<BusinessProfile>;
  /** The details of the person authorized to act on behalf of business. */
  primaryAuthorizedPerson?: Maybe<AuthorizedPerson>;
};

/** Input for filtering Business Account Holder's business by name. */
export type BusinessAccountHolderBusinessNameFilterInput = {
  doingBusinessAsName?: InputMaybe<StringSearchFilterInput>;
  legalBusinessName?: InputMaybe<StringSearchFilterInput>;
};

/** Inputs for filtering business account holder business profile data. */
export type BusinessAccountHolderBusinessProfileFilterInput = {
  employerIdentificationNumber?: InputMaybe<HashedFilterInput>;
  employerIdentificationNumberLast4?: InputMaybe<HashedFilterInput>;
  name?: InputMaybe<BusinessAccountHolderBusinessNameFilterInput>;
  ultimateBeneficialOwner?: InputMaybe<BusinessAccountHolderUltimateBeneficialOwnerFilterInput>;
  website?: InputMaybe<StringSearchFilterInput>;
};

/** Permissions for a `BusinessAccountHolder` Client Token */
export enum BusinessAccountHolderClientTokenPermission {
  /**
   * Read the business account holder information.
   *
   * Setting this permission will allow visibility to the account holder's information.
   */
  READ_BUSINESS_ACCOUNT_HOLDER_DETAILS = "READ_BUSINESS_ACCOUNT_HOLDER_DETAILS",
}

/** Inputs for filtering business account holder data. */
export type BusinessAccountHolderFilterInput = {
  businessProfile?: InputMaybe<BusinessAccountHolderBusinessProfileFilterInput>;
  externalId?: InputMaybe<IdFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  primaryAuthorizedPerson?: InputMaybe<BusinessAccountHolderPrimaryAuthorizedPersonFilterInput>;
};

/** Indicates that identity verification documents have been requested for a `USBusinessAccountHolder`. */
export type BusinessAccountHolderIdentityDocumentsRequestedEvent = {
  __typename?: "BusinessAccountHolderIdentityDocumentsRequestedEvent";
  /** The `USBusinessAccountHolder` for which documents have been requested. */
  businessAccountHolder?: Maybe<UsBusinessAccountHolder>;
  /** The date and time, in ISO 8601 format, this event was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The `IdentityVerificationDocumentUploadSession` created for the requested documents. */
  documentUploadSession?: Maybe<IdentityVerificationDocumentUploadSession>;
  /** The reason identity verification documents are being requested. */
  reason?: Maybe<IdentityVerificationDocumentRequestReason>;
};

/** The type of identifying information which has been modified in a `BusinessAccountHolderIdentityUpdatedEvent`. */
export enum BusinessAccountHolderIdentityUpdateType {
  /** The annual revenue was modified. */
  ANNUAL_REVENUE = "ANNUAL_REVENUE",
  /** The billing address was modified. */
  BILLING_ADDRESS = "BILLING_ADDRESS",
  /** The employer identification number was modified. */
  EMPLOYER_IDENTIFICATION_NUMBER = "EMPLOYER_IDENTIFICATION_NUMBER",
  /** The legal business name was modified. */
  LEGAL_BUSINESS_NAME = "LEGAL_BUSINESS_NAME",
}

/** Indicates that the identifying information of a `USBusinessAccountHolder` has been updated. */
export type BusinessAccountHolderIdentityUpdatedEvent = {
  __typename?: "BusinessAccountHolderIdentityUpdatedEvent";
  /** The `USBusinessAccountHolder` which was updated. */
  businessAccountHolder?: Maybe<UsBusinessAccountHolder>;
  /** The date and time, in ISO 8601 format, this event was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The type of each update made, indicating which fields were modified on the `USBusinessAccountHolder`. */
  updateTypes?: Maybe<Array<BusinessAccountHolderIdentityUpdateType>>;
};

/** Input representing common fields of a BusinessAccountHolder's name. */
export type BusinessAccountHolderNameInput = {
  /**
   * The business' doing business as name.
   *
   * **Minimum length:** 1 character
   * **Maximum length:** 255 characters
   */
  doingBusinessAsName?: InputMaybe<Scalars["String"]>;
  /**
   * The business' legal name.
   * **Minimum length:** 1 character
   * **Maximum length:** 255 characters
   */
  legalBusinessName: Scalars["String"];
};

/** Input representing updatable fields of a BusinessAccountHolder's name. */
export type BusinessAccountHolderNameUpdateInput = {
  /**
   * The business' doing business as name.
   *
   * **Minimum length:** 1 character
   * **Maximum length:** 255 characters
   */
  doingBusinessAsName?: InputMaybe<Scalars["String"]>;
  /**
   * The business' legal name.
   * **Minimum length:** 1 character
   * **Maximum length:** 255 characters
   */
  legalBusinessName?: InputMaybe<Scalars["String"]>;
};

/** Input for filtering by Business Account Holder's Primary Authorized Person's Address. */
export type BusinessAccountHolderPrimaryAuthorizedAddressFilterInput = {
  postalCode?: InputMaybe<StringFilterInput>;
};

/** Inputs for filtering business account holder's primary authorized person. */
export type BusinessAccountHolderPrimaryAuthorizedPersonFilterInput = {
  dateOfBirth?: InputMaybe<DateFilterInput>;
  homeAddress?: InputMaybe<BusinessAccountHolderPrimaryAuthorizedAddressFilterInput>;
  name?: InputMaybe<BusinessAccountHolderPrimaryAuthorizedPersonNameFilterInput>;
  socialSecurityNumber?: InputMaybe<HashedFilterInput>;
  socialSecurityNumberLast4?: InputMaybe<HashedFilterInput>;
};

/**
 * Input for filtering Business Account Holders by name.
 * The matching for these name fields are performed using similar sounding scores.
 * e.g. keywords like Mayer, mayer, Mire & Mary will lead to the same score.
 */
export type BusinessAccountHolderPrimaryAuthorizedPersonNameFilterInput = {
  familyName?: InputMaybe<SoundsLikeFilterInput>;
  givenName?: InputMaybe<SoundsLikeFilterInput>;
  middleName?: InputMaybe<SoundsLikeFilterInput>;
  suffix?: InputMaybe<SoundsLikeFilterInput>;
  title?: InputMaybe<SoundsLikeFilterInput>;
};

/** Inputs for filtering `USBusinessAccountHolder`s by `USBusinessUltimateBeneficialOwner`. */
export type BusinessAccountHolderUltimateBeneficialOwnerFilterInput = {
  dateOfBirth?: InputMaybe<DateFilterInput>;
  homeAddress?: InputMaybe<UltimateBeneficialOwnerAddressFilterInput>;
  name?: InputMaybe<PersonNameFilterInput>;
  socialSecurityNumber?: InputMaybe<HashedFilterInput>;
  socialSecurityNumberLast4?: InputMaybe<HashedFilterInput>;
};

/** The type of identifying information which has been modified in a `BusinessAuthorizedPersonIdentityUpdatedEvent` or `BusinessUltimateBeneficialOwnerIdentityUpdatedEvent`. */
export enum BusinessAssociatedPersonIdentityUpdateType {
  /** The date of birth was modified. */
  DATE_OF_BIRTH = "DATE_OF_BIRTH",
  /** The full legal name was modified. */
  FULL_LEGAL_NAME = "FULL_LEGAL_NAME",
  /** The home address was modified. */
  HOME_ADDRESS = "HOME_ADDRESS",
  /** The social security number was modified. */
  SOCIAL_SECURITY_NUMBER = "SOCIAL_SECURITY_NUMBER",
}

/** The details of a person authorized to act on behalf of a `Business`. */
export type BusinessAuthorizedPerson = AuthorizedPerson & {
  __typename?: "BusinessAuthorizedPerson";
  /** The person's business title. */
  authorizingPersonTitle?: Maybe<BusinessTitle>;
  /** The date and time, in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) format, the `AuthorizedPerson` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date of birth of the `AuthorizedPerson`. Format: `YYYY-MM-DD`. */
  dateOfBirth?: Maybe<Scalars["String"]>;
  /** The email address of the `AuthorizedPerson`. */
  email?: Maybe<Scalars["String"]>;
  /** The default physical address of the `AuthorizedPerson`. */
  homeAddress?: Maybe<Address>;
  /** Global ID used to reference the authorized person. */
  id: Scalars["ID"];
  /** Identification documents associated with the `AuthorizedPerson`. */
  identificationDocuments?: Maybe<Array<PersonIdentificationDocument>>;
  /** Whether the `AuthorizedPerson` is a guarantor. */
  isGuarantor?: Maybe<Scalars["Boolean"]>;
  /** Whether this is the primary authorized person for the `Business`. */
  isPrimary?: Maybe<Scalars["Boolean"]>;
  /** Whether the `AuthorizedPerson` is an ultimate beneficial owner. */
  isUltimateBeneficialOwner?: Maybe<Scalars["Boolean"]>;
  /** Locality details for the `AuthorizedPerson`. */
  locality?: Maybe<PersonLocality>;
  /** The `AuthorizedPerson`'s name. */
  name?: Maybe<Name>;
  /** The percentage of the `Business` owned by this `AuthorizedPerson`, represented as a whole number from 0 to 100. */
  percentageOwnership?: Maybe<Scalars["UnsignedInt"]>;
  /** List of phone numbers associated with the `AuthorizedPerson`. */
  phoneNumbers?: Maybe<Array<Phone>>;
  /** The date and time, in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) format, the `AuthorizedPerson` was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Indicates that identity verification documents have been requested for a `USBusinessAuthorizedPerson`. */
export type BusinessAuthorizedPersonIdentityDocumentsRequestedEvent = {
  __typename?: "BusinessAuthorizedPersonIdentityDocumentsRequestedEvent";
  /** The `USBusinessAccountHolder` to which the `USBusinessAuthorizedPerson` is associated. */
  businessAccountHolder?: Maybe<UsBusinessAccountHolder>;
  /** The `USBusinessAuthorizedPerson` for which documents have been requested. */
  businessAuthorizedPerson?: Maybe<UsBusinessAuthorizedPerson>;
  /** The date and time, in ISO 8601 format, this event was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The `IdentityVerificationDocumentUploadSession` created for the requested documents. */
  documentUploadSession?: Maybe<IdentityVerificationDocumentUploadSession>;
  /** The reason identity verification documents are being requested. */
  reason?: Maybe<IdentityVerificationDocumentRequestReason>;
};

/** Indicates that the identifying information of a `USBusinessAuthorizedPerson` has been updated. */
export type BusinessAuthorizedPersonIdentityUpdatedEvent = {
  __typename?: "BusinessAuthorizedPersonIdentityUpdatedEvent";
  /** The `USBusinessAccountHolder` for which the `USBusinessAuthorizedPerson` was updated. */
  businessAccountHolder?: Maybe<UsBusinessAccountHolder>;
  /** The `USBusinessAuthorizedPerson` which was updated. */
  businessAuthorizedPerson?: Maybe<UsBusinessAuthorizedPerson>;
  /** The date and time, in ISO 8601 format, this event was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The type of each update made, indicating which fields were modified on the `USBusinessAuthorizedPerson`. */
  updateTypes?: Maybe<Array<BusinessAssociatedPersonIdentityUpdateType>>;
};

/** The snapshot details of the person authorized to act on behalf of business. */
export type BusinessAuthorizedPersonSnapshot =
  UsBusinessAuthorizedPersonSnapshot;

/** A type representing credit risk attributes. */
export type BusinessCreditRiskAttributes = {
  __typename?: "BusinessCreditRiskAttributes";
  /** Annual revenue expressed as an Amount. */
  annualRevenue?: Maybe<Array<Maybe<Amount>>>;
};

/** Input fields for business credit risk attributes. */
export type BusinessCreditRiskAttributesInput = {
  /** Annual revenue expressed as an AmountInput. */
  annualRevenue?: InputMaybe<Array<AmountInput>>;
};

/** A method of customer interaction */
export enum BusinessCustomerInteractionMethod {
  /** A business selling goods/services at a physical location. */
  IN_PERSON = "IN_PERSON",
  /** A business selling goods/services through mail or telephone orders. */
  MAIL_ORDER_TELEPHONE_ORDER = "MAIL_ORDER_TELEPHONE_ORDER",
  /** A business selling goods/services via an Android or iOS app. */
  MOBILE = "MOBILE",
  /** An eCommerce business with a website selling goods/services. */
  ONLINE = "ONLINE",
}

/** Detailed information about the business */
export type BusinessDetail = {
  __typename?: "BusinessDetail";
  /** Information about the business. */
  businessProfile?: Maybe<BusinessProfile>;
  /** The details of the person authorized to act on behalf of business. */
  primaryAuthorizedPerson?: Maybe<AuthorizedPerson>;
};

/** The type of business entity */
export enum BusinessEntityType {
  /** A government organization */
  GOVERNMENT = "GOVERNMENT",
  /** A privately held company */
  PRIVATE = "PRIVATE",
  /** A publicly traded company */
  PUBLIC = "PUBLIC",
}

/** `Business` identification document types. */
export type BusinessIdentificationDocument = NationalIdentificationDocument;

/** The locality details for a `Business`. */
export type BusinessLocality = {
  __typename?: "BusinessLocality";
  /** The country of incorporation in [ISO 3166-1 alpha-3](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3) format (for example, "USA", "GBR", "ISR", "CAN"). */
  countryOfIncorporation?: Maybe<Scalars["String"]>;
  /** The region of incorporation in [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2) format (for example, "US-DE", "GB-LND", "IL-TA", "CA-ON"). */
  regionOfIncorporation?: Maybe<Scalars["String"]>;
};

/** Sort types of the metric returned in response. */
export enum BusinessMetricAttributeSortedDirection {
  /** Ascending order. */
  ASCENDING = "ASCENDING",
  /** Descending order. */
  DESCENDING = "DESCENDING",
}

/** Describes generic metric Result interface. */
export type BusinessMetricResult = {
  /** Data freshness timestamp of metrics. */
  asOf?: Maybe<Scalars["String"]>;
  /** An ISO 8601 value (inclusive) for the beginning and end date. */
  timeRange?: Maybe<BusinessMetricTimeRange>;
};

/** Describes attributes of a sorted metric. */
export type BusinessMetricSortAttribute = {
  /** Sort by Ascending or Descending, Descending as default. */
  sortedDirection?: Maybe<BusinessMetricAttributeSortedDirection>;
};

/** Describes start and end timestamp of returned response. */
export type BusinessMetricTimeRange = {
  __typename?: "BusinessMetricTimeRange";
  /** An ISO 8601 value (inclusive) for the ending date. */
  end?: Maybe<Scalars["String"]>;
  /** An ISO 8601 value (inclusive) for the beginning date. */
  start?: Maybe<Scalars["String"]>;
};

/** Type representing common name fields of a business. */
export type BusinessName = {
  __typename?: "BusinessName";
  /** The business' doing business as (DBA) name. */
  doingBusinessAsName?: Maybe<Scalars["String"]>;
  /** The business' legal name. */
  legalBusinessName: Scalars["String"];
};

/** The response type for the `businessOrganizations` query. */
export type BusinessOrganizationConnectionPayload =
  | AccessDeniedError
  | OrganizationConnection
  | UserError;

/** Inputs for filtering business `Organization` data. */
export type BusinessOrganizationFilterInput = {
  /** Filter by the `Organization` ID. */
  id?: InputMaybe<IdFilterInput>;
};

/** Information about a business' ownership */
export type BusinessOwnershipInformation = OnboardingApplicationStep & {
  __typename?: "BusinessOwnershipInformation";
  /** Whether the business has an owner with more than 25% stake in the business. */
  hasOwnerWithMoreThan25PercentStake: Scalars["Boolean"];
  /** Whether the business is publicly traded or a government entity.  If set to true, then ultimate beneficial owner information is not required. */
  isPubliclyTradedOrGovernmentEntity: Scalars["Boolean"];
  /** Ultimate beneficial owners for the business, owning 25% or more of the business. */
  owners?: Maybe<Array<OnboardingBusinessAuthorizedPerson>>;
  /** The status of ownership information being collected */
  stepStatus?: Maybe<OnboardingApplicationStepStatus>;
};

/** A business plan attribute to be set on a business profile. */
export type BusinessPlanAttributeInput = {
  /** An indicator-type (boolean) business plan attribute. */
  indicatorAttribute?: InputMaybe<BusinessPlanIndicatorAttributeInput>;
};

/** Details on the business' customer support contact information */
export type BusinessPlanCustomerSupportContactInformation = {
  __typename?: "BusinessPlanCustomerSupportContactInformation";
  /** A support address */
  address?: Maybe<Address>;
  /** A support email */
  email?: Maybe<Scalars["String"]>;
  /** A support phone */
  phone?: Maybe<Phone>;
  /** A support URL */
  url?: Maybe<Scalars["String"]>;
};

/** An indicator-type (boolean) business plan attribute on the response. */
export type BusinessPlanIndicatorAttribute = {
  __typename?: "BusinessPlanIndicatorAttribute";
  /**
   * The date the indicator was reported.
   *
   * Format: `YYYY-MM-DD`
   */
  reportedAt?: Maybe<Scalars["String"]>;
  /** The type of indicator attribute. */
  type?: Maybe<BusinessPlanIndicatorAttributeType>;
  /** The boolean value for this indicator. */
  value?: Maybe<Scalars["Boolean"]>;
};

/** An indicator-type (boolean) business plan attribute. */
export type BusinessPlanIndicatorAttributeInput = {
  /** The date this attribute was reported, in YYYY-MM-DD format. */
  reportedAt: Scalars["String"];
  /** The type of indicator attribute. */
  type: BusinessPlanIndicatorAttributeType;
  /** The boolean value for this indicator. */
  value: Scalars["Boolean"];
};

/** Supported indicator-type business plan attribute types. */
export enum BusinessPlanIndicatorAttributeType {
  /** Whether the business is exempt from fuel taxes. */
  FUEL_TAX_EXEMPT = "FUEL_TAX_EXEMPT",
}

/** The business' reported operating details. */
export type BusinessPlanOperatingDetails = {
  __typename?: "BusinessPlanOperatingDetails";
  /** Gross annual revenues per reported year. */
  annualVolumes?: Maybe<Array<BusinessPlanReportedAmount>>;
  /** Average anticipated sales per reported year. */
  averageTickets?: Maybe<Array<BusinessPlanReportedAmount>>;
  /** Business to business sales percentage */
  businessSalesPercentage?: Maybe<Array<BusinessPlanReportedValue>>;
  /** Card not present sales percentage */
  cardNotPresentSalesPercentage?: Maybe<Array<BusinessPlanReportedValue>>;
  /** Card present sales percentage */
  cardPresentSalesPercentage?: Maybe<Array<BusinessPlanReportedValue>>;
  /** Business to consumer sales percentage */
  consumerSalesPercentage?: Maybe<Array<BusinessPlanReportedValue>>;
  /** Details on the business' customer support contact information */
  customerSupportContactInformation?: Maybe<BusinessPlanCustomerSupportContactInformation>;
  /** Reported Employee Count */
  employeeCounts?: Maybe<Array<BusinessPlanReportedValue>>;
  /** Government sales percentage */
  governmentSalesPercentage?: Maybe<Array<BusinessPlanReportedValue>>;
  /** Indicator-type business plan attributes (e.g., fuel tax exempt). */
  indicatorAttributes?: Maybe<Array<BusinessPlanIndicatorAttribute>>;
  /** The different points of interaction the business has with their customers. */
  interactionMethods?: Maybe<Array<BusinessCustomerInteractionMethod>>;
  /** Largest monthly volumes per reported year. */
  largestMonthlyVolumes?: Maybe<Array<BusinessPlanReportedAmount>>;
  /** Largest anticipated sales per reported year. */
  largestTickets?: Maybe<Array<BusinessPlanReportedAmount>>;
  /** Reported Business Operating Models */
  operatingModels?: Maybe<Array<BusinessPlanOperatingModel>>;
};

/** Good and/or service provided by the business. */
export enum BusinessPlanOperatingGoodsAndServiceCategory {
  /** Offers farm management services or participates in farming operations. */
  AGRICULTURAL_SERVICES = "AGRICULTURAL_SERVICES",
  /** Provides products and services that enable other businesses such as printing, cleaning, software development, or consulting. */
  BUSINESS_SERVICES = "BUSINESS_SERVICES",
  /** Provides products and services related to charity */
  CHARITABLE_ORGANIZATIONS = "CHARITABLE_ORGANIZATIONS",
  /** Sells clothing, footwear, accessories, or clothing-related services. */
  CLOTHING_STORES = "CLOTHING_STORES",
  /** Provides general or specialized construction, publishing, or printing services. */
  CONTRACTED_SERVICES = "CONTRACTED_SERVICES",
  /** Provides products and services related to government and legal organizations and operations. */
  GOVERNMENT_SERVICES = "GOVERNMENT_SERVICES",
  /** A broad range of products and services such as home goods, appliances, musical instruments, computers, marketing, or medical supplies. */
  MISCELLANEOUS_STORES = "MISCELLANEOUS_STORES",
  /** Provides medical, dental, and vision services as well as hospitals and clinics. */
  PROFESSIONAL_SERVICES_OR_MEMBERSHIP_ORGANIZATIONS = "PROFESSIONAL_SERVICES_OR_MEMBERSHIP_ORGANIZATIONS",
  /** Sells products or services for business-to-business, wholesale, or business-to-consumer markets. */
  RETAIL_OUTLET_SERVICES = "RETAIL_OUTLET_SERVICES",
  /** Provides consumer, commercial, and medical transportation services for Passengers and Cargo. */
  TRANSPORTATION_SERVICES = "TRANSPORTATION_SERVICES",
  /** Offers products and services related to booking and providing travel experiences such as flights, hotels, and rental vehicles. */
  TRAVEL = "TRAVEL",
  /** Constructs or operates public and private utilities such as electricity, phone service, and Internet service. */
  UTILITY_SERVICES = "UTILITY_SERVICES",
}

/** Business Plan Operating Model. */
export type BusinessPlanOperatingModel = {
  __typename?: "BusinessPlanOperatingModel";
  /** Details of the `BusinessPlanOperatingModelType`. */
  operatingModelDetails?: Maybe<Array<BusinessPlanOperatingModelDetail>>;
  /** Indicates whether the `BusinessPlanOperatingModelType` is a reported operating model. */
  reportedAsOperatingModel?: Maybe<Scalars["Boolean"]>;
  /** The business plan operating model. */
  type?: Maybe<BusinessPlanOperatingModelType>;
};

/** Details about the business plan operating model. */
export type BusinessPlanOperatingModelDetail =
  | BusinessPlanOperatingModelForwardCommitment
  | BusinessPlanOperatingModelGoodsAndService
  | BusinessPlanOperatingModelSeasonal;

/**
 * For those that engage in forward commitments, identifies the timeframe
 * for when contractually obligated sales will be completed
 */
export type BusinessPlanOperatingModelForwardCommitment = {
  __typename?: "BusinessPlanOperatingModelForwardCommitment";
  /** Maximum possible days for the forward commitment */
  maximumDays?: Maybe<Scalars["UnsignedInt"]>;
  /** Minimum possible days for the forward commitment */
  minimumDays?: Maybe<Scalars["UnsignedInt"]>;
  /**
   * The date the forward commitment operating model was reported.
   *
   * Format: `YYYY-MM-DD`
   */
  reportedOn?: Maybe<Scalars["Date"]>;
};

/** Captures the types of goods and services provided by the business. */
export type BusinessPlanOperatingModelGoodsAndService = {
  __typename?: "BusinessPlanOperatingModelGoodsAndService";
  /** The list of products and/or services sold to your customers. */
  goodsAndServicesProvided?: Maybe<
    Array<BusinessPlanOperatingGoodsAndServiceCategory>
  >;
  /**
   * The date the goods and services offered were reported.
   *
   * Format: `YYYY-MM-DD`
   */
  reportedOn?: Maybe<Scalars["Date"]>;
};

/** Captures when the business operates and whether they have seasonal peaks. Capture the open season or the peak season. */
export type BusinessPlanOperatingModelSeasonal = {
  __typename?: "BusinessPlanOperatingModelSeasonal";
  /** Highest grossing month(s) for the business. */
  peakMonths?: Maybe<Array<Month>>;
  /**
   * The date the seasonal operating models were reported.
   *
   * Format: `YYYY-MM-DD`
   */
  reportedOn?: Maybe<Scalars["Date"]>;
  /** A collection of seasonal ranges describing the business operations. */
  seasonalRanges?: Maybe<Array<BusinessPlanOperatingModelSeasonalMonthlyRange>>;
};

/** Represents a monthly start and ending range for seasonality. */
export type BusinessPlanOperatingModelSeasonalMonthlyRange = {
  __typename?: "BusinessPlanOperatingModelSeasonalMonthlyRange";
  /** End of the peak season */
  endMonth?: Maybe<Month>;
  /** Start of the peak season */
  startMonth?: Maybe<Month>;
};

/** Describes conditions on how the business operates. */
export enum BusinessPlanOperatingModelType {
  /** Whether the business has a forward commitment for delivery of sale. */
  FORWARD_COMMITMENT = "FORWARD_COMMITMENT",
  /** Whether the business sells physical goods. */
  PHYSICAL_GOODS_SOLD = "PHYSICAL_GOODS_SOLD",
  /** Whether the business is seasonal. */
  SEASONAL_BUSINESS = "SEASONAL_BUSINESS",
}

/** Reporting amount for a business plan */
export type BusinessPlanReportedAmount = {
  __typename?: "BusinessPlanReportedAmount";
  /** A collection of amounts to report */
  reportedAmounts?: Maybe<Array<Amount>>;
  /**
   * The close-out date of the preceding fiscal year in ISO 8601 format.
   *
   * Format: `YYYY-MM-DD`
   */
  reportedOn?: Maybe<Scalars["Date"]>;
};

/** Reporting value for a business plan */
export type BusinessPlanReportedValue = {
  __typename?: "BusinessPlanReportedValue";
  /**
   * The close-out date of the preceding fiscal year in ISO 8601 format.
   *
   * Format: `YYYY-MM-DD`
   */
  reportedOn?: Maybe<Scalars["Date"]>;
  /** A value, represented as an Unsigned Integer */
  value?: Maybe<Scalars["UnsignedInt"]>;
};

/** A type representing a snapshot of the applicant's data at the time of `ProductApplication`. */
export type BusinessProductApplicantSnapshot = {
  __typename?: "BusinessProductApplicantSnapshot";
  /** The account holder. */
  accountHolderCurrent?: Maybe<AccountHolder>;
  /**
   * Information about the business.
   * Contains verification data at `businessProfile.currentVerification`.
   */
  businessProfile?: Maybe<ProductApplicantBusinessProfileSnapshot>;
  /** The date and time, in ISO 8601 format, the business account holder was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /**
   * The current verification attempt, if any, of the business account holder.
   * Deprecated. Check the `currentVerification` field under `businessProfile` instead.
   * This field is provided for schema consistency with other snapshot types to prevent field erasure.
   * @deprecated use `businessProfile.currentVerification` instead.
   */
  currentVerification?: Maybe<AccountHolderVerification>;
  /** Global ID used to reference the business in operations. */
  id: Scalars["ID"];
  /**
   * The details of the person authorized to act on behalf of business.
   * Contains verification data at `primaryAuthorizedPerson.currentVerification`.
   */
  primaryAuthorizedPerson?: Maybe<BusinessAuthorizedPersonSnapshot>;
  /** The date and time, in ISO 8601 format, the business account holder was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Information about the business. */
export type BusinessProfile = {
  /** The primary address of the business. */
  billingAddress?: Maybe<Address>;
  /** The business' legal name. */
  name?: Maybe<BusinessName>;
  /** Operating Details */
  operatingDetails?: Maybe<BusinessPlanOperatingDetails>;
};

/** Profile for a `Business`. */
export type BusinessProfileDetail = BusinessProfile & {
  __typename?: "BusinessProfileDetail";
  /** The billing address of the `Business`. */
  billingAddress?: Maybe<Address>;
  /** A short description of what the business does, its purpose, and the products or services it provides. */
  businessDescription?: Maybe<Scalars["String"]>;
  /** The persons associated with the `Business`, including authorized persons, beneficial owners, and guarantors. */
  businessPersons?: Maybe<Array<BusinessAuthorizedPerson>>;
  /** The type of `Business` entity. */
  businessType?: Maybe<BusinessStructure>;
  /** The current verification attempt, if any, on the `Business` profile. */
  currentVerification?: Maybe<AccountHolderVerification>;
  /** An ID associated with the account holder provided by an external party. */
  externalId?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the business profile. */
  id: Scalars["ID"];
  /** Identification documents associated with the `Business`. For example, US Employer Identification Number (EIN) or UK Company Registration Number (CRN). */
  identificationDocuments?: Maybe<Array<BusinessIdentificationDocument>>;
  /**
   * The date this `Business` was incorporated.
   *
   * Format: `YYYY-MM-DD`
   */
  incorporationDate?: Maybe<Scalars["Date"]>;
  /** The industry type for the `Business`. */
  industryType?: Maybe<BusinessPlanOperatingGoodsAndServiceCategory>;
  /** The legal address of the `Business`. */
  legalAddress?: Maybe<Address>;
  /** Locality details for the `Business`, such as the country and region of incorporation. */
  locality?: Maybe<BusinessLocality>;
  /** Name of the `Business`. */
  name?: Maybe<BusinessName>;
  /** The operating details for the `Business`. */
  operatingDetails?: Maybe<BusinessPlanOperatingDetails>;
  /** List of phone numbers associated with the `Business`. */
  phoneNumbers?: Maybe<Array<Phone>>;
  /** The website of the `Business`. */
  website?: Maybe<Scalars["String"]>;
};

/** Business Type. */
export enum BusinessStructure {
  /** Corporation. */
  CORPORATION = "CORPORATION",
  /** Limited Liability Company (LLC). */
  LLC = "LLC",
  /** Non profit. */
  NON_PROFIT = "NON_PROFIT",
  /** Partnership. */
  PARTNERSHIP = "PARTNERSHIP",
  /** A private corporation */
  PRIVATE_CORPORATION = "PRIVATE_CORPORATION",
  /** A publicly traded corporation */
  PUBLIC_CORPORATION = "PUBLIC_CORPORATION",
  /** Sole Proprietorship. */
  SOLE_PROPRIETORSHIP = "SOLE_PROPRIETORSHIP",
}

/** Authorizing officer's business title. */
export enum BusinessTitle {
  /** Chief Executive Officer. */
  CEO = "CEO",
  /** Chief Financial Officer. */
  CFO = "CFO",
  /** Chief Operating Officer. */
  COO = "COO",
  /** Owner. */
  OWNER = "OWNER",
  /** President. */
  PRESIDENT = "PRESIDENT",
  /** Treasurer. */
  TREASURER = "TREASURER",
  /** Vice President. */
  VICE_PRESIDENT = "VICE_PRESIDENT",
}

/** Indicates that identity verification documents have been requested for a `USBusinessUltimateBeneficialOwner`. */
export type BusinessUltimateBeneficialOwnerIdentityDocumentsRequestedEvent = {
  __typename?: "BusinessUltimateBeneficialOwnerIdentityDocumentsRequestedEvent";
  /** The `USBusinessAccountHolder` to which the `USBusinessUltimateBeneficialOwner` is associated. */
  businessAccountHolder?: Maybe<UsBusinessAccountHolder>;
  /** The `USBusinessUltimateBeneficialOwner` for which documents have been requested. */
  businessUltimateBeneficialOwner?: Maybe<UsBusinessUltimateBeneficialOwner>;
  /** The date and time, in ISO 8601 format, this event was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The `IdentityVerificationDocumentUploadSession` created for the requested documents. */
  documentUploadSession?: Maybe<IdentityVerificationDocumentUploadSession>;
  /** The reason identity verification documents are being requested. */
  reason?: Maybe<IdentityVerificationDocumentRequestReason>;
};

/** Indicates that the identifying information of a `USBusinessUltimateBeneficialOwner` has been updated. */
export type BusinessUltimateBeneficialOwnerIdentityUpdatedEvent = {
  __typename?: "BusinessUltimateBeneficialOwnerIdentityUpdatedEvent";
  /** The `USBusinessAccountHolder` for which a `USBusinessUltimateBeneficialOwner` was updated. */
  businessAccountHolder?: Maybe<UsBusinessAccountHolder>;
  /** The `USBusinessUltimateBeneficialOwner` which was updated. */
  businessUltimateBeneficialOwner?: Maybe<UsBusinessUltimateBeneficialOwner>;
  /** The date and time, in ISO 8601 format, this event was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The type of each update made, indicating which fields were modified on the `USBusinessUltimateBeneficialOwner`. */
  updateTypes?: Maybe<Array<BusinessAssociatedPersonIdentityUpdateType>>;
};

/** Code representing the result of CVV (security code) verification */
export enum CvvResponseCode {
  /** The CVV provided on the authorization did match an CVV on file for the card. */
  MATCH = "MATCH",
  /** Returned when the card on file does not have a CVV. */
  NOT_ON_CARD = "NOT_ON_CARD",
  /**
   * The CVV (or similar) check was not performed.
   * Typically this will occur if we are unable to locate the same value in our vault.
   */
  NOT_PERFORMED = "NOT_PERFORMED",
  /** Returned when the CVV is not provided on the authorization */
  NOT_PROVIDED = "NOT_PROVIDED",
  /** The CVV provided on the authorization did not match the CVV on file for the card. */
  NO_MATCH = "NO_MATCH",
}

/** Input for filtering CVV response code */
export type CvvResponseCodeFilterInput = {
  /** Value matches the provided CVV response code */
  equals?: InputMaybe<CvvResponseCode>;
  /** Value does not match any of the provided CVV response code */
  excludes?: InputMaybe<Array<CvvResponseCode>>;
  /** Value exactly matches all of the provided CVV response code */
  includes?: InputMaybe<Array<CvvResponseCode>>;
  /** Value does not match the provided CVV response code */
  notEquals?: InputMaybe<CvvResponseCode>;
};

/** A Spend Control rule that allows or blocks certain CVV response codes during authorizations. */
export type CvvSpendRule = Node &
  SpendRule & {
    __typename?: "CVVSpendRule";
    /** The `CVVResponseCode` values that will be allowed during authorizations. */
    allowed?: Maybe<Array<CvvResponseCode>>;
    /** The `CVVResponseCode` values that will result in declined authorizations. */
    blocked?: Maybe<Array<CvvResponseCode>>;
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the CVV Spend Rule in operations. */
    id: Scalars["ID"];
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/** A Spend Control rule that allows or blocks certain CVV response codes during authorizations. */
export type CvvSpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The result of applying a CVV spend rule to an event. */
export type CvvSpendRuleResult = SpendRuleResult & {
  __typename?: "CVVSpendRuleResult";
  /** The attached level. */
  attachedLevel?: Maybe<AttachedLevel>;
  /** A message describing the result. */
  message?: Maybe<Scalars["String"]>;
  /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
  recommendation?: Maybe<SpendRuleRecommendation>;
  /** The spend rule attached at the time of the event. */
  spendRule?: Maybe<CvvSpendRule>;
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: Maybe<ApplicableRuleUserType>;
  /** The CVV response codes of the event. */
  valuesTested?: Maybe<Array<CvvResponseCode>>;
};

/** The way the amount to be transferred is calculated */
export enum CalculatedTransferAmountType {
  /** Indicates that the amount to be transferred is the minimum payment due on the latest statement billing period */
  MINIMUM_PAYMENT = "MINIMUM_PAYMENT",
  /** Indicates that the amount to be transferred is the outstanding balance on the account */
  OUTSTANDING_BALANCE = "OUTSTANDING_BALANCE",
  /** Indicates that the amount to be transferred is the remaining balance due on the latest statement billing period */
  OUTSTANDING_STATEMENT_BALANCE = "OUTSTANDING_STATEMENT_BALANCE",
}

/** Input for canceling the remaining authorized amount from a payment transaction. */
export type CancelPaymentTransactionInput = {
  /**
   * The amount to cancel.
   *
   * Defaults to cancel the remaining authorized amount.
   */
  amount?: InputMaybe<AmountInput>;
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /** The payment transaction to cancel the remaining authorized amount. */
  paymentTransactionId: Scalars["ID"];
};

/** Result of canceling a payment transaction. */
export type CancelPaymentTransactionPayload =
  | AccessDeniedError
  | CardReversalStepSummary
  | UserError;

/** Input fields for canceling a physical card group order. */
export type CancelPhysicalCardGroupOrderInput = {
  /** Id of the group order. */
  groupOrderId: Scalars["ID"];
};

/** Input fields for canceling an order for a physical payment card */
export type CancelPhysicalPaymentCardOrderInput = {
  /** Physical Payment Card ID */
  physicalPaymentCardOrderId: Scalars["ID"];
};

/** Types which can be returned for canceling a physical payment card order */
export type CancelPhysicalPaymentCardPayload =
  | AccessDeniedError
  | PhysicalPaymentCardOrder
  | UserError;

/** The input for canceling a `RequestedIdentityUpdate`. */
export type CancelRequestedIdentityUpdateInput = {
  /** The Global ID of the requested identity update. */
  id: Scalars["ID"];
};

/** The response type when canceling a `RequestedIdentityUpdate` */
export type CancelRequestedIdentityUpdatePayload =
  | AccessDeniedError
  | RequestedIdentityUpdate
  | UserError;

/** Input to cancel a scheduled transfer */
export type CancelScheduledTransferInput = {
  /** Global ID used to reference the scheduled transfer */
  scheduledTransferId: Scalars["ID"];
};

/** The return types when a scheduled transfer is canceled. */
export type CancelScheduledTransferPayload =
  | AccessDeniedError
  | OneTimeAchTransfer
  | RecurringAchTransfer
  | UserError;

/** Input for capturing a payment transaction. */
export type CapturePaymentTransactionInput = {
  /**
   * The amount to capture.
   *
   * Defaults to capture the remaining authorized amount.
   */
  amount?: InputMaybe<AmountInput>;
  /**
   * Optional capture type for indicating whether this is a final or a multi capture.
   * If not provided, capture type will be determined by the capturing amount and the remaining authorized amount
   */
  captureType?: InputMaybe<CaptureType>;
  /**
   * Optional contract ID to use for this transaction.
   *
   * If not provided, the default contract ID will be used.
   *
   * DEPRECATED: This field is no longer needed. Highnote will use the contractId provided on the `paymentTransactionId`.
   */
  contractId?: InputMaybe<Scalars["ID"]>;
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /** The payment transaction to capture. */
  paymentTransactionId: Scalars["ID"];
};

/** Result of capturing a payment transaction. */
export type CapturePaymentTransactionPayload =
  | AccessDeniedError
  | CardCaptureStepSummary
  | UserError;

/** The type of capture to perform on the authorized amount. */
export enum CaptureType {
  /** This is the final capture for the authorized amount, and any remaining authorized amount will be canceled. */
  FINAL_CAPTURE = "FINAL_CAPTURE",
  /** This is a partial capture for the authorized amount, and the remaining authorized amount will remain available for future captures. */
  MULTI_CAPTURE = "MULTI_CAPTURE",
}

/** The percentage breakdown of how the business accepts card payments */
export type CardAcceptanceMethodBreakdown = {
  __typename?: "CardAcceptanceMethodBreakdown";
  /** The percentage of transactions that are card-present */
  cardPresent: Scalars["UnsignedInt"];
  /** The percentage of transactions that are card-not-present */
  eCommerce: Scalars["UnsignedInt"];
  /** The percentage of transactions in which card information is provided over the phone or through mail */
  moto: Scalars["UnsignedInt"];
};

/** A secure upload link for a card art document upload session */
export type CardArtDocument = Node &
  UploadLink & {
    __typename?: "CardArtDocument";
    /** The date and time, in ISO 8601 format, this `document upload link` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The document type that was uploaded */
    documentType?: Maybe<CardArtDocumentType>;
    /** The session which associates all of the files uploaded using the secure upload link */
    documentUploadSession?: Maybe<CardProfileDocumentUploadSession>;
    /** a url to be used to download the contents of the document. */
    downloadUrl?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the secure upload link */
    id: Scalars["ID"];
    /** The status of the upload */
    status?: Maybe<DocumentUploadLinkStatusCode>;
    /** The date and time, in ISO 8601 format, this `document upload link` was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /**
     * A url to be used to upload the contents of the document.
     *
     * ** Note: ** The maximum file size is 10 MB
     */
    uploadUrl?: Maybe<Scalars["String"]>;
  };

/** The type of card art document */
export enum CardArtDocumentType {
  /** The card art is the background image of a Digital Card */
  DIGITAL_BACKGROUND = "DIGITAL_BACKGROUND",
  /** The card art document is a front image of a Digital Card */
  DIGITAL_FRONT_OF_CARD = "DIGITAL_FRONT_OF_CARD",
  /** The card art is the icon image of a Digital Card */
  DIGITAL_ICON = "DIGITAL_ICON",
  /** The card art is the logo image of a Digital Card */
  DIGITAL_LOGO = "DIGITAL_LOGO",
  /** The card art document is a back image of a Physical Card */
  PHYSICAL_BACK_OF_CARD = "PHYSICAL_BACK_OF_CARD",
  /** The card art document is a front image of a Physical Card */
  PHYSICAL_FRONT_OF_CARD = "PHYSICAL_FRONT_OF_CARD",
  /** The card art document is a front image of a Virtual Card */
  VIRTUAL_FRONT_OF_CARD = "VIRTUAL_FRONT_OF_CARD",
  /** The card logo for 3DS verification */
  VIRTUAL_THREE_DS_VERIFICATION_LOGO = "VIRTUAL_THREE_DS_VERIFICATION_LOGO",
}

/**
 * Deprecated: Reference `CardAuthorizationStep` and `CardCaptureStep` instead of `CardAuthorizationAndCaptureStep`.
 *
 * Record of an acquiring `PaymentTransaction` authorization and capture step.
 */
export type CardAuthorizationAndCaptureStep =
  PaymentTransactionLifecycleStep & {
    __typename?: "CardAuthorizationAndCaptureStep";
    /**
     * The amount for this `PaymentTransaction`.
     * @deprecated Highnote will return `CardAuthorizationStep` and `CardCaptureStep` instead of `CardAuthorizationAndCaptureStep`.
     */
    amount?: Maybe<Amount>;
    /**
     * The date and time, in ISO 8601 format, this object was created.
     * @deprecated Highnote will return `CardAuthorizationStep` and `CardCaptureStep` instead of `CardAuthorizationAndCaptureStep`.
     */
    createdAt?: Maybe<Scalars["String"]>;
    /**
     * Events associated with this step.
     * @deprecated Highnote will return `CardAuthorizationStep` and `CardCaptureStep` instead of `CardAuthorizationAndCaptureStep`.
     */
    events?: Maybe<Array<PaymentTransactionEvent>>;
    /**
     * The current status for this step.
     * @deprecated Highnote will return `CardAuthorizationStep` and `CardCaptureStep` instead of `CardAuthorizationAndCaptureStep`.
     */
    status?: Maybe<PaymentTransactionLifecycleStepStatus>;
    /**
     * The `PaymentTransaction` associated with this step.
     * @deprecated Highnote will return `CardAuthorizationStep` and `CardCaptureStep` instead of `CardAuthorizationAndCaptureStep`.
     */
    transaction?: Maybe<PaymentTransaction>;
  };

/** Record of an acquiring `PaymentTransaction` authorizing an amount with a `PaymentMethod`. */
export type CardAuthorizationStep = PaymentTransactionLifecycleStep & {
  __typename?: "CardAuthorizationStep";
  /** The amount for this `PaymentTransaction`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Events associated with this step. */
  events?: Maybe<Array<PaymentTransactionEvent>>;
  /** The current status for this step. */
  status?: Maybe<PaymentTransactionLifecycleStepStatus>;
  /** The `PaymentTransaction` associated with this step. */
  transaction?: Maybe<PaymentTransaction>;
};

/** Record of a payment transaction authorizing an amount with a `PaymentMethod`. */
export type CardAuthorizationStepSummary =
  PaymentTransactionLifecycleStepSummary & {
    __typename?: "CardAuthorizationStepSummary";
    /** The amount for this `PaymentTransaction`. */
    amount?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, this object was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The `PaymentTransactionSummary` associated with this event. */
    transaction?: Maybe<PaymentDebitTransactionSummary>;
  };

/** Record of an acquiring `PaymentTransaction` authorizing an amount with a `PaymentMethod`. */
export type CardAuthorizedStep = PaymentTransactionLifecycleStep & {
  __typename?: "CardAuthorizedStep";
  /**
   * The amount for this `PaymentTransaction`.
   * @deprecated Use `CardAuthorizationStep` instead.
   */
  amount?: Maybe<Amount>;
  /**
   * The date and time, in ISO 8601 format, this object was created.
   * @deprecated Use `CardAuthorizationStep` instead.
   */
  createdAt?: Maybe<Scalars["String"]>;
  /**
   * Events associated with this step.
   * @deprecated Use `CardAuthorizationStep` instead.
   */
  events?: Maybe<Array<PaymentTransactionEvent>>;
  /**
   * The current status for this step.
   * @deprecated Use `CardAuthorizationStep` instead.
   */
  status?: Maybe<PaymentTransactionLifecycleStepStatus>;
  /**
   * The `PaymentTransaction` associated with this step.
   * @deprecated Use `CardAuthorizationStep` instead.
   */
  transaction?: Maybe<PaymentTransaction>;
};

/** Record of an `PaymentOrder` capturing an amount with a `PaymentMethod`. */
export type CardCapturePaymentOrderSummary =
  PaymentTransactionLifecycleStepSummary & {
    __typename?: "CardCapturePaymentOrderSummary";
    /** The amount for this `PaymentTransaction`. */
    amount?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, this object was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The `PaymentOrder` associated with this `PaymentTransaction`. */
    order?: Maybe<PaymentOrder>;
    /** The `PaymentTransactionSummary` associated with this event. */
    transaction?: Maybe<PaymentDebitTransactionSummary>;
  };

/** Record of an acquiring `PaymentTransaction` capturing an amount with a `PaymentMethod`. */
export type CardCaptureStep = PaymentTransactionLifecycleStep & {
  __typename?: "CardCaptureStep";
  /** The amount for this `PaymentTransaction`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Events associated with this step. */
  events?: Maybe<Array<PaymentTransactionEvent>>;
  /** The current status for this step. */
  status?: Maybe<PaymentTransactionLifecycleStepStatus>;
  /** The `PaymentTransaction` associated with this step. */
  transaction?: Maybe<PaymentTransaction>;
};

/** Record of a payment transaction capturing an amount with a `PaymentMethod`. */
export type CardCaptureStepSummary = PaymentTransactionLifecycleStepSummary & {
  __typename?: "CardCaptureStepSummary";
  /** The amount for this `PaymentTransaction`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The `PaymentTransactionSummary` associated with this event. */
  transaction?: Maybe<PaymentDebitTransactionSummary>;
};

/** Record of an acquiring `PaymentTransaction` capturing an amount with a `PaymentMethod`. */
export type CardCapturedStep = PaymentTransactionLifecycleStep & {
  __typename?: "CardCapturedStep";
  /**
   * The amount for this `PaymentTransaction`.
   * @deprecated Use `CardCaptureStep` instead.
   */
  amount?: Maybe<Amount>;
  /**
   * The date and time, in ISO 8601 format, this object was created.
   * @deprecated Use `CardCaptureStep` instead.
   */
  createdAt?: Maybe<Scalars["String"]>;
  /**
   * Events associated with this step.
   * @deprecated Use `CardCaptureStep` instead.
   */
  events?: Maybe<Array<PaymentTransactionEvent>>;
  /**
   * The current status for this step.
   * @deprecated Use `CardCaptureStep` instead.
   */
  status?: Maybe<PaymentTransactionLifecycleStepStatus>;
  /**
   * The `PaymentTransaction` associated with this step.
   * @deprecated Use `CardCaptureStep` instead.
   */
  transaction?: Maybe<PaymentTransaction>;
};

/** Record of an acquiring `PaymentTransaction` refunding an amount to a `PaymentMethod`. */
export type CardCreditStep = PaymentTransactionLifecycleStep & {
  __typename?: "CardCreditStep";
  /** The amount for this `PaymentTransaction`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Events associated with this step. */
  events?: Maybe<Array<PaymentTransactionEvent>>;
  /** The current status for this step. */
  status?: Maybe<PaymentTransactionLifecycleStepStatus>;
  /** The `PaymentTransaction` associated with this step. */
  transaction?: Maybe<PaymentTransaction>;
};

/** Record of a payment transaction refunding an amount to a `PaymentMethod`. */
export type CardCreditStepSummary = PaymentTransactionLifecycleStepSummary & {
  __typename?: "CardCreditStepSummary";
  /** The amount for this `PaymentTransaction`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The `PaymentTransactionSummary` associated with this event. */
  transaction?: Maybe<PaymentCreditTransactionSummary>;
};

/** Record of an acquiring `PaymentTransaction` refunding an amount to a `PaymentMethod`. */
export type CardCreditedStep = PaymentTransactionLifecycleStep & {
  __typename?: "CardCreditedStep";
  /**
   * The amount for this `PaymentTransaction`.
   * @deprecated Use `CardCreditStep` instead.
   */
  amount?: Maybe<Amount>;
  /**
   * The date and time, in ISO 8601 format, this object was created.
   * @deprecated Use `CardCreditStep` instead.
   */
  createdAt?: Maybe<Scalars["String"]>;
  /**
   * Events associated with this step.
   * @deprecated Use `CardCreditStep` instead.
   */
  events?: Maybe<Array<PaymentTransactionEvent>>;
  /**
   * The current status for this step.
   * @deprecated Use `CardCreditStep` instead.
   */
  status?: Maybe<PaymentTransactionLifecycleStepStatus>;
  /**
   * The `PaymentTransaction` associated with this step.
   * @deprecated Use `CardCreditStep` instead.
   */
  transaction?: Maybe<PaymentTransaction>;
};

/** The capabilities of the terminal to read card data. */
export enum CardDataInputCapability {
  /** The terminal supports reading the PAN via barcode or QR code. */
  BARCODE_OR_QR_CODE = "BARCODE_OR_QR_CODE",
  /** The terminal’s PAN entry capability is unknown. */
  CAPABILITY_UNKNOWN = "CAPABILITY_UNKNOWN",
  /** The terminal supports reading the PAN via the card’s contactless chip only. The terminal does not support reading the PAN via the card’s contact chip. */
  CONTACTLESS_ONLY_SUPPORTED = "CONTACTLESS_ONLY_SUPPORTED",
  /** The terminal only supports reading the PAN via the card chip’s contactless method. */
  CONTACTLESS_READ_VIA_CHIP_RULES = "CONTACTLESS_READ_VIA_CHIP_RULES",
  /** The terminal only supports reading the PAN via the magnetic stripe’s contactless method. */
  CONTACTLESS_READ_VIA_MAG_STRIPE_RULES = "CONTACTLESS_READ_VIA_MAG_STRIPE_RULES",
  /** The terminal supports file reading, but does not supporting reading card data. */
  FILE = "FILE",
  /** The terminal supports reading the PAN via the Integrated Circuit Card (ICC - chip). */
  INTEGRATED_CIRCUIT_CARD = "INTEGRATED_CIRCUIT_CARD",
  /** The terminal supports keyed entry of the PAN. */
  KEY_ENTERED = "KEY_ENTERED",
  /** The terminal supports reading the PAN via the card’s magnetic stripe. */
  MAGNETIC_STRIPE = "MAGNETIC_STRIPE",
  /** The terminal supports an Integrated Circuit Card (ICC) and can read the PAN via the card’s contact chip, magnetic stripe, or contactless chip. */
  MAG_STRIPE_READER_AND_EMV_ICC = "MAG_STRIPE_READER_AND_EMV_ICC",
  /** The terminal supports reading the PAN from the magnetic stripe or keyed entry of the PAN only. */
  MAG_STRIPE_READER_AND_KEY_ENTRY = "MAG_STRIPE_READER_AND_KEY_ENTRY",
  /** The terminal supports reading the PAN from the magnetic stripe or the card’s chip only and keyed entry of the PAN. */
  MAG_STRIPE_READER_AND_KEY_ENTRY_AND_EMV_ICC = "MAG_STRIPE_READER_AND_KEY_ENTRY_AND_EMV_ICC",
  /** The PAN was entered manually, and the terminal was not used. */
  MANUAL_NO_TERMINAL = "MANUAL_NO_TERMINAL",
  /** The terminal supports reading the PAN via Optical Character Recognition. */
  OCR = "OCR",
  /** Secure Cardless Entry. */
  SECURE_CARDLESS_ENTRY = "SECURE_CARDLESS_ENTRY",
}

/** A Spend Control rule that allows or blocks certain `CardDataInputCapability` types during authorizations. */
export type CardDataInputCapabilitySpendRule = Node &
  SpendRule & {
    __typename?: "CardDataInputCapabilitySpendRule";
    /** The `CardDataInputCapability` types that will be allowed during authorizations. */
    allowed?: Maybe<Array<CardDataInputCapability>>;
    /** The `CardDataInputCapability` types that will result in declined authorizations. */
    blocked?: Maybe<Array<CardDataInputCapability>>;
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the `CardDataInputCapabilitySpendRule` in operations. */
    id: Scalars["ID"];
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/** A Spend Control rule that allows or blocks certain `CardDataInputCapability` types during authorizations. */
export type CardDataInputCapabilitySpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The result of applying a `CardDataInputCapabilitySpendRule` to an event. */
export type CardDataInputCapabilitySpendRuleResult = SpendRuleResult & {
  __typename?: "CardDataInputCapabilitySpendRuleResult";
  /** The attached level. */
  attachedLevel?: Maybe<AttachedLevel>;
  /** A message describing the result. */
  message?: Maybe<Scalars["String"]>;
  /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
  recommendation?: Maybe<SpendRuleRecommendation>;
  /** The spend rule attached at the time of the event. */
  spendRule?: Maybe<CardDataInputCapabilitySpendRule>;
  /** The tested `CardDataInputCapability` of the event. */
  valuesTested?: Maybe<Array<CardDataInputCapability>>;
};

/** A Card Digital Wallet Token which can be used for a card transactions. */
export type CardDigitalWalletToken = Node & {
  __typename?: "CardDigitalWalletToken";
  /** Additional Card Digital Wallet Token information. */
  additionalWalletTokenDetails?: Maybe<CardDigitalWalletTokenAdditionalInformation>;
  /** Paginated list of card digital wallet token state transitions associated to a token. */
  cardDigitalWalletTokenStateTransitions?: Maybe<CardDigitalWalletTokenStateTransitionConnection>;
  /** The date and time, in ISO 8601 format, the Digital Wallet Token was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The exact date and time in UTC when the token expires. */
  expirationDate?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the Digital Wallet Token in operations. */
  id: Scalars["ID"];
  /** The last four digits of the token primary account number (TPAN). */
  last4?: Maybe<Scalars["String"]>;
  /** The `PaymentCard` that is associated to the `CardDigitalWalletToken` */
  paymentCard?: Maybe<PaymentCard>;
  /** The identifier assigned to the token requester by the Network. */
  requesterIdentifier?: Maybe<Scalars["String"]>;
  /** The name of the requester the Digital Wallet Token was created for. */
  requesterName?: Maybe<Scalars["String"]>;
  /** The Card Digital Wallet Token source entry method. */
  sourceEntryMethod?: Maybe<CardDigitalWalletTokenSourceEntryMethod>;
  /** The current status of the Digital Wallet Token. */
  status?: Maybe<CardDigitalWalletTokenState>;
  /** The Card Digital Wallet Token type. */
  tokenType?: Maybe<CardDigitalWalletTokenType>;
  /** The date and time, in ISO 8601 format, the Digital Wallet Token was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** The verification methods used to activate the Card Digital Wallet Token. */
  verificationMethods?: Maybe<Array<CardDigitalWalletTokenVerificationMethod>>;
};

/** A Card Digital Wallet Token which can be used for a card transactions. */
export type CardDigitalWalletTokenCardDigitalWalletTokenStateTransitionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The CardDigitalWalletTokenActivatedEvent is triggered when a `CardDigitalWalletToken` has been activated. */
export type CardDigitalWalletTokenActivatedEvent = CardDigitalWalletTokenEvent &
  Node & {
    __typename?: "CardDigitalWalletTokenActivatedEvent";
    /** The ID used to reference the `CardDigitalWalletToken` in operations. */
    id: Scalars["ID"];
    /** Payment card ID for which token was issued. */
    paymentCardId?: Maybe<Scalars["ID"]>;
    /** The reason for the status change. */
    reason?: Maybe<DigitalWalletTokenStatusChangeReason>;
    /** The previous status of the `CardDigitalWalletToken`. */
    tokenPreviousStatus?: Maybe<DigitalWalletTokenStatus>;
    /** The current status of the `CardDigitalWalletToken`. */
    tokenStatus?: Maybe<DigitalWalletTokenStatus>;
  };

/** Additional Card Digital Wallet Token information. */
export type CardDigitalWalletTokenAdditionalInformation = {
  __typename?: "CardDigitalWalletTokenAdditionalInformation";
  /** Device information for the Card Digital Wallet Token. */
  deviceInformation?: Maybe<CardDigitalWalletTokenDeviceInformation>;
  /** The decision reason provided by issuer. */
  issuerDeclineReasons?: Maybe<Array<Scalars["String"]>>;
  /** The number of activation attempts of the Card Digital Wallet Token. */
  numActivationAttempts?: Maybe<Scalars["Int"]>;
  /** The number of active tokens of the current card. */
  numNetworkActiveTokens?: Maybe<Scalars["Int"]>;
  /** The identifier assigned to the token requester by the Network. */
  requesterIdentifier?: Maybe<Scalars["String"]>;
  /** The Card Digital Wallet Token unique reference. */
  tokenUniqueReference?: Maybe<Scalars["String"]>;
  /** The decision reasons provided by provider. */
  walletProviderDeclineReasons?: Maybe<Array<Scalars["String"]>>;
};

/** The connection type for card digital wallet token. */
export type CardDigitalWalletTokenConnection = {
  __typename?: "CardDigitalWalletTokenConnection";
  /** A list of edges. */
  edges?: Maybe<Array<CardDigitalWalletTokenEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The details of a `CardDigitalWalletToken` at the time of a transaction event. */
export type CardDigitalWalletTokenDetails = {
  __typename?: "CardDigitalWalletTokenDetails";
  /** The `CardDigitalWalletToken`. */
  cardDigitalWalletTokenCurrent?: Maybe<CardDigitalWalletToken>;
  /** Identifies the token service provider managing this token. */
  tokenServiceProviderIdentifier?: Maybe<Scalars["String"]>;
  /** Indicates the type of application used for the token. */
  tokenUserApplicationType?: Maybe<TokenUserApplicationType>;
};

/** Used to simulate digital wallet token specific data for a transaction. */
export type CardDigitalWalletTokenDetailsInput = {
  /** Token Service Provider ID to simulate. */
  tokenServiceProviderIdentifier?: InputMaybe<Scalars["String"]>;
  /** Token User Application Type to simulate. */
  tokenUserApplicationType?: InputMaybe<TokenUserApplicationType>;
};

/** The Card Digital Wallet Token device information. */
export type CardDigitalWalletTokenDeviceInformation = {
  __typename?: "CardDigitalWalletTokenDeviceInformation";
  /** The technology used to capture the card details. */
  cardCaptureType?: Maybe<Scalars["String"]>;
  /** The architecture or technology used for token storage. */
  cardStorageType?: Maybe<Scalars["String"]>;
  /** The form factor of the device to be provisioned. */
  formFactor?: Maybe<Scalars["String"]>;
  /** The IP address where the Card Digital Wallet Token is activated. */
  ip?: Maybe<IpAddress>;
  /** The location where the Card Digital Wallet Token is activated. */
  location?: Maybe<Coordinates>;
  /** The device name. */
  name?: Maybe<Scalars["String"]>;
  /** The device operating system name. */
  osName?: Maybe<Scalars["String"]>;
  /** The device operating system version. */
  osVersion?: Maybe<Scalars["String"]>;
  /** The payment types of the Card Digital Wallet Token. */
  paymentTypes?: Maybe<Array<DevicePaymentType>>;
  /** The device serial number. */
  serialNumber?: Maybe<Scalars["String"]>;
};

/** The edge type for card digital wallet token. */
export type CardDigitalWalletTokenEdge = {
  __typename?: "CardDigitalWalletTokenEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The card digital wallet token. */
  node?: Maybe<CardDigitalWalletToken>;
};

export type CardDigitalWalletTokenEvent = {
  /** The ID used to reference the `CardDigitalWalletToken` in operations. */
  id: Scalars["ID"];
  /** Payment card ID for which token was issued. */
  paymentCardId?: Maybe<Scalars["ID"]>;
  /** The reason for the status change. */
  reason?: Maybe<DigitalWalletTokenStatusChangeReason>;
  /** The previous status of the `CardDigitalWalletToken`. */
  tokenPreviousStatus?: Maybe<DigitalWalletTokenStatus>;
  /** The current status of the `CardDigitalWalletToken`. */
  tokenStatus?: Maybe<DigitalWalletTokenStatus>;
};

/** The method used to enter the card information when creating a digital wallet token. */
export enum CardDigitalWalletTokenSourceEntryMethod {
  /** The token is provisioned through an application. */
  APP_PROVISIONED = "APP_PROVISIONED",
  /** The token is generated through a web browser. */
  BROWSER = "BROWSER",
  /** The token is stored on the card network and can be used for transactions. */
  CARD_ON_FILE = "CARD_ON_FILE",
  /** CHIP_DATA: The token is generated from the chip data on the card. */
  CHIP_DATA = "CHIP_DATA",
  /** The token is manually entered by the user or merchant. */
  MANUAL_ENTRY = "MANUAL_ENTRY",
  /** The token is generated by the card network or issuer. */
  TOKEN = "TOKEN",
}

/** States of a card digital wallet token. */
export enum CardDigitalWalletTokenState {
  /** The card digital wallet token has been provisioned and is available for transaction use. */
  ACTIVE = "ACTIVE",
  /** The initial state of the card digital wallet token. The card digital wallet token is not yet available for use. */
  REQUESTED = "REQUESTED",
  /**
   * The card digital wallet token has been blocked from transaction use and action may be required by the account holder.
   * Card digital wallet token can be suspended by the Issuer, Program owner, or Account holder.
   */
  SUSPENDED = "SUSPENDED",
  /** The card digital wallet token has been deleted and is no longer available for transaction use. */
  TERMINATED = "TERMINATED",
}

/** A reason for a card digital wallet token state transition. */
export enum CardDigitalWalletTokenStateReason {
  /** Account holder account closed. */
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  /** Account holder has been deleted. */
  ACCOUNT_HOLDER_DELETED = "ACCOUNT_HOLDER_DELETED",
  /**
   * Account holder successfully authenticated with an activation method (activation
   * code by text message, email, Issuer mobile application, etc.) prior to activation.
   */
  ACTIVATION_METHOD = "ACTIVATION_METHOD",
  /** Account holder called customer agent for verification. */
  CUSTOMER_SERVICE_AGENT = "CUSTOMER_SERVICE_AGENT",
  /** A lost or stolen device has been found or recovered. */
  DEVICE_FOUND = "DEVICE_FOUND",
  /** Device was reported as lost. */
  DEVICE_LOST = "DEVICE_LOST",
  /** Device was reported as stolen. */
  DEVICE_STOLEN = "DEVICE_STOLEN",
  /** Fraudulent transactions have been reported by `Highnote` or the account holder. */
  FRAUDULENT_TRANSACTIONS = "FRAUDULENT_TRANSACTIONS",
  /** State changed based on Card Network request. */
  NETWORK_INITIATED = "NETWORK_INITIATED",
  /**
   * After reviewing transaction history,
   * the account holder or `Highnote` confirmed that there were no fraudulent transactions.
   */
  NON_FRAUDULENT_TRANSACTIONS = "NON_FRAUDULENT_TRANSACTIONS",
  /** Any other reason for the card digital wallet token state change. */
  OTHER = "OTHER",
}

/** State transitions for a card digital wallet token. */
export type CardDigitalWalletTokenStateTransition = {
  __typename?: "CardDigitalWalletTokenStateTransition";
  /** The date and time, in ISO 8601 format, the state transition was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** A reason for the state transition. */
  reason?: Maybe<CardDigitalWalletTokenStateReason>;
  /** A state of the card digital wallet token. */
  state?: Maybe<CardDigitalWalletTokenState>;
  /** The date and time, in ISO 8601 format, the state transition was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The connection type for card digital wallet token state transition. */
export type CardDigitalWalletTokenStateTransitionConnection = {
  __typename?: "CardDigitalWalletTokenStateTransitionConnection";
  /** A list of edges. */
  edges?: Maybe<Array<CardDigitalWalletTokenStateTransitionEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for card digital wallet token state transition. */
export type CardDigitalWalletTokenStateTransitionEdge = {
  __typename?: "CardDigitalWalletTokenStateTransitionEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The card digital wallet token state transition. */
  node?: Maybe<CardDigitalWalletTokenStateTransition>;
};

/** The CardDigitalWalletTokenSuspendedEvent is triggered when a  `CardDigitalWalletToken` has been suspended. */
export type CardDigitalWalletTokenSuspendedEvent = CardDigitalWalletTokenEvent &
  Node & {
    __typename?: "CardDigitalWalletTokenSuspendedEvent";
    /** The ID used to reference the `CardDigitalWalletToken` in operations. */
    id: Scalars["ID"];
    /** Payment card ID for which token was issued. */
    paymentCardId?: Maybe<Scalars["ID"]>;
    /** The reason for the status change. */
    reason?: Maybe<DigitalWalletTokenStatusChangeReason>;
    /** The previous status of the `CardDigitalWalletToken`. */
    tokenPreviousStatus?: Maybe<DigitalWalletTokenStatus>;
    /** The current status of the `CardDigitalWalletToken`. */
    tokenStatus?: Maybe<DigitalWalletTokenStatus>;
  };

/** The CardDigitalWalletTokenTerminatedEvent is triggered when a  `CardDigitalWalletToken` has been terminated. */
export type CardDigitalWalletTokenTerminatedEvent =
  CardDigitalWalletTokenEvent &
    Node & {
      __typename?: "CardDigitalWalletTokenTerminatedEvent";
      /** The ID used to reference the `CardDigitalWalletToken` in operations. */
      id: Scalars["ID"];
      /** Payment card ID for which token was issued. */
      paymentCardId?: Maybe<Scalars["ID"]>;
      /** The reason for the status change. */
      reason?: Maybe<DigitalWalletTokenStatusChangeReason>;
      /** The previous status of the `CardDigitalWalletToken`. */
      tokenPreviousStatus?: Maybe<DigitalWalletTokenStatus>;
      /** The current status of the `CardDigitalWalletToken`. */
      tokenStatus?: Maybe<DigitalWalletTokenStatus>;
    };

/** The Card Digital Wallet Token type. */
export enum CardDigitalWalletTokenType {
  /** The token is stored on file with the card network or issuer. */
  CARD_ON_FILE = "CARD_ON_FILE",
  /** The token is stored in the cloud and can be used for transactions. */
  CLOUD_BASED = "CLOUD_BASED",
  /** The token is stored in a secure element on the device. */
  DEVICE_SECURE_ELEMENT = "DEVICE_SECURE_ELEMENT",
  /** The token is used for ecommerce transactions. */
  ECOMMERCE = "ECOMMERCE",
  /** The token is static and does not change. */
  STATIC = "STATIC",
}

/** The Card Digital Wallet Token verification method. */
export type CardDigitalWalletTokenVerificationMethod = {
  __typename?: "CardDigitalWalletTokenVerificationMethod";
  /** The verification method of the Card Digital Wallet Token activation. */
  type?: Maybe<Scalars["String"]>;
  /** The value of the verification method. e.g. xxx@gmail.com */
  value?: Maybe<Scalars["String"]>;
};

/** Verification methods available for digital wallet token provisioning. These methods determine how cardholders verify their identity when adding cards to digital wallets like Apple Pay, Google Pay, or Samsung Pay. */
export enum CardDigitalWalletTokenVerificationMethodType {
  /** Customer service verification method. The cardholder must call the customer service number to verify their identity with a representative or automated system. In the digital wallet app, the user will see an option to "Call to Verify" with the customer service phone number displayed. */
  CUSTOMER_SERVICE = "CUSTOMER_SERVICE",
  /** Email verification method. The cardholder receives a one-time passcode (OTP) via email to their registered email address. In the digital wallet app, the user will see an option to "Verify via Email" and will need to enter the code they receive to complete provisioning. */
  EMAIL = "EMAIL",
  /** SMS verification method. The cardholder receives a one-time passcode (OTP) via text message to their registered phone number. In the digital wallet app, the user will see an option to "Verify via Text Message" and will need to enter the code they receive to complete provisioning. */
  SMS = "SMS",
}

/** Whether a card is (or will be) `VIRTUAL` or `PHYSICAL`. */
export enum CardFormFactor {
  /** A card which is issued physically and can be used across multiple channels. */
  PHYSICAL = "PHYSICAL",
  /** A card which can only be used through virtual channels. */
  VIRTUAL = "VIRTUAL",
}

/** Input for filtering by `CardFormFactor`. */
export type CardFormFactorFilterInput = {
  equals?: InputMaybe<CardFormFactor>;
  excludes?: InputMaybe<Array<CardFormFactor>>;
  includes?: InputMaybe<Array<CardFormFactor>>;
  notEquals?: InputMaybe<CardFormFactor>;
};

/** Whether or not the Financial Account supports Card Funding. */
export type CardFundingFinancialAccountFeature = FinancialAccountFeature & {
  __typename?: "CardFundingFinancialAccountFeature";
  /** The date and time, in ISO 8601 format, the feature was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The credit limit on the `FleetCardAccountFeature` */
  creditLimit?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, the feature was effective from. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective through. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Whether or not the feature is enabled for the Financial Account. */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** The date and time, in ISO 8601 format, the feature was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Used to represent cardHolder data. */
export type CardHolder = {
  __typename?: "CardHolder";
  /** The billing address associated with the card. */
  billingAddress?: Maybe<Address>;
  /** The email address associated with the Card Holder. */
  email?: Maybe<Scalars["String"]>;
  /** The full name as represented on the card. */
  fullName?: Maybe<Scalars["String"]>;
};

/** Used to represent cardHolder data. */
export type CardHolderInput = {
  /** The billing address associated with the card. */
  billingAddress?: InputMaybe<AddressInput>;
  /** The email address associated with the Card Holder. */
  email?: InputMaybe<Scalars["String"]>;
  /**
   * The full name as represented on the card.
   * **Minimum length:** 1 character
   * **Maximum length:** 255 characters
   */
  fullName?: InputMaybe<Scalars["String"]>;
};

/** Record of an acquiring `PaymentTransaction` authorized some incremental amount. */
export type CardIncrementalAuthorizationStep =
  PaymentTransactionLifecycleStep & {
    __typename?: "CardIncrementalAuthorizationStep";
    /** The amount for this `PaymentTransaction`. */
    amount?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, this object was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Events associated with this step. */
    events?: Maybe<Array<PaymentTransactionEvent>>;
    /** The current status for this step. */
    status?: Maybe<PaymentTransactionLifecycleStepStatus>;
    /** The `PaymentTransaction` associated with this step. */
    transaction?: Maybe<PaymentTransaction>;
  };

/** Record of an acquiring `PaymentTransaction` authorized some incremental amount. */
export type CardIncrementalAuthorizedStep = PaymentTransactionLifecycleStep & {
  __typename?: "CardIncrementalAuthorizedStep";
  /**
   * The amount for this `PaymentTransaction`.
   * @deprecated Use `CardIncrementalAuthorizationStep` instead.
   */
  amount?: Maybe<Amount>;
  /**
   * The date and time, in ISO 8601 format, this object was created.
   * @deprecated Use `CardIncrementalAuthorizationStep` instead.
   */
  createdAt?: Maybe<Scalars["String"]>;
  /**
   * Events associated with this step.
   * @deprecated Use `CardIncrementalAuthorizationStep` instead.
   */
  events?: Maybe<Array<PaymentTransactionEvent>>;
  /**
   * The current status for this step.
   * @deprecated Use `CardIncrementalAuthorizationStep` instead.
   */
  status?: Maybe<PaymentTransactionLifecycleStepStatus>;
  /**
   * The `PaymentTransaction` associated with this step.
   * @deprecated Use `CardIncrementalAuthorizationStep` instead.
   */
  transaction?: Maybe<PaymentTransaction>;
};

/** Represents an arbitration event for an acquiring `PaymentTransaction`. */
export type CardPaymentArbitrationEvent = PaymentTransactionEvent & {
  __typename?: "CardPaymentArbitrationEvent";
  /**
   * The acquirer reference number associated with this event. This is a unique
   * identifier assigned by the acquiring processor to track the transaction.
   */
  acquirerReferenceNumber?: Maybe<Scalars["String"]>;
  /** The amount associated with the `PaymentTransactionEvent`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Reference to the parent `PaymentTransaction` that this event was created for. */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Represents a synchronous card authorization declined payment event for an acquiring `PaymentTransaction`. */
export type CardPaymentAuthorizationDeclinedEvent = PaymentTransactionEvent & {
  __typename?: "CardPaymentAuthorizationDeclinedEvent";
  /**
   * The acquirer reference number associated with this event. This is a unique
   * identifier assigned by the acquiring processor to track the transaction.
   */
  acquirerReferenceNumber?: Maybe<Scalars["String"]>;
  /** The amount associated with the `PaymentTransactionEvent`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Reference to the parent `PaymentTransaction` that this event was created for. */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Represents a synchronous card authorized payment event for an acquiring `PaymentTransaction`. */
export type CardPaymentAuthorizedEvent = PaymentTransactionEvent & {
  __typename?: "CardPaymentAuthorizedEvent";
  /**
   * The acquirer reference number associated with this event. This is a unique
   * identifier assigned by the acquiring processor to track the transaction.
   */
  acquirerReferenceNumber?: Maybe<Scalars["String"]>;
  /** The amount associated with the `PaymentTransactionEvent`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Reference to the parent `PaymentTransaction` that this event was created for. */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Represents a synchronous card authorizing payment event for an acquiring `PaymentTransaction`. */
export type CardPaymentAuthorizingEvent = PaymentTransactionEvent & {
  __typename?: "CardPaymentAuthorizingEvent";
  /**
   * The acquirer reference number associated with this event. This is a unique
   * identifier assigned by the acquiring processor to track the transaction.
   */
  acquirerReferenceNumber?: Maybe<Scalars["String"]>;
  /** The amount associated with the `PaymentTransactionEvent`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Reference to the parent `PaymentTransaction` that this event was created for. */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Represents a synchronous card capture declined payment event for an acquiring `PaymentTransaction`. */
export type CardPaymentCaptureDeclinedEvent = PaymentTransactionEvent & {
  __typename?: "CardPaymentCaptureDeclinedEvent";
  /**
   * The acquirer reference number associated with this event. This is a unique
   * identifier assigned by the acquiring processor to track the transaction.
   */
  acquirerReferenceNumber?: Maybe<Scalars["String"]>;
  /** The amount associated with the `PaymentTransactionEvent`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Reference to the parent `PaymentTransaction` that this event was created for. */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Represents a synchronous card capture processing payment event for an acquiring `PaymentTransaction`. */
export type CardPaymentCaptureProcessingEvent = PaymentTransactionEvent & {
  __typename?: "CardPaymentCaptureProcessingEvent";
  /**
   * The acquirer reference number associated with this event. This is a unique
   * identifier assigned by the acquiring processor to track the transaction.
   */
  acquirerReferenceNumber?: Maybe<Scalars["String"]>;
  /** The amount associated with the `PaymentTransactionEvent`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Reference to the parent `PaymentTransaction` that this event was created for. */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Represents a synchronous card captured payment event for an acquiring `PaymentTransaction`. */
export type CardPaymentCapturedEvent = PaymentTransactionEvent & {
  __typename?: "CardPaymentCapturedEvent";
  /**
   * The acquirer reference number associated with this event. This is a unique
   * identifier assigned by the acquiring processor to track the transaction.
   */
  acquirerReferenceNumber?: Maybe<Scalars["String"]>;
  /**
   * The amount associated with the `PaymentTransactionEvent`.
   * @deprecated Use `CardPaymentCaptureProcessingEvent` instead.
   */
  amount?: Maybe<Amount>;
  /**
   * The date and time, in ISO 8601 format, this object was created.
   * @deprecated Use `CardPaymentCaptureProcessingEvent` instead.
   */
  createdAt?: Maybe<Scalars["String"]>;
  /** Reference to the parent `PaymentTransaction` that this event was created for. */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /**
   * The date and time, in ISO 8601 format, this object was updated.
   * @deprecated Use `CardPaymentCaptureProcessingEvent` instead.
   */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Represents a synchronous card capturing payment event for an acquiring `PaymentTransaction`. */
export type CardPaymentCapturingEvent = PaymentTransactionEvent & {
  __typename?: "CardPaymentCapturingEvent";
  /**
   * The acquirer reference number associated with this event. This is a unique
   * identifier assigned by the acquiring processor to track the transaction.
   */
  acquirerReferenceNumber?: Maybe<Scalars["String"]>;
  /** The amount associated with the `PaymentTransactionEvent`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Reference to the parent `PaymentTransaction` that this event was created for. */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Represents a synchronous card cleared payment event for an acquiring `PaymentTransaction`. */
export type CardPaymentClearedEvent = PaymentTransactionEvent & {
  __typename?: "CardPaymentClearedEvent";
  /**
   * The acquirer reference number associated with this event. This is a unique
   * identifier assigned by the acquiring processor to track the transaction.
   */
  acquirerReferenceNumber?: Maybe<Scalars["String"]>;
  /** The amount associated with the `PaymentTransactionEvent`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Reference to the parent `PaymentTransaction` that this event was created for. */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Represents a synchronous card clearing failed payment event for an acquiring `PaymentTransaction`. */
export type CardPaymentClearingFailedEvent = PaymentTransactionEvent & {
  __typename?: "CardPaymentClearingFailedEvent";
  /**
   * The acquirer reference number associated with this event. This is a unique
   * identifier assigned by the acquiring processor to track the transaction.
   */
  acquirerReferenceNumber?: Maybe<Scalars["String"]>;
  /** The amount associated with the `PaymentTransactionEvent`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Reference to the parent `PaymentTransaction` that this event was created for. */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Represents a synchronous card disbursed payment event for an acquiring `PaymentTransaction`. */
export type CardPaymentDisbursedEvent = PaymentTransactionEvent & {
  __typename?: "CardPaymentDisbursedEvent";
  /**
   * The acquirer reference number associated with this event. This is a unique
   * identifier assigned by the acquiring processor to track the transaction.
   */
  acquirerReferenceNumber?: Maybe<Scalars["String"]>;
  /** The amount associated with the `PaymentTransactionEvent`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Reference to the parent `PaymentTransaction` that this event was created for. */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/**
 * Represents an acquiring payment transaction dispute raised by a card network.
 *
 * A dispute progresses through stages
 * with its own actions and evidence.
 */
export type CardPaymentDispute = Node & {
  __typename?: "CardPaymentDispute";
  /** The overall lifecycle state of the dispute. */
  cardPaymentDisputeStatus?: Maybe<CardPaymentDisputeStatus>;
  /** The category of the dispute as defined by the card network. */
  category?: Maybe<CardPaymentDisputeCategory>;
  /** ISO-8601 formatted string representing when the dispute was closed. */
  closedAt?: Maybe<Scalars["String"]>;
  /** ISO-8601 formatted string representing when the dispute was created in the system. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The financial impact of the dispute on the merchant. */
  financialImpact?: Maybe<Amount>;
  /** Unique identifier for the dispute. */
  id: Scalars["ID"];
  /** ISO-8601 formatted string representing when the dispute was initiated by the network. */
  initiatedAt?: Maybe<Scalars["String"]>;
  /** The network-defined reason for the dispute. */
  networkReason?: Maybe<CardPaymentDisputeNetworkReason>;
  /**
   * The chronological history of the dispute lifecycle.
   *
   * Each stage represents a phase
   * with its own status, actions, and evidence.
   */
  stages?: Maybe<Array<CardPaymentDisputeStage>>;
  /** The payment transaction event associated with the dispute. */
  transactionEvent?: Maybe<PaymentTransactionEvent>;
  /** ISO-8601 formatted string representing when the dispute was last updated in the system. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/**
 * Stage implementation for formal network arbitration.
 *
 * Arbitration is the final stage where the card network makes a binding decision.
 */
export type CardPaymentDisputeArbitrationStage = CardPaymentDisputeStage & {
  __typename?: "CardPaymentDisputeArbitrationStage";
  /** Actions associated with this stage, optionally filtered by completion status. */
  actions?: Maybe<Array<CardPaymentDisputeStageAction>>;
  /** The amount being disputed. */
  amount?: Maybe<Amount>;
  /** ISO-8601 formatted string representing when the arbitration was completed. */
  completedAt?: Maybe<Scalars["String"]>;
  /** A list of all evidence pertaining to this stage. */
  evidence?: Maybe<Array<CardPaymentDisputeStageEvidence>>;
  /** ISO-8601 formatted string representing the deadline for response. */
  responseDueAt?: Maybe<Scalars["String"]>;
  /** ISO-8601 formatted string representing when the arbitration started. */
  startedAt?: Maybe<Scalars["String"]>;
  /** The lifecycle status of this stage. */
  status?: Maybe<CardPaymentDisputeStageStatus>;
};

/**
 * Stage implementation for formal network arbitration.
 *
 * Arbitration is the final stage where the card network makes a binding decision.
 */
export type CardPaymentDisputeArbitrationStageActionsArgs = {
  filterBy?: InputMaybe<CardPaymentDisputeStageActionFilterInput>;
};

/** The category of a dispute. */
export enum CardPaymentDisputeCategory {
  /** Dispute categorized as a consumer dispute. */
  CONSUMER_DISPUTE = "CONSUMER_DISPUTE",
  /** Dispute categorized as fraud. */
  FRAUD = "FRAUD",
  /** Dispute categorized as an authorization issue. */
  INVALID_AUTHORIZATION = "INVALID_AUTHORIZATION",
  /** Dispute categorized as a processing error. */
  PROCESSING_ERROR = "PROCESSING_ERROR",
}

/**
 * Stage implementation for the first chargeback issued by the network.
 *
 * This is the first stage where the transaction is actively disputed with evidence.
 */
export type CardPaymentDisputeChargebackStage = CardPaymentDisputeStage & {
  __typename?: "CardPaymentDisputeChargebackStage";
  /** Actions associated with this stage, optionally filtered by completion status. */
  actions?: Maybe<Array<CardPaymentDisputeStageAction>>;
  /** The amount being disputed. */
  amount?: Maybe<Amount>;
  /** ISO-8601 formatted string representing when the chargeback stage was completed. */
  completedAt?: Maybe<Scalars["String"]>;
  /** A list of all evidence pertaining to this stage. */
  evidence?: Maybe<Array<CardPaymentDisputeStageEvidence>>;
  /** ISO-8601 formatted string representing the deadline for merchant response. */
  responseDueAt?: Maybe<Scalars["String"]>;
  /** ISO-8601 formatted string representing when the chargeback was filed. */
  startedAt?: Maybe<Scalars["String"]>;
  /** The lifecycle status of this stage. */
  status?: Maybe<CardPaymentDisputeStageStatus>;
};

/**
 * Stage implementation for the first chargeback issued by the network.
 *
 * This is the first stage where the transaction is actively disputed with evidence.
 */
export type CardPaymentDisputeChargebackStageActionsArgs = {
  filterBy?: InputMaybe<CardPaymentDisputeStageActionFilterInput>;
};

/** The network-defined reason for a dispute. */
export type CardPaymentDisputeNetworkReason = {
  __typename?: "CardPaymentDisputeNetworkReason";
  /** The network-specific reason code. */
  code?: Maybe<Scalars["String"]>;
  /** Human-readable description of the reason code. */
  description?: Maybe<Scalars["String"]>;
};

/**
 * Stage implementation for pre-arbitration.
 *
 * Pre-arbitration is an escalation after representment, where the issuer disputes
 * the merchant's representment before formal arbitration. This is the last opportunity
 * for the parties to resolve the dispute without network intervention.
 */
export type CardPaymentDisputePreArbitrationStage = CardPaymentDisputeStage & {
  __typename?: "CardPaymentDisputePreArbitrationStage";
  /** Actions associated with this stage, optionally filtered by completion status. */
  actions?: Maybe<Array<CardPaymentDisputeStageAction>>;
  /** The amount being disputed. */
  amount?: Maybe<Amount>;
  /** ISO-8601 formatted string representing when the pre-arbitration was completed. */
  completedAt?: Maybe<Scalars["String"]>;
  /** A list of all evidence pertaining to this stage. */
  evidence?: Maybe<Array<CardPaymentDisputeStageEvidence>>;
  /** ISO-8601 formatted string representing the deadline for response. */
  responseDueAt?: Maybe<Scalars["String"]>;
  /** ISO-8601 formatted string representing when the pre-arbitration started. */
  startedAt?: Maybe<Scalars["String"]>;
  /** The lifecycle status of this stage. */
  status?: Maybe<CardPaymentDisputeStageStatus>;
};

/**
 * Stage implementation for pre-arbitration.
 *
 * Pre-arbitration is an escalation after representment, where the issuer disputes
 * the merchant's representment before formal arbitration. This is the last opportunity
 * for the parties to resolve the dispute without network intervention.
 */
export type CardPaymentDisputePreArbitrationStageActionsArgs = {
  filterBy?: InputMaybe<CardPaymentDisputeStageActionFilterInput>;
};

/** Details specific to the representment stage. */
export type CardPaymentDisputeRepresentmentDetails = {
  __typename?: "CardPaymentDisputeRepresentmentDetails";
  /**
   * Whether the representment was automatically initiated
   * using compelling evidence (e.g., Visa CE 3.0).
   */
  isAutoRepresented?: Maybe<Scalars["Boolean"]>;
};

/**
 * Stage implementation for the merchant's representment response.
 *
 * Representment is the process of challenging a chargeback by submitting evidence.
 */
export type CardPaymentDisputeRepresentmentStage = CardPaymentDisputeStage & {
  __typename?: "CardPaymentDisputeRepresentmentStage";
  /** Actions associated with this stage, optionally filtered by completion status. */
  actions?: Maybe<Array<CardPaymentDisputeStageAction>>;
  /** The monetary amount being disputed. */
  amount?: Maybe<Amount>;
  /** ISO-8601 formatted string representing when the representment was completed. */
  completedAt?: Maybe<Scalars["String"]>;
  /** A list of all evidence pertaining to this stage. */
  evidence?: Maybe<Array<CardPaymentDisputeStageEvidence>>;
  /** Details specific to the representment process. */
  representmentDetails?: Maybe<CardPaymentDisputeRepresentmentDetails>;
  /** ISO-8601 formatted string representing the deadline for response. */
  responseDueAt?: Maybe<Scalars["String"]>;
  /** ISO-8601 formatted string representing when the representment started. */
  startedAt?: Maybe<Scalars["String"]>;
  /** The lifecycle status of this stage. */
  status?: Maybe<CardPaymentDisputeStageStatus>;
};

/**
 * Stage implementation for the merchant's representment response.
 *
 * Representment is the process of challenging a chargeback by submitting evidence.
 */
export type CardPaymentDisputeRepresentmentStageActionsArgs = {
  filterBy?: InputMaybe<CardPaymentDisputeStageActionFilterInput>;
};

/** The base contract for any stage in the dispute lifecycle. */
export type CardPaymentDisputeStage = {
  /** Actions associated with this stage, optionally filtered by completion status. */
  actions?: Maybe<Array<CardPaymentDisputeStageAction>>;
  /** The monetary amount associated with this stage. */
  amount?: Maybe<Amount>;
  /** ISO-8601 formatted string representing when this stage was completed. */
  completedAt?: Maybe<Scalars["String"]>;
  /** A list of all evidence pertaining to this stage. */
  evidence?: Maybe<Array<CardPaymentDisputeStageEvidence>>;
  /** ISO-8601 formatted string representing the deadline for response. */
  responseDueAt?: Maybe<Scalars["String"]>;
  /** ISO-8601 formatted string representing when this stage started. */
  startedAt?: Maybe<Scalars["String"]>;
  /** The lifecycle status of this stage. */
  status?: Maybe<CardPaymentDisputeStageStatus>;
};

/** The base contract for any stage in the dispute lifecycle. */
export type CardPaymentDisputeStageActionsArgs = {
  filterBy?: InputMaybe<CardPaymentDisputeStageActionFilterInput>;
};

/** Represents an action that is available during a dispute stage. */
export type CardPaymentDisputeStageAction = Node & {
  __typename?: "CardPaymentDisputeStageAction";
  /** Human-readable description of the action. */
  description?: Maybe<Scalars["String"]>;
  /** The specialized data structure required to complete this specific action. */
  details?: Maybe<CardPaymentDisputeStageActionDetails>;
  /** The primary identifier for the action. */
  id: Scalars["ID"];
  /** Whether this action has been completed. */
  isCompleted?: Maybe<Scalars["Boolean"]>;
  /** Whether this action is mandatory for the stage to progress. */
  isRequired?: Maybe<Scalars["Boolean"]>;
};

/** Action-specific details for a dispute stage action. */
export type CardPaymentDisputeStageActionDetails =
  | CardPaymentDisputeStageDecisionActionDetails
  | CardPaymentDisputeStageFileUploadActionDetails;

/** Filter input for dispute stage actions. */
export type CardPaymentDisputeStageActionFilterInput = {
  /** Filter by whether the action has been completed. */
  isCompleted?: InputMaybe<BooleanFilterInput>;
};

/**
 * Used for simple network operations or questions.
 * Provides the UI with the valid button choices.
 */
export type CardPaymentDisputeStageDecisionActionDetails = {
  __typename?: "CardPaymentDisputeStageDecisionActionDetails";
  /** The valid choices for this step. */
  choices?: Maybe<Array<CardPaymentDisputeStageDecisionChoice>>;
  /** The financial liability associated with the chosen decision. */
  impactAmount?: Maybe<Amount>;
};

/** A decision choice available on a dispute stage action. */
export enum CardPaymentDisputeStageDecisionChoice {
  /** Accept the dispute at this stage. */
  ACCEPT = "ACCEPT",
  /** Challenge the dispute at this stage. */
  CHALLENGE = "CHALLENGE",
  /** Withdraw from the dispute process. */
  WITHDRAW = "WITHDRAW",
}

/** Represents evidence submitted for a dispute stage. */
export type CardPaymentDisputeStageEvidence = {
  __typename?: "CardPaymentDisputeStageEvidence";
  /** The category of evidence. */
  category?: Maybe<CardPaymentDisputeStageEvidenceCategory>;
  /** ISO-8601 formatted string representing when the evidence was uploaded. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The details of the evidence. */
  details?: Maybe<CardPaymentDisputeStageEvidenceDetails>;
  /** Unique identifier for the evidence. */
  id: Scalars["ID"];
  /** The processing status of the evidence. */
  status?: Maybe<CardPaymentDisputeStageEvidenceStatus>;
};

/** The category of evidence submitted for a dispute. */
export enum CardPaymentDisputeStageEvidenceCategory {
  /** Correspondence or communication records between the merchant and cardholder. */
  CUSTOMER_COMMUNICATION = "CUSTOMER_COMMUNICATION",
  /** Identity verification documents confirming the cardholder's identity at the time of purchase. */
  IDENTITY_VERIFICATION = "IDENTITY_VERIFICATION",
  /** Order history or transaction records demonstrating a pattern of legitimate purchases by the cardholder. */
  ORDER_HISTORY = "ORDER_HISTORY",
  /** Documentation confirming delivery of goods or services (e.g., signed courier confirmation, tracking number). */
  PROOF_OF_DELIVERY = "PROOF_OF_DELIVERY",
  /** Proof that a refund was already issued or a reversal was processed for the disputed transaction. */
  REFUND_REVERSAL_PROOF = "REFUND_REVERSAL_PROOF",
  /** Documentation of the service provided (e.g., service agreement, completion certificate, usage logs). */
  SERVICE_DOCUMENTATION = "SERVICE_DOCUMENTATION",
}

export type CardPaymentDisputeStageEvidenceDetails =
  | CardPaymentDisputeStageFileEvidenceDetails
  | CardPaymentDisputeStageGlobalNoteEvidenceDetails;

/** The processing status of an evidence file. */
export enum CardPaymentDisputeStageEvidenceStatus {
  /** The evidence was accepted by the network. */
  ACCEPTED = "ACCEPTED",
  /** The evidence has been uploaded but not yet submitted to the network. */
  PENDING = "PENDING",
  /** The evidence was rejected by the network. */
  REJECTED = "REJECTED",
  /** The evidence has been submitted to the network. */
  SUBMITTED = "SUBMITTED",
}

/** Details for evidence uploaded as a document. */
export type CardPaymentDisputeStageFileEvidenceDetails = {
  __typename?: "CardPaymentDisputeStageFileEvidenceDetails";
  /** The uploaded document associated with this evidence. */
  document?: Maybe<DocumentUploadLink>;
};

/** Used when the action requires uploading documents or evidence files. */
export type CardPaymentDisputeStageFileUploadActionDetails = {
  __typename?: "CardPaymentDisputeStageFileUploadActionDetails";
  /** Suggested evidence categories that would satisfy this action. */
  suggestedEvidenceCategories?: Maybe<
    Array<CardPaymentDisputeStageEvidenceCategory>
  >;
};

/** Details for evidence recorded as a global note on a dispute stage. */
export type CardPaymentDisputeStageGlobalNoteEvidenceDetails = {
  __typename?: "CardPaymentDisputeStageGlobalNoteEvidenceDetails";
  /** The global note associated with this evidence. */
  globalNote?: Maybe<GlobalNote>;
};

/** The lifecycle status of an individual dispute stage. */
export enum CardPaymentDisputeStageStatus {
  /** The stage has been completed. */
  COMPLETED = "COMPLETED",
  /** The stage has expired without action. */
  EXPIRED = "EXPIRED",
  /** The stage is actively being worked on. */
  IN_PROGRESS = "IN_PROGRESS",
  /** The stage is awaiting action. */
  PENDING = "PENDING",
}

/** Represents the overall lifecycle state of a `Dispute`. */
export enum CardPaymentDisputeStatus {
  /** The dispute is closed. */
  CLOSED = "CLOSED",
  /** The dispute has been initiated. */
  INITIATED = "INITIATED",
  /** The dispute is in review. */
  IN_REVIEW = "IN_REVIEW",
  /** The issuer accepts responsibility for the dispute. Resolved in favor of the merchant. */
  ISSUER_ACCEPTED = "ISSUER_ACCEPTED",
  /** The merchant accepts responsibility for the dispute. Resolved in favor of the issuer. */
  MERCHANT_ACCEPTED = "MERCHANT_ACCEPTED",
  /** The dispute has timed out due to inaction. */
  TIMED_OUT = "TIMED_OUT",
  /** The dispute has been withdrawn by the party that created it. */
  WITHDRAWN = "WITHDRAWN",
}

/** Represents a first chargeback event for an acquiring `PaymentTransaction`. */
export type CardPaymentFirstChargebackEvent = PaymentTransactionEvent & {
  __typename?: "CardPaymentFirstChargebackEvent";
  /**
   * The acquirer reference number associated with this event. This is a unique
   * identifier assigned by the acquiring processor to track the transaction.
   */
  acquirerReferenceNumber?: Maybe<Scalars["String"]>;
  /** The amount associated with the `PaymentTransactionEvent`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Reference to the parent `PaymentTransaction` that this event was created for. */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Represents a synchronous card incremental authorization declined payment event for an acquiring `PaymentTransaction`. */
export type CardPaymentIncrementalAuthorizationDeclinedEvent =
  PaymentTransactionEvent & {
    __typename?: "CardPaymentIncrementalAuthorizationDeclinedEvent";
    /**
     * The acquirer reference number associated with this event. This is a unique
     * identifier assigned by the acquiring processor to track the transaction.
     */
    acquirerReferenceNumber?: Maybe<Scalars["String"]>;
    /** The amount associated with the `PaymentTransactionEvent`. */
    amount?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, this object was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Reference to the parent `PaymentTransaction` that this event was created for. */
    paymentTransaction?: Maybe<PaymentTransaction>;
    /** The date and time, in ISO 8601 format, this object was updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Represents a synchronous card incremental authorized payment event for an acquiring `PaymentTransaction`. */
export type CardPaymentIncrementalAuthorizedEvent = PaymentTransactionEvent & {
  __typename?: "CardPaymentIncrementalAuthorizedEvent";
  /**
   * The acquirer reference number associated with this event. This is a unique
   * identifier assigned by the acquiring processor to track the transaction.
   */
  acquirerReferenceNumber?: Maybe<Scalars["String"]>;
  /** The amount associated with the `PaymentTransactionEvent`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Reference to the parent `PaymentTransaction` that this event was created for. */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Represents a synchronous card partial reversed payment event for an acquiring `PaymentTransaction`. */
export type CardPaymentPartialReversedEvent = PaymentTransactionEvent & {
  __typename?: "CardPaymentPartialReversedEvent";
  /**
   * The acquirer reference number associated with this event. This is a unique
   * identifier assigned by the acquiring processor to track the transaction.
   */
  acquirerReferenceNumber?: Maybe<Scalars["String"]>;
  /** The amount associated with the `PaymentTransactionEvent`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Reference to the parent `PaymentTransaction` that this event was created for. */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Represents a disbursement payout event for an acquiring `PaymentTransaction`. */
export type CardPaymentPayoutEvent = PaymentTransactionEvent & {
  __typename?: "CardPaymentPayoutEvent";
  /**
   * The acquirer reference number associated with this event. This is a unique
   * identifier assigned by the acquiring processor to track the transaction.
   */
  acquirerReferenceNumber?: Maybe<Scalars["String"]>;
  /** The amount associated with the `PaymentTransactionEvent`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Reference to the parent `PaymentTransaction` that this event was created for. */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Represents a pre-arbitration event for an acquiring `PaymentTransaction`. */
export type CardPaymentPreArbitrationEvent = PaymentTransactionEvent & {
  __typename?: "CardPaymentPreArbitrationEvent";
  /**
   * The acquirer reference number associated with this event. This is a unique
   * identifier assigned by the acquiring processor to track the transaction.
   */
  acquirerReferenceNumber?: Maybe<Scalars["String"]>;
  /** The amount associated with the `PaymentTransactionEvent`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Reference to the parent `PaymentTransaction` that this event was created for. */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Represents a representment event for an acquiring `PaymentTransaction`. */
export type CardPaymentRepresentmentEvent = PaymentTransactionEvent & {
  __typename?: "CardPaymentRepresentmentEvent";
  /**
   * The acquirer reference number associated with this event. This is a unique
   * identifier assigned by the acquiring processor to track the transaction.
   */
  acquirerReferenceNumber?: Maybe<Scalars["String"]>;
  /** The amount associated with the `PaymentTransactionEvent`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Reference to the parent `PaymentTransaction` that this event was created for. */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Represents a synchronous card reversal declined payment event for an acquiring `PaymentTransaction`. */
export type CardPaymentReversalDeclinedEvent = PaymentTransactionEvent & {
  __typename?: "CardPaymentReversalDeclinedEvent";
  /**
   * The acquirer reference number associated with this event. This is a unique
   * identifier assigned by the acquiring processor to track the transaction.
   */
  acquirerReferenceNumber?: Maybe<Scalars["String"]>;
  /** The amount associated with the `PaymentTransactionEvent`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Reference to the parent `PaymentTransaction` that this event was created for. */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Represents a synchronous card reversed payment event for an acquiring `PaymentTransaction`. */
export type CardPaymentReversedEvent = PaymentTransactionEvent & {
  __typename?: "CardPaymentReversedEvent";
  /**
   * The acquirer reference number associated with this event. This is a unique
   * identifier assigned by the acquiring processor to track the transaction.
   */
  acquirerReferenceNumber?: Maybe<Scalars["String"]>;
  /** The amount associated with the `PaymentTransactionEvent`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Reference to the parent `PaymentTransaction` that this event was created for. */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Represents a synchronous card settled payment event for an acquiring `PaymentTransaction`. */
export type CardPaymentSettledEvent = PaymentTransactionEvent & {
  __typename?: "CardPaymentSettledEvent";
  /**
   * The acquirer reference number associated with this event. This is a unique
   * identifier assigned by the acquiring processor to track the transaction.
   */
  acquirerReferenceNumber?: Maybe<Scalars["String"]>;
  /**
   * The amount associated with the `PaymentTransactionEvent`.
   * @deprecated Use `CardPaymentClearedEvent` instead.
   */
  amount?: Maybe<Amount>;
  /**
   * The date and time, in ISO 8601 format, this object was created.
   * @deprecated Use `CardPaymentClearedEvent` instead.
   */
  createdAt?: Maybe<Scalars["String"]>;
  /** Reference to the parent `PaymentTransaction` that this event was created for. */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /**
   * The date and time, in ISO 8601 format, this object was updated.
   * @deprecated Use `CardPaymentClearedEvent` instead.
   */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Represents a synchronous card verification declined event for an acquiring `PaymentTransaction`. */
export type CardPaymentVerificationDeclinedEvent = PaymentTransactionEvent & {
  __typename?: "CardPaymentVerificationDeclinedEvent";
  /**
   * The acquirer reference number associated with this event. This is a unique
   * identifier assigned by the acquiring processor to track the transaction.
   */
  acquirerReferenceNumber?: Maybe<Scalars["String"]>;
  /** The amount associated with the `PaymentTransactionEvent`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Reference to the parent `PaymentTransaction` that this event was created for. */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Represents a synchronous card verification pending event for an acquiring `PaymentTransaction`. */
export type CardPaymentVerificationPendingEvent = PaymentTransactionEvent & {
  __typename?: "CardPaymentVerificationPendingEvent";
  /**
   * The acquirer reference number associated with this event. This is a unique
   * identifier assigned by the acquiring processor to track the transaction.
   */
  acquirerReferenceNumber?: Maybe<Scalars["String"]>;
  /** The amount associated with the `PaymentTransactionEvent`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Reference to the parent `PaymentTransaction` that this event was created for. */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Represents a synchronous card verification event for an acquiring `PaymentTransaction`. */
export type CardPaymentVerifiedEvent = PaymentTransactionEvent & {
  __typename?: "CardPaymentVerifiedEvent";
  /**
   * The acquirer reference number associated with this event. This is a unique
   * identifier assigned by the acquiring processor to track the transaction.
   */
  acquirerReferenceNumber?: Maybe<Scalars["String"]>;
  /** The amount associated with the `PaymentTransactionEvent`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Reference to the parent `PaymentTransaction` that this event was created for. */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** A card processing capability */
export type CardProcessingCapability = {
  __typename?: "CardProcessingCapability";
  /** The acquiring provider or sponsor bank */
  acquiringProviderType?: Maybe<AcquiringProviderType>;
  /** The merchant description that will be used for individual transactions */
  merchantDescriptor?: Maybe<Scalars["String"]>;
  /** The permitted payment method, e.g. CARD */
  permittedPaymentMethod?: Maybe<PaymentMethod>;
  /** The permitted processing network where transactions can take place, e.g. Visa */
  permittedProcessingNetwork?: Maybe<AcquirerNetwork>;
  /** The permitted types of transactions, e.g., goods and services */
  permittedTransactionTypes?: Maybe<Array<CardTransactionProcessingType>>;
  /** The status of this `CardProcessingCapability`. */
  status?: Maybe<ProcessingCapabilityStatus>;
};

export type CardProcessingProductFeature = ProductFeature & {
  __typename?: "CardProcessingProductFeature";
  /** The date and time, in ISO 8601 format, this `ProductFeature` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, this `ProductFeature` was effective from. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, this `ProductFeature` was effective through. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Whether or not this `ProductFeature` is enabled for the `Product`. */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** The supported card networks enabled for this `Product`. */
  supportedNetworks?: Maybe<Array<PaymentCardNetwork>>;
  /** The date and time, in ISO 8601 format, this `ProductFeature` was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** A shared configuration for a group of cards. */
export type CardProduct = Node & {
  __typename?: "CardProduct";
  /**
   * The financial accounts associated with this `CardProduct`.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  accounts?: Maybe<FinancialAccountConnection>;
  /** The inter financial account transfer rules attached to this Card Product. */
  attachedInterFinancialAccountTransferRules?: Maybe<InterFinancialAccountTransferRuleConnectionPayload>;
  /**
   * The platform spend rules attached to this `CardProduct`.
   * These are READ ONLY and cannot be modified.
   */
  attachedPlatformSpendRules?: Maybe<SpendRuleConnection>;
  /**
   * The platform velocity rules attached to this `CardProduct`.
   * These are READ ONLY and cannot be modified.
   */
  attachedPlatformVelocityRules?: Maybe<VelocityRuleConnection>;
  /** The realtime risk rules attached to this Card Product. */
  attachedRealtimeRiskRules?: Maybe<RealtimeRiskRuleConnectionPayload>;
  /** A paginated list of Attached RewardRedemptionConfigs. */
  attachedRewardRedemptionConfigurations?: Maybe<RewardRedemptionConfigurationAttachmentConnection>;
  /** A paginated list of Attached `RewardEarnRule`s. */
  attachedRewardRules?: Maybe<RewardRuleAttachmentConnection>;
  /** The spend rules attached to this Card Product. */
  attachedSpendRules?: Maybe<SpendRuleConnection>;
  /** The velocity inter financial account transfer rules belonging to this Card Product. */
  attachedVelocityInterFinancialAccountTransferRules?: Maybe<VelocityInterFinancialAccountTransferRuleConnectionPayload>;
  /** The velocity rules attached to this Card Product. */
  attachedVelocityRules?: Maybe<VelocityRuleConnection>;
  /**
   * The Applications for this Card Product.
   * @deprecated Use searchCardProductApplications instead.
   */
  cardProductApplications?: Maybe<AccountHolderCardProductApplicationConnection>;
  /**
   * A paginated list of all card profile sets filtered by name, status
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  cardProfileSets?: Maybe<CardProfileSetConnectionPayload>;
  /** Indicates Card Product usage is for commercial purposes. */
  commercial?: Maybe<Scalars["Boolean"]>;
  /** The credit configuration for this `CardProduct`. */
  creditConfiguration?: Maybe<CreditCardProductConfiguration>;
  /** A paginated list of `CreditPlanTemplate`s available on this `CardProduct`. */
  creditPlanTemplates?: Maybe<CreditPlanTemplateConnection>;
  /** A paginated list of `CreditPlan`s available on this `CardProduct`. */
  creditPlans?: Maybe<CreditPlanConnection>;
  /** The default `CardProfileSet` for this `CardProduct`. */
  defaultCardProfileSet?: Maybe<CardProfileSet>;
  /**
   * A paginated list of Externally Initiated ACH Transfers.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  externalACHTransfers?: Maybe<ExternallyInitiatedAchTransferConnection>;
  /** The list of features for this CardProduct. */
  features?: Maybe<Array<CardProductFeature>>;
  /**
   * The Fee schedules for this Card Product.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  feeSchedules?: Maybe<FeeScheduleConnection>;
  /**
   * The financial account backing this CardProduct.
   * @deprecated Use accounts instead.
   */
  financialAccounts?: Maybe<Array<FinancialAccount>>;
  /** The physical card group orders for this CardProduct. */
  groupOrders?: Maybe<PhysicalCardGroupOrderConnection>;
  /** Global ID used to reference the Card Product in operations. */
  id: Scalars["ID"];
  /**
   * A paginated list of Integrator Initiated ACH Transfers.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  integratorACHTransfers?: Maybe<IntegratorInitiatedAchTransferConnection>;
  /**
   * The `InterfinancialAccountTransfers` belonging to this `CardProduct`
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  interFinancialAccountTransfers?: Maybe<InterFinancialAccountTransferConnection>;
  /** Human-friendly name of the Card Product. */
  name?: Maybe<Scalars["String"]>;
  /**
   * A paginated list of non-originated ACH transfers.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  nonOriginatedAchTransfers?: Maybe<NonOriginatedAchTransferPayload>;
  /**
   * A paginated list of originated ACH transfers.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  originatedAchTransfers?: Maybe<OriginatedAchTransferPayload>;
  /**
   * A paginated list of `PaymentCardTransactionChargeback` for this `CardProduct`.
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  paymentCardTransactionChargebacks?: Maybe<PaymentCardTransactionChargebackConnection>;
  /** A paginated list of `PaymentCardTransactionDispute` for this `CardProduct`. */
  paymentCardTransactionDisputes?: Maybe<PaymentCardTransactionDisputeConnectionPayload>;
  /**
   * The Payment Cards issued to this Card Product.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  paymentCards?: Maybe<PaymentCardConnection>;
  /** `ProductProfile`s that are attached to this `CardProduct`. */
  profiles?: Maybe<Array<ProductProfile>>;
  /**
   * Search Applications for this Card Product with a filter.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  searchCardProductApplications?: Maybe<SearchCardProductApplicationConnection>;
  /** The ID for the source template that created this `CardProduct`. */
  sourceTemplateId?: Maybe<Scalars["String"]>;
  /**
   * A paginated list of `Transaction` Events.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  transactionEvents?: Maybe<TransactionEventConnection>;
  /** Whether the cards issued for this product are `MULTI_USE` or `SINGLE_USE` */
  usage?: Maybe<CardUsage>;
  /** The business use case for the Card Product. */
  vertical?: Maybe<CardProductVertical>;
};

/** A shared configuration for a group of cards. */
export type CardProductAccountsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<AccountHolderFinancialAccountsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A shared configuration for a group of cards. */
export type CardProductAttachedInterFinancialAccountTransferRulesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A shared configuration for a group of cards. */
export type CardProductAttachedPlatformSpendRulesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A shared configuration for a group of cards. */
export type CardProductAttachedPlatformVelocityRulesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A shared configuration for a group of cards. */
export type CardProductAttachedRealtimeRiskRulesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A shared configuration for a group of cards. */
export type CardProductAttachedRewardRedemptionConfigurationsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A shared configuration for a group of cards. */
export type CardProductAttachedRewardRulesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A shared configuration for a group of cards. */
export type CardProductAttachedSpendRulesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A shared configuration for a group of cards. */
export type CardProductAttachedVelocityInterFinancialAccountTransferRulesArgs =
  {
    after?: InputMaybe<Scalars["String"]>;
    first?: InputMaybe<Scalars["Int"]>;
  };

/** A shared configuration for a group of cards. */
export type CardProductAttachedVelocityRulesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A shared configuration for a group of cards. */
export type CardProductCardProductApplicationsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A shared configuration for a group of cards. */
export type CardProductCardProfileSetsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<FilteredCardProductCardProfileSetsInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A shared configuration for a group of cards. */
export type CardProductCreditPlanTemplatesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<CreditPlanTemplateFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A shared configuration for a group of cards. */
export type CardProductCreditPlansArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<CreditPlanFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A shared configuration for a group of cards. */
export type CardProductExternalAchTransfersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<ExternallyInitiatedAchTransferFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A shared configuration for a group of cards. */
export type CardProductFeeSchedulesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<FeeScheduleFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A shared configuration for a group of cards. */
export type CardProductGroupOrdersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A shared configuration for a group of cards. */
export type CardProductIntegratorAchTransfersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<IntegratorInitiatedAchTransferFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A shared configuration for a group of cards. */
export type CardProductInterFinancialAccountTransfersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<InterFinancialAccountTransferFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A shared configuration for a group of cards. */
export type CardProductNonOriginatedAchTransfersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<NonOriginatedAchTransferFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A shared configuration for a group of cards. */
export type CardProductOriginatedAchTransfersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<OriginatedAchTransferFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A shared configuration for a group of cards. */
export type CardProductPaymentCardTransactionChargebacksArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<CardProductPaymentCardTransactionChargebacksFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A shared configuration for a group of cards. */
export type CardProductPaymentCardTransactionDisputesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<CardProductPaymentCardTransactionDisputesFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A shared configuration for a group of cards. */
export type CardProductPaymentCardsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<CardProductPaymentCardsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A shared configuration for a group of cards. */
export type CardProductSearchCardProductApplicationsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<CardProductApplicationFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A shared configuration for a group of cards. */
export type CardProductTransactionEventsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<CardProductTransactionEventsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The possible application types */
export type CardProductApplication =
  | AccountHolderCardProductApplication
  | AuthorizedUserCardProductApplication;

/** Describes the metrics for applications. */
export type CardProductApplicationBusinessMetric = {
  __typename?: "CardProductApplicationBusinessMetric";
  /** The approved applications. */
  approvedApplications?: Maybe<CreatedOrApprovedApplicationBusinessMetricAttribute>;
  /** The closed applications. */
  closedApplications?: Maybe<Scalars["UnsignedInt"]>;
  /** The created applications. */
  createdApplications?: Maybe<CreatedOrApprovedApplicationBusinessMetricAttribute>;
  /** The denied applications. */
  deniedApplications?: Maybe<Scalars["UnsignedInt"]>;
  /** The in review applications. */
  inReviewApplications?: Maybe<Scalars["UnsignedInt"]>;
  /** The pending applications. */
  pendingApplications?: Maybe<Scalars["UnsignedInt"]>;
  /** An ISO 8601 value (inclusive) for the beginning and end date. */
  timeRange?: Maybe<BusinessMetricTimeRange>;
};

/** Used to filter which application metrics are requested. */
export type CardProductApplicationBusinessMetricFilterInput = {
  /** Filters application metrics by CardProductId, optional. */
  cardProductIds?: InputMaybe<Array<Scalars["String"]>>;
  /** Filters application metrics by TimeRange, start and end are inclusive. */
  timeRange?: InputMaybe<TimestampFilterInputRange>;
};

/** Describes metric Result of card product application metric. */
export type CardProductApplicationBusinessMetricResult =
  BusinessMetricResult & {
    __typename?: "CardProductApplicationBusinessMetricResult";
    /** Data freshness timestamp of metrics. */
    asOf?: Maybe<Scalars["String"]>;
    /** Returned list of cardProductApplicationBusinessMetrics. */
    cardProductApplicationBusinessMetrics?: Maybe<
      Array<CardProductApplicationBusinessMetric>
    >;
    /** An ISO 8601 value (inclusive) for the beginning and end date. */
    timeRange?: Maybe<BusinessMetricTimeRange>;
  };

/** The connection type for `CardProductApplication`. */
export type CardProductApplicationConnection = {
  __typename?: "CardProductApplicationConnection";
  /** A list of edges. */
  edges?: Maybe<Array<CardProductApplicationEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for an `CardProductApplication`. */
export type CardProductApplicationEdge = {
  __typename?: "CardProductApplicationEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The `CardProductApplication`. */
  node?: Maybe<CardProductApplication>;
};

/** Inputs for filtering `CardProductApplication` data. */
export type CardProductApplicationFilterInput = {
  /** The date and time, in ISO 8601 format, the Card Product Application was created. */
  createdAt?: InputMaybe<TimestampFilterInput>;
  /** The id of the Card Product Application. */
  id?: InputMaybe<IdFilterInput>;
  /** The status of the Card Product Application. */
  status?: InputMaybe<AccountHolderApplicationStateInput>;
  /** The task group review category associated with the Card Product Application. */
  taskGroupReviewCategory?: InputMaybe<IdentityTaskGroupReviewCategoryFilterInput>;
  /** The date and time, in ISO 8601 format, the Card Product Application was last updated. */
  updatedAt?: InputMaybe<TimestampFilterInput>;
};

/** The offer category of an `AccountHolderCardProductApplicationOffer` */
export enum CardProductApplicationOfferCategory {
  /** A Secured Credit type offer */
  SECURED_CREDIT = "SECURED_CREDIT",
  /** An Unsecured Credit type offer */
  UNSECURED_CREDIT = "UNSECURED_CREDIT",
}

/** The status of an `AccountHolderCardProductApplicationOffer` */
export enum CardProductApplicationOfferStatus {
  /** The offer has been extended and Accepted by the Applicant */
  ACCEPTED = "ACCEPTED",
  /** The offer has been disqualified and cannot be extended to the Applicant */
  DISQUALIFIED = "DISQUALIFIED",
  /** The offer has expired */
  EXPIRED = "EXPIRED",
  /** The offer has been extended to the Applicant */
  EXTENDED = "EXTENDED",
  /** The offer has not been extended or decisioned yet */
  OPEN = "OPEN",
  /** The offer has been rejected by the Applicant */
  REJECTED = "REJECTED",
}

/** `CardProductApplicationOfferStatus` filter input */
export type CardProductApplicationOfferStatusFilterInput = {
  includes?: InputMaybe<Array<CardProductApplicationOfferStatus>>;
};

/** The connection type for Card Product. */
export type CardProductConnection = {
  __typename?: "CardProductConnection";
  /** A list of edges. */
  edges?: Maybe<Array<CardProductEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a CardProduct. */
export type CardProductEdge = {
  __typename?: "CardProductEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The Card Product. */
  node?: Maybe<CardProduct>;
};

export type CardProductFeature = {
  /** The date and time, in ISO 8601 format, the feature was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective from. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective through. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Whether or not the feature is enabled for the `CardProduct`. */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** The date and time, in ISO 8601 format, the feature was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Details about the Card Product to be created. */
export type CardProductInput = {
  /** Human-friendly name for the Card Product to be created. */
  name: Scalars["String"];
  /** Whether the cards issued for this product will be `MULTI_USE` or `SINGLE_USE` */
  usage: CardUsage;
  /** The business use case for the Card Product. */
  vertical: CardProductVertical;
};

/** Input for filtering `PaymentCardTransactionChargeback` on `CardProduct` */
export type CardProductPaymentCardTransactionChargebacksFilterInput = {
  /** Input to filter by `PaymentCardTransactionChargeback` created date. */
  chargebackCreatedAt?: InputMaybe<TimestampFilterInput>;
  /** Input to filter by `PaymentCardTransactionChargeback` ID. */
  chargebackId?: InputMaybe<IdFilterInput>;
  /** Input to filter by `PaymentCardTransactionChargeback` status. */
  chargebackStatus?: InputMaybe<PaymentCardChargebackStatusFilterInput>;
  /** Chargeback externalNetworkId filter */
  externalNetworkId?: InputMaybe<StringFilterInput>;
};

/** Input for filtering `PaymentCardTransactionDispute` on `CardProduct` */
export type CardProductPaymentCardTransactionDisputesFilterInput = {
  /** Input to filter by `PaymentCardTransactionChargeback` created date. */
  chargebackCreatedAt?: InputMaybe<TimestampFilterInput>;
  /** Input to filter by `PaymentCardTransactionChargeback` ID. */
  chargebackId?: InputMaybe<IdFilterInput>;
  /** Input to filter by `PaymentCardTransactionChargeback` status. */
  chargebackStatus?: InputMaybe<PaymentCardChargebackStatusFilterInput>;
  /** Input to filter by `PaymentCardTransactionDispute` created date. */
  disputeCreatedAt?: InputMaybe<TimestampFilterInput>;
  /** Input to filter disputes by whether a `PaymentCardTransactionDispute` has an associated `PaymentCardTransactionChargeback`. */
  disputeHasChargeback?: InputMaybe<BooleanFilterInput>;
  /** Input to filter by `PaymentCardTransactionDispute` ID. */
  disputeId?: InputMaybe<IdFilterInput>;
  /** Input to filter by `PaymentCardTransactionDispute` status. */
  disputeStatus?: InputMaybe<PaymentCardDisputeStatusFilterInput>;
  /** Chargeback externalNetworkId filter */
  externalNetworkId?: InputMaybe<StringFilterInput>;
};

/** Inputs for filtering Payment Card data. */
export type CardProductPaymentCardsFilterInput = {
  accountHolderId?: InputMaybe<IdFilterInput>;
  bin?: InputMaybe<StringFilterInput>;
  cardNetwork?: InputMaybe<PaymentCardNetworkFilterInput>;
  createDate?: InputMaybe<TimestampFilterInput>;
  customFields?: InputMaybe<CustomFieldsFilterInput>;
  expirationDate?: InputMaybe<TimestampFilterInput>;
  formFactor?: InputMaybe<CardFormFactorFilterInput>;
  last4?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<PaymentCardStatusFilterInput>;
  updateDate?: InputMaybe<TimestampFilterInput>;
};

/** Inputs for filtering transaction events. */
export type CardProductTransactionEventsFilterInput = {
  approvedAmount?: InputMaybe<MoneyFilterInput>;
  /** Authorization expiration date */
  authorizationExpiration?: InputMaybe<TimestampFilterInput>;
  avsResponseCode?: InputMaybe<AvsResponseCodeFilterInput>;
  cardProductId?: InputMaybe<IdFilterInput>;
  createdAt?: InputMaybe<TimestampFilterInput>;
  cvvResponseCode?: InputMaybe<CvvResponseCodeFilterInput>;
  eventType?: InputMaybe<TransactionEventFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  merchantDetails?: InputMaybe<MerchantDetailsFilterInput>;
  /**
   * Open authorizations events have the following properties:
   * * Are the first transaction event with a particular public transaction
   * identifier. This means they are the first event in a sequence of events with
   * the same public transaction identifier.
   * * Authorization expiration date is not empty and not in the past.
   * * The approved amount has not been fully reversed or cleared to zero by
   * subsequent transaction events with the same public transaction identifier.
   */
  onlyOpenAuthorizations?: InputMaybe<BooleanFilterInput>;
  operationalCurrency?: InputMaybe<Iso4217Alpha3CurrencyCode>;
  paymentCardId?: InputMaybe<IdFilterInput>;
  postalCodeResponseCode?: InputMaybe<PostalCodeResponseCodeFilterInput>;
  requestedAmount?: InputMaybe<MoneyFilterInput>;
  responseCode?: InputMaybe<TransactionEventResponseCodeFilterInput>;
  transactionId?: InputMaybe<IdFilterInput>;
  transactionType?: InputMaybe<TransactionTypeFilterInput>;
  updatedAt?: InputMaybe<TimestampFilterInput>;
};

/** The product vertical for a card. */
export enum CardProductVertical {
  /**
   * This `CardProduct` supports acquiring.
   *
   * This `CardProduct` cannot be used with issuance, and would result in a validation error if it is.
   */
  ACQUIRING = "ACQUIRING",
  /** Cards issued to pay for invoices. */
  AP_INVOICE_AUTOMATION = "AP_INVOICE_AUTOMATION",
  /** Cards issued to provide commercial credit. */
  COMMERCIAL_CREDIT = "COMMERCIAL_CREDIT",
  /** Cards issued to proved commercial credit pay in full. */
  COMMERCIAL_CREDIT_PAY_IN_FULL = "COMMERCIAL_CREDIT_PAY_IN_FULL",
  /** Cards issued to provide commercial debit. */
  COMMERCIAL_DEBIT = "COMMERCIAL_DEBIT",
  /** Cards issued for commercial prepaid products. */
  COMMERCIAL_PREPAID = "COMMERCIAL_PREPAID",
  /** Cards issued to provide consumer credit. */
  CONSUMER_CREDIT = "CONSUMER_CREDIT",
  /** Cards issued to provide consumer prepaid. */
  CONSUMER_PREPAID = "CONSUMER_PREPAID",
  /** Cards issued to provide people with advances for earned wages. */
  EARNED_WAGE_ACCESS = "EARNED_WAGE_ACCESS",
  /** Cards issued to provide fleet commercial cards. */
  FLEET = "FLEET",
  /** Cards issued to provide people with general reloadable cards. */
  GENERAL_PURPOSE_RELOADABLE = "GENERAL_PURPOSE_RELOADABLE",
  /** This `CardProduct` supports money movement. */
  MONEY_MOVEMENT = "MONEY_MOVEMENT",
  /** Cards issued for payroll products. */
  PAYROLL = "PAYROLL",
  /**
   * Cards issued to provide secured deposited funded cards.
   * @deprecated The SECURED_COMMERCIAL_CREDIT CardProductVertical is deprecated. Please use COMMERCIAL_CREDIT instead. Please reach out to Highnote support with any questions.
   */
  SECURED_COMMERCIAL_CREDIT = "SECURED_COMMERCIAL_CREDIT",
}

/** Card Profile common interface */
export type CardProfile = {
  /** Card Holder Agreement ID of the card profile. */
  cardHolderAgreementId?: Maybe<Scalars["ID"]>;
  /** Card Product of the card profile. */
  cardProduct?: Maybe<CardProduct>;
  /** The list of `CardProfileSet` related to this `CardProfile`. */
  cardProfileSetRelationships?: Maybe<Array<CardProfileSetRelationship>>;
  /** The date and time, in ISO 8601 format, this `virtual card profile` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Description about the `CardProfile`. */
  description?: Maybe<Scalars["String"]>;
  /** ID of the card profile. */
  id: Scalars["ID"];
  /** Name of the `CardProfile`. */
  name?: Maybe<Scalars["String"]>;
  /** Status of the card profile. */
  status?: Maybe<CardProfileStatus>;
  /** The date and time, in ISO 8601 format, this `virtual card profile` was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Payment Card Profile Bank Status */
export enum CardProfileBankStatus {
  /** Bank Status is approved */
  APPROVED = "APPROVED",
  /** Bank Status is in review */
  IN_REVIEW = "IN_REVIEW",
  /** Bank Status is PENDING */
  PENDING = "PENDING",
  /** Bank Status is ready for review */
  READY_FOR_REVIEW = "READY_FOR_REVIEW",
}

/** The details of a card profile bin. */
export type CardProfileBin = {
  __typename?: "CardProfileBin";
  /** The payment card bin classification. */
  classification?: Maybe<PaymentCardBinClassification>;
  /** The first digits of the bin based on the defined bin length. */
  firstDigitsOfBin?: Maybe<Scalars["String"]>;
  /** The payment card bin funding model. */
  fundingModel?: Maybe<PaymentCardBinFundingModel>;
  /** The ID of the `CardProfileBin`. */
  id: Scalars["ID"];
  /** The bin length. */
  length?: Maybe<Scalars["UnsignedInt"]>;
  /** The configured card brand. */
  network?: Maybe<PaymentCardNetwork>;
};

/** A document upload session for a card profile */
export type CardProfileDocumentUploadSession = DocumentUploadSession &
  Node & {
    __typename?: "CardProfileDocumentUploadSession";
    /** List of allowed document types for the card art document upload session */
    allowedDocumentTypes?: Maybe<Array<CardArtDocumentType>>;
    /** Card Product of the card art document Upload Session. */
    cardProduct: CardProduct;
    /** The date and time, in ISO 8601 format, this `document upload session` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** A list of documents uploaded via a secure card art document upload link */
    documents?: Maybe<Array<CardArtDocument>>;
    /** The date and time the card art document upload session will expire. */
    expiration?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the card art document upload session */
    id: Scalars["ID"];
    /** The current state of the card art document upload session */
    status?: Maybe<DocumentUploadSessionStatusCode>;
    /** The date and time, in ISO 8601 format, this `document upload session` was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Input to pass time in milliseconds. */
export type CardProfileDuration = {
  __typename?: "CardProfileDuration";
  /** Interval in milliseconds. */
  timeInMilliseconds?: Maybe<Scalars["UnsignedInt"]>;
};

/** Physical Card Profile Payment Network Status */
export enum CardProfilePaymentNetworkStatus {
  /** Network Status is approved */
  APPROVED = "APPROVED",
  /** Network Status is in review */
  IN_REVIEW = "IN_REVIEW",
  /** Network Status is PENDING */
  PENDING = "PENDING",
  /** Network Status is ready for review */
  READY_FOR_REVIEW = "READY_FOR_REVIEW",
}

/** A selected set of Card Profiles for a given card product */
export type CardProfileSet = CardProfileSetInterface &
  Node & {
    __typename?: "CardProfileSet";
    /** The bin details associated with the card profile set. */
    binDetails?: Maybe<CardProfileBin>;
    /** Card Product of the card profile set. */
    cardProduct?: Maybe<CardProduct>;
    /** The date and time, in ISO 8601 format, this `CardProfileSet` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Description about the `CardProfileSet`. */
    description?: Maybe<Scalars["String"]>;
    /** Digital Card Profiles of the card profile set. */
    digitalCardProfiles?: Maybe<Array<DigitalCardProfile>>;
    /** ID of the card profile set. */
    id: Scalars["ID"];
    /** Intent of the card profile set. */
    intent?: Maybe<CardProfileSetIntent>;
    /** Name of the card profile set. */
    name?: Maybe<Scalars["String"]>;
    /** Network of the card profile set. */
    network?: Maybe<CardProfileSetNetwork>;
    /** Physical Card Profiles of the card profile set. */
    physicalCardProfiles?: Maybe<Array<PhysicalCardProfile>>;
    /** Preferred `CardProfileSet` configuration */
    preferredConfiguration?: Maybe<Scalars["Boolean"]>;
    /** Status of the card profile set. */
    status?: Maybe<CardProfileSetStatus>;
    /** The date and time, in ISO 8601 format, this `CardProfileSet` was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** Virtual Card Profiles of the card profile set. */
    virtualCardProfiles?: Maybe<Array<VirtualCardProfile>>;
  };

/** The connection type for `CardProfileSetConnection`. */
export type CardProfileSetConnection = {
  __typename?: "CardProfileSetConnection";
  /** A list of edges. */
  edges?: Maybe<Array<CardProfileSetEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The payload for querying card profile sets */
export type CardProfileSetConnectionPayload =
  | AccessDeniedError
  | CardProfileSetConnection
  | UserError;

/** The edge type for CardProfileSet. */
export type CardProfileSetEdge = {
  __typename?: "CardProfileSetEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The Card Profile Set. */
  node?: Maybe<CardProfileSet>;
};

/** Card Profile Set Intent */
export enum CardProfileSetIntent {
  /** Intended to issue Digital cards */
  DIGITAL = "DIGITAL",
  /** Intended to issue Physical cards */
  PHYSICAL = "PHYSICAL",
  /** Intended to issue Virtual cards */
  VIRTUAL = "VIRTUAL",
}

/** A selected set of Card Profiles for a given card product */
export type CardProfileSetInterface = {
  /** Card Product of the card profile set. */
  cardProduct?: Maybe<CardProduct>;
  /** The date and time, in ISO 8601 format, this `CardProfileSet` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** A description about the card profile set. */
  description?: Maybe<Scalars["String"]>;
  /** Digital Card Profiles of the card profile set. */
  digitalCardProfiles?: Maybe<Array<DigitalCardProfile>>;
  /** ID of the card profile set. */
  id: Scalars["ID"];
  /** Intent of the card profile set. */
  intent?: Maybe<CardProfileSetIntent>;
  /** Name of the card profile set. */
  name?: Maybe<Scalars["String"]>;
  /** Network of the card profile set. */
  network?: Maybe<CardProfileSetNetwork>;
  /** Physical Card Profiles of the card profile set. */
  physicalCardProfiles?: Maybe<Array<PhysicalCardProfile>>;
  /** Preferred `CardProfileSet` configuration */
  preferredConfiguration?: Maybe<Scalars["Boolean"]>;
  /** Status of the card profile set. */
  status?: Maybe<CardProfileSetStatus>;
  /** The date and time, in ISO 8601 format, this `CardProfileSet` was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** Virtual Card Profiles of the card profile set. */
  virtualCardProfiles?: Maybe<Array<VirtualCardProfile>>;
};

/** Card Profile Set Network */
export enum CardProfileSetNetwork {
  /** Card Profile Set Network is MASTERCARD */
  MASTERCARD = "MASTERCARD",
  /** Card Profile Set Network is VISA */
  VISA = "VISA",
}

/** The card profile set relationship */
export type CardProfileSetRelationship = {
  __typename?: "CardProfileSetRelationship";
  /** The parent `CardProfileSet`. */
  cardProfileSet?: Maybe<CardProfileSet>;
  /** The date and time, in ISO 8601 format, this `CardProfileSetRelationship` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** ID of the `CardProfileSetRelationship`. */
  id: Scalars["ID"];
  /** The date and time, in ISO 8601 format, this `CardProfileSetRelationship` was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** A selected set of Card Profiles for a given card product */
export type CardProfileSetRestricted = CardProfileSetInterface &
  Node & {
    __typename?: "CardProfileSetRestricted";
    /** Card Product of the card profile set. */
    cardProduct: CardProduct;
    /** The bin assignment id associated with the card profile set. */
    cardProductBinAssignmentId?: Maybe<Scalars["ID"]>;
    /** The date and time, in ISO 8601 format, this `CardProfileSetRestricted` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Description about the `CardProfileSet`. */
    description?: Maybe<Scalars["String"]>;
    /** Digital Card Profiles of the card profile set. */
    digitalCardProfiles?: Maybe<Array<DigitalCardProfile>>;
    /** ID of the card profile set. */
    id: Scalars["ID"];
    /** Intent of the card profile set. */
    intent?: Maybe<CardProfileSetIntent>;
    /** Name of the card profile set. */
    name?: Maybe<Scalars["String"]>;
    /** Network of the card profile set. */
    network?: Maybe<CardProfileSetNetwork>;
    /** Physical Card Profiles of the card profile set. */
    physicalCardProfiles?: Maybe<Array<PhysicalCardProfile>>;
    /** Preferred `CardProfileSet` configuration */
    preferredConfiguration?: Maybe<Scalars["Boolean"]>;
    /** Status of the card profile set. */
    status?: Maybe<CardProfileSetStatus>;
    /** The date and time, in ISO 8601 format, this `CardProfileSetRestricted` was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** Virtual Card Profiles of the card profile set. */
    virtualCardProfiles?: Maybe<Array<VirtualCardProfile>>;
  };

/** Card Profile Set states */
export enum CardProfileSetStatus {
  /** Card Profile Set Status is approved */
  APPROVED = "APPROVED",
  /** Card Profile Set Status is archived */
  ARCHIVED = "ARCHIVED",
  /** Card Profile Set Status is inactive */
  INACTIVE = "INACTIVE",
  /** Card Profile Set Status is in review */
  IN_REVIEW = "IN_REVIEW",
  /** Card Profile Set Status is PENDING */
  PENDING = "PENDING",
  /** Card Profile Set Status is ready for review */
  READY_FOR_REVIEW = "READY_FOR_REVIEW",
}

/** The input to filter by card profile set status */
export type CardProfileSetStatusInput = {
  /** Value matches the provided card profile set status. */
  equals?: InputMaybe<CardProfileSetStatus>;
  /** Value does not match any of the provided card profile set statuses. */
  excludes?: InputMaybe<Array<CardProfileSetStatus>>;
  /** Value matches any of the provided card profile set statuses. */
  includes?: InputMaybe<Array<CardProfileSetStatus>>;
  /** Value does not match the provided card profile set status. */
  notEquals?: InputMaybe<CardProfileSetStatus>;
};

/** CardProfileShipment */
export type CardProfileShipment = {
  __typename?: "CardProfileShipment";
  /** Courier information. */
  courier?: Maybe<CardProfileShipmentCourier>;
  /** Sender details. */
  senderDetails?: Maybe<PaymentCardSenderDetails>;
};

/** The details of the shipping information. */
export type CardProfileShipmentCourier = {
  __typename?: "CardProfileShipmentCourier";
  /** Shipping method. */
  method?: Maybe<PaymentCardShippingMethod>;
  /** Whether signature is required on delivery. */
  signatureRequiredOnDelivery?: Maybe<Scalars["Boolean"]>;
};

/** Card Profile states. */
export enum CardProfileStatus {
  /** The profile was approved. */
  APPROVED = "APPROVED",
  /** The profile is inactive. */
  INACTIVE = "INACTIVE",
  /** The profile requires further review. */
  IN_REVIEW = "IN_REVIEW",
  /** The profile is currently being processed. */
  PENDING = "PENDING",
  /** The profile is ready for review. */
  READY_FOR_REVIEW = "READY_FOR_REVIEW",
}

/** Physical Card Profile Vendor Status */
export enum CardProfileVendorStatus {
  /** Vendor Status is approved */
  APPROVED = "APPROVED",
  /** Vendor Status is in review */
  IN_REVIEW = "IN_REVIEW",
  /** Vendor Status is PENDING */
  PENDING = "PENDING",
  /** Vendor Status is ready for review */
  READY_FOR_REVIEW = "READY_FOR_REVIEW",
}

/** Record of an acquiring `PaymentTransaction` authorization being canceled. */
export type CardReversalStep = PaymentTransactionLifecycleStep & {
  __typename?: "CardReversalStep";
  /** The amount for this `PaymentTransaction`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Events associated with this step. */
  events?: Maybe<Array<PaymentTransactionEvent>>;
  /** The current status for this step. */
  status?: Maybe<PaymentTransactionLifecycleStepStatus>;
  /** The `PaymentTransaction` associated with this step. */
  transaction?: Maybe<PaymentTransaction>;
};

/** Record of a payment transaction authorization being canceled. */
export type CardReversalStepSummary = PaymentTransactionLifecycleStepSummary & {
  __typename?: "CardReversalStepSummary";
  /** The amount for this `PaymentTransaction`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The `PaymentTransaction` associated with this step. */
  transaction?: Maybe<PaymentDebitTransactionSummary>;
};

/** Record of an acquiring `PaymentTransaction` authorization being canceled. */
export type CardReversedStep = PaymentTransactionLifecycleStep & {
  __typename?: "CardReversedStep";
  /**
   * The amount for this `PaymentTransaction`.
   * @deprecated Use `CardReversalStep` instead.
   */
  amount?: Maybe<Amount>;
  /**
   * The date and time, in ISO 8601 format, this object was created.
   * @deprecated Use `CardReversalStep` instead.
   */
  createdAt?: Maybe<Scalars["String"]>;
  /**
   * Events associated with this step.
   * @deprecated Use `CardReversalStep` instead.
   */
  events?: Maybe<Array<PaymentTransactionEvent>>;
  /**
   * The current status for this step.
   * @deprecated Use `CardReversalStep` instead.
   */
  status?: Maybe<PaymentTransactionLifecycleStepStatus>;
  /**
   * The `PaymentTransaction` associated with this step.
   * @deprecated Use `CardReversalStep` instead.
   */
  transaction?: Maybe<PaymentTransaction>;
};

/** The transaction processing type for a card event */
export enum CardTransactionProcessingType {
  /** Account Verification. Category: `INQUIRY_SERVICE`. */
  ACCOUNT_VERIFICATION = "ACCOUNT_VERIFICATION",
  /** Adjustment. Category: `CREDIT`. */
  ADJUSTMENT_CREDIT = "ADJUSTMENT_CREDIT",
  /** Adjustment. Category: `DEBIT`. */
  ADJUSTMENT_DEBIT = "ADJUSTMENT_DEBIT",
  /** Request to provide transaction history by ATM. Category: `INQUIRY_SERVICE`. */
  ATM_MINI_STATEMENT = "ATM_MINI_STATEMENT",
  /** Available funds inquiry. Category: `INQUIRY_SERVICE`. */
  AVAILABLE_FUNDS_INQUIRY = "AVAILABLE_FUNDS_INQUIRY",
  /** Balance inquiry. Category: `INQUIRY_SERVICE`. */
  BALANCE_INQUIRY = "BALANCE_INQUIRY",
  /** Cardholder accounts transfer. Category: `TRANSFER_PAYMENT_TRANSFER_SERVICE`. */
  CARDHOLDER_ACCOUNTS_TRANSFER = "CARDHOLDER_ACCOUNTS_TRANSFER",
  /** Cash. Category: `DEBIT`. */
  CASH = "CASH",
  /** Cash disbursement. Category: `DEBIT`. */
  CASH_DISBURSEMENT = "CASH_DISBURSEMENT",
  /** Deposits/Deposit payments. Category: `CREDIT`. */
  DEPOSITS = "DEPOSITS",
  /** Eligibility inquiry. Category: `INQUIRY_SERVICE`. */
  ELIGIBILITY_INQUIRY = "ELIGIBILITY_INQUIRY",
  /** Used to collect miscellaneous fees. Category: `DEBIT`. */
  FEE_COLLECTION_DEBIT = "FEE_COLLECTION_DEBIT",
  /** Used to remit miscellaneous fees. Category: `CREDIT`. */
  FUNDS_DISBURSEMENT_CREDIT = "FUNDS_DISBURSEMENT_CREDIT",
  /** Funds withdrawal for electronic purse. Category: `DEBIT`. */
  FUNDS_WITHDRAWAL_FOR_ELECTRONIC_PURSE = "FUNDS_WITHDRAWAL_FOR_ELECTRONIC_PURSE",
  /** Goods and services. Category: `DEBIT`. */
  GOODS_AND_SERVICES = "GOODS_AND_SERVICES",
  /** Goods and services with cash disbursement. Category: `DEBIT`. */
  GOODS_AND_SERVICES_WITH_CASH_DISBURSEMENT = "GOODS_AND_SERVICES_WITH_CASH_DISBURSEMENT",
  /** Load funds onto a prepaid card. Category: `CREDIT`. */
  LOAD_OF_PREPAID_OR_STORED_VALUE_CARD = "LOAD_OF_PREPAID_OR_STORED_VALUE_CARD",
  /** Non-cash financial for funding. Category: `DEBIT`. */
  NON_CASH_FINANCIAL_FOR_FUNDING = "NON_CASH_FINANCIAL_FOR_FUNDING",
  /** Notification to bank. Category: `PRIVATE_USE`. */
  NOTIFICATION_TO_BANK = "NOTIFICATION_TO_BANK",
  /** Enables funds to be credited to account numbers for a purpose other than refunding a purchase. Category: `CREDIT`. */
  ORIGINAL_CREDIT = "ORIGINAL_CREDIT",
  /** Payment credit (P2P). Category: `CREDIT`. */
  PAYMENT_CREDIT = "PAYMENT_CREDIT",
  /** Payment debit (P2P). Category: `DEBIT`. */
  PAYMENT_DEBIT = "PAYMENT_DEBIT",
  /** Payment enclosed. Category: `CREDIT`. */
  PAYMENT_ENCLOSED = "PAYMENT_ENCLOSED",
  /** Payment from third party. Category: `CREDIT`. */
  PAYMENT_FROM_THIRD_PARTY = "PAYMENT_FROM_THIRD_PARTY",
  /** Payment to another party. Category: `DEBIT`. */
  PAYMENT_TO_ANOTHER_PARTY = "PAYMENT_TO_ANOTHER_PARTY",
  /** Payment transaction. Category: `CREDIT`. */
  PAYMENT_TRANSACTION = "PAYMENT_TRANSACTION",
  /** PIN change. Category: `PRIVATE_USE`. */
  PIN_CHANGE = "PIN_CHANGE",
  /** PIN Unblock. Category: `PRIVATE_USE`. */
  PIN_UNBLOCK = "PIN_UNBLOCK",
  /** Quasi-Cash and scrip. Category: `DEBIT`. */
  QUASI_CASH_AND_SCRIP = "QUASI_CASH_AND_SCRIP",
  /** Returns. Category: `CREDIT`. */
  RETURNS = "RETURNS",
}

/** A rule that will allow or block `CardTransactionProcessingType`. */
export type CardTransactionProcessingTypeConditionSpendRule = Node &
  SpendRule & {
    __typename?: "CardTransactionProcessingTypeConditionSpendRule";
    /**
     * The list of `CardTransactionProcessingType` that will be allowed.
     * Min: 1
     * Max: 5000
     */
    allowed?: Maybe<Array<CardTransactionProcessingType>>;
    /**
     * The list of `CardTransactionProcessingType` that will be blocked.
     * Min: 1
     * Max: 5000
     */
    blocked?: Maybe<Array<CardTransactionProcessingType>>;
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the rule in operations. */
    id: Scalars["ID"];
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/** A rule that will allow or block `CardTransactionProcessingType`. */
export type CardTransactionProcessingTypeConditionSpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The result of applying a `CardTransactionProcessingTypeConditionSpendRule` to an event. */
export type CardTransactionProcessingTypeConditionSpendRuleResult =
  SpendRuleResult & {
    __typename?: "CardTransactionProcessingTypeConditionSpendRuleResult";
    /** The attached level. */
    attachedLevel?: Maybe<AttachedLevel>;
    /** A message describing the result. */
    message?: Maybe<Scalars["String"]>;
    /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
    recommendation?: Maybe<SpendRuleRecommendation>;
    /** The spend rule attached at the time of the event. */
    spendRule?: Maybe<CardTransactionProcessingTypeConditionSpendRule>;
    /** The tested `CardTransactionProcessingType` of the event. */
    valuesTested?: Maybe<Array<CardTransactionProcessingType>>;
  };

/** Whether a card is (or will be) `MULTI_USE` or `SINGLE_USE`. */
export enum CardUsage {
  /** Cards which can be used more than once. */
  MULTI_USE = "MULTI_USE",
  /** Cards which can only be used once. */
  SINGLE_USE = "SINGLE_USE",
}

/** Record of an acquiring `PaymentTransaction` verifying a `PaymentMethod`. */
export type CardVerificationStep = PaymentTransactionLifecycleStep & {
  __typename?: "CardVerificationStep";
  /** The amount for this `PaymentTransaction`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Events associated with this step. */
  events?: Maybe<Array<PaymentTransactionEvent>>;
  /** The current status for this step. */
  status?: Maybe<PaymentTransactionLifecycleStepStatus>;
  /** The `PaymentTransaction` associated with this step. */
  transaction?: Maybe<PaymentTransaction>;
};

/** An defined item that can be added to an `PaymentOrder`. */
export type CatalogItem = {
  __typename?: "CatalogItem";
  /** The amount for this `CatalogItem` per individual item. */
  amountPerItem?: Maybe<Amount>;
  /** The description of the `CatalogItem`. */
  description?: Maybe<Scalars["String"]>;
  /** An optional external reference ID for this `PaymentOrderItem`. */
  externalIdentifier?: Maybe<Scalars["String"]>;
  /** The ID of the `CatalogItem`. */
  id: Scalars["ID"];
  /** The name of the `CatalogItem`. */
  name?: Maybe<Scalars["String"]>;
  /** Breakdown of the payment instructions for the `CatalogItem` by `Amount`. */
  paymentInstructions?: Maybe<Array<PaymentInstruction>>;
};

/** Whether or not the `CardProduct` supports charge. */
export type ChargeCardProductFeature = CardProductFeature &
  ProductFeature & {
    __typename?: "ChargeCardProductFeature";
    /** The date and time, in ISO 8601 format, the feature was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective from. */
    effectiveFrom?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective through. */
    effectiveThrough?: Maybe<Scalars["String"]>;
    /** Whether or not the feature is enabled for the `CardProduct`. */
    enabled?: Maybe<Scalars["Boolean"]>;
    /** The date and time, in ISO 8601 format, the feature was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Input for charging a `NetworkToken`. */
export type ChargeNetworkTokenInput = {
  /** The amount to charge. */
  amount: AmountInput;
  /** The cardHolder to associate the tokenized `NetworkToken` with. */
  cardHolder?: InputMaybe<CardHolderInput>;
  /**
   * Optional contract ID to use for this transaction.
   *
   * If not provided, the default contract ID will be used.
   *
   * DEPRECATED: This field is no longer needed. If you currently are using `contractId` contact Highnote for details on switching to `merchantAcceptorId`.
   */
  contractId?: InputMaybe<Scalars["ID"]>;
  /** Indicates that the `NetworkTokenInput` is or will be stored externally. */
  externalCredentialOnFile?: InputMaybe<AcquiringExternalCredentialOnFileInput>;
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /** Installment payment information for merchant-managed installment payments. */
  installmentPayment?: InputMaybe<MerchantManagedInstallmentPaymentInput>;
  /**
   * Optional merchant acceptor ID for this transaction.
   *
   * This is used to identify the specific merchant location or terminal accepting the payment.
   */
  merchantAcceptorId?: InputMaybe<Scalars["ID"]>;
  /** Optional Merchant descriptor information for this transaction. */
  merchantDescriptor?: InputMaybe<MerchantDescriptorInput>;
  /** The `NetworkToken` to charge. */
  networkToken: NetworkTokenInput;
  /**
   * How the payment was initiated.
   * If the payment was initiated by the customer, include the way in which payment details were given (i.e. via the web, over the phone, by mail, etc).
   * If the payment was merchant initiated, define the reason for the payment (i.e. recurring, installment, etc).
   */
  paymentInitiator?: InputMaybe<AcquiringPaymentInitiator>;
};

/** Result of charging a `NetworkToken`. */
export type ChargeNetworkTokenPayload =
  | AccessDeniedError
  | CardCaptureStepSummary
  | UserError;

/** Input for charging a `PaymentCard`. */
export type ChargePaymentCardInput = {
  /** The amount to charge. */
  amount: AmountInput;
  /** The cardHolder to associate the tokenized `PaymentCard` with. */
  cardHolder?: InputMaybe<CardHolderInput>;
  /**
   * Optional contract ID to use for this transaction.
   *
   * If not provided, the default contract ID will be used.
   *
   * DEPRECATED: This field is no longer needed. If you currently are using `contractId` contact Highnote for details on switching to `merchantAcceptorId`.
   */
  contractId?: InputMaybe<Scalars["ID"]>;
  /** Indicates that the `PaymentCardInput` is or will be stored externally. */
  externalCredentialOnFile?: InputMaybe<AcquiringExternalCredentialOnFileInput>;
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /** Installment payment information for merchant-managed installment payments. */
  installmentPayment?: InputMaybe<MerchantManagedInstallmentPaymentInput>;
  /**
   * Optional merchant acceptor ID for this transaction.
   *
   * This is used to identify the specific merchant location or terminal accepting the payment.
   */
  merchantAcceptorId?: InputMaybe<Scalars["ID"]>;
  /** Optional Merchant descriptor information for this transaction. */
  merchantDescriptor?: InputMaybe<MerchantDescriptorInput>;
  /** The `PaymentCard` to charge. */
  paymentCard: PaymentCardInput;
  /**
   * How the payment was initiated.
   * If the payment was initiated by the customer, include the way in which payment details were given (i.e. via the web, over the phone, by mail, etc).
   * If the payment was merchant initiated, define the reason for the payment (i.e. recurring, installment, etc).
   */
  paymentInitiator?: InputMaybe<AcquiringPaymentInitiator>;
};

/** Result of charging a `PaymentCard`. */
export type ChargePaymentCardPayload =
  | AccessDeniedError
  | CardCaptureStepSummary
  | UserError;

/** Input for charging a `PaymentMethodToken`. */
export type ChargePaymentMethodTokenInput = {
  /** The amount to charge. */
  amount: AmountInput;
  /**
   * Optional contract ID to use for this transaction.
   *
   * If not provided, the default contract ID will be used.
   *
   * DEPRECATED: This field is no longer needed. If you currently are using `contractId` contact Highnote for details on switching to `merchantAcceptorId`.
   */
  contractId?: InputMaybe<Scalars["ID"]>;
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /** Installment payment information for merchant-managed installment payments. */
  installmentPayment?: InputMaybe<MerchantManagedInstallmentPaymentInput>;
  /**
   * Optional merchant acceptor ID for this transaction.
   *
   * This is used to identify the specific merchant location or terminal accepting the payment.
   */
  merchantAcceptorId?: InputMaybe<Scalars["ID"]>;
  /** Optional Merchant descriptor information for this transaction. */
  merchantDescriptor?: InputMaybe<MerchantDescriptorInput>;
  /**
   * How the payment was initiated.
   * If the payment was initiated by the customer, include the way in which payment details were given (i.e. via the web, over the phone, by mail, etc).
   * If the payment was merchant initiated, define the reason for the payment (i.e. recurring, installment, etc).
   */
  paymentInitiator?: InputMaybe<AcquiringPaymentInitiator>;
  /** The `PaymentMethodToken` to charge. */
  paymentMethodTokenId: Scalars["ID"];
};

/** Result of charging a payment method token. */
export type ChargePaymentMethodTokenPayload =
  | AccessDeniedError
  | CardCaptureStepSummary
  | UserError;

/** Input for charging an `PaymentOrder`. */
export type ChargePaymentOrderInput = {
  /** The amount to charge. If not provided, the remaining authorized amount will be charged. */
  amount?: InputMaybe<AmountInput>;
  /** The cardHolder to associate the tokenized payment card with. */
  cardHolder?: InputMaybe<CardHolderInput>;
  /**
   * Optional contract ID to use for this transaction.
   *
   * If not provided, the default contract ID will be used.
   *
   * DEPRECATED: This field is no longer needed. If you currently are using `contractId` contact Highnote for details on switching to `merchantAcceptorId`.
   */
  contractId?: InputMaybe<Scalars["ID"]>;
  /** Indicates that the `PaymentCardInput` is or will be stored externally. */
  externalCredentialOnFile?: InputMaybe<AcquiringExternalCredentialOnFileInput>;
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /**
   * Optional merchant acceptor ID for this transaction.
   *
   * This is used to identify the specific merchant location or terminal accepting the payment.
   */
  merchantAcceptorId?: InputMaybe<Scalars["ID"]>;
  /** The ID of the `PaymentOrder` to charge. */
  orderId: Scalars["ID"];
  /** The payment card to charge. */
  paymentCard: PaymentCardInput;
  /**
   * How the payment was initiated.
   * If the payment was initiated by the customer, include the way in which payment details were given (i.e. via the web, over the phone, by mail, etc).
   * If the payment was merchant initiated, define the reason for the payment (i.e. recurring, installment, etc).
   */
  paymentInitiator?: InputMaybe<AcquiringPaymentInitiator>;
};

/** Result of charging an order. */
export type ChargePaymentOrderPayload =
  | AccessDeniedError
  | CardCapturePaymentOrderSummary
  | UserError;

/** Input for charging an `PaymentOrder` via a `PaymentMethodToken`. */
export type ChargePaymentOrderPaymentMethodTokenInput = {
  /** The amount to charge. If not provided, the remaining authorized amount will be charged. */
  amount?: InputMaybe<AmountInput>;
  /**
   * Optional contract ID to use for this transaction.
   *
   * If not provided, the default contract ID will be used.
   *
   * DEPRECATED: This field is no longer needed. If you currently are using `contractId` contact Highnote for details on switching to `merchantAcceptorId`.
   */
  contractId?: InputMaybe<Scalars["ID"]>;
  /** Indicates that the `PaymentCardInput` is or will be stored externally. */
  externalCredentialOnFile?: InputMaybe<AcquiringExternalCredentialOnFileInput>;
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /**
   * Optional merchant acceptor ID for this transaction.
   *
   * This is used to identify the specific merchant location or terminal accepting the payment.
   */
  merchantAcceptorId?: InputMaybe<Scalars["ID"]>;
  /** The `PaymentOrder` to charge. */
  orderId: Scalars["ID"];
  /**
   * How the payment was initiated.
   * If the payment was initiated by the customer, include the way in which payment details were given (i.e. via the web, over the phone, by mail, etc).
   * If the payment was merchant initiated, define the reason for the payment (i.e. recurring, installment, etc).
   */
  paymentInitiator?: InputMaybe<AcquiringPaymentInitiator>;
  /** The `PaymentMethodToken` to charge. */
  paymentMethodTokenId: Scalars["ID"];
};

/** The external network of the chargeback. */
export type ChargebackExternalNetwork = {
  __typename?: "ChargebackExternalNetwork";
  /** The external network id of the chargeback. */
  externalNetworkId: Scalars["ID"];
  /** The external network of the chargeback. */
  networkType?: Maybe<ChargebackExternalNetworkType>;
};

/** The external network type of the chargeback. */
export enum ChargebackExternalNetworkType {
  /** Mastercard Network Gateway Online Manager Case ID */
  NGOM = "NGOM",
  /** Visa Resolve Online Case ID */
  VROL = "VROL",
}

/**
 * Charged fee transfer. Fees are charged to the account holder and transferred from
 *
 * account holder financial account to income financial account.
 */
export type ChargedFeeTransfer = {
  __typename?: "ChargedFeeTransfer";
  /** The Card product associated with the financial activity from the account holder that triggered the fee charge. */
  cardProduct?: Maybe<CardProduct>;
  /** The activity for which the fee is charged. */
  feeActivityType?: Maybe<FeeTransferEventFeeActivityType>;
  /** The configured fee amount. */
  feeAmount?: Maybe<Amount>;
  /** Details of the charge activity of account holder that is triggering fee transfer event. */
  feeChargeActvity?: Maybe<FeeChargeActivity>;
  /** Fee charge rule that was applied to this fee transfer event. */
  feeChargeRule?: Maybe<FeeChargeRule>;
  /** The actual fee amount charged. */
  feeTransferAmount?: Maybe<Amount>;
  /** The Financial account of account holder from where the fee is deducted. */
  originatingAccount?: Maybe<FinancialAccount>;
  /** The income financial account of receiving fees. */
  receivingAccount?: Maybe<FinancialAccount>;
  /** The Fee transfer event status. */
  status?: Maybe<FeeTransferStatusDetails>;
  /** The date and time, in ISO 8601 format, the fee was charged. */
  transferDate?: Maybe<Scalars["String"]>;
  /**
   * The actual fee amount charged.
   * @deprecated Use feeTransferAmount instead.
   */
  transferedFeeAmount?: Maybe<Amount>;
};

/** Whether or not the `FinancialAccount` is capable of sending checks. */
export type CheckCapableAccountFeature = FinancialAccountFeature & {
  __typename?: "CheckCapableAccountFeature";
  /** The date and time, in ISO 8601 format, the feature was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective from. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective through. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Whether or not the feature is enabled for the Financial Account. */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** The date and time, in ISO 8601 format, the feature was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** An object representing a check. */
export type CheckPayment = Node & {
  __typename?: "CheckPayment";
  /** The amount of the check. */
  amount?: Maybe<Amount>;
  /** The number of the check. */
  checkNumber?: Maybe<Scalars["String"]>;
  /** The type of the check: digital or physical. */
  checkType?: Maybe<CheckPaymentType>;
  /** The date and time, in ISO 8602 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** A list of events that the `CheckPayment` has gone through. */
  events?: Maybe<Array<CheckPaymentEvent>>;
  /** The reason for the check failure, if applicable. */
  failureReason?: Maybe<CheckPaymentFailureReason>;
  /** The `FinancialAccount` that funded the check. */
  financialAccount?: Maybe<FinancialAccount>;
  /** Global ID used to reference this object. */
  id: Scalars["ID"];
  /** The location of the check image. */
  imageUri?: Maybe<Scalars["String"]>;
  /** The recipient of the check. */
  recipient?: Maybe<CheckPaymentRecipient>;
  /** The delivery type of the check. */
  shippingTime?: Maybe<CheckPaymentShippingTime>;
  /** The current status of the check. */
  status?: Maybe<CheckPaymentStatus>;
  /** The date and time, in ISO 8602 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The type of `CheckPayment` document. */
export enum CheckPaymentDocumentType {
  /** A signature of the account holder. */
  ACCOUNT_HOLDER_SIGNATURE = "ACCOUNT_HOLDER_SIGNATURE",
}

/** A document upload session for `CheckPayment`. */
export type CheckPaymentDocumentUploadSession = DocumentUploadSession &
  Node & {
    __typename?: "CheckPaymentDocumentUploadSession";
    /** List of allowed document types for the `CheckPayment` upload session */
    allowedDocumentTypes?: Maybe<Array<CheckPaymentDocumentType>>;
    /** The date and time, in ISO 8601 format, this `document upload session` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** A list of documents uploaded via a secure document upload link */
    documents?: Maybe<Array<UploadLink>>;
    /** Global ID used to reference the document upload session */
    id: Scalars["ID"];
    /** The current state of the document upload session */
    status?: Maybe<DocumentUploadSessionStatusCode>;
    /** The date and time, in ISO 8601 format, this `document upload session` was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** An object representing a check event type change. */
export type CheckPaymentEvent = Node & {
  __typename?: "CheckPaymentEvent";
  /** The checkPayment associated with this event. */
  checkPayment?: Maybe<CheckPayment>;
  /** The date and time, in ISO 8602 format, this event occurred. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The reason for the check failure, if applicable. */
  failureReason?: Maybe<CheckPaymentFailureReason>;
  /** Global ID used to reference this object. */
  id: Scalars["ID"];
  /** The event type of check at the time of the event. */
  type?: Maybe<CheckPaymentEventType>;
};

/** The current event type of the check. */
export enum CheckPaymentEventType {
  /** The check has been delivered, and cashed or deposited. */
  COMPLETED = "COMPLETED",
  /** The check has failed. The reason for the failure is included in the event. */
  FAILED = "FAILED",
  /** The check has been funded and is pending disbursement. */
  FUNDING_COMPLETED = "FUNDING_COMPLETED",
  /** The funds have been disbursed to external accounts. */
  FUNDING_DISBURSED = "FUNDING_DISBURSED",
  /** The check has been initiated and is pending funding. */
  FUNDING_PENDING = "FUNDING_PENDING",
  /** The check funding has been initiated. */
  FUNDING_STARTED = "FUNDING_STARTED",
  /** The check has been put on hold for risk assessment */
  ON_RISK_HOLD = "ON_RISK_HOLD",
  /** The check has been paid out. */
  PAID = "PAID",
  /** The check is pending processing by Highnote. */
  PENDING_PROCESSING_BY_HIGHNOTE = "PENDING_PROCESSING_BY_HIGHNOTE",
  /** The check has been printed and is pending shipment. */
  PENDING_SHIPMENT = "PENDING_SHIPMENT",
  /** The check has been printed. */
  PRINTED = "PRINTED",
  /** The check has been processed by Highnote. */
  PROCESSED_BY_HIGHNOTE = "PROCESSED_BY_HIGHNOTE",
  /** The check is processing by Highnote. */
  PROCESSING_BY_HIGHNOTE = "PROCESSING_BY_HIGHNOTE",
  /** The check reversal has been completed. */
  REVERSAL_COMPLETED = "REVERSAL_COMPLETED",
  /** The check has been reversed due to voiding or failure. */
  REVERSAL_INITIATED = "REVERSAL_INITIATED",
  /** The check has been shipped. */
  SHIPPED = "SHIPPED",
  /** The check has been voided. */
  VOIDED = "VOIDED",
}

/** The reason for the check failure, if applicable. */
export enum CheckPaymentFailureReason {
  /** The check failed due to a closed account. */
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  /** The check failed due since the `FinancialAccount` is not enabled for checks. */
  FINANCIAL_ACCOUNT_NOT_ENABLED_FOR_CHECK_PAYMENTS = "FINANCIAL_ACCOUNT_NOT_ENABLED_FOR_CHECK_PAYMENTS",
  /** The check failed due to insufficient funds. */
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  /** The check failed due to a Highnote internal error. */
  INTERNAL_ERROR = "INTERNAL_ERROR",
  /** The check failed due to the address being invalid. */
  INVALID_ADDRESS = "INVALID_ADDRESS",
  /** The check failed due to a stop payment request. */
  PAYMENT_STOPPED = "PAYMENT_STOPPED",
  /** The check failed due to a risk assessment. */
  RISK = "RISK",
  /** The check failed due to an unknown reason. Contact Highnote support for more information. */
  UNKNOWN = "UNKNOWN",
}

/** An object representing a check recipient. */
export type CheckPaymentRecipient = {
  __typename?: "CheckPaymentRecipient";
  /** The address of the recipient of the check. */
  address?: Maybe<Address>;
  /** Externally provided ID (255 character limit) to associate this recipient with an external system. */
  externalIdentifier?: Maybe<Scalars["String"]>;
  /** The name of the recipient of the check. */
  name?: Maybe<Scalars["String"]>;
};

/** Enum representing the shipping time for a physical check. */
export enum CheckPaymentShippingTime {
  /** Certified mail. */
  CERTIFIED = "CERTIFIED",
  /** Expedited mail. */
  EXPEDITED = "EXPEDITED",
  /** Overnight mail. */
  OVERNIGHT = "OVERNIGHT",
  /** Standard mail. */
  STANDARD = "STANDARD",
}

/** The status of the check. */
export enum CheckPaymentStatus {
  /** The check has been completed. */
  COMPLETE = "COMPLETE",
  /** An event has occurred that has caused the check to fail. Check the `CheckPayment.failureReason` field for more information. */
  FAILED = "FAILED",
  /** The check is started and pending completion. */
  PENDING = "PENDING",
}

/** The type of the check: digital or physical. */
export enum CheckPaymentType {
  /** A physical check. */
  PHYSICAL = "PHYSICAL",
}

/** The connection object for the `checkPayments` query. */
export type CheckPaymentsConnection = {
  __typename?: "CheckPaymentsConnection";
  /** A list of edges. */
  edges?: Maybe<Array<CheckPaymentsEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** The edge object for the `checkPayments` query. */
export type CheckPaymentsEdge = {
  __typename?: "CheckPaymentsEdge";
  /** The cursor for use in pagination. */
  cursor?: Maybe<Scalars["String"]>;
  /** The node itself. */
  node?: Maybe<CheckPayment>;
};

/** The connection type for `CheckRule`. */
export type CheckRuleConnection = {
  __typename?: "CheckRuleConnection";
  /** A list of edges. */
  edges?: Maybe<Array<CheckRuleEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a `CheckRule`. */
export type CheckRuleEdge = {
  __typename?: "CheckRuleEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
};

/** Describes attributes of a cleared transaction metric. */
export type ClearedTransactionBusinessMetricAttribute = {
  __typename?: "ClearedTransactionBusinessMetricAttribute";
  /** The total amount of cleared transactions. */
  amount?: Maybe<Amount>;
  /** The total number of cleared transactions. */
  count?: Maybe<Scalars["UnsignedInt"]>;
  /** Top merchant category. */
  topMerchantCategory?: Maybe<ClearedTransactionBusinessMetricTopMerchantCategory>;
  /** Top merchant name. */
  topMerchantName?: Maybe<ClearedTransactionBusinessMetricTopMerchantName>;
};

/** Describes cleared transaction merchant category metrics. */
export type ClearedTransactionBusinessMetricTopMerchantCategory =
  BusinessMetricSortAttribute & {
    __typename?: "ClearedTransactionBusinessMetricTopMerchantCategory";
    /** Sort by Ascending or Descending, Descending as default. */
    sortedDirection?: Maybe<BusinessMetricAttributeSortedDirection>;
    /** Top merchant category. */
    topMerchantCategoryAttributes?: Maybe<
      Array<ClearedTransactionMerchantCategoryBusinessMetricAttribute>
    >;
  };

/** Describes cleared transaction merchant metrics. */
export type ClearedTransactionBusinessMetricTopMerchantName =
  BusinessMetricSortAttribute & {
    __typename?: "ClearedTransactionBusinessMetricTopMerchantName";
    /** Sort by Ascending or Descending, Descending as default. */
    sortedDirection?: Maybe<BusinessMetricAttributeSortedDirection>;
    /** Top merchant name. */
    topMerchantNameAttributes?: Maybe<
      Array<ClearedTransactionMerchantNameBusinessMetricAttribute>
    >;
  };

/** Describes attributes of a cleared transaction merchant Category metric. */
export type ClearedTransactionMerchantCategoryBusinessMetricAttribute = {
  __typename?: "ClearedTransactionMerchantCategoryBusinessMetricAttribute";
  /** The total amount of cleared transactions for the merchant category. */
  amount?: Maybe<Amount>;
  /** The total number of cleared transactions for the merchant category. */
  count?: Maybe<Scalars["UnsignedInt"]>;
  /** Merchant category. */
  merchantCategory?: Maybe<MerchantCategory>;
};

/** Describes attributes of a cleared transaction merchant name metric. */
export type ClearedTransactionMerchantNameBusinessMetricAttribute = {
  __typename?: "ClearedTransactionMerchantNameBusinessMetricAttribute";
  /** The total amount of cleared transactions for the merchant. */
  amount?: Maybe<Amount>;
  /** The total number of cleared transactions for the merchant. */
  count?: Maybe<Scalars["UnsignedInt"]>;
  /** Merchant name. */
  merchantName?: Maybe<Scalars["String"]>;
};

/** A Clearing event for a transaction. */
export type ClearingEvent = Node &
  TransactionEvent & {
    __typename?: "ClearingEvent";
    /**
     * The direction funds are moving in the perspective of the cardholder.
     *
     * * when DEBIT, funds are moving out of the cardholder's account
     * * when CREDIT, funds are moving into the cardholder's account
     */
    accountingDirection?: Maybe<AccountingDirection>;
    /** Network specific transaction data. */
    additionalNetworkData?: Maybe<AdditionalNetworkData>;
    /** Level 2 / Level 3 transaction data for this transaction */
    additionalTransactionData?: Maybe<Array<AdditionalTransactionData>>;
    /** Determines whether this event is an advice. */
    advice?: Maybe<Scalars["Boolean"]>;
    /** Details if event is an advice. */
    adviceDetail?: Maybe<AdviceDetail>;
    /** The `Amount` approved for this `ClearingEvent` and posted in the settlement currency. Does not include fees. */
    approvedAmount?: Maybe<Amount>;
    /** The `CardProduct` associated to this `ClearingEvent`. */
    cardProduct?: Maybe<CardProduct>;
    /** The `Amount` of cashback requested. */
    cashbackAmount?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, this `ClearingEvent` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /**
     * Conversion rate applied to the requestedAmount to get the requestedAmountInSettlementCurrency for this `ClearingEvent`.
     *
     * Can be up to 7 decimal places, e.g. 1.2345678.
     */
    currencyConversionRate?: Maybe<Scalars["Float"]>;
    /** The `Amount` available to spend after this transaction event. */
    currentFinancialAccountAvailableToSpendAmount?: Maybe<Amount>;
    /** Maximum balance allowed for the card account at the time of this transaction event */
    currentFinancialAccountMaximumBalanceAmount?: Maybe<Amount>;
    /** Disputes on this `ClearingEvent`. */
    disputes?: Maybe<Array<PaymentCardTransactionDispute>>;
    /** Fees applied to the transaction, if any. */
    fees?: Maybe<Array<TransactionFee>>;
    /** The ID of the transaction event. This `id` can be used to later retrieve details of this `ClearingEvent` or correlate it with other events on this `Transaction`. */
    id: Scalars["ID"];
    /** The details about the merchant who requested the clear. */
    merchantDetails?: Maybe<MerchantDetails>;
    /**
     * The response code from the card network (e.g. Mastercard).
     * @deprecated Use responseCode instead
     */
    networkResponseCode?: Maybe<Scalars["String"]>;
    /**
     * The transaction ID from the card network (e.g. Mastercard).
     * @deprecated No longer supported
     */
    networkTransactionId?: Maybe<Scalars["ID"]>;
    /** The original `Amount` of the `AuthorizationEvent` related to this `ClearingEvent`. */
    originalAmount?: Maybe<Amount>;
    /** Determines whether this is a partial or full clear for an authorization. */
    partial?: Maybe<Scalars["Boolean"]>;
    /** The `PaymentCard` associated to this `ClearingEvent`. */
    paymentCard?: Maybe<PaymentCard>;
    /** A snapshot of the `PaymentCard` at the time of the `ClearingEvent`. */
    paymentCardSnapshot?: Maybe<PaymentCardSnapshot>;
    /** The Point Of Service Details. */
    pointOfServiceDetails?: Maybe<PointOfServiceDetails>;
    /** The `Amount` requested to be approved for this `ClearingEvent` and displayed in the transaction's (local) currency. Does not include fees. */
    requestedAmount?: Maybe<Amount>;
    /** The `Amount` requested to be approved for this `ClearingEvent` converted to the settlement currency. */
    requestedAmountInSettlementCurrency?: Maybe<Amount>;
    /** The Highnote response code. */
    responseCode?: Maybe<TransactionEventResponseCode>;
    /** The `Transaction` for this event. */
    transaction?: Maybe<Transaction>;
    /**
     * ID of the transaction
     * @deprecated Use transaction instead
     */
    transactionId?: Maybe<Scalars["ID"]>;
    /** Represents the customer transaction type being processed. */
    transactionProcessingType?: Maybe<CardTransactionProcessingType>;
  };

/** A token for use in a client-side integration. */
export type ClientToken = {
  __typename?: "ClientToken";
  /**
   * The expiration date for the token in ISO 8601 format.
   *
   * Tokens expire after 15 minutes.
   */
  expirationDate?: Maybe<Scalars["String"]>;
  /** Describes how the client token can be used */
  usage?: Maybe<ClientTokenUsage>;
  /** The value to send as an Authorization Bearer header or to provide to the SDK. */
  value: Scalars["String"];
};

/** Options for how the client token can be used */
export enum ClientTokenUsage {
  /**
   * The client token can only be used once. Once used, the client token is no longer valid.
   *
   * **Note:**
   *
   * In the event of a failure to process the request, the client token will be invalidated.
   */
  SINGLE_USE = "SINGLE_USE",
  /** The client token can be repeatedly used until its expiration date. */
  UNTIL_EXPIRATION = "UNTIL_EXPIRATION",
}

/** The details to close the external financial bank account for account holder. */
export type CloseExternalFinancialBankAccountInput = {
  /** The Global ID of the external financial bank account to be closed. */
  externalFinancialBankAccountId: Scalars["ID"];
};

/**
 * The external financial bank account closed while removing bank account for account holder.
 *
 * The bank account details like routing number, last four and account type will be returned
 * as response to closeExternalFinancialBankAccount mutation.
 *
 * Once the external financial bank account is closed, querying will not return bank account details.
 */
export type CloseExternalFinancialBankAccountPayload =
  | AccessDeniedError
  | ExternalFinancialBankAccount
  | UserError;

/** The details of the Payment Card to close. */
export type ClosePaymentCardInput = {
  /** The ID of the Payment Card to close. */
  paymentCardId: Scalars["ID"];
};

/** The return types when closing a Payment Card. */
export type ClosePaymentCardPayload =
  | AccessDeniedError
  | PaymentCard
  | UserError;

/** Whether or not the `CardProduct` supports collaborative app underwriting. */
export type CollaborativeApplicationUnderwritingCardProductFeature =
  CardProductFeature &
    ProductFeature & {
      __typename?: "CollaborativeApplicationUnderwritingCardProductFeature";
      /** The date and time, in ISO 8601 format, the feature was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** The date and time, in ISO 8601 format, the feature was effective from. */
      effectiveFrom?: Maybe<Scalars["String"]>;
      /** The date and time, in ISO 8601 format, the feature was effective through. */
      effectiveThrough?: Maybe<Scalars["String"]>;
      /** Whether or not the feature is enabled for the `CardProduct`. */
      enabled?: Maybe<Scalars["Boolean"]>;
      /** The date and time, in ISO 8601 format, the feature was last updated. */
      updatedAt?: Maybe<Scalars["String"]>;
    };

/** Whether or not the `CardProduct` supports collaborative authorization. */
export type CollaborativeAuthorizationCardProductFeature = CardProductFeature &
  ProductFeature & {
    __typename?: "CollaborativeAuthorizationCardProductFeature";
    /** The date and time, in ISO 8601 format, the feature was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective from. */
    effectiveFrom?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective through. */
    effectiveThrough?: Maybe<Scalars["String"]>;
    /** Whether or not the feature is enabled for the `CardProduct`. */
    enabled?: Maybe<Scalars["Boolean"]>;
    /** Indicates usage of card product's default settings to determine authorization decision when a `CollaborativeAuthorizationEndpoint` fails to respond. */
    issuerStandInEnabled?: Maybe<Scalars["Boolean"]>;
    /** The date and time, in ISO 8601 format, the feature was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Details regarding your responses and settings for collaborative authorization on a transaction */
export type CollaborativeAuthorizationDetails = {
  __typename?: "CollaborativeAuthorizationDetails";
  /** The `Amount` you authorized for the transaction. Value will be ZERO if you responded with an invalid amount or did not provide an amount. */
  authorizedAmount?: Maybe<Amount>;
  /** The state of the product's stand-in value at the time this event was processed, which determines whether transactions are approved or declined in the case of a timeout in the collaborative authorization flow. */
  currentProductStandIn?: Maybe<CollaborativeAuthorizationStandIn>;
  /**
   * Response code returned by you in collaborative authorization flow. This Response code is set to TIMEOUT if the platform does not receive a response within the allotted time.
   * If an error occurred while receiving your response, the response code will be set to ERROR
   */
  responseCode?: Maybe<CollaborativeAuthorizationResponseCode>;
};

/** A collaborative authorization endpoint. */
export type CollaborativeAuthorizationEndpoint = Node & {
  __typename?: "CollaborativeAuthorizationEndpoint";
  /** The date and time, in ISO 8601 format, the `CollaborativeAuthorizationEndpoint` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the `CollaborativeAuthorizationEndpoint` in operations. */
  id: Scalars["ID"];
  /** The name of the `CollaborativeAuthorizationEndpoint`. */
  name?: Maybe<Scalars["String"]>;
  /** The signing keys used for this `CollaborativeAuthorizationEndpoint`. */
  signingKeys?: Maybe<Array<SigningKey>>;
  /** The status of the `CollaborativeAuthorizationEndpoint`. */
  status: CollaborativeAuthorizationEndpointStatus;
  /** The date and time, in ISO 8601 format, the `CollaborativeAuthorizationEndpoint` was most recently updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** The URI to send collaborative authorization requests. */
  uri?: Maybe<Scalars["String"]>;
};

/** The connection type for `CollaborativeAuthorizationEndpoints`. */
export type CollaborativeAuthorizationEndpointConnection = {
  __typename?: "CollaborativeAuthorizationEndpointConnection";
  /** A list of edges. */
  edges?: Maybe<Array<CollaborativeAuthorizationEndpointEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for `CollaborativeAuthorizationEndpoints`. */
export type CollaborativeAuthorizationEndpointEdge = {
  __typename?: "CollaborativeAuthorizationEndpointEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The `CollaborativeAuthorizationEndpoint`. */
  node?: Maybe<CollaborativeAuthorizationEndpoint>;
};

/** The status of a `CollaborativeAuthorizationEndpoint`. */
export enum CollaborativeAuthorizationEndpointStatus {
  /** The `CollaborativeAuthorizationEndpoint` was unable to be verified. */
  ACTIVATION_FAILED = "ACTIVATION_FAILED",
  /** The `CollaborativeAuthorizationEndpoint` has been verified and events are being delivered. */
  ACTIVE = "ACTIVE",
  /** The `CollaborativeAuthorizationEndpoint` has been manually deactivated or Highnote has detected an error delivering events. */
  DEACTIVATED = "DEACTIVATED",
  /** The `CollaborativeAuthorizationEndpoint` has not yet been verified. Events will not be delivered. */
  PENDING_VERIFICATION = "PENDING_VERIFICATION",
}

/** The possible values for a transaction Authorization Response in the Collaborative Authorization flow. */
export enum CollaborativeAuthorizationResponseCode {
  /** `Transaction` approved */
  APPROVED = "APPROVED",
  /** `Transaction` declined due to special condition - new card not activated or card is temporarily blocked */
  BLOCKED_CARD = "BLOCKED_CARD",
  /** `Transaction` declined because Card Not Present transactions such as eCommerce are not permitted as a fraud prevention measure */
  CARD_NOT_PRESENT_AT_POS = "CARD_NOT_PRESENT_AT_POS",
  /** `Transaction` declined because the transaction exceeded the cashback limit */
  CASHBACK_LIMIT_EXCEEDED = "CASHBACK_LIMIT_EXCEEDED",
  /**
   * `Transaction` declined
   * @deprecated Deprecated in favor of more granular response codes
   */
  DECLINED = "DECLINED",
  /** `Transaction` declined because it was a duplicate of a previous transaction */
  DUPLICATE_TRANSACTION = "DUPLICATE_TRANSACTION",
  /**
   * Collaborative Authorization response resulted in an error
   *
   * **Note:** This response code is not meant to be returned by the Collaborative Authorization Partner. It is used by Highnote to indicate an `Error` occurred during Collaborative Authorization
   */
  ERROR = "ERROR",
  /** `Transaction` declined because the transaction exceeded the frequency limit */
  EXCEEDS_FREQUENCY = "EXCEEDS_FREQUENCY",
  /** `Transaction` declined because the amount exceeded the transaction limit */
  EXCEEDS_LIMIT = "EXCEEDS_LIMIT",
  /** `Transaction` declined due to insufficient funds */
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  /** `Transaction` declined because the cardholder is not a recognized driver */
  INVALID_DRIVER = "INVALID_DRIVER",
  /** `Transaction` declined because the cardholder did not provide a recognized ID number */
  INVALID_ID = "INVALID_ID",
  /** `Transaction` declined because the cardholder attempted a transaction outside of their defined working area */
  INVALID_LOCATION = "INVALID_LOCATION",
  /** `Transaction` declined because transaction will not be allowed at this merchant. Use this code for merchants that will never be allowed. */
  INVALID_MERCHANT = "INVALID_MERCHANT",
  /** `Transaction` declined because transaction will not be allowed at this `MerchantCategory`. Use this code for categories that will never be allowed. */
  INVALID_MERCHANT_CATEGORY_CODE = "INVALID_MERCHANT_CATEGORY_CODE",
  /** `Transaction` declined because it occurred outside allowed hours */
  INVALID_PURCHASE_TIME = "INVALID_PURCHASE_TIME",
  /** `Transaction` declined because it failed a partner defined special condition */
  INVALID_TRANSACTION = "INVALID_TRANSACTION",
  /** `Transaction` declined because the cardholder did not provide a recognized vehicle number */
  INVALID_VEHICLE = "INVALID_VEHICLE",
  /** `Transaction` declined because manually entering card details is not permitted as a fraud prevention measure */
  MANUAL_KEY_ENTERED_AT_POS = "MANUAL_KEY_ENTERED_AT_POS",
  /** `Transaction` approved for partial amount */
  PARTIAL_AMOUNT_APPROVED = "PARTIAL_AMOUNT_APPROVED",
  /** `Transaction` declined because the merchant appears to be the cardholder */
  PROHIBITED_SELFPAY = "PROHIBITED_SELFPAY",
  /**
   * `Transaction` declined because card was used in a restricted region or country
   * @deprecated Deprecated in favor of `RESTRICTED_LOCATION`
   */
  RESTRICTED_CARD = "RESTRICTED_CARD",
  /** `Transaction` declined because the use of the card is restricted in the region or country where the transaction occurs */
  RESTRICTED_LOCATION = "RESTRICTED_LOCATION",
  /** `Transaction` declined because transactions are currently blocked for the merchant. */
  RESTRICTED_MERCHANT = "RESTRICTED_MERCHANT",
  /** `Transaction` declined because transactions are currently blocked for the merchant category code. */
  RESTRICTED_MERCHANT_CATEGORY_CODE = "RESTRICTED_MERCHANT_CATEGORY_CODE",
  /** `Transaction` declined due to suspected fraudulent activity */
  SUSPECTED_FRAUD = "SUSPECTED_FRAUD",
  /**
   * System did not receive Collaborative Authorization response within the allotted time
   *
   * **Note:** This response code is not meant to be returned by the Collaborative Authorization Partner. It is used by Highnote to indicate a `Timeout` occurred during Collaborative Authorization
   */
  TIMEOUT = "TIMEOUT",
}

/** Determines whether transactions are approved or declined in the case of a timeout during collaborative authorization. */
export enum CollaborativeAuthorizationStandIn {
  /** Transactions should be approved if Subcriber does not respond to collaborative authorization request. */
  APPROVE = "APPROVE",
  /** Transactions should be declined if the Subscriber does not respond to collaborative authorization request. */
  DECLINE = "DECLINE",
}

/** Statement for commercial charge card accounts */
export type CommercialChargeCardFinancialAccountStatement =
  FinancialAccountStatement &
    Node & {
      __typename?: "CommercialChargeCardFinancialAccountStatement";
      /** The interest and fees that an account has accumulated as it relates to a `FinancialAccountStatement`. */
      accumulatedAccountInterestAndFees?: Maybe<AccumulatedAccountInterestAndFees>;
      /** The timestamp, in ISO 8601 format, the statement was closed. */
      closedAt?: Maybe<Scalars["String"]>;
      /** The date and time, in ISO 8601 format, this was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** The credit limit at the end of the period. */
      endingCreditLimit?: Maybe<Amount>;
      /** The credit balance at the end of the period for the primary ledger. */
      endingPrimaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the end of the period for the primary ledger. */
      endingPrimaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the end of the period for the secondary ledger. */
      endingSecondaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the end of the period for the secondary ledger. */
      endingSecondaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the end of the period for the tertiary ledger. */
      endingTertiaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the end of the period for the tertiary ledger. */
      endingTertiaryDebitBalance?: Maybe<Amount>;
      /** The unique id of the `FinancialAccountStatement`. */
      id: Scalars["ID"];
      /** The timestamp, in ISO 8601 format, the statement was opened. */
      openedAt?: Maybe<Scalars["String"]>;
      /** The past due balance on the Financial Account as of the close of the statement’s billing cycle. */
      pastDueAmount?: Maybe<Amount>;
      /** The date, in ISO 8601 format, payment is due on end of day. */
      paymentDueOn?: Maybe<Scalars["String"]>;
      /** The date, in ISO 8601 format, the statement period ends. */
      periodEnd?: Maybe<Scalars["String"]>;
      /** The total fee credit (for example due to waiving fees) for the statement period. */
      periodFeeCredit?: Maybe<Amount>;
      /** The total from fees for the statement period. */
      periodFeesAmount?: Maybe<Amount>;
      /** The total from purchases for the statement period. */
      periodPurchasesAmount?: Maybe<Amount>;
      /** The total refunds and payments for the statement period. */
      periodRefundsAndPaymentsAmount?: Maybe<Amount>;
      /** The date, in ISO 8601 format, the statement period starts. */
      periodStart?: Maybe<Scalars["String"]>;
      /** The ledger associated with the primary balance */
      primaryLedger?: Maybe<Ledger>;
      /** History of repayments per statement */
      repaymentHistory?: Maybe<Array<CreditRepaymentStatementApplication>>;
      /** The ledger associated with the primary balance */
      secondaryLedger?: Maybe<Ledger>;
      /** The credit balance at the start of the period for the primary ledger. */
      startingPrimaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the start of the period for the primary ledger. */
      startingPrimaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the start of the period for the secondary ledger. */
      startingSecondaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the start of the period for the secondary ledger. */
      startingSecondaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the start of the period for the tertiary ledger. */
      startingTertiaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the start of the period for the tertiary ledger. */
      startingTertiaryDebitBalance?: Maybe<Amount>;
      /**
       * statement entries.
       *
       * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
       */
      statementEntries?: Maybe<FinancialAccountStatementEntryConnection>;
      /** The ledger associated with the tertiary balance */
      tertiaryLedger?: Maybe<Ledger>;
      /** The date and time, in ISO 8601 format, this was most recently updated. */
      updatedAt?: Maybe<Scalars["String"]>;
    };

/** Statement for commercial charge card accounts */
export type CommercialChargeCardFinancialAccountStatementStatementEntriesArgs =
  {
    after?: InputMaybe<Scalars["String"]>;
    filterBy?: InputMaybe<FinancialAccountStatementEntriesFilterInput>;
    first?: InputMaybe<Scalars["Int"]>;
  };

/** Statement entry for Commercial Charge */
export type CommercialChargeCardFinancialAccountStatementEntry =
  FinancialAccountStatementEntry & {
    __typename?: "CommercialChargeCardFinancialAccountStatementEntry";
    /** The date and time, in ISO 8601 format, this was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Credit amount of the transaction. */
    creditAmount?: Maybe<Amount>;
    /** Debit amount of the transaction. */
    debitAmount?: Maybe<Amount>;
    /** Ledger Entry for the entry */
    ledgerEntry?: Maybe<LedgerEntry>;
    /** The date, in ISO 8601 format, the transaction was posted. (Different word for 'posted'?) */
    postDate?: Maybe<Scalars["String"]>;
    /** Credit balance of the account. */
    primaryCreditBalance?: Maybe<Amount>;
    /** Debit balance of the account. */
    primaryDebitBalance?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, this was most recently updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Current account snapshot for a commercial charge card */
export type CommercialChargeCardFinancialAccountStatementSnapshot =
  FinancialAccountStatementSnapshot & {
    __typename?: "CommercialChargeCardFinancialAccountStatementSnapshot";
    /**
     * The date and time, in ISO 8601 format, the snapshot was calculated.
     * Note that this will be the date/time of the last impactful event.
     */
    asOf?: Maybe<Scalars["String"]>;
    /** The ending balance from the `latestClosedStatement`, minus any payments that have been cleared and processed. */
    currentAmountDue?: Maybe<Amount>;
    /** The current open statement */
    currentOpenStatement?: Maybe<FinancialAccountStatement>;
    /** The most recently closed statement */
    latestClosedStatement?: Maybe<FinancialAccountStatement>;
    /** The date and time, in ISO 8601 format, this was most recently updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Whether or not the Financial Account supports a Commercial Credit Pay In Full Card. */
export type CommercialCreditPayInFullCardAccountFeature =
  FinancialAccountFeature & {
    __typename?: "CommercialCreditPayInFullCardAccountFeature";
    /** The date and time, in ISO 8601 format, the feature was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The credit limit on the `CommercialCreditPayInFullCardAccountFeature` */
    creditLimit?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, the feature was effective from. */
    effectiveFrom?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective through. */
    effectiveThrough?: Maybe<Scalars["String"]>;
    /** Whether or not the feature is enabled for the Financial Account. */
    enabled?: Maybe<Scalars["Boolean"]>;
    /** The date and time, in ISO 8601 format, the feature was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Statement for commercial revolving card accounts */
export type CommercialRevolvingCardFinancialAccountStatement =
  FinancialAccountStatement &
    Node & {
      __typename?: "CommercialRevolvingCardFinancialAccountStatement";
      /** The interest and fees that an account has accumulated as it relates to a `FinancialAccountStatement`. */
      accumulatedAccountInterestAndFees?: Maybe<AccumulatedAccountInterestAndFees>;
      /** The timestamp, in ISO 8601 format, the statement was closed. */
      closedAt?: Maybe<Scalars["String"]>;
      /** The date and time, in ISO 8601 format, this was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** The credit limit at the end of the period. */
      endingCreditLimit?: Maybe<Amount>;
      /** The credit balance at the end of the period for the primary ledger. */
      endingPrimaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the end of the period for the primary ledger. */
      endingPrimaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the end of the period for the secondary ledger. */
      endingSecondaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the end of the period for the secondary ledger. */
      endingSecondaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the end of the period for the tertiary ledger. */
      endingTertiaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the end of the period for the tertiary ledger. */
      endingTertiaryDebitBalance?: Maybe<Amount>;
      /** The unique id of the `FinancialAccountStatement`. */
      id: Scalars["ID"];
      /** The timestamp, in ISO 8601 format, the statement was opened. */
      openedAt?: Maybe<Scalars["String"]>;
      /** The past due balance on the Financial Account as of the close of the statement’s billing cycle. */
      pastDueAmount?: Maybe<Amount>;
      /** Payoff warning for the statement when balance is greater than zero */
      payOffWarning?: Maybe<FinancialAccountStatementPayOffWarning>;
      /** The date, in ISO 8601 format, payment is due on end of day. */
      paymentDueOn?: Maybe<Scalars["String"]>;
      /** The date, in ISO 8601 format, the statement period ends. */
      periodEnd?: Maybe<Scalars["String"]>;
      /** The total fee credit (for example due to waiving fees) for the statement period. */
      periodFeeCredit?: Maybe<Amount>;
      /** The total from fees for the statement period. */
      periodFeesAmount?: Maybe<Amount>;
      /** `InstallmentAgreement` activity for this statement. */
      periodInstallmentActivity?: Maybe<
        Array<FinancialAccountStatementInstallmentCreditPlanActivity>
      >;
      /** The total from interest for the statement period. */
      periodInterestCharges?: Maybe<Amount>;
      /** The total interest credit (for example due to waiving interest) for the statement period. */
      periodInterestCredit?: Maybe<Amount>;
      /** Period's minimum payment due to the statement */
      periodMinimumPaymentDue?: Maybe<Amount>;
      /** Period's purchase details by Credit Plan for the statement */
      periodPurchaseCreditPlan?: Maybe<
        Array<FinancialAccountStatementPurchaseCreditPlan>
      >;
      /** The total from purchases for the statement period. */
      periodPurchasesAmount?: Maybe<Amount>;
      /** The total refunds and payments for the statement period. */
      periodRefundsAndPaymentsAmount?: Maybe<Amount>;
      /** The date, in ISO 8601 format, the statement period starts. */
      periodStart?: Maybe<Scalars["String"]>;
      /** The ledger associated with the primary balance */
      primaryLedger?: Maybe<Ledger>;
      /** History of repayments per statement */
      repaymentHistory?: Maybe<Array<CreditRepaymentStatementApplication>>;
      /** The ledger associated with the primary balance */
      secondaryLedger?: Maybe<Ledger>;
      /** The credit balance at the start of the period for the primary ledger. */
      startingPrimaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the start of the period for the primary ledger. */
      startingPrimaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the start of the period for the secondary ledger. */
      startingSecondaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the start of the period for the secondary ledger. */
      startingSecondaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the start of the period for the tertiary ledger. */
      startingTertiaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the start of the period for the tertiary ledger. */
      startingTertiaryDebitBalance?: Maybe<Amount>;
      /**
       * statement entries.
       *
       * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
       */
      statementEntries?: Maybe<FinancialAccountStatementEntryConnection>;
      /** The ledger associated with the tertiary balance */
      tertiaryLedger?: Maybe<Ledger>;
      /** The date and time, in ISO 8601 format, this was most recently updated. */
      updatedAt?: Maybe<Scalars["String"]>;
    };

/** Statement for commercial revolving card accounts */
export type CommercialRevolvingCardFinancialAccountStatementStatementEntriesArgs =
  {
    after?: InputMaybe<Scalars["String"]>;
    filterBy?: InputMaybe<FinancialAccountStatementEntriesFilterInput>;
    first?: InputMaybe<Scalars["Int"]>;
  };

/** Statement entry for Commercial Revolving */
export type CommercialRevolvingCardFinancialAccountStatementEntry =
  FinancialAccountStatementEntry & {
    __typename?: "CommercialRevolvingCardFinancialAccountStatementEntry";
    /** The date and time, in ISO 8601 format, this was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Credit amount of the transaction. */
    creditAmount?: Maybe<Amount>;
    /** Debit amount of the transaction. */
    debitAmount?: Maybe<Amount>;
    /** Ledger Entry for the entry */
    ledgerEntry?: Maybe<LedgerEntry>;
    /** The date, in ISO 8601 format, the transaction was posted. (Different word for 'posted'?) */
    postDate?: Maybe<Scalars["String"]>;
    /** Credit balance of the account. */
    primaryCreditBalance?: Maybe<Amount>;
    /** Debit balance of the account. */
    primaryDebitBalance?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, this was most recently updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Current account snapshot for a commercial revolving card */
export type CommercialRevolvingCardFinancialAccountStatementSnapshot =
  FinancialAccountStatementSnapshot & {
    __typename?: "CommercialRevolvingCardFinancialAccountStatementSnapshot";
    /**
     * The date and time, in ISO 8601 format, the snapshot was calculated.
     * Note that this will be the date/time of the last impactful event.
     */
    asOf?: Maybe<Scalars["String"]>;
    /** The ending balance from the `latestClosedStatement`, minus any payments that have been cleared and processed. */
    currentAmountDue?: Maybe<Amount>;
    /** The current open statement */
    currentOpenStatement?: Maybe<FinancialAccountStatement>;
    /** The most recently closed statement */
    latestClosedStatement?: Maybe<FinancialAccountStatement>;
    /** The date and time, in ISO 8601 format, this was most recently updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Input fields for completing a physical card group order. */
export type CompletePhysicalCardGroupOrderInput = {
  /** Id of the group order. */
  groupOrderId: Scalars["ID"];
};

/** Available regions to persist data. */
export enum ComputeRegion {
  ASIA = "ASIA",
  EUROPE = "EUROPE",
  USA = "USA",
}

/** All possible conditional rules to be used with a `VelocityInterFinancialAccountTransferRule` */
export type ConditionalInterFinancialAccountTransferRule =
  TransferPurposeInterFinancialAccountTransferRule;

/**
 * A rule that combines multiple other spend rule results together in an all or none approach.
 * Must be used as a cumulativeRule for a `VelocityRule` with a `PER_TRANSACTION` window.
 * The resulting `VelocityRule` will have a passing result if all spendRules on the
 * `VelocityRule` pass or if all spendRules on the `VelocityRule` fail.
 */
export type ConditionalRuleSetSpendRule = Node &
  SpendRule & {
    __typename?: "ConditionalRuleSetSpendRule";
    /** The action to apply to the transaction event, if the rule passes */
    allow?: Maybe<Scalars["Boolean"]>;
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the rule in operations. */
    id: Scalars["ID"];
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/**
 * A rule that combines multiple other spend rule results together in an all or none approach.
 * Must be used as a cumulativeRule for a `VelocityRule` with a `PER_TRANSACTION` window.
 * The resulting `VelocityRule` will have a passing result if all spendRules on the
 * `VelocityRule` pass or if all spendRules on the `VelocityRule` fail.
 */
export type ConditionalRuleSetSpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The input for confirming a credit freeze is lifted for a credit-based `AccountHolderCardProductApplication`. */
export type ConfirmCreditReportUnfrozenInput = {
  /** Global identifier of the application in question. */
  applicationId: Scalars["ID"];
  /** Optionally, subscribers may track details about this application using this field. Maximum length of 2048 characters. */
  subscriberNote?: InputMaybe<Scalars["String"]>;
};

/** The response type for confirming a credit freeze is lifted for a credit-product `AccountHolderCardProductApplication`. */
export type ConfirmCreditReportUnfrozenPayload =
  | AccessDeniedError
  | AccountHolderCardProductApplication
  | UserError;

/** The details to confirm a payroll deposit. */
export type ConfirmPayrollDepositInput = {
  /**
   * The employer financial account. This value is required if `isPayrollDeposit`
   * is true.
   *
   * This must be a `FinancialAccount` ID.
   */
  employerFinancialAccountId?: InputMaybe<Scalars["ID"]>;
  /**
   * The ACH Credit transfer that will be marked as a Payroll Deposit.
   *
   * This must be a `ElectronicFundsTransfer` ID.
   */
  id: Scalars["ID"];
  /**
   * If true, the transfer will be considered a PayrollTransfer, if not,
   * it will always remain a CreditFunds transfer. If this flag is omitted
   * then the default value will be true and the transfer will be marked as
   * a PayrollTransfer.
   */
  isPayrollDeposit?: InputMaybe<Scalars["Boolean"]>;
};

/** The return types when confirming a payroll deposit. */
export type ConfirmPayrollDepositPayload =
  | AccessDeniedError
  | CreditFunds
  | NonOriginatedAchTransfer
  | PayrollTransfer
  | SecureDeposit
  | UserError;

/** The input for confirming a `RequestedIdentityUpdate`. */
export type ConfirmRequestedIdentityUpdateInput = {
  /** The Global ID of the requested identity update. */
  id: Scalars["ID"];
};

/** The response type when confirming a `RequestedIdentityUpdate` */
export type ConfirmRequestedIdentityUpdatePayload =
  | AccessDeniedError
  | RequestedIdentityUpdate
  | UserError;

/** The input for confirming the details of a credit-based `AccountHolderCardProductApplication` in the case of a fraud alert on the applicant's credit report. */
export type ConfirmVerificationOfCreditProductApplicationForFraudAlertInput = {
  /** Global identifier of the application in question. */
  applicationId: Scalars["ID"];
  /** An optional note related to this confirmation. */
  memo?: InputMaybe<Scalars["String"]>;
  /** The `AccountHolderCardProductApplication` fields that were confirmed. These must all be confirmed in order to move forward with this application. These fields will also be persisted to the `AccountHolderCardProductApplication` type under the `creditReportFraudAlertVerificationResult` field. */
  verificationResult?: InputMaybe<VerifiedApplicationFieldsForFraudAlertInput>;
};

/** The response type for verifying a credit-product `AccountHolderCardProductApplication` in the case of a fraud alert. */
export type ConfirmVerificationOfCreditProductApplicationForFraudAlertPayload =
  | AccessDeniedError
  | AccountHolderCardProductApplication
  | UserError;

/** Details on the acceptance of terms and conditions */
export type ConsentAgreement = {
  __typename?: "ConsentAgreement";
  /** The `IPAddress` of the `ConsentingParty` when they accepted the agreement. */
  consentIpAddress?: Maybe<IpAddress>;
  /**
   * The date and time, in ISO 8601 format, marking when the `ConsentingParty` accepted the agreement
   *
   * For example, `2022-01-01T22:00:00.000Z`.
   */
  consentTimestamp?: Maybe<Scalars["String"]>;
  /** This field represents the consenting party */
  primaryAuthorizedPerson?: Maybe<ConsentingParty>;
};

/** Details on the acceptance of terms and conditions of the card holder agreement. */
export type ConsentInput = {
  /** The `IPAddress` of the consenting party when they accepted the agreement. */
  consentIpAddress?: InputMaybe<IpAddressInput>;
  /**
   * The date and time, in ISO 8601 format, marking when the primary authorized person or person card holder accepted card holder agreement.
   *
   * For example, `2022-01-01T22:00:00.000Z`.
   */
  consentTimestamp: Scalars["String"];
  /** The ID of the primary authorized person of the business or the person card holder. For authorized user applications, the primaryAuthorizedPersonId is the authorized user id. */
  primaryAuthorizedPersonId: Scalars["ID"];
};

/** Represents a consenting party */
export type ConsentingParty =
  | UsBusinessAuthorizedPerson
  | UsPersonAccountHolder
  | UsPersonAuthorizedUser;

/** Statement for consumer charge card accounts */
export type ConsumerChargeCardFinancialAccountStatement =
  FinancialAccountStatement &
    Node & {
      __typename?: "ConsumerChargeCardFinancialAccountStatement";
      /** The interest and fees that an account has accumulated as it relates to a `FinancialAccountStatement`. */
      accumulatedAccountInterestAndFees?: Maybe<AccumulatedAccountInterestAndFees>;
      /** The timestamp, in ISO 8601 format, the statement was closed. */
      closedAt?: Maybe<Scalars["String"]>;
      /** The date and time, in ISO 8601 format, this was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** The credit limit at the end of the period. */
      endingCreditLimit?: Maybe<Amount>;
      /** The credit balance at the end of the period for the primary ledger. */
      endingPrimaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the end of the period for the primary ledger. */
      endingPrimaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the end of the period for the secondary ledger. */
      endingSecondaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the end of the period for the secondary ledger. */
      endingSecondaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the end of the period for the tertiary ledger. */
      endingTertiaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the end of the period for the tertiary ledger. */
      endingTertiaryDebitBalance?: Maybe<Amount>;
      /** The unique id of the `FinancialAccountStatement`. */
      id: Scalars["ID"];
      /** The timestamp, in ISO 8601 format, the statement was opened. */
      openedAt?: Maybe<Scalars["String"]>;
      /** The past due balance on the Financial Account as of the close of the statement’s billing cycle. */
      pastDueAmount?: Maybe<Amount>;
      /** The date, in ISO 8601 format, payment is due on end of day. */
      paymentDueOn?: Maybe<Scalars["String"]>;
      /** The date, in ISO 8601 format, the statement period ends. */
      periodEnd?: Maybe<Scalars["String"]>;
      /** The total fee credit (for example due to waiving fees) for the statement period. */
      periodFeeCredit?: Maybe<Amount>;
      /** The total from fees for the statement period. */
      periodFeesAmount?: Maybe<Amount>;
      /** The total from purchases for the statement period. */
      periodPurchasesAmount?: Maybe<Amount>;
      /** The total refunds and payments for the statement period. */
      periodRefundsAndPaymentsAmount?: Maybe<Amount>;
      /** The date, in ISO 8601 format, the statement period starts. */
      periodStart?: Maybe<Scalars["String"]>;
      /** The ledger associated with the primary balance */
      primaryLedger?: Maybe<Ledger>;
      /** History of repayments per statement */
      repaymentHistory?: Maybe<Array<CreditRepaymentStatementApplication>>;
      /** The ledger associated with the primary balance */
      secondaryLedger?: Maybe<Ledger>;
      /** The credit balance at the start of the period for the primary ledger. */
      startingPrimaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the start of the period for the primary ledger. */
      startingPrimaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the start of the period for the secondary ledger. */
      startingSecondaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the start of the period for the secondary ledger. */
      startingSecondaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the start of the period for the tertiary ledger. */
      startingTertiaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the start of the period for the tertiary ledger. */
      startingTertiaryDebitBalance?: Maybe<Amount>;
      /**
       * statement entries.
       *
       * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
       */
      statementEntries?: Maybe<FinancialAccountStatementEntryConnection>;
      /** The ledger associated with the tertiary balance */
      tertiaryLedger?: Maybe<Ledger>;
      /** The date and time, in ISO 8601 format, this was most recently updated. */
      updatedAt?: Maybe<Scalars["String"]>;
    };

/** Statement for consumer charge card accounts */
export type ConsumerChargeCardFinancialAccountStatementStatementEntriesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<FinancialAccountStatementEntriesFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Statement entry for consumer charge card */
export type ConsumerChargeCardFinancialAccountStatementEntry =
  FinancialAccountStatementEntry & {
    __typename?: "ConsumerChargeCardFinancialAccountStatementEntry";
    /** The date and time, in ISO 8601 format, this was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Credit amount of the transaction. */
    creditAmount?: Maybe<Amount>;
    /** Debit amount of the transaction. */
    debitAmount?: Maybe<Amount>;
    /** Ledger Entry for the entry */
    ledgerEntry?: Maybe<LedgerEntry>;
    /** The date, in ISO 8601 format, the transaction was posted. (Different word for 'posted'?) */
    postDate?: Maybe<Scalars["String"]>;
    /** Credit balance of the account. */
    primaryCreditBalance?: Maybe<Amount>;
    /** Debit balance of the account. */
    primaryDebitBalance?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, this was most recently updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Current account snapshot for a consumer charge card */
export type ConsumerChargeCardFinancialAccountStatementSnapshot =
  FinancialAccountStatementSnapshot & {
    __typename?: "ConsumerChargeCardFinancialAccountStatementSnapshot";
    /**
     * The date and time, in ISO 8601 format, the snapshot was calculated.
     * Note that this will be the date/time of the last impactful event.
     */
    asOf?: Maybe<Scalars["String"]>;
    /** The ending balance from the `latestClosedStatement`, minus any payments that have been cleared and processed. */
    currentAmountDue?: Maybe<Amount>;
    /** The current open statement */
    currentOpenStatement?: Maybe<FinancialAccountStatement>;
    /** The most recently closed statement */
    latestClosedStatement?: Maybe<FinancialAccountStatement>;
    /** The date and time, in ISO 8601 format, this was most recently updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Statement for consumer prepaid card accounts */
export type ConsumerPrepaidCardFinancialAccountStatement =
  FinancialAccountStatement &
    Node & {
      __typename?: "ConsumerPrepaidCardFinancialAccountStatement";
      /** The timestamp, in ISO 8601 format, the statement was closed. */
      closedAt?: Maybe<Scalars["String"]>;
      /** The date and time, in ISO 8601 format, this was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** The credit balance at the end of the period for the primary ledger. */
      endingPrimaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the end of the period for the primary ledger. */
      endingPrimaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the end of the period for the secondary ledger. */
      endingSecondaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the end of the period for the secondary ledger. */
      endingSecondaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the end of the period for the tertiary ledger. */
      endingTertiaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the end of the period for the tertiary ledger. */
      endingTertiaryDebitBalance?: Maybe<Amount>;
      /** The unique id of the `FinancialAccountStatement`. */
      id: Scalars["ID"];
      /** The timestamp, in ISO 8601 format, the statement was opened. */
      openedAt?: Maybe<Scalars["String"]>;
      /** The date, in ISO 8601 format, the statement period ends. */
      periodEnd?: Maybe<Scalars["String"]>;
      /** The total fee credit (for example due to waiving fees) for the statement period. */
      periodFeeCredit?: Maybe<Amount>;
      /** The total from fees for the statement period. */
      periodFeesAmount?: Maybe<Amount>;
      /** The total from purchases for the statement period. */
      periodPurchasesAmount?: Maybe<Amount>;
      /** The total refunds and payments for the statement period. */
      periodRefundsAndPaymentsAmount?: Maybe<Amount>;
      /** The date, in ISO 8601 format, the statement period starts. */
      periodStart?: Maybe<Scalars["String"]>;
      /** The ledger associated with the primary balance */
      primaryLedger?: Maybe<Ledger>;
      /** The ledger associated with the primary balance */
      secondaryLedger?: Maybe<Ledger>;
      /** The credit balance at the start of the period for the primary ledger. */
      startingPrimaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the start of the period for the primary ledger. */
      startingPrimaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the start of the period for the secondary ledger. */
      startingSecondaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the start of the period for the secondary ledger. */
      startingSecondaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the start of the period for the tertiary ledger. */
      startingTertiaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the start of the period for the tertiary ledger. */
      startingTertiaryDebitBalance?: Maybe<Amount>;
      /**
       * statement entries.
       *
       * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
       */
      statementEntries?: Maybe<FinancialAccountStatementEntryConnection>;
      /** The ledger associated with the tertiary balance */
      tertiaryLedger?: Maybe<Ledger>;
      /** The date and time, in ISO 8601 format, this was most recently updated. */
      updatedAt?: Maybe<Scalars["String"]>;
    };

/** Statement for consumer prepaid card accounts */
export type ConsumerPrepaidCardFinancialAccountStatementStatementEntriesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<FinancialAccountStatementEntriesFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Statement entry for consumer prepaid card */
export type ConsumerPrepaidCardFinancialAccountStatementEntry =
  FinancialAccountStatementEntry & {
    __typename?: "ConsumerPrepaidCardFinancialAccountStatementEntry";
    /** The date and time, in ISO 8601 format, this was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Credit amount of the transaction. */
    creditAmount?: Maybe<Amount>;
    /** Debit amount of the transaction. */
    debitAmount?: Maybe<Amount>;
    /** Ledger Entry for the entry */
    ledgerEntry?: Maybe<LedgerEntry>;
    /** The date, in ISO 8601 format, the transaction was posted. (Different word for 'posted'?) */
    postDate?: Maybe<Scalars["String"]>;
    /** Credit balance of the account. */
    primaryCreditBalance?: Maybe<Amount>;
    /** Debit balance of the account. */
    primaryDebitBalance?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, this was most recently updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Current account snapshot for a consumer prepaid card */
export type ConsumerPrepaidCardFinancialAccountStatementSnapshot =
  FinancialAccountStatementSnapshot & {
    __typename?: "ConsumerPrepaidCardFinancialAccountStatementSnapshot";
    /**
     * The date and time, in ISO 8601 format, the snapshot was calculated.
     * Note that this will be the date/time of the last impactful event.
     */
    asOf?: Maybe<Scalars["String"]>;
    /** The current open statement */
    currentOpenStatement?: Maybe<FinancialAccountStatement>;
    /** The most recently closed statement */
    latestClosedStatement?: Maybe<FinancialAccountStatement>;
    /** The date and time, in ISO 8601 format, this was most recently updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Statement for consumer revolving card accounts */
export type ConsumerRevolvingCardFinancialAccountStatement =
  FinancialAccountStatement &
    Node & {
      __typename?: "ConsumerRevolvingCardFinancialAccountStatement";
      /** The interest and fees that an account has accumulated as it relates to a `FinancialAccountStatement`. */
      accumulatedAccountInterestAndFees?: Maybe<AccumulatedAccountInterestAndFees>;
      /** The timestamp, in ISO 8601 format, the statement was closed. */
      closedAt?: Maybe<Scalars["String"]>;
      /** The date and time, in ISO 8601 format, this was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** The credit limit at the end of the period. */
      endingCreditLimit?: Maybe<Amount>;
      /** The credit balance at the end of the period for the primary ledger. */
      endingPrimaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the end of the period for the primary ledger. */
      endingPrimaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the end of the period for the secondary ledger. */
      endingSecondaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the end of the period for the secondary ledger. */
      endingSecondaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the end of the period for the tertiary ledger. */
      endingTertiaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the end of the period for the tertiary ledger. */
      endingTertiaryDebitBalance?: Maybe<Amount>;
      /** The unique id of the `FinancialAccountStatement`. */
      id: Scalars["ID"];
      /** The timestamp, in ISO 8601 format, the statement was opened. */
      openedAt?: Maybe<Scalars["String"]>;
      /** The past due balance on the Financial Account as of the close of the statement’s billing cycle. */
      pastDueAmount?: Maybe<Amount>;
      /** Payoff warning for the statement when balance is greater than zero */
      payOffWarning?: Maybe<FinancialAccountStatementPayOffWarning>;
      /** The date, in ISO 8601 format, payment is due on end of day. */
      paymentDueOn?: Maybe<Scalars["String"]>;
      /** The date, in ISO 8601 format, the statement period ends. */
      periodEnd?: Maybe<Scalars["String"]>;
      /** The total fee credit (for example due to waiving fees) for the statement period. */
      periodFeeCredit?: Maybe<Amount>;
      /** The total from fees for the statement period. */
      periodFeesAmount?: Maybe<Amount>;
      /** `InstallmentAgreement` activity for this statement. */
      periodInstallmentActivity?: Maybe<
        Array<FinancialAccountStatementInstallmentCreditPlanActivity>
      >;
      /** The total from interest for the statement period. */
      periodInterestCharges?: Maybe<Amount>;
      /** The total interest credit (for example due to waiving interest) for the statement period. */
      periodInterestCredit?: Maybe<Amount>;
      /** Period's minimum payment due to the statement */
      periodMinimumPaymentDue?: Maybe<Amount>;
      /** Period's purchase details by Credit Plan for the statement */
      periodPurchaseCreditPlan?: Maybe<
        Array<FinancialAccountStatementPurchaseCreditPlan>
      >;
      /** The total from purchases for the statement period. */
      periodPurchasesAmount?: Maybe<Amount>;
      /** The total refunds and payments for the statement period. */
      periodRefundsAndPaymentsAmount?: Maybe<Amount>;
      /** The date, in ISO 8601 format, the statement period starts. */
      periodStart?: Maybe<Scalars["String"]>;
      /** The ledger associated with the primary balance */
      primaryLedger?: Maybe<Ledger>;
      /** History of repayments per statement */
      repaymentHistory?: Maybe<Array<CreditRepaymentStatementApplication>>;
      /** The ledger associated with the primary balance */
      secondaryLedger?: Maybe<Ledger>;
      /** The credit balance at the start of the period for the primary ledger. */
      startingPrimaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the start of the period for the primary ledger. */
      startingPrimaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the start of the period for the secondary ledger. */
      startingSecondaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the start of the period for the secondary ledger. */
      startingSecondaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the start of the period for the tertiary ledger. */
      startingTertiaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the start of the period for the tertiary ledger. */
      startingTertiaryDebitBalance?: Maybe<Amount>;
      /**
       * statement entries.
       *
       * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
       */
      statementEntries?: Maybe<FinancialAccountStatementEntryConnection>;
      /** The ledger associated with the tertiary balance */
      tertiaryLedger?: Maybe<Ledger>;
      /** The date and time, in ISO 8601 format, this was most recently updated. */
      updatedAt?: Maybe<Scalars["String"]>;
    };

/** Statement for consumer revolving card accounts */
export type ConsumerRevolvingCardFinancialAccountStatementStatementEntriesArgs =
  {
    after?: InputMaybe<Scalars["String"]>;
    filterBy?: InputMaybe<FinancialAccountStatementEntriesFilterInput>;
    first?: InputMaybe<Scalars["Int"]>;
  };

/** Statement entry for consumer revolving card */
export type ConsumerRevolvingCardFinancialAccountStatementEntry =
  FinancialAccountStatementEntry & {
    __typename?: "ConsumerRevolvingCardFinancialAccountStatementEntry";
    /** The date and time, in ISO 8601 format, this was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Credit amount of the transaction. */
    creditAmount?: Maybe<Amount>;
    /** Debit amount of the transaction. */
    debitAmount?: Maybe<Amount>;
    /** Ledger Entry for the entry */
    ledgerEntry?: Maybe<LedgerEntry>;
    /** The date, in ISO 8601 format, the transaction was posted. (Different word for 'posted'?) */
    postDate?: Maybe<Scalars["String"]>;
    /** Credit balance of the account. */
    primaryCreditBalance?: Maybe<Amount>;
    /** Debit balance of the account. */
    primaryDebitBalance?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, this was most recently updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Current account snapshot for a consumer revolving card */
export type ConsumerRevolvingCardFinancialAccountStatementSnapshot =
  FinancialAccountStatementSnapshot & {
    __typename?: "ConsumerRevolvingCardFinancialAccountStatementSnapshot";
    /**
     * The date and time, in ISO 8601 format, the snapshot was calculated.
     * Note that this will be the date/time of the last impactful event.
     */
    asOf?: Maybe<Scalars["String"]>;
    /** The ending balance from the `latestClosedStatement`, minus any payments that have been cleared and processed. */
    currentAmountDue?: Maybe<Amount>;
    /** The current open statement */
    currentOpenStatement?: Maybe<FinancialAccountStatement>;
    /** The most recently closed statement */
    latestClosedStatement?: Maybe<FinancialAccountStatement>;
    /** The date and time, in ISO 8601 format, this was most recently updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Representation of a unique location on a georgraphic plane. */
export type Coordinates = {
  __typename?: "Coordinates";
  /** The north–south position of a point on the Earth's surface. */
  latitude: Scalars["String"];
  /** The east–west position of a point on the Earth's surface. */
  longitude: Scalars["String"];
};

/** Representation of a unique location on a georgraphic plane. */
export type CoordinatesInput = {
  /** The north–south position of a point on the Earth's surface. */
  latitude: Scalars["String"];
  /** The east–west position of a point on the Earth's surface. */
  longitude: Scalars["String"];
};

/** The logical condition which compares count of account holder activity. */
export type CountFeeCondition = {
  __typename?: "CountFeeCondition";
  /** The fee charge condition comparison operator. */
  operator?: Maybe<FeeChargeOperator>;
  /** The count value against which account holder activity count is compared. */
  value?: Maybe<CountFeeConditionValue>;
};

/** Count Condition value. */
export type CountFeeConditionValue = {
  __typename?: "CountFeeConditionValue";
  /** The fee charge condition count used with COUNT condition type. */
  count?: Maybe<Scalars["Int"]>;
  /**
   * The fee charge condition maximum count used with COUNT condition type.
   * Used with BETWEEN condition operator.
   */
  maximumCount?: Maybe<Scalars["Int"]>;
};

/** A `CheckRule` that will put a check on hold if the number of checks is exceeded. */
export type CountLimitCheckRule = Node & {
  __typename?: "CountLimitCheckRule";
  /** The date and time, in ISO 8601 format, the rule was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the `CountLimitCheckRule` in operations. */
  id: Scalars["ID"];
  /** The maximum number of checks to allow. */
  maximumCount?: Maybe<Scalars["Int"]>;
  /** The name assigned to the rule. */
  name?: Maybe<Scalars["String"]>;
  /** The list of revisions for this check rule. */
  revisions?: Maybe<CheckRuleConnection>;
  /** The date and time, in ISO 8601 format, the rule was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
  version?: Maybe<Scalars["String"]>;
};

/** A `CheckRule` that will put a check on hold if the number of checks is exceeded. */
export type CountLimitCheckRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/**
 * A `InterFinancialAccountTransferRule` that will put an inter financial account transfer on hold if the count is exceeded.
 * This `TransferRule` must be used in a `VelocityInterFinancialAccountTransferRule`.
 */
export type CountLimitInterFinancialAccountTransferRule =
  InterFinancialAccountTransferRule &
    Node & {
      __typename?: "CountLimitInterFinancialAccountTransferRule";
      /** The date and time, in ISO 8601 format, the transfer rule was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** Global ID used to reference the `CountLimitInterFinancialAccountTransferRule` in operations. */
      id: Scalars["ID"];
      /** Indicates the account type to monitor. */
      interFinancialAccountTransferAccountType?: Maybe<InterFinancialAccountTransferAccountType>;
      /** The maximum count of inter financial account transfers to allow. */
      maximumCount?: Maybe<Scalars["Int"]>;
      /** The name assigned to the rule. */
      name?: Maybe<Scalars["String"]>;
      /** The list of revisions for this transfer rule. */
      revisions?: Maybe<InterFinancialAccountTransferRuleConnection>;
      /** The date and time, in ISO 8601 format, the transfer rule was last updated. */
      updatedAt?: Maybe<Scalars["String"]>;
      /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
      version?: Maybe<Scalars["String"]>;
    };

/**
 * A `InterFinancialAccountTransferRule` that will put an inter financial account transfer on hold if the count is exceeded.
 * This `TransferRule` must be used in a `VelocityInterFinancialAccountTransferRule`.
 */
export type CountLimitInterFinancialAccountTransferRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A Spend Control rule that limits the number of allowed transactions. */
export type CountLimitSpendRule = Node &
  SpendRule & {
    __typename?: "CountLimitSpendRule";
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the Count Limit Spend Rule in operations. */
    id: Scalars["ID"];
    /** The maximum count of transactions to allow. */
    maximumCount?: Maybe<Scalars["Int"]>;
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/** A Spend Control rule that limits the number of allowed transactions. */
export type CountLimitSpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Input fields for creating an Account Holder Card Product Application. */
export type CreateAccountHolderCardProductApplicationInput = {
  /** Details on the account holder's consent to pull their credit report as part of the card product application. */
  accountHolderCreditReportPullConsent?: InputMaybe<ConsentInput>;
  /** The ID of the account holder applicant. */
  accountHolderId: Scalars["ID"];
  /**
   * Optional application-level configuration provided by the applicant at the start of the application,
   * such as billing cycle preferences.
   */
  applicationConfiguration?: InputMaybe<ApplicationConfigurationInput>;
  /** Details on the acceptance of terms and conditions of the card holder agreement. */
  cardHolderAgreementConsent: ConsentInput;
  /** The ID of the Card Product for which the account holder is applying to use. */
  cardProductId: Scalars["ID"];
  /** The IP address details of the account holder applicant. */
  ipAddress?: InputMaybe<IpAddressInput>;
};

/** Response type for creating an Account Holder Card Product Application. */
export type CreateAccountHolderCardProductApplicationPayload =
  | AccessDeniedError
  | AccountHolderCardProductApplication
  | UserError;

/** The details of the `AccountSpendRule` to create. */
export type CreateAccountSpendRuleInput = {
  /**
   * The `Account` IDs to allow during authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  allowed?: InputMaybe<Array<Scalars["ID"]>>;
  /**
   * The `Account` IDs to block during authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  blocked?: InputMaybe<Array<Scalars["ID"]>>;
  /** A name for the rule for future reference. */
  name: Scalars["String"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when creating a `AccountSpendRule`. */
export type CreateAccountSpendRulePayload =
  | AccessDeniedError
  | AccountSpendRule
  | UserError;

/** The details of the `AccountTransactionCountSpendRule` spend rule to create. */
export type CreateAccountTransactionCountSpendRuleInput = {
  /**
   * The maximum number of transactions allowed for an account before transactions are declined.
   * **Minimum:** 0
   */
  maximumAccountTransactionCount: Scalars["UnsignedInt"];
  /** A name for the rule for future reference. */
  name: Scalars["String"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when creating a `AccountTransactionCountSpendRule`. */
export type CreateAccountTransactionCountSpendRulePayload =
  | AccessDeniedError
  | AccountTransactionCountSpendRule
  | UserError;

/** The details of the `CreateAmountLimitSpendRuleInput` spend rule to create. */
export type CreateAmountLimitSpendRuleInput = {
  /** The maximum amount to allow for a single authorization. */
  maximumAmount: AmountInput;
  /** A name for the rule for future reference. */
  name: Scalars["String"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when creating a new amount limit rule. */
export type CreateAmountLimitSpendRulePayload =
  | AccessDeniedError
  | AmountLimitSpendRule
  | UserError;

/** Input fields for creating an Authorized User Card Product Application. */
export type CreateAuthorizedUserCardProductApplicationInput = {
  /**
   * The ID of the account holder application linked to this application.
   * **Note:** The Application must be APPROVED.
   */
  accountHolderCardProductApplicationId: Scalars["ID"];
  /** The ID of the authorized user. */
  authorizedUserId: Scalars["ID"];
  /** Details on the acceptance of terms and conditions of the card holder agreement. */
  cardHolderAgreementConsent: ConsentInput;
  /** The ID of the financial account for which the authorized user is applying to use. */
  financialAccountId: Scalars["ID"];
  /** The IP address details of the authorized user applicant. */
  ipAddress?: InputMaybe<IpAddressInput>;
};

/** Response type for creating an Authorized User Card Product Application. */
export type CreateAuthorizedUserCardProductApplicationPayload =
  | AccessDeniedError
  | AuthorizedUserCardProductApplication
  | UserError;

/** The details of the spend rule to create. */
export type CreateCvvSpendRuleInput = {
  /**
   * The `CVVResponseCode` values you want to allow during authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  allowed?: InputMaybe<Array<CvvResponseCode>>;
  /**
   * The `CVVResponseCode` values that will result in declined authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  blocked?: InputMaybe<Array<CvvResponseCode>>;
  /** A name for the rule for future reference. */
  name: Scalars["String"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when creating a new CVV rule. */
export type CreateCvvSpendRulePayload =
  | AccessDeniedError
  | CvvSpendRule
  | UserError;

/** The details of the `CardDataInputCapabilitySpendRule` spend rule to create. */
export type CreateCardDataInputCapabilitySpendRuleInput = {
  /**
   * The `CardDataInputCapability` values you want to allow during authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  allowed?: InputMaybe<Array<CardDataInputCapability>>;
  /**
   * The `CardDataInputCapability` values that will result in declined authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  blocked?: InputMaybe<Array<CardDataInputCapability>>;
  /** A name for the rule for future reference. */
  name: Scalars["String"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when creating a `CardDataInputCapabilitySpendRule`. */
export type CreateCardDataInputCapabilitySpendRulePayload =
  | AccessDeniedError
  | CardDataInputCapabilitySpendRule
  | UserError;

/** Create a `CreditPlan` for a `CardProduct` based on a `CreditPlanTemplate`. */
export type CreateCardProductCreditPlanInput = {
  /** The id for the `CreditPlanTemplate` to use when creating this `CreditPlan`. For plans with a `CreditBalanceType` of `INSTALLMENT`, please use `createCardProductInstallmentCreditPlan`. */
  creditPlanTemplateId: Scalars["ID"];
  /** The interest rate (APR) to apply by default for this `CreditPlan`. Must be a positive floating point number with up to 3 digit precision after the decimal point. */
  defaultApr: Scalars["Float"];
  /** The name for this `CreditPlan`. Supports up to 255 alphanumeric characters. Does not need to be unique. */
  name: Scalars["String"];
  /** The percentage of the `FinancialAccount`'s credit limit that will be available for this `CreditPlan`. Must be an integer value between 0 and 100 inclusive. */
  percentageOfCreditLimit: Scalars["UnsignedInt"];
  /** The id for the `CardProduct` to use when creating this `CreditPlan`. */
  productId: Scalars["ID"];
  /**
   * Optional; currently only used for `PROMOTIONAL` `CreditPlan`s. This represents the number of units this `CreditPlan` will be in effect for a given `FinancialAccount` once it is enrolled in this `CreditPlan`. Units are set at the template level. Currently we only support units of `BILLING_CYCLES`.
   *
   * Note: this is different from the `effectiveFromDate` and `effectiveThroughDate` on the `CreditPlan`, which represent the dates where a `CreditPlan` is active for a `CardProduct`.
   */
  promotionDuration?: InputMaybe<Scalars["UnsignedInt"]>;
};

/** Types which can be returned when creating a `CreditPlan` for a `CardProduct`. */
export type CreateCardProductCreditPlanPayload =
  | AccessDeniedError
  | CreditPlan
  | UserError;

/** Top-level input type. */
export type CreateCardProductInput = {
  /** Details about the Card Product to be created. */
  cardProduct: CardProductInput;
};

/** Create a `CreditPlan` for a `CardProduct` with a `BalanceType` of `INSTALLMENT`, based on a `CreditPlanTemplate`. */
export type CreateCardProductInstallmentCreditPlanInput = {
  /** The id for the `CreditPlanTemplate` to use when creating this `CreditPlan`. Must have a `CreditBalanceType` of `INSTALLMENT`. */
  creditPlanTemplateId: Scalars["ID"];
  /** The fee configuration for this `CreditPlan`. */
  fee?: InputMaybe<CreditPlanFeeInput>;
  /** The maximum cleared `Amount` a `Transaction` can have to be eligible to convert into installments. Optional; if included, will be validated against the provided `CreditPlanTemplate`. */
  maximumPrincipalAmount?: InputMaybe<AmountInput>;
  /** The minimum cleared `Amount` a `Transaction` can have to be eligible to convert into installments. Optional; if included, will be validated against the provided `CreditPlanTemplate`. */
  minimumPrincipalAmount?: InputMaybe<AmountInput>;
  /** The name for this `CreditPlan`. Supports up to 255 alphanumeric characters. Does not need to be unique. */
  name: Scalars["String"];
  /** The number of periods for an `InstallmentAgreement` based on this `CreditPlan`. */
  numberOfInstallmentPeriods: Scalars["UnsignedInt"];
  /** The id for the `CardProduct` to use when creating this `CreditPlan`. */
  productId: Scalars["ID"];
};

/** Types which can be returned when creating a `CreditPlan` with `CreditBalanceType` of `INSTALLMENT` for a `CardProduct`. */
export type CreateCardProductInstallmentCreditPlanPayload =
  | AccessDeniedError
  | CreditPlan
  | UserError;

/** Types which can be returned for Card Product operations. */
export type CreateCardProductPayload =
  | AccessDeniedError
  | CardProduct
  | UserError;

/** The return type for `createCardProductWithTemplate` */
export type CreateCardProductWithTemplate = {
  __typename?: "CreateCardProductWithTemplate";
  /** The resulting `CardProduct`. */
  cardProduct: CardProduct;
};

/** Input values for `createCardProductWithTemplate` */
export type CreateCardProductWithTemplateCardProductInput = {
  /** The name of the card product. */
  name: Scalars["String"];
  /** The ID of the card product template to use. */
  sourceTemplateId: Scalars["ID"];
};

/** Input values for `createCardProductWithTemplate` */
export type CreateCardProductWithTemplateInput = {
  /** The card product to create. */
  cardProduct: CreateCardProductWithTemplateCardProductInput;
};

/** The return types for `createCardProductWithTemplate` */
export type CreateCardProductWithTemplatePayload =
  | AccessDeniedError
  | CreateCardProductWithTemplate
  | UserError;

/** The details of the `CardTransactionProcessingTypeConditionSpendRule` to create */
export type CreateCardTransactionProcessingTypeConditionSpendRuleInput = {
  /**
   * The list of possible `CardTransactionProcessingType` that will be allowed.
   * Min: 1
   * Max: 5000
   */
  allowed?: InputMaybe<Array<CardTransactionProcessingType>>;
  /**
   * The list of possible `CardTransactionProcessingType` that will result in a decline.
   * Min: 1
   * Max: 5000
   */
  blocked?: InputMaybe<Array<CardTransactionProcessingType>>;
  /** The name of the `CardTransactionProcessingTypeConditionSpendRule` */
  name?: InputMaybe<Scalars["String"]>;
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when creating a new `CardTransactionProcessingTypeConditionSpendRule`. */
export type CreateCardTransactionProcessingTypeConditionSpendRulePayload =
  | AccessDeniedError
  | CardTransactionProcessingTypeConditionSpendRule
  | UserError;

/** The input type for creating a charge `CardProductCreditConfiguration` */
export type CreateChargeCreditCardProductConfigurationInput = {
  /** The input type for the account aging configuration available on a `CardProduct`. For example, the number of days until a payment is due, and until an account is */
  accountAgingConfiguration: CreditAccountAgingProductConfigurationInput;
  /** The billing statement configuration available on a `CardProduct`. */
  billingCycleConfiguration: CreditBillingCycleCardProductConfigurationInput;
  /** The globally unique id for the `CreditProduct` */
  cardProductId: Scalars["ID"];
};

/** Input object for the `createCheckPaymentDocumentUploadSession` mutation. */
export type CreateCheckPaymentDocumentUploadSessionInput = {
  /** The type of document to upload. */
  documentTypes: Array<CheckPaymentDocumentType>;
  /** The `FinancialAccount` ID to associate the check document with. */
  financialAccountId: Scalars["ID"];
};

export type CreateCheckPaymentDocumentUploadSessionPayload =
  | AccessDeniedError
  | CheckPaymentDocumentUploadSession
  | UserError;

/** The details of the `ConditionalRuleSetSpendRule` to create */
export type CreateConditionalRuleSetSpendRuleInput = {
  /** The action to apply to the transaction event, if the rule passes */
  allow: Scalars["Boolean"];
  /** The name of the `ConditionalRuleSetSpendRule` */
  name: Scalars["String"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when creating a new conditional rule set rule. */
export type CreateConditionalRuleSetSpendRulePayload =
  | AccessDeniedError
  | ConditionalRuleSetSpendRule
  | UserError;

/** The details of the `CreateCountLimitSpendRuleInput` spend rule to create. */
export type CreateCountLimitSpendRuleInput = {
  /** The maximum count of transactions. */
  maximumCount: Scalars["Int"];
  /** A name for the rule for future reference. */
  name: Scalars["String"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when creating a new count limit rule. */
export type CreateCountLimitSpendRulePayload =
  | AccessDeniedError
  | CountLimitSpendRule
  | UserError;

/** Types that can be returned when creating a `CardProductCreditConfiguration`. */
export type CreateCreditCardProductConfigurationPayload =
  | AccessDeniedError
  | CreditCardProductConfiguration
  | UserError;

/** The input type for creating a `CreditLimitChangeRequest`. */
export type CreateCreditLimitChangeRequestInput = {
  /** The identifier for the `FinancialAccount` to review. */
  financialAccountId: Scalars["ID"];
  /** Details about the `CreditLimitChangeRequest`. */
  requestedChange?: InputMaybe<CreditLimitChangeRequestDetailsInput>;
};

/** The details of the `CreditLimitPercentageSpendRule` spend rule to create. */
export type CreateCreditLimitPercentageSpendRuleInput = {
  /**
   * The maximum percentage of the credit limit allowed for a transaction before transactions are declined.
   * **Minimum:** 0
   * **Maximum:** 100
   */
  maximumPercentageOfCreditLimit: Scalars["UnsignedInt"];
  /** A name for the rule for future reference. */
  name: Scalars["String"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when creating a `CreditLimitPercentageSpendRule`. */
export type CreateCreditLimitPercentageSpendRulePayload =
  | AccessDeniedError
  | CreditLimitPercentageSpendRule
  | UserError;

/** The details of the `DaysWithinAccountCreateDateSpendRule` spend rule to create. */
export type CreateDaysWithinAccountCreateDateSpendRuleInput = {
  /** The maximum number of days since the creation of the `FinancialAccount` before transactions are declined. */
  maximumDaysAccountCreated: Scalars["UnsignedInt"];
  /** A name for the rule for future reference. */
  name: Scalars["String"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when creating a `DaysWithinAccountCreateDateSpendRule`. */
export type CreateDaysWithinAccountCreateDateSpendRulePayload =
  | AccessDeniedError
  | DaysWithinAccountCreateDateSpendRule
  | UserError;

/** The details of the `DaysWithinCardCreateDateSpendRule` spend rule to create. */
export type CreateDaysWithinCardCreateDateSpendRuleInput = {
  /** The maximum number of days elapsed since the creation of the `PaymentCard` before transactions are declined. */
  maximumDaysCardCreated: Scalars["UnsignedInt"];
  /** A name for the rule for future reference. */
  name: Scalars["String"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when creating a `DaysWithinCardCreateDateSpendRule`. */
export type CreateDaysWithinCardCreateDateSpendRulePayload =
  | AccessDeniedError
  | DaysWithinCardCreateDateSpendRule
  | UserError;

/** The details of the `DepositAmountLimitSpendRule` to create. */
export type CreateDepositAmountLimitSpendRuleInput = {
  /** The maximum amount to allow for a single deposit. */
  maximumAmount: AmountInput;
  /** A name for the rule for future reference. */
  name: Scalars["String"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when creating a new deposit amount limit rule. */
export type CreateDepositAmountLimitSpendRulePayload =
  | AccessDeniedError
  | DepositAmountLimitSpendRule
  | UserError;

/** The details of the `DepositCountLimitSpendRule` to create. */
export type CreateDepositCountLimitSpendRuleInput = {
  /** The maximum count of deposits. */
  maximumCount: Scalars["UnsignedInt"];
  /** A name for the rule for future reference. */
  name: Scalars["String"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when creating a new deposit count limit rule. */
export type CreateDepositCountLimitSpendRulePayload =
  | AccessDeniedError
  | DepositCountLimitSpendRule
  | UserError;

/** The details of the `DepositProcessingNetworkSpendRule` spend rule to create. */
export type CreateDepositProcessingNetworkSpendRuleInput = {
  /**
   * The list of possible `DepositProcessingNetwork` that will be allowed during cash deposits.
   * Min: 1
   * Max: 5000
   */
  allowed?: InputMaybe<Array<DepositProcessingNetwork>>;
  /**
   * The list of possible `DepositProcessingNetwork` that will result in declined cash deposits.
   * Min: 1
   * Max: 5000
   */
  blocked?: InputMaybe<Array<DepositProcessingNetwork>>;
  /** A name for the rule for future reference. */
  name: Scalars["String"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when creating a new cash deposit processing network rule. */
export type CreateDepositProcessingNetworkSpendRulePayload =
  | AccessDeniedError
  | DepositProcessingNetworkSpendRule
  | UserError;

/** The input to generate a secure upload link */
export type CreateDocumentUploadLinkInput = {
  /** The document type to be uploaded */
  documentType: DocumentType;
  /** The ID of the document upload session */
  documentUploadSessionId: Scalars["ID"];
};

export type CreateDocumentUploadLinkPayload =
  | AccessDeniedError
  | CardArtDocument
  | CheckPaymentDocumentUploadSession
  | DocumentUploadLink
  | UserError;

/** The input details of the `GlobalNote` being created. */
export type CreateGlobalNoteInput = {
  /** The aggregate entity input for the `GlobalNote`. */
  aggregateEntity?: InputMaybe<GlobalNoteAggregateEntityInput>;
  /**
   * The message for the `GlobalNote`.
   *
   * Regex: ^[a-zA-Z\d$ ',.\-\_!@#$%^&*+=`?"\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\n]+$
   * Note has a max length of 2048 characters.
   * For compliance and security reasons, note should not contain any sensitive information, such as PII or PCI.
   */
  message: Scalars["String"];
  /** The primary entity input for the `GlobalNote`. */
  primaryEntity: GlobalNotePrimaryEntityInput;
};

/** The details of the `MastercardFraudScoreSpendRule` spend rule to create. */
export type CreateMastercardFraudScoreSpendRuleInput = {
  /**
   * The maximum Mastercard Fraud Score allowed for a transaction before transaction is declined.
   *
   * **Minimum:** 0
   * **Maximum:** 999
   */
  maximumMastercardFraudScore: Scalars["UnsignedInt"];
  /** A name for the rule for future reference. */
  name: Scalars["String"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when creating a `MastercardFraudScoreSpendRule`. */
export type CreateMastercardFraudScoreSpendRulePayload =
  | AccessDeniedError
  | MastercardFraudScoreSpendRule
  | UserError;

/** The details of the `MaximumAmountVarianceOnPseudoBalanceSpendRule` spend rule to create. */
export type CreateMaximumAmountVarianceOnPseudoBalanceSpendRuleInput = {
  /** The `Amount` over the account's original balance that is permitted for additional spending. */
  amountVariance: AmountInput;
  /** A name for the rule for future reference. */
  name: Scalars["String"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when creating a `MaximumAmountVarianceOnPseudoBalanceSpendRule`. */
export type CreateMaximumAmountVarianceOnPseudoBalanceSpendRulePayload =
  | AccessDeniedError
  | MaximumAmountVarianceOnPseudoBalanceSpendRule
  | UserError;

/** The details of the `MaximumPercentVarianceOnPseudoBalanceSpendRule` spend rule to create. */
export type CreateMaximumPercentVarianceOnPseudoBalanceSpendRuleInput = {
  /** A name for the rule for future reference. */
  name: Scalars["String"];
  /** The percentage over the account's original balance that is permitted for additional spending. */
  percentVariance: Scalars["Int"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when creating a `MaximumPercentVarianceOnPseudoBalanceSpendRule`. */
export type CreateMaximumPercentVarianceOnPseudoBalanceSpendRulePayload =
  | AccessDeniedError
  | MaximumPercentVarianceOnPseudoBalanceSpendRule
  | UserError;

/** The details of the spend rule to create. */
export type CreateMerchantCategorySpendRuleInput = {
  /**
   * The merchant categories that will be allowed during authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  allowed?: InputMaybe<Array<MerchantCategory>>;
  /**
   * The merchant category codes that will be allowed during authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  allowedMcc?: InputMaybe<Array<Scalars["String"]>>;
  /**
   * The merchant categories that will result in declined authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  blocked?: InputMaybe<Array<MerchantCategory>>;
  /**
   * The merchant category codes that will result in declined authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  blockedMcc?: InputMaybe<Array<Scalars["String"]>>;
  /** A name for the rule for future reference. */
  name: Scalars["String"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when creating a new category rule. */
export type CreateMerchantCategorySpendRulePayload =
  | AccessDeniedError
  | MerchantCategorySpendRule
  | UserError;

/** The details of the spend rule to create. */
export type CreateMerchantCountrySpendRuleInput = {
  /**
   * The merchant countries that will be allowed during authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  allowed?: InputMaybe<Array<Iso3166Alpha3Country>>;
  /**
   * The merchant countries that will result in declined authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  blocked?: InputMaybe<Array<Iso3166Alpha3Country>>;
  /** A name for the rule for future reference. */
  name: Scalars["String"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when creating a new country rule. */
export type CreateMerchantCountrySpendRulePayload =
  | AccessDeniedError
  | MerchantCountrySpendRule
  | UserError;

/** The details of the spend rule to create. */
export type CreateMerchantIdentifierSpendRuleInput = {
  /**
   * The merchant identifiers you want to allow during authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  allowed?: InputMaybe<Array<Scalars["String"]>>;
  /**
   * The merchant identifiers you want to block during authorizations.
   *
   * Matching values will result in a declined authorization.
   *
   * Min: 1
   * Max: 5000
   */
  blocked?: InputMaybe<Array<Scalars["String"]>>;
  /** A name for the rule for future reference. */
  name: Scalars["String"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when creating a new merchant identifier rule. */
export type CreateMerchantIdentifierSpendRulePayload =
  | AccessDeniedError
  | MerchantIdentifierSpendRule
  | UserError;

/** The input for creating a minimal `USBusinessAccountHolder` */
export type CreateMinimalUsBusinessAccountHolderInput = {
  /** The details of the business. */
  businessProfile: MinimalUsBusinessProfileInput;
  /** An ID representing this account holder in an external system. Provide this field if you create identifiers for this business that you would like us to store for easy access to their information. */
  externalId?: InputMaybe<Scalars["String"]>;
  /**
   * The idempotency key for this request.
   *
   * This is a random string such as UUIDv4 used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   *
   * Minimum length: 5 characters
   * Maximum length: 255 characters
   */
  idempotencyKey: Scalars["IdempotencyKey"];
  /** The details of the person authorized to act on behalf of business. */
  primaryAuthorizedPerson: MinimalUsAuthorizedPersonInput;
};

/** Response type for creating a minimal `USBusinessAccountHolder`. */
export type CreateMinimalUsBusinessAccountHolderPayload =
  | AccessDeniedError
  | UsBusinessAccountHolder
  | UserError;

/** The details of the `MinimumAmountLimitSpendRule` spend rule to create. */
export type CreateMinimumAmountLimitSpendRuleInput = {
  /** The exact amount to allow for a single authorization. */
  minimumAmount: AmountInput;
  /** A name for the rule for future reference. */
  name: Scalars["String"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when creating a `MinimumAmountLimitSpendRule`. */
export type CreateMinimumAmountLimitSpendRulePayload =
  | AccessDeniedError
  | MinimumAmountLimitSpendRule
  | UserError;

/** Input to create a one time ACH transfer */
export type CreateOneTimeAchTransferInput = {
  /** Descriptive fields about the ACH transfer which may show up on bank reports. */
  descriptor: AchDescriptorInput;
  /**
   * The ID of the `FinancialAccount` the funds will be coming from.
   *
   * Exactly one of `fromFinancialAccountId` and `toFinancialAccountId` will reference an external account id and the other will reference a Highnote account.
   */
  fromFinancialAccountId: Scalars["ID"];
  /** Exactly one of `fromFinancialAccountId` and `toFinancialAccountId` will reference an external account id and the other will reference a Highnote account. */
  toFinancialAccountId: Scalars["ID"];
  /** The consent provided by the individual authorizing the scheduled payment. Included is the mandate template details to be collected to provide auditability of the exact terms accepted. */
  transferAgreementConsent: TransferAgreementConsentInput;
  /** The amount to be transferred */
  transferAmountStrategy: AmountStrategyInput;
  /** The strategy for the transfer date */
  transferDateStrategy?: InputMaybe<TransferDateStrategyInput>;
};

/** The return types when a one time transfer is created. */
export type CreateOneTimeAchTransferPayload =
  | AccessDeniedError
  | OneTimeAchTransfer
  | UserError;

/** The details of the `PanEntryModeSpendRule` to be created. */
export type CreatePanEntryModeSpendRuleInput = {
  /**
   * The `PanEntryMode` values you want to allow during authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  allowed?: InputMaybe<Array<PanEntryMode>>;
  /**
   * The `PanEntryMode` values that will result in declined authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  blocked?: InputMaybe<Array<PanEntryMode>>;
  /** A name for the rule for future reference. */
  name: Scalars["String"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when creating a `PanEntryModeSpendRule`. */
export type CreatePanEntryModeSpendRulePayload =
  | AccessDeniedError
  | PanEntryModeSpendRule
  | UserError;

/** Input for creating a new `PaymentOrder`. */
export type CreatePaymentOrderInput = {
  /** Predefined items to add to the `PaymentOrder`. These items are defined in the catalog and can be queried independently. `CatalogItem`s can be use to showcase products and services that are available for purchase. */
  catalogItems?: InputMaybe<Array<PaymentOrderItemFromCatalogItemInput>>;
  /** Custom items to add to the `PaymentOrder`. These are one-off items defined at the time the order is created. They cannot be queried outside of the `PaymentOrder`. */
  customItems?: InputMaybe<Array<PaymentOrderItemFromCustomItemInput>>;
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
};

/** Result of creating a new `PaymentOrder`. */
export type CreatePaymentOrderPayload =
  | AccessDeniedError
  | PaymentOrder
  | UserError;

/** Input fields for creating a physical card group order. */
export type CreatePhysicalCardGroupOrderInput = {
  /** Id of the product with which the group order will be associated. */
  cardProductId: Scalars["ID"];
  /** ID of the `CardProfileSet` to be used for the physical card group order. */
  cardProfileSetId?: InputMaybe<Scalars["ID"]>;
  /** Courier information. */
  courier?: InputMaybe<PaymentCardShipmentCourierInput>;
  /** Delivery details. */
  deliveryDetails: PaymentCardDeliveryDetailsInput;
  /**
   * Requested ship date in YYYY-MM-DD format.
   *
   * Use this if the order should not be shipped before a certain date.
   *
   * If the order should be shipped as soon as possible, omit this field. If the date provided is in the past, the value will be ignored.
   */
  requestedShipDate?: InputMaybe<Scalars["String"]>;
};

/** Input fields for creating a physical card group order with validated address. */
export type CreatePhysicalCardGroupOrderWithValidatedAddressInput = {
  /** Id of the product with which the group order will be associated. */
  cardProductId: Scalars["ID"];
  /** ID of the `CardProfileSet` to be used for the physical card group order. */
  cardProfileSetId?: InputMaybe<Scalars["ID"]>;
  /** Courier information. */
  courier?: InputMaybe<PaymentCardShipmentCourierInput>;
  /** Delivery details. */
  deliveryDetails: PaymentCardDeliveryDetailsWithValidatedAddressInput;
  /**
   * The idempotency key for this request.
   *
   * This is a random string such as UUIDv4 used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   *
   * Minimum length: 5 characters
   * Maximum length: 255 characters
   */
  idempotencyKey: Scalars["IdempotencyKey"];
  /**
   * Requested ship date in YYYY-MM-DD format.
   *
   * Use this if the order should not be shipped before a certain date.
   *
   * If the order should be shipped as soon as possible, omit this field. If the date provided is in the past, the value will be ignored.
   */
  requestedShipDate?: InputMaybe<Scalars["String"]>;
};

/** Input fields for creating a physical card group order with validated address token. */
export type CreatePhysicalCardGroupOrderWithValidatedAddressTokenInput = {
  /** Id of the product with which the group order will be associated. */
  cardProductId: Scalars["ID"];
  /** ID of the `CardProfileSet` to be used for the physical card group order. */
  cardProfileSetId?: InputMaybe<Scalars["ID"]>;
  /** Courier information. */
  courier?: InputMaybe<PaymentCardShipmentCourierInput>;
  /** Delivery details. */
  deliveryDetails: PaymentCardDeliveryDetailsWithValidatedAddressInput;
  /**
   * The idempotency key for this request.
   *
   * This is a random string such as UUIDv4 used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   *
   * Minimum length: 5 characters
   * Maximum length: 255 characters
   */
  idempotencyKey: Scalars["IdempotencyKey"];
  /**
   * Requested ship date in YYYY-MM-DD format.
   *
   * Use this if the order should not be shipped before a certain date.
   *
   * If the order should be shipped as soon as possible, omit this field. If the date provided is in the past, the value will be ignored.
   */
  requestedShipDate?: InputMaybe<Scalars["String"]>;
};

/** The details of the `PointOfServiceCategorySpendRule` spend rule to create. */
export type CreatePointOfServiceCategorySpendRuleInput = {
  /**
   * The `PointOfServiceCategoryCondition` values you want to allow during authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  allowed?: InputMaybe<Array<PointOfServiceCategoryCondition>>;
  /**
   * The `PointOfServiceCondition` values that will result in declined authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  blocked?: InputMaybe<Array<PointOfServiceCategoryCondition>>;
  /** A name for the rule for future reference. */
  name: Scalars["String"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when creating a point of service category rule. */
export type CreatePointOfServiceCategorySpendRulePayload =
  | AccessDeniedError
  | PointOfServiceCategorySpendRule
  | UserError;

/** The details of the `PostalCodeVerificationSpendRule` spend rule to create. */
export type CreatePostalCodeVerificationSpendRuleInput = {
  /**
   * The `PostalCodeResponseCode` values you want to allow during authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  allowed?: InputMaybe<Array<PostalCodeResponseCode>>;
  /**
   * The `PostalCodeResponseCode` values that will result in declined authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  blocked?: InputMaybe<Array<PostalCodeResponseCode>>;
  /** A name for the rule for future reference. */
  name: Scalars["String"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when creating a postal code verification rule. */
export type CreatePostalCodeVerificationSpendRulePayload =
  | AccessDeniedError
  | PostalCodeVerificationSpendRule
  | UserError;

/** Input to create a recurring ACH transfer */
export type CreateRecurringAchTransferInput = {
  /** Descriptive fields about the transfer which may show up on bank reports. */
  descriptor: AchDescriptorInput;
  /** The frequency of the scheduled payment */
  frequency: RecurringAchTransferFrequencyCode;
  /**
   * The financial account id sending the funds.
   *
   *
   * Exactly one of `fromFinancialAccountId` and `toFinancialAccountId` will reference an external account id and the other will reference a Highnote account.
   */
  fromFinancialAccountId: Scalars["ID"];
  /**
   * The financial account id receiving the funds.
   *
   * Exactly one of `fromFinancialAccountId` and `toFinancialAccountId` will reference an external account id and the other will reference a Highnote account.
   */
  toFinancialAccountId: Scalars["ID"];
  /**
   * The consent provided by the individual authorizing the scheduled payment.
   *
   * This includes the mandate template details to be collected for auditability of the accepted terms.
   */
  transferAgreementConsent: TransferAgreementConsentInput;
  /** The strategy for the transfer amount */
  transferAmountStrategy: AmountStrategyInput;
  /** The strategy for the transfer day */
  transferDayStrategy?: InputMaybe<TransferDayStrategyInput>;
};

/** The return types when a recurring transfer is created. */
export type CreateRecurringAchTransferPayload =
  | AccessDeniedError
  | RecurringAchTransfer
  | UserError;

/** Input fields for creating a reusable payment method from a tokenized payment method. */
export type CreateReusablePaymentMethodTokenInput = {
  /**
   * An identifier that uniquely identifies the customer associated with the payment method in the subscriber system.
   *
   * Optionally, pass a Highnote `AccountHolder` ID to associate this payment method with an existing `AccountHolder`.
   *
   * **Minimum length:** 5 character
   * **Maximum length:** 255 characters
   */
  customerIdentifier: Scalars["String"];
  /**
   * The idempotency key for this request.
   *
   * This is a random string such as UUIDv4 used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   *
   * Minimum length: 5 characters
   * Maximum length: 255 characters
   */
  idempotencyKey: Scalars["IdempotencyKey"];
  /** The tokenized payment method id to save. */
  paymentMethodTokenId: Scalars["ID"];
};

/** Types which can be returned when saving payment method */
export type CreateReusablePaymentMethodTokenPayload =
  | AccessDeniedError
  | PaymentMethodToken
  | UserError;

/** The input type for creating a revolving `CardProductCreditConfiguration` */
export type CreateRevolvingCreditCardProductConfigurationInput = {
  /** The input type for the account aging configuration available on a `CardProduct`. For example, the number of days until a payment is due, and until an account is */
  accountAgingConfiguration: CreditAccountAgingProductConfigurationInput;
  /** The billing statement configuration available on a `CardProduct`. Required for `Revolving` credit `CardProduct`s. */
  billingCycleConfiguration: CreditBillingCycleCardProductConfigurationInput;
  /** The globally unique id for the `CreditProduct` */
  cardProductId: Scalars["ID"];
  /** The input type for the minimum payment configuration available on a `CardProduct`. For example, whether the minimum payment includes the past due amount, interest, and fees. */
  minimumPaymentConfiguration: CreditMinimumPaymentCardProductConfigurationInput;
};

/** Input type for creating a `RewardDefaultEarnRule` that holds configuration for how transactions should earn rewards. */
export type CreateRewardDefaultEarnRuleInput = {
  /** Name of Earning Rule. Should be between 1 and 255 characters. */
  name: Scalars["String"];
  /** Earning Rate. This rate describes the amount of points earn related to the amount of money spent. See `RewardEarnRateInput`. */
  rewardPointEarning: RewardEarnRateInput;
};

/** Types which can be returned for Create `RewardDefaultEarnRule`. */
export type CreateRewardDefaultEarnRulePayload =
  | AccessDeniedError
  | RewardDefaultEarnRule
  | UserError;

/** Input type for creating a `RewardMerchantCategoryEarnRule` that holds configuration for how transactions should earn rewards. */
export type CreateRewardMerchantCategoryEarnRuleInput = {
  /** Collection of `MerchantCategory` that a transaction's MCC must exist within in order for this rule to earn reward points. This field must have at least one `MerchantCategory` */
  allowedList: Array<MerchantCategory>;
  /** Name of Earning Rule. Should be between 1 and 255 characters. */
  name: Scalars["String"];
  /** Earning Rate. This rate describes the amount of points earned relative to the amount of money spent. See `RewardEarnRateInput`. */
  rewardPointEarning: RewardEarnRateInput;
};

/** Types which can be returned for Create `RewardMerchantCategoryEarnRule`. */
export type CreateRewardMerchantCategoryEarnRulePayload =
  | AccessDeniedError
  | RewardMerchantCategoryEarnRule
  | UserError;

/** Create a Manual Reward Point deduction. */
export type CreateRewardPointsAdjustmentInput = {
  /** Reward activity operation : AWARD, DEDUCT */
  activity: RewardPointsActivityTypeInput;
  /** Financial Account id that will be the recipient of the adjustment. */
  financialAccountId: Scalars["ID"];
  /** memo description for the deduction. Max character length is 1024. */
  memo?: InputMaybe<Scalars["String"]>;
  /** Amount of points that will be adjusted. Value should be between 0 and the reward point balance on the account. */
  pointsToAdjust: Scalars["UnsignedInt"];
};

/** Create `RewardRedemptionConfiguration` */
export type CreateRewardRedemptionConfigurationInput = {
  /**
   * Name of Redemption Configuration
   * Must be between 1 and 255 characters.
   */
  name: Scalars["String"];
  /** Redemption Rate. This rate describes the value of money that can be redeemed for earned points. See `RewardRedemptionRateInput`. */
  rewardPointRedemption: RewardRedemptionRateInput;
};

/** Types which can be returned when creating a `RewardRedemptionConfiguration`. */
export type CreateRewardRedemptionConfigurationPayload =
  | AccessDeniedError
  | RewardRedemptionConfiguration
  | UserError;

/** Permissions for a `CreateScheduledTransfer` Client Token */
export enum CreateScheduledTransferClientTokenPermission {
  /** Setting this permission will enable creation of a scheduled transfer. */
  CREATE_SCHEDULED_TRANSFER = "CREATE_SCHEDULED_TRANSFER",
}

/** Top level Relay compatible input type. */
export type CreateSecretApiKeyInput = {
  /** Details of the new Secret Key */
  secretKey: SecretApiKeyInput;
};

/** The possible return types from `createSecretAPIKey`. */
export type CreateSecretApiKeyPayload = ApiKey | AccessDeniedError | UserError;

/** The details of the spend rule to create. */
export type CreateStreetAddressSpendRuleInput = {
  /**
   * The `AVSResponseCode` values you want to allow during authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  allowed?: InputMaybe<Array<AvsResponseCode>>;
  /**
   * The `AVSResponseCode` values that will result in declined authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  blocked?: InputMaybe<Array<AvsResponseCode>>;
  /** A name for the rule for future reference. */
  name: Scalars["String"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when creating a new street address rule. */
export type CreateStreetAddressSpendRulePayload =
  | AccessDeniedError
  | StreetAddressSpendRule
  | UserError;

/** The input for creating a new USBusinessAccountHolder from tokenized data. */
export type CreateUsBusinessAccountHolderFromTokenInput = {
  /** The token from `tokenizeUSBusinessAccountHolder` to use to create the USBusinessAccountHolder. */
  token: Scalars["String"];
};

/**
 * Response type for onboarding a USBusinessAccountHolder from a token.
 *
 * User error paths returned match paths for `CreateUSBusinessAccountHolderInput`.
 */
export type CreateUsBusinessAccountHolderFromTokenPayload =
  | AccessDeniedError
  | UsBusinessAccountHolder
  | UserError;

/** Input fields for creating a USBusinessAccountHolder. */
export type CreateUsBusinessAccountHolderInput = {
  /** The details of the business. */
  businessProfile: UsBusinessProfileInput;
  /**
   * An ID representing this account holder in an external system. Provide this field if you create identifiers for this business that you would like us to store for easy access to their information.
   * **Maximum length:** 255 characters.
   *
   * The validation for the `externalId` uses the following regex pattern `^([a-zA-Z\d[\s][_][=][,][-][.][^;]])+$`.
   */
  externalId?: InputMaybe<Scalars["String"]>;
  /** The details of the person authorized to act on behalf of business. */
  primaryAuthorizedPerson: UsAuthorizedPersonInput;
};

/** Response type for creating a USBusinessAccountHolder. */
export type CreateUsBusinessAccountHolderPayload =
  | AccessDeniedError
  | UsBusinessAccountHolder
  | UserError;

/** The input for creating a new USPersonAccountHolder from tokenized data. */
export type CreateUsPersonAccountHolderFromTokenInput = {
  /** The token from `tokenizeUSPersonAccountHolder` to use to create the USPersonAccountHolder. */
  token: Scalars["String"];
};

/**
 * Response type for onboarding a USPersonAccountHolder from a token.
 *
 * User error paths returned match paths for `CreateUSPersonAccountHolderInput`.
 */
export type CreateUsPersonAccountHolderFromTokenPayload =
  | AccessDeniedError
  | UsPersonAccountHolder
  | UserError;

/** Input fields for creating PersonAccountHolder. */
export type CreateUsPersonAccountHolderInput = {
  /** The details of the account holder. */
  personAccountHolder: UsPersonAccountHolderInput;
};

/** Response type for onboarding a USPersonAccountHolder. */
export type CreateUsPersonAccountHolderPayload =
  | AccessDeniedError
  | UsPersonAccountHolder
  | UserError;

/** The input for creating a new USPersonAuthorizedUser from tokenized data. */
export type CreateUsPersonAuthorizedUserFromTokenInput = {
  /** The token from `tokenizeUSPersonAuthorizedUser` to use to create the USPersonAuthorizedUser. */
  token: Scalars["String"];
};

/**
 * Response type for onboarding a USPersonAuthorizedUser from a token.
 *
 * User error paths returned match paths for `CreateUSPersonAuthorizedUserInput`.
 */
export type CreateUsPersonAuthorizedUserFromTokenPayload =
  | AccessDeniedError
  | UsPersonAuthorizedUser
  | UserError;

/** Input fields for creating PersonAuthorizedUser. */
export type CreateUsPersonAuthorizedUserInput = {
  /** The identifier of the business account holder for which authorized user should be created. */
  accountHolderId: Scalars["ID"];
  /** The details of the account holder. */
  personAuthorizedUser: UsPersonAuthorizedUserInput;
};

/** Response type for onboarding a USPersonAuthorizedUser. */
export type CreateUsPersonAuthorizedUserPayload =
  | AccessDeniedError
  | UsPersonAuthorizedUser
  | UserError;

/**
 * Input for `createUnifiedFundsTransferQuote`.
 *
 * One of `source.amount` or `destination.amount` must be provided, but not both. The other amount will be calculated based on the remaining amount after the fee.
 */
export type CreateUnifiedFundsTransferQuoteInput = {
  /** The destination of the funds to transfer. */
  destination: UnifiedFundsTransferDestinationInput;
  /** Externally provided ID (255 character limit) to associate this request with an external system. */
  externalIdentifier?: InputMaybe<Scalars["String"]>;
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["String"]>;
  /**
   * The reason for the transfer.
   *
   * **Maximum length:** 1024 alphanumeric characters.
   */
  memo?: InputMaybe<Scalars["String"]>;
  /** The source of the funds to transfer. */
  source: UnifiedFundsTransferSourceInput;
};

/** The possible results of `createUnifiedFundsTransferQuote` */
export type CreateUnifiedFundsTransferQuotePayload =
  | AccessDeniedError
  | CreateUnifiedFundsTransferQuoteResult
  | UserError;

/** The result of `createUnifiedFundsTransferQuote`. */
export type CreateUnifiedFundsTransferQuoteResult = {
  __typename?: "CreateUnifiedFundsTransferQuoteResult";
  /** The `UnifiedFundsTransfer`s that can be offered to the end user for them to accept, and then initiate the transfer. */
  quotes?: Maybe<Array<UnifiedFundsTransferQuote>>;
};

/** The input for creating a `UserDefinedFieldDefinition`. */
export type CreateUserDefinedFieldDefinitionInput = {
  /** The data type that values of this field must conform to. */
  dataType: UserDefinedFieldDefinitionDataType;
  /** Optional description explaining the purpose of this field definition. */
  description?: InputMaybe<Scalars["String"]>;
  /** The name for the new field definition. */
  name: Scalars["String"];
};

/** The input to create a `UserDefinedField` */
export type CreateUserDefinedFieldInput = {
  /** The ID of the field definition to create an instance of. */
  definitionId: Scalars["ID"];
  /** The ID of the `Node` entity to attach this field to. */
  nodeId: Scalars["ID"];
  /** The value to store in this field instance. */
  value: UserDefinedFieldValueInput;
};

/** The details of the `VelocityRule` to create */
export type CreateVelocityRuleInput = {
  /**
   * The following `cumulativeRule` must be a rule that represents a cumulative amount.
   * When the all of the conditions of the non-cumulative SpendRules are true this amount will increment.
   */
  cumulativeRule: AttachSpendRuleInput;
  /** The name of the `VelocityRule` */
  name: Scalars["String"];
  /**
   * The SpendRules to attach to `VelocityRule`. Note: Up to 3 allowed, 1-2 recommended
   * When all of the compounded SpendRules below are true then the transaction amount will be added to the cumulative sum.
   */
  spendRules?: InputMaybe<Array<AttachSpendRuleInput>>;
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
  /**
   * Optional `VelocityConstraintLevel` at which the cumulative spend rule will be evaluated.
   *
   * Defaults to `CARD` when `VelocityRule` is directly attached to a card
   * All other times defaults to `ACCOUNT`
   */
  velocityConstraintLevelOverride?: InputMaybe<VelocityConstraintLevel>;
  /** The velocity cadence time frame */
  velocityRuleWindow: VelocityRuleWindow;
};

/** The return types when creating a new `VelocityRule`. */
export type CreateVelocityRulePayload =
  | AccessDeniedError
  | UserError
  | VelocityRule;

/** The details of the `VisaRiskScoreSpendRule` spend rule to create. */
export type CreateVisaRiskScoreSpendRuleInput = {
  /**
   * The maximum Visa Risk Score allowed for a transaction before transaction is declined.
   *
   * **Minimum:** 0
   * **Maximum:** 99
   */
  maximumVisaRiskScore: Scalars["UnsignedInt"];
  /** A name for the rule for future reference. */
  name: Scalars["String"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when creating a `VisaRiskScoreSpendRule`. */
export type CreateVisaRiskScoreSpendRulePayload =
  | AccessDeniedError
  | UserError
  | VisaRiskScoreSpendRule;

/** Describes attributes of an approved application metric. */
export type CreatedOrApprovedApplicationBusinessMetricAttribute = {
  __typename?: "CreatedOrApprovedApplicationBusinessMetricAttribute";
  /** The total account holder number. */
  accountHolders?: Maybe<Scalars["UnsignedInt"]>;
  /** The total authorized user number. */
  authorizedUsers?: Maybe<Scalars["UnsignedInt"]>;
  /** The total number of approved or created applications. */
  total?: Maybe<Scalars["UnsignedInt"]>;
};

/**
 * The account aging configuration available on a `CardProduct`. For example, the number of days until a payment is due, and until an account is
 * considered `DELINQUENT`, `SUSPENDED`, or `CLOSED`.
 */
export type CreditAccountAgingCardProductConfiguration = {
  __typename?: "CreditAccountAgingCardProductConfiguration";
  /** The number of days between when a payment is due and when a `FinancialAccount` becomes closed if the payment is not made. */
  chargeOffInDays?: Maybe<Scalars["UnsignedInt"]>;
  /** The number of days between when a payment is due and when a `FinancialAccount` becomes delinquent if the payment is not made. */
  delinquentInDays?: Maybe<Scalars["UnsignedInt"]>;
  /** The number of days between when a payment is assessed (cycle close date) and when it is due. */
  lateFeeGracePeriodInDays?: Maybe<Scalars["UnsignedInt"]>;
  /** The number of days between when a payment is due and when a `FinancialAccount` becomes suspended if the payment is not made. */
  suspendedInDays?: Maybe<Scalars["UnsignedInt"]>;
};

/**
 * The input type for the account aging configuration available on a `CardProduct`. For example, the number of days until a payment is due, and until an account is
 * considered `DELINQUENT`, `SUSPENDED`, or `CLOSED`.
 */
export type CreditAccountAgingProductConfigurationInput = {
  /** The number of days between when a payment is due and when a `FinancialAccount` becomes closed if the payment is not made. Must be greater than zero. */
  chargeOffInDays: Scalars["UnsignedInt"];
  /** The number of days between when a payment is due and when a `FinancialAccount` becomes delinquent if the payment is not made. Must be greater than zero. */
  delinquentInDays: Scalars["UnsignedInt"];
  /** The number of days between when a late fee is assessed and when it is due. Must be greater than or equal to zero. */
  lateFeeGracePeriodInDays: Scalars["UnsignedInt"];
  /** The number of days between when a payment is due and when a `FinancialAccount` becomes suspended if the payment is not made. Must be greater than zero. */
  suspendedInDays: Scalars["UnsignedInt"];
};

/** The type of balance this `CreditPlan` applies to. For example, `PURCHASE`, `CASH_ADVANCE`, `INSTALLMENT`, or `BALANCE_TRANSFER`. */
export enum CreditBalanceType {
  BALANCE_TRANSFER = "BALANCE_TRANSFER",
  CASH_ADVANCE = "CASH_ADVANCE",
  INSTALLMENT = "INSTALLMENT",
  PURCHASE = "PURCHASE",
}

/** The billing statement configuration available on a `CardProduct`. */
export type CreditBillingCycleCardProductConfiguration = {
  __typename?: "CreditBillingCycleCardProductConfiguration";
  /** Number of days included in the grace period */
  billingCycleGracePeriodInDays?: Maybe<Scalars["UnsignedInt"]>;
  /** Whether the grace period is `FLOATING` or `FIXED`. Please note that `WEEKLY` cycles must have a `FIXED` grace period and `MONTHLY` cycles must have a `FLOATING` grace period. */
  billingCycleGracePeriodType?: Maybe<CreditStatementGracePeriodType>;
  /**
   * Number of days before payment is due to send notification(s).
   *
   * **Examples:** `With Due Date of 1/15 and a Grace Period of 10 days, billingCyclePaymentDueNotificationDays of [5,3,1] would produce notifications on 1/10, 1/12, and 1/14."`
   */
  billingCyclePaymentDueNotificationsDays?: Maybe<
    Array<Scalars["UnsignedInt"]>
  >;
  /** Whether statement cycles are `WEEKLY` or `MONTHLY`. Please note that `WEEKLY` cycles must have a `FIXED` grace period and `MONTHLY` cycles must have a `FLOATING` grace period. */
  billingCyclePeriod?: Maybe<CreditStatementCyclePeriod>;
};

/** The billing statement configuration available on a `CardProduct`. */
export type CreditBillingCycleCardProductConfigurationInput = {
  /** Number of days included in the grace period */
  billingCycleGracePeriodInDays?: InputMaybe<Scalars["UnsignedInt"]>;
};

/** Credit Bureaus */
export enum CreditBureau {
  /** Experian */
  EXPERIAN = "EXPERIAN",
}

/** Whether or not the Financial Account supports a Credit Card. */
export type CreditCardAccountFeature = FinancialAccountFeature & {
  __typename?: "CreditCardAccountFeature";
  /** The date and time, in ISO 8601 format, the feature was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The credit limit on the `CreditCardAccountFeature` */
  creditLimit?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, the feature was effective from. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective through. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Whether or not the feature is enabled for the Financial Account. */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** The date and time, in ISO 8601 format, the feature was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Details about interest accrual. */
export type CreditCardInterestAccrual = {
  __typename?: "CreditCardInterestAccrual";
  /** The relevant annual percentage rate (APR) for the interest charged. */
  apr?: Maybe<Scalars["Float"]>;
  /** The `CardProduct` associated with this `CreditCardInterestAccrual`. */
  cardProduct?: Maybe<CardProduct>;
  /** The date and time, in ISO 8601 format, this `CreditCardInterestAccrual` took place. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The `CreditPlan` associated with this `CreditCardInterestAccrual`. */
  creditPlan?: Maybe<CreditPlan>;
  /** The `FinancialAccount` associated with this `CreditCardInterestAccrual`. */
  financialAccount?: Maybe<FinancialAccount>;
  /** The `FinancialAccountStatement` associated with this `CreditCardInterestAccrual`. */
  statement?: Maybe<FinancialAccountStatement>;
  /** The `Amount` of interest accrued for this `CreditCardInterestAccrual`. */
  transferAmount?: Maybe<Amount>;
};

/** Details about interest reversal. */
export type CreditCardInterestReversal = {
  __typename?: "CreditCardInterestReversal";
  /** The `CardProduct` associated with this `CreditCardInterestReversal`. */
  cardProduct?: Maybe<CardProduct>;
  /** The date and time, in ISO 8601 format, this `CreditCardInterestReversal` took place. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The `CreditPlan` associated with this `CreditCardInterestReversal`. */
  creditPlan?: Maybe<CreditPlan>;
  /** The `FinancialAccount` associated with this `CreditCardInterestReversal`. */
  financialAccount?: Maybe<FinancialAccount>;
  /** The source `CreditCardTransferEvent` whose interest was waived. */
  sourceInterestAccrual?: Maybe<CreditCardTransferEvent>;
  /** The `FinancialAccountStatement` associated with this `CreditCardInterestReversal`. */
  statement?: Maybe<FinancialAccountStatement>;
  /** The `Amount` of interest reversed for this `CreditCardInterestReversal`. */
  transferAmount?: Maybe<Amount>;
};

/** The union type for `CreditCardInterestTransfer`, which supports accrual and reversal. */
export type CreditCardInterestTransfer =
  | CreditCardInterestAccrual
  | CreditCardInterestReversal;

/** The credit configuration values available on a `CardProduct`. For example, account aging, minimum payment, and repayment configuration. */
export type CreditCardProductConfiguration = {
  __typename?: "CreditCardProductConfiguration";
  /**
   * The account aging configuration available on a `CardProduct`. For example, the number of days until a payment is due, and until an account is
   * considered `DELINQUENT`, `SUSPENDED`, or `CLOSED`.
   */
  accountAging?: Maybe<CreditAccountAgingCardProductConfiguration>;
  /** The billing statement configuration available on a `CardProduct`. Used for Revolving Card Products only. */
  billingCycleConfiguration?: Maybe<CreditBillingCycleCardProductConfiguration>;
  /** The interest configuration available on a `CardProduct`. Used for Revolving Card Products only. */
  interest?: Maybe<CreditInterestApplicationCardProductConfiguration>;
  /**
   * The minimum payment configuration available on a `CardProduct`. For example, whether the minimum payment includes the past due amount, interest, and fees.
   *  Used for Revolving Card Products only.
   */
  minimumPayment?: Maybe<CreditMinimumPaymentCardProductConfiguration>;
  /** The repayment configuration available on a `CardProduct`. Used for Revolving Card Products only. */
  repayment?: Maybe<CreditRepaymentCardProductConfiguration>;
};

/** Type of credit card product feature. */
export enum CreditCardProductFeature {
  /** Charge credit. */
  CHARGE = "CHARGE",
  /** Revolving credit. */
  REVOLVING = "REVOLVING",
}

/** A financial event that represents a credit card transfer. */
export type CreditCardTransferEvent = Node & {
  __typename?: "CreditCardTransferEvent";
  /**
   * The direction funds are moving in the perspective of the customer.
   * * when DEBIT, funds are moving out of the customer's account
   * * when CREDIT, funds are moving into the customer's account
   * @deprecated not in use
   */
  accountingDirection?: Maybe<AccountingDirection>;
  /**
   * The type of balance this `CreditPlan` applies to. For example, `PURCHASE`, `CASH_ADVANCE`, `INSTALLMENT`, or `BALANCE_TRANSFER`.
   * @deprecated please use balanceType on creditPlan in creditCardInterestTransferEvent field instead
   */
  balanceType?: Maybe<CreditBalanceType>;
  /** The `CreditCardInterestTransfer`, such as a `CreditCardInterestAccrual` or `CreditCardInterestReversal`, represented by this `CreditCardTransferEvent`. */
  creditCardInterestTransferEvent?: Maybe<CreditCardInterestTransfer>;
  /**
   * The `CreditPlan` associated with this event.
   * @deprecated please use creditPlan in creditCardInterestTransferEvent field instead
   */
  creditPlan?: Maybe<CreditPlan>;
  /** Global ID used to reference the transfer in operations. */
  id: Scalars["ID"];
  /**
   * Details about the interest that will be charged, such as the annual percentage rate (APR).
   * @deprecated please use apr in creditCardInterestTransferEvent field instead
   */
  interestDetails?: Maybe<InterestDetails>;
  /**
   * The `FinancialAccountStatement` associated with this event.
   * @deprecated please use statement in creditCardInterestTransferEvent field instead
   */
  statement?: Maybe<FinancialAccountStatement>;
};

/** A result from a credit decision. */
export enum CreditDecisionResult {
  /** The cardholder has an active bankruptcy. */
  ACTIVE_BANKRUPTCY = "ACTIVE_BANKRUPTCY",
  /** The cardholder's address could not be verified as provided. */
  ADDRESS_MISMATCH = "ADDRESS_MISMATCH",
  /** The age of the oldest tradeline in the cardholders's credit report is too recent. */
  AGE_OF_OLDEST_TRADELINE = "AGE_OF_OLDEST_TRADELINE",
  /** The cardholder has filed for bankruptcy in the past. */
  BANKRUPTCY = "BANKRUPTCY",
  /** The cardholder has had a tradeline sent to collections in the past. */
  COLLECTIONS = "COLLECTIONS",
  /** The cardholder has placed a fraud alert on their credit report. */
  CREDIT_REPORT_FRAUD_ALERT = "CREDIT_REPORT_FRAUD_ALERT",
  /** The cardholder has placed a freeze on their credit report. */
  CREDIT_REPORT_FREEZE = "CREDIT_REPORT_FREEZE",
  /**
   * The cardholder has current debt obligations that exceed the set threshold.
   * ***Note** This attribute is deprecated and will be removed in a future release. Please refer to the `EXCESSIVE_DEBT_OBLIGATIONS`.
   */
  CURRENT_DEBT_OBLIGATIONS = "CURRENT_DEBT_OBLIGATIONS",
  /** The cardholder currently has delinquent tradelines. */
  CURRENT_DELINQUENT_CREDIT_OBLIGATIONS = "CURRENT_DELINQUENT_CREDIT_OBLIGATIONS",
  /** The cardholder currently has tradelines more than 30 days delinquent. */
  CURRENT_DELINQUENT_CREDIT_OBLIGATIONS_30 = "CURRENT_DELINQUENT_CREDIT_OBLIGATIONS_30",
  /** The cardholder currently has tradelines more than 90 days delinquent. */
  CURRENT_DELINQUENT_CREDIT_OBLIGATIONS_90 = "CURRENT_DELINQUENT_CREDIT_OBLIGATIONS_90",
  /** The cardholder is deceased. */
  DECEASED = "DECEASED",
  /** The cardholder has credit obligations that are delinquent. */
  DELINQUENT_CREDIT_OBLIGATIONS = "DELINQUENT_CREDIT_OBLIGATIONS",
  /** The date of birth provided does not match the date of birth of the cardholder. */
  DOB_MISMATCH = "DOB_MISMATCH",
  /** The cardholder has current debt obligations that exceed the set threshold. */
  EXCESSIVE_DEBT_OBLIGATIONS = "EXCESSIVE_DEBT_OBLIGATIONS",
  /** The cardholder has excessive payment obligations in relation to their income. */
  EXCESSIVE_OBLIGATIONS_TO_INCOME = "EXCESSIVE_OBLIGATIONS_TO_INCOME",
  /** The cardholder has a foreclosure on their credit report. */
  FORECLOSURE = "FORECLOSURE",
  /** The cardholder has high credit card utilization. */
  HIGH_CREDIT_CARD_UTILIZATION = "HIGH_CREDIT_CARD_UTILIZATION",
  /** The cardholder has a high debt-to-income ratio. */
  HIGH_DEBT_TO_INCOME = "HIGH_DEBT_TO_INCOME",
  /** The cardholder has a high debt-to-income ratio (excluding monthly housing payments). */
  HIGH_DEBT_TO_INCOME_EXCLUDING_HOUSING = "HIGH_DEBT_TO_INCOME_EXCLUDING_HOUSING",
  /** The cardholder has high revolving credit card utilization. */
  HIGH_REVOLVING_CREDIT_CARD_UTILIZATION = "HIGH_REVOLVING_CREDIT_CARD_UTILIZATION",
  /** The cardholder does not meet the minimum income requirement. */
  INSUFFICIENT_INCOME = "INSUFFICIENT_INCOME",
  /** The cardholder has limited credit references or history */
  LIMITED_CREDIT_EXPERIENCE = "LIMITED_CREDIT_EXPERIENCE",
  /** The cardholder does not meet the minimum credit score requirement. */
  MIN_CREDIT_SCORE = "MIN_CREDIT_SCORE",
  /** The cardholder is eligible for Military Lending Act (MLA) privileges. */
  MLA_ELIGIBLE = "MLA_ELIGIBLE",
  /** The name provided does not match any known names for the cardholder. */
  NAME_MISMATCH = "NAME_MISMATCH",
  /** The cardholder has no credit history. */
  NO_CREDIT_HISTORY = "NO_CREDIT_HISTORY",
  /** The cardholder has too many open accounts. */
  NUMBER_OF_OPEN_ACCOUNTS = "NUMBER_OF_OPEN_ACCOUNTS",
  /** The cardholder has tradeline chargeoffs on their credit report. */
  PAST_CHARGE_OFFS = "PAST_CHARGE_OFFS",
  /** The cardholder has had delinquent tradelines in the past. */
  PAST_DELINQUENT_CREDIT_OBLIGATIONS = "PAST_DELINQUENT_CREDIT_OBLIGATIONS",
  /** The cardholder has had a bankruptcy discharged or dismissed recently. */
  RECENT_BANKRUPTCY = "RECENT_BANKRUPTCY",
  /** The cardholder has had an account charge off recently. */
  RECENT_CHARGE_OFF = "RECENT_CHARGE_OFF",
  /** The cardholder has opened lines of credit a number of times that exceed the set threshold. */
  RECENT_CREDIT_ACCOUNTS = "RECENT_CREDIT_ACCOUNTS",
  /** The cardholder has applied for lines of credit a number of times that exceed the set threshold. */
  RECENT_CREDIT_APPLICATIONS = "RECENT_CREDIT_APPLICATIONS",
  /** The cardholder has had a delinquent account recently. */
  RECENT_DELINQUENCY = "RECENT_DELINQUENCY",
  /** The cardholder has recent inquiries that exceed the set threshold. */
  RECENT_INQUIRIES = "RECENT_INQUIRIES",
  /** The cardholder's social security number could not be verified as provided. */
  SSN_MISMATCH = "SSN_MISMATCH",
}

/** The credit configuration for this `FinancialAccount`. */
export type CreditFinancialAccountConfiguration = {
  __typename?: "CreditFinancialAccountConfiguration";
  /**
   * A list of credit plan configurations for this `FinancialAccount`.
   * @deprecated Please use `purchasePlans` on `FinancialAccount` instead.
   */
  interestRates?: Maybe<Array<CreditPlanFinancialAccountConfiguration>>;
  /** The Military Lending Act (MLA) configuration for this `FinancialAccount`. */
  militaryLendingAct?: Maybe<MilitaryLendingActConfiguration>;
  /** The Servicemembers Civil Relief Act (SCRA) configuration for this `FinancialAccount`. */
  servicemembersCivilReliefAct?: Maybe<ServicemembersCivilReliefActConfiguration>;
};

/** A credit transfer to a Highnote account. */
export type CreditFunds = ElectronicFundsTransfer &
  ExternallyInitiatedAchTransfer &
  Node & {
    __typename?: "CreditFunds";
    /** The amount of the transfer. */
    amount?: Maybe<Amount>;
    /** The Card Product associated to the Financial Account. */
    cardProduct?: Maybe<CardProduct>;
    /** The ID of the company that initiated the ACH transfer, ISO 8601 format. */
    companyIdentifier?: Maybe<Scalars["String"]>;
    /** The name of the company that initiated the ACH transfer. */
    companyName?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the transfer was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Descriptive fields about the transfer which may show up on bank reports. */
    descriptor?: Maybe<AchDescriptor>;
    /** Global ID used to reference the transfer in operations. */
    id: Scalars["ID"];
    /** The ledgers affected by the transfer. */
    ledgers?: Maybe<Array<Ledger>>;
    /** The date this transaction was returned, in ISO 8601 format. */
    returnDate?: Maybe<Scalars["String"]>;
    /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
    settlementDate?: Maybe<Scalars["String"]>;
    /** The status of the externally initiated ACH transfer. */
    status?: Maybe<ExternallyInitiatedAchStatusDetails>;
    /** The Highnote account receiving the credit. */
    toFinancialAccount?: Maybe<FinancialAccount>;
    /** A unique 15 digit number assigned by the originator to identify the transfer. */
    traceNumber?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the transfer was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** A credit transfer to a Highnote account. */
export type CreditFundsLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** A financial event that represents a `CreditFunds` transfer. */
export type CreditFundsAchTransferEvent = AchTransferEvent &
  Node & {
    __typename?: "CreditFundsACHTransferEvent";
    /** The amount of the transfer. */
    amount?: Maybe<Amount>;
    /** Company entered value for the type of ACH. */
    companyEntryDescription?: Maybe<Scalars["String"]>;
    /**
     * The Company Identifier is a 10-position alphameric code used to identify an Originator of the ACH transaction. It may begin with an ANSI one-digit Identification Code Designator (ICD), followed by the Identification Number.
     *
     * |`Identification Code Designator (ICD)`    | `ANSI Identification Number` | Example                                                                         |
     * | ---------------------------------------- | ---------------------------- | ------------------------------------------------------------------------------- |
     * |`IRS Employer Identification Number (EIN)`| 1                            | 1234567890 for an Originator with 234567890 EIN                                 |
     * |`Data Universal Numbering Systems (DUNS)` | 3                            | 30008016958 for an Originator with 0008016958 DUNS                              |
     * |`User Assigned Number`                    | 9                            | 9111111111 for an Originator with 111111111 under assigned Identification Number|
     */
    companyIdentifier?: Maybe<Scalars["String"]>;
    /** The name of the company that initiated the ACH transfer. */
    companyName?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the transfer was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the transfer in operations. */
    id: Scalars["ID"];
    /** The date this transaction was returned, in ISO 8601 format. */
    returnDate?: Maybe<Scalars["String"]>;
    /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
    settlementDate?: Maybe<Scalars["String"]>;
    /** The status of the externally initiated ACH transfer. */
    status?: Maybe<ExternallyInitiatedAchStatusDetails>;
    /** The account receiving the funds. */
    toFinancialAccount?: Maybe<FinancialAccount>;
    /** The `ElectronicFundsTransfer` that triggered this event. */
    transfer?: Maybe<ElectronicFundsTransfer>;
  };

/** Possible status values for installment eligibility for a `TransactionEvent`. */
export enum CreditInstallmentEligibilityStatusForTransactionEvent {
  /** Indicates that the `TransactionEvent` meets the `Amount` range for at least one active `CreditPlan` of `CreditBalanceType` `INSTALLMENT`, and that the `TransactionEvent` has not yet been converted into an `InstallmentAgreement`. */
  ELIGIBLE = "ELIGIBLE",
  /** Indicates that either the `TransactionEvent` does not have an `Amount` within range for an active `CreditPlan` of `CreditBalanceType` `INSTALLMENT`, or the `TransactionEvent` has already been converted into an `InstallmentAgreement`. */
  NOT_ELIGIBLE = "NOT_ELIGIBLE",
}

/** The interest calculation configuration available on a `CardProduct`. */
export type CreditInterestApplicationCardProductConfiguration = {
  __typename?: "CreditInterestApplicationCardProductConfiguration";
  /** Whether or not to include fees when calculating interest. */
  includesFees?: Maybe<Scalars["Boolean"]>;
  /** Whether or not to include purchase amount when calculating interest. */
  includesPurchase?: Maybe<Scalars["Boolean"]>;
};

/** A ledger entry of type credit, it represents the portion of a financial event where a Ledger had money credited to it. */
export type CreditLedgerEntry = LedgerEntry &
  Node & {
    __typename?: "CreditLedgerEntry";
    /** The `Amount` of the `CreditLedgerEntry`. */
    amount?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, this ledger entry was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The credit balance that is the result of the ledger entry. */
    creditBalanceAtLedgerEntry?: Maybe<Amount>;
    /** The debit balance that is the result of the ledger entry. */
    debitBalanceAtLedgerEntry?: Maybe<Amount>;
    /** A `FinancialAccount` backed by the `Ledger` that this ledger entry belongs to. */
    financialAccount?: Maybe<FinancialAccount>;
    /** The event that triggered the ledger entry. */
    financialEvent?: Maybe<FinancialEvent>;
    /** The unique id of the `CreditLedgerEntry`. */
    id: Scalars["ID"];
    /** A `JournalEntry` showing this `CreditLedgerEntry` and its offsetting `DebitLedgerEntry`. */
    journalEntry?: Maybe<JournalEntry>;
    /** `Ledger` that `CreditLedgerEntry` belongs to. */
    ledger?: Maybe<Ledger>;
    /** The optional memo of the `CreditLedgerEntry`. */
    memo?: Maybe<Scalars["String"]>;
  };

/** A review of the credit limit on a `FinancialAccount` to either increase or decrease it. */
export type CreditLimitChangeRequest = AccountReview &
  Node & {
    __typename?: "CreditLimitChangeRequest";
    /** The date and time, in ISO 8601 format, this was closed. */
    closedAt?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, this was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Details collected about the customer. */
    customerDetails?: Maybe<CreditLimitChangeRequestCustomerDetails>;
    /** The credit limit before the review. */
    existingCreditLimit?: Maybe<Amount>;
    /** The `FinancialAccount` in review. */
    financialAccount?: Maybe<FinancialAccount>;
    /**
     * The Global ID of the `FinancialAccount` in review.
     * @deprecated use financialAccount instead
     */
    financialAccountId: Scalars["ID"];
    /** The Global ID of this `CreditLimitChangeRequest` */
    id: Scalars["ID"];
    /** Details about the `CreditLimitChangeRequest`. */
    requestedChange?: Maybe<CreditLimitChangeRequestDetails>;
    /** The status of the `CreditLimitChangeRequest`. */
    status?: Maybe<CreditLimitChangeRequestStatus>;
    /** The status history of the `CreditLimitChangeRequest`. */
    statusHistory?: Maybe<Array<CreditLimitChangeRequestStatusHistory>>;
    /** The date and time, in ISO 8601 format, this was updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The updated credit limit. */
    updatedCreditLimit?: Maybe<Amount>;
  };

/** Details collected about the customer. */
export type CreditLimitChangeRequestCustomerDetails = {
  __typename?: "CreditLimitChangeRequestCustomerDetails";
  /** The adverse action reason(s) why an increase request is denied or if a decrease request is approved. */
  adverseActionReasons?: Maybe<Array<AdverseActionReason>>;
  /** The annual income amount used for this decision. */
  annualIncome?: Maybe<Array<Amount>>;
  /** The annual revenue amount used for this decision. Only applicable for business accounts. */
  annualRevenue?: Maybe<Array<Amount>>;
  /** The current debt obligations amount used for this decision. */
  currentDebtObligations?: Maybe<Array<Amount>>;
  /** The external bank balance used for this decision. */
  externalFinancialAccountBalance?: Maybe<Array<Amount>>;
};

/** The input type for details collected about the customer. */
export type CreditLimitChangeRequestCustomerDetailsInput = {
  /** The annual income amount used for this decision. */
  annualIncome?: InputMaybe<AmountInput>;
  /** The annual revenue amount used for this decision. Only applicable for business accounts. */
  annualRevenue?: InputMaybe<AmountInput>;
  /** The current debt obligations amount used for this decision. */
  currentDebtObligations?: InputMaybe<AmountInput>;
  /** The external bank balance used for this decision. */
  externalFinancialAccountBalance?: InputMaybe<AmountInput>;
};

/** Details about the requested credit limit change. */
export type CreditLimitChangeRequestDetails = {
  __typename?: "CreditLimitChangeRequestDetails";
  /** The type of `CreditLimitChangeRequest`, whether `INCREASE` or `DECREASE`. */
  requestedChangeType?: Maybe<CreditLimitChangeRequestType>;
  /** The requested credit limit. */
  requestedCreditLimit?: Maybe<Amount>;
  /** The type of requestor, whether `CUSTOMER` or `SUBSCRIBER`. */
  requestor?: Maybe<CreditLimitChangeRequestor>;
};

/** The input type for specifying details about the `CreditLimitChangeRequest`. */
export type CreditLimitChangeRequestDetailsInput = {
  /** The type of `CreditLimitChangeRequest`, whether `INCREASE` or `DECREASE`. */
  requestedChangeType?: InputMaybe<CreditLimitChangeRequestType>;
  /** The requested credit limit. Optional; can be omitted if the credit limit amount will be determined during the review process. */
  requestedCreditLimit?: InputMaybe<AmountInput>;
  /** The type of requestor, whether `CUSTOMER` or `SUBSCRIBER`. */
  requestor?: InputMaybe<CreditLimitChangeRequestor>;
};

/** Possible reasons for a `CreditLimitChangeRequestStatus` of `FAILED`. */
export enum CreditLimitChangeRequestFailureReason {
  NSF = "NSF",
  OTHER = "OTHER",
}

/** Types that can be returned for `CreditLimitChangeRequest`. */
export type CreditLimitChangeRequestPayload =
  | AccessDeniedError
  | CreditLimitChangeRequest
  | UserError;

/** Possible `CreditLimitChangeRequest` statuses. */
export enum CreditLimitChangeRequestStatus {
  APPROVED = "APPROVED",
  CLOSED = "CLOSED",
  DENIED = "DENIED",
  FAILED = "FAILED",
  INITIATED = "INITIATED",
  PENDING = "PENDING",
}

/** An event that occurs when a `CreditLimitChangeRequest` has a change in status. */
export type CreditLimitChangeRequestStatusChangedEvent = {
  __typename?: "CreditLimitChangeRequestStatusChangedEvent";
  /** The date and time in ISO 8601 format this was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Details about a failure status. */
  creditLimitChangeRequestFailureReason?: Maybe<CreditLimitChangeRequestFailureReason>;
  /** Unique identifier for the `CreditLimitChangeRequest`. */
  creditLimitChangeRequestId?: Maybe<Scalars["ID"]>;
  /** The status of the change request. */
  creditLimitChangeRequestStatus?: Maybe<CreditLimitChangeRequestStatus>;
  /** The type of change request, whether `INCREASE` or `DECREASE`. */
  creditLimitChangeRequestType?: Maybe<CreditLimitChangeRequestType>;
  /** The identifier of the `FinancialAccount` associated with this request. */
  financialAccountId?: Maybe<Scalars["ID"]>;
  /** The date and time in ISO 8601 format this was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** `CreditLimitChangeRequest` status history. */
export type CreditLimitChangeRequestStatusHistory = {
  __typename?: "CreditLimitChangeRequestStatusHistory";
  /** The date and time when the status changed, in ISO 8601 format. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The new status. */
  newStatus?: Maybe<CreditLimitChangeRequestStatus>;
  /** The previous status. */
  previousStatus?: Maybe<CreditLimitChangeRequestStatus>;
};

/** Types of `CreditLimitChangeRequest`. */
export enum CreditLimitChangeRequestType {
  DECREASE = "DECREASE",
  INCREASE = "INCREASE",
}

/** Possible requestors of `CreditLimitChangeRequest`. */
export enum CreditLimitChangeRequestor {
  CUSTOMER = "CUSTOMER",
  SUBSCRIBER = "SUBSCRIBER",
}

/** A Spend Control rule that blocks transactions if the amount is above a configured percentage of the account's credit limit. */
export type CreditLimitPercentageSpendRule = Node &
  SpendRule & {
    __typename?: "CreditLimitPercentageSpendRule";
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the `CreditLimitPercentageSpendRule` in operations. */
    id: Scalars["ID"];
    /** The maximum percentage of the credit limit allowed for a transaction before transactions are declined. */
    maximumPercentageOfCreditLimit?: Maybe<Scalars["UnsignedInt"]>;
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/** A Spend Control rule that blocks transactions if the amount is above a configured percentage of the account's credit limit. */
export type CreditLimitPercentageSpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The result of applying a `CreditLimitPercentageSpendRule` to an event. */
export type CreditLimitPercentageSpendRuleResult = SpendRuleResult & {
  __typename?: "CreditLimitPercentageSpendRuleResult";
  /** The attached level. */
  attachedLevel?: Maybe<AttachedLevel>;
  /** A message describing the result. */
  message?: Maybe<Scalars["String"]>;
  /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
  recommendation?: Maybe<SpendRuleRecommendation>;
  /** The spend rule attached at the time of the event. */
  spendRule?: Maybe<CreditLimitPercentageSpendRule>;
};

/** This event encapsulates the impacted account and credit amount for a `ManualAdjustmentEvent`. */
export type CreditManualAdjustmentDetail = {
  __typename?: "CreditManualAdjustmentDetail";
  /** The `Amount` of the manual adjustment. */
  amount?: Maybe<Amount>;
  /** The account that got impacted */
  financialAccount?: Maybe<FinancialAccount>;
  /** The name of the `Ledger`. */
  ledgerName?: Maybe<LedgerName>;
  /** The normal balance type of the `Ledger`. */
  normalBalance?: Maybe<NormalBalance>;
};

/** The minimum payment configuration available on a `CardProduct`. For example, whether the minimum payment includes the past due amount, interest, and fees. */
export type CreditMinimumPaymentCardProductConfiguration = {
  __typename?: "CreditMinimumPaymentCardProductConfiguration";
  /** Whether the minimum payment includes fees charged or not. */
  includesFeesCharged?: Maybe<Scalars["Boolean"]>;
  /** Whether the minimum payment includes interest amount or not. */
  includesInterestAmount?: Maybe<Scalars["Boolean"]>;
  /** Whether the minimum payment includes past due amount or not. */
  includesPastDueAmount?: Maybe<Scalars["Boolean"]>;
  /** The percentage of the card balance used to calculate the minimum payment. A value of '100' indicates '100%'. */
  percentage?: Maybe<Scalars["Float"]>;
  /** The minimum threshold for the minimum payment. For example, minimum payments are at least $25. */
  thresholdAmount?: Maybe<Amount>;
};

/** The input type for the minimum payment configuration available on a `CardProduct`. For example, whether the minimum payment includes the past due amount, interest, and fees. */
export type CreditMinimumPaymentCardProductConfigurationInput = {
  /** The percentage of the card balance used to calculate the minimum payment. Must be between 0 and 100. A value of '100' indicates '100%'. */
  percentage: Scalars["Float"];
  /** The minimum threshold for the minimum payment. For example, minimum payments are at least $25. Must be greater than or equal to zero. */
  thresholdAmount: AmountInput;
};

/** Statement for credit pay in full card accounts */
export type CreditPayInFullCardFinancialAccountStatement =
  FinancialAccountStatement &
    Node & {
      __typename?: "CreditPayInFullCardFinancialAccountStatement";
      /** The interest and fees that an account has accumulated as it relates to a `FinancialAccountStatement`. */
      accumulatedAccountInterestAndFees?: Maybe<AccumulatedAccountInterestAndFees>;
      /** The timestamp, in ISO 8601 format, the statement was closed. */
      closedAt?: Maybe<Scalars["String"]>;
      /** The date and time, in ISO 8601 format, this was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** The credit limit at the end of the period. */
      endingCreditLimit?: Maybe<Amount>;
      /** The credit balance at the end of the period for the primary ledger. */
      endingPrimaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the end of the period for the primary ledger. */
      endingPrimaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the end of the period for the secondary ledger. */
      endingSecondaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the end of the period for the secondary ledger. */
      endingSecondaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the end of the period for the tertiary ledger. */
      endingTertiaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the end of the period for the tertiary ledger. */
      endingTertiaryDebitBalance?: Maybe<Amount>;
      /** The unique id of the `FinancialAccountStatement`. */
      id: Scalars["ID"];
      /** The timestamp, in ISO 8601 format, the statement was opened. */
      openedAt?: Maybe<Scalars["String"]>;
      /** The past due balance on the Financial Account as of the close of the statement’s billing cycle. */
      pastDueAmount?: Maybe<Amount>;
      /** The date, in ISO 8601 format, payment is due on end of day. */
      paymentDueOn?: Maybe<Scalars["String"]>;
      /** The date, in ISO 8601 format, the statement period ends. */
      periodEnd?: Maybe<Scalars["String"]>;
      /** The total fee credit (for example due to waiving fees) for the statement period. */
      periodFeeCredit?: Maybe<Amount>;
      /** The total from fees for the statement period. */
      periodFeesAmount?: Maybe<Amount>;
      /** The total from purchases for the statement period. */
      periodPurchasesAmount?: Maybe<Amount>;
      /** The total refunds and payments for the statement period. */
      periodRefundsAndPaymentsAmount?: Maybe<Amount>;
      /** The date, in ISO 8601 format, the statement period starts. */
      periodStart?: Maybe<Scalars["String"]>;
      /** The ledger associated with the primary balance */
      primaryLedger?: Maybe<Ledger>;
      /** History of repayments per statement */
      repaymentHistory?: Maybe<Array<CreditRepaymentStatementApplication>>;
      /** The ledger associated with the primary balance */
      secondaryLedger?: Maybe<Ledger>;
      /** The credit balance at the start of the period for the primary ledger. */
      startingPrimaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the start of the period for the primary ledger. */
      startingPrimaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the start of the period for the secondary ledger. */
      startingSecondaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the start of the period for the secondary ledger. */
      startingSecondaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the start of the period for the tertiary ledger. */
      startingTertiaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the start of the period for the tertiary ledger. */
      startingTertiaryDebitBalance?: Maybe<Amount>;
      /**
       * statement entries.
       *
       * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
       */
      statementEntries?: Maybe<FinancialAccountStatementEntryConnection>;
      /** The ledger associated with the tertiary balance */
      tertiaryLedger?: Maybe<Ledger>;
      /** The date and time, in ISO 8601 format, this was most recently updated. */
      updatedAt?: Maybe<Scalars["String"]>;
    };

/** Statement for credit pay in full card accounts */
export type CreditPayInFullCardFinancialAccountStatementStatementEntriesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<FinancialAccountStatementEntriesFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Statement entry for credit pay in full card */
export type CreditPayInFullCardFinancialAccountStatementEntry =
  FinancialAccountStatementEntry & {
    __typename?: "CreditPayInFullCardFinancialAccountStatementEntry";
    /** The date and time, in ISO 8601 format, this was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Credit amount of the transaction. */
    creditAmount?: Maybe<Amount>;
    /** Debit amount of the transaction. */
    debitAmount?: Maybe<Amount>;
    /** Ledger Entry for the entry */
    ledgerEntry?: Maybe<LedgerEntry>;
    /** The date, in ISO 8601 format, the transaction was posted. (Different word for 'posted'?) */
    postDate?: Maybe<Scalars["String"]>;
    /** Credit balance of the account. */
    primaryCreditBalance?: Maybe<Amount>;
    /** Debit balance of the account. */
    primaryDebitBalance?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, this was most recently updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Current account snapshot for a credit pay in full card */
export type CreditPayInFullCardFinancialAccountStatementSnapshot =
  FinancialAccountStatementSnapshot & {
    __typename?: "CreditPayInFullCardFinancialAccountStatementSnapshot";
    /**
     * The date and time, in ISO 8601 format, the snapshot was calculated.
     * Note that this will be the date/time of the last impactful event.
     */
    asOf?: Maybe<Scalars["String"]>;
    /** The ending balance from the `latestClosedStatement`, minus any payments that have been cleared and processed. */
    currentAmountDue?: Maybe<Amount>;
    /** The current open statement */
    currentOpenStatement?: Maybe<FinancialAccountStatement>;
    /** The most recently closed statement */
    latestClosedStatement?: Maybe<FinancialAccountStatement>;
    /** The date and time, in ISO 8601 format, this was most recently updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Delinquency for a `FinancialAccount` associated with a credit pay in full product. */
export type CreditPayInFullFinancialAccountDelinquency =
  FinancialAccountDelinquency & {
    __typename?: "CreditPayInFullFinancialAccountDelinquency";
    /** A list of contiguous billing cycles where this `FinancialAccount` was delinquent. */
    currentDelinquentCycles?: Maybe<
      Array<Maybe<CreditPayInFullFinancialAccountDelinquencyCycle>>
    >;
    /** The due date of the oldest contiguous delinquent Statement. Null if the `FinancialAccount` is not currently delinquent. */
    delinquencyStartedOn?: Maybe<Scalars["String"]>;
    /** Count of contiguous delinquent cycles for this `FinancialAccount`. 0 if the `FinancialAccount` is not currently delinquent. */
    numberOfCycles?: Maybe<Scalars["UnsignedInt"]>;
    /** The current amount deliquent, including any interest or fees, for this `FinancialAccount`. */
    totalAmount?: Maybe<Amount>;
    /** Number of days since the due date of the oldest contiguous delinquent statement. 0 if the `FinancialAccount` is not currently delinquent. */
    totalDaysDelinquent?: Maybe<Scalars["UnsignedInt"]>;
  };

/** A billing cycle where a `FinancialAccount` associated with a credit pay in full product is delinquent at some point. */
export type CreditPayInFullFinancialAccountDelinquencyCycle =
  FinancialAccountDelinquencyCycle & {
    __typename?: "CreditPayInFullFinancialAccountDelinquencyCycle";
    /** The amount delinquent, including any interest or fees, at the periodEnd of this cycle. */
    amount?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, this was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Days elapsed between the due date of the oldest contiguous delinquent cycle and the periodEnd of this cycle. */
    daysDelinquent?: Maybe<Scalars["UnsignedInt"]>;
    /** A list of repayments applied to this billing cycle. Please note that only the first 20 repayments for a cycle will be returned. */
    repayments?: Maybe<Array<CreditRepaymentStatementApplication>>;
    /** The delinquency state of this `FinancialAccount` at the periodEnd of this cycle, such as CURRENT, DELINQUENT, or CLOSING. */
    state?: Maybe<FinancialAccountDelinquencyState>;
    /** The financial account statement for this billing cycle. Includes information such as periodStart, periodEnd, and paymentDueOn. */
    statement?: Maybe<CreditPayInFullCardFinancialAccountStatement>;
    /** The unique identifier for the financial account statement for this billing cycle. */
    statementId: Scalars["ID"];
    /** The total Amount of repayments applied to this billing cycle. */
    totalRepaymentsApplied?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, this was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/**
 * **Deprecated**. Please use `CreditCardAccountFeature` instead.
 *
 * Whether or not the Financial Account supports a Credit Payment Card.
 */
export type CreditPaymentCardFinancialAccountFeature =
  FinancialAccountFeature & {
    __typename?: "CreditPaymentCardFinancialAccountFeature";
    /**
     * The date and time, in ISO 8601 format, the feature was created.
     * @deprecated CreditPaymentCardFinancialAccountFeature is deprecated. Please use CreditCardAccountFeature instead.
     */
    createdAt?: Maybe<Scalars["String"]>;
    /**
     * The date and time, in ISO 8601 format, the feature was effective from.
     * @deprecated CreditPaymentCardFinancialAccountFeature is deprecated. Please use CreditCardAccountFeature instead.
     */
    effectiveFrom?: Maybe<Scalars["String"]>;
    /**
     * The date and time, in ISO 8601 format, the feature was effective through.
     * @deprecated CreditPaymentCardFinancialAccountFeature is deprecated. Please use CreditCardAccountFeature instead.
     */
    effectiveThrough?: Maybe<Scalars["String"]>;
    /**
     * Whether or not the feature is enabled for the Financial Account.
     * @deprecated CreditPaymentCardFinancialAccountFeature is deprecated. Please use CreditCardAccountFeature instead.
     */
    enabled?: Maybe<Scalars["Boolean"]>;
    /**
     * The date and time, in ISO 8601 format, the feature was last updated.
     * @deprecated CreditPaymentCardFinancialAccountFeature is deprecated. Please use CreditCardAccountFeature instead.
     */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** `CreditPlans` define the credit and interest terms of a credit `CardProduct`. For example, they include the interest rate (APR), the way interest will accrue and be assessed, and the effective dates of the plan. */
export type CreditPlan = Node & {
  __typename?: "CreditPlan";
  /** The type of transaction this `CreditPlan` applies to. For example, `PURCHASE`, `CASH_ADVANCE`, `INSTALLMENT`, or `BALANCE_TRANSFER`. */
  balanceType?: Maybe<CreditBalanceType>;
  /** The date and time, in ISO 8601 format, this was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date this plan starts to be in effect for new `FinancialAccount`s, in YYYY-MM-DD (ISO 8601 RFC 3339) date format. For example, `2023-01-15`. */
  effectiveFromDate?: Maybe<Scalars["Date"]>;
  /** The date this plan stops being in effect for new `FinancialAccount`s, in YYYY-MM-DD (ISO 8601 RFC 3339) date format. For example, `2023-02-15`. If null, the plan is treated as indefinite, with no set ending. */
  effectiveThroughDate?: Maybe<Scalars["Date"]>;
  /** The `FeeSchedule` attached to this `CreditPlan`. */
  feeSchedule?: Maybe<FeeSchedule>;
  /** The globally unique identifier for this `CreditPlan`. */
  id: Scalars["ID"];
  /** The installment policy for this `CreditPlan`. */
  installmentPolicy?: Maybe<CreditPlanInstallmentPolicy>;
  /** The interest policy for this `CreditPlan`. */
  interestPolicy?: Maybe<CreditPlanInterestPolicy>;
  /** The name for this `CreditPlan`. Supports up to 255 alphanumeric characters. Does not need to be unique. */
  name?: Maybe<Scalars["String"]>;
  /** The percentage of the `FinancialAccount`'s credit limit that will be available for this `CreditPlan`. */
  percentageOfCreditLimit?: Maybe<Scalars["UnsignedInt"]>;
  /** The type of `CreditPlan`. For example, `STANDARD` or `PROMOTIONAL`. */
  planType?: Maybe<CreditPlanType>;
  /** For `PROMOTIONAL` plans, the promotional policy for this `CreditPlan`. */
  promotionalPolicy?: Maybe<CreditPlanPromotionalPolicy>;
  /** The risk based pricing policy for this `CreditPlan`. */
  riskBasedPricingPolicy?: Maybe<RiskBasedPricingPolicy>;
  /** The status of this `CreditPlan`. For example, `ACTIVE`, `INACTIVE`, or `DEPRECATED`. */
  status?: Maybe<CreditPlanStatus>;
  /** The date and time, in ISO 8601 format, this was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The connection type for a `CreditPlan`. */
export type CreditPlanConnection = {
  __typename?: "CreditPlanConnection";
  /** A list of edges. */
  edges?: Maybe<Array<CreditPlanEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The duration type for `CreditPlan`. */
export type CreditPlanDuration = {
  __typename?: "CreditPlanDuration";
  /** The units used to express this duration. For example, `BILLING_CYCLES`. */
  units?: Maybe<CreditPlanDurationUnits>;
  /** The number of units this `CreditPlan` will be in effect for a given `FinancialAccount` once it is enrolled in this `CreditPlan`. */
  value?: Maybe<Scalars["UnsignedInt"]>;
};

/** The units used to express the duration of a `CreditPlan`, for example `BILLING_CYCLES`. */
export enum CreditPlanDurationUnits {
  /** The time between billings. At the end of a billing cycle, a `FinancialAccountStatement` is generated. Generally, there will be a grace period before Payment is due. */
  BILLING_CYCLES = "BILLING_CYCLES",
}

/** The edge type for a `CreditPlan`. */
export type CreditPlanEdge = {
  __typename?: "CreditPlanEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The `CreditPlan`. */
  node?: Maybe<CreditPlan>;
};

/** The input type for `CreditPlan` fee configuration. Currently only used for `CreditPlan`s of `CreditBalanceType` `INSTALLMENT`. */
export type CreditPlanFeeInput = {
  /** The identifier for the `FeeSchedule` to attach to the `CreditPlan`. */
  scheduleId?: InputMaybe<Scalars["ID"]>;
};

/** The input type for filtering `CreditPlan`. */
export type CreditPlanFilterInput = {
  /** The type of balance. For example, `PURCHASE` or `INSTALLMENT`. */
  balanceType?: InputMaybe<CreditBalanceType>;
  /** The type of `CreditPlan`. For example, `STANDARD` or `PROMOTIONAL`. */
  planType?: InputMaybe<CreditPlanType>;
  /** The status of the `CreditPlan`. For example, `INACTIVE` or `ACTIVE`. */
  status?: InputMaybe<CreditPlanStatus>;
};

/** The credit configuration values for `CreditPlan`s available on a `FinancialAccount`. For example, the interest rate configured for this `FinancialAccount` for this `CreditPlan`. */
export type CreditPlanFinancialAccountConfiguration = {
  __typename?: "CreditPlanFinancialAccountConfiguration";
  /** The type of balance this configuration applies to. For example, `PURCHASE`, `CASH_ADVANCE`, `INSTALLMENT`, or `BALANCE_TRANSFER`. */
  balanceType?: Maybe<CreditBalanceType>;
  /** The `CreditPlan` this configuration applies to. */
  creditPlan?: Maybe<CreditPlan>;
  /** Details about the interest that will be charged, such as the annual percentage rate (APR). */
  interest?: Maybe<InterestDetails>;
};

/** The installment policy for this `CreditPlan`. */
export type CreditPlanInstallmentPolicy = {
  __typename?: "CreditPlanInstallmentPolicy";
  /** The number of periods for an `InstallmentAgreement` based on this `CreditPlan`. */
  numberOfPeriods?: Maybe<Scalars["UnsignedInt"]>;
  /** The minimum and maximum cleared `Amount` a `Transaction` can have to be eligible to convert into installments. */
  principalAmountRange?: Maybe<AmountRange>;
};

/** The interest policy for this `CreditPlan`. */
export type CreditPlanInterestPolicy = {
  __typename?: "CreditPlanInterestPolicy";
  /** The date used to calculate interest accrual. For example, `TRANSACTION_POST_DATE`, `FIRST_DAY_OF_BILLING_PERIOD`, or `PAYMENT_DUE_DATE`. */
  accrualMethod?: Maybe<InterestAccrualMethod>;
  /** Whether interest accrues using a `SIMPLE` or `COMPOUND` formula. */
  accrualType?: Maybe<InterestAccrualType>;
  /** Whether interest is assessed `DAILY` or on the `STATEMENT` cycle close date. */
  assessmentSchedule?: Maybe<InterestAssessmentSchedule>;
  /** The default interest rate (APR) for this `CreditPlan`, expressed as a `Float` with up to 3 digit precision after the decimal point. */
  defaultApr?: Maybe<Scalars["Float"]>;
  /** For variable interest rates only. The current configuration of the index used to derive the variable APR. */
  index?: Maybe<InterestRateIndexConfiguration>;
  /** Whether the interest rate is fixed or variable. */
  rateType?: Maybe<InterestRateType>;
  /** The Servicemembers Civil Relief Act (SCRA) interest rate for this `CreditPlan`, expressed as a `Float` with up to 3 digit precision after the decimal point. */
  scraApr?: Maybe<Scalars["Float"]>;
};

/** The promotional policy for this `CreditPlan`. */
export type CreditPlanPromotionalPolicy = {
  __typename?: "CreditPlanPromotionalPolicy";
  /** The number of units this `CreditPlan` will be in effect for a given `FinancialAccount` once it is enrolled in this `CreditPlan`. */
  duration?: Maybe<CreditPlanDuration>;
};

/** The status of the `CreditPlan`. For example, `ACTIVE`, `INACTIVE`, or `DEPRECATED`. */
export enum CreditPlanStatus {
  ACTIVE = "ACTIVE",
  DEPRECATED = "DEPRECATED",
  INACTIVE = "INACTIVE",
}

/** `CreditPlanTemplates` provide a base configuration for creating a `CreditPlan`. For example, they define the interest policy, the transaction and plan types, and the maximum credit limit allowed by the `CreditPlan`. */
export type CreditPlanTemplate = Node & {
  __typename?: "CreditPlanTemplate";
  /** The type of transaction this `CreditPlanTemplate` applies to. For example, `PURCHASE`, `CASH_ADVANCE`, `INSTALLMENT`, or `BALANCE_TRANSFER`. */
  balanceType?: Maybe<CreditBalanceType>;
  /** The date and time, in ISO 8601 format, this was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The globally unique identifier for this `CreditPlanTemplate`. */
  id: Scalars["ID"];
  /** The installment policy for this `CreditPlanTemplate`. */
  installmentPolicy?: Maybe<CreditPlanTemplateInstallmentPolicy>;
  /** The interest policy for this `CreditPlanTemplate`. */
  interestPolicy?: Maybe<CreditPlanTemplateInterestPolicy>;
  /** The maximum credit limit allowed by this plan, expressed as an `Amount`. */
  maximumCreditLimit?: Maybe<Amount>;
  /** The name for this `CreditPlanTemplate`. Supports up to 255 alphanumeric characters. Does not need to be unique. */
  name?: Maybe<Scalars["String"]>;
  /** The type of `CreditPlan` this template supports. For example, `STANDARD` or `PROMOTIONAL`. */
  planType?: Maybe<CreditPlanType>;
  /** The promotional policy for this `CreditPlanTemplate`. */
  promotionalPolicy?: Maybe<CreditPlanTemplatePromotionalPolicy>;
  /** The risk based pricing policy for this `CreditPlanTemplate`. */
  riskBasedPricingPolicy?: Maybe<RiskBasedPricingPolicy>;
  /** The status of this `CreditPlanTemplate`. For example, `ACTIVE`, `INACTIVE`, or `DEPRECATED`. */
  status?: Maybe<CreditPlanTemplateStatus>;
  /** The date and time, in ISO 8601 format, this was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The connection type for a `CreditPlanTemplate`. */
export type CreditPlanTemplateConnection = {
  __typename?: "CreditPlanTemplateConnection";
  /** A list of edges. */
  edges?: Maybe<Array<CreditPlanTemplateEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a `CreditPlanTemplate`. */
export type CreditPlanTemplateEdge = {
  __typename?: "CreditPlanTemplateEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The `CreditPlanTemplate`. */
  node?: Maybe<CreditPlanTemplate>;
};

/** The input type for filtering `CreditPlanTemplate`. */
export type CreditPlanTemplateFilterInput = {
  /** The type of balance. For example, `PURCHASE` or `INSTALLMENT`. */
  balanceType?: InputMaybe<CreditBalanceType>;
};

/** The installment policy for this `CreditPlanTemplate`. */
export type CreditPlanTemplateInstallmentPolicy = {
  __typename?: "CreditPlanTemplateInstallmentPolicy";
  /** The minimum and maximum number of periods allowed for an `InstallmentAgreement` created from this `CreditPlanTemplate`. For example, if the range is 1 to 6 periods, a duration of 3 would be allowed but a duration of 7 would not. */
  numberOfPeriodsRange?: Maybe<UnsignedIntegerRange>;
  /** The minimum and maximum `Amount`s that can be converted into an `InstallmentAgreement` created from this `CreditPlanTemplate`. */
  principalAmountRange?: Maybe<AmountRange>;
};

/** The interest policy for this `CreditPlanTemplate`. */
export type CreditPlanTemplateInterestPolicy = {
  __typename?: "CreditPlanTemplateInterestPolicy";
  /** The date used to calculate interest accrual. For example, `TRANSACTION_POST_DATE`, `FIRST_DAY_OF_BILLING_PERIOD`, or `PAYMENT_DUE_DATE`. */
  accrualMethod?: Maybe<InterestAccrualMethod>;
  /** Whether interest accrues using a `SIMPLE` or `COMPOUND` formula. */
  accrualType?: Maybe<InterestAccrualType>;
  /** The range of potential interest rates (APRs) available through this `CreditPlanTemplate`. */
  aprRange?: Maybe<InterestRateRange>;
  /** Whether interest is assessed `DAILY` or on the `STATEMENT` cycle close date. */
  assessmentSchedule?: Maybe<InterestAssessmentSchedule>;
  /** Whether the interest rate is fixed or variable. */
  rateType?: Maybe<InterestRateType>;
  /** The Servicemembers Civil Relief Act (SCRA) interest rate for this `CreditPlanTemplate`, expressed as a `Float` with up to 3 digit precision after the decimal point. */
  scraApr?: Maybe<Scalars["Float"]>;
  /** The index used for interest rate calculation. For example, `PRIME` or `LIBOR`. */
  variableAprIndex?: Maybe<InterestRateIndex>;
};

/** The promotional policy for this `CreditPlanTemplate`. */
export type CreditPlanTemplatePromotionalPolicy = {
  __typename?: "CreditPlanTemplatePromotionalPolicy";
  /** The units used to express the duration of a `CreditPlan`, for example `BILLING_CYCLES`. The specific duration value is defined when creating a `PROMOTIONAL` `CreditPlan`. */
  durationUnits?: Maybe<CreditPlanDurationUnits>;
};

/** The status of the `CreditPlanTemplate`. For example, `ACTIVE`, `INACTIVE`, or `DEPRECATED`. */
export enum CreditPlanTemplateStatus {
  ACTIVE = "ACTIVE",
  DEPRECATED = "DEPRECATED",
  INACTIVE = "INACTIVE",
}

/** The terms in play for a `CreditPlan`, such as interest rate. */
export type CreditPlanTerms = {
  __typename?: "CreditPlanTerms";
  /** The `CreditPlan` for this configuration. */
  creditPlan?: Maybe<CreditPlan>;
  /** Details about the interest that will be charged, such as the annual percentage rate (APR). */
  interest?: Maybe<InterestDetails>;
};

/** The type of `CreditPlan`. For example, `STANDARD` or `PROMOTIONAL`. */
export enum CreditPlanType {
  PROMOTIONAL = "PROMOTIONAL",
  STANDARD = "STANDARD",
}

/** A payment towards a balance owed for a credit product. */
export type CreditRepayment = {
  __typename?: "CreditRepayment";
  /** The total amount of the repayment. */
  amount?: Maybe<Amount>;
  /** The date and time this was created, in ISO 8601 format. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Used for manual credit repayments. This field represents notes about the adjustment. Can include UTF-8 or ASCII characters, with a maximum length of 1024 characters. */
  memo?: Maybe<Scalars["String"]>;
  /** Used for manual credit repayments. This is a list of references, such as support ticket identifiers or other external identifiers. Can include UTF-8 or ASCII characters, with a maximum length of 255 characters for each reference. */
  references?: Maybe<Array<Scalars["String"]>>;
  /** The method used to repay the credit balance. For example, `ACH`. */
  repaymentMethod?: Maybe<CreditRepaymentMethod>;
  /** Whether the repayment decreases (`CREDIT`) or increases (`DEBIT`) the owed balance. */
  repaymentType?: Maybe<CreditRepaymentType>;
  /** The date and time this was updated, in ISO 8601 format. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The repayment configuration available on a `CardProduct`. */
export type CreditRepaymentCardProductConfiguration = {
  __typename?: "CreditRepaymentCardProductConfiguration";
  /** The order in which to apply a repayment across categories such as principal, interest, and fees. */
  repaymentWaterfall?: Maybe<Array<RepaymentCategory>>;
};

/** The methods available to repay a credit balance. For example, `ACH`. */
export enum CreditRepaymentMethod {
  ACH = "ACH",
  FEE_ADJUSTMENT = "FEE_ADJUSTMENT",
  INTEREST_ADJUSTMENT = "INTEREST_ADJUSTMENT",
  MANUAL_ADJUSTMENT = "MANUAL_ADJUSTMENT",
  REWARD_BALANCE = "REWARD_BALANCE",
}

/** An application of a repayment to a statement. */
export type CreditRepaymentStatementApplication = {
  __typename?: "CreditRepaymentStatementApplication";
  /** The amount applied to this statement. */
  appliedAmount?: Maybe<Amount>;
  /** The `CreditRepayment` associated with this `CreditRepaymentStatementApplication`. */
  sourceRepayment?: Maybe<CreditRepayment>;
  /** The statement this repayment is being applied to. */
  statement?: Maybe<FinancialAccountStatement>;
};

/** Whether the Credit Repayment decreases the owed balance (a `CREDIT`) or increases the owed balance (a `DEBIT`). */
export enum CreditRepaymentType {
  CREDIT = "CREDIT",
  DEBIT = "DEBIT",
}

/** The `AccountHolderCardProductApplication` fields that were confirmed in response to a fraud alert on the applicant's credit report. */
export type CreditReportFraudAlertVerificationResult = {
  __typename?: "CreditReportFraudAlertVerificationResult";
  /** Whether or not the `AccountHolder`initiated this application. */
  accountHolderInitiatedApplication: Scalars["Boolean"];
  /** Whether or not the `AccountHolder` mailing address on the application matches the applicant. */
  address: Scalars["Boolean"];
  /** Whether or not the `AccountHolder` date of birth on the application matches the applicant. */
  dateOfBirth: Scalars["Boolean"];
  /** Whether or not the `AccountHolder` name on the application matches the applicant. */
  name: Scalars["Boolean"];
};

/** A type representing credit risk attributes. */
export type CreditRiskAttributes = {
  __typename?: "CreditRiskAttributes";
  /** Annual revenue expressed as an Amount. */
  annualRevenue?: Maybe<Array<Maybe<Amount>>>;
};

/** Input fields for credit risk attributes. */
export type CreditRiskAttributesInput = {
  /** Annual revenue expressed as an AmountInput. */
  annualRevenue?: InputMaybe<Array<InputMaybe<AmountInput>>>;
};

/** Details about the factors considered behind specific credit scores. */
export type CreditScoreModel = {
  __typename?: "CreditScoreModel";
  /** Credit Score at time of underwriting. */
  creditScore?: Maybe<Scalars["String"]>;
  /** A list of reasons from the credit decision for a specific credit score. */
  creditScoreReasons?: Maybe<Array<Scalars["String"]>>;
  /** Credit Score Type */
  creditScoreType?: Maybe<Scalars["String"]>;
};

/** Whether statement cycles are `WEEKLY` or `MONTHLY`. */
export enum CreditStatementCyclePeriod {
  MONTHLY = "MONTHLY",
  WEEKLY = "WEEKLY",
}

/** Whether the grace period is `FLOATING` or `FIXED`. */
export enum CreditStatementGracePeriodType {
  FIXED = "FIXED",
  FLOATING = "FLOATING",
}

/** A Transaction which credits money to a PaymentCard. */
export type CreditTransaction = Node & {
  __typename?: "CreditTransaction";
  /** The ID of the transaction. This `id` can be used to later retrieve details of this Transaction. */
  id: Scalars["ID"];
  /** The list of TransactionEvents related to this Transaction. */
  transactionEvents?: Maybe<Array<TransactionEvent>>;
};

/** A Transaction which credits money to a PaymentCard. */
export type CreditTransactionTransactionEventsArgs = {
  eventTypes?: InputMaybe<Array<TransactionEventFilter>>;
};

/** A type representing the current state in the credit underwriting process. */
export type CreditUnderwritingVerification = {
  __typename?: "CreditUnderwritingVerification";
  /** Details about the credit score associated with this decision. */
  creditScoreDetails?: Maybe<CreditUnderwritingVerificationCreditScoreDetails>;
  /** The credit underwriting decision. */
  decision?: Maybe<UnderwriterDecision>;
  /** The date and time, in ISO 8601 format for a given application underwriting decision date. */
  decisionDate?: Maybe<Scalars["String"]>;
  /** A list of results from the credit decision. */
  decisionResults?: Maybe<Array<CreditDecisionResult>>;
  /** Details about an `IN_REVIEW` `UnderwritingVerificationStatusCode`. Only present if `IN_REVIEW`. */
  reviewReasonDetails?: Maybe<CreditUnderwritingVerificationReviewReasonDetails>;
  /** The current underwriting status. */
  status?: Maybe<UnderwriterVerificationStatusCode>;
};

/** Details about the source, model, and retrieval context for a specific credit score used in underwriting. */
export type CreditUnderwritingVerificationCreditScoreDetails = {
  __typename?: "CreditUnderwritingVerificationCreditScoreDetails";
  /** Credit Bureau that sourced this credit score */
  creditBureau?: Maybe<CreditBureau>;
  /** The date when the credit report was pulled. */
  creditReportPullDate?: Maybe<Scalars["String"]>;
  /** Credit Score Model */
  creditScoreModels?: Maybe<Array<CreditScoreModel>>;
};

/** Details about why a `CreditUnderwritingVerification` is in `IN_REVIEW` status. */
export type CreditUnderwritingVerificationReviewReasonDetails = {
  __typename?: "CreditUnderwritingVerificationReviewReasonDetails";
  /** Optional memo field for the reason for `CreditUnderwritingVerification` to be `IN_REVIEW`. */
  memo?: Maybe<Scalars["String"]>;
  /** The reason for `CreditUnderwritingVerification` to be `IN_REVIEW`. */
  reviewReason?: Maybe<CreditUnderwritingVerificationReviewStatusReasonCode>;
};

/** Reasons for `CreditUnderwritingVerification` to be `IN_REVIEW` status. */
export enum CreditUnderwritingVerificationReviewStatusReasonCode {
  /** The account holder has placed a freeze on their credit report. Their report must be unfrozen in order to process an application. */
  AWAITING_CREDIT_REPORT_TO_BE_UNFROZEN = "AWAITING_CREDIT_REPORT_TO_BE_UNFROZEN",
  /** The account holder has placed a fraud alert on their credit report. Their application data must be verified by phone. */
  AWAITING_FRAUD_ALERT_REVIEW = "AWAITING_FRAUD_ALERT_REVIEW",
}

/** All possible cumulative rules to be used with a `VelocityInterFinancialAccountTransferRule` */
export type CumulativeInterFinancialAccountTransferRule =
  | AmountLimitInterFinancialAccountTransferRule
  | CountLimitInterFinancialAccountTransferRule;

/** The current delinquency state of this `FinancialAccount`. */
export type CurrentFinancialAccountDelinquencyState = {
  __typename?: "CurrentFinancialAccountDelinquencyState";
  /** The delinquency state, such as CURRENT, DELINQUENT, or CLOSING. */
  state?: Maybe<FinancialAccountDelinquencyState>;
  /** The date and time, in ISO 8601 format, the `FinancialAccount` transitioned to this state. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The interface for an element of `CustomFields`. */
export type CustomField = {
  /** The key of the custom field. */
  key: Scalars["String"];
};

/** The input to specify a `CustomFields` key value pair. */
export type CustomFieldInput = {
  /** The key of the custom field. */
  key: Scalars["String"];
  /** The value of the custom field. */
  value: Scalars["String"];
};

/** Inputs for filtering `CustomFields`. */
export type CustomFieldsFilterInput = {
  /** Value matches the provided `String`. */
  equals?: InputMaybe<CustomFieldInput>;
  /** Value does not match any of the provided `Strings`. */
  excludes?: InputMaybe<Array<CustomFieldInput>>;
  /** Value exactly matches any of the provided `Strings`. */
  includes?: InputMaybe<Array<CustomFieldInput>>;
  /** Value does not match the provided `String`. */
  notEquals?: InputMaybe<CustomFieldInput>;
};

/** The return types for `CustomFields`. */
export type CustomFieldsPayload =
  | AccessDeniedError
  | CustomFieldsResult
  | UserError;

/** The result object returned when you update CustomFields. */
export type CustomFieldsResult = {
  __typename?: "CustomFieldsResult";
  /** The `CustomFields` associated with the object. */
  customFields?: Maybe<Array<CustomField>>;
};

/** The string value data type for an element of `CustomFields`. */
export type CustomStringField = CustomField & {
  __typename?: "CustomStringField";
  /** The key of the custom field. */
  key: Scalars["String"];
  /** The value of the custom field. */
  value: Scalars["String"];
};

/** Type for customer */
export type Customer = {
  __typename?: "Customer";
  /**
   * The customer identifier that can be used to uniquely identify the `Customer` on subscriber side.
   *
   * This can be either an external identifier defined on the subscriber side, or an `AccountHolder` ID to associate the customer with that `AccountHolder`.
   */
  customerIdentifier?: Maybe<Scalars["String"]>;
  /** The associated account holder if present in Highnote system. */
  referenceNode?: Maybe<CustomerReferencePayload>;
  /** Payment methods associated to the `Customer`. */
  wallet?: Maybe<PaymentMethodConnectionPayload>;
};

/** Type for customer */
export type CustomerWalletArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy: FilteredPaymentMethodInput;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Saved `CustomerAddress` details. */
export type CustomerAddress = Node & {
  __typename?: "CustomerAddress";
  /** The saved `Address`. */
  address?: Maybe<Address>;
  /** The company name associated to this address. */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the date this `CustomerAddress` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the `CustomerAddress`. */
  id: Scalars["ID"];
  /** The name associated with the `CustomerAddress`. */
  name?: Maybe<Name>;
  /** A short lived scoped address token for the `CustomerAddress`. */
  token?: Maybe<ScopedCustomerAddressTokenPayload>;
  /** The date and time, in ISO 8601 format, the date this `CustomerAddress` was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Saved `CustomerAddress` details. */
export type CustomerAddressTokenArgs = {
  scope: AddressTokenScope;
};

/** Input for customer contact information. */
export type CustomerContactInput = {
  /** The email of the customer. */
  email: Scalars["String"];
  /** The family name of the customer. */
  familyName: Scalars["String"];
  /** The given name of the customer. */
  givenName: Scalars["String"];
  /** The phone number of the customer. */
  phone?: InputMaybe<PhoneInput>;
};

/** Saved Email contact details. */
export type CustomerEmailContactMethod = Node & {
  __typename?: "CustomerEmailContactMethod";
  /** The date and time, in ISO 8601 format, the date this `CustomerEmailContactMethod` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the `CustomerEmailContactMethod`. */
  id: Scalars["ID"];
  /** The date and time, in ISO 8601 format, the date this `CustomerEmailContactMethod` was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Saved `CustomerName` details. */
export type CustomerName = Node & {
  __typename?: "CustomerName";
  /** The date and time, in ISO 8601 format, the date this `CustomerName` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the `CustomerName`. */
  id: Scalars["ID"];
  /** The date and time, in ISO 8601 format, the date this `CustomerName` was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Types which can be returned for a `Customer`. */
export type CustomerPayload = AccessDeniedError | Customer | UserError;

/** Saved `CustomerPhone` details. */
export type CustomerPhone = Node & {
  __typename?: "CustomerPhone";
  /** The date and time, in ISO 8601 format, the date this `CustomerPhone` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the `CustomerPhone`. */
  id: Scalars["ID"];
  /** The date and time, in ISO 8601 format, the date this `CustomerPhone` was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Types to expect when looking up a customer. */
export type CustomerReferencePayload =
  | UsBusinessAccountHolder
  | UsBusinessAuthorizedPerson
  | UsPersonAccountHolder
  | UsPersonAuthorizedUser;

/** Saved Website contact details. */
export type CustomerWebsiteContactMethod = Node & {
  __typename?: "CustomerWebsiteContactMethod";
  /** The date and time, in ISO 8601 format, the date this `CustomerWebsiteContactMethod` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the `CustomerWebsiteContactMethod`. */
  id: Scalars["ID"];
  /** The date and time, in ISO 8601 format, the date this `CustomerWebsiteContactMethod` was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/**
 * Input for filtering dates.
 *
 * The format for each `String` field should be in YYYY-MM-DD format.
 *
 * Example: `2021-11-12`
 */
export type DateFilterInput = {
  /** Value to filter to dates that fall between values. */
  between?: InputMaybe<DateFilterInputRange>;
  /** An ISO 8601 value that exactly matches the provided `String`. */
  equals?: InputMaybe<Scalars["String"]>;
  /** An ISO 8601 value to filter to dates after the given `String`. */
  greaterThan?: InputMaybe<Scalars["String"]>;
  /** An ISO 8601 value to filter to dates that match or are after the given `String`. */
  greaterThanOrEquals?: InputMaybe<Scalars["String"]>;
  /** An ISO 8601 value to filter to dates before the given `String`. */
  lessThan?: InputMaybe<Scalars["String"]>;
  /** An ISO 8601 value to filter to dates that match or are before the given `String`. */
  lessThanOrEquals?: InputMaybe<Scalars["String"]>;
  /** An ISO 8601 value that does not match the provided `String`. */
  notEquals?: InputMaybe<Scalars["String"]>;
};

/**
 * Input for filtering by date value ranges (inclusive).
 *
 * The format for each `String` field should be in YYYY-MM-DD format.
 *
 * Example: `2021-11-12`
 */
export type DateFilterInputRange = {
  /** An ISO 8601 value (inclusive) for the ending date. */
  end?: InputMaybe<Scalars["String"]>;
  /** An ISO 8601 value (inclusive) for the beginning date. */
  start?: InputMaybe<Scalars["String"]>;
};

/** A Spend Control rule that blocks transactions if the card's `FinancialAccount` was created more than a specified number of days ago. */
export type DaysWithinAccountCreateDateSpendRule = Node &
  SpendRule & {
    __typename?: "DaysWithinAccountCreateDateSpendRule";
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the `DaysWithinAccountCreateDateSpendRule` in operations. */
    id: Scalars["ID"];
    /** The maximum number of days since the creation of the `FinancialAccount` before transactions are declined. */
    maximumDaysAccountCreated?: Maybe<Scalars["UnsignedInt"]>;
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/** A Spend Control rule that blocks transactions if the card's `FinancialAccount` was created more than a specified number of days ago. */
export type DaysWithinAccountCreateDateSpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The result of applying a `DaysWithinAccountCreateDateSpendRule` to an event. */
export type DaysWithinAccountCreateDateSpendRuleResult = SpendRuleResult & {
  __typename?: "DaysWithinAccountCreateDateSpendRuleResult";
  /** The attached level. */
  attachedLevel?: Maybe<AttachedLevel>;
  /** The number of days since the `FinancialAccount` was created at the time of the event. */
  daysAccountCreated?: Maybe<Scalars["UnsignedInt"]>;
  /** A message describing the result. */
  message?: Maybe<Scalars["String"]>;
  /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
  recommendation?: Maybe<SpendRuleRecommendation>;
  /** The spend rule attached at the time of the event. */
  spendRule?: Maybe<DaysWithinAccountCreateDateSpendRule>;
};

/** A Spend Control rule that blocks transactions if the `PaymentCard` was created more than a specified number of days ago. */
export type DaysWithinCardCreateDateSpendRule = Node &
  SpendRule & {
    __typename?: "DaysWithinCardCreateDateSpendRule";
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the `DaysWithinCardCreateDateSpendRule` in operations. */
    id: Scalars["ID"];
    /** The maximum number of days elapsed since the creation of the `PaymentCard` before transactions are declined. */
    maximumDaysCardCreated?: Maybe<Scalars["UnsignedInt"]>;
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/** A Spend Control rule that blocks transactions if the `PaymentCard` was created more than a specified number of days ago. */
export type DaysWithinCardCreateDateSpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The result of applying a `DaysWithinCardCreateDateSpendRule` to an event. */
export type DaysWithinCardCreateDateSpendRuleResult = SpendRuleResult & {
  __typename?: "DaysWithinCardCreateDateSpendRuleResult";
  /** The attached level. */
  attachedLevel?: Maybe<AttachedLevel>;
  /** The number of days since the `PaymentCard` was created at the time of the event. */
  daysCardCreated?: Maybe<Scalars["UnsignedInt"]>;
  /** A message describing the result. */
  message?: Maybe<Scalars["String"]>;
  /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
  recommendation?: Maybe<SpendRuleRecommendation>;
  /** The spend rule attached at the time of the event. */
  spendRule?: Maybe<DaysWithinCardCreateDateSpendRule>;
};

/** The input to deactivate a `CollaborativeAuthorizationEndpoint`. */
export type DeactivateCollaborativeAuthorizationEndpointInput = {
  /** The Global ID of the `CollaborativeAuthorizationEndpoint` to deactivate. */
  endpointId: Scalars["ID"];
};

/** The return types when deactivating a `CollaborativeAuthorizationEndpoint`. */
export type DeactivateCollaborativeAuthorizationEndpointPayload =
  | AccessDeniedError
  | CollaborativeAuthorizationEndpoint
  | UserError;

/** The input to deactivate a notification target. */
export type DeactivateNotificationTargetInput = {
  targetId: Scalars["ID"];
};

/** The return types when deactivating a notification target. */
export type DeactivateNotificationTargetPayload =
  | AccessDeniedError
  | UserError
  | WebhookNotificationTarget;

/** A debit transfer to a Highnote account. */
export type DebitFunds = ElectronicFundsTransfer &
  ExternallyInitiatedAchTransfer &
  Node & {
    __typename?: "DebitFunds";
    /** The amount of the transfer. */
    amount?: Maybe<Amount>;
    /** The Card Product associated to the Financial Account. */
    cardProduct?: Maybe<CardProduct>;
    /** The ID of the company that initiated the ACH transfer, ISO 8601 format. */
    companyIdentifier?: Maybe<Scalars["String"]>;
    /** The name of the company that initiated the ACH transfer. */
    companyName?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the transfer was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Descriptive fields about the transfer which may show up on bank reports. */
    descriptor?: Maybe<AchDescriptor>;
    /** The Highnote account receiving the debit. */
    fromFinancialAccount?: Maybe<FinancialAccount>;
    /** Global ID used to reference the transfer in operations. */
    id: Scalars["ID"];
    /** The ledgers affected by the transfer. */
    ledgers?: Maybe<Array<Ledger>>;
    /** The date this transaction was returned, in ISO 8601 format. */
    returnDate?: Maybe<Scalars["String"]>;
    /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
    settlementDate?: Maybe<Scalars["String"]>;
    /** The status of the externally initiated ACH transfer. */
    status?: Maybe<ExternallyInitiatedAchStatusDetails>;
    /** A unique 15 digit number assigned by the originator to identify the transfer. */
    traceNumber?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the transfer was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** A debit transfer to a Highnote account. */
export type DebitFundsLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** A financial event that represents a `DebitFunds` transfer. */
export type DebitFundsAchTransferEvent = AchTransferEvent &
  Node & {
    __typename?: "DebitFundsACHTransferEvent";
    /** The amount of the transfer. */
    amount?: Maybe<Amount>;
    /** Company entered value for the type of ACH. */
    companyEntryDescription?: Maybe<Scalars["String"]>;
    /**
     * The Company Identifier is a 10-position alphameric code used to identify an Originator of the ACH transaction. It may begin with an ANSI one-digit Identification Code Designator (ICD), followed by the Identification Number.
     *
     * |`Identification Code Designator (ICD)`    | `ANSI Identification Number` | Example                                                                         |
     * | ---------------------------------------- | ---------------------------- | ------------------------------------------------------------------------------- |
     * |`IRS Employer Identification Number (EIN)`| 1                            | 1234567890 for an Originator with 234567890 EIN                                 |
     * |`Data Universal Numbering Systems (DUNS)` | 3                            | 30008016958 for an Originator with 0008016958 DUNS                              |
     * |`User Assigned Number`                    | 9                            | 9111111111 for an Originator with 111111111 under assigned Identification Number|
     */
    companyIdentifier?: Maybe<Scalars["String"]>;
    /** The name of the company that initiated the ACH transfer. */
    companyName?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the transfer was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The account debiting the funds. */
    fromFinancialAccount?: Maybe<FinancialAccount>;
    /** Global ID used to reference the transfer in operations. */
    id: Scalars["ID"];
    /** The date this transaction was returned, in ISO 8601 format. */
    returnDate?: Maybe<Scalars["String"]>;
    /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
    settlementDate?: Maybe<Scalars["String"]>;
    /** The status of the externally initiated ACH transfer. */
    status?: Maybe<ExternallyInitiatedAchStatusDetails>;
    /** The `ElectronicFundsTransfer` that triggered this event. */
    transfer?: Maybe<ElectronicFundsTransfer>;
  };

/** A ledger entry of type debit, it represents the portion of a financial event where a Ledger had money debited from it. */
export type DebitLedgerEntry = LedgerEntry &
  Node & {
    __typename?: "DebitLedgerEntry";
    /** The `Amount` of the `DebitLedgerEntry`. */
    amount?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, this ledger entry was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The credit balance that is the result of the ledger entry. */
    creditBalanceAtLedgerEntry?: Maybe<Amount>;
    /** The debit balance that is the result of the ledger entry. */
    debitBalanceAtLedgerEntry?: Maybe<Amount>;
    /** A `FinancialAccount` backed by the `Ledger` that this ledger entry belongs to. */
    financialAccount?: Maybe<FinancialAccount>;
    /** The event that triggered the ledger entry. */
    financialEvent?: Maybe<FinancialEvent>;
    /** The unique id of the `DebitLedgerEntry`. */
    id: Scalars["ID"];
    /** A `JournalEntry` showing this `DebitLedgerEntry` and its offsetting `CreditLedgerEntry`. */
    journalEntry?: Maybe<JournalEntry>;
    /** Ledger that `DebitLedgerEntry` belongs to. */
    ledger?: Maybe<Ledger>;
    /** The optional memo of the `DebitLedgerEntry`. */
    memo?: Maybe<Scalars["String"]>;
  };

/** This event encapsulates the impacted account and debit amount for a `ManualAdjustmentEvent`. */
export type DebitManualAdjustmentDetail = {
  __typename?: "DebitManualAdjustmentDetail";
  /** The `Amount` of the manual adjustment. */
  amount?: Maybe<Amount>;
  /** The account that got impacted */
  financialAccount?: Maybe<FinancialAccount>;
  /** The name of the `Ledger`. */
  ledgerName?: Maybe<LedgerName>;
  /** The normal balance type of the `Ledger`. */
  normalBalance?: Maybe<NormalBalance>;
};

/** Whether or not the Financial Account supports a Debit Payment Card. */
export type DebitPaymentCardFinancialAccountFeature =
  FinancialAccountFeature & {
    __typename?: "DebitPaymentCardFinancialAccountFeature";
    /** The date and time, in ISO 8601 format, the feature was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective from. */
    effectiveFrom?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective through. */
    effectiveThrough?: Maybe<Scalars["String"]>;
    /** Whether or not the feature is enabled for the Financial Account. */
    enabled?: Maybe<Scalars["Boolean"]>;
    /** The date and time, in ISO 8601 format, the feature was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** A Transaction which debits money from a PaymentCard. */
export type DebitTransaction = Node & {
  __typename?: "DebitTransaction";
  /** The ID of the transaction. This `id` can be used to later retrieve details of this Transaction. */
  id: Scalars["ID"];
  /** The list of TransactionEvents related to this Transaction. */
  transactionEvents?: Maybe<Array<TransactionEvent>>;
};

/** A Transaction which debits money from a PaymentCard. */
export type DebitTransactionTransactionEventsArgs = {
  eventTypes?: InputMaybe<Array<TransactionEventFilter>>;
};

/** Describes attributes of a declined transaction metric. */
export type DeclinedTransactionBusinessMetricAttribute = {
  __typename?: "DeclinedTransactionBusinessMetricAttribute";
  /** The amount field attributes of a transaction. */
  amount?: Maybe<Amount>;
  /** The count field attributes of a transaction. */
  count?: Maybe<Scalars["UnsignedInt"]>;
  /** List of response codes. */
  responseCode?: Maybe<DeclinedTransactionResponseCodeBusinessMetric>;
};

/** Describes declined transaction reasons metric. */
export type DeclinedTransactionResponseCodeBusinessMetric =
  BusinessMetricSortAttribute & {
    __typename?: "DeclinedTransactionResponseCodeBusinessMetric";
    /** Declined response code attributes. */
    responseCodeAttributes?: Maybe<
      Array<DeclinedTransactionResponseCodeBusinessMetricAttribute>
    >;
    /** Sort by Ascending or Descending, Descending as default. */
    sortedDirection?: Maybe<BusinessMetricAttributeSortedDirection>;
  };

/** Describes attributes of a declined transaction reason metric. */
export type DeclinedTransactionResponseCodeBusinessMetricAttribute = {
  __typename?: "DeclinedTransactionResponseCodeBusinessMetricAttribute";
  /** The total amount of declined transactions. */
  amount?: Maybe<Amount>;
  /** The total number of declined transactions. */
  count?: Maybe<Scalars["UnsignedInt"]>;
  /** Declined response code. */
  responseCode?: Maybe<TransactionEventResponseCode>;
};

/** The input to clear all `CustomFields` keys associated with the object. */
export type DeleteCustomFieldsInput = {
  /** The ID of the object associated with the `CustomFields`. */
  id: Scalars["ID"];
};

/** The details of the spend rule you want to delete. */
export type DeleteSpendRuleInput = {
  /** The Global ID of the Spend Rule to delete. */
  spendRuleId: Scalars["ID"];
};

/** The return types when deleting an existing spend rule. */
export type DeleteSpendRulePayload =
  | AccessDeniedError
  | SpendRuleContainer
  | UserError;

/** The details of the velocity rule you want to delete. */
export type DeleteVelocityRuleInput = {
  /** The Global ID of the Velocity Rule to delete. */
  velocityRuleId: Scalars["ID"];
};

/** The return types when deleting an existing velocity rule. */
export type DeleteVelocityRulePayload =
  | AccessDeniedError
  | UserError
  | VelocityRuleContainer;

/** The transition of a `FinancialAccount` to a certain `FinancialAccountDelinquencyState`, such as CURRENT, DELINQUENT, or CLOSING. */
export type DelinquencyStateTransition = {
  __typename?: "DelinquencyStateTransition";
  /** The date and time, in ISO 8601 format, the `FinancialAccount` transitioned to this state. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The delinquency state this `FinancialAccount` is transitioning to, such as CURRENT, DELINQUENT, or CLOSING. */
  newState?: Maybe<FinancialAccountDelinquencyState>;
};

/** An attempt to delivery a Notification Event to a target. */
export type DeliveryAttempt = Node & {
  __typename?: "DeliveryAttempt";
  /** The time the delivery attempt was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Whether the attempt was successful, failed or skipped */
  deliveryAttemptStatus?: Maybe<DeliveryAttemptStatus>;
  /** The event that triggered the delivery attempt. */
  event?: Maybe<NotificationEvent>;
  /** Global ID used to reference the delivery attempt in operations. */
  id: Scalars["ID"];
  /** Details about the response from the target on this delivery attempt */
  response?: Maybe<DeliveryAttemptResponse>;
  /**
   * HTTP Status Code returned by the target.
   * @deprecated Use response.httpStatusCode instead.
   */
  status?: Maybe<Scalars["Int"]>;
  /**
   * Whether or not the attempt was successful.
   * @deprecated Use deliveryAttemptStatus instead.
   */
  success?: Maybe<Scalars["Boolean"]>;
  /** The target used for this attempt. */
  target?: Maybe<WebhookNotificationTarget>;
  /** The uri used for this attempt. */
  uri?: Maybe<Scalars["String"]>;
};

/** The connection type for DeliveryAttempt. */
export type DeliveryAttemptConnection = {
  __typename?: "DeliveryAttemptConnection";
  /** A list of edges. */
  edges?: Maybe<Array<DeliveryAttemptEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for DeliveryAttempt. */
export type DeliveryAttemptEdge = {
  __typename?: "DeliveryAttemptEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The DeliveryAttempt */
  node?: Maybe<DeliveryAttempt>;
};

/** Provides details about the response from the target on the delivery attempt */
export type DeliveryAttemptResponse = {
  __typename?: "DeliveryAttemptResponse";
  /** The HTTP Status Code returned by the target. */
  httpStatusCode?: Maybe<Scalars["Int"]>;
};

/** Indicates whether a delivery attempt was successful, failed or skipped. */
export enum DeliveryAttemptStatus {
  /** The delivery attempt was unsuccessful with a non 200 OK response */
  FAILURE = "FAILURE",
  /** The delivery attempt was skipped because the target was deactivated */
  SKIPPED = "SKIPPED",
  /** The delivery attempt was successful with a 200 OK response */
  SUCCESS = "SUCCESS",
}

/** The input type for denying a credit limit decrease for a `CreditLimitChangeRequest`. */
export type DenyCreditLimitDecreaseInput = {
  /** The identifier for the `CreditLimitChangeRequest` to deny. */
  creditLimitChangeRequestId: Scalars["ID"];
  /** Details collected about the customer, such as their current debt obligations and annual income. */
  customerDetails?: InputMaybe<CreditLimitChangeRequestCustomerDetailsInput>;
};

/** The input type for denying a credit limit increase for a `CreditLimitChangeRequest`. */
export type DenyCreditLimitIncreaseInput = {
  /** If the customer requested this credit limit increase, please provide at least one adverse action reason for the deny. */
  adverseActionReasons?: InputMaybe<Array<AdverseActionCodeInput>>;
  /** The identifier for the `CreditLimitChangeRequest` to deny. */
  creditLimitChangeRequestId: Scalars["ID"];
  /** Details collected about the customer, such as their current debt obligations and annual income. */
  customerDetails?: InputMaybe<CreditLimitChangeRequestCustomerDetailsInput>;
};

/** The input for denying a credit-based `AccountHolderCardProductApplication`. */
export type DenyCreditProductApplicationUnderwritingInput = {
  /** A list of reasons why the underwriting decision was adverse. */
  adverseActionReasons: Array<AdverseActionReasonInput>;
  /** Global id of the application */
  applicationId: Scalars["ID"];
  /** Optional input to accept an Open Offer on the application as an alternative to the primary underwritten offer that is being denied. */
  counterOffer?: InputMaybe<AcceptCounterOfferInput>;
  /**
   * The date and time, in ISO 8601 format, marking when the underwriting decision was made.
   * For example, `2023-01-01T22:00:00.000Z`.
   */
  decisionDate: Scalars["String"];
};

/** The response type for denying a credit-product `AccountHolderCardProductApplication`. */
export type DenyCreditProductApplicationUnderwritingPayload =
  | AccessDeniedError
  | AccountHolderCardProductApplication
  | UserError;

/** A rule that limits the dollar amount that can be deposited. */
export type DepositAmountLimitSpendRule = Node &
  SpendRule & {
    __typename?: "DepositAmountLimitSpendRule";
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the rule in operations. */
    id: Scalars["ID"];
    /** The maximum amount to allow for a single deposit. */
    maximumAmount?: Maybe<Amount>;
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/** A rule that limits the dollar amount that can be deposited. */
export type DepositAmountLimitSpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The result of applying a `DepositAmountLimitSpendRule` to an event. */
export type DepositAmountLimitSpendRuleResult = SpendRuleResult & {
  __typename?: "DepositAmountLimitSpendRuleResult";
  /** The attached level. */
  attachedLevel?: Maybe<AttachedLevel>;
  /** A message describing the result. */
  message?: Maybe<Scalars["String"]>;
  /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
  recommendation?: Maybe<SpendRuleRecommendation>;
  /** The spend rule attached at the time of the event. */
  spendRule?: Maybe<DepositAmountLimitSpendRule>;
  /** The tested amount of the event. */
  valuesTested?: Maybe<Array<Amount>>;
};

/** A rule that limits the number of times that a cash deposit can be made. */
export type DepositCountLimitSpendRule = Node &
  SpendRule & {
    __typename?: "DepositCountLimitSpendRule";
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the rule in operations. */
    id: Scalars["ID"];
    /** The maximum count of allowed deposits. */
    maximumCount?: Maybe<Scalars["UnsignedInt"]>;
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/** A rule that limits the number of times that a cash deposit can be made. */
export type DepositCountLimitSpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The list of Processing Networks that can be utilized for a deposit */
export enum DepositProcessingNetwork {
  /** Accel Processing Network */
  ACCEL = "ACCEL",
  /** Accel Card Free Cash Processing Network */
  ACCEL_CARD_FREE_CASH = "ACCEL_CARD_FREE_CASH",
  /** Accel Nebraska Processing Network */
  ACCEL_NEBRASKA = "ACCEL_NEBRASKA",
  /** Accel No Pin Processing Network */
  ACCEL_NO_PIN = "ACCEL_NO_PIN",
  /** Accel Surcharge Free Processing Network */
  ACCEL_SURCHARGE_FREE = "ACCEL_SURCHARGE_FREE",
  /** AFFN Processing Network */
  AFFN = "AFFN",
  /** AFFN High Ticket POS Processing Network */
  AFFN_HIGH_TICKET_POS = "AFFN_HIGH_TICKET_POS",
  /** AFFN Low Ticket POS Processing Network */
  AFFN_LOW_TICKET_POS = "AFFN_LOW_TICKET_POS",
  /** AFFN Reciprocal Processing Network */
  AFFN_RECIPROCAL = "AFFN_RECIPROCAL",
  /** Alaska Option Processing Network */
  ALASKA_OPTION = "ALASKA_OPTION",
  /** Allpoint Processing Network */
  ALLPOINT_NETWORK = "ALLPOINT_NETWORK",
  /** American Express ATM Processing Network */
  AMERICAN_EXPRESS_ATM = "AMERICAN_EXPRESS_ATM",
  /** Cirrus ATM Processing Network */
  CIRRUS_ATM = "CIRRUS_ATM",
  /** Cirrus Europe Acquired Dual Message Processing Network */
  CIRRUS_EUROPE_ACQUIRED_DUAL_MESSAGE = "CIRRUS_EUROPE_ACQUIRED_DUAL_MESSAGE",
  /** Credit Union Cooperative ATM Processing Network */
  CREDIT_UNION_COOPERATIVE_ATM = "CREDIT_UNION_COOPERATIVE_ATM",
  /** CU24 Processing Network */
  CU24 = "CU24",
  /** Culinace Processing Network */
  CULIANCE = "CULIANCE",
  /** Culinace Cuhere MoneyPass Reciprocal Processing Network */
  CULIANCE_CUHERE_MONEYPASS_RECIPROCAL = "CULIANCE_CUHERE_MONEYPASS_RECIPROCAL",
  /** Culinace Cuhere Presto Processing Network */
  CULIANCE_CUHERE_PRESTO_PUBLIX = "CULIANCE_CUHERE_PRESTO_PUBLIX",
  /** Culinace Cuhere Processing Network */
  CULIANCE_CUHERE_PROGRAM = "CULIANCE_CUHERE_PROGRAM",
  /** Culince Nyce Reciprocal Processing Network */
  CULIANCE_NYCE_RECIPROCAL = "CULIANCE_NYCE_RECIPROCAL",
  /** Culinace Pinless Low Value POS Processing Network */
  CULIANCE_PINLESS_LOW_VALUE_POS = "CULIANCE_PINLESS_LOW_VALUE_POS",
  /** Discover ATM Processing Network */
  DISCOVER_ATM = "DISCOVER_ATM",
  /** EBT ATM Processing Network */
  EBT_ATM = "EBT_ATM",
  /** EBT POS Processing Network */
  EBT_POS = "EBT_POS",
  /** EBT Processing Network */
  EBT_PROGRAMS = "EBT_PROGRAMS",
  /** Interlink Processing Network */
  INTERLINK = "INTERLINK",
  /** Maestro Processing Network */
  MAESTRO = "MAESTRO",
  /** Maestro Europe Acquirer Dual Message Processing Network */
  MAESTRO_EUROPE_ACQUIRER_DUAL_MESSAGE = "MAESTRO_EUROPE_ACQUIRER_DUAL_MESSAGE",
  /** Mastercard ATM Processing Network */
  MASTERCARD_ATM = "MASTERCARD_ATM",
  /** Mastercard Dual Message Processing Network */
  MASTERCARD_DUAL_MESSAGE_AUTHORIZATION_SYSTEM = "MASTERCARD_DUAL_MESSAGE_AUTHORIZATION_SYSTEM",
  /** Mastercard Single Message Processing Network */
  MASTERCARD_SINGLE_MESSAGE_SYSTEM = "MASTERCARD_SINGLE_MESSAGE_SYSTEM",
  /** MoneyPass Processing Network */
  MONEY_PASS = "MONEY_PASS",
  /** MoneyPass ATM Nebraska Processing Network */
  MONEY_PASS_ATM_NEBRASKA = "MONEY_PASS_ATM_NEBRASKA",
  /** MoneyPass ATM Star Processing Network */
  MONEY_PASS_ATM_STAR = "MONEY_PASS_ATM_STAR",
  /** NETS Processing Network */
  NETS = "NETS",
  /** NYCE Processing Network */
  NYCE = "NYCE",
  /** NYCE AFFN Reciprocal Processing Network */
  NYCE_AFFN_RECIPROCAL = "NYCE_AFFN_RECIPROCAL",
  /** NYCE Cross Border Processing Network */
  NYCE_CROSS_BORDER = "NYCE_CROSS_BORDER",
  /** NYCE Culiance Reciprocal Processing Network */
  NYCE_CULIANCE_RECIPROCAL = "NYCE_CULIANCE_RECIPROCAL",
  /** NYCE Direct Settlement Link Processing Network */
  NYCE_DIRECT_SETTLEMENT_LINK = "NYCE_DIRECT_SETTLEMENT_LINK",
  /** NYCE Ecommerce Processing Network */
  NYCE_ECOMMERCE = "NYCE_ECOMMERCE",
  /** NYCE International Reciprocal Group 1 Processing Network */
  NYCE_INTERNATIONAL_RECIPROCAL_GROUP1 = "NYCE_INTERNATIONAL_RECIPROCAL_GROUP1",
  /** NYCE International Reciprocal Group 2 Processing Network */
  NYCE_INTERNATIONAL_RECIPROCAL_GROUP2 = "NYCE_INTERNATIONAL_RECIPROCAL_GROUP2",
  /** NYCE Pinless POS Processing Network */
  NYCE_PINLESS_POS = "NYCE_PINLESS_POS",
  /** Plus ATM Processing Network */
  PLUS_ATM = "PLUS_ATM",
  /** Primary Routing or Generic File Update */
  PRIMARY_ROUTING_OR_GENERIC_FILE_UPDATE = "PRIMARY_ROUTING_OR_GENERIC_FILE_UPDATE",
  /** Pulse Processing Network */
  PULSE = "PULSE",
  /** Pulse Accel Processing Network */
  PULSE_ACCEL_RECIPROCAL = "PULSE_ACCEL_RECIPROCAL",
  /** Pulse Affn Reciprocal Processing Network */
  PULSE_AFFN_RECIPROCAL = "PULSE_AFFN_RECIPROCAL",
  /** Pulse Canada Processing Network */
  PULSE_CANADA = "PULSE_CANADA",
  /** Pulse Direct Settlement Link Processing Network */
  PULSE_DIRECT_SETTLEMENT_LINK = "PULSE_DIRECT_SETTLEMENT_LINK",
  /** Pulse Mexico Processing Network */
  PULSE_MEXICO = "PULSE_MEXICO",
  /** Pulse Pay Express Processing Network */
  PULSE_PAY_EXPRESS = "PULSE_PAY_EXPRESS",
  /** Pulse Select Processing Network */
  PULSE_SELECT = "PULSE_SELECT",
  /** Shazam Processing Network */
  SHAZAM = "SHAZAM",
  /** Star Processing Network */
  STAR = "STAR",
  /** Star Access Processing Network */
  STAR_ACCESS = "STAR_ACCESS",
  /** Star BC Card Korea Reciprocal Processing Network */
  STAR_BC_CARD_KOREA_RECIPROCAL = "STAR_BC_CARD_KOREA_RECIPROCAL",
  /** Star Direct Settlement Link Processing Network */
  STAR_DIRECT_SETTLEMENT_LINK = "STAR_DIRECT_SETTLEMENT_LINK",
  /** Star Publix Presto Processing Network */
  STAR_PUBLIX_PRESTO = "STAR_PUBLIX_PRESTO",
  /** Star Rapidflash Processing Network */
  STAR_RAPIDFLASH = "STAR_RAPIDFLASH",
  /** Star SF Processing Network */
  STAR_SF = "STAR_SF",
  /** Unknown Processing Network */
  UNKNOWN = "UNKNOWN",
  /** Visa Processing Network */
  VISA = "VISA",
  /** Visa Direct Processing Network */
  VISA_DIRECT = "VISA_DIRECT",
  /** Visa Direct Settlement Link Processing Network */
  VISA_DIRECT_SETTLEMENT_LINK = "VISA_DIRECT_SETTLEMENT_LINK",
  /** Visa Singapore Direct Settlement Link Processing Network */
  VISA_SINGAPORE_DIRECT_SETTLEMENT_LINK = "VISA_SINGAPORE_DIRECT_SETTLEMENT_LINK",
}

/** A rule that limits which processing networks can be used to make a deposit. */
export type DepositProcessingNetworkSpendRule = Node &
  SpendRule & {
    __typename?: "DepositProcessingNetworkSpendRule";
    /** The `DepositProcessingNetwork` values that will be allowed during deposits. */
    allowed?: Maybe<Array<DepositProcessingNetwork>>;
    /** The `DepositProcessingNetwork` values that will result in declined deposits. */
    blocked?: Maybe<Array<DepositProcessingNetwork>>;
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the spend rule in operations. */
    id: Scalars["ID"];
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/** A rule that limits which processing networks can be used to make a deposit. */
export type DepositProcessingNetworkSpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The result of applying a `DepositProcessingNetworkSpendRule` to an event. */
export type DepositProcessingNetworkSpendRuleResult = SpendRuleResult & {
  __typename?: "DepositProcessingNetworkSpendRuleResult";
  /** The attached level. */
  attachedLevel?: Maybe<AttachedLevel>;
  /** A message describing the result. */
  message?: Maybe<Scalars["String"]>;
  /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
  recommendation?: Maybe<SpendRuleRecommendation>;
  /** The spend rule attached at the time of the event. */
  spendRule?: Maybe<DepositProcessingNetworkSpendRule>;
  /** The tested `DepositProcessingNetwork` of the event. */
  valuesTested?: Maybe<Array<DepositProcessingNetwork>>;
};

/** The details of the `VelocityRule` to detach from the `CardProduct` */
export type DetachCardProductVelocityRuleInput = {
  /** The Global ID of the `CardProduct` connected to the `VelocityRule`. */
  cardProductId: Scalars["ID"];
  /** The details of the `VelocityRule` to detach from the `CardProduct`. */
  velocityRule: VelocityRuleInput;
};

/** The return types when detaching a `VelocityRule` from a `CardProduct`. */
export type DetachCardProductVelocityRulePayload =
  | AccessDeniedError
  | UserError
  | VelocityRuleAssociation;

/** The details of the `VelocityRule` to detach from the `PaymentCard` */
export type DetachPaymentCardVelocityRuleInput = {
  /** The Global ID of the `PaymentCard` connected to the `VelocityRule`. */
  paymentCardId: Scalars["ID"];
  /**
   * The details of the `VelocityRule` to detach from the `PaymentCard`.
   *
   * NOTE: version does not matter here
   */
  velocityRule: VelocityRuleInput;
};

/** The return types when detaching a `VelocityRule` from a `PaymentCard`. */
export type DetachPaymentCardVelocityRulePayload =
  | AccessDeniedError
  | UserError
  | VelocityRuleAssociation;

/** The details of the realtime risk rule to detach from the Card Product. */
export type DetachRealtimeRiskRuleFromCardProductInput = {
  /** The Global ID of the Card Product to detach the realtime risk rule. */
  cardProductId: Scalars["ID"];
  /** The details of the realtime risk rule to detach from the Card Product. */
  riskRule: DetachRiskRuleInput;
};

/** The return types when detaching a realtime risk rule from a card product. */
export type DetachRealtimeRiskRuleFromCardProductPayload =
  | AccessDeniedError
  | CardProduct
  | UserError;

/** The details of the realtime risk rule to detach from the Financial Account. */
export type DetachRealtimeRiskRuleFromFinancialAccountInput = {
  /** The Global ID of the Financial Account to detach the realtime risk rule. */
  financialAccountId: Scalars["ID"];
  /** The details of the realtime risk rule to detach from the Financial Account. */
  riskRule: DetachRiskRuleInput;
};

/** The return types when detaching a realtime risk rule from a financial account. */
export type DetachRealtimeRiskRuleFromFinancialAccountPayload =
  | AccessDeniedError
  | FinancialAccount
  | UserError;

/** The details of the realtime risk rule to detach from the Payment Card. */
export type DetachRealtimeRiskRuleFromPaymentCardInput = {
  /** The Global ID of the Payment Card to detach the realtime risk rule. */
  paymentCardId: Scalars["ID"];
  /** The details of the realtime risk rule to detach from the Payment Card. */
  riskRule: DetachRiskRuleInput;
};

/** The return types when detaching a realtime risk rule from a payment card. */
export type DetachRealtimeRiskRuleFromPaymentCardPayload =
  | AccessDeniedError
  | PaymentCard
  | UserError;

/** The details of the risk rule to detach. */
export type DetachRiskRuleInput = {
  /** The Global ID of the to detach. */
  id: Scalars["ID"];
};

/** The details of the spend rule to detach from the Card Product */
export type DetachSpendRuleFromCardProductInput = {
  /** The Global ID of the Card Product to detach the spend rule. */
  cardProductId: Scalars["ID"];
  /** The details of the spend rule to detach from the Card Product. */
  spendRule: DetachSpendRuleInput;
};

/** The return types when detaching a spend rule from a card product. */
export type DetachSpendRuleFromCardProductPayload =
  | AccessDeniedError
  | CardProduct
  | UserError;

/** The details of the spend rule to detach from the Payment Card. */
export type DetachSpendRuleFromFinancialAccountInput = {
  /** The Global ID of the Payment Card to detach the spend rule. */
  financialAccountId: Scalars["ID"];
  /** The details of the spend rule to detach from the Payment Card. */
  spendRule: DetachSpendRuleInput;
};

/** The return types when detaching a `SpendRule` from a `FinancialAccount`. */
export type DetachSpendRuleFromFinancialAccountPayload =
  | AccessDeniedError
  | FinancialAccount
  | UserError;

/** The details of the spend rule to detach from the Payment Card. */
export type DetachSpendRuleFromPaymentCardInput = {
  /** The Global ID of the Payment Card to detach the spend rule. */
  paymentCardId: Scalars["ID"];
  /** The details of the spend rule to detach from the Payment Card. */
  spendRule: DetachSpendRuleInput;
};

/** The return types when detaching a spend control rule from a payment card. */
export type DetachSpendRuleFromPaymentCardPayload =
  | AccessDeniedError
  | PaymentCard
  | UserError;

/** The details of the spend rule to detach. */
export type DetachSpendRuleInput = {
  /** The Global ID of the Spend Rule to detach. */
  id: Scalars["ID"];
};

/** The details of the `VelocityRule` to detach from the `FinancialAccount` */
export type DetachVelocityRuleFromFinancialAccountInput = {
  /** The Global ID of the `FinancialAccount` connected to the `VelocityRule`. */
  financialAccountId: Scalars["ID"];
  /** The details of the `VelocityRule` to detach from the `FinancialAccount`. */
  velocityRule: VelocityRuleInput;
};

/** The return types when detaching a `VelocityRule` from a `FinancialAccount`. */
export type DetachVelocityRuleFromFinancialAccountPayload =
  | AccessDeniedError
  | FinancialAccount
  | UserError;

/** Different types of Payments supported for the token. */
export enum DevicePaymentType {
  /** Digital Secure Remote Payment */
  DSRP = "DSRP",
  /** Ecommerce payment type. */
  ECOMMERCE = "ECOMMERCE",
  /** Near Field Communication payment type. */
  NFC = "NFC",
}

/** Digital card Art color customizations */
export type DigitalArtColors = {
  __typename?: "DigitalArtColors";
  /** Background color in hex format: #a9b1c0 */
  backgroundColor: Scalars["String"];
  /** Background color in RGB format: rgb(169, 177, 192) */
  backgroundColorRgb: Scalars["String"];
  /** Card descriptor color in hex format: #a9b1c0 */
  cardDescriptorColor: Scalars["String"];
  /** Card descriptor color in RGB format: rgb(169, 177, 192) */
  cardDescriptorColorRgb: Scalars["String"];
  /** PAN color in hex format: #a9b1c0 */
  panColor: Scalars["String"];
  /** PAN color in RGB format: rgb(169, 177, 192) */
  panColorRgb: Scalars["String"];
};

/** Digital Card art properties for a card art document upload session */
export type DigitalCardArtDocument = {
  __typename?: "DigitalCardArtDocument";
  /** The files for digital card art */
  cardArt: CardArtDocument;
  /** Digital wallet provider */
  digitalWalletProviders?: Maybe<Array<DigitalWalletProvider>>;
};

/** Digital Card Profile attributes */
export type DigitalCardProfile = CardProfile &
  Node & {
    __typename?: "DigitalCardProfile";
    /** Bank Status of the digital card profile. */
    bankStatus?: Maybe<CardProfileBankStatus>;
    /** Card art */
    cardArt?: Maybe<Array<DigitalCardArtDocument>>;
    /** Card Holder Agreement ID of the digital card profile. */
    cardHolderAgreementId?: Maybe<Scalars["ID"]>;
    /** Card Product of the digital card profile. */
    cardProduct?: Maybe<CardProduct>;
    /** The list of `CardProfileSet` related to this `DigitalCardProfile`. */
    cardProfileSetRelationships?: Maybe<Array<CardProfileSetRelationship>>;
    /** Digital Art colors in hex format. */
    colors?: Maybe<DigitalArtColors>;
    /** The date and time, in ISO 8601 format, this `digital card profile` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Description about the `DigitalCardProfile`. */
    description?: Maybe<Scalars["String"]>;
    /** The external id of the digital card profile used by the network for the card art configuration. */
    externalProfileId?: Maybe<Scalars["String"]>;
    /** ID of the digital card profile. */
    id: Scalars["ID"];
    /** Name of the `DigitalCardProfile`. */
    name?: Maybe<Scalars["String"]>;
    /** Payment Network Status of the digital card profile. */
    paymentNetworkStatus?: Maybe<CardProfilePaymentNetworkStatus>;
    /** The list of allowed source entry methods for digital wallet tokens. */
    sourceEntryMethods?: Maybe<Array<CardDigitalWalletTokenSourceEntryMethod>>;
    /** Status of the digital card profile. */
    status?: Maybe<CardProfileStatus>;
    /** Card digital wallet token provisioning constraints. */
    tokenProvisioningConstraints?: Maybe<DigitalCardProfileTokenProvisioningConstraints>;
    /** The date and time, in ISO 8601 format, this `digital card profile` was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** Web push provisioning asset Identifier. */
    webPushAssetIdentifier?: Maybe<Scalars["String"]>;
    /** Web push provisioning asset type */
    webPushAssetType?: Maybe<WebPushAssetType>;
  };

/** Active token quantity restrictions that limit how many digital wallet tokens can exist simultaneously. These controls help manage security exposure by preventing unlimited token proliferation across devices. */
export type DigitalCardProfileActiveTokenLimits = {
  __typename?: "DigitalCardProfileActiveTokenLimits";
  /** The maximum number of active digital wallet tokens allowed simultaneously across all devices and digital wallets. When set, this number represents the hard limit - attempting to exceed it will result in provisioning failure. Common values range from 3-10 tokens depending on expected user behavior. Null indicates no active token limit is enforced. */
  maximumActiveTokens?: Maybe<Scalars["UnsignedInt"]>;
};

/** Historical usage tracking that monitors lifetime token creation patterns to detect suspicious behavior. These limits look at the total number of tokens ever created by a cardholder, regardless of current status. */
export type DigitalCardProfileHistoricalTokenLimits = {
  __typename?: "DigitalCardProfileHistoricalTokenLimits";
  /** Total number of digital wallet tokens the cardholder can create over their entire account lifetime. This cumulative count includes all tokens ever provisioned - active, deleted, expired, or suspended. Typical values range from 10-50 tokens depending on expected user behavior. When reached, provisioning is blocked until manual review. Null indicates no historical tracking limit. */
  maximumHistoricalActiveTokens?: Maybe<Scalars["UnsignedInt"]>;
  /** List of merchant category codes (MCCs) where declined transactions prevent digital wallet provisioning. If the cardholder has any declined transactions with merchants in these categories, they cannot add their card to digital wallets until the restriction is lifted. Common restricted categories include gambling, adult entertainment, or high-risk merchants. */
  previousDeclineRestrictedMerchantCategories?: Maybe<Array<MerchantCategory>>;
};

/** Account balance requirements for digital wallet enrollment eligibility. These controls ensure cardholders have sufficient funds before allowing digital wallet provisioning. */
export type DigitalCardProfileTokenProvisioningAccountBalanceControl = {
  __typename?: "DigitalCardProfileTokenProvisioningAccountBalanceControl";
  /**
   * Minimum account balance required before cardholders can add their card to any digital wallet.
   * This amount must be available in the account at the time of provisioning. Common values range from $0 (no restriction) to $25-100 for risk management.
   * Null indicates no minimum balance requirement for digital wallet enrollment.
   */
  minimumAccountBalance?: Maybe<Amount>;
};

/**
 * Active digital wallet provisioning configuration applied to this card profile. This type contains the current restrictions and limits that govern how cardholders can add and use this card in digital wallets.
 * Use this to understand what restrictions and options are currently active for digital wallet provisioning.
 */
export type DigitalCardProfileTokenProvisioningConstraints = {
  __typename?: "DigitalCardProfileTokenProvisioningConstraints";
  /** Current provisioning controls including card entry methods and account requirements. Specifies how users can input their card information and what conditions must be met for successful digital wallet enrollment. Null indicates default platform controls apply. */
  controls?: Maybe<DigitalCardProfileTokenProvisioningControls>;
  /** Lifecycle management controls that govern automatic cleanup of digital wallet tokens based on card or account status changes. Configures automatic deletion of tokens when cards expire or when account balances reach zero, helping maintain security hygiene and reduce orphaned tokens in digital wallets. Null indicates no automatic lifecycle-based token deletion is configured. */
  lifeCycleControls?: Maybe<DigitalCardProfileTokenProvisioningLifeCycleControls>;
  /** Current token quantity limits and lifecycle restrictions. When configured, these limits control how many digital wallet tokens a cardholder can have active simultaneously and throughout their account history. Null indicates no specific limits are set. */
  limits?: Maybe<DigitalCardProfileTokenProvisioningLimits>;
  /** Active identity verification requirements for wallet provisioning. Defines which verification methods (SMS, email, customer service) are available to cardholders when adding their card to a digital wallet. Null indicates default verification methods apply. */
  verificationRules?: Maybe<DigitalCardProfileTokenProvisioningVerificationRules>;
};

/** Primary controls that govern the digital wallet provisioning experience and requirements. These settings determine both how users can add their card and what conditions must be met for successful enrollment. */
export type DigitalCardProfileTokenProvisioningControls = {
  __typename?: "DigitalCardProfileTokenProvisioningControls";
  /** Account balance requirements that must be met before cardholders can add their card to digital wallets. Defines minimum balance thresholds or other account-based eligibility criteria. Null indicates no special balance requirements beyond standard account status. */
  accountBalance?: Maybe<DigitalCardProfileTokenProvisioningAccountBalanceControl>;
  /** Card information entry method controls that specify how cardholders can input their card details when adding to digital wallets. Determines whether users can manually type their information, use camera scanning, or other supported entry methods. Null indicates all platform-supported entry methods are allowed. */
  sourceEntry?: Maybe<DigitalCardProfileTokenProvisioningSourceEntryControls>;
};

/**
 * Lifecycle management controls that govern automatic cleanup and maintenance of digital wallet tokens.
 * These settings determine when tokens should be automatically deleted based on card or account status changes, helping maintain security hygiene and reduce orphaned tokens across digital wallets.
 */
export type DigitalCardProfileTokenProvisioningLifeCycleControls = {
  __typename?: "DigitalCardProfileTokenProvisioningLifeCycleControls";
  /** When enabled, automatically deletes digital wallet tokens when the underlying payment card expires. */
  deleteExpiredCardTokens?: Maybe<Scalars["Boolean"]>;
  /** When enabled, automatically deletes digital wallet tokens when the associated financial account reaches a zero balance. */
  deleteZeroBalanceAccountTokens?: Maybe<Scalars["Boolean"]>;
};

/** Current token quantity limits and restrictions for this card profile. These limits control how many digital wallet tokens cardholders can create and maintain across all their devices and digital wallets. */
export type DigitalCardProfileTokenProvisioningLimits = {
  __typename?: "DigitalCardProfileTokenProvisioningLimits";
  /** Maximum number of tokens that can be active simultaneously across all devices. When this limit is reached, users must remove their card from an existing device before adding it to a new one. Null indicates no active token limit is set. */
  active?: Maybe<DigitalCardProfileActiveTokenLimits>;
  /** Lifetime limits based on total tokens created by the cardholder over time. Tracks all tokens ever created (including deleted/expired ones) to detect suspicious activity patterns. Null indicates no historical tracking limits. */
  historical?: Maybe<DigitalCardProfileHistoricalTokenLimits>;
  /** Time-based restrictions controlling how frequently users can attempt token provisioning. Prevents rapid-fire provisioning attempts that could indicate malicious behavior. Null indicates no rate limiting is configured. */
  rateLimits?: Maybe<DigitalCardProfileTokenRateLimits>;
};

/** Card information entry method restrictions that control how cardholders can input their details when adding cards to digital wallets. These settings balance security, user experience, and fraud prevention. */
export type DigitalCardProfileTokenProvisioningSourceEntryControls = {
  __typename?: "DigitalCardProfileTokenProvisioningSourceEntryControls";
  /** Permitted card entry methods for digital wallet provisioning. Each method in this list becomes available as an option when users add their card to wallet apps. Common configurations include [MANUAL_ENTRY, CAMERA_SCAN] for maximum flexibility or [CAMERA_SCAN] only for enhanced security. Empty list defaults to platform-standard entry methods. */
  allowedMethods?: Maybe<Array<CardDigitalWalletTokenSourceEntryMethod>>;
};

/** Specific verification method configuration that defines which identity verification channels are available to cardholders. This determines the actual verification options presented in the digital wallet interface. */
export type DigitalCardProfileTokenProvisioningVerificationMethodRules = {
  __typename?: "DigitalCardProfileTokenProvisioningVerificationMethodRules";
  /** Enabled verification method types for this card profile. Each method in this list becomes a selectable option when cardholders add their card to digital wallets. Common combinations include [SMS, EMAIL] for broad accessibility or [SMS, CUSTOMER_SERVICE] for enhanced security support. Empty list defaults to platform-standard verification methods. */
  allowedMethods?: Maybe<Array<CardDigitalWalletTokenVerificationMethodType>>;
};

/** Identity verification requirements and available methods for digital wallet provisioning. These rules determine what verification options are presented to cardholders when adding their card to a digital wallet. */
export type DigitalCardProfileTokenProvisioningVerificationRules = {
  __typename?: "DigitalCardProfileTokenProvisioningVerificationRules";
  /** Available verification method options for cardholders during digital wallet provisioning. Defines which verification channels (SMS, email, customer service, etc.) are enabled for this card profile. Null indicates default platform verification methods apply. */
  verificationMethod?: Maybe<DigitalCardProfileTokenProvisioningVerificationMethodRules>;
};

/** Time-based restrictions that prevent rapid provisioning attempts while allowing legitimate user retries. These controls help distinguish between normal user behavior and potential attack patterns. */
export type DigitalCardProfileTokenRateLimits = {
  __typename?: "DigitalCardProfileTokenRateLimits";
  /** Required waiting time between consecutive tokenization attempts for the same cardholder. Measured in milliseconds from the last failed attempt. Common values range from 30 seconds (30000ms) for user-friendly retries to 15 minutes (900000ms) for stronger security. Null indicates no rate limiting is applied - users can retry immediately. */
  tokenizationCooldown?: Maybe<CardProfileDuration>;
};

/** Digital Wallet Provider */
export enum DigitalWalletProvider {
  /** Apple Pay */
  APPLE_PAY = "APPLE_PAY",
  /** Google Pay */
  GOOGLE_PAY = "GOOGLE_PAY",
  /** Samsung Pay */
  SAMSUNG_PAY = "SAMSUNG_PAY",
}

/** Type representing common fields of a person's name. */
export type DigitalWalletPushProvisioningCardholderName = {
  __typename?: "DigitalWalletPushProvisioningCardholderName";
  /** Part of a personal name that identifies a family, tribe, or community. */
  familyName?: Maybe<Scalars["String"]>;
  /** A formatted name, composing the components of the name into a single field */
  formattedName?: Maybe<Scalars["String"]>;
  /** The part of the name that identifies a person. */
  givenName?: Maybe<Scalars["String"]>;
  /** Additional part of name that identifies a person. */
  middleName?: Maybe<Scalars["String"]>;
  /** Provides additional information about the person (e.g. Jr., Sr.) */
  suffix?: Maybe<Scalars["String"]>;
  /** One or more words used before the person's name (e.g. Mx., Dr.). */
  title?: Maybe<Scalars["String"]>;
};

/** The status of a `CardDigitalWalletToken`. */
export enum DigitalWalletTokenStatus {
  /** The `CardDigitalWalletToken` is active and ready for use. */
  ACTIVE = "ACTIVE",
  /** The `CardDigitalWalletToken` is requested and pending activation. */
  REQUESTED = "REQUESTED",
  /** The `CardDigitalWalletToken` has been suspended and authorizations will fail until the `CardDigitalWalletToken` is `ACTIVE` again. */
  SUSPENDED = "SUSPENDED",
  /** The `CardDigitalWalletToken` has been terminated and all future authorizations will fail. */
  TERMINATED = "TERMINATED",
}

/** The reason for a `CardDigitalWalletToken` status change. */
export enum DigitalWalletTokenStatusChangeReason {
  /** Financial Account has been closed. */
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  /** Cardholder Account has been closed by issuer. */
  ACCOUNT_HOLDER_DELETED = "ACCOUNT_HOLDER_DELETED",
  /** Cardholder successfully authenticated with an activation method. */
  ACTIVATION_METHOD = "ACTIVATION_METHOD",
  /** Cardholder called customer agent for verification. */
  CUSTOMER_SERVICE_AGENT = "CUSTOMER_SERVICE_AGENT",
  /** Cardholder reported token device found. */
  DEVICE_FOUND = "DEVICE_FOUND",
  /** Cardholder reported token device lost. */
  DEVICE_LOST = "DEVICE_LOST",
  /** Cardholder reported token device stolen. */
  DEVICE_STOLEN = "DEVICE_STOLEN",
  /** Issuer or Cardholder reported fraudulent token transactions. */
  FRAUDULENT_TRANSACTIONS = "FRAUDULENT_TRANSACTIONS",
  /** Network request. */
  NETWORK_INITIATED = "NETWORK_INITIATED",
  /** Issuer or Cardholder reported no fraudulent token transactions. */
  NON_FRAUDULENT_TRANSACTIONS = "NON_FRAUDULENT_TRANSACTIONS",
  /** Other reason. */
  OTHER = "OTHER",
}

/**
 * A financial instrument with an associated account and routing number.
 *
 * The direct deposit detail that can be used to deposit funds.
 */
export type DirectDepositDetail = Node & {
  __typename?: "DirectDepositDetail";
  /** The date and time, in ISO 8601 format, the direct deposit detail was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the direct deposit detail in operations. */
  id: Scalars["ID"];
  /** The decrypted account number for this direct deposit detail. */
  restrictedDetails?: Maybe<DirectDepositDetailRestrictedDetailsResult>;
  /** The date and time, in ISO 8601 format, the direct deposit detail was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Permissions for a Direct Deposit Details Client Token */
export enum DirectDepositDetailClientTokenPermission {
  /**
   * Read `accountNumber` for Direct Deposit Details.
   *
   * Setting this permission will allow using the token to query for a DirectDepositDetail and read its `restrictedDetails` property.
   */
  READ_RESTRICTED_DETAILS = "READ_RESTRICTED_DETAILS",
}

/** Direct deposit details for a financial account. */
export type DirectDepositDetailRestrictedDetails = {
  __typename?: "DirectDepositDetailRestrictedDetails";
  /** The details about the backing bank. */
  bank?: Maybe<BankDetails>;
  /** The primary account number for the financial account. */
  number?: Maybe<Scalars["String"]>;
  /** The routing number for the financial account. */
  routingNumber?: Maybe<Scalars["String"]>;
  /** The details about the type of account. */
  type?: Maybe<BankAccountType>;
};

export type DirectDepositDetailRestrictedDetailsResult =
  | AccessDeniedError
  | DirectDepositDetailRestrictedDetails;

/**
 * Whether or not the Financial Account supports a backing account and routing number.
 *
 * The account and routing number can be used to deposit funds.
 */
export type DirectDepositFinancialAccountFeature = FinancialAccountFeature & {
  __typename?: "DirectDepositFinancialAccountFeature";
  /** The date and time, in ISO 8601 format, the feature was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective from. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective through. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Whether or not the feature is enabled for the Financial Account. */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** The date and time, in ISO 8601 format, the feature was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Whether or not the `CardProduct` supports direct merchant acquiring. */
export type DirectMerchantAcquiringCardProductFeature = CardProductFeature &
  ProductFeature & {
    __typename?: "DirectMerchantAcquiringCardProductFeature";
    /** The date and time, in ISO 8601 format, the feature was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective from. */
    effectiveFrom?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective through. */
    effectiveThrough?: Maybe<Scalars["String"]>;
    /** Whether or not the feature is enabled for the `CardProduct`. */
    enabled?: Maybe<Scalars["Boolean"]>;
    /** The date and time, in ISO 8601 format, the feature was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** The input to disable the authorized user product feature. */
export type DisableAuthorizedUserFeatureInput = {
  /** The Global ID of the `CardProduct` for which to disable authorized user product feature. */
  cardProductId: Scalars["ID"];
};

/** The return types when calling `disableAuthorizedUserFeature` on a `CardProduct`. */
export type DisableAuthorizedUserFeaturePayload =
  | AccessDeniedError
  | CardProduct
  | UserError;

/** `TransferEvent` for disbursement. */
export type DisbursementTransferEvent = Node & {
  __typename?: "DisbursementTransferEvent";
  /** The amount of the `DisbursementTransferEvent`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, the `DisbursementTransferEvent` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The type of the `DisbursementTransferEvent`. */
  eventType?: Maybe<DisbursementTransferEventType>;
  /** The reason code on why this `DisbursementTransferEvent` failed. */
  failureReason?: Maybe<DisbursementTransferEventFailureReason>;
  /** Global ID used to reference the `DisbursementTransferEvent` in operations. */
  id: Scalars["ID"];
  /** The ledgers affected by the `DisbursementTransferEvent`. */
  ledgers?: Maybe<Array<Ledger>>;
  /** The status of the `DisbursementTransferEvent`. */
  status?: Maybe<DisbursementTransferEventStatus>;
  /** The receiving financial account of the `DisbursementTransferEvent`. */
  toFinancialAccount?: Maybe<FinancialAccount>;
  /** The date and time, in ISO 8601 format, the `DisbursementTransferEvent` was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** `TransferEvent` for disbursement. */
export type DisbursementTransferEventLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** Additional details when the `DisbursementTransferEvent` status is failed. */
export enum DisbursementTransferEventFailureReason {
  /** The originating and receiving account do not belong to same product. */
  ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT = "ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT",
  /** The originating or receiving account is closed. */
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  /** The originating or receiving account is not active. */
  ACCOUNT_NOT_ACTIVE = "ACCOUNT_NOT_ACTIVE",
  /** The originating or receiving account was not found. */
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  /** The originating or receiving account not provided. */
  ACCOUNT_NOT_PROVIDED = "ACCOUNT_NOT_PROVIDED",
  /** Ach load is not allowed by program. */
  ACH_LOAD_NOT_ALLOWED_BY_PROGRAM = "ACH_LOAD_NOT_ALLOWED_BY_PROGRAM",
  /** Card funding feature not enabled on account. */
  CARD_FUNDING_FEATURE_NOT_ENABLED = "CARD_FUNDING_FEATURE_NOT_ENABLED",
  /** Cash fund out not supported on product. */
  CASH_FUND_OUT_NOT_SUPPORTED_ON_PRODUCT = "CASH_FUND_OUT_NOT_SUPPORTED_ON_PRODUCT",
  /** Commercial credit Pay In Full card feature is not enabled on account. */
  COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED = "COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED",
  /** Corporate bank account feature is not enabled. */
  CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED = "CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED",
  /** Credit card feature is not enabled on account. */
  CREDIT_CARD_FEATURE_NOT_ENABLED = "CREDIT_CARD_FEATURE_NOT_ENABLED",
  /** The originating account does not have credit limit set. */
  CREDIT_LIMIT_NOT_SET_ON_ACCOUNT = "CREDIT_LIMIT_NOT_SET_ON_ACCOUNT",
  /** The originating and receiving account have different currency. */
  CURRENCY_MISMATCH = "CURRENCY_MISMATCH",
  /** Dda feature is not enabled on account. */
  DDA_FEATURE_NOT_ENABLED = "DDA_FEATURE_NOT_ENABLED",
  /** Debit card feature is not enabled on account. */
  DEBIT_CARD_FEATURE_NOT_ENABLED = "DEBIT_CARD_FEATURE_NOT_ENABLED",
  /** Fleet card feature is not enabled on account. */
  FLEET_FEATURE_NOT_ENABLED = "FLEET_FEATURE_NOT_ENABLED",
  /** Funding account feature is not enabled on account. */
  FUNDING_ACCOUNT_FEATURE_NOT_ENABLED = "FUNDING_ACCOUNT_FEATURE_NOT_ENABLED",
  /** Product funding feature is not enabled on account. */
  FUNDING_CARD_NOT_SUPPORTED = "FUNDING_CARD_NOT_SUPPORTED",
  /** Idempotency Key not provided. */
  IDEMPOTENCY_KEY_NOT_PROVIDED = "IDEMPOTENCY_KEY_NOT_PROVIDED",
  /** The originating account of the FeeTransferEvent did not have enough funds to cover the requested amount. */
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  /** The amount specified for the disbursement is invalid. */
  INVALID_DISBURSEMENT_AMOUNT = "INVALID_DISBURSEMENT_AMOUNT",
  /** Merchant settlement is not enabled on this account. */
  MERCHANT_SETTLEMENT_FEATURE_NOT_ENABLED = "MERCHANT_SETTLEMENT_FEATURE_NOT_ENABLED",
  /** The originating or receiving account does not belong to the organization. */
  NOT_AN_ORGANIZATION_OWNED_ACCOUNT = "NOT_AN_ORGANIZATION_OWNED_ACCOUNT",
  /** The originating account does not have enough balance to reduce credit limit. */
  NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT = "NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT",
  /** Organization not provided. */
  ORGANIZATION_ID_NOT_PROVIDED = "ORGANIZATION_ID_NOT_PROVIDED",
  /** Originated ach unload not supported on product */
  ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT = "ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT",
  /** Payroll advance feature not enabled. */
  PAYROLL_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED",
  /** Payroll employer advance feature not enabled. */
  PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED",
  /** Prepaid card feature is not enabled on account. */
  PREPAID_CARD_FEATURE_NOT_ENABLED = "PREPAID_CARD_FEATURE_NOT_ENABLED",
  /** Product funding feature is not enabled on account. */
  PRODUCT_FUNDING_FEATURE_NOT_ENABLED = "PRODUCT_FUNDING_FEATURE_NOT_ENABLED",
  /** Reward point feature not enabled. */
  REWARD_POINT_FEATURE_NOT_ENABLED = "REWARD_POINT_FEATURE_NOT_ENABLED",
  /** Secured card feature is not enabled on account. */
  SECURE_CARD_FEATURE_NOT_ENABLED = "SECURE_CARD_FEATURE_NOT_ENABLED",
  /** Tenant Id is not provided. */
  TENANT_ID_NOT_PROVIDED = "TENANT_ID_NOT_PROVIDED",
  /** Transaction Id not provided. */
  TRANSACTION_ID_NOT_PROVIDED = "TRANSACTION_ID_NOT_PROVIDED",
  /** Transfer amount below program minimum reload limit. */
  TRANSFER_AMOUNT_BELOW_MIN_PROGRAM_RELOAD_LIMIT = "TRANSFER_AMOUNT_BELOW_MIN_PROGRAM_RELOAD_LIMIT",
  /** The requested amount exceeds the maximum aggregate credit distribution amount. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_AGGREGATE_CREDIT_DISTRIBUTION_AMOUNT = "TRANSFER_AMOUNT_EXCEEDING_MAX_AGGREGATE_CREDIT_DISTRIBUTION_AMOUNT",
  /** Transfer amount exceeding maximum program card balance. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_CARD_BALANCE = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_CARD_BALANCE",
  /** Transfer amount exceeds allowed max program load limit. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT",
  /** Transfer amount exceeds allowed max program reload limit. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_RELOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_RELOAD_LIMIT",
  /** Transfer amount is negative or zero. */
  TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO = "TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO",
  /** Accounts do not have same primary account holder. */
  TRANSFER_CONDITION_SAME_PRIMARY_ACCOUNT_HOLDER_NOT_SATISFIED = "TRANSFER_CONDITION_SAME_PRIMARY_ACCOUNT_HOLDER_NOT_SATISFIED",
  /** Transfer is not supported on product. */
  TRANSFER_NOT_SUPPORTED_ON_PRODUCT = "TRANSFER_NOT_SUPPORTED_ON_PRODUCT",
  /**
   * The `DisbursementTransferEvent` failure reason is unspecified.
   *
   * Contact Highnote support for more information.
   */
  UNSPECIFIED = "UNSPECIFIED",
}

/** Status of the `DisbursementTransferEvent`. */
export enum DisbursementTransferEventStatus {
  /** The `DisbursementTransferEvent` status is completed. */
  COMPLETED = "COMPLETED",
  /** The `DisbursementTransferEvent` status is failed. */
  FAILED = "FAILED",
  /** The `DisbursementTransferEvent` status is pending. */
  PENDING = "PENDING",
  /**
   * The `DisbursementTransferEvent` status is unspecified.
   *
   * Contact Highnote support for more information.
   */
  UNSPECIFIED = "UNSPECIFIED",
}

/** The event type for the `DisbursementTransferEvent`. */
export enum DisbursementTransferEventType {
  /** The `DisbursementTransferEvent` type is a carry over event. */
  DISBURSEMENT_CARRY_OVER = "DISBURSEMENT_CARRY_OVER",
  /** The `DisbursementTransferEvent` type is a chargeback fee event. */
  DISBURSEMENT_CHARGEBACK_FEE = "DISBURSEMENT_CHARGEBACK_FEE",
  /** The `DisbursementTransferEvent` type is for an interchange fee. */
  DISBURSEMENT_INTERCHANGE_FEE = "DISBURSEMENT_INTERCHANGE_FEE",
  /** The `DisbursementTransferEvent` type is an interchange fee precision adjustment event. */
  DISBURSEMENT_INTERCHANGE_FEE_PRECISION_ADJUSTMENT = "DISBURSEMENT_INTERCHANGE_FEE_PRECISION_ADJUSTMENT",
  /** The `DisbursementTransferEvent` type is for a network fee. */
  DISBURSEMENT_NETWORK_FEE = "DISBURSEMENT_NETWORK_FEE",
  /** The `DisbursementTransferEvent` type is a payable event. */
  DISBURSEMENT_PAYABLE = "DISBURSEMENT_PAYABLE",
  /** The `DisbursementTransferEvent` type is a payment event. */
  DISBURSEMENT_PAYMENT = "DISBURSEMENT_PAYMENT",
  /** The `DisbursementTransferEvent` type is a payout payable event. */
  DISBURSEMENT_PAYOUT_PAYABLE = "DISBURSEMENT_PAYOUT_PAYABLE",
  /** The `DisbursementTransferEvent` type is for a platform fee. */
  DISBURSEMENT_PLATFORM_FEE = "DISBURSEMENT_PLATFORM_FEE",
  /**
   * The `DisbursementTransferEvent` type is unspecified.
   *
   * Contact Highnote support for more information.
   */
  UNSPECIFIED = "UNSPECIFIED",
}

/** Whether or not the `CardProduct` supports Disputes and feature configurations for Dispute and Chargeback restrictions. */
export type DisputeChargebackCardProductFeature = CardProductFeature &
  ProductFeature & {
    __typename?: "DisputeChargebackCardProductFeature";
    /** The minimum `Amount` for a Dispute to qualify for a Chargeback with the Network. */
    chargebackMinimumThreshold?: Maybe<Amount>;
    /** Whether or not a `Provisional Credit` will be granted when a Chargeback is filed to the Network. */
    chargebackProvisionalCreditEnabled?: Maybe<Scalars["Boolean"]>;
    /** The date and time, in ISO 8601 format, the feature was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The maximum number of days from the original `TransactionEvent` date that a Transaction can be disputed. */
    disputeMaximumDaySinceTransaction?: Maybe<Scalars["UnsignedInt"]>;
    /** The date and time, in ISO 8601 format, the feature was effective from. */
    effectiveFrom?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective through. */
    effectiveThrough?: Maybe<Scalars["String"]>;
    /** Whether or not the feature is enabled for the `CardProduct`. */
    enabled?: Maybe<Scalars["Boolean"]>;
    /** The date and time, in ISO 8601 format, the feature was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Record of an acquiring `PaymentTransaction` dispute step. */
export type DisputeStep = PaymentTransactionLifecycleStep & {
  __typename?: "DisputeStep";
  /** The amount for this `PaymentTransaction`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Events associated with this step. */
  events?: Maybe<Array<PaymentTransactionEvent>>;
  /** The current status for this step. */
  status?: Maybe<PaymentTransactionLifecycleStepStatus>;
  /** The `PaymentTransaction` associated with this step. */
  transaction?: Maybe<PaymentTransaction>;
};

/** A representation of size and unit of measurement of a distance. */
export type Distance = {
  __typename?: "Distance";
  /** The length of the measurement. */
  length: Scalars["Float"];
  /** The unit of measurement. */
  unit: DistanceUnit;
};

/** A representation of size and unit of measurement of a distance. */
export type DistanceInput = {
  /** The length of the measurement. */
  length: Scalars["Float"];
  /** The unit of measurement. */
  unit: DistanceUnit;
};

/** A unit of distance measurement. */
export enum DistanceUnit {
  /** A unit of distance in the metric system. */
  KILOMETER = "KILOMETER",
  /** A British imperial unit and US customary unit of distance. */
  MILE = "MILE",
}

/** A categorization of an uploaded document */
export enum DocumentCategoryType {
  /** A primary document */
  PRIMARY_DOCUMENT_TYPE = "PRIMARY_DOCUMENT_TYPE",
  /** A secondary document */
  SECONDARY_DOCUMENT_TYPE = "SECONDARY_DOCUMENT_TYPE",
  /** A supporting document type */
  SUPPORTING_DOCUMENT_TYPE = "SUPPORTING_DOCUMENT_TYPE",
}

export type DocumentCollectionAggregateEntity =
  | AccountHolderCardProductApplication
  | AuthorizedUserCardProductApplication
  | CardProduct
  | FinancialAccount
  | Organization
  | UsBusinessAccountHolder
  | UsPersonAccountHolder;

export type DocumentCollectionOwnerEntity =
  | Organization
  | UsBusinessAccountHolder
  | UsBusinessAuthorizedPerson
  | UsPersonAccountHolder;

export type DocumentCollectionPrimaryEntity =
  | AccountHolderCardProductApplication
  | AuthorizedUserCardProductApplication
  | CardProduct
  | FinancialAccount
  | Organization
  | ReviewWorkflowEvent
  | UsBusinessAccountHolder
  | UsPersonAccountHolder;

/** The document being requested */
export type DocumentRequest = {
  __typename?: "DocumentRequest";
  /** The type of document that is requested */
  documentType?: Maybe<DocumentType>;
  /** Indicates whether the document is required or optional */
  required?: Maybe<Scalars["Boolean"]>;
};

/** Document types that can be uploaded for identity verification. */
export enum DocumentType {
  /** The signature of the account holder */
  ACCOUNT_HOLDER_SIGNATURE = "ACCOUNT_HOLDER_SIGNATURE",
  /**
   * Articles of incorporation for a business
   *
   * **Note: ** To be used only for a business account holder type
   */
  ARTICLES_OF_INCORPORATION = "ARTICLES_OF_INCORPORATION",
  /** An insurance document related to an insurance policy on an automobile */
  AUTO_INSURANCE = "AUTO_INSURANCE",
  /**
   * A printed record of the balance in a bank account and the amounts that have been paid into it and withdrawn from it, issued periodically to the holder of the account.
   *
   * The bank statement must be dated within the last 60 days.
   *
   * The document must show the account holder's full name and full physical address. The address cannot be associated to a PO Box or CMRA.
   */
  BANK_STATEMENT = "BANK_STATEMENT",
  /** A birth certificate */
  BIRTH_CERTIFICATE = "BIRTH_CERTIFICATE",
  /** The official document for complete information pertaining to your brokerage account's value, holdings, and activity */
  BROKERAGE_STATEMENT = "BROKERAGE_STATEMENT",
  /**
   * Permits issued by government agencies that allow individuals or companies to conduct business within the government's geographical jurisdiction.
   *
   * **Note: ** To be used only for a business account holder type
   */
  BUSINESS_LICENSE = "BUSINESS_LICENSE",
  /**
   * Business registration issued by the Secretary of State.
   *
   * The business registration must be current and active within the State where the Business operates.
   *
   *  The document must show the business name and full physical address.
   *
   * **Note: ** To be used only for a business account holder type
   */
  BUSINESS_REGISTRATION = "BUSINESS_REGISTRATION",
  /** A cable bill is an account or bill for the charges for access to paid television. */
  CABLE_BILL = "CABLE_BILL",
  /** A document confirming citizenship */
  CERTIFICATE_OF_CITIZENSHIP = "CERTIFICATE_OF_CITIZENSHIP",
  /**
   * A document indicating that the business has filed all reports and fees with the Secretary of State's office.
   * It serves as proof, or evidence, that the entity exists and is authorized to transact business in the state
   *
   * **Note: ** To be used only for a business account holder type
   */
  CERTIFICATE_OF_GOOD_STANDING = "CERTIFICATE_OF_GOOD_STANDING",
  /** A military record indicating an individuals release or dischage from active duty */
  CERTIFICATE_OF_RELEASE_OR_DISCHARGE_FROM_ACTIVE_DUTY = "CERTIFICATE_OF_RELEASE_OR_DISCHARGE_FROM_ACTIVE_DUTY",
  /** A legal name change document provided by the court */
  COURT_ORDER_FOR_LEGAL_NAME_CHANGE = "COURT_ORDER_FOR_LEGAL_NAME_CHANGE",
  /** The card art is the background image of a Digital Card */
  DIGITAL_BACKGROUND = "DIGITAL_BACKGROUND",
  /** The card art document is a front image of a Digital Card */
  DIGITAL_FRONT_OF_CARD = "DIGITAL_FRONT_OF_CARD",
  /** The card art is the icon image of a Digital Card */
  DIGITAL_ICON = "DIGITAL_ICON",
  /** The card art is the logo image of a Digital Card */
  DIGITAL_LOGO = "DIGITAL_LOGO",
  /** A certificate of a divorce */
  DIVORCE_DECREE = "DIVORCE_DECREE",
  /**
   * A document permitting a person to drive a motor vehicle.
   *
   * The driver's license must be unexpired and valid.
   *
   * The document must show the driver's full name and full physical address. The address cannot be associated to a PO Box or CMRA.
   */
  DRIVERS_LICENSE = "DRIVERS_LICENSE",
  /**
   * Federal Employer Identification Number
   *
   * **Note: ** To be used only for a business account holder type
   */
  FEDERAL_EMPLOYER_IDENTIFICATION_NUMBER = "FEDERAL_EMPLOYER_IDENTIFICATION_NUMBER",
  /** A report on mortgage interest (including points, defined later) of $600 or more you received during the year in the course of your trade or business from an individual, including a sole proprietor */
  FORM_1098 = "FORM_1098",
  /** A collection of tax forms documenting different types of payments made by an individual or a business that typically isn't your employer */
  FORM_1099 = "FORM_1099",
  /** A form submitted by the trustee or issuer of your individual retirement arrangement (IRA) to report contributions, including any catch-up contributions, required minimum distributions (RMDs), and the fair market value (FMV) of the account */
  FORM_5498 = "FORM_5498",
  /**
   * IRS Form CP-575 - Confirmation of Federal Employer Identification Number letter.
   *
   * **Note: ** To be used only for a business account holder type
   */
  FORM_CP_575 = "FORM_CP_575",
  /** An insurance document related to an insurance policy on the health of the policy holder */
  HEALTH_INSURANCE = "HEALTH_INSURANCE",
  /** An internet bill is an account or bill for the charges for access to internet. */
  INTERNET_BILL = "INTERNET_BILL",
  /** A federal tax returrn issued by United States of America Internal Revenue Service. */
  IRS_ISSUED_FEDERAL_TAX_RETURN = "IRS_ISSUED_FEDERAL_TAX_RETURN",
  /** A state tax return issued by a state in the United States. */
  IRS_ISSUED_STATE_TAX_RETURN = "IRS_ISSUED_STATE_TAX_RETURN",
  /**
   * A business tax return, indicating taxes filed for the filing year, proving the business is current with IRS filing requirements.
   *
   * **Note: ** To be used only for a business account holder type
   */
  IRS_ISSUED_TAX_RETURN = "IRS_ISSUED_TAX_RETURN",
  /**
   * A contractual arrangement calling for the user to pay the owner for use of property.
   *
   * The lease agreement must be current and valid.
   *
   * The document must show the user's full name and full physical address. The address cannot be associated to a PO Box or CMRA.
   */
  LEASE_AGREEMENT = "LEASE_AGREEMENT",
  /** An insurance document related to an insurance policy on the life of the policy holder */
  LIFE_INSURANCE = "LIFE_INSURANCE",
  /** A certificate of marriage */
  MARRIAGE_CERTIFICATE = "MARRIAGE_CERTIFICATE",
  /** A document representing the medicare card */
  MEDICARE_CARD = "MEDICARE_CARD",
  /** An identification card issued by a municipality */
  MUNICIPAL_ID = "MUNICIPAL_ID",
  /**
   * Non Profit 501c3 charter for a business
   *
   * **Note: ** To be used only for a business account holder type
   */
  NON_PROFIT_501_C3 = "NON_PROFIT_501_C3",
  /**
   * A key document used by limited liability companies (LLCs)  to outline the business' financial and functional decisions including rules, regulations, and provisions.
   *
   * **Note: ** To be used only for a business account holder type
   */
  OPERATING_AGREEMENT = "OPERATING_AGREEMENT",
  /**
   * A legal document that dictates the way a business is run and details the relationship between each partner
   *
   * **Note: ** To be used only for a business account holder type
   */
  PARTNERSHIP_AGREEMENT = "PARTNERSHIP_AGREEMENT",
  /** An official document issued by a government, certifying the holder's identity and citizenship and entitling them to travel under its protection to and from foreign countries */
  PASSPORT = "PASSPORT",
  /** A document issued by an employer to pay an employee for services rendered. */
  PAY_STUB = "PAY_STUB",
  /** A phone bill is an account or bill for the charges for a telephone and line and for calls made from it */
  PHONE_BILL = "PHONE_BILL",
  /** The card art document is a back image of a Physical Card */
  PHYSICAL_BACK_OF_CARD = "PHYSICAL_BACK_OF_CARD",
  /** The card art document is a front image of a Physical Card */
  PHYSICAL_FRONT_OF_CARD = "PHYSICAL_FRONT_OF_CARD",
  /** The identification card and associated number used by the State or Federal entity to track an inmate */
  PRISON_ID = "PRISON_ID",
  /** All certified document(s) granted to applicant at the time of discharge from a correctional institution */
  PRISON_RELEASE_PAPERWORK = "PRISON_RELEASE_PAPERWORK",
  /** A social security card */
  SOCIAL_SECURITY_CARD = "SOCIAL_SECURITY_CARD",
  /**
   * Identification Document representing a social security card
   *
   * **Note: ** A social security for a business is only accepted for business' that are sole proprietorships.
   */
  SOLE_PROPRIETOR_SOCIAL_SECURITY_CARD = "SOLE_PROPRIETOR_SOCIAL_SECURITY_CARD",
  /** A summary of the investments in a 401k retirement account */
  STATEMENT_401K = "STATEMENT_401K",
  /** A document that many consulates issue to identify the citizens of their country who reside abroad */
  STATE_CONSULAR_IDENTIFICATION_CARD = "STATE_CONSULAR_IDENTIFICATION_CARD",
  /** A state issued benefit card */
  STATE_ISSUED_BENEFIT_CARD = "STATE_ISSUED_BENEFIT_CARD",
  /** A State ID Card is a government issued form of identification containing personal and biometric information, that allows its holder to prove their identity and citizenship. */
  STATE_ISSUED_ID = "STATE_ISSUED_ID",
  /** A state issued permit */
  STATE_ISSUED_PERMIT = "STATE_ISSUED_PERMIT",
  /** Tribal identification cards are issued by tribes as proof of your enrollment and membership in the tribe */
  STATE_TRIBAL_ID = "STATE_TRIBAL_ID",
  /** An identity document used by nationals of Mexico to enter the United States. */
  STATE_US_BORDER_CROSSING_CARD = "STATE_US_BORDER_CROSSING_CARD",
  /** An identity document indicating the right to employment within the United States of America. */
  STATE_US_EMPLOYMENT_AUTHORIZATION_CARD = "STATE_US_EMPLOYMENT_AUTHORIZATION_CARD",
  /** An identification document issued by the United State of America Military Armed Forces */
  STATE_US_MILITARY_ARMED_FORCES_ID = "STATE_US_MILITARY_ARMED_FORCES_ID",
  /** An permanent resident card issued by the United State of America */
  STATE_US_PERMANENT_RESIDENT_CARD = "STATE_US_PERMANENT_RESIDENT_CARD",
  /**
   * Confirmation of application submission - Tax ID Number.
   *
   * **Note: ** To be used only for a business account holder type
   */
  TAX_ID_APPLICATION = "TAX_ID_APPLICATION",
  /**
   * An estate planning document that allows the business to transfer ownership of its assets to a third party.
   *
   * **Note: ** To be used only for a business account holder type
   */
  TRUST_AGREEMENT = "TRUST_AGREEMENT",
  /** A document representing a record of service in the US military */
  US_MILITARY_RECORD_OF_SERVICE = "US_MILITARY_RECORD_OF_SERVICE",
  /** A tax form from the United States */
  US_TAX_FORM = "US_TAX_FORM",
  /**
   * A utility bill is a monthly statement of the amount a household or business owes for essential services or utilities.
   *
   * The utility bill must be dated within the last 60 days.
   *
   * The document must show the biller's full name and full physical address. The address cannot be associated to a PO Box or CMRA.
   */
  UTILITY_BILL = "UTILITY_BILL",
  /**
   * A VA award letter is issued by the Department of Veterans Affairs (VA) when a decision has been made regarding a veteran's claim for benefits.
   * Specifically, this letter indicates a veteran's disability rating(s) along with the corresponding amount of monthly compensation.
   */
  VETERAN_AFFAIRS_BENEFITS_LETTER = "VETERAN_AFFAIRS_BENEFITS_LETTER",
  /** The card art document is a front image of a Virtual Card */
  VIRTUAL_FRONT_OF_CARD = "VIRTUAL_FRONT_OF_CARD",
  /** The card art document for 3DS Verification Logo */
  VIRTUAL_THREE_DS_VERIFICATION_LOGO = "VIRTUAL_THREE_DS_VERIFICATION_LOGO",
  /** A W2 or Income tax form */
  W2 = "W2",
  /** Verifies that a wire transfer was sent or received. */
  WIRE_CONFIRMATION = "WIRE_CONFIRMATION",
}

/** Domains that may drive requests for document uploads. */
export enum DocumentUploadCategory {
  /** A primary document */
  APPLICATION = "APPLICATION",
  /** A supporting document type */
  CARD_ART = "CARD_ART",
  /** A supporting document type */
  CHECK_PAYMENTS = "CHECK_PAYMENTS",
  /** A secondary document */
  DISPUTES = "DISPUTES",
  /** A supporting document type */
  IDENTITY_CASE = "IDENTITY_CASE",
  /** A supporting document type */
  MANUAL_REQUEST = "MANUAL_REQUEST",
}

/** Permissions for a Document Upload Client Token */
export enum DocumentUploadClientTokenPermission {
  /**
   * Manage the lifecycle of a document upload session.
   *
   * Setting this permission will allow the using the token to start and end the session. Additionally, the client will be allowed to
   * initiate file uploads for the specified session in the token.
   */
  MANAGE_DOCUMENT_UPLOAD_SESSION = "MANAGE_DOCUMENT_UPLOAD_SESSION",
}

/** A collection of documents pertaining to a specific `DocumentUploadDomain`, all associated with a single entity */
export type DocumentUploadCollection = {
  __typename?: "DocumentUploadCollection";
  /** The domain associated with these documents */
  domain?: Maybe<DocumentUploadCategory>;
  /** The sets of documents associated with this collection. */
  entries?: Maybe<Array<DocumentUploadCollectionEntry>>;
  /** The unique identifier for the document upload collection. */
  id: Scalars["ID"];
  /** The owner to which all documents in this collection are associated. */
  owner?: Maybe<DocumentCollectionOwnerEntity>;
};

/** A set of documents collected in a single document upload session */
export type DocumentUploadCollectionEntry = {
  __typename?: "DocumentUploadCollectionEntry";
  /** The aggregate entity to which all documents in this collection entry are associated. */
  aggregateEntity?: Maybe<DocumentCollectionAggregateEntity>;
  /** The document upload collection this entry is a member of. */
  documents?: Maybe<DocumentUploadCollection>;
  /** The domain associated with these documents */
  domain?: Maybe<DocumentUploadCategory>;
  /** The files in this collection entry. */
  files?: Maybe<Array<UploadLink>>;
  /** The unique identifier for the document upload collection entry. */
  id: Scalars["ID"];
  /** The primary entity associated with the `DocumentUploadSession`. */
  primaryEntity?: Maybe<DocumentCollectionPrimaryEntity>;
};

/** A secure upload link for a document upload session */
export type DocumentUploadLink = Node &
  UploadLink & {
    __typename?: "DocumentUploadLink";
    /** The date and time, in ISO 8601 format, this `document upload link` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The categorization of an uploaded document */
    documentCategoryType?: Maybe<DocumentCategoryType>;
    /** The document type that was uploaded */
    documentType?: Maybe<DocumentType>;
    /** The document details. */
    documentUploadLinkDocumentDetails?: Maybe<DocumentUploadLinkDocumentDetailsResult>;
    /** The session which associates all of the files uploaded using the secure upload link */
    documentUploadSession?: Maybe<DocumentUploadSession>;
    /** Global ID used to reference the secure upload link */
    id: Scalars["ID"];
    /** The status of the upload */
    status?: Maybe<DocumentUploadLinkStatusCode>;
    /** The date and time, in ISO 8601 format, this `document upload link` was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /**
     * A url to be used to upload the contents of the document.
     *
     * ** Note: ** The maximum file size is 10 MB
     */
    uploadUrl?: Maybe<Scalars["String"]>;
  };

/** Upload link document details. */
export type DocumentUploadLinkDocumentDetails = {
  __typename?: "DocumentUploadLinkDocumentDetails";
  /** The url to download the document */
  downloadUrl?: Maybe<Scalars["String"]>;
};

/** Response type for upload link document details. */
export type DocumentUploadLinkDocumentDetailsResult =
  | AccessDeniedError
  | DocumentUploadLinkDocumentDetails
  | UserError;

/** A status representing a file upload */
export enum DocumentUploadLinkStatusCode {
  /** A file upload completed successfully and has been securely stored in the document store */
  COMPLETED = "COMPLETED",
  /** A file upload has been denied due to malicious content or malware present in the file */
  DENIED = "DENIED",
  /** A file upload has failed due to server communication and needs to be retried */
  FAILED = "FAILED",
  /** A file upload is currently in progress and is being processed */
  IN_PROGRESS = "IN_PROGRESS",
  /** The upload link has been created and is waiting for a file to be uploaded */
  PENDING = "PENDING",
}

/** A document upload session that has been requested. */
export type DocumentUploadRequestEvent = Node & {
  __typename?: "DocumentUploadRequestEvent";
  /** A list of requested documents. */
  documents?: Maybe<Array<DocumentRequest>>;
  /** The date and time, in ISO 8601 format, this `ManuallyDocumentRequestUploadSession` will expire. */
  expiresAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the document upload session */
  id: Scalars["ID"];
};

/** A requirement constraint for a document upload */
export type DocumentUploadRequirementConstraint = {
  __typename?: "DocumentUploadRequirementConstraint";
  /** Allowed document type supported for a given upload requirement */
  documentType?: Maybe<DocumentCategoryType>;
  /** The number of documents required for a category type */
  numberOfDocuments?: Maybe<Scalars["Int"]>;
};

export type DocumentUploadSession = {
  /** The date and time, in ISO 8601 format, this `document upload session` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** A list of documents uploaded via a secure document upload link */
  documents?: Maybe<Array<UploadLink>>;
  /** Global ID used to reference the document upload session */
  id: Scalars["ID"];
  /** The current state of the document upload session */
  status?: Maybe<DocumentUploadSessionStatusCode>;
  /** The date and time, in ISO 8601 format, this `document upload session` was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

export type DocumentUploadSessionCompleteEvent = Node & {
  __typename?: "DocumentUploadSessionCompleteEvent";
  /** All document upload links associated with the document upload session */
  documents?: Maybe<Array<DocumentUploadLink>>;
  /** Global ID used to reference the document upload session */
  id: Scalars["ID"];
};

/** A union representing a `DocumentUploadSessionContext` */
export type DocumentUploadSessionContext =
  AccountHolderApplicationDocumentUploadSessionContext;

/** A status code representing the state of the document upload session */
export enum DocumentUploadSessionStatusCode {
  /** The document upload session is created, but has not been initiated */
  CREATED = "CREATED",
  /**
   * A session has expired due to inactivity. A session can result in an expired state if it is never transitioned to submitted.
   * Files can no longer be uploaded to the session.
   */
  EXPIRED = "EXPIRED",
  /** The document upload session has been initiated and files can now be uploaded to the session */
  INITIATED = "INITIATED",
  /** A session has started and a file upload request has been initiated. */
  IN_PROGRESS = "IN_PROGRESS",
  /**
   * A session has ended.
   * Files can no longer be uploaded to the session.
   */
  SUBMITTED = "SUBMITTED",
}

/** Whether or not the `CardProduct` supports early direct deposit feature. */
export type EarlyDirectDepositCardProductFeature = CardProductFeature &
  ProductFeature & {
    __typename?: "EarlyDirectDepositCardProductFeature";
    /** The date and time, in ISO 8601 format, the feature was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective from. */
    effectiveFrom?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective through. */
    effectiveThrough?: Maybe<Scalars["String"]>;
    /** Whether or not the feature is enabled for the `CardProduct`. */
    enabled?: Maybe<Scalars["Boolean"]>;
    /** The date and time, in ISO 8601 format, the feature was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Method of Earning for Rewards Rule. */
export enum EarnRuleType {
  /** Earning points on a per transaction basis. */
  PER_TRANSACTION_SPEND_AMOUNT = "PER_TRANSACTION_SPEND_AMOUNT",
}

/** Electronic fund transfer type used for fund movement. */
export enum ElectronicFundTransferSource {
  /** Transfer funds using wire transfer */
  WIRE = "WIRE",
}

/** A movement of money within the Highnote platform. */
export type ElectronicFundsTransfer = {
  /** The amount of the Transfer. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, the Transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the Transfer in operations. */
  id: Scalars["ID"];
  /** The ledgers affected by the transfer. */
  ledgers?: Maybe<Array<Ledger>>;
  /** The date and time, in ISO 8601 format, the Transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** A movement of money within the Highnote platform. */
export type ElectronicFundsTransferLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** Embedded Device information */
export type EmbeddedDeviceInformation = {
  __typename?: "EmbeddedDeviceInformation";
  /** Type of form factor */
  formFactor?: Maybe<FormFactorType>;
  /** URL to image of the device */
  image?: Maybe<Scalars["String"]>;
  /** Device name */
  name?: Maybe<Scalars["String"]>;
  /** Serial number */
  serialNumber?: Maybe<Scalars["String"]>;
  /** Device variant */
  variant?: Maybe<Scalars["String"]>;
};

/** A employee financial account allows you to move money from Employer owned accounts to their customer accounts */
export type EmployerFinancialAccount = Node & {
  __typename?: "EmployerFinancialAccount";
  /** The Card Product Application used to issue this Employer Financial Account. */
  application?: Maybe<AccountHolderCardProductApplication>;
  /** The Card Product associated to the Employer Financial Account. */
  cardProduct?: Maybe<CardProduct>;
  /** The company Identifier. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the Employer Financial Account was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The list of features for a Employer Financial Account. */
  features?: Maybe<Array<FinancialAccountFeature>>;
  /** Global ID used to reference the Employer Advance Account in operations. */
  id: Scalars["ID"];
  /** The name of this account. */
  name?: Maybe<Scalars["String"]>;
  /** The owner of this Employer Financial Account */
  owner?: Maybe<FinancialAccountOwner>;
  /** The date and time, in ISO 8601 format, the Employer Financial Account was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The types of employment status. */
export enum EmploymentStatus {
  /** The person account holder is currently employed by an employer. */
  EMPLOYED = "EMPLOYED",
  /** The person account holder has another employment status. */
  OTHER = "OTHER",
  /** The person account holder is not employed and currently retired. */
  RETIRED = "RETIRED",
  /** The person account holder is currently self-employed. */
  SELF_EMPLOYED = "SELF_EMPLOYED",
  /** The person account holder is not employed and currently a student. */
  STUDENT = "STUDENT",
  /** The person account holder is not employed. */
  UNEMPLOYED = "UNEMPLOYED",
}

/** The input to enable the authorized user product feature. */
export type EnableAuthorizedUserFeatureInput = {
  /** The Global ID of the `CardProduct` for which to enable authorized user product feature. */
  cardProductId: Scalars["ID"];
};

/** The return types when calling `enableAuthorizedUserFeature` on a `CardProduct`. */
export type EnableAuthorizedUserFeaturePayload =
  | AccessDeniedError
  | CardProduct
  | UserError;

/** The input to configure the Collaborative Application Decisioning product feature. */
export type EnableCollaborativeApplicationUnderwritingFeatureInput = {
  /** The Global ID of the `CardProduct` for which to enable the Collaborative Application Decisioning product feature. */
  cardProductId: Scalars["ID"];
};

/** The return types when calling `enableCollaborativeApplicationUnderwritingFeature` on a `CardProduct`. */
export type EnableCollaborativeApplicationUnderwritingFeaturePayload =
  | AccessDeniedError
  | CardProduct
  | UserError;

/** The input to configure the Collaborative Authorization product feature. */
export type EnableCollaborativeAuthorizationFeatureInput = {
  /** The Global ID of the `CardProduct` for which to enable the Collaborative Authorization product feature. */
  cardProductId: Scalars["ID"];
};

/** The return types when enabling the Collaborative Authorization product feature. */
export type EnableCollaborativeAuthorizationFeaturePayload =
  | AccessDeniedError
  | CardProduct
  | UserError;

/** The input to configure the credit card product feature. */
export type EnableCreditCardFeatureInput = {
  /** The Global ID of the `CardProduct` for which to enable the credit card product feature. */
  cardProductId: Scalars["ID"];
  /** Whether the feature assigned to this credit product will be `REVOLVING` or `CHARGE` */
  feature: CreditCardProductFeature;
};

/** The return types when calling `enableCreditCardFeature` on a `CardProduct`. */
export type EnableCreditCardFeaturePayload =
  | AccessDeniedError
  | CardProduct
  | UserError;

/** The input to configure the On demand product feature. */
export type EnableOnDemandFundingFeatureInput = {
  /** The Global ID of the `CardProduct` for which to enable the On Demand product feature. */
  cardProductId: Scalars["ID"];
  /** Whether or not a pseudo balance will be used for maximum spend on `FinancialAccount` associated to a card */
  pseudoBalanceEnabled: Scalars["Boolean"];
};

/** The return types when calling `enableOnDemandFundingFeature` on a `CardProduct`. */
export type EnableOnDemandFundingFeaturePayload =
  | AccessDeniedError
  | CardProduct
  | UserError;

/** The input to end a document upload session */
export type EndDocumentUploadSessionInput = {
  /** The ID of the document upload session */
  documentUploadSessionId: Scalars["ID"];
};

export type EndDocumentUploadSessionPayload =
  | AccessDeniedError
  | CardProfileDocumentUploadSession
  | CheckPaymentDocumentUploadSession
  | IdentityVerificationDocumentUploadSession
  | ManualDocumentRequestUploadSession
  | UsAccountHolderApplicationDocumentUploadSession
  | UserError;

/** A event containing additional data related to a transaction. */
export type EnhancedDataEvent = Node &
  TransactionEvent & {
    __typename?: "EnhancedDataEvent";
    /** Not used for this `EnhancedDataEvent`. */
    accountingDirection?: Maybe<AccountingDirection>;
    /** Not used for this `EnhancedDataEvent` */
    additionalNetworkData?: Maybe<AdditionalNetworkData>;
    /** Level 2 / Level 3 transaction data for this transaction */
    additionalTransactionData?: Maybe<Array<AdditionalTransactionData>>;
    /** Not used for this `EnhancedDataEvent` */
    approvedAmount?: Maybe<Amount>;
    /** Not used for this `EnhancedDataEvent` */
    cardProduct?: Maybe<CardProduct>;
    /** The date and time, in ISO 8601 format, this `EnhancedDataEvent` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Not used for this `EnhancedDataEvent` */
    currentFinancialAccountAvailableToSpendAmount?: Maybe<Amount>;
    /** Not used for this `EnhancedDataEvent` */
    currentFinancialAccountMaximumBalanceAmount?: Maybe<Amount>;
    /** The ID of the transaction event. This `id` can be used to later retrieve details of this `EnhancedDataEvent` or correlate it with other events on this `Transaction`. */
    id: Scalars["ID"];
    /** Not used for this `EnhancedDataEvent` */
    merchantDetails?: Maybe<MerchantDetails>;
    /**
     * Not used for this `EnhancedDataEvent`
     * @deprecated Use responseCode instead
     */
    networkResponseCode?: Maybe<Scalars["String"]>;
    /**
     * The transaction ID from the card network (e.g. Mastercard).
     * @deprecated No longer supported
     */
    networkTransactionId?: Maybe<Scalars["ID"]>;
    /** Not used for this `EnhancedDataEvent` */
    paymentCard?: Maybe<PaymentCard>;
    /** Not used for this `EnhancedDataEvent` */
    pointOfServiceDetails?: Maybe<PointOfServiceDetails>;
    /** Not used for this `EnhancedDataEvent` */
    requestedAmount?: Maybe<Amount>;
    /** The Highnote response code. */
    responseCode?: Maybe<TransactionEventResponseCode>;
    /** The `Transaction` for this event. */
    transaction?: Maybe<Transaction>;
    /** Not used for this `EnhancedDataEvent` */
    transactionProcessingType?: Maybe<CardTransactionProcessingType>;
  };

/** A time range that an api can be accessed. */
export type ExpirationDetail = {
  /** The end date and time, in ISO 8601 format, that an API can be accessed. */
  expiry: Scalars["String"];
  /** The start date and time, in ISO 8601 format, that an API can be accessed. */
  start: Scalars["String"];
};

/** Event generated when an external bank account is linked to an account holder. */
export type ExternalBankAccountAddedEvent = ExternalBankAccountEvent &
  Node & {
    __typename?: "ExternalBankAccountAddedEvent";
    /** The identifier of an Account holder */
    accountHolderId?: Maybe<Scalars["ID"]>;
    /** The name of this account. */
    accountName?: Maybe<Scalars["String"]>;
    /** ExternalFinancialBankAccount status. */
    accountStatus?: Maybe<ExternalFinancialAccountStatus>;
    /** The date and time, in ISO 8601 format, the external bank account was added. */
    addedAt?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the external bank account was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The external bank account added to this external financial account. */
    externalBankAccountDetail?: Maybe<ExternalBankAccountDetail>;
    /** Id for the external account. */
    id: Scalars["ID"];
    /** The provider that Highnote used to verify this bank account. */
    provider?: Maybe<BankVerificationProvider>;
    /** The date and time, in ISO 8601 format, the external bank account was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/**
 * A financial instrument with an associated account and routing number.
 *
 * The direct deposit detail that can be used to deposit funds.
 *
 * If ExternalFinancialBankAccount is CLOSED then ExternalBankAccountDetail will not be returned except during close mutation.
 */
export type ExternalBankAccountDetail = Node & {
  __typename?: "ExternalBankAccountDetail";
  /** The date and time, in ISO 8601 format, the external bank account detail was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the external bank account detail in operations. */
  id: Scalars["ID"];
  /** The last four digits of bank account number. */
  last4?: Maybe<Scalars["String"]>;
  /** The routing number for the bank account. */
  routingNumber?: Maybe<Scalars["String"]>;
  /** The details about the type of bank account. */
  type?: Maybe<BankAccountType>;
  /** The date and time, in ISO 8601 format, the external bank account detail was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Permissions for a Direct Deposit Details Client Token */
export enum ExternalBankAccountDetailClientTokenPermission {
  /**
   * Read `accountNumber` for Direct Deposit Details.
   *
   * Setting this permission will allow using the token to query for a DirectDepositDetail and read its `restrictedDetails` property.
   */
  READ_RESTRICTED_DETAILS = "READ_RESTRICTED_DETAILS",
}

/** External Bank Account Added Event */
export type ExternalBankAccountEvent = {
  /** The identifier of an Account holder */
  accountHolderId?: Maybe<Scalars["ID"]>;
  /** The name of this account. */
  accountName?: Maybe<Scalars["String"]>;
  /** ExternalFinancialBankAccount status. */
  accountStatus?: Maybe<ExternalFinancialAccountStatus>;
  /** The date and time, in ISO 8601 format, the external bank account was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The external bank account added to this external financial account. */
  externalBankAccountDetail?: Maybe<ExternalBankAccountDetail>;
  /** Id for the external account. */
  id: Scalars["ID"];
  /** The provider that Highnote used to verify this bank account. */
  provider?: Maybe<BankVerificationProvider>;
  /** The date and time, in ISO 8601 format, the external bank account was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Event generated when an external bank account was disconnected from an account holder. */
export type ExternalBankAccountRemovedEvent = ExternalBankAccountEvent &
  Node & {
    __typename?: "ExternalBankAccountRemovedEvent";
    /** The identifier of an Account holder */
    accountHolderId?: Maybe<Scalars["ID"]>;
    /** The name of this account. */
    accountName?: Maybe<Scalars["String"]>;
    /** ExternalFinancialBankAccount status. */
    accountStatus?: Maybe<ExternalFinancialAccountStatus>;
    /** The date and time, in ISO 8601 format, the external bank account was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The external bank account removed from this external financial account. */
    externalBankAccountDetail?: Maybe<ExternalBankAccountDetail>;
    /** Id for the external account. */
    id: Scalars["ID"];
    /** The provider that Highnote used to verify this bank account. */
    provider?: Maybe<BankVerificationProvider>;
    /** The date and time, in ISO 8601 format, the external bank account was removed. */
    removedAt?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the external bank account was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Whether or not the `CardProduct` supports external business management */
export type ExternalBusinessManagementCardProductFeature = CardProductFeature &
  ProductFeature & {
    __typename?: "ExternalBusinessManagementCardProductFeature";
    /** The date and time, in ISO 8601 format, the feature was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective from. */
    effectiveFrom?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective through. */
    effectiveThrough?: Maybe<Scalars["String"]>;
    /** Whether or not the feature is enabled for the `CardProduct`. */
    enabled?: Maybe<Scalars["Boolean"]>;
    /** The date and time, in ISO 8601 format, the feature was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** The external financial account created for any external financial instrument of account holder. */
export type ExternalFinancialAccount =
  | ExternalFinancialBankAccount
  | NonVerifiedExternalUsFinancialBankAccount;

/** The connection type for External Financial Account. */
export type ExternalFinancialAccountConnection = {
  __typename?: "ExternalFinancialAccountConnection";
  /** A list of edges. */
  edges?: Maybe<Array<ExternalFinancialAccountEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a ExternalFinancialAccount. */
export type ExternalFinancialAccountEdge = {
  __typename?: "ExternalFinancialAccountEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The External Financial Account. */
  node?: Maybe<ExternalFinancialAccount>;
};

/** The status of a `ExternalFinancialAccount`. */
export enum ExternalFinancialAccountStatus {
  /** The `ExternalFinancialAccount` is active and in good standing. */
  ACTIVE = "ACTIVE",
  /**
   * The `ExternalFinancialAccount` is Closed.
   *
   * This is a terminal state and cannot be reversed.
   */
  CLOSED = "CLOSED",
}

/** External financial account for external bank account. */
export type ExternalFinancialBankAccount = Node & {
  __typename?: "ExternalFinancialBankAccount";
  /** ExternalFinancialBankAccount status. */
  accountStatus?: Maybe<ExternalFinancialAccountStatus>;
  /** The date and time, in ISO 8601 format, the Financial Account was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /**
   * A paginated list of Externally Initiated ACH Transfers.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  externalACHTransfers?: Maybe<ExternallyInitiatedAchTransferConnection>;
  /** The external bank account added to this external financial account. */
  externalBankAccountDetails?: Maybe<ExternalBankAccountDetail>;
  /**
   * A paginated list of Externally Initiated ACH Transfers.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   *
   * Deprecated, in favor of externalACHTransfers
   */
  externallyInitiatedACHTransfer?: Maybe<ExternallyInitiatedAchTransferConnection>;
  /**
   * A paginated list of Externally Initiated ACH Transfers.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   *
   * Deprecated
   * @deprecated ACHTransactionConnection is deprecated in favor of IntegratorInitiatedACHTransferConnection and/or ExternallyInitiatedACHTransferConnection.
   */
  externallyInitiatedAchTransfers?: Maybe<AchTransactionConnection>;
  /** The list of features for this financial account. */
  features?: Maybe<Array<FinancialAccountFeature>>;
  /** Global ID used to reference the External Financial Account in operations. */
  id: Scalars["ID"];
  /**
   * A paginated list of Integrator Initiated ACH Transfers.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  integratorACHTransfers?: Maybe<IntegratorInitiatedAchTransferConnection>;
  /**
   * A paginated list of Integrator Initiated ACH Transfers.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   *
   * Deprecated, in favor of internalACHTransfers
   */
  integratorInitiatedACHTransfer?: Maybe<IntegratorInitiatedAchTransferConnection>;
  /**
   * A paginated list of Integrator Initiated ACH Transfers.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   *
   * Deprecated
   * @deprecated ACHTransactionConnection is deprecated in favor of IntegratorInitiatedACHTransferConnection and/or ExternallyInitiatedACHTransferConnection.
   */
  integratorInitiatedAchTransfers?: Maybe<AchTransactionConnection>;
  /** The ledgers backing this financial account. */
  ledgers?: Maybe<Array<Ledger>>;
  /** The name of this account. */
  name?: Maybe<Scalars["String"]>;
  /**
   * A paginated list of non-originated ACH transfers.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  nonOriginatedAchTransfers?: Maybe<NonOriginatedAchTransferPayload>;
  /**
   * A paginated list of originated ACH transfers.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  originatedAchTransfers?: Maybe<OriginatedAchTransferPayload>;
  /** The owner of this financial account */
  owner?: Maybe<FinancialAccountOwner>;
  /** The provider that Highnote used to verify this bank account. */
  provider?: Maybe<BankVerificationProvider>;
  /**
   * A paginated list of TransactionEvents.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  transactionEvents?: Maybe<TransactionEventConnection>;
  /** The date and time, in ISO 8601 format, the Financial Account was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** External financial account for external bank account. */
export type ExternalFinancialBankAccountExternalAchTransfersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<ExternallyInitiatedAchTransferFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** External financial account for external bank account. */
export type ExternalFinancialBankAccountExternallyInitiatedAchTransferArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<ExternallyInitiatedAchTransferFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** External financial account for external bank account. */
export type ExternalFinancialBankAccountExternallyInitiatedAchTransfersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<ExternallyInitiatedAchTransferFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** External financial account for external bank account. */
export type ExternalFinancialBankAccountIntegratorAchTransfersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<IntegratorInitiatedAchTransferFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** External financial account for external bank account. */
export type ExternalFinancialBankAccountIntegratorInitiatedAchTransferArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<IntegratorInitiatedAchTransferFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** External financial account for external bank account. */
export type ExternalFinancialBankAccountIntegratorInitiatedAchTransfersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<IntegratorInitiatedAchTransferFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** External financial account for external bank account. */
export type ExternalFinancialBankAccountNonOriginatedAchTransfersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<NonOriginatedAchTransferFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** External financial account for external bank account. */
export type ExternalFinancialBankAccountOriginatedAchTransfersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<OriginatedAchTransferFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** External financial account for external bank account. */
export type ExternalFinancialBankAccountTransactionEventsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<TransactionEventsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A transaction for an external money movement. */
export type ExternalMoneyMovementTransaction = ElectronicFundsTransfer &
  Node & {
    __typename?: "ExternalMoneyMovementTransaction";
    /** The transfer amount. */
    amount?: Maybe<Amount>;
    /** The date and time the transfer was created, in ISO 8601 format, e.g. 2024-01-01T00:00:00.000Z. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The external ID of the transaction. */
    externalIdentifier?: Maybe<Scalars["String"]>;
    /** The FinancialAccount where the funds for this transfer has initiated from */
    financialAccount?: Maybe<FinancialAccount>;
    /** Global ID used to reference the transfer. */
    id: Scalars["ID"];
    /** The ledgers affected by the transfer. */
    ledgers?: Maybe<Array<Ledger>>;
    /** The status of the transfer. */
    status?: Maybe<ExternalMoneyMovementTransactionStatus>;
    /** In the case of a failed `status`, returns the failed reason. */
    statusReason?: Maybe<ExternalMoneyMovementTransactionStatusReasonCode>;
    /** The type for this transfer. */
    type?: Maybe<ExternalMoneyMovementTransactionType>;
    /** The date and time the transfer was last updated, in ISO 8601 format, e.g. 2024-01-01T00:00:00.000Z. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** A transaction for an external money movement. */
export type ExternalMoneyMovementTransactionLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** A transaction event for an external money movement. */
export type ExternalMoneyMovementTransactionEvent = Node & {
  __typename?: "ExternalMoneyMovementTransactionEvent";
  /** The amount of the `ExternalMoneyMovementTransactionEvent`. */
  amount?: Maybe<Amount>;
  /** The date and time the transfer was created, in ISO 8601 format, e.g. 2024-01-01T00:00:00.000Z. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The type of the `ExternalMoneyMovementTransactionEvent`. */
  eventType?: Maybe<ExternalMoneyMovementTransactionEventType>;
  /** The reason for the failure of the `ExternalMoneyMovementTransactionEvent`. */
  failureReason?: Maybe<ExternalMoneyMovementTransactionEventStatusFailureReason>;
  /** Global ID used to reference the `ExternalMoneyMovementTransactionEvent` in operations. */
  id: Scalars["ID"];
  /** The ledgers affected by the DisbursementTransferEvent. */
  ledgers?: Maybe<Array<Ledger>>;
  /** The status of the `ExternalMoneyMovementTransactionEvent`. */
  status?: Maybe<ExternalMoneyMovementTransactionEventStatus>;
  /** The date and time the transfer was last updated, in ISO 8601 format, e.g. 2024-01-01T00:00:00.000Z. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The status of the `ExternalMoneyMovementTransactionEvent`. */
export enum ExternalMoneyMovementTransactionEventStatus {
  /** The `ExternalMoneyMovementTransactionEvent` has failed. See `failureReason` for more information. */
  FAILED = "FAILED",
  /** The `ExternalMoneyMovementTransactionEvent` has been initiated. */
  INITIATED = "INITIATED",
  /** The `ExternalMoneyMovementTransactionEvent` has been processed. */
  PROCESSED = "PROCESSED",
  /** The `ExternalMoneyMovementTransactionEvent` is processing. */
  PROCESSING = "PROCESSING",
}

/** The reason for a `ExternalMoneyMovementTransactionEvent` failure. */
export enum ExternalMoneyMovementTransactionEventStatusFailureReason {
  /** The source or receiving account was not found. */
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  /** Idempotency Key not provided. */
  IDEMPOTENCY_KEY_NOT_PROVIDED = "IDEMPOTENCY_KEY_NOT_PROVIDED",
  /** The source account of the transfer did not have enough funds to cover the requested amount. */
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  /** The account number provided was invalid. */
  INVALID_ACCOUNT_NUMBER = "INVALID_ACCOUNT_NUMBER",
  /** Transfer amount is negative or zero. */
  TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO = "TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO",
  /** The reason for the failure is unspecified, contact Highnote support for more information. */
  UNSPECIFIED = "UNSPECIFIED",
}

/** The type of an `ExternalMoneyMovementTransactionEvent`. */
export enum ExternalMoneyMovementTransactionEventType {
  /** Indicates a payout event. */
  PAYOUT = "PAYOUT",
  /** Indicates a platform fee event. */
  PLATFORM_FEE = "PLATFORM_FEE",
}

/** The status of a `ExternalMoneyMovementTransaction` */
export enum ExternalMoneyMovementTransactionStatus {
  /** The payment has been completed. */
  COMPLETED = "COMPLETED",
  /** The payment has been failed. */
  FAILED = "FAILED",
  /** The payment has been initiated. */
  INITIATED = "INITIATED",
  /** The payment is pending. */
  PENDING = "PENDING",
  /** The payment status is unspecified. Contact Highnote support for more information. */
  UNSPECIFIED = "UNSPECIFIED",
}

/** The possible reasons a `ExternalMoneyMovementTransaction` could fail. */
export enum ExternalMoneyMovementTransactionStatusReasonCode {
  /** The source or receiving account was not found. */
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  /** Idempotency Key not provided. */
  IDEMPOTENCY_KEY_NOT_PROVIDED = "IDEMPOTENCY_KEY_NOT_PROVIDED",
  /** The source account of the transfer did not have enough funds to cover the requested amount. */
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  /** The account number provided was invalid. */
  INVALID_ACCOUNT_NUMBER = "INVALID_ACCOUNT_NUMBER",
  /** Transfer amount is negative or zero. */
  TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO = "TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO",
  /** The reason for the failure is unspecified, contact Highnote support for more information. */
  UNSPECIFIED = "UNSPECIFIED",
}

/** The type of an `ExternalMoneyMovementTransaction`. */
export enum ExternalMoneyMovementTransactionType {
  /** Indicates a payout. */
  PAYOUT = "PAYOUT",
  /** Indicates a platform fee. */
  PLATFORM_FEE = "PLATFORM_FEE",
}

/** External Physical Payment Card Order */
export type ExternalPhysicalPaymentCardOrder = Node & {
  __typename?: "ExternalPhysicalPaymentCardOrder";
  /**
   * Payment card.
   * @deprecated `card` is no longer supported
   */
  card?: Maybe<PaymentCard>;
  /** The date and time, in ISO 8601 format, the order was created at. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Embedded Device information. */
  embeddedDevice?: Maybe<EmbeddedDeviceInformation>;
  /** Global ID used to reference the ExternalPhysicalPaymentCardOrder in operations. */
  id: Scalars["ID"];
  /** Payment card. */
  paymentCard?: Maybe<PaymentCard>;
  /** Current order status. */
  status?: Maybe<PaymentCardOrderStatus>;
  /** The date and time, in ISO 8601 format, the order was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The Finicity token that can be used to fetch bank account details of account holder. */
export type ExternalTokenFinicityInput = {
  /** A pseudo customer ID that Highnote will use to retrieve data via Finicity's 3PA integration. */
  customerId: Scalars["ID"];
  /** An array of products/api-endpoints that Highnote can use to retrieve users' financial data. */
  products?: InputMaybe<Array<FinicityProduct>>;
  /** Proof of user consent to share financial data with Highnote. */
  receiptId: Scalars["ID"];
};

/** The external token that can be used to fetch bank account details of account holder. */
export type ExternalTokenInput = {
  /** A token provided by a third-party (e.g. Plaid) that Highnote can use to securely fetch an account holder's bank details. */
  value: Scalars["String"];
};

/** Hold status of an ACH integrator initiated transaction */
export enum ExternallyInitiatedAchHoldStatus {
  /** The ACH Transaction had a hold but it has been removed */
  HOLD_REMOVED = "HOLD_REMOVED",
  /** The ACH Transaction is not on hold */
  NO_HOLDS = "NO_HOLDS",
  /** The ACH Transaction is currently on hold */
  ON_HOLD = "ON_HOLD",
  /** The hold status is unspecified */
  UNSPECIFIED = "UNSPECIFIED",
}

/** Input for filtering by `ExternallyInitiatedACHHoldStatusFilterInput`. */
export type ExternallyInitiatedAchHoldStatusFilterInput = {
  equals?: InputMaybe<ExternallyInitiatedAchHoldStatus>;
  excludes?: InputMaybe<Array<ExternallyInitiatedAchHoldStatus>>;
  includes?: InputMaybe<Array<ExternallyInitiatedAchHoldStatus>>;
  notEquals?: InputMaybe<ExternallyInitiatedAchHoldStatus>;
};

/** Status of an externally initiated ACH transfer that has been sent to Highnote by a partner bank. */
export enum ExternallyInitiatedAchStatus {
  /** The transfer has been canceled by Highnote. This status is rare and typically indicates the transfer was received in error. */
  CANCELED = "CANCELED",
  /** The transfer failed. More details are available in `ExternallyInitiatedACHStatusReasonCode`. */
  FAILED = "FAILED",
  /** The transfer has been received by Highnote, but cannot be processed yet as the effective date is in the future. */
  PENDING = "PENDING",
  /** The transfer has successfully been processed by Highnote. */
  PROCESSED = "PROCESSED",
  /** The transfer is processing at Highnote, but funds are not available yet. */
  PROCESSING = "PROCESSING",
  /** The transfer has been returned to the bank that initiated it. More details are available in `ExternallyInitiatedACHStatusReasonCode`. */
  RETURNED = "RETURNED",
  /** The transfer has been returned to the bank that initiated it. */
  REVERSED = "REVERSED",
}

/** Details about the status of the ACH transfer. */
export type ExternallyInitiatedAchStatusDetails =
  | FailureExternallyInitiatedAchStatus
  | NonFailureExternallyInitiatedAchStatus;

/** Input for filtering by `ExternallyInitiatedACHStatusFilterInput`. */
export type ExternallyInitiatedAchStatusFilterInput = {
  equals?: InputMaybe<ExternallyInitiatedAchStatus>;
  excludes?: InputMaybe<Array<ExternallyInitiatedAchStatus>>;
  includes?: InputMaybe<Array<ExternallyInitiatedAchStatus>>;
  notEquals?: InputMaybe<ExternallyInitiatedAchStatus>;
};

/** Additional details regarding a `FAILED` or `RETURNED` transfer. */
export enum ExternallyInitiatedAchStatusReasonCode {
  /** R11 - The `fromFinancialAccount` and `toFinancialAccount` do not belong to the same product. */
  ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT = "ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT",
  /** The Highnote account was closed. */
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  /** R16 - The account is frozen. */
  ACCOUNT_FROZEN = "ACCOUNT_FROZEN",
  /** The Highnote account could not be found. */
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  /** Loading funds via ACH is not supported. */
  ACH_LOAD_NOT_SUPPORTED = "ACH_LOAD_NOT_SUPPORTED",
  /** R19 - There is an error in the amount field. */
  AMOUNT_FIELD_ERROR = "AMOUNT_FIELD_ERROR",
  /** R07 - The Authorization was revoked by Customer. */
  AUTHORIZATION_REVOKED_BY_CUSTOMER = "AUTHORIZATION_REVOKED_BY_CUSTOMER",
  /** R11 - The account does not have the required commercial pay in full account feature enabled. */
  COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED = "COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED",
  /** The account does not have the required corporate bank account feature enabled. */
  CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED = "CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED",
  /** R11 - The credit limit is not set on the account. */
  CREDIT_LIMIT_NOT_SET_ON_ACCOUNT = "CREDIT_LIMIT_NOT_SET_ON_ACCOUNT",
  /** The currency of the transfer did not match the currency of the Highnote account. */
  CURRENCY_MISMATCH = "CURRENCY_MISMATCH",
  /** R24 - Resulted in a Duplicate Entry. */
  DUPLICATE_ENTRY = "DUPLICATE_ENTRY",
  /** R11 - The transfer is not in accordance with the terms of the account. */
  ENTRY_NOT_IN_ACCORDANCE_WITH_TERMS_OF_AUTHORIZATION = "ENTRY_NOT_IN_ACCORDANCE_WITH_TERMS_OF_AUTHORIZATION",
  /** R18 - Has an Improper Effective entry date. */
  IMPROPER_EFFECTIVE_ENTRY_DATE = "IMPROPER_EFFECTIVE_ENTRY_DATE",
  /** This was a debit from an account at Highnote which did not have enough funds. */
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  /** There is an internal error with the transfer. */
  INTERNAL_ERROR = "INTERNAL_ERROR",
  /** R04 - Has an Invalid Account Number. */
  INVALID_ACCOUNT_NUMBER = "INVALID_ACCOUNT_NUMBER",
  /** R21 - Has an Invalid Company ID Number. */
  INVALID_COMPANY_ID_NUMBER = "INVALID_COMPANY_ID_NUMBER",
  /** R22 - Has an Invalid Individual ID Number. */
  INVALID_INDIVIDUAL_ID_NUMBER = "INVALID_INDIVIDUAL_ID_NUMBER",
  /** R20 - Is a Non Transactional Account. */
  NON_TRANSACTION_ACCOUNT = "NON_TRANSACTION_ACCOUNT",
  /** R08 - The Payment was stopped. */
  PAYMENT_STOPPED = "PAYMENT_STOPPED",
  /** The account does not have the required payroll advance feature enabled. */
  PAYROLL_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED",
  /** The account does not have the required payroll employer advance feature enabled. */
  PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED",
  /** R06 - Funds were returned per OFDI Request. */
  RETURNED_PER_ODFI_REQUEST = "RETURNED_PER_ODFI_REQUEST",
  /** R29 - The Transaction was not Authorized By Account Holder. */
  TRANSACTION_NOT_AUTHORIZED_BY_ACCOUNT_HOLDER = "TRANSACTION_NOT_AUTHORIZED_BY_ACCOUNT_HOLDER",
  /** The transfer amount is below the minimum amount to reload. */
  TRANSFER_AMOUNT_BELOW_MIN_RELOAD_LIMIT = "TRANSFER_AMOUNT_BELOW_MIN_RELOAD_LIMIT",
  /** The transfer exceeds the maximum load limit. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_LOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_LOAD_LIMIT",
  /** The transfer exceeds the maximum reload limit. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_RELOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_RELOAD_LIMIT",
  /** R05 - Is an Unauthorized Debit to Consumer Account Using Corporate SEC Code. */
  UNAUTHORIZED_CONSUMER_DEBIT_USING_CORPORATE_SEC_CODE = "UNAUTHORIZED_CONSUMER_DEBIT_USING_CORPORATE_SEC_CODE",
  /** R10 - Is an Unauthorized, Improper, Ineligible, or Incomplete Transaction. */
  UNAUTHORIZED_IMPROPER_INELIGIBLE_OR_INCOMPLETE_TRANSACTION = "UNAUTHORIZED_IMPROPER_INELIGIBLE_OR_INCOMPLETE_TRANSACTION",
  /** R09 - Transaction represents Uncollected Funds. */
  UNCOLLECTED_FUNDS = "UNCOLLECTED_FUNDS",
}

/** Input for filtering by `ExternallyInitiatedACHStatusReasonCodeFilterInput`. */
export type ExternallyInitiatedAchStatusReasonCodeFilterInput = {
  equals?: InputMaybe<ExternallyInitiatedAchStatusReasonCode>;
  excludes?: InputMaybe<Array<ExternallyInitiatedAchStatusReasonCode>>;
  includes?: InputMaybe<Array<ExternallyInitiatedAchStatusReasonCode>>;
  notEquals?: InputMaybe<ExternallyInitiatedAchStatusReasonCode>;
};

/**
 * An ACH transfer initiated by an outside company and sent to Highnote.
 *
 * [ACH](https://en.wikipedia.org/wiki/Automated_clearing_house) is a method of transferring funds between banks.
 */
export type ExternallyInitiatedAchTransfer = {
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The Card Product associated to the Financial Account. */
  cardProduct?: Maybe<CardProduct>;
  /** The ID of the company that initiated the ACH transfer, ISO 8601 format. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /** The name of the company that initiated the ACH transfer. */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Descriptive fields about the transfer which may show up on bank reports. */
  descriptor?: Maybe<AchDescriptor>;
  /** Global ID used to reference the transfer in operations. */
  id: Scalars["ID"];
  /** The ledgers affected by the transfer. */
  ledgers?: Maybe<Array<Ledger>>;
  /** The date this transaction was returned, in ISO 8601 format. */
  returnDate?: Maybe<Scalars["String"]>;
  /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
  settlementDate?: Maybe<Scalars["String"]>;
  /** The status of the externally initiated ACH transfer. */
  status?: Maybe<ExternallyInitiatedAchStatusDetails>;
  /** A unique 15 digit number assigned by the originator to identify the transfer. */
  traceNumber?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/**
 * An ACH transfer initiated by an outside company and sent to Highnote.
 *
 * [ACH](https://en.wikipedia.org/wiki/Automated_clearing_house) is a method of transferring funds between banks.
 */
export type ExternallyInitiatedAchTransferLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** The connection type for Externally Initiated ACH Transfers. */
export type ExternallyInitiatedAchTransferConnection = {
  __typename?: "ExternallyInitiatedACHTransferConnection";
  /** A list of edges. */
  edges?: Maybe<Array<ExternallyInitiatedAchTransferEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for an Externally Initiated ACH Transfer. */
export type ExternallyInitiatedAchTransferEdge = {
  __typename?: "ExternallyInitiatedACHTransferEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The ACH Transfer. */
  node?: Maybe<ExternallyInitiatedAchTransferEdgeNode>;
};

export type ExternallyInitiatedAchTransferEdgeNode =
  | CreditFunds
  | DebitFunds
  | PayrollTransfer
  | SecureDeposit;

/** Inputs for filtering Externally Initiated ACH Transfer data. */
export type ExternallyInitiatedAchTransferFilterInput = {
  cardProductId?: InputMaybe<StringSearchFilterInput>;
  companyEntryDescription?: InputMaybe<StringSearchFilterInput>;
  companyIdentifier?: InputMaybe<StringFilterInput>;
  companyName?: InputMaybe<StringSearchFilterInput>;
  holdStatus?: InputMaybe<ExternallyInitiatedAchHoldStatusFilterInput>;
  reasonCode?: InputMaybe<ExternallyInitiatedAchStatusReasonCodeFilterInput>;
  returnDate?: InputMaybe<TimestampFilterInput>;
  settlementDate?: InputMaybe<TimestampFilterInput>;
  status?: InputMaybe<ExternallyInitiatedAchStatusFilterInput>;
  transactionAmount?: InputMaybe<MoneyFilterInput>;
  transactionType?: InputMaybe<ExternallyInitiatedTransferTypeFilterInput>;
};

/** The return types when initiating a new simulated `ExternallyInitiatedACHTransfer`. */
export type ExternallyInitiatedAchTransferPayload =
  | AccessDeniedError
  | CreditFunds
  | DebitFunds
  | PayrollTransfer
  | SecureDeposit
  | UserError;

/** A movement of money to release hold on non originated ach credit */
export type ExternallyInitiatedAchReleaseHoldTransfer = Node & {
  __typename?: "ExternallyInitiatedAchReleaseHoldTransfer";
  /** The amount released from hold. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the transfer in operations. */
  id: Scalars["ID"];
  /** The ledgers affected by the transfer. */
  ledgers?: Maybe<Array<Ledger>>;
  /** A description of the transfer for reference. */
  memo?: Maybe<Scalars["String"]>;
  /** The current status of the transfer. */
  status?: Maybe<InterFinancialAccountTransferStatus>;
  /** The reason for the current status. */
  statusReason?: Maybe<InterFinancialAccountTransferStatusReasonCode>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** A movement of money to release hold on non originated ach credit */
export type ExternallyInitiatedAchReleaseHoldTransferLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** Transaction Type of an externally initiated ACH transfer. */
export enum ExternallyInitiatedTransferType {
  /** Credit Funds */
  CREDIT_FUNDS = "CREDIT_FUNDS",
  /** Debit Funds */
  DEBIT_FUNDS = "DEBIT_FUNDS",
  /** Payroll */
  PAYROLL = "PAYROLL",
}

/** Input for filtering by `ExternallyInitiatedTransferType`. */
export type ExternallyInitiatedTransferTypeFilterInput = {
  equals?: InputMaybe<ExternallyInitiatedTransferType>;
  excludes?: InputMaybe<Array<ExternallyInitiatedTransferType>>;
  includes?: InputMaybe<Array<ExternallyInitiatedTransferType>>;
  notEquals?: InputMaybe<ExternallyInitiatedTransferType>;
};

/** A wire transfer in to a Highnote account. */
export type ExternallyInitiatedWireTransfer = ElectronicFundsTransfer &
  Node & {
    __typename?: "ExternallyInitiatedWireTransfer";
    /** The amount of the transfer. */
    amount?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, the transfer was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the transfer in operations. */
    id: Scalars["ID"];
    /** The ledgers affected by the transfer. */
    ledgers?: Maybe<Array<Ledger>>;
    /** The status of the wire transfer. */
    status?: Maybe<WireTransferStatusDetails>;
    /** The destination financial account that will receive the funds. */
    toFinancialAccount?: Maybe<FinancialAccount>;
    /** The date and time, in ISO 8601 format, the transfer was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** A wire transfer in to a Highnote account. */
export type ExternallyInitiatedWireTransferLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** Information about integrator initiated transfers which have failed. */
export type FailureAchTransferStatus = {
  __typename?: "FailureACHTransferStatus";
  /** The status of the failed transfer. This can only be `FAILED` or `RETURNED`. */
  status?: Maybe<AchTransferStatus>;
  /** Additional details about why a transfer failed. */
  statusReasonCode?: Maybe<AchTransferStatusReasonCode>;
};

/** Information about externally initiated transfers which have failed. */
export type FailureExternallyInitiatedAchStatus = {
  __typename?: "FailureExternallyInitiatedACHStatus";
  /** The status of the failed transfer. This can only be `FAILED` or `RETURNED`. */
  status?: Maybe<ExternallyInitiatedAchStatus>;
  /** Additional details about why a transfer failed. */
  statusReasonCode?: Maybe<ExternallyInitiatedAchStatusReasonCode>;
};

/** Failure fee transfer event status. */
export type FailureFeeTransferStatus = {
  __typename?: "FailureFeeTransferStatus";
  /** Additional details for failure. */
  reasonDetails?: Maybe<FeeTransferEventFailure>;
  /** The fee transfer event status. */
  status?: Maybe<FeeTransferEventStatus>;
};

/** Information about integrator initiated transfers which have failed. */
export type FailureIntegratorInitiatedAchStatus = {
  __typename?: "FailureIntegratorInitiatedACHStatus";
  /** The status of the failed transfer. This can only be `FAILED` or `RETURNED`. */
  status?: Maybe<IntegratorInitiatedAchStatus>;
  /** Additional details about why a transfer failed. */
  statusReasonCode?: Maybe<IntegratorInitiatedAchStatusReasonCode>;
};

/** Information about wire transfers which have failed. */
export type FailureWireTransferStatus = {
  __typename?: "FailureWireTransferStatus";
  /** The status of the failed transfer. This will always be `FAILED`. */
  status?: Maybe<WireTransferStatus>;
  /** Additional details about why a transfer failed. */
  statusReasonCode?: Maybe<WireStatusReasonCode>;
};

/** The `FeaturePermission` interface */
export type FeaturePermission = {
  /** When the entity was created */
  createDate?: Maybe<Scalars["String"]>;
  /** The entity that created the feature permission */
  createdBy?: Maybe<Scalars["String"]>;
  /** Indicates if the permission is enabled */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** ID of the `FeaturePermission` */
  id: Scalars["ID"];
  /** The list of revisions for this feature permission. */
  revisions?: Maybe<FeaturePermissionRevisionConnection>;
  /** When the entity was updated */
  updateDate?: Maybe<Scalars["String"]>;
  /** The entity that updated the feature permission */
  updatedBy?: Maybe<Scalars["String"]>;
};

/** The `FeaturePermission` interface */
export type FeaturePermissionRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The connection object for a `FeaturePermission` */
export type FeaturePermissionConnection = {
  __typename?: "FeaturePermissionConnection";
  /** A list of edges. */
  edges?: Maybe<Array<FeaturePermissionEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge object for a `FeaturePermission` */
export type FeaturePermissionEdge = {
  __typename?: "FeaturePermissionEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The feature permission. */
  node?: Maybe<FeaturePermission>;
};

/** The `FeaturePermissionRevision` interface */
export type FeaturePermissionRevision = {
  /** When the entity was created */
  createDate?: Maybe<Scalars["String"]>;
  /** The entity that created the feature permission */
  createdBy?: Maybe<Scalars["String"]>;
  /** Indicates if the permission is enabled */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** ID of the `FeaturePermission` that this entity is a revision of */
  featurePermissionId: Scalars["ID"];
  /** ID of the `FeaturePermissionRevision` */
  id: Scalars["ID"];
  /** When the entity was updated */
  updateDate?: Maybe<Scalars["String"]>;
  /** The entity that updated the feature permission */
  updatedBy?: Maybe<Scalars["String"]>;
};

/** The connection object for a `FeaturePermissionRevision` */
export type FeaturePermissionRevisionConnection = {
  __typename?: "FeaturePermissionRevisionConnection";
  /** A list of edges. */
  edges?: Maybe<Array<FeaturePermissionRevisionEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge object for a `FeaturePermissionRevision` */
export type FeaturePermissionRevisionEdge = {
  __typename?: "FeaturePermissionRevisionEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The feature permission revision. */
  node?: Maybe<FeaturePermissionRevision>;
};

/** Activity that is triggering the fee transfer event. */
export type FeeChargeActivity =
  | AuthorizationAndClearEvent
  | BalanceInquiryEvent
  | ClearingEvent
  | FinancialAccount
  | IntegratorInitiatedFundsDepositAchTransfer
  | IntegratorInitiatedFundsWithdrawalAchTransfer
  | PaymentCard
  | PhysicalPaymentCardOrder
  | SecureCardBalanceRepaymentAchTransfer
  | SecureDepositAchTransfer;

/** The possible Fee Charge Condition accumulation durations. */
export enum FeeChargeConditionDuration {
  /** Calendar day (UTC). Accumulated count/amount is reset each day. */
  DAY = "DAY",
  /** Lifetime of the account. Accumulated count/amount is never reset. */
  LIFETIME = "LIFETIME",
  /** Calendar month (UTC). Accumulated count/amount is reset each month. */
  MONTH = "MONTH",
  /** Applies to all without aggregation. */
  NONE = "NONE",
  /** Calendar week, starting on Sunday (UTC). Accumulated count/amount is reset each week. */
  WEEK = "WEEK",
  /** Calendar year (UTC). Accumulated count/amount is reset each year. */
  YEAR = "YEAR",
}

/** An event that occurs when a Fee is charged. */
export type FeeChargeEvent = Node & {
  __typename?: "FeeChargeEvent";
  /** The activity for which the fee is charged. */
  feeActivityType?: Maybe<FeeTransferEventFeeActivityType>;
  /** The actual fee amount charged. This field is available when status is COMPLETE. */
  feeTransferAmount?: Maybe<Amount>;
  /** Global ID used to reference the `FeeTransferEvent` object. */
  id: Scalars["ID"];
  /** The financial account from where the fee was deducted. */
  originatingAccount?: Maybe<FinancialAccount>;
  /** The Financial account that receives the fee. */
  receivingAccount?: Maybe<FinancialAccount>;
  /** The Fee status. */
  status?: Maybe<FeeTransferStatusDetails>;
  /** The date and time, in ISO 8601 format, the fee was charged. */
  transferDate?: Maybe<Scalars["String"]>;
};

/** The possible Fee Charge Condition operator types. */
export enum FeeChargeOperator {
  /** Between count/amount and maximumCount/maximumAmount inclusive. */
  BETWEEN = "BETWEEN",
  /** Equal */
  EQUAL = "EQUAL",
  /** Greater than. */
  GREATER_THAN = "GREATER_THAN",
  /** Greater than or equal. */
  GREATER_THAN_OR_EQUAL = "GREATER_THAN_OR_EQUAL",
  /** Less than. */
  LESS_THAN = "LESS_THAN",
  /** Less than or equal. */
  LESS_THAN_OR_EQUAL = "LESS_THAN_OR_EQUAL",
  /** Not equal */
  NOT_EQUAL = "NOT_EQUAL",
}

/** A fee charge rule. */
export type FeeChargeRule = Node & {
  __typename?: "FeeChargeRule";
  /**
   * The list of conditions that determine if this fee charge rule should be applied.
   * All conditions must be true for this charge rule to apply.
   */
  conditions?: Maybe<Array<FeeChargeRuleCondition>>;
  /** The date and time, in ISO 8601 format, the fee charge rule was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** ID used to reference the fee charge rule. */
  id: Scalars["ID"];
  /** Fee charge rule name. */
  name?: Maybe<Scalars["String"]>;
  /** Order at which this fee charge rule will be applied against other applicable fee charge rules. */
  order?: Maybe<Scalars["Int"]>;
  /** The date and time, in ISO 8601 format, the fee charge rule was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** The value of fee charged when this charge rule is applied. */
  value?: Maybe<FeeChargeValue>;
};

/** A fee charge condition that is based on amount in account holder activity. */
export type FeeChargeRuleAmountCondition = {
  __typename?: "FeeChargeRuleAmountCondition";
  /** The amount of account holder activity is aggregated at. */
  aggregatedAt?: Maybe<FeeConditionAggregation>;
  /** The duration for which amount is aggregated before it resets. */
  aggregationDuration?: Maybe<FeeChargeConditionDuration>;
  /** The logical condition with regard to amount in account holder activity. */
  condition?: Maybe<AmountFeeCondition>;
  /** The date and time, in ISO 8601 format, the fee charge rule amount condition was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The description of fee charge rule amount condition. */
  description?: Maybe<Scalars["String"]>;
  /** ID used to reference fee charge rule amount condition. */
  id: Scalars["ID"];
  /** The date and time, in ISO 8601 format, the fee charge rule amount condition was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Fee charge rule condition. */
export type FeeChargeRuleCondition =
  | FeeChargeRuleAmountCondition
  | FeeChargeRuleCountCondition;

/** A fee charge condition that is based on count of account holder activity. */
export type FeeChargeRuleCountCondition = {
  __typename?: "FeeChargeRuleCountCondition";
  /** The count of account holder activity is aggregated at. */
  aggregatedAt?: Maybe<FeeConditionAggregation>;
  /** The duration for which the count of account holder activity is aggregated before it resets. */
  aggregationDuration?: Maybe<FeeChargeConditionDuration>;
  /** The logical condition with regard to count of account holder activity. */
  condition?: Maybe<CountFeeCondition>;
  /** The date and time, in ISO 8601 format, the fee charge rule count condition was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The description of fee charge rule count condition. */
  description?: Maybe<Scalars["String"]>;
  /** ID used to reference the fee charge rule count condition. */
  id: Scalars["ID"];
  /** The date and time, in ISO 8601 format, the fee charge rule count condition was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Fee charge value. */
export type FeeChargeValue = FixedFeeChargeValue | VariableFeeChargeValue;

/** Type to which fee condition is attached. */
export enum FeeConditionAggregation {
  /** Account. */
  ACCOUNT = "ACCOUNT",
  /** Payment Card. */
  PAYMENT_CARD = "PAYMENT_CARD",
}

/**
 * A fee configuration. Fee configuration consists of account holder activity that is being
 * charged and the rules that determines what fee charge is applicable.
 */
export type FeeConfiguration = {
  __typename?: "FeeConfiguration";
  /** The date and time, in ISO 8601 format, the fee configuration was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The account holder activity for which fee is charged. */
  feeActivityType?: Maybe<FeeTransferEventFeeActivityType>;
  /** Set of rules that determine amount of fee to be charged. */
  feeChargeRules?: Maybe<Array<FeeChargeRule>>;
  /** ID used to reference the fee configuration. */
  id: Scalars["ID"];
  /** The date and time, in ISO 8601 format, the fee configuration was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** An event that occurs when a Fee is reversed. */
export type FeeReversalEvent = Node & {
  __typename?: "FeeReversalEvent";
  /** The activity for which the fee is charged. */
  feeActivityType?: Maybe<FeeTransferEventFeeActivityType>;
  /** The actual fee amount reversed. This field is available when status is COMPLETE. */
  feeTransferAmount?: Maybe<Amount>;
  /** Global ID used to reference the `FeeTransferEvent` object. */
  id: Scalars["ID"];
  /** The financial account from where the fee was deducted. */
  originatingAccount?: Maybe<FinancialAccount>;
  /** The Financial account that receives the fee. */
  receivingAccount?: Maybe<FinancialAccount>;
  /** The original fee transfer event that was reversed. */
  sourceFeeTransferEvent?: Maybe<FeeTransferEvent>;
  /** The Fee status. */
  status?: Maybe<FeeTransferStatusDetails>;
  /** The date and time, in ISO 8601 format, the fee was reversed. */
  transferDate?: Maybe<Scalars["String"]>;
};

/** Fee schedule. It has set of fee configurations. */
export type FeeSchedule = Node & {
  __typename?: "FeeSchedule";
  /** The date and time, in ISO 8601 format, the fee schedule was activated. */
  activationDate?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the fee schedule was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Set of fee configurations for this fee schedule. */
  feeConfigurations?: Maybe<Array<FeeConfiguration>>;
  /** The Fee schedule that is associated to a Card Product. */
  feeScheduleAssociatedTo?: Maybe<FeeScheduleAssociatedTo>;
  /** Global ID used to reference the fee schedule. */
  id: Scalars["ID"];
  /** Status of fee schedule. */
  status?: Maybe<FeeScheduleStatus>;
  /** The date and time, in ISO 8601 format, the fee schedule was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Fee schedules associated to. */
export type FeeScheduleAssociatedTo = CardProduct;

/** The connection type for Fee Schedule. */
export type FeeScheduleConnection = {
  __typename?: "FeeScheduleConnection";
  /** A list of edges. */
  edges?: Maybe<Array<FeeScheduleEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a Fee Schedule. */
export type FeeScheduleEdge = {
  __typename?: "FeeScheduleEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The Fee schedule. */
  node?: Maybe<FeeSchedule>;
};

/** Inputs for filtering Fee Schedules. */
export type FeeScheduleFilterInput = {
  /** The date and time, in ISO 8601 format, the fee schedule was activated. */
  activationDate?: InputMaybe<TimestampFilterInput>;
  /** The date and time, in ISO 8601 format, the fee schedule was created. */
  createDate?: InputMaybe<TimestampFilterInput>;
  /** The date and time, in ISO 8601 format, the fee schedule was updated. */
  updateDate?: InputMaybe<TimestampFilterInput>;
};

/** Fee schedule status. */
export enum FeeScheduleStatus {
  /** Fee schedule is active and currently applicable. */
  ACTIVE = "ACTIVE",
  /** The fee schedule is inactive and no longer applicable. */
  INACTIVE = "INACTIVE",
  /** The fee schedule is pending. Pending status is when fee schedule activation date is in future. */
  PENDING = "PENDING",
}

/** Union of charged fee transfer and reversed fee transfer. */
export type FeeTransfer = ChargedFeeTransfer | ReversedFeeTransfer;

/** A Fee Transfer Event. */
export type FeeTransferEvent = Node & {
  __typename?: "FeeTransferEvent";
  /** Details about this fee transfer event. */
  feeTransfer?: Maybe<FeeTransfer>;
  /** Global ID used to reference the Fee Transfer Event in operations. */
  id: Scalars["ID"];
};

/** The connection type for Fee Transfer Event. */
export type FeeTransferEventConnection = {
  __typename?: "FeeTransferEventConnection";
  /** A list of edges. */
  edges?: Maybe<Array<FeeTransferEventEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a Fee Transfer Event. */
export type FeeTransferEventEdge = {
  __typename?: "FeeTransferEventEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The Fee Transfer Event. */
  node?: Maybe<FeeTransferEvent>;
};

/** A Fee Transfer Event Failure. */
export type FeeTransferEventFailure = {
  __typename?: "FeeTransferEventFailure";
  /** Additional details. */
  reason?: Maybe<Scalars["String"]>;
  /** The type of failure. */
  type?: Maybe<FeeTransferEventFailureType>;
};

/** The reasons a Fee Transfer Event could fail. */
export enum FeeTransferEventFailureType {
  /** The originating and receiving account do not belong to same product. */
  ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT = "ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT",
  /** The originating or receiving account is closed. */
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  /** The originating or receiving account is not active. */
  ACCOUNT_NOT_ACTIVE = "ACCOUNT_NOT_ACTIVE",
  /** The originating or receiving account was not found. */
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  /** The originating or receiving account not provided. */
  ACCOUNT_NOT_PROVIDED = "ACCOUNT_NOT_PROVIDED",
  /** Ach load is not allowed by program. */
  ACH_LOAD_NOT_ALLOWED_BY_PROGRAM = "ACH_LOAD_NOT_ALLOWED_BY_PROGRAM",
  /** Card funding feature not enabled on account. */
  CARD_FUNDING_FEATURE_NOT_ENABLED = "CARD_FUNDING_FEATURE_NOT_ENABLED",
  /** Cash fund out not supported on product. */
  CASH_FUND_OUT_NOT_SUPPORTED_ON_PRODUCT = "CASH_FUND_OUT_NOT_SUPPORTED_ON_PRODUCT",
  /** Commercial credit Pay In Full card feature is not enabled on account. */
  COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED = "COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED",
  /** Corporate bank account feature is not enabled. */
  CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED = "CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED",
  /** Credit card feature is not enabled on account. */
  CREDIT_CARD_FEATURE_NOT_ENABLED = "CREDIT_CARD_FEATURE_NOT_ENABLED",
  /** The originating account does not have credit limit set. */
  CREDIT_LIMIT_NOT_SET_ON_ACCOUNT = "CREDIT_LIMIT_NOT_SET_ON_ACCOUNT",
  /** The originating and receiving account have different currency. */
  CURRENCY_MISMATCH = "CURRENCY_MISMATCH",
  /** Dda feature is not enabled on account. */
  DDA_FEATURE_NOT_ENABLED = "DDA_FEATURE_NOT_ENABLED",
  /** Debit card feature is not enabled on account. */
  DEBIT_CARD_FEATURE_NOT_ENABLED = "DEBIT_CARD_FEATURE_NOT_ENABLED",
  /** Fleet card feature is not enabled on account. */
  FLEET_FEATURE_NOT_ENABLED = "FLEET_FEATURE_NOT_ENABLED",
  /** Funding account feature is not enabled on account. */
  FUNDING_ACCOUNT_FEATURE_NOT_ENABLED = "FUNDING_ACCOUNT_FEATURE_NOT_ENABLED",
  /** Product funding feature is not enabled on account. */
  FUNDING_CARD_NOT_SUPPORTED = "FUNDING_CARD_NOT_SUPPORTED",
  /** Idempotency Key not provided. */
  IDEMPOTENCY_KEY_NOT_PROVIDED = "IDEMPOTENCY_KEY_NOT_PROVIDED",
  /** The originating account of the FeeTransferEvent did not have enough funds to cover the requested amount. */
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  /** The originating or receiving account does not belong to the organization. */
  NOT_AN_ORGANIZATION_OWNED_ACCOUNT = "NOT_AN_ORGANIZATION_OWNED_ACCOUNT",
  /** The originating account does not have enough balance to reduce credit limit. */
  NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT = "NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT",
  /** Organization not provided. */
  ORGANIZATION_ID_NOT_PROVIDED = "ORGANIZATION_ID_NOT_PROVIDED",
  /** Originated ach unload not supported on product */
  ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT = "ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT",
  /** Payroll advance feature not enabled. */
  PAYROLL_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED",
  /** Payroll employer advance feature not enabled. */
  PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED",
  /** Prepaid card feature is not enabled on account. */
  PREPAID_CARD_FEATURE_NOT_ENABLED = "PREPAID_CARD_FEATURE_NOT_ENABLED",
  /** Product funding feature is not enabled on account. */
  PRODUCT_FUNDING_FEATURE_NOT_ENABLED = "PRODUCT_FUNDING_FEATURE_NOT_ENABLED",
  /** Reward point feature not enabled. */
  REWARD_POINT_FEATURE_NOT_ENABLED = "REWARD_POINT_FEATURE_NOT_ENABLED",
  /** Secured card feature is not enabled on account. */
  SECURE_CARD_FEATURE_NOT_ENABLED = "SECURE_CARD_FEATURE_NOT_ENABLED",
  /** Tenant Id is not provided. */
  TENANT_ID_NOT_PROVIDED = "TENANT_ID_NOT_PROVIDED",
  /** Transaction Id not provided. */
  TRANSACTION_ID_NOT_PROVIDED = "TRANSACTION_ID_NOT_PROVIDED",
  /** Transfer amount below program minimum reload limit. */
  TRANSFER_AMOUNT_BELOW_MIN_PROGRAM_RELOAD_LIMIT = "TRANSFER_AMOUNT_BELOW_MIN_PROGRAM_RELOAD_LIMIT",
  /** Transfer amount exceeding maximum program card balance. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_CARD_BALANCE = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_CARD_BALANCE",
  /** Fransfer amount exceeds allowed max program load limit. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT",
  /** Transfer amount exceeds allowed max program reload limit. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_RELOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_RELOAD_LIMIT",
  /** Transfer amount is negative or zero. */
  TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO = "TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO",
  /** Accounts do not have same primary account holder. */
  TRANSFER_CONDITION_SAME_PRIMARY_ACCOUNT_HOLDER_NOT_SATISFIED = "TRANSFER_CONDITION_SAME_PRIMARY_ACCOUNT_HOLDER_NOT_SATISFIED",
  /** Transfer is not supported on product. */
  TRANSFER_NOT_SUPPORTED_ON_PRODUCT = "TRANSFER_NOT_SUPPORTED_ON_PRODUCT",
}

/** The possible fee types that can be charged. */
export enum FeeTransferEventFeeActivityType {
  /** Account inactivity */
  ACCOUNT_INACTIVITY_FEE = "ACCOUNT_INACTIVITY_FEE",
  /** Account initiation */
  ACCOUNT_INITIATION_FEE = "ACCOUNT_INITIATION_FEE",
  /** ATM balance inquiry (in-network) */
  ATM_BALANCE_INQUIRY_IN_NETWORK_FEE = "ATM_BALANCE_INQUIRY_IN_NETWORK_FEE",
  /** ATM balance inquiry (international, in-network) */
  ATM_BALANCE_INQUIRY_IN_NETWORK_INTERNATIONAL_FEE = "ATM_BALANCE_INQUIRY_IN_NETWORK_INTERNATIONAL_FEE",
  /** ATM balance inquiry (out-of-network) */
  ATM_BALANCE_INQUIRY_OUT_OF_NETWORK_FEE = "ATM_BALANCE_INQUIRY_OUT_OF_NETWORK_FEE",
  /** ATM balance inquiry (international) */
  ATM_BALANCE_INQUIRY_OUT_OF_NETWORK_INTERNATIONAL_FEE = "ATM_BALANCE_INQUIRY_OUT_OF_NETWORK_INTERNATIONAL_FEE",
  /** ATM decline */
  ATM_DECLINE_FEE = "ATM_DECLINE_FEE",
  /** ATM decline (international) */
  ATM_DECLINE_INTERNATIONAL_FEE = "ATM_DECLINE_INTERNATIONAL_FEE",
  /** ATM withdrawal (in-network) */
  ATM_WITHDRAWAL_IN_NETWORK_FEE = "ATM_WITHDRAWAL_IN_NETWORK_FEE",
  /** ATM withdrawal (international, in-network) */
  ATM_WITHDRAWAL_IN_NETWORK_INTERNATIONAL_FEE = "ATM_WITHDRAWAL_IN_NETWORK_INTERNATIONAL_FEE",
  /** ATM withdrawal (out-of-network) */
  ATM_WITHDRAWAL_OUT_OF_NETWORK_FEE = "ATM_WITHDRAWAL_OUT_OF_NETWORK_FEE",
  /** ATM withdrawal (international) */
  ATM_WITHDRAWAL_OUT_OF_NETWORK_INTERNATIONAL_FEE = "ATM_WITHDRAWAL_OUT_OF_NETWORK_INTERNATIONAL_FEE",
  /** Cash back at bank tell */
  CASH_BACK_OTC_FEE = "CASH_BACK_OTC_FEE",
  /** Cash back at point of sale terminal */
  CASH_BACK_POS_FEE = "CASH_BACK_POS_FEE",
  /** Expedited physical card */
  EXPEDITED_PHYSICAL_CARD_FEE = "EXPEDITED_PHYSICAL_CARD_FEE",
  /** Foreign exchange */
  FOREIGN_EXCHANGE_FEE = "FOREIGN_EXCHANGE_FEE",
  /** Credit Installment */
  INSTALLMENT_FEE = "INSTALLMENT_FEE",
  /** International transaction */
  INTERNATIONAL_TRANSACTION_FEE = "INTERNATIONAL_TRANSACTION_FEE",
  /** Late Payment */
  LATE_PAYMENT_FEE = "LATE_PAYMENT_FEE",
  /** Monthly account anniversary fee */
  MONTHLY_ACCOUNT_ANNIVERSARY_FEE = "MONTHLY_ACCOUNT_ANNIVERSARY_FEE",
  /** Physical card reissue (new PAN) */
  PHYSICAL_CARD_REISSUE_FEE = "PHYSICAL_CARD_REISSUE_FEE",
  /** Returned ACH origication */
  RETURN_PAYMENT_FEE = "RETURN_PAYMENT_FEE",
  /** Virtual card reissue (new PAN) */
  VIRTUAL_CARD_REISSUE_FEE = "VIRTUAL_CARD_REISSUE_FEE",
}

/** The possible fee types that can be charged. */
export enum FeeTransferEventFeeActivityTypeInput {
  /** Account inactivity */
  ACCOUNT_INACTIVITY_FEE = "ACCOUNT_INACTIVITY_FEE",
  /** Account initiation */
  ACCOUNT_INITIATION_FEE = "ACCOUNT_INITIATION_FEE",
  /** ATM balance inquiry (in-network) */
  ATM_BALANCE_INQUIRY_IN_NETWORK_FEE = "ATM_BALANCE_INQUIRY_IN_NETWORK_FEE",
  /** ATM balance inquiry (international, in-network) */
  ATM_BALANCE_INQUIRY_IN_NETWORK_INTERNATIONAL_FEE = "ATM_BALANCE_INQUIRY_IN_NETWORK_INTERNATIONAL_FEE",
  /** ATM balance inquiry (out-of-network) */
  ATM_BALANCE_INQUIRY_OUT_OF_NETWORK_FEE = "ATM_BALANCE_INQUIRY_OUT_OF_NETWORK_FEE",
  /** ATM balance inquiry (international) */
  ATM_BALANCE_INQUIRY_OUT_OF_NETWORK_INTERNATIONAL_FEE = "ATM_BALANCE_INQUIRY_OUT_OF_NETWORK_INTERNATIONAL_FEE",
  /** ATM decline */
  ATM_DECLINE_FEE = "ATM_DECLINE_FEE",
  /** ATM decline (international) */
  ATM_DECLINE_INTERNATIONAL_FEE = "ATM_DECLINE_INTERNATIONAL_FEE",
  /** ATM withdrawal (in-network) */
  ATM_WITHDRAWAL_IN_NETWORK_FEE = "ATM_WITHDRAWAL_IN_NETWORK_FEE",
  /** ATM withdrawal (international, in-network) */
  ATM_WITHDRAWAL_IN_NETWORK_INTERNATIONAL_FEE = "ATM_WITHDRAWAL_IN_NETWORK_INTERNATIONAL_FEE",
  /** ATM withdrawal (out-of-network) */
  ATM_WITHDRAWAL_OUT_OF_NETWORK_FEE = "ATM_WITHDRAWAL_OUT_OF_NETWORK_FEE",
  /** ATM withdrawal (international) */
  ATM_WITHDRAWAL_OUT_OF_NETWORK_INTERNATIONAL_FEE = "ATM_WITHDRAWAL_OUT_OF_NETWORK_INTERNATIONAL_FEE",
  /** Cash back at bank tell */
  CASH_BACK_OTC_FEE = "CASH_BACK_OTC_FEE",
  /** Cash back at point of sale terminal */
  CASH_BACK_POS_FEE = "CASH_BACK_POS_FEE",
  /** Expedited physical card */
  EXPEDITED_PHYSICAL_CARD_FEE = "EXPEDITED_PHYSICAL_CARD_FEE",
  /** Foreign exchange */
  FOREIGN_EXCHANGE_FEE = "FOREIGN_EXCHANGE_FEE",
  /** Credit Installment */
  INSTALLMENT_FEE = "INSTALLMENT_FEE",
  /** International transaction */
  INTERNATIONAL_TRANSACTION_FEE = "INTERNATIONAL_TRANSACTION_FEE",
  /** Late Payment */
  LATE_PAYMENT_FEE = "LATE_PAYMENT_FEE",
  /** Monthly account anniversary fee */
  MONTHLY_ACCOUNT_ANNIVERSARY_FEE = "MONTHLY_ACCOUNT_ANNIVERSARY_FEE",
  /** Physical card reissue (new PAN) */
  PHYSICAL_CARD_REISSUE_FEE = "PHYSICAL_CARD_REISSUE_FEE",
  /** Returned ACH origination */
  RETURN_PAYMENT_FEE = "RETURN_PAYMENT_FEE",
  /** Virtual card reissue (new PAN) */
  VIRTUAL_CARD_REISSUE_FEE = "VIRTUAL_CARD_REISSUE_FEE",
}

/** Inputs for filtering Fee Transfer Events. */
export type FeeTransferEventFilterInput = {
  /** The id of the card product associated to the fee transfer event. */
  cardProductId?: InputMaybe<StringFilterInput>;
  /** The date and time, in ISO 8601 format, fee transfer was created. */
  createDate?: InputMaybe<TimestampFilterInput>;
  /** The financial account from where fee is deducted. */
  originatingAccountId?: InputMaybe<StringFilterInput>;
  /** The financial account where fee is transferred. */
  receivingAccountId?: InputMaybe<StringFilterInput>;
  /** The date and time, in ISO 8601 format, fee was charged. */
  transferDate?: InputMaybe<TimestampFilterInput>;
  /** The date and time, in ISO 8601 format, fee transfer was updated. */
  updateDate?: InputMaybe<TimestampFilterInput>;
};

/** Response type for waive fee. */
export type FeeTransferEventPayload =
  | AccessDeniedError
  | FeeTransferEvent
  | UserError;

/** Status of the Fee Transfer Event. */
export enum FeeTransferEventStatus {
  /** The Fee Transfer Event completed. */
  COMPLETE = "COMPLETE",
  /** The Fee Transfer Event failed. Additional details are available in failureReason. */
  FAIL = "FAIL",
  /** The Fee Transfer Event is pending. */
  PENDING = "PENDING",
}

/** Details about the status of the fee transfer. */
export type FeeTransferStatusDetails =
  | FailureFeeTransferStatus
  | NonFailureFeeTransferStatus;

/** A enum of `FeedbackCode` codes */
export enum FeedbackCode {
  /** This code will tell the risk system to override the rule results. */
  OVERRIDE_RULE_RESULTS_TO_ACCEPTED = "OVERRIDE_RULE_RESULTS_TO_ACCEPTED",
  /** This code will indicate that the override was denied. */
  OVERRIDE_RULE_RESULTS_TO_DENIED = "OVERRIDE_RULE_RESULTS_TO_DENIED",
}

/** A validation error for a specific field or input path. */
export type FieldUserError = {
  __typename?: "FieldUserError";
  /** A machine-readable code for the specific error. */
  code?: Maybe<Scalars["String"]>;
  /** A human-friendly description for the specific error. */
  description?: Maybe<Scalars["String"]>;
  /** The path to the input field which has an error, including indices. */
  errorPath?: Maybe<Array<Scalars["String"]>>;
  /**
   * The path to the input field which has an error.
   * @deprecated `path` does not provide index information for list input errors. Use `errorPath` instead.
   */
  path?: Maybe<Array<Scalars["String"]>>;
};

export type FileUploadCompleteEvent = Node & {
  __typename?: "FileUploadCompleteEvent";
  /** The date and time, in ISO 8601 format, this `document upload link` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The categorization of an uploaded document */
  documentCategoryType?: Maybe<DocumentCategoryType>;
  /** The document type that was uploaded */
  documentType?: Maybe<DocumentType>;
  /** The session which associates all of the files uploaded using the secure upload link */
  documentUploadSession?: Maybe<DocumentUploadSession>;
  /** Global ID used to reference the secure upload link */
  id: Scalars["ID"];
  /** The status of the upload */
  status?: Maybe<DocumentUploadLinkStatusCode>;
  /** The date and time, in ISO 8601 format, this `document upload link` was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /**
   * A url to be used to upload the contents of the document.
   *
   * ** Note: ** The maximum file size is 10 MB
   */
  uploadUrl?: Maybe<Scalars["String"]>;
};

/** The input to filter card profile sets on a 'CardProduct' */
export type FilteredCardProductCardProfileSetsInput = {
  status?: InputMaybe<CardProfileSetStatusInput>;
};

/** The input to filter card profile sets */
export type FilteredCardProfileSetsInput = {
  cardProductId: IdFilterInput;
  status?: InputMaybe<CardProfileSetStatusInput>;
};

/** Input to filter payment method. */
export type FilteredPaymentMethodInput = {
  /** Filter based on payment method type. */
  paymentMethodType?: InputMaybe<PaymentMethodTypeInput>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccount = Node & {
  __typename?: "FinancialAccount";
  /**
   * A List of `FinancialAccountAttribute` associated with this `FinancialAccount`.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  accountAttributes?: Maybe<Array<Maybe<FinancialAccountAttribute>>>;
  /**
   * A list of states which could block account closure.
   * @deprecated Legacy, unused field
   */
  accountClosureBlockers?: Maybe<Array<Maybe<AccountClosureBlocker>>>;
  /** The reason(s) for closure of the `FinancialAccount`. Currently only available for revolving `CardProduct`s. */
  accountClosureReasons?: Maybe<Array<FinancialAccountClosureReason>>;
  /** Will be the same as `owner` if the `FinancialAccount` is owned by the primary user, otherwise this will link to the authorized user. */
  accountHolder?: Maybe<FinancialAccountOwner>;
  /** For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search). */
  accountReviewHistory?: Maybe<AccountReviewConnectionPayload>;
  /** The `FinancialAccountStatus`. */
  accountStatus?: Maybe<FinancialAccountStatus>;
  /** The active billing cycle configuration for this financial account. */
  activeBillingCycleConfiguration?: Maybe<BillingCycleConfiguration>;
  /**
   * The Card Product Application used to issue this Financial Account.
   * @deprecated Use cardProductApplication instead.
   */
  application?: Maybe<AccountHolderCardProductApplication>;
  /** The realtime risk rules attached to this Financial Account. */
  attachedRealtimeRiskRules?: Maybe<RealtimeRiskRuleConnectionPayload>;
  /** The spend rules attached to this Financial Account. */
  attachedSpendRules?: Maybe<SpendRuleConnection>;
  /** The velocity rules attached to this Financial Account. */
  attachedVelocityRules?: Maybe<VelocityRuleConnection>;
  /** The `FinancialAccount`s for authorized user's managed by this `FinancialAccount`. */
  authorizedUserFinancialAccounts?: Maybe<FinancialAccountConnection>;
  /**
   * A paginated list of billing cycles for this `FinancialAccount`
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  billingCycleHistory?: Maybe<BillingCycleConnection>;
  /** The current billing summary, including information on balances, minimum payment, and payment due date, for this `FinancialAccount` */
  billingSummary?: Maybe<FinancialAccountBillingSummary>;
  /** The Card Product associated to the Financial Account. */
  cardProduct?: Maybe<CardProduct>;
  /** The Card Product Application used to issue this Financial Account. */
  cardProductApplication?: Maybe<CardProductApplication>;
  /** A paginated list of `CheckPayment`s. */
  checkPayments?: Maybe<CheckPaymentsConnection>;
  /** The date and time, in ISO 8601 format, the Financial Account was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The credit configuration for this `FinancialAccount`. */
  creditConfiguration?: Maybe<CreditFinancialAccountConfiguration>;
  /** The customFields associated with this `FinancialAccount`. */
  customFields?: Maybe<Array<CustomField>>;
  /** The delinquency details of this `FinancialAccount` */
  delinquency?: Maybe<FinancialAccountDelinquency>;
  /** The current delinquency state of this `FinancialAccount` */
  delinquencyState?: Maybe<CurrentFinancialAccountDelinquencyState>;
  /** The direct deposit details for this financial account. */
  directDepositDetails?: Maybe<DirectDepositDetail>;
  /**
   * A paginated list of Externally Initiated ACH Transfers.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  externalACHTransfers?: Maybe<ExternallyInitiatedAchTransferConnection>;
  /** Externally provided ID (255 character limit) that is unique per organization and tenant. If not provided, Highnote will generate an ID (ten digit, Base58, all caps). */
  externalId?: Maybe<Scalars["String"]>;
  /**
   * A paginated list of Externally Initiated ACH Transfers.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   *
   * Deprecated, in favor of externalACHTransfers
   * @deprecated externallyInitiatedACHTransfer is deprecated in favor of externalACHTransfers.
   */
  externallyInitiatedACHTransfer?: Maybe<ExternallyInitiatedAchTransferConnection>;
  /**
   * A paginated list of Externally Initiated ACH Transfers.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   *
   * Deprecated
   * @deprecated ACHTransactionConnection is deprecated in favor of IntegratorInitiatedACHTransferConnection and/or ExternallyInitiatedACHTransferConnection.
   */
  externallyInitiatedAchTransfers?: Maybe<AchTransactionConnection>;
  /** The list of features for a Financial Account. */
  features?: Maybe<Array<FinancialAccountFeature>>;
  /**
   * A paginated list of FeeTransferEvents.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  feeTransferEvents?: Maybe<FeeTransferEventConnection>;
  /**
   * The Activities that occurred on this Financial Account.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  financialAccountActivities?: Maybe<FinancialAccountActivityConnection>;
  /** The attributes and reasons for the `FinancialAccount`. */
  financialAccountAttributesWithReason?: Maybe<
    Array<FinancialAccountAttributeWithReason>
  >;
  /** All global notes pertaining to this `FinancialAccount`. */
  globalNotes?: Maybe<GlobalNoteConnectionPayload>;
  /** Global ID used to reference the Financial Account in operations. */
  id: Scalars["ID"];
  /** Incoming Scheduled Transfers for the financial account */
  incomingScheduledTransfers?: Maybe<ScheduledTransferConnection>;
  /**
   * A paginated list of installment agreement for this `FinancialAccount`
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  installmentAgreements?: Maybe<InstallmentAgreementConnection>;
  /**
   * A paginated list of Integrator Initiated ACH Transfers.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  integratorACHTransfers?: Maybe<IntegratorInitiatedAchTransferConnection>;
  /**
   * A paginated list of Integrator Initiated ACH Transfers.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   *
   * Deprecated, in favor of integratorACHTransfers
   * @deprecated integratorInitiatedACHTransfer is deprecated in favor of integratorACHTransfers.
   */
  integratorInitiatedACHTransfer?: Maybe<IntegratorInitiatedAchTransferConnection>;
  /**
   * A paginated list of Integrator Initiated ACH Transfers.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   *
   * Deprecated.
   * @deprecated ACHTransactionConnection is deprecated in favor of IntegratorInitiatedACHTransferConnection and/or ExternallyInitiatedACHTransferConnection.
   */
  integratorInitiatedAchTransfers?: Maybe<AchTransactionConnection>;
  /**
   * The `InterFinancialAccountTransfers` belonging to this `FinancialAccount`
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  interFinancialAccountTransfers?: Maybe<InterFinancialAccountTransferConnection>;
  /** The ledgers backing this financial account. */
  ledgers?: Maybe<Array<Ledger>>;
  /** The name of this account. */
  name?: Maybe<Scalars["String"]>;
  /**
   * A paginated list of non-originated ACH transfers.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  nonOriginatedAchTransfers?: Maybe<NonOriginatedAchTransferPayload>;
  /**
   * A paginated list of originated ACH transfers.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  originatedAchTransfers?: Maybe<OriginatedAchTransferPayload>;
  /** The primary owner of this `FinancialAccount`. */
  owner?: Maybe<FinancialAccountOwner>;
  /** The name of our bank partner associated to this `FinancialAccount` */
  partnerBankName?: Maybe<PartnerBankName>;
  /**
   * A paginated list of `PaymentCardTransactionChargeback` for this `FinancialAccount`.
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  paymentCardTransactionChargebacks?: Maybe<PaymentCardTransactionChargebackConnection>;
  /**
   * A paginated list of `PaymentCardTransactionDispute` for this `FinancialAccount`.
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  paymentCardTransactionDisputes?: Maybe<PaymentCardTransactionDisputeConnectionPayload>;
  /** The Payment Cards issued to this Financial Account. */
  paymentCards?: Maybe<PaymentCardConnection>;
  /** A list of `CreditPlan`s with a `CreditBalanceType` of `PURCHASE` configured for this `FinancialAccount`. */
  purchasePlans?: Maybe<Array<FinancialAccountPurchaseCreditPlan>>;
  /** The `ReviewWorkflowEvents` related to this `FinancialAccount`. */
  reviewWorkflowEvents?: Maybe<ReviewWorkflowEventConnectionPayload>;
  /** A paginated list of revisions made to this `FinancialAccount`. */
  revisionSnapshots?: Maybe<FinancialAccountSnapshotConnection>;
  /**
   * The reward points transfers associated to this `FinancialAccount`.
   * @deprecated Please query the REWARDS_POINTS ledger on your FinancialAccount for ledger entries, which include RewardPointsTransfer financial events.
   */
  rewardPointsTransfers?: Maybe<RewardPointsTransferConnectionPayload>;
  /** Current account balance snapshot */
  statementSnapshot?: Maybe<FinancialAccountStatementSnapshot>;
  /**
   * A paginated list of FinancialAccountStatements.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  statements?: Maybe<FinancialAccountStatementConnection>;
  /**
   * A paginated list of TransactionEvents.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  transactionEvents?: Maybe<TransactionEventConnection>;
  /** The date and time, in ISO 8601 format, the Financial Account was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** The `UserDefinedFields` associated with this `FinancialAccount`. */
  userDefinedFields?: Maybe<UserDefinedFieldConnection>;
  /** The balances of VelocityInterFinancialAccountTransferRules that pertain to this `FinancialAccount` */
  velocityInterFinancialAccountTransferRuleBalances?: Maybe<VelocityInterFinancialAccountTransferRuleBalanceConnectionPayload>;
  /**
   * The balances of the VelocityRules that pertain to this `FinancialAccount`
   * @deprecated Use velocitySpendRuleBalances instead
   */
  velocityRuleBalances?: Maybe<Array<Maybe<VelocityRuleBalance>>>;
  /** The balances of the VelocityRules that pertain to this `FinancialAccount` */
  velocitySpendRuleBalances?: Maybe<Array<Maybe<VelocitySpendRuleBalance>>>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountAccountReviewHistoryArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountAttachedRealtimeRiskRulesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountAttachedSpendRulesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountAttachedVelocityRulesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountAuthorizedUserFinancialAccountsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountBillingCycleHistoryArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<BillingCycleFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountCheckPaymentsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountExternalAchTransfersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<ExternallyInitiatedAchTransferFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountExternallyInitiatedAchTransferArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<ExternallyInitiatedAchTransferFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountExternallyInitiatedAchTransfersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<ExternallyInitiatedAchTransferFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountFeeTransferEventsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<FeeTransferEventFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountFinancialAccountActivitiesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<FinancialAccountActivitiesFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountGlobalNotesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountIncomingScheduledTransfersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountInstallmentAgreementsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<InstallmentAgreementFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountIntegratorAchTransfersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<IntegratorInitiatedAchTransferFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountIntegratorInitiatedAchTransferArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<IntegratorInitiatedAchTransferFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountIntegratorInitiatedAchTransfersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<IntegratorInitiatedAchTransferFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountInterFinancialAccountTransfersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<InterFinancialAccountTransferFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountNonOriginatedAchTransfersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<NonOriginatedAchTransferFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountOriginatedAchTransfersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<OriginatedAchTransferFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountPaymentCardTransactionChargebacksArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<FinancialAccountPaymentCardTransactionChargebacksFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountPaymentCardTransactionDisputesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<FinancialAccountPaymentCardTransactionDisputesFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountPaymentCardsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<FinancialAccountPaymentCardsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountReviewWorkflowEventsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountRevisionSnapshotsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountRewardPointsTransfersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountStatementsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<FinancialAccountStatementFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountTransactionEventsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<TransactionEventsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountUserDefinedFieldsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<UserDefinedFieldsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A financial account allows you to move money into the Highnote platform and move funds to other accounts. */
export type FinancialAccountVelocityInterFinancialAccountTransferRuleBalancesArgs =
  {
    after?: InputMaybe<Scalars["String"]>;
    first?: InputMaybe<Scalars["Int"]>;
  };

/** Inputs for filtering Financial Account Activities. */
export type FinancialAccountActivitiesFilterInput = {
  activityType?: InputMaybe<FinancialAccountActivityTypeFilterInput>;
  createdAt?: InputMaybe<TimestampFilterInput>;
  isComplete?: InputMaybe<BooleanFilterInput>;
  isSignNegative?: InputMaybe<BooleanFilterInput>;
  pendingAmount?: InputMaybe<MoneyFilterInput>;
  postedAmount?: InputMaybe<MoneyFilterInput>;
  updatedAt?: InputMaybe<TimestampFilterInput>;
};

/** Details of an activity, such as a transfer or payment card transaction, for a Financial Account. */
export type FinancialAccountActivity = {
  __typename?: "FinancialAccountActivity";
  /** The date and time, in ISO 8601 format, this activity was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** If true, there are no more expected changes or updates to this activity. */
  isComplete?: Maybe<Scalars["Boolean"]>;
  /**
   * The amount pending for this activity. For PaymentCard transactions, this
   * represents the remaining amount authorized.
   */
  pendingAmount?: Maybe<Amount>;
  /**
   * The amount posted for this activity. For PaymentCard transactions, this
   * represents the total amount cleared.
   */
  postedAmount?: Maybe<Amount>;
  /**
   * Whether the activity decreases or increases available cash or credit for
   * the Financial Account.
   */
  sign?: Maybe<FinancialAccountActivitySign>;
  /** The source of this activity. */
  source?: Maybe<FinancialAccountActivitySource>;
  /** The date and time, in ISO 8601 format, this activity was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The connection type for `FinancialAccountActivity`. */
export type FinancialAccountActivityConnection = {
  __typename?: "FinancialAccountActivityConnection";
  /** A list of edges. */
  edges?: Maybe<Array<FinancialAccountActivityEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a `FinancialAccountActivity`. */
export type FinancialAccountActivityEdge = {
  __typename?: "FinancialAccountActivityEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The Financial Account Activity. */
  node?: Maybe<FinancialAccountActivity>;
};

/**
 * Whether the activity decreases or increases available cash or credit for
 * the account.
 */
export enum FinancialAccountActivitySign {
  /** The activity decreases available cash or credit. */
  NEGATIVE = "NEGATIVE",
  /** The activity increases available cash or credit. */
  POSITIVE = "POSITIVE",
}

export type FinancialAccountActivitySource =
  | CreditFunds
  | CreditTransaction
  | DebitFunds
  | DebitTransaction
  | FeeTransferEvent
  | IntegratorInitiatedFundsDepositAchTransfer
  | IntegratorInitiatedFundsWithdrawalAchTransfer
  | InterFinancialAccountTransfer
  | PayrollTransfer
  | SecureCardBalanceRepaymentAchTransfer
  | SecureDeposit
  | SecureDepositAchTransfer;

/** Financial Account Activity Types to return */
export enum FinancialAccountActivityType {
  /** Is the financial account activity an account holder fee type */
  ACCOUNT_HOLDER_FEE = "ACCOUNT_HOLDER_FEE",
  /** Is the financial account activity an externally initiated ACH */
  EXTERNALLY_INITIATED_ACH = "EXTERNALLY_INITIATED_ACH",
  /** Is the financial account activity an integrator initiated ACH */
  INTEGRATOR_INITIATED_ACH = "INTEGRATOR_INITIATED_ACH",
  /** Is the financial account activity an internal transfer type */
  INTERNAL_TRANSFER = "INTERNAL_TRANSFER",
  /** Is the financial account activity a payment card type */
  PAYMENT_CARD = "PAYMENT_CARD",
}

/** Inputs for filtering Financial Account Activity types */
export type FinancialAccountActivityTypeFilterInput = {
  /** Value matches the provided activity type */
  equals?: InputMaybe<FinancialAccountActivityType>;
  /** Value does not match any of the provided activity types */
  excludes?: InputMaybe<Array<FinancialAccountActivityType>>;
  /** Value exactly matches any of the provided activity types */
  includes?: InputMaybe<Array<FinancialAccountActivityType>>;
  /** Value does not match the provided activity type */
  notEquals?: InputMaybe<FinancialAccountActivityType>;
};

/**
 * An Attribute of a `FinancialAccount`.
 *
 * Account Attributes are used to signal specific capability restrictions and/or substatuses.
 *
 * For more information on `FinancialAccountAttribute` please check the developer documentation.
 */
export enum FinancialAccountAttribute {
  /** The account is under investigation for potential account takeover. */
  ACCOUNT_TAKEOVER = "ACCOUNT_TAKEOVER",
  /** The account is under investigation for unusual electronic funds transfer activity. */
  ACH_RISK_HOLD = "ACH_RISK_HOLD",
  /** The account is charged off and suspended for excessive delinquency based on the number of days set on your card product. */
  CHARGE_OFF = "CHARGE_OFF",
  /** The account has been closed with an outstanding balance payable and repayment is required. */
  CLOSED_WITH_BALANCE = "CLOSED_WITH_BALANCE",
  /** The account’s payment is delinquent and may be reported to the credit bureaus as such based on the number of days set on your card product. */
  DELINQUENT = "DELINQUENT",
  /** The account is suspended for authorizations for excessive delinquency based on the number of days set on your card product. */
  DELINQUENT_SUSPENDED = "DELINQUENT_SUSPENDED",
  /** The account is under investigation for potential identity theft. */
  IDENTITY_THEFT = "IDENTITY_THEFT",
  /** The account is under investigation for a potential OFAC match. */
  OFAC_WARNING = "OFAC_WARNING",
  /** The account is being processed for closure. */
  PENDING_CLOSURE = "PENDING_CLOSURE",
  /** The account is suspended due to program owner initiated suspension. */
  PROGRAM_OWNER_INITIATED_SUSPENSION = "PROGRAM_OWNER_INITIATED_SUSPENSION",
  /** The account is under investigation for suspected fraud. */
  SUSPECTED_FRAUD = "SUSPECTED_FRAUD",
}

/** The reason for a `FinancialAccountAttribute`. */
export enum FinancialAccountAttributeReason {
  /** The `FinancialAccount` is being suspended due to account holder request. */
  PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_ACCOUNT_HOLDER_REQUEST = "PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_ACCOUNT_HOLDER_REQUEST",
  /** The `FinancialAccount` is being suspended due to account review. */
  PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_ACCOUNT_REVIEW = "PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_ACCOUNT_REVIEW",
  /** The `FinancialAccount` is being suspended due to related ACH transfer returns. */
  PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_ACH_RETURNS = "PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_ACH_RETURNS",
  /** The `FinancialAccount` is being suspended due to delinquency. */
  PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_DELINQUENCY = "PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_DELINQUENCY",
  /** The `FinancialAccount` is being suspended due to lost or stolen `PaymentCard`. */
  PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_LOST_OR_STOLEN_CARD = "PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_LOST_OR_STOLEN_CARD",
  /** The `FinancialAccount` is being suspended due to suspected fraud. */
  PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_SUSPECTED_FRAUD = "PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_SUSPECTED_FRAUD",
  /** The `FinancialAccount` is being suspended due to unspecified reason. */
  PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_UNSPECIFIED = "PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_UNSPECIFIED",
}

/** The Attribute of a `FinancialAccount` with a reason. */
export type FinancialAccountAttributeWithReason = {
  __typename?: "FinancialAccountAttributeWithReason";
  /** The attribute of the `FinancialAccount`. */
  attribute: FinancialAccountAttribute;
  /** The reason for the attribute. */
  reason?: Maybe<FinancialAccountAttributeReason>;
};

/** The ledger details for the `FinancialAccount` balance. */
export type FinancialAccountBalanceLedgerDetail = {
  __typename?: "FinancialAccountBalanceLedgerDetail";
  /** The date and time, in ISO 8601 format, the `debitBalance` and `creditBalance` were last calculated. */
  asOf?: Maybe<Scalars["String"]>;
  /**
   * The credit balance of the `Ledger`.
   *
   * When the `Ledger`'s `normalBalance` is `CREDIT` this field should change based on activity. Otherwise, the `value` will stay zero. If the balance is negative, this amount will be zero, and the `DEBIT` amount will be positive. Refer to `normalBalance` definition to see information about possible negative balances.
   */
  creditBalance?: Maybe<Amount>;
  /**
   * The debit balance of the `Ledger`.
   *
   * When the `Ledger`'s `normalBalance` is `DEBIT` this field should change based on activity. Otherwise, the `value` will stay zero. If the balance is negative, this amount will be zero, and the `CREDIT` amount will be positive. Refer to `normalBalance` definition to see information about possible negative balances.
   */
  debitBalance?: Maybe<Amount>;
  /** The name of the `Ledger`. */
  ledgerName?: Maybe<LedgerName>;
  /**
   * The expected normal balance of the `Ledger`.
   *
   * In most cases the corresponding `creditBalance` and `debitBalance` field will have a non-zero value. If the corresponding `creditBalance` or `debitBalance` field has a zero value and the other `creditBalance` or `debitBalance` field has a value greater than zero, that greater than zero value represents a negative balance on the ledger.
   */
  normalBalance?: Maybe<NormalBalance>;
};

/** The available fields that are available to search on. */
export enum FinancialAccountBalanceSearchField {
  /**
   * The available cash balance of the `FinancialAccount`.
   *
   * If choosing this field, the `signedBalance` can be used to search by the current balance.
   * Otherwise, use `creditBalance` for positive amounts and `debitBalance` for negative amounts.
   */
  AVAILABLE_CASH_LEDGER_BALANCE = "AVAILABLE_CASH_LEDGER_BALANCE",
  /**
   * The available credit balance of the `FinancialAccount`.
   *
   * If choosing this field, the `signedBalance` can be used to search by the current balance.
   * Otherwise, use `creditBalance` for positive amounts and `debitBalance` for negative amounts.
   */
  AVAILABLE_CREDIT_LEDGER_BALANCE = "AVAILABLE_CREDIT_LEDGER_BALANCE",
  /**
   * The `CardProduct` ID of the `FinancialAccount`.
   *
   * If choosing this field, the `stringFilter` must be used.
   */
  CARD_PRODUCT_ID = "CARD_PRODUCT_ID",
  /**
   * The cash balance of the `FinancialAccount`.
   *
   * If choosing this field, the `signedBalance` can be used to search by the current balance.
   * Otherwise, use `debitBalance` for positive amounts and `creditBalance` for negative amounts.
   */
  CASH_LEDGER_BALANCE = "CASH_LEDGER_BALANCE",
  /**
   * The credit outstanding balance of the `FinancialAccount`.
   *
   * If choosing this field, the `signedBalance` can be used to search by the current balance.
   * Otherwise, use `debitBalance` for positive amounts and `creditBalance` for negative amounts.
   */
  CREDIT_OUTSTANDING_LEDGER_BALANCE = "CREDIT_OUTSTANDING_LEDGER_BALANCE",
  /**
   * The `FinancialAccount` created at date.
   *
   * If choosing this field, the `timestampFilter` must be used.
   */
  FINANCIAL_ACCOUNT_CREATED_AT = "FINANCIAL_ACCOUNT_CREATED_AT",
  /**
   * The `FinancialAccount` ID pertaining the `FinancialAccount` balance.
   *
   * If choosing this field, the `stringFilter` must be used.
   */
  FINANCIAL_ACCOUNT_ID = "FINANCIAL_ACCOUNT_ID",
  /**
   * The ID of the `FinancialAccountOwner`.
   *
   * If choosing this field, the `stringFilter` must be used.
   */
  FINANCIAL_ACCOUNT_OWNER_ID = "FINANCIAL_ACCOUNT_OWNER_ID",
  /**
   * The outstanding balance payable of the `FinancialAccount`.
   *
   * If choosing this field, the `signedBalance` can be used to search by the current balance.
   * Otherwise, use `creditBalance` for positive amounts and `debitBalance` for negative amounts.
   */
  OUTSTANDING_BALANCE_PAYABLE_LEDGER_BALANCE = "OUTSTANDING_BALANCE_PAYABLE_LEDGER_BALANCE",
  /**
   * The outstanding balance receivable of the `FinancialAccount`.
   *
   * If choosing this field, the `signedBalance` can be used to search by the current balance.
   * Otherwise, use `debitBalance` for positive amounts and `creditBalance` for negative amounts.
   */
  OUTSTANDING_BALANCE_RECEIVABLE_LEDGER_BALANCE = "OUTSTANDING_BALANCE_RECEIVABLE_LEDGER_BALANCE",
}

/**
 * A filter to search for a `FinancialAccountBalanceSearchResult`.
 * Each `FinancialAccountBalanceSearchFilter` must define a `searchField`, along with the value filter for that
 * field.
 * stringFilter field names:
 * - `FINANCIAL_ACCOUNT_ID`
 * - `CARD_PRODUCT_ID`
 * - `FINANCIAL_ACCOUNT_OWNER_ID`
 *
 * timestampFilter field names:
 * - `FINANCIAL_ACCOUNT_CREATE_DATE`
 *
 * signedBalance field can be used with any `*_LEDGER_BALANCE` fields to filter by the current balance of the ledger.
 *
 * creditBalance field for positive amounts:
 * - `AVAILABLE_CASH_LEDGER_BALANCE`
 * - `AVAILABLE_CREDIT_LEDGER_BALANCE`
 * - `OUTSTANDING_BALANCE_PAYABLE_LEDGER_BALANCE`
 *
 * debitBalance field for positive amounts:
 * - `CASH_LEDGER_BALANCE`
 * - `CREDIT_OUTSTANDING_LEDGER_BALANCE`
 * - `OUTSTANDING_BALANCE_RECEIVABLE_LEDGER_BALANCE`
 *
 * For negative balances, the creditBalance and debitBalance fields for the respective ledger's `NormalBalance` will be reversed.
 */
export type FinancialAccountBalanceSearchFilter = {
  /** Input to filter by amount. */
  creditBalance?: InputMaybe<MoneyFilterInput>;
  /** Input to filter by amount. */
  debitBalance?: InputMaybe<MoneyFilterInput>;
  /** The field to search on. */
  searchField: FinancialAccountBalanceSearchField;
  /** Input to filter by amount by the current balance of the `Ledger`. */
  signedBalance?: InputMaybe<SignedMoneyFilterInput>;
  /** String value type */
  stringFilter?: InputMaybe<StringFilterInput>;
  /** Timestamp value type in ISO 8601 format */
  timestampFilter?: InputMaybe<TimestampFilterInput>;
};

/** Input for filtering `FinancialAccountBalanceSearchResults`. */
export type FinancialAccountBalanceSearchFilterInput = {
  filters?: InputMaybe<Array<FinancialAccountBalanceSearchFilter>>;
};

/** The `FinancialAccount` balance search result object. */
export type FinancialAccountBalanceSearchResult = {
  __typename?: "FinancialAccountBalanceSearchResult";
  /** The balances of the `FinancialAccount`. */
  balances?: Maybe<Array<FinancialAccountBalanceLedgerDetail>>;
  /** The `CardProduct` of the `FinancialAccount`. */
  cardProduct?: Maybe<CardProduct>;
  /** The `FinancialAccount` pertaining to the `FinancialAccount` balance. */
  financialAccount?: Maybe<FinancialAccount>;
  /** The date and time, in ISO 8601 format, when the `FinancialAccount` was created. */
  financialAccountCreatedAt?: Maybe<Scalars["String"]>;
  /** The owner of the `FinancialAccount`. */
  financialAccountOwner?: Maybe<FinancialAccountOwner>;
  /** The date and time, in ISO 8601 format, when the `FinancialAccount` balance report was generated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The connection type for `FinancialAccountBalanceSearchResult` */
export type FinancialAccountBalanceSearchResultConnection = {
  __typename?: "FinancialAccountBalanceSearchResultConnection";
  /** A list of edges. */
  edges?: Maybe<Array<FinancialAccountBalanceSearchResultEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for `FinancialAccountBalanceSearchResult` */
export type FinancialAccountBalanceSearchResultEdge = {
  __typename?: "FinancialAccountBalanceSearchResultEdge";
  /** The cursor for this edge for use in pagination. */
  cursor?: Maybe<Scalars["String"]>;
  /** The search result. */
  node?: Maybe<FinancialAccountBalanceSearchResult>;
};

/** The possible return types of `searchFinancialAccountBalances`. */
export type FinancialAccountBalanceSearchResultPayload =
  | AccessDeniedError
  | FinancialAccountBalanceSearchResultConnection
  | UserError;

/** The current billing summary, including information on remaining latest closed statement balance, minimum payment, and payment due date, for this `FinancialAccount` */
export type FinancialAccountBillingSummary = {
  __typename?: "FinancialAccountBillingSummary";
  /** The date and time this data was fetched, in ISO 8601 format. */
  asOf?: Maybe<Scalars["String"]>;
  /** The current minimum payment due, taking into account any payments made that applied to the latest closed statement balance. */
  minimumPaymentDue?: Maybe<Amount>;
  /**
   * The date payment is due for the latest closed statement, in ISO 8601 format.
   * @deprecated please use `paymentDueOn` instead
   */
  paymentDueDate?: Maybe<Scalars["String"]>;
  /** The date and time payment is due for the latest closed statement, in ISO 8601 format. */
  paymentDueOn?: Maybe<Scalars["String"]>;
  /** The latest closed statement balance less any payments applied to it. */
  remainingLatestClosedStatementBalance?: Maybe<Amount>;
};

/** The possible reasons for closure of a `FinancialAccount`. */
export enum FinancialAccountClosureReason {
  /** Account is closed at the request of the account holder. */
  ACCOUNT_HOLDER_REQUEST = "ACCOUNT_HOLDER_REQUEST",
  /** Account is closed due to bankruptcy. */
  BANKRUPTCY = "BANKRUPTCY",
  /** Account is closed due to a negative balance on the account. */
  CHARGE_OFF = "CHARGE_OFF",
  /** Information has been provided that determines the account holder is deceased. */
  DECEASED = "DECEASED",
  /** Account is closed due to inactivity. */
  INACTIVITY = "INACTIVITY",
  /** Account is closed due to lost or stolen card. */
  LOST_OR_STOLEN_CARD = "LOST_OR_STOLEN_CARD",
  /** Account is closed due to the business type. */
  PROHIBITED_BUSINESS_TYPE = "PROHIBITED_BUSINESS_TYPE",
  /** Requested information not received or there is suspect activity occurring on the account that could not be verified. */
  SECURITY_CONCERN = "SECURITY_CONCERN",
  /** Account is closed due to unusual activity taking place on the account. */
  UNUSUAL_ACTIVITY = "UNUSUAL_ACTIVITY",
}

/** The connection type for FinancialAccount. */
export type FinancialAccountConnection = {
  __typename?: "FinancialAccountConnection";
  /** A list of edges. */
  edges?: Maybe<Array<FinancialAccountEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
  /** The total number of records. */
  totalRecords?: Maybe<Scalars["UnsignedInt"]>;
};

/** Credit limit update of a Financial Account within the Highnote platform. */
export type FinancialAccountCreditLimitUpdateFromProductFunding = Node & {
  __typename?: "FinancialAccountCreditLimitUpdateFromProductFunding";
  /** The amount of the credit limit. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, the credit limit update was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the credit limit update in operations. */
  id: Scalars["ID"];
  /** The ledgers affected by the credit limit update. */
  ledgers?: Maybe<Array<Ledger>>;
  /** A description of the credit limit update for later reference. */
  memo?: Maybe<Scalars["String"]>;
  /** The current status of the credit limit. */
  status?: Maybe<FinancialAccountCreditLimitUpdateFromProductFundingStatus>;
  /** The reason for the current status. */
  statusReason?: Maybe<FinancialAccountCreditLimitUpdateFromProductFundingStatusReasonCode>;
  /** The date and time, in ISO 8601 format, the credit limit update was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Credit limit update of a Financial Account within the Highnote platform. */
export type FinancialAccountCreditLimitUpdateFromProductFundingLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** The states of a FinancialAccountCreditLimitUpdateFromProductFunding. */
export enum FinancialAccountCreditLimitUpdateFromProductFundingStatus {
  /** The platform has completed the credit limit update. */
  COMPLETED = "COMPLETED",
  /** The platform was not able to complete the credit limit update. See `statusReasonCode` for more information. */
  FAILED = "FAILED",
  /** The platform is currently validating and executing the credit limit update. */
  PENDING = "PENDING",
  /**
   * The platform has started processing the credit limit update.
   * @deprecated unused
   */
  PROCESSING = "PROCESSING",
}

/** The reasons a FinancialAccountCreditLimitUpdateFromProductFunding could fail. */
export enum FinancialAccountCreditLimitUpdateFromProductFundingStatusReasonCode {
  /** The associated product funding account or account is closed. */
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  /** The account was not found. */
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  /** The associated product funding account did not have enough funds to cover the requested amount. */
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  /** The requested amount is more than max program limit. */
  LIMIT_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT = "LIMIT_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT",
  /** There is not enough balance to reduce the credit limit. */
  NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT = "NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT",
  /** The requested amount exceeds the maximum aggregate credit distribution amount. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_AGGREGATE_CREDIT_DISTRIBUTION_AMOUNT = "TRANSFER_AMOUNT_EXCEEDING_MAX_AGGREGATE_CREDIT_DISTRIBUTION_AMOUNT",
}

/** Interface for a delinquency for a `FinancialAccount` associated with a credit product. */
export type FinancialAccountDelinquency = {
  /** A list of contiguous billing cycles where this `FinancialAccount` was delinquent. */
  currentDelinquentCycles?: Maybe<
    Array<Maybe<FinancialAccountDelinquencyCycle>>
  >;
  /** The due date of the oldest contiguous delinquent Statement. Null if the `FinancialAccount` is not currently delinquent. */
  delinquencyStartedOn?: Maybe<Scalars["String"]>;
  /** Count of contiguous delinquent cycles for this `FinancialAccount`. 0 if the `FinancialAccount` is not currently delinquent. */
  numberOfCycles?: Maybe<Scalars["UnsignedInt"]>;
  /** The current amount deliquent, including any interest or fees, for this `FinancialAccount`. */
  totalAmount?: Maybe<Amount>;
  /** Number of days since the due date of the oldest contiguous delinquent statement. 0 if the `FinancialAccount` is not currently delinquent. */
  totalDaysDelinquent?: Maybe<Scalars["UnsignedInt"]>;
};

/** A billing cycle where a `FinancialAccount` is delinquent at some point. */
export type FinancialAccountDelinquencyCycle = {
  /** The amount delinquent, including any interest or fees, at the periodEnd of this cycle. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Days elapsed between the due date of the oldest contiguous delinquent cycle and the periodEnd of this cycle. */
  daysDelinquent?: Maybe<Scalars["UnsignedInt"]>;
  /** A list of repayments applied to this billing cycle. Please note that only the first 20 repayments for a cycle will be returned. */
  repayments?: Maybe<Array<CreditRepaymentStatementApplication>>;
  /** The delinquency state of this `FinancialAccount` at the periodEnd of this cycle. Can be DELINQUENT or CURRENT. */
  state?: Maybe<FinancialAccountDelinquencyState>;
  /** The `FinancialAccount` statement for this billing cycle. Includes information such as periodStart, periodEnd, and paymentDueOn. */
  statement?: Maybe<FinancialAccountStatement>;
  /** The unique identifier for the `FinancialAccount` statement for this billing cycle. */
  statementId: Scalars["ID"];
  /** The total amount of repayments applied to this billing cycle. */
  totalRepaymentsApplied?: Maybe<Amount>;
  /** The date and time when this was updated, in ISO 8601 format. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** `FinancialAccount` delinquency state. */
export enum FinancialAccountDelinquencyState {
  /** Account is closed. */
  CLOSED = "CLOSED",
  /** Account is chargedOff and now in the process of closing. */
  CLOSING = "CLOSING",
  /** Most recent required payment was received before its due date. */
  CURRENT = "CURRENT",
  /** At least one required payment was not received before its due date. */
  DELINQUENT = "DELINQUENT",
}

/** The edge type for a FinancialAccount. */
export type FinancialAccountEdge = {
  __typename?: "FinancialAccountEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The financial account. */
  node?: Maybe<FinancialAccount>;
};

export type FinancialAccountFeature = {
  /** The date and time, in ISO 8601 format, the feature was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective from. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective through. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Whether or not the feature is enabled for the Financial Account. */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** The date and time, in ISO 8601 format, the feature was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Possible features of the Financial Accounts */
export enum FinancialAccountFeatureType {
  /** Whether or not the `FinancialAccount` is associated to the authorized user. */
  AUTHORIZED_USER = "AUTHORIZED_USER",
  /** Whether or not the Financial Account supports Card Funding. */
  CARD_FUNDING_ACCOUNT = "CARD_FUNDING_ACCOUNT",
  /** Whether or not the Financial Account supports a Credit Payment Card. */
  CREDIT_PAYMENT_CARD = "CREDIT_PAYMENT_CARD",
  /** Whether or not the Financial Account supports a Debit Payment Card. */
  DEBIT_PAYMENT_CARD = "DEBIT_PAYMENT_CARD",
  /** The account and routing number can be used to deposit funds. */
  DIRECT_DEPOSIT = "DIRECT_DEPOSIT",
  /** Whether or not the Financial Account supports the Income Account feature. */
  INCOME_ACCOUNT = "INCOME_ACCOUNT",
  /** Whether or not the Financial Account supports Just-in-time Funding. */
  JUST_IN_TIME_FUNDING = "JUST_IN_TIME_FUNDING",
  /** Whether or not the `FinancialAccount` supports the merchant settlement account feature. */
  MERCHANT_SETTLEMENT = "MERCHANT_SETTLEMENT",
  /** Whether or not the Financial Account supports Negative Balance Reserve. */
  NEGATIVE_BALANCE_RESERVE = "NEGATIVE_BALANCE_RESERVE",
  /** Whether or not the Financial Account supports On-Demand Funding. */
  ON_DEMAND_FUNDING = "ON_DEMAND_FUNDING",
  /** Whether or not the Financial Account supports Payroll Advance. */
  PAYROLL_ADVANCE = "PAYROLL_ADVANCE",
  /** Whether or not the Financial Account supports Payroll Employer Advance. */
  PAYROLL_EMPLOYER_ADVANCE = "PAYROLL_EMPLOYER_ADVANCE",
  /** Whether or not the Financial Account supports Point Rewards. */
  POINT_REWARDS = "POINT_REWARDS",
  /** Whether or not the Financial Account supports a PrePaid Payment Card. */
  PREPAID_PAYMENT_CARD = "PREPAID_PAYMENT_CARD",
  /** Whether or not the `FinancialAccount` supports the preprinted card account feature. */
  PREPRINTED_CARD = "PREPRINTED_CARD",
  /** Whether or not the Financial Account supports Product Funding. */
  PRODUCT_FUNDING = "PRODUCT_FUNDING",
  /** Whether or not the Financial Account supports Product Reserve. */
  PRODUCT_RESERVE = "PRODUCT_RESERVE",
  /** Whether or not the `FinancialAccount` supports the product secured deposit account feature. */
  PRODUCT_SECURED_DEPOSIT = "PRODUCT_SECURED_DEPOSIT",
  /** Whether or not the `FinancialAccount` supports the repayment account feature. */
  REPAYMENT_ACCOUNT = "REPAYMENT_ACCOUNT",
  /** Whether or not the `FinancialAccount` supports the reset balance account feature. */
  RESET_BALANCE = "RESET_BALANCE",
  /** Whether or not the Financial Account supports a Secured Deposit Funded Credit Payment Card. */
  SECURED_CREDIT_PAYMENT_CARD = "SECURED_CREDIT_PAYMENT_CARD",
  /** Whether or not the `FinancialAccount` supports the secured deposit account feature. */
  SECURED_DEPOSIT = "SECURED_DEPOSIT",
  /** Whether or not the `FinancialAccount` supports the suspense account feature. */
  SUSPENSE = "SUSPENSE",
}

/** Input for filtering Financial Account feature */
export type FinancialAccountFeatureTypeFilterInput = {
  /** Value matches the provided Financial Account feature */
  equals?: InputMaybe<FinancialAccountFeatureType>;
  /** Value does not match any of the provided Financial Account feature */
  excludes?: InputMaybe<Array<FinancialAccountFeatureType>>;
  /** Value exactly matches all of the provided Financial Account feature */
  includes?: InputMaybe<Array<FinancialAccountFeatureType>>;
  /** Value does not match the provided Financial Account feature */
  notEquals?: InputMaybe<FinancialAccountFeatureType>;
};

/** The possible owners of a `FinancialAccount` */
export type FinancialAccountOwner =
  | Organization
  | PaymentCard
  | UsBusinessAccountHolder
  | UsPersonAccountHolder;

export type FinancialAccountPayload =
  | AccessDeniedError
  | FinancialAccount
  | UserError;

/** Input for filtering `PaymentCardTransactionChargeback` on `FinancialAccount` */
export type FinancialAccountPaymentCardTransactionChargebacksFilterInput = {
  /** Input to filter by `PaymentCardTransactionChargeback` created date. */
  chargebackCreatedAt?: InputMaybe<TimestampFilterInput>;
  /** Input to filter by `PaymentCardTransactionChargeback` ID. */
  chargebackId?: InputMaybe<IdFilterInput>;
  /** Input to filter by `PaymentCardTransactionChargeback` status. */
  chargebackStatus?: InputMaybe<PaymentCardChargebackStatusFilterInput>;
  /** Chargeback externalNetworkId filter */
  externalNetworkId?: InputMaybe<StringFilterInput>;
};

/** Input for filtering `PaymentCardTransactionDispute` on `FinancialAccount` */
export type FinancialAccountPaymentCardTransactionDisputesFilterInput = {
  /** Input to filter by `PaymentCardTransactionChargeback` created date. */
  chargebackCreatedAt?: InputMaybe<TimestampFilterInput>;
  /** Input to filter by `PaymentCardTransactionChargeback` ID. */
  chargebackId?: InputMaybe<IdFilterInput>;
  /** Input to filter by `PaymentCardTransactionChargeback` status. */
  chargebackStatus?: InputMaybe<PaymentCardChargebackStatusFilterInput>;
  /** Input to filter by `PaymentCardTransactionDispute` created date. */
  disputeCreatedAt?: InputMaybe<TimestampFilterInput>;
  /** Input to filter disputes by whether a `PaymentCardTransactionDispute` has an associated `PaymentCardTransactionChargeback`. */
  disputeHasChargeback?: InputMaybe<BooleanFilterInput>;
  /** Input to filter by `PaymentCardTransactionDispute` ID. */
  disputeId?: InputMaybe<IdFilterInput>;
  /** Input to filter by `PaymentCardTransactionDispute` status. */
  disputeStatus?: InputMaybe<PaymentCardDisputeStatusFilterInput>;
  /** Chargeback externalNetworkId filter */
  externalNetworkId?: InputMaybe<StringFilterInput>;
};

/** Inputs for filtering Payment Card data. */
export type FinancialAccountPaymentCardsFilterInput = {
  accountHolderId?: InputMaybe<IdFilterInput>;
  bin?: InputMaybe<StringFilterInput>;
  cardNetwork?: InputMaybe<PaymentCardNetworkFilterInput>;
  createDate?: InputMaybe<TimestampFilterInput>;
  customFields?: InputMaybe<CustomFieldsFilterInput>;
  expirationDate?: InputMaybe<TimestampFilterInput>;
  formFactor?: InputMaybe<CardFormFactorFilterInput>;
  last4?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<PaymentCardStatusFilterInput>;
  updateDate?: InputMaybe<TimestampFilterInput>;
};

/** The pseudo balance update applied to a financial account ID. */
export type FinancialAccountPseudoBalanceUpdate = Node & {
  __typename?: "FinancialAccountPseudoBalanceUpdate";
  /** The amount set for this pseudo balance. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, at which this update was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** ID for the pseudo balance update. */
  id: Scalars["ID"];
  /** The memo set when creating the pseudo balance update. */
  memo?: Maybe<Scalars["String"]>;
  /** The status of this pseudo balance update. */
  status?: Maybe<FinancialAccountPseudoBalanceUpdateStatus>;
  /** In the case of a failed `status`, returns the failed reason. */
  statusReason?: Maybe<FinancialAccountPseudoBalanceUpdateStatusReason>;
  /** The date and time, in ISO 8601 format, at which this update was modified. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** One of the possible return types for FinancialAccountPseudoBalanceUpdatePayload. */
export type FinancialAccountPseudoBalanceUpdatePayload =
  | AccessDeniedError
  | FinancialAccountPseudoBalanceUpdate
  | InterFinancialAccountTransfer
  | UserError;

/** An enum used to represent the status of the pseudo balance update request. */
export enum FinancialAccountPseudoBalanceUpdateStatus {
  /** The platform has completed the pseudo balance update. */
  COMPLETED = "COMPLETED",
  /** The platform was not able to complete the limit update. See `statusReasonCode` for more information. */
  FAILED = "FAILED",
  /** The platform is currently validating and executing the limit update. */
  PENDING = "PENDING",
}

/** An enum used to represent the failure reasons for the pseudo balance update request. */
export enum FinancialAccountPseudoBalanceUpdateStatusReason {
  /** The account has been closed so the pseudo balance update can not be applied. */
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  /** The financial account ID provided was not tied to a valid financial account. Double check the `financialAccountId` and try again. */
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
}

/** A `CreditPlan` for `PURCHASE` balances that is configured with an APR for this `FinancialAccount`. */
export type FinancialAccountPurchaseCreditPlan = {
  __typename?: "FinancialAccountPurchaseCreditPlan";
  /** The annual percentage rate (APR) that will be charged for purchases under this `CreditPlan` for this `FinancialAccount`. */
  apr?: Maybe<Scalars["Float"]>;
  /** The `CreditPlan` this configuration applies to. */
  creditPlan?: Maybe<CreditPlan>;
};

/** The initial details of the `FinancialAccount` before the revision was applied. */
export type FinancialAccountSnapshot = Node & {
  __typename?: "FinancialAccountSnapshot";
  /** The status of the `FinancialAccount`. */
  accountStatus?: Maybe<FinancialAccountStatus>;
  /**
   * The Card Product Application used to issue this Employer Financial Account.
   * @deprecated Use cardProductApplication instead.
   */
  application?: Maybe<AccountHolderCardProductApplication>;
  /** The card product associated to the `FinancialAccount`. */
  cardProduct?: Maybe<CardProduct>;
  /** The Card Product Application used to issue this Financial Account. */
  cardProductApplication?: Maybe<CardProductApplication>;
  /**
   * The date and time, in ISO 8601 format, when this snapshot was created.
   * This is also the date that the `FinancialAccount` was created.
   */
  createdAt?: Maybe<Scalars["String"]>;
  /**
   * Externally provided ID (255 character limit) that can be used to refer to the issued payment card's' financial account.
   * This ID is unique per organization and tenant. If not provided, Highnote will generate an ID (ten digit, Base58, all caps).
   */
  externalId?: Maybe<Scalars["String"]>;
  /** The `FinancialAccount` that this is a revision of. */
  financialAccount?: Maybe<FinancialAccount>;
  /** The attributes of the `FinancialAccount`. */
  financialAccountAttributes?: Maybe<Array<FinancialAccountAttribute>>;
  /** Global ID used to reference the `FinancialAccountSnapshot`. */
  id: Scalars["ID"];
  /** The name of this account. */
  name?: Maybe<Scalars["String"]>;
  /**
   * The date and time, in ISO 8601 format, when this snapshot was updated.
   * This is also the date that the `FinancialAccount` was modified.
   */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The connection type for `FinancialAccountSnapshot`. */
export type FinancialAccountSnapshotConnection = {
  __typename?: "FinancialAccountSnapshotConnection";
  /** A list of edges. */
  edges?: Maybe<Array<FinancialAccountSnapshotEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a `FinancialAccountSnapshot`. */
export type FinancialAccountSnapshotEdge = {
  __typename?: "FinancialAccountSnapshotEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The details of the revision made to a `FinancialAccount`. */
  node?: Maybe<FinancialAccountSnapshot>;
};

/** Interface for a Statement for a Financial Account. */
export type FinancialAccountStatement = {
  /** The timestamp, in ISO 8601 format, the statement was closed. */
  closedAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, this was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The credit balance at the end of the period for the primary ledger. */
  endingPrimaryCreditBalance?: Maybe<Amount>;
  /** The debit balance at the end of the period for the primary ledger. */
  endingPrimaryDebitBalance?: Maybe<Amount>;
  /** The credit balance at the end of the period for the secondary ledger. */
  endingSecondaryCreditBalance?: Maybe<Amount>;
  /** The debit balance at the end of the period for the secondary ledger. */
  endingSecondaryDebitBalance?: Maybe<Amount>;
  /** The credit balance at the end of the period for the tertiary ledger. */
  endingTertiaryCreditBalance?: Maybe<Amount>;
  /** The debit balance at the end of the period for the tertiary ledger. */
  endingTertiaryDebitBalance?: Maybe<Amount>;
  /** The unique id of the `FinancialAccountStatement`. */
  id: Scalars["ID"];
  /** The timestamp, in ISO 8601 format, the statement was opened. */
  openedAt?: Maybe<Scalars["String"]>;
  /** The date, in ISO 8601 format, the statement period ends. */
  periodEnd?: Maybe<Scalars["String"]>;
  /** The date, in ISO 8601 format, the statement period starts. */
  periodStart?: Maybe<Scalars["String"]>;
  /** The ledger associated with the primary balance */
  primaryLedger?: Maybe<Ledger>;
  /** The ledger associated with the secondary balance */
  secondaryLedger?: Maybe<Ledger>;
  /** The credit balance at the start of the period for the primary ledger. */
  startingPrimaryCreditBalance?: Maybe<Amount>;
  /** The debit balance at the start of the period for the primary ledger. */
  startingPrimaryDebitBalance?: Maybe<Amount>;
  /** The credit balance at the start of the period for the secondary ledger. */
  startingSecondaryCreditBalance?: Maybe<Amount>;
  /** The debit balance at the start of the period for the secondary ledger. */
  startingSecondaryDebitBalance?: Maybe<Amount>;
  /** The credit balance at the start of the period for the tertiary ledger. */
  startingTertiaryCreditBalance?: Maybe<Amount>;
  /** The debit balance at the start of the period for the tertiary ledger. */
  startingTertiaryDebitBalance?: Maybe<Amount>;
  /**
   * statement entries.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  statementEntries?: Maybe<FinancialAccountStatementEntryConnection>;
  /** The ledger associated with the tertiary balance */
  tertiaryLedger?: Maybe<Ledger>;
  /** The date and time, in ISO 8601 format, this was most recently updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Interface for a Statement for a Financial Account. */
export type FinancialAccountStatementStatementEntriesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<FinancialAccountStatementEntriesFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

export type FinancialAccountStatementBalanceType = {
  /** Purchase balance for this `CreditPlan`, subject to the interest charge for specific credit plan' */
  balanceSubjectToInterestAmount?: Maybe<Amount>;
  /** Balance Type for the current statement */
  balanceType?: Maybe<BalanceType>;
  /** The `CreditPlan` associated with this statement. */
  creditPlan?: Maybe<CreditPlan>;
  /** Period's purchase interest charge for this `CreditPlan`, subject to the interest charge for specific balance for specific credit plan type' */
  interestChargedAmount?: Maybe<Amount>;
};

/** The connection type for `FinancialAccountStatement`. */
export type FinancialAccountStatementConnection = {
  __typename?: "FinancialAccountStatementConnection";
  /** A list of edges. */
  edges?: Maybe<Array<FinancialAccountStatementEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a `FinancialAccountStatementy`. */
export type FinancialAccountStatementEdge = {
  __typename?: "FinancialAccountStatementEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The Financial Account Statement. */
  node?: Maybe<FinancialAccountStatement>;
};

/** Inputs for filtering Financial Account Statement Entry. */
export type FinancialAccountStatementEntriesFilterInput = {
  isCredit?: InputMaybe<BooleanFilterInput>;
  postDate?: InputMaybe<TimestampFilterInput>;
};

/** FinancialAccountStatementEntry */
export type FinancialAccountStatementEntry = {
  /** The date and time, in ISO 8601 format, this was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Credit amount of the transaction. */
  creditAmount?: Maybe<Amount>;
  /** Debit amount of the transaction. */
  debitAmount?: Maybe<Amount>;
  /** Ledger Entry for the entry */
  ledgerEntry?: Maybe<LedgerEntry>;
  /** The date, in ISO 8601 format, the transaction was posted. (Different word for 'posted'?) */
  postDate?: Maybe<Scalars["String"]>;
  /** Credit balance of the account. */
  primaryCreditBalance?: Maybe<Amount>;
  /** Debit balance of the account. */
  primaryDebitBalance?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this was most recently updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The connection type for `FinancialAccountStatementEntry`. */
export type FinancialAccountStatementEntryConnection = {
  __typename?: "FinancialAccountStatementEntryConnection";
  /** A list of edges. */
  edges?: Maybe<Array<FinancialAccountStatementEntryEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a `FinancialAccountStatementEntry`. */
export type FinancialAccountStatementEntryEdge = {
  __typename?: "FinancialAccountStatementEntryEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The Financial Account Statement Entry. */
  node?: Maybe<FinancialAccountStatementEntry>;
};

export type FinancialAccountStatementEvent = {
  /** Account Id associated with this statement. */
  financialAccountId?: Maybe<Scalars["ID"]>;
  /** Id for statement which is ready. */
  id: Scalars["ID"];
};

/** Inputs for filtering Financial Account Statement. */
export type FinancialAccountStatementFilterInput = {
  periodEnd?: InputMaybe<TimestampFilterInput>;
  periodStart?: InputMaybe<TimestampFilterInput>;
};

/** `FinancialAccount` activity for this statement related to `InstallmentAgreement`s. */
export type FinancialAccountStatementInstallmentCreditPlanActivity = {
  __typename?: "FinancialAccountStatementInstallmentCreditPlanActivity";
  /** The `InstallmentAgreement`. */
  installmentAgreement?: Maybe<InstallmentAgreement>;
  /** The amount the total balance, including principal and fees, is reduced by during this statement period for this `InstallmentAgreement`. */
  periodBalancePaid?: Maybe<Amount>;
  /** The fee credit (for example due to waiving fees) associated with this `InstallmentAgreement` for this statement period. */
  periodFeeCredit?: Maybe<Amount>;
  /** The fees associated with this `InstallmentAgreement` for this statement period. */
  periodFeesAmount?: Maybe<Amount>;
  /** The amount of principal paid down during this statement period for this `InstallmentAgreement`. */
  periodPrincipal?: Maybe<Amount>;
};

/** The FinanceAccountStatementPayOffPayment is the amount paid by the consumer. This can be minimum or time based details. */
export type FinancialAccountStatementPayOffPayment = {
  __typename?: "FinancialAccountStatementPayOffPayment";
  /** Pay off Type to identity if pay off details are associated with Fixed minimum pay or Fixed three year pay. */
  payOffType?: Maybe<PayOffType>;
  /** Payment details for the consumer for define category. */
  paymentDetails?: Maybe<PayOffPaymentDetails>;
};

/** Warning for consumer to let them know about how much time it takes for them to pay statement balance and how additional payment they do with minimum or 36 months pay. */
export type FinancialAccountStatementPayOffWarning = {
  __typename?: "FinancialAccountStatementPayOffWarning";
  /** Minimum amount paid by the consumer. */
  paymentCycles?: Maybe<Array<FinancialAccountStatementPayOffPayment>>;
};

/** Financial Account Statement purchase credit Plan with details related to purchase interest charge and balance subject to interest. */
export type FinancialAccountStatementPurchaseCreditPlan =
  FinancialAccountStatementBalanceType & {
    __typename?: "FinancialAccountStatementPurchaseCreditPlan";
    /**
     * The interest rate (APR) for this `CreditPlan` for this statement, expressed as a `Float` with up to 3 digit precision after the decimal point.
     * If this `FinancialAccount` qualifies for a Servicemembers Civil Relief Act (SCRA) interest rate during this statement period, it will be reflected in this value.
     */
    apr?: Maybe<Scalars["Float"]>;
    /** Purchase balance for this `CreditPlan`, subject to the interest charge for specific credit plan' */
    balanceSubjectToInterestAmount?: Maybe<Amount>;
    /** Balance Type for the current statement */
    balanceType?: Maybe<BalanceType>;
    /** The `CreditPlan` associated with this statement. */
    creditPlan?: Maybe<CreditPlan>;
    /** For variable interest rates only. The current configuration of the index used to derive the variable APR. */
    index?: Maybe<Scalars["Float"]>;
    /** Period's purchase interest charge for this `CreditPlan`, subject to the interest charge for specific balance for specific credit plan type' */
    interestChargedAmount?: Maybe<Amount>;
    /** For variable interest rates only. The current configuration of the margin used to derive the variable APR. */
    margin?: Maybe<Scalars["Float"]>;
  };

/** The FinancialAccountStatementEvent notifies when a statement is ready. */
export type FinancialAccountStatementReadyEvent =
  FinancialAccountStatementEvent &
    Node & {
      __typename?: "FinancialAccountStatementReadyEvent";
      /** Account Id associated with this statement. */
      financialAccountId?: Maybe<Scalars["ID"]>;
      /** Id for statement which is ready. */
      id: Scalars["ID"];
    };

/** Interface for a FinancialAccountStatementSnapshot. */
export type FinancialAccountStatementSnapshot = {
  /**
   * The date and time, in ISO 8601 format, the snapshot was calculated.
   * Note that this will be the date/time of the last impactful event.
   */
  asOf?: Maybe<Scalars["String"]>;
  /** The current open statement */
  currentOpenStatement?: Maybe<FinancialAccountStatement>;
  /** The most recently closed statement */
  latestClosedStatement?: Maybe<FinancialAccountStatement>;
  /** The date and time, in ISO 8601 format, this was most recently updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/**
 * The status of a `FinancialAccount`.
 *
 * Depending on the `CardProduct` and `FinancialAccountFeature` of this account there may be restrictions placed on the account when the status is anything other than `ACTIVE`.
 *
 * For more information on `FinancialAccountStatuses` please check the developer documentation.
 */
export enum FinancialAccountStatus {
  /** The `FinancialAccount` is active and in good standing. */
  ACTIVE = "ACTIVE",
  /**
   * The Financial Account is Closed.
   *
   * This is a terminal state and cannot be reversed.
   */
  CLOSED = "CLOSED",
  /**
   * The `FinancialAccount` is pending closure and will be restricted until it is closed.
   *
   * Once a `FinancialAccount` is marked for closure, it cannot be reversed. A `PENDING_CLOSURE` account status may become `CLOSED` when the Issuer completes checks on the account.
   */
  PENDING_CLOSURE = "PENDING_CLOSURE",
  /**
   * The `FinancialAccount` is suspended and may have certain restrictions in effect.
   *
   * There may have been possible fraudulent activity associated with the `FinancialAccount`. The `AccountHolder` may need to contact customer support to resolve these issues prior to the `FinancialAccount` being reinstated.
   */
  SUSPENDED = "SUSPENDED",
  /**
   * The `FinancialAccount` is under review and may have certain restrictions in effect.
   *
   * There may have been possible fraudulent activity associated with the `FinancialAccount`. The `AccountHolder` may need to contact customer support to resolve these issues prior to the `FinancialAccount` being reinstated.
   */
  UNDER_REVIEW = "UNDER_REVIEW",
}

/** The reason input for suspending a `FinancialAccount`. */
export enum FinancialAccountSuspensionReasonInput {
  /** The `FinancialAccount` is being suspended due to account holder request. */
  ACCOUNT_HOLDER_REQUEST = "ACCOUNT_HOLDER_REQUEST",
  /** The `FinancialAccount` is being suspended due to account review. */
  ACCOUNT_REVIEW = "ACCOUNT_REVIEW",
  /** The `FinancialAccount` is being suspended due to related ACH transfer returns. */
  ACH_RETURNS = "ACH_RETURNS",
  /** The `FinancialAccount` is being suspended due to delinquency. */
  DELINQUENCY = "DELINQUENCY",
  /** The `FinancialAccount` is being suspended due to lost or stolen `PaymentCard`. */
  LOST_OR_STOLEN_CARD = "LOST_OR_STOLEN_CARD",
  /** The `FinancialAccount` is being suspended due to suspected fraud. */
  SUSPECTED_FRAUD = "SUSPECTED_FRAUD",
}

/** The financial event that the `LedgerEntry` results from. */
export type FinancialEvent =
  | AdjustmentEvent
  | AuthorizationAndClearEvent
  | AuthorizationEvent
  | CheckPaymentEvent
  | ClearingEvent
  | CreditCardTransferEvent
  | CreditFundsAchTransferEvent
  | DebitFundsAchTransferEvent
  | DisbursementTransferEvent
  | ExternalMoneyMovementTransactionEvent
  | ExternallyInitiatedAchReleaseHoldTransfer
  | FeeTransferEvent
  | FinancialAccountCreditLimitUpdateFromProductFunding
  | FinancialAccountPseudoBalanceUpdate
  | InstantNetworkTransferEvent
  | InstantSettlementTransactionEvent
  | IntegratorInitiatedFundsDepositAchTransferEvent
  | IntegratorInitiatedFundsWithdrawalAchTransferEvent
  | InterFinancialAccountTransfer
  | IssuerPreliminaryAuthorizationEvent
  | ManualAdjustmentEvent
  | PayrollAchTransferEvent
  | PayrollAdvanceRepaymentTransfer
  | PayrollAdvanceWriteoffTransfer
  | ReversalEvent
  | RewardPointsTransfer
  | SecureCardBalanceRepaymentAchTransferEvent
  | SecureDepositAchTransferEvent
  | SecureDepositTransferEvent
  | Transfer
  | WireTransfer;

/** The possible values of a financial event's name. */
export enum FinancialEventType {
  /** The name of a financial event representing ADJUST_FEE. */
  ADJUST_FEE = "ADJUST_FEE",
  /** The name of a financial event representing ADJUST_SETTLEMENT_AMOUNT. */
  ADJUST_SETTLEMENT_AMOUNT = "ADJUST_SETTLEMENT_AMOUNT",
  /** The name of a financial event representing ADJUST_TRANSACTION_AMOUNT. */
  ADJUST_TRANSACTION_AMOUNT = "ADJUST_TRANSACTION_AMOUNT",
  /** The name of a financial event representing AUTHORIZATION. */
  AUTHORIZATION = "AUTHORIZATION",
  /**
   * The name of a financial event representing AUTHORIZATION_AND_CLEAR_EVENT.
   * @deprecated Use AUTHORIZE_AND_CLEAR instead
   */
  AUTHORIZATION_AND_CLEAR_EVENT = "AUTHORIZATION_AND_CLEAR_EVENT",
  /**
   * The name of a financial event representing AUTHORIZATION_EVENT.
   * @deprecated Use AUTHORIZATION or AUTHORIZE instead
   */
  AUTHORIZATION_EVENT = "AUTHORIZATION_EVENT",
  /** The name of a financial event representing AUTHORIZE. */
  AUTHORIZE = "AUTHORIZE",
  /** The name of a financial event representing AUTHORIZE_AND_CLEAR. */
  AUTHORIZE_AND_CLEAR = "AUTHORIZE_AND_CLEAR",
  /** The name of a financial event representing CLEAR. */
  CLEAR = "CLEAR",
  /** The name of a financial event representing CLEARING. */
  CLEARING = "CLEARING",
  /**
   * The name of a financial event representing CLEARING_EVENT.
   * @deprecated Use CLEARING instead
   */
  CLEARING_EVENT = "CLEARING_EVENT",
  /** The name of a financial event representing CREDIT_CARD_TRANSFER. */
  CREDIT_CARD_TRANSFER = "CREDIT_CARD_TRANSFER",
  /**
   * The name of a financial event representing CREDIT_CARD_TRANSFER_EVENT.
   * @deprecated Use CREDIT_CARD_TRANSFER instead
   */
  CREDIT_CARD_TRANSFER_EVENT = "CREDIT_CARD_TRANSFER_EVENT",
  /** The name of a financial event representing CREDIT_FUNDS_ACH_TRANSFER. */
  CREDIT_FUNDS_ACH_TRANSFER = "CREDIT_FUNDS_ACH_TRANSFER",
  /**
   * The name of a financial event representing CREDIT_FUNDS_ACH_TRANSFER_EVENT.
   * @deprecated Use CREDIT_FUNDS_ACH_TRANSFER instead
   */
  CREDIT_FUNDS_ACH_TRANSFER_EVENT = "CREDIT_FUNDS_ACH_TRANSFER_EVENT",
  /** The name of a financial event representing DEBIT_FUNDS_ACH_TRANSFER. */
  DEBIT_FUNDS_ACH_TRANSFER = "DEBIT_FUNDS_ACH_TRANSFER",
  /**
   * The name of a financial event representing DEBIT_FUNDS_ACH_TRANSFER_EVENT.
   * @deprecated Use DEBIT_FUNDS_ACH_TRANSFER instead
   */
  DEBIT_FUNDS_ACH_TRANSFER_EVENT = "DEBIT_FUNDS_ACH_TRANSFER_EVENT",
  /** The name of a financial event representing DISBURSEMENT_TRANSFER. */
  DISBURSEMENT_TRANSFER = "DISBURSEMENT_TRANSFER",
  /**
   * The name of a financial event representing DISBURSEMENT_TRANSFER_EVENT.
   * @deprecated Use DISBURSEMENT_TRANSFER instead
   */
  DISBURSEMENT_TRANSFER_EVENT = "DISBURSEMENT_TRANSFER_EVENT",
  /** The name of a financial event representing EFT. */
  EFT = "EFT",
  /**
   * The name of a financial event representing EXTERNALLY_INITIATED_ACH_RELEASE_HOLD_TRANSFER.
   * @deprecated Use EXTERNAL_MONEY_MOVEMENT instead
   */
  EXTERNALLY_INITIATED_ACH_RELEASE_HOLD_TRANSFER = "EXTERNALLY_INITIATED_ACH_RELEASE_HOLD_TRANSFER",
  /** The name of a financial event representing EXTERNAL_MONEY_MOVEMENT. */
  EXTERNAL_MONEY_MOVEMENT = "EXTERNAL_MONEY_MOVEMENT",
  /**
   * The name of a financial event representing EXTERNAL_MONEY_MOVEMENT_TRANSACTION_EVENT.
   * @deprecated Use EXTERNAL_MONEY_MOVEMENT instead
   */
  EXTERNAL_MONEY_MOVEMENT_TRANSACTION_EVENT = "EXTERNAL_MONEY_MOVEMENT_TRANSACTION_EVENT",
  /** The name of a financial event representing FEE_TRANSFER. */
  FEE_TRANSFER = "FEE_TRANSFER",
  /**
   * The name of a financial event representing FEE_TRANSFER_EVENT.
   * @deprecated Use FEE_TRANSFER instead
   */
  FEE_TRANSFER_EVENT = "FEE_TRANSFER_EVENT",
  /**
   * The name of a financial event representing FINANCIAL_ACCOUNT_CREDIT_LIMIT_UPDATE_FROM_PRODUCT_FUNDING.
   * @deprecated No longer supported
   */
  FINANCIAL_ACCOUNT_CREDIT_LIMIT_UPDATE_FROM_PRODUCT_FUNDING = "FINANCIAL_ACCOUNT_CREDIT_LIMIT_UPDATE_FROM_PRODUCT_FUNDING",
  /**
   * The name of a financial event representing FINANCIAL_ACCOUNT_PSEUDO_BALANCE_UPDATE.
   * @deprecated No longer supported
   */
  FINANCIAL_ACCOUNT_PSEUDO_BALANCE_UPDATE = "FINANCIAL_ACCOUNT_PSEUDO_BALANCE_UPDATE",
  /** The name of a financial event representing INSTANT_NETWORK_TRANSFER. */
  INSTANT_NETWORK_TRANSFER = "INSTANT_NETWORK_TRANSFER",
  /** The name of a financial event representing INTEGRATOR_INITIATED_FUNDS_DEPOSIT_ACH_TRANSFER. */
  INTEGRATOR_INITIATED_FUNDS_DEPOSIT_ACH_TRANSFER = "INTEGRATOR_INITIATED_FUNDS_DEPOSIT_ACH_TRANSFER",
  /**
   * The name of a financial event representing INTEGRATOR_INITIATED_FUNDS_DEPOSIT_ACH_TRANSFER_EVENT.
   * @deprecated No longer supported
   */
  INTEGRATOR_INITIATED_FUNDS_DEPOSIT_ACH_TRANSFER_EVENT = "INTEGRATOR_INITIATED_FUNDS_DEPOSIT_ACH_TRANSFER_EVENT",
  /** The name of a financial event representing INTEGRATOR_INITIATED_FUNDS_WITHDRAWAL_ACH_TRANSFER. */
  INTEGRATOR_INITIATED_FUNDS_WITHDRAWAL_ACH_TRANSFER = "INTEGRATOR_INITIATED_FUNDS_WITHDRAWAL_ACH_TRANSFER",
  /**
   * The name of a financial event representing INTEGRATOR_INITIATED_FUNDS_WITHDRAWAL_ACH_TRANSFER_EVENT.
   * @deprecated No longer supported
   */
  INTEGRATOR_INITIATED_FUNDS_WITHDRAWAL_ACH_TRANSFER_EVENT = "INTEGRATOR_INITIATED_FUNDS_WITHDRAWAL_ACH_TRANSFER_EVENT",
  /** The name of a financial event representing INTER_FINANCIAL_ACCOUNT_TRANSFER. */
  INTER_FINANCIAL_ACCOUNT_TRANSFER = "INTER_FINANCIAL_ACCOUNT_TRANSFER",
  /**
   * The name of a financial event representing INTER_FINANCIAL_ACCOUNT_TRANSFER_EVENT.
   * @deprecated No longer supported
   */
  INTER_FINANCIAL_ACCOUNT_TRANSFER_EVENT = "INTER_FINANCIAL_ACCOUNT_TRANSFER_EVENT",
  /** The name of a financial event representing ISSUER_PRELIMINARY_AUTHORIZATION. */
  ISSUER_PRELIMINARY_AUTHORIZATION = "ISSUER_PRELIMINARY_AUTHORIZATION",
  /**
   * The name of a financial event representing ISSUER_PRELIMINARY_AUTHORIZATION_EVENT.
   * @deprecated No longer supported
   */
  ISSUER_PRELIMINARY_AUTHORIZATION_EVENT = "ISSUER_PRELIMINARY_AUTHORIZATION_EVENT",
  /**
   * The name of a financial event representing MANUAL_ADJUSTMENT_EVENT.
   * @deprecated Use MANUAL_RECONCILE instead
   */
  MANUAL_ADJUSTMENT_EVENT = "MANUAL_ADJUSTMENT_EVENT",
  /** The name of a financial event representing MANUAL_RECONCILE. */
  MANUAL_RECONCILE = "MANUAL_RECONCILE",
  /** The name of a financial event representing PAYROLL_ACH_TRANSFER. */
  PAYROLL_ACH_TRANSFER = "PAYROLL_ACH_TRANSFER",
  /**
   * The name of a financial event representing PAYROLL_ACH_TRANSFER_EVENT.
   * @deprecated Use PAYROLL_ACH_TRANSFER instead
   */
  PAYROLL_ACH_TRANSFER_EVENT = "PAYROLL_ACH_TRANSFER_EVENT",
  /**
   * The name of a financial event representing PAYROLL_ADVANCE_REPAYMENT_TRANSFER.
   * @deprecated Use PAYROLL_ACH_TRANSFER instead
   */
  PAYROLL_ADVANCE_REPAYMENT_TRANSFER = "PAYROLL_ADVANCE_REPAYMENT_TRANSFER",
  /**
   * The name of a financial event representing PAYROLL_ADVANCE_WRITEOFF_TRANSFER.
   * @deprecated Use PAYROLL_ACH_TRANSFER instead
   */
  PAYROLL_ADVANCE_WRITEOFF_TRANSFER = "PAYROLL_ADVANCE_WRITEOFF_TRANSFER",
  /** The name of a financial event representing RECONCILIATION_ACCOUNT_TRANSFER. */
  RECONCILIATION_ACCOUNT_TRANSFER = "RECONCILIATION_ACCOUNT_TRANSFER",
  /**
   * The name of a financial event representing REVERSAL_EVENT.
   * @deprecated Use REVERSAL instead
   */
  REVERSAL_EVENT = "REVERSAL_EVENT",
  /** The name of a financial event representing REVERSE. */
  REVERSE = "REVERSE",
  /** The name of a financial event representing REWARD_POINTS_TRANSFER. */
  REWARD_POINTS_TRANSFER = "REWARD_POINTS_TRANSFER",
  /** The name of a financial event representing SECURE_CARD_BALANCE_REPAYMENT_ACH_TRANSFER. */
  SECURE_CARD_BALANCE_REPAYMENT_ACH_TRANSFER = "SECURE_CARD_BALANCE_REPAYMENT_ACH_TRANSFER",
  /**
   * The name of a financial event representing SECURE_CARD_BALANCE_REPAYMENT_ACH_TRANSFER_EVENT.
   * @deprecated Use SECURE_CARD_BALANCE_REPAYMENT_ACH_TRANSFER instead
   */
  SECURE_CARD_BALANCE_REPAYMENT_ACH_TRANSFER_EVENT = "SECURE_CARD_BALANCE_REPAYMENT_ACH_TRANSFER_EVENT",
  /** The name of a financial event representing SECURE_DEPOSIT_ACH_TRANSFER. */
  SECURE_DEPOSIT_ACH_TRANSFER = "SECURE_DEPOSIT_ACH_TRANSFER",
  /**
   * The name of a financial event representing SECURE_DEPOSIT_ACH_TRANSFER_EVENT.
   * @deprecated Use SECURE_DEPOSIT_ACH_TRANSFER instead
   */
  SECURE_DEPOSIT_ACH_TRANSFER_EVENT = "SECURE_DEPOSIT_ACH_TRANSFER_EVENT",
  /** The name of a financial event representing SECURE_DEPOSIT_TRANSFER. */
  SECURE_DEPOSIT_TRANSFER = "SECURE_DEPOSIT_TRANSFER",
  /**
   * The name of a financial event representing SECURE_DEPOSIT_TRANSFER_EVENT.
   * @deprecated Use SECURE_DEPOSIT_TRANSFER instead
   */
  SECURE_DEPOSIT_TRANSFER_EVENT = "SECURE_DEPOSIT_TRANSFER_EVENT",
  /** The name of a financial event representing TRANSFER. */
  TRANSFER = "TRANSFER",
  /**
   * The name of a financial event representing WIRE_TRANSFER.
   * @deprecated Use TRANSFER instead
   */
  WIRE_TRANSFER = "WIRE_TRANSFER",
}

/** A single product/api-endpoint that Highnote can use to retrieve users' financial data. */
export type FinicityProduct = {
  /** A pseudo account ID that Highnote will use to retrieve data via Finicity's 3PA integration. */
  accountId: Scalars["ID"];
  /** A limit on how many times an api can be called. */
  callLimit: Scalars["Int"];
  /** A time range that an api can be accessed. */
  expirationDetail: ExpirationDetail;
  /** A specific product type represented by an api endpoint. */
  productType: FinicityProductType;
};

/** A specific product type represented by an api endpoint. */
export enum FinicityProductType {
  /** Retrieves a customer's ACH routing and account numbers. */
  ACH_DETAILS = "ACH_DETAILS",
  /** Retrieves the names and addresses of the account owner from a financial institution. */
  ACH_OWNER_DETAILS = "ACH_OWNER_DETAILS",
  /**
   * Retrieves the latest cached available and cleared account balances for a single customer account.
   * Faster than CURRENT_BALANCE.
   */
  APPROXIMATE_BALANCE = "APPROXIMATE_BALANCE",
  /** Retrieves a customer's up-to-date account balance. */
  CURRENT_BALANCE = "CURRENT_BALANCE",
}

/** Flat amount fee charge value. */
export type FixedFeeChargeValue = {
  __typename?: "FixedFeeChargeValue";
  /** The flat fee amount to be charged. */
  amount?: Maybe<Amount>;
};

/** Whether or not the Financial Account supports a Fleet Card. */
export type FleetCardAccountFeature = FinancialAccountFeature & {
  __typename?: "FleetCardAccountFeature";
  /** The date and time, in ISO 8601 format, the feature was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The credit limit on the `FleetCardAccountFeature` */
  creditLimit?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, the feature was effective from. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective through. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Whether or not the feature is enabled for the Financial Account. */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** The date and time, in ISO 8601 format, the feature was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Input for force capturing a payment transaction. */
export type ForceCapturePaymentTransactionInput = {
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /** The payment transaction to capture. */
  paymentTransactionId: Scalars["ID"];
};

/** Type of form factor */
export enum FormFactorType {
  /** Physical card */
  PHYSICAL_CARD = "PHYSICAL_CARD",
  /** Wristband */
  WRISTBAND = "WRISTBAND",
}

/** The percentage breakdown of forward comittments */
export type ForwardCommittmentBreakdown = {
  __typename?: "ForwardCommittmentBreakdown";
  /** The percentage of transactions that are shipped within 8-14 days of collecting payment */
  percentageOfTransactionEightToFourteenDays: Scalars["UnsignedInt"];
  /** The percentage of transactions that are shipped within 15-30 days of collecting payment */
  percentageOfTransactionFIfteenToThirtyDays: Scalars["UnsignedInt"];
  /** The percentage of transactions that are shipped more than 30 days past payment collection */
  percentageOfTransactionMoreThanThirtyDays: Scalars["UnsignedInt"];
  /** The percentage of transactions that are shipped within 0-7 days of collecting payment */
  percentageOfTransactionZeroToSevenDays: Scalars["UnsignedInt"];
};

/** The `FundsDepositCanceledEvent` notifies when `IntegratorInitiatedFundsDepositACHTransfer`s are canceled. */
export type FundsDepositCanceledEvent = Node & {
  __typename?: "FundsDepositCanceledEvent";
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The ID for Highnote. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /**
   * The name of the company that initiated the ACH transfer.
   *
   * This will always be Highnote.
   */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the account sending the funds. Will always be an `ExternalFinancialBankAccount`. */
  fromFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
  fundsAvailableDate?: Maybe<Scalars["String"]>;
  /** The ID of the transfer event. This `id` can be used to later retrieve details of this `FundsDepositCanceledEvent` or correlate it with other events on this `ElectronicFundsTransfer`. */
  id: Scalars["ID"];
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
  /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
  settlementDate?: Maybe<Scalars["String"]>;
  /** The ID of the account receiving the funds. Will always be a `FinancialBankAccount` */
  toFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The ID of the `IntegratorInitiatedFundsDepositACHTransfer` that triggered this event. */
  transactionId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The `FundsDepositFailedEvent` notifies when `IntegratorInitiatedFundsDepositACHTransfer`s have failed. */
export type FundsDepositFailedEvent = Node & {
  __typename?: "FundsDepositFailedEvent";
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The ID for Highnote. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /**
   * The name of the company that initiated the ACH transfer.
   *
   * This will always be Highnote.
   */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the account sending the funds. Will always be an `ExternalFinancialBankAccount`. */
  fromFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
  fundsAvailableDate?: Maybe<Scalars["String"]>;
  /** Additional details about why an Funds Deposit ACH Transfer failed. */
  fundsDepositACHReasonCode?: Maybe<IntegratorInitiatedAchStatusReasonCode>;
  /** The ID of the transfer event. This `id` can be used to later retrieve details of this `FundsDepositFailedEvent` or correlate it with other events on this `ElectronicFundsTransfer`. */
  id: Scalars["ID"];
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
  /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
  settlementDate?: Maybe<Scalars["String"]>;
  /** The ID of the account receiving the funds. Will always be a `FinancialBankAccount` */
  toFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The ID of the `IntegratorInitiatedFundsDepositACHTransfer` that triggered this event. */
  transactionId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The `FundsDepositInitiatedEvent` notifies when `IntegratorInitiatedFundsDepositACHTransfer`s are initiated. */
export type FundsDepositInitiatedEvent = Node & {
  __typename?: "FundsDepositInitiatedEvent";
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The ID for Highnote. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /**
   * The name of the company that initiated the ACH transfer.
   *
   * This will always be Highnote.
   */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the account sending the funds. Will always be an `ExternalFinancialBankAccount`. */
  fromFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
  fundsAvailableDate?: Maybe<Scalars["String"]>;
  /** The ID of the transfer event. This `id` can be used to later retrieve details of this `FundsDepositInitiatedEvent` or correlate it with other events on this `ElectronicFundsTransfer`. */
  id: Scalars["ID"];
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
  /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
  settlementDate?: Maybe<Scalars["String"]>;
  /** The ID of the account receiving the funds. Will always be a `FinancialBankAccount` */
  toFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The ID of the `IntegratorInitiatedFundsDepositACHTransfer` that triggered this event. */
  transactionId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The `FundsDepositProcessedEvent` notifies when `IntegratorInitiatedFundsDepositACHTransfer`s are processed. */
export type FundsDepositProcessedEvent = Node & {
  __typename?: "FundsDepositProcessedEvent";
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The ID for Highnote. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /**
   * The name of the company that initiated the ACH transfer.
   *
   * This will always be Highnote.
   */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the account sending the funds. Will always be an `ExternalFinancialBankAccount`. */
  fromFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
  fundsAvailableDate?: Maybe<Scalars["String"]>;
  /** The ID of the transfer event. This `id` can be used to later retrieve details of this `FundsDepositProcessedEvent` or correlate it with other events on this `ElectronicFundsTransfer`. */
  id: Scalars["ID"];
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
  /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
  settlementDate?: Maybe<Scalars["String"]>;
  /** The ID of the account receiving the funds. Will always be a `FinancialBankAccount` */
  toFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The ID of the `IntegratorInitiatedFundsDepositACHTransfer` that triggered this event. */
  transactionId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The `FundsDepositProcessingEvent` notifies when `IntegratorInitiatedFundsDepositACHTransfer`s are processing. */
export type FundsDepositProcessingEvent = Node & {
  __typename?: "FundsDepositProcessingEvent";
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The ID for Highnote. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /**
   * The name of the company that initiated the ACH transfer.
   *
   * This will always be Highnote.
   */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the account sending the funds. Will always be an `ExternalFinancialBankAccount`. */
  fromFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
  fundsAvailableDate?: Maybe<Scalars["String"]>;
  /** The ID of the transfer event. This `id` can be used to later retrieve details of this `FundsDepositProcessingEvent` or correlate it with other events on this `ElectronicFundsTransfer`. */
  id: Scalars["ID"];
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
  /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
  settlementDate?: Maybe<Scalars["String"]>;
  /** The ID of the account receiving the funds. Will always be a `FinancialBankAccount` */
  toFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The ID of the `IntegratorInitiatedFundsDepositACHTransfer` that triggered this event. */
  transactionId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The `FundsDepositReturnedEvent` notifies when `IntegratorInitiatedFundsDepositACHTransfer`s are returned. */
export type FundsDepositReturnedEvent = Node & {
  __typename?: "FundsDepositReturnedEvent";
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The ID for Highnote. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /**
   * The name of the company that initiated the ACH transfer.
   *
   * This will always be Highnote.
   */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the account sending the funds. Will always be an `ExternalFinancialBankAccount`. */
  fromFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
  fundsAvailableDate?: Maybe<Scalars["String"]>;
  /** Additional details about why an Funds Deposit ACH Transfer failed. */
  fundsDepositACHReasonCode?: Maybe<IntegratorInitiatedAchStatusReasonCode>;
  /** The ID of the transfer event. This `id` can be used to later retrieve details of this `FundsDepositReturnedEvent` or correlate it with other events on this `ElectronicFundsTransfer`. */
  id: Scalars["ID"];
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
  /** The date this transaction was returned, in ISO 8601 format. */
  returnDate?: Maybe<Scalars["String"]>;
  /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
  settlementDate?: Maybe<Scalars["String"]>;
  /** The ID of the account receiving the funds. Will always be a `FinancialBankAccount` */
  toFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The ID of the `IntegratorInitiatedFundsDepositACHTransfer` that triggered this event. */
  transactionId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The `FundsWithdrawalCanceledEvent` notifies when `IntegratorInitiatedFundsWithdrawalACHTransfer`s are canceled. */
export type FundsWithdrawalCanceledEvent = Node & {
  __typename?: "FundsWithdrawalCanceledEvent";
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The ID for Highnote. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /**
   * The name of the company that initiated the ACH transfer.
   *
   * This will always be Highnote.
   */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the account sending the funds. Will always be a `FinancialAccount`. */
  fromFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
  fundsAvailableDate?: Maybe<Scalars["String"]>;
  /** The ID of the transfer event. This `id` can be used to later retrieve details of this `FundsWithdrawalCanceledEvent` or correlate it with other events on this `ElectronicFundsTransfer`. */
  id: Scalars["ID"];
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
  /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
  settlementDate?: Maybe<Scalars["String"]>;
  /** The ID of the account receiving the funds. Will always be an `ExternalFinancialBankAccount` */
  toFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The ID of the `IntegratorInitiatedFundsWithdrawalACHTransfer` that triggered this event. */
  transactionId?: Maybe<Scalars["ID"]>;
  /**
   * The status of the ACH transfer.
   * @deprecated transfer status only needed for failed or returned events
   */
  transferStatus?: Maybe<AchTransferStatusDetails>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The `FundsWithdrawalFailedEvent` notifies when `IntegratorInitiatedFundsWithdrawalACHTransfer`s have failed. */
export type FundsWithdrawalFailedEvent = Node & {
  __typename?: "FundsWithdrawalFailedEvent";
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The ID for Highnote. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /**
   * The name of the company that initiated the ACH transfer.
   *
   * This will always be Highnote.
   */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the account sending the funds. Will always be a `FinancialAccount`. */
  fromFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
  fundsAvailableDate?: Maybe<Scalars["String"]>;
  /** Additional details about why an Funds Withdrawal ACH Transfer failed. */
  fundsWithdrawalACHReasonCode?: Maybe<IntegratorInitiatedAchStatusReasonCode>;
  /** The ID of the transfer event. This `id` can be used to later retrieve details of this `FundsWithdrawalFailedEvent` or correlate it with other events on this `ElectronicFundsTransfer`. */
  id: Scalars["ID"];
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
  /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
  settlementDate?: Maybe<Scalars["String"]>;
  /** The ID of the account receiving the funds. Will always be an `ExternalFinancialBankAccount` */
  toFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The ID of the `IntegratorInitiatedFundsWithdrawalACHTransfer` that triggered this event. */
  transactionId?: Maybe<Scalars["ID"]>;
  /**
   * The status of the ACH transfer.
   * @deprecated use fundsWithdrawalACHReasonCode instead
   */
  transferStatus?: Maybe<AchTransferStatusDetails>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The `FundsWithdrawalInitiatedEvent` notifies when `IntegratorInitiatedFundsWithdrawalACHTransfer`s are initiated. */
export type FundsWithdrawalInitiatedEvent = Node & {
  __typename?: "FundsWithdrawalInitiatedEvent";
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The ID for Highnote. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /**
   * The name of the company that initiated the ACH transfer.
   *
   * This will always be Highnote.
   */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the account sending the funds. Will always be a `FinancialAccount`. */
  fromFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
  fundsAvailableDate?: Maybe<Scalars["String"]>;
  /** The ID of the transfer event. This `id` can be used to later retrieve details of this `FundsWithdrawalInitiatedEvent` or correlate it with other events on this `ElectronicFundsTransfer`. */
  id: Scalars["ID"];
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
  /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
  settlementDate?: Maybe<Scalars["String"]>;
  /** The ID of the account receiving the funds. Will always be an `ExternalFinancialBankAccount` */
  toFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The ID of the `IntegratorInitiatedFundsWithdrawalACHTransfer` that triggered this event. */
  transactionId?: Maybe<Scalars["ID"]>;
  /**
   * The status of the ACH transfer.
   * @deprecated transfer status only needed for failed or returned events
   */
  transferStatus?: Maybe<AchTransferStatusDetails>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The `FundsWithdrawalProcessedEvent` notifies when `IntegratorInitiatedFundsWithdrawalACHTransfer`s are processed. */
export type FundsWithdrawalProcessedEvent = Node & {
  __typename?: "FundsWithdrawalProcessedEvent";
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The ID for Highnote. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /**
   * The name of the company that initiated the ACH transfer.
   *
   * This will always be Highnote.
   */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the account sending the funds. Will always be a `FinancialAccount`. */
  fromFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
  fundsAvailableDate?: Maybe<Scalars["String"]>;
  /** The ID of the transfer event. This `id` can be used to later retrieve details of this `FundsWithdrawalProcessedEvent` or correlate it with other events on this `ElectronicFundsTransfer`. */
  id: Scalars["ID"];
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
  /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
  settlementDate?: Maybe<Scalars["String"]>;
  /** The ID of the account receiving the funds. Will always be an `ExternalFinancialBankAccount` */
  toFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The ID of the `IntegratorInitiatedFundsWithdrawalACHTransfer` that triggered this event. */
  transactionId?: Maybe<Scalars["ID"]>;
  /**
   * The status of the ACH transfer.
   * @deprecated transfer status only needed for failed or returned events
   */
  transferStatus?: Maybe<AchTransferStatusDetails>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The `FundsWithdrawalProcessingEvent` notifies when `IntegratorInitiatedFundsWithdrawalACHTransfer`s are processing. */
export type FundsWithdrawalProcessingEvent = Node & {
  __typename?: "FundsWithdrawalProcessingEvent";
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The ID for Highnote. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /**
   * The name of the company that initiated the ACH transfer.
   *
   * This will always be Highnote.
   */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the account sending the funds. Will always be a `FinancialAccount`. */
  fromFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
  fundsAvailableDate?: Maybe<Scalars["String"]>;
  /** The ID of the transfer event. This `id` can be used to later retrieve details of this `FundsWithdrawalProcessingEvent` or correlate it with other events on this `ElectronicFundsTransfer`. */
  id: Scalars["ID"];
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
  /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
  settlementDate?: Maybe<Scalars["String"]>;
  /** The ID of the account receiving the funds. Will always be an `ExternalFinancialBankAccount` */
  toFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The ID of the `IntegratorInitiatedFundsWithdrawalACHTransfer` that triggered this event. */
  transactionId?: Maybe<Scalars["ID"]>;
  /**
   * The status of the ACH transfer.
   * @deprecated transfer status only needed for failed or returned events
   */
  transferStatus?: Maybe<AchTransferStatusDetails>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The `FundsWithdrawalReturnedEvent` notifies when `IntegratorInitiatedFundsWithdrawalACHTransfer`s are returned. */
export type FundsWithdrawalReturnedEvent = Node & {
  __typename?: "FundsWithdrawalReturnedEvent";
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The ID for Highnote. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /**
   * The name of the company that initiated the ACH transfer.
   *
   * This will always be Highnote.
   */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the account sending the funds. Will always be a `FinancialAccount`. */
  fromFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
  fundsAvailableDate?: Maybe<Scalars["String"]>;
  /** Additional details about why an Funds Withdrawal ACH Transfer failed. */
  fundsWithdrawalACHReasonCode?: Maybe<IntegratorInitiatedAchStatusReasonCode>;
  /** The ID of the transfer event. This `id` can be used to later retrieve details of this `FundsWithdrawalReturnedEvent` or correlate it with other events on this `ElectronicFundsTransfer`. */
  id: Scalars["ID"];
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
  /** The date this transaction was returned, in ISO 8601 format. */
  returnDate?: Maybe<Scalars["String"]>;
  /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
  settlementDate?: Maybe<Scalars["String"]>;
  /** The ID of the account receiving the funds. Will always be an `ExternalFinancialBankAccount` */
  toFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The ID of the `IntegratorInitiatedFundsWithdrawalACHTransfer` that triggered this event. */
  transactionId?: Maybe<Scalars["ID"]>;
  /**
   * The status of the ACH transfer.
   * @deprecated use fundsWithdrawalACHReasonCode instead
   */
  transferStatus?: Maybe<AchTransferStatusDetails>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Input for generating an Apple Pay Web Push Provisioning token. */
export type GenerateAppleWebPushProvisioningTokenInput = {
  /** The ID of the payment card for Apple Pay provisioning. */
  paymentCardId: Scalars["ID"];
};

/** The possible return types from `generateAppleWebPushProvisioningToken`. */
export type GenerateAppleWebPushProvisioningTokenPayload =
  | AccessDeniedError
  | AppleWebPushProvisioningToken
  | UserError;

/** Input for creating a Business Account Holder Client Token. */
export type GenerateBusinessAccountHolderClientTokenInput = {
  /** The global ID of the Business Account holder for this token. */
  accountHolderId: Scalars["ID"];
  /** Specify permissions for this token. */
  permissions: Array<BusinessAccountHolderClientTokenPermission>;
};

/** The possible return types of `generateBusinessAccountHolderClientToken` */
export type GenerateBusinessAccountHolderClientTokenPayload =
  | AccessDeniedError
  | ClientToken
  | UserError;

/** Input for creating a Scheduled Transfer Client Token. */
export type GenerateCreateScheduledTransferClientTokenInput = {
  /**
   * The global ID of financial account.
   *
   * This must be an external financial account.
   */
  fromFinancialAccountId: Scalars["ID"];
  /** Specify permissions for this token. */
  permissions: Array<CreateScheduledTransferClientTokenPermission>;
  /**
   * The global ID of financial account.
   *
   * This must be an internal financial account.
   */
  toFinancialAccountId: Scalars["ID"];
};

/** The possible return types of `generateCreateScheduledTransferClientToken` */
export type GenerateCreateScheduledTransferClientTokenPayload =
  | AccessDeniedError
  | ClientToken
  | UserError;

/** Input for creating a Direct Deposit Detail Client Token. */
export type GenerateDirectDepositDetailClientTokenInput = {
  /** The global ID of the Direct Deposit Detail for this token. */
  directDepositDetailId: Scalars["ID"];
  /** Specify permissions for this token. */
  permissions: Array<DirectDepositDetailClientTokenPermission>;
};

/** The possible return types of `generateDirectDepositDetailClientToken` */
export type GenerateDirectDepositDetailClientTokenPayload =
  | AccessDeniedError
  | ClientToken
  | UserError;

/** Input for creating a Document Upload Client Token. */
export type GenerateDocumentUploadClientTokenInput = {
  /** The global ID of the Document Upload Session for this token. */
  documentUploadSessionId: Scalars["ID"];
  /** Specify permissions for this token. */
  permissions: Array<DocumentUploadClientTokenPermission>;
};

/** The possible return types of `generateDocumentUploadClientToken` */
export type GenerateDocumentUploadClientTokenPayload =
  | AccessDeniedError
  | ClientToken
  | UserError;

/** Input for creating a Direct Deposit Detail Client Token. */
export type GenerateExternalBankAccountDetailClientTokenInput = {
  /** The global ID of the Direct Deposit Detail for this token. */
  externalBankAccountDetailId: Scalars["ID"];
  /** Specify permissions for this token. */
  permissions: Array<ExternalBankAccountDetailClientTokenPermission>;
};

/** The possible return types of `generateDirectDepositDetailClientToken` */
export type GenerateExternalBankAccountDetailClientTokenPayload =
  | AccessDeniedError
  | ClientToken
  | UserError;

/** Details for creating a Single Use Client Token for a Financial Account */
export type GenerateFinancialAccountSingleUseClientTokenInput = {
  /** The ID of the financial account. */
  financialAccountId: Scalars["ID"];
  /** A set of permissions to be included on the client token. */
  permissions: Array<GenerateFinancialAccountSingleUseClientTokenPermission>;
  /**
   * An optional arbitrary identifier to be passed to ensure the client token can only be used once.
   *
   * If not provided, Highnote will generate the nonce on behalf of the integrator.
   *
   * The `singleUseToken` can be any valid ASCII character and cannot exceed 255 characters.
   */
  singleUseToken?: InputMaybe<Scalars["String"]>;
};

/** The possible return types of `generateFinancialAccountSingleUseClientToken` */
export type GenerateFinancialAccountSingleUseClientTokenPayload =
  | AccessDeniedError
  | ClientToken
  | UserError;

/** Permissions for `generateFinancialAccountSingleUseClientToken` */
export enum GenerateFinancialAccountSingleUseClientTokenPermission {
  /** Allows issuing a payment card for a financial account */
  ISSUE_PAYMENT_CARD = "ISSUE_PAYMENT_CARD",
}

/** Input for creating a Secure Deposit Client Token. */
export type GenerateInitiateSecureDepositClientTokenInput = {
  /**
   * The global ID of financial account.
   *
   * This must be an external financial account.
   */
  fromFinancialAccountId: Scalars["ID"];
  /** Specify permissions for this token. */
  permissions: Array<InitiateSecureDepositClientTokenPermission>;
  /**
   * The global ID of financial account.
   *
   * This must be an internal financial account.
   */
  toFinancialAccountId: Scalars["ID"];
};

/** The possible return types of `generateInitiateSecureDepositClientToken` */
export type GenerateInitiateSecureDepositClientTokenPayload =
  | AccessDeniedError
  | ClientToken
  | UserError;

/** Input for creating a Payment Card Client Token. */
export type GeneratePaymentCardClientTokenInput = {
  /** The global ID of the Payment Card for this token. */
  paymentCardId: Scalars["ID"];
  /** Specify permissions for this token. */
  permissions: Array<PaymentCardClientTokenPermission>;
};

/** The possible return types of `generatePaymentCardClientToken` */
export type GeneratePaymentCardClientTokenPayload =
  | AccessDeniedError
  | ClientToken
  | UserError;

/** Input to generate a client token for payment method tokenization */
export type GeneratePaymentMethodTokenizationClientTokenInput = {
  /** Requested permissions for the `GeneratePaymentMethodTokenizationClientToken` */
  permissions: Array<GeneratePaymentMethodTokenizationClientTokenPermission>;
};

/** The possible return types of `generatePaymentMethodTokenizationClientToken` */
export type GeneratePaymentMethodTokenizationClientTokenPayload =
  | AccessDeniedError
  | ClientToken
  | UserError;

/** Permissions for generating a `PaymentMethodTokenizationClientToken`. */
export enum GeneratePaymentMethodTokenizationClientTokenPermission {
  /** Setting this permission will enable the tokenization of a payment method via the Secure Inputs SDK. */
  TOKENIZE_PAYMENT_METHOD = "TOKENIZE_PAYMENT_METHOD",
}

/** Input for creating a Person Account Holder Client Token. */
export type GeneratePersonAccountHolderClientTokenInput = {
  /** The global ID of the Person Account holder for this token. */
  accountHolderId: Scalars["ID"];
  /** Specify permissions for this token. */
  permissions: Array<PersonAccountHolderClientTokenPermission>;
};

/** The possible return types of `generatePersonAccountHolderClientToken` */
export type GeneratePersonAccountHolderClientTokenPayload =
  | AccessDeniedError
  | ClientToken
  | UserError;

/** Input for creating a Person Authorized User Client Token. */
export type GeneratePersonAuthorizedUserClientTokenInput = {
  /** The global ID of the Person Authorized User for this token. */
  authorizedUserId: Scalars["ID"];
  /** Specify permissions for this token. */
  permissions: Array<PersonAuthorizedUserClientTokenPermission>;
};

/** The possible return types of `generatePersonAuthorizedUserClientToken` */
export type GeneratePersonAuthorizedUserClientTokenPayload =
  | AccessDeniedError
  | ClientToken
  | UserError;

/** The possible return types from `generateRiskApplicationSDKSessionToken`. */
export type GenerateRiskApplicationSdkSessionTokenPayload =
  | AccessDeniedError
  | RiskApplicationSdkSessionToken
  | UserError;

/** Details for creating a `ClientToken` for `generateRiskClientToken` */
export type GenerateRiskClientTokenInput = {
  /** The session id to correlate with a token. */
  sessionId: Scalars["String"];
};

/** The possible return types from `generateRiskClientToken`. */
export type GenerateRiskClientTokenPayload =
  | AccessDeniedError
  | ClientToken
  | UserError;

/** Input for a Scheduled Transfer Client Token. */
export type GenerateScheduledTransferClientTokenInput = {
  /** Specify permissions for this token. */
  permissions: Array<ScheduledTransferClientTokenPermission>;
  /** The global ID of the secure deposit transfer. */
  scheduledTransferId: Scalars["ID"];
};

/** Input for creating a Secure Deposit Client Token. */
export type GenerateSecureDepositClientTokenInput = {
  /** Specify permissions for this token. */
  permissions: Array<SecureDepositClientTokenPermission>;
  /** The global ID of the secure deposit transfer. */
  transactionId: Scalars["ID"];
};

/** The possible return types of `generateSecureDepositClientToken` */
export type GenerateSecureDepositClientTokenPayload =
  | AccessDeniedError
  | ClientToken
  | UserError;

/** The possible return types of `generateTokenizeAccountHolderClientToken` */
export type GenerateTokenizeAccountHolderClientTokenPayload =
  | AccessDeniedError
  | ClientToken
  | UserError;

/** The possible return types of `generateTokenizeAuthorizedUserClientToken` */
export type GenerateTokenizeAuthorizedUserClientTokenPayload =
  | AccessDeniedError
  | ClientToken
  | UserError;

/** The details of the link token from the third-party provider. */
export type GenerateVerifiedExternalBankAccountExternalLinkToken = {
  __typename?: "GenerateVerifiedExternalBankAccountExternalLinkToken";
  /** The account holder for whom bank account is linked. */
  accountHolder?: Maybe<AccountHolder>;
  /** The expiration date for the token in ISO 8601 format. */
  expirationDate?: Maybe<Scalars["String"]>;
  /** The hosted URL generated by the third-party provider. */
  externalLinkHostedUrl?: Maybe<Scalars["String"]>;
  /** The link token generated by the third-party provider. */
  externalLinkToken?: Maybe<Scalars["String"]>;
};

/** Input for retrieving a link token. */
export type GenerateVerifiedExternalBankAccountLinkTokenInput = {
  /** The global ID of the Person Account holder for this token. */
  accountHolderId: Scalars["ID"];
  /** Optional link experience configuration. Highnote will default the integration to WEB_SDK if it is not provided. */
  linkExperience?: InputMaybe<VerifiedExternalBankAccountLinkExperience>;
};

export type GenerateVerifiedExternalBankAccountLinkTokenPayload =
  | AccessDeniedError
  | GenerateVerifiedExternalBankAccountExternalLinkToken
  | UserError;

/** A `GlobalNote` */
export type GlobalNote = {
  __typename?: "GlobalNote";
  /** The aggregate entity for the `GlobalNote`. */
  aggregateEntity?: Maybe<GlobalNoteAggregateEntity>;
  /** The date and time, in ISO 8601 format, the `GlobalNote` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The user who added this `GlobalNote`. */
  createdBy?: Maybe<User>;
  /** The ID used to reference the `GlobalNote` in operations. */
  id: Scalars["ID"];
  /** The message of the `GlobalNote`. */
  message: Scalars["String"];
  /** The primary entity for the `GlobalNote`. */
  primaryEntity?: Maybe<GlobalNotePrimaryEntity>;
};

/** The potential types for a `GlobalNote` aggregate entity */
export type GlobalNoteAggregateEntity =
  | UsBusinessAccountHolder
  | UsPersonAccountHolder;

/** The input details for a aggregate entity of a `GlobalNote`. */
export type GlobalNoteAggregateEntityInput = {
  /** The aggregate entity id for the `GlobalNote`. You can use this ID to group notes together that do not have the same primaryEntityId. */
  aggregateEntityId?: InputMaybe<Scalars["ID"]>;
  /** The aggregate entity type for the `GlobalNote`. */
  aggregateEntityType?: InputMaybe<GlobalNoteAggregateEntityType>;
};

/** The allowable aggregate entities for creating a `GlobalNote`. */
export enum GlobalNoteAggregateEntityType {
  /** The account holder aggregate type. When using this type you can resolve all global notes on the `AccountHolder`. */
  ACCOUNT_HOLDER = "ACCOUNT_HOLDER",
}

/** The connection object for a `GlobalNote` */
export type GlobalNoteConnection = {
  __typename?: "GlobalNoteConnection";
  /** A list of edges. */
  edges?: Maybe<Array<GlobalNoteEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

export type GlobalNoteConnectionPayload =
  | AccessDeniedError
  | GlobalNoteConnection
  | UserError;

/** The edge object for a `GlobalNote` */
export type GlobalNoteEdge = {
  __typename?: "GlobalNoteEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The global note. */
  node?: Maybe<GlobalNote>;
};

/** The return types when creating a `GlobalNote`. */
export type GlobalNotePayload = AccessDeniedError | GlobalNote | UserError;

/** The potential types for a `GlobalNote` primary entity. */
export type GlobalNotePrimaryEntity =
  | AccountHolderCardProductApplication
  | FinancialAccount;

/** The input details for a primary entity of a `GlobalNote`. */
export type GlobalNotePrimaryEntityInput = {
  /** The primary entity id for the `GlobalNote`. */
  primaryEntityId: Scalars["ID"];
  /** The primary entity type for the `GlobalNote`. */
  primaryEntityType: GlobalNotePrimaryEntityType;
};

/** The allowable primary entities for creating a `GlobalNote`. */
export enum GlobalNotePrimaryEntityType {
  /** The account holder card product application primary type. When using this type you can resolve global notes on the `AccountHolderCardProductApplication` object. */
  ACCOUNT_HOLDER_CARD_PRODUCT_APPLICATION = "ACCOUNT_HOLDER_CARD_PRODUCT_APPLICATION",
  /** The financial account primary type. When using this type you can resolve global notes on the `FinancialAccount` object. */
  FINANCIAL_ACCOUNT = "FINANCIAL_ACCOUNT",
}

/** Input for filtering by sensitive data using Hashing */
export type HashedFilterInput = {
  /** Value matches the provided data */
  equals?: InputMaybe<Scalars["String"]>;
  /** Value does not match any of the provided data */
  excludes?: InputMaybe<Array<Scalars["String"]>>;
  /** Value exactly matches all of the provided data */
  includes?: InputMaybe<Array<Scalars["String"]>>;
  /** Value does not match the provided data */
  notEquals?: InputMaybe<Scalars["String"]>;
};

/**
 * ID value type
 * Input for filtering objects using id (ID).
 */
export type IdFilterInput = {
  /** Value matches the provided object id. */
  equals?: InputMaybe<Scalars["ID"]>;
  /** Value does not match any of the provided object id. */
  excludes?: InputMaybe<Array<Scalars["ID"]>>;
  /** Value exactly matches any of the provided object id. */
  includes?: InputMaybe<Array<Scalars["ID"]>>;
  /** Value does not match the provided object id. */
  notEquals?: InputMaybe<Scalars["ID"]>;
};

/** IP address details. */
export type IpAddress = {
  __typename?: "IPAddress";
  /** The IPv4 address of the consenting party at the time they accepted the agreement. */
  v4?: Maybe<Scalars["String"]>;
  /** The IPv6 address. The IPv6 address provided should be the IP address of your customer and not your hosted server. */
  v6?: Maybe<Scalars["String"]>;
};

/** Input fields for IP address details. */
export type IpAddressInput = {
  /** By providing the IPv4 address, Highnote can provide higher confidence during identity verification of the account holder. The IPv4 address provided should be the IP address of your customer and not your hosted server. */
  v4?: InputMaybe<Scalars["String"]>;
  /** By providing the IPv6 address, Highnote can provide higher confidence during identity verification of the account holder. The IPv6 address provided should be the IP address of your customer and not your hosted server. */
  v6?: InputMaybe<Scalars["String"]>;
};

/**
 * The three character alpha codes for support countries.
 *
 * See [ISO 3166](https://www.iso.org/iso-3166-country-codes.html)
 */
export enum Iso3166Alpha3Country {
  /** The country code for Aruba. */
  ABW = "ABW",
  /** The country code for Afghanistan. */
  AFG = "AFG",
  /** The country code for Angola. */
  AGO = "AGO",
  /** The country code for Anguilla. */
  AIA = "AIA",
  /** The country code for Åland Islands. */
  ALA = "ALA",
  /** The country code for Albania. */
  ALB = "ALB",
  /** The country code for Andorra. */
  AND = "AND",
  /** The country code for United Arab Emirates. */
  ARE = "ARE",
  /** The country code for Argentina. */
  ARG = "ARG",
  /** The country code for Armenia. */
  ARM = "ARM",
  /** The country code for American Samoa. */
  ASM = "ASM",
  /** The country code for Antarctica. */
  ATA = "ATA",
  /** The country code for French Southern Territories. */
  ATF = "ATF",
  /** The country code for Antigua and Barbuda. */
  ATG = "ATG",
  /** The country code for Australia. */
  AUS = "AUS",
  /** The country code for Austria. */
  AUT = "AUT",
  /** The country code for Azerbaijan. */
  AZE = "AZE",
  /** The country code for Burundi. */
  BDI = "BDI",
  /** The country code for Belgium. */
  BEL = "BEL",
  /** The country code for Benin. */
  BEN = "BEN",
  /** The country code for "Bonaire, Sint Eustatius and Saba". */
  BES = "BES",
  /** The country code for Burkina Faso. */
  BFA = "BFA",
  /** The country code for Bangladesh. */
  BGD = "BGD",
  /** The country code for Bulgaria. */
  BGR = "BGR",
  /** The country code for Bahrain. */
  BHR = "BHR",
  /** The country code for Bahamas. */
  BHS = "BHS",
  /** The country code for Bosnia and Herzegovina. */
  BIH = "BIH",
  /** The country code for Saint Barthélemy. */
  BLM = "BLM",
  /** The country code for Belarus. */
  BLR = "BLR",
  /** The country code for Belize. */
  BLZ = "BLZ",
  /** The country code for Bermuda. */
  BMU = "BMU",
  /** The country code for Bolivia (Plurinational State of). */
  BOL = "BOL",
  /** The country code for Brazil. */
  BRA = "BRA",
  /** The country code for Barbados. */
  BRB = "BRB",
  /** The country code for Brunei Darussalam. */
  BRN = "BRN",
  /** The country code for Bhutan. */
  BTN = "BTN",
  /** The country code for Bouvet Island. */
  BVT = "BVT",
  /** The country code for Botswana. */
  BWA = "BWA",
  /** The country code for Central African Republic. */
  CAF = "CAF",
  /** The country code for Canada. */
  CAN = "CAN",
  /** The country code for Cocos (Keeling) Islands. */
  CCK = "CCK",
  /** The country code for Switzerland. */
  CHE = "CHE",
  /** The country code for Chile. */
  CHL = "CHL",
  /** The country code for China. */
  CHN = "CHN",
  /** The country code for Côte d'Ivoire. */
  CIV = "CIV",
  /** The country code for Cameroon. */
  CMR = "CMR",
  /** The country code for "Congo, Democratic Republic of the". */
  COD = "COD",
  /** The country code for Congo. */
  COG = "COG",
  /** The country code for Cook Islands. */
  COK = "COK",
  /** The country code for Colombia. */
  COL = "COL",
  /** The country code for Comoros. */
  COM = "COM",
  /** The country code for Cabo Verde. */
  CPV = "CPV",
  /** The country code for Costa Rica. */
  CRI = "CRI",
  /** The country code for Cuba. */
  CUB = "CUB",
  /** The country code for Curaçao. */
  CUW = "CUW",
  /** The country code for Christmas Island. */
  CXR = "CXR",
  /** The country code for Cayman Islands. */
  CYM = "CYM",
  /** The country code for Cyprus. */
  CYP = "CYP",
  /** The country code for Czechia. */
  CZE = "CZE",
  /** The country code for Germany. */
  DEU = "DEU",
  /** The country code for Djibouti. */
  DJI = "DJI",
  /** The country code for Dominica. */
  DMA = "DMA",
  /** The country code for Denmark. */
  DNK = "DNK",
  /** The country code for Dominican Republic. */
  DOM = "DOM",
  /** The country code for Algeria. */
  DZA = "DZA",
  /** The country code for Ecuador. */
  ECU = "ECU",
  /** The country code for Egypt. */
  EGY = "EGY",
  /** The country code for Eritrea. */
  ERI = "ERI",
  /** The country code for Western Sahara. */
  ESH = "ESH",
  /** The country code for Spain. */
  ESP = "ESP",
  /** The country code for Estonia. */
  EST = "EST",
  /** The country code for Ethiopia. */
  ETH = "ETH",
  /** The country code for Finland. */
  FIN = "FIN",
  /** The country code for Fiji. */
  FJI = "FJI",
  /** The country code for Falkland Islands (Malvinas). */
  FLK = "FLK",
  /** The country code for France. */
  FRA = "FRA",
  /** The country code for Faroe Islands. */
  FRO = "FRO",
  /** The country code for Micronesia (Federated States of). */
  FSM = "FSM",
  /** The country code for Gabon. */
  GAB = "GAB",
  /** The country code for United Kingdom of Great Britain and Northern Ireland. */
  GBR = "GBR",
  /** The country code for Georgia. */
  GEO = "GEO",
  /** The country code for Guernsey. */
  GGY = "GGY",
  /** The country code for Ghana. */
  GHA = "GHA",
  /** The country code for Gibraltar. */
  GIB = "GIB",
  /** The country code for Guinea. */
  GIN = "GIN",
  /** The country code for Guadeloupe. */
  GLP = "GLP",
  /** The country code for Gambia. */
  GMB = "GMB",
  /** The country code for Guinea-Bissau. */
  GNB = "GNB",
  /** The country code for Equatorial Guinea. */
  GNQ = "GNQ",
  /** The country code for Greece. */
  GRC = "GRC",
  /** The country code for Grenada. */
  GRD = "GRD",
  /** The country code for Greenland. */
  GRL = "GRL",
  /** The country code for Guatemala. */
  GTM = "GTM",
  /** The country code for French Guiana. */
  GUF = "GUF",
  /** The country code for Guam. */
  GUM = "GUM",
  /** The country code for Guyana. */
  GUY = "GUY",
  /** The country code for Hong Kong. */
  HKG = "HKG",
  /** The country code for Heard Island and McDonald Islands. */
  HMD = "HMD",
  /** The country code for Honduras. */
  HND = "HND",
  /** The country code for Croatia. */
  HRV = "HRV",
  /** The country code for Haiti. */
  HTI = "HTI",
  /** The country code for Hungary. */
  HUN = "HUN",
  /** The country code for Indonesia. */
  IDN = "IDN",
  /** The country code for Isle of Man. */
  IMN = "IMN",
  /** The country code for India. */
  IND = "IND",
  /** The country code for British Indian Ocean Territory. */
  IOT = "IOT",
  /** The country code for Ireland. */
  IRL = "IRL",
  /** The country code for Iran (Islamic Republic of). */
  IRN = "IRN",
  /** The country code for Iraq. */
  IRQ = "IRQ",
  /** The country code for Iceland. */
  ISL = "ISL",
  /** The country code for Israel. */
  ISR = "ISR",
  /** The country code for Italy. */
  ITA = "ITA",
  /** The country code for Jamaica. */
  JAM = "JAM",
  /** The country code for Jersey. */
  JEY = "JEY",
  /** The country code for Jordan. */
  JOR = "JOR",
  /** The country code for Japan. */
  JPN = "JPN",
  /** The country code for Kazakhstan. */
  KAZ = "KAZ",
  /** The country code for Kenya. */
  KEN = "KEN",
  /** The country code for Kyrgyzstan. */
  KGZ = "KGZ",
  /** The country code for Cambodia. */
  KHM = "KHM",
  /** The country code for Kiribati. */
  KIR = "KIR",
  /** The country code for Saint Kitts and Nevis. */
  KNA = "KNA",
  /** The country code for "Korea, Republic of". */
  KOR = "KOR",
  /** The country code for Kuwait. */
  KWT = "KWT",
  /** The country code for Lao People's Democratic Republic. */
  LAO = "LAO",
  /** The country code for Lebanon. */
  LBN = "LBN",
  /** The country code for Liberia. */
  LBR = "LBR",
  /** The country code for Libya. */
  LBY = "LBY",
  /** The country code for Saint Lucia. */
  LCA = "LCA",
  /** The country code for Liechtenstein. */
  LIE = "LIE",
  /** The country code for Sri Lanka. */
  LKA = "LKA",
  /** The country code for Lesotho. */
  LSO = "LSO",
  /** The country code for Lithuania. */
  LTU = "LTU",
  /** The country code for Luxembourg. */
  LUX = "LUX",
  /** The country code for Latvia. */
  LVA = "LVA",
  /** The country code for Macao. */
  MAC = "MAC",
  /** The country code for Saint Martin (French part). */
  MAF = "MAF",
  /** The country code for Morocco. */
  MAR = "MAR",
  /** The country code for Monaco. */
  MCO = "MCO",
  /** The country code for "Moldova, Republic of". */
  MDA = "MDA",
  /** The country code for Madagascar. */
  MDG = "MDG",
  /** The country code for Maldives. */
  MDV = "MDV",
  /** The country code for Mexico. */
  MEX = "MEX",
  /** The country code for Marshall Islands. */
  MHL = "MHL",
  /** The country code for North Macedonia. */
  MKD = "MKD",
  /** The country code for Mali. */
  MLI = "MLI",
  /** The country code for Malta. */
  MLT = "MLT",
  /** The country code for Myanmar. */
  MMR = "MMR",
  /** The country code for Montenegro. */
  MNE = "MNE",
  /** The country code for Mongolia. */
  MNG = "MNG",
  /** The country code for Northern Mariana Islands. */
  MNP = "MNP",
  /** The country code for Mozambique. */
  MOZ = "MOZ",
  /** The country code for Mauritania. */
  MRT = "MRT",
  /** The country code for Montserrat. */
  MSR = "MSR",
  /** The country code for Martinique. */
  MTQ = "MTQ",
  /** The country code for Mauritius. */
  MUS = "MUS",
  /** The country code for Malawi. */
  MWI = "MWI",
  /** The country code for Malaysia. */
  MYS = "MYS",
  /** The country code for Mayotte. */
  MYT = "MYT",
  /** The country code for Namibia. */
  NAM = "NAM",
  /** The country code for New Caledonia. */
  NCL = "NCL",
  /** The country code for Niger. */
  NER = "NER",
  /** The country code for Norfolk Island. */
  NFK = "NFK",
  /** The country code for Nigeria. */
  NGA = "NGA",
  /** The country code for Nicaragua. */
  NIC = "NIC",
  /** The country code for Niue. */
  NIU = "NIU",
  /** The country code for Netherlands. */
  NLD = "NLD",
  /** The country code for Norway. */
  NOR = "NOR",
  /** The country code for Nepal. */
  NPL = "NPL",
  /** The country code for Nauru. */
  NRU = "NRU",
  /** The country code for New Zealand. */
  NZL = "NZL",
  /** The country code for Oman. */
  OMN = "OMN",
  /** The country code for Pakistan. */
  PAK = "PAK",
  /** The country code for Panama. */
  PAN = "PAN",
  /** The country code for Pitcairn. */
  PCN = "PCN",
  /** The country code for Peru. */
  PER = "PER",
  /** The country code for Philippines. */
  PHL = "PHL",
  /** The country code for Palau. */
  PLW = "PLW",
  /** The country code for Papua New Guinea. */
  PNG = "PNG",
  /** The country code for Poland. */
  POL = "POL",
  /** The country code for Puerto Rico. */
  PRI = "PRI",
  /** The country code for Korea (Democratic People's Republic of). */
  PRK = "PRK",
  /** The country code for Portugal. */
  PRT = "PRT",
  /** The country code for Paraguay. */
  PRY = "PRY",
  /** The country code for "Palestine, State of". */
  PSE = "PSE",
  /** The country code for French Polynesia. */
  PYF = "PYF",
  /** The country code for Qatar. */
  QAT = "QAT",
  /** The country code for Kosovo. Note: "It is not ISO 3166 approved, but is approved by Visa and Mastercard" */
  QZZ = "QZZ",
  /** The country code for Réunion. */
  REU = "REU",
  /** The country code for Romania. */
  ROU = "ROU",
  /** The country code for Russian Federation. */
  RUS = "RUS",
  /** The country code for Rwanda. */
  RWA = "RWA",
  /** The country code for Saudi Arabia. */
  SAU = "SAU",
  /** The country code for Sudan. */
  SDN = "SDN",
  /** The country code for Senegal. */
  SEN = "SEN",
  /** The country code for Singapore. */
  SGP = "SGP",
  /** The country code for South Georgia and the South Sandwich Islands. */
  SGS = "SGS",
  /** The country code for "Saint Helena, Ascension and Tristan da Cunha". */
  SHN = "SHN",
  /** The country code for Svalbard and Jan Mayen. */
  SJM = "SJM",
  /** The country code for Solomon Islands. */
  SLB = "SLB",
  /** The country code for Sierra Leone. */
  SLE = "SLE",
  /** The country code for El Salvador. */
  SLV = "SLV",
  /** The country code for San Marino. */
  SMR = "SMR",
  /** The country code for Somalia. */
  SOM = "SOM",
  /** The country code for Saint Pierre and Miquelon. */
  SPM = "SPM",
  /** The country code for Serbia. */
  SRB = "SRB",
  /** The country code for South Sudan. */
  SSD = "SSD",
  /** The country code for Sao Tome and Principe. */
  STP = "STP",
  /** The country code for Suriname. */
  SUR = "SUR",
  /** The country code for Slovakia. */
  SVK = "SVK",
  /** The country code for Slovenia. */
  SVN = "SVN",
  /** The country code for Sweden. */
  SWE = "SWE",
  /** The country code for Eswatini. */
  SWZ = "SWZ",
  /** The country code for Sint Maarten (Dutch part). */
  SXM = "SXM",
  /** The country code for Seychelles. */
  SYC = "SYC",
  /** The country code for Syrian Arab Republic. */
  SYR = "SYR",
  /** The country code for Turks and Caicos Islands. */
  TCA = "TCA",
  /** The country code for Chad. */
  TCD = "TCD",
  /** The country code for Togo. */
  TGO = "TGO",
  /** The country code for Thailand. */
  THA = "THA",
  /** The country code for Tajikistan. */
  TJK = "TJK",
  /** The country code for Tokelau. */
  TKL = "TKL",
  /** The country code for Turkmenistan. */
  TKM = "TKM",
  /** The country code for Timor-Leste. */
  TLS = "TLS",
  /** The country code for Tonga. */
  TON = "TON",
  /** The country code for Trinidad and Tobago. */
  TTO = "TTO",
  /** The country code for Tunisia. */
  TUN = "TUN",
  /** The country code for Turkey. */
  TUR = "TUR",
  /** The country code for Tuvalu. */
  TUV = "TUV",
  /** The country code for "Taiwan, Province of China". */
  TWN = "TWN",
  /** The country code for "Tanzania, United Republic of". */
  TZA = "TZA",
  /** The country code for Uganda. */
  UGA = "UGA",
  /** The country code for Ukraine. */
  UKR = "UKR",
  /** The country code for United States Minor Outlying Islands. */
  UMI = "UMI",
  /** The country code for Uruguay. */
  URY = "URY",
  /** The country code for United States of America. */
  USA = "USA",
  /** The country code for Uzbekistan. */
  UZB = "UZB",
  /** The country code for Holy See. */
  VAT = "VAT",
  /** The country code for Saint Vincent and the Grenadines. */
  VCT = "VCT",
  /** The country code for Venezuela (Bolivarian Republic of). */
  VEN = "VEN",
  /** The country code for Virgin Islands (British). */
  VGB = "VGB",
  /** The country code for Virgin Islands (U.S.). */
  VIR = "VIR",
  /** The country code for Viet Nam. */
  VNM = "VNM",
  /** The country code for Vanuatu. */
  VUT = "VUT",
  /** The country code for Wallis and Futuna. */
  WLF = "WLF",
  /** The country code for Samoa. */
  WSM = "WSM",
  /** The country code for Yemen. */
  YEM = "YEM",
  /** The country code for South Africa. */
  ZAF = "ZAF",
  /** The country code for Zambia. */
  ZMB = "ZMB",
  /** The country code for Zimbabwe. */
  ZWE = "ZWE",
}

/** All currency codes for ISO4217. */
export enum Iso4217Alpha3CurrencyCode {
  /** The code for Andorran Peseta. */
  ADP = "ADP",
  /** The code for UAE Dirham. */
  AED = "AED",
  /** The code for Afghani. */
  AFA = "AFA",
  /** The code for Afghani. */
  AFN = "AFN",
  /** The code for Old Lek. */
  ALK = "ALK",
  /** The code for Lek. */
  ALL = "ALL",
  /** The code for Armenian Dram. */
  AMD = "AMD",
  /** The code for Netherlands Antillean Guilder. */
  ANG = "ANG",
  /** The code for Kwanza. */
  AOA = "AOA",
  /** The code for Kwanza. */
  AOK = "AOK",
  /** The code for New Kwanza. */
  AON = "AON",
  /** The code for Kwanza Reajustado. */
  AOR = "AOR",
  /** The code for Austral. */
  ARA = "ARA",
  /** The code for Peso Argentino. */
  ARP = "ARP",
  /** The code for Argentine Peso. */
  ARS = "ARS",
  /** The code for Peso. */
  ARY = "ARY",
  /** The code for Schilling. */
  ATS = "ATS",
  /** The code for Australian Dollar. */
  AUD = "AUD",
  /** The code for Aruban Florin. */
  AWG = "AWG",
  /** The code for Azerbaijan Manat. */
  AYM = "AYM",
  /** The code for Azerbaijanian Manat. */
  AZM = "AZM",
  /** The code for Azerbaijan Manat. */
  AZN = "AZN",
  /** The code for Dinar. */
  BAD = "BAD",
  /** The code for Convertible Mark. */
  BAM = "BAM",
  /** The code for Barbados Dollar. */
  BBD = "BBD",
  /** The code for Taka. */
  BDT = "BDT",
  /** The code for Convertible Franc. */
  BEC = "BEC",
  /** The code for Belgian Franc. */
  BEF = "BEF",
  /** The code for Financial Franc. */
  BEL = "BEL",
  /** The code for Lev A/52. */
  BGJ = "BGJ",
  /** The code for Lev A/62. */
  BGK = "BGK",
  /** The code for Lev. */
  BGL = "BGL",
  /** The code for Bulgarian Lev. */
  BGN = "BGN",
  /** The code for Bahraini Dinar. */
  BHD = "BHD",
  /** The code for Burundi Franc. */
  BIF = "BIF",
  /** The code for Bermudian Dollar. */
  BMD = "BMD",
  /** The code for Brunei Dollar. */
  BND = "BND",
  /** The code for Boliviano. */
  BOB = "BOB",
  /** The code for Peso boliviano. */
  BOP = "BOP",
  /** The code for Mvdol. */
  BOV = "BOV",
  /** The code for Cruzeiro. */
  BRB = "BRB",
  /** The code for Cruzado. */
  BRC = "BRC",
  /** The code for Cruzeiro. */
  BRE = "BRE",
  /** The code for Brazilian Real. */
  BRL = "BRL",
  /** The code for New Cruzado. */
  BRN = "BRN",
  /** The code for Cruzeiro Real. */
  BRR = "BRR",
  /** The code for Bahamian Dollar. */
  BSD = "BSD",
  /** The code for Ngultrum. */
  BTN = "BTN",
  /** The code for Kyat. */
  BUK = "BUK",
  /** The code for Pula. */
  BWP = "BWP",
  /** The code for Belarusian Ruble. */
  BYB = "BYB",
  /** The code for Belarusian Ruble. */
  BYN = "BYN",
  /** The code for Belarusian Ruble. */
  BYR = "BYR",
  /** The code for Belize Dollar. */
  BZD = "BZD",
  /** The code for Canadian Dollar. */
  CAD = "CAD",
  /** The code for Congolese Franc. */
  CDF = "CDF",
  /** The code for WIR Franc (for electronic). */
  CHC = "CHC",
  /** The code for WIR Euro. */
  CHE = "CHE",
  /** The code for Swiss Franc. */
  CHF = "CHF",
  /** The code for WIR Franc. */
  CHW = "CHW",
  /** The code for Unidad de Fomento. */
  CLF = "CLF",
  /** The code for Chilean Peso. */
  CLP = "CLP",
  /** The code for Yuan Renminbi. */
  CNY = "CNY",
  /** The code for Colombian Peso. */
  COP = "COP",
  /** The code for Unidad de Valor Real. */
  COU = "COU",
  /** The code for Costa Rican Colon. */
  CRC = "CRC",
  /** The code for Serbian Dinar. */
  CSD = "CSD",
  /** The code for Krona A/53. */
  CSJ = "CSJ",
  /** The code for Koruna. */
  CSK = "CSK",
  /** The code for Peso Convertible. */
  CUC = "CUC",
  /** The code for Cuban Peso. */
  CUP = "CUP",
  /** The code for Cabo Verde Escudo. */
  CVE = "CVE",
  /** The code for Cyprus Pound. */
  CYP = "CYP",
  /** The code for Czech Koruna. */
  CZK = "CZK",
  /** The code for Mark der DDR. */
  DDM = "DDM",
  /** The code for Deutsche Mark. */
  DEM = "DEM",
  /** The code for Djibouti Franc. */
  DJF = "DJF",
  /** The code for Danish Krone. */
  DKK = "DKK",
  /** The code for Dominican Peso. */
  DOP = "DOP",
  /** The code for Algerian Dinar. */
  DZD = "DZD",
  /** The code for Sucre. */
  ECS = "ECS",
  /** The code for Unidad de Valor Constante (UVC). */
  ECV = "ECV",
  /** The code for Kroon. */
  EEK = "EEK",
  /** The code for Egyptian Pound. */
  EGP = "EGP",
  /** The code for Nakfa. */
  ERN = "ERN",
  /** The code for Spanish Peseta. */
  ESA = "ESA",
  /** The code for Account (convertible Peseta Account). */
  ESB = "ESB",
  /** The code for Spanish Peseta. */
  ESP = "ESP",
  /** The code for Ethiopian Birr. */
  ETB = "ETB",
  /** The code for Euro. */
  EUR = "EUR",
  /** The code for Markka. */
  FIM = "FIM",
  /** The code for Fiji Dollar. */
  FJD = "FJD",
  /** The code for Falkland Islands Pound. */
  FKP = "FKP",
  /** The code for French Franc. */
  FRF = "FRF",
  /** The code for Pound Sterling. */
  GBP = "GBP",
  /** The code for Georgian Coupon. */
  GEK = "GEK",
  /** The code for Lari. */
  GEL = "GEL",
  /** The code for Cedi. */
  GHC = "GHC",
  /** The code for Ghana Cedi. */
  GHP = "GHP",
  /** The code for Ghana Cedi. */
  GHS = "GHS",
  /** The code for Gibraltar Pound. */
  GIP = "GIP",
  /** The code for Dalasi. */
  GMD = "GMD",
  /** The code for Syli. */
  GNE = "GNE",
  /** The code for Guinean Franc. */
  GNF = "GNF",
  /** The code for Syli. */
  GNS = "GNS",
  /** The code for Ekwele. */
  GQE = "GQE",
  /** The code for Drachma. */
  GRD = "GRD",
  /** The code for Quetzal. */
  GTQ = "GTQ",
  /** The code for Guinea Escudo. */
  GWE = "GWE",
  /** The code for Guinea-Bissau Peso. */
  GWP = "GWP",
  /** The code for Guyana Dollar. */
  GYD = "GYD",
  /** The code for Hong Kong Dollar. */
  HKD = "HKD",
  /** The code for Lempira. */
  HNL = "HNL",
  /** The code for Croatian Dinar. */
  HRD = "HRD",
  /** The code for Croatian Kuna. */
  HRK = "HRK",
  /** The code for Gourde. */
  HTG = "HTG",
  /** The code for Forint. */
  HUF = "HUF",
  /** The code for Rupiah. */
  IDR = "IDR",
  /** The code for Irish Pound. */
  IEP = "IEP",
  /** The code for Pound. */
  ILP = "ILP",
  /** The code for Old Shekel. */
  ILR = "ILR",
  /** The code for New Israeli Sheqel. */
  ILS = "ILS",
  /** The code for Indian Rupee. */
  INR = "INR",
  /** The code for Iraqi Dinar. */
  IQD = "IQD",
  /** The code for Iranian Rial. */
  IRR = "IRR",
  /** The code for Old Krona. */
  ISJ = "ISJ",
  /** The code for Iceland Krona. */
  ISK = "ISK",
  /** The code for Italian Lira. */
  ITL = "ITL",
  /** The code for Jamaican Dollar. */
  JMD = "JMD",
  /** The code for Jordanian Dinar. */
  JOD = "JOD",
  /** The code for Yen. */
  JPY = "JPY",
  /** The code for Kenyan Shilling. */
  KES = "KES",
  /** The code for Som. */
  KGS = "KGS",
  /** The code for Riel. */
  KHR = "KHR",
  /** The code for Comorian Franc . */
  KMF = "KMF",
  /** The code for North Korean Won. */
  KPW = "KPW",
  /** The code for Won. */
  KRW = "KRW",
  /** The code for Kuwaiti Dinar. */
  KWD = "KWD",
  /** The code for Cayman Islands Dollar. */
  KYD = "KYD",
  /** The code for Tenge. */
  KZT = "KZT",
  /** The code for Pathet Lao Kip. */
  LAJ = "LAJ",
  /** The code for Lao Kip. */
  LAK = "LAK",
  /** The code for Lebanese Pound. */
  LBP = "LBP",
  /** The code for Sri Lanka Rupee. */
  LKR = "LKR",
  /** The code for Liberian Dollar. */
  LRD = "LRD",
  /** The code for Loti. */
  LSL = "LSL",
  /** The code for Loti. */
  LSM = "LSM",
  /** The code for Lithuanian Litas. */
  LTL = "LTL",
  /** The code for Talonas. */
  LTT = "LTT",
  /** The code for Luxembourg Convertible Franc. */
  LUC = "LUC",
  /** The code for Luxembourg Franc. */
  LUF = "LUF",
  /** The code for Luxembourg Financial Franc. */
  LUL = "LUL",
  /** The code for Latvian Lats. */
  LVL = "LVL",
  /** The code for Latvian Ruble. */
  LVR = "LVR",
  /** The code for Libyan Dinar. */
  LYD = "LYD",
  /** The code for Moroccan Dirham. */
  MAD = "MAD",
  /** The code for Moldovan Leu. */
  MDL = "MDL",
  /** The code for Malagasy Ariary. */
  MGA = "MGA",
  /** The code for Malagasy Franc. */
  MGF = "MGF",
  /** The code for Denar. */
  MKD = "MKD",
  /** The code for Mali Franc. */
  MLF = "MLF",
  /** The code for Kyat. */
  MMK = "MMK",
  /** The code for Tugrik. */
  MNT = "MNT",
  /** The code for Pataca. */
  MOP = "MOP",
  /** The code for Ouguiya. */
  MRO = "MRO",
  /** The code for Ouguiya. */
  MRU = "MRU",
  /** The code for Maltese Lira. */
  MTL = "MTL",
  /** The code for Maltese Pound. */
  MTP = "MTP",
  /** The code for Mauritius Rupee. */
  MUR = "MUR",
  /** The code for Maldive Rupee. */
  MVQ = "MVQ",
  /** The code for Rufiyaa. */
  MVR = "MVR",
  /** The code for Kwacha. */
  MWK = "MWK",
  /** The code for Mexican Peso. */
  MXN = "MXN",
  /** The code for Mexican Peso. */
  MXP = "MXP",
  /** The code for Mexican Unidad de Inversion (UDI). */
  MXV = "MXV",
  /** The code for Malaysian Ringgit. */
  MYR = "MYR",
  /** The code for Mozambique Escudo. */
  MZE = "MZE",
  /** The code for Mozambique Metical. */
  MZM = "MZM",
  /** The code for Mozambique Metical. */
  MZN = "MZN",
  /** The code for Namibia Dollar. */
  NAD = "NAD",
  /** The code for Naira. */
  NGN = "NGN",
  /** The code for Cordoba. */
  NIC = "NIC",
  /** The code for Cordoba Oro. */
  NIO = "NIO",
  /** The code for Netherlands Guilder. */
  NLG = "NLG",
  /** The code for Norwegian Krone. */
  NOK = "NOK",
  /** The code for Nepalese Rupee. */
  NPR = "NPR",
  /** The code for New Zealand Dollar. */
  NZD = "NZD",
  /** The code for Rial Omani. */
  OMR = "OMR",
  /** The code for Balboa. */
  PAB = "PAB",
  /** The code for Sol. */
  PEH = "PEH",
  /** The code for Inti. */
  PEI = "PEI",
  /** The code for Sol. */
  PEN = "PEN",
  /** The code for Sol. */
  PES = "PES",
  /** The code for Kina. */
  PGK = "PGK",
  /** The code for Philippine Peso. */
  PHP = "PHP",
  /** The code for Pakistan Rupee. */
  PKR = "PKR",
  /** The code for Zloty. */
  PLN = "PLN",
  /** The code for Zloty. */
  PLZ = "PLZ",
  /** The code for Portuguese Escudo. */
  PTE = "PTE",
  /** The code for Guarani. */
  PYG = "PYG",
  /** The code for Qatari Rial. */
  QAR = "QAR",
  /** The code for Rhodesian Dollar. */
  RHD = "RHD",
  /** The code for Leu A/52. */
  ROK = "ROK",
  /** The code for Old Leu. */
  ROL = "ROL",
  /** The code for Romanian Leu. */
  RON = "RON",
  /** The code for Serbian Dinar. */
  RSD = "RSD",
  /** The code for Russian Ruble. */
  RUB = "RUB",
  /** The code for Russian Ruble. */
  RUR = "RUR",
  /** The code for Rwanda Franc. */
  RWF = "RWF",
  /** The code for Saudi Riyal. */
  SAR = "SAR",
  /** The code for Solomon Islands Dollar. */
  SBD = "SBD",
  /** The code for Seychelles Rupee. */
  SCR = "SCR",
  /** The code for Sudanese Dinar. */
  SDD = "SDD",
  /** The code for Sudanese Pound. */
  SDG = "SDG",
  /** The code for Sudanese Pound. */
  SDP = "SDP",
  /** The code for Swedish Krona. */
  SEK = "SEK",
  /** The code for Singapore Dollar. */
  SGD = "SGD",
  /** The code for Saint Helena Pound. */
  SHP = "SHP",
  /** The code for Tolar. */
  SIT = "SIT",
  /** The code for Slovak Koruna. */
  SKK = "SKK",
  /** The code for Leone. */
  SLL = "SLL",
  /** The code for Somali Shilling. */
  SOS = "SOS",
  /** The code for Surinam Dollar. */
  SRD = "SRD",
  /** The code for Surinam Guilder. */
  SRG = "SRG",
  /** The code for South Sudanese Pound. */
  SSP = "SSP",
  /** The code for Dobra. */
  STD = "STD",
  /** The code for Dobra. */
  STN = "STN",
  /** The code for Rouble. */
  SUR = "SUR",
  /** The code for El Salvador Colon. */
  SVC = "SVC",
  /** The code for Syrian Pound. */
  SYP = "SYP",
  /** The code for Lilangeni. */
  SZL = "SZL",
  /** The code for Baht. */
  THB = "THB",
  /** The code for Tajik Ruble. */
  TJR = "TJR",
  /** The code for Somoni. */
  TJS = "TJS",
  /** The code for Turkmenistan Manat. */
  TMM = "TMM",
  /** The code for Turkmenistan New Manat. */
  TMT = "TMT",
  /** The code for Tunisian Dinar. */
  TND = "TND",
  /** The code for Pa'anga. */
  TOP = "TOP",
  /** The code for Timor Escudo. */
  TPE = "TPE",
  /** The code for Old Turkish Lira. */
  TRL = "TRL",
  /** The code for Turkish Lira. */
  TRY = "TRY",
  /** The code for Trinidad and Tobago Dollar. */
  TTD = "TTD",
  /** The code for New Taiwan Dollar. */
  TWD = "TWD",
  /** The code for Tanzanian Shilling. */
  TZS = "TZS",
  /** The code for Hryvnia. */
  UAH = "UAH",
  /** The code for Karbovanet. */
  UAK = "UAK",
  /** The code for Uganda Shilling. */
  UGS = "UGS",
  /** The code for Old Shilling. */
  UGW = "UGW",
  /** The code for Uganda Shilling. */
  UGX = "UGX",
  /** The code for US Dollar. */
  USD = "USD",
  /** The code for US Dollar (Next day). */
  USN = "USN",
  /** The code for US Dollar (Same day). */
  USS = "USS",
  /** The code for Uruguay Peso en Unidades Indexadas (UI). */
  UYI = "UYI",
  /** The code for Old Uruguay Peso. */
  UYN = "UYN",
  /** The code for Uruguayan Peso. */
  UYP = "UYP",
  /** The code for Peso Uruguayo. */
  UYU = "UYU",
  /** The code for Unidad Previsional. */
  UYW = "UYW",
  /** The code for Uzbekistan Sum. */
  UZS = "UZS",
  /** The code for Bolivar. */
  VEB = "VEB",
  /** The code for Bolivar. */
  VEF = "VEF",
  /** The code for Bolívar Soberano. */
  VES = "VES",
  /** The code for Old Dong. */
  VNC = "VNC",
  /** The code for Dong. */
  VND = "VND",
  /** The code for Vatu. */
  VUV = "VUV",
  /** The code for Tala. */
  WST = "WST",
  /** The code for CFA Franc BEAC. */
  XAF = "XAF",
  /** The code for Silver. */
  XAG = "XAG",
  /** The code for Gold. */
  XAU = "XAU",
  /** The code for Bond Markets Unit European Composite Unit (EURCO). */
  XBA = "XBA",
  /** The code for Bond Markets Unit European Monetary Unit (E.M.U.-6). */
  XBB = "XBB",
  /** The code for Bond Markets Unit European Unit of Account 9 (E.U.A.-9). */
  XBC = "XBC",
  /** The code for Bond Markets Unit European Unit of Account 17 (E.U.A.-17). */
  XBD = "XBD",
  /** The code for East Caribbean Dollar. */
  XCD = "XCD",
  /** The code for SDR (Special Drawing Right). */
  XDR = "XDR",
  /** The code for European Currency Unit (E.C.U). */
  XEU = "XEU",
  /** The code for Gold-Franc. */
  XFO = "XFO",
  /** The code for UIC-Franc. */
  XFU = "XFU",
  /** The code for CFA Franc BCEAO. */
  XOF = "XOF",
  /** The code for Palladium. */
  XPD = "XPD",
  /** The code for CFP Franc. */
  XPF = "XPF",
  /** The code for Platinum. */
  XPT = "XPT",
  /** The code for RINET Funds Code. */
  XRE = "XRE",
  /** The code for Sucre. */
  XSU = "XSU",
  /** The code for Codes specifically reserved for testing purposes. */
  XTS = "XTS",
  /** The code for ADB Unit of Account. */
  XUA = "XUA",
  /** The code for The codes assigned for transactions where no currency is involved. */
  XXX = "XXX",
  /** The code for Yemeni Dinar. */
  YDD = "YDD",
  /** The code for Yemeni Rial. */
  YER = "YER",
  /** The code for New Yugoslavian Dinar. */
  YUD = "YUD",
  /** The code for New Dinar. */
  YUM = "YUM",
  /** The code for Yugoslavian Dinar. */
  YUN = "YUN",
  /** The code for Financial Rand. */
  ZAL = "ZAL",
  /** The code for Rand. */
  ZAR = "ZAR",
  /** The code for Zambian Kwacha. */
  ZMK = "ZMK",
  /** The code for Zambian Kwacha. */
  ZMW = "ZMW",
  /** The code for New Zaire. */
  ZRN = "ZRN",
  /** The code for Zaire. */
  ZRZ = "ZRZ",
  /** The code for Rhodesian Dollar. */
  ZWC = "ZWC",
  /** The code for Zimbabwe Dollar. */
  ZWD = "ZWD",
  /** The code for Zimbabwe Dollar. */
  ZWL = "ZWL",
  /** The code for Zimbabwe Dollar (new). */
  ZWN = "ZWN",
  /** The code for Zimbabwe Dollar. */
  ZWR = "ZWR",
}

/** The supported currencies on the Highnote platform. */
export enum Iso4217Alpha3SupportedCurrency {
  /** The code for US Dollar. */
  USD = "USD",
}

/** The identity risk level */
export enum IdentityRiskLevel {
  /** A high risk assessment. Seeing this means fraud is likely. */
  HIGH = "HIGH",
  /** A low risk assessment. Seeing this means fraud is not likely. */
  LOW = "LOW",
  /** A medium risk assessment. Seeing this means fraud is somewhat likely. */
  MEDIUM = "MEDIUM",
  /** A medium low risk assessment. Seeing this means fraud is somewhat not likely. */
  MEDIUM_LOW = "MEDIUM_LOW",
  /** A very high risk assessment. Seeing this means fraud is very likely. */
  VERY_HIGH = "VERY_HIGH",
}

/** All possible categories for an `IdentityTaskGroupReview` to be created. */
export enum IdentityTaskGroupReviewCategory {
  ENHANCED_DUE_DILIGENCE = "ENHANCED_DUE_DILIGENCE",
}

/** Inputs for filtering by `IdentityTaskGroupReviewCategory`. */
export type IdentityTaskGroupReviewCategoryFilterInput = {
  /** Value matches the provided `IdentityTaskGroupReviewCategory`. */
  equals?: InputMaybe<IdentityTaskGroupReviewCategory>;
  /** Value does not match any of the provided `IdentityTaskGroupReviewCategory`. */
  excludes?: InputMaybe<Array<IdentityTaskGroupReviewCategory>>;
  /** Value exactly matches any of the provided `IdentityTaskGroupReviewCategory`. */
  includes?: InputMaybe<Array<IdentityTaskGroupReviewCategory>>;
  /** Value does not match the provided `IdentityTaskGroupReviewCategory`. */
  notEquals?: InputMaybe<IdentityTaskGroupReviewCategory>;
};

/** Reasons for which identity verification documents may be requested. */
export enum IdentityVerificationDocumentRequestReason {
  /** The documents are being requested for an update initiated by the account holder. */
  ACCOUNT_HOLDER_UPDATE = "ACCOUNT_HOLDER_UPDATE",
  /** The documents are being requested for CIP verification. */
  CIP_VERIFICATION = "CIP_VERIFICATION",
}

/** A document upload session for identity verification documents. */
export type IdentityVerificationDocumentUploadSession = DocumentUploadSession &
  Node & {
    __typename?: "IdentityVerificationDocumentUploadSession";
    /** The date and time, in ISO 8601 format, this `IdentityVerificationDocumentUploadSession` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** A list of documents uploaded via a secure document upload link */
    documents?: Maybe<Array<UploadLink>>;
    /** The date and time, in ISO 8601 format, this `IdentityVerificationDocumentUploadSession` will expire. */
    expiresAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the document upload session */
    id: Scalars["ID"];
    /** A list of `DocumentType` requested in order to verify the identity of the entity. */
    requestedDocuments?: Maybe<Array<DocumentType>>;
    /** The current state of the document upload session */
    status?: Maybe<DocumentUploadSessionStatusCode>;
    /** The date and time, in ISO 8601 format, this `IdentityVerificationDocumentUploadSession` was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Whether or not the Financial Account supports Product Income. */
export type IncomeAccountFinancialAccountFeature = FinancialAccountFeature & {
  __typename?: "IncomeAccountFinancialAccountFeature";
  /** The date and time, in ISO 8601 format, the feature was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective from. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective through. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Whether or not the feature is enabled for the Financial Account. */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** The date and time, in ISO 8601 format, the feature was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Input for incrementally authorizing an existing `PaymentTransaction`. */
export type IncrementalAuthorizePaymentTransactionInput = {
  /** The amount to incrementally authorize. */
  amount?: InputMaybe<AmountInput>;
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /** The payment transaction to incrementally authorize. */
  paymentTransactionId: Scalars["ID"];
};

/** Result of incrementally authorizing a `PaymentTransaction`. */
export type IncrementalAuthorizePaymentTransactionPayload =
  | AccessDeniedError
  | CardAuthorizationStepSummary
  | UserError;

/** Input details when initiating an `OriginatedAchTransfer`. */
export type InitiateAchTransferInput = {
  /**
   * The monetary amount of the transfer, in cents, e.g. use USD `currencyCode` and  10000 `value` for $100.00.
   *
   * Maximum length: 10 digits, including cents. There may be additional limits on the size based on program.
   */
  amount: AmountInput;
  /**
   * The number of milliseconds after the transfer is initiated during which cancellation is allowed.
   * The transfer will not be processed until the cancellation period elapses.
   *
   * The default value is 0.
   */
  cancellationPeriodMillis?: InputMaybe<Scalars["UnsignedInt"]>;
  /**
   * Provides the receiving financial institution with information about the nature or purpose of the transaction.
   * Examples include "ACCTVERIFY". "PAYROLL", "PAYMENT", etc.
   *
   * Maximum length: 10 characters. The characters should be alphanumeric.
   */
  companyEntryDescription: Scalars["String"];
  /**
   * The financial account to send funds from.
   *
   * This must be a verified external financial account (`ExternalFinancialBankAccount`) id when pulling funds
   * and a Highnote `FinancialAccount` id when pushing funds.
   */
  fromFinancialAccountId: Scalars["ID"];
  /**
   * A value to uniquely distinguish transfers, e.g. a UUID.
   *
   * This helps prevent duplicate transfers in error scenarios. If a failure happens and it is unclear
   * if a transfer went through, it is safe to repeat the request with the same idempotency key. If the
   * transfer already exists, the request will be deduped and the original transfer will be returned
   * instead of a new transfer getting created for the same amount. If idempotency key is the same between
   * two requests, the other fields will be ignored and the original transfer will be returned.
   *
   * This value is required. Maximum length: 255 characters.
   */
  idempotencyKey: Scalars["String"];
  /**
   * Receiver’s identification number. This could be a person or a business.
   *
   * Maximum length: 15 characters. The characters should be alphanumeric.
   */
  individualIdentificationNumber?: InputMaybe<Scalars["String"]>;
  /**
   * Receiver’s individual name. This could be a person or a business.
   *
   * Maximum length: 22 characters. The characters should be alphanumeric.
   */
  individualName: Scalars["String"];
  /**
   * Contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   *
   * **Maximum length:** 80 characters
   */
  paymentRelatedInformation?: InputMaybe<Scalars["String"]>;
  /** The purpose of the transfer, e.g. deposit. */
  purpose: AchTransferPurpose;
  /**
   * A flag that indicates the desire to process this transaction using same-day ACH.
   * Note that this flag is not a guarantee the transaction will be processed the same day.
   * Funds availability is highly dependent on the ACH network processing schedule.
   */
  sameDay?: InputMaybe<Scalars["Boolean"]>;
  /**
   * The financial account to send funds to.
   *
   * This must be a Highnote `FinancialAccount` id when pulling funds
   * and a verified or non-verified external financial account (`ExternalFinancialBankAccount`
   * or `NonVerifiedExternalUSFinancialBankAccount`) id when pushing funds.
   */
  toFinancialAccountId: Scalars["ID"];
  /**
   * The consent provided by the individual authorizing the transfer.
   *
   * This includes the mandate template details to be collected for auditability of the accepted terms.
   */
  transferAgreementConsent: TransferAgreementConsentInput;
};

/** The return types when initiating an `OriginatedAchTransfer`. */
export type InitiateAchTransferPayload =
  | AccessDeniedError
  | OriginatedAchTransfer
  | UserError;

/** The return types when initiating add funds to a `FinancialAccount` via wire. */
export type InitiateAddWiredFundsPayload =
  | AccessDeniedError
  | ReviewWorkflowEvent
  | UserError;

/** Input details when initiating an add wire transfer to `FinancialAccount`. */
export type InitiateAddWiredFundsToFinancialAccountInput = {
  /**
   * The monetary amount of the transfer, in cents, e.g. use USD `currencyCode` and  10000 `value` for $100.00.
   *
   * Maximum length: 10 digits, including cents. There may be additional limits on the size based on program.
   */
  amount: AmountInput;
  /**
   * Additional reference ID
   * Maximum length: 255 characters
   */
  externalIdentifier?: InputMaybe<Scalars["String"]>;
  /**
   * A value to uniquely distinguish transfers, e.g. a UUID.
   *
   * This helps prevent duplicate transfers in error scenarios. If a failure happens and it is unclear
   * if a transfer went through, it is safe to repeat the request with the same idempotency key. If the
   * transfer already exists, the request will be deduped and the original transfer will be returned
   * instead of a new transfer getting created for the same amount. If idempotency key is the same between
   * two requests, the other fields will be ignored and the original transfer will be returned.
   *
   * If not provided, a unique identifier will be generated.
   * Maximum length: 255 characters.
   */
  idempotencyKey?: InputMaybe<Scalars["String"]>;
  /**
   * A description of the wire transfer for later reference.
   * Maximum length: 1024 characters
   */
  memo?: InputMaybe<Scalars["String"]>;
  /** The `FinancialAccount` to send funds to. */
  toFinancialAccountId: Scalars["ID"];
};

/** Input for `initiateCustomerCardTransactionDispute`. */
export type InitiateCustomerCardTransactionDisputeInput = {
  /** The disputed amount. */
  amount: AmountInput;
  /** The ID of the transaction event (AuthorizationAndClearEvent or ClearingEvent). */
  cardTransactionEventId: Scalars["ID"];
  /** The category type of the dispute. */
  category: PaymentCardDisputeCategoryType;
  /** The customer claim type for the card transaction dispute. */
  customerClaimType: PaymentCardDisputeCustomerClaimType;
  /** The customer contact information for the card transaction dispute. */
  customerContact: CustomerContactInput;
  /** The customer initiated date, in YYYY-MM-DD format, for the card transaction dispute. */
  customerInitiatedOn: Scalars["String"];
  /** The subscriber note for the card transaction dispute. Maximum length is 2048. */
  subscriberNote?: InputMaybe<Scalars["String"]>;
};

/** The details to update credit limit of an account holder Financial Account. */
export type InitiateFinancialAccountCreditLimitUpdateFromProductFundingInput = {
  /** The amount of credit limit for the Payment Card. */
  amount: AmountInput;
  /** The ID of the Financial Account for setting credit limit. */
  financialAccountId: Scalars["ID"];
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /** A description of the credit limit update for later reference. */
  memo?: InputMaybe<Scalars["String"]>;
};

/** The return types of credit limit update to an account holder financial account. */
export type InitiateFinancialAccountCreditLimitUpdateFromProductFundingPayload =

    | AccessDeniedError
    | FinancialAccountCreditLimitUpdateFromProductFunding
    | InterFinancialAccountTransfer
    | UserError;

/** The input to update a pseudo balance for a financial account. */
export type InitiateFinancialAccountPseudoBalanceUpdateInput = {
  /** The amount to set as the pseudo balance. */
  amount: AmountInput;
  /** The ID of the financial account to apply the pseudo balance against. */
  financialAccountId: Scalars["ID"];
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /** A memo that can be tagged with this pseudo balance update. This field accepts up to 1024 alphanumeric characters. */
  memo?: InputMaybe<Scalars["String"]>;
};

/** The details to fund card to an account holder Financial Account. */
export type InitiateFundPaymentCardFinancialAccountTransferInput = {
  /** The amount to add to the Payment Card. */
  amount: AmountInput;
  /** The ID of the source funding Financial Account. */
  fromFinancialAccountId: Scalars["ID"];
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /** A description of the transfer for later reference. */
  memo?: InputMaybe<Scalars["String"]>;
  /** The ID of the target card holder Financial Account. */
  toFinancialAccountId: Scalars["ID"];
};

/** The return types when fund card to an account holder financial account. */
export type InitiateFundPaymentCardFinancialAccountTransferPayload =
  | AccessDeniedError
  | InterFinancialAccountTransfer
  | UserError;

/** The details to deposit funds from an `ExternalFinancialAccount` to a `FinancialAccount` using ACH. */
export type InitiateFundsDepositAchTransferInput = {
  /**
   * Amount of the ACH transfer.
   *
   * There are at most 10 digits, including cents. There may be additional limits on the size based on program.
   */
  amount: AmountInput;
  /**
   * The number of milliseconds after ACH transfer creation during which cancellation is allowed.
   * The ACH transfer will not be processed during that period. After the period ends, the cancellation
   * may no longer be possible.
   */
  cancellationPeriodMillis?: InputMaybe<Scalars["UnsignedInt"]>;
  /** Descriptive fields about the transfer which may show up on bank reports. */
  descriptor: AchDescriptorInput;
  /**
   * The financial account the funds will be coming from.
   *
   * This must be a `ExternalFinancialAccount` ID.
   */
  fromFinancialAccountId: Scalars["ID"];
  /**
   * A value to distinguish unique transfers.
   *
   * This helps prevent duplicate transfers in error scenarios. If a failure happens and it is unclear
   * if a transfer went through, it is safe to repeat the request with the same idempotency key. If the
   * transfer already exists, the request will be deduped and the original transfer will be returned
   * instead of a new transfer getting created for the same amount. If idempotency key is the same between
   * two requests, the other fields will be ignored and the original transfer will be returned.
   *
   * **Maximum length:** 255 characters
   */
  idempotencyKey?: InputMaybe<Scalars["String"]>;
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   *
   * **Maximum length:** 80 characters
   */
  paymentRelatedInformation?: InputMaybe<Scalars["String"]>;
  /**
   * A flag that indicates the desire to attempt to perform this transaction using Same-Day ACH methods.
   * Note that this is not a guarantee of a same day transaction, but clearing will still be expedited.
   */
  sameDay?: InputMaybe<Scalars["Boolean"]>;
  /**
   * The financial account the funds will be going to.
   *
   * This must be a `FinancialAccount` ID.
   */
  toFinancialAccountId: Scalars["ID"];
  /**
   * The consent provided by the individual authorizing the ACH transfer.
   *
   * This includes the mandate template details to be collected for auditability of the accepted terms.
   */
  transferAgreementConsent: TransferAgreementConsentInput;
};

/**
 * The return types when the integrator initiates a withdrawal of funds from
 * an `ExternalFinancialAccount` to a `FinancialAccount`.
 */
export type InitiateFundsDepositAchTransferPayload =
  | AccessDeniedError
  | IntegratorInitiatedFundsDepositAchTransfer
  | UserError;

/** The details to withdraw funds from a `FinancialAccount` to an `ExternalFinancialAccount` using ACH. */
export type InitiateFundsWithdrawalAchTransferInput = {
  /**
   * Amount of the ACH transfer.
   *
   * There are at most 10 digits, including cents. There may be additional limits on the size based on program.
   */
  amount: AmountInput;
  /**
   * The number of milliseconds after ACH transfer creation during which cancellation is allowed.
   * The ACH transfer will not be processed during that period. After the period ends, the cancellation
   * may no longer be possible.
   */
  cancellationPeriodMillis?: InputMaybe<Scalars["UnsignedInt"]>;
  /** Descriptive fields about the transfer which may show up on bank reports. */
  descriptor: AchDescriptorInput;
  /**
   * The financial account the funds will be coming from.
   *
   * This must be a `FinancialAccount` ID.
   */
  fromFinancialAccountId: Scalars["ID"];
  /**
   * A value to distinguish unique transfers.
   *
   * This helps prevent duplicate transfers in error scenarios. If a failure happens and it is unclear
   * if a transfer went through, it is safe to repeat the request with the same idempotency key. If the
   * transfer already exists, the request will be deduped and the original transfer will be returned
   * instead of a new transfer getting created for the same amount. If idempotency key is the same between
   * two requests, the other fields will be ignored and the original transfer will be returned.
   *
   * **Maximum length:** 255 characters
   */
  idempotencyKey?: InputMaybe<Scalars["String"]>;
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   *
   * **Maximum length:** 80 characters
   */
  paymentRelatedInformation?: InputMaybe<Scalars["String"]>;
  /**
   * A flag that indicates the desire to attempt to perform this transaction using Same-Day ACH methods.
   * Note that this is not a guarantee of a same day transaction, but clearing will still be expedited.
   */
  sameDay?: InputMaybe<Scalars["Boolean"]>;
  /**
   * The financial account the funds will be going to.
   *
   * This must be a `ExternalFinancialAccount` ID.
   */
  toFinancialAccountId: Scalars["ID"];
  /**
   * The consent provided by the individual authorizing the ACH transfer.
   *
   * This includes the mandate template details to be collected for auditability of the accepted terms.
   */
  transferAgreementConsent: TransferAgreementConsentInput;
};

/**
 * The return types when the integrator initiates a withdrawal of funds from
 * a `FinancialAccount` to an `ExternalFinancialAccount`.
 */
export type InitiateFundsWithdrawalAchTransferPayload =
  | AccessDeniedError
  | IntegratorInitiatedFundsWithdrawalAchTransfer
  | UserError;

/**
 * The details needed in order to generate a report for
 * an `Organization`.
 */
export type InitiateOrganizationReportInput = {
  /** Parameters used to generate the Report. */
  parameters: ReportParametersInput;
  /** The type of report to be generated for an `Organization`. */
  reportType: OrganizationReportType;
};

/** The return types when calling `initiateOrganizationReport`. */
export type InitiateOrganizationReportPayload =
  | AccessDeniedError
  | Report
  | UserError;

/** The details to payroll advance to an employee Financial Account. */
export type InitiatePayrollAdvanceInput = {
  /** The amount to add to the Payment Card. */
  amount: AmountInput;
  /** The ID of the employer Financial Account for payroll advance. */
  fromFinancialAccountId: Scalars["ID"];
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /** A description of the transfer for later reference. May not include the following characters: @ + = ’ " < > & */
  memo?: InputMaybe<Scalars["String"]>;
  /** The ID of the employee Financial Account for payroll advance. */
  toFinancialAccountId: Scalars["ID"];
};

/**
 * The return types when payroll advance funds to an employee financial account.
 *
 * WARNING: Transfer is deprecated. ElectronicFundsTransfer should be used instead.
 */
export type InitiatePayrollAdvancePayload =
  | AccessDeniedError
  | InterFinancialAccountTransfer
  | Transfer
  | UserError;

/** The input object that defines the fields for the initiatePhysicalCheckPayment mutation. */
export type InitiatePhysicalCheckPaymentInput = {
  /** The amount of the check. */
  amount: AmountInput;
  /** The `FinancialAccount` to use to fund the check. */
  financialAccountId: Scalars["ID"];
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /** Optional memo to include on the check. */
  memo?: InputMaybe<Scalars["String"]>;
  /** The recipient of the check. */
  recipient: PhysicalCheckPaymentRecipientInput;
  /**
   * The mail type for a physical check.
   *
   * If not provided, defaults to the standard mail type.
   */
  shippingTime?: InputMaybe<CheckPaymentShippingTime>;
};

export type InitiatePhysicalCheckPaymentPayload =
  | AccessDeniedError
  | CheckPayment
  | UserError;

/** The details for the integrator to initiate a secure deposit ACH transfer. */
export type InitiateSecureDepositAchTransferInput = {
  /**
   * Amount of the ACH transfer.
   *
   * There are at most 10 digits, including cents. There may be additional limits on the size based on program.
   */
  amount: AmountInput;
  /**
   * The number of milliseconds after ACH transfer creation during which cancellation is allowed.
   * The ACH transfer will not be processed during that period. After the period ends, the cancellation
   * may no longer be possible.
   */
  cancellationPeriodMillis?: InputMaybe<Scalars["UnsignedInt"]>;
  /** Descriptive fields about the transfer which may show up on bank reports. */
  descriptor: AchDescriptorInput;
  /**
   * The financial account the funds will be coming from.
   *
   * This must be an `ExternalFinancialBankAccount` ID.
   */
  fromFinancialAccountId: Scalars["ID"];
  /**
   * A value to distinguish unique transfers.
   *
   * This helps prevent duplicate transfers in error scenarios. If a failure happens and it is unclear
   * if a transfer went through, it is safe to repeat the request with the same idempotency key. If the
   * transfer already exists, the request will be deduped and the original transfer will be returned
   * instead of a new transfer getting created for the same amount. If idempotency key is the same between
   * two requests, the other fields will be ignored and the original transfer will be returned.
   *
   * **Maximum length:** 255 characters
   */
  idempotencyKey?: InputMaybe<Scalars["String"]>;
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   *
   * **Maximum length:** 80 characters
   */
  paymentRelatedInformation?: InputMaybe<Scalars["String"]>;
  /**
   * The financial account the funds will be going to.
   *
   * This must be a `FinancialAccount` ID.
   */
  toFinancialAccountId: Scalars["ID"];
  /**
   * The consent provided by the individual authorizing the ACH transfer.
   *
   * This includes the mandate template details to be collected for auditability of the accepted terms.
   */
  transferAgreementConsent: TransferAgreementConsentInput;
};

/** The return types when the integrator initiates an ACH transfer. */
export type InitiateSecureDepositAchTransferPayload =
  | AccessDeniedError
  | SecureDepositAchTransfer
  | UserError;

/** Permissions for a `SecureDeposit` Client Token */
export enum InitiateSecureDepositClientTokenPermission {
  /** Setting this permission will enable management of the lifecycle of a secure deposit. */
  INITIATE_SECURE_DEPOSIT = "INITIATE_SECURE_DEPOSIT",
}

/** The details to transfer money between financial accounts. */
export type InitiateTransferBetweenFinancialAccountsInput = {
  /** The amount to transfer. */
  amount: AmountInput;
  /**
   * Externally provided identifier that can be used to reference the transfer. If not provided, this field will be blank.
   *
   * The identifier can be any valid ASCII character and cannot exceed 255 characters.
   */
  externalIdentifier?: InputMaybe<Scalars["String"]>;
  /** The ID of the source financial account. */
  fromFinancialAccountId: Scalars["ID"];
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /**
   * A description of the transfer for later reference. Maximum length is 1024, and valid characters
   * are all UTF-8 and ASCII characters.
   */
  memo?: InputMaybe<Scalars["String"]>;
  /** The purpose for the transfer. */
  purpose: TransferPurpose;
  /** The ID of the target financial account. */
  toFinancialAccountId: Scalars["ID"];
};

/** The return types when transfer occurs between financial accounts. */
export type InitiateTransferBetweenFinancialAccountsPayload =
  | AccessDeniedError
  | InterFinancialAccountTransfer
  | UserError;

/** The details to transfer money from a funding financial account to a financial account backing a payment card. */
export type InitiateTransferFromFundingFinancialAccountToPaymentCardFinancialAccountInput =
  {
    /** The amount to add to the Payment Card. */
    amount: AmountInput;
    /** The ID of the source funding financial account. */
    fromFinancialAccountId: Scalars["ID"];
    /**
     * The idempotency key for this request.
     *
     * This is a UUIDv4 string used to uniquely identify requests.
     *
     * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
     *
     * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
     */
    idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
    /**
     * A description of the transfer for later reference. Maximum length is 1024, and valid characters
     * are all UTF-8 and ASCII characters.
     */
    memo?: InputMaybe<Scalars["String"]>;
    /** The ID of the target card holder financial account. */
    toFinancialAccountId: Scalars["ID"];
  };

/** The return types when financial account is used to fund a financial account backing a payment card. */
export type InitiateTransferFromFundingFinancialAccountToPaymentCardFinancialAccountPayload =
  AccessDeniedError | InterFinancialAccountTransfer | UserError;

/** The details to transfer money from a financial account backing a payment card to a funding financial account. */
export type InitiateTransferFromPaymentCardFinancialAccountToFundingFinancialAccountInput =
  {
    /** The amount to transfer to the funding financial account. */
    amount: AmountInput;
    /** The ID of the source payment card financial account. */
    fromFinancialAccountId: Scalars["ID"];
    /**
     * The idempotency key for this request.
     *
     * This is a UUIDv4 string used to uniquely identify requests.
     *
     * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
     *
     * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
     */
    idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
    /**
     * A description of the transfer for later reference. Maximum length is 1024, and valid characters
     * are all UTF-8 and ASCII characters.
     */
    memo?: InputMaybe<Scalars["String"]>;
    /** The ID of the target funding financial account. */
    toFinancialAccountId: Scalars["ID"];
  };

/** The return types when financial account backing a payment card is used to fund a funding financial account. */
export type InitiateTransferFromPaymentCardFinancialAccountToFundingFinancialAccountPayload =
  AccessDeniedError | InterFinancialAccountTransfer | UserError;

/** The input for initiating an `USBusinessAuthorizedPersonRequestedIdentityUpdate`. */
export type InitiateUsBusinessAuthorizedPersonRequestedIdentityUpdateInput = {
  /** Details for updating the `USAuthorizedPerson`. */
  primaryAuthorizedPerson: UsAuthorizedPersonUpdateInput;
  /** The Global ID of the requested identity update. */
  requestedIdentityUpdateId: Scalars["ID"];
};

/** The response type when applying an update for a `USBusinessAuthorizedPersonRequestedIdentityUpdate` */
export type InitiateUsBusinessAuthorizedPersonRequestedIdentityUpdatePayload =
  | AccessDeniedError
  | RequestedIdentityUpdate
  | UserError;

/** The input for initiating an `USBusinessProfileRequestedIdentityUpdate`. */
export type InitiateUsBusinessProfileRequestedIdentityUpdateInput = {
  /** Details for updating the `USBusinessProfile`. */
  businessProfile: UsBusinessProfileUpdateInput;
  /** The Global ID of the requested identity update. */
  requestedIdentityUpdateId: Scalars["ID"];
};

/** The response type when initiating an update for a `USBusinessProfileRequestedIdentityUpdate` */
export type InitiateUsBusinessProfileRequestedIdentityUpdatePayload =
  | AccessDeniedError
  | RequestedIdentityUpdate
  | UserError;

/** The input for initiating an `USBusinessUltimateBeneficialOwnerRequestedIdentityUpdate`. */
export type InitiateUsBusinessUltimateBeneficialOwnerRequestedIdentityUpdateInput =
  {
    /** The Global ID of the requested identity update. */
    requestedIdentityUpdateId: Scalars["ID"];
    /** Details for updating the `USUltimateBeneficialOwner`. */
    ultimateBeneficialOwner: UsUltimateBeneficialOwnerUpdateInput;
  };

/** The response type when applying an update for a `USBusinessUltimateBeneficialOwnerRequestedIdentityUpdate` */
export type InitiateUsBusinessUltimateBeneficialOwnerRequestedIdentityUpdatePayload =
  AccessDeniedError | RequestedIdentityUpdate | UserError;

/** The input for initiating an `USPersonAccountHolderRequestedIdentityUpdate`. */
export type InitiateUsPersonAccountHolderRequestedIdentityUpdateInput = {
  /** Details for updating the `USPersonAccountHolder`. */
  personAccountHolder: UsPersonAccountHolderUpdateInput;
  /** The Global ID of the requested identity update. */
  requestedIdentityUpdateId: Scalars["ID"];
};

/** The response type when applying an update for a `USPersonAccountHolderRequestedIdentityUpdate` */
export type InitiateUsPersonAccountHolderRequestedIdentityUpdatePayload =
  | AccessDeniedError
  | RequestedIdentityUpdate
  | UserError;

/** Input for `initiateUnifiedFundsTransfer`. */
export type InitiateUnifiedFundsTransferInput = {
  /**
   * Consent agreement information for the transfer.
   * Required when the transfer requires end-user authorization (e.g., RTP transfers).
   */
  consent?: InputMaybe<TransferAgreementConsentInput>;
  /** The `id` of the `UnifiedFundsTransferQuote` to initiate. */
  id: Scalars["ID"];
};

/** The possible results of `initiateUnifiedFundsTransfer` */
export type InitiateUnifiedFundsTransferPayload =
  | AccessDeniedError
  | UnifiedFundsTransfer
  | UserError;

/** Input details when initiating an unload wire transfer from a `FinancialAccount`. */
export type InitiateUnloadWiredFundsFromFinancialAccountInput = {
  /**
   * The monetary amount of the transfer, in cents, e.g. use USD `currencyCode` and 10000 `value` for $100.00.
   *
   * Maximum length: 10 digits, including cents. There may be additional limits on the size based on program.
   */
  amount: AmountInput;
  /**
   * Additional reference ID
   * Maximum length: 255 characters
   */
  externalIdentifier?: InputMaybe<Scalars["String"]>;
  /** The `FinancialAccount` that funds were wired out from. */
  fromFinancialAccountId: Scalars["ID"];
  /**
   * A value to uniquely distinguish transfers, e.g. a UUID.
   *
   * This helps prevent duplicate transfers in error scenarios. If a failure happens and it is unclear
   * if a transfer went through, it is safe to repeat the request with the same idempotency key. If the
   * transfer already exists, the request will be deduped and the original transfer will be returned
   * instead of a new transfer getting created for the same amount. If idempotency key is the same between
   * two requests, the other fields will be ignored and the original transfer will be returned.
   *
   * If not provided, a unique identifier will be generated.
   * Maximum length: 255 characters.
   */
  idempotencyKey?: InputMaybe<Scalars["String"]>;
  /**
   * A description of the wire transfer for later reference.
   * Maximum length: 1024 characters
   */
  memo?: InputMaybe<Scalars["String"]>;
};

/** The return types when initiating unloading funds from a `FinancialAccount` via wire. */
export type InitiateUnloadWiredFundsPayload =
  | AccessDeniedError
  | ReviewWorkflowEvent
  | UserError;

/** An arrangement to convert a `Transaction` into installments. */
export type InstallmentAgreement = Node & {
  __typename?: "InstallmentAgreement";
  /** The original offer information such as the relevant `CreditPlan`, and the total and per-installment amounts due. */
  agreement?: Maybe<InstallmentOffer>;
  /** The date and time, in ISO 8601 format, this was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The unique identifier for this `InstallmentAgreement`. */
  id: Scalars["ID"];
  /** The date and time, in ISO 8601 format, the first statement where an installment is due starts. */
  installmentAgreementPeriodStart?: Maybe<Scalars["String"]>;
  /** The progress to date and remaining obligations for this `InstallmentAgreement`. */
  snapshot?: Maybe<InstallmentAgreementSnapshot>;
  /** The status of this `InstallmentAgreement`. */
  status?: Maybe<InstallmentAgreementStatus>;
  /** The status history of this `InstallmentAgreement`. */
  statusHistory?: Maybe<Array<InstallmentAgreementStatusHistory>>;
  /** The `TransactionEvent` associated with this `InstallmentAgreement`. */
  transactionEvent?: Maybe<TransactionEvent>;
  /** The date and time, in ISO 8601 format, this was most recently updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** A summary of completed `InstallmentAgreement` activity. */
export type InstallmentAgreementCompletedRollup = {
  __typename?: "InstallmentAgreementCompletedRollup";
  /** The fees paid to date for this `InstallmentAgreement`. */
  feesPaid?: Maybe<Amount>;
  /** The number of installments completed to date for this `InstallmentAgreement`. */
  numberOfInstallmentsCompleted?: Maybe<Scalars["UnsignedInt"]>;
  /** The principal balance paid to date for this `InstallmentAgreement`. */
  principalBalancePaid?: Maybe<Amount>;
};

/** The connection type for a `InstallmentAgreement`. */
export type InstallmentAgreementConnection = {
  __typename?: "InstallmentAgreementConnection";
  /** A list of edges. */
  edges?: Maybe<Array<InstallmentAgreementEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a `InstallmentAgreement`. */
export type InstallmentAgreementEdge = {
  __typename?: "InstallmentAgreementEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The `InstallmentAgreement`. */
  node?: Maybe<InstallmentAgreement>;
};

/** The input type for filtering `InstallmentAgreement`. */
export type InstallmentAgreementFilterInput = {
  /** The status of the `InstallmentAgreement`. For example, `OPEN` or `REVERSE` or `PAID_OFF or `CHARGE_OFF`. */
  installmentAgreementStatus?: InputMaybe<InstallmentAgreementStatus>;
  /** The `ID`s of `TransactionEvent`s to include in results. */
  transactionEventIds?: InputMaybe<Array<Scalars["ID"]>>;
};

/** A summary of remaining `InstallmentAgreement` activity. */
export type InstallmentAgreementRemainingRollup = {
  __typename?: "InstallmentAgreementRemainingRollup";
  /** The remaining fees due for this `InstallmentAgreement`. This is a sum of per period fees for the remaining periods. */
  estimatedFeesRemaining?: Maybe<Amount>;
  /** The number of installments remaining for this `InstallmentAgreement`. */
  numberOfInstallmentsRemaining?: Maybe<Scalars["UnsignedInt"]>;
  /** The remaining principal balance due for this `InstallmentAgreement`. */
  principalBalanceRemaining?: Maybe<Amount>;
};

/** The progress to date and remaining obligations for this `InstallmentAgreement`. */
export type InstallmentAgreementSnapshot = {
  __typename?: "InstallmentAgreementSnapshot";
  /** The date and time, in ISO 8601 format, this was updated. */
  asOf?: Maybe<Scalars["String"]>;
  /** Details about past completed installments. */
  installmentPaymentsCompleted?: Maybe<InstallmentAgreementCompletedRollup>;
  /** Details about remaining installments. */
  installmentPaymentsRemaining?: Maybe<InstallmentAgreementRemainingRollup>;
};

/** Possible status values for an `InstallmentAgreement` */
export enum InstallmentAgreementStatus {
  CHARGED_OFF = "CHARGED_OFF",
  OPEN = "OPEN",
  PAID_OFF = "PAID_OFF",
  REVERSED = "REVERSED",
}

/** `InstallmentAgreement` status history. */
export type InstallmentAgreementStatusHistory = {
  __typename?: "InstallmentAgreementStatusHistory";
  /** The date and time when the status changed, in ISO 8601 format. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The new status. */
  newStatus?: Maybe<InstallmentAgreementStatus>;
  /** The previous status. */
  previousStatus?: Maybe<InstallmentAgreementStatus>;
};

/** The installment eligibility status of a `TransactionEvent`. */
export type InstallmentEligibilityForTransactionEvent = {
  __typename?: "InstallmentEligibilityForTransactionEvent";
  /** The installment eligibility status. For example, `ELIGIBLE` or `NOT_ELIGIBLE`. */
  eligibility?: Maybe<CreditInstallmentEligibilityStatusForTransactionEvent>;
  /** The relevant `TransactionEvent`. */
  transactionEvent?: Maybe<TransactionEvent>;
};

/** The installment eligibility status of the provided `TransactionEvent`s. */
export type InstallmentEligibilityForTransactionEvents = {
  __typename?: "InstallmentEligibilityForTransactionEvents";
  /** A list showing installment eligibility status by `TransactionEvent`. */
  eligibilityByTransactionEvent?: Maybe<
    Array<InstallmentEligibilityForTransactionEvent>
  >;
};

/** The input type for viewing `InstallmentEligibilityForTransactionEvents`. */
export type InstallmentEligibilityForTransactionEventsInput = {
  /** A list of globally unique identifiers for the relevant `TransactionEvent`s. Must be `ClearingEvent`s or `AuthorizationAndClearEvent`s. Must be between 1 and 20 identifiers, inclusive. */
  cardTransactionEventIds: Array<Scalars["ID"]>;
};

/** Types which can be returned when querying `InstallmentEligibilityForTransactionEvents`. */
export type InstallmentEligibilityForTransactionEventsPayload =
  | AccessDeniedError
  | InstallmentEligibilityForTransactionEvents
  | UserError;

/** The frequency at which installment payments occur. */
export enum InstallmentFrequency {
  /** Monthly. */
  MONTHLY = "MONTHLY",
}

/** Network-specific installment payment data. */
export type InstallmentNetworkData = MastercardInstallmentData;

/** Network-specific installment payment input data. */
export type InstallmentNetworkDataInput = {
  /** Mastercard-specific installment payment data. */
  mastercardData?: InputMaybe<MastercardInstallmentDataInput>;
};

/** An offer to convert a transaction into installments. */
export type InstallmentOffer = {
  __typename?: "InstallmentOffer";
  /** The `CreditPlan` associated with this `InstallmentOffer`. */
  creditPlan?: Maybe<CreditPlan>;
  /** Details including principal and fees for this `InstallmentOffer`. */
  details?: Maybe<InstallmentOfferDetails>;
};

/** Details about the `Amount` due for installment offer. */
export type InstallmentOfferDetails = {
  __typename?: "InstallmentOfferDetails";
  /** The `Amount` of fees charged per period for this offer. */
  feesChargedPerPeriod?: Maybe<Amount>;
  /** The `Amount` of principal due per period for this offer. */
  principalDuePerPeriod?: Maybe<Amount>;
  /** The total cost of converting this into installments, including principal and fees. */
  totalCost?: Maybe<Amount>;
  /** The total fees charged for this installment offer. */
  totalFees?: Maybe<Amount>;
  /** The total principal that is being converted into installments. */
  totalPrincipal?: Maybe<Amount>;
};

/** The available `InstallmentOffer`s for a given `TransactionEvent`. */
export type InstallmentOffersForTransactionEvent = {
  __typename?: "InstallmentOffersForTransactionEvent";
  /** The available `InstallmentOffer`s for the `TransactionEvent`. */
  offers?: Maybe<Array<InstallmentOffer>>;
  /** The `TransactionEvent` associated with these `InstallmentOffer`s. */
  transactionEvent?: Maybe<TransactionEvent>;
};

/** The input type for viewing `InstallmentOffersForTransactionEvent`. */
export type InstallmentOffersForTransactionEventInput = {
  /** The globally unique identifier for the relevant `TransactionEvent`. Must be a `ClearingEvent` or an `AuthorizationAndClearEvent`. */
  cardTransactionEventId: Scalars["ID"];
};

/** Types which can be returned when querying `InstallmentOffersForTransaction`. */
export type InstallmentOffersForTransactionEventPayload =
  | AccessDeniedError
  | InstallmentOffersForTransactionEvent
  | UserError;

/** Allows for transferring money between a `FinancialAccount` and a `PaymentMethodToken`. */
export type InstantNetworkTransfer = Node & {
  __typename?: "InstantNetworkTransfer";
  /** The date and time, in ISO 8601 format, when this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The destination of the funds to transfer. */
  destination?: Maybe<InstantNetworkTransferDestination>;
  /** The events associated with this transfer. */
  events?: Maybe<Array<InstantNetworkTransferEvent>>;
  /** Externally provided ID (255 character limit) to associate this object with an external system. */
  externalIdentifier?: Maybe<Scalars["String"]>;
  /** When the `InstantNetworkTransfer.status` is `FAILED`, this will be populated with the reason for the failure. */
  failureReason?: Maybe<InstantNetworkTransferFailureReason>;
  /** Global ID used to reference this object. */
  id: Scalars["ID"];
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: Maybe<Scalars["String"]>;
  /** The source of the funds to transfer. */
  source?: Maybe<InstantNetworkTransferSource>;
  /** The current status of the transfer. */
  status?: Maybe<InstantNetworkTransferStatus>;
  /** The detail of the transfer including the fee and time estimate. */
  transferDetail?: Maybe<InstantNetworkTransferDetail>;
  /** The date and time, in ISO 8601 format, when this object was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The destination of the funds being transferred. */
export type InstantNetworkTransferDestination = {
  __typename?: "InstantNetworkTransferDestination";
  /** The amount of funds to deposit at the destination. */
  amount?: Maybe<Amount>;
  /** If the source is a Highnote `Node`, this will be the `Node`. */
  node?: Maybe<InstantNetworkTransferDestinationNode>;
};

/** The possible destinations of the `InstantNetworkTransfer`. */
export type InstantNetworkTransferDestinationNode =
  | FinancialAccount
  | PaymentMethodToken;

/** Indicates that this `PaymentInstrument` can be used as the destination ID for `InstantNetworkTransfer`. */
export type InstantNetworkTransferDestinationPaymentInstrumentCapability = {
  __typename?: "InstantNetworkTransferDestinationPaymentInstrumentCapability";
  /** The date and time, in ISO 8601 format, the capability was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The current status for this capability. If it is `ENABLED`, the `PaymentInstrument` has this capability. */
  status?: Maybe<InstantNetworkTransferDestinationPaymentInstrumentCapabilityStatus>;
  /** The date and time, in ISO 8601 format, the capability was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** The `PaymentTransaction` that originated this capability. */
  verificationPaymentTransaction?: Maybe<PaymentTransaction>;
};

/** The possible statuses of the `InstantNetworkTransferDestinationPaymentInstrumentCapabilityStatus` */
export enum InstantNetworkTransferDestinationPaymentInstrumentCapabilityStatus {
  /** The `PaymentInstrument` has the `InstantNetworkTransfer` capability disabled. */
  DISABLED = "DISABLED",
  /** The `PaymentInstrument` has the `InstantNetworkTransfer` capability enabled. */
  ENABLED = "ENABLED",
  /** The `PaymentInstrument` is undergoing a review to determine the status. */
  REQUIRES_REVIEW = "REQUIRES_REVIEW",
}

/** Detail about the transfer. */
export type InstantNetworkTransferDetail = {
  __typename?: "InstantNetworkTransferDetail";
  /** The total fee for the transfer. */
  feeTotal?: Maybe<Amount>;
  /** A human-readable estimate of the time it will take for the transfer to complete. */
  timeEstimate?: Maybe<Scalars["String"]>;
};

/** An event associated with a `InstantNetworkTransfer`. */
export type InstantNetworkTransferEvent = Node & {
  __typename?: "InstantNetworkTransferEvent";
  /** The `PaymentTransaction` that `InstantNetworkTransfer` uses to move money. */
  associatedPaymentTransaction?: Maybe<PaymentTransaction>;
  /** The date and time, in ISO 8601 format, when this event occurred. */
  createdAt?: Maybe<Scalars["String"]>;
  /** When the `InstantNetworkTransfer.status` is `FAILED` during this event, this will be populated with the reason for the failure. */
  failureReason?: Maybe<InstantNetworkTransferFailureReason>;
  /** The global ID of the event. */
  id: Scalars["ID"];
  /** The `InstantNetworkTransfer` associated with this event. */
  instantNetworkTransfer?: Maybe<InstantNetworkTransfer>;
  /** The status of the transfer when the event happened. */
  status?: Maybe<InstantNetworkTransferStatus>;
  /** The type of event that has happened on the `InstantNetworkTransfer`. */
  type?: Maybe<InstantNetworkTransferEventType>;
  /** The date and time, in ISO 8601 format, when this event was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Possible types of events that have happened on `InstantNetworkTransfer`. */
export enum InstantNetworkTransferEventType {
  /** The `InstantNetworkTransfer`'s event to authorize the pulling of funds. */
  AUTHORIZE_PULL_PAYMENT_FUND = "AUTHORIZE_PULL_PAYMENT_FUND",
  /** The `InstantNetworkTransfer`'s event to authorize the pushing of funds. */
  AUTHORIZE_PUSH_PAYMENT_FUND = "AUTHORIZE_PUSH_PAYMENT_FUND",
  /** The `InstantNetworkTransfer`'s event to clear the pulling of funds. */
  CLEAR_PULL_PAYMENT_FUND = "CLEAR_PULL_PAYMENT_FUND",
  /** The `InstantNetworkTransfer`'s event to clear the pushing of funds. */
  CLEAR_PUSH_PAYMENT_FUND = "CLEAR_PUSH_PAYMENT_FUND",
  /** The `InstantNetworkTransfer`'s event for compliance review. */
  COMPLIANCE_REVIEW = "COMPLIANCE_REVIEW",
  /** The `InstantNetworkTransfer`'s event for the request to initiate the transfer. */
  INITIAL_REQUEST = "INITIAL_REQUEST",
  /** The `InstantNetworkTransfer`'s event to pull the funds. */
  PULL_PAYMENT = "PULL_PAYMENT",
  /** The `InstantNetworkTransfer`'s event to push the funds. */
  PUSH_PAYMENT = "PUSH_PAYMENT",
  /** The `InstantNetworkTransfer`'s event to reverse the pulling of funds. */
  REVERSE_PULL_PAYMENT_FUND = "REVERSE_PULL_PAYMENT_FUND",
  /** The `InstantNetworkTransfer`'s event to reverse the pushing of funds. */
  REVERSE_PUSH_PAYMENT_FUND = "REVERSE_PUSH_PAYMENT_FUND",
}

/** Reasons an `InstantNetworkTransfer` may have failed. */
export enum InstantNetworkTransferFailureReason {
  /** The `InstantNetworkTransfer` failed because the source and destination accounts do not belong to the same product. */
  ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT = "ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT",
  /** The `InstantNetworkTransfer` failed because the account is closed. */
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  /** The `InstantNetworkTransfer` failed because the account is not active. */
  ACCOUNT_NOT_ACTIVE = "ACCOUNT_NOT_ACTIVE",
  /** The `InstantNetworkTransfer` failed because the account could not be found. */
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  /** The `InstantNetworkTransfer` failed because the account was not provided. */
  ACCOUNT_NOT_PROVIDED = "ACCOUNT_NOT_PROVIDED",
  /** The `InstantNetworkTransfer` failed because ACH loads are not allowed by the program. */
  ACH_LOAD_NOT_ALLOWED_BY_PROGRAM = "ACH_LOAD_NOT_ALLOWED_BY_PROGRAM",
  /** The `InstantNetworkTransfer` failed because ANI verification failed. */
  ANI_VERIFICATION_FAILED = "ANI_VERIFICATION_FAILED",
  /** The `InstantNetworkTransfer` failed because the CVC3/DCVV is invalid. */
  BAD_CVC3_DCVV = "BAD_CVC3_DCVV",
  /** The `InstantNetworkTransfer` failed because the CVV is invalid. */
  BAD_CVV = "BAD_CVV",
  /** The `InstantNetworkTransfer` failed because the CVV2 is invalid. */
  BAD_CVV2 = "BAD_CVV2",
  /** The `InstantNetworkTransfer` failed because the bank-managed beta account feature is not enabled. */
  BANK_MANAGED_BETA_ACCOUNT_FEATURE_NOT_ENABLED = "BANK_MANAGED_BETA_ACCOUNT_FEATURE_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because the card is blocked. */
  BLOCKED_CARD = "BLOCKED_CARD",
  /** The `InstantNetworkTransfer` failed because the card funding feature is not enabled. */
  CARD_FUNDING_FEATURE_NOT_ENABLED = "CARD_FUNDING_FEATURE_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because the cash back limit was exceeded. */
  CASH_BACK_LIMIT_EXCEEDED = "CASH_BACK_LIMIT_EXCEEDED",
  /** The `InstantNetworkTransfer` failed because cash fund-out is not supported on this product. */
  CASH_FUND_OUT_NOT_SUPPORTED_ON_PRODUCT = "CASH_FUND_OUT_NOT_SUPPORTED_ON_PRODUCT",
  /** The `InstantNetworkTransfer` failed because the charge-off amount exceeds the account balance. */
  CHARGE_OFF_EXCEEDS_BALANCE = "CHARGE_OFF_EXCEEDS_BALANCE",
  /** The `InstantNetworkTransfer` failed because the check-capable account feature is not enabled. */
  CHECK_CAPABLE_ACCOUNT_FEATURE_NOT_ENABLED = "CHECK_CAPABLE_ACCOUNT_FEATURE_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because check payments are not supported on this product. */
  CHECK_PAYMENT_NOT_SUPPORTED_ON_PRODUCT = "CHECK_PAYMENT_NOT_SUPPORTED_ON_PRODUCT",
  /** The `InstantNetworkTransfer` failed because chip card ARQC validation failed. */
  CHIP_CARD_ARQC_VALIDATION_FAILURE = "CHIP_CARD_ARQC_VALIDATION_FAILURE",
  /** The `InstantNetworkTransfer` failed because the commercial credit (pay-in-full) feature is not enabled. */
  COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED = "COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because compliance verification failed. */
  COMPLIANCE_VERIFICATION_FAILED = "COMPLIANCE_VERIFICATION_FAILED",
  /** The `InstantNetworkTransfer` failed because the corporate bank account feature is not enabled. */
  CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED = "CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because the credit card feature is not enabled. */
  CREDIT_CARD_FEATURE_NOT_ENABLED = "CREDIT_CARD_FEATURE_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because a credit limit has not been set on the account. */
  CREDIT_LIMIT_NOT_SET_ON_ACCOUNT = "CREDIT_LIMIT_NOT_SET_ON_ACCOUNT",
  /** The `InstantNetworkTransfer` failed because the source and destination accounts use different currencies. */
  CURRENCY_MISMATCH = "CURRENCY_MISMATCH",
  /** The `InstantNetworkTransfer` failed because the DDA feature is not enabled. */
  DDA_FEATURE_NOT_ENABLED = "DDA_FEATURE_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because the debit card feature is not enabled. */
  DEBIT_CARD_FEATURE_NOT_ENABLED = "DEBIT_CARD_FEATURE_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because the dispute chargeback feature is not enabled. */
  DISPUTE_CHARGEBACK_NOT_ENABLED = "DISPUTE_CHARGEBACK_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because provisional credit for chargebacks is not enabled. */
  DISPUTE_CHARGEBACK_PROVISIONAL_CREDIT_NOT_ENABLED = "DISPUTE_CHARGEBACK_PROVISIONAL_CREDIT_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because the transaction was declined. */
  DO_NOT_HONOR = "DO_NOT_HONOR",
  /** The `InstantNetworkTransfer` failed because the approval amount limit was exceeded. */
  EXCEEDS_APPROVAL_AMOUNT_LIMIT = "EXCEEDS_APPROVAL_AMOUNT_LIMIT",
  /** The `InstantNetworkTransfer` failed because the withdrawal frequency limit was exceeded. */
  EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT = "EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT",
  /** The `InstantNetworkTransfer` failed because the card has expired. */
  EXPIRED_CARD = "EXPIRED_CARD",
  /** The `InstantNetworkTransfer` failed because external money movement is not supported on this product. */
  EXTERNAL_MONEY_MOVEMENT_NOT_SUPPORTED_ON_PRODUCT = "EXTERNAL_MONEY_MOVEMENT_NOT_SUPPORTED_ON_PRODUCT",
  /** The `InstantNetworkTransfer` failed because the fleet feature is not enabled. */
  FLEET_FEATURE_NOT_ENABLED = "FLEET_FEATURE_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because the funding account feature is not enabled. */
  FUNDING_ACCOUNT_FEATURE_NOT_ENABLED = "FUNDING_ACCOUNT_FEATURE_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because the funding card is not supported. */
  FUNDING_CARD_NOT_SUPPORTED = "FUNDING_CARD_NOT_SUPPORTED",
  /** The `InstantNetworkTransfer` failed because the Highnote account feature is not enabled. */
  HIGHNOTE_ACCOUNT_FEATURE_NOT_ENABLED = "HIGHNOTE_ACCOUNT_FEATURE_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because the idempotency key was not provided. */
  IDEMPOTENCY_KEY_NOT_PROVIDED = "IDEMPOTENCY_KEY_NOT_PROVIDED",
  /** The `InstantNetworkTransfer` failed because the source account has insufficient funds. */
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  /** The `InstantNetworkTransfer` failed because of an internal server error. */
  INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
  /** The `InstantNetworkTransfer` failed because inter-financial account transfer rules were not satisfied. */
  INTER_FINANCIAL_ACCOUNT_TRANSFER_RULES_NOT_PASSED = "INTER_FINANCIAL_ACCOUNT_TRANSFER_RULES_NOT_PASSED",
  /** The `InstantNetworkTransfer` failed because the authorization has expired. */
  INVALID_AUTHORIZATION_EXPIRATION = "INVALID_AUTHORIZATION_EXPIRATION",
  /** The `InstantNetworkTransfer` failed because the card number is invalid. */
  INVALID_CARD_NUMBER = "INVALID_CARD_NUMBER",
  /** The `InstantNetworkTransfer` failed because the disbursement amount is invalid. */
  INVALID_DISBURSEMENT_AMOUNT = "INVALID_DISBURSEMENT_AMOUNT",
  /** The `InstantNetworkTransfer` failed because the merchant is invalid. */
  INVALID_MERCHANT = "INVALID_MERCHANT",
  /** The `InstantNetworkTransfer` failed because the track data is invalid. */
  INVALID_TRACK_DATA = "INVALID_TRACK_DATA",
  /** The `InstantNetworkTransfer` failed because the transaction is invalid. */
  INVALID_TRANSACTION = "INVALID_TRANSACTION",
  /** The `InstantNetworkTransfer` failed because the JIT (Just-In-Time) feature is not enabled. */
  JIT_FEATURE_NOT_ENABLED = "JIT_FEATURE_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because the merchant funding feature is not enabled. */
  MERCHANT_FUNDING_FEATURE_NOT_ENABLED = "MERCHANT_FUNDING_FEATURE_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because the merchant settlement feature is not enabled. */
  MERCHANT_SETTLEMENT_FEATURE_NOT_ENABLED = "MERCHANT_SETTLEMENT_FEATURE_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because the account is not organization-owned as required. */
  NOT_AN_ORGANIZATION_OWNED_ACCOUNT = "NOT_AN_ORGANIZATION_OWNED_ACCOUNT",
  /** The `InstantNetworkTransfer` failed because the balance is insufficient to reduce the credit limit. */
  NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT = "NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT",
  /** The `InstantNetworkTransfer` failed because the ODF feature is not enabled. */
  ODF_FEATURE_NOT_ENABLED = "ODF_FEATURE_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because the organization ID was not provided. */
  ORGANIZATION_ID_NOT_PROVIDED = "ORGANIZATION_ID_NOT_PROVIDED",
  /** The `InstantNetworkTransfer` failed because originated ACH unloads are not supported on this product. */
  ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT = "ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT",
  /** The `InstantNetworkTransfer` failed because the partial funding feature is not enabled. */
  PARTIAL_FUNDING_FEATURE_NOT_ENABLED = "PARTIAL_FUNDING_FEATURE_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because the payroll advance feature is not enabled on the account. */
  PAYROLL_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because the payroll employer advance feature is not enabled on the account. */
  PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because the prepaid card feature is not enabled. */
  PREPAID_CARD_FEATURE_NOT_ENABLED = "PREPAID_CARD_FEATURE_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because the pre-authorization has expired. */
  PRE_AUTHORIZATION_EXPIRED = "PRE_AUTHORIZATION_EXPIRED",
  /** The `InstantNetworkTransfer` failed because the product funding feature is not enabled. */
  PRODUCT_FUNDING_FEATURE_NOT_ENABLED = "PRODUCT_FUNDING_FEATURE_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because the product-secured deposit account feature is not enabled. */
  PRODUCT_SECURED_DEPOSIT_ACCOUNT_FEATURE_NOT_ENABLED = "PRODUCT_SECURED_DEPOSIT_ACCOUNT_FEATURE_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because the pseudo balance feature is not enabled. */
  PSEUDO_BALANCE_NOT_ENABLED = "PSEUDO_BALANCE_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because the pull payment did not succeed. */
  PULL_PAYMENT_FAILED = "PULL_PAYMENT_FAILED",
  /** The `InstantNetworkTransfer` failed because the push payment did not succeed. */
  PUSH_PAYMENT_FAILED = "PUSH_PAYMENT_FAILED",
  /** The `InstantNetworkTransfer` failed because the receivable purchase feature is not enabled. */
  RECEIVABLE_PURCHASE_NOT_ENABLED = "RECEIVABLE_PURCHASE_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because the repayment account is not present on the product. */
  REPAYMENT_ACCOUNT_NOT_PRESENT_ON_PRODUCT = "REPAYMENT_ACCOUNT_NOT_PRESENT_ON_PRODUCT",
  /** The `InstantNetworkTransfer` failed because the location is restricted. */
  RESTRICTED_LOCATION = "RESTRICTED_LOCATION",
  /** The `InstantNetworkTransfer` failed because the reward point feature is not enabled. */
  REWARD_POINT_FEATURE_NOT_ENABLED = "REWARD_POINT_FEATURE_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because the transaction needs to be re-entered. */
  RE_ENTER_TRANSACTION = "RE_ENTER_TRANSACTION",
  /** The `InstantNetworkTransfer` failed because it was declined due to risk. */
  RISK_DECLINE = "RISK_DECLINE",
  /** The `InstantNetworkTransfer` failed because the secured deposit account feature is not enabled. */
  SECURED_DEPOSIT_ACCOUNT_FEATURE_NOT_ENABLED = "SECURED_DEPOSIT_ACCOUNT_FEATURE_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because the secure card feature is not enabled. */
  SECURE_CARD_FEATURE_NOT_ENABLED = "SECURE_CARD_FEATURE_NOT_ENABLED",
  /** The `InstantNetworkTransfer` failed because of a special condition with no pickup. */
  SPECIAL_CONDITION_NO_PICK_UP = "SPECIAL_CONDITION_NO_PICK_UP",
  /** The `InstantNetworkTransfer` failed because the card is suspended. */
  SUSPENDED_CARD = "SUSPENDED_CARD",
  /** The `InstantNetworkTransfer` failed because the tenant ID was not provided. */
  TENANT_ID_NOT_PROVIDED = "TENANT_ID_NOT_PROVIDED",
  /** The `InstantNetworkTransfer` failed because the card is terminated. */
  TERMINATED_CARD = "TERMINATED_CARD",
  /** The `InstantNetworkTransfer` failed because the transaction ID was not provided. */
  TRANSACTION_ID_NOT_PROVIDED = "TRANSACTION_ID_NOT_PROVIDED",
  /** The `InstantNetworkTransfer` failed because the transaction is not permitted. */
  TRANSACTION_NOT_PERMITTED = "TRANSACTION_NOT_PERMITTED",
  /** The `InstantNetworkTransfer` failed because the transfer amount is below the program’s minimum reload limit. */
  TRANSFER_AMOUNT_BELOW_MIN_PROGRAM_RELOAD_LIMIT = "TRANSFER_AMOUNT_BELOW_MIN_PROGRAM_RELOAD_LIMIT",
  /** The `InstantNetworkTransfer` failed because the transfer amount exceeds the maximum allowed for credit distribution. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_AGGREGATE_CREDIT_DISTRIBUTION_AMOUNT = "TRANSFER_AMOUNT_EXCEEDING_MAX_AGGREGATE_CREDIT_DISTRIBUTION_AMOUNT",
  /** The `InstantNetworkTransfer` failed because the transfer amount exceeds the program’s maximum card balance. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_CARD_BALANCE = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_CARD_BALANCE",
  /** The `InstantNetworkTransfer` failed because the transfer amount exceeds the program’s maximum load limit. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT",
  /** The `InstantNetworkTransfer` failed because the transfer amount exceeds the program’s maximum reload limit. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_RELOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_RELOAD_LIMIT",
  /** The `InstantNetworkTransfer` failed because the transfer amount is negative or zero. */
  TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO = "TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO",
  /** The `InstantNetworkTransfer` failed because transfers between different products are not allowed. */
  TRANSFER_BETWEEN_PRODUCTS_NOT_ALLOWED = "TRANSFER_BETWEEN_PRODUCTS_NOT_ALLOWED",
  /** The `InstantNetworkTransfer` failed because the accounts do not have the same primary account holder. */
  TRANSFER_CONDITION_SAME_PRIMARY_ACCOUNT_HOLDER_NOT_SATISFIED = "TRANSFER_CONDITION_SAME_PRIMARY_ACCOUNT_HOLDER_NOT_SATISFIED",
  /** The `InstantNetworkTransfer` failed because transfers between the source and destination accounts are not supported. */
  TRANSFER_NOT_SUPPORTED = "TRANSFER_NOT_SUPPORTED",
  /** The `InstantNetworkTransfer` failed because this product does not support this type of transfer. */
  TRANSFER_NOT_SUPPORTED_ON_PRODUCT = "TRANSFER_NOT_SUPPORTED_ON_PRODUCT",
  /** The `InstantNetworkTransfer` failed because the transfer orchestration ID was not provided. */
  TRANSFER_ORCHESTRATION_ID_NOT_PROVIDED = "TRANSFER_ORCHESTRATION_ID_NOT_PROVIDED",
  /** The `InstantNetworkTransfer` failed because the card is not activated. */
  UNACTIVATED_CARD = "UNACTIVATED_CARD",
  /** The `InstantNetworkTransfer` failed because the valid account amount is not supported. */
  VALID_ACCOUNT_AMOUNT_NOT_SUPPORTED = "VALID_ACCOUNT_AMOUNT_NOT_SUPPORTED",
}

/** The source of the funds to transfer. */
export type InstantNetworkTransferSource = {
  __typename?: "InstantNetworkTransferSource";
  /** The amount of funds to source the transfer. */
  amount?: Maybe<Amount>;
  /** If the source is a Highnote `Node`, this will be the `Node`. */
  node?: Maybe<InstantNetworkTransferSourceNode>;
};

/** The possible sources of the `InstantNetworkTransfer`. */
export type InstantNetworkTransferSourceNode =
  | FinancialAccount
  | PaymentMethodToken;

/** Indicates that this `PaymentInstrument` can be used as the source ID for `InstantNetworkTransfer`. */
export type InstantNetworkTransferSourcePaymentInstrumentCapability = {
  __typename?: "InstantNetworkTransferSourcePaymentInstrumentCapability";
  /** The date and time, in ISO 8601 format, the capability was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The current status for this capability. If it is `ENABLED`, the `PaymentInstrument` has this capability. */
  status?: Maybe<InstantNetworkTransferSourcePaymentInstrumentCapabilityStatus>;
  /** The date and time, in ISO 8601 format, the capability was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** The `PaymentTransaction` that originated this capability. */
  verificationPaymentTransaction?: Maybe<PaymentTransaction>;
};

/** The possible statuses of the `InstantNetworkTransferSourcePaymentInstrumentCapabilityStatus` */
export enum InstantNetworkTransferSourcePaymentInstrumentCapabilityStatus {
  /** The `PaymentInstrument` has the `InstantNetworkTransfer` capability disabled. */
  DISABLED = "DISABLED",
  /** The `PaymentInstrument` has the `InstantNetworkTransfer` capability enabled. */
  ENABLED = "ENABLED",
  /** The `PaymentInstrument` is undergoing a review to determine the status. */
  REQUIRES_REVIEW = "REQUIRES_REVIEW",
}

/** The status of a `InstantNetworkTransfer`. */
export enum InstantNetworkTransferStatus {
  /** The `InstantNetworkTransfer` has completed. */
  COMPLETED = "COMPLETED",
  /** The `InstantNetworkTransfer` has failed. */
  FAILED = "FAILED",
  /** The `InstantNetworkTransfer` is pending. */
  PENDING = "PENDING",
}

export type InstantSettlementTransaction = Node & {
  __typename?: "InstantSettlementTransaction";
  /** The `AmountImpact` that has been carried over from the last settlement transaction. */
  carryoverAmount?: Maybe<AmountImpact>;
  /** The date and time, in ISO 8601 format, when this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Events that have started due to this `InstantSettlementTransaction`. */
  events?: Maybe<Array<InstantSettlementTransactionEvent>>;
  /** The `FinancialAccount` used for fees. */
  feeAccount?: Maybe<FinancialAccount>;
  /** Global ID used to reference this object. */
  id: Scalars["ID"];
  /** The `FinancialAccount` used for merchant funding. */
  merchantFundingAccount?: Maybe<FinancialAccount>;
  /** The `PaymentCardNetwork` for which this settlement transaction occurred. */
  network?: Maybe<PaymentCardNetwork>;
  /** The originating `FinancialAccount`. */
  originatingAccount?: Maybe<FinancialAccount>;
  /** The `AmountImpact` for the pull payment settlement. */
  pullPaymentSettlementAmount?: Maybe<AmountImpact>;
  /** The `AmountImpact` for the pull payment settlement fees. */
  pullPaymentSettlementFeeAmount?: Maybe<AmountImpact>;
  /** The `AmountImpact` for the push payment settlement. */
  pushPaymentSettlementAmount?: Maybe<AmountImpact>;
  /** The `AmountImpact` for the push payment settlement fees. */
  pushPaymentSettlementFeeAmount?: Maybe<AmountImpact>;
  /** The receiving `FinancialAccount`. */
  receivingAccount?: Maybe<FinancialAccount>;
  /** The `AmountImpact` for settlement. */
  settlementAmount?: Maybe<AmountImpact>;
  /** The `RoundingStrategy` for the `settlementAmount`. */
  settlementAmountRoundingStrategy?: Maybe<RoundingStrategy>;
  /** The status of the `InstantSettlementTransaction`. */
  status?: Maybe<InstantSettlementTransactionStatus>;
  /** The date and time, in ISO 8601 format, when this object was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

export type InstantSettlementTransactionEvent = Node & {
  __typename?: "InstantSettlementTransactionEvent";
  /**
   * The `AchTransfer` that this event is related to.
   *
   * Populated when the eventType is ACH.
   */
  achTransfer?: Maybe<OriginatedAchTransfer>;
  /** The date and time, in ISO 8601 format, when this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The type of event. */
  eventType?: Maybe<InstantSettlementTransactionEventType>;
  /** Global ID used to reference this object. */
  id: Scalars["ID"];
  /**
   * The `InstantSettlementTransaction` that this event is related to.
   *
   * Populated when the eventType is FEE_VARIANCE_TRANSFER.
   */
  instantSettlementTransaction?: Maybe<InstantSettlementTransaction>;
  /** The status of the event. */
  status?: Maybe<InstantSettlementTransactionStatus>;
  /** The date and time, in ISO 8601 format, when this object was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The type of event on an `InstantSettlementTransaction`. */
export enum InstantSettlementTransactionEventType {
  /** An ACH event. */
  ACH = "ACH",
  /** A fee variance transfer event. */
  FEE_VARIANCE_TRANSFER = "FEE_VARIANCE_TRANSFER",
}

/** The status of an `InstantSettlementTransaction`. */
export enum InstantSettlementTransactionStatus {
  /** The `InstantSettlementTransaction` has completed. */
  COMPLETED = "COMPLETED",
  /** The `InstantSettlementTransaction` has failed. */
  FAILED = "FAILED",
  /** The `InstantSettlementTransaction` is pending. */
  PENDING = "PENDING",
}

/** The different environments available on the Highnote platform. */
export enum IntegrationEnvironment {
  LIVE = "LIVE",
  TEST = "TEST",
}

/** Hold status of an ACH integrator initiated transaction */
export enum IntegratorInitiatedAchHoldStatus {
  /** The ACH Transaction had a hold but it has been removed */
  HOLD_REMOVED = "HOLD_REMOVED",
  /** The ACH Transaction is not on hold */
  NO_HOLDS = "NO_HOLDS",
  /** The ACH Transaction is currently on hold */
  ON_HOLD = "ON_HOLD",
  /** The hold status is unspecified */
  UNSPECIFIED = "UNSPECIFIED",
}

/** Input for filtering by `IntegratorInitiatedACHHoldStatusFilterInput`. */
export type IntegratorInitiatedAchHoldStatusFilterInput = {
  equals?: InputMaybe<IntegratorInitiatedAchHoldStatus>;
  excludes?: InputMaybe<Array<IntegratorInitiatedAchHoldStatus>>;
  includes?: InputMaybe<Array<IntegratorInitiatedAchHoldStatus>>;
  notEquals?: InputMaybe<IntegratorInitiatedAchHoldStatus>;
};

/** Status of an integrator initiated ACH transfer that has been generated by Highnote. */
export enum IntegratorInitiatedAchStatus {
  /** You requested to cancel the transfer. */
  CANCELED = "CANCELED",
  /** The transfer failed. Additional details are available in IntegratorInitiatedACHStatusCode. */
  FAILED = "FAILED",
  /** A transfer request has been initiated. */
  INITIATED = "INITIATED",
  /** The transfer has successfully been processed by the bank and funds are available. */
  PROCESSED = "PROCESSED",
  /** The transfer is processing at Highnote and at the bank, but funds are not available yet. */
  PROCESSING = "PROCESSING",
  /** The transfer has been returned by the bank. */
  RETURNED = "RETURNED",
}

/** Details about the status of the ACH transfer. */
export type IntegratorInitiatedAchStatusDetails =
  | FailureIntegratorInitiatedAchStatus
  | NonFailureIntegratorInitiatedAchStatus;

/** Input for filtering by `IntegratorInitiatedACHStatusFilterInput`. */
export type IntegratorInitiatedAchStatusFilterInput = {
  equals?: InputMaybe<IntegratorInitiatedAchStatus>;
  excludes?: InputMaybe<Array<IntegratorInitiatedAchStatus>>;
  includes?: InputMaybe<Array<IntegratorInitiatedAchStatus>>;
  notEquals?: InputMaybe<IntegratorInitiatedAchStatus>;
};

/** Additional details regarding a FAILED or RETURNED transfer. */
export enum IntegratorInitiatedAchStatusReasonCode {
  /** The `fromFinancialAccount` and `toFinancialAccount` do not belong to the same product. */
  ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT = "ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT",
  /** R16 - The account is frozen. */
  ACCOUNT_FROZEN = "ACCOUNT_FROZEN",
  /** Loading funds via ACH is not supported. */
  ACH_LOAD_NOT_SUPPORTED = "ACH_LOAD_NOT_SUPPORTED",
  /** R19 - There is an error in the amount field. */
  AMOUNT_FIELD_ERROR = "AMOUNT_FIELD_ERROR",
  /** R07 - The Authorization was revoked by Customer. */
  AUTHORIZATION_REVOKED_BY_CUSTOMER = "AUTHORIZATION_REVOKED_BY_CUSTOMER",
  /** R11 - The account does not have the required commercial pay in full account feature enabled. */
  COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED = "COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED",
  /** The account does not have the required corporate bank account feature enabled. */
  CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED = "CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED",
  /** R11 - The credit limit is not set on the account. */
  CREDIT_LIMIT_NOT_SET_ON_ACCOUNT = "CREDIT_LIMIT_NOT_SET_ON_ACCOUNT",
  /** The amount of the transfer does not match the currency of the Highnote account. */
  CURRENCY_MISMATCH_WITH_HIGHNOTE_ACCOUNT = "CURRENCY_MISMATCH_WITH_HIGHNOTE_ACCOUNT",
  /** R24 - Resulted in a Duplicate Entry. */
  DUPLICATE_ENTRY = "DUPLICATE_ENTRY",
  /** R11 - The transfer is not in accordance with the terms of the authorization. */
  ENTRY_NOT_IN_ACCORDANCE_WITH_TERMS_OF_AUTHORIZATION = "ENTRY_NOT_IN_ACCORDANCE_WITH_TERMS_OF_AUTHORIZATION",
  /** The external account has been closed. */
  EXTERNAL_ACCOUNT_CLOSED = "EXTERNAL_ACCOUNT_CLOSED",
  /** No matching external account was found. */
  EXTERNAL_ACCOUNT_NOT_FOUND = "EXTERNAL_ACCOUNT_NOT_FOUND",
  /** The Highnote account has been closed. */
  HIGHNOTE_ACCOUNT_CLOSED = "HIGHNOTE_ACCOUNT_CLOSED",
  /** No matching Highnote account was found. */
  HIGHNOTE_ACCOUNT_NOT_FOUND = "HIGHNOTE_ACCOUNT_NOT_FOUND",
  /** R18 - Has an Improper Effective entry date. */
  IMPROPER_EFFECTIVE_ENTRY_DATE = "IMPROPER_EFFECTIVE_ENTRY_DATE",
  /** This was a debit from an en external account did not have enough funds. */
  INSUFFICIENT_FUNDS_IN_EXTERNAL_ACCOUNT = "INSUFFICIENT_FUNDS_IN_EXTERNAL_ACCOUNT",
  /** This was a debit from an account at Highnote which did not have enough funds. */
  INSUFFICIENT_FUNDS_IN_HIGHNOTE_ACCOUNT = "INSUFFICIENT_FUNDS_IN_HIGHNOTE_ACCOUNT",
  /** There is an internal error with the transfer. */
  INTERNAL_ERROR = "INTERNAL_ERROR",
  /** R04 - Has an Invalid Account Number. */
  INVALID_ACCOUNT_NUMBER = "INVALID_ACCOUNT_NUMBER",
  /** R21 - Has an Invalid Company ID Number. */
  INVALID_COMPANY_ID_NUMBER = "INVALID_COMPANY_ID_NUMBER",
  /** R22 - Has an Invalid Individual ID Number. */
  INVALID_INDIVIDUAL_ID_NUMBER = "INVALID_INDIVIDUAL_ID_NUMBER",
  /** R20 - Is a Non Transactional Account. */
  NON_TRANSACTION_ACCOUNT = "NON_TRANSACTION_ACCOUNT",
  /** R08 - The Payment was stopped. */
  PAYMENT_STOPPED = "PAYMENT_STOPPED",
  /** The account does not have the required payroll advance feature enabled. */
  PAYROLL_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED",
  /** The account does not have the required payroll employer advance feature enabled. */
  PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED",
  /** R06 - Funds were returned per OFDI Request. */
  RETURNED_PER_ODFI_REQUEST = "RETURNED_PER_ODFI_REQUEST",
  /** The account does not have the required secure card feature enabled. */
  SECURE_CARD_FEATURE_NOT_ENABLED = "SECURE_CARD_FEATURE_NOT_ENABLED",
  /** R29 - The Transaction was not Authorized By Account Holder. */
  TRANSACTION_NOT_AUTHORIZED_BY_ACCOUNT_HOLDER = "TRANSACTION_NOT_AUTHORIZED_BY_ACCOUNT_HOLDER",
  /** The transfer amount is below the minimum amount to reload. */
  TRANSFER_AMOUNT_BELOW_MIN_RELOAD_LIMIT = "TRANSFER_AMOUNT_BELOW_MIN_RELOAD_LIMIT",
  /** The transfer exceeds the maximum load limit. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_LOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_LOAD_LIMIT",
  /** The transfer exceeds the maximum reload limit. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_RELOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_RELOAD_LIMIT",
  /** R05 - Is an Unauthorized Debit to Consumer Account Using Corporate SEC Code. */
  UNAUTHORIZED_CONSUMER_DEBIT_USING_CORPORATE_SEC_CODE = "UNAUTHORIZED_CONSUMER_DEBIT_USING_CORPORATE_SEC_CODE",
  /** R10 - Is an Unauthorized, Improper, Ineligible, or Incomplete Transaction. */
  UNAUTHORIZED_IMPROPER_INELIGIBLE_OR_INCOMPLETE_TRANSACTION = "UNAUTHORIZED_IMPROPER_INELIGIBLE_OR_INCOMPLETE_TRANSACTION",
  /** R09 - Transaction represents Uncollected Funds. */
  UNCOLLECTED_FUNDS = "UNCOLLECTED_FUNDS",
}

/** Input for filtering by `IntegratorInitiatedACHStatusReasonCodeFilterInput`. */
export type IntegratorInitiatedAchStatusReasonCodeFilterInput = {
  equals?: InputMaybe<IntegratorInitiatedAchStatusReasonCode>;
  excludes?: InputMaybe<Array<IntegratorInitiatedAchStatusReasonCode>>;
  includes?: InputMaybe<Array<IntegratorInitiatedAchStatusReasonCode>>;
  notEquals?: InputMaybe<IntegratorInitiatedAchStatusReasonCode>;
};

/**
 * An ACH transfer initiated by Highnote and sent to an external bank.
 *
 * [ACH](https://en.wikipedia.org/wiki/Automated_clearing_house) is a method of transferring funds between banks.
 */
export type IntegratorInitiatedAchTransfer = {
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The Card Product associated to the Financial Account. */
  cardProduct?: Maybe<CardProduct>;
  /** The ID for Highnote. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /**
   * The name of the company that initiated the ACH transfer.
   *
   * This will always be Highnote.
   */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Descriptive fields about the transfer which may show up on bank reports. */
  descriptor?: Maybe<AchDescriptor>;
  /**
   * The account sending the funds.
   *
   * Exactly one of `fromFinancialAccount` and `toFinancialAccount` will be an `ExternalFinancialBankAccount` and the other will be a `FinancialAccount`.
   */
  fromFinancialAccount?: Maybe<AllFinancialAccount>;
  /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
  fundsAvailableDate?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the transfer in operations. */
  id: Scalars["ID"];
  /** The ledgers affected by the transfer. */
  ledgers?: Maybe<Array<Ledger>>;
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
  /** The date this transaction was returned, in ISO 8601 format. */
  returnDate?: Maybe<Scalars["String"]>;
  /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
  settlementDate?: Maybe<Scalars["String"]>;
  /** The status of the integrator initiated ACH transfer. */
  status?: Maybe<IntegratorInitiatedAchStatusDetails>;
  /**
   * The account receiving the funds.
   *
   * Exactly one of `fromFinancialAccount` and `toFinancialAccount` will be an `ExternalFinancialBankAccount` and the other will be a `FinancialAccount`.
   */
  toFinancialAccount?: Maybe<AllFinancialAccount>;
  /** A unique 15 digit number assigned by the originator to identify the transfer. */
  traceNumber?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/**
 * An ACH transfer initiated by Highnote and sent to an external bank.
 *
 * [ACH](https://en.wikipedia.org/wiki/Automated_clearing_house) is a method of transferring funds between banks.
 */
export type IntegratorInitiatedAchTransferLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** The connection type for Integrator Initiated ACH Transfers. */
export type IntegratorInitiatedAchTransferConnection = {
  __typename?: "IntegratorInitiatedACHTransferConnection";
  /** A list of edges. */
  edges?: Maybe<Array<IntegratorInitiatedAchTransferEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for an Integrator Initiated ACH Transfer. */
export type IntegratorInitiatedAchTransferEdge = {
  __typename?: "IntegratorInitiatedACHTransferEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The ACH Transfer. */
  node?: Maybe<IntegratorInitiatedAchTransferEdgeNode>;
};

export type IntegratorInitiatedAchTransferEdgeNode =
  | IntegratorInitiatedFundsDepositAchTransfer
  | IntegratorInitiatedFundsWithdrawalAchTransfer
  | SecureCardBalanceRepaymentAchTransfer
  | SecureDepositAchTransfer;

/** Inputs for filtering Integrator Initiated ACH Transfer data. */
export type IntegratorInitiatedAchTransferFilterInput = {
  cardProductId?: InputMaybe<StringSearchFilterInput>;
  companyEntryDescription?: InputMaybe<StringSearchFilterInput>;
  holdStatus?: InputMaybe<IntegratorInitiatedAchHoldStatusFilterInput>;
  reasonCode?: InputMaybe<IntegratorInitiatedAchStatusReasonCodeFilterInput>;
  returnDate?: InputMaybe<TimestampFilterInput>;
  settlementDate?: InputMaybe<TimestampFilterInput>;
  status?: InputMaybe<IntegratorInitiatedAchStatusFilterInput>;
  transactionAmount?: InputMaybe<MoneyFilterInput>;
  transactionType?: InputMaybe<IntegratorInitiatedTransferTypeFilterInput>;
};

/** A withdrawal of funds from an `ExternalFinancialAccount` to a `FinancialAccount`. */
export type IntegratorInitiatedFundsDepositAchTransfer =
  ElectronicFundsTransfer &
    IntegratorInitiatedAchTransfer &
    Node & {
      __typename?: "IntegratorInitiatedFundsDepositACHTransfer";
      /** The amount of the transfer. */
      amount?: Maybe<Amount>;
      /** The Card Product associated to the Financial Account. */
      cardProduct?: Maybe<CardProduct>;
      /** The ID for Highnote. */
      companyIdentifier?: Maybe<Scalars["String"]>;
      /**
       * The name of the company that initiated the ACH transfer.
       *
       * This will always be Highnote.
       */
      companyName?: Maybe<Scalars["String"]>;
      /** The date and time, in ISO 8601 format, the transfer was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** Descriptive fields about the transfer which may show up on bank reports. */
      descriptor?: Maybe<AchDescriptor>;
      /**
       * The account sending the funds.
       *
       * This will always be a `FinancialAccount`.
       */
      fromFinancialAccount?: Maybe<AllFinancialAccount>;
      /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
      fundsAvailableDate?: Maybe<Scalars["String"]>;
      /** Global ID used to reference the transfer in operations. */
      id: Scalars["ID"];
      /** The ledgers affected by the transfer. */
      ledgers?: Maybe<Array<Ledger>>;
      /**
       * This field contains payment-related information provided by the originator of the transaction.
       * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
       * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
       *
       * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
       *
       * Please note that this information may or may not be displayed to the recipient, based on the bank's
       * capabilities, and method of access (i.e., online banking, statement, etc.)
       */
      paymentRelatedInformation?: Maybe<Scalars["String"]>;
      /** The date this transaction was returned, in ISO 8601 format. */
      returnDate?: Maybe<Scalars["String"]>;
      /** A flag that indicates that this transaction was Same-Day ACH. */
      sameDay?: Maybe<Scalars["Boolean"]>;
      /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
      settlementDate?: Maybe<Scalars["String"]>;
      /** The status of the integrator initiated ACH transfer. */
      status?: Maybe<IntegratorInitiatedAchStatusDetails>;
      /**
       * The account receiving the funds.
       *
       * This will always be a type of `ExternalFinancialAccount`.
       */
      toFinancialAccount?: Maybe<AllFinancialAccount>;
      /** A unique 15 digit number assigned by the originator to identify the transfer. */
      traceNumber?: Maybe<Scalars["String"]>;
      /** The date and time, in ISO 8601 format, the transfer was last updated. */
      updatedAt?: Maybe<Scalars["String"]>;
    };

/** A withdrawal of funds from an `ExternalFinancialAccount` to a `FinancialAccount`. */
export type IntegratorInitiatedFundsDepositAchTransferLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** A financial event that represents ACH funds deposit. */
export type IntegratorInitiatedFundsDepositAchTransferEvent = AchTransferEvent &
  Node & {
    __typename?: "IntegratorInitiatedFundsDepositACHTransferEvent";
    /** The amount of the transfer. */
    amount?: Maybe<Amount>;
    /** Company entered value for the type of ACH. */
    companyEntryDescription?: Maybe<Scalars["String"]>;
    /**
     * The Company Identifier is a 10-position alphameric code used to identify an Originator of the ACH transaction. It may begin with an ANSI one-digit Identification Code Designator (ICD), followed by the Identification Number.
     *
     * |`Identification Code Designator (ICD)`    | `ANSI Identification Number` | Example                                                                         |
     * | ---------------------------------------- | ---------------------------- | ------------------------------------------------------------------------------- |
     * |`IRS Employer Identification Number (EIN)`| 1                            | 1234567890 for an Originator with 234567890 EIN                                 |
     * |`Data Universal Numbering Systems (DUNS)` | 3                            | 30008016958 for an Originator with 0008016958 DUNS                              |
     * |`User Assigned Number`                    | 9                            | 9111111111 for an Originator with 111111111 under assigned Identification Number|
     */
    companyIdentifier?: Maybe<Scalars["String"]>;
    /** The name of the company that initiated the ACH transfer. */
    companyName?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the transfer event was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The account sending the funds. */
    fromFinancialAccount?: Maybe<ExternalFinancialAccount>;
    /** Global ID used to reference the transfer in operations. */
    id: Scalars["ID"];
    /** The date this transaction was returned, in ISO 8601 format. */
    returnDate?: Maybe<Scalars["String"]>;
    /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
    settlementDate?: Maybe<Scalars["String"]>;
    /** The status of the integrator initiated ACH transfer. */
    status?: Maybe<IntegratorInitiatedAchStatusDetails>;
    /** The account receiving the funds. */
    toFinancialAccount?: Maybe<FinancialAccount>;
    /** The `ElectronicFundsTransfer` that triggered this event. */
    transfer?: Maybe<ElectronicFundsTransfer>;
  };

/** A withdrawal of funds from a `FinancialAccount` to an `ExternalFinancialAccount`. */
export type IntegratorInitiatedFundsWithdrawalAchTransfer =
  ElectronicFundsTransfer &
    IntegratorInitiatedAchTransfer &
    Node & {
      __typename?: "IntegratorInitiatedFundsWithdrawalACHTransfer";
      /** The amount of the transfer. */
      amount?: Maybe<Amount>;
      /** The Card Product associated to the Financial Account. */
      cardProduct?: Maybe<CardProduct>;
      /** The ID for Highnote. */
      companyIdentifier?: Maybe<Scalars["String"]>;
      /**
       * The name of the company that initiated the ACH transfer.
       *
       * This will always be Highnote.
       */
      companyName?: Maybe<Scalars["String"]>;
      /** The date and time, in ISO 8601 format, the transfer was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** Descriptive fields about the transfer which may show up on bank reports. */
      descriptor?: Maybe<AchDescriptor>;
      /**
       * The account sending the funds.
       *
       * This will always be a `FinancialAccount`.
       */
      fromFinancialAccount?: Maybe<AllFinancialAccount>;
      /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
      fundsAvailableDate?: Maybe<Scalars["String"]>;
      /** Global ID used to reference the transfer in operations. */
      id: Scalars["ID"];
      /** The ledgers affected by the transfer. */
      ledgers?: Maybe<Array<Ledger>>;
      /**
       * This field contains payment-related information provided by the originator of the transaction.
       * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
       * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
       *
       * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
       *
       * Please note that this information may or may not be displayed to the recipient, based on the bank's
       * capabilities, and method of access (i.e., online banking, statement, etc.)
       */
      paymentRelatedInformation?: Maybe<Scalars["String"]>;
      /** The date this transaction was returned, in ISO 8601 format. */
      returnDate?: Maybe<Scalars["String"]>;
      /** A flag that indicates that this transaction was Same-Day ACH. */
      sameDay?: Maybe<Scalars["Boolean"]>;
      /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
      settlementDate?: Maybe<Scalars["String"]>;
      /** The status of the integrator initiated ACH transfer. */
      status?: Maybe<IntegratorInitiatedAchStatusDetails>;
      /**
       * The account receiving the funds.
       *
       * This will always be a type of `ExternalFinancialAccount`.
       */
      toFinancialAccount?: Maybe<AllFinancialAccount>;
      /** A unique 15 digit number assigned by the originator to identify the transfer. */
      traceNumber?: Maybe<Scalars["String"]>;
      /** The date and time, in ISO 8601 format, the transfer was last updated. */
      updatedAt?: Maybe<Scalars["String"]>;
    };

/** A withdrawal of funds from a `FinancialAccount` to an `ExternalFinancialAccount`. */
export type IntegratorInitiatedFundsWithdrawalAchTransferLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** A financial event that represents ACH funds withdrawal. */
export type IntegratorInitiatedFundsWithdrawalAchTransferEvent =
  AchTransferEvent &
    Node & {
      __typename?: "IntegratorInitiatedFundsWithdrawalACHTransferEvent";
      /** The amount of the transfer. */
      amount?: Maybe<Amount>;
      /** Company entered value for the type of ACH. */
      companyEntryDescription?: Maybe<Scalars["String"]>;
      /**
       * The Company Identifier is a 10-position alphameric code used to identify an Originator of the ACH transaction. It may begin with an ANSI one-digit Identification Code Designator (ICD), followed by the Identification Number.
       *
       * |`Identification Code Designator (ICD)`    | `ANSI Identification Number` | Example                                                                         |
       * | ---------------------------------------- | ---------------------------- | ------------------------------------------------------------------------------- |
       * |`IRS Employer Identification Number (EIN)`| 1                            | 1234567890 for an Originator with 234567890 EIN                                 |
       * |`Data Universal Numbering Systems (DUNS)` | 3                            | 30008016958 for an Originator with 0008016958 DUNS                              |
       * |`User Assigned Number`                    | 9                            | 9111111111 for an Originator with 111111111 under assigned Identification Number|
       */
      companyIdentifier?: Maybe<Scalars["String"]>;
      /** The name of the company that initiated the ACH transfer. */
      companyName?: Maybe<Scalars["String"]>;
      /** The date and time, in ISO 8601 format, the transfer event was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** The account sending the funds. */
      fromFinancialAccount?: Maybe<FinancialAccount>;
      /** Global ID used to reference the transfer in operations. */
      id: Scalars["ID"];
      /** The date this transaction was returned, in ISO 8601 format. */
      returnDate?: Maybe<Scalars["String"]>;
      /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
      settlementDate?: Maybe<Scalars["String"]>;
      /** The status of the integrator initiated ACH transfer. */
      status?: Maybe<IntegratorInitiatedAchStatusDetails>;
      /** The account receiving the funds. */
      toFinancialAccount?: Maybe<ExternalFinancialAccount>;
      /** The `ElectronicFundsTransfer` that triggered this event. */
      transfer?: Maybe<ElectronicFundsTransfer>;
    };

/** Transaction Type of an integrator initiated ACH transfer. */
export enum IntegratorInitiatedTransferType {
  /** Funds deposit filters to `IntegratorInitiatedFundsDepositACHTransfer`. */
  FUNDS_DEPOSIT = "FUNDS_DEPOSIT",
  /** Funds withdrawal filters to `IntegratorInitiatedFundsWithdrawalACHTransfer`. */
  FUNDS_WITHDRAWAL = "FUNDS_WITHDRAWAL",
  /** Repayment filters to `SecureCardBalanceRepaymentACHTransfer`. */
  REPAYMENT = "REPAYMENT",
  /** Secure Deposit filters to `SecureDepositACHTransfer`. */
  SECURE_DEPOSIT = "SECURE_DEPOSIT",
}

/** Input for filtering by `IntegratorInitiatedTransferType`. */
export type IntegratorInitiatedTransferTypeFilterInput = {
  equals?: InputMaybe<IntegratorInitiatedTransferType>;
  excludes?: InputMaybe<Array<IntegratorInitiatedTransferType>>;
  includes?: InputMaybe<Array<IntegratorInitiatedTransferType>>;
  notEquals?: InputMaybe<IntegratorInitiatedTransferType>;
};

/** A movement of money within the Highnote platform. */
export type InterFinancialAccountTransfer = Node & {
  __typename?: "InterFinancialAccountTransfer";
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The source financial account of the transfer. */
  fromFinancialAccount?: Maybe<FinancialAccount>;
  /** Global ID used to reference the transfer in operations. */
  id: Scalars["ID"];
  /** The outcomes of running rules on the transfer. */
  interFinancialAccountTransferRuleResults?: Maybe<
    Array<InterFinancialAccountTransferRuleResult>
  >;
  /** The ledgers affected by the transfer. */
  ledgers?: Maybe<Array<Ledger>>;
  /** A description of the transfer for reference. */
  memo?: Maybe<Scalars["String"]>;
  /** The purpose for the transfer. */
  purpose?: Maybe<TransferPurpose>;
  /** The current status of the transfer. */
  status?: Maybe<InterFinancialAccountTransferStatus>;
  /** The reason for the current status. */
  statusReason?: Maybe<InterFinancialAccountTransferStatusReasonCode>;
  /** The receiving financial account of the transfer. */
  toFinancialAccount?: Maybe<FinancialAccount>;
  /** The type of activity associated with this transfer. */
  transferActivityType?: Maybe<InterFinancialAccountTransferActivityType>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** A movement of money within the Highnote platform. */
export type InterFinancialAccountTransferLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** The subject account type to which the inter financial account transfer rule applies. */
export enum InterFinancialAccountTransferAccountType {
  /** The account from which an inter financial account transfer moves funds. */
  SOURCE = "SOURCE",
}

/** The type of activity associated with the InterFinancialAccountTransfer. */
export enum InterFinancialAccountTransferActivityType {
  /** Transfer for payroll advance. */
  ACCOUNT_PAYROLL_ADVANCE = "ACCOUNT_PAYROLL_ADVANCE",
  /** Transfer for payroll advance repayment. */
  ACCOUNT_PAYROLL_ADVANCE_REPAYMENT = "ACCOUNT_PAYROLL_ADVANCE_REPAYMENT",
  /** Transfer for adjustment. */
  ADJUSTMENT = "ADJUSTMENT",
  /** `Transfer` of cash reward points redemption to this account. */
  CASH_REDEEM_REWARD_POINTS = "CASH_REDEEM_REWARD_POINTS",
  /** `Transfer` of cash reward points redemption reversal to this account. */
  CASH_REDEEM_REWARD_POINTS_REVERSAL = "CASH_REDEEM_REWARD_POINTS_REVERSAL",
  /** Chargeback adjustments made to the account to revoke the Provisional Credit after the Chargeback has been decided against it. */
  CHARGEBACK_LOSS = "CHARGEBACK_LOSS",
  /** Provisional credit issued for a network chargeback. */
  CHARGEBACK_PROVISIONAL_CREDIT = "CHARGEBACK_PROVISIONAL_CREDIT",
  /** Chargeback adjustments made to the account to award the Provisional Credit after the Chargeback has been decided in its favor. */
  CHARGEBACK_WIN = "CHARGEBACK_WIN",
  /** Chargeback adjustments made to the account to award the Provisional Credit after the Chargeback has been decided in its favor. */
  CHARGEBACK_WIN_WITHOUT_PROVISIONAL_CREDIT = "CHARGEBACK_WIN_WITHOUT_PROVISIONAL_CREDIT",
  /** Charge off an unrecoverable balance receivable on this account. */
  CHARGE_OFF = "CHARGE_OFF",
  /** Remove line of credit after an account closure. */
  CLOSE_LINE_OF_CREDIT = "CLOSE_LINE_OF_CREDIT",
  /** Decreasing the pseudo balance for a `FinancialAccount`. */
  DECREASE_PSEUDO_BALANCE = "DECREASE_PSEUDO_BALANCE",
  /** Decreasing an existing pseudo limit for a `FinancialAccount`. */
  DECREASE_PSEUDO_LIMIT = "DECREASE_PSEUDO_LIMIT",
  /** transfer for issuer-liable dispute adjustment. */
  DISPUTE_ADJUSTMENT_ISSUER_LIABLE = "DISPUTE_ADJUSTMENT_ISSUER_LIABLE",
  /** transfer for dispute adjustment reversal. */
  DISPUTE_ADJUSTMENT_REVERSAL = "DISPUTE_ADJUSTMENT_REVERSAL",
  /** A credit was issued for a transaction dispute that was not sent as a chargeback to the network. */
  DISPUTE_CREDIT = "DISPUTE_CREDIT",
  /** transfer for issuer-liable dispute where the chargeback was lost. */
  DISPUTE_WON_CHARGEBACK_LOSS_ISSUER_LIABLE = "DISPUTE_WON_CHARGEBACK_LOSS_ISSUER_LIABLE",
  /** Transfer of earned credit to this account. */
  EARNED_CREDIT = "EARNED_CREDIT",
  /** Reversing transfer of earned credit to this account. */
  EARNED_CREDIT_REVERSAL = "EARNED_CREDIT_REVERSAL",
  /** This transfer is a generic transfer. */
  GENERAL = "GENERAL",
  /** `Transfer` of manual adjustment. */
  GENERAL_ADJUSTMENT = "GENERAL_ADJUSTMENT",
  /** Transfer of goods and services credit to this account. */
  GOODS_AND_SERVICES = "GOODS_AND_SERVICES",
  /** Increasing the pseudo balance for a `FinancialAccount`. */
  INCREASE_PSEUDO_BALANCE = "INCREASE_PSEUDO_BALANCE",
  /** Increasing an existing pseudo limit for a `FinancialAccount`. */
  INCREASE_PSEUDO_LIMIT = "INCREASE_PSEUDO_LIMIT",
  /** transfer for interchange sweep. */
  INTERCHANGE_SWEEP = "INTERCHANGE_SWEEP",
  /** Intra company transfer of credit to this account. */
  INTRA_COMPANY = "INTRA_COMPANY",
  /** transfer for issuer balance migration. */
  ISSUER_BALANCE_MIGRATION = "ISSUER_BALANCE_MIGRATION",
  /** This transfer funds a payment card `FinancialAccount` from a funding `FinancialAccount`. */
  LOAD_PAYMENT_CARD_ACCOUNT = "LOAD_PAYMENT_CARD_ACCOUNT",
  /** Transfer for merchant payout. */
  MERCHANT_PAYOUT = "MERCHANT_PAYOUT",
  /** `Transfer` for a requested routes. */
  PAYOUT = "PAYOUT",
  /** Transfer for payroll. */
  PAYROLL = "PAYROLL",
  /** Payroll advance funds to an employee financial account. */
  PAYROLL_ADVANCE = "PAYROLL_ADVANCE",
  /** This transfer resulted from an account charge off. */
  PAYROLL_ADVANCE_CHARGE_OFF = "PAYROLL_ADVANCE_CHARGE_OFF",
  /** Payroll advance repayment from an employee financial account. */
  PAYROLL_ADVANCE_REPAYMENT = "PAYROLL_ADVANCE_REPAYMENT",
  /** Transfer for payroll advance repayment reversal. */
  PAYROLL_ADVANCE_REPAYMENT_REVERSAL = "PAYROLL_ADVANCE_REPAYMENT_REVERSAL",
  /** Transfer for payroll advance reversal. */
  PAYROLL_ADVANCE_REVERSAL = "PAYROLL_ADVANCE_REVERSAL",
  /** This transfer represents the remaining payroll deposit after advance repayment. */
  PAYROLL_DEPOSIT = "PAYROLL_DEPOSIT",
  /** Transfer for payroll reversal. */
  PAYROLL_REVERSAL = "PAYROLL_REVERSAL",
  /** transfer for peer to peer payment. */
  PEER_TO_PEER = "PEER_TO_PEER",
  /** transfer for peer to peer payment reversal. */
  PEER_TO_PEER_REVERSAL = "PEER_TO_PEER_REVERSAL",
  /** Receivables purchase agreement. Receivables were purchased from the bank. */
  RECEIVABLE_PURCHASE = "RECEIVABLE_PURCHASE",
  /** Receivables purchase interest. */
  RECEIVABLE_PURCHASE_INTEREST = "RECEIVABLE_PURCHASE_INTEREST",
  /** Reversal of a receivables purchase interest. */
  RECEIVABLE_PURCHASE_INTEREST_REVERSAL = "RECEIVABLE_PURCHASE_INTEREST_REVERSAL",
  /** Reversal of a receivables purchase agreement. */
  RECEIVABLE_PURCHASE_REVERSAL = "RECEIVABLE_PURCHASE_REVERSAL",
  /** Account Holder’s secured deposit used to cover an outstanding balance payable on the Financial Account. */
  RECOVER_SECURED_DEPOSIT = "RECOVER_SECURED_DEPOSIT",
  /** transfer for account repayment. */
  REPAYMENT = "REPAYMENT",
  /** `Transfer` for extra EWA repayment */
  REPAYMENT_ADJUSTMENT = "REPAYMENT_ADJUSTMENT",
  /** transfer for account repayment reversal. */
  REPAYMENT_REVERSAL = "REPAYMENT_REVERSAL",
  /** Resetting the pseudo balance for a `FinancialAccount`. */
  RESET_PSEUDO_BALANCE = "RESET_PSEUDO_BALANCE",
  /** Rewards earned for this account. */
  REWARD = "REWARD",
  /** Reversing rewards earned for this account. */
  REWARD_REVERSAL = "REWARD_REVERSAL",
  /** Transfer of secured deposit to this account. */
  SECURED_DEPOSIT = "SECURED_DEPOSIT",
  /** Transfer of secured deposit on this account being reversed. */
  SECURED_DEPOSIT_REVERSAL = "SECURED_DEPOSIT_REVERSAL",
  /**
   * Setting a limit on a financial account with a payment card.
   *
   * This isn't a transfer of funds, but a notification that a limit was set.
   */
  SET_LIMIT = "SET_LIMIT",
  /**
   * Setting a pseudo balance limit for this account.
   * This is only used for On-Demand Funding accounts.
   */
  SET_PSEUDO_BALANCE = "SET_PSEUDO_BALANCE",
  /** Setting a pseudo limit for a `FinancialAccount`. */
  SET_PSEUDO_LIMIT = "SET_PSEUDO_LIMIT",
  /** This transfer is a tip disbursement. */
  TIP_DISBURSEMENT = "TIP_DISBURSEMENT",
  /** This transfer is a tip disbursement reversal. */
  TIP_DISBURSEMENT_REVERSAL = "TIP_DISBURSEMENT_REVERSAL",
}

/** Inputs for filtering the purpose of InterFinancialAccountTransfer. */
export type InterFinancialAccountTransferActivityTypeFilterInput = {
  equals?: InputMaybe<InterFinancialAccountTransferActivityType>;
  excludes?: InputMaybe<Array<InterFinancialAccountTransferActivityType>>;
  includes?: InputMaybe<Array<InterFinancialAccountTransferActivityType>>;
  notEquals?: InputMaybe<InterFinancialAccountTransferActivityType>;
};

/** The connection type for InterFinancialAccountTransfers. */
export type InterFinancialAccountTransferConnection = {
  __typename?: "InterFinancialAccountTransferConnection";
  /** A list of edges. */
  edges?: Maybe<Array<InterFinancialAccountTransferEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a InterFinancialAccountTransfer. */
export type InterFinancialAccountTransferEdge = {
  __typename?: "InterFinancialAccountTransferEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The Inter Financial Account Transfer. */
  node?: Maybe<InterFinancialAccountTransfer>;
};

/** Inputs for filtering by InterFinancialAccountTransfer. */
export type InterFinancialAccountTransferFilterInput = {
  /** Search for InterFinancialAccountTransfers by transfer amount */
  amount?: InputMaybe<MoneyFilterInput>;
  /** The date and time, in ISO 8601 format, the InterFinancialAccountTransfer was created. */
  createdAt?: InputMaybe<TimestampFilterInput>;
  /** Status of the InterFinancialAccountTransfer */
  status?: InputMaybe<InterFinancialAccountTransferStatusFilterInput>;
  /** Purpose of the InterFinancialAccountTransfer */
  transferActivityType?: InputMaybe<InterFinancialAccountTransferActivityTypeFilterInput>;
  /** The date and time, in ISO 8601 format, the InterFinancialAccountTransfer was last updated. */
  updatedAt?: InputMaybe<TimestampFilterInput>;
};

/** A rule applicable to Inter Financial Account Transfers. */
export type InterFinancialAccountTransferRule = {
  /** The date and time, in ISO 8601 format, the rule was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the transfer rule in operations. */
  id: Scalars["ID"];
  /** The name assigned to the rule. */
  name?: Maybe<Scalars["String"]>;
  /** The list of revisions for this transfer rule. */
  revisions?: Maybe<InterFinancialAccountTransferRuleConnection>;
  /** The date and time, in ISO 8601 format, the rule was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
  version?: Maybe<Scalars["String"]>;
};

/** A rule applicable to Inter Financial Account Transfers. */
export type InterFinancialAccountTransferRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The connection type for `InterFinancialAccountTransferRule`. */
export type InterFinancialAccountTransferRuleConnection = {
  __typename?: "InterFinancialAccountTransferRuleConnection";
  /** A list of edges. */
  edges?: Maybe<Array<InterFinancialAccountTransferRuleEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The return types for finding inter financial account transfer rules. */
export type InterFinancialAccountTransferRuleConnectionPayload =
  | AccessDeniedError
  | InterFinancialAccountTransferRuleConnection;

/** The edge type for a `InterFinancialAccountTransferRule`. */
export type InterFinancialAccountTransferRuleEdge = {
  __typename?: "InterFinancialAccountTransferRuleEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The `InterFinancialAccountTransferRule`. */
  node?: Maybe<InterFinancialAccountTransferRule>;
};

/** The result of a `InterFinancialAccountTransferRule` execution in the risk layer. */
export type InterFinancialAccountTransferRuleResult = {
  /** A message describing the result. */
  message?: Maybe<Scalars["String"]>;
  /** A status representing the result of the rule’s evaluation. */
  status?: Maybe<InterFinancialAccountTransferRuleResultStatus>;
};

/** A enum of `InterFinancialAccountTransferRuleResult` statuses */
export enum InterFinancialAccountTransferRuleResultStatus {
  /** The rule had a unknown failure. */
  EXCEPTION = "EXCEPTION",
  /** The rule failed */
  FAILED = "FAILED",
  /** The rule was not ran. */
  NOT_RAN = "NOT_RAN",
  /** No decision was made for the rule */
  NO_DECISION = "NO_DECISION",
  /** The rule originally failed by was overridden to pass */
  OVERRIDDEN_TO_PASS = "OVERRIDDEN_TO_PASS",
  /** The rule passed */
  PASSED = "PASSED",
  /** The rule was flagged with a warning */
  WARNING = "WARNING",
}

/** The states of a InterFinancialAccountTransfer. */
export enum InterFinancialAccountTransferStatus {
  /** The platform has completed the money movement. */
  COMPLETED = "COMPLETED",
  /** The platform was not able to complete the money movement. See `statusReasonCode` for more information. */
  FAILED = "FAILED",
  /** The platform is currently validating and executing the InterFinancialAccountTransfer. */
  PENDING = "PENDING",
  /**
   * The platform has started processing the InterFinancialAccountTransfer.
   * @deprecated unused
   */
  PROCESSING = "PROCESSING",
}

/** Inputs for filtering InterFinancialAccountTransfer data. */
export type InterFinancialAccountTransferStatusFilterInput = {
  equals?: InputMaybe<InterFinancialAccountTransferStatus>;
  excludes?: InputMaybe<Array<InterFinancialAccountTransferStatus>>;
  includes?: InputMaybe<Array<InterFinancialAccountTransferStatus>>;
  notEquals?: InputMaybe<InterFinancialAccountTransferStatus>;
};

/** The reasons a InterFinancialAccountTransfer could fail. */
export enum InterFinancialAccountTransferStatusReasonCode {
  /** The accounts do not belong to the same product. */
  ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT = "ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT",
  /** The source or receiving account is closed. */
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  /** The receiving account holder is not an Organization. */
  ACCOUNT_HOLDER_IS_NOT_AN_ORGANIZATION = "ACCOUNT_HOLDER_IS_NOT_AN_ORGANIZATION",
  /** The account is not active. */
  ACCOUNT_NOT_ACTIVE = "ACCOUNT_NOT_ACTIVE",
  /** The source or receiving account was not found. */
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  /** The account was not provided in the request. */
  ACCOUNT_NOT_PROVIDED = "ACCOUNT_NOT_PROVIDED",
  /** ACH load is not allowed by the product configuration. */
  ACH_LOAD_NOT_ALLOWED_BY_PRODUCT = "ACH_LOAD_NOT_ALLOWED_BY_PRODUCT",
  /** The account does not have the `BankManagedBetaAccountFeature` enabled. */
  BANK_MANAGED_BETA_ACCOUNT_FEATURE_NOT_ENABLED = "BANK_MANAGED_BETA_ACCOUNT_FEATURE_NOT_ENABLED",
  /** Cash fund out is not supported on this product. */
  CASH_FUND_OUT_NOT_SUPPORTED_ON_PRODUCT = "CASH_FUND_OUT_NOT_SUPPORTED_ON_PRODUCT",
  /** The charge off amount exceeds the available balance. */
  CHARGE_OFF_EXCEEDS_BALANCE = "CHARGE_OFF_EXCEEDS_BALANCE",
  /** The account does not have the `CheckCapableAccountFeature` enabled. */
  CHECK_CAPABLE_ACCOUNT_FEATURE_NOT_ENABLED = "CHECK_CAPABLE_ACCOUNT_FEATURE_NOT_ENABLED",
  /** Check payment is not supported on this product. */
  CHECK_PAYMENT_NOT_SUPPORTED_ON_PRODUCT = "CHECK_PAYMENT_NOT_SUPPORTED_ON_PRODUCT",
  /** The account does not have the `CommercialCreditPayInFullFeature` enabled. */
  COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED = "COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED",
  /** The account does not have the `CorporateBankAccountFeature` enabled. */
  CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED = "CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED",
  /** The account does not have the `CreditCardFeature` enabled. */
  CREDIT_CARD_FEATURE_NOT_ENABLED = "CREDIT_CARD_FEATURE_NOT_ENABLED",
  /** The credit limit is not set on the account. */
  CREDIT_LIMIT_NOT_SET_ON_ACCOUNT = "CREDIT_LIMIT_NOT_SET_ON_ACCOUNT",
  /** The source and receiving account have different currency. */
  CURRENCY_MISMATCH = "CURRENCY_MISMATCH",
  /** The account does not have the `DDAFeature` enabled. */
  DDA_FEATURE_NOT_ENABLED = "DDA_FEATURE_NOT_ENABLED",
  /** The account does not have the `DebitCardFeature` enabled. */
  DEBIT_CARD_FEATURE_NOT_ENABLED = "DEBIT_CARD_FEATURE_NOT_ENABLED",
  /** The account does not have the `DisputeChargebackFeature` enabled. */
  DISPUTE_CHARGEBACK_NOT_ENABLED = "DISPUTE_CHARGEBACK_NOT_ENABLED",
  /** The account does not have the `DisputeChargebackProvisionalCreditFeature` enabled. */
  DISPUTE_CHARGEBACK_PROVISIONAL_CREDIT_NOT_ENABLED = "DISPUTE_CHARGEBACK_PROVISIONAL_CREDIT_NOT_ENABLED",
  /** External money movement is not supported on this product. */
  EXTERNAL_MONEY_MOVEMENT_NOT_SUPPORTED_ON_PRODUCT = "EXTERNAL_MONEY_MOVEMENT_NOT_SUPPORTED_ON_PRODUCT",
  /** The account does not have the `FleetFeature` enabled. */
  FLEET_FEATURE_NOT_ENABLED = "FLEET_FEATURE_NOT_ENABLED",
  /** The account does not have the `FundingAccountFeature` enabled. */
  FUNDING_ACCOUNT_FEATURE_NOT_ENABLED = "FUNDING_ACCOUNT_FEATURE_NOT_ENABLED",
  /** Funding card is not supported for this operation. */
  FUNDING_CARD_NOT_SUPPORTED = "FUNDING_CARD_NOT_SUPPORTED",
  /** The account does not have the `HighnoteAccountFeature` enabled. */
  HIGHNOTE_ACCOUNT_FEATURE_NOT_ENABLED = "HIGHNOTE_ACCOUNT_FEATURE_NOT_ENABLED",
  /** The idempotency key was not provided in the request. */
  IDEMPOTENCY_KEY_NOT_PROVIDED = "IDEMPOTENCY_KEY_NOT_PROVIDED",
  /** The source account of the InterFinancialAccountTransfer did not have enough funds to cover the requested amount. */
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  /** An internal server error occurred during the transfer. */
  INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
  /** Inter financial account transfer rules validation failed. */
  INTER_FINANCIAL_ACCOUNT_TRANSFER_RULES_NOT_PASSED = "INTER_FINANCIAL_ACCOUNT_TRANSFER_RULES_NOT_PASSED",
  /** The disbursement amount is invalid. */
  INVALID_DISBURSEMENT_AMOUNT = "INVALID_DISBURSEMENT_AMOUNT",
  /** Issuer migration cannot set cash balance less than available cash. */
  ISSUER_MIGRATION_CANNOT_SET_CASH_BALANCE_LESS_THAN_AVAILABLE_CASH = "ISSUER_MIGRATION_CANNOT_SET_CASH_BALANCE_LESS_THAN_AVAILABLE_CASH",
  /** The account does not have the `JITFeature` enabled. */
  JIT_FEATURE_NOT_ENABLED = "JIT_FEATURE_NOT_ENABLED",
  /** The requested amount is more than max program limit. */
  LIMIT_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT = "LIMIT_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT",
  /** The account does not have the `MerchantFundingFeature` enabled. */
  MERCHANT_FUNDING_FEATURE_NOT_ENABLED = "MERCHANT_FUNDING_FEATURE_NOT_ENABLED",
  /** The account does not have the `MerchantSettlementFeature` enabled. */
  MERCHANT_SETTLEMENT_FEATURE_NOT_ENABLED = "MERCHANT_SETTLEMENT_FEATURE_NOT_ENABLED",
  /** There is not enough balance to reduce the credit limit. */
  NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT = "NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT",
  /** The account does not have the `ODFFeature` enabled. */
  ODF_FEATURE_NOT_ENABLED = "ODF_FEATURE_NOT_ENABLED",
  /** The organization ID was not provided in the request. */
  ORGANIZATION_ID_NOT_PROVIDED = "ORGANIZATION_ID_NOT_PROVIDED",
  /** Originated ACH unload is not supported on this product. */
  ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT = "ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT",
  /** The account does not have the `PartialFundingFeature` enabled. */
  PARTIAL_FUNDING_FEATURE_NOT_ENABLED = "PARTIAL_FUNDING_FEATURE_NOT_ENABLED",
  /** The account does not have the required payroll advance feature enabled. */
  PAYROLL_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED",
  /** The employer account does not have the required payroll employer advance feature enabled. */
  PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED",
  /** The receiving account does not have PrepaidCardFeature or DebitCardFeature as enabled. */
  PREPAID_CARD_OR_DEBIT_CARD_FEATURE_NOT_ENABLED = "PREPAID_CARD_OR_DEBIT_CARD_FEATURE_NOT_ENABLED",
  /** The source account does not have ProductFundingFeature or CardFundingFeature as enabled. */
  PRODUCT_FUNDING_OR_CARD_FUNDING_FEATURE_NOT_ENABLED = "PRODUCT_FUNDING_OR_CARD_FUNDING_FEATURE_NOT_ENABLED",
  /** The product does not have the `SecuredDepositAccountFeature` enabled. */
  PRODUCT_SECURED_DEPOSIT_ACCOUNT_FEATURE_NOT_ENABLED = "PRODUCT_SECURED_DEPOSIT_ACCOUNT_FEATURE_NOT_ENABLED",
  /** Pseudo balance is not enabled on the account. */
  PSEUDO_BALANCE_NOT_ENABLED = "PSEUDO_BALANCE_NOT_ENABLED",
  /** The account does not have the `ReceivablePurchaseFeature` enabled. */
  RECEIVABLE_PURCHASE_NOT_ENABLED = "RECEIVABLE_PURCHASE_NOT_ENABLED",
  /** The repayment account is not present on the product. */
  REPAYMENT_ACCOUNT_NOT_PRESENT_ON_PRODUCT = "REPAYMENT_ACCOUNT_NOT_PRESENT_ON_PRODUCT",
  /** The account does not have the `RewardPointFeature` enabled. */
  REWARD_POINT_FEATURE_NOT_ENABLED = "REWARD_POINT_FEATURE_NOT_ENABLED",
  /** The account does not have the `SecuredDepositAccountFeature` enabled. */
  SECURED_DEPOSIT_ACCOUNT_FEATURE_NOT_ENABLED = "SECURED_DEPOSIT_ACCOUNT_FEATURE_NOT_ENABLED",
  /** The account does not have the `SecureCardFeature` enabled. */
  SECURE_CARD_FEATURE_NOT_ENABLED = "SECURE_CARD_FEATURE_NOT_ENABLED",
  /** The tenant ID was not provided in the request. */
  TENANT_ID_NOT_PROVIDED = "TENANT_ID_NOT_PROVIDED",
  /** The transaction ID was not provided in the request. */
  TRANSACTION_ID_NOT_PROVIDED = "TRANSACTION_ID_NOT_PROVIDED",
  /** The transfer amount is below the minimum product reload limit. */
  TRANSFER_AMOUNT_BELOW_MIN_PRODUCT_RELOAD_LIMIT = "TRANSFER_AMOUNT_BELOW_MIN_PRODUCT_RELOAD_LIMIT",
  /** The requested amount exceeds the maximum aggregate credit distribution amount. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_AGGREGATE_CREDIT_DISTRIBUTION_AMOUNT = "TRANSFER_AMOUNT_EXCEEDING_MAX_AGGREGATE_CREDIT_DISTRIBUTION_AMOUNT",
  /** The transfer amount exceeds the maximum product card balance. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_PRODUCT_CARD_BALANCE = "TRANSFER_AMOUNT_EXCEEDING_MAX_PRODUCT_CARD_BALANCE",
  /** The requested amount exceeds the maximum product reload limit. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_PRODUCT_RELOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_PRODUCT_RELOAD_LIMIT",
  /** The transfer amount is negative. */
  TRANSFER_AMOUNT_IS_NEGATIVE = "TRANSFER_AMOUNT_IS_NEGATIVE",
  /** The transfer amount is negative or zero. */
  TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO = "TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO",
  /** The transfer between different products is not allowed. */
  TRANSFER_BETWEEN_PRODUCTS_NOT_ALLOWED = "TRANSFER_BETWEEN_PRODUCTS_NOT_ALLOWED",
  /** The transfer condition requiring same primary account holder is not satisfied. */
  TRANSFER_CONDITION_SAME_PRIMARY_ACCOUNT_HOLDER_NOT_SATISFIED = "TRANSFER_CONDITION_SAME_PRIMARY_ACCOUNT_HOLDER_NOT_SATISFIED",
  /** The transfer is not supported on this product. */
  TRANSFER_NOT_SUPPORTED_ON_PRODUCT = "TRANSFER_NOT_SUPPORTED_ON_PRODUCT",
  /** The transfer orchestration ID was not provided in the request. */
  TRANSFER_ORCHESTRATION_ID_NOT_PROVIDED = "TRANSFER_ORCHESTRATION_ID_NOT_PROVIDED",
}

/** A fee associated with interchange a `PaymentTransaction`. */
export type InterchangeFeePaymentTransactionFee = PaymentTransactionFee & {
  __typename?: "InterchangeFeePaymentTransactionFee";
  /**
   * The direction the fees are moving in the perspective of the subscriber.
   * * when DEBIT, this fee is deducted from the total payable amount.
   * * when CREDIT, this fee is credited to the total payable amount.
   */
  accountingDirection?: Maybe<AccountingDirection>;
  /** The amount of the fee. */
  feeAmount?: Maybe<Amount>;
};

/** The date used to calculate interest accrual. For example, `TRANSACTION_POST_DATE`, `FIRST_DAY_OF_BILLING_PERIOD`, or `PAYMENT_DUE_DATE`. */
export enum InterestAccrualMethod {
  FIRST_DAY_OF_BILLING_PERIOD = "FIRST_DAY_OF_BILLING_PERIOD",
  PAYMENT_DUE_DATE = "PAYMENT_DUE_DATE",
  TRANSACTION_POST_DATE = "TRANSACTION_POST_DATE",
}

/** Whether interest accrues using a `SIMPLE` or `COMPOUND` formula. */
export enum InterestAccrualType {
  COMPOUND = "COMPOUND",
  SIMPLE = "SIMPLE",
}

/** Whether interest is assessed `DAILY` or on the `STATEMENT` cycle close date. */
export enum InterestAssessmentSchedule {
  DAILY = "DAILY",
  STATEMENT = "STATEMENT",
}

/** Details about the interest that will be charged, such as the annual percentage rate (APR). */
export type InterestDetails = {
  __typename?: "InterestDetails";
  /** The annual percentage rate (APR). */
  apr?: Maybe<Scalars["Float"]>;
  /** For variable interest rates only. The current configuration of the index used to derive the variable APR. */
  index?: Maybe<Scalars["Float"]>;
  /** For variable interest rates only. The current configuration of the margin used to derive the variable APR. */
  margin?: Maybe<Scalars["Float"]>;
};

/** The index used for interest rate calculation. For example, `PRIME`. */
export enum InterestRateIndex {
  LIBOR = "LIBOR",
  PRIME = "PRIME",
}

/** The current configuration of the index used for variable APRs. */
export type InterestRateIndexConfiguration = {
  __typename?: "InterestRateIndexConfiguration";
  /** The date this interest rate index value goes into effect, in YYYY-MM-DD (ISO 8601 RFC 3339) date format. */
  effectiveDate?: Maybe<Scalars["Date"]>;
  /** The index used; for example, `PRIME`. */
  type?: Maybe<InterestRateIndex>;
  /** The value of this interest rate index. */
  value?: Maybe<Scalars["Float"]>;
};

/** A range type for interest rates (APRs), including a minimum and maximum value. */
export type InterestRateRange = {
  __typename?: "InterestRateRange";
  /** The maximum interest rate (APR), expressed as a `Float` with up to 3 digit precision after the decimal point. */
  maximum?: Maybe<Scalars["Float"]>;
  /** The minimum interest rate (APR), expressed as a `Float` with up to 3 digit precision after the decimal point. */
  minimum?: Maybe<Scalars["Float"]>;
};

/** Whether the interest rate is fixed or variable. */
export enum InterestRateType {
  FIXED = "FIXED",
  VARIABLE = "VARIABLE",
}

export type InternalTransferEvent = {
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the transfer in operations. */
  id: Scalars["ID"];
  /** The current status of the internal transfer. */
  internalTransferStatus?: Maybe<InterFinancialAccountTransferStatus>;
  /** A description of the transfer for reference. */
  memo?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The InternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountPendingEvent is triggered when money movement from a Funding Financial Account to a Payment Financial Account has completed. */
export type InternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountCompletedEvent =
  InternalTransferEvent &
    Node & {
      __typename?: "InternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountCompletedEvent";
      /** The amount of the transfer. */
      amount?: Maybe<Amount>;
      /** The date and time, in ISO 8601 format, the transfer was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** Global ID used to reference the transfer in operations. */
      id: Scalars["ID"];
      /** The current status of the internal transfer. */
      internalTransferStatus?: Maybe<InterFinancialAccountTransferStatus>;
      /** A description of the transfer for reference. */
      memo?: Maybe<Scalars["String"]>;
      /** The date and time, in ISO 8601 format, the transfer was last updated. */
      updatedAt?: Maybe<Scalars["String"]>;
    };

/** The InternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountPendingEvent is triggered when money movement from a Funding Financial Account to a Payment Financial Account has failed. */
export type InternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountFailedEvent =
  InternalTransferEvent &
    Node & {
      __typename?: "InternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountFailedEvent";
      /** The amount of the transfer. */
      amount?: Maybe<Amount>;
      /** The date and time, in ISO 8601 format, the transfer was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** Global ID used to reference the transfer in operations. */
      id: Scalars["ID"];
      /** The current status of the internal transfer. */
      internalTransferStatus?: Maybe<InterFinancialAccountTransferStatus>;
      /** The reason for the current internal transfer status. */
      internalTransferStatusReason?: Maybe<InterFinancialAccountTransferStatusReasonCode>;
      /** A description of the transfer for reference. */
      memo?: Maybe<Scalars["String"]>;
      /** The date and time, in ISO 8601 format, the transfer was last updated. */
      updatedAt?: Maybe<Scalars["String"]>;
    };

/** The InternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountPendingEvent is triggered when money movement from a Funding Financial Account to a Payment Financial Account is pending. */
export type InternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountPendingEvent =
  InternalTransferEvent &
    Node & {
      __typename?: "InternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountPendingEvent";
      /** The amount of the transfer. */
      amount?: Maybe<Amount>;
      /** The date and time, in ISO 8601 format, the transfer was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** Global ID used to reference the transfer in operations. */
      id: Scalars["ID"];
      /** The current status of the internal transfer. */
      internalTransferStatus?: Maybe<InterFinancialAccountTransferStatus>;
      /** A description of the transfer for reference. */
      memo?: Maybe<Scalars["String"]>;
      /** The date and time, in ISO 8601 format, the transfer was last updated. */
      updatedAt?: Maybe<Scalars["String"]>;
    };

/** The InternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountCompletedEvent is triggered when money movement from a Payment Financial Account to a Funding Financial Account has completed. */
export type InternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountCompletedEvent =
  InternalTransferEvent &
    Node & {
      __typename?: "InternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountCompletedEvent";
      /** The amount of the transfer. */
      amount?: Maybe<Amount>;
      /** The date and time, in ISO 8601 format, the transfer was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** Global ID used to reference the transfer in operations. */
      id: Scalars["ID"];
      /** The current status of the internal transfer. */
      internalTransferStatus?: Maybe<InterFinancialAccountTransferStatus>;
      /** A description of the transfer for reference. */
      memo?: Maybe<Scalars["String"]>;
      /** The date and time, in ISO 8601 format, the transfer was last updated. */
      updatedAt?: Maybe<Scalars["String"]>;
    };

/** The InternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountFailedEvent is triggered when money movement from a Payment Financial Account to a Funding Financial Account has failed. */
export type InternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountFailedEvent =
  InternalTransferEvent &
    Node & {
      __typename?: "InternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountFailedEvent";
      /** The amount of the transfer. */
      amount?: Maybe<Amount>;
      /** The date and time, in ISO 8601 format, the transfer was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** Global ID used to reference the transfer in operations. */
      id: Scalars["ID"];
      /** The current status of the internal transfer. */
      internalTransferStatus?: Maybe<InterFinancialAccountTransferStatus>;
      /** The reason for the current internal transfer status. */
      internalTransferStatusReason?: Maybe<InterFinancialAccountTransferStatusReasonCode>;
      /** A description of the transfer for reference. */
      memo?: Maybe<Scalars["String"]>;
      /** The date and time, in ISO 8601 format, the transfer was last updated. */
      updatedAt?: Maybe<Scalars["String"]>;
    };

/** The InternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountPendingEvent is triggered when money movement from a Payment Financial Account to a Funding Financial Account is pending. */
export type InternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountPendingEvent =
  InternalTransferEvent &
    Node & {
      __typename?: "InternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountPendingEvent";
      /** The amount of the transfer. */
      amount?: Maybe<Amount>;
      /** The date and time, in ISO 8601 format, the transfer was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** Global ID used to reference the transfer in operations. */
      id: Scalars["ID"];
      /** The current status of the internal transfer. */
      internalTransferStatus?: Maybe<InterFinancialAccountTransferStatus>;
      /** A description of the transfer for reference. */
      memo?: Maybe<Scalars["String"]>;
      /** The date and time, in ISO 8601 format, the transfer was last updated. */
      updatedAt?: Maybe<Scalars["String"]>;
    };

/** Data needed to invite a new User. */
export type InviteUserInput = {
  /** E-mail of the user to invite. */
  email: Scalars["String"];
  /** The list of users' roles that determine a user's permissions within the organization. */
  roles: Array<UserRole>;
};

/** The possible return types of `inviteUser`. */
export type InviteUserPayload = AccessDeniedError | User | UserError;

/** Details for issuing an Employer Financial Account against a Card Product. */
export type IssueEmployerFinancialAccountForCardProductInput = {
  /** The ID of the Card Product to update. */
  cardProductId: Scalars["ID"];
  /**
   * The companyIdentifier associated with Employer Advanced Account.
   * **Maximum length:** 50 characters
   * **Allowed characters:** All characters
   */
  companyIdentifier?: InputMaybe<Scalars["String"]>;
  /**
   * The name of the Employer Advanced Account.
   * **Minimum length:** 1 character
   * **Maximum length:** 50 characters
   * **Allowed characters:** All characters
   */
  name: Scalars["String"];
};

/** The return types when creating a new Financial Account against an Application. */
export type IssueEmployerFinancialAccountForCardProductPayload =
  | AccessDeniedError
  | EmployerFinancialAccount
  | UserError;

/** Details for issuing a Financial Account against an Application. */
export type IssueFinancialAccountForApplicationInput = {
  /**
   * The ID of the application to issue this Financial Account against.
   *
   * **Note:** The Application must be APPROVED.
   */
  applicationId: Scalars["ID"];
  /** The `CustomFields` for the Financial Account. */
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  /** Externally provided ID (255 character limit) that is unique per organization and tenant. If not provided, Highnote will generate an ID (ten digit, Base58, all caps). */
  externalId?: InputMaybe<Scalars["String"]>;
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /** The name of the Financial Account. */
  name: Scalars["String"];
};

/** The return types when creating a new Financial Account against an Application. */
export type IssueFinancialAccountForApplicationPayload =
  | AccessDeniedError
  | FinancialAccount
  | UserError;

/** Details for issuing a Financial Account against an on-demand funding source. */
export type IssueFinancialAccountForApplicationWithOnDemandFundingSourceInput =
  {
    /**
     * The ID of the application to issue this Financial Account against.
     *
     * **Note:** The Application must be APPROVED.
     */
    applicationId: Scalars["ID"];
    /** Externally provided ID (255 character limit) that is unique per organization and tenant. If not provided, Highnote will generate an ID (ten digit, Base58, all caps). */
    externalId?: InputMaybe<Scalars["String"]>;
    /**
     * The idempotency key for this request.
     *
     * This is a UUIDv4 string used to uniquely identify requests.
     *
     * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
     *
     * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
     */
    idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
    /** The name of the Financial Account. */
    name: Scalars["String"];
    /** The source `FinancialAccount` that will act as the on-demand funding source for this `FinancialAccount`. */
    sourceFinancialAccountId: Scalars["ID"];
  };

/** The return types when creating a new Financial Account with an on-demand funding source. */
export type IssueFinancialAccountForApplicationWithOnDemandFundingSourcePayload =
  AccessDeniedError | FinancialAccount | UserError;

/** Details for issuing a Funding Financial Account against an Application. */
export type IssueFundingFinancialAccountForApplicationInput = {
  /**
   * The ID of the application to issue this Financial Account against.
   *
   * **Note:** The Application must be APPROVED.
   */
  applicationId: Scalars["ID"];
  /** The name of the Financial Account. */
  name: Scalars["String"];
};

/** The return types when creating a new Funding Financial Account against an Application. */
export type IssueFundingFinancialAccountForApplicationPayload =
  | AccessDeniedError
  | FinancialAccount
  | UserError;

/** Details for issuing a Payment Card against an Application. */
export type IssuePaymentCardForApplicationInput = {
  /**
   * The ID of the application to issue this Payment Card against.
   *
   * **Note:** The Application must be APPROVED.
   */
  applicationId: Scalars["ID"];
  /** The `CustomFields` for the Payment Card. */
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  /**
   * Externally provided ID (255 character limit) that can be used to refer to the issued payment card's' financial account.
   * This ID is unique per organization and tenant. If not provided, Highnote will generate an ID (ten digit, Base58, all caps).
   */
  externalId?: InputMaybe<Scalars["String"]>;
  /** Options for the newly issued Payment Card. */
  options: IssuePaymentCardOptionsInput;
};

/** The return types when creating a new Payment Card against an Application. */
export type IssuePaymentCardForApplicationPayload =
  | AccessDeniedError
  | PaymentCard
  | UserError;

/** Details for issuing a `PaymentCard` against an on-demand funding source. */
export type IssuePaymentCardForApplicationWithOnDemandFundingSourceInput = {
  /**
   * The ID of the application to issue this `PaymentCard` against.
   *
   * **Note:** The Application must be APPROVED.
   */
  applicationId: Scalars["ID"];
  /** The `CustomFields` for the `PaymentCard`. */
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  /** Externally provided ID (255 character limit) that is unique per organization and tenant. If not provided, Highnote will generate an ID (ten digit, Base58, all caps). */
  externalId?: InputMaybe<Scalars["String"]>;
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /** Options for the newly issued `PaymentCard`. */
  options: IssuePaymentCardOptionsInput;
  /** The source `FinancialAccount` that will act as the on-demand funding source for this `PaymentCard`. */
  sourceFinancialAccountId: Scalars["ID"];
};

/** The return types when creating a new `PaymentCard` with an on-demand funding source. */
export type IssuePaymentCardForApplicationWithOnDemandFundingSourcePayload =
  | AccessDeniedError
  | PaymentCard
  | UserError;

/** Details for issuing a Payment Card against an Authorized User Application. */
export type IssuePaymentCardForAuthorizedUserApplicationInput = {
  /**
   * The ID of the authorizecd user application to issue this Payment Card against.
   *
   * **Note:** The Application must be APPROVED.
   */
  applicationId: Scalars["ID"];
  /** The `CustomFields` for the Payment Card. */
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  /** Options for the newly issued Payment Card. */
  options: IssuePaymentCardOptionsInput;
};

/** Details for issuing a Payment Card against Financial Account. */
export type IssuePaymentCardForFinancialAccountInput = {
  /** The `CustomFields` for the Payment Card. */
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  /**
   * The ID of the financial account to issue this Payment Card against.
   *
   * **Note:** The Financial Account must have a payment card feature enabled.
   */
  financialAccountId: Scalars["ID"];
  /**
   * A value to distinguish unique `IssuePaymentCardForFinancialAccount` request.
   * This helps prevent duplicate cards from be issued. If a failure happens and it is unclear
   * if an issue payment card request went through, it is safe to repeat the request with the same idempotency key.
   * If card has already been issued, the request will be deduped and the original payment card response will be
   * returned instead.
   *
   * **Minimum length:** 10 characters
   * **Maximum length:** 255 characters
   */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /** Options for the newly issued Payment Card. */
  options: IssuePaymentCardOptionsInput;
};

/** The return types when creating a new Payment Card against a Financial Account. */
export type IssuePaymentCardForFinancialAccountPayload =
  | AccessDeniedError
  | IssuePaymentCardForFinancialAccountResponse
  | PaymentCard
  | UserError;

/** Represents a payment card creation request. */
export type IssuePaymentCardForFinancialAccountResponse = {
  __typename?: "IssuePaymentCardForFinancialAccountResponse";
  /** If the request failed, the reason for the failure. */
  failureReason?: Maybe<Scalars["String"]>;
  /** The `PaymentCard` created as part of the request. */
  paymentCard?: Maybe<PaymentCard>;
  /** The status of the request to issue `PaymentCard`s in bulk. */
  status?: Maybe<IssuePaymentCardForFinancialAccountResponseStatus>;
};

/** The status of the `issuePaymentCardForFinancialAccountResponse` request. */
export enum IssuePaymentCardForFinancialAccountResponseStatus {
  /** The request completed with a failure, reference the `failureReason` on why the request failed. */
  FAILURE = "FAILURE",
  /** The request is currently processing. */
  PROCESSING = "PROCESSING",
  /** The request completed successfully, and the response is available. */
  SUCCESS = "SUCCESS",
  /** The request status is unknown. Contact Highnote for more details. */
  UNKNOWN = "UNKNOWN",
}

/**
 * Representation of `IssuePaymentCardOptionsInput`.
 *
 * `IssuePaymentCardOptionsDetail` is used to safely return the values provided in `IssuePaymentCardOptionsInput`
 */
export type IssuePaymentCardOptionsDetail = {
  __typename?: "IssuePaymentCardOptionsDetail";
  /** Whether or not to activate the card when created. If **not** activated on creation, the card must be activated separately before use. */
  activateOnCreate?: Maybe<Scalars["Boolean"]>;
  /** The card profile set */
  cardProfileSet?: Maybe<CardProfileSet>;
  /** The exact date and time the payment card will expire. e.g. 2026-01-01T23:59:59Z */
  expirationDate?: Maybe<Scalars["String"]>;
};

/** Options for the newly issued Payment Card. */
export type IssuePaymentCardOptionsInput = {
  /** Whether or not to activate the card when created. If **not** activated on creation, the card must be activated separately before use. */
  activateOnCreate: Scalars["Boolean"];
  /** The card profile set containing the card profile to use for the newly issued Payment Card. */
  cardProfileSetId?: InputMaybe<Scalars["ID"]>;
  /** The exact date and time the payment card will expire. e.g. 2026-01-01T23:59:59Z */
  expirationDate: Scalars["String"];
  /** Externally provided ID (255 character limit) that is unique per organization and tenant. If not provided, Highnote will generate an ID (ten digit, Base58, all caps). */
  externalId?: InputMaybe<Scalars["String"]>;
};

/** Input values for `IssuePreprintedPaymentCardFinancialAccountForApplication` */
export type IssuePreprintedPaymentCardFinancialAccountForApplicationInput = {
  /**
   * The ID of the `AccountHolderCardProductApplication` to issue a preprinted payment card `FinancialAccount`.
   *
   * **Note:** The Application must be APPROVED.
   */
  applicationId: Scalars["ID"];
  /**
   * An optional externally provided ID (255 character limit) that can be used to refer to the issued payment card's' financial account.
   * This ID is unique per organization and tenant. If not provided, Highnote will generate an ID (ten digit, Base58, all caps).
   */
  externalId?: InputMaybe<Scalars["String"]>;
  /**
   * The name of the `FinancialAccount` that will be created.
   *
   * **Minimum length:** 1 character
   * **Maximum length:** 50 characters
   * **Allowed characters:** All characters
   */
  name: Scalars["String"];
};

/** The return types for `issuePreprintedPaymentCardFinancialAccountForApplication` */
export type IssuePreprintedPaymentCardFinancialAccountForApplicationPayload =
  | AccessDeniedError
  | FinancialAccount
  | UserError;

/** An `IssuerPreliminaryAuthorizationEvent` for a transaction. This event is created before subscriber's collaborative authorization endpoint is called. `AuthorizationEvent` is created after the subscribers response to collaborative request. */
export type IssuerPreliminaryAuthorizationEvent = Node &
  TransactionEvent & {
    __typename?: "IssuerPreliminaryAuthorizationEvent";
    /**
     * The direction funds are moving in the perspective of the cardholder.
     *
     * * when DEBIT, funds are moving out of the cardholder's account
     * * when CREDIT, funds are moving into the cardholder's account
     */
    accountingDirection?: Maybe<AccountingDirection>;
    /** Network specific transaction data. */
    additionalNetworkData?: Maybe<AdditionalNetworkData>;
    /** Additional transaction data for this transaction. */
    additionalTransactionData?: Maybe<Array<AdditionalTransactionData>>;
    /** The `Amount` approved for this `IssuerPreliminaryAuthorizationEvent` and posted in the settlement currency. Does not include fees. */
    approvedAmount?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, the authorization will expire. */
    authorizationExpiration?: Maybe<Scalars["String"]>;
    /** Code representing the result of AVS address verification. */
    avsResponseCode?: Maybe<AvsResponseCode>;
    /** The details of the `CardDigitalWalletToken` at the time of this `IssuerPreliminaryAuthorizationEvent` event. */
    cardDigitalWalletTokenDetails?: Maybe<CardDigitalWalletTokenDetails>;
    /** The `CardProduct` associated to this `IssuerPreliminaryAuthorizationEvent`. */
    cardProduct?: Maybe<CardProduct>;
    /** The `Amount` of cashback requested during the transaction. */
    cashbackAmount?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, this `IssuerPreliminaryAuthorizationEvent` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /**
     * Conversion rate applied to the requestedAmount to get the requestedAmountInSettlementCurrency for this `IssuerPreliminaryAuthorizationEvent`.
     *
     * Can be up to 7 decimal places, e.g. 1.2345678.
     */
    currencyConversionRate?: Maybe<Scalars["Float"]>;
    /** The `Amount` available to spend after this transaction event. */
    currentFinancialAccountAvailableToSpendAmount?: Maybe<Amount>;
    /** Maximum balance allowed for the card account at the time of this transaction event */
    currentFinancialAccountMaximumBalanceAmount?: Maybe<Amount>;
    /** Code representing the result of CVV (security code) verification */
    cvvResponseCode?: Maybe<CvvResponseCode>;
    /** The ID of the transaction event. This `id` can be used to later retrieve details of this `IssuerPreliminaryAuthorizationEvent` or correlate it with other events on this `Transaction`. */
    id: Scalars["ID"];
    /** The details about the merchant who requested the authorization. */
    merchantDetails?: Maybe<MerchantDetails>;
    /**
     * The response code from the card network (e.g. Mastercard).
     * @deprecated Use responseCode instead
     */
    networkResponseCode?: Maybe<Scalars["String"]>;
    /** The transaction ID from the card network (e.g. Mastercard). */
    networkTransactionId?: Maybe<Scalars["ID"]>;
    /** The original `Amount` of this `IssuerPreliminaryAuthorizationEvent`. */
    originalAmount?: Maybe<Amount>;
    /** The `PaymentCard` associated to this `IssuerPreliminaryAuthorizationEvent`. */
    paymentCard?: Maybe<PaymentCard>;
    /** A snapshot of the `PaymentCard` at the time of the `IssuerPreliminaryAuthorizationEvent`. */
    paymentCardSnapshot?: Maybe<PaymentCardSnapshot>;
    /** Code representing the result of PIN verification. */
    pinResponseCode?: Maybe<PinResponseCode>;
    /** The Point Of Service Service Input. */
    pointOfServiceDetails?: Maybe<PointOfServiceDetails>;
    /** Code representing the result of AVS postal code verification. */
    postalCodeResponseCode?: Maybe<PostalCodeResponseCode>;
    /** The `Amount` requested to be approved for this `IssuerPreliminaryAuthorizationEvent` and displayed in the transaction's (local) currency. Does not include fees. */
    requestedAmount?: Maybe<Amount>;
    /** The `Amount` requested to be approved for this `IssuerPreliminaryAuthorizationEvent` converted to the settlement currency. */
    requestedAmountInSettlementCurrency?: Maybe<Amount>;
    /** The Highnote response code. */
    responseCode?: Maybe<TransactionEventResponseCode>;
    /** The triggered spend rules and the results for the authorization. */
    spendRuleResults?: Maybe<SpendRuleResultConnection>;
    /** The `Transaction` for this event. */
    transaction?: Maybe<Transaction>;
    /** Represents the customer transaction type being processed. */
    transactionProcessingType?: Maybe<CardTransactionProcessingType>;
  };

/** An `IssuerPreliminaryAuthorizationEvent` for a transaction. This event is created before subscriber's collaborative authorization endpoint is called. `AuthorizationEvent` is created after the subscribers response to collaborative request. */
export type IssuerPreliminaryAuthorizationEventSpendRuleResultsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/**
 * A Journal Entry, showing the debit and credit ledger entries of a financial event. Every Journal Entry will have
 * a `LedgerEntry` that is crediting a Ledger and a corresponding `LedgerEntry` that is debiting from a Ledger.
 */
export type JournalEntry = Node & {
  __typename?: "JournalEntry";
  /** Credit entries for this `JournalEntry`. */
  credits?: Maybe<Array<CreditLedgerEntry>>;
  /** Debit entries for this `JournalEntry`. */
  debits?: Maybe<Array<DebitLedgerEntry>>;
  /** The id of `JournalEntry`. */
  id: Scalars["ID"];
};

/** Whether or not the Financial Account supports Just-in-time Funding. */
export type JustInTimeFundingFinancialAccountFeature =
  FinancialAccountFeature & {
    __typename?: "JustInTimeFundingFinancialAccountFeature";
    /**
     * The date and time, in ISO 8601 format, the feature was created.
     * @deprecated Access OnDemandFundingFinancialAccountFeature.createdAt instead
     */
    createdAt?: Maybe<Scalars["String"]>;
    /**
     * The date and time, in ISO 8601 format, the feature was effective from.
     * @deprecated Access OnDemandFundingFinancialAccountFeature.enabled instead
     */
    effectiveFrom?: Maybe<Scalars["String"]>;
    /**
     * The date and time, in ISO 8601 format, the feature was effective through.
     * @deprecated Access OnDemandFundingFinancialAccountFeature.enabled instead
     */
    effectiveThrough?: Maybe<Scalars["String"]>;
    /**
     * Whether or not the feature is enabled for the Financial Account.
     * @deprecated Access OnDemandFundingFinancialAccountFeature.enabled instead
     */
    enabled?: Maybe<Scalars["Boolean"]>;
    /**
     * The date and time, in ISO 8601 format, the feature was last updated.
     * @deprecated Access OnDemandFundingFinancialAccountFeature.updatedAt instead
     */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/**
 * A ledger represents a record in an account used to collect related activity.
 * For example, an `Organization` will have a `CASH` ledger which tracks every transaction related to `CASH`.
 */
export type Ledger = Node & {
  __typename?: "Ledger";
  /** The date and time, in ISO 8601 format, the `debitBalance` and `creditBalance` were last calculated. */
  asOf?: Maybe<Scalars["String"]>;
  /**
   * The credit balance of the `Ledger`.
   *
   * When the `Ledger`'s `normalBalance` is `CREDIT` this field should change based on activity. Otherwise, the `value` will stay zero. If the balance is negative, this amount will be zero, and the `DEBIT` amount will be positive. Refer to `normalBalance` definition to see information about possible negative balances.
   */
  creditBalance?: Maybe<Amount>;
  /**
   * The debit balance of the `Ledger`.
   *
   * When the `Ledger`'s `normalBalance` is `DEBIT` this field should change based on activity. Otherwise, the `value` will stay zero. If the balance is negative, this amount will be zero, and the `CREDIT` amount will be positive. Refer to `normalBalance` definition to see information about possible negative balances.
   */
  debitBalance?: Maybe<Amount>;
  /** A description of what activity the ledger is tracking. */
  description?: Maybe<Scalars["String"]>;
  /** The financial account the ledger is backing. */
  financialAccount?: Maybe<FinancialAccount>;
  /** Global ID used to reference the `Ledger` in operations. */
  id: Scalars["ID"];
  /**
   * The ledger entries that belong to this ledger
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  ledgerEntries?: Maybe<LedgerEntryConnection>;
  /** The name of the `Ledger`. */
  name?: Maybe<LedgerName>;
  /**
   * This property is for `PSEUDO*` ledgers and relates to the `PseudoBalanceCadence` set by the pseudo balance mutations.
   *
   * The date and time, in ISO 8601 format, when the pseudo balance for this ledger will next be reset. If it is empty, the balance will never reset.
   */
  nextBalanceResetAt?: Maybe<Scalars["String"]>;
  /**
   * The expected normal balance of the `Ledger`.
   *
   * In most cases the corresponding `creditBalance` and `debitBalance` field will have a non-zero value. If the corresponding `creditBalance` or `debitBalance` field has a zero value and the other `creditBalance` or `debitBalance` field has a value greater than zero, that greater than zero value represents a negative balance on the ledger.
   */
  normalBalance?: Maybe<NormalBalance>;
};

/**
 * A ledger represents a record in an account used to collect related activity.
 * For example, an `Organization` will have a `CASH` ledger which tracks every transaction related to `CASH`.
 */
export type LedgerLedgerEntriesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<LedgerEntriesFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Inputs for  filtering ledger entries. */
export type LedgerEntriesFilterInput = {
  createdAt?: InputMaybe<TimestampFilterInput>;
  ledgerName?: InputMaybe<LedgerNameFilterInput>;
};

export type LedgerEntry = {
  /** The `Amount` of the `LedgerEntry`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this ledger entry was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The credit balance that is the result of the ledger entry. */
  creditBalanceAtLedgerEntry?: Maybe<Amount>;
  /** The debit balance that is the result of the ledger entry. */
  debitBalanceAtLedgerEntry?: Maybe<Amount>;
  /** A `FinancialAccount` backed by the `Ledger` that this ledger entry belongs to. */
  financialAccount?: Maybe<FinancialAccount>;
  /** The event that triggered the ledger entry. */
  financialEvent?: Maybe<FinancialEvent>;
  /** The unique id of the `LedgerEntry`. */
  id: Scalars["ID"];
  /** A `JournalEntry` showing this ledger entry and its offsetting entry. */
  journalEntry?: Maybe<JournalEntry>;
  /** `Ledger` that `LedgerEntry` belongs to. */
  ledger?: Maybe<Ledger>;
  /** The optional memo of the `LedgerEntry`. */
  memo?: Maybe<Scalars["String"]>;
};

/** The connection type for `LedgerEntry`. */
export type LedgerEntryConnection = {
  __typename?: "LedgerEntryConnection";
  /** A list of edges. */
  edges?: Maybe<Array<LedgerEntryEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** Edge for `LedgerEntry`. */
export type LedgerEntryEdge = {
  __typename?: "LedgerEntryEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The `LedgerEntry`. */
  node?: Maybe<LedgerEntry>;
};

/** The possible values of a Ledger's name, based on the type of activity a ledger tracks. */
export enum LedgerName {
  /**
   * The name of a ledger that tracks account charge-offs on a `FinancialAccount`.
   *
   * NormalBalanceType = CREDIT
   */
  ACCOUNT_CHARGE_OFF = "ACCOUNT_CHARGE_OFF",
  /** The name of a ledger that tracks the credit limit for an Account Holder on a `FinancialAccount` associated to a credit Card Product. NormalBalanceType = CREDIT. */
  ACCOUNT_HOLDER_CREDIT_LIMIT = "ACCOUNT_HOLDER_CREDIT_LIMIT",
  /** The name of a ledger that tracks an Account holder payment owed on a `FinancialAccount` associated to a credit Card Product. NormalBalanceType = CREDIT. */
  ACCOUNT_HOLDER_PAYMENT_PAYABLE = "ACCOUNT_HOLDER_PAYMENT_PAYABLE",
  /** The name of a ledger that tracks an Account holder payment to be received on a `FinancialAccount` associated to a credit Card Product. NormalBalanceType = DEBIT. */
  ACCOUNT_HOLDER_PAYMENT_RECEIVABLE = "ACCOUNT_HOLDER_PAYMENT_RECEIVABLE",
  /** The name of a ledger that tracks the current account holder pseudo limit funds on a `FinancialAccount` that is expecting internal transfer to complete. NormalBalanceType = CREDIT. */
  ACCOUNT_HOLDER_PSEUDO_LIMIT = "ACCOUNT_HOLDER_PSEUDO_LIMIT",
  /** The name of a ledger that tracks the collateral in the form of a secured deposit associated to an Account Holder’s `FinancialAccount` associated to a Secured Credit Card Product. NormalBalanceType = DEBIT. */
  ACCOUNT_HOLDER_SECURED_DEPOSIT = "ACCOUNT_HOLDER_SECURED_DEPOSIT",
  /** The name of a ledger that tracks pending ACH Debits owed on a withdrawal for a `FinancialAccount`. NormalBalanceType = CREDIT. */
  ACH_DEBIT_PAYABLE = "ACH_DEBIT_PAYABLE",
  /** The name of a ledger that tracks pending ACH settlements on a `FinancialAccount` that have the `DirectDepositFinancialAccountFeature` enabled. NormalBalanceType = CREDIT. */
  ACH_PENDING_SETTLEMENT = "ACH_PENDING_SETTLEMENT",
  /** The name of a ledger that tracks pending ACH settlements on a withdrawn for a `FinancialAccount`. NormalBalanceType = DEBIT. */
  ACH_PENDING_SETTLEMENT_OUT = "ACH_PENDING_SETTLEMENT_OUT",
  /** The name of a ledger that tracks activity on a `PaymentCard`. NormalBalanceType = CREDIT. */
  ACTIVITY = "ACTIVITY",
  /** The name of a ledger that tracks amount of credit allocated to Account Holders on a Card Product `FinancialAccount` associated to a credit Card Product. NormalBalanceType = DEBIT. */
  ALLOCATED_CREDIT_LIMIT = "ALLOCATED_CREDIT_LIMIT",
  /** The name of a ledger that tracks the current allocated pseudo limit funds on a `FinancialAccount` that is expecting internal transfer to complete. NormalBalanceType = DEBIT. */
  ALLOCATED_PSEUDO_LIMIT = "ALLOCATED_PSEUDO_LIMIT",
  /** The name of a ledger that tracks authorizations on a `PaymentCard`. NormalBalanceType = CREDIT. */
  AUTHORIZATION = "AUTHORIZATION",
  /** The name of a ledger that tracks the money available to spend for an account. NormalBalanceType = CREDIT. */
  AVAILABLE_CASH = "AVAILABLE_CASH",
  /** The name of a ledger that tracks the available credit on a `FinancialAccount` associated to a credit Card Product. NormalBalanceType = CREDIT. */
  AVAILABLE_CREDIT = "AVAILABLE_CREDIT",
  /** The name of a ledger that tracks the amount owed by `PaymentCard` account to a card network (e.g., Mastercard, Visa, etc.). NormalBalanceType = CREDIT. */
  CARD_PAYABLE = "CARD_PAYABLE",
  /** The name of a ledger that tracks the amount owed to a `PaymentCard` from a card network (e.g., Mastercard, Visa, etc.). NormalBalanceType = DEBIT. */
  CARD_RECEIVABLE = "CARD_RECEIVABLE",
  /** The name of a ledger that tracks card transaction credit holds on a `PaymentCard`. NormalBalanceType = DEBIT. */
  CARD_TRANSACTION_CREDIT_HOLD = "CARD_TRANSACTION_CREDIT_HOLD",
  /** The name of a ledger that tracks the actual money in the account. The ledger can be impacted by any money movement, including cleared transactions and transfers. NormalBalanceType = DEBIT. */
  CASH = "CASH",
  /** The name of a ledger that tracks cash expense on a `PaymentCard`. NormalBalanceType = DEBIT. */
  CASH_EXPENSE = "CASH_EXPENSE",
  /**
   * The name of a ledger that tracks charge-off expenses on a `FinancialAccount`.
   *
   * NormalBalanceType = DEBIT
   */
  CHARGE_OFF_EXPENSE = "CHARGE_OFF_EXPENSE",
  /** The name of a ledger that tracks the initiation of a `CheckPayment` on a `FinancialAccount`. NormalBalanceType = CREDIT. */
  CHECK_PAYABLE = "CHECK_PAYABLE",
  /** The name of a ledger that tracks the processing of a `CheckPayment`. NormalBalanceType = CREDIT. */
  CHECK_PROCESSING = "CHECK_PROCESSING",
  /** The name of a ledger that tracks the settlement of `CheckPayment` funds. NormalBalanceType = DEBIT. */
  CHECK_SETTLEMENT_DEPOSIT = "CHECK_SETTLEMENT_DEPOSIT",
  /** The name of a ledger that tracks cleared authorizations on a `PaymentCard`. NormalBalanceType = CREDIT. */
  CLEARED = "CLEARED",
  /** The name of a ledger that tracks credit authorizations on a `PaymentCard`. These are authorizations that are typically associated with a refund. NormalBalanceType = DEBIT. */
  CREDIT_AUTHORIZATION = "CREDIT_AUTHORIZATION",
  /** The name of a ledger that tracks credit holds on a `PaymentCard`. NormalBalanceType = CREDIT. */
  CREDIT_HOLD = "CREDIT_HOLD",
  /** The name of a ledger that tracks the Credit Limit minus the outstanding balance on a `FinancialAccount` associated to a credit Card Product. NormalBalanceType = DEBIT. */
  CREDIT_OUTSTANDING = "CREDIT_OUTSTANDING",
  /**
   * The name of a ledger that tracks the cryptocurrency funds that can be assigned from a crypto wallet or account.
   *
   * NormalBalanceType = CREDIT
   */
  CRYPTO_AVAILABLE_CASH = "CRYPTO_AVAILABLE_CASH",
  /**
   * The name of a ledger that tracks the actual cryptocurrency in the wallet or account. The ledger can be impacted by any money movement, including cleared transactions and transfers.
   *
   * NormalBalanceType = DEBIT
   */
  CRYPTO_CASH = "CRYPTO_CASH",
  /**
   * The name of a ledger that tracks the customer fee payable on a `FinancialAccount`.
   *
   * NormalBalanceType = CREDIT
   */
  CUSTOMER_FEE_PAYABLE = "CUSTOMER_FEE_PAYABLE",
  /** The name of a ledger that tracks deposit authorizations on a `PaymentCard`. NormalBalanceType = CREDIT. */
  DEPOSIT_AUTHORIZATION = "DEPOSIT_AUTHORIZATION",
  /** The name of a ledger that tracks deposit holds on a `PaymentCard`. NormalBalanceType = CREDIT. */
  DEPOSIT_HOLD = "DEPOSIT_HOLD",
  /** The name of a ledger that tracks deposits waiting to be received on a `FinancialAccount` that have the `DirectDepositFinancialAccountFeature` enabled. NormalBalanceType = DEBIT. */
  DEPOSIT_RECEIVABLE = "DEPOSIT_RECEIVABLE",
  /**
   * The name of a ledger that tracks disbursement carry over payable on a `FinancialAccount`.
   *
   * NormalBalanceType = CREDIT
   */
  DISBURSEMENT_CARRY_OVER_PAYABLE = "DISBURSEMENT_CARRY_OVER_PAYABLE",
  /**
   * The name of a ledger that tracks disbursement carry over receivable on a `FinancialAccount`.
   *
   * NormalBalanceType = DEBIT
   */
  DISBURSEMENT_CARRY_OVER_RECEIVABLE = "DISBURSEMENT_CARRY_OVER_RECEIVABLE",
  /** The name of a ledger that tracks the amount issued to a `FinancialAccount` for a dispute. NormalBalanceType = CREDIT. */
  DISPUTE_CREDIT = "DISPUTE_CREDIT",
  /** The name of a ledger that tracks the amount owed by the issuer for a dispute on a `FinancialAccount`. NormalBalanceType = DEBIT. */
  DISPUTE_EXPENSE = "DISPUTE_EXPENSE",
  /**
   * The name of a ledger that tracks external transfer payables on a `FinancialAccount`.
   *
   * NormalBalanceType = CREDIT
   */
  EXTERNAL_TRANSFER_PAYABLE = "EXTERNAL_TRANSFER_PAYABLE",
  /** The name of a ledger that tracks surcharge fee authorizations on a `PaymentCard`. NormalBalanceType = CREDIT. */
  FEE_AUTHORIZATION = "FEE_AUTHORIZATION",
  /** The name of a ledger that tracks cleared surcharge fee authorizations on a `PaymentCard`. NormalBalanceType = CREDIT. */
  FEE_CLEARED = "FEE_CLEARED",
  /** The name of a ledger that tracks funding hold on an account. NormalBalanceType = CREDIT. */
  FUND_IN_HOLD = "FUND_IN_HOLD",
  /**
   * The name of a ledger that tracks interchange fee precision adjustment on a `FinancialAccount`.
   *
   * NormalBalanceType = CREDIT
   */
  INTERCHANGE_FEE_PRECISION_ADJUSTMENT = "INTERCHANGE_FEE_PRECISION_ADJUSTMENT",
  /** The name of a ledger that tracks interchange revenue from payment card transactions. NormalBalanceType = CREDIT. */
  INTERCHANGE_REVENUE = "INTERCHANGE_REVENUE",
  /** The name of a ledger that tracks the amount owed to an account from a card network due to a refunds or adjustments. NormalBalanceType = DEBIT. */
  NETWORK_CREDIT_RECEIVABLE = "NETWORK_CREDIT_RECEIVABLE",
  /** The name of a ledger that tracks the amount paid to a card network (e.g., Mastercard, Visa, etc.). NormalBalanceType = DEBIT. */
  NETWORK_EXPENSE = "NETWORK_EXPENSE",
  /** The name of a ledger that tracks the amount owed to a card network (e.g., Mastercard, Visa, etc.). NormalBalanceType = CREDIT. */
  NETWORK_PAYABLE = "NETWORK_PAYABLE",
  /** The name of a ledger that tracks the amount owed to an account from a card network (e.g., Mastercard, Visa, etc.). NormalBalanceType = DEBIT. */
  NETWORK_RECEIVABLE = "NETWORK_RECEIVABLE",
  /** The name of a ledger that tracks outstanding balance owed on a `FinancialAccount` associated to a credit Card Product. NormalBalanceType = CREDIT. */
  OUTSTANDING_BALANCE_PAYABLE = "OUTSTANDING_BALANCE_PAYABLE",
  /** The name of a ledger that tracks outstanding balance to be received on a `FinancialAccount` associated to a credit Card Product. NormalBalanceType = DEBIT. */
  OUTSTANDING_BALANCE_RECEIVABLE = "OUTSTANDING_BALANCE_RECEIVABLE",
  /**
   * The name of a ledger that tracks payment chargeback fees owed on a `FinancialAccount`.
   *
   * NormalBalanceType = CREDIT
   */
  PAYMENT_CHARGEBACK_FEE_PAYABLE = "PAYMENT_CHARGEBACK_FEE_PAYABLE",
  /** The name of a ledger that tracks the current payment interchange fee payable funds on a `FinancialAccount` that is expecting internal transfer to complete. NormalBalanceType = CREDIT. */
  PAYMENT_INTERCHANGE_FEE_PAYABLE = "PAYMENT_INTERCHANGE_FEE_PAYABLE",
  /** The name of a ledger that tracks the current payment network fee payable funds on a `FinancialAccount` that is expecting internal transfer to complete. NormalBalanceType = CREDIT. */
  PAYMENT_NETWORK_FEE_PAYABLE = "PAYMENT_NETWORK_FEE_PAYABLE",
  /** The name of a ledger that tracks the current payment payout payable funds on a `FinancialAccount` that is expecting internal transfer to complete. NormalBalanceType = CREDIT. */
  PAYMENT_PAYOUT_PAYABLE = "PAYMENT_PAYOUT_PAYABLE",
  /** The name of a ledger that tracks the current payment platform fee payable funds on a `FinancialAccount` that is expecting internal transfer to complete. NormalBalanceType = CREDIT. */
  PAYMENT_PLATFORM_FEE_PAYABLE = "PAYMENT_PLATFORM_FEE_PAYABLE",
  /** The name of a ledger that tracks Payroll Advance payable on a `FinancialAccount` associated to an `EARNED_WAGE_ACCESS` Card Product. NormalBalanceType = CREDIT. */
  PAYROLL_ADVANCE_PAYABLE = "PAYROLL_ADVANCE_PAYABLE",
  /** The name of a ledger that tracks Payroll Advance receivable on a `FinancialAccount` associated to an `EARNED_WAGE_ACCESS` Card Product. NormalBalanceType = DEBIT. */
  PAYROLL_ADVANCE_RECEIVABLE = "PAYROLL_ADVANCE_RECEIVABLE",
  /** The name of a ledger that tracks Payroll Advance write-off on a `FinancialAccount` associated to an `EARNED_WAGE_ACCESS` Card Product. NormalBalanceType = CREDIT. */
  PAYROLL_ADVANCE_WRITE_OFF = "PAYROLL_ADVANCE_WRITE_OFF",
  /** The name of a ledger that tracks Payroll Advance write-off expense on a `FinancialAccount` associated to an `EARNED_WAGE_ACCESS` Card Product. NormalBalanceType = DEBIT. */
  PAYROLL_ADVANCE_WRITE_OFF_EXPENSE = "PAYROLL_ADVANCE_WRITE_OFF_EXPENSE",
  /** The name of a ledger that tracks pending payment to be received on a `FinancialAccount` associated to a credit Card Product. NormalBalanceType = DEBIT. */
  PENDING_PAYMENT_RECEIVABLE = "PENDING_PAYMENT_RECEIVABLE",
  /** The name of a ledger that tracks provisional credit owed on a `FinancialAccount` of an Account Holder associated to a `FinancialAccount` of a Card Product. NormalBalanceType = CREDIT. */
  PROVISIONAL_CREDIT_PAYABLE = "PROVISIONAL_CREDIT_PAYABLE",
  /** The name of a ledger that tracks provisional credit to be received on a `FinancialAccount` of an Account Holder associated to a `FinancialAccount` of a Card Product. NormalBalanceType = DEBIT. */
  PROVISIONAL_CREDIT_RECEIVABLE = "PROVISIONAL_CREDIT_RECEIVABLE",
  /** The name of a ledger that tracks the available pseudo cash that this `FinancialAccount` has available to spend. NormalBalanceType = CREDIT. */
  PSEUDO_AVAILABLE_CASH = "PSEUDO_AVAILABLE_CASH",
  /**
   * The name of a ledger that tracks the available pseudo credit on a `FinancialAccount`.
   *
   * NormalBalanceType = CREDIT
   */
  PSEUDO_AVAILABLE_CREDIT = "PSEUDO_AVAILABLE_CREDIT",
  /** The name of a ledger that tracks the current pseudo cash that this `FinancialAccount` has spent. NormalBalanceType = DEBIT. */
  PSEUDO_CASH = "PSEUDO_CASH",
  /**
   * The name of a ledger that tracks the outstanding pseudo credit on a `FinancialAccount`.
   *
   * NormalBalanceType = DEBIT
   */
  PSEUDO_CREDIT_OUTSTANDING = "PSEUDO_CREDIT_OUTSTANDING",
  /** The name of a ledger that tracks pull payment credit holds on a `FinancialAccount`. NormalBalanceType = CREDIT. */
  PULL_PAYMENT_CREDIT_HOLD = "PULL_PAYMENT_CREDIT_HOLD",
  /** The name of a ledger that tracks pull payment fees payable on a `FinancialAccount`. NormalBalanceType = CREDIT. */
  PULL_PAYMENT_FEE_PAYABLE = "PULL_PAYMENT_FEE_PAYABLE",
  /** The name of a ledger that tracks pull payment receivables on a `FinancialAccount`. NormalBalanceType = DEBIT. */
  PULL_PAYMENT_RECEIVABLE = "PULL_PAYMENT_RECEIVABLE",
  /**
   * The name of a ledger that tracks the push payment fee payable on a `FinancialAccount`.
   *
   * NormalBalanceType = CREDIT.
   */
  PUSH_PAYMENT_FEE_PAYABLE = "PUSH_PAYMENT_FEE_PAYABLE",
  /**
   * The name of a ledger that tracks the push payment payable on a `FinancialAccount`.
   *
   * NormalBalanceType = CREDIT.
   */
  PUSH_PAYMENT_PAYABLE = "PUSH_PAYMENT_PAYABLE",
  /** The name of a ledger that tracks redeemable rewards points on a `FinancialAccount`. Only available if the `POINT_REWARDS` feature is available on the `FinancialAccount`. NormalBalanceType = CREDIT. */
  REDEEMABLE_REWARDS_POINTS = "REDEEMABLE_REWARDS_POINTS",
  /** The name of a ledger that tracks refund authorizations on a `PaymentCard`. NormalBalanceType = CREDIT. */
  REFUND_AUTHORIZATION = "REFUND_AUTHORIZATION",
  /** The name of a ledger that tracks refund holds on a `PaymentCard`. NormalBalanceType = CREDIT. */
  REFUND_HOLD = "REFUND_HOLD",
  /** The name of a ledger that tracks the reserve for an account. NormalBalanceType = DEBIT. */
  RESERVE = "RESERVE",
  /** The name of a ledger that tracks rewards points on a `FinancialAccount`. Only available if the `POINT_REWARDS` feature is available on the `FinancialAccount`. NormalBalanceType = DEBIT. */
  REWARDS_POINTS = "REWARDS_POINTS",
  /** The name of a ledger that tracks holds for an account that are associated with potential risk on the account. NormalBalanceType = CREDIT. */
  RISK_HOLD = "RISK_HOLD",
  /**
   * The name of a ledger that tracks RTP (Real-Time Payments) debits owed on a `FinancialAccount`.
   *
   * NormalBalanceType = CREDIT
   */
  RTP_DEBIT_PAYABLE = "RTP_DEBIT_PAYABLE",
  /**
   * The name of a ledger that tracks pending RTP (Real-Time Payments) settlements on a `FinancialAccount`.
   *
   * NormalBalanceType = CREDIT
   */
  RTP_PENDING_SETTLEMENT = "RTP_PENDING_SETTLEMENT",
  /** The name of a ledger that tracks collateral in the form of a secured deposit Card Product Funding `FinancialAccount` associated to a Secured Credit Card Product. NormalBalanceType = CREDIT. */
  SECURED_DEPOSIT_COLLATERAL = "SECURED_DEPOSIT_COLLATERAL",
  /** The name of a ledger that tracks secured deposit owed on a `FinancialAccount` associated to a Secured Credit Card Product. NormalBalanceType = CREDIT. */
  SECURED_DEPOSIT_PAYABLE = "SECURED_DEPOSIT_PAYABLE",
  /** The name of a ledger that tracks secured deposit to be received on a `FinancialAccount` associated to a Secured Credit Card Product. NormalBalanceType = DEBIT. */
  SECURED_DEPOSIT_RECEIVABLE = "SECURED_DEPOSIT_RECEIVABLE",
  /**
   * The name of a ledger that tracks self-payout shortages on a `FinancialAccount`.
   *
   * NormalBalanceType = CREDIT
   */
  SELF_PAYOUT_SHORTAGE = "SELF_PAYOUT_SHORTAGE",
  /**
   * The name of a ledger that tracks self-payout shortage expenses on a `FinancialAccount`.
   *
   * NormalBalanceType = DEBIT
   */
  SELF_PAYOUT_SHORTAGE_EXPENSE = "SELF_PAYOUT_SHORTAGE_EXPENSE",
  /** The name of a ledger that tracks the current settlement payable on a `FinancialAccount` that have the `PartialFundingFinancialAccountFeature` enabled. NormalBalanceType = CREDIT. */
  SETTLEMENT_PAYABLE = "SETTLEMENT_PAYABLE",
  /**
   * The name of a ledger that tracks statement due payables on a `FinancialAccount`.
   *
   * NormalBalanceType = CREDIT
   */
  STATEMENT_DUE_PAYABLE = "STATEMENT_DUE_PAYABLE",
  /**
   * The name of a ledger that tracks statement due receivables on a `FinancialAccount`.
   *
   * NormalBalanceType = DEBIT
   */
  STATEMENT_DUE_RECEIVABLE = "STATEMENT_DUE_RECEIVABLE",
  /** The name of a ledger that tracks the current transfer payable on a `FinancialAccount` that is expecting internal transfer to complete. NormalBalanceType = CREDIT. */
  TRANSFER_PAYABLE = "TRANSFER_PAYABLE",
  /** The name of a ledger that tracks the current pending transfer settlement funds on a `FinancialAccount` that is expecting internal transfer to complete. NormalBalanceType = CREDIT. */
  TRANSFER_PENDING_SETTLEMENT = "TRANSFER_PENDING_SETTLEMENT",
  /** The name of a ledger that tracks the current transfer receivable on a `FinancialAccount` that is expecting internal transfer to complete. NormalBalanceType = DEBIT. */
  TRANSFER_RECEIVABLE = "TRANSFER_RECEIVABLE",
  /** The name of a ledger that tracks all uncollected funds for an account. NormalBalanceType = DEBIT. */
  UNCOLLECTED_FUNDS = "UNCOLLECTED_FUNDS",
}

/** Inputs for  filtering ledger entries. */
export type LedgerNameFilterInput = {
  /** Value matches the provided ledger name */
  equals?: InputMaybe<LedgerName>;
  /** Value does not match any of the provided ledger name */
  excludes?: InputMaybe<Array<LedgerName>>;
  /** Value exactly matches all of the provided ledger name */
  includes?: InputMaybe<Array<LedgerName>>;
  /** Value does not match the provided ledger name */
  notEquals?: InputMaybe<LedgerName>;
};

/**
 * ledger report parameters.
 * these are additional, optional, parameters applicable only to ledger report.
 */
export type LedgerReportParametersInput = {
  /** Financial account ids to be included in the ledger report. */
  financialAccountIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Financial account names to be included in the ledger report. */
  financialAccountNames?: InputMaybe<Array<Scalars["String"]>>;
  /** Financial event names to be included in the ledger report. */
  financialEventTypes?: InputMaybe<Array<FinancialEventType>>;
  /** ledger names to be included in the ledger report. */
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** Event generated when an external bank account linking is failed. */
export type LinkVerifiedExternalBankAccountFailedEvent = Node & {
  __typename?: "LinkVerifiedExternalBankAccountFailedEvent";
  /** The identifier of an Account holder */
  accountHolderId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the external bank account was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Id for the workflow. */
  id: Scalars["ID"];
  /** The provider that Highnote used to verify this bank account. */
  provider?: Maybe<BankVerificationProvider>;
  /** The reasons for the external bank account linking failure. */
  reasons?: Maybe<Array<LinkVerifiedExternalBankAccountFailureReason>>;
  /** The date and time, in ISO 8601 format, the external bank account was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** A reason for the external bank account linking failure. */
export type LinkVerifiedExternalBankAccountFailureReason = {
  __typename?: "LinkVerifiedExternalBankAccountFailureReason";
  /** A machine-readable code for the specific failure reason. */
  code?: Maybe<Scalars["String"]>;
  /** A human-readable description for the specific failure reason. */
  description?: Maybe<Scalars["String"]>;
};

/** Input for linking an account holder with a verified external bank account */
export type LinkVerifiedExternalBankInput = {
  /** The token provided by account holder as part of the GenerateVerifiedExternalBankAccountLinkToken process */
  publicToken: Scalars["String"];
};

/** The activity type for a `ManualAdjustmentEvent` */
export enum ManualAdjustmentActivityType {
  /** This adjustment type is for account closure credit amount. */
  ACCOUNT_CLOSURE_CREDIT_AVAILABLE_CREDIT_SETTLEMENT = "ACCOUNT_CLOSURE_CREDIT_AVAILABLE_CREDIT_SETTLEMENT",
  /** This adjustment type is for account closure credit amount. */
  ACCOUNT_CLOSURE_CREDIT_CHARGE_OFF = "ACCOUNT_CLOSURE_CREDIT_CHARGE_OFF",
  /** This adjustment type is for account closure secured amount. */
  ACCOUNT_CLOSURE_SECURED_DEPOSIT_SETTLEMENT = "ACCOUNT_CLOSURE_SECURED_DEPOSIT_SETTLEMENT",
  /** The adjustment type is for fee. */
  ADJUST_FEE = "ADJUST_FEE",
  /** This adjustment type is for transaction amount. */
  CARD_TRANSACTION_ADJUSTMENT = "CARD_TRANSACTION_ADJUSTMENT",
  /** This adjustment type is for chargeback. */
  CHARGEBACK = "CHARGEBACK",
  /** This adjustment type is for chargeback provisional credit amount. */
  CHARGEBACK_CREATE_PROVISIONAL_CREDIT = "CHARGEBACK_CREATE_PROVISIONAL_CREDIT",
  /** This adjustment type is for early wage account repayment amount. */
  EWA_REPAYMENT = "EWA_REPAYMENT",
  /** This adjustment type is for general adjustment. */
  GENERAL_ADJUSTMENT = "GENERAL_ADJUSTMENT",
  /** This adjustment type is for interest waive amount. */
  INTEREST_CHARGED_ADJUSTMENT = "INTEREST_CHARGED_ADJUSTMENT",
  /** This adjustment type is for non-originating ACH amount. */
  NON_ORIGINATING_ACH_PAYROLL_LOAD = "NON_ORIGINATING_ACH_PAYROLL_LOAD",
  /** This adjustment type is for ACH unload amount. */
  NON_ORIGINATING_ACH_UNLOAD = "NON_ORIGINATING_ACH_UNLOAD",
  /** This adjustment type is for originating ACH payment. */
  ORIGINATING_ACH_COMMERCIAL_SECURED_CREDIT_CARD_BALANCE_PAYMENT = "ORIGINATING_ACH_COMMERCIAL_SECURED_CREDIT_CARD_BALANCE_PAYMENT",
  /** This adjustment type is for originating ACH deposit. */
  ORIGINATING_ACH_COMMERCIAL_SECURED_CREDIT_DEPOSIT = "ORIGINATING_ACH_COMMERCIAL_SECURED_CREDIT_DEPOSIT",
  /** This adjustment type is for originating ACH payment. */
  ORIGINATING_ACH_COMMERCIAL_SECURED_CREDIT_DEPOSIT_REPAYMENT = "ORIGINATING_ACH_COMMERCIAL_SECURED_CREDIT_DEPOSIT_REPAYMENT",
  /** This adjustment type is for receivable purchase. */
  RECEIVABLE_PURCHASE = "RECEIVABLE_PURCHASE",
  /** This adjustment type is for receivable purchase. */
  RECEIVABLE_PURCHASE_INTEREST = "RECEIVABLE_PURCHASE_INTEREST",
  /** `Transfer` for adjusting an EWA repayment */
  REPAYMENT_ADJUSTMENT = "REPAYMENT_ADJUSTMENT",
  /** This adjustment type is for risk hold amount. */
  RISK_HOLD_CREDIT = "RISK_HOLD_CREDIT",
  /** This adjustment type is for wire transfer amount. */
  WIRE_TRANSFER_ACCOUNT_LOAD = "WIRE_TRANSFER_ACCOUNT_LOAD",
  /** This adjustment type is for wire transfer amount. */
  WIRE_TRANSFER_ACCOUNT_UNLOAD = "WIRE_TRANSFER_ACCOUNT_UNLOAD",
}

export type ManualAdjustmentDetail =
  | CreditManualAdjustmentDetail
  | DebitManualAdjustmentDetail;

/** A `ManualAdjustmentEvent` for an event that triggers the ledger */
export type ManualAdjustmentEvent = Node & {
  __typename?: "ManualAdjustmentEvent";
  /** The type of manual adjustment event. */
  adjustmentActivityType?: Maybe<ManualAdjustmentActivityType>;
  /** The date and time, in ISO 8601 format, this `ManualAdjustment` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the manual adjustment event. This `id` can be used to later retrieve details of this `ManualAdjustmentEvent`. */
  id: Scalars["ID"];
  /** The event encapsulate impacted account and amount for a `ManualAdjustment`. */
  manualAdjustmentDetails?: Maybe<Array<ManualAdjustmentDetail>>;
  /**
   * Related original finanical event
   * @deprecated Use originalFinancialEventId instead
   */
  originalFinancialEvent?: Maybe<FinancialEvent>;
  /** The ID of a financial event. This `id` can be used to later retrieve details of this `FinancialEvent` or correlate it with other events on this `ManualAdjustment`. */
  originalFinancialEventId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, this `ManualAdjustment` was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** A document upload session that has been requested. */
export type ManualDocumentRequestUploadSession = DocumentUploadSession &
  Node & {
    __typename?: "ManualDocumentRequestUploadSession";
    /** The aggregate entity to which all documents in this collection entry are associated. */
    aggregateEntity?: Maybe<DocumentCollectionAggregateEntity>;
    /** The date and time, in ISO 8601 format, this `ManualDocumentRequestUploadSession` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** A list of requested documents. */
    documentRequests?: Maybe<Array<DocumentRequest>>;
    /** A list of documents uploaded via a secure document upload link */
    documents?: Maybe<Array<UploadLink>>;
    /** The date and time, in ISO 8601 format, this `ManualDocumentRequestUploadSession` will expire. */
    expiresAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the document upload session */
    id: Scalars["ID"];
    /** The document owner this session has been created for */
    owner?: Maybe<DocumentCollectionOwnerEntity>;
    /** The primary entity associated with the `DocumentUploadSession`. */
    primaryEntity?: Maybe<DocumentCollectionPrimaryEntity>;
    /** The current state of the document upload session */
    status?: Maybe<DocumentUploadSessionStatusCode>;
    /** The date and time, in ISO 8601 format, this `ManualDocumentRequestUploadSession` was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** A manually set amount to be transferred */
export type ManualTransferAmount = {
  __typename?: "ManualTransferAmount";
  /** The requested amount to be transferred */
  amount?: Maybe<Amount>;
};

/** Validation result for Mastercard's Accountholder Authentication Value. */
export enum MastercardAavResultCode {
  /** The AAV for the 3DS verification failed validation. */
  AAV_FAILED_VALIDATION = "AAV_FAILED_VALIDATION",
  /** AAV was not validated due to improper formatting. */
  AAV_MISFORMATTED = "AAV_MISFORMATTED",
  /** AAV was not validated due to improper formatting, or due to the AAV being reused or expired. */
  AAV_NOT_VALIDATED = "AAV_NOT_VALIDATED",
  /** The AAV for the 3DS verification passed validation. */
  AAV_PASSED_VALIDATION = "AAV_PASSED_VALIDATION",
  /** The AAV for the 3DS verification was invalid. */
  INVALID_AAV = "INVALID_AAV",
}

/** Details about the fuel location used in a fleet transaction. */
export type MastercardAdditionalFuelLocationDetails = {
  __typename?: "MastercardAdditionalFuelLocationDetails";
  /** This fuel location has alternative fuel pumps. */
  alternativeFuel?: Maybe<Scalars["Boolean"]>;
  /** This fuel location has an aviation location. */
  aviationLocation?: Maybe<Scalars["Boolean"]>;
  /** This fuel location has a convenience store. */
  convenienceStore?: Maybe<Scalars["Boolean"]>;
  /** This fuel location has diesel sites. */
  dieselSites?: Maybe<Scalars["Boolean"]>;
  /** This fuel location has access for 18 wheelers. */
  eighteenWheelerAccess?: Maybe<Scalars["Boolean"]>;
  /** This fuel location has a hotel. */
  hotel?: Maybe<Scalars["Boolean"]>;
  /** This fuel location has interstate highway access. */
  interstateAccess?: Maybe<Scalars["Boolean"]>;
  /** This fuel location has a marina location. */
  marinaLocation?: Maybe<Scalars["Boolean"]>;
  /** This fuel location is open 24 hours. */
  openTwentyFourHours?: Maybe<Scalars["Boolean"]>;
  /** This fuel location has pay-at-pump support. */
  payAtPump?: Maybe<Scalars["Boolean"]>;
  /** This fuel location has repair bays. */
  repairBays?: Maybe<Scalars["Boolean"]>;
  /** This fuel location has a restaurant. */
  restaurant?: Maybe<Scalars["Boolean"]>;
  /** This fuel location has showers. */
  showers?: Maybe<Scalars["Boolean"]>;
  /** This fuel location has a vehicle washing station. */
  vehicleWash?: Maybe<Scalars["Boolean"]>;
};

/** Mastercard specific transaction data. */
export type MastercardData = {
  __typename?: "MastercardData";
  /** Validation result for Mastercard's Accountholder Authentication Value. */
  aavResultCode?: Maybe<MastercardAavResultCode>;
  /** A number used by Mastercard to identify the acquiring institution. */
  acquiringInstitutionIdentificationCode?: Maybe<Scalars["String"]>;
  /** An alphanumeric value generated by Highnote and shared with Mastercard when an authorization is approved. */
  authorizationCode?: Maybe<Scalars["String"]>;
  /** Mastercard’s alphanumeric Banknet reference number used to identify the transaction. */
  banknetReferenceNumber?: Maybe<Scalars["String"]>;
  /** The fraud score for the transaction provided by Mastercard. Values are between 0-999. */
  fraudScore?: Maybe<Scalars["UnsignedInt"]>;
  /** The date and time that the network transmitted the transaction. This value is expressed in Greenwich Mean Time (GMT) with format (MMDDhhmmss) */
  networkTransmissionDateAndTime?: Maybe<Scalars["String"]>;
  /** Payment facilitator identifier for the transaction. */
  paymentFacilitatorIdentifier?: Maybe<Scalars["String"]>;
  /** An value used to identify and track a transaction’s separate messages. */
  retrievalReferenceNumber?: Maybe<Scalars["String"]>;
  /** A number assigned by the message initiator that uniquely identifies a transaction. */
  systemTraceAuditNumber?: Maybe<Scalars["String"]>;
  /** Information about the 3DSecure Cardholder Authentication. */
  threeDSecureCardholderAuthentication?: Maybe<MastercardThreeDSecureCardholderAuthentication>;
  /** Information about the collection capabilities of the Universal Cardholder Authentication Field. */
  ucafCollectionIndicator?: Maybe<MastercardUcafCollectionIndicator>;
};

/** Details pertaining to a Mastercard Fleet transaction available at Authorization and Authorization Advice time */
export type MastercardFleetAuthorizationData = AdditionalTransactionData &
  Node & {
    __typename?: "MastercardFleetAuthorizationData";
    /** An alphanumeric value representing a Driver ID provided by the cardholder */
    driverIdentifier?: Maybe<Scalars["String"]>;
    /** A list of fuel products purchased */
    fuelProducts?: Maybe<Array<MastercardFleetAuthorizationDataFuelProduct>>;
    /** Globally unique id of a `MastercardFleetEnhancedData` */
    id: Scalars["ID"];
    /** A list of non-fuel products purchased */
    nonFuelProducts?: Maybe<
      Array<MastercardFleetAuthorizationDataNonFuelProduct>
    >;
    /** A list of prompt codes and cardholder-entered values */
    prompts?: Maybe<Array<MastercardFleetPrompt>>;
    /** Indicates whether the POS supports overriding the fleet spend controls on the card */
    spendControlOverrideFlag?: Maybe<Scalars["Boolean"]>;
    /** An alphanumeric value representing a Vehicle ID provided by the cardholder */
    vehicleIdentifier?: Maybe<Scalars["String"]>;
  };

/** Details of a Mastercard Fleet fuel product available at Authorization and Authorization Advice time */
export type MastercardFleetAuthorizationDataFuelProduct = {
  __typename?: "MastercardFleetAuthorizationDataFuelProduct";
  /** Indicates the type of fuel product purchased */
  code?: Maybe<MastercardFleetFuelProductCode>;
  /** The quantity for the product purchased as a whole number */
  quantity?: Maybe<Scalars["UnsignedInt"]>;
  /** The precision of the `Quantity` value */
  quantityPrecision?: Maybe<Scalars["UnsignedInt"]>;
  /** Contains the sale amount of the product purchased */
  saleAmount?: Maybe<Amount>;
  /** The unit of measure for the product purchased */
  unitOfMeasure?: Maybe<MastercardFleetUnitOfMeasure>;
  /** The unit price of the fuel product as a whole number */
  unitPrice?: Maybe<Scalars["UnsignedInt"]>;
  /** The precision of the `UnitPrice` value */
  unitPricePrecision?: Maybe<Scalars["UnsignedInt"]>;
};

/** Details of a Mastercard Fleet non-fuel product available at Authorization and Authorization Advice time */
export type MastercardFleetAuthorizationDataNonFuelProduct = {
  __typename?: "MastercardFleetAuthorizationDataNonFuelProduct";
  /** Indicates the type of fuel product purchased */
  code?: Maybe<MastercardFleetNonFuelProductCode>;
  /** Contains the individual item amount that is normally calculated as price multiplied by quantity */
  extendedItemAmount?: Maybe<Amount>;
  /** The quantity for the product purchased as a whole number */
  quantity?: Maybe<Scalars["UnsignedInt"]>;
  /** The precision of the `Quantity` value */
  quantityPrecision?: Maybe<Scalars["UnsignedInt"]>;
  /** The unit of measure for the product purchased */
  unitOfMeasure?: Maybe<Scalars["String"]>;
};

/** Mastercard Fleet credit or debit indicator */
export enum MastercardFleetCreditOrDebitIndicator {
  /** Indicates that the amount is a credit */
  CREDIT = "CREDIT",
  /** Indicates that the amount is a debit */
  DEBIT = "DEBIT",
}

/** Details of Mastercard Fleet enhanced transaction data. These are relevant additional transaction data items pertaining to a fleet transaction. */
export type MastercardFleetEnhancedData = AdditionalTransactionData &
  Node & {
    __typename?: "MastercardFleetEnhancedData";
    /** Driver Identification Number. Only included if POS prompts for this value */
    driverIdentification?: Maybe<Scalars["String"]>;
    /** Oil Company Brand Name */
    fuelBrand?: Maybe<MastercardFleetFuelBrand>;
    /** Fuel Discount Amount */
    fuelDiscountAmount?: Maybe<Amount>;
    /** Details about the fuel location */
    fuelLocationDetails?: Maybe<MastercardAdditionalFuelLocationDetails>;
    /** Motor Fuel Quantity */
    fuelQuantity?: Maybe<Scalars["Float"]>;
    /** Motor Fuel Sale Amount */
    fuelSaleAmount?: Maybe<Amount>;
    /** Motor Fuel Service Type */
    fuelServiceType?: Maybe<MastercardFleetFuelServiceType>;
    /** Motor Fuel Product Code */
    fuelType?: Maybe<MastercardFleetProductCode>;
    /** Motor Fuel Unit of Measure */
    fuelUnitOfMeasure?: Maybe<MastercardFleetUnitOfMeasure>;
    /** Motor Fuel Unit Price */
    fuelUnitPrice?: Maybe<Amount>;
    /** The raw value received from the network for the motor fuel unit price */
    fuelUnitPriceValue?: Maybe<Scalars["UnsignedInt"]>;
    /** The decimal precision for the `fuelUnitPriceValue` */
    fuelUnitPriceValuePrecision?: Maybe<Scalars["UnsignedInt"]>;
    /** Globally unique id of a `MastercardFleetEnhancedData`. */
    id: Scalars["ID"];
    /** Line items on the invoice */
    lineItems?: Maybe<Array<MastercardFleetEnhancedDataLineItem>>;
    /** Odometer Reading. Only included if POS prompts for this value */
    odometerReading?: Maybe<Scalars["String"]>;
    /** Product Type Code */
    productType?: Maybe<MastercardFleetProductType>;
    /** The local time the purchase was made. Should be in the format hhmm, with hours in the range 00–23 and minutes in the range 00–59 */
    purchaseTime?: Maybe<Scalars["String"]>;
    /** Tax Amount 1 */
    taxAmount1?: Maybe<Amount>;
    /** Tax Amount 2 */
    taxAmount2?: Maybe<Amount>;
    /** Vehicle Identification Number. Only included if POS prompts for this value */
    vehicleNumber?: Maybe<Scalars["String"]>;
  };

/** An single line item within a `MastercardFleetEnhancedData` */
export type MastercardFleetEnhancedDataLineItem = {
  __typename?: "MastercardFleetEnhancedDataLineItem";
  /** Indicates whether the item amount, net of discount, taxes, and price, is a debit or credit */
  creditOrDebit?: Maybe<MastercardFleetCreditOrDebitIndicator>;
  /**
   * Description of the individual item purchased
   *
   * **Maximum length:** 255 characters
   */
  description?: Maybe<Scalars["String"]>;
  /** the individual item amount that is normally calculated as price multiplied by quantity */
  itemAmount?: Maybe<Amount>;
  /** The raw value received from the network for the individual item amount */
  itemAmountValue?: Maybe<Scalars["UnsignedInt"]>;
  /** The decimal precision for the `itemAmountValue` */
  itemAmountValuePrecision?: Maybe<Scalars["UnsignedInt"]>;
  /** The product code of the individual item purchased */
  productCode?: Maybe<MastercardFleetProductCode>;
  /** Quantity of the item purchased */
  quantity?: Maybe<Scalars["Float"]>;
  /** The unit of measurement for the item purchased */
  unitOfMeasure?: Maybe<Scalars["String"]>;
  /** The unit price of the item purchased */
  unitPrice?: Maybe<Amount>;
  /** The raw value received from the network for the line item unit price */
  unitPriceValue?: Maybe<Scalars["UnsignedInt"]>;
  /** The decimal precision for the `unitPriceValuePrecision` */
  unitPriceValuePrecision?: Maybe<Scalars["UnsignedInt"]>;
};

/** Mastercard Fleet fuel brands */
export enum MastercardFleetFuelBrand {
  /** AAFES */
  AAFES = "AAFES",
  /** Amoco Petroleum Products */
  AMOCO = "AMOCO",
  /** Amoco Canada */
  AMOCO_CA = "AMOCO_CA",
  /** Arco Products */
  ARCO = "ARCO",
  /** Asda */
  ASDA = "ASDA",
  /** Ashland Oil */
  ASHLAND = "ASHLAND",
  /** BFL */
  BFL = "BFL",
  /** BP Oil */
  BP = "BP",
  /** BP/Mobil */
  BP_MOBIL = "BP_MOBIL",
  /** Burrnah/Major */
  BURNAH = "BURNAH",
  /** Butler/Arndale */
  BUTLER = "BUTLER",
  /** Canadian Tire */
  CANADIAN_TIRE = "CANADIAN_TIRE",
  /** Canadian Turbo */
  CANADIAN_TURBO = "CANADIAN_TURBO",
  /** Casey’s General Store */
  CASEYS = "CASEYS",
  /** Cenex */
  CENEX = "CENEX",
  /** Chevron USA */
  CHEVRON = "CHEVRON",
  /** Chevron Canada */
  CHEVRON_CA = "CHEVRON_CA",
  /** Circle K Stores */
  CIRCLE_K = "CIRCLE_K",
  /** Citgo Petroleum */
  CITGO = "CITGO",
  /** Clark Brands */
  CLARK = "CLARK",
  /** Conoco Inc. */
  CONOCO = "CONOCO",
  /** Conoco Canada */
  CONOCO_CA = "CONOCO_CA",
  /** Crown Central Petroleum */
  CROWN_CENTRAL = "CROWN_CENTRAL",
  /** Diamond Shamrock Inc. */
  DIAMOND_SHAMROCK = "DIAMOND_SHAMROCK",
  /** Discount Tire */
  DISCOUNT_TIRE = "DISCOUNT_TIRE",
  /** Domo Gas */
  DOMO = "DOMO",
  /** Elf */
  ELF = "ELF",
  /** Erickson Oil */
  ERICKSON = "ERICKSON",
  /** Esso Canada */
  ESSO_CA = "ESSO_CA",
  /** Esso */
  ESSO_EU = "ESSO_EU",
  /** Exxon */
  EXXON = "EXXON",
  /** ExxonMobil */
  EXXON_MOBIL = "EXXON_MOBIL",
  /** Family Express */
  FAMILY = "FAMILY",
  /** Fas Gas Oil */
  FAS = "FAS",
  /** Fina Inc. */
  FINA = "FINA",
  /** Fina */
  FINA_EU = "FINA_EU",
  /** FKG Oil */
  FKG = "FKG",
  /** Flare */
  FLARE = "FLARE",
  /** Flying J Inc. */
  FLYING_J = "FLYING_J",
  /** Gas America */
  GAS_AMERICA = "GAS_AMERICA",
  /** Gate Petroleum */
  GATE = "GATE",
  /** Getty Petroleum */
  GETTY = "GETTY",
  /** Giant Eagle */
  GIANT_EAGLE = "GIANT_EAGLE",
  /** GrowMark, Inc. */
  GROWMARK = "GROWMARK",
  /** Gulf */
  GULF = "GULF",
  /** Gulf Canada */
  GULF_CA = "GULF_CA",
  /** Gulf (Chevron) */
  GULF_CHEVRON = "GULF_CHEVRON",
  /** Handy Way Food */
  HANDY_WAY = "HANDY_WAY",
  /** Heron */
  HERON = "HERON",
  /** Amerada Hess */
  HESS = "HESS",
  /** Holiday Stores */
  HOLIDAY = "HOLIDAY",
  /** Home Depot */
  HOME_DEPOT = "HOME_DEPOT",
  /** Martin & Bailey Inc. (DBA Huck’s) */
  HUCKS = "HUCKS",
  /** Husky */
  HUSKY = "HUSKY",
  /** Hyvee’s */
  HYVEES = "HYVEES",
  /** Irving Oil */
  IRVING = "IRVING",
  /** Irving Canada */
  IRVING_CA = "IRVING_CA",
  /** Jet (Conoco) */
  JET = "JET",
  /** J. Sainsbury */
  JSAINSBURY = "JSAINSBURY",
  /** Krogers */
  KROGER = "KROGER",
  /** Kuwait */
  KUWAIT = "KUWAIT",
  /** United Refining (Kwik Fill) */
  KWIK_FILL = "KWIK_FILL",
  /** Kwik Trip Inc. */
  KWIK_TRIP = "KWIK_TRIP",
  /** Lassus */
  LASSUS = "LASSUS",
  /** Love’s Country Stores */
  LOVES = "LOVES",
  /** Mapco Express Inc. */
  MAPCO = "MAPCO",
  /** Marathon Oil */
  MARATHON = "MARATHON",
  /** Maxol */
  MAXOL = "MAXOL",
  /** Meineke */
  MEINEKE = "MEINEKE",
  /** MFA */
  MFA = "MFA",
  /** Mohawk */
  MOHAWK = "MOHAWK",
  /** W M Morrison */
  MORRISON = "MORRISON",
  /** Mr. Gas */
  MR_GAS = "MR_GAS",
  /** Murco */
  MURCO = "MURCO",
  /** Murphy Oil USA Inc. */
  MURPHY = "MURPHY",
  /** Murphy Oil Canada */
  MURPHY_CA = "MURPHY_CA",
  /** Nexcom */
  NEXCOM = "NEXCOM",
  /** Nordstrom Oil */
  NORDSTROM = "NORDSTROM",
  /** Olco */
  OLCO = "OLCO",
  /** PDQ Store */
  PDQ = "PDQ",
  /** Pennzoil Products Inc. */
  PENNZOIL = "PENNZOIL",
  /** Petro */
  PETRO = "PETRO",
  /** PetroCanada */
  PETROCANADA = "PETROCANADA",
  /** Petro-T */
  PETRO_T = "PETRO_T",
  /** Phillips */
  PHILLIPS = "PHILLIPS",
  /** Pilot */
  PILOT = "PILOT",
  /** Pioneer */
  PIONEER = "PIONEER",
  /** Pioneer */
  PIONEER_EU = "PIONEER_EU",
  /** Pure Oil */
  PURE = "PURE",
  /** Quaker State */
  QUAKER_STATE = "QUAKER_STATE",
  /** Quarles Oil */
  QUARLES = "QUARLES",
  /** Quik Trip */
  QUIK_TRIP = "QUIK_TRIP",
  /** RaceTrac Petroleum Inc. */
  RACETRAC = "RACETRAC",
  /** Raceway Petroleum */
  RACEWAY = "RACEWAY",
  /** Repsol */
  REPSOL = "REPSOL",
  /** Rudy */
  RUDY = "RUDY",
  /** Safeway */
  SAFEWAY = "SAFEWAY",
  /** 7-Eleven */
  SEVEN_ELEVEN = "SEVEN_ELEVEN",
  /** Seven-Eleven */
  SEVEN_ELEVEN_CA = "SEVEN_ELEVEN_CA",
  /** Sheetz */
  SHEETZ = "SHEETZ",
  /** Shell Oil */
  SHELL = "SHELL",
  /** Shell Canada */
  SHELL_CA = "SHELL_CA",
  /** Shell */
  SHELL_EU = "SHELL_EU",
  /** Sinclair Oil */
  SINCLAIR = "SINCLAIR",
  /** Federated Co-op (Sonic) */
  SONIC = "SONIC",
  /** Southland Oil */
  SOUTHLAND = "SOUTHLAND",
  /** SPAR */
  SPAR = "SPAR",
  /** Speedway */
  SPEEDWAY = "SPEEDWAY",
  /** Sun Company Inc. */
  SUN = "SUN",
  /** Suncor (Sunoco Canada) */
  SUNOCO_CA = "SUNOCO_CA",
  /** Travel Centers of America */
  TA = "TA",
  /** Tempo */
  TEMPO = "TEMPO",
  /** Tesco */
  TESCO_EU = "TESCO_EU",
  /** Tesoro Alaska */
  TESORO_AK = "TESORO_AK",
  /** Texaco */
  TEXACO = "TEXACO",
  /** Texaco */
  TEXACO_EU = "TEXACO_EU",
  /** The Pantry, Inc. */
  THE_PANTRY = "THE_PANTRY",
  /** Thornton Oil */
  THORNTON = "THORNTON",
  /** Tosco */
  TOSCO = "TOSCO",
  /** Total */
  TOTAL = "TOTAL",
  /** UK */
  UK = "UK",
  /** Ultramar Canada */
  ULTRAMAR = "ULTRAMAR",
  /** Unbranded/Unassigned */
  UNBRANDED = "UNBRANDED",
  /** Union 76 */
  UNION_76 = "UNION_76",
  /** United Dairy Farmer */
  UNITED_DAIRY = "UNITED_DAIRY",
  /** USA Petroleum */
  USA_PETROLEUM = "USA_PETROLEUM",
  /** US Oil */
  US_OIL = "US_OIL",
  /** Valvoline */
  VALVOLINE = "VALVOLINE",
  /** VG */
  VG = "VG",
  /** Warren Equities */
  WARREN_EQUITIES = "WARREN_EQUITIES",
  /** Wawa */
  WAWA = "WAWA",
  /** Western Energetix */
  WESTERN_ENERGETIX = "WESTERN_ENERGETIX",
  /** Wilco */
  WILCO = "WILCO",
  /** Zions */
  ZIONS = "ZIONS",
}

/** Mastercard Fleet fuel product codes */
export enum MastercardFleetFuelProductCode {
  /** Additive Dosage */
  ADDITIVE_DOSAGE = "ADDITIVE_DOSAGE",
  /** Additized Diesel #2 */
  ADDITIZED_DIESEL_2 = "ADDITIZED_DIESEL_2",
  /** Additized Diesel #3 */
  ADDITIZED_DIESEL_3 = "ADDITIZED_DIESEL_3",
  /** Aviation Biofuel (Gasoline) */
  AVIATION_BIOFUEL = "AVIATION_BIOFUEL",
  /** Aviation Fuel 4 */
  AVIATION_FUEL_4 = "AVIATION_FUEL_4",
  /** Aviation Fuel 5 */
  AVIATION_FUEL_5 = "AVIATION_FUEL_5",
  /** Aviation Fuel JP8 */
  AVIATION_FUEL_JP8 = "AVIATION_FUEL_JP8",
  /** Aviation Fuel Premium */
  AVIATION_FUEL_PREMIUM = "AVIATION_FUEL_PREMIUM",
  /** Aviation Fuel Regular */
  AVIATION_FUEL_REGULAR = "AVIATION_FUEL_REGULAR",
  /** B1 Diesel Blend 1% Biodiesel */
  B1_DIESEL_BLEND = "B1_DIESEL_BLEND",
  /** B2 Diesel Blend 2% Biodiesel */
  B2_DIESEL_BLEND = "B2_DIESEL_BLEND",
  /** B5 Diesel Blend 5% Biodiesel */
  B5_DIESEL_BLEND = "B5_DIESEL_BLEND",
  /** B10 Diesel Blend 10% Biodiesel */
  B10_DIESEL_BLEND = "B10_DIESEL_BLEND",
  /** B11 Diesel Blend 11% Biodiesel */
  B11_DIESEL_BLEND = "B11_DIESEL_BLEND",
  /** B15 Diesel Blend 15% Biodiesel */
  B15_DIESEL_BLEND = "B15_DIESEL_BLEND",
  /** B20 Diesel Blend 20% Biodiesel */
  B20_DIESEL_BLEND = "B20_DIESEL_BLEND",
  /** B75 Diesel Blend 75% Biodiesel */
  B75_DIESEL_BLEND = "B75_DIESEL_BLEND",
  /** B99 Diesel Blend 99% Biodiesel */
  B99_DIESEL_BLEND = "B99_DIESEL_BLEND",
  /** B100 Diesel Blend 100% Biodiesel */
  B100_DIESEL_BLEND = "B100_DIESEL_BLEND",
  /** Biodiesel Blend 1% Off-Road (Non-Taxable) */
  BIODIESEL_BLEND_1_OFF_ROAD = "BIODIESEL_BLEND_1_OFF_ROAD",
  /** Biodiesel Blend 2% Off-Road (Non-Taxable) */
  BIODIESEL_BLEND_2_OFF_ROAD = "BIODIESEL_BLEND_2_OFF_ROAD",
  /** Biodiesel Blend 5% Off-Road (Non-Taxable) */
  BIODIESEL_BLEND_5_OFF_ROAD = "BIODIESEL_BLEND_5_OFF_ROAD",
  /** Biodiesel Blend 10% Off-Road (Non-Taxable) */
  BIODIESEL_BLEND_10_OFF_ROAD = "BIODIESEL_BLEND_10_OFF_ROAD",
  /** Biodiesel Blend 11% Off-Road (Non-Taxable) */
  BIODIESEL_BLEND_11_OFF_ROAD = "BIODIESEL_BLEND_11_OFF_ROAD",
  /** Biodiesel Blend 15% Off-Road (Non-Taxable) */
  BIODIESEL_BLEND_15_OFF_ROAD = "BIODIESEL_BLEND_15_OFF_ROAD",
  /** Biodiesel Blend 20% Off-Road (Non-Taxable) */
  BIODIESEL_BLEND_20_OFF_ROAD = "BIODIESEL_BLEND_20_OFF_ROAD",
  /** Biodiesel Blend 75% Off-Road (Non-Taxable) */
  BIODIESEL_BLEND_75_OFF_ROAD = "BIODIESEL_BLEND_75_OFF_ROAD",
  /** Biodiesel Blend 99% Off-Road (Non-Taxable) */
  BIODIESEL_BLEND_99_OFF_ROAD = "BIODIESEL_BLEND_99_OFF_ROAD",
  /** Biodiesel Blend 100% Off-Road (Non-Taxable) */
  BIODIESEL_BLEND_100_OFF_ROAD = "BIODIESEL_BLEND_100_OFF_ROAD",
  /** Biodiesel Blend Off-Road (Non-Taxable) */
  BIODIESEL_BLEND_OFF_ROAD = "BIODIESEL_BLEND_OFF_ROAD",
  /** Biojet (Diesel) */
  BIOJET = "BIOJET",
  /** Blended Diesel (#1 and #2) */
  BLENDED_DIESEL = "BLENDED_DIESEL",
  /** Compressed Natural Gas */
  COMPRESSED_NATURAL_GAS = "COMPRESSED_NATURAL_GAS",
  /** DEF (Diesel Exhaust Fluid) */
  DEF = "DEF",
  /** Diesel #1 Off-Road (Non-Taxable) */
  DIESEL_1_OFF_ROAD = "DIESEL_1_OFF_ROAD",
  /** Diesel #1 Premium Off-Road (Non-Taxable) */
  DIESEL_1_PREMIUM_OFF_ROAD = "DIESEL_1_PREMIUM_OFF_ROAD",
  /** Diesel #2 Off-Road (Non-Taxable) */
  DIESEL_2_OFF_ROAD = "DIESEL_2_OFF_ROAD",
  /** Diesel #2 Premium Off-Road (Non-Taxable) */
  DIESEL_2_PREMIUM_OFF_ROAD = "DIESEL_2_PREMIUM_OFF_ROAD",
  /** Diesel Off-Road (#1 and #2 Non-Taxable) */
  DIESEL_OFF_ROAD_1_AND_2_NON_TAXABLE = "DIESEL_OFF_ROAD_1_AND_2_NON_TAXABLE",
  /** Diesel Off-Road (Non-Taxable) */
  DIESEL_OFF_ROAD_NON_TAXABLE = "DIESEL_OFF_ROAD_NON_TAXABLE",
  /** <Deprecated> Ethanol (5.7% blend) */
  ETHANOL_5_7_BLEND = "ETHANOL_5_7_BLEND",
  /** <Deprecated> Ethanol (7.7% blend) */
  ETHANOL_7_7_BLEND = "ETHANOL_7_7_BLEND",
  /** Ethanol Blends E16-E84 */
  ETHANOL_BLENDS_E16_E84 = "ETHANOL_BLENDS_E16_E84",
  /** EVC-1 – Level 1 charge = 110v 15 amp */
  EVC_LEVEL_1_CHARGE = "EVC_LEVEL_1_CHARGE",
  /** EVC-2 – Level 2 charge = 240v 15-40 amp */
  EVC_LEVEL_2_CHARGE = "EVC_LEVEL_2_CHARGE",
  /** EVC-3 – Level 3 charge = 480v 3 phase charge */
  EVC_LEVEL_3_CHARGE = "EVC_LEVEL_3_CHARGE",
  /** E-85 */
  E_85 = "E_85",
  /** Green Gasoline Mid/Plus (Plant based not petroleum based) */
  GREEN_GASOLINE_MID_PLUS = "GREEN_GASOLINE_MID_PLUS",
  /** Green Gasoline Premium/Super (Plant based not petroleum based) */
  GREEN_GASOLINE_PREMIUM_SUPER = "GREEN_GASOLINE_PREMIUM_SUPER",
  /** Green Gasoline Regular (Plant based not petroleum based) */
  GREEN_GASOLINE_REGULAR = "GREEN_GASOLINE_REGULAR",
  /** Heating Oil */
  HEATING_OIL = "HEATING_OIL",
  /** Hydrogen H35 */
  HYDROGEN_H35 = "HYDROGEN_H35",
  /** Hydrogen H70 */
  HYDROGEN_H70 = "HYDROGEN_H70",
  /** Jet Fuel */
  JET_FUEL = "JET_FUEL",
  /** Kerosene – Low Sulfur */
  KEROSENE_LOW_SULFUR = "KEROSENE_LOW_SULFUR",
  /** Kerosene – Low Sulfur (Non-Taxable) */
  KEROSENE_LOW_SULFUR_NON_TAXABLE = "KEROSENE_LOW_SULFUR_NON_TAXABLE",
  /** Kerosene – Ultra Low Sulfur */
  KEROSENE_ULTRA_LOW_SULFUR = "KEROSENE_ULTRA_LOW_SULFUR",
  /** Kerosene – Ultra Low Sulfur (Non-Taxable) */
  KEROSENE_ULTRA_LOW_SULFUR_NON_TAXABLE = "KEROSENE_ULTRA_LOW_SULFUR_NON_TAXABLE",
  /** Liquid Natural Gas */
  LIQUID_NATURAL_GAS = "LIQUID_NATURAL_GAS",
  /** Liquid Propane Gas */
  LIQUID_PROPANE_GAS = "LIQUID_PROPANE_GAS",
  /** Low Octane UNL */
  LOW_OCTANE_UNL = "LOW_OCTANE_UNL",
  /** Marine Diesel */
  MARINE_DIESEL = "MARINE_DIESEL",
  /** Marine Fuel 1 */
  MARINE_FUEL_1 = "MARINE_FUEL_1",
  /** Marine Fuel 2 */
  MARINE_FUEL_2 = "MARINE_FUEL_2",
  /** Marine Fuel 3 */
  MARINE_FUEL_3 = "MARINE_FUEL_3",
  /** Marine Fuel 4 */
  MARINE_FUEL_4 = "MARINE_FUEL_4",
  /** Marine Fuel 5 */
  MARINE_FUEL_5 = "MARINE_FUEL_5",
  /** Marine - Other */
  MARINE_OTHER = "MARINE_OTHER",
  /** Mid/Plus */
  MID_PLUS = "MID_PLUS",
  /** Mid/Plus 2 */
  MID_PLUS_2 = "MID_PLUS_2",
  /** Mid/Plus 2 (10% Blend) */
  MID_PLUS_2_10_PERCENT_BLEND = "MID_PLUS_2_10_PERCENT_BLEND",
  /** Mid/Plus Ethanol 2 (15% Blend) */
  MID_PLUS_ETHANOL_2_10_BLEND = "MID_PLUS_ETHANOL_2_10_BLEND",
  /** <Deprecated> Mid/Plus Ethanol (5.7% blend) */
  MID_PLUS_ETHANOL_5_7_BLEND = "MID_PLUS_ETHANOL_5_7_BLEND",
  /** <Deprecated> Mid/Plus Ethanol (7.7% blend) */
  MID_PLUS_ETHANOL_7_7_BLEND = "MID_PLUS_ETHANOL_7_7_BLEND",
  /** Mid/Plus Ethanol (10% Blend) */
  MID_PLUS_ETHANOL_10_BLEND = "MID_PLUS_ETHANOL_10_BLEND",
  /** Mid/Plus Ethanol (15% Blend) */
  MID_PLUS_ETHANOL_15_BLEND = "MID_PLUS_ETHANOL_15_BLEND",
  /** Miscellaneous Aviation Fuel */
  MISCELLANEOUS_AVIATION_FUEL = "MISCELLANEOUS_AVIATION_FUEL",
  /** Miscellaneous Fuel */
  MISCELLANEOUS_FUEL = "MISCELLANEOUS_FUEL",
  /** Miscellaneous Marine Fuel */
  MISCELLANEOUS_MARINE_FUEL = "MISCELLANEOUS_MARINE_FUEL",
  /** Miscellaneous Other Fuel */
  MISCELLANEOUS_OTHER_FUEL = "MISCELLANEOUS_OTHER_FUEL",
  /** Off-Road Mid/Plus (Non-Taxable) */
  OFF_ROAD_MID_PLUS = "OFF_ROAD_MID_PLUS",
  /** Off-Road Mid/Plus 2 (Non-Taxable) */
  OFF_ROAD_MID_PLUS_2 = "OFF_ROAD_MID_PLUS_2",
  /** Off-Road Premium/Super (Non-Taxable) */
  OFF_ROAD_PREMIUM_SUPER = "OFF_ROAD_PREMIUM_SUPER",
  /** Off-Road Premium/Super 2 (Non-Taxable) */
  OFF_ROAD_PREMIUM_SUPER_2 = "OFF_ROAD_PREMIUM_SUPER_2",
  /** Off-Road Regular (Non-Taxable) */
  OFF_ROAD_REGULAR = "OFF_ROAD_REGULAR",
  /** Other Fuel (Non-Taxable) */
  OTHER_FUEL = "OTHER_FUEL",
  /** Premium Diesel #1 */
  PREMIUM_DIESEL_1 = "PREMIUM_DIESEL_1",
  /** Premium Diesel #2 */
  PREMIUM_DIESEL_2 = "PREMIUM_DIESEL_2",
  /** Premium Diesel Blend <20% Biodiesel */
  PREMIUM_DIESEL_BLEND_1 = "PREMIUM_DIESEL_BLEND_1",
  /** Premium Diesel Blend >= 20% Biodiesel */
  PREMIUM_DIESEL_BLEND_2 = "PREMIUM_DIESEL_BLEND_2",
  /** Premium/Super */
  PREMIUM_SUPER = "PREMIUM_SUPER",
  /** Premium/Super 2 */
  PREMIUM_SUPER_2 = "PREMIUM_SUPER_2",
  /** Premium/Super 2 (10% Blend) */
  PREMIUM_SUPER_2_10_BLEND = "PREMIUM_SUPER_2_10_BLEND",
  /** Premium/Super Ethanol 2 (15% Blend) */
  PREMIUM_SUPER_ETHANOL_2_10_BLEND = "PREMIUM_SUPER_ETHANOL_2_10_BLEND",
  /** <Deprecated> Premium/Super Ethanol (5.7% blend) */
  PREMIUM_SUPER_ETHANOL_5_7_BLEND = "PREMIUM_SUPER_ETHANOL_5_7_BLEND",
  /** <Deprecated> Premium/Super Ethanol (7.7% Blend) */
  PREMIUM_SUPER_ETHANOL_7_7_BLEND = "PREMIUM_SUPER_ETHANOL_7_7_BLEND",
  /** Premium/Super Ethanol (10% Blend) */
  PREMIUM_SUPER_ETHANOL_10_BLEND = "PREMIUM_SUPER_ETHANOL_10_BLEND",
  /** Premium/Super Ethanol (15% Blend) */
  PREMIUM_SUPER_ETHANOL_15_BLEND = "PREMIUM_SUPER_ETHANOL_15_BLEND",
  /** Racing Fuel */
  RACING_FUEL = "RACING_FUEL",
  /** Recreational Fuel (90 Octane) */
  RECREATIONAL_FUEL = "RECREATIONAL_FUEL",
  /** Reformulated 1 */
  REFORMULATED_1 = "REFORMULATED_1",
  /** Reformulated 2 */
  REFORMULATED_2 = "REFORMULATED_2",
  /** Reformulated 3 */
  REFORMULATED_3 = "REFORMULATED_3",
  /** Reformulated 4 */
  REFORMULATED_4 = "REFORMULATED_4",
  /** Reformulated 5 */
  REFORMULATED_5 = "REFORMULATED_5",
  /** Regular */
  REGULAR = "REGULAR",
  /** Regular Diesel #1 */
  REGULAR_DIESEL_1 = "REGULAR_DIESEL_1",
  /** Regular Diesel #2 */
  REGULAR_DIESEL_2 = "REGULAR_DIESEL_2",
  /** Regular Ethanol (10% Blend) */
  REGULAR_ETHANOL_10_BLEND = "REGULAR_ETHANOL_10_BLEND",
  /** Regular Ethanol (15% Blend) */
  REGULAR_ETHANOL_15_BLEND = "REGULAR_ETHANOL_15_BLEND",
  /** Renewable Diesel (>=R95) (meets ASTM D975 in US / EN 590 in Europe) */
  RENEWABLE_DIESEL = "RENEWABLE_DIESEL",
  /** Renewable Diesel (Biodiesel 6%-20%) (meets ASTM D7467 in US) */
  RENEWABLE_DIESEL_BIODIESEL = "RENEWABLE_DIESEL_BIODIESEL",
  /** Renewable Diesel (Biodiesel 6%-20%) Off-Road (Non-taxable) (meets ASTM D7467 in US) */
  RENEWABLE_DIESEL_BIODIESEL_OFF_ROAD = "RENEWABLE_DIESEL_BIODIESEL_OFF_ROAD",
  /** Renewable Diesel (>=R95) Off-Road (Non-Taxable) (meets ASTM D975 in US / EN 590 in Europe) */
  RENEWABLE_DIESEL_OFF_ROAD = "RENEWABLE_DIESEL_OFF_ROAD",
  /** Undefined Fuel - Reserved for Conexxus Future */
  UNDEFINED_FUEL = "UNDEFINED_FUEL",
  /** White Gas */
  WHITE_GAS = "WHITE_GAS",
}

/** Mastercard Fleet fuel service type */
export enum MastercardFleetFuelServiceType {
  /** Full service */
  FULL_SERVICE = "FULL_SERVICE",
  /** Only non-fuel products being purchased */
  ONLY_NON_FUEL_PRODUCTS = "ONLY_NON_FUEL_PRODUCTS",
  /** Self-service */
  SELF_SERVICE = "SELF_SERVICE",
  /** Undefined */
  UNDEFINED = "UNDEFINED",
}

/** Mastercard Fleet non-fuel product codes */
export enum MastercardFleetNonFuelProductCode {
  /** AC Parts */
  AC_PARTS = "AC_PARTS",
  /** Aircraft Accessories */
  AIRCRAFT_ACCESSORIES = "AIRCRAFT_ACCESSORIES",
  /** Aircraft Cleaning */
  AIRCRAFT_CLEANING = "AIRCRAFT_CLEANING",
  /** Aircraft Fuel Additive */
  AIRCRAFT_FUEL_ADDITIVE = "AIRCRAFT_FUEL_ADDITIVE",
  /** Aircraft Ground Handling */
  AIRCRAFT_GROUND_HANDLING = "AIRCRAFT_GROUND_HANDLING",
  /** Aircraft Ground Power Unit */
  AIRCRAFT_GROUND_POWER_UNIT = "AIRCRAFT_GROUND_POWER_UNIT",
  /** Aircraft Labor */
  AIRCRAFT_LABOR = "AIRCRAFT_LABOR",
  /** Aircraft Maintenance */
  AIRCRAFT_MAINTENANCE = "AIRCRAFT_MAINTENANCE",
  /** Aircraft Parking Fees */
  AIRCRAFT_PARKING_FEES = "AIRCRAFT_PARKING_FEES",
  /** Aircraft Rental */
  AIRCRAFT_RENTAL = "AIRCRAFT_RENTAL",
  /** Aircraft Sanitation Fees */
  AIRCRAFT_SANITATION_FEES = "AIRCRAFT_SANITATION_FEES",
  /** Aircraft Service */
  AIRCRAFT_SERVICE = "AIRCRAFT_SERVICE",
  /** Aircraft Tie Down Fees */
  AIRCRAFT_TIE_DOWN_FEES = "AIRCRAFT_TIE_DOWN_FEES",
  /** Aircraft Work Order */
  AIRCRAFT_WORK_ORDER = "AIRCRAFT_WORK_ORDER",
  /** Airport Fees */
  AIRPORT_FEES = "AIRPORT_FEES",
  /** Air Conditioning Service */
  AIR_CONDITIONING_SERVICE = "AIR_CONDITIONING_SERVICE",
  /** Air Filter */
  AIR_FILTER = "AIR_FILTER",
  /** Alternative Snacks */
  ALTERNATIVE_SNACKS = "ALTERNATIVE_SNACKS",
  /** Anti-Freeze */
  ANTI_FREEZE = "ANTI_FREEZE",
  /** AvGas Federal Excise Tax */
  AVGAS_FEDERAL_EXCISE_TAX = "AVGAS_FEDERAL_EXCISE_TAX",
  /** Batteries */
  BATTERIES = "BATTERIES",
  /** Beer - Alcoholic */
  BEER_ALCOHOLIC = "BEER_ALCOHOLIC",
  /** Beer - Non-Alcoholic */
  BEER_NON_ALCOHOLIC = "BEER_NON_ALCOHOLIC",
  /** Body Work */
  BODY_WORK = "BODY_WORK",
  /** Brake Fluid */
  BRAKE_FLUID = "BRAKE_FLUID",
  /** Brake Service */
  BRAKE_SERVICE = "BRAKE_SERVICE",
  /** Bread - Packaged */
  BREAD_PACKAGED = "BREAD_PACKAGED",
  /** Call Out Fee */
  CALL_OUT_FEE = "CALL_OUT_FEE",
  /** Cannabidiol (CBD) */
  CANNABIDIOL = "CANNABIDIOL",
  /** Cargo Handling */
  CARGO_HANDLING = "CARGO_HANDLING",
  /** Car Wash */
  CAR_WASH = "CAR_WASH",
  /** Cash Back */
  CASH_BACK = "CASH_BACK",
  /** Cash Back Fee */
  CASH_BACK_FEE = "CASH_BACK_FEE",
  /** Catering */
  CATERING = "CATERING",
  /** Charity */
  CHARITY = "CHARITY",
  /** Charter Fee */
  CHARTER_FEE = "CHARTER_FEE",
  /** Cigarettes */
  CIGARETTES = "CIGARETTES",
  /** Cold Dispensed Beverages */
  COLD_DISPENSED_BEVERAGES = "COLD_DISPENSED_BEVERAGES",
  /** Communication Fee */
  COMMUNICATION_FEE = "COMMUNICATION_FEE",
  /** Corrosion Inhibitor */
  CORROSION_INHIBITOR = "CORROSION_INHIBITOR",
  /** Coupon 1 */
  COUPON_1 = "COUPON_1",
  /** Coupon 2 */
  COUPON_2 = "COUPON_2",
  /** Coupon 3 */
  COUPON_3 = "COUPON_3",
  /** Coupon 4 */
  COUPON_4 = "COUPON_4",
  /** Coupon 5 */
  COUPON_5 = "COUPON_5",
  /** Deli Items */
  DELI_ITEMS = "DELI_ITEMS",
  /** De-fuel */
  DE_FUEL = "DE_FUEL",
  /** De-icing */
  DE_ICING = "DE_ICING",
  /** Disable Device/Handset Lock */
  DISABLE_DEVICE_HANDSET_LOCK = "DISABLE_DEVICE_HANDSET_LOCK",
  /** Discount 1 */
  DISCOUNT_1 = "DISCOUNT_1",
  /** Discount 2 */
  DISCOUNT_2 = "DISCOUNT_2",
  /** Discount 3 */
  DISCOUNT_3 = "DISCOUNT_3",
  /** Discount 4 */
  DISCOUNT_4 = "DISCOUNT_4",
  /** Discount 5 */
  DISCOUNT_5 = "DISCOUNT_5",
  /** Enable Device/Handset Unlock */
  ENABLE_DEVICE_HANDSET_UNLOCK = "ENABLE_DEVICE_HANDSET_UNLOCK",
  /** Engine Service */
  ENGINE_SERVICE = "ENGINE_SERVICE",
  /** EV Battery Exchanges */
  EV_BATTERY_EXCHANGES = "EV_BATTERY_EXCHANGES",
  /** EV Charging Fee */
  EV_CHARGING_FEE = "EV_CHARGING_FEE",
  /** Exhaust Service */
  EXHAUST_SERVICE = "EXHAUST_SERVICE",
  /** Federal Excise Tax (Tires) */
  FEDERAL_EXCISE_TAX_TIRES = "FEDERAL_EXCISE_TAX_TIRES",
  /** Fee 1 */
  FEE_1 = "FEE_1",
  /** Fee 2 */
  FEE_2 = "FEE_2",
  /** Fee 3 */
  FEE_3 = "FEE_3",
  /** Fee 4 */
  FEE_4 = "FEE_4",
  /** Fee 5 */
  FEE_5 = "FEE_5",
  /** Financial Prepaid Card Activate */
  FINANCIAL_PREPAID_CARD_ACTIVATE = "FINANCIAL_PREPAID_CARD_ACTIVATE",
  /** Financial Prepaid Card Reload */
  FINANCIAL_PREPAID_CARD_RELOAD = "FINANCIAL_PREPAID_CARD_RELOAD",
  /** Flight Plans / Weather Brief */
  FLIGHT_PLANS_WEATHER_BRIEF = "FLIGHT_PLANS_WEATHER_BRIEF",
  /** Flow Fee */
  FLOW_FEE = "FLOW_FEE",
  /** Fluid Milk Products */
  FLUID_MILK_PRODUCTS = "FLUID_MILK_PRODUCTS",
  /** Frozen Dispensed Beverages */
  FROZEN_DISPENSED_BEVERAGES = "FROZEN_DISPENSED_BEVERAGES",
  /** Frozen Foods */
  FROZEN_FOODS = "FROZEN_FOODS",
  /** Fuel System */
  FUEL_SYSTEM = "FUEL_SYSTEM",
  /** General Alcohol */
  GENERAL_ALCOHOL = "GENERAL_ALCOHOL",
  /** General Automotive Merchandise */
  GENERAL_AUTOMOTIVE_MERCHANDISE = "GENERAL_AUTOMOTIVE_MERCHANDISE",
  /** General Candy */
  GENERAL_CANDY = "GENERAL_CANDY",
  /** General Dairy */
  GENERAL_DAIRY = "GENERAL_DAIRY",
  /** General Deli */
  GENERAL_DELI = "GENERAL_DELI",
  /** General Dispensed Beverage */
  GENERAL_DISPENSED_BEVERAGE = "GENERAL_DISPENSED_BEVERAGE",
  /** General Food service */
  GENERAL_FOOD_SERVICE = "GENERAL_FOOD_SERVICE",
  /** General Grocery */
  GENERAL_GROCERY = "GENERAL_GROCERY",
  /** General Health & Beauty Care */
  GENERAL_HEALTH_BEAUTY_CARE = "GENERAL_HEALTH_BEAUTY_CARE",
  /** General Ice */
  GENERAL_ICE = "GENERAL_ICE",
  /** General Lottery */
  GENERAL_LOTTERY = "GENERAL_LOTTERY",
  /** General Merchandise */
  GENERAL_MERCHANDISE = "GENERAL_MERCHANDISE",
  /** General Money Order */
  GENERAL_MONEY_ORDER = "GENERAL_MONEY_ORDER",
  /** General Packaged Beverage */
  GENERAL_PACKAGED_BEVERAGE = "GENERAL_PACKAGED_BEVERAGE",
  /** General Publications */
  GENERAL_PUBLICATIONS = "GENERAL_PUBLICATIONS",
  /** General Purpose Activate */
  GENERAL_PURPOSE_ACTIVATE = "GENERAL_PURPOSE_ACTIVATE",
  /** General Purpose Reload */
  GENERAL_PURPOSE_RELOAD = "GENERAL_PURPOSE_RELOAD",
  /** General Snacks */
  GENERAL_SNACKS = "GENERAL_SNACKS",
  /** General Store Service */
  GENERAL_STORE_SERVICE = "GENERAL_STORE_SERVICE",
  /** General Tobacco */
  GENERAL_TOBACCO = "GENERAL_TOBACCO",
  /** Gratuity */
  GRATUITY = "GRATUITY",
  /** Groceries - Edible */
  GROCERIES_EDIBLE = "GROCERIES_EDIBLE",
  /** Groceries - Non-Edible */
  GROCERIES_NON_EDIBLE = "GROCERIES_NON_EDIBLE",
  /** Groceries - Perishable */
  GROCERIES_PERISHABLE = "GROCERIES_PERISHABLE",
  /** Ground Equipment Service Fees */
  GROUND_EQUIPMENT_SERVICE_FEES = "GROUND_EQUIPMENT_SERVICE_FEES",
  /** GST/HST (Canadian)/VAT 1 */
  GST_HST_CANADIAN_VAT_1 = "GST_HST_CANADIAN_VAT_1",
  /** Hangar Fee */
  HANGAR_FEE = "HANGAR_FEE",
  /** Home Delivery */
  HOME_DELIVERY = "HOME_DELIVERY",
  /** Hoses */
  HOSES = "HOSES",
  /** Hot Dispensed Beverages */
  HOT_DISPENSED_BEVERAGES = "HOT_DISPENSED_BEVERAGES",
  /** Inspection */
  INSPECTION = "INSPECTION",
  /** Instruction Fee */
  INSTRUCTION_FEE = "INSTRUCTION_FEE",
  /** IT/Bladder */
  IT_BLADDER = "IT_BLADDER",
  /** Jet Federal Excise Tax */
  JET_FEDERAL_EXCISE_TAX = "JET_FEDERAL_EXCISE_TAX",
  /** Labor */
  LABOR = "LABOR",
  /** Lamps */
  LAMPS = "LAMPS",
  /** Landing Fee */
  LANDING_FEE = "LANDING_FEE",
  /** Launch Fee */
  LAUNCH_FEE = "LAUNCH_FEE",
  /** Liquor */
  LIQUOR = "LIQUOR",
  /** Local Discount 1 */
  LOCAL_DISCOUNT_1 = "LOCAL_DISCOUNT_1",
  /** Local Discount 2 */
  LOCAL_DISCOUNT_2 = "LOCAL_DISCOUNT_2",
  /** Local Discount 3 */
  LOCAL_DISCOUNT_3 = "LOCAL_DISCOUNT_3",
  /** Local Discount 4 */
  LOCAL_DISCOUNT_4 = "LOCAL_DISCOUNT_4",
  /** Local Discount 5 */
  LOCAL_DISCOUNT_5 = "LOCAL_DISCOUNT_5",
  /** Lodging */
  LODGING = "LODGING",
  /** Lottery - Instant */
  LOTTERY_INSTANT = "LOTTERY_INSTANT",
  /** Lottery - Online */
  LOTTERY_ONLINE = "LOTTERY_ONLINE",
  /** Lottery - Other */
  LOTTERY_OTHER = "LOTTERY_OTHER",
  /** Lottery Pay Out - Instant */
  LOTTERY_PAY_OUT_INSTANT = "LOTTERY_PAY_OUT_INSTANT",
  /** Lottery Pay Out - Online */
  LOTTERY_PAY_OUT_ONLINE = "LOTTERY_PAY_OUT_ONLINE",
  /** Lottery Pay Out - Other */
  LOTTERY_PAY_OUT_OTHER = "LOTTERY_PAY_OUT_OTHER",
  /** Lube */
  LUBE = "LUBE",
  /** Marine Labor */
  MARINE_LABOR = "MARINE_LABOR",
  /** Marine Service */
  MARINE_SERVICE = "MARINE_SERVICE",
  /** Marine Work Order */
  MARINE_WORK_ORDER = "MARINE_WORK_ORDER",
  /** Membership/Loyalty */
  MEMBERSHIP_LOYALTY = "MEMBERSHIP_LOYALTY",
  /** Miscellaneous Administrative */
  MISCELLANEOUS_ADMINISTRATIVE = "MISCELLANEOUS_ADMINISTRATIVE",
  /** Miscellaneous Aviation Products/Services */
  MISCELLANEOUS_AVIATION_PRODUCTS_SERVICES = "MISCELLANEOUS_AVIATION_PRODUCTS_SERVICES",
  /** Miscellaneous Aviation Tax */
  MISCELLANEOUS_AVIATION_TAX = "MISCELLANEOUS_AVIATION_TAX",
  /** Miscellaneous Marine Products/Services */
  MISCELLANEOUS_MARINE_PRODUCTS_SERVICES = "MISCELLANEOUS_MARINE_PRODUCTS_SERVICES",
  /** Miscellaneous Negative Administrative */
  MISCELLANEOUS_NEGATIVE_ADMINISTRATIVE = "MISCELLANEOUS_NEGATIVE_ADMINISTRATIVE",
  /** Miscellaneous Packaged Fuels */
  MISCELLANEOUS_PACKAGED_FUELS = "MISCELLANEOUS_PACKAGED_FUELS",
  /** Miscellaneous Vehicle Products / Services */
  MISCELLANEOUS_VEHICLE_PRODUCTS_SERVICES = "MISCELLANEOUS_VEHICLE_PRODUCTS_SERVICES",
  /** Money Order - Dividend Check */
  MONEY_ORDER_DIVIDEND_CHECK = "MONEY_ORDER_DIVIDEND_CHECK",
  /** Money Order - Gift Certificate */
  MONEY_ORDER_GIFT_CERTIFICATE = "MONEY_ORDER_GIFT_CERTIFICATE",
  /** Money Order - Official Check */
  MONEY_ORDER_OFFICIAL_CHECK = "MONEY_ORDER_OFFICIAL_CHECK",
  /** Money Order - Payroll Check */
  MONEY_ORDER_PAYROLL_CHECK = "MONEY_ORDER_PAYROLL_CHECK",
  /** Money Order - Rebate Check */
  MONEY_ORDER_REBATE_CHECK = "MONEY_ORDER_REBATE_CHECK",
  /** Money Order - Refund Check */
  MONEY_ORDER_REFUND_CHECK = "MONEY_ORDER_REFUND_CHECK",
  /** Money Order - Utility Check */
  MONEY_ORDER_UTILITY_CHECK = "MONEY_ORDER_UTILITY_CHECK",
  /** Money Order - Vendor Payment */
  MONEY_ORDER_VENDOR_PAYMENT = "MONEY_ORDER_VENDOR_PAYMENT",
  /** Motor Oil */
  MOTOR_OIL = "MOTOR_OIL",
  /** Multiple Payee Bill Pay */
  MULTIPLE_PAYEE_BILL_PAY = "MULTIPLE_PAYEE_BILL_PAY",
  /** Oil Change */
  OIL_CHANGE = "OIL_CHANGE",
  /** Oil Filter */
  OIL_FILTER = "OIL_FILTER",
  /** Other Dairy */
  OTHER_DAIRY = "OTHER_DAIRY",
  /** Other Dispensed Beverages */
  OTHER_DISPENSED_BEVERAGES = "OTHER_DISPENSED_BEVERAGES",
  /** Other Lubricants */
  OTHER_LUBRICANTS = "OTHER_LUBRICANTS",
  /** Other Packaged Beverages */
  OTHER_PACKAGED_BEVERAGES = "OTHER_PACKAGED_BEVERAGES",
  /** Overtime Fees */
  OVERTIME_FEES = "OVERTIME_FEES",
  /** Oxygen */
  OXYGEN = "OXYGEN",
  /** Packaged Additive */
  PACKAGED_ADDITIVE = "PACKAGED_ADDITIVE",
  /** Packaged B99 */
  PACKAGED_B99 = "PACKAGED_B99",
  /** Packaged B100 */
  PACKAGED_B100 = "PACKAGED_B100",
  /** Packaged Beverages (non-alcoholic) */
  PACKAGED_BEVERAGES_NON_ALCOHOLIC = "PACKAGED_BEVERAGES_NON_ALCOHOLIC",
  /** Packaged DEF (Diesel Exhaust Fluid) */
  PACKAGED_DEF = "PACKAGED_DEF",
  /** Packaged Ice Cream/Novelties */
  PACKAGED_ICE_CREAM_NOVELTIES = "PACKAGED_ICE_CREAM_NOVELTIES",
  /** Packaged Juice */
  PACKAGED_JUICE = "PACKAGED_JUICE",
  /** Packaged Kerosene */
  PACKAGED_KEROSENE = "PACKAGED_KEROSENE",
  /** Packaged Propane */
  PACKAGED_PROPANE = "PACKAGED_PROPANE",
  /** Packaged Sandwiches/Deli Products */
  PACKAGED_SANDWICHES_DELI_PRODUCTS = "PACKAGED_SANDWICHES_DELI_PRODUCTS",
  /** Pilot Supplies */
  PILOT_SUPPLIES = "PILOT_SUPPLIES",
  /** PIN Activate Prepaid Card */
  PIN_ACTIVATE_PREPAID_CARD = "PIN_ACTIVATE_PREPAID_CARD",
  /** PIN Return Prepaid Card */
  PIN_RETURN_PREPAID_CARD = "PIN_RETURN_PREPAID_CARD",
  /** POS/Loyalty Reserved Discount 1 */
  POS_LOYALTY_RESERVED_DISCOUNT_1 = "POS_LOYALTY_RESERVED_DISCOUNT_1",
  /** POS/Loyalty Reserved Discount 2 */
  POS_LOYALTY_RESERVED_DISCOUNT_2 = "POS_LOYALTY_RESERVED_DISCOUNT_2",
  /** POS/Loyalty Reserved Discount 3 */
  POS_LOYALTY_RESERVED_DISCOUNT_3 = "POS_LOYALTY_RESERVED_DISCOUNT_3",
  /** POS/Loyalty Reserved Discount 4 */
  POS_LOYALTY_RESERVED_DISCOUNT_4 = "POS_LOYALTY_RESERVED_DISCOUNT_4",
  /** POS/Loyalty Reserved Discount 5 */
  POS_LOYALTY_RESERVED_DISCOUNT_5 = "POS_LOYALTY_RESERVED_DISCOUNT_5",
  /** Prepaid Cards - Activation/Recharge */
  PREPAID_CARDS_ACTIVATION_RECHARGE = "PREPAID_CARDS_ACTIVATION_RECHARGE",
  /** Prepaid Cards - Purchase */
  PREPAID_CARDS_PURCHASE = "PREPAID_CARDS_PURCHASE",
  /** Prepared Foods */
  PREPARED_FOODS = "PREPARED_FOODS",
  /** Preventative Maintenance */
  PREVENTATIVE_MAINTENANCE = "PREVENTATIVE_MAINTENANCE",
  /** Proprietary Prepaid Card Activate */
  PROPRIETARY_PREPAID_CARD_ACTIVATE = "PROPRIETARY_PREPAID_CARD_ACTIVATE",
  /** Proprietary Prepaid Card Reload */
  PROPRIETARY_PREPAID_CARD_RELOAD = "PROPRIETARY_PREPAID_CARD_RELOAD",
  /** PST/QST (Canadian) VAT 2 */
  PST_QST_CANADIAN_VAT_2 = "PST_QST_CANADIAN_VAT_2",
  /** Ramp Fees */
  RAMP_FEES = "RAMP_FEES",
  /** Real Time Recharge */
  REAL_TIME_RECHARGE = "REAL_TIME_RECHARGE",
  /** Repairs */
  REPAIRS = "REPAIRS",
  /** Re-service */
  RE_SERVICE = "RE_SERVICE",
  /** Road Service */
  ROAD_SERVICE = "ROAD_SERVICE",
  /** RV Dump Fee */
  RV_DUMP_FEE = "RV_DUMP_FEE",
  /** Salty Snacks */
  SALTY_SNACKS = "SALTY_SNACKS",
  /** Scales */
  SCALES = "SCALES",
  /** Secure Fees */
  SECURE_FEES = "SECURE_FEES",
  /** Service Package */
  SERVICE_PACKAGE = "SERVICE_PACKAGE",
  /** Shower */
  SHOWER = "SHOWER",
  /** Single Payee Bill Pay */
  SINGLE_PAYEE_BILL_PAY = "SINGLE_PAYEE_BILL_PAY",
  /** Slip Rental */
  SLIP_RENTAL = "SLIP_RENTAL",
  /** Split Tender */
  SPLIT_TENDER = "SPLIT_TENDER",
  /** Static Dissipater Additive */
  STATIC_DISSIPATER_ADDITIVE = "STATIC_DISSIPATER_ADDITIVE",
  /** Storage */
  STORAGE = "STORAGE",
  /** Sweet Snacks - Packaged */
  SWEET_SNACKS_PACKAGED = "SWEET_SNACKS_PACKAGED",
  /** SWT Rate (Canadian) */
  SWT_RATE_CANADIAN = "SWT_RATE_CANADIAN",
  /** Synthetic Oil */
  SYNTHETIC_OIL = "SYNTHETIC_OIL",
  /** Tax 1 */
  TAX_1 = "TAX_1",
  /** Tax 2 */
  TAX_2 = "TAX_2",
  /** Tax 3 */
  TAX_3 = "TAX_3",
  /** Tax 4 */
  TAX_4 = "TAX_4",
  /** Tax 5 */
  TAX_5 = "TAX_5",
  /** Tax 6 */
  TAX_6 = "TAX_6",
  /** Tax 7 */
  TAX_7 = "TAX_7",
  /** Tax 8 */
  TAX_8 = "TAX_8",
  /** Tax Discount/Forgiven */
  TAX_DISCOUNT_FORGIVEN = "TAX_DISCOUNT_FORGIVEN",
  /** 3rd Party Prepaid Card Activate */
  THIRD_PARTY_PREPAID_CARD_ACTIVATE = "THIRD_PARTY_PREPAID_CARD_ACTIVATE",
  /** 3rd Party Prepaid Card Reload */
  THIRD_PARTY_PREPAID_CARD_RELOAD = "THIRD_PARTY_PREPAID_CARD_RELOAD",
  /** Tires */
  TIRES = "TIRES",
  /** Tire-related (Wheel Balance, Valve Stem) */
  TIRE_RELATED = "TIRE_RELATED",
  /** Tire Repair */
  TIRE_REPAIR = "TIRE_REPAIR",
  /** Tire Rotation */
  TIRE_ROTATION = "TIRE_ROTATION",
  /** Tobacco - Other */
  TOBACCO_OTHER = "TOBACCO_OTHER",
  /** Toll Payments */
  TOLL_PAYMENTS = "TOLL_PAYMENTS",
  /** Towing */
  TOWING = "TOWING",
  /** Trailer Wash */
  TRAILER_WASH = "TRAILER_WASH",
  /** Transmission Service */
  TRANSMISSION_SERVICE = "TRANSMISSION_SERVICE",
  /** Transportation */
  TRANSPORTATION = "TRANSPORTATION",
  /** Truck Tank Cleaning */
  TRUCK_TANK_CLEANING = "TRUCK_TANK_CLEANING",
  /** Vehicle Accessories */
  VEHICLE_ACCESSORIES = "VEHICLE_ACCESSORIES",
  /** Vehicle Fuel Additives/Treatment (Injected) */
  VEHICLE_FUEL_ADDITIVES_TREATMENT = "VEHICLE_FUEL_ADDITIVES_TREATMENT",
  /** Vehicle Glass */
  VEHICLE_GLASS = "VEHICLE_GLASS",
  /** Vehicle Parking */
  VEHICLE_PARKING = "VEHICLE_PARKING",
  /** Vehicle Parts */
  VEHICLE_PARTS = "VEHICLE_PARTS",
  /** Vehicle Prep */
  VEHICLE_PREP = "VEHICLE_PREP",
  /** Vehicle Rental */
  VEHICLE_RENTAL = "VEHICLE_RENTAL",
  /** Washer Fluid */
  WASHER_FLUID = "WASHER_FLUID",
  /** Wash Out */
  WASH_OUT = "WASH_OUT",
  /** Wine */
  WINE = "WINE",
  /** Wipers */
  WIPERS = "WIPERS",
  /** Wireless Real Time Recharge */
  WIRELESS_REAL_TIME_RECHARGE = "WIRELESS_REAL_TIME_RECHARGE",
  /** Work Order */
  WORK_ORDER = "WORK_ORDER",
}

/** Mastercard Fleet product codes */
export enum MastercardFleetProductCode {
  /** Aviation Accessories */
  AC_ACC = "AC_ACC",
  /** Aircraft Cleaning */
  AIRCRAFT_CLEANING = "AIRCRAFT_CLEANING",
  /** APU or Aircraft Jump Start */
  APU = "APU",
  /** Automotive Accessories */
  AUTO_ACC = "AUTO_ACC",
  /** Automotive Glass */
  AUTO_GLASS = "AUTO_GLASS",
  /** Aviation CAtering */
  AV_CATERING = "AV_CATERING",
  /** Aviation Fuel */
  AV_FUEL = "AV_FUEL",
  /** Aviation 100 Octane */
  AV_FUEL_100 = "AV_FUEL_100",
  /** Aviation Maintenance */
  AV_MAINTENANCE = "AV_MAINTENANCE",
  /** Batteries */
  BATTERIES = "BATTERIES",
  /** Beer/Wine */
  BEER_WINE = "BEER_WINE",
  /** Biodiesel */
  BIODIESEL = "BIODIESEL",
  /** Biodiesel (Non-Taxable) */
  BIODIESEL_NON_TAXABLE = "BIODIESEL_NON_TAXABLE",
  /** Boat Service */
  BOAT_SERVICE = "BOAT_SERVICE",
  /** Brake Fluid */
  BRAKE_FLUID = "BRAKE_FLUID",
  /** Brake Service */
  BRAKE_SERVICE = "BRAKE_SERVICE",
  /** Call Out Fee */
  CALL_OUT_FEE = "CALL_OUT_FEE",
  /** Cargo Handling */
  CARGO_HANDLING = "CARGO_HANDLING",
  /** Car Wash */
  CAR_WASH = "CAR_WASH",
  /** Charter Fees */
  CHARTER_FEE = "CHARTER_FEE",
  /** Cigarettes/Tobacco */
  CIGARETTES = "CIGARETTES",
  /** Compressed Natural Gas */
  CNG = "CNG",
  /** Communication Fees */
  COMM_FEE = "COMM_FEE",
  /** Diesel Exhaust Fluid (DEF) */
  DEF = "DEF",
  /** De-icing */
  DE_ICING = "DE_ICING",
  /** Diesel */
  DIESEL = "DIESEL",
  /** Diesel Exhaust Fluid: Dispensed */
  DIESEL_EXHAUST_FLUID_DISPENSED = "DIESEL_EXHAUST_FLUID_DISPENSED",
  /** Diesel (Non-Taxable) */
  DIESEL_NON_TAXABLE = "DIESEL_NON_TAXABLE",
  /** Diesel Premium */
  DIESEL_PREMIUM = "DIESEL_PREMIUM",
  /** Dyed Diesel */
  DYED_DIESEL = "DYED_DIESEL",
  /** E85 (Ethanol 85%) */
  E85 = "E85",
  /** Engine Service */
  ENGINE_SERVICE = "ENGINE_SERVICE",
  /** Electric Vehicle Charge Level 1: 110v */
  EV_LEVEL_1_CHARGE = "EV_LEVEL_1_CHARGE",
  /** Electric Vehicle Charge Level 2: 240v */
  EV_LEVEL_2_CHARGE = "EV_LEVEL_2_CHARGE",
  /** Electric Vehicle Charge Level 3: 480v */
  EV_LEVEL_3_CHARGE = "EV_LEVEL_3_CHARGE",
  /** Flight Planning/Weather Fees */
  FLIGHT_PLAN_FEE = "FLIGHT_PLAN_FEE",
  /** Gasohol */
  GASOHOL = "GASOHOL",
  /** Ground Handling */
  GROUND_HANDLING = "GROUND_HANDLING",
  /** Health/Beauty Aid */
  HEALTH_BEAUTY = "HEALTH_BEAUTY",
  /** Instruction Fee */
  INSTRUCTION_FEE = "INSTRUCTION_FEE",
  /** Jet Fuel */
  JET_FUEL = "JET_FUEL",
  /** Kerosene */
  KEROSENE = "KEROSENE",
  /** Landing Fee */
  LANDING_FEE = "LANDING_FEE",
  /** Ethanol Regular Leaded */
  LEADED_ETHANOL = "LEADED_ETHANOL",
  /** Methanol Regular Leaded */
  LEADED_METHANOL = "LEADED_METHANOL",
  /** Liquid Natural Gas */
  LNG = "LNG",
  /** Liquid Propane gas (LPG) */
  LPG = "LPG",
  /** M85 (Methanol 85%) */
  M85 = "M85",
  /** Marine Fuel */
  MARINE_FUEL = "MARINE_FUEL",
  /** Unleaded Mid Grade (88 or 89 octane) */
  MID = "MID",
  /** Ethanol Unleaded Mid Grade (88 or 89 octane) */
  MID_ETHANOL = "MID_ETHANOL",
  /** Methanol Unleaded Mid Grade (88 or 89 octane) */
  MID_METHANOL = "MID_METHANOL",
  /** Milk/Juice */
  MILK_JUICE = "MILK_JUICE",
  /** Miscellaneous Aviation */
  MISC_AV = "MISC_AV",
  /** Miscellaneous Beverage */
  MISC_BEV = "MISC_BEV",
  /** Miscellaneous Food/Grocery */
  MISC_FOOD = "MISC_FOOD",
  /** Miscellaneous Fuel */
  MISC_FUEL = "MISC_FUEL",
  /** Miscellaneous Labor */
  MISC_LABOR = "MISC_LABOR",
  /** Miscellaneous Other */
  MISC_OTHER_FUEL = "MISC_OTHER_FUEL",
  /** Miscellaneous Parts */
  MISC_PARTS = "MISC_PARTS",
  /** Miscellaneous Repairs */
  MISC_REPAIRS = "MISC_REPAIRS",
  /** Motor Oil */
  MOTOR_OIL = "MOTOR_OIL",
  /** Oil Change */
  OIL_CHANGE = "OIL_CHANGE",
  /** Plane Rental */
  PLANE_RENTAL = "PLANE_RENTAL",
  /** Unleaded Premium (90 or 91 octane) */
  PREMIUM = "PREMIUM",
  /** Ethanol Unleaded Premium (90 or 91 octane) */
  PREMIUM_ETHANOL = "PREMIUM_ETHANOL",
  /** Methanol Unleaded Premium (90 or 91 octane) */
  PREMIUM_METHANOL = "PREMIUM_METHANOL",
  /** Racing Fuel */
  RACING_FUEL = "RACING_FUEL",
  /** Ramp Fee */
  RAMP_FEE = "RAMP_FEE",
  /** Unleaded Regular (85 to 87 octane) */
  REGULAR = "REGULAR",
  /** Ethanol Unleaded Regular (86 or 87 octane) */
  REGULAR_ETHANOL = "REGULAR_ETHANOL",
  /** Regular Leaded Gasoline */
  REGULAR_LEADED = "REGULAR_LEADED",
  /** Methanol Unleaded Regular (86 or 87 octane) */
  REGULAR_METHANOL = "REGULAR_METHANOL",
  /** Restaurant */
  RESTAURANT = "RESTAURANT",
  /** Soda */
  SODA = "SODA",
  /** Solvent */
  SOLVENT = "SOLVENT",
  /** Unleaded Super (92 to 94 octane) */
  SUPER = "SUPER",
  /** Ethanol Unleaded Super (92 to 94 octane) */
  SUPER_ETHANOL = "SUPER_ETHANOL",
  /** Methanol Unleaded Super (92 to 94 octane) */
  SUPER_METHANOL = "SUPER_METHANOL",
  /** Tiedown or Hangar */
  TIEDOWN_HANGAR = "TIEDOWN_HANGAR",
  /** Tires */
  TIRES = "TIRES",
  /** TBA (tires, batteries, accessories) */
  TIRES_BATTERIES_ACCESSORIES = "TIRES_BATTERIES_ACCESSORIES",
  /** Towing */
  TOWING = "TOWING",
  /** Transmission Service */
  TRANSMISSION_SERVICE = "TRANSMISSION_SERVICE",
  /** Ultralow Sulfur Diesel (ULSD) */
  ULSD = "ULSD",
  /** Unleaded Mid Grade Reformulated (88 or 89 octane) */
  UNLEADED_MID_REFORMULATED = "UNLEADED_MID_REFORMULATED",
  /** Unleaded Reformulated (86 or 87 octane) */
  UNLEADED_REFORMULATED = "UNLEADED_REFORMULATED",
  /** White Gas */
  WHITE_GAS = "WHITE_GAS",
}

/** Mastercard Fleet product type code */
export enum MastercardFleetProductType {
  /** No prompts issued */
  NO_PROMPTS_ISSUED = "NO_PROMPTS_ISSUED",
  /** Prompts for driver number and odometer reading */
  PROMPT_FOR_DRIVER_NUMBER_AND_ODOMETER = "PROMPT_FOR_DRIVER_NUMBER_AND_ODOMETER",
  /** Prompts for ID number and odometer reading */
  PROMPT_FOR_ID_AND_ODOMETER = "PROMPT_FOR_ID_AND_ODOMETER",
  /** Prompts for odometer reading only */
  PROMPT_FOR_ODOMETER_ONLY = "PROMPT_FOR_ODOMETER_ONLY",
  /** Prompts for vehicle number and odometer reading */
  PROMPT_FOR_VEHICLE_NUMBER_AND_ODOMETER = "PROMPT_FOR_VEHICLE_NUMBER_AND_ODOMETER",
}

/** Details of a Mastercard Fleet Prompt. Contains a prompt code and cardholder-entered value */
export type MastercardFleetPrompt = {
  __typename?: "MastercardFleetPrompt";
  /** Indicates the type of prompted information */
  code?: Maybe<MastercardFleetPromptType>;
  /** An alphanumeric value indicating the value entered by the cardholder */
  value?: Maybe<Scalars["String"]>;
};

/** Mastercard Fleet prompt types */
export enum MastercardFleetPromptType {
  /** Additional Card Data */
  ADDITIONAL_CARD_DATA = "ADDITIONAL_CARD_DATA",
  /** Additional Vehicle Data */
  ADDITIONAL_VEHICLE_DATA = "ADDITIONAL_VEHICLE_DATA",
  /** Battery Voltage */
  BATTERY_VOLTAGE = "BATTERY_VOLTAGE",
  /** Billing ID */
  BILLING_ID = "BILLING_ID",
  /** Check Engine Status */
  CHECK_ENGINE_STATUS = "CHECK_ENGINE_STATUS",
  /** Control Number */
  CONTROL_NUMBER = "CONTROL_NUMBER",
  /** Coolant Temperature */
  COOLANT_TEMPERATURE = "COOLANT_TEMPERATURE",
  /** Customer Number */
  CUSTOMER_NUMBER = "CUSTOMER_NUMBER",
  /** Delivery Ticket Number */
  DELIVERY_TICKET_NUMBER = "DELIVERY_TICKET_NUMBER",
  /** Department Number */
  DEPARTMENT_NUMBER = "DEPARTMENT_NUMBER",
  /** Driver ID */
  DRIVER_ID = "DRIVER_ID",
  /** Driver or Vehicle Card */
  DRIVER_OR_VEHICLE_CARD = "DRIVER_OR_VEHICLE_CARD",
  /** Engine Hours */
  ENGINE_HOURS = "ENGINE_HOURS",
  /** Engine Load */
  ENGINE_LOAD = "ENGINE_LOAD",
  /** Engine Oil Life */
  ENGINE_OIL_LIFE = "ENGINE_OIL_LIFE",
  /** Engine Oil Pressure */
  ENGINE_OIL_PRESSURE = "ENGINE_OIL_PRESSURE",
  /** Engine Oil Temperature */
  ENGINE_OIL_TEMPERATURE = "ENGINE_OIL_TEMPERATURE",
  /** Engine RPM */
  ENGINE_RPM = "ENGINE_RPM",
  /** Engine Time Total */
  ENGINE_TIME_TOTAL = "ENGINE_TIME_TOTAL",
  /** Entered Data Alpha */
  ENTERED_DATA_ALPHA = "ENTERED_DATA_ALPHA",
  /** Entered Data Num */
  ENTERED_DATA_NUM = "ENTERED_DATA_NUM",
  /** Fuel Economy */
  FUEL_ECONOMY = "FUEL_ECONOMY",
  /** Fuel Gauge Level */
  FUEL_GAUGE_LEVEL = "FUEL_GAUGE_LEVEL",
  /** Hard Acceleration */
  HARD_ACCELERATION = "HARD_ACCELERATION",
  /** Hard Breaking */
  HARD_BREAKING = "HARD_BREAKING",
  /** Hubometer */
  HUBOMETER = "HUBOMETER",
  /** Idle Time */
  IDLE_TIME = "IDLE_TIME",
  /** Invoice Number */
  INVOICE_NUMBER = "INVOICE_NUMBER",
  /** Job Number */
  JOB_NUMBER = "JOB_NUMBER",
  /** Maintenance ID */
  MAINTENANCE_ID = "MAINTENANCE_ID",
  /** Odometer */
  ODOMETER = "ODOMETER",
  /** Reefer Hours */
  REEFER_HOURS = "REEFER_HOURS",
  /** Reefer Temperature */
  REEFER_TEMPERATURE = "REEFER_TEMPERATURE",
  /** Replacement Car */
  REPLACEMENT_CAR = "REPLACEMENT_CAR",
  /** Sub Fleet Number */
  SUB_FLEET_NUMBER = "SUB_FLEET_NUMBER",
  /** Tank Level Start */
  TANK_LEVEL_START = "TANK_LEVEL_START",
  /** Total Idle Time */
  TOTAL_IDLE_TIME = "TOTAL_IDLE_TIME",
  /** Trailer Number */
  TRAILER_NUMBER = "TRAILER_NUMBER",
  /** Transaction Number */
  TRANSACTION_NUMBER = "TRANSACTION_NUMBER",
  /** Trip Number */
  TRIP_NUMBER = "TRIP_NUMBER",
  /** Unit Number */
  UNIT_NUMBER = "UNIT_NUMBER",
  /** User ID */
  USER_ID = "USER_ID",
  /** Vehicle Number */
  VEHICLE_NUMBER = "VEHICLE_NUMBER",
  /** Vehicle Tag */
  VEHICLE_TAG = "VEHICLE_TAG",
  /** Web Portal Data */
  WEB_PORTAL_DATA = "WEB_PORTAL_DATA",
  /** Work Order / P.O. Number */
  WORK_ORDER_OR_PO_NUMBER = "WORK_ORDER_OR_PO_NUMBER",
  /** ZIP Code / Postal Code */
  ZIP_OR_POSTAL_CODE = "ZIP_OR_POSTAL_CODE",
}

/** Mastercard Fleet fuel unit of measure */
export enum MastercardFleetUnitOfMeasure {
  /** Gallons */
  GALLONS = "GALLONS",
  /** Hours */
  HOURS = "HOURS",
  /** Imperial Gallons */
  IMPERIAL_GALLONS = "IMPERIAL_GALLONS",
  /** Kilograms */
  KILOS = "KILOS",
  /** Kilowatt Hours */
  KILOWATT_HOURS = "KILOWATT_HOURS",
  /** Liters */
  LITERS = "LITERS",
  /** Minutes */
  MINUTES = "MINUTES",
  /** Not Applicable */
  NOT_APPLICABLE = "NOT_APPLICABLE",
  /** Pounds */
  POUNDS = "POUNDS",
}

/** A Spend Control rule that blocks transactions if the Mastercard Fraud Score is above a configured threshold. */
export type MastercardFraudScoreSpendRule = Node &
  SpendRule & {
    __typename?: "MastercardFraudScoreSpendRule";
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the `MastercardFraudScoreSpendRule` in operations. */
    id: Scalars["ID"];
    /** The maximum Mastercard Fraud Score allowed for a transaction before transaction is declined. */
    maximumMastercardFraudScore?: Maybe<Scalars["UnsignedInt"]>;
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/** A Spend Control rule that blocks transactions if the Mastercard Fraud Score is above a configured threshold. */
export type MastercardFraudScoreSpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The result of applying a `MastercardFraudScoreSpendRule` to an event. */
export type MastercardFraudScoreSpendRuleResult = SpendRuleResult & {
  __typename?: "MastercardFraudScoreSpendRuleResult";
  /** The attached level. */
  attachedLevel?: Maybe<AttachedLevel>;
  /** The Mastercard Fraud Score for this transaction. */
  mastercardFraudScore?: Maybe<Scalars["UnsignedInt"]>;
  /** A message describing the result. */
  message?: Maybe<Scalars["String"]>;
  /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
  recommendation?: Maybe<SpendRuleRecommendation>;
  /** The spend rule attached at the time of the event. */
  spendRule?: Maybe<MastercardFraudScoreSpendRule>;
};

/** Mastercard-specific installment payment data. */
export type MastercardInstallmentData = {
  __typename?: "MastercardInstallmentData";
  /** Indicates whether this is a single authorization with multiple captures. */
  singleAuthorizationMultipleCaptures?: Maybe<Scalars["Boolean"]>;
};

/** Mastercard-specific installment payment input data. */
export type MastercardInstallmentDataInput = {
  /** Indicates whether this is a single authorization with multiple captures. */
  singleAuthorizationMultipleCaptures?: InputMaybe<Scalars["Boolean"]>;
};

/** Information about the 3DSecure Cardholder Authentication. */
export enum MastercardThreeDSecureCardholderAuthentication {
  /** Channel encryption was used instead of a cardholder certificate. This is the preferred value. */
  CARDHOLDER_CERTIFICATE_NOT_USED = "CARDHOLDER_CERTIFICATE_NOT_USED",
  /** Processed through Masterpass. */
  MASTERPASS_PROCESSED = "MASTERPASS_PROCESSED",
  /** Tokenized payment. */
  TOKENIZED_PAYMENT = "TOKENIZED_PAYMENT",
}

/** Information about the collection capabilities of the Universal Cardholder Authentication Field. */
export enum MastercardUcafCollectionIndicator {
  /** Issuer risk-based decisioning. */
  ISSUER_RISK_DECISIONING = "ISSUER_RISK_DECISIONING",
  /** Merchant risk-based decisioning. */
  MERCHANT_RISK_DECISIONING = "MERCHANT_RISK_DECISIONING",
  /** The 3DS verification method is not supported. */
  NOT_SUPPORTED = "NOT_SUPPORTED",
  /** Partial shipment or recurring payment (UCAF not required). Liability depends on the original UCAF values provided and matching with the initial transaction. */
  PARTIAL_SHIPMENT_OR_RECURRING_PAYMENT = "PARTIAL_SHIPMENT_OR_RECURRING_PAYMENT",
  /** UCAF data collection is not supported by the Merchant. */
  UCAF_DATA_NOT_SUPPORTED = "UCAF_DATA_NOT_SUPPORTED",
  /** UCAF data collection is supported by the Merchant and must be present. */
  UCAF_DATA_REQUIRED = "UCAF_DATA_REQUIRED",
  /** UCAF data collection is supported by the Merchant and contains static AAV data. */
  UCAF_DATA_STATIC = "UCAF_DATA_STATIC",
  /** UCAF data collection is supported by the Merchant. */
  UCAF_DATA_SUPPORTED = "UCAF_DATA_SUPPORTED",
}

/** A Spend Control rule that allows for spending up to a specified `Amount` above the account's original balance'. */
export type MaximumAmountVarianceOnPseudoBalanceSpendRule = Node &
  SpendRule & {
    __typename?: "MaximumAmountVarianceOnPseudoBalanceSpendRule";
    /** The `Amount` over the account's original balance that is permitted for additional spending. */
    amountVariance?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the `MaximumAmountVarianceOnPseudoBalanceSpendRule` in operations. */
    id: Scalars["ID"];
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/** A Spend Control rule that allows for spending up to a specified `Amount` above the account's original balance'. */
export type MaximumAmountVarianceOnPseudoBalanceSpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The result of applying a `MaximumAmountVarianceOnPseudoBalanceSpendRule` to an event. */
export type MaximumAmountVarianceOnPseudoBalanceSpendRuleResult =
  SpendRuleResult & {
    __typename?: "MaximumAmountVarianceOnPseudoBalanceSpendRuleResult";
    /** The attached level. */
    attachedLevel?: Maybe<AttachedLevel>;
    /** A message describing the result. */
    message?: Maybe<Scalars["String"]>;
    /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
    recommendation?: Maybe<SpendRuleRecommendation>;
    /** The spend rule attached at the time of the event. */
    spendRule?: Maybe<MaximumAmountVarianceOnPseudoBalanceSpendRule>;
    /** The tested `Amount` of the event. */
    valuesTested?: Maybe<Array<Amount>>;
  };

/** A Spend Control rule that allows for spending up to a specified percentage over the account's original balance. */
export type MaximumPercentVarianceOnPseudoBalanceSpendRule = Node &
  SpendRule & {
    __typename?: "MaximumPercentVarianceOnPseudoBalanceSpendRule";
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the `MaximumPercentVarianceOnPseudoBalanceSpendRule` in operations. */
    id: Scalars["ID"];
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The percentage over the account's original balance that is permitted for additional spending. */
    percentVariance?: Maybe<Scalars["Int"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/** A Spend Control rule that allows for spending up to a specified percentage over the account's original balance. */
export type MaximumPercentVarianceOnPseudoBalanceSpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The result of applying a `MaximumPercentVarianceOnPseudoBalanceSpendRule` to an event. */
export type MaximumPercentVarianceOnPseudoBalanceSpendRuleResult =
  SpendRuleResult & {
    __typename?: "MaximumPercentVarianceOnPseudoBalanceSpendRuleResult";
    /** The attached level. */
    attachedLevel?: Maybe<AttachedLevel>;
    /** A message describing the result. */
    message?: Maybe<Scalars["String"]>;
    /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
    recommendation?: Maybe<SpendRuleRecommendation>;
    /** The spend rule attached at the time of the event. */
    spendRule?: Maybe<MaximumPercentVarianceOnPseudoBalanceSpendRule>;
    /** The tested `Amount` of the event. */
    valuesTested?: Maybe<Array<Amount>>;
  };

/** The list of human friendly merchant category codes (MCC) according to [ISO-18245](https://en.wikipedia.org/wiki/ISO_18245). */
export enum MerchantCategory {
  /**
   * The category for A1 Rent A Car
   *
   * Numeric Code: '3412'
   */
  A1_RENT_A_CAR = "A1_RENT_A_CAR",
  /**
   * The category for AB Hotel
   *
   * Numeric code: '3861'
   */
  AB_HOTEL = "AB_HOTEL",
  /**
   * The category for Accent Rent A Car
   *
   * Numeric Code: '3374'
   */
  ACCENT_RENT_A_CAR = "ACCENT_RENT_A_CAR",
  /**
   * The category for Accounting/Bookkeeping Services.
   *
   * Numeric code: '8931'
   */
  ACCOUNTING_BOOKKEEPING_SERVICES = "ACCOUNTING_BOOKKEEPING_SERVICES",
  /**
   * The category for Action Auto Rental
   *
   * Numeric Code: '3354'
   */
  ACTION_AUTO_RENTAL = "ACTION_AUTO_RENTAL",
  /**
   * The category for AC Hotels
   *
   * Numeric code: '3844'
   */
  AC_HOTELS = "AC_HOTELS",
  /**
   * The category for "A/C, Refrigeration Repair".
   *
   * Numeric code: '7623'
   */
  AC_REFRIGERATION_REPAIR = "AC_REFRIGERATION_REPAIR",
  /**
   * The category for Adams Mark
   *
   * Numeric Code: '3681'
   */
  ADAMS_MARK = "ADAMS_MARK",
  /**
   * The category for Adria Airways
   *
   * Numeric Code: '3064'
   */
  ADRIA_AIR = "ADRIA_AIR",
  /**
   * The category for Advantage Rent A Car
   *
   * Numeric Code: '3441'
   */
  ADVANTAGE_RENT_A_CAR = "ADVANTAGE_RENT_A_CAR",
  /**
   * The category for Advertising Services.
   *
   * Numeric code: '7311'
   */
  ADVERTISING_SERVICES = "ADVERTISING_SERVICES",
  /**
   * The category for Aeorflot
   *
   * Numeric Code: '3011'
   */
  AEORFLOT = "AEORFLOT",
  /**
   * The category for Aeorlineas Argentinas
   *
   * Numeric Code: '3030'
   */
  AEROLINEAS_ARGENTINAS = "AEROLINEAS_ARGENTINAS",
  /**
   * The category for Aeromexico
   *
   * Numeric Code: '3076'
   */
  AEROMEXICO = "AEROMEXICO",
  /**
   * The category for Aero Coach Aviation
   *
   * Numeric Code: '3287'
   */
  AERO_COACH_AVIATION = "AERO_COACH_AVIATION",
  /**
   * The category for Aero Continente
   *
   * Numeric Code: '3167'
   */
  AERO_CONTINENTE = "AERO_CONTINENTE",
  /**
   * The category for Aero Nicaraguensis
   *
   * Numeric Code: '3286'
   */
  AERO_NICARAGUENSIS = "AERO_NICARAGUENSIS",
  /**
   * The category for Aero Peru
   *
   * Numeric Code: '3285'
   */
  AERO_PERU = "AERO_PERU",
  /**
   * The category for Aero Virgin Islands
   *
   * Numeric Code: '3284'
   */
  AERO_VIRGIN_ISLANDS = "AERO_VIRGIN_ISLANDS",
  /**
   * The category for Aer Lingus
   *
   * Numeric Code: '3043'
   */
  AER_LINGUS = "AER_LINGUS",
  /**
   * The category for Affiliated Auto Rental
   *
   * Numeric Code: '3351'
   */
  AFFILIATED_AUTO_RENTAL = "AFFILIATED_AUTO_RENTAL",
  /**
   * The category for Affinia
   *
   * Numeric Code: '3817'
   */
  AFFINIA = "AFFINIA",
  /**
   * The category for Agency Rent A Car
   *
   * Numeric Code: '3364'
   */
  AGENCY_RENT_A_CAR = "AGENCY_RENT_A_CAR",
  /**
   * The category for Agricultural Cooperative.
   *
   * Numeric code: '0763'
   */
  AGRICULTURAL_COOPERATIVE = "AGRICULTURAL_COOPERATIVE",
  /**
   * The category for Airinter
   *
   * Numeric Code: '3065'
   */
  AIRINTER = "AIRINTER",
  /**
   * The category for "Airlines, Air Carriers".
   *
   * Numeric codes: ['3003','3019','3070','3073','3074','3080','3091','3092','3093','3095','3101','3104','3105','3107','3108','3109','3113','3114','3116','3119','3120','3121','3122','3123','3124','3128','3134','3139','3140','3141','3142','3147','3149','3150','3152','3153','3155','3157','3158','3160','3162','3163','3166','3173','3179','3189','3192','3194','3195','3198','3199','3201','3202','3205','3207','3208','3209','3210','3214','3224','3225','3227','3230','3232','3237','3244','3249','3250','3255','3257','3258','3264','3265','3268','3269','3270','3271','3272','3273','3274','3275','3276','3277','3278','3279','3281','3283','3288','3289','3290','3291','4511']
   */
  AIRLINES_AIR_CARRIERS = "AIRLINES_AIR_CARRIERS",
  /**
   * The category for "Airports, Flying Fields".
   *
   * Numeric code: '4582'
   */
  AIRPORTS_FLYING_FIELDS = "AIRPORTS_FLYING_FIELDS",
  /**
   * The category for AirTran Airways
   *
   * Numeric Code: '3177'
   */
  AIRTRAN_AIRWAYS = "AIRTRAN_AIRWAYS",
  /**
   * The category for Airways
   *
   * Numeric Code: '3361'
   */
  AIRWAYS = "AIRWAYS",
  /**
   * The category for Air Afrique
   *
   * Numeric Code: '3083'
   */
  AIR_AFRIQUE = "AIR_AFRIQUE",
  /**
   * The category for Air Algerie
   *
   * Numeric Code: '3021'
   */
  AIR_ALGERIE = "AIR_ALGERIE",
  /**
   * The category for Air Arabia Airline
   *
   * Numeric Code: '3236'
   */
  AIR_ARABIA = "AIR_ARABIA",
  /**
   * The category for Air Astana
   *
   * Numeric Code: '3068'
   */
  AIR_ASTANA = "AIR_ASTANA",
  /**
   * The category for Air Baltic
   *
   * Numeric code: '3304'
   */
  AIR_BALTIC = "AIR_BALTIC",
  /**
   * The category for Air Berlin
   *
   * Numeric Code: '3296'
   */
  AIR_BERLIN = "AIR_BERLIN",
  /**
   * The category for Air British Columbia
   *
   * Numeric Code: '3071'
   */
  AIR_BRITISH_COLUMBIA = "AIR_BRITISH_COLUMBIA",
  /**
   * The category for Air Canada
   *
   * Numeric Code: '3009'
   */
  AIR_CANADA = "AIR_CANADA",
  /**
   * The category for Air China
   *
   * Numeric Code: '3261'
   */
  AIR_CHINA = "AIR_CHINA",
  /**
   * The category for Air Djibouti
   *
   * Numeric Code: '3282'
   */
  AIR_DJIBOUTI = "AIR_DJIBOUTI",
  /**
   * The category for Air France
   *
   * Numeric Code: '3007'
   */
  AIR_FRANCE = "AIR_FRANCE",
  /**
   * The category for Air India
   *
   * Numeric Code: '3020'
   */
  AIR_INDIA = "AIR_INDIA",
  /**
   * The category for Air Jamaica
   *
   * Numeric Code: '3280'
   */
  AIR_JAMAICA = "AIR_JAMAICA",
  /**
   * The category for Air Lanka
   *
   * Numeric Code: '3044'
   */
  AIR_LANKA = "AIR_LANKA",
  /**
   * The category for Air Littoral S.A.
   *
   * Numeric Code: '3148'
   */
  AIR_LITTORAL = "AIR_LITTORAL",
  /**
   * The category for Air Malta
   *
   * Numeric Code: '3028'
   */
  AIR_MALTA = "AIR_MALTA",
  /**
   * The category for Royal Air Maroc
   *
   * Numeric Code: '3048'
   */
  AIR_MAROC = "AIR_MAROC",
  /**
   * The category for Air Mauritius
   *
   * Numeric Code: '3298'
   */
  AIR_MAURITIUS = "AIR_MAURITIUS",
  /**
   * The category for Air New Zealand
   *
   * Numeric Code: '3025'
   */
  AIR_NEW_ZEALAND = "AIR_NEW_ZEALAND",
  /**
   * The category for Air Panama International
   *
   * Numeric Code: '3267'
   */
  AIR_PANAMA = "AIR_PANAMA",
  /**
   * The category for Air Seychelles
   *
   * Numeric Code: '3266'
   */
  AIR_SEYCHELLES = "AIR_SEYCHELLES",
  /**
   * The category for Air Transat
   *
   * Numeric code: '3305'
   */
  AIR_TRANSAT = "AIR_TRANSAT",
  /**
   * The category for Air Zaire
   *
   * Numeric Code: '3151'
   */
  AIR_ZAIRE = "AIR_ZAIRE",
  /**
   * The category for Air Zimbabwe Corp
   *
   * Numeric Code: '3096'
   */
  AIR_ZIMBABWE_CORP = "AIR_ZIMBABWE_CORP",
  /**
   * The category for Ajax Rent A Car
   *
   * Numeric Code: '3376'
   */
  AJAX_RENT_A_CAR = "AJAX_RENT_A_CAR",
  /**
   * The category for Aladdin Resort And Casino
   *
   * Numeric Code: '3560'
   */
  ALADDIN_RESORT_AND_CASINO = "ALADDIN_RESORT_AND_CASINO",
  /**
   * The category for Alamo Rent A Car
   *
   * Numeric Code: '3387'
   */
  ALAMO_RENT_A_CAR = "ALAMO_RENT_A_CAR",
  /**
   * The category for Alaska Airlines Inc.
   *
   * Numeric Code: '3256'
   */
  ALASKA_AIR = "ALASKA_AIR",
  /**
   * The category for Ala Moana Hotel
   *
   * Numeric Code: '3788'
   */
  ALA_MOANA_HOTEL = "ALA_MOANA_HOTEL",
  /**
   * The category for Alitalia
   *
   * Numeric Code: '3013'
   */
  ALITALIA = "ALITALIA",
  /**
   * The category for Allstate
   *
   * Numeric Code: '3421'
   */
  ALLSTATE = "ALLSTATE",
  /**
   * The category for Antilean Airlines (ALM)
   *
   * Numeric Code: '3252'
   */
  ALM_AIRLINE = "ALM_AIRLINE",
  /**
   * The category for Aloft
   *
   * Numeric Code: '3619'
   */
  ALOFT = "ALOFT",
  /**
   * The category for Aloha Airlines
   *
   * Numeric Code: '3251'
   */
  ALOHA_AIRLINES = "ALOHA_AIRLINES",
  /**
   * The category for Altra Auto Rental
   *
   * Numeric Code: '3362'
   */
  ALTRA_AUTO_RENTAL = "ALTRA_AUTO_RENTAL",
  /**
   * The category for Ambulance Services.
   *
   * Numeric code: '4119'
   */
  AMBULANCE_SERVICES = "AMBULANCE_SERVICES",
  /**
   * The category for Amelia Island Plantation
   *
   * Numeric Code: '3754'
   */
  AMELIA_ISLAND_PLANTATION = "AMELIA_ISLAND_PLANTATION",
  /**
   * The category for Americana Hotels Corporation
   *
   * Numeric Code: '3517'
   */
  AMERICANA_HOTELS_CORPORATION = "AMERICANA_HOTELS_CORPORATION",
  /**
   * The category for American Airlines
   *
   * Numeric Code: '3001'
   */
  AMERICAN_AIRLINES = "AMERICAN_AIRLINES",
  /**
   * The category for American International
   *
   * Numeric Code: '3352'
   */
  AMERICAN_INTERNATIONAL = "AMERICAN_INTERNATIONAL",
  /**
   * The category for America’S Best Value Inn
   *
   * Numeric Code: '3617'
   */
  AMERICAS_BEST_VALUE_INN = "AMERICAS_BEST_VALUE_INN",
  /**
   * The category for America West
   *
   * Numeric Code: '3253'
   */
  AMERICA_WEST = "AMERICA_WEST",
  /**
   * The category for Americinn
   *
   * Numeric Code: '3614'
   */
  AMERICINN = "AMERICINN",
  /**
   * The category for Amerisuites
   *
   * Numeric Code: '3514'
   */
  AMERISUITES = "AMERISUITES",
  /**
   * The category for Amfac Hotels
   *
   * Numeric Code: '3536'
   */
  AMFAC_HOTELS = "AMFAC_HOTELS",
  /**
   * The category for Amusement Parks/Carnivals.
   *
   * Numeric code: '7996'
   */
  AMUSEMENT_PARKS_CARNIVALS = "AMUSEMENT_PARKS_CARNIVALS",
  /**
   * The category for All Nipon Airways
   *
   * Numeric Code: '3161'
   */
  ANA_AIR = "ANA_AIR",
  /**
   * The category for Ana Hotels
   *
   * Numeric Code: '3537'
   */
  ANA_HOTELS = "ANA_HOTELS",
  /**
   * The category for Ansa International
   *
   * Numeric Code: '3420'
   */
  ANSA_INTERNATIONAL = "ANSA_INTERNATIONAL",
  /**
   * The category for Ansett Airlines
   *
   * Numeric Code: '3033'
   */
  ANSETT_AIRLINES = "ANSETT_AIRLINES",
  /**
   * The category for Antique Reproductions.
   *
   * Numeric code: '5937'
   */
  ANTIQUE_REPRODUCTIONS = "ANTIQUE_REPRODUCTIONS",
  /**
   * The category for Antique Shops.
   *
   * Numeric code: ['5932', '5832']
   */
  ANTIQUE_SHOPS = "ANTIQUE_SHOPS",
  /**
   * The category for Aquariums.
   *
   * Numeric code: '7998'
   */
  AQUARIUMS = "AQUARIUMS",
  /**
   * The category for Arabella Hotels
   *
   * Numeric Code: '3511'
   */
  ARABELLA_HOTELS = "ARABELLA_HOTELS",
  /**
   * The category for Arcade
   *
   * Numeric Code: '3670'
   */
  ARCADE = "ARCADE",
  /**
   * The category for Architectural/Surveying Services.
   *
   * Numeric code: '8911'
   */
  ARCHITECTURAL_SURVEYING_SERVICES = "ARCHITECTURAL_SURVEYING_SERVICES",
  /**
   * The category for Arctia
   *
   * Numeric Code: '3671'
   */
  ARCTIA = "ARCTIA",
  /**
   * The category for Aria
   *
   * Numeric Code: '3824'
   */
  ARIA = "ARIA",
  /**
   * The category for Arizona Biltmore
   *
   * Numeric Code: '3594'
   */
  ARIZONA_BILTMORE = "ARIZONA_BILTMORE",
  /**
   * The category for Artists Supply and Craft Shops.
   *
   * Numeric code: '5970'
   */
  ARTISTS_SUPPLY_AND_CRAFT_SHOPS = "ARTISTS_SUPPLY_AND_CRAFT_SHOPS",
  /**
   * The category for Art Dealers and Galleries.
   *
   * Numeric code: '5971'
   */
  ART_DEALERS_AND_GALLERIES = "ART_DEALERS_AND_GALLERIES",
  /**
   * The category for Aero Servicio Carabobo
   *
   * Numeric Code: '3263'
   */
  ASC_AIRLINE = "ASC_AIRLINE",
  /**
   * The category for Asiana Airlines
   *
   * Numeric Code: '3098'
   */
  ASIANA_AIRLINES = "ASIANA_AIRLINES",
  /**
   * The category for American Trans Air
   *
   * Numeric Code: '3259'
   */
  ATA_AIR = "ATA_AIR",
  /**
   * The category for Atlantic City Hilton
   *
   * Numeric Code: '3797'
   */
  ATLANTIC_CITY_HILTON = "ATLANTIC_CITY_HILTON",
  /**
   * The category for Auberge Des Governeurs
   *
   * Numeric Code: '3549'
   */
  AUBERGE_DES_GOVERNEURS = "AUBERGE_DES_GOVERNEURS",
  /**
   * The category for Austrian Airlines
   *
   * Numeric Code: '3051'
   */
  AUSTRIAN_AIR = "AUSTRIAN_AIR",
  /**
   * The category for Austrian Air Service
   *
   * Numeric Code: '3243'
   */
  AUSTRIAN_AIR_SERVICE = "AUSTRIAN_AIR_SERVICE",
  /**
   * The category for Autograph
   *
   * Numeric Code: '3826'
   */
  AUTOGRAPH = "AUTOGRAPH",
  /**
   * The category for Autohansa
   *
   * Numeric Code: '3436'
   */
  AUTOHANSA = "AUTOHANSA",
  /**
   * The category for Automate
   *
   * Numeric Code: '3425'
   */
  AUTOMATE = "AUTOMATE",
  /**
   * The category for Automated Cash Disburse.
   *
   * Numeric code: '6011'
   */
  AUTOMATED_CASH_DISBURSE = "AUTOMATED_CASH_DISBURSE",
  /**
   * The category for Automated Fuel Dispensers.
   *
   * Numeric code: '5542'
   */
  AUTOMATED_FUEL_DISPENSERS = "AUTOMATED_FUEL_DISPENSERS",
  /**
   * The category for Automobile Associations.
   *
   * Numeric code: '8675'
   */
  AUTOMOBILE_ASSOCIATIONS = "AUTOMOBILE_ASSOCIATIONS",
  /**
   * The category for Automotive Parts and Accessories Stores.
   *
   * Numeric code: '5533'
   */
  AUTOMOTIVE_PARTS_AND_ACCESSORIES_STORES = "AUTOMOTIVE_PARTS_AND_ACCESSORIES_STORES",
  /**
   * The category for Automotive Tire Stores.
   *
   * Numeric code: '5532'
   */
  AUTOMOTIVE_TIRE_STORES = "AUTOMOTIVE_TIRE_STORES",
  /**
   * The category for Auto and Home Supply Stores.
   *
   * Numeric code: '5531'
   */
  AUTO_AND_HOME_SUPPLY_STORES = "AUTO_AND_HOME_SUPPLY_STORES",
  /**
   * The category for Auto Body Repair Shops.
   *
   * Numeric code: '7531'
   */
  AUTO_BODY_REPAIR_SHOPS = "AUTO_BODY_REPAIR_SHOPS",
  /**
   * The category for Auto Host Rental Cars
   *
   * Numeric Code: '3400'
   */
  AUTO_HOST_RENTAL_CARS = "AUTO_HOST_RENTAL_CARS",
  /**
   * The category for Auto Paint Shops.
   *
   * Numeric code: '7535'
   */
  AUTO_PAINT_SHOPS = "AUTO_PAINT_SHOPS",
  /**
   * The category for Auto Service Shops.
   *
   * Numeric code: '7538'
   */
  AUTO_SERVICE_SHOPS = "AUTO_SERVICE_SHOPS",
  /**
   * The category for Avcar
   *
   * Numeric Code: '3423'
   */
  AVCAR = "AVCAR",
  /**
   * The category for Avensa
   *
   * Numeric Code: '3242'
   */
  AVENSA_AIR = "AVENSA_AIR",
  /**
   * The category for Aviacion Y Comercio (AVIACO)
   *
   * Numeric Code: '3053'
   */
  AVIACO_AIR = "AVIACO_AIR",
  /**
   * The category for Avianca
   *
   * Numeric Code: '3039'
   */
  AVIANCA = "AVIANCA",
  /**
   * The category for Aviateca
   *
   * Numeric Code: '3241'
   */
  AVIATECA_AIR = "AVIATECA_AIR",
  /**
   * The category for Avis Rent A Car
   *
   * Numeric Code: '3389'
   */
  AVIS_RENT_A_CAR = "AVIS_RENT_A_CAR",
  /**
   * The category for Avon Rent A Car
   *
   * Numeric Code: '3427'
   */
  AVON_RENT_A_CAR = "AVON_RENT_A_CAR",
  /**
   * The category for Azul Brazilian Airlines
   *
   * Numeric Code: '3300'
   */
  AZUL_BRAZILIAN_AIRLINES = "AZUL_BRAZILIAN_AIRLINES",
  /**
   * The category for Bahamasair
   *
   * Numeric Code: '3240'
   */
  BAHAMAS_AIR = "BAHAMAS_AIR",
  /**
   * The category for "Bail and Bond Payments (payment to the surety for the bond, not the actual bond paid to the government agency)".
   *
   * Numeric code: '9223'
   */
  BAIL_AND_BOND_PAYMENTS = "BAIL_AND_BOND_PAYMENTS",
  /**
   * The category for Bakeries.
   *
   * Numeric code: '5462'
   */
  BAKERIES = "BAKERIES",
  /**
   * The category for Balkan-Bulgarian Airlines
   *
   * Numeric Code: '3041'
   */
  BALKAN_AIR = "BALKAN_AIR",
  /**
   * The category for Ballys Hotel And Casino
   *
   * Numeric Code: '3728'
   */
  BALLYS_HOTEL_AND_CASINO = "BALLYS_HOTEL_AND_CASINO",
  /**
   * The category for "Bands, Orchestras".
   *
   * Numeric code: '7929'
   */
  BANDS_ORCHESTRAS = "BANDS_ORCHESTRAS",
  /**
   * The category for Banyan Tree Hotels and Resorts
   *
   * Numeric code: '3856'
   */
  BANYAN_TREE_HOTELS_AND_RESORTS = "BANYAN_TREE_HOTELS_AND_RESORTS",
  /**
   * The category for Barber and Beauty Shops.
   *
   * Numeric code: '7230'
   */
  BARBER_AND_BEAUTY_SHOPS = "BARBER_AND_BEAUTY_SHOPS",
  /**
   * The category for Barton Creek Resort
   *
   * Numeric Code: '3556'
   */
  BARTON_CREEK_RESORT = "BARTON_CREEK_RESORT",
  /**
   * The category for Bar Harbor Airlines
   *
   * Numeric Code: '3239'
   */
  BAR_HARBOR_AIRLINES = "BAR_HARBOR_AIRLINES",
  /**
   * The category for Baymont Inn & Suites
   *
   * Numeric Code: '3834'
   */
  BAYMONT_INN_SUITES = "BAYMONT_INN_SUITES",
  /**
   * The category for Beau Rivage Hotel And Casino
   *
   * Numeric Code: '3764'
   */
  BEAU_RIVAGE_HOTEL_AND_CASINO = "BEAU_RIVAGE_HOTEL_AND_CASINO",
  /**
   * The category for Bellagio
   *
   * Numeric Code: '3765'
   */
  BELLAGIO = "BELLAGIO",
  /**
   * The category for Bemidji Aviation
   *
   * Numeric Code: '3238'
   */
  BEMIDJI_AIR = "BEMIDJI_AIR",
  /**
   * The category for Best Western
   *
   * Numeric Code: '3502'
   */
  BEST_WESTERN = "BEST_WESTERN",
  /**
   * The category for Betting/Casino Gambling.
   *
   * Numeric code: '7995'
   */
  BETTING_CASINO_GAMBLING = "BETTING_CASINO_GAMBLING",
  /**
   * The category for Beverly Hills Hotel
   *
   * Numeric Code: '3749'
   */
  BEVERLY_HILLS_HOTEL = "BEVERLY_HILLS_HOTEL",
  /**
   * The category for Bicycle Shops.
   *
   * Numeric code: '5940'
   */
  BICYCLE_SHOPS = "BICYCLE_SHOPS",
  /**
   * The category for Billiard/Pool Establishments.
   *
   * Numeric code: '7932'
   */
  BILLIARD_POOL_ESTABLISHMENTS = "BILLIARD_POOL_ESTABLISHMENTS",
  /**
   * The category for Biltmore Hotel And Suites
   *
   * Numeric Code: '3743'
   */
  BILTMORE_HOTEL_AND_SUITES = "BILTMORE_HOTEL_AND_SUITES",
  /**
   * The category for Binions Horseshoe Club
   *
   * Numeric Code: '3620'
   */
  BINIONS_HORSESHOE_CLUB = "BINIONS_HORSESHOE_CLUB",
  /**
   * The category for Blueprinting and Photocopying Services
   *
   * Numeric Code: '7332'
   */
  BLUEPRINTING_AND_PHOTOCOPYING_SERVICES = "BLUEPRINTING_AND_PHOTOCOPYING_SERVICES",
  /**
   * The category for Boat Dealers.
   *
   * Numeric code: '5551'
   */
  BOAT_DEALERS = "BOAT_DEALERS",
  /**
   * The category for Boat Rentals and Leases.
   *
   * Numeric code: '4457'
   */
  BOAT_RENTALS_AND_LEASES = "BOAT_RENTALS_AND_LEASES",
  /**
   * The category for Boca Raton Resort
   *
   * Numeric Code: '3733'
   */
  BOCA_RATON_RESORT = "BOCA_RATON_RESORT",
  /**
   * The category for "Books, Periodicals, and Newspapers".
   *
   * Numeric code: '5192'
   */
  BOOKS_PERIODICALS_AND_NEWSPAPERS = "BOOKS_PERIODICALS_AND_NEWSPAPERS",
  /**
   * The category for Book Stores.
   *
   * Numeric code: '5942'
   */
  BOOK_STORES = "BOOK_STORES",
  /**
   * The category for Bowling Alleys.
   *
   * Numeric code: '7933'
   */
  BOWLING_ALLEYS = "BOWLING_ALLEYS",
  /**
   * The category for Braathens S.A.F.E
   *
   * Numeric Code: '3106'
   */
  BRAATHENS = "BRAATHENS",
  /**
   * The category for Bradbury Suites
   *
   * Numeric Code: '3683'
   */
  BRADBURY_SUITES = "BRADBURY_SUITES",
  /**
   * The category for Breakers Resort
   *
   * Numeric Code: '3547'
   */
  BREAKERS_RESORT = "BREAKERS_RESORT",
  /**
   * The category for Breezbay Group
   *
   * Numeric code: '3850'
   */
  BREEZBAY_HOTEL_GROUP = "BREEZBAY_HOTEL_GROUP",
  /**
   * The category for British Airways
   *
   * Numeric Code: '3005'
   */
  BRITISH_AIRWAYS = "BRITISH_AIRWAYS",
  /**
   * The category for British Midland Air
   *
   * Numeric Code: '3111'
   */
  BRITISH_MIDLAND_AIR = "BRITISH_MIDLAND_AIR",
  /**
   * The category for Broadmoor Hotel
   *
   * Numeric Code: '3727'
   */
  BROADMOOR_HOTEL = "BROADMOOR_HOTEL",
  /**
   * The category for Brockway Air
   *
   * Numeric Code: '3235'
   */
  BROCKWAY_AIR = "BROCKWAY_AIR",
  /**
   * The category for Brooks Rent A Car
   *
   * Numeric Code: '3353'
   */
  BROOKS_RENT_A_CAR = "BROOKS_RENT_A_CAR",
  /**
   * The category for Budgetel
   *
   * Numeric Code: '3685'
   */
  BUDGETEL = "BUDGETEL",
  /**
   * The category for Budget Host Inns
   *
   * Numeric Code: '3684'
   */
  BUDGET_HOST_INNS = "BUDGET_HOST_INNS",
  /**
   * The category for Budget Rent A Car
   *
   * Numeric Code: '3366'
   */
  BUDGET_RENT_A_CAR = "BUDGET_RENT_A_CAR",
  /**
   * The category for Buffalo Bills Hotel And Casino
   *
   * Numeric Code: '3712'
   */
  BUFFALO_BILLS_HOTEL_AND_CASINO = "BUFFALO_BILLS_HOTEL_AND_CASINO",
  /**
   * The category for Bulgari
   *
   * Numeric code: '3845'
   */
  BULGARI = "BULGARI",
  /**
   * The category for Business/Secretarial Schools.
   *
   * Numeric code: '8244'
   */
  BUSINESS_SECRETARIAL_SCHOOLS = "BUSINESS_SECRETARIAL_SCHOOLS",
  /**
   * The category for Bus Lines.
   *
   * Numeric code: '4131'
   */
  BUS_LINES = "BUS_LINES",
  /**
   * The category for Buying/Shopping Services.
   *
   * Numeric code: '7278'
   */
  BUYING_SHOPPING_SERVICES = "BUYING_SHOPPING_SERVICES",
  /**
   * The category for "Cable, Satellite, and Other Pay Television and Radio".
   *
   * Numeric code: '4899'
   */
  CABLE_SATELLITE_AND_OTHER_PAY_TELEVISION_AND_RADIO = "CABLE_SATELLITE_AND_OTHER_PAY_TELEVISION_AND_RADIO",
  /**
   * The category for Caesars Hotel And Casino
   *
   * Numeric Code: '3771'
   */
  CAESARS_HOTEL_AND_CASINO = "CAESARS_HOTEL_AND_CASINO",
  /**
   * The category for California Hotel And Casino
   *
   * Numeric Code: '3582'
   */
  CALIFORNIA_HOTEL_AND_CASINO = "CALIFORNIA_HOTEL_AND_CASINO",
  /**
   * The category for Camera and Photographic Supply Stores.
   *
   * Numeric code: '5946'
   */
  CAMERA_AND_PHOTOGRAPHIC_SUPPLY_STORES = "CAMERA_AND_PHOTOGRAPHIC_SUPPLY_STORES",
  /**
   * The category for Campanile
   *
   * Numeric Code: '3672'
   */
  CAMPANILE = "CAMPANILE",
  /**
   * The category for Canadian Airlines International
   *
   * Numeric Code: '3171'
   */
  CANADIAN_AIR = "CANADIAN_AIR",
  /**
   * The category for Canadian Pacific
   *
   * Numeric Code: '3529'
   */
  CANADIAN_PACIFIC = "CANADIAN_PACIFIC",
  /**
   * The category for Candeo Hotels
   *
   * Numeric code: '3851'
   */
  CANDEO_HOTELS = "CANDEO_HOTELS",
  /**
   * The category for Candlewood Suites
   *
   * Numeric Code: '3559'
   */
  CANDLEWOOD_SUITES = "CANDLEWOOD_SUITES",
  /**
   * The category for "Candy, Nut, and Confectionery Stores".
   *
   * Numeric code: '5441'
   */
  CANDY_NUT_AND_CONFECTIONERY_STORES = "CANDY_NUT_AND_CONFECTIONERY_STORES",
  /**
   * The category for Canyon Ranch
   *
   * Numeric Code: '3757'
   */
  CANYON_RANCH = "CANYON_RANCH",
  /**
   * The category for Capitol Air
   *
   * Numeric Code: '3233'
   */
  CAPITOL_AIR = "CAPITOL_AIR",
  /**
   * The category for Carefree Resorts
   *
   * Numeric Code: '3744'
   */
  CAREFREE_RESORTS = "CAREFREE_RESORTS",
  /**
   * The category for Carey
   *
   * Numeric Code: '3428'
   */
  CAREY = "CAREY",
  /**
   * The category for Caribbean Airlines
   *
   * Numeric Code: '3234'
   */
  CARIBBEAN_AIRLINES = "CARIBBEAN_AIRLINES",
  /**
   * The category for Caribe Royal
   *
   * Numeric Code: '3821'
   */
  CARIBE_ROYAL = "CARIBE_ROYAL",
  /**
   * The category for Caribe Royal Resort Suite And Villas
   *
   * Numeric Code: '3787'
   */
  CARIBE_ROYAL_RESORT_SUITE_AND_VILLAS = "CARIBE_ROYAL_RESORT_SUITE_AND_VILLAS",
  /**
   * The category for Carlton Hotels
   *
   * Numeric Code: '3716'
   */
  CARLTON_HOTELS = "CARLTON_HOTELS",
  /**
   * The category for Carnival Airlines
   *
   * Numeric Code: '3086'
   */
  CARNIVAL_AIRLINES = "CARNIVAL_AIRLINES",
  /**
   * The category for Carpentry Services.
   *
   * Numeric code: '1750'
   */
  CARPENTRY_SERVICES = "CARPENTRY_SERVICES",
  /**
   * The category for Carpet/Upholstery Cleaning.
   *
   * Numeric code: '7217'
   */
  CARPET_UPHOLSTERY_CLEANING = "CARPET_UPHOLSTERY_CLEANING",
  /**
   * The category for "Car and Truck Dealers (New & Used) Sales, Service, Repairs Parts and Leasing".
   *
   * Numeric code: '5511'
   */
  CAR_AND_TRUCK_DEALERS_NEW_USED = "CAR_AND_TRUCK_DEALERS_NEW_USED",
  /**
   * The category for "Car and Truck Dealers (Used Only) Sales, Service, Repairs Parts and Leasing".
   *
   * Numeric code: '5521'
   */
  CAR_AND_TRUCK_DEALERS_USED_ONLY = "CAR_AND_TRUCK_DEALERS_USED_ONLY",
  /**
   * The category for Car Rentals.
   *
   * Numeric Codes: ['3356','3358','3363','3365','3367','3369','3371','3372','3373','3375','3377','3378','3379','3382','3383','3384','3392','3397','3399','3401','3402','3403','3404','3406','3407','3408','3410','3411','3413','3415','3416','3417','3418','3419','3422','3424','3426','3440']
   */
  CAR_RENTAL = "CAR_RENTAL",
  /**
   * The category for Car Rental Agencies.
   *
   * Numeric code: '7512'
   */
  CAR_RENTAL_AGENCIES = "CAR_RENTAL_AGENCIES",
  /**
   * The category for Car Washes.
   *
   * Numeric code: '7542'
   */
  CAR_WASHES = "CAR_WASHES",
  /**
   * The category for Caterers.
   *
   * Numeric code: '5811'
   */
  CATERERS = "CATERERS",
  /**
   * The category for Cathay Pacific
   *
   * Numeric Code: '3099'
   */
  CATHAY_PACIFIC = "CATHAY_PACIFIC",
  /**
   * The category for Cayman Airways
   *
   * Numeric Code: '3228'
   */
  CAYMAN_AIRWAYS = "CAYMAN_AIRWAYS",
  /**
   * The category for Cebu Pacific Airlines
   *
   * Numeric Code: '3072'
   */
  CEBU_PACIFIC_AIRLINES = "CEBU_PACIFIC_AIRLINES",
  /**
   * The category for Centurion Hotels
   *
   * Numeric code: '3882'
   */
  CENTURION_HOTELS = "CENTURION_HOTELS",
  /**
   * The category for C'est La Vie Resort Izumigo
   *
   * Numeric code: '3855'
   */
  CEST_LA_VIE_RESORT_IZUMIGO = "CEST_LA_VIE_RESORT_IZUMIGO",
  /**
   * The category for Champagne Producers.
   *
   * Numeric code: '0744'
   */
  CHAMPAGNE_PRODUCERS = "CHAMPAGNE_PRODUCERS",
  /**
   * The category for Charitable and Social Service Organizations - Fundraising.
   *
   * Numeric code: '8398'
   */
  CHARITABLE_AND_SOCIAL_SERVICE_ORGANIZATIONS_FUNDRAISING = "CHARITABLE_AND_SOCIAL_SERVICE_ORGANIZATIONS_FUNDRAISING",
  /**
   * The category for Chateau Elan Winery And Resort
   *
   * Numeric Code: '3763'
   */
  CHATEAU_ELAN_WINERY_AND_RESORT = "CHATEAU_ELAN_WINERY_AND_RESORT",
  /**
   * The category for Chemicals and Allied Products (Not Elsewhere Classified).
   *
   * Numeric code: '5169'
   */
  CHEMICALS_AND_ALLIED_PRODUCTS = "CHEMICALS_AND_ALLIED_PRODUCTS",
  /**
   * The category for Children's and Infants Wear Stores.
   *
   * Numeric code: '5641'
   */
  CHILDRENS_AND_INFANTS_WEAR_STORES = "CHILDRENS_AND_INFANTS_WEAR_STORES",
  /**
   * The category for Child Care Services.
   *
   * Numeric code: '8351'
   */
  CHILD_CARE_SERVICES = "CHILD_CARE_SERVICES",
  /**
   * The category for China Airlines
   *
   * Numeric Code: '3078'
   */
  CHINA_AIRLINES = "CHINA_AIRLINES",
  /**
   * The category for China Eastern Airlines
   *
   * Numeric Code: '3206'
   */
  CHINA_EASTERN_AIRLINES = "CHINA_EASTERN_AIRLINES",
  /**
   * The category for China Southern Airlines
   *
   * Numeric Code: '3308'
   */
  CHINA_SOUTHERN_AIRLINES = "CHINA_SOUTHERN_AIRLINES",
  /**
   * The category for "Chiropodists, Podiatrists".
   *
   * Numeric code: '8049'
   */
  CHIROPODISTS_PODIATRISTS = "CHIROPODISTS_PODIATRISTS",
  /**
   * The category for Chiropractors.
   *
   * Numeric code: '8041'
   */
  CHIROPRACTORS = "CHIROPRACTORS",
  /**
   * The category for Chisun Hotels
   *
   * Numeric code: '3862'
   */
  CHISUN_HOTELS = "CHISUN_HOTELS",
  /**
   * The category for Cigahotels
   *
   * Numeric Code: '3544'
   */
  CIGAHOTELS = "CIGAHOTELS",
  /**
   * The category for Cigar Stores and Stands.
   *
   * Numeric code: '5993'
   */
  CIGAR_STORES_AND_STANDS = "CIGAR_STORES_AND_STANDS",
  /**
   * The category for Circus Circus Hotel And Casino
   *
   * Numeric Code: '3662'
   */
  CIRCUS_CIRCUS_HOTEL_AND_CASINO = "CIRCUS_CIRCUS_HOTEL_AND_CASINO",
  /**
   * The category for Cite
   *
   * Numeric Code: '3437'
   */
  CITE = "CITE",
  /**
   * The category for City Lodge Hotels
   *
   * Numeric Code: '3717'
   */
  CITY_LODGE_HOTELS = "CITY_LODGE_HOTELS",
  /**
   * The category for "Civic, Social, Fraternal Associations".
   *
   * Numeric code: '8641'
   */
  CIVIC_SOCIAL_FRATERNAL_ASSOCIATIONS = "CIVIC_SOCIAL_FRATERNAL_ASSOCIATIONS",
  /**
   * The category for Claridge Casino Hotel
   *
   * Numeric Code: '3792'
   */
  CLARIDGE_CASINO_HOTEL = "CLARIDGE_CASINO_HOTEL",
  /**
   * The category for Clarion Hotel
   *
   * Numeric Code: '3687'
   */
  CLARION_HOTEL = "CLARION_HOTEL",
  /**
   * The category for Cleaning and Maintenance.
   *
   * Numeric code: '7349'
   */
  CLEANING_AND_MAINTENANCE = "CLEANING_AND_MAINTENANCE",
  /**
   * The category for Climat De France
   *
   * Numeric Code: '3677'
   */
  CLIMAT_DE_FRANCE = "CLIMAT_DE_FRANCE",
  /**
   * The category for Clothing Rental.
   *
   * Numeric code: '7296'
   */
  CLOTHING_RENTAL = "CLOTHING_RENTAL",
  /**
   * The category for Club Corporation Club Resorts
   *
   * Numeric Code: '3747'
   */
  CLUB_CORPORATION_CLUB_RESORTS = "CLUB_CORPORATION_CLUB_RESORTS",
  /**
   * The category for Club Med
   *
   * Numeric Code: '3742'
   */
  CLUB_MED = "CLUB_MED",
  /**
   * The category for Coast Hotels
   *
   * Numeric Code: '3552'
   */
  COAST_HOTELS = "COAST_HOTELS",
  /**
   * The category for "Colleges, Universities".
   *
   * Numeric code: '8220'
   */
  COLLEGES_UNIVERSITIES = "COLLEGES_UNIVERSITIES",
  /**
   * The category for Colorado Belle Edgewater Resort
   *
   * Numeric Code: '3736'
   */
  COLORADO_BELLE_EDGEWATER_RESORT = "COLORADO_BELLE_EDGEWATER_RESORT",
  /**
   * The category for Comair
   *
   * Numeric Code: '3223'
   */
  COMAIR = "COMAIR",
  /**
   * The category for Comfort Hotel International
   *
   * Numeric Code: '3562'
   */
  COMFORT_HOTEL_INTERNATIONAL = "COMFORT_HOTEL_INTERNATIONAL",
  /**
   * The category for Command Airways
   *
   * Numeric Code: '3222'
   */
  COMMAND_AIR = "COMMAND_AIR",
  /**
   * The category for Commercial Equipment (Not Elsewhere Classified).
   *
   * Numeric code: '5046'
   */
  COMMERCIAL_EQUIPMENT = "COMMERCIAL_EQUIPMENT",
  /**
   * The category for Commercial Footwear.
   *
   * Numeric code: '5139'
   */
  COMMERCIAL_FOOTWEAR = "COMMERCIAL_FOOTWEAR",
  /**
   * The category for "Commercial Photography, Art and Graphics".
   *
   * Numeric code: '7333'
   */
  COMMERCIAL_PHOTOGRAPHY_ART_AND_GRAPHICS = "COMMERCIAL_PHOTOGRAPHY_ART_AND_GRAPHICS",
  /**
   * The category for "Commuter Transport, Ferries".
   *
   * Numeric code: '4111'
   */
  COMMUTER_TRANSPORT_AND_FERRIES = "COMMUTER_TRANSPORT_AND_FERRIES",
  /**
   * The category for Compri Hotel
   *
   * Numeric Code: '3688'
   */
  COMPRI_HOTEL = "COMPRI_HOTEL",
  /**
   * The category for "Computers, Peripherals, and Software".
   *
   * Numeric code: '5045'
   */
  COMPUTERS_PERIPHERALS_AND_SOFTWARE = "COMPUTERS_PERIPHERALS_AND_SOFTWARE",
  /**
   * The category for Computer Network Services.
   *
   * Numeric code: '4816'
   */
  COMPUTER_NETWORK_SERVICES = "COMPUTER_NETWORK_SERVICES",
  /**
   * The category for Computer Programming.
   *
   * Numeric code: '7372'
   */
  COMPUTER_PROGRAMMING = "COMPUTER_PROGRAMMING",
  /**
   * The category for Computer Repair.
   *
   * Numeric code: '7379'
   */
  COMPUTER_REPAIR = "COMPUTER_REPAIR",
  /**
   * The category for Computer Software Stores.
   *
   * Numeric code: '5734'
   */
  COMPUTER_SOFTWARE_STORES = "COMPUTER_SOFTWARE_STORES",
  /**
   * The category for Compania Faucett
   *
   * Numeric Code: '3220'
   */
  COMP_FAU_AIR = "COMP_FAU_AIR",
  /**
   * The category for Concession.
   *
   * Numeric code: '1003'
   */
  CONCESSION = "CONCESSION",
  /**
   * The category for Concorde Hotels
   *
   * Numeric Code: '3538'
   */
  CONCORDE_HOTELS = "CONCORDE_HOTELS",
  /**
   * The category for Concrete Work Services.
   *
   * Numeric code: '1771'
   */
  CONCRETE_WORK_SERVICES = "CONCRETE_WORK_SERVICES",
  /**
   * The category for Conrad Hotels
   *
   * Numeric Code: '3721'
   */
  CONRAD_HOTELS = "CONRAD_HOTELS",
  /**
   * The category for Consort
   *
   * Numeric Code: '3689'
   */
  CONSORT = "CONSORT",
  /**
   * The category for Construction Materials (Not Elsewhere Classified).
   *
   * Numeric code: '5039'
   */
  CONSTRUCTION_MATERIALS = "CONSTRUCTION_MATERIALS",
  /**
   * The category for "Consulting, Public Relations".
   *
   * Numeric code: '7392'
   */
  CONSULTING_PUBLIC_RELATIONS = "CONSULTING_PUBLIC_RELATIONS",
  /**
   * The category for Continental Airlines
   *
   * Numeric Code: '3061'
   */
  CONTINENTAL_AIRLINES = "CONTINENTAL_AIRLINES",
  /**
   * The category for Compania Panamena De Aviacion (COPA)
   *
   * Numeric Code: '3219'
   */
  COPA_AIR = "COPA_AIR",
  /**
   * The category for Core Global Management Hotels and Resorts
   *
   * Numeric code: '3852'
   */
  CORE_GLOBAL_MANAGEMENT_HOTELS_AND_RESORTS = "CORE_GLOBAL_MANAGEMENT_HOTELS_AND_RESORTS",
  /**
   * The category for Correspondence Schools.
   *
   * Numeric code: '8241'
   */
  CORRESPONDENCE_SCHOOLS = "CORRESPONDENCE_SCHOOLS",
  /**
   * The category for Cosmetic Stores.
   *
   * Numeric code: '5977'
   */
  COSMETIC_STORES = "COSMETIC_STORES",
  /**
   * The category for Cosmopolitan Of Las Vegas
   *
   * Numeric Code: '3828'
   */
  COSMOPOLITAN_OF_LAS_VEGAS = "COSMOPOLITAN_OF_LAS_VEGAS",
  /**
   * The category for Counseling Services.
   *
   * Numeric code: '7277'
   */
  COUNSELING_SERVICES = "COUNSELING_SERVICES",
  /**
   * The category for Country Clubs.
   *
   * Numeric code: '7997'
   */
  COUNTRY_CLUBS = "COUNTRY_CLUBS",
  /**
   * The category for Country Inn By Carlson
   *
   * Numeric Code: '3829'
   */
  COUNTRY_INN_BY_CARLSON = "COUNTRY_INN_BY_CARLSON",
  /**
   * The category for Courier Services.
   *
   * Numeric code: '4215'
   */
  COURIER_SERVICES = "COURIER_SERVICES",
  /**
   * The category for Courtyard By Marriott
   *
   * Numeric Code: '3690'
   */
  COURTYARD_BY_MARRIOTT = "COURTYARD_BY_MARRIOTT",
  /**
   * The category for "Court Costs, Including Alimony and Child Support - Courts of Law".
   *
   * Numeric code: '9211'
   */
  COURT_COSTS = "COURT_COSTS",
  /**
   * The category for Credit Reporting Agencies.
   *
   * Numeric code: '7321'
   */
  CREDIT_REPORTING_AGENCIES = "CREDIT_REPORTING_AGENCIES",
  /**
   * The category for Crest Hotels
   *
   * Numeric Code: '3521'
   */
  CREST_HOTELS = "CREST_HOTELS",
  /**
   * The category for Croatia Air
   *
   * Numeric Code: '3088'
   */
  CROATIA_AIR = "CROATIA_AIR",
  /**
   * The category for Crossland
   *
   * Numeric Code: '3822'
   */
  CROSSLAND = "CROSSLAND",
  /**
   * The category for Crowne Plaza Hotels
   *
   * Numeric Code: '3750'
   */
  CROWNE_PLAZA_HOTELS = "CROWNE_PLAZA_HOTELS",
  /**
   * The category for Crown Air
   *
   * Numeric Code: '3218'
   */
  CROWN_AIR = "CROWN_AIR",
  /**
   * The category for Cruise Lines.
   *
   * Numeric code: '4411'
   */
  CRUISE_LINES = "CRUISE_LINES",
  /**
   * The category for Cruzeiro Do Sul
   *
   * Numeric Code: '3046'
   */
  CRUZIERO_AIR = "CRUZIERO_AIR",
  /**
   * The category for Ceskoslovenske Aerolinie (CSA)
   *
   * Numeric Code: '3217'
   */
  CSA_AIRLINE = "CSA_AIRLINE",
  /**
   * The category for Cumberland Airlines
   *
   * Numeric Code: '3216'
   */
  CUMBERLAND_AIRLINES = "CUMBERLAND_AIRLINES",
  /**
   * The category for Cumulus Hotels
   *
   * Numeric Code: '3678'
   */
  CUMULUS_HOTELS = "CUMULUS_HOTELS",
  /**
   * The category for Cunard Hotels
   *
   * Numeric Code: '3593'
   */
  CUNARD_HOTELS = "CUNARD_HOTELS",
  /**
   * The category for Curio - A Collection by Hilton
   *
   * Numeric Code: '3832'
   */
  CURIO_HOTELS = "CURIO_HOTELS",
  /**
   * The category for Cyprus Airways
   *
   * Numeric Code: '3292'
   */
  CYPRUS_AIRWAYS = "CYPRUS_AIRWAYS",
  /**
   * The category for C Mon Inn
   *
   * Numeric Code: '3611'
   */
  C_MON_INN = "C_MON_INN",
  /**
   * The category for Dairy Products Stores.
   *
   * Numeric code: '5451'
   */
  DAIRY_PRODUCTS_STORES = "DAIRY_PRODUCTS_STORES",
  /**
   * The category for "Dance Hall, Studios, Schools".
   *
   * Numeric code: '7911'
   */
  DANCE_HALL_STUDIOS_SCHOOLS = "DANCE_HALL_STUDIOS_SCHOOLS",
  /**
   * The category for Dan Air Services
   *
   * Numeric Code: '3215'
   */
  DAN_AIR_SERVICES = "DAN_AIR_SERVICES",
  /**
   * The category for Dan Hotels
   *
   * Numeric Code: '3629'
   */
  DAN_HOTELS = "DAN_HOTELS",
  /**
   * The category for Dating/Escort Services.
   *
   * Numeric code: '7273'
   */
  DATING_ESCORT_SERVICES = "DATING_ESCORT_SERVICES",
  /**
   * The category for Days Inns Of America
   *
   * Numeric Code: '3510'
   */
  DAYS_INNS_OF_AMERICA = "DAYS_INNS_OF_AMERICA",
  /**
   * The category for DBA Airlines
   *
   * Numeric Code: '3059'
   */
  DBA_AIR = "DBA_AIR",
  /**
   * The category for Debt Collection Agencies
   *
   * Numeric code: '7322'
   */
  DEBT_COLLECTION_AGENCIES = "DEBT_COLLECTION_AGENCIES",
  /**
   * The category for Delta Airlines
   *
   * Numeric Code: '3058'
   */
  DELTA_AIRLINES = "DELTA_AIRLINES",
  /**
   * The category for Delta Hotels
   *
   * Numeric Code: '3581'
   */
  DELTA_HOTELS = "DELTA_HOTELS",
  /**
   * The category for "Dentists, Orthodontists".
   *
   * Numeric code: '8021'
   */
  DENTISTS_ORTHODONTISTS = "DENTISTS_ORTHODONTISTS",
  /**
   * The category for Department Stores.
   *
   * Numeric code: '5311'
   */
  DEPARTMENT_STORES = "DEPARTMENT_STORES",
  /**
   * The category for Detective Agencies.
   *
   * Numeric code: '7393'
   */
  DETECTIVE_AGENCIES = "DETECTIVE_AGENCIES",
  /**
   * The category for De Vere Hotels
   *
   * Numeric Code: '3648'
   */
  DE_VERE_HOTELS = "DE_VERE_HOTELS",
  /**
   * The category for Digital Goods – Applications (Excludes Games).
   *
   * Numeric code: '5817'
   */
  DIGITAL_GOODS_APPLICATIONS = "DIGITAL_GOODS_APPLICATIONS",
  /**
   * The category for Digital Goods – Games.
   *
   * Numeric code: '5816'
   */
  DIGITAL_GOODS_GAMES = "DIGITAL_GOODS_GAMES",
  /**
   * The category for Digital Goods – Large Digital Goods Merchant.
   *
   * Numeric code: '5818'
   */
  DIGITAL_GOODS_LARGE_VOLUME = "DIGITAL_GOODS_LARGE_VOLUME",
  /**
   * The category for "Digital Goods Media – Books, Movies, Music".
   *
   * Numeric code: '5815'
   */
  DIGITAL_GOODS_MEDIA = "DIGITAL_GOODS_MEDIA",
  /**
   * The category for Dillon Inn
   *
   * Numeric Code: '3691'
   */
  DILLON_INN = "DILLON_INN",
  /**
   * The category for Direct Marketing - Catalog Merchant.
   *
   * Numeric code: '5964'
   */
  DIRECT_MARKETING_CATALOG_MERCHANT = "DIRECT_MARKETING_CATALOG_MERCHANT",
  /**
   * The category for Direct Marketing - Combination Catalog and Retail Merchant.
   *
   * Numeric code: '5965'
   */
  DIRECT_MARKETING_COMBINATION_CATALOG_AND_RETAIL_MERCHANT = "DIRECT_MARKETING_COMBINATION_CATALOG_AND_RETAIL_MERCHANT",
  /**
   * The category for Direct Marketing - Inbound Telemarketing.
   *
   * Numeric code: '5967'
   */
  DIRECT_MARKETING_INBOUND_TELEMARKETING = "DIRECT_MARKETING_INBOUND_TELEMARKETING",
  /**
   * The category for Direct Marketing - Insurance Services.
   *
   * Numeric code: '5960'
   */
  DIRECT_MARKETING_INSURANCE_SERVICES = "DIRECT_MARKETING_INSURANCE_SERVICES",
  /**
   * The category for Direct Marketing - Other.
   *
   * Numeric code: '5969'
   */
  DIRECT_MARKETING_OTHER = "DIRECT_MARKETING_OTHER",
  /**
   * The category for Direct Marketing - Outbound Telemarketing.
   *
   * Numeric code: '5966'
   */
  DIRECT_MARKETING_OUTBOUND_TELEMARKETING = "DIRECT_MARKETING_OUTBOUND_TELEMARKETING",
  /**
   * The category for Direct Marketing - Subscription.
   *
   * Numeric code: '5968'
   */
  DIRECT_MARKETING_SUBSCRIPTION = "DIRECT_MARKETING_SUBSCRIPTION",
  /**
   * The category for Direct Marketing - Travel.
   *
   * Numeric code: '5962'
   */
  DIRECT_MARKETING_TRAVEL = "DIRECT_MARKETING_TRAVEL",
  /**
   * The category for Discount Stores.
   *
   * Numeric code: '5310'
   */
  DISCOUNT_STORES = "DISCOUNT_STORES",
  /**
   * The category for Disneyland Resorts
   *
   * Numeric Code: '3780'
   */
  DISNEYLAND_RESORTS = "DISNEYLAND_RESORTS",
  /**
   * The category for Doctors.
   *
   * Numeric code: '8011'
   */
  DOCTORS = "DOCTORS",
  /**
   * The category for Dollar Rent A Car
   *
   * Numeric Code: '3390'
   */
  DOLLAR_RENT_A_CAR = "DOLLAR_RENT_A_CAR",
  /**
   * The category for Dominicana De Aviacion
   *
   * Numeric Code: '3212'
   */
  DOMINICA_AIR = "DOMINICA_AIR",
  /**
   * The category for Door-To-Door Sales.
   *
   * Numeric code: '5963'
   */
  DOOR_TO_DOOR_SALES = "DOOR_TO_DOOR_SALES",
  /**
   * The category for Doral Golf Resort
   *
   * Numeric Code: '3589'
   */
  DORAL_GOLF_RESORT = "DORAL_GOLF_RESORT",
  /**
   * The category for Doral Hotels
   *
   * Numeric Code: '3587'
   */
  DORAL_HOTELS = "DORAL_HOTELS",
  /**
   * The category for Dorint Hotels
   *
   * Numeric Code: '3623'
   */
  DORINT_HOTELS = "DORINT_HOTELS",
  /**
   * The category for Doubletree
   *
   * Numeric Code: '3692'
   */
  DOUBLETREE = "DOUBLETREE",
  /**
   * The category for Downtowner Passport
   *
   * Numeric Code: '3527'
   */
  DOWNTOWNER_PASSPORT = "DOWNTOWNER_PASSPORT",
  /**
   * The category for "Drapery, Window Covering, and Upholstery Stores".
   *
   * Numeric code: '5714'
   */
  DRAPERY_WINDOW_COVERING_AND_UPHOLSTERY_STORES = "DRAPERY_WINDOW_COVERING_AND_UPHOLSTERY_STORES",
  /**
   * The category for Drinking Places.
   *
   * Numeric code: '5813'
   */
  DRINKING_PLACES = "DRINKING_PLACES",
  /**
   * The category for "Drugs, Drug Proprietaries, and Druggist Sundries".
   *
   * Numeric code: '5122'
   */
  DRUGS_DRUG_PROPRIETARIES_AND_DRUGGIST_SUNDRIES = "DRUGS_DRUG_PROPRIETARIES_AND_DRUGGIST_SUNDRIES",
  /**
   * The category for Drug Stores and Pharmacies.
   *
   * Numeric code: '5912'
   */
  DRUG_STORES_AND_PHARMACIES = "DRUG_STORES_AND_PHARMACIES",
  /**
   * The category for Drury Inn
   *
   * Numeric Code: '3693'
   */
  DRURY_INN = "DRURY_INN",
  /**
   * The category for Dry Cleaners.
   *
   * Numeric code: '7216'
   */
  DRY_CLEANERS = "DRY_CLEANERS",
  /**
   * The category for Dunfey Hotels
   *
   * Numeric Code: '3525'
   */
  DUNFEY_HOTELS = "DUNFEY_HOTELS",
  /**
   * The category for Durable Goods (Not Elsewhere Classified).
   *
   * Numeric code: '5099'
   */
  DURABLE_GOODS = "DURABLE_GOODS",
  /**
   * The category for Duty Free Stores.
   *
   * Numeric code: '5309'
   */
  DUTY_FREE_STORES = "DUTY_FREE_STORES",
  /**
   * The category for Easyjet Air
   *
   * Numeric Code: '3245'
   */
  EASYJET_AIR = "EASYJET_AIR",
  /**
   * The category for "Eating Places, Restaurants".
   *
   * Numeric code: '5812'
   */
  EATING_PLACES_RESTAURANTS = "EATING_PLACES_RESTAURANTS",
  /**
   * The category for Economy Inns Of America
   *
   * Numeric Code: '3694'
   */
  ECONOMY_INNS_OF_AMERICA = "ECONOMY_INNS_OF_AMERICA",
  /**
   * The category for Econo Car Rent A Car
   *
   * Numeric Code: '3398'
   */
  ECONO_CAR_RENT_A_CAR = "ECONO_CAR_RENT_A_CAR",
  /**
   * The category for Econo Travel Motor Hotel
   *
   * Numeric Code: '3644'
   */
  ECONO_TRAVEL_MOTOR_HOTEL = "ECONO_TRAVEL_MOTOR_HOTEL",
  /**
   * The category for Ecuatoriana
   *
   * Numeric Code: '3293'
   */
  ECUATORIANA = "ECUATORIANA",
  /**
   * The category for Edition
   *
   * Numeric code: '3848'
   */
  EDITION = "EDITION",
  /**
   * The category for Educational Services.
   *
   * Numeric code: '8299'
   */
  EDUCATIONAL_SERVICES = "EDUCATIONAL_SERVICES",
  /**
   * The category for Egyptair
   *
   * Numeric Code: '3037'
   */
  EGYPT_AIR = "EGYPT_AIR",
  /**
   * The category for Eldorado Hotel And Casino
   *
   * Numeric Code: '3669'
   */
  ELDORADO_HOTEL_AND_CASINO = "ELDORADO_HOTEL_AND_CASINO",
  /**
   * The category for Electrical Parts and Equipment.
   *
   * Numeric code: '5065'
   */
  ELECTRICAL_PARTS_AND_EQUIPMENT = "ELECTRICAL_PARTS_AND_EQUIPMENT",
  /**
   * The category for Electrical Services.
   *
   * Numeric code: '1731'
   */
  ELECTRICAL_SERVICES = "ELECTRICAL_SERVICES",
  /**
   * The category for Electric Razor Stores.
   *
   * Numeric code: '5997'
   */
  ELECTRIC_RAZOR_STORES = "ELECTRIC_RAZOR_STORES",
  /**
   * The category for Electric Vehicle Charging.
   *
   * Numeric code: '5552'
   */
  ELECTRIC_VEHICLE_CHARGING = "ELECTRIC_VEHICLE_CHARGING",
  /**
   * The category for Electronics Repair Shops.
   *
   * Numeric code: '7622'
   */
  ELECTRONICS_REPAIR_SHOPS = "ELECTRONICS_REPAIR_SHOPS",
  /**
   * The category for Electronics Stores.
   *
   * Numeric code: '5732'
   */
  ELECTRONICS_STORES = "ELECTRONICS_STORES",
  /**
   * The category for Element
   *
   * Numeric Code: '3807'
   */
  ELEMENT = "ELEMENT",
  /**
   * The category for "Elementary, Secondary Schools".
   *
   * Numeric code: '8211'
   */
  ELEMENTARY_SECONDARY_SCHOOLS = "ELEMENTARY_SECONDARY_SCHOOLS",
  /**
   * The category for El Al Airlines
   *
   * Numeric Code: '3032'
   */
  EL_AL_AIRLINES = "EL_AL_AIRLINES",
  /**
   * The category for Embassy Hotels
   *
   * Numeric Code: '3652'
   */
  EMBASSY_HOTELS = "EMBASSY_HOTELS",
  /**
   * The category for Embassy Suites
   *
   * Numeric Code: '3695'
   */
  EMBASSY_SUITES = "EMBASSY_SUITES",
  /**
   * The category for Embassy Vacation Resort
   *
   * Numeric Code: '3798'
   */
  EMBASSY_VACATION_RESORT = "EMBASSY_VACATION_RESORT",
  /**
   * The category for Emirates
   *
   * Numeric Code: '3026'
   */
  EMIRATES = "EMIRATES",
  /**
   * The category for Employment/Temp Agencies.
   *
   * Numeric code: '7361'
   */
  EMPLOYMENT_TEMP_AGENCIES = "EMPLOYMENT_TEMP_AGENCIES",
  /**
   * The category for Enterprise Rent A Car
   *
   * Numeric Code: '3405'
   */
  ENTERPRISE_RENT_A_CAR = "ENTERPRISE_RENT_A_CAR",
  /**
   * The category for Equipment Rental.
   *
   * Numeric code: '7394'
   */
  EQUIPMENT_RENTAL = "EQUIPMENT_RENTAL",
  /**
   * The category for Ethiopian Airlines
   *
   * Numeric Code: '3294'
   */
  ETHIOPIAN_AIRLINES = "ETHIOPIAN_AIRLINES",
  /**
   * The category for Etihad Air
   *
   * Numeric Code: '3034'
   */
  ETIHAD_AIR = "ETIHAD_AIR",
  /**
   * The category for Europcar
   *
   * Numeric Code: '3381'
   */
  EUROPCAR = "EUROPCAR",
  /**
   * The category for Europe By Car
   *
   * Numeric Code: '3391'
   */
  EUROPE_BY_CAR = "EUROPE_BY_CAR",
  /**
   * The category for Eva Airways
   *
   * Numeric Code: '3084'
   */
  EVA_AIRWAYS = "EVA_AIRWAYS",
  /**
   * The category for Excalibur Hotel And Casino
   *
   * Numeric Code: '3628'
   */
  EXCALIBUR_HOTEL_AND_CASINO = "EXCALIBUR_HOTEL_AND_CASINO",
  /**
   * The category for Excel Inn
   *
   * Numeric Code: '3696'
   */
  EXCEL_INN = "EXCEL_INN",
  /**
   * The category for Extended Stay
   *
   * Numeric Code: '3621'
   */
  EXTENDED_STAY = "EXTENDED_STAY",
  /**
   * The category for Extended Stay America
   *
   * Numeric Code: '3627'
   */
  EXTENDED_STAY_AMERICA = "EXTENDED_STAY_AMERICA",
  /**
   * The category for Extended Stay Deluxe
   *
   * Numeric Code: '3630'
   */
  EXTENDED_STAY_DELUXE = "EXTENDED_STAY_DELUXE",
  /**
   * The category for Exterminating Services.
   *
   * Numeric code: '7342'
   */
  EXTERMINATING_SERVICES = "EXTERMINATING_SERVICES",
  /**
   * The category for Fairfield Hotel
   *
   * Numeric Code: '3697'
   */
  FAIRFIELD_HOTEL = "FAIRFIELD_HOTEL",
  /**
   * The category for Fairfield Inn
   *
   * Numeric Code: '3715'
   */
  FAIRFIELD_INN = "FAIRFIELD_INN",
  /**
   * The category for Fairmont Hotels Corporation
   *
   * Numeric Code: '3590'
   */
  FAIRMONT_HOTELS_CORPORATION = "FAIRMONT_HOTELS_CORPORATION",
  /**
   * The category for Family Clothing Stores.
   *
   * Numeric code: '5651'
   */
  FAMILY_CLOTHING_STORES = "FAMILY_CLOTHING_STORES",
  /**
   * The category for "Food Served in a Hospital, Hotel, Cruise Ship, or Similar Location".
   *
   * Numeric code: '2002'
   */
  FAST_FOOD = "FAST_FOOD",
  /**
   * The category for Fast Food Restaurants.
   *
   * Numeric code: '5814'
   */
  FAST_FOOD_RESTAURANTS = "FAST_FOOD_RESTAURANTS",
  /**
   * The category for Financial Institutions.
   *
   * Numeric code: '6012'
   */
  FINANCIAL_INSTITUTIONS = "FINANCIAL_INSTITUTIONS",
  /**
   * The category for Fines - Government Administrative Entities.
   *
   * Numeric code: '9222'
   */
  FINES_GOVERNMENT_ADMINISTRATIVE_ENTITIES = "FINES_GOVERNMENT_ADMINISTRATIVE_ENTITIES",
  /**
   * The category for Finnair
   *
   * Numeric Code: '3042'
   */
  FINNAIR = "FINNAIR",
  /**
   * The category for "Fireplace, Fireplace Screens, and Accessories Stores".
   *
   * Numeric code: '5718'
   */
  FIREPLACE_FIREPLACE_SCREENS_AND_ACCESSORIES_STORES = "FIREPLACE_FIREPLACE_SCREENS_AND_ACCESSORIES_STORES",
  /**
   * The category for First Hospitality Hotels
   *
   * Numeric Code: '3784'
   */
  FIRST_HOSPITALITY_HOTELS = "FIRST_HOSPITALITY_HOTELS",
  /**
   * The category for Flag Inns
   *
   * Numeric Code: '3664'
   */
  FLAG_INNS = "FLAG_INNS",
  /**
   * The category for Flag Inns Australia
   *
   * Numeric Code: '3711'
   */
  FLAG_INNS_AUSTRALIA = "FLAG_INNS_AUSTRALIA",
  /**
   * The category for Floor Covering Stores.
   *
   * Numeric code: '5713'
   */
  FLOOR_COVERING_STORES = "FLOOR_COVERING_STORES",
  /**
   * The category for Florists.
   *
   * Numeric code: '5992'
   */
  FLORISTS = "FLORISTS",
  /**
   * The category for "Florists Supplies, Nursery Stock, and Flowers".
   *
   * Numeric code: '5193'
   */
  FLORISTS_SUPPLIES_NURSERY_STOCK_AND_FLOWERS = "FLORISTS_SUPPLIES_NURSERY_STOCK_AND_FLOWERS",
  /**
   * The category for Flybe
   *
   * Numeric Code: '3302'
   */
  FLYBE = "FLYBE",
  /**
   * The category for Fontainebleau Resort
   *
   * Numeric Code: '3607'
   */
  FONTAINEBLEAU_RESORT = "FONTAINEBLEAU_RESORT",
  /**
   * The category for Four Points Hotels
   *
   * Numeric Code: '3778'
   */
  FOUR_POINTS_HOTELS = "FOUR_POINTS_HOTELS",
  /**
   * The category for Four Seasons
   *
   * Numeric Code: '3543'
   */
  FOUR_SEASONS = "FOUR_SEASONS",
  /**
   * The category for Four Seasons Australia
   *
   * Numeric Code: '3714'
   */
  FOUR_SEASONS_AUSTRALIA = "FOUR_SEASONS_AUSTRALIA",
  /**
   * The category for Frankenmuth Bavarian
   *
   * Numeric Code: '3578'
   */
  FRANKENMUTH_BAVARIAN = "FRANKENMUTH_BAVARIAN",
  /**
   * The category for Freedom Airlines
   *
   * Numeric Code: '3204'
   */
  FREEDOM_AIRLINES = "FREEDOM_AIRLINES",
  /**
   * The category for Freezer and Locker Meat Provisioners.
   *
   * Numeric code: '5422'
   */
  FREEZER_AND_LOCKER_MEAT_PROVISIONERS = "FREEZER_AND_LOCKER_MEAT_PROVISIONERS",
  /**
   * The category for Fremont Hotel And Casino
   *
   * Numeric Code: '3766'
   */
  FREMONT_HOTEL_AND_CASINO = "FREMONT_HOTEL_AND_CASINO",
  /**
   * The category for Friendship Inns International
   *
   * Numeric Code: '3507'
   */
  FRIENDSHIP_INNS_INTERNATIONAL = "FRIENDSHIP_INNS_INTERNATIONAL",
  /**
   * The category for Frontier Airlines
   *
   * Numeric Code: '3132'
   */
  FRONTIER_AIRLINES = "FRONTIER_AIRLINES",
  /**
   * The category for Fuel Dealers (Non Automotive).
   *
   * Numeric code: '5983'
   */
  FUEL_DEALERS_NON_AUTOMOTIVE = "FUEL_DEALERS_NON_AUTOMOTIVE",
  /**
   * The category for Fufu Japan
   *
   * Numeric code: '3875'
   */
  FUFU_JAPAN = "FUFU_JAPAN",
  /**
   * The category for Funding Transactions excluding MoneySend.
   *
   * Numeric code: '6539'
   */
  FUNDING_TRANSACTION = "FUNDING_TRANSACTION",
  /**
   * The category for "Funeral Services, Crematories".
   *
   * Numeric code: '7261'
   */
  FUNERAL_SERVICES_CREMATORIES = "FUNERAL_SERVICES_CREMATORIES",
  /**
   * The category for "Furniture, Home Furnishings, and Equipment Stores, Except Appliances".
   *
   * Numeric code: '5712'
   */
  FURNITURE_HOME_FURNISHINGS_AND_EQUIPMENT_STORES_EXCEPT_APPLIANCES = "FURNITURE_HOME_FURNISHINGS_AND_EQUIPMENT_STORES_EXCEPT_APPLIANCES",
  /**
   * The category for "Furniture Repair, Refinishing".
   *
   * Numeric code: '7641'
   */
  FURNITURE_REPAIR_REFINISHING = "FURNITURE_REPAIR_REFINISHING",
  /**
   * The category for Furriers and Fur Shops.
   *
   * Numeric code: '5681'
   */
  FURRIERS_AND_FUR_SHOPS = "FURRIERS_AND_FUR_SHOPS",
  /**
   * The category for Galt House
   *
   * Numeric Code: '3827'
   */
  GALT_HOUSE = "GALT_HOUSE",
  /**
   * The category for Garden Place Hotel
   *
   * Numeric Code: '3566'
   */
  GARDEN_PLACE_HOTEL = "GARDEN_PLACE_HOTEL",
  /**
   * The category for Garuda
   *
   * Numeric Code: '3103'
   */
  GARUDA = "GARUDA",
  /**
   * The category for Gaylord Opryland
   *
   * Numeric Code: '3608'
   */
  GAYLORD_OPRYLAND = "GAYLORD_OPRYLAND",
  /**
   * The category for Gaylord Palms
   *
   * Numeric Code: '3609'
   */
  GAYLORD_PALMS = "GAYLORD_PALMS",
  /**
   * The category for Gaylord Texan
   *
   * Numeric Code: '3610'
   */
  GAYLORD_TEXAN = "GAYLORD_TEXAN",
  /**
   * The category for General Rent A Car
   *
   * Numeric Code: '3409'
   */
  GENERAL_RENT_A_CAR = "GENERAL_RENT_A_CAR",
  /**
   * The category for General Services.
   *
   * Numeric code: '1520'
   */
  GENERAL_SERVICES = "GENERAL_SERVICES",
  /**
   * The category for "Gift, Card, Novelty, and Souvenir Shops".
   *
   * Numeric code: '5947'
   */
  GIFT_CARD_NOVELTY_AND_SOUVENIR_SHOPS = "GIFT_CARD_NOVELTY_AND_SOUVENIR_SHOPS",
  /**
   * The category for "Glassware, Crystal Stores".
   *
   * Numeric code: '5950'
   */
  GLASSWARE_CRYSTAL_STORES = "GLASSWARE_CRYSTAL_STORES",
  /**
   * The category for "Glass, Paint, and Wallpaper Stores".
   *
   * Numeric code: '5231'
   */
  GLASS_PAINT_AND_WALLPAPER_STORES = "GLASS_PAINT_AND_WALLPAPER_STORES",
  /**
   * The category for Godfrey National
   *
   * Numeric Code: '3414'
   */
  GODFREY_NATIONAL = "GODFREY_NATIONAL",
  /**
   * The category for GOFLY
   *
   * Numeric Code: '3156'
   */
  GOFLY = "GOFLY",
  /**
   * The category for Golden Nugget
   *
   * Numeric Code: '3561'
   */
  GOLDEN_NUGGET = "GOLDEN_NUGGET",
  /**
   * The category for Golden Pacific Air
   *
   * Numeric Code: '3203'
   */
  GOLDEN_PACIFIC_AIR = "GOLDEN_PACIFIC_AIR",
  /**
   * The category for Golden Tulip
   *
   * Numeric Code: '3506'
   */
  GOLDEN_TULIP = "GOLDEN_TULIP",
  /**
   * The category for Golf Courses - Public.
   *
   * Numeric code: '7992'
   */
  GOLF_COURSES_PUBLIC = "GOLF_COURSES_PUBLIC",
  /**
   * The category for Gol Airlines
   *
   * Numeric Code: '3247'
   */
  GOL_AIRLINES = "GOL_AIRLINES",
  /**
   * The category for Government Licensed On-Line Casinos
   *
   * Numeric Code: '7802'
   */
  GOVERNMENT_LICENSED_HORSE_OR_DOG_RACING = "GOVERNMENT_LICENSED_HORSE_OR_DOG_RACING",
  /**
   * The category for Government Licensed On-Line Casinos
   *
   * Numeric Code: '7801'
   */
  GOVERNMENT_LICENSED_ON_LINE_CASINO = "GOVERNMENT_LICENSED_ON_LINE_CASINO",
  /**
   * The category for Government Owned Lotteries
   *
   * Numeric Code: '7800'
   */
  GOVERNMENT_OWNED_LOTTERY = "GOVERNMENT_OWNED_LOTTERY",
  /**
   * The category for "Government Owned Lottery (Global, Excluding U.S. Region)"
   *
   * Numeric code: '9406'
   */
  GOVERNMENT_OWNED_LOTTERY_GLOBAL = "GOVERNMENT_OWNED_LOTTERY_GLOBAL",
  /**
   * The category for Government Services (Not Elsewhere Classified).
   *
   * Numeric code: '9399'
   */
  GOVERNMENT_SERVICES = "GOVERNMENT_SERVICES",
  /**
   * The category for Granbell Hotels and Resorts
   *
   * Numeric code: '3853'
   */
  GRANBELL_HOTELS_AND_RESORT = "GRANBELL_HOTELS_AND_RESORT",
  /**
   * The category for Grand Casino Hotels
   *
   * Numeric Code: '3794'
   */
  GRAND_CASINO_HOTELS = "GRAND_CASINO_HOTELS",
  /**
   * The category for Grand Met Forum Hotels
   *
   * Numeric Code: '3570'
   */
  GRAND_MET_FORUM_HOTELS = "GRAND_MET_FORUM_HOTELS",
  /**
   * The category for Grand Sierra Resort
   *
   * Numeric Code: '3823'
   */
  GRAND_SIERRA_RESORT = "GRAND_SIERRA_RESORT",
  /**
   * The category for Grand Wailea Resort
   *
   * Numeric Code: '3571'
   */
  GRAND_WAILEA_RESORT = "GRAND_WAILEA_RESORT",
  /**
   * The category for Great Wolf
   *
   * Numeric Code: '3618'
   */
  GREAT_WOLF = "GREAT_WOLF",
  /**
   * The category for Greenbriar Resorts
   *
   * Numeric Code: '3753'
   */
  GREENBRIAR_RESORTS = "GREENBRIAR_RESORTS",
  /**
   * The category for "Grocery Stores, Supermarkets".
   *
   * Numeric code: '5411'
   */
  GROCERY_STORES_SUPERMARKETS = "GROCERY_STORES_SUPERMARKETS",
  /**
   * The category for Grupo Hotels Husa Sa
   *
   * Numeric Code: '3647'
   */
  GRUPO_HOTELS_HUSA_SA = "GRUPO_HOTELS_HUSA_SA",
  /**
   * The category for Gulf Air (Bahrain)
   *
   * Numeric Code: '3040'
   */
  GULF_AIR = "GULF_AIR",
  /**
   * The category for guns and ammunition
   *
   * Numeric code: 5723
   */
  GUNS_AMMO = "GUNS_AMMO",
  /**
   * The category for Guyana Airways
   *
   * Numeric Code: '3200'
   */
  GUYANA_AIRWAYS = "GUYANA_AIRWAYS",
  /**
   * The category for Hainan Airlines
   *
   * Numeric code: ‘3168’
   */
  HAINAN_AIRLINES = "HAINAN_AIRLINES",
  /**
   * The category for Halekulani Hotel Waikiki Parc
   *
   * Numeric Code: '3760'
   */
  HALEKULANI_HOTEL_WAIKIKI_PARC = "HALEKULANI_HOTEL_WAIKIKI_PARC",
  /**
   * The category for Hale Koa Hotel
   *
   * Numeric Code: '3799'
   */
  HALE_KOA_HOTEL = "HALE_KOA_HOTEL",
  /**
   * The category for Hampton Inns
   *
   * Numeric Code: '3665'
   */
  HAMPTON_INNS = "HAMPTON_INNS",
  /**
   * The category for "Hardware, Equipment, and Supplies".
   *
   * Numeric code: '5072'
   */
  HARDWARE_EQUIPMENT_AND_SUPPLIES = "HARDWARE_EQUIPMENT_AND_SUPPLIES",
  /**
   * The category for Hardware Stores.
   *
   * Numeric code: '5251'
   */
  HARDWARE_STORES = "HARDWARE_STORES",
  /**
   * The category for Harley Hotel
   *
   * Numeric Code: '3698'
   */
  HARLEY_HOTEL = "HARLEY_HOTEL",
  /**
   * The category for Harrahs Hotels And Casinos
   *
   * Numeric Code: '3731'
   */
  HARRAHS_HOTELS_AND_CASINOS = "HARRAHS_HOTELS_AND_CASINOS",
  /**
   * The category for Harvey Bristol Hotels
   *
   * Numeric Code: '3734'
   */
  HARVEY_BRISTOL_HOTELS = "HARVEY_BRISTOL_HOTELS",
  /**
   * The category for Havasu Airlines
   *
   * Numeric Code: '3197'
   */
  HAVASU_AIRLINES = "HAVASU_AIRLINES",
  /**
   * The category for Hawaiian Air
   *
   * Numeric Code: '3196'
   */
  HAWAIIAN_AIR = "HAWAIIAN_AIR",
  /**
   * The category for Health and Beauty Spas.
   *
   * Numeric code: '7298'
   */
  HEALTH_AND_BEAUTY_SPAS = "HEALTH_AND_BEAUTY_SPAS",
  /**
   * The category for Hearing Aids Sales and Supplies.
   *
   * Numeric code: '5975'
   */
  HEARING_AIDS_SALES_AND_SUPPLIES = "HEARING_AIDS_SALES_AND_SUPPLIES",
  /**
   * The category for "Heating, Plumbing, A/C".
   *
   * Numeric code: '1711'
   */
  HEATING_PLUMBING_A_C = "HEATING_PLUMBING_A_C",
  /**
   * The category for Helmsley Hotels
   *
   * Numeric Code: '3588'
   */
  HELMSLEY_HOTELS = "HELMSLEY_HOTELS",
  /**
   * The category for Hermitage Hotels
   *
   * Numeric Code: '3616'
   */
  HERMITAGE_HOTELS = "HERMITAGE_HOTELS",
  /**
   * The category for Hertz
   *
   * Numeric Code: '3357'
   */
  HERTZ = "HERTZ",
  /**
   * The category for Hilton
   *
   * Numeric Code: '3504'
   */
  HILTON = "HILTON",
  /**
   * The category for Hilton Garden Inn
   *
   * Numeric Code: '3604'
   */
  HILTON_GARDEN_INN = "HILTON_GARDEN_INN",
  /**
   * The category for Hilton International
   *
   * Numeric Code: '3535'
   */
  HILTON_INTERNATIONAL = "HILTON_INTERNATIONAL",
  /**
   * The category for Hapag-Lloyd Express
   *
   * Numeric Code: '3062'
   */
  HLX_AIR = "HLX_AIR",
  /**
   * The category for HMI Hotel Group
   *
   * Numeric code: '3876'
   */
  HMI_HOTEL_GROUP = "HMI_HOTEL_GROUP",
  /**
   * The category for "Hobby, Toy, and Game Shops".
   *
   * Numeric code: '5945'
   */
  HOBBY_TOY_AND_GAME_SHOPS = "HOBBY_TOY_AND_GAME_SHOPS",
  /**
   * The category for Holiday Inns
   *
   * Numeric Code: '3501'
   */
  HOLIDAY_INNS = "HOLIDAY_INNS",
  /**
   * The category for Holiday Rent A Car
   *
   * Numeric Code: '3368'
   */
  HOLIDAY_RENT_A_CAR = "HOLIDAY_RENT_A_CAR",
  /**
   * The category for Home2Suites
   *
   * Numeric Code: '3816'
   */
  HOME2SUITES = "HOME2SUITES",
  /**
   * The category for Homestead
   *
   * Numeric Code: '3755'
   */
  HOMESTEAD = "HOMESTEAD",
  /**
   * The category for Homestead Suites
   *
   * Numeric Code: '3800'
   */
  HOMESTEAD_SUITES = "HOMESTEAD_SUITES",
  /**
   * The category for Homewood Suites
   *
   * Numeric Code: '3751'
   */
  HOMEWOOD_SUITES = "HOMEWOOD_SUITES",
  /**
   * The category for Home2Suites
   *
   * Numeric Code: '3816'
   */
  HOME_2_SUITES = "HOME_2_SUITES",
  /**
   * The category for Home Supply Warehouse Stores.
   *
   * Numeric code: '5200'
   */
  HOME_SUPPLY_WAREHOUSE_STORES = "HOME_SUPPLY_WAREHOUSE_STORES",
  /**
   * The category for Hospitality Inns
   *
   * Numeric Code: '3595'
   */
  HOSPITALITY_INNS = "HOSPITALITY_INNS",
  /**
   * The category for Hospitals.
   *
   * Numeric code: '8062'
   */
  HOSPITALS = "HOSPITALS",
  /**
   * The category for Hoteis Othan
   *
   * Numeric Code: '3680'
   */
  HOTEIS_OTHAN = "HOTEIS_OTHAN",
  /**
   * The category for Hoteles El Presidente
   *
   * Numeric Code: '3663'
   */
  HOTELES_EL_PRESIDENTE = "HOTELES_EL_PRESIDENTE",
  /**
   * The category for Hotels Melia
   *
   * Numeric Code: '3548'
   */
  HOTELS_MELIA = "HOTELS_MELIA",
  /**
   * The category for "Hotels, Motels, and Resorts".
   *
   * Numeric codes: ['3501','3502','3503','3504','3505','3506','3507','3508','3509','3510','3511','3512','3513','3514','3515','3516','3517','3518','3519','3520','3521','3522','3523','3524','3525','3526','3527','3528','3529','3530','3531','3532','3533','3534','3535','3536','3537','3538','3539','3540','3541','3542','3543','3544','3545','3546','3547','3548','3549','3550','3551','3552','3553','3554','3555','3556','3557','3558','3559','3560','3561','3562','3563','3564','3565','3566','3567','3568','3569','3570','3571','3572','3573','3574','3575','3576','3577','3578','3579','3580','3581','3582','3583','3584','3585','3586','3587','3588','3589','3590','3591','3592','3593','3594','3595','3596','3597','3598','3599','3600','3601','3602','3603','3604','3605','3606','3607','3608','3609','3610','3611','3612','3613','3614','3615','3616','3617','3618','3619','3620','3621','3622','3623','3624','3625','3626','3627','3628','3629','3630','3631','3632','3633','3634','3635','3636','3637','3638','3639','3640','3641','3642','3643','3644','3645','3646','3647','3648','3649','3650','3651','3652','3653','3654','3655','3656','3657','3658','3659','3660','3661','3662','3663','3664','3665','3666','3667','3668','3669','3670','3671','3672','3673','3674','3675','3676','3677','3678','3679','3680','3681','3682','3683','3684','3685','3686','3687','3688','3689','3690','3691','3692','3693','3694','3695','3696','3697','3698','3699','3700','3701','3702','3703','3704','3705','3706','3707','3708','3709','3710','3711','3712','3713','3714','3715','3716','3717','3718','3719','3720','3721','3722','3723','3724','3725','3726','3727','3728','3729','3730','3731','3732','3733','3734','3735','3736','3737','3738','3739','3740','3741','3742','3743','3744','3745','3746','3747','3748','3749','3750','3751','3752','3753','3754','3755','3756','3757','3758','3759','3760','3761','3762','3763','3764','3765','3766','3767','3768','3769','3770','3771','3772','3773','3774','3775','3776','3777','3778','3779','3780','3781','3782','3783','3784','3785','3786','3787','3788','3789','3790','7011']
   */
  HOTELS_MOTELS_AND_RESORTS = "HOTELS_MOTELS_AND_RESORTS",
  /**
   * The category for Hotel Alpha-1
   *
   * Numeric code: '3867'
   */
  HOTEL_ALPHA_1 = "HOTEL_ALPHA_1",
  /**
   * The category for Hotel Del Coronado
   *
   * Numeric Code: '3580'
   */
  HOTEL_DEL_CORONADO = "HOTEL_DEL_CORONADO",
  /**
   * The category for Hotel Indigo
   *
   * Numeric Code: '3813'
   */
  HOTEL_INDIGO = "HOTEL_INDIGO",
  /**
   * The category for Hotel Livemax
   *
   * Numeric code: '3874'
   */
  HOTEL_LIVEMAX = "HOTEL_LIVEMAX",
  /**
   * The category for Hotel Mercure
   *
   * Numeric Code: '3579'
   */
  HOTEL_MERCURE = "HOTEL_MERCURE",
  /**
   * The category for Hotel Metropolitan
   *
   * Numeric code: '3881'
   */
  HOTEL_METROPOLITAN = "HOTEL_METROPOLITAN",
  /**
   * The category for Hotel Okura
   *
   * Numeric Code: '3541'
   */
  HOTEL_OKURA = "HOTEL_OKURA",
  /**
   * The category for Hotel Sierra
   *
   * Numeric Code: '3546'
   */
  HOTEL_SIERRA = "HOTEL_SIERRA",
  /**
   * The category for Hotel Sunroute
   *
   * Numeric code: '3857'
   */
  HOTEL_SUNROUTE = "HOTEL_SUNROUTE",
  /**
   * The category for Hotel Universal
   *
   * Numeric Code: '3625'
   */
  HOTEL_UNIVERSAL = "HOTEL_UNIVERSAL",
  /**
   * The category for Hotel Unizo
   *
   * Numeric code: '3880'
   */
  HOTEL_UNIZO = "HOTEL_UNIZO",
  /**
   * The category for Household Appliance Stores.
   *
   * Numeric code: '5722'
   */
  HOUSEHOLD_APPLIANCE_STORES = "HOUSEHOLD_APPLIANCE_STORES",
  /**
   * The category for Howard Johnson
   *
   * Numeric Code: '3638'
   */
  HOWARD_JOHNSON = "HOWARD_JOHNSON",
  /**
   * The category for Hudson Hotel
   *
   * Numeric Code: '3602'
   */
  HUDSON_HOTEL = "HUDSON_HOTEL",
  /**
   * The category for Hungar Hotels
   *
   * Numeric Code: '3585'
   */
  HUNGAR_HOTELS = "HUNGAR_HOTELS",
  /**
   * The category for Hyatt Hotels/International
   *
   * Numeric Code: '3640'
   */
  HYATT_HOTELS_INTERNATIONAL = "HYATT_HOTELS_INTERNATIONAL",
  /**
   * The category for Hyatt Place
   *
   * Numeric Code: '3812'
   */
  HYATT_PLACE = "HYATT_PLACE",
  /**
   * The category for Iberia
   *
   * Numeric Code: '3102'
   */
  IBERIA = "IBERIA",
  /**
   * The category for Iberotel
   *
   * Numeric Code: '3540'
   */
  IBEROTEL = "IBEROTEL",
  /**
   * The category for Ibusz Hotels
   *
   * Numeric Code: '3673'
   */
  IBUSZ_HOTELS = "IBUSZ_HOTELS",
  /**
   * The category for Icelandair
   *
   * Numeric Code: '3050'
   */
  ICELAND_AIR = "ICELAND_AIR",
  /**
   * The category for Imperial London Hotels
   *
   * Numeric Code: '3651'
   */
  IMPERIAL_LONDON_HOTELS = "IMPERIAL_LONDON_HOTELS",
  /**
   * The category for Indian Airlines
   *
   * Numeric Code: '3193'
   */
  INDIAN_AIRLINES = "INDIAN_AIRLINES",
  /**
   * The category for Industrial Supplies (Not Elsewhere Classified).
   *
   * Numeric code: '5085'
   */
  INDUSTRIAL_SUPPLIES = "INDUSTRIAL_SUPPLIES",
  /**
   * The category for Information Retrieval Services.
   *
   * Numeric code: '7375'
   */
  INFORMATION_RETRIEVAL_SERVICES = "INFORMATION_RETRIEVAL_SERVICES",
  /**
   * The category for Insurance Agents, Brokers & Service
   *
   * Numeric code: '6411'
   */
  INSURANCE_AGENTS_BROKERS_SERVICE = "INSURANCE_AGENTS_BROKERS_SERVICE",
  /**
   * The category for Insurance - Default.
   *
   * Numeric code: '6399'
   */
  INSURANCE_DEFAULT = "INSURANCE_DEFAULT",
  /**
   * The category for Insurance Premiums
   *
   * Numeric Code: '6381'
   */
  INSURANCE_PREMIUMS = "INSURANCE_PREMIUMS",
  /**
   * The category for Insurance Rent A Car
   *
   * Numeric Code: '3429'
   */
  INSURANCE_RENT_A_CAR = "INSURANCE_RENT_A_CAR",
  /**
   * The category for "Insurance Underwriting, Premiums".
   *
   * Numeric code: '6300'
   */
  INSURANCE_UNDERWRITING_PREMIUMS = "INSURANCE_UNDERWRITING_PREMIUMS",
  /**
   * The category for Intercontinental
   *
   * Numeric Code: '3512'
   */
  INTERCONTINENTAL = "INTERCONTINENTAL",
  /**
   * The category for Interent
   *
   * Numeric Code: '3438'
   */
  INTERENT = "INTERENT",
  /**
   * The category for Interhotel Cedok
   *
   * Numeric Code: '3675'
   */
  INTERHOTEL_CEDOK = "INTERHOTEL_CEDOK",
  /**
   * The category for Inter Nor Hotels
   *
   * Numeric Code: '3724'
   */
  INTER_NOR_HOTELS = "INTER_NOR_HOTELS",
  /**
   * The category for Intra-Company Purchases.
   *
   * Numeric code: '9950'
   */
  INTRA_COMPANY_PURCHASES = "INTRA_COMPANY_PURCHASES",
  /**
   * The category for Island Airlines
   *
   * Numeric Code: '3191'
   */
  ISLAND_AIRLINES = "ISLAND_AIRLINES",
  /**
   * The category for Itoen Hotel
   *
   * Numeric code: '3864'
   */
  ITOEN_HOTEL = "ITOEN_HOTEL",
  /**
   * The category for Japan Airlines
   *
   * Numeric Code: '3006'
   */
  JAPAN_AIRLINES = "JAPAN_AIRLINES",
  /**
   * The category for Jefferson Hotel
   *
   * Numeric Code: '3606'
   */
  JEFFERSON_HOTEL = "JEFFERSON_HOTEL",
  /**
   * The category for Jetblue Airways
   *
   * Numeric Code: '3174'
   */
  JETBLUE_AIRWAYS = "JETBLUE_AIRWAYS",
  /**
   * The category for Jetstar Airways
   *
   * Numeric Code: '3079'
   */
  JETSTAR_AIRWAYS = "JETSTAR_AIRWAYS",
  /**
   * The category for Jet Airways
   *
   * Numeric Code: '3056'
   */
  JET_AIRWAYS = "JET_AIRWAYS",
  /**
   * The category for "Jewelry Stores, Watches, Clocks, and Silverware Stores".
   *
   * Numeric code: '5944'
   */
  JEWELRY_STORES_WATCHES_CLOCKS_AND_SILVERWARE_STORES = "JEWELRY_STORES_WATCHES_CLOCKS_AND_SILVERWARE_STORES",
  /**
   * The category for JHAT
   *
   * Numeric code: '3854'
   */
  JHAT = "JHAT",
  /**
   * The category for John Ascuagas Nugget
   *
   * Numeric Code: '3729'
   */
  JOHN_ASCUAGAS_NUGGET = "JOHN_ASCUAGAS_NUGGET",
  /**
   * The category for Jolly Hotels
   *
   * Numeric Code: '3558'
   */
  JOLLY_HOTELS = "JOLLY_HOTELS",
  /**
   * The category for Journeys End Motels
   *
   * Numeric Code: '3563'
   */
  JOURNEYS_END_MOTELS = "JOURNEYS_END_MOTELS",
  /**
   * The category for JR East Hotel Mets
   *
   * Numeric code: '3860'
   */
  JR_EAST_HOTEL_METS = "JR_EAST_HOTEL_METS",
  /**
   * The category for Jugoslav Air
   *
   * Numeric Code: '3190'
   */
  JUGOSLAV_AIR = "JUGOSLAV_AIR",
  /**
   * The category for Jumeirah Essex House
   *
   * Numeric Code: '3820'
   */
  JUMEIRAH_ESSEX_HOUSE = "JUMEIRAH_ESSEX_HOUSE",
  /**
   * The category for Jurys Doyle Hotel Group
   *
   * Numeric Code: '3605'
   */
  JURYS_DOYLE_HOTEL_GROUP = "JURYS_DOYLE_HOTEL_GROUP",
  /**
   * The category for JW Marriott
   *
   * Numeric code: '3847'
   */
  JW_MARRIOTT = "JW_MARRIOTT",
  /**
   * The category for Kahala Mandarin Oriental Hotel
   *
   * Numeric Code: '3758'
   */
  KAHALA_MANDARIN_ORIENTAL_HOTEL = "KAHALA_MANDARIN_ORIENTAL_HOTEL",
  /**
   * The category for Karos Hotels
   *
   * Numeric Code: '3718'
   */
  KAROS_HOTELS = "KAROS_HOTELS",
  /**
   * The category for Kauai Coconut Beach Resort
   *
   * Numeric Code: '3531'
   */
  KAUAI_COCONUT_BEACH_RESORT = "KAUAI_COCONUT_BEACH_RESORT",
  /**
   * The category for Keio Presso Inn
   *
   * Numeric code: '3870'
   */
  KEIO_PRESSO_INN = "KEIO_PRESSO_INN",
  /**
   * The category for Kemwell Group
   *
   * Numeric Code: '3394'
   */
  KEMWELL_GROUP = "KEMWELL_GROUP",
  /**
   * The category for Kenya Airways
   *
   * Numeric Code: '3295'
   */
  KENYA_AIRWAYS = "KENYA_AIRWAYS",
  /**
   * The category for KLM (Royal Dutch Airlines)
   *
   * Numeric Code: '3010'
   */
  KLM_ROYAL_DUTCH_AIRLINES = "KLM_ROYAL_DUTCH_AIRLINES",
  /**
   * The category for Knights Inn
   *
   * Numeric Code: '3660'
   */
  KNIGHTS_INN = "KNIGHTS_INN",
  /**
   * The category for Korean Airlines
   *
   * Numeric Code: '3082'
   */
  KOREAN_AIRLINES = "KOREAN_AIRLINES",
  /**
   * The category for Kuwait Air
   *
   * Numeric Code: '3038'
   */
  KUWAIT_AIR = "KUWAIT_AIR",
  /**
   * The category for Kyoritsu Hotels.
   *
   * Numeric code: '3839'
   */
  KYORITSUHOTELS = "KYORITSUHOTELS",
  /**
   * The category for Lloyd Aero Boliviano (LAB)
   *
   * Numeric Code: '3055'
   */
  LAB_AIR = "LAB_AIR",
  /**
   * The category for LACSA (Costa Rica)
   *
   * Numeric Code: '3187'
   */
  LACSA_AIR = "LACSA_AIR",
  /**
   * The category for Ladbroke Hotels
   *
   * Numeric Code: '3568'
   */
  LADBROKE_HOTELS = "LADBROKE_HOTELS",
  /**
   * The category for Linea Aerea Del Cobre (LADECO)
   *
   * Numeric Code: '3054'
   */
  LADECO_AIR = "LADECO_AIR",
  /**
   * The category for Lady Luck Hotel And Casino
   *
   * Numeric Code: '3624'
   */
  LADY_LUCK_HOTEL_AND_CASINO = "LADY_LUCK_HOTEL_AND_CASINO",
  /**
   * The category for Landscaping Services.
   *
   * Numeric code: '0780'
   */
  LANDSCAPING_SERVICES = "LANDSCAPING_SERVICES",
  /**
   * The category for LAN Airlines
   *
   * Numeric Code: '3052'
   */
  LAN_AIR = "LAN_AIR",
  /**
   * The category for Lineas Aereas Paraguayas (LAP)
   *
   * Numeric Code: '3186'
   */
  LAP_AIR = "LAP_AIR",
  /**
   * The category for Laundries.
   *
   * Numeric code: '7211'
   */
  LAUNDRIES = "LAUNDRIES",
  /**
   * The category for "Laundry, Cleaning Services".
   *
   * Numeric code: '7210'
   */
  LAUNDRY_CLEANING_SERVICES = "LAUNDRY_CLEANING_SERVICES",
  /**
   * The category for Linea Aeropostal Venezolana (LAV)
   *
   * Numeric Code: '3185'
   */
  LAV_AIR = "LAV_AIR",
  /**
   * The category for La Costa Resort
   *
   * Numeric Code: '3810'
   */
  LA_COSTA_RESORT = "LA_COSTA_RESORT",
  /**
   * The category for La Mansion Del Rio
   *
   * Numeric Code: '3701'
   */
  LA_MANSION_DEL_RIO = "LA_MANSION_DEL_RIO",
  /**
   * The category for La Quinta Motor Inns
   *
   * Numeric Code: '3516'
   */
  LA_QUINTA_MOTOR_INNS = "LA_QUINTA_MOTOR_INNS",
  /**
   * The category for La Quinta Resort
   *
   * Numeric Code: '3576'
   */
  LA_QUINTA_RESORT = "LA_QUINTA_RESORT",
  /**
   * The category for La Vista
   *
   * Numeric code: '3859'
   */
  LA_VISTA = "LA_VISTA",
  /**
   * The category for "Legal Services, Attorneys".
   *
   * Numeric code: '8111'
   */
  LEGAL_SERVICES_ATTORNEYS = "LEGAL_SERVICES_ATTORNEYS",
  /**
   * The category for Liat Airline
   *
   * Numeric Code: '3184'
   */
  LIAT_AIRLINE = "LIAT_AIRLINE",
  /**
   * The category for Loews Hotels
   *
   * Numeric Code: '3654'
   */
  LOEWS_HOTELS = "LOEWS_HOTELS",
  /**
   * The category for LOT (Polish Airlines)
   *
   * Numeric Code: '3182'
   */
  LOT_AIR = "LOT_AIR",
  /**
   * The category for Lufthansa
   *
   * Numeric Code: '3008'
   */
  LUFTHANSA = "LUFTHANSA",
  /**
   * The category for Luggage and Leather Goods Stores.
   *
   * Numeric code: '5948'
   */
  LUGGAGE_AND_LEATHER_GOODS_STORES = "LUGGAGE_AND_LEATHER_GOODS_STORES",
  /**
   * The category for "Lumber, Building Materials Stores".
   *
   * Numeric code: '5211'
   */
  LUMBER_BUILDING_MATERIALS_STORES = "LUMBER_BUILDING_MATERIALS_STORES",
  /**
   * The category for Luxair
   *
   * Numeric Code: '3146'
   */
  LUXAIR = "LUXAIR",
  /**
   * The category for Luxor Hotel And Casino
   *
   * Numeric Code: '3667'
   */
  LUXOR_HOTEL_AND_CASINO = "LUXOR_HOTEL_AND_CASINO",
  /**
   * The category for Luxury Resorts
   *
   * Numeric Code: '3808'
   */
  LUXURY_RESORTS = "LUXURY_RESORTS",
  /**
   * The category for Mainstay Suites
   *
   * Numeric Code: '3818'
   */
  MAINSTAY_SUITES = "MAINSTAY_SUITES",
  /**
   * The category for Main Street Station Hotel And Casino
   *
   * Numeric Code: '3767'
   */
  MAIN_STREET_STATION_HOTEL_AND_CASINO = "MAIN_STREET_STATION_HOTEL_AND_CASINO",
  /**
   * The category for Major Rent A Car
   *
   * Numeric Code: '3430'
   */
  MAJOR_RENT_A_CAR = "MAJOR_RENT_A_CAR",
  /**
   * The category for Malaysian Airline System
   *
   * Numeric Code: '3100'
   */
  MALAYSIAN_AIRLINE_SYSTEM = "MALAYSIAN_AIRLINE_SYSTEM",
  /**
   * The category for Malev
   *
   * Numeric Code: '3181'
   */
  MALEV = "MALEV",
  /**
   * The category for Malmo Aviation
   *
   * Numeric Code: '3213'
   */
  MALMO_AIR = "MALMO_AIR",
  /**
   * The category for Mandalay Bay Resort
   *
   * Numeric Code: '3777'
   */
  MANDALAY_BAY_RESORT = "MANDALAY_BAY_RESORT",
  /**
   * The category for Mandarin International
   *
   * Numeric Code: '3577'
   */
  MANDARIN_INTERNATIONAL = "MANDARIN_INTERNATIONAL",
  /**
   * The category for Manhattan East Suite Hotels
   *
   * Numeric Code: '3557'
   */
  MANHATTAN_EAST_SUITE_HOTELS = "MANHATTAN_EAST_SUITE_HOTELS",
  /**
   * The category for Manual Cash Disburse.
   *
   * Numeric code: '6010'
   */
  MANUAL_CASH_DISBURSE = "MANUAL_CASH_DISBURSE",
  /**
   * The category for "Marinas, Service and Supplies".
   *
   * Numeric code: '4468'
   */
  MARINAS_SERVICE_AND_SUPPLIES = "MARINAS_SERVICE_AND_SUPPLIES",
  /**
   * The category for Maritim
   *
   * Numeric Code: '3668'
   */
  MARITIM = "MARITIM",
  /**
   * The category for Marriott
   *
   * Numeric Code: '3509'
   */
  MARRIOTT = "MARRIOTT",
  /**
   * The category for Marriott Executive Apartments
   *
   * Numeric code: '3842'
   */
  MARRIOTT_EXECUTIVE_APARTMENTS = "MARRIOTT_EXECUTIVE_APARTMENTS",
  /**
   * The category for "Masonry, Stonework, and Plaster".
   *
   * Numeric code: '1740'
   */
  MASONRY_STONEWORK_AND_PLASTER = "MASONRY_STONEWORK_AND_PLASTER",
  /**
   * The category for Massage Parlors.
   *
   * Numeric code: '7297'
   */
  MASSAGE_PARLORS = "MASSAGE_PARLORS",
  /**
   * The category for Masters Economy Inns
   *
   * Numeric Code: '3835'
   */
  MASTERS_ECONOMY_INNS = "MASTERS_ECONOMY_INNS",
  /**
   * The category for Medical and Dental Labs.
   *
   * Numeric code: '8071'
   */
  MEDICAL_AND_DENTAL_LABS = "MEDICAL_AND_DENTAL_LABS",
  /**
   * The category for "Medical, Dental, Ophthalmic, and Hospital Equipment and Supplies".
   *
   * Numeric code: '5047'
   */
  MEDICAL_DENTAL_OPHTHALMIC_AND_HOSPITAL_EQUIPMENT_AND_SUPPLIES = "MEDICAL_DENTAL_OPHTHALMIC_AND_HOSPITAL_EQUIPMENT_AND_SUPPLIES",
  /**
   * The category for Medical Services.
   *
   * Numeric code: '8099'
   */
  MEDICAL_SERVICES = "MEDICAL_SERVICES",
  /**
   * The category for Meitetsu Inn
   *
   * Numeric code: '3872'
   */
  MEITETSU_INN = "MEITETSU_INN",
  /**
   * The category for Membership Organizations.
   *
   * Numeric code: '8699'
   */
  MEMBERSHIP_ORGANIZATIONS = "MEMBERSHIP_ORGANIZATIONS",
  /**
   * The category for Mens and Boys Clothing and Accessories Stores.
   *
   * Numeric code: '5611'
   */
  MENS_AND_BOYS_CLOTHING_AND_ACCESSORIES_STORES = "MENS_AND_BOYS_CLOTHING_AND_ACCESSORIES_STORES",
  /**
   * The category for "Mens, Women's Clothing Stores".
   *
   * Numeric code: '5691'
   */
  MENS_WOMENS_CLOTHING_STORES = "MENS_WOMENS_CLOTHING_STORES",
  /**
   * The category for Merchants Rent A Car
   *
   * Numeric Code: '3388'
   */
  MERCHANTS_RENT_A_CAR = "MERCHANTS_RENT_A_CAR",
  /**
   * The category for Meridien
   *
   * Numeric Code: '3520'
   */
  MERIDIEN = "MERIDIEN",
  /**
   * The category for Merlin Hotel Perth
   *
   * Numeric Code: '3622'
   */
  MERLIN_HOTEL_PERTH = "MERLIN_HOTEL_PERTH",
  /**
   * The category for Mesa Air
   *
   * Numeric Code: '3178'
   */
  MESA_AIR = "MESA_AIR",
  /**
   * The category for Metal Service Centers.
   *
   * Numeric code: '5051'
   */
  METAL_SERVICE_CENTERS = "METAL_SERVICE_CENTERS",
  /**
   * The category for Metroflight Airlines
   *
   * Numeric Code: '3176'
   */
  METROFLIGHT_AIRLINES = "METROFLIGHT_AIRLINES",
  /**
   * The category for Metropole Hotels
   *
   * Numeric Code: '3661'
   */
  METROPOLE_HOTELS = "METROPOLE_HOTELS",
  /**
   * The category for Metro Airlines
   *
   * Numeric Code: '3087'
   */
  METRO_AIRLINES = "METRO_AIRLINES",
  /**
   * The category for Mexicana Airlines
   *
   * Numeric Code: '3023'
   */
  MEXICANA_AIRLINES = "MEXICANA_AIRLINES",
  /**
   * The category for Mgm Grand Hotel
   *
   * Numeric Code: '3730'
   */
  MGM_GRAND_HOTEL = "MGM_GRAND_HOTEL",
  /**
   * The category for Microtel Inn And Suites
   *
   * Numeric Code: '3613'
   */
  MICROTEL_INN_AND_SUITES = "MICROTEL_INN_AND_SUITES",
  /**
   * The category for Middle East Air
   *
   * Numeric Code: '3175'
   */
  MIDDLE_EAST_AIR = "MIDDLE_EAST_AIR",
  /**
   * The category for Midway Motor Lodge
   *
   * Numeric Code: '3699'
   */
  MIDWAY_MOTOR_LODGE = "MIDWAY_MOTOR_LODGE",
  /**
   * The category for Midwest Express Airlines
   *
   * Numeric Code: '3085'
   */
  MIDWEST_EXPRESS_AIRLINES = "MIDWEST_EXPRESS_AIRLINES",
  /**
   * The category for Millennium Broadway Hotel
   *
   * Numeric Code: '3741'
   */
  MILLENNIUM_BROADWAY_HOTEL = "MILLENNIUM_BROADWAY_HOTEL",
  /**
   * The category for Milleville
   *
   * Numeric Code: '3439'
   */
  MILLEVILLE = "MILLEVILLE",
  /**
   * The category for Minacia
   *
   * Numeric code: '3849'
   */
  MINACIA = "MINACIA",
  /**
   * The category for Mirage Hotel And Casino
   *
   * Numeric Code: '3551'
   */
  MIRAGE_HOTEL_AND_CASINO = "MIRAGE_HOTEL_AND_CASINO",
  /**
   * The category for Miscellaneous Apparel and Accessory Shops.
   *
   * Numeric code: '5699'
   */
  MISCELLANEOUS_APPAREL_AND_ACCESSORY_SHOPS = "MISCELLANEOUS_APPAREL_AND_ACCESSORY_SHOPS",
  /**
   * The category for Miscellaneous Auto Dealers.
   *
   * Numeric code: '5599'
   */
  MISCELLANEOUS_AUTO_DEALERS = "MISCELLANEOUS_AUTO_DEALERS",
  /**
   * The category for Miscellaneous Business Services.
   *
   * Numeric code: '7399'
   */
  MISCELLANEOUS_BUSINESS_SERVICES = "MISCELLANEOUS_BUSINESS_SERVICES",
  /**
   * The category for Miscellaneous Food Stores - Convenience Stores and Specialty Markets.
   *
   * Numeric code: '5499'
   */
  MISCELLANEOUS_FOOD_STORES = "MISCELLANEOUS_FOOD_STORES",
  /**
   * The category for Miscellaneous General Merchandise.
   *
   * Numeric code: '5399'
   */
  MISCELLANEOUS_GENERAL_MERCHANDISE = "MISCELLANEOUS_GENERAL_MERCHANDISE",
  /**
   * The category for Miscellaneous General Services.
   *
   * Numeric code: '7299'
   */
  MISCELLANEOUS_GENERAL_SERVICES = "MISCELLANEOUS_GENERAL_SERVICES",
  /**
   * The category for Miscellaneous Home Furnishing Specialty Stores.
   *
   * Numeric code: '5719'
   */
  MISCELLANEOUS_HOME_FURNISHING_SPECIALTY_STORES = "MISCELLANEOUS_HOME_FURNISHING_SPECIALTY_STORES",
  /**
   * The category for Miscellaneous Publishing and Printing.
   *
   * Numeric code: '2741'
   */
  MISCELLANEOUS_PUBLISHING_AND_PRINTING = "MISCELLANEOUS_PUBLISHING_AND_PRINTING",
  /**
   * The category for Miscellaneous Recreation Services.
   *
   * Numeric code: '7999'
   */
  MISCELLANEOUS_RECREATION_SERVICES = "MISCELLANEOUS_RECREATION_SERVICES",
  /**
   * The category for Miscellaneous Repair Shops.
   *
   * Numeric code: '7699'
   */
  MISCELLANEOUS_REPAIR_SHOPS = "MISCELLANEOUS_REPAIR_SHOPS",
  /**
   * The category for Miscellaneous Specialty Retail.
   *
   * Numeric code: '5999'
   */
  MISCELLANEOUS_SPECIALTY_RETAIL = "MISCELLANEOUS_SPECIALTY_RETAIL",
  /**
   * The category for Miyako Hotel/Kintetsu
   *
   * Numeric Code: '3572'
   */
  MIYAKO_HOTEL_KINTETSU = "MIYAKO_HOTEL_KINTETSU",
  /**
   * The category for Mobile Home Dealers.
   *
   * Numeric code: '5271'
   */
  MOBILE_HOME_DEALERS = "MOBILE_HOME_DEALERS",
  /**
   * The category for Moevenpick
   *
   * Numeric Code: '3612'
   */
  MOEVENPICK = "MOEVENPICK",
  /**
   * The category for MoneySend Funding.
   *
   * Numeric code: '6538'
   */
  MONEYSEND_FUNDING = "MONEYSEND_FUNDING",
  /**
   * The category for MoneySend Intercountry.
   *
   * Numeric code: '6537'
   */
  MONEYSEND_INTERCOUNTRY = "MONEYSEND_INTERCOUNTRY",
  /**
   * The category for MoneySend Intracountry.
   *
   * Numeric code: '6536'
   */
  MONEYSEND_INTRACOUNTRY = "MONEYSEND_INTRACOUNTRY",
  /**
   * The category for money transfer - Member Financial Institution
   *
   * Numeric code: '6534'
   */
  MONEY_TRANSFER_FINANCIAL_INSTITUTION = "MONEY_TRANSFER_FINANCIAL_INSTITUTION",
  /**
   * The category for Monte Carlo Hotel And Casino
   *
   * Numeric Code: '3676'
   */
  MONTE_CARLO_HOTEL_AND_CASINO = "MONTE_CARLO_HOTEL_AND_CASINO",
  /**
   * The category for Mortgage Bankers & Loan Correspondents
   *
   * Numeric code: '6162'
   */
  MORTGAGE_BANKERS_LOAN_CORRESPONDENTS = "MORTGAGE_BANKERS_LOAN_CORRESPONDENTS",
  /**
   * The category for Motel 6
   *
   * Numeric Code: '3700'
   */
  MOTEL_6 = "MOTEL_6",
  /**
   * The category for Motion Picture Theaters.
   *
   * Numeric code: '7832'
   */
  MOTION_PICTURE_THEATERS = "MOTION_PICTURE_THEATERS",
  /**
   * The category for Motorcycle Shops and Dealers.
   *
   * Numeric code: '5571'
   */
  MOTORCYCLE_SHOPS_AND_DEALERS = "MOTORCYCLE_SHOPS_AND_DEALERS",
  /**
   * The category for "Motorcycle Shops, Dealers".
   *
   * Numeric code: '5561'
   */
  MOTORCYCLE_SHOPS_DEALERS = "MOTORCYCLE_SHOPS_DEALERS",
  /**
   * The category for "Motor Freight Carriers and Trucking - Local and Long Distance, Moving and Storage Companies, and Local Delivery Services".
   *
   * Numeric code: '4214'
   */
  MOTOR_FREIGHT_CARRIERS_AND_TRUCKING = "MOTOR_FREIGHT_CARRIERS_AND_TRUCKING",
  /**
   * The category for Motor Homes Dealers.
   *
   * Numeric code: '5592'
   */
  MOTOR_HOMES_DEALERS = "MOTOR_HOMES_DEALERS",
  /**
   * The category for Motor Vehicle Supplies and New Parts.
   *
   * Numeric code: '5013'
   */
  MOTOR_VEHICLE_SUPPLIES_AND_NEW_PARTS = "MOTOR_VEHICLE_SUPPLIES_AND_NEW_PARTS",
  /**
   * The category for Mount Charlotte Hotels
   *
   * Numeric Code: '3639'
   */
  MOUNT_CHARLOTTE_HOTELS = "MOUNT_CHARLOTTE_HOTELS",
  /**
   * The category for Mount Cook
   *
   * Numeric Code: '3170'
   */
  MOUNT_COOK = "MOUNT_COOK",
  /**
   * The category for Moxy
   *
   * Numeric code: '3843'
   */
  MOXY = "MOXY",
  /**
   * The category for "Music Stores-Musical Instruments, Pianos, and Sheet Music".
   *
   * Numeric code: '5733'
   */
  MUSIC_STORES_MUSICAL_INSTRUMENTS_PIANOS_AND_SHEET_MUSIC = "MUSIC_STORES_MUSICAL_INSTRUMENTS_PIANOS_AND_SHEET_MUSIC",
  /**
   * The category for Nationair
   *
   * Numeric Code: '3172'
   */
  NATIONAIR = "NATIONAIR",
  /**
   * The category for National Car Rental
   *
   * Numeric Code: '3393'
   */
  NATIONAL_CAR_RENTAL = "NATIONAL_CAR_RENTAL",
  /**
   * The category for Nemacolin Woodlands
   *
   * Numeric Code: '3772'
   */
  NEMACOLIN_WOODLANDS = "NEMACOLIN_WOODLANDS",
  /**
   * The category for Nest Hotel
   *
   * Numeric code: '3883'
   */
  NEST_HOTEL = "NEST_HOTEL",
  /**
   * The category for Nevele Grande Resort And Country Club
   *
   * Numeric Code: '3776'
   */
  NEVELE_GRANDE_RESORT_AND_COUNTRY_CLUB = "NEVELE_GRANDE_RESORT_AND_COUNTRY_CLUB",
  /**
   * The category for News Dealers and Newsstands.
   *
   * Numeric code: '5994'
   */
  NEWS_DEALERS_AND_NEWSSTANDS = "NEWS_DEALERS_AND_NEWSSTANDS",
  /**
   * The category for New Otani Hotels
   *
   * Numeric Code: '3658'
   */
  NEW_OTANI_HOTELS = "NEW_OTANI_HOTELS",
  /**
   * The category for New York New York Hotel And Casino
   *
   * Numeric Code: '3774'
   */
  NEW_YORK_NEW_YORK_HOTEL_AND_CASINO = "NEW_YORK_NEW_YORK_HOTEL_AND_CASINO",
  /**
   * The category for Nickelodeon Family Suites By Holiday Inn
   *
   * Numeric Code: '3815'
   */
  NICKELODEON_FAMILY_SUITES_BY_HOLIDAY_INN = "NICKELODEON_FAMILY_SUITES_BY_HOLIDAY_INN",
  /**
   * The category for Nigeria Airways
   *
   * Numeric Code: '3045'
   */
  NIGERIA_AIR = "NIGERIA_AIR",
  /**
   * The category for Noahs Hotel Melbourne
   *
   * Numeric Code: '3603'
   */
  NOAHS_HOTEL_MELBOURNE = "NOAHS_HOTEL_MELBOURNE",
  /**
   * The category for Nondurable Goods (Not Elsewhere Classified).
   *
   * Numeric code: '5199'
   */
  NONDURABLE_GOODS = "NONDURABLE_GOODS",
  /**
   * The category for "Non-FI, Money Orders".
   *
   * Numeric code: '6051'
   */
  NON_FI_MONEY_ORDERS = "NON_FI_MONEY_ORDERS",
  /**
   * The category for "Non-FI, Stored Value Card Purchase/Load".
   *
   * Numeric code: '6540'
   */
  NON_FI_STORED_VALUE_CARD_PURCHASE_LOAD = "NON_FI_STORED_VALUE_CARD_PURCHASE_LOAD",
  /**
   * The category for NordAir
   *
   * Numeric Code: '3081'
   */
  NORD_AIR = "NORD_AIR",
  /**
   * The category for Norontair
   *
   * Numeric Code: '3164'
   */
  NORONTAIR = "NORONTAIR",
  /**
   * The category for Norwegian Air Shuttle
   *
   * Numeric Code: '3211'
   */
  NORWEGIAN_AIR_SHUTTLE = "NORWEGIAN_AIR_SHUTTLE",
  /**
   * The category for Novotel Sieh Accor
   *
   * Numeric Code: '3642'
   */
  NOVOTEL_SIEH_ACCOR = "NOVOTEL_SIEH_ACCOR",
  /**
   * The category for "Nurseries, Lawn and Garden Supply Stores".
   *
   * Numeric code: '5261'
   */
  NURSERIES_LAWN_AND_GARDEN_SUPPLY_STORES = "NURSERIES_LAWN_AND_GARDEN_SUPPLY_STORES",
  /**
   * The category for Nursing/Personal Care.
   *
   * Numeric code: '8050'
   */
  NURSING_PERSONAL_CARE = "NURSING_PERSONAL_CARE",
  /**
   * The category for Northwest Airlines
   *
   * Numeric Code: '3060'
   */
  NWA_AIR = "NWA_AIR",
  /**
   * The category for New York Helicopter
   *
   * Numeric Code: '3165'
   */
  NY_HELI = "NY_HELI",
  /**
   * The category for Oberoi Hotels
   *
   * Numeric Code: '3657'
   */
  OBEROI_HOTELS = "OBEROI_HOTELS",
  /**
   * The category for Office and Commercial Furniture.
   *
   * Numeric code: '5021'
   */
  OFFICE_AND_COMMERCIAL_FURNITURE = "OFFICE_AND_COMMERCIAL_FURNITURE",
  /**
   * The category for Ohana Hotels Of Hawaii
   *
   * Numeric Code: '3786'
   */
  OHANA_HOTELS_OF_HAWAII = "OHANA_HOTELS_OF_HAWAII",
  /**
   * The category for Olympic Airways
   *
   * Numeric Code: '3031'
   */
  OLYMPIC_AIRWAYS = "OLYMPIC_AIRWAYS",
  /**
   * The category for Oman Air
   *
   * Numeric Code: '3183'
   */
  OMAN_AIR = "OMAN_AIR",
  /**
   * The category for Omni International
   *
   * Numeric Code: '3592'
   */
  OMNI_INTERNATIONAL = "OMNI_INTERNATIONAL",
  /**
   * The category for Online Marketplaces.
   *
   * Numeric code: '5262'
   */
  ONLINE_MARKETPLACES = "ONLINE_MARKETPLACES",
  /**
   * The category for Opryland Hotel
   *
   * Numeric Code: '3732'
   */
  OPRYLAND_HOTEL = "OPRYLAND_HOTEL",
  /**
   * The category for "Opticians, Eyeglasses".
   *
   * Numeric code: '8043'
   */
  OPTICIANS_EYEGLASSES = "OPTICIANS_EYEGLASSES",
  /**
   * The category for "Optometrists, Ophthalmologist".
   *
   * Numeric code: '8042'
   */
  OPTOMETRISTS_OPHTHALMOLOGIST = "OPTOMETRISTS_OPHTHALMOLOGIST",
  /**
   * The category for Orchid At Mauna Lai
   *
   * Numeric Code: '3759'
   */
  ORCHID_AT_MAUNA_LAI = "ORCHID_AT_MAUNA_LAI",
  /**
   * The category for Orix Hotels and Resorts
   *
   * Numeric code: '3877'
   */
  ORIX_HOTELS_AND_RESORTS = "ORIX_HOTELS_AND_RESORTS",
  /**
   * The category for Orthopedic Goods - Prosthetic Devices.
   *
   * Numeric code: '5976'
   */
  ORTHOPEDIC_GOODS_PROSTHETIC_DEVICES = "ORTHOPEDIC_GOODS_PROSTHETIC_DEVICES",
  /**
   * The category for Osteopaths.
   *
   * Numeric code: '8031'
   */
  OSTEOPATHS = "OSTEOPATHS",
  /**
   * The category for Outrigger Hotels And Resorts
   *
   * Numeric Code: '3785'
   */
  OUTRIGGER_HOTELS_AND_RESORTS = "OUTRIGGER_HOTELS_AND_RESORTS",
  /**
   * The category for Overpayments
   *
   * Numeric code: '6611'
   */
  OVERPAYMENT_TRANSACTIONS = "OVERPAYMENT_TRANSACTIONS",
  /**
   * The category for Oxford Suites
   *
   * Numeric Code: '3819'
   */
  OXFORD_SUITES = "OXFORD_SUITES",
  /**
   * The category for "Package Stores-Beer, Wine, and Liquor".
   *
   * Numeric code: '5921'
   */
  PACKAGE_STORES_BEER_WINE_AND_LIQUOR = "PACKAGE_STORES_BEER_WINE_AND_LIQUOR",
  /**
   * The category for "Paints, Varnishes, and Supplies".
   *
   * Numeric code: '5198'
   */
  PAINTS_VARNISHES_AND_SUPPLIES = "PAINTS_VARNISHES_AND_SUPPLIES",
  /**
   * The category for Pakistan International
   *
   * Numeric Code: '3024'
   */
  PAKISTAN_INTERNATIONAL = "PAKISTAN_INTERNATIONAL",
  /**
   * The category for Pannonia Hotels
   *
   * Numeric Code: '3599'
   */
  PANNONIA_HOTELS = "PANNONIA_HOTELS",
  /**
   * The category for Pan American
   *
   * Numeric Code: '3002'
   */
  PAN_AMERICAN = "PAN_AMERICAN",
  /**
   * The category for Paris Las Vegas Hotel
   *
   * Numeric Code: '3795'
   */
  PARIS_LAS_VEGAS_HOTEL = "PARIS_LAS_VEGAS_HOTEL",
  /**
   * The category for "Parking Lots, Garages".
   *
   * Numeric code: '7523'
   */
  PARKING_LOTS_GARAGES = "PARKING_LOTS_GARAGES",
  /**
   * The category for Parks Inns International
   *
   * Numeric Code: '3553'
   */
  PARKS_INNS_INTERNATIONAL = "PARKS_INNS_INTERNATIONAL",
  /**
   * The category for Park Inn By Radisson
   *
   * Numeric Code: '3533'
   */
  PARK_INN_BY_RADISSON = "PARK_INN_BY_RADISSON",
  /**
   * The category for Park Plaza Hotel
   *
   * Numeric Code: '3830'
   */
  PARK_PLAZA_HOTEL = "PARK_PLAZA_HOTEL",
  /**
   * The category for Passenger Railways.
   *
   * Numeric code: '4112'
   */
  PASSENGER_RAILWAYS = "PASSENGER_RAILWAYS",
  /**
   * The category for Patricia Grand Resort Hotels
   *
   * Numeric Code: '3781'
   */
  PATRICIA_GRAND_RESORT_HOTELS = "PATRICIA_GRAND_RESORT_HOTELS",
  /**
   * The category for Pawn Shops.
   *
   * Numeric code: '5933'
   */
  PAWN_SHOPS = "PAWN_SHOPS",
  /**
   * The category for Payless Car Rental
   *
   * Numeric Code: '3359'
   */
  PAYLESS_CAR_RENTAL = "PAYLESS_CAR_RENTAL",
  /**
   * The category for Payment Service Provider - money transfer for a purchase
   *
   * Numeric code: '6531'
   */
  PAYMENT_SERVICE_PROVIDER_MONEY_TRANSFER = "PAYMENT_SERVICE_PROVIDER_MONEY_TRANSFER",
  /**
   * The category for Provincetown-Boston Airways
   *
   * Numeric Code: '3159'
   */
  PBA_AIRLINE = "PBA_AIRLINE",
  /**
   * The category for Peabody Hotels
   *
   * Numeric Code: '3752'
   */
  PEABODY_HOTELS = "PEABODY_HOTELS",
  /**
   * The category for Peninsula Hotels
   *
   * Numeric Code: '3523'
   */
  PENINSULA_HOTELS = "PENINSULA_HOTELS",
  /**
   * The category for Penta Hotels
   *
   * Numeric Code: '3653'
   */
  PENTA_HOTELS = "PENTA_HOTELS",
  /**
   * The category for Peppermill Hotel Casino
   *
   * Numeric Code: '3796'
   */
  PEPPERMILL_HOTEL_CASINO = "PEPPERMILL_HOTEL_CASINO",
  /**
   * The category for companies which provide loans to individuals
   *
   * Numeric Code: ‘6141’
   */
  PERSONAL_CREDIT_INSTITUTIONS = "PERSONAL_CREDIT_INSTITUTIONS",
  /**
   * The category for Petroleum and Petroleum Products.
   *
   * Numeric code: '5172'
   */
  PETROLEUM_AND_PETROLEUM_PRODUCTS = "PETROLEUM_AND_PETROLEUM_PRODUCTS",
  /**
   * The category for "Pet Shops, Pet Food, and Supplies".
   *
   * Numeric code: '5995'
   */
  PET_SHOPS_PET_FOOD_AND_SUPPLIES = "PET_SHOPS_PET_FOOD_AND_SUPPLIES",
  /**
   * The category for Philippine Airlines
   *
   * Numeric Code: '3022'
   */
  PHILIPPINE_AIRLINES = "PHILIPPINE_AIRLINES",
  /**
   * The category for "Photographic, Photocopy, Microfilm Equipment, and Supplies".
   *
   * Numeric code: '5044'
   */
  PHOTOGRAPHIC_PHOTOCOPY_MICROFILM_EQUIPMENT_AND_SUPPLIES = "PHOTOGRAPHIC_PHOTOCOPY_MICROFILM_EQUIPMENT_AND_SUPPLIES",
  /**
   * The category for Photographic Studios.
   *
   * Numeric code: '7221'
   */
  PHOTOGRAPHIC_STUDIOS = "PHOTOGRAPHIC_STUDIOS",
  /**
   * The category for Photo Developing.
   *
   * Numeric code: '7395'
   */
  PHOTO_DEVELOPING = "PHOTO_DEVELOPING",
  /**
   * The category for Picture/Video Production.
   *
   * Numeric code: '7829'
   */
  PICTURE_VIDEO_PRODUCTION = "PICTURE_VIDEO_PRODUCTION",
  /**
   * The category for "Piece Goods, Notions, and Other Dry Goods".
   *
   * Numeric code: '5131'
   */
  PIECE_GOODS_NOTIONS_AND_OTHER_DRY_GOODS = "PIECE_GOODS_NOTIONS_AND_OTHER_DRY_GOODS",
  /**
   * The category for Pinehurst Resort
   *
   * Numeric Code: '3554'
   */
  PINEHURST_RESORT = "PINEHURST_RESORT",
  /**
   * The category for PINless Debit BillPay Tier 2 (Tel, Cable, TV, Radio, Insurance)
   *
   * Numeric Code: '6321'
   */
  PINLESS_DEBIT_BILLPAY_TIER_2 = "PINLESS_DEBIT_BILLPAY_TIER_2",
  /**
   * The category for Plm/Etap International
   *
   * Numeric Code: '3519'
   */
  PLM_ETAP_INTERNATIONAL = "PLM_ETAP_INTERNATIONAL",
  /**
   * The category for "Plumbing, Heating Equipment, and Supplies".
   *
   * Numeric code: '5074'
   */
  PLUMBING_HEATING_EQUIPMENT_AND_SUPPLIES = "PLUMBING_HEATING_EQUIPMENT_AND_SUPPLIES",
  /**
   * The category for Political Organizations.
   *
   * Numeric code: '8651'
   */
  POLITICAL_ORGANIZATIONS = "POLITICAL_ORGANIZATIONS",
  /**
   * The category for Postal Services - Government Only.
   *
   * Numeric code: '9402'
   */
  POSTAL_SERVICES_GOVERNMENT_ONLY = "POSTAL_SERVICES_GOVERNMENT_ONLY",
  /**
   * The category for "Precious Stones and Metals, Watches and Jewelry".
   *
   * Numeric code: '5094'
   */
  PRECIOUS_STONES_AND_METALS_WATCHES_AND_JEWELRY = "PRECIOUS_STONES_AND_METALS_WATCHES_AND_JEWELRY",
  /**
   * The category for Premier Travel Inns
   *
   * Numeric Code: '3811'
   */
  PREMIER_TRAVEL_INNS = "PREMIER_TRAVEL_INNS",
  /**
   * The category for Primadonna Hotel And Casino
   *
   * Numeric Code: '3761'
   */
  PRIMADONNA_HOTEL_AND_CASINO = "PRIMADONNA_HOTEL_AND_CASINO",
  /**
   * The category for Princess Hotels International
   *
   * Numeric Code: '3584'
   */
  PRINCESS_HOTELS_INTERNATIONAL = "PRINCESS_HOTELS_INTERNATIONAL",
  /**
   * The category for Princeville Air
   *
   * Numeric Code: '3154'
   */
  PRINCEVILLE_AIR = "PRINCEVILLE_AIR",
  /**
   * The category for Princeville Resort
   *
   * Numeric Code: '3806'
   */
  PRINCEVILLE_RESORT = "PRINCEVILLE_RESORT",
  /**
   * The category for Prince Hotels
   *
   * Numeric Code: '3526'
   */
  PRINCE_HOTELS = "PRINCE_HOTELS",
  /**
   * The category for Professional Services.
   *
   * Numeric code: '8999'
   */
  PROFESSIONAL_SERVICES = "PROFESSIONAL_SERVICES",
  /**
   * The category for Protea Hotels
   *
   * Numeric Code: '3719'
   */
  PROTEA_HOTELS = "PROTEA_HOTELS",
  /**
   * The category for "Public Warehousing and Storage - Farm Products, Refrigerated Goods, Household Goods, and Storage".
   *
   * Numeric code: '4225'
   */
  PUBLIC_WAREHOUSING_AND_STORAGE = "PUBLIC_WAREHOUSING_AND_STORAGE",
  /**
   * The category for Qatar Airways
   *
   * Numeric Code: '3136'
   */
  QATAR_AIRWAYS = "QATAR_AIRWAYS",
  /**
   * The category for Quality International
   *
   * Numeric Code: '3508'
   */
  QUALITY_INTERNATIONAL = "QUALITY_INTERNATIONAL",
  /**
   * The category for Quality Pacific Hotel
   *
   * Numeric Code: '3713'
   */
  QUALITY_PACIFIC_HOTEL = "QUALITY_PACIFIC_HOTEL",
  /**
   * The category for Quantas
   *
   * Numeric Code: '3012'
   */
  QUANTAS = "QUANTAS",
  /**
   * The category for Quasi Cash - Customer Financial Institutions.
   *
   * Numeric code: '6050'
   */
  QUASI_CASH_CUSTOMER_FINANCIAL_INSTITUTIONS = "QUASI_CASH_CUSTOMER_FINANCIAL_INSTITUTIONS",
  /**
   * The category for Queens Moat Houses
   *
   * Numeric Code: '3645'
   */
  QUEENS_MOAT_HOUSES = "QUEENS_MOAT_HOUSES",
  /**
   * The category for "Quick Copy, Repro, and Blueprint".
   *
   * Numeric code: '7338'
   */
  QUICK_COPY_REPRO_AND_BLUEPRINT = "QUICK_COPY_REPRO_AND_BLUEPRINT",
  /**
   * The category for Quintessa Hotel
   *
   * Numeric code: '3865'
   */
  QUINTESSA_HOTEL = "QUINTESSA_HOTEL",
  /**
   * The category for Radisson
   *
   * Numeric Code: '3649'
   */
  RADISSON = "RADISSON",
  /**
   * The category for Radisson Blu
   *
   * Numeric Code: '3583'
   */
  RADISSON_BLU = "RADISSON_BLU",
  /**
   * The category for Raffles Hotels
   *
   * Numeric Code: '3790'
   */
  RAFFLES_HOTELS = "RAFFLES_HOTELS",
  /**
   * The category for Railroads.
   *
   * Numeric code: '4011'
   */
  RAILROADS = "RAILROADS",
  /**
   * The category for Ramada Inns
   *
   * Numeric Code: '3637'
   */
  RAMADA_INNS = "RAMADA_INNS",
  /**
   * The category for Rank Hotels
   *
   * Numeric Code: '3633'
   */
  RANK_HOTELS = "RANK_HOTELS",
  /**
   * The category for Rantasipi Hotels
   *
   * Numeric Code: '3674'
   */
  RANTASIPI_HOTELS = "RANTASIPI_HOTELS",
  /**
   * The category for Real Estate Agents and Managers - Rentals.
   *
   * Numeric code: '6513'
   */
  REAL_ESTATE_AGENTS_AND_MANAGERS_RENTALS = "REAL_ESTATE_AGENTS_AND_MANAGERS_RENTALS",
  /**
   * The category for Record Stores.
   *
   * Numeric code: '5735'
   */
  RECORD_STORES = "RECORD_STORES",
  /**
   * The category for Recreational Vehicle Rentals.
   *
   * Numeric code: '7519'
   */
  RECREATIONAL_VEHICLE_RENTALS = "RECREATIONAL_VEHICLE_RENTALS",
  /**
   * The category for Red Roof Inns
   *
   * Numeric Code: '3650'
   */
  RED_ROOF_INNS = "RED_ROOF_INNS",
  /**
   * The category for Regal 8 Inns
   *
   * Numeric Code: '3550'
   */
  REGAL_8_INNS = "REGAL_8_INNS",
  /**
   * The category for Regent Hotels
   *
   * Numeric Code: '3598'
   */
  REGENT_HOTELS = "REGENT_HOTELS",
  /**
   * The category for Registry Hotels
   *
   * Numeric Code: '3702'
   */
  REGISTRY_HOTELS = "REGISTRY_HOTELS",
  /**
   * The category for Relax Inns
   *
   * Numeric Code: '3565'
   */
  RELAX_INNS = "RELAX_INNS",
  /**
   * The category for Religious Goods Stores.
   *
   * Numeric code: '5973'
   */
  RELIGIOUS_GOODS_STORES = "RELIGIOUS_GOODS_STORES",
  /**
   * The category for Religious Organizations.
   *
   * Numeric code: '8661'
   */
  RELIGIOUS_ORGANIZATIONS = "RELIGIOUS_ORGANIZATIONS",
  /**
   * The category for Relo Vacations
   *
   * Numeric code: '3868'
   */
  RELO_VACATIONS = "RELO_VACATIONS",
  /**
   * The category for Remote Stored Value Load - Member Financial Institution
   *
   * Numeric code: '6529'
   */
  REMOTE_STORED_VALUE_LOAD_FINANCIAL_INSTITUTION = "REMOTE_STORED_VALUE_LOAD_FINANCIAL_INSTITUTION",
  /**
   * The category for Remote Stored Value Load - Merchant
   *
   * Numeric code: '6530'
   */
  REMOTE_STORED_VALUE_LOAD_MERCHANT = "REMOTE_STORED_VALUE_LOAD_MERCHANT",
  /**
   * The category for Renaissance Hotels
   *
   * Numeric Code: '3530'
   */
  RENAISSANCE_HOTELS = "RENAISSANCE_HOTELS",
  /**
   * The category for Reno Air
   *
   * Numeric Code: '3262'
   */
  RENO_AIR = "RENO_AIR",
  /**
   * The category for Rent A Wreck
   *
   * Numeric Code: '3370'
   */
  RENT_A_WRECK = "RENT_A_WRECK",
  /**
   * The category for Replacement Rent A Car
   *
   * Numeric Code: '3431'
   */
  REPLACEMENT_RENT_A_CAR = "REPLACEMENT_RENT_A_CAR",
  /**
   * The category for Reserve Rent A Car
   *
   * Numeric Code: '3432'
   */
  RESERVE_RENT_A_CAR = "RESERVE_RENT_A_CAR",
  /**
   * The category for Residence Inn
   *
   * Numeric Code: '3703'
   */
  RESIDENCE_INN = "RESIDENCE_INN",
  /**
   * The category for Reso Hotels
   *
   * Numeric Code: '3635'
   */
  RESO_HOTELS = "RESO_HOTELS",
  /**
   * The category for Rica Hotels
   *
   * Numeric Code: '3723'
   */
  RICA_HOTELS = "RICA_HOTELS",
  /**
   * The category for Rio Hotels
   *
   * Numeric code: '3840'
   */
  RIO_HOTELS = "RIO_HOTELS",
  /**
   * The category for Rio Suites
   *
   * Numeric Code: '3726'
   */
  RIO_SUITES = "RIO_SUITES",
  /**
   * The category for Ritz Carlton
   *
   * Numeric Code: '3710'
   */
  RITZ_CARLTON = "RITZ_CARLTON",
  /**
   * The category for Riverside Resort And Casino
   *
   * Numeric Code: '3597'
   */
  RIVERSIDE_RESORT_AND_CASINO = "RIVERSIDE_RESORT_AND_CASINO",
  /**
   * The category for Riviera Hotel And Casino
   *
   * Numeric Code: '3737'
   */
  RIVIERA_HOTEL_AND_CASINO = "RIVIERA_HOTEL_AND_CASINO",
  /**
   * The category for Riyadh Air
   *
   * Numeric code: ‘3169'
   */
  RIYADH_AIR = "RIYADH_AIR",
  /**
   * The category for Rodeway Inns International
   *
   * Numeric Code: '3515'
   */
  RODEWAY_INNS_INTERNATIONAL = "RODEWAY_INNS_INTERNATIONAL",
  /**
   * The category for "Roofing/Siding, Sheet Metal".
   *
   * Numeric code: '1761'
   */
  ROOFING_SIDING_SHEET_METAL = "ROOFING_SIDING_SHEET_METAL",
  /**
   * The category for Rosen Hotel And Resorts
   *
   * Numeric Code: '3782'
   */
  ROSEN_HOTEL_AND_RESORTS = "ROSEN_HOTEL_AND_RESORTS",
  /**
   * The category for Royal Hotels
   *
   * Numeric Code: '3542'
   */
  ROYAL_HOTELS = "ROYAL_HOTELS",
  /**
   * The category for Royal Kona Resort
   *
   * Numeric Code: '3532'
   */
  ROYAL_KONA_RESORT = "ROYAL_KONA_RESORT",
  /**
   * The category for Royce Hotel
   *
   * Numeric Code: '3704'
   */
  ROYCE_HOTEL = "ROYCE_HOTEL",
  /**
   * The category for Ryanair
   *
   * Numeric Code: '3246'
   */
  RYANAIR = "RYANAIR",
  /**
   * The category for Sabena
   *
   * Numeric Code: '3029'
   */
  SABENA = "SABENA",
  /**
   * The category for Saddlebrook Resort–Tampa
   *
   * Numeric Code: '3600'
   */
  SADDLEBROOK_RESORT_TAMPA = "SADDLEBROOK_RESORT_TAMPA",
  /**
   * The category for SAETA (Sociedad Ecuatorianos De Transportes Aereos)
   *
   * Numeric Code: '3229'
   */
  SAETA_AIR = "SAETA_AIR",
  /**
   * The category for Sahara Hotel And Casino
   *
   * Numeric Code: '3682'
   */
  SAHARA_HOTEL_AND_CASINO = "SAHARA_HOTEL_AND_CASINO",
  /**
   * The category for SAHSA (Servicio Aero De Honduras)
   *
   * Numeric Code: '3231'
   */
  SAHSA_AIR = "SAHSA_AIR",
  /**
   * The category for Sams Town Hotel And Casino
   *
   * Numeric Code: '3564'
   */
  SAMS_TOWN_HOTEL_AND_CASINO = "SAMS_TOWN_HOTEL_AND_CASINO",
  /**
   * The category for Sanco Inn
   *
   * Numeric code: '3879'
   */
  SANCO_INN = "SANCO_INN",
  /**
   * The category for Sandman Hotels
   *
   * Numeric Code: '3573'
   */
  SANDMAN_HOTELS = "SANDMAN_HOTELS",
  /**
   * The category for Sandman Inn
   *
   * Numeric Code: '3705'
   */
  SANDMAN_INN = "SANDMAN_INN",
  /**
   * The category for Sands Resort
   *
   * Numeric Code: '3775'
   */
  SANDS_RESORT = "SANDS_RESORT",
  /**
   * The category for San Juan Air
   *
   * Numeric Code: '3145'
   */
  SAN_JUAN_AIR = "SAN_JUAN_AIR",
  /**
   * The category for Sara Hotels
   *
   * Numeric Code: '3656'
   */
  SARA_HOTELS = "SARA_HOTELS",
  /**
   * The category for Sarova Hotels
   *
   * Numeric Code: '3636'
   */
  SAROVA_HOTELS = "SAROVA_HOTELS",
  /**
   * The category for Saudia Arabian Airlines
   *
   * Numeric Code: '3014'
   */
  SAUDIA_ARABIAN_AIRLINES = "SAUDIA_ARABIAN_AIRLINES",
  /**
   * The category for Scandic Hotels
   *
   * Numeric Code: '3655'
   */
  SCANDIC_HOTELS = "SCANDIC_HOTELS",
  /**
   * The category for Scandinavian Airline System
   *
   * Numeric Code: '3016'
   */
  SCANDINAVIAN_AIRLINE_SYSTEM = "SCANDINAVIAN_AIRLINE_SYSTEM",
  /**
   * The category for Scenic Airlines
   *
   * Numeric Code: '3143'
   */
  SCENIC_AIRLINES = "SCENIC_AIRLINES",
  /**
   * The category for Sea Pines Resort
   *
   * Numeric Code: '3725'
   */
  SEA_PINES_RESORT = "SEA_PINES_RESORT",
  /**
   * The category for Secretarial Support Services.
   *
   * Numeric code: '7339'
   */
  SECRETARIAL_SUPPORT_SERVICES = "SECRETARIAL_SUPPORT_SERVICES",
  /**
   * The category for Security Brokers/Dealers.
   *
   * Numeric code: '6211'
   */
  SECURITY_BROKERS_DEALERS = "SECURITY_BROKERS_DEALERS",
  /**
   * The category for Service Stations.
   *
   * Numeric code: '5541'
   */
  SERVICE_STATIONS = "SERVICE_STATIONS",
  /**
   * The category for Settle Inn
   *
   * Numeric Code: '3809'
   */
  SETTLE_INN = "SETTLE_INN",
  /**
   * The category for "Sewing, Needlework, Fabric, and Piece Goods Stores".
   *
   * Numeric code: '5949'
   */
  SEWING_NEEDLEWORK_FABRIC_AND_PIECE_GOODS_STORES = "SEWING_NEEDLEWORK_FABRIC_AND_PIECE_GOODS_STORES",
  /**
   * The category for Shangri La International
   *
   * Numeric Code: '3545'
   */
  SHANGRI_LA_INTERNATIONAL = "SHANGRI_LA_INTERNATIONAL",
  /**
   * The category for Sheraton
   *
   * Numeric Code: '3503'
   */
  SHERATON = "SHERATON",
  /**
   * The category for Shilo Inn
   *
   * Numeric Code: '3706'
   */
  SHILO_INN = "SHILO_INN",
  /**
   * The category for Shoe Repair/Hat Cleaning.
   *
   * Numeric code: '7251'
   */
  SHOE_REPAIR_HAT_CLEANING = "SHOE_REPAIR_HAT_CLEANING",
  /**
   * The category for Shoe Stores.
   *
   * Numeric code: '5661'
   */
  SHOE_STORES = "SHOE_STORES",
  /**
   * The category for Shoneys Inn
   *
   * Numeric Code: '3707'
   */
  SHONEYS_INN = "SHONEYS_INN",
  /**
   * The category for Showcase Rental Cars
   *
   * Numeric Code: '3386'
   */
  SHOWCASE_RENTAL_CARS = "SHOWCASE_RENTAL_CARS",
  /**
   * The category for Silver Legacy Hotel And Casino
   *
   * Numeric Code: '3679'
   */
  SILVER_LEGACY_HOTEL_AND_CASINO = "SILVER_LEGACY_HOTEL_AND_CASINO",
  /**
   * The category for Silver Star Hotel And Casino
   *
   * Numeric Code: '3768'
   */
  SILVER_STAR_HOTEL_AND_CASINO = "SILVER_STAR_HOTEL_AND_CASINO",
  /**
   * The category for Simmons Airlines
   *
   * Numeric Code: '3138'
   */
  SIMMONS_AIRLINES = "SIMMONS_AIRLINES",
  /**
   * The category for Singapore Airlines
   *
   * Numeric Code: '3075'
   */
  SINGAPORE_AIRLINES = "SINGAPORE_AIRLINES",
  /**
   * The category for Singleton Air
   *
   * Numeric Code: '3137'
   */
  SINGLETON_AIR = "SINGLETON_AIR",
  /**
   * The category for Sixt Car Rental
   *
   * Numeric Code: '3355'
   */
  SIXT_CAR_RENTAL = "SIXT_CAR_RENTAL",
  /**
   * The category for Skyways
   *
   * Numeric Code: '3226'
   */
  SKYWAYS_AIR = "SKYWAYS_AIR",
  /**
   * The category for Sleep Inn
   *
   * Numeric Code: '3631'
   */
  SLEEP_INN = "SLEEP_INN",
  /**
   * The category for Small Appliance Repair.
   *
   * Numeric code: '7629'
   */
  SMALL_APPLIANCE_REPAIR = "SMALL_APPLIANCE_REPAIR",
  /**
   * The category for Smile Hotel
   *
   * Numeric code: '3866'
   */
  SMILE_HOTEL = "SMILE_HOTEL",
  /**
   * The category for Smugglers Notch Resort
   *
   * Numeric Code: '3789'
   */
  SMUGGLERS_NOTCH_RESORT = "SMUGGLERS_NOTCH_RESORT",
  /**
   * The category for Snappy Car Rental
   *
   * Numeric Code: '3360'
   */
  SNAPPY_CAR_RENTAL = "SNAPPY_CAR_RENTAL",
  /**
   * The category for Snowmobile Dealers.
   *
   * Numeric code: '5598'
   */
  SNOWMOBILE_DEALERS = "SNOWMOBILE_DEALERS",
  /**
   * The category for Sofitel Hotels
   *
   * Numeric Code: '3641'
   */
  SOFITEL_HOTELS = "SOFITEL_HOTELS",
  /**
   * The category for Soho Grand Hotel
   *
   * Numeric Code: '3567'
   */
  SOHO_GRAND_HOTEL = "SOHO_GRAND_HOTEL",
  /**
   * The category for Sokos Hotel
   *
   * Numeric Code: '3586'
   */
  SOKOS_HOTEL = "SOKOS_HOTEL",
  /**
   * The category for Sol Hotels
   *
   * Numeric Code: '3518'
   */
  SOL_HOTELS = "SOL_HOTELS",
  /**
   * The category for Sonesta International Hotels
   *
   * Numeric Code: '3591'
   */
  SONESTA_INTERNATIONAL_HOTELS = "SONESTA_INTERNATIONAL_HOTELS",
  /**
   * The category for Sotetsu Fresa Inn
   *
   * Numeric code: '3858'
   */
  SOTETSU_FRESA_INN = "SOTETSU_FRESA_INN",
  /**
   * The category for Southern Pacific Hotel
   *
   * Numeric Code: '3534'
   */
  SOUTHERN_PACIFIC_HOTEL = "SOUTHERN_PACIFIC_HOTEL",
  /**
   * The category for Southern Sun Hotels
   *
   * Numeric Code: '3720'
   */
  SOUTHERN_SUN_HOTELS = "SOUTHERN_SUN_HOTELS",
  /**
   * The category for Southwest Airlines
   *
   * Numeric Code: '3066'
   */
  SOUTHWEST_AIRLINES = "SOUTHWEST_AIRLINES",
  /**
   * The category for South African Airways
   *
   * Numeric Code: '3017'
   */
  SOUTH_AFRICAN_AIRWAYS = "SOUTH_AFRICAN_AIRWAYS",
  /**
   * The category for Spanair
   *
   * Numeric Code: '3097'
   */
  SPANAIR = "SPANAIR",
  /**
   * The category for Specialty Cleaning.
   *
   * Numeric code: '2842'
   */
  SPECIALTY_CLEANING = "SPECIALTY_CLEANING",
  /**
   * The category for Special Trade Services.
   *
   * Numeric code: '1799'
   */
  SPECIAL_TRADE_SERVICES = "SPECIAL_TRADE_SERVICES",
  /**
   * The category for Spirit Airlines
   *
   * Numeric Code: '3260'
   */
  SPIRIT_AIRLINES = "SPIRIT_AIRLINES",
  /**
   * The category for Sporting Goods Stores.
   *
   * Numeric code: '5941'
   */
  SPORTING_GOODS_STORES = "SPORTING_GOODS_STORES",
  /**
   * The category for Sporting/Recreation Camps.
   *
   * Numeric code: '7032'
   */
  SPORTING_RECREATION_CAMPS = "SPORTING_RECREATION_CAMPS",
  /**
   * The category for Sports and Riding Apparel Stores.
   *
   * Numeric code: '5655'
   */
  SPORTS_AND_RIDING_APPAREL_STORES = "SPORTS_AND_RIDING_APPAREL_STORES",
  /**
   * The category for Sports Clubs/Fields.
   *
   * Numeric code: '7941'
   */
  SPORTS_CLUBS_FIELDS = "SPORTS_CLUBS_FIELDS",
  /**
   * The category for Springhill Suites
   *
   * Numeric Code: '3770'
   */
  SPRINGHILL_SUITES = "SPRINGHILL_SUITES",
  /**
   * The category for Stakis Hotels
   *
   * Numeric Code: '3666'
   */
  STAKIS_HOTELS = "STAKIS_HOTELS",
  /**
   * The category for Stamp and Coin Stores.
   *
   * Numeric code: '5972'
   */
  STAMP_AND_COIN_STORES = "STAMP_AND_COIN_STORES",
  /**
   * The category for "Stationary, Office Supplies, Printing and Writing Paper".
   *
   * Numeric code: '5111'
   */
  STATIONARY_OFFICE_SUPPLIES_PRINTING_AND_WRITING_PAPER = "STATIONARY_OFFICE_SUPPLIES_PRINTING_AND_WRITING_PAPER",
  /**
   * The category for "Stationery Stores, Office, and School Supply Stores".
   *
   * Numeric code: '5943'
   */
  STATIONERY_STORES_OFFICE_AND_SCHOOL_SUPPLY_STORES = "STATIONERY_STORES_OFFICE_AND_SCHOOL_SUPPLY_STORES",
  /**
   * The category for Staybridge Suites
   *
   * Numeric Code: '3791'
   */
  STAYBRIDGE_SUITES = "STAYBRIDGE_SUITES",
  /**
   * The category for Steigenberger
   *
   * Numeric Code: '3643'
   */
  STEIGENBERGER = "STEIGENBERGER",
  /**
   * The category for Stratosphere Hotel And Casino
   *
   * Numeric Code: '3769'
   */
  STRATOSPHERE_HOTEL_AND_CASINO = "STRATOSPHERE_HOTEL_AND_CASINO",
  /**
   * The category for Studio Plus
   *
   * Numeric Code: '3626'
   */
  STUDIO_PLUS = "STUDIO_PLUS",
  /**
   * The category for St Regis Hotel
   *
   * Numeric Code: '3745'
   */
  ST_REGIS_HOTEL = "ST_REGIS_HOTEL",
  /**
   * The category for Sudan Airways
   *
   * Numeric Code: '3135'
   */
  SUDAN_AIRWAYS = "SUDAN_AIRWAYS",
  /**
   * The category for Suisse Chalet
   *
   * Numeric Code: '3686'
   */
  SUISSE_CHALET = "SUISSE_CHALET",
  /**
   * The category for Summerfield Suites Hotel
   *
   * Numeric Code: '3539'
   */
  SUMMERFIELD_SUITES_HOTEL = "SUMMERFIELD_SUITES_HOTEL",
  /**
   * The category for Sunbelt Airlines
   *
   * Numeric Code: '3133'
   */
  SUNBELT_AIRLINES = "SUNBELT_AIRLINES",
  /**
   * The category for Sunworld International
   *
   * Numeric Code: '3130'
   */
  SUNWORLD_AIR = "SUNWORLD_AIR",
  /**
   * The category for Sun Country Airlines
   *
   * Numeric Code: '3069'
   */
  SUN_COUNTRY_AIRLINES = "SUN_COUNTRY_AIRLINES",
  /**
   * The category for Super 8 Motel
   *
   * Numeric Code: '3709'
   */
  SUPER_8_MOTEL = "SUPER_8_MOTEL",
  /**
   * The category for Super Hotel
   *
   * Numeric code: '3863'
   */
  SUPER_HOTEL = "SUPER_HOTEL",
  /**
   * The category for Surinam Airways
   *
   * Numeric Code: '3129'
   */
  SURINAM_AIRWAYS = "SURINAM_AIRWAYS",
  /**
   * The category for Swallow Hotels
   *
   * Numeric Code: '3646'
   */
  SWALLOW_HOTELS = "SWALLOW_HOTELS",
  /**
   * The category for Swimming Pools Sales.
   *
   * Numeric code: '5996'
   */
  SWIMMING_POOLS_SALES = "SWIMMING_POOLS_SALES",
  /**
   * The category for Swissotel
   *
   * Numeric Code: '3634'
   */
  SWISSOTEL = "SWISSOTEL",
  /**
   * The category for Swiss Air
   *
   * Numeric Code: '3015'
   */
  SWISS_AIR = "SWISS_AIR",
  /**
   * The category for Taca International
   *
   * Numeric Code: '3127'
   */
  TACA_INTERNATIONAL_AIR = "TACA_INTERNATIONAL_AIR",
  /**
   * The category for "Tailors, Alterations".
   *
   * Numeric code: '5697'
   */
  TAILORS_ALTERATIONS = "TAILORS_ALTERATIONS",
  /**
   * The category for Taj Hotels Intl
   *
   * Numeric Code: '3659'
   */
  TAJ_HOTELS_INTL = "TAJ_HOTELS_INTL",
  /**
   * The category for Tal Air
   *
   * Numeric Code: '3126'
   */
  TAL_AIR = "TAL_AIR",
  /**
   * The category for Transportes Aeros Militares
   *
   * Numeric Code: '3221'
   */
  TAME_AIR = "TAME_AIR",
  /**
   * The category for Tam Airlines
   *
   * Numeric Code: '3248'
   */
  TAM_AIRLINES = "TAM_AIRLINES",
  /**
   * The category for Tan Sahsa (Tan Air)
   *
   * Numeric Code: '3125'
   */
  TAN_AIR = "TAN_AIR",
  /**
   * The category for TAP Air Portugal
   *
   * Numeric Code: '3035'
   */
  TAP_AIR_PORTUGAL = "TAP_AIR_PORTUGAL",
  /**
   * The category for Tarom Romanian Air Transport
   *
   * Numeric Code: '3297'
   */
  TAROM_AIR = "TAROM_AIR",
  /**
   * The category for Taxicabs/Limousines.
   *
   * Numeric code: '4121'
   */
  TAXICABS_LIMOUSINES = "TAXICABS_LIMOUSINES",
  /**
   * The category for Tax Payments - Government Agencies.
   *
   * Numeric code: '9311'
   */
  TAX_PAYMENTS_GOVERNMENT_AGENCIES = "TAX_PAYMENTS_GOVERNMENT_AGENCIES",
  /**
   * The category for Tax Preparation Services.
   *
   * Numeric code: '7276'
   */
  TAX_PREPARATION_SERVICES = "TAX_PREPARATION_SERVICES",
  /**
   * The category for Telecommunication Equipment and Telephone Sales.
   *
   * Numeric code: '4812'
   */
  TELECOMMUNICATION_EQUIPMENT_AND_TELEPHONE_SALES = "TELECOMMUNICATION_EQUIPMENT_AND_TELEPHONE_SALES",
  /**
   * The category for Telecommunication Services.
   *
   * Numeric code: '4814'
   */
  TELECOMMUNICATION_SERVICES = "TELECOMMUNICATION_SERVICES",
  /**
   * The category for Telegraph Services.
   *
   * Numeric code: '4821'
   */
  TELEGRAPH_SERVICES = "TELEGRAPH_SERVICES",
  /**
   * The category for Tent and Awning Shops.
   *
   * Numeric code: '5998'
   */
  TENT_AND_AWNING_SHOPS = "TENT_AND_AWNING_SHOPS",
  /**
   * The category for Testing Laboratories.
   *
   * Numeric code: '8734'
   */
  TESTING_LABORATORIES = "TESTING_LABORATORIES",
  /**
   * The category for Thai Airways
   *
   * Numeric Code: '3077'
   */
  THAI_AIRWAYS = "THAI_AIRWAYS",
  /**
   * The category for Theatrical Ticket Agencies.
   *
   * Numeric code: '7922'
   */
  THEATRICAL_TICKET_AGENCIES = "THEATRICAL_TICKET_AGENCIES",
  /**
   * The category for The Atlantic
   *
   * Numeric Code: '3805'
   */
  THE_ATLANTIC = "THE_ATLANTIC",
  /**
   * The category for The Diplomat Country Club And Spa
   *
   * Numeric Code: '3804'
   */
  THE_DIPLOMAT_COUNTRY_CLUB_AND_SPA = "THE_DIPLOMAT_COUNTRY_CLUB_AND_SPA",
  /**
   * The category for The Eliot Hotel
   *
   * Numeric Code: '3746'
   */
  THE_ELIOT_HOTEL = "THE_ELIOT_HOTEL",
  /**
   * The category for The Flamingo Hotels
   *
   * Numeric Code: '3793'
   */
  THE_FLAMINGO_HOTELS = "THE_FLAMINGO_HOTELS",
  /**
   * The category for The Luxury Collection
   *
   * Numeric code: '3846'
   */
  THE_LUXURY_COLLECTION = "THE_LUXURY_COLLECTION",
  /**
   * The category for The Palace Hotel
   *
   * Numeric Code: '3802'
   */
  THE_PALACE_HOTEL = "THE_PALACE_HOTEL",
  /**
   * The category for The Phoenician
   *
   * Numeric Code: '3632'
   */
  THE_PHOENICIAN = "THE_PHOENICIAN",
  /**
   * The category for The Roosevelt Hotel Ny
   *
   * Numeric Code: '3814'
   */
  THE_ROOSEVELT_HOTEL_NY = "THE_ROOSEVELT_HOTEL_NY",
  /**
   * The category for The Wigwam Golf Resort And Spa
   *
   * Numeric Code: '3803'
   */
  THE_WIGWAM_GOLF_RESORT_AND_SPA = "THE_WIGWAM_GOLF_RESORT_AND_SPA",
  /**
   * The category for Thrifty Car Rental
   *
   * Numeric Code: '3395'
   */
  THRIFTY_CAR_RENTAL = "THRIFTY_CAR_RENTAL",
  /**
   * The category for Thunderbird/Red Lion
   *
   * Numeric Code: '3528'
   */
  THUNDERBIRD_RED_LION = "THUNDERBIRD_RED_LION",
  /**
   * The category for "Turk Hava Yollar (Thy Airline)"
   *
   * Numeric Code: '3047'
   */
  THY_AIRLINE = "THY_AIRLINE",
  /**
   * The category for Tigerair
   *
   * Numeric Code: '3303'
   */
  TIGERAIR = "TIGERAIR",
  /**
   * The category for Tilden Rent A Car
   *
   * Numeric Code: '3396'
   */
  TILDEN_RENT_A_CAR = "TILDEN_RENT_A_CAR",
  /**
   * The category for Timeshares.
   *
   * Numeric code: '7012'
   */
  TIMESHARES = "TIMESHARES",
  /**
   * The category for Tire Retreading and Repair.
   *
   * Numeric code: '7534'
   */
  TIRE_RETREADING_AND_REPAIR = "TIRE_RETREADING_AND_REPAIR",
  /**
   * The category for Tokyo Group
   *
   * Numeric Code: '3522'
   */
  TOKYO_GROUP = "TOKYO_GROUP",
  /**
   * The category for Tokyu Harvestclub
   *
   * Numeric code: '3873'
   */
  TOKYU_HARVESTCLUB = "TOKYU_HARVESTCLUB",
  /**
   * The category for Tolls/Bridge Fees.
   *
   * Numeric code: '4784'
   */
  TOLLS_BRIDGE_FEES = "TOLLS_BRIDGE_FEES",
  /**
   * The category for Tourist Attractions and Exhibits.
   *
   * Numeric code: '7991'
   */
  TOURIST_ATTRACTIONS_AND_EXHIBITS = "TOURIST_ATTRACTIONS_AND_EXHIBITS",
  /**
   * The category for Tower Air
   *
   * Numeric Code: '3115'
   */
  TOWER_AIR = "TOWER_AIR",
  /**
   * The category for Towing Services.
   *
   * Numeric code: '7549'
   */
  TOWING_SERVICES = "TOWING_SERVICES",
  /**
   * The category for Towneplace Suites
   *
   * Numeric Code: '3740'
   */
  TOWNEPLACE_SUITES = "TOWNEPLACE_SUITES",
  /**
   * The category for Town And Country Resort And Convention Center
   *
   * Numeric Code: '3783'
   */
  TOWN_AND_COUNTRY_RESORT_AND_CONVENTION_CENTER = "TOWN_AND_COUNTRY_RESORT_AND_CONVENTION_CENTER",
  /**
   * The category for Tradewinds Resort
   *
   * Numeric Code: '3601'
   */
  TRADEWINDS_RESORT = "TRADEWINDS_RESORT",
  /**
   * The category for "Trailer Parks, Campgrounds".
   *
   * Numeric code: '7033'
   */
  TRAILER_PARKS_CAMPGROUNDS = "TRAILER_PARKS_CAMPGROUNDS",
  /**
   * The category for Transaero
   *
   * Numeric Code: '3089'
   */
  TRANSAERO = "TRANSAERO",
  /**
   * The category for Transportation Services (Not Elsewhere Classified).
   *
   * Numeric code: '4789'
   */
  TRANSPORTATION_SERVICES = "TRANSPORTATION_SERVICES",
  /**
   * The category for Trans World Airlines
   *
   * Numeric Code: '3004'
   */
  TRANS_WORLD_AIRLINES = "TRANS_WORLD_AIRLINES",
  /**
   * The category for Travelodge Motels
   *
   * Numeric Code: '3615'
   */
  TRAVELODGE_MOTELS = "TRAVELODGE_MOTELS",
  /**
   * The category for "Travel Agencies, Tour Operators".
   *
   * Numeric code: '4722'
   */
  TRAVEL_AGENCIES_TOUR_OPERATORS = "TRAVEL_AGENCIES_TOUR_OPERATORS",
  /**
   * The category for Treasure Island Hotel And Casino
   *
   * Numeric Code: '3555'
   */
  TREASURE_ISLAND_HOTEL_AND_CASINO = "TREASURE_ISLAND_HOTEL_AND_CASINO",
  /**
   * The category for Triangle Rent A Car
   *
   * Numeric Code: '3380'
   */
  TRIANGLE_RENT_A_CAR = "TRIANGLE_RENT_A_CAR",
  /**
   * The category for Tribeca Grand Hotel
   *
   * Numeric Code: '3569'
   */
  TRIBECA_GRAND_HOTEL = "TRIBECA_GRAND_HOTEL",
  /**
   * The category for Tribute Portfolio
   *
   * Numeric code: '3841'
   */
  TRIBUTE_PORTFOLIO = "TRIBUTE_PORTFOLIO",
  /**
   * The category for Tropical Rent A Car
   *
   * Numeric Code: '3385'
   */
  TROPICAL_RENT_A_CAR = "TROPICAL_RENT_A_CAR",
  /**
   * The category for Tropicana Resort And Casino
   *
   * Numeric Code: '3738'
   */
  TROPICANA_RESORT_AND_CASINO = "TROPICANA_RESORT_AND_CASINO",
  /**
   * The category for Truck StopIteration.
   *
   * Numeric code: '7511'
   */
  TRUCK_STOP_ITERATION = "TRUCK_STOP_ITERATION",
  /**
   * The category for Truck/Utility Trailer Rentals.
   *
   * Numeric code: '7513'
   */
  TRUCK_UTILITY_TRAILER_RENTALS = "TRUCK_UTILITY_TRAILER_RENTALS",
  /**
   * The category for Trusthouse Forte
   *
   * Numeric Code: '3505'
   */
  TRUSTHOUSE_FORTE = "TRUSTHOUSE_FORTE",
  /**
   * The category for Tunis Air
   *
   * Numeric Code: '3049'
   */
  TUNIS_AIR = "TUNIS_AIR",
  /**
   * The category for "Typesetting, Plate Making, and Related Services".
   *
   * Numeric code: '2791'
   */
  TYPESETTING_PLATE_MAKING_AND_RELATED_SERVICES = "TYPESETTING_PLATE_MAKING_AND_RELATED_SERVICES",
  /**
   * The category for Typewriter Stores.
   *
   * Numeric code: '5978'
   */
  TYPEWRITER_STORES = "TYPEWRITER_STORES",
  /**
   * The category for TUI Travel - Germany.
   *
   * Numeric code: '4723'
   */
  T_UI_TRAVEL_GERMANY = "T_UI_TRAVEL_GERMANY",
  /**
   * The category for Ugly Duckling Rent A Car
   *
   * Numeric Code: '3433'
   */
  UGLY_DUCKLING_RENT_A_CAR = "UGLY_DUCKLING_RENT_A_CAR",
  /**
   * The category for "Uniforms, Commercial Clothing".
   *
   * Numeric code: '5137'
   */
  UNIFORMS_COMMERCIAL_CLOTHING = "UNIFORMS_COMMERCIAL_CLOTHING",
  /**
   * The category for United Airlines
   *
   * Numeric Code: '3000'
   */
  UNITED_AIRLINES = "UNITED_AIRLINES",
  /**
   * The category for Uni Airways Corporation
   *
   * Numeric Code: '3090'
   */
  UNI_AIRWAYS_CORPORATION = "UNI_AIRWAYS_CORPORATION",
  /**
   * The category for Usa Rental
   *
   * Numeric Code: '3434'
   */
  USA_RENTAL = "USA_RENTAL",
  /**
   * The category for Used Merchandise and Secondhand Stores.
   *
   * Numeric code: '5931'
   */
  USED_MERCHANDISE_AND_SECONDHAND_STORES = "USED_MERCHANDISE_AND_SECONDHAND_STORES",
  /**
   * The category for US Airways
   *
   * Numeric Code: '3063'
   */
  US_AIRWAYS = "US_AIRWAYS",
  /**
   * The category for U.S. Air Shuttle
   *
   * Numeric Code: '3254'
   */
  US_AIR_SHUTTLE = "US_AIR_SHUTTLE",
  /**
   * The category for U.S. Federal Government Agencies or Departments.
   *
   * Numeric code: '9405'
   */
  US_FEDERAL_GOVERNMENT_AGENCIES_OR_DEPARTMENTS = "US_FEDERAL_GOVERNMENT_AGENCIES_OR_DEPARTMENTS",
  /**
   * The category for UTA/Interair
   *
   * Numeric Code: '3027'
   */
  UTA_INTERAIR = "UTA_INTERAIR",
  /**
   * The category for Utilities.
   *
   * Numeric code: '4900'
   */
  UTILITIES = "UTILITIES",
  /**
   * The category for Vagabond Hotels
   *
   * Numeric Code: '3575'
   */
  VAGABOND_HOTELS = "VAGABOND_HOTELS",
  /**
   * The category for Valley Airlines
   *
   * Numeric Code: '3118'
   */
  VALLEY_AIRLINES = "VALLEY_AIRLINES",
  /**
   * The category for Value Rent A Car
   *
   * Numeric Code: '3435'
   */
  VALUE_RENT_A_CAR = "VALUE_RENT_A_CAR",
  /**
   * The category for Vanguard Airlines
   *
   * Numeric Code: '3067'
   */
  VANGUARD_AIR = "VANGUARD_AIR",
  /**
   * The category for Variety Stores.
   *
   * Numeric code: '5331'
   */
  VARIETY_STORES = "VARIETY_STORES",
  /**
   * The category for Varig
   *
   * Numeric Code: '3018'
   */
  VARIG = "VARIG",
  /**
   * The category for Viacao Aerea Sao Pãulo (VASP)
   *
   * Numeric Code: '3036'
   */
  VASP_AIR = "VASP_AIR",
  /**
   * The category for Vdara
   *
   * Numeric Code: '3825'
   */
  VDARA = "VDARA",
  /**
   * The category for Venetian Resort Hotel And Casino
   *
   * Numeric Code: '3773'
   */
  VENETIAN_RESORT_HOTEL_AND_CASINO = "VENETIAN_RESORT_HOTEL_AND_CASINO",
  /**
   * The category for Venture Inn
   *
   * Numeric Code: '3574'
   */
  VENTURE_INN = "VENTURE_INN",
  /**
   * The category for Veterinary Services.
   *
   * Numeric code: '0742'
   */
  VETERINARY_SERVICES = "VETERINARY_SERVICES",
  /**
   * The category for Venezolana International De Aviacion
   *
   * Numeric Code: '3117'
   */
  VIASA_AIR = "VIASA_AIR",
  /**
   * The category for Video Amusement Game Supplies.
   *
   * Numeric code: '7993'
   */
  VIDEO_AMUSEMENT_GAME_SUPPLIES = "VIDEO_AMUSEMENT_GAME_SUPPLIES",
  /**
   * The category for Video Game Arcades.
   *
   * Numeric code: '7994'
   */
  VIDEO_GAME_ARCADES = "VIDEO_GAME_ARCADES",
  /**
   * The category for Video Tape Rental Stores.
   *
   * Numeric code: '7841'
   */
  VIDEO_TAPE_RENTAL_STORES = "VIDEO_TAPE_RENTAL_STORES",
  /**
   * The category for Villa Fontaine
   *
   * Numeric code: '3871'
   */
  VILLA_FONTAINE = "VILLA_FONTAINE",
  /**
   * The category for Virgin America
   *
   * Numeric Code: '3057'
   */
  VIRGIN_AMERICA = "VIRGIN_AMERICA",
  /**
   * The category for Virgin Atlantic
   *
   * Numeric Code: '3144'
   */
  VIRGIN_ATLANTIC = "VIRGIN_ATLANTIC",
  /**
   * The category for Virgin Express Air
   *
   * Numeric Code: '3188'
   */
  VIRGIN_EXPRESS_AIR = "VIRGIN_EXPRESS_AIR",
  /**
   * The category for Virgin River Hotel And Casino
   *
   * Numeric Code: '3708'
   */
  VIRGIN_RIVER_HOTEL_AND_CASINO = "VIRGIN_RIVER_HOTEL_AND_CASINO",
  /**
   * The category for VLM Airlines
   *
   * Numeric Code: '3131'
   */
  VLM_AIRLINES = "VLM_AIRLINES",
  /**
   * The category for Vocational/Trade Schools.
   *
   * Numeric code: '8249'
   */
  VOCATIONAL_TRADE_SCHOOLS = "VOCATIONAL_TRADE_SCHOOLS",
  /**
   * The category for Waldorf
   *
   * Numeric Code: '3831'
   */
  WALDORF = "WALDORF",
  /**
   * The category for Washington Hotel
   *
   * Numeric code: '3878'
   */
  WASHINGTON_HOTEL = "WASHINGTON_HOTEL",
  /**
   * The category for Watch/Jewelry Repair.
   *
   * Numeric code: '7631'
   */
  WATCH_JEWELRY_REPAIR = "WATCH_JEWELRY_REPAIR",
  /**
   * The category for Welcomgroup
   *
   * Numeric Code: '3524'
   */
  WELCOMGROUP = "WELCOMGROUP",
  /**
   * The category for Welding Repair.
   *
   * Numeric code: '7692'
   */
  WELDING_REPAIR = "WELDING_REPAIR",
  /**
   * The category for Wellesley Inns
   *
   * Numeric Code: '3748'
   */
  WELLESLEY_INNS = "WELLESLEY_INNS",
  /**
   * The category for Westin Hotels
   *
   * Numeric Code: '3513'
   */
  WESTIN_HOTELS = "WESTIN_HOTELS",
  /**
   * The category for Westjet Airlines
   *
   * Numeric Code: '3180'
   */
  WESTJET_AIRLINES = "WESTJET_AIRLINES",
  /**
   * The category for Whiskey Pete’S Hotel And Casino
   *
   * Numeric Code: '3762'
   */
  WHISKEY_PETES_HOTEL_AND_CASINO = "WHISKEY_PETES_HOTEL_AND_CASINO",
  /**
   * The category for Wholesale.
   *
   * Numeric code: '1002'
   */
  WHOLESALE = "WHOLESALE",
  /**
   * The category for Wholesale Clubs.
   *
   * Numeric code: '5300'
   */
  WHOLESALE_CLUBS = "WHOLESALE_CLUBS",
  /**
   * The category for Wideroes Flyveselskap
   *
   * Numeric Code: '3299'
   */
  WIDEROES = "WIDEROES",
  /**
   * The category for Wig and Toupee Stores.
   *
   * Numeric code: '5698'
   */
  WIG_AND_TOUPEE_STORES = "WIG_AND_TOUPEE_STORES",
  /**
   * The category for Wilderness Hotel And Resort
   *
   * Numeric Code: '3801'
   */
  WILDERNESS_HOTEL_AND_RESORT = "WILDERNESS_HOTEL_AND_RESORT",
  /**
   * The category for Windward Island Air
   *
   * Numeric Code: '3112'
   */
  WINDWARD_ISLAND_AIR = "WINDWARD_ISLAND_AIR",
  /**
   * The category for Wine Producers.
   *
   * Numeric code: '0743'
   */
  WINE_PRODUCERS = "WINE_PRODUCERS",
  /**
   * The category for Wings Airways
   *
   * Numeric Code: '3110'
   */
  WINGS_AIRWAYS = "WINGS_AIRWAYS",
  /**
   * The category for "Wires, Money Orders".
   *
   * Numeric code: '4829'
   */
  WIRES_MONEY_ORDERS = "WIRES_MONEY_ORDERS",
  /**
   * The category for Wizz Air
   *
   * Numeric Code: '3301'
   */
  WIZZ_AIR = "WIZZ_AIR",
  /**
   * The category for Women's Accessory and Specialty Shops.
   *
   * Numeric code: '5631'
   */
  WOMENS_ACCESSORY_AND_SPECIALTY_SHOPS = "WOMENS_ACCESSORY_AND_SPECIALTY_SHOPS",
  /**
   * The category for Women's Ready-To-Wear Stores.
   *
   * Numeric code: '5621'
   */
  WOMENS_READY_TO_WEAR_STORES = "WOMENS_READY_TO_WEAR_STORES",
  /**
   * The category for Woodside Hotels And Resorts
   *
   * Numeric Code: '3739'
   */
  WOODSIDE_HOTELS_AND_RESORTS = "WOODSIDE_HOTELS_AND_RESORTS",
  /**
   * The category for Wrecking and Salvage Yards.
   *
   * Numeric code: '5935'
   */
  WRECKING_AND_SALVAGE_YARDS = "WRECKING_AND_SALVAGE_YARDS",
  /**
   * The category for Wyndham
   *
   * Numeric Code: '3722'
   */
  WYNDHAM = "WYNDHAM",
  /**
   * The category for Wynn Las Vegas
   *
   * Numeric Code: '3596'
   */
  WYNN_LAS_VEGAS = "WYNN_LAS_VEGAS",
  /**
   * The category for W Hotels
   *
   * Numeric Code: '3779'
   */
  W_HOTELS = "W_HOTELS",
  /**
   * The category for Yutorelo
   *
   * Numeric code: '3869'
   */
  YUTORELO = "YUTORELO",
  /**
   * The category for Zambia Airways
   *
   * Numeric Code: '3094'
   */
  ZAMBIA_AIRWAYS = "ZAMBIA_AIRWAYS",
}

/** Input filter for querying data points for a Sankey diagram representing flows between account holders and merchant categories. */
export type MerchantCategoryCodeSankeyDataPointsFilterInput = {
  /** Required identifier to filter data specific to an account holder. */
  accountHolderId: Scalars["ID"];
  /** Date range for filtering Sankey data points. */
  createdAt: TimestampFilterInput;
};

/** Union type for the Sankey data points query response, which can include data points, user errors, or access denial messages. */
export type MerchantCategoryCodeSankeyDataPointsPayload =
  | AccessDeniedError
  | SankeyDataPoints
  | UserError;

/** A representation of the merchant category that includes the category, the code and a display name. */
export type MerchantCategoryDetails = {
  __typename?: "MerchantCategoryDetails";
  /** The display name of the merchant category. */
  displayName?: Maybe<Scalars["String"]>;
  /** The merchant category enum. */
  merchantCategory?: Maybe<MerchantCategory>;
  /** The merchant category enum number representation. */
  merchantCategoryCode?: Maybe<Scalars["String"]>;
};

/** A container for a list of merchant category details. */
export type MerchantCategoryDetailsContainer = {
  __typename?: "MerchantCategoryDetailsContainer";
  /** A list of merchant category details. */
  merchantCategoryDetails?: Maybe<Array<MerchantCategoryDetails>>;
};

/** Input for filtering merchant category */
export type MerchantCategoryFilterInput = {
  /** Value matches the provided merchant category. */
  equals?: InputMaybe<MerchantCategory>;
  /** Value does not match any of the provided merchant category. */
  excludes?: InputMaybe<Array<MerchantCategory>>;
  /** Value exactly matches all of the provided merchant category. */
  includes?: InputMaybe<Array<MerchantCategory>>;
  /** Value does not match the provided merchant category. */
  notEquals?: InputMaybe<MerchantCategory>;
};

/** A Spend Control rule that allows or blocks certain merchant categories codes (MCC) during authorizations. */
export type MerchantCategorySpendRule = Node &
  SpendRule & {
    __typename?: "MerchantCategorySpendRule";
    /** The merchant categories that will be allowed during authorizations. */
    allowed?: Maybe<Array<MerchantCategory>>;
    /** The merchant category codes that will be allowed during authorizations. */
    allowedMcc?: Maybe<Array<Scalars["String"]>>;
    /** The merchant categories that will result in declined authorizations. */
    blocked?: Maybe<Array<MerchantCategory>>;
    /** The merchant category codes that will result in declined authorizations. */
    blockedMcc?: Maybe<Array<Scalars["String"]>>;
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the Merchant Category Spend Rule in operations. */
    id: Scalars["ID"];
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/** A Spend Control rule that allows or blocks certain merchant categories codes (MCC) during authorizations. */
export type MerchantCategorySpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The result of applying a merchant category spend rule to an event. */
export type MerchantCategorySpendRuleResult = SpendRuleResult & {
  __typename?: "MerchantCategorySpendRuleResult";
  /** The attached level. */
  attachedLevel?: Maybe<AttachedLevel>;
  /** A message describing the result. */
  message?: Maybe<Scalars["String"]>;
  /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
  recommendation?: Maybe<SpendRuleRecommendation>;
  /** The spend rule attached at the time of the event. */
  spendRule?: Maybe<MerchantCategorySpendRule>;
  /** The merchant category of the event. */
  valuesTested?: Maybe<Array<MerchantCategory>>;
};

/** A Spend Control rule that allows or blocks certain merchant countries during authorizations. */
export type MerchantCountrySpendRule = Node &
  SpendRule & {
    __typename?: "MerchantCountrySpendRule";
    /** The merchant countries that will be allowed during authorizations. */
    allowed?: Maybe<Array<Iso3166Alpha3Country>>;
    /** The merchant countries that will result in declined authorizations. */
    blocked?: Maybe<Array<Iso3166Alpha3Country>>;
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the Merchant Category Spend Rule in operations. */
    id: Scalars["ID"];
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/** A Spend Control rule that allows or blocks certain merchant countries during authorizations. */
export type MerchantCountrySpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The result of applying a merchant country spend rule to an event. */
export type MerchantCountrySpendRuleResult = SpendRuleResult & {
  __typename?: "MerchantCountrySpendRuleResult";
  /** The attached level. */
  attachedLevel?: Maybe<AttachedLevel>;
  /** A message describing the result. */
  message?: Maybe<Scalars["String"]>;
  /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
  recommendation?: Maybe<SpendRuleRecommendation>;
  /** The spend rule attached at the time of the event. */
  spendRule?: Maybe<MerchantCountrySpendRule>;
  /** The merchant country of the event. */
  valuesTested?: Maybe<Array<Iso3166Alpha3Country>>;
};

/** Used to represent merchant descriptor data. */
export type MerchantDescriptorInput = {
  /**
   * The suffix to append to the merchant descriptor that appears on transaction details.
   *  The combined descriptor (prefix + suffix) has a maximum length of 22 characters. If the combined length exceeds this limit, the suffix will be truncated.
   */
  suffix?: InputMaybe<Scalars["String"]>;
};

/** The details about the merchant who requested the authorization. */
export type MerchantDetails = {
  __typename?: "MerchantDetails";
  /** The address of the merchant. */
  address?: Maybe<Address>;
  /** The merchant category for the authorization. */
  category?: Maybe<MerchantCategory>;
  /** The merchant category code for the authorization. */
  categoryCode?: Maybe<Scalars["String"]>;
  /** The merchant country code for the authorization. */
  countryCodeAlpha3?: Maybe<Iso3166Alpha3Country>;
  /** The description. a.k.a. "Descriptor". */
  description?: Maybe<Scalars["String"]>;
  /** The merchant identifier. */
  merchantId?: Maybe<Scalars["String"]>;
  /** The merchant or institution name. */
  name?: Maybe<Scalars["String"]>;
  /** Sub-merchant identifier for the transaction. */
  subMerchantIdentifier?: Maybe<Scalars["String"]>;
};

/** Input representing the parts of an address for a `MerchantDetails` input. */
export type MerchantDetailsAddressInput = {
  /** The [three letter country code](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3) where the address resides. */
  countryCodeAlpha3: Iso3166Alpha3Country;
  /**
   * The locality of the address up to 13 characters (e.g. town, city)
   *
   * The validation for the `locality` uses the following regex pattern `^['\p{L}]+(?:[ \p{L},'-:])*$`.
   *
   * It checks to ensure it begins with a single quote or any letter, followed by whitespace, commas, single quote, any letter, or character in this set '()*+,-./0123456789: .
   */
  locality: Scalars["String"];
  /** The postal code of the address. The value can include 5 numbers only or a hyphen - and 4 numbers. */
  postalCode: Scalars["String"];
  /** A region for the address based on the two letter state, including districts and outlying areas. */
  region: Scalars["String"];
};

/** Inputs for filtering merchant details. */
export type MerchantDetailsFilterInput = {
  /** The merchant category for the authorization. */
  category?: InputMaybe<MerchantCategoryFilterInput>;
  /** The merchant country code */
  countryCodeAlpha3?: InputMaybe<Iso3166Alpha3Country>;
  /** The merchant description */
  description?: InputMaybe<StringSearchFilterInput>;
  /** The merchant or institution name. */
  name?: InputMaybe<StringSearchFilterInput>;
};

/**
 * Details to set about a Merchant submitting the authorization.
 *
 * You can use these details to test merchant specific spend rules.
 */
export type MerchantDetailsInput = {
  /** Represents the address of the merchant as sent by the acquirer. */
  address?: InputMaybe<MerchantDetailsAddressInput>;
  /** The merchant category for the authorization. */
  category?: InputMaybe<MerchantCategory>;
  /** The merchant country code for the authorization. */
  countryCodeAlpha3?: InputMaybe<Iso3166Alpha3Country>;
  /** The description. a.k.a. "Descriptor" */
  description?: InputMaybe<Scalars["String"]>;
  /** The unique ID assigned by the merchant's acquirer to identify the merchant account. This is also referred to as the MID. */
  merchantId?: InputMaybe<Scalars["String"]>;
  /**
   * The merchant or institution name.
   * **Maximum length:** 25 characters
   */
  name?: InputMaybe<Scalars["String"]>;
  /**
   * Sub-merchant identifier for the transaction.
   * **Maximum length:** 15
   */
  subMerchantIdentifier?: InputMaybe<Scalars["String"]>;
};

/** Input filter for querying detailed Sankey diagram data points, including flows between account holders, merchant categories, and merchants. */
export type MerchantDrilldownSankeyDataPointsFilterInput = {
  /** Filter for data points under a specific merchant category code. */
  merchantCategoryCode: StringFilterInput;
  /**
   * Required filter for querying data points for a Sankey diagram representing flows between account holders and merchant
   * categories.
   */
  sankeyDataPointsFilter: MerchantCategoryCodeSankeyDataPointsFilterInput;
};

/** Union type for the detailed Sankey data points query response, which can include data points, user errors, or access denial messages. */
export type MerchantDrilldownSankeyDataPointsPayload =
  | AccessDeniedError
  | SankeyDataPoints
  | UserError;

/** A fee associated for the merchant to process the `PaymentTransaction`. */
export type MerchantFeePaymentTransactionFee = PaymentTransactionFee & {
  __typename?: "MerchantFeePaymentTransactionFee";
  /**
   * The direction the fees are moving in the perspective of the subscriber.
   * * when DEBIT, this fee is deducted from the total payable amount.
   * * when CREDIT, this fee is credited to the total payable amount.
   */
  accountingDirection?: Maybe<AccountingDirection>;
  /** The amount of the fee. */
  feeAmount?: Maybe<Amount>;
};

/**
 * A Spend Control rule that allows or blocks authorizations based on merchant identifier.
 *
 * A merchant identifier is typically a numeric string representing the merchant in an acquirer's or network's system.
 */
export type MerchantIdentifierSpendRule = Node &
  SpendRule & {
    __typename?: "MerchantIdentifierSpendRule";
    /** The merchant identifiers that will be allowed during authorizations. */
    allowed?: Maybe<Array<Scalars["String"]>>;
    /**
     * The merchant identifiers you want to block during authorizations.
     *
     * Matching values will result in a declined authorization.
     */
    blocked?: Maybe<Array<Scalars["String"]>>;
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the spend rule in operations. */
    id: Scalars["ID"];
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/**
 * A Spend Control rule that allows or blocks authorizations based on merchant identifier.
 *
 * A merchant identifier is typically a numeric string representing the merchant in an acquirer's or network's system.
 */
export type MerchantIdentifierSpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The result of applying a merchant identifier spend rule to an event. */
export type MerchantIdentifierSpendRuleResult = SpendRuleResult & {
  __typename?: "MerchantIdentifierSpendRuleResult";
  /** The attached level. */
  attachedLevel?: Maybe<AttachedLevel>;
  /** A message describing the result. */
  message?: Maybe<Scalars["String"]>;
  /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
  recommendation?: Maybe<SpendRuleRecommendation>;
  /** The spend rule attached at the time of the event. */
  spendRule?: Maybe<MerchantIdentifierSpendRule>;
  /** The merchant identifiers of the event. */
  valuesTested?: Maybe<Array<Scalars["String"]>>;
};

/** Information about a merchant-managed installment payment plan. */
export type MerchantManagedInstallmentPayment = {
  __typename?: "MerchantManagedInstallmentPayment";
  /**
   * The `PaymentTransaction` from the first installment payment.
   * Used to link all subsequent installment payments in the series.
   */
  firstInstallmentPaymentTransaction?: Maybe<PaymentTransaction>;
  /** The date of first installment payment, in ISO 8601 format (YYYY-MM-DD). */
  firstPaymentDate?: Maybe<Scalars["String"]>;
  /** The frequency at which payments occur. */
  frequency?: Maybe<InstallmentFrequency>;
  /** The total amount that has been funded so far in the plan. */
  fundedAmount?: Maybe<Amount>;
  /** Network-specific installment payment data. */
  networkData?: Maybe<InstallmentNetworkData>;
  /** The total number of payments in the plan. */
  numberOfInstallments?: Maybe<Scalars["UnsignedInt"]>;
  /** The amount for each individual payment. */
  paymentAmount?: Maybe<Amount>;
  /** The number of this installment payment. */
  paymentNumber?: Maybe<Scalars["UnsignedInt"]>;
  /** The total amount across all payments in the plan. */
  totalAmount?: Maybe<Amount>;
};

/** Information about a merchant-managed installment payment plan. */
export type MerchantManagedInstallmentPaymentInput = {
  /**
   * The `PaymentTransaction` ID from the first installment payment.
   * Used to link all subsequent installment payments in the series.
   */
  firstInstallmentPaymentTransactionId?: InputMaybe<Scalars["ID"]>;
  /** The date of first installment payment, in ISO 8601 format (YYYY-MM-DD). */
  firstPaymentDate: Scalars["String"];
  /** The frequency at which payments occur. */
  frequency: InstallmentFrequency;
  /** Optional: The total amount that has been funded so far in the plan. */
  fundedAmount?: InputMaybe<AmountInput>;
  /** Network-specific installment payment data. */
  networkData?: InputMaybe<InstallmentNetworkDataInput>;
  /** The total number of installment payments in the plan. */
  numberOfInstallments: Scalars["UnsignedInt"];
  /** The amount for each individual payment. */
  paymentAmount: AmountInput;
  /** The number of this installment payment. */
  paymentNumber: Scalars["UnsignedInt"];
  /** The total amount across all installment payments in the plan. */
  totalAmount: AmountInput;
};

/** Whether or not the `FinancialAccount` supports merchant settlement. */
export type MerchantSettlementFinancialAccountFeature =
  FinancialAccountFeature & {
    __typename?: "MerchantSettlementFinancialAccountFeature";
    /** The date and time, in ISO 8601 format, the feature was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective from. */
    effectiveFrom?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective through. */
    effectiveThrough?: Maybe<Scalars["String"]>;
    /** Whether or not the feature is enabled for the Financial Account. */
    enabled?: Maybe<Scalars["Boolean"]>;
    /** The date and time, in ISO 8601 format, the feature was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** The Military Lending Act (MLA) configuration. */
export type MilitaryLendingActConfiguration = {
  __typename?: "MilitaryLendingActConfiguration";
  /** The date and time, in ISO 8601 format, this was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date this `MilitaryLendingActConfiguration` starts to be in effect, in YYYY-MM-DD (ISO 8601 RFC 3339) date format. For example, `2023-01-15`. */
  effectiveFrom?: Maybe<Scalars["Date"]>;
  /** The date this `MilitaryLendingActConfiguration` stops being in effect, in YYYY-MM-DD (ISO 8601 RFC 3339) date format. For example, `2023-01-15`. Optional; if not present, this configuration is treated as indefinite, with no set end date. */
  effectiveThrough?: Maybe<Scalars["Date"]>;
  /** The date and time when this was updated, in ISO 8601 format. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The input for creating a minimal `USAuthorizedPerson` */
export type MinimalUsAuthorizedPersonInput = {
  /** Authorized person's title. */
  authorizingPersonTitle?: InputMaybe<BusinessTitle>;
  /**
   * Date of birth in YYYY-MM-DD format.
   * **Minimum age:** 18 years. **Maximum age:** 100 years, in place to combat fraud and potential elder financial abuse.
   */
  dateOfBirth: Scalars["String"];
  /**
   * The authorized person's e-mail address.
   *
   * **Note:** Highnote does not verify the e-mail address.
   */
  email?: InputMaybe<Scalars["String"]>;
  /**
   * The authorized person's U.S. physical address.
   *
   * Provide either `homeAddress` or `homeAddressToken`, but not both.
   */
  homeAddress?: InputMaybe<AddressInput>;
  /**
   * A token representing the authorized person's U.S. physical address.
   *
   * Provide either `homeAddress` or `homeAddressToken`, but not both.
   */
  homeAddressToken?: InputMaybe<Scalars["ID"]>;
  /** The identification document used to verify the authorized person. */
  identificationDocument?: InputMaybe<UsIdentificationDocumentInput>;
  /** The authorized person's legal name. */
  name: UsAssociatedPersonNameInput;
  /** Percentage ownership of this authorized person in business if any. */
  percentageOwnership?: InputMaybe<Scalars["Int"]>;
  /** The primary phone number for this authorized person. */
  phoneNumber?: InputMaybe<PhoneInput>;
};

/** Input fields for creating a `USBusinessProfile` with minimum required details. */
export type MinimalUsBusinessProfileInput = {
  /**
   * The business' U.S. billing address.
   *
   * Exactly one of `billingAddress` or `billingAddressToken` must be provided.
   */
  billingAddress?: InputMaybe<AddressInput>;
  /**
   * A token representing the business' U.S. billing address.
   *
   * Exactly one of `billingAddress` or `billingAddressToken` must be provided.
   */
  billingAddressToken?: InputMaybe<Scalars["ID"]>;
  /** The business' credit risk attributes. Only used for unsecured credit applications. */
  businessCreditRiskAttributes?: InputMaybe<BusinessCreditRiskAttributesInput>;
  /**
   * A short description of what the business does, its purpose, and the products or services it provides.
   *
   * Max length: 140 characters.
   * Min length: 1 character.
   * Input Regex Validation: `^[a-zA-Z\d$ ',.\-\_!@#$%^&*+=`?"\n]+$`
   */
  businessDescription?: InputMaybe<Scalars["String"]>;
  /** Type of business. */
  businessType: BusinessStructure;
  /**
   * Business identification document such as employer identification number in USA.
   *
   * A business identification document is not required for SOLE_PROPRIETORSHIP.
   *
   * Highnote recommends passing an identification document when available to streamline the onboarding and future product approval processes.
   */
  identificationDocument?: InputMaybe<UsBusinessIdentificationDocumentInput>;
  /**
   * The address supplied for the business' registration.
   * Supplying the address associated with the business primary SOS filing location is recommended.
   *
   * **Note**:  Depending on the product that the Account Holder is applying for, the legal entity address may be required.
   * During your implementation review, requirements around conditionally mandatory fields will be outlined.
   */
  legalAddress?: InputMaybe<AddressInput>;
  /** The business' name fields. */
  name: BusinessAccountHolderNameInput;
  /** The primary phone number for this business. */
  phoneNumber?: InputMaybe<PhoneInput>;
  /** Ultimate beneficial owners of business information */
  ultimateBeneficialOwners?: InputMaybe<
    Array<MinimalUsUltimateBeneficialOwnerInput>
  >;
  /**
   * Business website URL.
   *
   * The validation for the `website` URL uses the following regex pattern `^((((https?|ftps?|gopher|telnet|nntp)://)|(mailto:|news:))(%[0-9A-Fa-f]{2}|[-()_.!~*';/?:@&=+$,A-Za-z0-9])+)([).!';/?:,][[:blank:|:blank:]])?$`
   */
  website?: InputMaybe<Scalars["String"]>;
};

/** Input fields for creating a `USUltimateBeneficialOwner` with minimal information. */
export type MinimalUsUltimateBeneficialOwnerInput = {
  /**
   * Date of birth in YYYY-MM-DD format.
   * **Minimum age:** 18 years. **Maximum age:** 100 years, in place to combat fraud and potential elder financial abuse.
   */
  dateOfBirth: Scalars["String"];
  /**
   * The ultimate beneficial owner's e-mail address.
   *
   * **Note:** Highnote does not verify the e-mail address.
   */
  email?: InputMaybe<Scalars["String"]>;
  /**
   * The ultimate beneficial owner's U.S. physical address.
   *
   * Provide either `homeAddress` or `homeAddressToken`, but not both.
   */
  homeAddress?: InputMaybe<AddressInput>;
  /**
   * A token representing the ultimate beneficial owner's U.S. physical address.
   *
   * Provide either `homeAddress` or `homeAddressToken`, but not both.
   */
  homeAddressToken?: InputMaybe<Scalars["ID"]>;
  /** The identification document used to verify the ultimate beneficial owner. */
  identificationDocument?: InputMaybe<UsIdentificationDocumentInput>;
  /** The ultimate beneficial owner's legal name. */
  name: UsAssociatedPersonNameInput;
  /**
   * Percentage ownership of this ultimate beneficial owner in business if any.
   * **Minimum percentage ownership:** 25%
   */
  percentageOwnership?: InputMaybe<Scalars["Int"]>;
  /** The primary phone number for this ultimate beneficial owner. */
  phoneNumber?: InputMaybe<PhoneInput>;
};

/** A Spend Control rule that only allows transactions for a specified amount. */
export type MinimumAmountLimitSpendRule = Node &
  SpendRule & {
    __typename?: "MinimumAmountLimitSpendRule";
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the `MinimumAmountLimitSpendRule` in operations. */
    id: Scalars["ID"];
    /** The exact amount to allow for a single transaction. */
    minimumAmount?: Maybe<Amount>;
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/** A Spend Control rule that only allows transactions for a specified amount. */
export type MinimumAmountLimitSpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The result of applying a `MinimumAmountLimitSpendRule` to an event. */
export type MinimumAmountLimitSpendRuleResult = SpendRuleResult & {
  __typename?: "MinimumAmountLimitSpendRuleResult";
  /** The attached level. */
  attachedLevel?: Maybe<AttachedLevel>;
  /** A message describing the result. */
  message?: Maybe<Scalars["String"]>;
  /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
  recommendation?: Maybe<SpendRuleRecommendation>;
  /** The spend rule attached at the time of the event. */
  spendRule?: Maybe<MinimumAmountLimitSpendRule>;
  /** The tested `Amount` of the event. */
  valuesTested?: Maybe<Array<Amount>>;
};

/** Money value type */
export type MoneyFilterInput = {
  /** Filter to values that fall between the provided `UnsignedInts`. */
  between?: InputMaybe<MoneyFilterInputRange>;
  currencyCode: Iso4217Alpha3CurrencyCode;
  /** A value that exactly matches the provided `UnsignedInt`. */
  equals?: InputMaybe<Scalars["UnsignedInt"]>;
  /** Filter to values that do not match any of the provided `UnsignedInts`. */
  excludes?: InputMaybe<Array<Scalars["UnsignedInt"]>>;
  /** A value to filter to numbers greater than the given `UnsignedInt`. */
  greaterThan?: InputMaybe<Scalars["UnsignedInt"]>;
  /** A value to filter to numbers greater than or equal to the given `UnsignedInt`. */
  greaterThanOrEquals?: InputMaybe<Scalars["UnsignedInt"]>;
  /** Filter to values that exactly match any of the provided `UnsignedInts`. */
  includes?: InputMaybe<Array<Scalars["UnsignedInt"]>>;
  /** A value to filter to numbers less than the given `UnsignedInt`. */
  lessThan?: InputMaybe<Scalars["UnsignedInt"]>;
  /** A value to filter to numbers less than or equal to the given `UnsignedInt`. */
  lessThanOrEquals?: InputMaybe<Scalars["UnsignedInt"]>;
  /** A value that does not exactly match the provided `UnsignedInt`. */
  notEquals?: InputMaybe<Scalars["UnsignedInt"]>;
};

/** Money value range (inclusive) */
export type MoneyFilterInputRange = {
  /** An `UnsignedInt` value (inclusive) for the end of the range. */
  end?: InputMaybe<Scalars["UnsignedInt"]>;
  /** An `UnsignedInt` value (inclusive) for the beginning of the range. */
  start?: InputMaybe<Scalars["UnsignedInt"]>;
};

export type MoneyMovementProductFeature = ProductFeature & {
  __typename?: "MoneyMovementProductFeature";
  /** The date and time, in ISO 8601 format, this `ProductFeature` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, this `ProductFeature` was effective from. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, this `ProductFeature` was effective through. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Whether or not this `ProductFeature` is enabled for the `Product`. */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** The date and time, in ISO 8601 format, this `ProductFeature` was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** A month in the calendar year. */
export enum Month {
  /**
   * The month of April
   *
   * Represented numerically as `04`
   */
  APRIL = "APRIL",
  /**
   * The month of August
   *
   * Represented numerically as `08`
   */
  AUGUST = "AUGUST",
  /**
   * The month of December
   *
   * Represented numerically as `12`
   */
  DECEMBER = "DECEMBER",
  /**
   * The month of February
   *
   * Represented numerically as `02`
   */
  FEBRUARY = "FEBRUARY",
  /**
   * The month of January
   *
   * Represented numerically as `01`
   */
  JANUARY = "JANUARY",
  /**
   * The month of July
   *
   * Represented numerically as `07`
   */
  JULY = "JULY",
  /**
   * The month of June
   *
   * Represented numerically as `06`
   */
  JUNE = "JUNE",
  /**
   * The month of March
   *
   * Represented numerically as `03`
   */
  MARCH = "MARCH",
  /**
   * The month of May
   *
   * Represented numerically as `05`
   */
  MAY = "MAY",
  /**
   * The month of November
   *
   * Represented numerically as `11`
   */
  NOVEMBER = "NOVEMBER",
  /**
   * The month of October
   *
   * Represented numerically as `10`
   */
  OCTOBER = "OCTOBER",
  /**
   * The month of September
   *
   * Represented numerically as `09`
   */
  SEPTEMBER = "SEPTEMBER",
}

/** Root Mutation type extending the main GraphQL schema. */
export type Mutation = {
  __typename?: "Mutation";
  /** Accept an extended `AccountHolderCardProductApplicationOffer`. */
  acceptAccountHolderCardProductApplicationOffer?: Maybe<AccountHolderCardProductApplicationOffersPayload>;
  /** Activate a `CreditPlan` for a `CardProduct`. */
  activateCardProductCreditPlan?: Maybe<ActivateCardProductCreditPlanPayload>;
  /** Activate a `CollaborativeAuthorizationEndpoint`. */
  activateCollaborativeAuthorizationEndpoint?: Maybe<ActivateCollaborativeAuthorizationEndpointPayload>;
  /** Activate an `InstallmentAgreement` for a `Transaction` by providing a `TransactionEvent`. */
  activateInstallmentAgreementForTransactionEvent?: Maybe<ActivateInstallmentAgreementForTransactionEventPayload>;
  /** Reactivates a previously deactivated notification target. */
  activateNotificationTarget?: Maybe<ActivateNotificationTargetPayload>;
  /** Activate a Payment Card. */
  activatePaymentCard?: Maybe<ActivatePaymentCardPayload>;
  /**
   * Add a `CollaborativeAuthorizationEndpoint` for use in real-time transaction authorization.
   *
   * You are able to create up to 5 `CollaborativeAuthorizationEndpoints`, but only one may be active at a time.
   *
   * By default, the created endpoint is _not_ active. You must call the `activateCollaborativeAuthorizationEndpoint` mutation.
   */
  addCollaborativeAuthorizationEndpoint?: Maybe<AddCollaborativeAuthorizationEndpointPayload>;
  /**
   * Add a bank account for account holder using external token.
   * @deprecated Use Mutation.addExternalBankAccountVerifiedThroughPlaid instead.
   */
  addExternalBankAccountFromToken?: Maybe<AddExternalBankAccountFromTokenPayload>;
  /** Add a bank account for account holder using external token. (Finicity specific) */
  addExternalBankAccountVerifiedThroughFinicity?: Maybe<AddExternalBankAccountFromTokenPayload>;
  /** Add a bank account for account holder using external token. (Plaid specific) */
  addExternalBankAccountVerifiedThroughPlaid?: Maybe<AddExternalBankAccountFromTokenPayload>;
  /**
   * Add a bank account for account holder using external tokens. (Third Party with Plaid specific)
   * This is only usable for specific products within the `CONSUMER_CREDIT` vertical.
   */
  addExternalBankAccountVerifiedThroughPlaidUsingThirdPartyProcessorToken?: Maybe<AddExternalBankAccountFromTokenPayload>;
  /**
   * Transfer funds from a funding account of the Organization to a payment card.
   * @deprecated Transfer is deprecated in favor of initiateTransferFromFundingFinancialAccountToPaymentCardFinancialAccount
   */
  addFundsToPaymentCard?: Maybe<AddFundsToPaymentCardPayload>;
  /** Add a non-verified US bank account for an account holder.  Can only be used to initiateFundsWithdrawalACHTransfer */
  addNonVerifiedExternalUSFinancialBankAccount?: Maybe<AddNonVerifiedExternalUsFinancialBankAccountPayload>;
  /** Request encrypted and activation data required to push provision a `PaymentCard` directly from your mobile application to an Apple Pay enabled device. */
  addPaymentCardToApplePayByDevicePushProvisioning?: Maybe<AddPaymentCardDigitalWalletTokenApplePayDevicePushProvisioningPayload>;
  /** Request encrypted and activation data required to push provision a `PaymentCard` directly from your mobile application to a Google Pay enabled device. */
  addPaymentCardToGooglePayByDevicePushProvisioning?: Maybe<AddPaymentCardDigitalWalletTokenGooglePayPushProvisioningPayload>;
  /** Adds subscriptions to a notification target. */
  addSubscriptionsToNotificationTarget?: Maybe<AddSubscriptionsToNotificationTargetPayload>;
  /**
   * Adds a relationship between a `UserDefinedFieldDefinition` and the given
   * entity type.
   */
  addUserDefinedFieldDefinitionRelationship?: Maybe<UserDefinedFieldDefinitionPayload>;
  /** Adds a new https target for webhook notifications. */
  addWebhookNotificationTarget?: Maybe<AddWebhookNotificationTargetPayload>;
  /** Once a decision has been reached to approve a credit limit decrease, use this mutation to update the `CreditLimitChangeRequest` and provide the adverse action reason (if applicable) and other details. */
  approveCreditLimitDecrease?: Maybe<CreditLimitChangeRequestPayload>;
  /** Once a decision has been reached to approve a credit limit increase, use this decision to update the `CreditLimitChangeRequest` and provide the updated credit limit and other details. */
  approveCreditLimitIncrease?: Maybe<CreditLimitChangeRequestPayload>;
  /** Approve a credit-based `AccountHolderCardProductApplication`. */
  approveCreditProductApplicationUnderwriting?: Maybe<ApproveCreditProductApplicationUnderwritingPayload>;
  /**
   * Assigns a `PaymentCard` to a `FinancialAccount`.
   *
   * This is used in addition to the `issuePreprintedPaymentCardFinancialAccountForApplication` mutation.
   */
  assignPaymentCardToFinancialAccount?: Maybe<AssignPaymentCardToFinancialAccountPayload>;
  /** Attach a `VelocityRule` to a `CardProduct` */
  attachCardProductVelocityRule?: Maybe<AttachCardProductVelocityRulePayload>;
  /** Attach a fee to a `CreditPlan`. */
  attachFeeToCreditPlan?: Maybe<AttachFeeToCreditPlanPayload>;
  /** Attach a `VelocityRule` to a `PaymentCard` */
  attachPaymentCardVelocityRule?: Maybe<AttachPaymentCardVelocityRulePayload>;
  /**
   * Attaches a realtime risk rule to the given Card Product. The risk rule will be evaluated in realtime for every authorization
   * on a payment card issued under the card product.
   */
  attachRealtimeRiskRuleToCardProduct?: Maybe<AttachRealtimeRiskRuleToCardProductPayload>;
  /** Attaches a realtime risk rule to the given Financial Account. The risk rule will be evaluated in realtime for every authorization. */
  attachRealtimeRiskRuleToFinancialAccount?: Maybe<AttachRealtimeRiskRuleToFinancialAccountPayload>;
  /** Attaches a realtime risk rule to the given Payment Card. The risk rule will be evaluated in realtime for every authorization. */
  attachRealtimeRiskRuleToPaymentCard?: Maybe<AttachRealtimeRiskRuleToPaymentCardPayload>;
  /** Attach a reward earn rule to a product. */
  attachRewardEarnRuleToProduct?: Maybe<AttachRewardEarnRuleToProductPayload>;
  /** Attach Reward `RewardRedemptionConfiguration` to a `CardProduct`. */
  attachRewardRedemptionConfigurationToProduct?: Maybe<AttachRewardRedemptionConfigurationToProductPayload>;
  /**
   * Attaches a spend rule to the given Card Product. The spend rule will be evaluated for every authorization
   * on a payment card issued under the card product.
   */
  attachSpendRuleToCardProduct?: Maybe<AttachSpendRuleToCardProductPayload>;
  /** Attaches a spend rule to the given `FinancialAccount`. The spend control rule will be evaluated for every authorization. */
  attachSpendRuleToFinancialAccount?: Maybe<AttachSpendRuleToFinancialAccountPayload>;
  /** Attaches a spend control rule to the given Payment Card. The spend control rule will be evaluated for every authorization. */
  attachSpendRuleToPaymentCard?: Maybe<AttachSpendRuleToPaymentCardPayload>;
  /** Attach a `VelocityRule` to a `FinancialAccount` */
  attachVelocityRuleToFinancialAccount?: Maybe<AttachVelocityRuleToFinancialAccountPayload>;
  /** Authorizes a `NetworkToken` for later capture. */
  authorizeNetworkToken?: Maybe<AuthorizeNetworkTokenPayload>;
  /** Authorizes a `PaymentCard` for later capture. */
  authorizePaymentCard?: Maybe<AuthorizePaymentCardPayload>;
  /** Authorizes a `PaymentMethodToken` for later capture. */
  authorizePaymentMethodToken?: Maybe<AuthorizePaymentMethodTokenPayload>;
  /** Cancels remaining held authorized amount. */
  cancelPaymentTransaction?: Maybe<CancelPaymentTransactionPayload>;
  /** Cancels a group order, and all the fulfillments in it. */
  cancelPhysicalCardGroupOrder?: Maybe<PhysicalCardGroupOrderPayload>;
  /**
   * Cancel an order for a physical payment card. This can only be called while the
   * order is in the `NEW` state.
   */
  cancelPhysicalPaymentCardOrder?: Maybe<CancelPhysicalPaymentCardPayload>;
  /**
   * Cancels the `RequestedIdentityUpdate`. The individual or business has acknowledged the accuracy and correctness of the provided information.
   *
   * Requested updates will not be applied.
   */
  cancelRequestedIdentityUpdate?: Maybe<CancelRequestedIdentityUpdatePayload>;
  /** Cancel a scheduled transfer between financial accounts. */
  cancelScheduledTransfer?: Maybe<CancelScheduledTransferPayload>;
  /** Captures a previously authorized payment. */
  capturePaymentTransaction?: Maybe<CapturePaymentTransactionPayload>;
  /** One step authorization and capture of a `NetworkToken`. */
  chargeNetworkToken?: Maybe<ChargeNetworkTokenPayload>;
  /** One step authorization and capture of a `PaymentCard`. */
  chargePaymentCard?: Maybe<ChargePaymentCardPayload>;
  /** One step authorization and capture of a `PaymentMethodToken`. */
  chargePaymentMethodToken?: Maybe<ChargePaymentMethodTokenPayload>;
  /** One step authorization and capture of an `Order`. */
  chargePaymentOrder?: Maybe<ChargePaymentOrderPayload>;
  /** One step authorization and capture of an `PaymentOrder`. */
  chargePaymentOrderFromPaymentMethodToken?: Maybe<ChargePaymentOrderPayload>;
  /** Close previously added external bank account. */
  closeExternalFinancialBankAccount?: Maybe<CloseExternalFinancialBankAccountPayload>;
  /** Close a Payment Card and decline all future authorizations. */
  closePaymentCard?: Maybe<ClosePaymentCardPayload>;
  /** Completes a group order, marking it as ready to ship. */
  completePhysicalCardGroupOrder?: Maybe<PhysicalCardGroupOrderPayload>;
  /**
   * Confirm credit freeze is lifted for an `AccountHolderCardProductApplication`.
   *
   * If a credit freeze was present during initial underwriting, confirm the freeze is no longer present and then use this mutation to restart underwriting.
   *
   * Will return an error if the `AccountHolderCardProductApplication` is in a terminal state such as `APPROVED`, `DENIED`, or `CLOSED`.
   */
  confirmCreditReportUnfrozen?: Maybe<ConfirmCreditReportUnfrozenPayload>;
  /** Confirm that the specified ACH deposit is a payroll deposit. */
  confirmPayrollDeposit?: Maybe<ConfirmPayrollDepositPayload>;
  /** Confirms the `RequestedIdentityUpdate`. The individual or business has acknowledged the accuracy and correctness of the supplied information. */
  confirmRequestedIdentityUpdate?: Maybe<ConfirmRequestedIdentityUpdatePayload>;
  /**
   * Confirm a credit-based `AccountHolderCardProductApplication` is verified in response to a fraud alert on the applicant's credit report.
   *
   * If an applicant's credit report contains a fraud alert, verify the applicant did intend to initiate this application,
   * and that their name, date of birth, and address are correct on the application. Then, call this mutation.
   *
   * Will return an error if the `AccountHolderCardProductApplication` is in a terminal state such as `APPROVED`, `DENIED`, or `CLOSED`.
   */
  confirmVerificationOfCreditProductApplicationForFraudAlert?: Maybe<ConfirmVerificationOfCreditProductApplicationForFraudAlertPayload>;
  /** Create a new card product application for an AccountHolder. */
  createAccountHolderCardProductApplication?: Maybe<CreateAccountHolderCardProductApplicationPayload>;
  /**
   * Creates a new spend rule that specifies which accounts are
   * either allowed or blocked.
   */
  createAccountSpendRule?: Maybe<CreateAccountSpendRulePayload>;
  /** Creates a `AccountTransactionCountSpendRule` that limits the number of transactions on an account. */
  createAccountTransactionCountSpendRule?: Maybe<CreateAccountTransactionCountSpendRulePayload>;
  /** Creates a new spend rule that limits the amount of authorizations. */
  createAmountLimitSpendRule?: Maybe<CreateAmountLimitSpendRulePayload>;
  /** Create a new card product application for an AuthorizedUser. */
  createAuthorizedUserCardProductApplication?: Maybe<CreateAuthorizedUserCardProductApplicationPayload>;
  /**
   * Creates a new spend rule that specifies if the result of a CVV check should be
   * approved or declined.
   */
  createCVVSpendRule?: Maybe<CreateCvvSpendRulePayload>;
  /** Creates a `CardDataInputCapabilitySpendRule` that allows or blocks a `CardDataInputCapability`. */
  createCardDataInputCapabilitySpendRule?: Maybe<CreateCardDataInputCapabilitySpendRulePayload>;
  /** Creates a new Card Product. */
  createCardProduct?: Maybe<CreateCardProductPayload>;
  /** Create a `CreditPlan` for a `CardProduct` based on a `CreditPlanTemplate`. For plans with a `CreditBalanceType` of `INSTALLMENT`, please use `createCardProductInstallmentCreditPlan`. */
  createCardProductCreditPlan?: Maybe<CreateCardProductCreditPlanPayload>;
  /** Create a `CreditPlan` with a `CreditBalanceType` of `INSTALLMENT` for a `CardProduct` based on a `CreditPlanTemplate`. */
  createCardProductInstallmentCreditPlan?: Maybe<CreateCardProductInstallmentCreditPlanPayload>;
  /**
   * Creates a card product from a template.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  createCardProductWithTemplate?: Maybe<CreateCardProductWithTemplatePayload>;
  /** Creates a `CardTransactionProcessingTypeConditionSpendRule` that allows or blocks a `CardTransactionProcessingType`. */
  createCardTransactionProcessingTypeConditionSpendRule?: Maybe<CreateCardTransactionProcessingTypeConditionSpendRulePayload>;
  /** Create a `CreditCardProductConfiguration` for a charge `CardProduct`, specifying details about the number of days until an account ages into states like `DELINQUENT`, `SUSPENDED`, and `CLOSING`, what is included in the minimum payment, and how repayments are applied. */
  createChargeCreditCardProductConfiguration?: Maybe<CreateCreditCardProductConfigurationPayload>;
  /** Creates a document upload session for check documents. */
  createCheckPaymentDocumentUploadSession?: Maybe<CreateCheckPaymentDocumentUploadSessionPayload>;
  /** Creates a `ConditionalRuleSetSpendRule` that combines the results of multiple spend rules. */
  createConditionalRuleSetSpendRule?: Maybe<CreateConditionalRuleSetSpendRulePayload>;
  /** Creates a new spend rule that limits the number of allowed transactions. */
  createCountLimitSpendRule?: Maybe<CreateCountLimitSpendRulePayload>;
  /** Create a `CreditLimitChangeRequest`, to track status and ultimately decision it. */
  createCreditLimitChangeRequest?: Maybe<CreditLimitChangeRequestPayload>;
  /** Creates a `CreditLimitPercentageSpendRule` that limits the amount a transaction can be authorized for to a percentage of the credit limit. */
  createCreditLimitPercentageSpendRule?: Maybe<CreateCreditLimitPercentageSpendRulePayload>;
  /** Creates a `DaysWithinAccountCreateDateSpendRule` that allows for spending up to a specified number of days since the create date of the card's `FinancialAccount`. */
  createDaysWithinAccountCreateDateSpendRule?: Maybe<CreateDaysWithinAccountCreateDateSpendRulePayload>;
  /** Creates a `DaysWithinCardCreateDateSpendRule` that allows for spending up to a specified number of days since the create date of the `PaymentCard`. */
  createDaysWithinCardCreateDateSpendRule?: Maybe<CreateDaysWithinCardCreateDateSpendRulePayload>;
  /** Creates a `DepositAmountLimitSpendRule` that limits the amount of authorizations. */
  createDepositAmountLimitSpendRule?: Maybe<CreateDepositAmountLimitSpendRulePayload>;
  /** Creates a new `DepositCountLimitSpendRule` that limits the number of authorizations. */
  createDepositCountLimitSpendRule?: Maybe<CreateDepositCountLimitSpendRulePayload>;
  /** Creates a new `DepositProcessingNetworkSpendRule` which allows or blocks an ATM processing network. */
  createDepositProcessingNetworkSpendRule?: Maybe<CreateDepositProcessingNetworkSpendRulePayload>;
  /** Create a link to upload a document to Highnote. */
  createDocumentUploadLink?: Maybe<CreateDocumentUploadLinkPayload>;
  /** Creates a new `GlobalNote` for an entity. */
  createGlobalNote?: Maybe<GlobalNotePayload>;
  /** Creates a `MastercardFraudScoreSpendRule` that limits the acceptable Mastercard Fraud Score for transactions. */
  createMastercardFraudScoreSpendRule?: Maybe<CreateMastercardFraudScoreSpendRulePayload>;
  /** Creates a `MaximumAmountVarianceOnPseudoBalanceSpendRule` that allows for spending up to a specified `Amount` above the account's original balance. */
  createMaximumAmountVarianceOnPseudoBalanceSpendRule?: Maybe<CreateMaximumAmountVarianceOnPseudoBalanceSpendRulePayload>;
  /** Creates a `MaximumPercentVarianceOnPseudoBalanceSpendRule` that allows for spending up to a specified percentage over the account's original balance. */
  createMaximumPercentVarianceOnPseudoBalanceSpendRule?: Maybe<CreateMaximumPercentVarianceOnPseudoBalanceSpendRulePayload>;
  /**
   * Creates a new spend rule that specifies the merchant categories that are either
   * allowed or blocked during authorizations.
   */
  createMerchantCategorySpendRule?: Maybe<CreateMerchantCategorySpendRulePayload>;
  /**
   * Creates a new spend rule that specifies the merchant countries that are either
   * allowed or blocked during authorizations.
   */
  createMerchantCountrySpendRule?: Maybe<CreateMerchantCountrySpendRulePayload>;
  /**
   * Creates a new spend rule that specifies which merchant identifiers (MIDs) are
   * either allowed or blocked.
   */
  createMerchantIdentifierSpendRule?: Maybe<CreateMerchantIdentifierSpendRulePayload>;
  /**
   * Create a new `USBusinessAccountHolder` with minimal information.
   *
   * Note: The following mutation may not be sufficient for your `CardProduct`.
   */
  createMinimalUSBusinessAccountHolder?: Maybe<CreateMinimalUsBusinessAccountHolderPayload>;
  /** Creates a `MinimumAmountLimitSpendRule` that only allows transactions for a specified amount. */
  createMinimumAmountLimitSpendRule?: Maybe<CreateMinimumAmountLimitSpendRulePayload>;
  /** Create a one time ACH transfer between financial accounts. */
  createOneTimeACHTransfer?: Maybe<CreateOneTimeAchTransferPayload>;
  /** Creates a `PanEntryModeSpendRule` that allows or blocks a `PanEntryMode`. */
  createPanEntryModeSpendRule?: Maybe<CreatePanEntryModeSpendRulePayload>;
  /** Creates a new `PaymentOrder`. */
  createPaymentOrder?: Maybe<CreatePaymentOrderPayload>;
  /** Creates a new group order that can be used to ship multiple physical cards to the same location. */
  createPhysicalCardGroupOrder?: Maybe<PhysicalCardGroupOrderPayload>;
  /**
   * Creates a new group order that can be used to ship multiple physical cards to the same validated address.
   * @deprecated Use `createPhysicalCardGroupOrderWithValidatedAddressToken` instead.
   */
  createPhysicalCardGroupOrderWithValidatedAddress?: Maybe<PhysicalCardGroupOrderPayload>;
  /** Creates a new group order that can be used to ship multiple physical cards to the same validated address. */
  createPhysicalCardGroupOrderWithValidatedAddressToken?: Maybe<PhysicalCardGroupOrderPayload>;
  /** Creates a new spend rule that specifies which Point of Service (POS) categories are either allowed or blocked. */
  createPointOfServiceCategorySpendRule?: Maybe<CreatePointOfServiceCategorySpendRulePayload>;
  /** Creates a new spend rule that specifies which address verification postal codes are either allowed or blocked. */
  createPostalCodeVerificationSpendRule?: Maybe<CreatePostalCodeVerificationSpendRulePayload>;
  /** Create a recurring ACH transfer between financial accounts. */
  createRecurringACHTransfer?: Maybe<CreateRecurringAchTransferPayload>;
  /** Create a reusable payment method from a tokenized payment method. */
  createReusablePaymentMethodToken?: Maybe<CreateReusablePaymentMethodTokenPayload>;
  /** Create a `CreditCardProductConfiguration` for a revolving `CardProduct`, specifying details about the number of days until an account ages into states like `DELINQUENT`, `SUSPENDED`, and `CLOSING`, what is included in the minimum payment, and how repayments are applied. */
  createRevolvingCreditCardProductConfiguration?: Maybe<CreateCreditCardProductConfigurationPayload>;
  /** Creates a new `RewardDefaultEarnRule`. */
  createRewardDefaultEarnRule?: Maybe<CreateRewardDefaultEarnRulePayload>;
  /** Creates a new `RewardMerchantCategoryEarnRule`. */
  createRewardMerchantCategoryEarnRule?: Maybe<CreateRewardMerchantCategoryEarnRulePayload>;
  /** Manually Deduct reward points from reward point balance. */
  createRewardPointsAdjustment?: Maybe<RewardPointsTransferPayload>;
  /** Creates a new `RewardRedemptionConfiguration`. */
  createRewardRedemptionConfiguration?: Maybe<CreateRewardRedemptionConfigurationPayload>;
  /** Creates a new Secret API Key. */
  createSecretAPIKey?: Maybe<CreateSecretApiKeyPayload>;
  /**
   * Creates a new spend rule that specifies if the result of a street address verification should be
   * approved or declined.
   *
   * **Note** Street address verifications only verify a street number. Use `createPostalCodeVerificationSpendRule` to
   * change how postal codes are verified.
   */
  createStreetAddressSpendRule?: Maybe<CreateStreetAddressSpendRulePayload>;
  /** Create a new USBusinessAccountHolder. */
  createUSBusinessAccountHolder?: Maybe<CreateUsBusinessAccountHolderPayload>;
  /** Create a new USBusinessAccountHolder from tokenized data. */
  createUSBusinessAccountHolderFromToken?: Maybe<CreateUsBusinessAccountHolderFromTokenPayload>;
  /** Create a new USPersonAccountHolder. */
  createUSPersonAccountHolder?: Maybe<CreateUsPersonAccountHolderPayload>;
  /** Create a new USPersonAccountHolder from tokenized data. */
  createUSPersonAccountHolderFromToken?: Maybe<CreateUsPersonAccountHolderFromTokenPayload>;
  /** Create a new USPersonAuthorizedUser. */
  createUSPersonAuthorizedUser?: Maybe<CreateUsPersonAuthorizedUserPayload>;
  /** Create a new USPersonAuthorizedUser from tokenized data. */
  createUSPersonAuthorizedUserFromToken?: Maybe<CreateUsPersonAuthorizedUserFromTokenPayload>;
  /**
   * Starts the process by creating a `UnifiedFundsTransferQuote`, which the end user can then accept.
   *
   * Once the quote is accepted, call `initiateUnifiedFundsTransfer` with the `UnifiedFundsTransferQuote.id` to initiate the transfer.
   */
  createUnifiedFundsTransferQuote?: Maybe<CreateUnifiedFundsTransferQuotePayload>;
  /** Creates a `UserDefinedField`. */
  createUserDefinedField?: Maybe<UserDefinedFieldPayload>;
  /** Creates a `UserDefinedFieldDefinition`. */
  createUserDefinedFieldDefinition?: Maybe<UserDefinedFieldDefinitionPayload>;
  /** Create a `VelocityRule` */
  createVelocityRule?: Maybe<CreateVelocityRulePayload>;
  /** Creates a `VisaRiskScoreSpendRule` that limits the acceptable Visa Risk Score for transactions. */
  createVisaRiskScoreSpendRule?: Maybe<CreateVisaRiskScoreSpendRulePayload>;
  /** Deactivate a `CollaborativeAuthorizationEndpoint`. */
  deactivateCollaborativeAuthorizationEndpoint?: Maybe<DeactivateCollaborativeAuthorizationEndpointPayload>;
  /** Deactivates a notification target. */
  deactivateNotificationTarget?: Maybe<DeactivateNotificationTargetPayload>;
  /** Deletes all `CustomFields` for an object. */
  deleteCustomFields?: Maybe<CustomFieldsPayload>;
  /** Deletes an existing spend rule. */
  deleteSpendRule?: Maybe<DeleteSpendRulePayload>;
  /** Deletes an existing velocity rule. */
  deleteVelocityRule?: Maybe<DeleteVelocityRulePayload>;
  /** Once a decision has been reached to deny a credit limit decrease, use this mutation to update the `CreditLimitChangeRequest` and provide any customer information collected. */
  denyCreditLimitDecrease?: Maybe<CreditLimitChangeRequestPayload>;
  /** Once a decision has been reached to deny a credit limit increase, use this mutation to update the `CreditLimitChangeRequest` and provide the adverse action reason (if applicable) and other details. */
  denyCreditLimitIncrease?: Maybe<CreditLimitChangeRequestPayload>;
  /** Deny a credit-based `AccountHolderCardProductApplication`. */
  denyCreditProductApplicationUnderwriting?: Maybe<DenyCreditProductApplicationUnderwritingPayload>;
  /** Detach a `VelocityRule` from a `CardProduct` */
  detachCardProductVelocityRule?: Maybe<DetachCardProductVelocityRulePayload>;
  /** Detach a `VelocityRule` from a `PaymentCard` */
  detachPaymentCardVelocityRule?: Maybe<DetachPaymentCardVelocityRulePayload>;
  /**
   * Detaches, or removes, a realtime risk rule from the given Card Product. The risk rule will **not** be evaluated for future authorizations
   * on a payment card issued under the card product.
   */
  detachRealtimeRiskRuleFromCardProduct?: Maybe<DetachRealtimeRiskRuleFromCardProductPayload>;
  /** Detaches, or removes, a realtime risk rule from the given Financial Account. The risk rule will **not** be evaluated for future authorizations. */
  detachRealtimeRiskRuleFromFinancialAccount?: Maybe<DetachRealtimeRiskRuleFromFinancialAccountPayload>;
  /** Detaches, or removes, a realtime risk rule from the given Payment Card. The risk rule will **not** be evaluated for future authorizations. */
  detachRealtimeRiskRuleFromPaymentCard?: Maybe<DetachRealtimeRiskRuleFromPaymentCardPayload>;
  /**
   * Detaches, or removes, a spend rule from the given Card Product. The spend rule will **not** be evaluated for future authorizations
   * on a payment card issued under the card product.
   */
  detachSpendRuleFromCardProduct?: Maybe<DetachSpendRuleFromCardProductPayload>;
  /** Detaches, or removes, a spend rule from the given `FinancialAccount`. The spend rule will **not** be evaluated for future authorizations. */
  detachSpendRuleFromFinancialAccount?: Maybe<DetachSpendRuleFromFinancialAccountPayload>;
  /** Detaches, or removes, a spend rule from the given Payment Card. The spend rule will **not** be evaluated for future authorizations. */
  detachSpendRuleFromPaymentCard?: Maybe<DetachSpendRuleFromPaymentCardPayload>;
  /** Detach a `VelocityRule` from a `FinancialAccount` */
  detachVelocityRuleFromFinancialAccount?: Maybe<DetachVelocityRuleFromFinancialAccountPayload>;
  /** Disable the authorized user feature for a `CardProduct`. */
  disableAuthorizedUserFeature?: Maybe<DisableAuthorizedUserFeaturePayload>;
  /** Enable the authorized user feature for a `CardProduct`. */
  enableAuthorizedUserFeature?: Maybe<EnableAuthorizedUserFeaturePayload>;
  /**
   * Enable the Collaborative Application Decisioning feature for a `CardProduct`.
   * This feature is only available for the COMMERCIAL_CREDIT_PAY_IN_FULL product.
   * If this feature is enabled, all application will wait for customer to use actual API
   * to update underwriting status and until that time the Application will remain in pending state.
   */
  enableCollaborativeApplicationUnderwritingFeature?: Maybe<EnableCollaborativeApplicationUnderwritingFeaturePayload>;
  /** Enable the collaborative authorization feature for a `CardProduct`. */
  enableCollaborativeAuthorizationFeature?: Maybe<EnableCollaborativeAuthorizationFeaturePayload>;
  /**
   * Enable a credit card feature for a `CardProduct`. For example, `REVOLVING` or `CHARGE`.
   * This feature is only available for the `COMMERCIAL_CREDIT` and `CONSUMER_CREDIT` `CardProductVertical`s.
   */
  enableCreditCardFeature?: Maybe<EnableCreditCardFeaturePayload>;
  /**
   * Enable the on-demand funding feature for a `CardProduct`.
   * If this feature is enabled, on-demand funding source is supported on `FinancialAccount` of a `CardProduct`.
   *
   * **Note:** Enabling this feature is only supported in the `TEST` environment.
   */
  enableOnDemandFundingFeature?: Maybe<EnableOnDemandFundingFeaturePayload>;
  /**
   * Ends the session.
   * The session no longer accepts additional files to be uploaded.
   */
  endDocumentUploadSession?: Maybe<EndDocumentUploadSessionPayload>;
  /** Force Captures a payment. */
  forceCapturePaymentTransaction?: Maybe<CapturePaymentTransactionPayload>;
  /** Generate a JWT token for Apple Pay Web Push Provisioning session initiation. */
  generateAppleWebPushProvisioningToken?: Maybe<GenerateAppleWebPushProvisioningTokenPayload>;
  /** Generate a token for use in a client-side integration to manage a business account holder. */
  generateBusinessAccountHolderClientToken?: Maybe<GenerateBusinessAccountHolderClientTokenPayload>;
  /** Generate a token for use in a client-side integration to create a scheduled transfer. */
  generateCreateScheduledTransferClientToken?: Maybe<GenerateCreateScheduledTransferClientTokenPayload>;
  /** Generate a token for use in a client-side integration for a specific Financial Account Direct Deposit Details. */
  generateDirectDepositDetailClientToken?: Maybe<GenerateDirectDepositDetailClientTokenPayload>;
  /** Generate a token for use in a client-side integration to orchestrate document uploads. */
  generateDocumentUploadClientToken?: Maybe<GenerateDocumentUploadClientTokenPayload>;
  /** Generate a token for use in a client-side integration for a specific Financial Account Direct Deposit Details. */
  generateExternalBankAccountDetailClientToken?: Maybe<GenerateExternalBankAccountDetailClientTokenPayload>;
  /**
   * Generate a Single Use Client Token for use in a client-side integration for a specific Financial Account.
   *
   * `generateFinancialAccountSingleUseClientToken` can only be called once provisioned a restricted key after a security audit.
   *
   * In Test, Highnote Customer Service can grant a restricted key without a security audit.
   *
   * In Live, please reach out to Highnote Customer Service to initiate the audit.
   */
  generateFinancialAccountSingleUseClientToken?: Maybe<GenerateFinancialAccountSingleUseClientTokenPayload>;
  /** Generate a token for use in a client-side integration to initiate a secure deposit. */
  generateInitiateSecureDepositClientToken?: Maybe<GenerateInitiateSecureDepositClientTokenPayload>;
  /** Generate a token for use in a client-side integration for a specific Payment Card. */
  generatePaymentCardClientToken?: Maybe<GeneratePaymentCardClientTokenPayload>;
  /**
   * Generate a client token for use in the Secure Inputs SDK when tokenizing a payment method.
   *
   * Expiry: 15 minutes
   */
  generatePaymentMethodTokenizationClientToken?: Maybe<GeneratePaymentMethodTokenizationClientTokenPayload>;
  /** Generate a token for use in a client-side integration to manage a person account holder. */
  generatePersonAccountHolderClientToken?: Maybe<GeneratePersonAccountHolderClientTokenPayload>;
  /** Generate a token for use in a client-side integration to manage a person authorized user. */
  generatePersonAuthorizedUserClientToken?: Maybe<GeneratePersonAuthorizedUserClientTokenPayload>;
  /** Generate risk application sdk session token */
  generateRiskApplicationSDKSessionToken?: Maybe<GenerateRiskApplicationSdkSessionTokenPayload>;
  /** Generate risk client token */
  generateRiskClientToken?: Maybe<GenerateRiskClientTokenPayload>;
  /** Generate a token for use in a client-side integration for a scheduled transfer. */
  generateScheduledTransferClientToken?: Maybe<GenerateSecureDepositClientTokenPayload>;
  /** Generate a token for use in a client-side integration for a secure deposit. */
  generateSecureDepositClientToken?: Maybe<GenerateSecureDepositClientTokenPayload>;
  /**
   * Generate a token to tokenize input for a new account holder.
   *
   * The resulting token can be used with `createUSPersonAccountHolderFromToken`
   */
  generateTokenizeAccountHolderClientToken?: Maybe<GenerateTokenizeAccountHolderClientTokenPayload>;
  /**
   * Generate a token to tokenize input for a new authorized user.
   *
   * The resulting token can be used with `createUSPersonAuthorizedUserFromToken`
   */
  generateTokenizeAuthorizedUserClientToken?: Maybe<GenerateTokenizeAuthorizedUserClientTokenPayload>;
  /** Generate a token for account holder to link external bank accounts */
  generateVerifiedExternalBankAccountLinkToken?: Maybe<GenerateVerifiedExternalBankAccountLinkTokenPayload>;
  /** Incrementally authorizes an existing `PaymentTransaction`, increasing its authorized amount. */
  incrementalAuthorizePaymentTransaction?: Maybe<IncrementalAuthorizePaymentTransactionPayload>;
  /**
   * Push or pull funds between a Highnote `FinancialAccount` and an external financial account
   * (`ExternalFinancialBankAccount` or `NonVerifiedExternalUSFinancialBankAccount`) via ACH transfer.
   */
  initiateAchTransfer?: Maybe<InitiateAchTransferPayload>;
  /** Initiate add funds to a `FinancialAccount` via wire. */
  initiateAddWiredFundsToFinancialAccount?: Maybe<InitiateAddWiredFundsPayload>;
  /** Initiate `PaymentCardTransactionDispute` on a valid card transaction event. */
  initiateCustomerCardTransactionDispute?: Maybe<PaymentCardTransactionDisputePayload>;
  /**
   * Update Credit Limit for the account holder from product funding account.
   * Account Holder financial account has FleetCardFeature as enabled
   * Product has Product Funding Feature as enabled
   */
  initiateFinancialAccountCreditLimitUpdateFromProductFunding?: Maybe<InitiateFinancialAccountCreditLimitUpdateFromProductFundingPayload>;
  /**
   * Set and update the pseudo balance on your customers' financial account.
   *
   * The pseudo balance is the lifetime limit for this financial account. Highnote checks the pseudo balance during the transaction processing and will decline authorizations that would cause the current balance to exceed the pseudo balance. For example, if you allocate a pseudo balance of $100 for this finanacial account, the financial account already has a balance of $100 and the account holder attempts to authorize $1, Highnote would decline the authorization.
   * @deprecated Use updatePseudoBalance instead.
   */
  initiateFinancialAccountPseudoBalanceUpdate?: Maybe<FinancialAccountPseudoBalanceUpdatePayload>;
  /**
   * Add funds to account holder `FinancialAccount` from funding account .
   * Account holder financial account that has PrepaidCardAccountFeature or DebitCardAccountFeature as enabled
   * Origination account is either a Product financial account that has ProductFundingFeature as enabled or account that has CardFundingAccountFeature enabled
   * @deprecated Use initiateTransferFromFundingFinancialAccountToPaymentCardFinancialAccount instead.
   */
  initiateFundPaymentCardFinancialAccountTransfer?: Maybe<InitiateFundPaymentCardFinancialAccountTransferPayload>;
  /**
   * Send funds from an `ExternalFinancialAccount` to a `FinancialAccount` using ACH.
   *
   * [ACH](https://en.wikipedia.org/wiki/Automated_clearing_house) is a method of transferring funds between banks.
   */
  initiateFundsDepositACHTransfer?: Maybe<InitiateFundsDepositAchTransferPayload>;
  /**
   * Send funds from a `FinancialAccount` to an `ExternalFinancialAccount` using ACH.
   *
   * [ACH](https://en.wikipedia.org/wiki/Automated_clearing_house) is a method of transferring funds between banks.
   */
  initiateFundsWithdrawalACHTransfer?: Maybe<InitiateFundsWithdrawalAchTransferPayload>;
  /**
   * Initiates an asynchronous operation to generate a report
   * for an Organization.
   */
  initiateOrganizationReport?: Maybe<InitiateOrganizationReportPayload>;
  /**
   * Move funds from an employer `FinancialAccount` to an employee `FinancialAccount` as a payroll advance.
   * Requires the following `FinancialAccountFeatureType`s to be enabled:
   * - `PayrollEmployerAdvanceFinancialAccountFeature` on the employer `FinancialAccount`
   * - `PayrollAdvanceFinancialAccountFeature` on the employee `FinancialAccount`
   */
  initiatePayrollAdvance?: Maybe<InitiatePayrollAdvancePayload>;
  /** Initiate the process of sending a physical check. */
  initiatePhysicalCheckPayment?: Maybe<InitiatePhysicalCheckPaymentPayload>;
  /**
   * Transfer funds from an `ExternalFinancialAccount` to an internal `FinancialAccount` via ACH for a secure deposit.
   *
   * [ACH](https://en.wikipedia.org/wiki/Automated_clearing_house) is a method of transferring funds between banks.
   */
  initiateSecureDepositACHTransfer?: Maybe<InitiateSecureDepositAchTransferPayload>;
  /**
   * Transfer funds between `FinancialAccount`s.
   * - When the transfer purpose is `REWARD` or `EARNED_CREDIT`.
   *   - Origination account is either a Business financial account with ProductFundingFeature enabled, or an account with CardFundingAccountFeature enabled.
   *   - Payment Card Holder financial account has PrepaidCardAccountFeature or DebitCardAccountFeature enabled.
   *
   * - When the transfer purpose is `REWARD_REVERSAL` or `EARNED_CREDIT_REVERSAL`.
   *   - Payment Card Holder financial account has PrepaidCardAccountFeature or DebitCardAccountFeature enabled.
   *   - Target account is either a Business financial account with ProductFundingFeature enabled, or an account with CardFundingAccountFeature enabled.
   *
   * - When the transfer purpose is `GENERAL`, both financial accounts have the PrepaidCardFeature,
   * DebitCardFeature, ProductFundingFeature, or CardFundingAccountFeature enabled.
   */
  initiateTransferBetweenFinancialAccounts?: Maybe<InitiateTransferBetweenFinancialAccountsPayload>;
  /**
   * Add funds to payment card holder `FinancialAccount` from funding account .
   * Payment Card Holder financial account has PrepaidCardAccountFeature or DebitCardAccountFeature as enabled
   * Origination account is either a Business financial account that has ProductFundingFeature as enabled or account has CardFundingAccountFeature enabled
   */
  initiateTransferFromFundingFinancialAccountToPaymentCardFinancialAccount?: Maybe<InitiateTransferFromFundingFinancialAccountToPaymentCardFinancialAccountPayload>;
  /**
   * Add funds to funding account from payment card holder `FinancialAccount`.
   * Payment Card Holder financial account has PrepaidCardAccountFeature or DebitCardAccountFeature as enabled
   * Target account is either a Business financial account that has ProductFundingFeature as enabled or account has CardFundingAccountFeature enabled
   */
  initiateTransferFromPaymentCardFinancialAccountToFundingFinancialAccount?: Maybe<InitiateTransferFromPaymentCardFinancialAccountToFundingFinancialAccountPayload>;
  /** Initiate the request to modify a `USBusinessAuthorizedPerson`. */
  initiateUSBusinessAuthorizedPersonRequestedIdentityUpdate?: Maybe<InitiateUsBusinessAuthorizedPersonRequestedIdentityUpdatePayload>;
  /** Initiate the request to modify a `USBusinessProfile`. */
  initiateUSBusinessProfileRequestedIdentityUpdate?: Maybe<InitiateUsBusinessProfileRequestedIdentityUpdatePayload>;
  /** Initiate the request to modify a `USBusinessUltimateBeneficialOwner`. */
  initiateUSBusinessUltimateBeneficialOwnerRequestedIdentityUpdate?: Maybe<InitiateUsBusinessUltimateBeneficialOwnerRequestedIdentityUpdatePayload>;
  /** Initiate the request to modify a `USPersonAccountHolder`. */
  initiateUSPersonAccountHolderRequestedIdentityUpdate?: Maybe<InitiateUsPersonAccountHolderRequestedIdentityUpdatePayload>;
  /** Accepts a `UnifiedFundsTransferQuote` initiating the transfer process. OFAC checks are run on the sender and receiver when a `UnifiedNetworkTransfer` (or Instant Payment) is initiated. */
  initiateUnifiedFundsTransfer?: Maybe<InitiateUnifiedFundsTransferPayload>;
  /** Initiate unloading funds from a `FinancialAccount` via wire. */
  initiateUnloadWiredFundsFromFinancialAccount?: Maybe<InitiateUnloadWiredFundsPayload>;
  /** Invites a User to your Organization. */
  inviteUser?: Maybe<InviteUserPayload>;
  /** Issue an Employer Financial Account against a Product. */
  issueEmployerFinancialAccountForCardProduct?: Maybe<IssueEmployerFinancialAccountForCardProductPayload>;
  /** Issue a new Payment Card against an Account Holder Application. */
  issueFinancialAccountForApplication?: Maybe<IssueFinancialAccountForApplicationPayload>;
  /** Issue a new Financial Account with an on-demand funding source. */
  issueFinancialAccountForApplicationWithOnDemandFundingSource?: Maybe<IssueFinancialAccountForApplicationWithOnDemandFundingSourcePayload>;
  /** Issue a new Funding Financial Account against an Account Holder Application. */
  issueFundingFinancialAccountForApplication?: Maybe<IssueFundingFinancialAccountForApplicationPayload>;
  /** Issue a new Payment Card against an Account Holder Application. */
  issuePaymentCardForApplication?: Maybe<IssuePaymentCardForApplicationPayload>;
  /** Issue a new Payment Card against an Account Holder Application with an on-demand funding source. */
  issuePaymentCardForApplicationWithOnDemandFundingSource?: Maybe<IssuePaymentCardForApplicationWithOnDemandFundingSourcePayload>;
  /** Issue a new Payment Card against an Authorized User Application. */
  issuePaymentCardForAuthorizedUserApplication?: Maybe<IssuePaymentCardForApplicationPayload>;
  /** Issue a new Payment Card against an Account Holder Application. */
  issuePaymentCardForFinancialAccount?: Maybe<IssuePaymentCardForFinancialAccountPayload>;
  /** Issues a preprinted payment card financial account for a `AccountHolderCardProductApplication`. */
  issuePreprintedPaymentCardFinancialAccountForApplication?: Maybe<IssuePreprintedPaymentCardFinancialAccountForApplicationPayload>;
  /** Order and ship a payment card to an account holder. */
  orderPhysicalPaymentCard?: Maybe<OrderPhysicalPaymentCardPayload>;
  /** Order and ship a payment card to an account holder as part of a group order. */
  orderPhysicalPaymentCardForGroup?: Maybe<OrderPhysicalPaymentCardPayload>;
  /**
   * Order and ship a payment card to an account holder using validated address.
   * @deprecated Use `orderPhysicalPaymentCardWithValidatedAddressToken` instead.
   */
  orderPhysicalPaymentCardWithValidatedAddress?: Maybe<OrderPhysicalPaymentCardPayload>;
  /** Order and ship a payment card to an account holder using validated address token. */
  orderPhysicalPaymentCardWithValidatedAddressToken?: Maybe<OrderPhysicalPaymentCardPayload>;
  /** A workflow which provisions an Account Holder */
  provisionAccountHolder?: Maybe<ProvisionAccountHolderPayload>;
  /** Redeem reward points accrued. */
  redeemRewardsForStatementCredit?: Maybe<RewardPointsTransferPayload>;
  /** For a given application that has already been APPROVED, this creates a new, related application using the latest information available for the account holder and initiates the specified workflow */
  reevaluateApplication?: Maybe<ReevaluateApplicationPayload>;
  /** Refunds a previously captured payment. */
  refundPaymentTransaction?: Maybe<RefundPaymentTransactionPayload>;
  /** Issue a new Payment Card against an existing payment card. */
  reissuePaymentCard?: Maybe<ReissuePaymentCardPayload>;
  /** Remove a `CollaborativeAuthorizationEndpoint`. */
  removeCollaborativeAuthorizationEndpoint?: Maybe<RemoveCollaborativeAuthorizationEndpointPayload>;
  /** Remove the email for a notification target. This mutation is a noop in the test environment. */
  removeEmailFromNotificationTarget?: Maybe<RemoveEmailFromNotificationTargetPayload>;
  /** Deletes a notification target. */
  removeNotificationTarget?: Maybe<RemoveNotificationTargetPayload>;
  /** Removes subscriptions from a notification target. */
  removeSubscriptionsFromNotificationTarget?: Maybe<RemoveSubscriptionsFromNotificationTargetPayload>;
  /** Removes a User from your Organization. */
  removeUser?: Maybe<RemoveUserPayload>;
  /** Rename a `CollaborativeAuthorizationEndpoint`. */
  renameCollaborativeAuthorizationEndpoint?: Maybe<RenameCollaborativeAuthorizationEndpointPayload>;
  /** Updates the name of an existing notification target. */
  renameNotificationTarget?: Maybe<RenameNotificationTargetPayload>;
  /** Replays a given Notification Event to all subscribing notification targets. */
  replayNotificationEvent?: Maybe<ReplayNotificationEventPayload>;
  /** Resets the pseudo balance for a `FinancialAccount` to zero. */
  resetPseudoBalance?: Maybe<ResetPseudoBalancePayload>;
  /** Revokes an API Key. After revocation, the API Key will be unusable for subsequent requests. */
  revokeAPIKey?: Maybe<RevokeApiKeyPayload>;
  /**
   * Rotate the signing keys for a notification target.
   * Creates a new signing key and sets an expiration date on the old key.
   * The old key will be valid for 24 hours after the new key is created.
   * During that time, signatures for both keys will be sent in the notification payload.
   * There is a maximum of 5 active keys at a time for a target.
   */
  rotateNotificationTargetSigningKey?: Maybe<RotateNotificationTargetSigningKeyPayload>;
  /**
   * Sets the email for a notification target. This data is only stored in the live environment.
   * Deactivation emails are not sent in the test environment.
   */
  setEmailForNotificationTarget?: Maybe<SetEmailForNotificationTargetPayload>;
  /** Set a pin on a payment card. */
  setPinForPaymentCard?: Maybe<SetPinForPaymentCardPayload>;
  /** Sets the pseudo balance limit amount for a `FinancialAccount`. */
  setPseudoLimit?: Maybe<SetPseudoLimitPayload>;
  /**
   * Simulates processing of an `OriginatedAchTransfer` or `NonOriginatedAchTransfer`. The status is updated to `PROCESSED`.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateAchTransferProcessing?: Maybe<SimulateAchTransferProcessingPayload>;
  /**
   * Simulates return of an `OriginatedAchTransfer` or `NonOriginatedAchTransfer`. The status will be updated to `RETURNED`.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateAchTransferReturn?: Maybe<SimulateAchTransferReturnPayload>;
  /**
   * Simulate behaviors around a network adjustment in the Test environment.
   *
   * This operation mirrors Live behavior and allows you to test various scenarios before going live.
   */
  simulateAdjustment?: Maybe<SimulateAdjustmentPayload>;
  /**
   * Simulate updating the review status on a previously created `AccountHolderApplicationDocument` in the Test environment.
   *
   * This operation allows you to test various application lifecycle scenarios before going live.
   */
  simulateApplicationDocumentReview?: Maybe<SimulateApplicationDocumentReviewPayload>;
  /**
   * Simulate updating the application status on a previously created `AccountHolderCardProductApplication` in the Test environment.
   *
   * This operation allows you to test various application lifecycle scenarios before going live.
   */
  simulateApplicationStatusChange?: Maybe<SimulateApplicationUpdatePayload>;
  /**
   * Simulate updating the verification status for existing AccountHolder on a previously created `AccountHolderCardProductApplication` in the Test environment.
   *
   * This operation allows you to test various application lifecycle scenarios before going live.
   */
  simulateApplicationVerificationStatusChange?: Maybe<SimulateApplicationUpdatePayload>;
  /**
   * Simulate behaviors around authorizations in the Test environment.
   * This operation mirrors Live behavior and allows you to test various scenarios before going live.
   */
  simulateAuthorization?: Maybe<SimulateAuthorizationPayload>;
  /**
   * Shift the statement end period of the current statement for a Financial Account
   * n periods backward, and age the account.
   *
   * The `FinancialAccount` must have an `OUTSTANDING_BALANCE_PAYABLE` > 0, and it
   * cannot have any closed billing statements more recent than the `numberOfCyclesToShiftCurrentStatementBackward`
   * input.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateBackwardShiftAndAgeCurrentFinancialAccountStatementPeriod?: Maybe<SimulateFinancialAccountAgingPayload>;
  /**
   * Simulate the card digital wallet token activated flow.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateCardDigitalWalletTokenActivated?: Maybe<SimulateCardDigitalWalletTokenPayload>;
  /**
   * Simulate the card digital wallet token activation flow.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateCardDigitalWalletTokenActivation?: Maybe<SimulateCardDigitalWalletTokenPayload>;
  /** Simulates a `CheckPaymentEvent` for an initiated physical check payment. This will only work in the prod-test environment. */
  simulateCheckPaymentEvent?: Maybe<SimulateCheckPaymentEventChangePayload>;
  /**
   * Simulate behaviors around clearing authorizations in the Test environment.
   *
   * This operation mirrors Live behavior and allows you to test various scenarios before going live.
   */
  simulateClearing?: Maybe<SimulateClearingPayload>;
  /**
   * Simulates moving a `FinancialAccount` into `CLOSED` status.
   * The specified `FinancialAccount` must be in `PENDING_CLOSURE` status.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateCloseFinancialAccount?: Maybe<SimulateCloseFinancialAccountPayload>;
  /**
   * Simulated create new fee schedule in the Highnote test environment.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateCreateAndActivateFeeSchedule?: Maybe<SimulateCreateAndActivateFeeSchedulePayload>;
  /** Simulate creating the application documents upload sessions. */
  simulateCreateApplicationDocumentsUploadSessions?: Maybe<SimulateApplicationManualReviewPayload>;
  /** Add funds to an Organization's account in the Highnote test environment. */
  simulateDeposit?: Maybe<SimulateDepositPayload>;
  /**
   * Simulate an authorization using a digital wallet token in the Test environment.
   *
   * This operation mirrors `Live` behavior and allows you to test various scenarios before going live.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateDigitalWalletTokenAuthorization?: Maybe<SimulateAuthorizationPayload>;
  /**
   * Simulate the authorization of a Mastercard Fleet transaction using a digital wallet token in the Test environment. This allows for partial authorizations.
   *
   * This operation mirrors Live behavior and allows you to test various scenarios before going live.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateDigitalWalletTokenMastercardFleetAuthorization?: Maybe<SimulateAuthorizationPayload>;
  /**
   * Simulate a single step authorization and clear using a digital wallet token in the Test environment.
   *
   * This operation mirrors Live behavior and allows you to test various scenarios before going live.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateDigitalWalletTokenSingleStepAuthAndClear?: Maybe<SimulateAuthAndClearPayload>;
  /**
   * Simulate the authorization of a Visa Fleet transaction using a digital wallet token in the Test environment. This allows for partial authorizations.
   *
   * This operation mirrors Live behavior and allows you to test various scenarios before going live.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateDigitalWalletTokenVisaFleetAuthorization?: Maybe<SimulateAuthorizationPayload>;
  /**
   * Simulate initiating a new `ExternallyInitiatedACHTransfer`.
   *
   * This is only used for testing purposes.
   */
  simulateExternallyInitiatedACHTransfer?: Maybe<ExternallyInitiatedAchTransferPayload>;
  /** Simulate finalizing the provisional credit for the card transaction dispute. */
  simulateFinalizeProvisionalCreditForCardTransactionDispute?: Maybe<PaymentCardTransactionDisputePayload>;
  /** Simulate initiating the chargeback for the card transaction dispute. */
  simulateInitiateCardTransactionChargeback?: Maybe<SimulatePaymentCardTransactionDisputePayload>;
  /** Simulate initiating the dispute for the card transaction. */
  simulateInitiateCardTransactionDispute?: Maybe<SimulatePaymentCardTransactionDisputePayload>;
  /**
   * Simulates moving a `FinancialAccount` into `PENDING_CLOSURE` status.
   * The `PENDING_CLOSURE` account attribute will also be applied.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateInitiateFinancialAccountClosure?: Maybe<SimulateInitiateFinancialAccountClosurePayload>;
  /**
   * Simulate issuing the Credit for a Dispute that has been decided in favor of the Account Holder for cases
   * where the Dispute was not sent as a Chargeback to the Network due to not meeting
   * the DisputeChargebackCardProductFeature.chargebackMinimumThreshold.
   */
  simulateIssueCreditForCardTransactionDispute?: Maybe<SimulatePaymentCardTransactionDisputePayload>;
  /**
   * Simulate issuing provisional credit for the card transaction dispute when the disputed amount
   * meets the DisputeChargebackCardProductFeature.chargebackMinimumThreshold.
   */
  simulateIssueProvisionalCreditForCardTransactionDispute?: Maybe<SimulatePaymentCardTransactionDisputePayload>;
  /**
   * Simulate the authorization of a Mastercard Fleet transaction in the Test environment. This allows for partial authorizations.
   *
   * This operation mirrors Live behavior and allows you to test various scenarios before going live.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateMastercardFleetAuthorization?: Maybe<SimulateAuthorizationPayload>;
  /**
   * Simulate an authorization advice event for a Mastercard Fleet transaction in the Test environment.
   *
   * This creates a `ReversalEvent` for the difference between the authorized amount and the provided advice amount.
   *
   * This operation mirrors Live behavior and allows you to test various scenarios before going live.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateMastercardFleetAuthorizationAdvice?: Maybe<SimulateAuthorizationAdvicePayload>;
  /**
   * Simulate the `ClearingEvent` for a Mastercard Fleet transaction in the Test environment.
   *
   * This operation mirrors Live behavior and allows you to test various scenarios before going live.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateMastercardFleetClearing?: Maybe<SimulateClearingPayload>;
  /**
   * Simulate the `MastercardFleetEnhancedData` for a Mastercard Fleet transaction in the Test environment.
   *
   * Allows for the input of enhanced transaction data pertaining to a Mastercard Fleet transaction to mimic what would be received in a Live transaction.
   *
   * This operation mirrors Live behavior and allows you to test various scenarios before going live.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateMastercardFleetEnhancedData?: Maybe<SimulateEnhancedDataPayload>;
  /**
   * Simulate receiving a new `NonOriginatedACHTransfer`.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateNonOriginatedAchTransfer?: Maybe<SimulateNonOriginatedAchTransferPayload>;
  /**
   * Simulate printer approval of the order. This can only be called while the order is in the
   * `SENT_TO_PRINTER` state.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulatePhysicalCardGroupOrderApproval?: Maybe<SimulatePhysicalCardGroupOrderPayload>;
  /**
   * Simulate sending the order to the printer for fulfillment. This can only
   * be called while the order is in the `NEW` state.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulatePhysicalCardGroupOrderSendToPrinter?: Maybe<SimulatePhysicalCardGroupOrderPayload>;
  /**
   * Simulate a failed shipment by the printer. This can only be called while the
   * order is in the `APPROVED` state.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulatePhysicalCardGroupOrderShipmentFailed?: Maybe<SimulatePhysicalCardGroupOrderPayload>;
  /**
   * Simulate a successful shipment by the printer. This can only be called while
   * the order is in the `APPROVED` state.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulatePhysicalCardGroupOrderShipped?: Maybe<SimulatePhysicalCardGroupOrderPayload>;
  /**
   * Simulate printer approval of the order. This can only be called while the order is in the
   * `SENT_TO_PRINTER` state.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulatePhysicalPaymentCardOrderApproval?: Maybe<SimulatePhysicalPaymentCardPayload>;
  /**
   * Simulate sending the order to the printer for fulfillment. This can only
   * be called while the order is in the `NEW` state.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulatePhysicalPaymentCardOrderSendToPrinter?: Maybe<SimulatePhysicalPaymentCardPayload>;
  /**
   * Simulate a failed shipment by the printer. This can only be called while the
   * order is in the `APPROVED` state.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulatePhysicalPaymentCardOrderShipmentFailed?: Maybe<SimulatePhysicalPaymentCardPayload>;
  /**
   * Simulate a successful shipment by the printer. This can only be called while
   * the order is in the `APPROVED` state.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulatePhysicalPaymentCardOrderShipped?: Maybe<SimulatePhysicalPaymentCardPayload>;
  /**
   * Change the status of an `IntegratorInitiatedACHTransfer` from `PROCESSING` to `PROCESSED`.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateProcessedIntegratorInitiatedStatusChange?: Maybe<SimulateProcessedIntegratorInitiatedStatusChangePayload>;
  /**
   * Change the status of an `ExternallyInitiatedACHTransfer` from `PENDING` to `PROCESSING`.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateProcessingExternallyInitiatedStatusChange?: Maybe<ExternallyInitiatedAchTransferPayload>;
  /**
   * Change the status of an `IntegratorInitiatedACHTransfer` from `INITIATED` to `PROCESSING`.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateProcessingIntegratorInitiatedStatusChange?: Maybe<SimulateProcessingIntegratorInitiatedStatusChangePayload>;
  /**
   * Simulate behaviors around reversing authorizations in the Test environment.
   *
   * This operation mirrors Live behavior and allows you to test various scenarios before going live.
   *
   * **Note:** In Test, the `RefundResponseCode` will always be `APPROVED`, however, more response codes may be added in the future.
   */
  simulateRefund?: Maybe<SimulateRefundPayload>;
  /**
   * Simulate resolving the payment card transaction chargeback for the dispute.
   * If received amount is 0, the chargeback is resolved as a loss.
   * @deprecated Use simulateFinalizeProvisionalCreditForCardTransactionDispute instead.
   */
  simulateResolvePaymentCardTransactionChargeback?: Maybe<SimulatePaymentCardTransactionDisputePayload>;
  /**
   * Change the status of an `IntegratorInitiatedACHTransfer` from `PROCESSING` to `RETURNED`.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateReturnedIntegratorInitiatedStatusChange?: Maybe<SimulateReturnedIntegratorInitiatedStatusChangePayload>;
  /**
   * Simulate behaviors around reversing authorizations in the Test environment.
   *
   * This operation mirrors Live behavior and allows you to test various scenarios before going live.
   *
   * **Note:** In Test, the `ReversalResponseCode` will always be `APPROVED`, however, more response codes may be added in the future.
   */
  simulateReversal?: Maybe<SimulateReversalPayload>;
  /**
   * Rollover the current/next statements. This will simultaneously close the
   * current open statement and open the next statement. If the current open
   * statement's end period is in the future, this will fail. Use
   * simulateShiftCurrentFinancialAccountStatementPeriod mutation to
   * move the end period to now.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateRolloverCurrentFinancialAccountStatementPeriod?: Maybe<SimulateFinancialAccountStatementPayload>;
  /**
   * Shift the statement end period of the current statement for an account to now.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateShiftCurrentFinancialAccountStatementPeriod?: Maybe<SimulateFinancialAccountStatementPayload>;
  /**
   * Simulate behaviors around a single step authorization and clear in the Test environment.
   * This operation mirrors Live behavior and allows you to test various scenarios before going live.
   */
  simulateSingleStepAuthAndClear?: Maybe<SimulateAuthAndClearPayload>;
  /** Simulate updating the dispute for the card transaction. */
  simulateUpdateCardTransactionDispute?: Maybe<SimulatePaymentCardTransactionDisputePayload>;
  /**
   * Simulate updating the payment card transaction chargeback for the dispute.
   * If received amount is 0, the chargeback is resolved as a loss.
   */
  simulateUpdatePaymentCardTransactionChargeback?: Maybe<SimulatePaymentCardTransactionDisputePayload>;
  /**
   * Simulate the authorization of a Visa Fleet transaction in the Test environment. This allows for partial authorizations.
   *
   * This operation mirrors Live behavior and allows you to test various scenarios before going live.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateVisaFleetAuthorization?: Maybe<SimulateAuthorizationPayload>;
  /**
   * Simulate an authorization advice event for a Visa Fleet transaction in the Test environment.
   *
   * This creates a `ReversalEvent` for the difference between the authorized amount and the provided advice amount.
   *
   * This operation mirrors Live behavior and allows you to test various scenarios before going live.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateVisaFleetAuthorizationAdvice?: Maybe<SimulateAuthorizationAdvicePayload>;
  /**
   * Simulate the `ClearingEvent` for a Visa Fleet transaction in the Test environment.
   *
   * Also allows for input of simulated `VisaFleetL2TransactionData` to mimic what would be received in a Live clearing event.
   *
   * This operation mirrors Live behavior and allows you to test various scenarios before going live.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateVisaFleetClearing?: Maybe<SimulateClearingPayload>;
  /**
   * Simulate the `VisaFleetL3EnhancedData` for a Visa Fleet transaction in the Test environment.
   *
   * Allows for the input of Level 3 transaction data pertaining to a Visa Fleet transaction to mimic what would be received in a Live transaction.
   *
   * This operation mirrors Live behavior and allows you to test various scenarios before going live.
   *
   * **Note:** This feature is only available in the `TEST` environment.
   */
  simulateVisaFleetL3EnhancedData?: Maybe<SimulateVisaFleetL3EnhancedDataPayload>;
  /** Initiates a session to allow multiple files to be uploaded. */
  startDocumentUploadSession?: Maybe<StartDocumentUploadSessionPayload>;
  /** Temporarily suspend a card digital wallet token. */
  suspendCardDigitalWalletToken?: Maybe<SuspendCardDigitalWalletTokenPayload>;
  /** Suspends a `FinancialAccount`. */
  suspendFinancialAccount?: Maybe<FinancialAccountPayload>;
  /** Suspend a Payment Card and decline all authorizations until the suspension is lifted. */
  suspendPaymentCard?: Maybe<SuspendPaymentCardPayload>;
  /** Terminate a card digital wallet token. */
  terminateCardDigitalWalletToken?: Maybe<TerminateCardDigitalWalletTokenPayload>;
  /** Creates a single use payment method from a card. */
  tokenizeCardPaymentMethod?: Maybe<TokenizeCardPaymentMethodPayload>;
  /** Tokenizes data for a new USBusinessAccountHolder. */
  tokenizeUSBusinessAccountHolder?: Maybe<TokenizeUsBusinessAccountHolderPayload>;
  /** Tokenizes data for a new USPersonAccountHolder. */
  tokenizeUSPersonAccountHolder?: Maybe<TokenizeUsPersonAccountHolderPayload>;
  /** Tokenizes data for a new USPersonAuthorizedUser. */
  tokenizeUSPersonAuthorizedUser?: Maybe<TokenizeUsPersonAuthorizedUserPayload>;
  /** Execute a funds transfer directly. */
  transferFunds?: Maybe<TransferFundsPayload>;
  /** Reactivate a suspended card digital wallet token. */
  unsuspendCardDigitalWalletToken?: Maybe<UnsuspendCardDigitalWalletTokenPayload>;
  /** Unsuspends a `FinancialAccount`. */
  unsuspendFinancialAccount?: Maybe<FinancialAccountPayload>;
  /** Update non-terminal `AccountHolderCardProductApplicationOffer` on an `AccountHolderCardProductApplication`. */
  updateAccountHolderCardProductApplicationOffers?: Maybe<AccountHolderCardProductApplicationOffersPayload>;
  /**
   * Updates an existing spend rule that specifies which accounts are
   * either allowed or blocked.
   */
  updateAccountSpendRule?: Maybe<UpdateAccountSpendRulePayload>;
  /** Updates a `AccountTransactionCountSpendRule` that limits the number of transactions on an account. */
  updateAccountTransactionCountSpendRule?: Maybe<UpdateAccountTransactionCountSpendRulePayload>;
  /** Updates an existing spend rule that limits the amount of authorizations. */
  updateAmountLimitSpendRule?: Maybe<UpdateAmountLimitSpendRulePayload>;
  /**
   * Updates an existing spend rule that specifies if the result of a CVV check should be
   * approved or declined.
   */
  updateCVVSpendRule?: Maybe<UpdateCvvSpendRulePayload>;
  /** Updates a `CardDataInputCapabilitySpendRule` that allows or blocks a `CardDataInputCapability`. */
  updateCardDataInputCapabilitySpendRule?: Maybe<UpdateCardDataInputCapabilitySpendRulePayload>;
  /** Changes the name of a Card Product. */
  updateCardProductName?: Maybe<UpdateCardProductNamePayload>;
  /** Updates a `CardTransactionProcessingTypeConditionSpendRule` that allows or blocks a `CardTransactionProcessingType`. */
  updateCardTransactionProcessingTypeConditionSpendRule?: Maybe<UpdateCardTransactionProcessingTypeConditionSpendRulePayload>;
  /** Updates a `ConditionalRuleSetSpendRule` that combines the results of multiple spend rules. */
  updateConditionalRuleSetSpendRule?: Maybe<UpdateConditionalRuleSetSpendRulePayload>;
  /** Updates an existing spend rule that limits the number of allowed transactions. */
  updateCountLimitSpendRule?: Maybe<UpdateCountLimitSpendRulePayload>;
  /** Updates a `CreditLimitPercentageSpendRule` that limits the amount a transaction can be authorized for to a percentage of the credit limit. */
  updateCreditLimitPercentageSpendRule?: Maybe<UpdateCreditLimitPercentageSpendRulePayload>;
  /** Updates `CustomFields` for an object. */
  updateCustomFields?: Maybe<CustomFieldsPayload>;
  /** Updates a `DaysWithinAccountCreateDateSpendRule` that allows for spending up to a specified number of days since the create date of the card's `FinancialAccount`. */
  updateDaysWithinAccountCreateDateSpendRule?: Maybe<UpdateDaysWithinAccountCreateDateSpendRulePayload>;
  /** Updates a `DaysWithinCardCreateDateSpendRule` that allows for spending up to a specified number of days since the create date of the `PaymentCard`. */
  updateDaysWithinCardCreateDateSpendRule?: Maybe<UpdateDaysWithinCardCreateDateSpendRulePayload>;
  /** Updates a `DepositAmountLimitSpendRule` that limits the amount of authorizations. */
  updateDepositAmountLimitSpendRule?: Maybe<UpdateDepositAmountLimitSpendRulePayload>;
  /** Updates a `DepositCountLimitSpendRule` that limits the number of authorizations. */
  updateDepositCountLimitSpendRule?: Maybe<UpdateDepositCountLimitSpendRulePayload>;
  /** Updates a `DepositProcessingNetworkSpendRule` which allows or blocks an ATM processing network. */
  updateDepositProcessingNetworkSpendRule?: Maybe<UpdateDepositProcessingNetworkSpendRulePayload>;
  /**
   * Update the billing cycle configuration for a `FinancialAccount`.
   * Currently, this enables you to update the day of the month when payment is due for a `FinancialAccount`.
   * The change only applies to future billing cycles, not the current open cycle or any closed cycles.
   */
  updateFinancialAccountBillingCycleConfiguration?: Maybe<UpdateFinancialAccountBillingCycleConfigurationPayload>;
  /** Changes the name of a Financial Account. */
  updateFinancialAccountName?: Maybe<UpdateFinancialAccountNamePayload>;
  /** Updates a `MastercardFraudScoreSpendRule` that limits the acceptable Mastercard Fraud Score for transactions. */
  updateMastercardFraudScoreSpendRule?: Maybe<UpdateMastercardFraudScoreSpendRulePayload>;
  /** Updates a `MaximumAmountVarianceOnPseudoBalanceSpendRule` that allows for spending up to a specified `Amount` above the account's original balance. */
  updateMaximumAmountVarianceOnPseudoBalanceSpendRule?: Maybe<UpdateMaximumAmountVarianceOnPseudoBalanceSpendRulePayload>;
  /** Updates a `MaximumPercentVarianceOnPseudoBalanceSpendRule` that allows for spending up to a specified percentage over the account's original balance. */
  updateMaximumPercentVarianceOnPseudoBalanceSpendRule?: Maybe<UpdateMaximumPercentVarianceOnPseudoBalanceSpendRulePayload>;
  /**
   * Updates an existing spend rule that specifies the merchant categories that are either
   * allowed or blocked during authorizations.
   */
  updateMerchantCategorySpendRule?: Maybe<UpdateMerchantCategorySpendRulePayload>;
  /**
   * Updates an existing spend rule that specifies the merchant countries that are either
   * allowed or blocked during authorizations.
   */
  updateMerchantCountrySpendRule?: Maybe<UpdateMerchantCountrySpendRulePayload>;
  /**
   * Updates an existing spend rule that specifies which merchant identifiers (MIDs) are
   * either allowed or blocked.
   */
  updateMerchantIdentifierSpendRule?: Maybe<UpdateMerchantIdentifierSpendRulePayload>;
  /** Updates a `MinimumAmountLimitSpendRule` that only allows transactions for a specified amount. */
  updateMinimumAmountLimitSpendRule?: Maybe<UpdateMinimumAmountLimitSpendRulePayload>;
  /** Update the display name of an organization. */
  updateOrganizationProfileDisplayName?: Maybe<UpdateOrganizationProfileDisplayNamePayload>;
  /** Updates a `PanEntryModeSpendRule` that allows or blocks a `PanEntryMode`. */
  updatePanEntryModeSpendRule?: Maybe<UpdatePanEntryModeSpendRulePayload>;
  /**
   * Updates an existing spend rule that specifies which Point of Service (POS) categories are
   * either allowed or blocked.
   */
  updatePointOfServiceCategorySpendRule?: Maybe<UpdatePointOfServiceCategorySpendRulePayload>;
  /**
   * Updates an existing spend rule that specifies which address verification postal codes categories are
   * either allowed or blocked.
   */
  updatePostalCodeVerificationSpendRule?: Maybe<UpdatePostalCodeVerificationSpendRulePayload>;
  /**
   * Updates the pseudo balance amount for a `FinancialAccount`.
   * The amount can be increased or decreased.
   */
  updatePseudoBalance?: Maybe<UpdatePseudoBalancePayload>;
  /**
   * Updates the pseudo limit amount for a `FinancialAccount`.
   * The amount can be increased or decreased.
   */
  updatePseudoLimit?: Maybe<UpdatePseudoLimitPayload>;
  /** Update a `RewardRedemptionConfigurationAttachment`. Note: only the effective through date is modifiable. */
  updateRewardRedemptionConfigurationAttachment?: Maybe<UpdateRewardRedemptionConfigurationAttachmentPayload>;
  /** Update a `RewardRuleAttachment`. Note: only the effective through date is modifiable. */
  updateRewardRuleAttachment?: Maybe<UpdateRewardRuleAttachmentPayload>;
  /**
   * Updates an existing spend rule that specifies if the result of street address verification should be
   * approved or declined.
   *
   * **Note** Street address verifications only verify a street number. Use `createPostalCodeVerificationSpendRule` to
   * change how postal codes are verified.
   */
  updateStreetAddressSpendRule?: Maybe<UpdateStreetAddressSpendRulePayload>;
  /** Update email for existing USAssociatedPersonAccountHolder. */
  updateUSAssociatedPersonAccountHolderEmail?: Maybe<UpdateUsAssociatedPersonAccountHolderPayload>;
  /** Update address for existing USAssociatedPersonAccountHolder. */
  updateUSAssociatedPersonAccountHolderHomeAddress?: Maybe<UpdateUsAssociatedPersonAccountHolderPayload>;
  /** Update phone for existing USAssociatedPersonAccountHolder. */
  updateUSAssociatedPersonAccountHolderPhone?: Maybe<UpdateUsAssociatedPersonAccountHolderPayload>;
  /** Update address for existing USBusinessAccountHolder. */
  updateUSBusinessAccountHolderBillingAddress?: Maybe<UpdateUsBusinessAccountHolderPayload>;
  /** Update credit risk attribute for existing USBusinessAccountHolder. */
  updateUSBusinessAccountHolderCreditRiskAttribute?: Maybe<UpdateUsBusinessAccountHolderPayload>;
  /** Update phone for existing USBusinessAccountHolder. */
  updateUSBusinessAccountHolderPhone?: Maybe<UpdateUsBusinessAccountHolderPayload>;
  /** Update website for existing USBusinessAccountHolder. */
  updateUSBusinessAccountHolderWebsite?: Maybe<UpdateUsBusinessAccountHolderPayload>;
  /** Update billing address for existing USPersonAccountHolder. */
  updateUSPersonAccountHolderBillingAddress?: Maybe<UpdateUsPersonAccountHolderPayload>;
  /** Update credit risk attribute for an existing `USPersonAccountHolder`. */
  updateUSPersonAccountHolderCreditRiskAttribute?: Maybe<UpdateUsPersonAccountHolderPayload>;
  /** Update email for existing USPersonAccountHolder. */
  updateUSPersonAccountHolderEmail?: Maybe<UpdateUsPersonAccountHolderPayload>;
  /** Update phone for existing USPersonAccountHolder. */
  updateUSPersonAccountHolderPhone?: Maybe<UpdateUsPersonAccountHolderPayload>;
  /** Update address for existing USPersonAuthorizedUser. */
  updateUSPersonAuthorizedUserBillingAddress?: Maybe<UpdateUsPersonAuthorizedUserPayload>;
  /** Update email for existing USPersonAuthorizedUser. */
  updateUSPersonAuthorizedUserEmail?: Maybe<UpdateUsPersonAuthorizedUserPayload>;
  /** Update phone for existing USPersonAuthorizedUser. */
  updateUSPersonAuthorizedUserPhone?: Maybe<UpdateUsPersonAuthorizedUserPayload>;
  /** Updates an existing Users data. */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Updates a `UserDefinedField`. */
  updateUserDefinedField?: Maybe<UserDefinedFieldPayload>;
  /** Updates a `UserDefinedFieldDefinition`. */
  updateUserDefinedFieldDefinition?: Maybe<UserDefinedFieldDefinitionPayload>;
  /** Update an existing `VelocityRule` */
  updateVelocityRule?: Maybe<UpdateVelocityRulePayload>;
  /** Updates a `VisaRiskScoreSpendRule` that limits the acceptable Visa Risk Score for transactions. */
  updateVisaRiskScoreSpendRule?: Maybe<UpdateVisaRiskScoreSpendRulePayload>;
  /** Validate provided address. */
  validateAddress?: Maybe<ValidateAddressPayload>;
  /** Verifies that the `NetworkTokenInput` is a valid `NetworkToken`, and able to be used during authorization. */
  verifyNetworkToken?: Maybe<VerifyNetworkTokenPayload>;
  /** Verifies that the `PaymentCardInput` is a valid `PaymentCard`, and able to be used during authorization. */
  verifyPaymentCard?: Maybe<VerifyPaymentCardPayload>;
  /** Verifies that the `PaymentMethodTokenInput` is a valid payment method token, and can be used for authorization. */
  verifyPaymentMethodToken?: Maybe<VerifyPaymentMethodTokenPayload>;
  /**
   * Waive fee of a fee transfer event.
   *
   * This will waive fee of already charged fee transfer event.
   */
  waiveFeeTransfer?: Maybe<FeeTransferEventPayload>;
  /** Waive full interest for an `InterestAssessmentEvent` associated with a closed `FinancialAccountStatement`. */
  waiveInterestAmountForClosedStatement?: Maybe<WaiveInterestAmountForClosedStatementPayload>;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAcceptAccountHolderCardProductApplicationOfferArgs = {
  input: AcceptAccountHolderCardProductApplicationOfferInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationActivateCardProductCreditPlanArgs = {
  input: ActivateCardProductCreditPlanInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationActivateCollaborativeAuthorizationEndpointArgs = {
  input: ActivateCollaborativeAuthorizationEndpointInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationActivateInstallmentAgreementForTransactionEventArgs = {
  input: ActivateInstallmentAgreementForTransactionEventInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationActivateNotificationTargetArgs = {
  input: ActivateNotificationTargetInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationActivatePaymentCardArgs = {
  input: ActivatePaymentCardInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAddCollaborativeAuthorizationEndpointArgs = {
  input: AddCollaborativeAuthorizationEndpointInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAddExternalBankAccountFromTokenArgs = {
  input: AddExternalBankAccountFromTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAddExternalBankAccountVerifiedThroughFinicityArgs = {
  input: AddExternalBankAccountVerifiedThroughFinicityInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAddExternalBankAccountVerifiedThroughPlaidArgs = {
  input: AddExternalBankAccountVerifiedThroughPlaidInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAddExternalBankAccountVerifiedThroughPlaidUsingThirdPartyProcessorTokenArgs =
  {
    input: AddExternalBankAccountVerifiedThroughPlaidUsingThirdPartyProcessorTokenInput;
  };

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAddFundsToPaymentCardArgs = {
  input: AddFundsToPaymentCardInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAddNonVerifiedExternalUsFinancialBankAccountArgs = {
  input: AddNonVerifiedExternalUsFinancialBankAccountInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAddPaymentCardToApplePayByDevicePushProvisioningArgs = {
  input: AddPaymentCardToApplePayByDevicePushProvisioningInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAddPaymentCardToGooglePayByDevicePushProvisioningArgs = {
  input: AddPaymentCardToGooglePayByDevicePushProvisioningInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAddSubscriptionsToNotificationTargetArgs = {
  input: AddSubscriptionsToNotificationTargetInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAddUserDefinedFieldDefinitionRelationshipArgs = {
  input: AddUserDefinedFieldDefinitionRelationshipInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAddWebhookNotificationTargetArgs = {
  input: AddWebhookNotificationTargetInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationApproveCreditLimitDecreaseArgs = {
  input: ApproveCreditLimitDecreaseInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationApproveCreditLimitIncreaseArgs = {
  input: ApproveCreditLimitIncreaseInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationApproveCreditProductApplicationUnderwritingArgs = {
  input: ApproveCreditProductApplicationUnderwritingInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAssignPaymentCardToFinancialAccountArgs = {
  input: AssignPaymentCardToFinancialAccountInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAttachCardProductVelocityRuleArgs = {
  input: AttachCardProductVelocityRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAttachFeeToCreditPlanArgs = {
  input: AttachFeeToCreditPlanInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAttachPaymentCardVelocityRuleArgs = {
  input: AttachPaymentCardVelocityRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAttachRealtimeRiskRuleToCardProductArgs = {
  input: AttachRealtimeRiskRuleToCardProductInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAttachRealtimeRiskRuleToFinancialAccountArgs = {
  input: AttachRealtimeRiskRuleToFinancialAccountInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAttachRealtimeRiskRuleToPaymentCardArgs = {
  input: AttachRealtimeRiskRuleToPaymentCardInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAttachRewardEarnRuleToProductArgs = {
  input: AttachRewardEarnRuleToProductInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAttachRewardRedemptionConfigurationToProductArgs = {
  input: AttachRewardRedemptionConfigurationToProductInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAttachSpendRuleToCardProductArgs = {
  input: AttachSpendRuleToCardProductInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAttachSpendRuleToFinancialAccountArgs = {
  input: AttachSpendRuleToFinancialAccountInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAttachSpendRuleToPaymentCardArgs = {
  input: AttachSpendRuleToPaymentCardInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAttachVelocityRuleToFinancialAccountArgs = {
  input: AttachVelocityRuleToFinancialAccountInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAuthorizeNetworkTokenArgs = {
  input: AuthorizeNetworkTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAuthorizePaymentCardArgs = {
  input: AuthorizePaymentCardInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationAuthorizePaymentMethodTokenArgs = {
  input: AuthorizePaymentMethodTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCancelPaymentTransactionArgs = {
  input: CancelPaymentTransactionInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCancelPhysicalCardGroupOrderArgs = {
  input: CancelPhysicalCardGroupOrderInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCancelPhysicalPaymentCardOrderArgs = {
  input: CancelPhysicalPaymentCardOrderInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCancelRequestedIdentityUpdateArgs = {
  input: CancelRequestedIdentityUpdateInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCancelScheduledTransferArgs = {
  input: CancelScheduledTransferInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCapturePaymentTransactionArgs = {
  input: CapturePaymentTransactionInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationChargeNetworkTokenArgs = {
  input: ChargeNetworkTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationChargePaymentCardArgs = {
  input: ChargePaymentCardInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationChargePaymentMethodTokenArgs = {
  input: ChargePaymentMethodTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationChargePaymentOrderArgs = {
  input: ChargePaymentOrderInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationChargePaymentOrderFromPaymentMethodTokenArgs = {
  input: ChargePaymentOrderPaymentMethodTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCloseExternalFinancialBankAccountArgs = {
  input: CloseExternalFinancialBankAccountInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationClosePaymentCardArgs = {
  input: ClosePaymentCardInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCompletePhysicalCardGroupOrderArgs = {
  input: CompletePhysicalCardGroupOrderInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationConfirmCreditReportUnfrozenArgs = {
  input: ConfirmCreditReportUnfrozenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationConfirmPayrollDepositArgs = {
  input: ConfirmPayrollDepositInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationConfirmRequestedIdentityUpdateArgs = {
  input: ConfirmRequestedIdentityUpdateInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationConfirmVerificationOfCreditProductApplicationForFraudAlertArgs =
  {
    input: ConfirmVerificationOfCreditProductApplicationForFraudAlertInput;
  };

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateAccountHolderCardProductApplicationArgs = {
  input: CreateAccountHolderCardProductApplicationInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateAccountSpendRuleArgs = {
  input: CreateAccountSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateAccountTransactionCountSpendRuleArgs = {
  input: CreateAccountTransactionCountSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateAmountLimitSpendRuleArgs = {
  input: CreateAmountLimitSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateAuthorizedUserCardProductApplicationArgs = {
  input: CreateAuthorizedUserCardProductApplicationInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateCvvSpendRuleArgs = {
  input: CreateCvvSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateCardDataInputCapabilitySpendRuleArgs = {
  input: CreateCardDataInputCapabilitySpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateCardProductArgs = {
  input: CreateCardProductInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateCardProductCreditPlanArgs = {
  input: CreateCardProductCreditPlanInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateCardProductInstallmentCreditPlanArgs = {
  input: CreateCardProductInstallmentCreditPlanInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateCardProductWithTemplateArgs = {
  input: CreateCardProductWithTemplateInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateCardTransactionProcessingTypeConditionSpendRuleArgs =
  {
    input: CreateCardTransactionProcessingTypeConditionSpendRuleInput;
  };

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateChargeCreditCardProductConfigurationArgs = {
  input: CreateChargeCreditCardProductConfigurationInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateCheckPaymentDocumentUploadSessionArgs = {
  input: CreateCheckPaymentDocumentUploadSessionInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateConditionalRuleSetSpendRuleArgs = {
  input: CreateConditionalRuleSetSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateCountLimitSpendRuleArgs = {
  input: CreateCountLimitSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateCreditLimitChangeRequestArgs = {
  input: CreateCreditLimitChangeRequestInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateCreditLimitPercentageSpendRuleArgs = {
  input: CreateCreditLimitPercentageSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateDaysWithinAccountCreateDateSpendRuleArgs = {
  input: CreateDaysWithinAccountCreateDateSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateDaysWithinCardCreateDateSpendRuleArgs = {
  input: CreateDaysWithinCardCreateDateSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateDepositAmountLimitSpendRuleArgs = {
  input: CreateDepositAmountLimitSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateDepositCountLimitSpendRuleArgs = {
  input: CreateDepositCountLimitSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateDepositProcessingNetworkSpendRuleArgs = {
  input: CreateDepositProcessingNetworkSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateDocumentUploadLinkArgs = {
  input: CreateDocumentUploadLinkInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateGlobalNoteArgs = {
  input: CreateGlobalNoteInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateMastercardFraudScoreSpendRuleArgs = {
  input: CreateMastercardFraudScoreSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateMaximumAmountVarianceOnPseudoBalanceSpendRuleArgs = {
  input: CreateMaximumAmountVarianceOnPseudoBalanceSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateMaximumPercentVarianceOnPseudoBalanceSpendRuleArgs = {
  input: CreateMaximumPercentVarianceOnPseudoBalanceSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateMerchantCategorySpendRuleArgs = {
  input: CreateMerchantCategorySpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateMerchantCountrySpendRuleArgs = {
  input: CreateMerchantCountrySpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateMerchantIdentifierSpendRuleArgs = {
  input: CreateMerchantIdentifierSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateMinimalUsBusinessAccountHolderArgs = {
  input: CreateMinimalUsBusinessAccountHolderInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateMinimumAmountLimitSpendRuleArgs = {
  input: CreateMinimumAmountLimitSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateOneTimeAchTransferArgs = {
  input: CreateOneTimeAchTransferInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreatePanEntryModeSpendRuleArgs = {
  input: CreatePanEntryModeSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreatePaymentOrderArgs = {
  input: CreatePaymentOrderInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreatePhysicalCardGroupOrderArgs = {
  input: CreatePhysicalCardGroupOrderInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreatePhysicalCardGroupOrderWithValidatedAddressArgs = {
  input: CreatePhysicalCardGroupOrderWithValidatedAddressInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreatePhysicalCardGroupOrderWithValidatedAddressTokenArgs =
  {
    input: CreatePhysicalCardGroupOrderWithValidatedAddressTokenInput;
  };

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreatePointOfServiceCategorySpendRuleArgs = {
  input: CreatePointOfServiceCategorySpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreatePostalCodeVerificationSpendRuleArgs = {
  input: CreatePostalCodeVerificationSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateRecurringAchTransferArgs = {
  input: CreateRecurringAchTransferInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateReusablePaymentMethodTokenArgs = {
  input: CreateReusablePaymentMethodTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateRevolvingCreditCardProductConfigurationArgs = {
  input: CreateRevolvingCreditCardProductConfigurationInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateRewardDefaultEarnRuleArgs = {
  input: CreateRewardDefaultEarnRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateRewardMerchantCategoryEarnRuleArgs = {
  input: CreateRewardMerchantCategoryEarnRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateRewardPointsAdjustmentArgs = {
  input: CreateRewardPointsAdjustmentInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateRewardRedemptionConfigurationArgs = {
  input: CreateRewardRedemptionConfigurationInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateSecretApiKeyArgs = {
  input: CreateSecretApiKeyInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateStreetAddressSpendRuleArgs = {
  input: CreateStreetAddressSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateUsBusinessAccountHolderArgs = {
  input: CreateUsBusinessAccountHolderInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateUsBusinessAccountHolderFromTokenArgs = {
  input: CreateUsBusinessAccountHolderFromTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateUsPersonAccountHolderArgs = {
  input: CreateUsPersonAccountHolderInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateUsPersonAccountHolderFromTokenArgs = {
  input: CreateUsPersonAccountHolderFromTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateUsPersonAuthorizedUserArgs = {
  input: CreateUsPersonAuthorizedUserInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateUsPersonAuthorizedUserFromTokenArgs = {
  input: CreateUsPersonAuthorizedUserFromTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateUnifiedFundsTransferQuoteArgs = {
  input: CreateUnifiedFundsTransferQuoteInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateUserDefinedFieldArgs = {
  input: CreateUserDefinedFieldInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateUserDefinedFieldDefinitionArgs = {
  input: CreateUserDefinedFieldDefinitionInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateVelocityRuleArgs = {
  input: CreateVelocityRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationCreateVisaRiskScoreSpendRuleArgs = {
  input: CreateVisaRiskScoreSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationDeactivateCollaborativeAuthorizationEndpointArgs = {
  input: DeactivateCollaborativeAuthorizationEndpointInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationDeactivateNotificationTargetArgs = {
  input: DeactivateNotificationTargetInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationDeleteCustomFieldsArgs = {
  input: DeleteCustomFieldsInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationDeleteSpendRuleArgs = {
  input: DeleteSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationDeleteVelocityRuleArgs = {
  input: DeleteVelocityRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationDenyCreditLimitDecreaseArgs = {
  input: DenyCreditLimitDecreaseInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationDenyCreditLimitIncreaseArgs = {
  input: DenyCreditLimitIncreaseInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationDenyCreditProductApplicationUnderwritingArgs = {
  input: DenyCreditProductApplicationUnderwritingInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationDetachCardProductVelocityRuleArgs = {
  input: DetachCardProductVelocityRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationDetachPaymentCardVelocityRuleArgs = {
  input: DetachPaymentCardVelocityRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationDetachRealtimeRiskRuleFromCardProductArgs = {
  input: DetachRealtimeRiskRuleFromCardProductInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationDetachRealtimeRiskRuleFromFinancialAccountArgs = {
  input: DetachRealtimeRiskRuleFromFinancialAccountInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationDetachRealtimeRiskRuleFromPaymentCardArgs = {
  input: DetachRealtimeRiskRuleFromPaymentCardInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationDetachSpendRuleFromCardProductArgs = {
  input: DetachSpendRuleFromCardProductInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationDetachSpendRuleFromFinancialAccountArgs = {
  input: DetachSpendRuleFromFinancialAccountInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationDetachSpendRuleFromPaymentCardArgs = {
  input: DetachSpendRuleFromPaymentCardInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationDetachVelocityRuleFromFinancialAccountArgs = {
  input: DetachVelocityRuleFromFinancialAccountInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationDisableAuthorizedUserFeatureArgs = {
  input: DisableAuthorizedUserFeatureInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationEnableAuthorizedUserFeatureArgs = {
  input: EnableAuthorizedUserFeatureInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationEnableCollaborativeApplicationUnderwritingFeatureArgs = {
  input: EnableCollaborativeApplicationUnderwritingFeatureInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationEnableCollaborativeAuthorizationFeatureArgs = {
  input: EnableCollaborativeAuthorizationFeatureInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationEnableCreditCardFeatureArgs = {
  input: EnableCreditCardFeatureInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationEnableOnDemandFundingFeatureArgs = {
  input: EnableOnDemandFundingFeatureInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationEndDocumentUploadSessionArgs = {
  input: EndDocumentUploadSessionInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationForceCapturePaymentTransactionArgs = {
  input: ForceCapturePaymentTransactionInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationGenerateAppleWebPushProvisioningTokenArgs = {
  input: GenerateAppleWebPushProvisioningTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationGenerateBusinessAccountHolderClientTokenArgs = {
  input: GenerateBusinessAccountHolderClientTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationGenerateCreateScheduledTransferClientTokenArgs = {
  input: GenerateCreateScheduledTransferClientTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationGenerateDirectDepositDetailClientTokenArgs = {
  input: GenerateDirectDepositDetailClientTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationGenerateDocumentUploadClientTokenArgs = {
  input: GenerateDocumentUploadClientTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationGenerateExternalBankAccountDetailClientTokenArgs = {
  input: GenerateExternalBankAccountDetailClientTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationGenerateFinancialAccountSingleUseClientTokenArgs = {
  input: GenerateFinancialAccountSingleUseClientTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationGenerateInitiateSecureDepositClientTokenArgs = {
  input: GenerateInitiateSecureDepositClientTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationGeneratePaymentCardClientTokenArgs = {
  input: GeneratePaymentCardClientTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationGeneratePaymentMethodTokenizationClientTokenArgs = {
  input: GeneratePaymentMethodTokenizationClientTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationGeneratePersonAccountHolderClientTokenArgs = {
  input: GeneratePersonAccountHolderClientTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationGeneratePersonAuthorizedUserClientTokenArgs = {
  input: GeneratePersonAuthorizedUserClientTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationGenerateRiskClientTokenArgs = {
  input: GenerateRiskClientTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationGenerateScheduledTransferClientTokenArgs = {
  input: GenerateScheduledTransferClientTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationGenerateSecureDepositClientTokenArgs = {
  input: GenerateSecureDepositClientTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationGenerateVerifiedExternalBankAccountLinkTokenArgs = {
  input: GenerateVerifiedExternalBankAccountLinkTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationIncrementalAuthorizePaymentTransactionArgs = {
  input: IncrementalAuthorizePaymentTransactionInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationInitiateAchTransferArgs = {
  input: InitiateAchTransferInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationInitiateAddWiredFundsToFinancialAccountArgs = {
  input: InitiateAddWiredFundsToFinancialAccountInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationInitiateCustomerCardTransactionDisputeArgs = {
  input: InitiateCustomerCardTransactionDisputeInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationInitiateFinancialAccountCreditLimitUpdateFromProductFundingArgs =
  {
    input: InitiateFinancialAccountCreditLimitUpdateFromProductFundingInput;
  };

/** Root Mutation type extending the main GraphQL schema. */
export type MutationInitiateFinancialAccountPseudoBalanceUpdateArgs = {
  input: InitiateFinancialAccountPseudoBalanceUpdateInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationInitiateFundPaymentCardFinancialAccountTransferArgs = {
  input: InitiateFundPaymentCardFinancialAccountTransferInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationInitiateFundsDepositAchTransferArgs = {
  input: InitiateFundsDepositAchTransferInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationInitiateFundsWithdrawalAchTransferArgs = {
  input: InitiateFundsWithdrawalAchTransferInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationInitiateOrganizationReportArgs = {
  input: InitiateOrganizationReportInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationInitiatePayrollAdvanceArgs = {
  input: InitiatePayrollAdvanceInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationInitiatePhysicalCheckPaymentArgs = {
  input: InitiatePhysicalCheckPaymentInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationInitiateSecureDepositAchTransferArgs = {
  input: InitiateSecureDepositAchTransferInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationInitiateTransferBetweenFinancialAccountsArgs = {
  input: InitiateTransferBetweenFinancialAccountsInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationInitiateTransferFromFundingFinancialAccountToPaymentCardFinancialAccountArgs =
  {
    input: InitiateTransferFromFundingFinancialAccountToPaymentCardFinancialAccountInput;
  };

/** Root Mutation type extending the main GraphQL schema. */
export type MutationInitiateTransferFromPaymentCardFinancialAccountToFundingFinancialAccountArgs =
  {
    input: InitiateTransferFromPaymentCardFinancialAccountToFundingFinancialAccountInput;
  };

/** Root Mutation type extending the main GraphQL schema. */
export type MutationInitiateUsBusinessAuthorizedPersonRequestedIdentityUpdateArgs =
  {
    input: InitiateUsBusinessAuthorizedPersonRequestedIdentityUpdateInput;
  };

/** Root Mutation type extending the main GraphQL schema. */
export type MutationInitiateUsBusinessProfileRequestedIdentityUpdateArgs = {
  input: InitiateUsBusinessProfileRequestedIdentityUpdateInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationInitiateUsBusinessUltimateBeneficialOwnerRequestedIdentityUpdateArgs =
  {
    input: InitiateUsBusinessUltimateBeneficialOwnerRequestedIdentityUpdateInput;
  };

/** Root Mutation type extending the main GraphQL schema. */
export type MutationInitiateUsPersonAccountHolderRequestedIdentityUpdateArgs = {
  input: InitiateUsPersonAccountHolderRequestedIdentityUpdateInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationInitiateUnifiedFundsTransferArgs = {
  input: InitiateUnifiedFundsTransferInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationInitiateUnloadWiredFundsFromFinancialAccountArgs = {
  input: InitiateUnloadWiredFundsFromFinancialAccountInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationInviteUserArgs = {
  input: InviteUserInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationIssueEmployerFinancialAccountForCardProductArgs = {
  input: IssueEmployerFinancialAccountForCardProductInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationIssueFinancialAccountForApplicationArgs = {
  input: IssueFinancialAccountForApplicationInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationIssueFinancialAccountForApplicationWithOnDemandFundingSourceArgs =
  {
    input: IssueFinancialAccountForApplicationWithOnDemandFundingSourceInput;
  };

/** Root Mutation type extending the main GraphQL schema. */
export type MutationIssueFundingFinancialAccountForApplicationArgs = {
  input: IssueFundingFinancialAccountForApplicationInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationIssuePaymentCardForApplicationArgs = {
  input: IssuePaymentCardForApplicationInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationIssuePaymentCardForApplicationWithOnDemandFundingSourceArgs =
  {
    input: IssuePaymentCardForApplicationWithOnDemandFundingSourceInput;
  };

/** Root Mutation type extending the main GraphQL schema. */
export type MutationIssuePaymentCardForAuthorizedUserApplicationArgs = {
  input: IssuePaymentCardForAuthorizedUserApplicationInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationIssuePaymentCardForFinancialAccountArgs = {
  input: IssuePaymentCardForFinancialAccountInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationIssuePreprintedPaymentCardFinancialAccountForApplicationArgs =
  {
    input: IssuePreprintedPaymentCardFinancialAccountForApplicationInput;
  };

/** Root Mutation type extending the main GraphQL schema. */
export type MutationOrderPhysicalPaymentCardArgs = {
  input: OrderPhysicalPaymentCardInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationOrderPhysicalPaymentCardForGroupArgs = {
  input: OrderPhysicalPaymentCardForGroupInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationOrderPhysicalPaymentCardWithValidatedAddressArgs = {
  input: OrderPhysicalPaymentCardWithValidatedAddressInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationOrderPhysicalPaymentCardWithValidatedAddressTokenArgs = {
  input: OrderPhysicalPaymentCardWithValidatedAddressTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationProvisionAccountHolderArgs = {
  input: ProvisionAccountHolderInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationRedeemRewardsForStatementCreditArgs = {
  input: RedeemRewardsForStatementCreditInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationReevaluateApplicationArgs = {
  input: ReevaluateApplicationInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationRefundPaymentTransactionArgs = {
  input: RefundPaymentTransactionInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationReissuePaymentCardArgs = {
  input: ReissuePaymentCardInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationRemoveCollaborativeAuthorizationEndpointArgs = {
  input: RemoveCollaborativeAuthorizationEndpointInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationRemoveEmailFromNotificationTargetArgs = {
  input: RemoveEmailFromNotificationTargetInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationRemoveNotificationTargetArgs = {
  input: RemoveNotificationTargetInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationRemoveSubscriptionsFromNotificationTargetArgs = {
  input: RemoveSubscriptionsFromNotificationTargetInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationRemoveUserArgs = {
  input: RemoveUserInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationRenameCollaborativeAuthorizationEndpointArgs = {
  input: RenameCollaborativeAuthorizationEndpointInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationRenameNotificationTargetArgs = {
  input: RenameNotificationTargetInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationReplayNotificationEventArgs = {
  input: ReplayNotificationEventInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationResetPseudoBalanceArgs = {
  input: ResetPseudoBalanceInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationRevokeApiKeyArgs = {
  input: RevokeApiKeyInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationRotateNotificationTargetSigningKeyArgs = {
  input: RotateNotificationTargetSigningKeyInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSetEmailForNotificationTargetArgs = {
  input: SetEmailForNotificationTargetInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSetPinForPaymentCardArgs = {
  input: SetPinForPaymentCardInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSetPseudoLimitArgs = {
  input: SetPseudoLimitInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateAchTransferProcessingArgs = {
  input: SimulateAchTransferProcessingInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateAchTransferReturnArgs = {
  input: SimulateAchTransferReturnInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateAdjustmentArgs = {
  input: SimulateAdjustmentInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateApplicationDocumentReviewArgs = {
  input: SimulateApplicationDocumentReviewInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateApplicationStatusChangeArgs = {
  input: SimulateApplicationStatusChangeInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateApplicationVerificationStatusChangeArgs = {
  input: SimulateApplicationVerificationStatusChangeInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateAuthorizationArgs = {
  input: SimulateAuthorizationInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateBackwardShiftAndAgeCurrentFinancialAccountStatementPeriodArgs =
  {
    input: SimulateBackwardShiftAndAgeCurrentFinancialAccountStatementPeriodInput;
  };

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateCardDigitalWalletTokenActivatedArgs = {
  input: SimulateCardDigitalWalletTokenActivatedInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateCardDigitalWalletTokenActivationArgs = {
  input: SimulateCardDigitalWalletTokenActivationInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateCheckPaymentEventArgs = {
  input: SimulateCheckPaymentEventInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateClearingArgs = {
  input: SimulateClearingInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateCloseFinancialAccountArgs = {
  input: SimulateCloseFinancialAccountInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateCreateAndActivateFeeScheduleArgs = {
  input: SimulateCreateAndActivateFeeScheduleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateCreateApplicationDocumentsUploadSessionsArgs = {
  input: SimulateCreateApplicationDocumentsUploadSessionsInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateDepositArgs = {
  input: SimulateDepositInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateDigitalWalletTokenAuthorizationArgs = {
  input: SimulateDigitalWalletTokenAuthorizationInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateDigitalWalletTokenMastercardFleetAuthorizationArgs =
  {
    input: SimulateDigitalWalletTokenMastercardFleetAuthorizationInput;
  };

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateDigitalWalletTokenSingleStepAuthAndClearArgs = {
  input: SimulateDigitalWalletTokenSingleStepAuthAndClearInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateDigitalWalletTokenVisaFleetAuthorizationArgs = {
  input: SimulateDigitalWalletTokenVisaFleetAuthorizationInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateExternallyInitiatedAchTransferArgs = {
  input: SimulateExternallyInitiatedAchTransferInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateFinalizeProvisionalCreditForCardTransactionDisputeArgs =
  {
    input: SimulateFinalizeProvisionalCreditForCardTransactionDisputeInput;
  };

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateInitiateCardTransactionChargebackArgs = {
  input: SimulateInitiateCardTransactionChargebackInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateInitiateCardTransactionDisputeArgs = {
  input: SimulateInitiateCardTransactionDisputeInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateInitiateFinancialAccountClosureArgs = {
  input: SimulateInitiateFinancialAccountClosureInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateIssueCreditForCardTransactionDisputeArgs = {
  input: SimulateIssueCreditForCardTransactionDisputeInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateIssueProvisionalCreditForCardTransactionDisputeArgs =
  {
    input: SimulateIssueProvisionalCreditForCardTransactionDisputeInput;
  };

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateMastercardFleetAuthorizationArgs = {
  input: SimulateMastercardFleetAuthorizationInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateMastercardFleetAuthorizationAdviceArgs = {
  input: SimulateMastercardFleetAuthorizationAdviceInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateMastercardFleetClearingArgs = {
  input: SimulateMastercardFleetClearingInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateMastercardFleetEnhancedDataArgs = {
  input: SimulateMastercardFleetEnhancedDataInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateNonOriginatedAchTransferArgs = {
  input: SimulateNonOriginatedAchTransferInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulatePhysicalCardGroupOrderApprovalArgs = {
  input: SimulatePhysicalCardGroupOrderApprovalInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulatePhysicalCardGroupOrderSendToPrinterArgs = {
  input: SimulatePhysicalCardGroupOrderSendToPrinterInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulatePhysicalCardGroupOrderShipmentFailedArgs = {
  input: SimulatePhysicalCardGroupOrderShipmentFailedInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulatePhysicalCardGroupOrderShippedArgs = {
  input: SimulatePhysicalCardGroupOrderShippedInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulatePhysicalPaymentCardOrderApprovalArgs = {
  input: SimulatePhysicalPaymentCardApprovalInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulatePhysicalPaymentCardOrderSendToPrinterArgs = {
  input: SimulatePhysicalPaymentCardSendToPrinterInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulatePhysicalPaymentCardOrderShipmentFailedArgs = {
  input: SimulatePhysicalPaymentCardShipmentFailedInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulatePhysicalPaymentCardOrderShippedArgs = {
  input: SimulatePhysicalPaymentCardShippedInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateProcessedIntegratorInitiatedStatusChangeArgs = {
  input: SimulateProcessedIntegratorInitiatedStatusChangeInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateProcessingExternallyInitiatedStatusChangeArgs = {
  input: SimulateProcessingExternallyInitiatedStatusChangeInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateProcessingIntegratorInitiatedStatusChangeArgs = {
  input: SimulateProcessingIntegratorInitiatedStatusChangeInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateRefundArgs = {
  input: SimulateRefundInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateResolvePaymentCardTransactionChargebackArgs = {
  input: SimulateResolvePaymentCardTransactionChargebackInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateReturnedIntegratorInitiatedStatusChangeArgs = {
  input: SimulateReturnedIntegratorInitiatedStatusChangeInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateReversalArgs = {
  input: SimulateReversalInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateRolloverCurrentFinancialAccountStatementPeriodArgs =
  {
    input: SimulateRolloverCurrentFinancialAccountStatementPeriodInput;
  };

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateShiftCurrentFinancialAccountStatementPeriodArgs = {
  input: SimulateShiftCurrentFinancialAccountStatementPeriodInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateSingleStepAuthAndClearArgs = {
  input: SimulateSingleStepAuthAndClearInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateUpdateCardTransactionDisputeArgs = {
  input: SimulateUpdateCardTransactionDisputeInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateUpdatePaymentCardTransactionChargebackArgs = {
  input: SimulateUpdatePaymentCardTransactionChargebackInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateVisaFleetAuthorizationArgs = {
  input: SimulateVisaFleetAuthorizationInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateVisaFleetAuthorizationAdviceArgs = {
  input: SimulateVisaFleetAuthorizationAdviceInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateVisaFleetClearingArgs = {
  input: SimulateVisaFleetClearingInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSimulateVisaFleetL3EnhancedDataArgs = {
  input: SimulateVisaFleetL3EnhancedDataInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationStartDocumentUploadSessionArgs = {
  input: StartDocumentUploadSessionInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSuspendCardDigitalWalletTokenArgs = {
  input: SuspendCardDigitalWalletTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSuspendFinancialAccountArgs = {
  input: SuspendFinancialAccountInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationSuspendPaymentCardArgs = {
  input: SuspendPaymentCardInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationTerminateCardDigitalWalletTokenArgs = {
  input: TerminateCardDigitalWalletTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationTokenizeCardPaymentMethodArgs = {
  input: TokenizeCardPaymentMethodInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationTokenizeUsBusinessAccountHolderArgs = {
  input?: InputMaybe<CreateUsBusinessAccountHolderInput>;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationTokenizeUsPersonAccountHolderArgs = {
  input: CreateUsPersonAccountHolderInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationTokenizeUsPersonAuthorizedUserArgs = {
  input: CreateUsPersonAuthorizedUserInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationTransferFundsArgs = {
  input: TransferFundsInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUnsuspendCardDigitalWalletTokenArgs = {
  input: UnsuspendCardDigitalWalletTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUnsuspendFinancialAccountArgs = {
  input: UnsuspendFinancialAccountInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateAccountHolderCardProductApplicationOffersArgs = {
  input: UpdateAccountHolderCardProductApplicationOffersInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateAccountSpendRuleArgs = {
  input: UpdateAccountSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateAccountTransactionCountSpendRuleArgs = {
  input: UpdateAccountTransactionCountSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateAmountLimitSpendRuleArgs = {
  input: UpdateAmountLimitSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateCvvSpendRuleArgs = {
  input: UpdateCvvSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateCardDataInputCapabilitySpendRuleArgs = {
  input: UpdateCardDataInputCapabilitySpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateCardProductNameArgs = {
  input: UpdateCardProductNameInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateCardTransactionProcessingTypeConditionSpendRuleArgs =
  {
    input: UpdateCardTransactionProcessingTypeConditionSpendRuleInput;
  };

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateConditionalRuleSetSpendRuleArgs = {
  input: UpdateConditionalRuleSetSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateCountLimitSpendRuleArgs = {
  input: UpdateCountLimitSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateCreditLimitPercentageSpendRuleArgs = {
  input: UpdateCreditLimitPercentageSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateCustomFieldsArgs = {
  input: UpdateCustomFieldsInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateDaysWithinAccountCreateDateSpendRuleArgs = {
  input: UpdateDaysWithinAccountCreateDateSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateDaysWithinCardCreateDateSpendRuleArgs = {
  input: UpdateDaysWithinCardCreateDateSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateDepositAmountLimitSpendRuleArgs = {
  input: UpdateDepositAmountLimitSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateDepositCountLimitSpendRuleArgs = {
  input: UpdateDepositCountLimitSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateDepositProcessingNetworkSpendRuleArgs = {
  input: UpdateDepositProcessingNetworkSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateFinancialAccountBillingCycleConfigurationArgs = {
  input: UpdateFinancialAccountBillingCycleConfigurationInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateFinancialAccountNameArgs = {
  input: UpdateFinancialAccountNameInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateMastercardFraudScoreSpendRuleArgs = {
  input: UpdateMastercardFraudScoreSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateMaximumAmountVarianceOnPseudoBalanceSpendRuleArgs = {
  input: UpdateMaximumAmountVarianceOnPseudoBalanceSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateMaximumPercentVarianceOnPseudoBalanceSpendRuleArgs = {
  input: UpdateMaximumPercentVarianceOnPseudoBalanceSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateMerchantCategorySpendRuleArgs = {
  input: UpdateMerchantCategorySpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateMerchantCountrySpendRuleArgs = {
  input: UpdateMerchantCountrySpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateMerchantIdentifierSpendRuleArgs = {
  input: UpdateMerchantIdentifierSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateMinimumAmountLimitSpendRuleArgs = {
  input: UpdateMinimumAmountLimitSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateOrganizationProfileDisplayNameArgs = {
  input: UpdateOrganizationProfileDisplayNameInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdatePanEntryModeSpendRuleArgs = {
  input: UpdatePanEntryModeSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdatePointOfServiceCategorySpendRuleArgs = {
  input: UpdatePointOfServiceCategorySpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdatePostalCodeVerificationSpendRuleArgs = {
  input: UpdatePostalCodeVerificationSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdatePseudoBalanceArgs = {
  input: UpdatePseudoBalanceInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdatePseudoLimitArgs = {
  input: UpdatePseudoLimitInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateRewardRedemptionConfigurationAttachmentArgs = {
  input: UpdateRewardRedemptionConfigurationAttachmentInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateRewardRuleAttachmentArgs = {
  input: UpdateRewardRuleAttachmentInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateStreetAddressSpendRuleArgs = {
  input: UpdateStreetAddressSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateUsAssociatedPersonAccountHolderEmailArgs = {
  input: UpdateUsAssociatedPersonAccountHolderEmailInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateUsAssociatedPersonAccountHolderHomeAddressArgs = {
  input: UpdateUsAssociatedPersonAccountHolderHomeAddressInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateUsAssociatedPersonAccountHolderPhoneArgs = {
  input: UpdateUsAssociatedPersonAccountHolderPhoneInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateUsBusinessAccountHolderBillingAddressArgs = {
  input: UpdateUsBusinessAccountHolderBillingAddressInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateUsBusinessAccountHolderCreditRiskAttributeArgs = {
  input: UpdateUsBusinessAccountHolderCreditRiskAttributeInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateUsBusinessAccountHolderPhoneArgs = {
  input: UpdateUsBusinessAccountHolderPhoneInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateUsBusinessAccountHolderWebsiteArgs = {
  input: UpdateUsBusinessAccountHolderWebsiteInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateUsPersonAccountHolderBillingAddressArgs = {
  input: UpdateUsPersonAccountHolderBillingAddressInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateUsPersonAccountHolderCreditRiskAttributeArgs = {
  input: UpdateUsPersonAccountHolderCreditRiskAttributeInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateUsPersonAccountHolderEmailArgs = {
  input: UpdateUsPersonAccountHolderEmailInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateUsPersonAccountHolderPhoneArgs = {
  input: UpdateUsPersonAccountHolderPhoneInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateUsPersonAuthorizedUserBillingAddressArgs = {
  input: UpdateUsPersonAuthorizedUserBillingAddressInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateUsPersonAuthorizedUserEmailArgs = {
  input: UpdateUsPersonAuthorizedUserEmailInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateUsPersonAuthorizedUserPhoneArgs = {
  input: UpdateUsPersonAuthorizedUserPhoneInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateUserDefinedFieldArgs = {
  input: UpdateUserDefinedFieldInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateUserDefinedFieldDefinitionArgs = {
  input: UpdateUserDefinedFieldDefinitionInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateVelocityRuleArgs = {
  input: UpdateVelocityRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationUpdateVisaRiskScoreSpendRuleArgs = {
  input: UpdateVisaRiskScoreSpendRuleInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationValidateAddressArgs = {
  input: ValidateAddressInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationVerifyNetworkTokenArgs = {
  input: VerifyNetworkTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationVerifyPaymentCardArgs = {
  input: VerifyPaymentCardInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationVerifyPaymentMethodTokenArgs = {
  input: VerifyPaymentMethodTokenInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationWaiveFeeTransferArgs = {
  input: WaiveFeeTransferInput;
};

/** Root Mutation type extending the main GraphQL schema. */
export type MutationWaiveInterestAmountForClosedStatementArgs = {
  input: WaiveInterestAmountForClosedStatementInput;
};

/** Type representing common fields of a person's name. */
export type Name = {
  __typename?: "Name";
  /** Part of a personal name that identifies a family, tribe, or community. */
  familyName?: Maybe<Scalars["String"]>;
  /** The part of the name that identifies a person. */
  givenName?: Maybe<Scalars["String"]>;
  /** Additional part of name that identifies a person. */
  middleName?: Maybe<Scalars["String"]>;
  /** Provides additional information about the person (e.g. Jr., Sr.) */
  suffix?: Maybe<Scalars["String"]>;
  /** One or more words used before the person's name (e.g. Mx., Dr.). */
  title?: Maybe<Scalars["String"]>;
};

/** Input representing common fields of a person's name. */
export type NameInput = {
  /**
   * Part of a personal name that identifies a family, tribe, or community.
   *
   * **Minimum length:** 2 character
   * **Maximum length:** 255 characters
   *
   * The validation for the input uses the following regex pattern `^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$`.
   */
  familyName: Scalars["String"];
  /**
   * The part of the name that identifies a person.
   *
   * **Minimum length:** 1 character
   * **Maximum length:** 255 characters
   *
   * The validation for the input uses the following regex pattern `^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$`.
   */
  givenName: Scalars["String"];
  /**
   * Additional part of name that identifies a person.
   *
   * **Maximum length:** 255 characters
   *
   * The validation for the input uses the following regex pattern `^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$`.
   */
  middleName?: InputMaybe<Scalars["String"]>;
  /**
   * Provides additional information about the person (e.g. Jr., Sr.)
   *
   * **Maximum length:** 10 characters
   *
   * The validation for the input uses the following regex pattern `^[a-zA-Z.]+$`.
   */
  suffix?: InputMaybe<Scalars["String"]>;
  /**
   * One or more words used before the person's name (e.g. Mx., Dr.).
   *
   * **Maximum length:** 10 characters
   *
   * The validation for the input uses the following regex pattern `^[a-zA-Z.]+$`.
   */
  title?: InputMaybe<Scalars["String"]>;
};

/** A country-specific identification document. */
export type NationalIdentificationDocument = {
  __typename?: "NationalIdentificationDocument";
  /**
   * The three-character country code of the issuing country.
   * Uses [ISO 3166-1 alpha-3](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3) country codes.
   */
  countryCodeAlpha3?: Maybe<Iso3166Alpha3Country>;
  /** The expiration date of the identification document in YYYY-MM-DD format. */
  expirationDate?: Maybe<Scalars["String"]>;
  /** The type of national identification number. */
  nationalIdentificationNumberType?: Maybe<NationalIdentificationNumberType>;
  /** A cryptographically hashed representation of the number. */
  numberHash?: Maybe<Scalars["String"]>;
};

/** National identification number types. */
export enum NationalIdentificationNumberType {
  /**
   * Employer Identification Number (EIN) for the United States.
   * A 9-digit number assigned to business entities operating in the U.S. for tax purposes.
   */
  EMPLOYER_IDENTIFICATION_NUMBER = "EMPLOYER_IDENTIFICATION_NUMBER",
  /**
   * Individual Taxpayer Identification Number (ITIN) for the United States.
   * A 9-digit tax processing number issued by the IRS for those ineligible for an SSN.
   */
  INDIVIDUAL_TAXPAYER_IDENTIFICATION_NUMBER = "INDIVIDUAL_TAXPAYER_IDENTIFICATION_NUMBER",
  /**
   * Identity Number (Mispar Zehut) for Israel.
   * A 9-digit number assigned to Israeli citizens and permanent residents.
   */
  ISRAELI_IDENTITY_NUMBER = "ISRAELI_IDENTITY_NUMBER",
  /**
   * National Insurance Number (NINO) for the United Kingdom.
   * Used for tax and national insurance purposes in the United Kingdom.
   * Format: 2 letters, 6 digits, 1 letter (for example, AB123456C).
   * Certain prefix combinations are invalid (BG, GB, NK, KN, TN, NT, ZZ).
   */
  NATIONAL_INSURANCE_NUMBER = "NATIONAL_INSURANCE_NUMBER",
  /**
   * Social Insurance Number (SIN) for Canada.
   * A 9-digit number used for tax and government benefits purposes.
   */
  SOCIAL_INSURANCE_NUMBER = "SOCIAL_INSURANCE_NUMBER",
  /**
   * Social Security Number (SSN) for the United States.
   * A 9-digit identifier issued to U.S. citizens, permanent residents, and temporary residents.
   */
  SOCIAL_SECURITY_NUMBER = "SOCIAL_SECURITY_NUMBER",
}

/** The Negative Reserve is held to cover deficits in the product such as potential over limits, fraud, uncollectible negative balances, and losses due to disputes or network charges. Funds may not be transferred out of the Negative Reserve. */
export type NegativeBalanceReserveFinancialAccountFeature =
  FinancialAccountFeature & {
    __typename?: "NegativeBalanceReserveFinancialAccountFeature";
    /** The date and time, in ISO 8601 format, the feature was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective from. */
    effectiveFrom?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective through. */
    effectiveThrough?: Maybe<Scalars["String"]>;
    /** Whether or not the feature is enabled for the Financial Account. */
    enabled?: Maybe<Scalars["Boolean"]>;
    /** The date and time, in ISO 8601 format, the feature was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** A fee associated with network processing the `PaymentTransaction`. */
export type NetworkFeePaymentTransactionFee = PaymentTransactionFee & {
  __typename?: "NetworkFeePaymentTransactionFee";
  /**
   * The direction the fees are moving in the perspective of the subscriber.
   * * when DEBIT, this fee is deducted from the total payable amount.
   * * when CREDIT, this fee is credited to the total payable amount.
   */
  accountingDirection?: Maybe<AccountingDirection>;
  /** The amount of the fee. */
  feeAmount?: Maybe<Amount>;
};

/** Used to represent a `NetworkToken`. */
export type NetworkTokenInput = {
  /** The primary account number for the payment card. */
  cardNumber: Scalars["String"];
  /**
   * The month the payment card expires.
   *
   * Must be formatted as MM.
   */
  expiryMonth: Scalars["String"];
  /**
   * The year the payment card expires.
   *
   * Must be formatted as YY.
   */
  expiryYear: Scalars["String"];
  /** Information about the network tokenization */
  networkTokenization?: InputMaybe<NetworkTokenizationInfoInput>;
};

/** Information about the network tokenization */
export type NetworkTokenizationInfoInput = {
  /** The dynamic one-time security code that authenticates this `NetworkToken`. */
  cryptogram?: InputMaybe<Scalars["String"]>;
  /** The identifier from the card network for this `NetworkToken`. */
  tokenRequestorIdentifier?: InputMaybe<Scalars["String"]>;
};

export type Node = {
  /** Globally unique ID to fetch a Node. */
  id: Scalars["ID"];
};

/**
 * The status of the ACH transfer that has not failed.
 *
 * This could be statuses which are still pending work or that have successfully completed.
 */
export type NonFailureAchTransferStatus = {
  __typename?: "NonFailureACHTransferStatus";
  /** The status of the integrator initiated ACH transfer. */
  status?: Maybe<AchTransferStatus>;
};

/**
 * The status of the ACH transfer that has not failed.
 *
 * This could be statuses which are still pending work or that have successfully completed.
 */
export type NonFailureExternallyInitiatedAchStatus = {
  __typename?: "NonFailureExternallyInitiatedACHStatus";
  /** The status of the externally initiated ACH transfer. */
  status?: Maybe<ExternallyInitiatedAchStatus>;
};

/** Non failure fee transfer event status. */
export type NonFailureFeeTransferStatus = {
  __typename?: "NonFailureFeeTransferStatus";
  /** The fee transfer event status. */
  status?: Maybe<FeeTransferEventStatus>;
};

/**
 * The status of the ACH transfer that has not failed.
 *
 * This could be statuses which are still pending work or that have successfully completed.
 */
export type NonFailureIntegratorInitiatedAchStatus = {
  __typename?: "NonFailureIntegratorInitiatedACHStatus";
  /** The status of the integrator initiated ACH transfer. */
  status?: Maybe<IntegratorInitiatedAchStatus>;
};

/**
 * The status of the wire transfer that has not failed.
 *
 * This could be statuses which are still pending work or that have successfully completed.
 */
export type NonFailureWireTransferStatus = {
  __typename?: "NonFailureWireTransferStatus";
  /** The status of the wire transfer. */
  status?: Maybe<WireTransferStatus>;
};

/**
 * The details of an `AchTransfer` initiated by an external financial institution.
 * It can `PULL` funds from a Highnote `FinancialAccount` to an external financial institution
 * or `PUSH` funds from an external financial institution to a Highnote `FinancialAccount`.
 */
export type NonOriginatedAchTransfer = AchTransfer &
  ElectronicFundsTransfer &
  Node & {
    __typename?: "NonOriginatedAchTransfer";
    /** The monetary amount to transfer. */
    amount?: Maybe<Amount>;
    /** The `CardProduct` associated with the Highnote `FinancialAccount`. */
    cardProduct?: Maybe<CardProduct>;
    /**
     * Provides the receiving financial institution with information about the nature or purpose of the transaction.
     * Examples include "ACCTVERIFY". "PAYROLL", "PAYMENT", etc.
     *
     * Maximum length: 10 characters.
     */
    companyEntryDescription?: Maybe<Scalars["String"]>;
    /** The ID of the company that initiated the transfer. */
    companyIdentifier?: Maybe<Scalars["String"]>;
    /** The name of the company that initiated the transfer. */
    companyName?: Maybe<Scalars["String"]>;
    /** The date and time the transfer was received, in ISO 8601 format, e.g. 2024-01-01T00:00:00.000Z. */
    createdAt?: Maybe<Scalars["String"]>;
    /**
     * The date and time the transfer was failed by Highnote before it was returned to the external financial institution,
     * in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z.
     */
    failedAt?: Maybe<Scalars["String"]>;
    /** The Highnote `FinancialAccount` funds being pulled from or pushed to. */
    financialAccount?: Maybe<FinancialAccount>;
    /**
     * The hold status of the transfer.
     *
     * Funds from a `NonOriginatedAchTransfer` `PUSH` are not available to spend while the transfer is `ON_HOLD`.
     *
     * This field is currently restricted to administrators.
     */
    holdStatus?: Maybe<AchHoldStatus>;
    /**
     * The hold type of the transfer.
     *
     * This field is currently restricted to administrators.
     */
    holdType?: Maybe<AchHoldType>;
    /** Global ID used to reference the `NonOriginatedAchTransfer`. */
    id: Scalars["ID"];
    /**
     * Receiver’s identification number. This could be a person or a business.
     *
     * Maximum length: 15 characters.
     */
    individualIdentificationNumber?: Maybe<Scalars["String"]>;
    /**
     * Receiver’s individual name. This could be a person or a business.
     *
     * Maximum length: 22 characters.
     */
    individualName?: Maybe<Scalars["String"]>;
    /**
     * The date and time the hold status last changed, in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z.
     *
     * Funds from a `NonOriginatedAchTransfer` `PUSH` are not available to spend while the transfer is `ON_HOLD`.
     *
     * This field is currently restricted to administrators.
     */
    lastHoldStatusChangedAt?: Maybe<Scalars["String"]>;
    /** The ledgers affected by the transfer. */
    ledgers?: Maybe<Array<Ledger>>;
    /**
     * Contains payment-related information provided by the originator of the transaction.
     * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
     * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
     *
     * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
     *
     * Please note that this information may or may not be displayed to the recipient, based on the bank's
     * capabilities, and method of access (i.e., online banking, statement, etc.)
     *
     * Maximum length: 80 characters.
     */
    paymentRelatedInformation?: Maybe<Scalars["String"]>;
    /**
     * The date and time the transfer was processed (e.g. transitioned to `PROCESSED`) and reflected on the financial account,
     * in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z.
     */
    processedAt?: Maybe<Scalars["String"]>;
    /** The purpose of the transfer, e.g. repayment. */
    purpose?: Maybe<AchTransferPurpose>;
    /** The date the transfer was returned by Highnote to the external financial institution, in ISO 8601 format, e.g. 2024-01-01T00:00:00.000Z. */
    returnSentToBankAt?: Maybe<Scalars["String"]>;
    /** The date in which the originating financial institution expects ACH settlement to occur, in ISO 8601 format, e.g. 2024-01-01. */
    settlementDate?: Maybe<Scalars["String"]>;
    /**
     * The impact of the transfer on the Highnote `FinancialAccount`.
     * Negative means a reduction of funds on the Highnote `FinancialAccount`.
     * Positive means an increase of funds on the Highnote `FinancialAccount`.
     */
    sign?: Maybe<AchTransferSign>;
    /** The status of the transfer. */
    status?: Maybe<NonOriginatedAchTransferStatus>;
    /** Additional details about why the transfer failed. This is only applicable when the transfer status is `FAILED` or `RETURNED`. */
    statusFailureReason?: Maybe<AchTransferStatusFailureReason>;
    /** A unique 15 digit number assigned by the originator. It is used is used to identify the transfer in the ACH network. */
    traceNumber?: Maybe<Scalars["String"]>;
    /**
     * The direction of the transfer, `PUSH` or `PULL`, from the perspective of the originating financial institution.
     *
     * `PUSH` means pushing funds from an external financial account to a Highnote `FinancialAccount` and
     * `PULL` means pulling funds from a Highnote `FinancialAccount` to an external financial account.
     */
    type?: Maybe<AchTransferType>;
    /** The date and time the transfer details were last updated, in ISO 8601 format, e.g. 2024-01-01T00:00:00.000Z. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/**
 * The details of an `AchTransfer` initiated by an external financial institution.
 * It can `PULL` funds from a Highnote `FinancialAccount` to an external financial institution
 * or `PUSH` funds from an external financial institution to a Highnote `FinancialAccount`.
 */
export type NonOriginatedAchTransferLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** The connection type for `NonOriginatedAchTransfer`. */
export type NonOriginatedAchTransferConnection = {
  __typename?: "NonOriginatedAchTransferConnection";
  /** A list of edges. */
  edges?: Maybe<Array<NonOriginatedAchTransferEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a `NonOriginatedAchTransfer`. */
export type NonOriginatedAchTransferEdge = {
  __typename?: "NonOriginatedAchTransferEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The `NonOriginatedAchTransfer`. */
  node?: Maybe<NonOriginatedAchTransfer>;
};

/** An event that occurs when a `NonOriginatedAchTransfer` is failed by Highnote. */
export type NonOriginatedAchTransferFailedEvent = Node & {
  __typename?: "NonOriginatedAchTransferFailedEvent";
  /** The date the transfer was failed by Highnote, in ISO 8601 format, e.g. 2024-01-01T00:00:00.000Z. */
  failedAt?: Maybe<Scalars["String"]>;
  /** Uniquely identifies the `NonOriginatedAchTransferFailedEvent`. */
  id: Scalars["ID"];
  /** Additional details about why the ACH transfer failed. */
  statusFailureReason?: Maybe<AchTransferStatusFailureReason>;
  /** Details about the `NonOriginatedAchTransfer` that was failed by Highnote. */
  transfer: NonOriginatedAchTransfer;
};

/** Inputs for filtering non-originated ACH transfer data. */
export type NonOriginatedAchTransferFilterInput = {
  amount?: InputMaybe<MoneyFilterInput>;
  cardProductId?: InputMaybe<StringSearchFilterInput>;
  companyEntryDescription?: InputMaybe<StringSearchFilterInput>;
  companyIdentifier?: InputMaybe<StringFilterInput>;
  companyName?: InputMaybe<StringSearchFilterInput>;
  createdAt?: InputMaybe<TimestampFilterInput>;
  holdStatus?: InputMaybe<AchHoldStatusFilterInput>;
  purpose?: InputMaybe<AchTransferPurposeFilterInput>;
  returnSentToBankAt?: InputMaybe<TimestampFilterInput>;
  settlementDate?: InputMaybe<DateFilterInput>;
  sign?: InputMaybe<AchTransferSignFilterInput>;
  status?: InputMaybe<NonOriginatedAchTransferStatusFilterInput>;
  statusFailureReason?: InputMaybe<AchTransferStatusFailureReasonFilterInput>;
  traceNumber?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<AchTransferTypeFilterInput>;
};

export type NonOriginatedAchTransferPayload =
  | AccessDeniedError
  | NonOriginatedAchTransferConnection
  | UserError;

/** An event that occurs when a `NonOriginatedAchTransfer` is processed by Highnote. */
export type NonOriginatedAchTransferProcessedEvent = Node & {
  __typename?: "NonOriginatedAchTransferProcessedEvent";
  /** Uniquely identifies the `NonOriginatedAchTransferProcessedEvent`. */
  id: Scalars["ID"];
  /**
   * The date and time the transfer was processed (e.g. transitioned to `PROCESSED`) and reflected on the financial account,
   * in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z.
   */
  processedAt?: Maybe<Scalars["String"]>;
  /** Details about the `NonOriginatedAchTransfer` that was processed. */
  transfer: NonOriginatedAchTransfer;
};

/** An event that occurs when a `NonOriginatedAchTransfer` is received from an external financial institution. */
export type NonOriginatedAchTransferReceivedEvent = Node & {
  __typename?: "NonOriginatedAchTransferReceivedEvent";
  /** The date the transfer was received by Highnote, in ISO 8601 format, e.g. 2024-01-01T00:00:00.000Z. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Uniquely identifies the `NonOriginatedAchTransferReceivedEvent`. */
  id: Scalars["ID"];
  /** Details about the `NonOriginatedAchTransfer` that was received. */
  transfer: NonOriginatedAchTransfer;
};

/** An event that occurs when a `NonOriginatedAchTransfer` is returned by Highnote. */
export type NonOriginatedAchTransferReturnedEvent = Node & {
  __typename?: "NonOriginatedAchTransferReturnedEvent";
  /** Uniquely identifies the `NonOriginatedAchTransferReturnedEvent`. */
  id: Scalars["ID"];
  /**
   * The date the transfer was returned by Highnote to the external financial institution,
   * in ISO 8601 format, e.g. 2024-01-01T00:00:00.000Z.
   */
  returnSentToBankAt?: Maybe<Scalars["String"]>;
  /** Additional details about why the ACH transfer failed. */
  statusFailureReason?: Maybe<AchTransferStatusFailureReason>;
  /** Details about the `NonOriginatedAchTransfer` that was returned by Highnote. */
  transfer: NonOriginatedAchTransfer;
};

/** A snapshot of a non-originated ACH transfer. */
export type NonOriginatedAchTransferSnapshot = Node & {
  __typename?: "NonOriginatedAchTransferSnapshot";
  /** The monetary amount to transfer. */
  amount?: Maybe<Amount>;
  /** The `CardProduct` associated with the Highnote `FinancialAccount`. */
  cardProduct?: Maybe<CardProduct>;
  /**
   * Provides the receiving financial institution with information about the nature or purpose of the transaction.
   * Examples include "ACCTVERIFY". "PAYROLL", "PAYMENT", etc.
   *
   * Maximum length: 10 characters.
   */
  companyEntryDescription?: Maybe<Scalars["String"]>;
  /** The ID of the company that initiated the transfer. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /** The name of the company that initiated the transfer. */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time this snapshot was created, in ISO 8601 format. */
  createdAt?: Maybe<Scalars["String"]>;
  /**
   * The date and time the transfer was failed by Highnote before it was returned to the external financial institution,
   * in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z.
   */
  failedAt?: Maybe<Scalars["String"]>;
  /** The Highnote `FinancialAccount` funds being pulled from or pushed to. */
  financialAccount?: Maybe<FinancialAccount>;
  /**
   * The hold status of the transfer.
   *
   * Funds from a `NonOriginatedAchTransfer` `PUSH` are not available to spend while the transfer is `ON_HOLD`.
   *
   * This field is currently restricted to administrators.
   */
  holdStatus?: Maybe<AchHoldStatus>;
  /**
   * The hold type of the transfer.
   *
   * This field is currently restricted to administrators.
   */
  holdType?: Maybe<AchHoldType>;
  /** Global ID used to reference this snapshot. */
  id: Scalars["ID"];
  /**
   * Receiver's identification number. This could be a person or a business.
   *
   * Maximum length: 15 characters.
   */
  individualIdentificationNumber?: Maybe<Scalars["String"]>;
  /**
   * Receiver's individual name. This could be a person or a business.
   *
   * Maximum length: 22 characters.
   */
  individualName?: Maybe<Scalars["String"]>;
  /**
   * The date and time the hold status last changed, in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z.
   *
   * Funds from a `NonOriginatedAchTransfer` `PUSH` are not available to spend while the transfer is `ON_HOLD`.
   *
   * This field is currently restricted to administrators.
   */
  lastHoldStatusChangedAt?: Maybe<Scalars["String"]>;
  /** The ledgers affected by the transfer. */
  ledgers?: Maybe<Array<Ledger>>;
  /**
   * Contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   *
   * Maximum length: 80 characters.
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
  /**
   * The date and time the transfer was processed (e.g. transitioned to `PROCESSED`) and reflected on the financial account,
   * in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z.
   */
  processedAt?: Maybe<Scalars["String"]>;
  /** The purpose of the transfer, e.g. repayment. */
  purpose?: Maybe<AchTransferPurpose>;
  /** The date the transfer was returned by Highnote to the external financial institution, in ISO 8601 format, e.g. 2024-01-01T00:00:00.000Z. */
  returnSentToBankAt?: Maybe<Scalars["String"]>;
  /** The date in which the originating financial institution expects ACH settlement to occur, in ISO 8601 format, e.g. 2024-01-01. */
  settlementDate?: Maybe<Scalars["String"]>;
  /**
   * The impact of the transfer on the Highnote `FinancialAccount`.
   * Negative means a reduction of funds on the Highnote `FinancialAccount`.
   * Positive means an increase of funds on the Highnote `FinancialAccount`.
   */
  sign?: Maybe<AchTransferSign>;
  /** The status of the transfer. */
  status?: Maybe<NonOriginatedAchTransferStatus>;
  /** Additional details about why the transfer failed. This is only applicable when the transfer status is `FAILED` or `RETURNED`. */
  statusFailureReason?: Maybe<AchTransferStatusFailureReason>;
  /** A unique 15 digit number assigned by the originator. It is used is used to identify the transfer in the ACH network. */
  traceNumber?: Maybe<Scalars["String"]>;
  /** The non-originated ACH transfer that this is a revision of. */
  transfer?: Maybe<NonOriginatedAchTransfer>;
  /**
   * The direction of the transfer, `PUSH` or `PULL`, from the perspective of the originating financial institution.
   *
   * `PUSH` means pushing funds from an external financial account to a Highnote `FinancialAccount` and
   * `PULL` means pulling funds from a Highnote `FinancialAccount` to an external financial account.
   */
  type?: Maybe<AchTransferType>;
  /** The date and time this snapshot was last updated, in ISO 8601 format. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** The version number of this snapshot. */
  version?: Maybe<Scalars["Int"]>;
};

/** A snapshot of a non-originated ACH transfer. */
export type NonOriginatedAchTransferSnapshotLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** The status of a `NonOriginatedAchTransfer`. */
export enum NonOriginatedAchTransferStatus {
  /** The transfer has been canceled by Highnote. This status is rare and typically indicates the transfer was received in error. */
  CANCELED = "CANCELED",
  /** The transfer failed but has not yet been returned to the external financial institution that initiated it. More details are available in `AchTransferStatusFailureReason`. */
  FAILED = "FAILED",
  /** The transfer has been processed by Highnote. */
  PROCESSED = "PROCESSED",
  /** The transfer has been received by Highnote, but has not been processed yet, e.g. the settlement date is in the future. */
  RECEIVED = "RECEIVED",
  /** The transfer has been returned to the external financial institution that initiated it. More details are available in `AchTransferStatusFailureReason`. */
  RETURNED = "RETURNED",
}

/** Input for filtering by `AchTransferPurpose`. */
export type NonOriginatedAchTransferStatusFilterInput = {
  equals?: InputMaybe<NonOriginatedAchTransferStatus>;
  excludes?: InputMaybe<Array<NonOriginatedAchTransferStatus>>;
  includes?: InputMaybe<Array<NonOriginatedAchTransferStatus>>;
  notEquals?: InputMaybe<NonOriginatedAchTransferStatus>;
};

/**
 * A non-originated RTP (Real-Time Payments) transfer via the TCH network.
 *
 * A `NonOriginatedRtpTransfer` represents an RTP transfer received by the Highnote partner bank
 * from an external bank account.
 */
export type NonOriginatedRtpTransfer = Node &
  RtpTransfer & {
    __typename?: "NonOriginatedRtpTransfer";
    /** Additional details for the bank transfer including payment related information. */
    bankTransferDetails?: Maybe<RtpTransferBankTransferDetails>;
    /** The date and time, in ISO 8601 format, when this object was received. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The destination of the funds being transferred. */
    destination?: Maybe<RtpTransferDestination>;
    /** The events associated with this `NonOriginatedRtpTransfer`. */
    events?: Maybe<Array<NonOriginatedRtpTransferEvent>>;
    /** When the `NonOriginatedRtpTransfer` has failed, this will be populated with the reason for the failure. */
    failureReason?: Maybe<RtpTransferFailureReason>;
    /** Global ID used to reference this object. */
    id: Scalars["ID"];
    /** The source of the funds being transferred. */
    source?: Maybe<RtpTransferSource>;
    /** The current status of the `NonOriginatedRtpTransfer`. */
    status?: Maybe<RtpTransferStatus>;
    /** The date and time, in ISO 8601 format, when this object was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** An event associated with a `NonOriginatedRtpTransfer`. */
export type NonOriginatedRtpTransferEvent = Node & {
  __typename?: "NonOriginatedRtpTransferEvent";
  /** The date and time, in ISO 8601 format, when this event occurred. */
  createdAt?: Maybe<Scalars["String"]>;
  /** When the `NonOriginatedRtpTransfer.status` is `FAILED` during this event, this will be populated with the reason for the failure. */
  failureReason?: Maybe<RtpTransferFailureReason>;
  /** The global ID of the event. */
  id: Scalars["ID"];
  /** The `NonOriginatedRtpTransfer` associated with this event. */
  rtpTransfer?: Maybe<NonOriginatedRtpTransfer>;
  /** The status of the `NonOriginatedRtpTransfer` when the event occurred. */
  status?: Maybe<RtpTransferStatus>;
};

/** A NonVerifiedExternalUSFinancialBankAccount */
export type NonVerifiedExternalUsFinancialBankAccount = Node & {
  __typename?: "NonVerifiedExternalUSFinancialBankAccount";
  /** ExternalFinancialBankAccount status. */
  accountStatus?: Maybe<ExternalFinancialAccountStatus>;
  /** The date and time, in ISO 8601 format, the account was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The external bank account added to this external financial account. */
  externalBankAccountDetails?: Maybe<NonVerifiedExternalUsFinancialBankAccountDetail>;
  /** Features on the `NonVerifiedExternalUSFinancialBankAccount` */
  features?: Maybe<Array<FinancialAccountFeature>>;
  /** Global ID used to reference the External Financial Account in operations. */
  id: Scalars["ID"];
  /** The name of this account */
  name?: Maybe<Scalars["String"]>;
  /** The owner of this financial account. */
  owner?: Maybe<FinancialAccountOwner>;
  /** The date and time, in ISO 8601 format, the account was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/**
 * A financial instrument with an associated account and routing number.
 *
 * The direct deposit detail that can be used to deposit funds.
 */
export type NonVerifiedExternalUsFinancialBankAccountDetail = Node & {
  __typename?: "NonVerifiedExternalUSFinancialBankAccountDetail";
  /** The date and time, in ISO 8601 format, the external bank account detail was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the external bank account detail in operations. */
  id: Scalars["ID"];
  /** The last four digits of bank account number. */
  last4?: Maybe<Scalars["String"]>;
  /** The decrypted account number for this external bank account detail. */
  restrictedDetails?: Maybe<NonVerifiedExternalUsFinancialBankAccountDetailRestrictedDetailsResult>;
  /** The routing number for the bank account. */
  routingNumber?: Maybe<Scalars["String"]>;
  /** The details about the type of bank account. */
  type?: Maybe<BankAccountType>;
  /** The date and time, in ISO 8601 format, the external bank account detail was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

export type NonVerifiedExternalUsFinancialBankAccountDetailRestrictedDetailsResult =

    | AccessDeniedError
    | NonVerifiedExternalUsFinancialBankAccountRestrictedDetails;

/** Non Verified External US Financial Bank Account Details. */
export type NonVerifiedExternalUsFinancialBankAccountRestrictedDetails = {
  __typename?: "NonVerifiedExternalUSFinancialBankAccountRestrictedDetails";
  /** The bank account number. */
  number?: Maybe<Scalars["String"]>;
  /** The routing number for the bank account. */
  routingNumber?: Maybe<Scalars["String"]>;
};

/** Whether or not the Financial Account is a Non Verified account */
export type NonVerifiedFinancialAccountFeature = FinancialAccountFeature & {
  __typename?: "NonVerifiedFinancialAccountFeature";
  /** The date and time, in ISO 8601 format, the feature was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective from. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective through. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Whether or not the feature is enabled for the Financial Account. */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** The date and time, in ISO 8601 format, the feature was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The expected balance of a Ledger. */
export enum NormalBalance {
  /** The value when a Ledger is expected to have a credit balance. */
  CREDIT = "CREDIT",
  /** The value when a Ledger is expected to have a debit balance. */
  DEBIT = "DEBIT",
}

/** The Notification Event that was triggered in the Highnote platform. */
export type NotificationEvent = Node & {
  __typename?: "NotificationEvent";
  /** The date and time, in ISO 8601 format, the Notification Event was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The history of delivery attempts for this Notification Event. */
  deliveryAttempts?: Maybe<DeliveryAttemptConnection>;
  /** The date and time, in ISO 8601 format, the Notification Event will expire. */
  expiresAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the Event in operations. */
  id: Scalars["ID"];
  /** The name of the Notification Event that was triggered. */
  name?: Maybe<NotificationEventName>;
  /** The Notification Event. */
  node?: Maybe<NotificationEventNode>;
  /**
   * Information about the origination of this event if it was relayed from another organization.
   * Only present for relayed events.
   */
  origination?: Maybe<Origination>;
};

/** The Notification Event that was triggered in the Highnote platform. */
export type NotificationEventDeliveryAttemptsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The edge type for Notification Events. */
export type NotificationEventEdge = {
  __typename?: "NotificationEventEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The Notification Event. */
  node?: Maybe<NotificationEvent>;
};

/** The Notification Events that can be triggered in the Highnote platform. */
export enum NotificationEventName {
  /** The name of the Notification Event when a Financial Account enters the ACTIVE status. */
  ACCOUNT_STATUS_ACTIVE = "ACCOUNT_STATUS_ACTIVE",
  /** The name of the Notification Event when a Financial Account has been CLOSED. */
  ACCOUNT_STATUS_CLOSED = "ACCOUNT_STATUS_CLOSED",
  /** The name of the Notification Event when a Financial Account enters the PENDING_CLOSURE status. */
  ACCOUNT_STATUS_PENDING_CLOSURE = "ACCOUNT_STATUS_PENDING_CLOSURE",
  /** The name of the Notification Event when a Financial Account enters the SUSPENDED status. */
  ACCOUNT_STATUS_SUSPENDED = "ACCOUNT_STATUS_SUSPENDED",
  /** The name of the Notification Event when a Financial Account enters the UNDER_REVIEW status. */
  ACCOUNT_STATUS_UNDER_REVIEW = "ACCOUNT_STATUS_UNDER_REVIEW",
  /** The name of the Notification Event when externally initiated ACH deposits have failed */
  ACH_EXTERNALLY_INITIATED_DEPOSIT_FAILED = "ACH_EXTERNALLY_INITIATED_DEPOSIT_FAILED",
  /** The name of the Notification Event when externally initiated ACH deposits are processed */
  ACH_EXTERNALLY_INITIATED_DEPOSIT_PROCESSED = "ACH_EXTERNALLY_INITIATED_DEPOSIT_PROCESSED",
  /** The name of the Notification Event when externally initiated ACH deposits are received */
  ACH_EXTERNALLY_INITIATED_DEPOSIT_RECEIVED = "ACH_EXTERNALLY_INITIATED_DEPOSIT_RECEIVED",
  /** The name of the Notification Event when externally initiated ACH withdrawals have failed */
  ACH_EXTERNALLY_INITIATED_WITHDRAWAL_FAILED = "ACH_EXTERNALLY_INITIATED_WITHDRAWAL_FAILED",
  /** The name of the Notification Event when externally initiated ACH withdrawals are processed */
  ACH_EXTERNALLY_INITIATED_WITHDRAWAL_PROCESSED = "ACH_EXTERNALLY_INITIATED_WITHDRAWAL_PROCESSED",
  /** The name of the Notification Event when externally initiated ACH withdrawals are received */
  ACH_EXTERNALLY_INITIATED_WITHDRAWAL_RECEIVED = "ACH_EXTERNALLY_INITIATED_WITHDRAWAL_RECEIVED",
  /** The name of the Notification Event when ACH funds deposits are canceled */
  ACH_FUNDS_DEPOSIT_CANCELED = "ACH_FUNDS_DEPOSIT_CANCELED",
  /** The name of the Notification Event when ACH funds deposits have failed */
  ACH_FUNDS_DEPOSIT_FAILED = "ACH_FUNDS_DEPOSIT_FAILED",
  /** The name of the Notification Event when ACH funds withdrawals are initiated */
  ACH_FUNDS_DEPOSIT_INITIATED = "ACH_FUNDS_DEPOSIT_INITIATED",
  /** The name of the Notification Event when ACH funds deposits are processed */
  ACH_FUNDS_DEPOSIT_PROCESSED = "ACH_FUNDS_DEPOSIT_PROCESSED",
  /** The name of the Notification Event when ACH funds deposits are processing */
  ACH_FUNDS_DEPOSIT_PROCESSING = "ACH_FUNDS_DEPOSIT_PROCESSING",
  /** The name of the Notification Event when ACH funds deposits are returned */
  ACH_FUNDS_DEPOSIT_RETURNED = "ACH_FUNDS_DEPOSIT_RETURNED",
  /** The name of the Notification Event when ACH funds withdrawals are canceled */
  ACH_FUNDS_WITHDRAWAL_CANCELED = "ACH_FUNDS_WITHDRAWAL_CANCELED",
  /** The name of the Notification Event when ACH funds withdrawals have failed */
  ACH_FUNDS_WITHDRAWAL_FAILED = "ACH_FUNDS_WITHDRAWAL_FAILED",
  /** The name of the Notification Event when ACH funds withdrawals are initiated */
  ACH_FUNDS_WITHDRAWAL_INITIATED = "ACH_FUNDS_WITHDRAWAL_INITIATED",
  /** The name of the Notification Event when ACH funds withdrawals are processed */
  ACH_FUNDS_WITHDRAWAL_PROCESSED = "ACH_FUNDS_WITHDRAWAL_PROCESSED",
  /** The name of the Notification Event when ACH funds withdrawals are processing */
  ACH_FUNDS_WITHDRAWAL_PROCESSING = "ACH_FUNDS_WITHDRAWAL_PROCESSING",
  /** The name of the Notification Event when ACH funds withdrawals are returned */
  ACH_FUNDS_WITHDRAWAL_RETURNED = "ACH_FUNDS_WITHDRAWAL_RETURNED",
  /** The name of the Notification Event when an ACH is put on hold. */
  ACH_HOLD_ADDED = "ACH_HOLD_ADDED",
  /** The name of the Notification Event when an ACH hold is removed. */
  ACH_HOLD_REMOVED = "ACH_HOLD_REMOVED",
  /** The name of the Notification Event when ACH repayments have failed */
  ACH_REPAYMENT_FAILED = "ACH_REPAYMENT_FAILED",
  /** The name of the Notification Event when ACH repayments are processed */
  ACH_REPAYMENT_PROCESSED = "ACH_REPAYMENT_PROCESSED",
  /** The name of the Notification Event when ACH repayments are processing */
  ACH_REPAYMENT_PROCESSING = "ACH_REPAYMENT_PROCESSING",
  /** The name of the Notification Event when ACH repayments are returned */
  ACH_REPAYMENT_RETURNED = "ACH_REPAYMENT_RETURNED",
  /** The name of the Notification Event when ACH secure deposits are canceled */
  ACH_SECURE_DEPOSIT_CANCELED = "ACH_SECURE_DEPOSIT_CANCELED",
  /** The name of the Notification Event when ACH secure deposits have failed */
  ACH_SECURE_DEPOSIT_FAILED = "ACH_SECURE_DEPOSIT_FAILED",
  /** The name of the Notification Event when ACH secure deposits are initiated */
  ACH_SECURE_DEPOSIT_INITIATED = "ACH_SECURE_DEPOSIT_INITIATED",
  /** The name of the Notification Event when ACH secure deposits are processed */
  ACH_SECURE_DEPOSIT_PROCESSED = "ACH_SECURE_DEPOSIT_PROCESSED",
  /** The name of the Notification Event when ACH secure deposits are processing */
  ACH_SECURE_DEPOSIT_PROCESSING = "ACH_SECURE_DEPOSIT_PROCESSING",
  /** The name of the Notification Event when ACH secure deposits are returned */
  ACH_SECURE_DEPOSIT_RETURNED = "ACH_SECURE_DEPOSIT_RETURNED",
  /** Triggered when an ACH transfer hold is added. */
  ACH_TRANSFER_HOLD_ADDED = "ACH_TRANSFER_HOLD_ADDED",
  /** Triggered when an ACH transfer hold is removed. */
  ACH_TRANSFER_HOLD_REMOVED = "ACH_TRANSFER_HOLD_REMOVED",
  /**
   * `DEPRECATED`
   *
   * The name of the Notification Event when an authorization is created.
   * @deprecated No longer supported
   */
  AUTHORIZATION_CREATED = "AUTHORIZATION_CREATED",
  /** The name of the Notification Event when an authorized user application is approved */
  AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_APPROVED = "AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_APPROVED",
  /** The name of the Notification Event when an authorized user application is closed */
  AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_CLOSED = "AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_CLOSED",
  /** The name of the Notification Event when an authorized user application is denied */
  AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_DENIED = "AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_DENIED",
  /** The name of the Notification Event when `DocumentUploadSessions` have been requested for an authorized user application. */
  AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_DOCUMENT_UPLOAD_REQUESTED = "AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_DOCUMENT_UPLOAD_REQUESTED",
  /**
   * The name of the Notification Event when an authorized user application is in review
   * @deprecated Deprecated for more specific action notification event types.
   */
  AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_IN_REVIEW = "AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_IN_REVIEW",
  /** The name of the Notification Event when an authorized user application requires manual review */
  AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_MANUAL_REVIEW = "AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_MANUAL_REVIEW",
  /** The name of the Notification Event when an authorized user application requires an underwriting decision. */
  AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_UNDERWRITING_DECISION_REQUESTED = "AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_UNDERWRITING_DECISION_REQUESTED",
  /** Triggered when identity verification documents are requested for a `BusinessAccountHolder`. */
  BUSINESS_ACCOUNT_HOLDER_IDENTITY_DOCUMENTS_REQUESTED = "BUSINESS_ACCOUNT_HOLDER_IDENTITY_DOCUMENTS_REQUESTED",
  /** Triggered when a `BusinessAccountHolder` is updated. */
  BUSINESS_ACCOUNT_HOLDER_IDENTITY_UPDATED = "BUSINESS_ACCOUNT_HOLDER_IDENTITY_UPDATED",
  /** Triggered when identity verification documents are requested for an `AuthorizedPerson`. */
  BUSINESS_AUTHORIZED_PERSON_IDENTITY_DOCUMENTS_REQUESTED = "BUSINESS_AUTHORIZED_PERSON_IDENTITY_DOCUMENTS_REQUESTED",
  /** Triggered when an `AuthorizedPerson` is updated. */
  BUSINESS_AUTHORIZED_PERSON_IDENTITY_UPDATED = "BUSINESS_AUTHORIZED_PERSON_IDENTITY_UPDATED",
  /** Triggered when identity verification documents are requested for a `USBusinessUltimateBeneficialOwner`. */
  BUSINESS_ULTIMATE_BENEFICIAL_OWNER_IDENTITY_DOCUMENTS_REQUESTED = "BUSINESS_ULTIMATE_BENEFICIAL_OWNER_IDENTITY_DOCUMENTS_REQUESTED",
  /** Triggered when a `USBusinessUltimateBeneficialOwner` is updated. */
  BUSINESS_ULTIMATE_BENEFICIAL_OWNER_IDENTITY_UPDATED = "BUSINESS_ULTIMATE_BENEFICIAL_OWNER_IDENTITY_UPDATED",
  /** The name of the Notification Event when a `CardDigitalWalletToken` has been activated. */
  CARD_DIGITAL_WALLET_TOKEN_ACTIVATED = "CARD_DIGITAL_WALLET_TOKEN_ACTIVATED",
  /** The name of the Notification Event when a `CardDigitalWalletToken` has been suspended. */
  CARD_DIGITAL_WALLET_TOKEN_SUSPENDED = "CARD_DIGITAL_WALLET_TOKEN_SUSPENDED",
  /** The name of the Notification Event when a `CardDigitalWalletToken` has been terminated. */
  CARD_DIGITAL_WALLET_TOKEN_TERMINATED = "CARD_DIGITAL_WALLET_TOKEN_TERMINATED",
  /** Triggered when a `PaymentTransaction` receives a authorization declined event. */
  CARD_PAYMENT_AUTHORIZATION_DECLINED_EVENT = "CARD_PAYMENT_AUTHORIZATION_DECLINED_EVENT",
  /** Triggered when a `PaymentTransaction` receives a authorized event. */
  CARD_PAYMENT_AUTHORIZED_EVENT = "CARD_PAYMENT_AUTHORIZED_EVENT",
  /**
   * Deprecated: Use `CARD_PAYMENT_AUTHORIZED_EVENT` instead.
   * @deprecated Use `CARD_PAYMENT_AUTHORIZED_EVENT` instead.
   */
  CARD_PAYMENT_AUTHORIZING_EVENT = "CARD_PAYMENT_AUTHORIZING_EVENT",
  /**
   * Deprecated: Use `CARD_PAYMENT_CAPTURING_EVENT` instead.
   * @deprecated Use `CARD_PAYMENT_CAPTURING_EVENT` instead.
   */
  CARD_PAYMENT_CAPTURED_EVENT = "CARD_PAYMENT_CAPTURED_EVENT",
  /** Triggered when a `PaymentTransaction` receives a capture declined event. */
  CARD_PAYMENT_CAPTURE_DECLINED_EVENT = "CARD_PAYMENT_CAPTURE_DECLINED_EVENT",
  /** Triggered when a `PaymentTransaction` receives a capture processing event. */
  CARD_PAYMENT_CAPTURE_PROCESSING_EVENT = "CARD_PAYMENT_CAPTURE_PROCESSING_EVENT",
  /** Triggered when a `PaymentTransaction` receives a capturing event. */
  CARD_PAYMENT_CAPTURING_EVENT = "CARD_PAYMENT_CAPTURING_EVENT",
  /** Triggered when a `PaymentTransaction` receives a cleared event. */
  CARD_PAYMENT_CLEARED_EVENT = "CARD_PAYMENT_CLEARED_EVENT",
  /** Triggered when a `PaymentTransaction` receives a clearing failed event. */
  CARD_PAYMENT_CLEARING_FAILED_EVENT = "CARD_PAYMENT_CLEARING_FAILED_EVENT",
  /** Triggered when a `PaymentTransaction` receives a disbursed event. */
  CARD_PAYMENT_DISBURSED_EVENT = "CARD_PAYMENT_DISBURSED_EVENT",
  /** Triggered when a `CardPaymentDispute` requires action from the merchant. */
  CARD_PAYMENT_DISPUTE_ACTION_REQUIRED = "CARD_PAYMENT_DISPUTE_ACTION_REQUIRED",
  /** Triggered when a `PaymentTransaction` receives a incremental authorization declined event. */
  CARD_PAYMENT_INCREMENTAL_AUTHORIZATION_DECLINED_EVENT = "CARD_PAYMENT_INCREMENTAL_AUTHORIZATION_DECLINED_EVENT",
  /** Triggered when a `PaymentTransaction` receives a incremental authorized event. */
  CARD_PAYMENT_INCREMENTAL_AUTHORIZED_EVENT = "CARD_PAYMENT_INCREMENTAL_AUTHORIZED_EVENT",
  /**
   * Deprecated: Use `CARD_PAYMENT_REVERSED_EVENT` instead.
   * @deprecated Use `CARD_PAYMENT_REVERSED_EVENT` instead.
   */
  CARD_PAYMENT_PARTIAL_REVERSED_EVENT = "CARD_PAYMENT_PARTIAL_REVERSED_EVENT",
  /** Triggered when a `PaymentTransaction` receives a payout event. */
  CARD_PAYMENT_PAYOUT_EVENT = "CARD_PAYMENT_PAYOUT_EVENT",
  /** Triggered when a `PaymentTransaction` receives a reversal declined event. */
  CARD_PAYMENT_REVERSAL_DECLINED_EVENT = "CARD_PAYMENT_REVERSAL_DECLINED_EVENT",
  /** Triggered when a `PaymentTransaction` receives a reversed event. */
  CARD_PAYMENT_REVERSED_EVENT = "CARD_PAYMENT_REVERSED_EVENT",
  /** Triggered when a `PaymentTransaction` receives a settled event. */
  CARD_PAYMENT_SETTLED_EVENT = "CARD_PAYMENT_SETTLED_EVENT",
  /** Triggered when a `PaymentTransaction` receives a verification declined event. */
  CARD_PAYMENT_VERIFICATION_DECLINED_EVENT = "CARD_PAYMENT_VERIFICATION_DECLINED_EVENT",
  /**
   * Triggered when a `PaymentTransaction` receives a verification pending event.
   * @deprecated Use `CARD_PAYMENT_VERIFIED_EVENT` or `CARD_PAYMENT_VERIFICATION_DECLINED_EVENT` instead.
   */
  CARD_PAYMENT_VERIFICATION_PENDING_EVENT = "CARD_PAYMENT_VERIFICATION_PENDING_EVENT",
  /** Triggered when a `PaymentTransaction` receives a verified event. */
  CARD_PAYMENT_VERIFIED_EVENT = "CARD_PAYMENT_VERIFIED_EVENT",
  /** The name of the Notification Event when an application is approved */
  CARD_PRODUCT_APPLICATION_APPROVED = "CARD_PRODUCT_APPLICATION_APPROVED",
  /** The name of the Notification Event when an application is closed */
  CARD_PRODUCT_APPLICATION_CLOSED = "CARD_PRODUCT_APPLICATION_CLOSED",
  /** The name of the Notification Event when an application requires an account holder to verify if they are the one who are applying for the application. */
  CARD_PRODUCT_APPLICATION_CREDIT_REPORT_FRAUD_ALERT = "CARD_PRODUCT_APPLICATION_CREDIT_REPORT_FRAUD_ALERT",
  /** The name of the Notification Event when an application requires an account holder to take action to unfreeze credit bureau. */
  CARD_PRODUCT_APPLICATION_CREDIT_REPORT_FREEZE = "CARD_PRODUCT_APPLICATION_CREDIT_REPORT_FREEZE",
  /** The name of the Notification Event when an application is denied */
  CARD_PRODUCT_APPLICATION_DENIED = "CARD_PRODUCT_APPLICATION_DENIED",
  /** The name of the Notification Event when `DocumentUploadSessions` have been requested for an application. */
  CARD_PRODUCT_APPLICATION_DOCUMENT_UPLOAD_REQUESTED = "CARD_PRODUCT_APPLICATION_DOCUMENT_UPLOAD_REQUESTED",
  /** The name of the Notification Event when `IdentityUpdateSessions` have been requested for an application. */
  CARD_PRODUCT_APPLICATION_IDENTITY_UPDATE_REQUESTED = "CARD_PRODUCT_APPLICATION_IDENTITY_UPDATE_REQUESTED",
  /**
   * The name of the Notification Event when an application is in review
   * @deprecated Deprecated for more specific action notification event types.
   */
  CARD_PRODUCT_APPLICATION_IN_REVIEW = "CARD_PRODUCT_APPLICATION_IN_REVIEW",
  /** The name of the Notification Event when an application requires manual review */
  CARD_PRODUCT_APPLICATION_MANUAL_REVIEW = "CARD_PRODUCT_APPLICATION_MANUAL_REVIEW",
  /** The name of the Notification Event when offer(s) on an application need to be decisioned. */
  CARD_PRODUCT_APPLICATION_OFFER_MANAGEMENT_REQUESTED = "CARD_PRODUCT_APPLICATION_OFFER_MANAGEMENT_REQUESTED",
  /** The name of the Notification Event when an application requires an underwriting decision. */
  CARD_PRODUCT_APPLICATION_UNDERWRITING_DECISION_REQUESTED = "CARD_PRODUCT_APPLICATION_UNDERWRITING_DECISION_REQUESTED",
  /** The check has been delivered, and cashed or deposited. */
  CHECK_PAYMENT_EVENT_COMPLETED = "CHECK_PAYMENT_EVENT_COMPLETED",
  /** The check has failed. The reason for the failure is included in the event. */
  CHECK_PAYMENT_EVENT_FAILED = "CHECK_PAYMENT_EVENT_FAILED",
  /** The check has been funded and is pending disbursement. */
  CHECK_PAYMENT_EVENT_FUNDING_COMPLETED = "CHECK_PAYMENT_EVENT_FUNDING_COMPLETED",
  /** The funds have been disbursed to external accounts. */
  CHECK_PAYMENT_EVENT_FUNDING_DISBURSED = "CHECK_PAYMENT_EVENT_FUNDING_DISBURSED",
  /** The check has been initiated and is pending funding. */
  CHECK_PAYMENT_EVENT_FUNDING_PENDING = "CHECK_PAYMENT_EVENT_FUNDING_PENDING",
  /** The check funding has been initiated. */
  CHECK_PAYMENT_EVENT_FUNDING_STARTED = "CHECK_PAYMENT_EVENT_FUNDING_STARTED",
  /** The check has been put on hold for risk assessment */
  CHECK_PAYMENT_EVENT_ON_RISK_HOLD = "CHECK_PAYMENT_EVENT_ON_RISK_HOLD",
  /** The check has been paid out. */
  CHECK_PAYMENT_EVENT_PAID = "CHECK_PAYMENT_EVENT_PAID",
  /** The check is pending processing by Highnote. */
  CHECK_PAYMENT_EVENT_PENDING_PROCESSING_BY_HIGHNOTE = "CHECK_PAYMENT_EVENT_PENDING_PROCESSING_BY_HIGHNOTE",
  /** The check has been printed and is pending shipment. */
  CHECK_PAYMENT_EVENT_PENDING_SHIPMENT = "CHECK_PAYMENT_EVENT_PENDING_SHIPMENT",
  /** The check has been printed. */
  CHECK_PAYMENT_EVENT_PRINTED = "CHECK_PAYMENT_EVENT_PRINTED",
  /** The check has been processed by Highnote. */
  CHECK_PAYMENT_EVENT_PROCESSED_BY_HIGHNOTE = "CHECK_PAYMENT_EVENT_PROCESSED_BY_HIGHNOTE",
  /** The check is processing by Highnote. */
  CHECK_PAYMENT_EVENT_PROCESSING_BY_HIGHNOTE = "CHECK_PAYMENT_EVENT_PROCESSING_BY_HIGHNOTE",
  /** The check reversal has been completed. */
  CHECK_PAYMENT_EVENT_REVERSAL_COMPLETED = "CHECK_PAYMENT_EVENT_REVERSAL_COMPLETED",
  /** The check has been reversed due to voiding or failure. */
  CHECK_PAYMENT_EVENT_REVERSAL_INITIATED = "CHECK_PAYMENT_EVENT_REVERSAL_INITIATED",
  /** The check has been shipped. */
  CHECK_PAYMENT_EVENT_SHIPPED = "CHECK_PAYMENT_EVENT_SHIPPED",
  /** The check has been voided. */
  CHECK_PAYMENT_EVENT_VOIDED = "CHECK_PAYMENT_EVENT_VOIDED",
  /** Triggered when a `CreditLimitChangeRequest` has a status change. */
  CREDIT_LIMIT_CHANGE_REQUEST_STATUS_CHANGED = "CREDIT_LIMIT_CHANGE_REQUEST_STATUS_CHANGED",
  /** Triggered when a `ManuallyRequestedDocumentUploadSession` is created. */
  DOCUMENT_UPLOAD_REQUESTED_EVENT = "DOCUMENT_UPLOAD_REQUESTED_EVENT",
  /** Triggered when a `DocumentUploadSession` has moved into a terminal state. */
  DOCUMENT_UPLOAD_SESSION_COMPLETE_EVENT = "DOCUMENT_UPLOAD_SESSION_COMPLETE_EVENT",
  /** The name of the Notification Event when a `Verified External Financial Account` is created */
  EXTERNAL_BANK_ACCOUNT_ADDED = "EXTERNAL_BANK_ACCOUNT_ADDED",
  /** The name of the Notification Event when a `Verified External Financial Account` is disconnected */
  EXTERNAL_BANK_ACCOUNT_REMOVED = "EXTERNAL_BANK_ACCOUNT_REMOVED",
  /** Triggered when a Fee has been charged. */
  FEE_CHARGE_EVENT = "FEE_CHARGE_EVENT",
  /** Triggered when a Fee has been reversed. */
  FEE_REVERSAL_EVENT = "FEE_REVERSAL_EVENT",
  /** Triggered when a `DocumentUploadLink` has completed upload. */
  FILE_UPLOAD_COMPLETE_EVENT = "FILE_UPLOAD_COMPLETE_EVENT",
  /** The name of the Notification Event when a `FinancialAccountAttribute` is added as CHARGE_OFF. */
  FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_CHARGE_OFF = "FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_CHARGE_OFF",
  /** The name of the Notification Event when a `FinancialAccountAttribute` is added as `CLOSED_WITH_BALANCE`. */
  FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_CLOSED_WITH_BALANCE = "FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_CLOSED_WITH_BALANCE",
  /** The name of the Notification Event when a `FinancialAccountAttribute` is added as DELINQUENT. */
  FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_DELINQUENT = "FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_DELINQUENT",
  /** The name of the Notification Event when a `FinancialAccountAttribute` is added as DELINQUENT_SUSPENDED. */
  FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_DELINQUENT_SUSPENDED = "FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_DELINQUENT_SUSPENDED",
  /** The name of the Notification Event when a `FinancialAccountAttribute` is added as PROGRAM_OWNER_INITIATED_SUSPENSION. */
  FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_PROGRAM_OWNER_INITIATED_SUSPENSION = "FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_PROGRAM_OWNER_INITIATED_SUSPENSION",
  /** The name of the Notification Event when a `FinancialAccountAttribute` is removed as CHARGE_OFF. */
  FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_CHARGE_OFF = "FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_CHARGE_OFF",
  /** The name of the Notification Event when a `FinancialAccountAttribute` is removed as `CLOSED_WITH_BALANCE`. */
  FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_CLOSED_WITH_BALANCE = "FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_CLOSED_WITH_BALANCE",
  /** The name of the Notification Event when a `FinancialAccountAttribute` is removed as DELINQUENT. */
  FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_DELINQUENT = "FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_DELINQUENT",
  /** The name of the Notification Event when a `FinancialAccountAttribute` is removed as DELINQUENT_SUSPENDED. */
  FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_DELINQUENT_SUSPENDED = "FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_DELINQUENT_SUSPENDED",
  /** The name of the Notification Event when a `FinancialAccountAttribute` is removed as PROGRAM_OWNER_INITIATED_SUSPENSION. */
  FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_PROGRAM_OWNER_INITIATED_SUSPENSION = "FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_PROGRAM_OWNER_INITIATED_SUSPENSION",
  /** The name of the Notification Event when a statement is ready */
  FINANCIAL_ACCOUNT_STATEMENT_READY = "FINANCIAL_ACCOUNT_STATEMENT_READY",
  /** Triggered when the `InstantNetworkTransfer` has completed. */
  INSTANT_NETWORK_TRANSFER_COMPLETED_EVENT = "INSTANT_NETWORK_TRANSFER_COMPLETED_EVENT",
  /** Triggered when the `InstantNetworkTransfer` has failed. */
  INSTANT_NETWORK_TRANSFER_FAILED_EVENT = "INSTANT_NETWORK_TRANSFER_FAILED_EVENT",
  /** Triggered when the `InstantNetworkTransfer` has been initiated. */
  INSTANT_NETWORK_TRANSFER_INITIATED_EVENT = "INSTANT_NETWORK_TRANSFER_INITIATED_EVENT",
  /** Triggered when money movement between `FinancialAccount`s has complete. */
  INTERNAL_TRANSFER_BETWEEN_FINANCIAL_ACCOUNTS_COMPLETED = "INTERNAL_TRANSFER_BETWEEN_FINANCIAL_ACCOUNTS_COMPLETED",
  /** Triggered when money movement between `FinancialAccount`s has failed. */
  INTERNAL_TRANSFER_BETWEEN_FINANCIAL_ACCOUNTS_FAILED = "INTERNAL_TRANSFER_BETWEEN_FINANCIAL_ACCOUNTS_FAILED",
  /** Triggered when money movement between `FinancialAccount`s is pending. */
  INTERNAL_TRANSFER_BETWEEN_FINANCIAL_ACCOUNTS_PENDING = "INTERNAL_TRANSFER_BETWEEN_FINANCIAL_ACCOUNTS_PENDING",
  /** The name of the Notification Event when an internal transfer from Funding Financial Account to Payment Card Financial Account has completed */
  INTERNAL_TRANSFER_FROM_FUNDING_FINANCIAL_ACCOUNT_TO_PAYMENT_CARD_FINANCIAL_ACCOUNT_COMPLETED = "INTERNAL_TRANSFER_FROM_FUNDING_FINANCIAL_ACCOUNT_TO_PAYMENT_CARD_FINANCIAL_ACCOUNT_COMPLETED",
  /** The name of the Notification Event when an internal transfer from Funding Financial Account to Payment Card Financial Account has failed */
  INTERNAL_TRANSFER_FROM_FUNDING_FINANCIAL_ACCOUNT_TO_PAYMENT_CARD_FINANCIAL_ACCOUNT_FAILED = "INTERNAL_TRANSFER_FROM_FUNDING_FINANCIAL_ACCOUNT_TO_PAYMENT_CARD_FINANCIAL_ACCOUNT_FAILED",
  /** The name of the Notification Event when an internal transfer from Funding Financial Account to Payment Card Financial Account is pending */
  INTERNAL_TRANSFER_FROM_FUNDING_FINANCIAL_ACCOUNT_TO_PAYMENT_CARD_FINANCIAL_ACCOUNT_PENDING = "INTERNAL_TRANSFER_FROM_FUNDING_FINANCIAL_ACCOUNT_TO_PAYMENT_CARD_FINANCIAL_ACCOUNT_PENDING",
  /** The name of the Notification Event when an internal transfer from Payment Card Financial Account to Funding Financial Account has completed */
  INTERNAL_TRANSFER_FROM_PAYMENT_CARD_FINANCIAL_ACCOUNT_TO_FUNDING_FINANCIAL_ACCOUNT_COMPLETED = "INTERNAL_TRANSFER_FROM_PAYMENT_CARD_FINANCIAL_ACCOUNT_TO_FUNDING_FINANCIAL_ACCOUNT_COMPLETED",
  /** The name of the Notification Event when an internal transfer from Payment Card Financial Account to Funding Financial Account has failed */
  INTERNAL_TRANSFER_FROM_PAYMENT_CARD_FINANCIAL_ACCOUNT_TO_FUNDING_FINANCIAL_ACCOUNT_FAILED = "INTERNAL_TRANSFER_FROM_PAYMENT_CARD_FINANCIAL_ACCOUNT_TO_FUNDING_FINANCIAL_ACCOUNT_FAILED",
  /** The name of the Notification Event when an internal transfer from Payment Card Financial Account to Funding Financial Account is pending */
  INTERNAL_TRANSFER_FROM_PAYMENT_CARD_FINANCIAL_ACCOUNT_TO_FUNDING_FINANCIAL_ACCOUNT_PENDING = "INTERNAL_TRANSFER_FROM_PAYMENT_CARD_FINANCIAL_ACCOUNT_TO_FUNDING_FINANCIAL_ACCOUNT_PENDING",
  /** The name of the Notification Event when a `Verified External Financial Account` creation fails */
  LINK_VERIFIED_EXTERNAL_BANK_ACCOUNT_FAILED = "LINK_VERIFIED_EXTERNAL_BANK_ACCOUNT_FAILED",
  /** Triggered when a non-originated ACH transfer has failed before it is sent to the external financial institution. */
  NON_ORIGINATED_ACH_TRANSFER_FAILED = "NON_ORIGINATED_ACH_TRANSFER_FAILED",
  /** Triggered when a non-originated ACH transfer is processed by Highnote. */
  NON_ORIGINATED_ACH_TRANSFER_PROCESSED = "NON_ORIGINATED_ACH_TRANSFER_PROCESSED",
  /** Triggered when a non-originated ACH transfer is received from an external financial institution. */
  NON_ORIGINATED_ACH_TRANSFER_RECEIVED = "NON_ORIGINATED_ACH_TRANSFER_RECEIVED",
  /** Triggered when a non-originated ACH transfer has been returned by the external financial institution. */
  NON_ORIGINATED_ACH_TRANSFER_RETURNED = "NON_ORIGINATED_ACH_TRANSFER_RETURNED",
  /**
   * The name of the Notification Event when a notification target is being activated.
   *
   * **Note:** This field will be ignored if provided as an event name when adding a notification target.
   */
  NOTIFICATION_ACTIVATION = "NOTIFICATION_ACTIVATION",
  /** Triggered when an originated ACH transfer is canceled before it is sent to the external financial institution. */
  ORIGINATED_ACH_TRANSFER_CANCELED = "ORIGINATED_ACH_TRANSFER_CANCELED",
  /** Triggered when an originated ACH transfer has failed before it is sent to the external financial institution. */
  ORIGINATED_ACH_TRANSFER_FAILED = "ORIGINATED_ACH_TRANSFER_FAILED",
  /** Triggered when an originated ACH transfer is initiated. */
  ORIGINATED_ACH_TRANSFER_INITIATED = "ORIGINATED_ACH_TRANSFER_INITIATED",
  /** Triggered when an originated ACH transfer is processed by Highnote, pending send to the external financial institution for processing. */
  ORIGINATED_ACH_TRANSFER_PENDING = "ORIGINATED_ACH_TRANSFER_PENDING",
  /** Triggered when an originated ACH transfer is finalized and the funds are available or withdrawn. */
  ORIGINATED_ACH_TRANSFER_PROCESSED = "ORIGINATED_ACH_TRANSFER_PROCESSED",
  /** Triggered when an originated ACH transfer is sent to the external financial institution for processing. */
  ORIGINATED_ACH_TRANSFER_PROCESSING = "ORIGINATED_ACH_TRANSFER_PROCESSING",
  /** Triggered when an originated ACH transfer has been returned by the external financial institution. */
  ORIGINATED_ACH_TRANSFER_RETURNED = "ORIGINATED_ACH_TRANSFER_RETURNED",
  /** The name of the Notification Event when a payment card has been activated */
  PAYMENT_CARD_ACTIVATED = "PAYMENT_CARD_ACTIVATED",
  /** The name of the Notification Event when a payment card transaction authorization has been adjusted */
  PAYMENT_CARD_ADJUSTMENT = "PAYMENT_CARD_ADJUSTMENT",
  /** The name of the Notification Event when a payment card transaction authorization and clear happens together and has been approved */
  PAYMENT_CARD_AUTHORIZATION_AND_CLEAR_APPROVED = "PAYMENT_CARD_AUTHORIZATION_AND_CLEAR_APPROVED",
  /** The name of the Notification Event when a payment card transaction authorization and clear happens together and has been declined */
  PAYMENT_CARD_AUTHORIZATION_AND_CLEAR_DECLINED = "PAYMENT_CARD_AUTHORIZATION_AND_CLEAR_DECLINED",
  /** The name of the Notification Event when a payment card transaction authorization has been approved */
  PAYMENT_CARD_AUTHORIZATION_APPROVED = "PAYMENT_CARD_AUTHORIZATION_APPROVED",
  /**
   * `DEPRECATED`
   *
   * The name of the Notification Event when a payment card transaction authorization has been created
   * @deprecated No longer supported
   */
  PAYMENT_CARD_AUTHORIZATION_CREATED = "PAYMENT_CARD_AUTHORIZATION_CREATED",
  /** The name of the Notification Event when a payment card transaction authorization has been declined */
  PAYMENT_CARD_AUTHORIZATION_DECLINED = "PAYMENT_CARD_AUTHORIZATION_DECLINED",
  /** The name of the Notification Event when a payment card transaction authorization has been reversed */
  PAYMENT_CARD_AUTHORIZATION_REVERSED = "PAYMENT_CARD_AUTHORIZATION_REVERSED",
  /** The name of the Notification Event when a payment card transaction has been cleared */
  PAYMENT_CARD_CLEARED = "PAYMENT_CARD_CLEARED",
  /** The name of the Notification Event when a payment card has been closed */
  PAYMENT_CARD_CLOSED = "PAYMENT_CARD_CLOSED",
  /** The name of the Notification Event when enhanced data for a payment card transaction has been received */
  PAYMENT_CARD_ENHANCED_DATA_RECEIVED = "PAYMENT_CARD_ENHANCED_DATA_RECEIVED",
  /** The name of the Notification Event when a payment card has been issued. */
  PAYMENT_CARD_ISSUED = "PAYMENT_CARD_ISSUED",
  /** The name of the Notification Event when a payment card has been suspended */
  PAYMENT_CARD_SUSPENDED = "PAYMENT_CARD_SUSPENDED",
  /** Triggered when a Provisional Credit has been issued for a  `PaymentCardTransactionChargeback`. */
  PAYMENT_CARD_TRANSACTION_CHARGEBACK_PROVISIONAL_CREDIT_ISSUED = "PAYMENT_CARD_TRANSACTION_CHARGEBACK_PROVISIONAL_CREDIT_ISSUED",
  /** Triggered when a Provisional Credit has been revoked for a `PaymentCardTransactionChargeback`. */
  PAYMENT_CARD_TRANSACTION_CHARGEBACK_PROVISIONAL_CREDIT_REVOKED = "PAYMENT_CARD_TRANSACTION_CHARGEBACK_PROVISIONAL_CREDIT_REVOKED",
  /** Triggered when a `PaymentCardTransactionDispute` has been canceled. */
  PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_CANCELLED = "PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_CANCELLED",
  /** Triggered when a `PaymentCardTransactionDispute` has been resolved as a cardholder loss. */
  PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_CASE_CARDHOLDER_LOST = "PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_CASE_CARDHOLDER_LOST",
  /** Triggered when a `PaymentCardTransactionDispute` has been resolved as a cardholder win. */
  PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_CASE_CARDHOLDER_WON = "PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_CASE_CARDHOLDER_WON",
  /** Triggered when a `PaymentCardTransactionDispute` has been initiated. */
  PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_INITIATED = "PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_INITIATED",
  /** Triggered when a `PaymentCardTransactionDispute` has been rejected by the issuer or network. */
  PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_REJECTED = "PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_REJECTED",
  /** Triggered when a `PaymentCardTransactionDispute` has been resolved by issuing a dispute credit. */
  PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_RESOLVED_WITH_DISPUTE_CREDIT = "PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_RESOLVED_WITH_DISPUTE_CREDIT",
  /** Triggered when a Dispute Credit has been issued for a `PaymentCardTransactionDispute`. */
  PAYMENT_CARD_TRANSACTION_DISPUTE_CREDIT_ISSUED = "PAYMENT_CARD_TRANSACTION_DISPUTE_CREDIT_ISSUED",
  /** Triggered when a Dispute Credit has been reversed for a `PaymentCardTransactionDispute`. */
  PAYMENT_CARD_TRANSACTION_DISPUTE_CREDIT_REVERSED = "PAYMENT_CARD_TRANSACTION_DISPUTE_CREDIT_REVERSED",
  /** Triggered when a Provisional Credit has been issued for a `PaymentCardTransactionDispute`. */
  PAYMENT_CARD_TRANSACTION_DISPUTE_PROVISIONAL_CREDIT_ISSUED = "PAYMENT_CARD_TRANSACTION_DISPUTE_PROVISIONAL_CREDIT_ISSUED",
  /** Triggered when a Provisional Credit has been revoked for a `PaymentCardTransactionDispute`. */
  PAYMENT_CARD_TRANSACTION_DISPUTE_PROVISIONAL_CREDIT_REVOKED = "PAYMENT_CARD_TRANSACTION_DISPUTE_PROVISIONAL_CREDIT_REVOKED",
  /** Triggered when a Provisional Credit has been won for a `PaymentCardTransactionDispute`. */
  PAYMENT_CARD_TRANSACTION_DISPUTE_PROVISIONAL_CREDIT_WON = "PAYMENT_CARD_TRANSACTION_DISPUTE_PROVISIONAL_CREDIT_WON",
  /** The name of the Notification Event when a payment card has been unsuspended */
  PAYMENT_CARD_UNSUSPENDED = "PAYMENT_CARD_UNSUSPENDED",
  /** The name of the Notification Event when a payment card verification has been approved */
  PAYMENT_CARD_VERIFICATION_APPROVED = "PAYMENT_CARD_VERIFICATION_APPROVED",
  /** The name of the Notification Event when a payment card verification has been declined */
  PAYMENT_CARD_VERIFICATION_DECLINED = "PAYMENT_CARD_VERIFICATION_DECLINED",
  /** Triggered when a `PaymentTransaction` receives a payout transfer completed event. */
  PAYOUT_TRANSFER_COMPLETED_EVENT = "PAYOUT_TRANSFER_COMPLETED_EVENT",
  /** The name of the Notification Event when a payroll advance repayment has completed */
  PAYROLL_ADVANCE_REPAYMENT_COMPLETED = "PAYROLL_ADVANCE_REPAYMENT_COMPLETED",
  /** The name of the Notification Event when a payroll advance repayment has been written off */
  PAYROLL_ADVANCE_WRITE_OFF_COMPLETED = "PAYROLL_ADVANCE_WRITE_OFF_COMPLETED",
  /** Triggered when identity verification documents are requested for a `PersonAccountHolder`. */
  PERSON_ACCOUNT_HOLDER_IDENTITY_DOCUMENTS_REQUESTED = "PERSON_ACCOUNT_HOLDER_IDENTITY_DOCUMENTS_REQUESTED",
  /** Triggered when a `PersonAccountHolder` is updated. */
  PERSON_ACCOUNT_HOLDER_IDENTITY_UPDATED = "PERSON_ACCOUNT_HOLDER_IDENTITY_UPDATED",
  /** The name of the Notification Event when a physical payment card group order has shipped */
  PHYSICAL_PAYMENT_CARD_GROUP_ORDER_SHIPPED = "PHYSICAL_PAYMENT_CARD_GROUP_ORDER_SHIPPED",
  /** The name of the Notification Event when a physical payment card group order has failed to ship */
  PHYSICAL_PAYMENT_CARD_GROUP_ORDER_SHIP_FAILED = "PHYSICAL_PAYMENT_CARD_GROUP_ORDER_SHIP_FAILED",
  /** The name of the Notification Event when a physical payment card has shipped */
  PHYSICAL_PAYMENT_CARD_SHIPPED = "PHYSICAL_PAYMENT_CARD_SHIPPED",
  /** The name of the Notification Event when a physical payment card has failed to ship */
  PHYSICAL_PAYMENT_CARD_SHIP_FAILED = "PHYSICAL_PAYMENT_CARD_SHIP_FAILED",
  /** The provision account holder workflow has completed. */
  PROVISION_ACCOUNT_HOLDER_COMPLETED = "PROVISION_ACCOUNT_HOLDER_COMPLETED",
  /** The provision account holder CREATE_APPLICATION action has completed. */
  PROVISION_ACCOUNT_HOLDER_CREATE_APPLICATION_COMPLETED = "PROVISION_ACCOUNT_HOLDER_CREATE_APPLICATION_COMPLETED",
  /** The provision account holder CREATE_APPLICATION action has encountered an error. */
  PROVISION_ACCOUNT_HOLDER_CREATE_APPLICATION_ERROR = "PROVISION_ACCOUNT_HOLDER_CREATE_APPLICATION_ERROR",
  /** The provision account holder CREATE_APPLICATION action has been initiated. */
  PROVISION_ACCOUNT_HOLDER_CREATE_APPLICATION_INITIATED = "PROVISION_ACCOUNT_HOLDER_CREATE_APPLICATION_INITIATED",
  /** The provision account holder CREATE_APPLICATION action has started processing. */
  PROVISION_ACCOUNT_HOLDER_CREATE_APPLICATION_IN_PROGRESS = "PROVISION_ACCOUNT_HOLDER_CREATE_APPLICATION_IN_PROGRESS",
  /** The provision account holder CREATE_APPLICATION action will not be completed due to the workflow exiting early. */
  PROVISION_ACCOUNT_HOLDER_CREATE_APPLICATION_NOT_COMPLETED = "PROVISION_ACCOUNT_HOLDER_CREATE_APPLICATION_NOT_COMPLETED",
  /** The provision account holder workflow has encountered an error. */
  PROVISION_ACCOUNT_HOLDER_ERROR = "PROVISION_ACCOUNT_HOLDER_ERROR",
  /** The provision account holder workflow has been initiated. */
  PROVISION_ACCOUNT_HOLDER_INITIATED = "PROVISION_ACCOUNT_HOLDER_INITIATED",
  /** The provision account holder workflow has started processing. */
  PROVISION_ACCOUNT_HOLDER_IN_PROGRESS = "PROVISION_ACCOUNT_HOLDER_IN_PROGRESS",
  /** The provision account holder ISSUE_FINANCIAL_ACCOUNT action has completed. */
  PROVISION_ACCOUNT_HOLDER_ISSUE_FINANCIAL_ACCOUNT_COMPLETED = "PROVISION_ACCOUNT_HOLDER_ISSUE_FINANCIAL_ACCOUNT_COMPLETED",
  /** The provision account holder ISSUE_FINANCIAL_ACCOUNT action has encountered an error. */
  PROVISION_ACCOUNT_HOLDER_ISSUE_FINANCIAL_ACCOUNT_ERROR = "PROVISION_ACCOUNT_HOLDER_ISSUE_FINANCIAL_ACCOUNT_ERROR",
  /** The provision account holder ISSUE_FINANCIAL_ACCOUNT action has been initiated. */
  PROVISION_ACCOUNT_HOLDER_ISSUE_FINANCIAL_ACCOUNT_INITIATED = "PROVISION_ACCOUNT_HOLDER_ISSUE_FINANCIAL_ACCOUNT_INITIATED",
  /** The provision account holder ISSUE_FINANCIAL_ACCOUNT action has started processing. */
  PROVISION_ACCOUNT_HOLDER_ISSUE_FINANCIAL_ACCOUNT_IN_PROGRESS = "PROVISION_ACCOUNT_HOLDER_ISSUE_FINANCIAL_ACCOUNT_IN_PROGRESS",
  /** The provision account holder ISSUE_FINANCIAL_ACCOUNT action will not be completed due to the workflow exiting early. */
  PROVISION_ACCOUNT_HOLDER_ISSUE_FINANCIAL_ACCOUNT_NOT_COMPLETED = "PROVISION_ACCOUNT_HOLDER_ISSUE_FINANCIAL_ACCOUNT_NOT_COMPLETED",
  /** The provision account holder ISSUE_PAYMENT_CARD action has completed. */
  PROVISION_ACCOUNT_HOLDER_ISSUE_PAYMENT_CARD_COMPLETED = "PROVISION_ACCOUNT_HOLDER_ISSUE_PAYMENT_CARD_COMPLETED",
  /** The provision account holder ISSUE_PAYMENT_CARD action has encountered an error. */
  PROVISION_ACCOUNT_HOLDER_ISSUE_PAYMENT_CARD_ERROR = "PROVISION_ACCOUNT_HOLDER_ISSUE_PAYMENT_CARD_ERROR",
  /** The provision account holder ISSUE_PAYMENT_CARD action has been initiated. */
  PROVISION_ACCOUNT_HOLDER_ISSUE_PAYMENT_CARD_INITIATED = "PROVISION_ACCOUNT_HOLDER_ISSUE_PAYMENT_CARD_INITIATED",
  /** The provision account holder ISSUE_PAYMENT_CARD action has started processing. */
  PROVISION_ACCOUNT_HOLDER_ISSUE_PAYMENT_CARD_IN_PROGRESS = "PROVISION_ACCOUNT_HOLDER_ISSUE_PAYMENT_CARD_IN_PROGRESS",
  /** The provision account holder ISSUE_PAYMENT_CARD action will not be completed due to the workflow exiting early. */
  PROVISION_ACCOUNT_HOLDER_ISSUE_PAYMENT_CARD_NOT_COMPLETED = "PROVISION_ACCOUNT_HOLDER_ISSUE_PAYMENT_CARD_NOT_COMPLETED",
  /** The provision account holder LINK_EXTERNAL_BANK_ACCOUNT action has completed. */
  PROVISION_ACCOUNT_HOLDER_LINK_EXTERNAL_BANK_ACCOUNT_COMPLETED = "PROVISION_ACCOUNT_HOLDER_LINK_EXTERNAL_BANK_ACCOUNT_COMPLETED",
  /** The provision account holder LINK_EXTERNAL_BANK_ACCOUNT action has encountered an error. */
  PROVISION_ACCOUNT_HOLDER_LINK_EXTERNAL_BANK_ACCOUNT_ERROR = "PROVISION_ACCOUNT_HOLDER_LINK_EXTERNAL_BANK_ACCOUNT_ERROR",
  /** The provision account holder LINK_EXTERNAL_BANK_ACCOUNT action has been initiated. */
  PROVISION_ACCOUNT_HOLDER_LINK_EXTERNAL_BANK_ACCOUNT_INITIATED = "PROVISION_ACCOUNT_HOLDER_LINK_EXTERNAL_BANK_ACCOUNT_INITIATED",
  /** The provision account holder LINK_EXTERNAL_BANK_ACCOUNT action has started processing. */
  PROVISION_ACCOUNT_HOLDER_LINK_EXTERNAL_BANK_ACCOUNT_IN_PROGRESS = "PROVISION_ACCOUNT_HOLDER_LINK_EXTERNAL_BANK_ACCOUNT_IN_PROGRESS",
  /** The provision account holder LINK_EXTERNAL_BANK_ACCOUNT action will not be completed due to the workflow exiting early. */
  PROVISION_ACCOUNT_HOLDER_LINK_EXTERNAL_BANK_ACCOUNT_NOT_COMPLETED = "PROVISION_ACCOUNT_HOLDER_LINK_EXTERNAL_BANK_ACCOUNT_NOT_COMPLETED",
  /** The provision account holder NOTIFY_PROVIDER action has completed. */
  PROVISION_ACCOUNT_HOLDER_NOTIFY_PROVIDER_COMPLETED = "PROVISION_ACCOUNT_HOLDER_NOTIFY_PROVIDER_COMPLETED",
  /** The provision account holder NOTIFY_PROVIDER action has encountered an error. */
  PROVISION_ACCOUNT_HOLDER_NOTIFY_PROVIDER_ERROR = "PROVISION_ACCOUNT_HOLDER_NOTIFY_PROVIDER_ERROR",
  /** The provision account holder NOTIFY_PROVIDER action has been initiated. */
  PROVISION_ACCOUNT_HOLDER_NOTIFY_PROVIDER_INITIATED = "PROVISION_ACCOUNT_HOLDER_NOTIFY_PROVIDER_INITIATED",
  /** The provision account holder NOTIFY_PROVIDER action has started processing. */
  PROVISION_ACCOUNT_HOLDER_NOTIFY_PROVIDER_IN_PROGRESS = "PROVISION_ACCOUNT_HOLDER_NOTIFY_PROVIDER_IN_PROGRESS",
  /** The provision account holder NOTIFY_PROVIDER action will not be completed due to the workflow exiting early. */
  PROVISION_ACCOUNT_HOLDER_NOTIFY_PROVIDER_NOT_COMPLETED = "PROVISION_ACCOUNT_HOLDER_NOTIFY_PROVIDER_NOT_COMPLETED",
  /** The provision account holder REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT action has completed. */
  PROVISION_ACCOUNT_HOLDER_REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT_COMPLETED = "PROVISION_ACCOUNT_HOLDER_REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT_COMPLETED",
  /** The provision account holder REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT action has encountered an error. */
  PROVISION_ACCOUNT_HOLDER_REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT_ERROR = "PROVISION_ACCOUNT_HOLDER_REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT_ERROR",
  /** The provision account holder REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT action has been initiated. */
  PROVISION_ACCOUNT_HOLDER_REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT_INITIATED = "PROVISION_ACCOUNT_HOLDER_REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT_INITIATED",
  /** The provision account holder REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT action has started processing. */
  PROVISION_ACCOUNT_HOLDER_REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT_IN_PROGRESS = "PROVISION_ACCOUNT_HOLDER_REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT_IN_PROGRESS",
  /** The provision account holder REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT action will not be completed due to the workflow exiting early. */
  PROVISION_ACCOUNT_HOLDER_REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT_NOT_COMPLETED = "PROVISION_ACCOUNT_HOLDER_REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT_NOT_COMPLETED",
  /** The provision account holder workflow has terminated due to a rejection. */
  PROVISION_ACCOUNT_HOLDER_REJECTED = "PROVISION_ACCOUNT_HOLDER_REJECTED",
  /** The provision account holder SET_CREDIT_LIMIT action has completed. */
  PROVISION_ACCOUNT_HOLDER_SET_CREDIT_LIMIT_COMPLETED = "PROVISION_ACCOUNT_HOLDER_SET_CREDIT_LIMIT_COMPLETED",
  /** The provision account holder SET_CREDIT_LIMIT action has encountered an error. */
  PROVISION_ACCOUNT_HOLDER_SET_CREDIT_LIMIT_ERROR = "PROVISION_ACCOUNT_HOLDER_SET_CREDIT_LIMIT_ERROR",
  /** The provision account holder SET_CREDIT_LIMIT action has been initiated. */
  PROVISION_ACCOUNT_HOLDER_SET_CREDIT_LIMIT_INITIATED = "PROVISION_ACCOUNT_HOLDER_SET_CREDIT_LIMIT_INITIATED",
  /** The provision account holder SET_CREDIT_LIMIT action has started processing. */
  PROVISION_ACCOUNT_HOLDER_SET_CREDIT_LIMIT_IN_PROGRESS = "PROVISION_ACCOUNT_HOLDER_SET_CREDIT_LIMIT_IN_PROGRESS",
  /** The provision account holder SET_CREDIT_LIMIT action will not be completed due to the workflow exiting early. */
  PROVISION_ACCOUNT_HOLDER_SET_CREDIT_LIMIT_NOT_COMPLETED = "PROVISION_ACCOUNT_HOLDER_SET_CREDIT_LIMIT_NOT_COMPLETED",
  /** The name of the Notification Event when a report has completed. */
  REPORT_COMPLETED = "REPORT_COMPLETED",
  /** The name of the Notification Event when a report has failed. */
  REPORT_FAILED = "REPORT_FAILED",
  /** Triggered when the `UnifiedFundsTransfer` has completed. */
  UNIFIED_FUNDS_TRANSFER_COMPLETED_EVENT = "UNIFIED_FUNDS_TRANSFER_COMPLETED_EVENT",
  /** Triggered when the `UnifiedFundsTransfer` has failed. */
  UNIFIED_FUNDS_TRANSFER_FAILED_EVENT = "UNIFIED_FUNDS_TRANSFER_FAILED_EVENT",
  /** Triggered when the `UnifiedFundsTransfer` has been initiated. */
  UNIFIED_FUNDS_TRANSFER_INITIATED_EVENT = "UNIFIED_FUNDS_TRANSFER_INITIATED_EVENT",
  /** Triggered when a `FinancialAccountStatement` has an upcoming payment due date. The number of days in advance of the due date to trigger this notification is configurable at the `CardProduct` level. */
  UPCOMING_STATEMENT_DUE_DATE = "UPCOMING_STATEMENT_DUE_DATE",
}

/** The types providing more details about the Notification Event. */
export type NotificationEventNode =
  | AccountHolderCardProductApplication
  | AccountHolderProvisioning
  | AccountHolderProvisioningWorkflowAction
  | AccountStatusActiveEvent
  | AccountStatusClosedEvent
  | AccountStatusPendingClosureEvent
  | AccountStatusSuspendedEvent
  | AccountStatusUnderReviewEvent
  | AchExternallyInitatedDepositFailedEvent
  | AchExternallyInitatedDepositProcessedEvent
  | AchExternallyInitatedDepositReceivedEvent
  | AchExternallyInitiatedWithdrawalFailedEvent
  | AchExternallyInitiatedWithdrawalProcessedEvent
  | AchExternallyInitiatedWithdrawalReceivedEvent
  | AchHoldAddedEvent
  | AchHoldRemovedEvent
  | AchTransferHoldAddedEvent
  | AchTransferHoldRemovedEvent
  | AuthorizationEvent
  | AuthorizedUserCardProductApplication
  | BusinessAccountHolderIdentityDocumentsRequestedEvent
  | BusinessAccountHolderIdentityUpdatedEvent
  | BusinessAuthorizedPersonIdentityDocumentsRequestedEvent
  | BusinessAuthorizedPersonIdentityUpdatedEvent
  | BusinessUltimateBeneficialOwnerIdentityDocumentsRequestedEvent
  | BusinessUltimateBeneficialOwnerIdentityUpdatedEvent
  | CardDigitalWalletTokenActivatedEvent
  | CardDigitalWalletTokenSuspendedEvent
  | CardDigitalWalletTokenTerminatedEvent
  | CardPaymentAuthorizationDeclinedEvent
  | CardPaymentAuthorizedEvent
  | CardPaymentAuthorizingEvent
  | CardPaymentCaptureDeclinedEvent
  | CardPaymentCaptureProcessingEvent
  | CardPaymentCapturingEvent
  | CardPaymentClearedEvent
  | CardPaymentClearingFailedEvent
  | CardPaymentDisbursedEvent
  | CardPaymentDispute
  | CardPaymentIncrementalAuthorizationDeclinedEvent
  | CardPaymentIncrementalAuthorizedEvent
  | CardPaymentPartialReversedEvent
  | CardPaymentPayoutEvent
  | CardPaymentReversalDeclinedEvent
  | CardPaymentReversedEvent
  | CardPaymentVerificationDeclinedEvent
  | CardPaymentVerificationPendingEvent
  | CardPaymentVerifiedEvent
  | CheckPaymentEvent
  | CreditLimitChangeRequestStatusChangedEvent
  | DocumentUploadSessionCompleteEvent
  | ExternalBankAccountAddedEvent
  | ExternalBankAccountRemovedEvent
  | FeeChargeEvent
  | FeeReversalEvent
  | FileUploadCompleteEvent
  | FinancialAccount
  | FinancialAccountStatementReadyEvent
  | FundsDepositCanceledEvent
  | FundsDepositFailedEvent
  | FundsDepositInitiatedEvent
  | FundsDepositProcessedEvent
  | FundsDepositProcessingEvent
  | FundsDepositReturnedEvent
  | FundsWithdrawalCanceledEvent
  | FundsWithdrawalFailedEvent
  | FundsWithdrawalInitiatedEvent
  | FundsWithdrawalProcessedEvent
  | FundsWithdrawalProcessingEvent
  | FundsWithdrawalReturnedEvent
  | InstantNetworkTransfer
  | InterFinancialAccountTransfer
  | InternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountCompletedEvent
  | InternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountFailedEvent
  | InternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountPendingEvent
  | InternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountCompletedEvent
  | InternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountFailedEvent
  | InternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountPendingEvent
  | LinkVerifiedExternalBankAccountFailedEvent
  | ManualDocumentRequestUploadSession
  | NonOriginatedAchTransferFailedEvent
  | NonOriginatedAchTransferProcessedEvent
  | NonOriginatedAchTransferReceivedEvent
  | NonOriginatedAchTransferReturnedEvent
  | NotificationEventValidationTestEvent
  | NotificationPingTestEvent
  | NotificationTargetActivationEvent
  | OriginatedAchTransferCanceledEvent
  | OriginatedAchTransferFailedEvent
  | OriginatedAchTransferInitiatedEvent
  | OriginatedAchTransferPendingEvent
  | OriginatedAchTransferProcessedEvent
  | OriginatedAchTransferProcessingEvent
  | OriginatedAchTransferReturnedEvent
  | PaymentCardActivatedEvent
  | PaymentCardAdjustmentEvent
  | PaymentCardAuthorizationAndClearApprovedEvent
  | PaymentCardAuthorizationAndClearDeclinedEvent
  | PaymentCardAuthorizationApprovedEvent
  | PaymentCardAuthorizationCreatedEvent
  | PaymentCardAuthorizationDeclinedEvent
  | PaymentCardAuthorizationReversedEvent
  | PaymentCardClearedEvent
  | PaymentCardClosedEvent
  | PaymentCardEnhancedDataEvent
  | PaymentCardIssuedEvent
  | PaymentCardSuspendedEvent
  | PaymentCardTransactionChargeback
  | PaymentCardTransactionDispute
  | PaymentCardUnsuspendedEvent
  | PaymentCardVerificationApprovedEvent
  | PaymentCardVerificationDeclinedEvent
  | PayoutTransferCompletedEvent
  | PayrollAdvanceRepaymentCompletedEvent
  | PayrollAdvanceWriteOffCompletedEvent
  | PersonAccountHolderIdentityDocumentsRequestedEvent
  | PersonAccountHolderIdentityUpdatedEvent
  | PhysicalPaymentCardGroupOrderShipFailedEvent
  | PhysicalPaymentCardGroupOrderShippedEvent
  | PhysicalPaymentCardShipFailedEvent
  | PhysicalPaymentCardShippedEvent
  | RepaymentFailedEvent
  | RepaymentProcessedEvent
  | RepaymentProcessingEvent
  | RepaymentReturnedEvent
  | Report
  | SecureDepositCanceledEvent
  | SecureDepositFailedEvent
  | SecureDepositInitiatedEvent
  | SecureDepositProcessedEvent
  | SecureDepositProcessingEvent
  | SecureDepositReturnedEvent
  | UnifiedFundsTransfer
  | UpcomingStatementDueDateEvent;

/** The event sent when initiateEventValidationTest mutation is called. */
export type NotificationEventValidationTestEvent = {
  __typename?: "NotificationEventValidationTestEvent";
  /** emptyListOfAccountAttributes */
  emptyListOfAccountAttributes?: Maybe<Array<Maybe<FinancialAccountAttribute>>>;
  /** emptyListOfStrings */
  emptyListOfStrings?: Maybe<Array<Scalars["String"]>>;
  /** fixture version */
  fixtureVersion?: Maybe<Scalars["String"]>;
  /** listOfAccountAttributesWithNull */
  listOfAccountAttributesWithNull?: Maybe<
    Array<Maybe<FinancialAccountAttribute>>
  >;
  /** nullMerchantDetails */
  merchantDetails?: Maybe<MerchantDetails>;
  /** nonEmptyListOfAccountAttributes */
  nonEmptyListOfAccountAttributes?: Maybe<
    Array<Maybe<FinancialAccountAttribute>>
  >;
  /** nonEmptyListOfStrings */
  nonEmptyListOfStrings?: Maybe<Array<Scalars["String"]>>;
  /** nonZeroAmount */
  nonZeroAmount?: Maybe<Amount>;
  /** nullMerchantDetails */
  nullMerchantDetails?: Maybe<MerchantDetails>;
  /** nullableListOfStrings */
  nullableListOfStringsWithNull?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** zeroAmount */
  zeroAmount?: Maybe<Amount>;
};

/** The connection type for Notification Events. */
export type NotificationEventsConnection = {
  __typename?: "NotificationEventsConnection";
  /** A list of edges. */
  edges?: Maybe<Array<NotificationEventEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The input to provide filters for the notificationEvents query. */
export type NotificationEventsFilterInput = {
  /** Filter by the createdAt timestamp of the notification event. */
  createdAt?: InputMaybe<NotificationTimestampFilterInput>;
  /** Filter by the name of the notification event. */
  name?: InputMaybe<Array<NotificationEventName>>;
};

/** The event sent when initiateNotificationPingTest mutation is called. */
export type NotificationPingTestEvent = {
  __typename?: "NotificationPingTestEvent";
  /** A simple field to return a static value of "pong" */
  ping: Scalars["String"];
};

/** The types of notification targets. */
export type NotificationTarget = WebhookNotificationTarget;

/** The event sent to a notification target during activation. */
export type NotificationTargetActivationEvent = {
  __typename?: "NotificationTargetActivationEvent";
  /** A field that returns a static value of `pong` */
  ping?: Maybe<Scalars["String"]>;
};

/** The status of a notification target. */
export enum NotificationTargetStatus {
  /** The target was unable to be verified. */
  ACTIVATION_FAILED = "ACTIVATION_FAILED",
  /** The target has been verified and events are being delivered. */
  ACTIVE = "ACTIVE",
  /** The target has been manually deactivated or Highnote has detected an error delivering events. */
  DEACTIVATED = "DEACTIVATED",
  /** The target has not yet been verified. Events will not be delivered. */
  PENDING_VERIFICATION = "PENDING_VERIFICATION",
}

/** Notification Target status history */
export type NotificationTargetStatusHistory = {
  __typename?: "NotificationTargetStatusHistory";
  /** The date and time, in ISO 8601 format the status changed. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the status event in operations. */
  id: Scalars["ID"];
  /** New order status. */
  newStatus?: Maybe<NotificationTargetStatus>;
  /** Previous status status. */
  previousStatus?: Maybe<NotificationTargetStatus>;
  /** The notification target for this status entry. */
  target?: Maybe<NotificationTarget>;
};

/** The connection type for a notification target's status history. */
export type NotificationTargetStatusHistoryConnection = {
  __typename?: "NotificationTargetStatusHistoryConnection";
  /** A list of edges. */
  edges?: Maybe<Array<NotificationTargetStatusHistoryEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a notification target's status history'. */
export type NotificationTargetStatusHistoryEdge = {
  __typename?: "NotificationTargetStatusHistoryEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The DeliveryAttempt */
  node?: Maybe<NotificationTargetStatusHistory>;
};

/**
 * Input for filtering dates.
 *
 * The format for each `String` field should be in YYYY-MM-DD format.
 *
 * Example: `2021-11-12`
 */
export type NotificationTimestampFilterInput = {
  /** Value to filter to dates that fall between values. */
  between?: InputMaybe<NotificationTimestampFilterInputRange>;
  /** An ISO 8601 value that exactly matches the provided `String`. */
  equals?: InputMaybe<Scalars["String"]>;
  /** An ISO 8601 value to filter to dates after the given `String`. */
  greaterThan?: InputMaybe<Scalars["String"]>;
  /** An ISO 8601 value to filter to dates that match or are after the given `String`. */
  greaterThanOrEquals?: InputMaybe<Scalars["String"]>;
  /** An ISO 8601 value to filter to dates before the given `String`. */
  lessThan?: InputMaybe<Scalars["String"]>;
  /** An ISO 8601 value to filter to dates that match or are before the given `String`. */
  lessThanOrEquals?: InputMaybe<Scalars["String"]>;
  /** An ISO 8601 value that does not match the provided `String`. */
  notEquals?: InputMaybe<Scalars["String"]>;
};

/**
 * Input for filtering by date value ranges (inclusive).
 *
 * The format for each `String` field should be in YYYY-MM-DD format.
 *
 * Example: `2021-11-12`
 */
export type NotificationTimestampFilterInputRange = {
  /** An ISO 8601 value (inclusive) for the ending date. */
  end?: InputMaybe<Scalars["String"]>;
  /** An ISO 8601 value (inclusive) for the beginning date. */
  start?: InputMaybe<Scalars["String"]>;
};

/** Region of the world */
export enum OnBoardingBusinessGlobalRegion {
  /** Asia Pacific */
  APAC = "APAC",
  /** Canada */
  CANADA = "CANADA",
  /** Europe */
  EUROPE = "EUROPE",
  /** Latin America */
  LATIN_AMERICA = "LATIN_AMERICA",
  /** Other Region */
  OTHER = "OTHER",
  /** United States */
  UNITED_STATES = "UNITED_STATES",
}

/** Whether or not the `CardProduct` supports on demand funding. */
export type OnDemandFundingCardProductFeature = CardProductFeature &
  ProductFeature & {
    __typename?: "OnDemandFundingCardProductFeature";
    /** The date and time, in ISO 8601 format, the feature was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective from. */
    effectiveFrom?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective through. */
    effectiveThrough?: Maybe<Scalars["String"]>;
    /** Whether or not the feature is enabled for the `CardProduct`. */
    enabled?: Maybe<Scalars["Boolean"]>;
    /** Whether or not pseudo balance is enabled for the `CardProduct`. */
    pseudoBalanceEnabled?: Maybe<Scalars["Boolean"]>;
    /** The date and time, in ISO 8601 format, the feature was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Whether or not the Financial Account supports On-Demand Funding. */
export type OnDemandFundingFinancialAccountFeature = FinancialAccountFeature & {
  __typename?: "OnDemandFundingFinancialAccountFeature";
  /** The date and time, in ISO 8601 format, the feature was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective from. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective through. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Whether or not the feature is enabled for the Financial Account. */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** Whether or not pseudo balance should be enabled for this financial account. */
  pseudoBalanceEnabled?: Maybe<Scalars["Boolean"]>;
  /** The source financial account that will act as the on-demand funding source for this financial account. */
  sourceFinancialAccount?: Maybe<FinancialAccount>;
  /**
   * The source financial account that will act as the on-demand funding source for this financial account.
   * @deprecated Use sourceFinancialAccount.id instead.
   */
  sourceFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the feature was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The person to contract for questions about this application */
export type OnboardingApplicantContact = OnboardingApplicationStep & {
  __typename?: "OnboardingApplicantContact";
  /** The email address for the person to contact */
  emailAddress?: Maybe<Scalars["String"]>;
  /** Name of person to contact */
  name: Name;
  /** The phone number for the person to contact */
  phoneNumber: Phone;
  /** The status of applicant contact information being collected */
  stepStatus?: Maybe<OnboardingApplicationStepStatus>;
  /** The business title of the person to contact */
  title?: Maybe<Scalars["String"]>;
};

export type OnboardingApplicationStep = {
  /** The status of the individual step of the application */
  stepStatus?: Maybe<OnboardingApplicationStepStatus>;
};

/** Status of an individual step of the business onboarding application */
export enum OnboardingApplicationStepStatus {
  /** No data has yet been received */
  NOT_STARTED = "NOT_STARTED",
  /** Data has been entered and saved */
  SUBMITTED = "SUBMITTED",
}

/** The range of monthly average volume for a business */
export enum OnboardingAverageMonthlyPaymentVolumeRange {
  /** Between $1,000,000 and $5,000,000 USD average monthly volume */
  BETWEEN_1_000_000_AND_5_000_000 = "BETWEEN_1_000_000_AND_5_000_000",
  /** Between $5,000,000 and $25,000,000 USD average monthly volume */
  BETWEEN_5_000_000_AND_25_000_000 = "BETWEEN_5_000_000_AND_25_000_000",
  /** Between $500,000 and $1,000,000 USD average monthly volume */
  BETWEEN_500_000_AND_1_000_000 = "BETWEEN_500_000_AND_1_000_000",
  /** Over $25,000,000 USD average monthly volume */
  OVER_25_000_000 = "OVER_25_000_000",
  /** Under $500,000 USD average monthly volume */
  UNDER_500_000 = "UNDER_500_000",
}

/** The range of monthly average volume for a business */
export enum OnboardingAverageMonthlyVolumeRange {
  /** Between $1,000,000 and $5,000,000 USD average monthly volume */
  BETWEEN_1_000_000_AND_5_000_000 = "BETWEEN_1_000_000_AND_5_000_000",
  /** Between $5,000,000 and $10,000,000 USD average monthly volume */
  BETWEEN_5_000_000_AND_10_000_000 = "BETWEEN_5_000_000_AND_10_000_000",
  /** Between $10,000,000 and $50,000,000 USD average monthly volume */
  BETWEEN_10_000_000_AND_50_000_000 = "BETWEEN_10_000_000_AND_50_000_000",
  /** Between $500,000 and $1,000,000 USD average monthly volume */
  BETWEEN_500_000_AND_1_000_000 = "BETWEEN_500_000_AND_1_000_000",
  /** Over $50,000,000 USD average monthly volume */
  OVER_50_000_000 = "OVER_50_000_000",
  /** Under $500,000 USD average monthly volume */
  UNDER_500_000 = "UNDER_500_000",
}

/** The details of the person authorized to act on behalf of business. */
export type OnboardingBusinessAuthorizedPerson = {
  __typename?: "OnboardingBusinessAuthorizedPerson";
  /** Authorized person's business title. */
  businessTitle?: Maybe<OnboardingBusinessTitle>;
  /** The date of birth of the authorized person represented in YYYY-MM-DD format. */
  dateOfBirth?: Maybe<Scalars["String"]>;
  /** The email address of the authorized person. */
  email?: Maybe<Scalars["String"]>;
  /** The default physical address of the authorized person. */
  homeAddress?: Maybe<Address>;
  /** The ID of the authorized person. */
  id?: Maybe<Scalars["ID"]>;
  /** Identification Document associated with the authorized person. */
  identificationDocument?: Maybe<OnboardingIdentificationDocument>;
  /** Indicates who is the primary applicant of the application */
  isPrimaryApplicant?: Maybe<Scalars["Boolean"]>;
  /** Is this person a US citizen or resident? */
  isUsPerson?: Maybe<Scalars["Boolean"]>;
  /** The authorized person's name. */
  name?: Maybe<Name>;
  /** Percentage ownership of authorized person. */
  percentageOwnership?: Maybe<Scalars["UnsignedInt"]>;
  /** List of phone numbers associated to the authorized person. */
  phoneNumbers?: Maybe<Array<Phone>>;
  /** Identification Document associated with the authorized person. */
  yearsAtCurrentAddress?: Maybe<Scalars["UnsignedInt"]>;
};

/** Business information collected for an application */
export type OnboardingBusinessDetails = OnboardingApplicationStep & {
  __typename?: "OnboardingBusinessDetails";
  /** Does the business accept tips? */
  acceptsTips: Scalars["Boolean"];
  /** Business address on tax returns */
  businessAddressOnTaxReturns: Address;
  /** The name of the business as it appears on tax returns */
  businessNameOnTaxReturns: Scalars["String"];
  /**
   * Customer support website URL.
   *
   * The validation for the `website` URL uses the following regex pattern `^((((https?|ftps?|gopher|telnet|nntp)://)|(mailto:|news:))(%[0-9A-Fa-f]{2}|[-()_.!~*';/?:@&=+$,A-Za-z0-9])+)([).!';/?:,][[:blank:|:blank:]])?$`
   */
  customerSupportWebsite: Scalars["String"];
  /** The address that customer's are familiar with' */
  dbaAddress?: Maybe<Address>;
  /** Doing Business As name */
  doingBusinessAsName: Scalars["String"];
  /** Email address for tax returns */
  emailAddressForTaxReturns: Scalars["String"];
  /** Is the DBA address the same as the legal address */
  isDbaAddressTheSameAsLegal?: Maybe<Scalars["Boolean"]>;
  /** Is the mailing address the same as the legal address */
  isMailingAddressTheSameAsLegal?: Maybe<Scalars["Boolean"]>;
  /** Is the address for tax purposes the same as the legal address */
  isTaxAddressTheSameAsLegal?: Maybe<Scalars["Boolean"]>;
  /** The legal address of the business */
  legalBusinessAddress?: Maybe<Address>;
  /** Business name */
  legalBusinessName: Scalars["String"];
  /** The mailing address of the business (if different from legal address) */
  mailingBusinessAddress?: Maybe<Address>;
  /** The status of business details information being collected */
  stepStatus?: Maybe<OnboardingApplicationStepStatus>;
  /** The physical address for customer support */
  supportAddress: Address;
  /** Email address for customer support */
  supportEmail: Scalars["String"];
  /** The phone nunmber for customer support */
  supportPhone: Phone;
  /** Business identifier used for business tax returns */
  taxIdentifier?: Maybe<TaxIdentificationDocument>;
};

/** Business history related to incorporaton, history, and goods and services provided. */
export type OnboardingBusinessHistory = OnboardingApplicationStep & {
  __typename?: "OnboardingBusinessHistory";
  /** The advertising methods used by the business */
  advertisingMethods?: Maybe<Array<AdvertisingMethod>>;
  /** 3-4 sentences about overall company answeering "Who is your target market?", "What type of products/services do you specialize in?", "What differentitates you from your competitors?" */
  businessDescription: Scalars["String"];
  /** The type of business entity */
  businessEntity?: Maybe<BusinessEntityType>;
  /** The fax number in a country specific format. */
  businessFaxNumber?: Maybe<Phone>;
  /** The phone number in a country specific format. */
  businessPhoneNumber: Phone;
  /** The type of business */
  businessStructure?: Maybe<BusinessStructure>;
  /** The percentage of transactions broken down by acceptance methods */
  cardAcceptanceBreakdown?: Maybe<CardAcceptanceMethodBreakdown>;
  /** Whether the business has previously accepted credit cards */
  creditCardsPreviouslyAccepted: Scalars["Boolean"];
  /**
   * The date this business was formed
   *
   * Format: `YYYY-MM-DD`
   */
  dateOfFormation?: Maybe<Scalars["Date"]>;
  /** The number of people employed by the business */
  employeeCount?: Maybe<Scalars["UnsignedInt"]>;
  /** Whether the business bills its customers prior to shipping goods */
  forwardCommittment: Scalars["Boolean"];
  /** Details regarding how long the business holds onto funds before shipping goods */
  forwardCommittmentBreakdown?: Maybe<ForwardCommittmentBreakdown>;
  /** (If applicable) The names of the fulfillment partners used by the business */
  fulfillmentPartnersNames?: Maybe<Array<Scalars["String"]>>;
  /** The number of physical locations for this business */
  numberOfBusinessLocations?: Maybe<Scalars["UnsignedInt"]>;
  /** (If applicable) details about the termination by a previous payment processor, including reasoning */
  paymentProcessorTerminationReason?: Maybe<Scalars["String"]>;
  /** Whether the business sells physical goods */
  physicalGoodsSold: Scalars["Boolean"];
  /** Whether the business has filed for bankruptcy in the past */
  previousBankruptcy: Scalars["Boolean"];
  /** The name of the previous card processor used by the business (if applicable) */
  previousCardProcessorName?: Maybe<Scalars["String"]>;
  /**
   * A region for the address based on the codes for identifying the principle subdivisions, e.g. provinces and states, of countries
   * [IS0 3166 standard](https://en.wikipedia.org/wiki/ISO_3166-2), including districts and outlying areas.
   */
  regionOfFormation: Scalars["String"];
  /** The status of business history information being collected */
  stepStatus?: Maybe<OnboardingApplicationStepStatus>;
  /** (If applicable) The stock exchange where the business is listed */
  stockExchange?: Maybe<StockExchange>;
  /** (If applicable) ticker symbol from the stock exchange where this company is traded */
  stockTickerSymbol?: Maybe<Scalars["String"]>;
  /** Whether the business was terminated by a previous payment processor */
  terminatedByPreviousPaymentProcessor?: Maybe<Scalars["Boolean"]>;
  /** Whether the business is using one or more fulfillment partners */
  usingFulfillmentPartners: Scalars["Boolean"];
  /** The number of years this business has been in operation */
  yearsOfOperation?: Maybe<Scalars["UnsignedInt"]>;
  /** The number of years this business has been owned by its current owners */
  yearsOfOwnership?: Maybe<Scalars["UnsignedInt"]>;
};

/** Business information collected for a subscriber application */
export type OnboardingBusinessOrganizationInformation = Node & {
  __typename?: "OnboardingBusinessOrganizationInformation";
  /** The person to contact about questions regarding this application */
  applicantContact?: Maybe<OnboardingApplicantContact>;
  /** The details of the business */
  businessDetails?: Maybe<OnboardingBusinessDetails>;
  /** The history of the business */
  businessHistory?: Maybe<OnboardingBusinessHistory>;
  /** The type of business */
  businessType?: Maybe<OnboardingBusinessType>;
  /** The beneficial owner who has significant responsibility to control, manage, or direct the business. */
  controlProng?: Maybe<OnboardingControlProng>;
  /** The date and time, in ISO 8601 format, when this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The details recorded at time of submission for business organization information */
  eSignature?: Maybe<OnboardingESignature>;
  /** The Global ID of the business organization info. */
  id: Scalars["ID"];
  /** The operating details of the business */
  operatingDetails?: Maybe<OnboardingBusinessProcessingAttributes>;
  /** Ownership information for the business */
  ownershipInformation?: Maybe<BusinessOwnershipInformation>;
  /** Status of collection and processing of OnboardingBusinessOrganizationInformation */
  status?: Maybe<OnboardingBusinessOrganizationInformationStatus>;
  /** The date and time, in ISO 8601 format, when this object was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Overall status on the business onboarding application */
export enum OnboardingBusinessOrganizationInformationStatus {
  /** Processing the merchant information within BusinessOrganizationInformation has been started */
  PROCESSING_STARTED = "PROCESSING_STARTED",
  /** Updates to the BusinessOrganizationInformation have been completed */
  UPDATE_COMPLETE = "UPDATE_COMPLETE",
  /** Update of the BusinessOrganizationInformation is still in progress */
  UPDATE_IN_PROGRESS = "UPDATE_IN_PROGRESS",
}

/** The types of payment solutions desired by the business */
export enum OnboardingBusinessPaymentSolution {
  /** Accept payments as a marketplace or platform */
  ACCEPT_PAYMENTS_AS_MARKETPLACE = "ACCEPT_PAYMENTS_AS_MARKETPLACE",
  /** Accept payments online */
  ACCEPT_PAYMENTS_ONLINE = "ACCEPT_PAYMENTS_ONLINE",
  /** Accept payments online and swiped payments at point-of-sale */
  ACCEPT_PAYMENTS_ONLINE_AND_SWIPED = "ACCEPT_PAYMENTS_ONLINE_AND_SWIPED",
  /** Accept swiped payments at point-of-sale, kiosk, etc */
  ACCEPT_SWIPED_PAYMENTS = "ACCEPT_SWIPED_PAYMENTS",
  /** Issue virtual cards or physical cards */
  ISSUE_VIRTUAL_CARDS = "ISSUE_VIRTUAL_CARDS",
}

/** The business' reported operating details. */
export type OnboardingBusinessProcessingAttributes =
  OnboardingApplicationStep & {
    __typename?: "OnboardingBusinessProcessingAttributes";
    /** Whether an account number was previously stored for this object */
    accountNumberStored?: Maybe<Scalars["Boolean"]>;
    /** Gross annual revenues for each currency the business transacts with, per the most recent fiscal year */
    annualVolume?: Maybe<Array<Amount>>;
    /** Average single order amount for each currency the business transacts with, per the most recent fiscal year */
    averageTicket?: Maybe<Array<Amount>>;
    /** Card brands that are currently being accepted or would like to accept with their new program */
    cardAcceptance?: Maybe<Array<OnboardingPaymentCardBrand>>;
    /**
     * The fiscal year end date for the financial numbers reported numbers reported here
     *
     * Format: `YYYY-MM-DD`
     */
    fiscalYearEndDate?: Maybe<Scalars["Date"]>;
    /** Whether a business experiences seasonality in its operations. */
    isSeasonalBusiness: Scalars["Boolean"];
    /** Largest monthly volumes for each currency the business transacts with, per the most recent fiscal year */
    largestMonthlyVolume?: Maybe<Array<Amount>>;
    /** Largest single order amount for each currency the business transacts with, per the most recent fiscal year */
    largestTicket?: Maybe<Array<Amount>>;
    /** Name as it appears on bank account */
    nameOnBankAccount: Scalars["String"];
    /** Routing number of bank account 6-9 digits */
    routingNumber?: Maybe<Scalars["String"]>;
    /** Breakdown of volumme by month */
    seasonalVolumeBreakdown?: Maybe<SeasonalVolumeBreakdown>;
    /** The status of processing attributes information being collected */
    stepStatus?: Maybe<OnboardingApplicationStepStatus>;
  };

/** The title held by the business representative */
export enum OnboardingBusinessTitle {
  /** Authorized Signatory */
  AUTHORIZED_SIGNATORY = "AUTHORIZED_SIGNATORY",
  /** CEO */
  CEO = "CEO",
  /** CFO */
  CFO = "CFO",
  /** COO */
  COO = "COO",
  /** Owner */
  OWNER = "OWNER",
  /** President */
  PRESIDENT = "PRESIDENT",
  /** Treasurer */
  TREASURER = "TREASURER",
  /** Vice President */
  VICE_PRESIDENT = "VICE_PRESIDENT",
}

/** Business information collected for an application */
export type OnboardingBusinessType = OnboardingApplicationStep & {
  __typename?: "OnboardingBusinessType";
  /** The description that will appear on a consumer's bank statement and will help them identify the transaction. */
  billingDescriptor?: Maybe<Scalars["String"]>;
  /** A set of suggestions for the billing descriptor */
  billingDescriptorSuggestions?: Maybe<Array<Scalars["String"]>>;
  /**
   * Business website URL.
   *
   * The validation for the `website` URL uses the following regex pattern `^((((https?|ftps?|gopher|telnet|nntp)://)|(mailto:|news:))(%[0-9A-Fa-f]{2}|[-()_.!~*';/?:@&=+$,A-Za-z0-9])+)([).!';/?:,][[:blank:|:blank:]])?$`
   */
  businessWebsite: Scalars["String"];
  /** Description of goods and services provided */
  goodsAndServicesProvided: Scalars["String"];
  /** The high-level categorization of the business */
  industry?: Maybe<BusinessPlanOperatingGoodsAndServiceCategory>;
  /** Additional information about your specific use-case */
  productDescription: Scalars["String"];
  /** The status of type of business information being collected */
  stepStatus?: Maybe<OnboardingApplicationStepStatus>;
};

/** Under the control prong, the beneficial owner is a single individual who has significant responsibility to control, manage, or direct the business. */
export type OnboardingControlProng = OnboardingApplicationStep & {
  __typename?: "OnboardingControlProng";
  /** If not an ultimate beneficial owner, the person who is the Control Prong */
  authorizedPerson?: Maybe<OnboardingBusinessAuthorizedPerson>;
  /** Whether the Control Prong is one of the ultimate beneficial owners of the company */
  isControlProngAnUltimateBeneficialOwner: Scalars["Boolean"];
  /** The status of the controlling individual information being collected */
  stepStatus?: Maybe<OnboardingApplicationStepStatus>;
  /** (if applicable) The ID of the ultimate beneficial owner who is the Control Prong */
  ultimateBeneficialOwnerID?: Maybe<Scalars["ID"]>;
};

/** Location where customers are based */
export enum OnboardingCustomerLocation {
  /** 50% are based in the United States */
  HALF_UNITED_STATES = "HALF_UNITED_STATES",
  /** Majority are based outside of the United States */
  MAJORITY_OUTSIDE_UNITED_STATES = "MAJORITY_OUTSIDE_UNITED_STATES",
  /** Majority are based in the Unided States */
  MAJORITY_UNITED_STATES = "MAJORITY_UNITED_STATES",
  /** 100% of customers are based in the United States */
  UNITED_STATES = "UNITED_STATES",
}

/** The types of payment solutions desired by the business */
export enum OnboardingDesiredPaymentSolution {
  /** Accept in-person payments at point-of-sale, kiosk, etc */
  ACCEPT_IN_PERSON_PAYMENTS = "ACCEPT_IN_PERSON_PAYMENTS",
  /** Accept payments online */
  ACCEPT_PAYMENTS_ONLINE = "ACCEPT_PAYMENTS_ONLINE",
  /** Issue virtual cards or physical cards */
  ISSUE_PAYMENT_CARDS = "ISSUE_PAYMENT_CARDS",
}

/** eSignature and date */
export type OnboardingESignature = OnboardingApplicationStep & {
  __typename?: "OnboardingESignature";
  /** Acceptance date of Acquirer Terms */
  acceptanceDateOfAcquirerTerms?: Maybe<Scalars["Date"]>;
  /** Acceptance date of Privacy Policy */
  acceptanceDateOfPrivacyPolicy?: Maybe<Scalars["Date"]>;
  /** Acceptance date of Terms and Conditions */
  acceptanceDateOfTermsAndConditions?: Maybe<Scalars["Date"]>;
  /** Acceptance of Acquirer Terms */
  acceptanceOfAcquirerTerms?: Maybe<Scalars["Boolean"]>;
  /** Acceptance of Privacy Policy */
  acceptanceOfPrivacyPolicy?: Maybe<Scalars["Boolean"]>;
  /** Acceptance of Terms & Conditions */
  acceptanceOfTermsAndConditions?: Maybe<Scalars["Boolean"]>;
  /** Confirmation of eSignature */
  confirmationOfESignature?: Maybe<Scalars["Boolean"]>;
  /** eSignature */
  eSignature?: Maybe<Scalars["String"]>;
  /** The status of eSignature information being collected */
  stepStatus?: Maybe<OnboardingApplicationStepStatus>;
  /** Submission date */
  submissionDate?: Maybe<Scalars["Date"]>;
};

/** The identification documents attached to a Person. */
export type OnboardingIdentificationDocument = {
  __typename?: "OnboardingIdentificationDocument";
  /** A person's passport information */
  passport?: Maybe<PassportIdentificationDocument>;
  /**
   * A person's social security number (USA only).
   *
   * Must have 9 digits divided into 3 parts by hyphen. For example, `123-45-6789`.
   * The first part should have 3 digits and should not be 000, 666, or between 900 and 999.
   * The second part should have 2 digits and it should be from 01 to 99.
   * The third part should have 4 digits and it should be from 0001 to 9999.
   *
   * The validation for the input uses the following regex pattern `^(?!666|000|9\d{2})\d{3}-(?!00)\d{2}-(?!0{4})\d{4}$`.
   */
  socialSecurityNumber?: Maybe<TaxIdentificationDocument>;
};

/** Possible Payment Card Brand types */
export enum OnboardingPaymentCardBrand {
  /** American Express card brand. */
  AMERICAN_EXPRESS = "AMERICAN_EXPRESS",
  /** Diners card brand. */
  DINERS_CLUB = "DINERS_CLUB",
  /** Discover card brand. */
  DISCOVER = "DISCOVER",
  /** JCB card brand. */
  JCB = "JCB",
  /** Maestro card brand. */
  MAESTRO = "MAESTRO",
  /** Mastercard card brand. */
  MASTERCARD = "MASTERCARD",
  /** Visa card brand. */
  VISA = "VISA",
}

/** Status of the preliminary decision on the merchant onboarding application */
export enum OnboardingPreApprovalStatus {
  /** Approved to move forward */
  APPROVED = "APPROVED",
  /** Approved to move forward, but outreach should also be done to confirm needs of new business */
  APPROVED_WITH_OUTREACH = "APPROVED_WITH_OUTREACH",
  /** Denied from moving forward in the onboarding process */
  DENIED = "DENIED",
  /** No decision yet made */
  NOT_DECISIONED = "NOT_DECISIONED",
  /** Redirect the request to issuing product */
  REDIRECT_TO_ISSUING = "REDIRECT_TO_ISSUING",
}

/** The initial business information collected from a potential business customer */
export type OnboardingPreliminaryBusinessInformation = Node & {
  __typename?: "OnboardingPreliminaryBusinessInformation";
  /** The average processing volume for the business */
  averageMonthlyPaymentVolume?: Maybe<OnboardingAverageMonthlyPaymentVolumeRange>;
  /**
   * The average processing volume for the business
   * @deprecated Use averageMonthlyPaymentVolume instead.
   */
  averageMonthlyVolume?: Maybe<OnboardingAverageMonthlyVolumeRange>;
  /** The legal name of the business */
  businessName: Scalars["String"];
  /**
   * Business website URL.
   *
   * The validation for the `website` URL uses the following regex pattern `^((((https?|ftps?|gopher|telnet|nntp)://)|(mailto:|news:))(%[0-9A-Fa-f]{2}|[-()_.!~*';/?:@&=+$,A-Za-z0-9])+)([).!';/?:,][[:blank:|:blank:]])?$`
   */
  businessWebsite: Scalars["String"];
  /** Consent to store the preliminary business information */
  consent?: Maybe<ConsentAgreement>;
  /** The date and time, in ISO 8601 format, when this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /**
   * The location of the business' customers
   * @deprecated No longer supported.
   */
  customerLocation?: Maybe<OnboardingCustomerLocation>;
  /** All applicable desired solutions for the business */
  desiredSolutions?: Maybe<Array<OnboardingDesiredPaymentSolution>>;
  /** The global region the business operates in */
  globalRegion?: Maybe<OnBoardingBusinessGlobalRegion>;
  /** The permitted types of transactions, e.g goods and services. If empty, this will be populated from the contract's capabilities which match attributes of this MID. */
  goodsAndServicesProvided: BusinessPlanOperatingGoodsAndServiceCategory;
  /** The Global ID of the preliminary business info. */
  id: Scalars["ID"];
  /** Whether subscriber has been pre-approved for acquiring */
  preApproved?: Maybe<Scalars["Boolean"]>;
  /** The primary contact email to use during the onboarding process */
  primaryContactEmail: Scalars["String"];
  /** The primary contact name to use during the onboarding process */
  primaryContactName?: Maybe<Scalars["String"]>;
  /** A brief description of the products or services it provides. */
  productDescription?: Maybe<Scalars["String"]>;
  /**
   * A region for the address based on the codes for identifying the principle subdivisions, e.g. provinces and states, of countries
   * [IS0 3166 standard](https://en.wikipedia.org/wiki/ISO_3166-2), including districts and outlying areas.
   */
  regionOfFormation?: Maybe<Scalars["String"]>;
  /**
   * The desired solution for the business
   * @deprecated Use desiredSolutions instead.
   */
  solution?: Maybe<OnboardingBusinessPaymentSolution>;
  /** Current status of the preliminary decision on the business onboarding application */
  status?: Maybe<OnboardingPreApprovalStatus>;
  /** The date and time, in ISO 8601 format, when this object was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** A scheduled one time ACH transfer */
export type OneTimeAchTransfer = Node &
  ScheduledTransfer & {
    __typename?: "OneTimeACHTransfer";
    /** The date and time, in ISO 8601 format, this `OneTimeACHTransfer` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Descriptive fields about the transfer which may show up on bank reports. */
    descriptor?: Maybe<AchDescriptor>;
    /**
     * The financial account sending the funds.
     *
     * Exactly one of `fromFinancialAccount` and `toFinancialAccount` will be an `ExternalFinancialAccount` and the other will be a `FinancialAccount`.
     */
    fromFinancialAccount?: Maybe<AllFinancialAccount>;
    /** Global ID used to reference the one time ACH transfer */
    id: Scalars["ID"];
    /** The date and time, in ISO 8601 format, the scheduled transfer is to be executed. */
    scheduledTransferDate?: Maybe<Scalars["String"]>;
    /** The status of the scheduled transfer */
    status?: Maybe<ScheduledTransferStatusCode>;
    /**
     * The financial account receiving the funds.
     *
     * Exactly one of `fromFinancialAccount` and `toFinancialAccount` will be an `ExternalFinancialAccount` and the other will be a `FinancialAccount`.
     */
    toFinancialAccount?: Maybe<AllFinancialAccount>;
    /** The amount to be transferred. */
    transferAmount?: Maybe<TransferAmountStrategy>;
    /** The day the transfer is scheduled to be executed. Optional; only set if transfer day is calculated (for example, payment due date). */
    transferDayCalculationType?: Maybe<TransferDateCode>;
    /** The transfers executed as a result of the recurring transfer */
    transferEvents?: Maybe<ScheduledTransferEventConnection>;
    /** The date and time, in ISO 8601 format, this `OneTimeACHTransfer` was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** A scheduled one time ACH transfer */
export type OneTimeAchTransferTransferEventsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Input fields for ordering a payment card. */
export type OrderPhysicalPaymentCardForGroupInput = {
  /** Card personalization. */
  cardPersonalization: PaymentCardPersonalizationInput;
  /** Delivery details. */
  deliveryDetails?: InputMaybe<PaymentCardDeliveryDetailsInput>;
  /** Id of the group order. */
  groupOrderId: Scalars["ID"];
  /** Id of the payment card. */
  paymentCardId: Scalars["ID"];
};

/** Input fields for ordering a payment card. */
export type OrderPhysicalPaymentCardInput = {
  /** Card personalization. */
  cardPersonalization: PaymentCardPersonalizationInput;
  /** Courier information. */
  courier?: InputMaybe<PaymentCardShipmentCourierInput>;
  /** Delivery details. */
  deliveryDetails: PaymentCardDeliveryDetailsInput;
  /** Id of the payment card. */
  paymentCardId: Scalars["ID"];
  /**
   * Requested ship date in YYYY-MM-DD format.
   *
   * Use this if the fulfillment should not happen before a certain date.
   *
   * If the card should be shipped as soon as possible, omit this field. If the date provided is in the past, the value will be ignored.
   */
  requestedShipDate?: InputMaybe<Scalars["String"]>;
};

/** Types which can be returned for ordering a payment card. */
export type OrderPhysicalPaymentCardPayload =
  | AccessDeniedError
  | PhysicalPaymentCardOrder
  | UserError;

/** Input fields for ordering a payment card with validated address. */
export type OrderPhysicalPaymentCardWithValidatedAddressInput = {
  /** Card personalization. */
  cardPersonalization: PaymentCardPersonalizationInput;
  /** Courier information. */
  courier?: InputMaybe<PaymentCardShipmentCourierInput>;
  /** Delivery details. */
  deliveryDetails: PaymentCardDeliveryDetailsWithValidatedAddressInput;
  /**
   * The idempotency key for this request.
   *
   * This is a random string such as UUIDv4 used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   *
   * Minimum length: 5 characters
   * Maximum length: 255 characters
   */
  idempotencyKey: Scalars["IdempotencyKey"];
  /** Id of the payment card. */
  paymentCardId: Scalars["ID"];
  /**
   * Requested ship date in YYYY-MM-DD format.
   *
   * Use this if the fulfillment should not happen before a certain date.
   *
   * If the card should be shipped as soon as possible, omit this field. If the date provided is in the past, the value will be ignored.
   */
  requestedShipDate?: InputMaybe<Scalars["String"]>;
};

/** Input fields for ordering a payment card with validated address token. */
export type OrderPhysicalPaymentCardWithValidatedAddressTokenInput = {
  /** Card personalization. */
  cardPersonalization: PaymentCardPersonalizationInput;
  /** Courier information. */
  courier?: InputMaybe<PaymentCardShipmentCourierInput>;
  /** Delivery details. */
  deliveryDetails: PaymentCardDeliveryDetailsWithValidatedAddressInput;
  /**
   * The idempotency key for this request.
   *
   * This is a random string such as UUIDv4 used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   *
   * Minimum length: 5 characters
   * Maximum length: 255 characters
   */
  idempotencyKey: Scalars["IdempotencyKey"];
  /** Id of the payment card. */
  paymentCardId: Scalars["ID"];
  /**
   * Requested ship date in YYYY-MM-DD format.
   *
   * Use this if the fulfillment should not happen before a certain date.
   *
   * If the card should be shipped as soon as possible, omit this field. If the date provided is in the past, the value will be ignored.
   */
  requestedShipDate?: InputMaybe<Scalars["String"]>;
};

/** Organization that controls a set of card programs. */
export type Organization = Node & {
  __typename?: "Organization";
  /** All financial accounts associated with this organization. */
  accounts?: Maybe<FinancialAccountConnection>;
  /** All API Keys associated to this Organization. */
  apiKeys?: Maybe<ApiKeyConnection>;
  /** Detailed information about the organization */
  businessDetail?: Maybe<BusinessDetail>;
  /** A paginated list of Card Products for this Organization. */
  cardProducts?: Maybe<CardProductConnection>;
  /** A paginated list of `CollaborativeAuthorizationEndpoints`. */
  collaborativeAuthorizationEndpoints?: Maybe<CollaborativeAuthorizationEndpointConnection>;
  /** Contains all document uploads associated with this organization */
  documents?: Maybe<Array<DocumentUploadCollection>>;
  /**
   * The financial accounts backing this Organization.
   * @deprecated Use accounts instead.
   */
  financialAccounts?: Maybe<Array<FinancialAccount>>;
  /** ID of the Organization */
  id: Scalars["ID"];
  /** The inter financial account transfer rules belonging to this `Organization`. */
  interFinancialAccountTransferRules?: Maybe<InterFinancialAccountTransferRuleConnectionPayload>;
  /** Business information collected during onboarding */
  onboardingBusinessOrganizationInformationByOrganization?: Maybe<OnboardingBusinessOrganizationInformation>;
  /** Onboarding information associated with this organization */
  onboardingPreliminaryBusinessInformation?: Maybe<OnboardingPreliminaryBusinessInformation>;
  /**
   * A paginated list of `PaymentCardTransactionChargeback` for this `Organization`.
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  paymentCardTransactionChargebacks?: Maybe<PaymentCardTransactionChargebackConnection>;
  /**
   * A paginated list of `PaymentCardTransactionDispute` for this `Organization`.
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  paymentCardTransactionDisputes?: Maybe<PaymentCardTransactionDisputeConnection>;
  /**
   * A paginated list of Physical Card Group Orders
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   * @deprecated Use physicalPaymentCardGroupOrders instead.
   */
  physicalCardGroupOrders?: Maybe<PhysicalCardGroupOrderConnection>;
  /**
   * A paginated list of Physical Card Group Orders
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  physicalPaymentCardGroupOrders?: Maybe<PhysicalCardGroupOrderConnection>;
  /**
   * A paginated list of Physical Payment Card Orders
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  physicalPaymentCardOrders?: Maybe<PhysicalPaymentCardOrderConnection>;
  /** Details of the Organization */
  profile: OrganizationProfile;
  /** The realtime risk rules belonging to this `Organization`. */
  realtimeRiskRules?: Maybe<RealtimeRiskRuleConnectionPayload>;
  /** The `ReviewWorkflowEvents` related to this `FinancialAccount`. */
  reviewWorkflowEvents?: Maybe<ReviewWorkflowEventConnectionPayload>;
  /** A paginated list of `RewardEarnRule`s. */
  rewardEarnRules?: Maybe<RewardEarnRuleConnection>;
  /** A paginated list of `RewardRedemptionConfiguration`s. */
  rewardRedemptionConfigurations?: Maybe<RewardRedemptionConfigurationConnection>;
  /** `FinancialAccount` balances associated with this `Organization`. */
  searchFinancialAccountBalances?: Maybe<FinancialAccountBalanceSearchResultPayload>;
  /** Searches across all types of transaction, transaction events, and financial activities. */
  searchTransactions?: Maybe<TransactionSearchResultPayload>;
  /** A paginated list of spend rules. */
  spendRules?: Maybe<SpendRuleConnection>;
  /** `UserDefinedFieldDefinitions` associated with this organization. */
  userDefinedFieldDefinitions?: Maybe<UserDefinedFieldDefinitionConnection>;
  /** `UserDefinedFields` associated with this organization. */
  userDefinedFields?: Maybe<UserDefinedFieldConnection>;
  /** All Users with access to the Organization. */
  users?: Maybe<UserConnection>;
  /** The internal velocity transfer rules belonging to this `Organization`. */
  velocityInterFinancialAccountTransferRules?: Maybe<VelocityInterFinancialAccountTransferRuleConnectionPayload>;
  /** A paginated list of VelocityRules. */
  velocityRules?: Maybe<VelocityRuleConnection>;
  /** A paginated list of Webhook Notification Target. */
  webhookNotificationTargets?: Maybe<WebhookNotificationTargetConnection>;
};

/** Organization that controls a set of card programs. */
export type OrganizationAccountsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<AccountHolderFinancialAccountsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Organization that controls a set of card programs. */
export type OrganizationApiKeysArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Organization that controls a set of card programs. */
export type OrganizationCardProductsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Organization that controls a set of card programs. */
export type OrganizationCollaborativeAuthorizationEndpointsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Organization that controls a set of card programs. */
export type OrganizationInterFinancialAccountTransferRulesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Organization that controls a set of card programs. */
export type OrganizationPaymentCardTransactionChargebacksArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<PaymentCardTransactionChargebacksFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Organization that controls a set of card programs. */
export type OrganizationPaymentCardTransactionDisputesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<PaymentCardTransactionDisputesFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Organization that controls a set of card programs. */
export type OrganizationPhysicalCardGroupOrdersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<PhysicalCardGroupOrderFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Organization that controls a set of card programs. */
export type OrganizationPhysicalPaymentCardGroupOrdersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<PhysicalPaymentCardGroupOrderFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Organization that controls a set of card programs. */
export type OrganizationPhysicalPaymentCardOrdersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<PhysicalPaymentCardOrderFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Organization that controls a set of card programs. */
export type OrganizationRealtimeRiskRulesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Organization that controls a set of card programs. */
export type OrganizationReviewWorkflowEventsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<ReviewWorkflowEventFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Organization that controls a set of card programs. */
export type OrganizationRewardEarnRulesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Organization that controls a set of card programs. */
export type OrganizationRewardRedemptionConfigurationsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Organization that controls a set of card programs. */
export type OrganizationSearchFinancialAccountBalancesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<FinancialAccountBalanceSearchFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Organization that controls a set of card programs. */
export type OrganizationSearchTransactionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy: TransactionSearchFilterInput;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Organization that controls a set of card programs. */
export type OrganizationSpendRulesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Organization that controls a set of card programs. */
export type OrganizationUserDefinedFieldDefinitionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<UserDefinedFieldDefinitionsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Organization that controls a set of card programs. */
export type OrganizationUserDefinedFieldsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<UserDefinedFieldsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Organization that controls a set of card programs. */
export type OrganizationUsersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Organization that controls a set of card programs. */
export type OrganizationVelocityInterFinancialAccountTransferRulesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Organization that controls a set of card programs. */
export type OrganizationVelocityRulesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Organization that controls a set of card programs. */
export type OrganizationWebhookNotificationTargetsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Represents an organization business relationship with a customer. */
export type OrganizationBusinessCustomerRelationship = {
  __typename?: "OrganizationBusinessCustomerRelationship";
  /** The customer organization. */
  organization?: Maybe<Organization>;
  /** The status of the relationship. */
  relationshipStatus?: Maybe<OrganizationBusinessRelationshipStatus>;
};

/** Represents an organization business relationship with a partner. */
export type OrganizationBusinessPartnerRelationship = {
  __typename?: "OrganizationBusinessPartnerRelationship";
  /** The partner organization. */
  organization?: Maybe<Organization>;
  /** The status of the relationship. */
  relationshipStatus?: Maybe<OrganizationBusinessRelationshipStatus>;
};

/** Represents all possible types of organization business relationships. */
export type OrganizationBusinessRelationship =
  | OrganizationBusinessCustomerRelationship
  | OrganizationBusinessPartnerRelationship;

/** A paginated list of organization business relationships. */
export type OrganizationBusinessRelationshipConnection = {
  __typename?: "OrganizationBusinessRelationshipConnection";
  /** A list of edges representing organization business relationships. */
  edges?: Maybe<Array<OrganizationBusinessRelationshipEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** An edge in the organization business relationship connection. */
export type OrganizationBusinessRelationshipEdge = {
  __typename?: "OrganizationBusinessRelationshipEdge";
  /** A pagination cursor for this edge. */
  cursor: Scalars["String"];
  /** The organization business relationship represented by this edge. */
  node?: Maybe<OrganizationBusinessRelationship>;
};

/** Inputs for filtering organization business relationships. */
export type OrganizationBusinessRelationshipFilterInput = {
  /** The id of the organization from where the relationship originates */
  fromOrganization?: InputMaybe<Scalars["ID"]>;
  /** Filter by relationship status (ACTIVE or INACTIVE). */
  relationshipStatus?: InputMaybe<
    Array<OrganizationBusinessRelationshipStatus>
  >;
  /** The types of relationships */
  relationshipTypes?: InputMaybe<Array<OrganizationBusinessRelationshipType>>;
};

/** The status of an organization business relationship. */
export enum OrganizationBusinessRelationshipStatus {
  /** The relationship is currently active and valid. */
  ACTIVE = "ACTIVE",
  /** The relationship is inactive or has been revoked. */
  INACTIVE = "INACTIVE",
}

/** The type of an organization business relationship. */
export enum OrganizationBusinessRelationshipType {
  /** The relationship is with a customer. */
  CUSTOMER = "CUSTOMER",
  /** The relationship is with a partner. */
  PARTNER = "PARTNER",
}

/** The connection type for `Organization`. */
export type OrganizationConnection = {
  __typename?: "OrganizationConnection";
  /** A list of edges. */
  edges?: Maybe<Array<OrganizationEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for an `Organization`. */
export type OrganizationEdge = {
  __typename?: "OrganizationEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The `Organization`. */
  node?: Maybe<Organization>;
};

/** Details of the Organization */
export type OrganizationProfile = {
  __typename?: "OrganizationProfile";
  /** Display name of the Organization. */
  displayName?: Maybe<Scalars["String"]>;
  /** The environment for the organization. */
  environment?: Maybe<IntegrationEnvironment>;
  /** The feature permissions for this Organization */
  featurePermissions?: Maybe<FeaturePermissionConnection>;
  /** Geographic region where organization data is persisted. */
  region?: Maybe<ComputeRegion>;
  /** ID of the Tenant */
  tenantId?: Maybe<Scalars["ID"]>;
};

/** Details of the Organization */
export type OrganizationProfileFeaturePermissionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/**
 * Available report types that apply to `Organizations` and that can be passed into
 * `initiateOrganizationReport`.
 */
export enum OrganizationReportType {
  /** This report contains all ACH event activities across all financial accounts for the organization. */
  ACH_EVENT_ACTIVITY = "ACH_EVENT_ACTIVITY",
  /** This report contains card interchange and transaction settlement activity across all financial accounts for the organization. */
  CARD_INTERCHANGE_ACTIVITY = "CARD_INTERCHANGE_ACTIVITY",
  /** This report contains all card transaction event activities across all financial accounts for the organization. */
  CARD_TRANSACTION_ACTIVITY = "CARD_TRANSACTION_ACTIVITY",
  /** This is the credit loan tape report across all financial accounts for the organization. */
  CREDIT_LOAN_TAPE = "CREDIT_LOAN_TAPE",
  /** Metro2 file formatted for credit report furnishing with Experian. */
  EXPERIAN_CREDIT_REPORT = "EXPERIAN_CREDIT_REPORT",
  /** This report contains all the enhanced data (level 2/3) sent by the payment networks for cleared fleet transactions for a specific time period */
  FLEET_ENHANCED_DATA_SUMMARY = "FLEET_ENHANCED_DATA_SUMMARY",
  /** This report contains ledger entries across all financial accounts for the organization. */
  LEDGER_ENTRY = "LEDGER_ENTRY",
  /** This is the negative balance report across all financial accounts for the organization. */
  NEGATIVE_ACCOUNT_BALANCE = "NEGATIVE_ACCOUNT_BALANCE",
  /** This report contains the breakdown of each financial account’s receivable being sold on a given business day (sum to the amount in the Receivable Sale report) */
  RECEIVABLE_ACCOUNTS_SALE = "RECEIVABLE_ACCOUNTS_SALE",
  /** This report contains the overall amount(s) being sold on a given business day */
  RECEIVABLE_SALE = "RECEIVABLE_SALE",
  /** This is the RPA purchase agreement for a given day */
  RECEIVABLE_SALE_AGREEMENT = "RECEIVABLE_SALE_AGREEMENT",
  /** This report contains the breakdown of each transaction’s receivable being sold on a given business day (sum to the amount in the Receivable Sale report) */
  RECEIVABLE_SALE_TRANSACTIONS = "RECEIVABLE_SALE_TRANSACTIONS",
  /** This report contains all transfer event activities across all financial accounts for the organization. */
  TRANSFER_EVENT_ACTIVITY = "TRANSFER_EVENT_ACTIVITY",
}

/**
 * The details of an `AchTransfer` initiated by Highnote.
 * It can `PUSH` funds from a Highnote `FinancialAccount` to an external financial institution
 * or `PULL` funds from an external financial institution to a Highnote `FinancialAccount`.
 */
export type OriginatedAchTransfer = AchTransfer &
  ElectronicFundsTransfer &
  Node & {
    __typename?: "OriginatedAchTransfer";
    /** The monetary amount to transfer. */
    amount?: Maybe<Amount>;
    /** The date and time the transfer was canceled, in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z. */
    canceledAt?: Maybe<Scalars["String"]>;
    /** The `CardProduct` associated with the Highnote `FinancialAccount`. */
    cardProduct?: Maybe<CardProduct>;
    /**
     * Provides the receiving financial institution with information about the nature or purpose of the transaction.
     * Examples include "ACCTVERIFY". "PAYROLL", "PAYMENT", etc.
     *
     * Maximum length: 10 characters.
     */
    companyEntryDescription?: Maybe<Scalars["String"]>;
    /** The ID of the company that initiated the transfer. */
    companyIdentifier?: Maybe<Scalars["String"]>;
    /** The name of the company that initiated the transfer. */
    companyName?: Maybe<Scalars["String"]>;
    /** The date and time the transfer was initiated, in ISO 8601 format, e.g. 2024-01-01T00:00:00.000Z. */
    createdAt?: Maybe<Scalars["String"]>;
    /**
     * The date specified by Highnote in which ACH settlement is expected to occur at the external financial institution,
     * in ISO 8601 date format, e.g. 2024-01-01.
     *
     * When `sameDay` is `true` and the transfer is initiated within the Federal Reserve ACH processing schedule, the
     * effective entry date is the same date as the date of `createdAt` on Eastern Time Zone, otherwise, it is equal to
     * the next business day.
     *
     * When `sameDay` is `false`, the effective entry date is equal to one business day from `createdAt` if the transfer
     * is initiated within the Federal Reserve ACH processing schedule, otherwise, it is equal to two business days from
     * `createdAt`.
     */
    effectiveEntryDate?: Maybe<Scalars["String"]>;
    /**
     * The date and time the transfer is expected to process, e.g. transition to `PROCESSED`, and reflected on the financial account',
     * in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z.
     */
    expectedProcessedAt?: Maybe<Scalars["String"]>;
    /**
     * The date and time the transfer failed by Highnote, in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z.
     *
     * A failed transfer is not sent to the external financial institution.
     */
    failedAt?: Maybe<Scalars["String"]>;
    /**
     * The financial account sending funds. This can be a Highnote `FinancialAccount`
     * or a verified external financial account (`ExternalFinancialBankAccount`).
     */
    fromFinancialAccount?: Maybe<AchFromFinancialAccount>;
    /**
     * The hold status of the transfer.
     *
     * Funds from an `OriginatedAchTransfer` `PULL` are not available to spend while the transfer is `ON_HOLD`.
     * An `OriginatedAchTransfer` `PUSH` is not sent to the external financial institution while the transfer is `ON_HOLD`.
     *
     * This field is currently restricted to administrators.
     */
    holdStatus?: Maybe<AchHoldStatus>;
    /**
     * The hold type of the transfer.
     *
     * This field is currently restricted to administrators.
     */
    holdType?: Maybe<AchHoldType>;
    /** Global ID used to reference the `OriginatedAchTransfer`. */
    id: Scalars["ID"];
    /**
     * Receiver’s identification number. This could be a person or a business.
     *
     * Maximum length: 15 characters.
     */
    individualIdentificationNumber?: Maybe<Scalars["String"]>;
    /**
     * Receiver’s individual name. This could be a person or a business.
     *
     * Maximum length: 22 characters.
     */
    individualName?: Maybe<Scalars["String"]>;
    /**
     * The date and time the hold status last changed, in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z.
     *
     * Funds from an `OriginatedAchTransfer` `PULL` are not available to spend while the transfer is `ON_HOLD`.
     * An `OriginatedAchTransfer` `PUSH` is not sent to the external financial institution while the transfer is `ON_HOLD`.
     *
     * This field is currently restricted to administrators.
     */
    lastHoldStatusChangedAt?: Maybe<Scalars["String"]>;
    /** The ledgers affected by the transfer. */
    ledgers?: Maybe<Array<Ledger>>;
    /**
     * Contains payment-related information provided by the originator of the transaction.
     * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
     * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
     *
     * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
     *
     * Please note that this information may or may not be displayed to the recipient, based on the bank's
     * capabilities, and method of access (i.e., online banking, statement, etc.)
     *
     * Maximum length: 80 characters.
     */
    paymentRelatedInformation?: Maybe<Scalars["String"]>;
    /**
     * The date and time the transfer was processed (e.g. transitioned to `PROCESSED`) and reflected on the financial account,
     * in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z.
     */
    processedAt?: Maybe<Scalars["String"]>;
    /** The purpose of the transfer, e.g. deposit. */
    purpose?: Maybe<AchTransferPurpose>;
    /**
     * The date a return received from the external financial institution for this transfer was processed by Highnote,
     * in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z.
     */
    returnProcessedAt?: Maybe<Scalars["String"]>;
    /** A flag that indicates the desire to process this transaction using same-day ACH. */
    sameDay?: Maybe<Scalars["Boolean"]>;
    /**
     * The date and time the transfer was sent to the external financial institution for processing,
     * in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z.
     */
    sentToBankAt?: Maybe<Scalars["String"]>;
    /**
     * The impact of the transfer on the Highnote `FinancialAccount`.
     * Negative means a reduction of funds on the Highnote `FinancialAccount`.
     * Positive means an increase of funds on the Highnote `FinancialAccount`.
     */
    sign?: Maybe<AchTransferSign>;
    /** The status of the transfer. */
    status?: Maybe<OriginatedAchTransferStatus>;
    /** Additional details about why the transfer failed. This is only applicable when the transfer status is `FAILED` or `RETURNED`. */
    statusFailureReason?: Maybe<AchTransferStatusFailureReason>;
    /**
     * The financial account receiving funds. This can be a Highnote `FinancialAccount`
     * or a verified or non-verified external financial account (`ExternalFinancialBankAccount`
     * or `NonVerifiedExternalUSFinancialBankAccount`).
     */
    toFinancialAccount?: Maybe<AchToFinancialAccount>;
    /**
     * A unique 15 digit number assigned by the originator when the transfer is in the `PROCESSING` state.
     * It is used is used to identify the transfer in the ACH network.
     */
    traceNumber?: Maybe<Scalars["String"]>;
    /**
     * The direction of the transfer, `PUSH` or `PULL`, from the perspective of the originating financial institution.
     *
     * `PUSH` means pushing funds from a Highnote `FinancialAccount` to an external financial account and
     * `PULL` means pulling funds from an external financial account to a Highnote `FinancialAccount`.
     */
    type?: Maybe<AchTransferType>;
    /** The date and time the transfer details were last updated, in ISO 8601 format, e.g. 2024-01-01T00:00:00.000Z. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/**
 * The details of an `AchTransfer` initiated by Highnote.
 * It can `PUSH` funds from a Highnote `FinancialAccount` to an external financial institution
 * or `PULL` funds from an external financial institution to a Highnote `FinancialAccount`.
 */
export type OriginatedAchTransferLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** An event that occurs when an `OriginatedAchTransfer` is canceled by Highnote. */
export type OriginatedAchTransferCanceledEvent = Node & {
  __typename?: "OriginatedAchTransferCanceledEvent";
  /** The date the transfer was canceled by Highnote, in ISO 8601 format, e.g. 2024-01-01T00:00:00.000Z. */
  canceledAt?: Maybe<Scalars["String"]>;
  /** Uniquely identifies the `OriginatedAchTransferCanceledEvent`. */
  id: Scalars["ID"];
  /** Details about the `OriginatedAchTransfer` that was canceled by Highnote. */
  transfer: OriginatedAchTransfer;
};

/** The connection type for `OriginatedAchTransfer`s. */
export type OriginatedAchTransferConnection = {
  __typename?: "OriginatedAchTransferConnection";
  /** A list of edges. */
  edges?: Maybe<Array<OriginatedAchTransferEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for an `OriginatedAchTransfer`. */
export type OriginatedAchTransferEdge = {
  __typename?: "OriginatedAchTransferEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The `OriginatedAchTransfer`. */
  node?: Maybe<OriginatedAchTransfer>;
};

/** An event that occurs when an `OriginatedAchTransfer` is failed by Highnote. */
export type OriginatedAchTransferFailedEvent = Node & {
  __typename?: "OriginatedAchTransferFailedEvent";
  /** The date the transfer was failed by Highnote, in ISO 8601 format, e.g. 2024-01-01T00:00:00.000Z. */
  failedAt?: Maybe<Scalars["String"]>;
  /** Uniquely identifies the `OriginatedAchTransferFailedEvent`. */
  id: Scalars["ID"];
  /** Additional details about why the originated transfer was failed by Highnote. */
  statusFailureReason?: Maybe<AchTransferStatusFailureReason>;
  /** Details about the `OriginatedAchTransfer` that was failed by Highnote. */
  transfer: OriginatedAchTransfer;
};

/** Inputs for filtering originated ACH transfer data. */
export type OriginatedAchTransferFilterInput = {
  amount?: InputMaybe<MoneyFilterInput>;
  cardProductId?: InputMaybe<StringSearchFilterInput>;
  companyEntryDescription?: InputMaybe<StringSearchFilterInput>;
  createdAt?: InputMaybe<TimestampFilterInput>;
  holdStatus?: InputMaybe<AchHoldStatusFilterInput>;
  purpose?: InputMaybe<AchTransferPurposeFilterInput>;
  returnProcessedAt?: InputMaybe<TimestampFilterInput>;
  sign?: InputMaybe<AchTransferSignFilterInput>;
  status?: InputMaybe<OriginatedAchTransferStatusFilterInput>;
  statusFailureReason?: InputMaybe<AchTransferStatusFailureReasonFilterInput>;
  traceNumber?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<AchTransferTypeFilterInput>;
};

/** An event that occurs when an `OriginatedAchTransfer` is initiated by Highnote. */
export type OriginatedAchTransferInitiatedEvent = Node & {
  __typename?: "OriginatedAchTransferInitiatedEvent";
  /** The date the transfer was initiated, in ISO 8601 format, e.g. 2024-01-01T00:00:00.000Z. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Uniquely identifies the `OriginatedAchTransferInitiatedEvent`. */
  id: Scalars["ID"];
  /** Details about the `OriginatedAchTransfer` that was initiated. */
  transfer: OriginatedAchTransfer;
};

export type OriginatedAchTransferPayload =
  | AccessDeniedError
  | OriginatedAchTransferConnection
  | UserError;

/** An event that occurs when an `OriginatedAchTransfer` is processed as `PENDING` by Highnote. */
export type OriginatedAchTransferPendingEvent = Node & {
  __typename?: "OriginatedAchTransferPendingEvent";
  /** Uniquely identifies the `OriginatedAchTransferPendingEvent`. */
  id: Scalars["ID"];
  /** The date the transfer was initiated, in ISO 8601 format, e.g. 2024-01-01T00:00:00.000Z. */
  processedPendingAt?: Maybe<Scalars["String"]>;
  /** Details about the `OriginatedAchTransfer` that was processed as `PENDING` by Highnote. */
  transfer: OriginatedAchTransfer;
};

/** An event that occurs when an `OriginatedAchTransfer` was processed (e.g. transitioned to `PROCESSED`) and reflected on the financial account. */
export type OriginatedAchTransferProcessedEvent = Node & {
  __typename?: "OriginatedAchTransferProcessedEvent";
  /** Uniquely identifies the `OriginatedAchTransferProcessedEvent`. */
  id: Scalars["ID"];
  /**
   * The date and time the transfer was processed (e.g. transitioned to `PROCESSED`) and reflected on the financial account,
   * in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z.
   */
  processedAt?: Maybe<Scalars["String"]>;
  /** Details about the `OriginatedAchTransfer` that was processed (e.g. transitioned to `PROCESSED`) and reflected on the financial account. */
  transfer: OriginatedAchTransfer;
};

/** An event that occurs when an `OriginatedAchTransfer` is sent to the external financial institution. */
export type OriginatedAchTransferProcessingEvent = Node & {
  __typename?: "OriginatedAchTransferProcessingEvent";
  /** Uniquely identifies the `OriginatedAchTransferProcessingEvent`. */
  id: Scalars["ID"];
  /**
   * The date and time the transfer is sent to the external financial institution for processing,
   * in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z.
   */
  sentToBankAt?: Maybe<Scalars["String"]>;
  /** Details about the `OriginatedAchTransfer` that was sent to the external financial institution. */
  transfer: OriginatedAchTransfer;
};

/**
 * An event that occurs when a return received from the external financial institution for this transfer was processed by Highnote,
 * in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z.
 */
export type OriginatedAchTransferReturnedEvent = Node & {
  __typename?: "OriginatedAchTransferReturnedEvent";
  /** Uniquely identifies the `OriginatedAchTransferReturnedEvent`. */
  id: Scalars["ID"];
  /**
   * The date and time when a return received from the external financial institution for this transfer was processed by Highnote,
   * in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z.
   */
  returnProcessedAt?: Maybe<Scalars["String"]>;
  /** Additional details about why the originated transfer was returned by the external financial institution. */
  statusFailureReason?: Maybe<AchTransferStatusFailureReason>;
  /** Details about the `OriginatedAchTransfer` that was returned by the external financial institution. */
  transfer: OriginatedAchTransfer;
};

/** A snapshot of an originated ACH transfer. */
export type OriginatedAchTransferSnapshot = Node & {
  __typename?: "OriginatedAchTransferSnapshot";
  /** The monetary amount to transfer. */
  amount?: Maybe<Amount>;
  /** The date and time the transfer was canceled, in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z. */
  canceledAt?: Maybe<Scalars["String"]>;
  /** The `CardProduct` associated with the Highnote `FinancialAccount`. */
  cardProduct?: Maybe<CardProduct>;
  /**
   * Provides the receiving financial institution with information about the nature or purpose of the transaction.
   * Examples include "ACCTVERIFY". "PAYROLL", "PAYMENT", etc.
   *
   * Maximum length: 10 characters.
   */
  companyEntryDescription?: Maybe<Scalars["String"]>;
  /** The ID of the company that initiated the transfer. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /** The name of the company that initiated the transfer. */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time this snapshot was created, in ISO 8601 format. */
  createdAt?: Maybe<Scalars["String"]>;
  /**
   * The date specified by Highnote in which ACH settlement is expected to occur at the external financial institution,
   * in ISO 8601 date format, e.g. 2024-01-01.
   *
   * When `sameDay` is `true` and the transfer is initiated within the Federal Reserve ACH processing schedule, the
   * effective entry date is the same date as the date of `createdAt` on Eastern Time Zone, otherwise, it is equal to
   * the next business day.
   *
   * When `sameDay` is `false`, the effective entry date is equal to one business day from `createdAt` if the transfer
   * is initiated within the Federal Reserve ACH processing schedule, otherwise, it is equal to two business days from
   * `createdAt`.
   */
  effectiveEntryDate?: Maybe<Scalars["String"]>;
  /**
   * The date and time the transfer is expected to process, e.g. transition to `PROCESSED`, and reflected on the financial account',
   * in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z.
   */
  expectedProcessedAt?: Maybe<Scalars["String"]>;
  /**
   * The date and time the transfer failed by Highnote, in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z.
   *
   * A failed transfer is not sent to the external financial institution.
   */
  failedAt?: Maybe<Scalars["String"]>;
  /**
   * The financial account sending funds. This can be a Highnote `FinancialAccount`
   * or a verified external financial account (`ExternalFinancialBankAccount`).
   */
  fromFinancialAccount?: Maybe<AchFromFinancialAccount>;
  /**
   * The hold status of the transfer.
   *
   * Funds from an `OriginatedAchTransfer` `PULL` are not available to spend while the transfer is `ON_HOLD`.
   * An `OriginatedAchTransfer` `PUSH` is not sent to the external financial institution while the transfer is `ON_HOLD`.
   *
   * This field is currently restricted to administrators.
   */
  holdStatus?: Maybe<AchHoldStatus>;
  /**
   * The hold type of the transfer.
   *
   * This field is currently restricted to administrators.
   */
  holdType?: Maybe<AchHoldType>;
  /** Global ID used to reference this snapshot. */
  id: Scalars["ID"];
  /**
   * Receiver's identification number. This could be a person or a business.
   *
   * Maximum length: 15 characters.
   */
  individualIdentificationNumber?: Maybe<Scalars["String"]>;
  /**
   * Receiver's individual name. This could be a person or a business.
   *
   * Maximum length: 22 characters.
   */
  individualName?: Maybe<Scalars["String"]>;
  /**
   * The date and time the hold status last changed, in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z.
   *
   * Funds from an `OriginatedAchTransfer` `PULL` are not available to spend while the transfer is `ON_HOLD`.
   * An `OriginatedAchTransfer` `PUSH` is not sent to the external financial institution while the transfer is `ON_HOLD`.
   *
   * This field is currently restricted to administrators.
   */
  lastHoldStatusChangedAt?: Maybe<Scalars["String"]>;
  /** The ledgers affected by the transfer. */
  ledgers?: Maybe<Array<Ledger>>;
  /**
   * Contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   *
   * Maximum length: 80 characters.
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
  /**
   * The date and time the transfer was processed (e.g. transitioned to `PROCESSED`) and reflected on the financial account,
   * in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z.
   */
  processedAt?: Maybe<Scalars["String"]>;
  /** The purpose of the transfer, e.g. deposit. */
  purpose?: Maybe<AchTransferPurpose>;
  /**
   * The date a return received from the external financial institution for this transfer was processed by Highnote,
   * in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z.
   */
  returnProcessedAt?: Maybe<Scalars["String"]>;
  /** A flag that indicates the desire to process this transaction using same-day ACH. */
  sameDay?: Maybe<Scalars["Boolean"]>;
  /**
   * The date and time the transfer was sent to the external financial institution for processing,
   * in ISO 8601 date and time format, e.g. 2024-01-01T00:00:00.000Z.
   */
  sentToBankAt?: Maybe<Scalars["String"]>;
  /**
   * The impact of the transfer on the Highnote `FinancialAccount`.
   * Negative means a reduction of funds on the Highnote `FinancialAccount`.
   * Positive means an increase of funds on the Highnote `FinancialAccount`.
   */
  sign?: Maybe<AchTransferSign>;
  /** The status of the transfer. */
  status?: Maybe<OriginatedAchTransferStatus>;
  /** Additional details about why the transfer failed. This is only applicable when the transfer status is `FAILED` or `RETURNED`. */
  statusFailureReason?: Maybe<AchTransferStatusFailureReason>;
  /**
   * The financial account receiving funds. This can be a Highnote `FinancialAccount`
   * or a verified or non-verified external financial account (`ExternalFinancialBankAccount`
   * or `NonVerifiedExternalUSFinancialBankAccount`).
   */
  toFinancialAccount?: Maybe<AchToFinancialAccount>;
  /**
   * A unique 15 digit number assigned by the originator when the transfer is in the `PROCESSING` state.
   * It is used is used to identify the transfer in the ACH network.
   */
  traceNumber?: Maybe<Scalars["String"]>;
  /** The originated ACH transfer that this is a revision of. */
  transfer?: Maybe<OriginatedAchTransfer>;
  /**
   * The direction of the transfer, `PUSH` or `PULL`, from the perspective of the originating financial institution.
   *
   * `PUSH` means pushing funds from a Highnote `FinancialAccount` to an external financial account and
   * `PULL` means pulling funds from an external financial account to a Highnote `FinancialAccount`.
   */
  type?: Maybe<AchTransferType>;
  /** The date and time this snapshot was last updated, in ISO 8601 format. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** The version number of this snapshot. */
  version?: Maybe<Scalars["Int"]>;
};

/** A snapshot of an originated ACH transfer. */
export type OriginatedAchTransferSnapshotLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** The status of an `OriginatedAchTransfer`. */
export enum OriginatedAchTransferStatus {
  /** The transfer has been cancelled before it was sent to the external financial institution. */
  CANCELED = "CANCELED",
  /** The transfer failed by Highnote before it was sent to the external financial institution. Additional details are available in `AchTransferStatusFailureReason`. */
  FAILED = "FAILED",
  /** A transfer request has been initiated. */
  INITIATED = "INITIATED",
  /** The transfer has been processed by Highnote, pending submittal to the external financial institution. */
  PENDING = "PENDING",
  /** The transfer has successfully been processed by the external financial institution and funds are available. */
  PROCESSED = "PROCESSED",
  /** The transfer is processing at the external financial institution, but funds are not available yet. */
  PROCESSING = "PROCESSING",
  /** The transfer has been returned by the external financial institution. Additional details are available in `AchTransferStatusFailureReason`. */
  RETURNED = "RETURNED",
}

/** Input for filtering by `AchTransferPurpose`. */
export type OriginatedAchTransferStatusFilterInput = {
  equals?: InputMaybe<OriginatedAchTransferStatus>;
  excludes?: InputMaybe<Array<OriginatedAchTransferStatus>>;
  includes?: InputMaybe<Array<OriginatedAchTransferStatus>>;
  notEquals?: InputMaybe<OriginatedAchTransferStatus>;
};

/**
 * An originated RTP (Real-Time Payments) transfer via the TCH network.
 *
 * An `OriginatedRtpTransfer` represents an RTP transfer originated by the Highnote partner bank
 * to an external bank account.
 */
export type OriginatedRtpTransfer = Node &
  RtpTransfer & {
    __typename?: "OriginatedRtpTransfer";
    /** Additional details for the bank transfer including payment related information. */
    bankTransferDetails?: Maybe<RtpTransferBankTransferDetails>;
    /** The date and time, in ISO 8601 format, when this object was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The destination of the funds being transferred. */
    destination?: Maybe<RtpTransferDestination>;
    /** The events associated with this `OriginatedRtpTransfer`. */
    events?: Maybe<Array<OriginatedRtpTransferEvent>>;
    /** When the `OriginatedRtpTransfer` has failed, this will be populated with the reason for the failure. */
    failureReason?: Maybe<RtpTransferFailureReason>;
    /** Global ID used to reference this object. */
    id: Scalars["ID"];
    /** The source of the funds being transferred. */
    source?: Maybe<RtpTransferSource>;
    /** The current status of the `OriginatedRtpTransfer`. */
    status?: Maybe<RtpTransferStatus>;
    /** The date and time, in ISO 8601 format, when this object was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** An event associated with an `OriginatedRtpTransfer`. */
export type OriginatedRtpTransferEvent = Node & {
  __typename?: "OriginatedRtpTransferEvent";
  /** The date and time, in ISO 8601 format, when this event occurred. */
  createdAt?: Maybe<Scalars["String"]>;
  /** When the `OriginatedRtpTransfer.status` is `FAILED` during this event, this will be populated with the reason for the failure. */
  failureReason?: Maybe<RtpTransferFailureReason>;
  /** The global ID of the event. */
  id: Scalars["ID"];
  /** The `OriginatedRtpTransfer` associated with this event. */
  rtpTransfer?: Maybe<OriginatedRtpTransfer>;
  /** The status of the `OriginatedRtpTransfer` when the event occurred. */
  status?: Maybe<RtpTransferStatus>;
};

/**
 * Information about the origination of a relayed notification event.
 * Provides context about which organization originally triggered the event
 * and when it was relayed to the current organization.
 */
export type Origination = {
  __typename?: "Origination";
  /** The original event that was relayed. */
  event?: Maybe<NotificationEvent>;
  /** The organization that originally triggered this notification event. */
  organization?: Maybe<Organization>;
  /** The date and time, in ISO 8601 format, when this event was relayed. */
  relayedAt?: Maybe<Scalars["String"]>;
};

/** Information about the paginated result set. */
export type PageInfo = {
  __typename?: "PageInfo";
  /** When paginating forward, the cursor to use for your next request. */
  endCursor: Scalars["String"];
  /** Whether or not edges prior to `before` or `after` exist. */
  hasNextPage: Scalars["Boolean"];
  /** Whether or not edges further from `before` or `after` exist. */
  hasPreviousPage: Scalars["Boolean"];
  /** When paginating backward, the cursor to use for your next request. */
  startCursor: Scalars["String"];
};

/** The PAN entry mode. */
export enum PanEntryMode {
  /** Bar code or QR Code. */
  BAR_CODE_OR_QR_CODE = "BAR_CODE_OR_QR_CODE",
  /**
   * Chip card or chip-capable terminal was unable to process the transaction using the data on the chip, the PAN was entered via magnetic stripe.
   * The full track data was read from the data encoded on the card and transmitted within the authorization request on Track 2 Data
   * or Track 1 Data without alteration or truncation.
   */
  CC_UNABLE_TO_PROCESS_ENTERED_VIA_MAGNETIC_STRIPE = "CC_UNABLE_TO_PROCESS_ENTERED_VIA_MAGNETIC_STRIPE",
  /**
   * Chip card or chip-capable terminal was unable to process the transaction using the data on the chip or magnetic stripe,
   * the PAN was entered manually, or the Acquirer is not certified to process the value CC_UNABLE_TO_PROCESS_ENTERED_VIA_MAGNETIC_STRIPE.
   */
  CHIP_CARD_UNABLE_TO_PROCESS_ENTERED_MANUALLY = "CHIP_CARD_UNABLE_TO_PROCESS_ENTERED_MANUALLY",
  /** Contactless via Chip rules. */
  CONTACTLESS_VIA_CHIP_RULES = "CONTACTLESS_VIA_CHIP_RULES",
  /** Contactless via magnetic stripe rules. */
  CONTACTLESS_VIA_MAGNETIC_STRIPE_RULES = "CONTACTLESS_VIA_MAGNETIC_STRIPE_RULES",
  /** From file; credentials on file */
  CREDENTIALS_ON_FILE = "CREDENTIALS_ON_FILE",
  /** Full magnetic stripe read (full magnetic stripe data will be present). */
  FULL_MAGNETIC_STRIPE_READ = "FULL_MAGNETIC_STRIPE_READ",
  /** Integrated circuit card, CVV data may be unreliable. */
  ICC_CARD_CVV_DATA_MAY_BE_UNRELIABLE = "ICC_CARD_CVV_DATA_MAY_BE_UNRELIABLE",
  /** Integrated circuit card (contact chip). */
  INTEGRATED_CIRCUIT_CARD = "INTEGRATED_CIRCUIT_CARD",
  /** Magnetic stripe (full magnetic stripe data may not be present). */
  MAGNETIC_STRIPE = "MAGNETIC_STRIPE",
  /** Manual. */
  MANUAL = "MANUAL",
  /** Manual (key-entered). */
  MANUAL_KEY_ENTERED = "MANUAL_KEY_ENTERED",
  /** Optical Character Reader (OCR) */
  OPTICAL_CHARACTER_READER = "OPTICAL_CHARACTER_READER",
  /** PAN Auto Entry via Server (issuer, acquirer, or third party vendor system). */
  PAN_AUTO_ENTRY_VIA_SERVER = "PAN_AUTO_ENTRY_VIA_SERVER",
  /** Reserved for ISO, national, or private use. */
  RESERVED = "RESERVED",
  /** Secure cardless entry. */
  SECURE_CARD_LESS_ENTRY = "SECURE_CARD_LESS_ENTRY",
  /**
   * PAN entry via electronic commerce, including remote chip for which data must be passed by the acquirer
   * (although such remote chip data may not be present in transactions received by the issuer if cryptographic
   * validation is being performed by a network or other entity on behalf of the issuer).
   */
  VIA_ELECTRONIC_COMMERCE = "VIA_ELECTRONIC_COMMERCE",
}

/** A Spend Control rule that allows or blocks certain `PanEntryMode` types during authorizations. */
export type PanEntryModeSpendRule = Node &
  SpendRule & {
    __typename?: "PanEntryModeSpendRule";
    /** The `PanEntryMode` types that will be allowed during authorizations. */
    allowed?: Maybe<Array<PanEntryMode>>;
    /** The `PanEntryMode` types that will result in declined authorizations. */
    blocked?: Maybe<Array<PanEntryMode>>;
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the `PanEntryModeSpendRule` in operations. */
    id: Scalars["ID"];
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/** A Spend Control rule that allows or blocks certain `PanEntryMode` types during authorizations. */
export type PanEntryModeSpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The result of applying a `PanEntryModeSpendRule` to an event. */
export type PanEntryModeSpendRuleResult = SpendRuleResult & {
  __typename?: "PanEntryModeSpendRuleResult";
  /** The attached level. */
  attachedLevel?: Maybe<AttachedLevel>;
  /** A message describing the result. */
  message?: Maybe<Scalars["String"]>;
  /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
  recommendation?: Maybe<SpendRuleRecommendation>;
  /** The spend rule attached at the time of the event. */
  spendRule?: Maybe<PanEntryModeSpendRule>;
  /** The tested `PanEntryMode` of the event. */
  valuesTested?: Maybe<Array<PanEntryMode>>;
};

/** Whether or not the `CardProduct` supports Partial funding configurations for unsecured credit product funding. */
export type PartialFundingCardProductFeature = CardProductFeature &
  ProductFeature & {
    __typename?: "PartialFundingCardProductFeature";
    /** The date and time, in ISO 8601 format, the feature was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Whether or not credit processor only functionality should be used. */
    creditProcessorOnlyEnabled?: Maybe<Scalars["Boolean"]>;
    /** The date and time, in ISO 8601 format, the feature was effective from. */
    effectiveFrom?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective through. */
    effectiveThrough?: Maybe<Scalars["String"]>;
    /** Whether or not the feature is enabled for the `CardProduct`. */
    enabled?: Maybe<Scalars["Boolean"]>;
    /** Whether or not Receivables Purchase Agreement functionality should be used. */
    receivablesPurchaseAgreementEnabled?: Maybe<Scalars["Boolean"]>;
    /** The date and time, in ISO 8601 format, the feature was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Whether or not the `FinancialAccount` supports partial funding. */
export type PartialFundingFinancialAccountFeature = FinancialAccountFeature & {
  __typename?: "PartialFundingFinancialAccountFeature";
  /** The date and time, in ISO 8601 format, the feature was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective from. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective through. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Whether or not the feature is enabled for the Financial Account. */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** The maximum aggregate credit distribution limit amount on the `PartialFundingFinancialAccountFeature` */
  maximumAggregateCreditDistributionAmount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, the feature was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The possible bank names. */
export enum PartnerBankName {
  /** The value representing Bancorp. */
  BANCORP = "BANCORP",
  /** The value representing BNY. */
  BNY = "BNY",
  /** The value representing Cass Bank. */
  CASS_BANK = "CASS_BANK",
  /** The value representing Celtic. */
  CELTIC = "CELTIC",
  /** The value representing CFSB. */
  CFSB = "CFSB",
  /** The value representing Cross River. */
  CROSS_RIVER = "CROSS_RIVER",
  /** The value representing FinWise Bank. */
  FINWISE_BANK = "FINWISE_BANK",
  /** The value representing Highnote. */
  HIGHNOTE = "HIGHNOTE",
  /** The value representing Sutton. */
  SUTTON = "SUTTON",
  /** The value representing Silicon Valley Bank. */
  SVB_BANK = "SVB_BANK",
  /** The value representing Transpecos Bank. */
  TRANSPECOS_BANK = "TRANSPECOS_BANK",
  /** The value representing Veritex Bank. */
  VERITEX_BANK = "VERITEX_BANK",
}

/** A representation of a passport identification document. */
export type PassportIdentificationDocument = {
  __typename?: "PassportIdentificationDocument";
  /** The three character country code of the issuing country. */
  countryCodeAlpha3: Scalars["String"];
  /** The passport expiration date. */
  expirationDate: Scalars["Date"];
  /** Whether the passport identification number has been previously saved. */
  identificationNumberPreviouslySaved?: Maybe<Scalars["Boolean"]>;
  /** The passport issue date. */
  issueDate: Scalars["Date"];
};

/** Payoff payment details. */
export type PayOffPaymentDetails = {
  __typename?: "PayOffPaymentDetails";
  /**
   * Pay off can be completed in how many estimated days.
   * @deprecated use estimatedPayOffPeriod instead
   */
  estimatedPayOffDays?: Maybe<Scalars["UnsignedInt"]>;
  /** Pay off can be completed in how many estimated years and / or months. */
  estimatedPayOffPeriod?: Maybe<Scalars["String"]>;
  /** Pay off estimated total amount. */
  estimatedTotal?: Maybe<Amount>;
  /** If you pay this amount each period, you will pay off your unpaid balance in estimatedPayOffPeriod. */
  periodPayment?: Maybe<Amount>;
};

/** The possible values for Payment Detail type of the Payoff warning associated with the statement */
export enum PayOffType {
  /** Estimated Total payment and time it takes with minimum payment amount of the statement. */
  MINIMUM_PAY_OFF = "MINIMUM_PAY_OFF",
  /** Estimated Total payment and minimum required to pay it within 3 years fix time. */
  THREE_YEAR_PAY_OFF = "THREE_YEAR_PAY_OFF",
}

export type PaymentAdvance = {
  /** The original amount of the Payroll Payment Advance. */
  advanceAmount?: Maybe<Amount>;
  /** The amount that should be deducted from the Payroll Payment Advance outstanding balance. */
  amountApplied?: Maybe<Amount>;
  /** The amount of the Payroll Payment Advance that has yet to be repaid. */
  amountBefore?: Maybe<Amount>;
  /** The balance amount due after `amountApplied` has been applied and deducted from the Payroll Payment Advance outstanding balance. */
  balanceAfter?: Maybe<Amount>;
  /** Global ID used to reference the Payroll Payment Advance. */
  id: Scalars["ID"];
  /** The status of Payroll Payment Advance. */
  paymentAdvanceStatus?: Maybe<PaymentAdvanceStatus>;
  /** Count of repayment attempts. */
  repaymentAttemptCount: Scalars["UnsignedInt"];
  /** Amount that will be written off from the Payroll Payment Advance outstanding balance. */
  writeOffAmount?: Maybe<Amount>;
  /** Will be set if the PaymentAdvanceStatus is of type `WRITTEN_OFF`, explains the reason for write off. Limit of 1024 characters. */
  writeOffReason?: Maybe<PaymentAdvanceWriteOffReason>;
};

/** The states of a Payment Advance. */
export enum PaymentAdvanceStatus {
  /** The full amount of the `PaymentAdvance` has been repaid. */
  FULLY_REPAID = "FULLY_REPAID",
  /** The full amount of the `PaymentAdvance` has not been repaid. */
  NOT_REPAID = "NOT_REPAID",
  /** A partial amount of the `PaymentAdvance` has been repaid. */
  PARTIALLY_REPAID = "PARTIALLY_REPAID",
  /** The `PaymentAdvance` line item is written off because repaymentAttemptCount has reached 3. */
  WRITTEN_OFF = "WRITTEN_OFF",
}

/** The reasons for writing off a payment advance. */
export enum PaymentAdvanceWriteOffReason {
  /** Payment Advance will be written off because repaymentAttemptCount has reached 3. */
  EXCEED_MAX_ATTEMPT_COUNT = "EXCEED_MAX_ATTEMPT_COUNT",
}

/** A Payment Card which can be used for card transactions. */
export type PaymentCard = Node & {
  __typename?: "PaymentCard";
  /**
   * The Card Product Application used to issue this Payment Card.
   * @deprecated Use `cardProductApplication` instead.
   */
  application?: Maybe<AccountHolderCardProductApplication>;
  /** Search ATM locations for the Payment Card. */
  atmLocations?: Maybe<AtmLocationsResult>;
  /** The realtime risk rules attached to this Payment Card. */
  attachedRealtimeRiskRules?: Maybe<RealtimeRiskRuleConnectionPayload>;
  /** The spend rules attached to this Payment Card. */
  attachedSpendRules?: Maybe<SpendRuleConnection>;
  /** The velocity rules attached to this Payment Card. */
  attachedVelocityRules?: Maybe<VelocityRuleConnection>;
  /** The Bank Identification Number of the Payment Card. Usually the first 6 digits of the primary account number (PAN). */
  bin?: Maybe<Scalars["String"]>;
  /** Paginated list of card digital wallet tokens associated to a card. */
  cardDigitalWalletTokens?: Maybe<CardDigitalWalletTokenConnection>;
  /** The UTC date on which the card was lost. e.g. 2026-01-01T23:59:59Z */
  cardLostDate?: Maybe<Scalars["String"]>;
  /** The Card Product associated to the Payment Card. */
  cardProduct?: Maybe<CardProduct>;
  /** The `CardProductApplication` used to issue this Payment Card. */
  cardProductApplication?: Maybe<CardProductApplication>;
  /** The `CardProfileSet` used to issue this `PaymentCard`. */
  cardProfileSet?: Maybe<CardProfileSet>;
  /** The customFields associated with this `PaymentCard`. */
  customFields?: Maybe<Array<CustomField>>;
  /** The exact date and time in UTC when the payment card expires. */
  expirationDate?: Maybe<Scalars["String"]>;
  /** The expiration month to display to the card holder. This value would be printed on the physical card. */
  expirationMonth?: Maybe<Scalars["String"]>;
  /** The expiration year to display to the card holder. This value would be printed on the physical card. */
  expirationYear?: Maybe<Scalars["String"]>;
  /** Externally provided ID (255 character limit) that is unique per organization and tenant. If not provided, Highnote will generate an ID (ten digit, Base58, all caps). */
  externalId?: Maybe<Scalars["String"]>;
  /** The external physical card orders for the Payment Card. */
  externalPhysicalPaymentCardOrders?: Maybe<
    Array<ExternalPhysicalPaymentCardOrder>
  >;
  /** The financial accounts backing this Payment Card. */
  financialAccounts?: Maybe<Array<FinancialAccount>>;
  /** Whether the card is `PHYSICAL` or `VIRTUAL` */
  formFactor?: Maybe<CardFormFactor>;
  /** Global ID used to reference the Payment Card in operations. */
  id: Scalars["ID"];
  /** The last four digits of the primary account number (PAN). */
  last4?: Maybe<Scalars["String"]>;
  /** The card network that issued the Payment Card. */
  network?: Maybe<PaymentCardNetwork>;
  /** The Payment card from which this card was reissued. */
  originalPaymentCard?: Maybe<PaymentCard>;
  /** The billing address for AVS, identity of payment card holder and the associated account details. */
  paymentCardHolderDetails?: Maybe<PaymentCardHolderDetails>;
  /** The physical card orders for the Payment Card. */
  physicalPaymentCardOrders?: Maybe<Array<Maybe<PhysicalPaymentCardOrder>>>;
  /** PIN details for this `PaymentCard`. */
  pinDetails?: Maybe<PaymentCardPinDetails>;
  /**
   * The decrypted values for this this card.
   *
   * **Note:** This is only available to users/organizations who have provided an AOC (attestation of compliance).
   */
  restrictedDetails?: Maybe<PaymentCardRestrictedDetailsResult>;
  /** A paginated list of snapshotted revisions made to this `PaymentCard`. */
  revisionSnapshots?: Maybe<PaymentCardSnapshotConnection>;
  /** The current status of the Payment Card. */
  status?: Maybe<PaymentCardStatus>;
  /** The suspension flags on the `PaymentCard`. */
  suspensionFlags?: Maybe<Array<PaymentCardSuspensionFlag>>;
  /** The Transaction Events that occurred on this Payment Card. */
  transactionEvents?: Maybe<TransactionEventConnection>;
  /** The `UserDefinedFields` associated with this `PaymentCard`. */
  userDefinedFields?: Maybe<UserDefinedFieldConnection>;
  /**
   * The balances of the VelocityRules that pertain to this `PaymentCard`
   * @deprecated Use velocitySpendRuleBalances instead
   */
  velocityRuleBalances?: Maybe<Array<Maybe<VelocityRuleBalance>>>;
  /** The balances of the VelocityRules that pertain to this `PaymentCard` */
  velocitySpendRuleBalances?: Maybe<Array<Maybe<VelocitySpendRuleBalance>>>;
};

/** A Payment Card which can be used for card transactions. */
export type PaymentCardAtmLocationsArgs = {
  atmFilter?: InputMaybe<AtmLocationFilterInput>;
  limit?: InputMaybe<Scalars["Int"]>;
  radius?: InputMaybe<AtmLocationRadiusInput>;
  viewport?: InputMaybe<AtmLocationViewportInput>;
};

/** A Payment Card which can be used for card transactions. */
export type PaymentCardAttachedRealtimeRiskRulesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A Payment Card which can be used for card transactions. */
export type PaymentCardAttachedSpendRulesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A Payment Card which can be used for card transactions. */
export type PaymentCardAttachedVelocityRulesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A Payment Card which can be used for card transactions. */
export type PaymentCardCardDigitalWalletTokensArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A Payment Card which can be used for card transactions. */
export type PaymentCardRevisionSnapshotsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A Payment Card which can be used for card transactions. */
export type PaymentCardTransactionEventsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<PaymentCardTransactionEventsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A Payment Card which can be used for card transactions. */
export type PaymentCardUserDefinedFieldsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<UserDefinedFieldsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The PaymentCardActivatedEvent is triggered when a Payment Card has been activated. */
export type PaymentCardActivatedEvent = Node &
  PaymentCardEvent & {
    __typename?: "PaymentCardActivatedEvent";
    /** The Bank Identification Number of the Payment Card. Usually the first 6 digits of the primary account number (PAN). */
    bin?: Maybe<Scalars["String"]>;
    /** The Card Product ID associated to the Payment Card. */
    cardProductId?: Maybe<Scalars["ID"]>;
    /** The exact date and time the payment card expires. */
    expirationDate?: Maybe<Scalars["String"]>;
    /** Whether the card is PHYSICAL or VIRTUAL */
    formFactor?: Maybe<CardFormFactor>;
    /** Global ID used to reference the Payment Card in operations. */
    id: Scalars["ID"];
    /** The last four digits of the primary account number (PAN). */
    last4?: Maybe<Scalars["String"]>;
    /** The card network that issued the Payment Card. */
    network?: Maybe<PaymentCardNetwork>;
    /** The authorized user of this `PaymentCard`. */
    paymentCardHolder?: Maybe<PaymentCardHolder>;
    /** The previous status of the Payment Card. */
    previousStatus?: Maybe<PaymentCardStatus>;
    /** The current status of the Payment Card. */
    status?: Maybe<PaymentCardStatus>;
    /** The date and time, in ISO 8601 format that the status of the Payment Card was updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** `PaymentCardAdjustmentEvent` indicates an adjustment has been made to a `Transaction`. */
export type PaymentCardAdjustmentEvent = Node &
  PaymentCardTransactionEvent & {
    __typename?: "PaymentCardAdjustmentEvent";
    /** ID of the account holder for the card account. */
    accountHolderId?: Maybe<Scalars["ID"]>;
    /** Not used for this `PaymentCardAdjustmentEvent`. */
    accountingDirection?: Maybe<AccountingDirection>;
    /** Network specific transaction data. */
    additionalNetworkData?: Maybe<AdditionalNetworkData>;
    /** The `Amount` approved for this `PaymentCardAdjustmentEvent` and posted in the settlement currency. Does not include fees. */
    approvedAmount?: Maybe<Amount>;
    /** Not used for this `PaymentCardAdjustmentEvent`. */
    avsResponseCode?: Maybe<AvsResponseCode>;
    /** ID of the payment card. */
    cardId?: Maybe<Scalars["ID"]>;
    /** The date and time, in ISO 8601 format, this `PaymentCardAdjustmentEvent` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** `Amount` available to spend after this transaction event. */
    currentFinancialAccountAvailableToSpendAmount?: Maybe<Amount>;
    /** Maximum balance allowed for the card account at the time of this transaction event. */
    currentFinancialAccountMaximumBalanceAmount?: Maybe<Amount>;
    /** Not used for this `PaymentCardAdjustmentEvent`. */
    cvvResponseCode?: Maybe<CvvResponseCode>;
    /** Not used for this `PaymentCardAdjustmentEvent`. */
    fees?: Maybe<Array<TransactionFee>>;
    /** ID of the financial account. */
    financialAccountId?: Maybe<Scalars["ID"]>;
    /** The ID of the transaction event. This `id` can be used to later retrieve details of this `PaymentCardAdjustmentEvent` or correlate it with other events on this `Transaction`. */
    id: Scalars["ID"];
    /** The details about the merchant who completed the transaction. */
    merchantDetails?: Maybe<MerchantDetails>;
    /** Not used for this `PaymentCardAdjustmentEvent`. */
    originalAmount?: Maybe<Amount>;
    /** A snapshot of the `PaymentCard` at the time of the `PaymentCardTransactionEvent`. */
    paymentCardSnapshot?: Maybe<PaymentCardSnapshot>;
    /** Not used for this `PaymentCardAdjustmentEvent`. */
    pinResponseCode?: Maybe<PinResponseCode>;
    /** The Point Of Service Details. */
    pointOfServiceDetails?: Maybe<PointOfServiceDetails>;
    /** Not used for this `PaymentCardAdjustmentEvent`. */
    postalCodeResponseCode?: Maybe<PostalCodeResponseCode>;
    /** Not used for this `PaymentCardAdjustmentEvent`. */
    requestedAmount?: Maybe<Amount>;
    /** The Highnote response code. */
    responseCode?: Maybe<TransactionEventResponseCode>;
    /** ID of the transaction. */
    transactionId?: Maybe<Scalars["ID"]>;
    /** Represents the customer transaction type being processed. */
    transactionProcessingType?: Maybe<CardTransactionProcessingType>;
  };

/** PaymentCardAuthorizationAndClearApprovedEvent indicates that a PaymentCard Transaction Authorization and Clear has been approved. */
export type PaymentCardAuthorizationAndClearApprovedEvent = Node &
  PaymentCardTransactionEvent & {
    __typename?: "PaymentCardAuthorizationAndClearApprovedEvent";
    /** ID of the account holder for the card account. */
    accountHolderId?: Maybe<Scalars["ID"]>;
    /**
     * The direction funds are moving in the perspective of the cardholder.
     *
     * * when DEBIT, funds are moving out of the cardholder's account
     * * when CREDIT, funds are moving into the cardholder's account
     */
    accountingDirection?: Maybe<AccountingDirection>;
    /** Network specific transaction data. */
    additionalNetworkData?: Maybe<AdditionalNetworkData>;
    /** Determines whether this event is an advice. */
    advice?: Maybe<Scalars["Boolean"]>;
    /** Details if event is an advice. */
    adviceDetail?: Maybe<AdviceDetail>;
    /** The `Amount` approved for this `PaymentCardAuthorizationAndClearApprovedEvent` and posted in the settlement currency. Does not include fees. */
    approvedAmount?: Maybe<Amount>;
    /** Code representing the result of AVS address verification. */
    avsResponseCode?: Maybe<AvsResponseCode>;
    /** ID of the payment card. */
    cardId?: Maybe<Scalars["ID"]>;
    /** The date and time, in ISO 8601 format, this `PaymentCardAuthorizationAndClearApprovedEvent` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** `Amount` available to spend after this transaction event. */
    currentFinancialAccountAvailableToSpendAmount?: Maybe<Amount>;
    /** Maximum balance allowed for the card account at the time of this transaction event. */
    currentFinancialAccountMaximumBalanceAmount?: Maybe<Amount>;
    /** Code representing the result of CVV (security code) verification. */
    cvvResponseCode?: Maybe<CvvResponseCode>;
    /** Fees applied to the transaction, if any. */
    fees?: Maybe<Array<TransactionFee>>;
    /** ID of the financial account. */
    financialAccountId?: Maybe<Scalars["ID"]>;
    /** The ID of the transaction event. This `id` can be used to later retrieve details of this `PaymentCardAuthorizationAndClearApprovedEvent` or correlate it with other events on this `Transaction`. */
    id: Scalars["ID"];
    /** The details about the merchant who requested the authorization and clear. */
    merchantDetails?: Maybe<MerchantDetails>;
    /** The original `Amount` of this `PaymentCardAuthorizationAndClearApprovedEvent`. */
    originalAmount?: Maybe<Amount>;
    /** Determines whether this authorization and clear was approved for partial or full amount. */
    partial?: Maybe<Scalars["Boolean"]>;
    /** A snapshot of the `PaymentCard` at the time of the `PaymentCardTransactionEvent`. */
    paymentCardSnapshot?: Maybe<PaymentCardSnapshot>;
    /** Code representing the result of PIN verification. */
    pinResponseCode?: Maybe<PinResponseCode>;
    /** The Point Of Service Details. */
    pointOfServiceDetails?: Maybe<PointOfServiceDetails>;
    /** Code representing the result of AVS postal code verification. */
    postalCodeResponseCode?: Maybe<PostalCodeResponseCode>;
    /** The `Amount` requested to be approved for this `PaymentCardAuthorizationAndClearApprovedEvent` and displayed in the transaction's (local) currency. Does not include fees. */
    requestedAmount?: Maybe<Amount>;
    /** The Highnote response code. */
    responseCode?: Maybe<TransactionEventResponseCode>;
    /** ID of the transaction. */
    transactionId?: Maybe<Scalars["ID"]>;
    /** Represents the customer transaction type being processed. */
    transactionProcessingType?: Maybe<CardTransactionProcessingType>;
  };

/** PaymentCardAuthorizationAndClearDeclinedEvent indicates that a PaymentCard Transaction Authorization and Clear has been declined. */
export type PaymentCardAuthorizationAndClearDeclinedEvent = Node &
  PaymentCardTransactionEvent & {
    __typename?: "PaymentCardAuthorizationAndClearDeclinedEvent";
    /** ID of the account holder for the card account. */
    accountHolderId?: Maybe<Scalars["ID"]>;
    /**
     * The direction funds are moving in the perspective of the cardholder.
     *
     * * when DEBIT, funds are moving out of the cardholder's account
     * * when CREDIT, funds are moving into the cardholder's account
     */
    accountingDirection?: Maybe<AccountingDirection>;
    /** Network specific transaction data. */
    additionalNetworkData?: Maybe<AdditionalNetworkData>;
    /** The `Amount` approved for this `PaymentCardAuthorizationAndClearDeclinedEvent` and posted in the settlement currency. Does not include fees. */
    approvedAmount?: Maybe<Amount>;
    /** Code representing the result of AVS address verification. */
    avsResponseCode?: Maybe<AvsResponseCode>;
    /** ID of the payment card. */
    cardId?: Maybe<Scalars["ID"]>;
    /** The date and time, in ISO 8601 format, this `PaymentCardAuthorizationAndClearDeclinedEvent` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** `Amount` available to spend after this transaction event. */
    currentFinancialAccountAvailableToSpendAmount?: Maybe<Amount>;
    /** Maximum balance allowed for the card account at the time of this transaction event. */
    currentFinancialAccountMaximumBalanceAmount?: Maybe<Amount>;
    /** Code representing the result of CVV (security code) verification. */
    cvvResponseCode?: Maybe<CvvResponseCode>;
    /** Fees applied to the transaction, if any. */
    fees?: Maybe<Array<TransactionFee>>;
    /** ID of the financial account. */
    financialAccountId?: Maybe<Scalars["ID"]>;
    /** The ID of the transaction event. This `id` can be used to later retrieve details of this `PaymentCardAuthorizationAndClearDeclinedEvent` or correlate it with other events on this `Transaction`. */
    id: Scalars["ID"];
    /** The details about the merchant who requested the authorization and clear. */
    merchantDetails?: Maybe<MerchantDetails>;
    /** The original `Amount` of this `PaymentCardAuthorizationAndClearDeclinedEvent`. */
    originalAmount?: Maybe<Amount>;
    /** A snapshot of the `PaymentCard` at the time of the `PaymentCardTransactionEvent`. */
    paymentCardSnapshot?: Maybe<PaymentCardSnapshot>;
    /** Code representing the result of PIN verification. */
    pinResponseCode?: Maybe<PinResponseCode>;
    /** The Point Of Service Details. */
    pointOfServiceDetails?: Maybe<PointOfServiceDetails>;
    /** Code representing the result of AVS postal code verification. */
    postalCodeResponseCode?: Maybe<PostalCodeResponseCode>;
    /** The `Amount` requested to be approved for this `PaymentCardAuthorizationAndClearDeclinedEvent` and displayed in the transaction's (local) currency. Does not include fees. */
    requestedAmount?: Maybe<Amount>;
    /** The Highnote response code. */
    responseCode?: Maybe<TransactionEventResponseCode>;
    /** ID of the transaction. */
    transactionId?: Maybe<Scalars["ID"]>;
    /** Represents the customer transaction type being processed. */
    transactionProcessingType?: Maybe<CardTransactionProcessingType>;
  };

/** PaymentCardAuthorizationApprovedEvent indicates if a Payment Card Transaction Authorization has been approved. */
export type PaymentCardAuthorizationApprovedEvent = Node &
  PaymentCardTransactionEvent & {
    __typename?: "PaymentCardAuthorizationApprovedEvent";
    /** ID of the account holder for the card account. */
    accountHolderId?: Maybe<Scalars["ID"]>;
    /**
     * The direction funds are moving in the perspective of the cardholder.
     *
     * * when DEBIT, funds are moving out of the cardholder's account
     * * when CREDIT, funds are moving into the cardholder's account
     */
    accountingDirection?: Maybe<AccountingDirection>;
    /** Network specific transaction data. */
    additionalNetworkData?: Maybe<AdditionalNetworkData>;
    /** Determines whether this event is an advice. */
    advice?: Maybe<Scalars["Boolean"]>;
    /** Details if event is an advice. */
    adviceDetail?: Maybe<AdviceDetail>;
    /** The `Amount` approved for this `PaymentCardAuthorizationApprovedEvent` and posted in the settlement currency. Does not include fees. */
    approvedAmount?: Maybe<Amount>;
    /** Code representing the result of AVS address verification. */
    avsResponseCode?: Maybe<AvsResponseCode>;
    /** ID of the payment card. */
    cardId?: Maybe<Scalars["ID"]>;
    /** The date and time, in ISO 8601 format, this `PaymentCardAuthorizationApprovedEvent` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** `Amount` available to spend after this transaction event. */
    currentFinancialAccountAvailableToSpendAmount?: Maybe<Amount>;
    /** Maximum balance allowed for the card account at the time of this transaction event. */
    currentFinancialAccountMaximumBalanceAmount?: Maybe<Amount>;
    /** Code representing the result of CVV (security code) verification. */
    cvvResponseCode?: Maybe<CvvResponseCode>;
    /** Fees applied to the transaction, if any. */
    fees?: Maybe<Array<TransactionFee>>;
    /** ID of the financial account. */
    financialAccountId?: Maybe<Scalars["ID"]>;
    /** The ID of the transaction event. This `id` can be used to later retrieve details of this `PaymentCardAuthorizationApprovedEvent` or correlate it with other events on this `Transaction`. */
    id: Scalars["ID"];
    /** The details about the merchant who requested the authorization. */
    merchantDetails?: Maybe<MerchantDetails>;
    /** The original `Amount` of this `PaymentCardAuthorizationApprovedEvent`. */
    originalAmount?: Maybe<Amount>;
    /** Determines whether this authorization was approved for partial or full amount. */
    partial?: Maybe<Scalars["Boolean"]>;
    /** A snapshot of the `PaymentCard` at the time of the `PaymentCardTransactionEvent`. */
    paymentCardSnapshot?: Maybe<PaymentCardSnapshot>;
    /** Code representing the result of PIN verification. */
    pinResponseCode?: Maybe<PinResponseCode>;
    /** The Point Of Service Details. */
    pointOfServiceDetails?: Maybe<PointOfServiceDetails>;
    /** Code representing the result of AVS postal code verification. */
    postalCodeResponseCode?: Maybe<PostalCodeResponseCode>;
    /** The `Amount` requested to be approved for this `PaymentCardAuthorizationApprovedEvent` and displayed in the transaction's (local) currency. Does not include fees. */
    requestedAmount?: Maybe<Amount>;
    /** The Highnote response code. */
    responseCode?: Maybe<TransactionEventResponseCode>;
    /** ID of the transaction. */
    transactionId?: Maybe<Scalars["ID"]>;
    /** Represents the customer transaction type being processed. */
    transactionProcessingType?: Maybe<CardTransactionProcessingType>;
  };

/** PaymentCardAuthorizationCreatedEvent indicates if a Payment Card Transaction Authorization has been created. */
export type PaymentCardAuthorizationCreatedEvent = Node &
  PaymentCardTransactionEvent & {
    __typename?: "PaymentCardAuthorizationCreatedEvent";
    /**
     * ID of the account holder for the card account
     * @deprecated `PaymentCardAuthorizationCreatedEvent` is no longer supported
     */
    accountHolderId?: Maybe<Scalars["ID"]>;
    /**
     * The direction funds are moving in the perspective of the cardholder.
     *
     * * when DEBIT, funds are moving out of the cardholder's account
     * * when CREDIT, funds are moving into the cardholder's account
     * @deprecated `PaymentCardAuthorizationCreatedEvent` is no longer supported
     */
    accountingDirection?: Maybe<AccountingDirection>;
    /**
     * Network specific transaction data.
     * @deprecated `PaymentCardAuthorizationCreatedEvent` is no longer supported
     */
    additionalNetworkData?: Maybe<AdditionalNetworkData>;
    /**
     * The `Amount` approved for this `PaymentCardAuthorizationCreatedEvent` and posted in the settlement currency. Does not include fees.
     * @deprecated `PaymentCardAuthorizationCreatedEvent` is no longer supported
     */
    approvedAmount?: Maybe<Amount>;
    /**
     * Code representing the result of AVS address verification.
     * @deprecated `PaymentCardAuthorizationCreatedEvent` is no longer supported
     */
    avsResponseCode?: Maybe<AvsResponseCode>;
    /**
     * ID of the payment card.
     * @deprecated `PaymentCardAuthorizationCreatedEvent` is no longer supported
     */
    cardId?: Maybe<Scalars["ID"]>;
    /**
     * The date and time, in ISO 8601 format, this `PaymentCardAuthorizationCreatedEvent` was created.
     * @deprecated `PaymentCardAuthorizationCreatedEvent` is no longer supported
     */
    createdAt?: Maybe<Scalars["String"]>;
    /**
     * The `Amount` available to spend after this transaction event.
     * @deprecated `PaymentCardAuthorizationCreatedEvent` is no longer supported
     */
    currentFinancialAccountAvailableToSpendAmount?: Maybe<Amount>;
    /**
     * Maximum balance allowed for the card account at the time of this transaction event
     * @deprecated `PaymentCardAuthorizationCreatedEvent` is no longer supported
     */
    currentFinancialAccountMaximumBalanceAmount?: Maybe<Amount>;
    /**
     * Code representing the result of CVV (security code) verification.
     * @deprecated `PaymentCardAuthorizationCreatedEvent` is no longer supported
     */
    cvvResponseCode?: Maybe<CvvResponseCode>;
    /**
     * Fees applied to the transaction, if any.
     * @deprecated `PaymentCardAuthorizationCreatedEvent` is no longer supported
     */
    fees?: Maybe<Array<TransactionFee>>;
    /**
     * ID of the financial account.
     * @deprecated `PaymentCardAuthorizationCreatedEvent` is no longer supported
     */
    financialAccountId?: Maybe<Scalars["ID"]>;
    /**
     * The ID of the transaction event. This `id` can be used to later retrieve details of this `PaymentCardAuthorizationCreatedEvent` or correlate it with other events on this `Transaction`.
     * @deprecated `PaymentCardAuthorizationCreatedEvent` is no longer supported
     */
    id: Scalars["ID"];
    /**
     * The details about the merchant who requested the authorization.
     * @deprecated `PaymentCardAuthorizationCreatedEvent` is no longer supported
     */
    merchantDetails?: Maybe<MerchantDetails>;
    /**
     * The original `Amount` of this `PaymentCardAuthorizationCreatedEvent`.
     * @deprecated `PaymentCardAuthorizationCreatedEvent` is no longer supported
     */
    originalAmount?: Maybe<Amount>;
    /**
     * A snapshot of the `PaymentCard` at the time of the `PaymentCardTransactionEvent`.
     * @deprecated `PaymentCardAuthorizationCreatedEvent` is no longer supported
     */
    paymentCardSnapshot?: Maybe<PaymentCardSnapshot>;
    /**
     * Code representing the result of PIN verification.
     * @deprecated `PaymentCardAuthorizationCreatedEvent` is no longer supported
     */
    pinResponseCode?: Maybe<PinResponseCode>;
    /**
     * The Point Of Service Details.
     * @deprecated `PaymentCardAuthorizationCreatedEvent` is no longer supported
     */
    pointOfServiceDetails?: Maybe<PointOfServiceDetails>;
    /**
     * Code representing the result of AVS postal code verification.
     * @deprecated `PaymentCardAuthorizationCreatedEvent` is no longer supported
     */
    postalCodeResponseCode?: Maybe<PostalCodeResponseCode>;
    /**
     * The `Amount` requested to be approved for this `PaymentCardAuthorizationCreatedEvent` and displayed in the transaction's (local) currency. Does not include fees.
     * @deprecated `PaymentCardAuthorizationCreatedEvent` is no longer supported
     */
    requestedAmount?: Maybe<Amount>;
    /**
     * The Highnote response code.
     * @deprecated `PaymentCardAuthorizationCreatedEvent` is no longer supported
     */
    responseCode?: Maybe<TransactionEventResponseCode>;
    /**
     * ID of the transaction
     * @deprecated `PaymentCardAuthorizationCreatedEvent` is no longer supported
     */
    transactionId?: Maybe<Scalars["ID"]>;
    /**
     * Represents the customer transaction type being processed.
     * @deprecated `PaymentCardAuthorizationCreatedEvent` is no longer supported
     */
    transactionProcessingType?: Maybe<CardTransactionProcessingType>;
  };

/** PaymentCardAuthorizationDeclinedEvent indicates if a Payment Card Transaction Authorization has been declined. */
export type PaymentCardAuthorizationDeclinedEvent = Node &
  PaymentCardTransactionEvent & {
    __typename?: "PaymentCardAuthorizationDeclinedEvent";
    /** ID of the account holder for the card account. */
    accountHolderId?: Maybe<Scalars["ID"]>;
    /**
     * The direction funds are moving in the perspective of the cardholder.
     *
     * * when DEBIT, funds are moving out of the cardholder's account
     * * when CREDIT, funds are moving into the cardholder's account
     */
    accountingDirection?: Maybe<AccountingDirection>;
    /** Network specific transaction data. */
    additionalNetworkData?: Maybe<AdditionalNetworkData>;
    /** The `Amount` approved for this `PaymentCardAuthorizationDeclinedEvent` and posted in the settlement currency. Does not include fees. */
    approvedAmount?: Maybe<Amount>;
    /** Code representing the result of AVS address verification. */
    avsResponseCode?: Maybe<AvsResponseCode>;
    /** ID of the payment card. */
    cardId?: Maybe<Scalars["ID"]>;
    /** The date and time, in ISO 8601 format, this `PaymentCardAuthorizationDeclinedEvent` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** `Amount` available to spend after this transaction event. */
    currentFinancialAccountAvailableToSpendAmount?: Maybe<Amount>;
    /** Maximum balance allowed for the card account at the time of this transaction event. */
    currentFinancialAccountMaximumBalanceAmount?: Maybe<Amount>;
    /** Code representing the result of CVV (security code) verification. */
    cvvResponseCode?: Maybe<CvvResponseCode>;
    /** Fees applied to the transaction, if any. */
    fees?: Maybe<Array<TransactionFee>>;
    /** ID of the financial account. */
    financialAccountId?: Maybe<Scalars["ID"]>;
    /** The ID of the transaction event. This `id` can be used to later retrieve details of this `PaymentCardAuthorizationDeclinedEvent` or correlate it with other events on this `Transaction`. */
    id: Scalars["ID"];
    /** The details about the merchant who requested the authorization. */
    merchantDetails?: Maybe<MerchantDetails>;
    /** The original `Amount` of this `PaymentCardAuthorizationDeclinedEvent`. */
    originalAmount?: Maybe<Amount>;
    /** A snapshot of the `PaymentCard` at the time of the `PaymentCardTransactionEvent`. */
    paymentCardSnapshot?: Maybe<PaymentCardSnapshot>;
    /** Code representing the result of PIN verification. */
    pinResponseCode?: Maybe<PinResponseCode>;
    /** The Point Of Service Details. */
    pointOfServiceDetails?: Maybe<PointOfServiceDetails>;
    /** Code representing the result of AVS postal code verification. */
    postalCodeResponseCode?: Maybe<PostalCodeResponseCode>;
    /** The `Amount` requested to be approved for this `PaymentCardAuthorizationDeclinedEvent` and displayed in the transaction's (local) currency. Does not include fees. */
    requestedAmount?: Maybe<Amount>;
    /** The Highnote response code. */
    responseCode?: Maybe<TransactionEventResponseCode>;
    /** ID of the transaction. */
    transactionId?: Maybe<Scalars["ID"]>;
    /** Represents the customer transaction type being processed. */
    transactionProcessingType?: Maybe<CardTransactionProcessingType>;
  };

/** PaymentCardAuthorizationReversedEvent indicates that a PaymentCard Transaction Reversal has occurred. */
export type PaymentCardAuthorizationReversedEvent = Node &
  PaymentCardTransactionEvent & {
    __typename?: "PaymentCardAuthorizationReversedEvent";
    /** ID of the account holder for the card account. */
    accountHolderId?: Maybe<Scalars["ID"]>;
    /**
     * The direction funds are moving in the perspective of the cardholder.
     *
     * * when DEBIT, funds are moving out of the cardholder's account
     * * when CREDIT, funds are moving into the cardholder's account
     */
    accountingDirection?: Maybe<AccountingDirection>;
    /** Network specific transaction data. */
    additionalNetworkData?: Maybe<AdditionalNetworkData>;
    /** Determines whether this event is an advice. */
    advice?: Maybe<Scalars["Boolean"]>;
    /** Details if event is an advice. */
    adviceDetail?: Maybe<AdviceDetail>;
    /** The `Amount` approved for this `PaymentCardAuthorizationReversedEvent` and posted in the settlement currency. Does not include fees. */
    approvedAmount?: Maybe<Amount>;
    /** Code representing the result of AVS address verification. */
    avsResponseCode?: Maybe<AvsResponseCode>;
    /** ID of the payment card. */
    cardId?: Maybe<Scalars["ID"]>;
    /** The date and time, in ISO 8601 format, this `PaymentCardAuthorizationReversedEvent` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** `Amount` available to spend after this transaction event. */
    currentFinancialAccountAvailableToSpendAmount?: Maybe<Amount>;
    /** Maximum balance allowed for the card account at the time of this transaction event. */
    currentFinancialAccountMaximumBalanceAmount?: Maybe<Amount>;
    /** Code representing the result of CVV (security code) verification. */
    cvvResponseCode?: Maybe<CvvResponseCode>;
    /** Fees applied to the transaction, if any. */
    fees?: Maybe<Array<TransactionFee>>;
    /** ID of the financial account. */
    financialAccountId?: Maybe<Scalars["ID"]>;
    /** The ID of the transaction event. This `id` can be used to later retrieve details of this `PaymentCardAuthorizationReversedEvent` or correlate it with other events on this `Transaction`. */
    id: Scalars["ID"];
    /** Determines whether this is an issuer initiated reversal for an expired authorization. */
    issuerExpiredAuthorization?: Maybe<Scalars["Boolean"]>;
    /** The details about the merchant who requested the authorization. */
    merchantDetails?: Maybe<MerchantDetails>;
    /** The original `Amount` of this `PaymentCardAuthorizationReversedEvent`. */
    originalAmount?: Maybe<Amount>;
    /** Determines whether this is a partial or full reversal for an authorization. */
    partial?: Maybe<Scalars["Boolean"]>;
    /** A snapshot of the `PaymentCard` at the time of the `PaymentCardTransactionEvent`. */
    paymentCardSnapshot?: Maybe<PaymentCardSnapshot>;
    /** Code representing the result of PIN verification. */
    pinResponseCode?: Maybe<PinResponseCode>;
    /** The Point Of Service Details. */
    pointOfServiceDetails?: Maybe<PointOfServiceDetails>;
    /** Code representing the result of AVS postal code verification. */
    postalCodeResponseCode?: Maybe<PostalCodeResponseCode>;
    /** The `Amount` requested to be reversed for this `PaymentCardAuthorizationReversedEvent` and displayed in the transaction's (local) currency. Does not include fees. */
    requestedAmount?: Maybe<Amount>;
    /** The Highnote response code. */
    responseCode?: Maybe<TransactionEventResponseCode>;
    /** ID of the transaction. */
    transactionId?: Maybe<Scalars["ID"]>;
    /** Represents the customer transaction type being processed. */
    transactionProcessingType?: Maybe<CardTransactionProcessingType>;
  };

/** Possible Payment Card Bin classification. */
export enum PaymentCardBinClassification {
  /** Business bin. */
  BUSINESS = "BUSINESS",
  /** Commercial bin. */
  COMMERCIAL = "COMMERCIAL",
  /** Consumer bin. */
  CONSUMER = "CONSUMER",
  /** Fleet bin. */
  FLEET = "FLEET",
  /** Government bin. */
  GOVERNMENT = "GOVERNMENT",
}

/** Possible Payment Card Bin funding model. */
export enum PaymentCardBinFundingModel {
  /** Credit funding model. */
  CREDIT = "CREDIT",
  /** Debit funding model. */
  DEBIT = "DEBIT",
  /** Prepaid funding model. */
  PREPAID = "PREPAID",
}

/** Possible Payment Card Bin Product Codes. */
export enum PaymentCardBinProductCode {
  /** Mastercard Corporate Fleet Card. */
  MASTERCARD_MCF = "MASTERCARD_MCF",
  /** Mastercard Corporate Card. */
  MASTERCARD_MCO = "MASTERCARD_MCO",
  /** Debit Mastercard BusinessCard Card. */
  MASTERCARD_MDB = "MASTERCARD_MDB",
  /** Debit Mastercard BusinessCard Card. */
  MASTERCARD_MDJ = "MASTERCARD_MDJ",
  /** Prepaid Mastercard Payroll Card. */
  MASTERCARD_MPA = "MASTERCARD_MPA",
  /** Prepaid Mastercard General Spend Card. */
  MASTERCARD_MPG = "MASTERCARD_MPG",
  /** Mastercard Platinum. */
  MASTERCARD_MPL = "MASTERCARD_MPL",
  /** Prepaid Mastercard Consumer Incentive Card. */
  MASTERCARD_MPM = "MASTERCARD_MPM",
  /** Prepaid Mastercard Workplace B2B Solutions. */
  MASTERCARD_MPW = "MASTERCARD_MPW",
  /** Mastercard Humanitarian Prepaid. */
  MASTERCARD_MWF = "MASTERCARD_MWF",
  /** Visa Traditional. */
  VISA_A = "VISA_A",
  /** Visa Rewards. */
  VISA_B = "VISA_B",
  /** Visa Signature. */
  VISA_C = "VISA_C",
  /** Visa Classic */
  VISA_F = "VISA_F",
  /** Visa Business. */
  VISA_G = "VISA_G",
  /** Visa Signature Business. */
  VISA_G1 = "VISA_G1",
  /** Visa Infinite Business. */
  VISA_G4 = "VISA_G4",
  /** Visa Infinite. */
  VISA_I = "VISA_I",
  /** Visa Healthcare. */
  VISA_J3 = "VISA_J3",
  /** Visa Corporate T&E. */
  VISA_K = "VISA_K",
  /** Visa Government Corporate T&E. */
  VISA_K1 = "VISA_K1",
  /** Visa Private Label. */
  VISA_Q = "VISA_Q",
  /** Visa Private Label Basic. */
  VISA_Q2 = "VISA_Q2",
  /** Visa Private Label Standard. */
  VISA_Q3 = "VISA_Q3",
  /** Visa Private Label Enhanced. */
  VISA_Q4 = "VISA_Q4",
  /** Visa Private Label Specialized. */
  VISA_Q5 = "VISA_Q5",
  /** Visa Private Label Premium. */
  VISA_Q6 = "VISA_Q6",
  /** Visa Proprietary. */
  VISA_R = "VISA_R",
  /** Visa Purchasing. */
  VISA_S = "VISA_S",
  /** Visa Purchasing with Fleet. */
  VISA_S1 = "VISA_S1",
  /** Visa Government Purchasing. */
  VISA_S2 = "VISA_S2",
  /** Visa B2B Virtual Payments. */
  VISA_X = "VISA_X",
}

/** Payment Card Bin Range details. */
export type PaymentCardBinRange = Node & {
  __typename?: "PaymentCardBinRange";
  /** The indicator whether the bin is active at network */
  activeAtNetwork?: Maybe<Scalars["Boolean"]>;
  /** The indicator whether the bin is active on the platform */
  activeAtPlatform?: Maybe<Scalars["Boolean"]>;
  /** The payment card bin classification. */
  binClassification?: Maybe<PaymentCardBinClassification>;
  /** The payment card bin funding model. */
  binFundingModel?: Maybe<PaymentCardBinFundingModel>;
  /** The bin length. */
  binLength?: Maybe<Scalars["UnsignedInt"]>;
  /** The configured paymet card bin product code. */
  binProductCode?: Maybe<PaymentCardBinProductCode>;
  /** The configured payment card bin sub product code. */
  binSubProductCode?: Maybe<PaymentCardBinSubProductCode>;
  /** The date and time, in ISO 8601 format, the date this `BinRange` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /**
   * Three-character [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217) currency code
   *
   * **Examples:** `"USD", "EUR", "GBP"`
   */
  currencyCodes?: Maybe<Array<Scalars["String"]>>;
  /** The date and time, in ISO 8601 format, the date (inclusive) this `BinRange` is effective from. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the date (inclusive) this `BinRange` stops being in effect. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** The configured payment card EMV type. */
  emvType?: Maybe<PaymentCardEmvType>;
  /** The first digits of the bin based on the defined bin length. */
  firstDigitsOfBin?: Maybe<Scalars["String"]>;
  /** The ID of the `BinRange`. */
  id: Scalars["ID"];
  /** The date and time, in ISO 8601 format, the date this `PaymentCardBinRange` was live at network. */
  liveAtNetworkFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the date this `PaymentCardBinRange` was live at platform. */
  liveAtPlatformFrom?: Maybe<Scalars["String"]>;
  /** The configured card brand. */
  paymentCardBrand?: Maybe<PaymentCardBrand>;
  /**
   * The product name.
   *
   * **Examples:** `"Corporate T&E Prepaid", "Debit Mastercard BusinessCard Card", "Fleet with Purchasing"`
   */
  productName?: Maybe<Scalars["String"]>;
  /** The reload indicator for the bin. */
  reloadable?: Maybe<Scalars["Boolean"]>;
  /** Allowed secondary atm networks. */
  secondaryAtmNetworks?: Maybe<Array<SecondaryAtmNetwork>>;
  /** Allowed secondary point of sale networks */
  secondaryPointOfSaleNetworks?: Maybe<Array<SecondaryPointOfSaleNetwork>>;
  /** Allowed Secondary surcharge free atm networks */
  secondarySurchargeFreeAtmNetworks?: Maybe<
    Array<SecondarySurchargeFreeAtmNetwork>
  >;
  /** The date and time, in ISO 8601 format, the date this `BinRange` was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Possible Payment Card Bin Sub Product Codes. */
export enum PaymentCardBinSubProductCode {
  /** Visa Youth/College. */
  VISA_BX = "VISA_BX",
  /** Visa Cross Border Remittance. */
  VISA_CB = "VISA_CB",
  /** Visa Healthcare - FSA/HRA. */
  VISA_FS = "VISA_FS",
  /** Visa Cosumer Gift. */
  VISA_GI = "VISA_GI",
  /** Visa General Purpose. */
  VISA_GP = "VISA_GP",
  /** Visa Government Disbursement. */
  VISA_GV = "VISA_GV",
  /** Visa Employee Benefits. */
  VISA_HS = "VISA_HS",
  /** Visa Corporate Disbursement. */
  VISA_IC = "VISA_IC",
  /** Visa Insurance. */
  VISA_IP = "VISA_IP",
  /** Visa Multi-Currency Solution. */
  VISA_MS = "VISA_MS",
  /** Visa Other. */
  VISA_OT = "VISA_OT",
  /** Visa Payroll/Salary. */
  VISA_PP = "VISA_PP",
  /** Visa Campus/University. */
  VISA_ST = "VISA_ST",
  /** Visa Travel/Visa Travel Money. */
  VISA_TP = "VISA_TP",
}

/** Possible Payment Card Brand types */
export enum PaymentCardBrand {
  /** American Express card brand. */
  AMERICAN_EXPRESS = "AMERICAN_EXPRESS",
  /** Dankort card brand. */
  DANKORT = "DANKORT",
  /** Diners card brand. */
  DINERS = "DINERS",
  /** Discover card brand. */
  DISCOVER = "DISCOVER",
  /** Electron card brand. */
  ELECTRON = "ELECTRON",
  /** JCB card brand. */
  JCB = "JCB",
  /** Maestro card brand. */
  MAESTRO = "MAESTRO",
  /** Mastercard card brand. */
  MASTERCARD = "MASTERCARD",
  /** Payment card brand. */
  PAYMENT = "PAYMENT",
  /** Union Pay card brand. */
  UNION_PAY = "UNION_PAY",
  /** Visa card brand. */
  VISA = "VISA",
}

/** The credit status of the chargeback. */
export enum PaymentCardChargebackCreditStatus {
  /** A chargeback credit has not been issued. */
  CREDIT_NOT_ISSUED = "CREDIT_NOT_ISSUED",
  /** The chargeback credit has been partially awarded following the partial win of the chargeback. */
  CREDIT_PARTIALLY_WON = "CREDIT_PARTIALLY_WON",
  /** The chargeback credit is pending partial award following the partial win of the chargeback. */
  CREDIT_PENDING_PARTIAL_WIN = "CREDIT_PENDING_PARTIAL_WIN",
  /** The chargeback credit is pending award following the win of the chargeback. */
  CREDIT_PENDING_WIN = "CREDIT_PENDING_WIN",
  /** The chargeback credit has been awarded following the win of the chargeback. */
  CREDIT_WON = "CREDIT_WON",
  /** The Provisional Credit for the chargeback has been issued. */
  PROVISIONAL_CREDIT_ISSUED = "PROVISIONAL_CREDIT_ISSUED",
  /** The Provisional Credit for the chargeback has been partially awarded following the partial win of the chargeback. */
  PROVISIONAL_CREDIT_PARTIALLY_WON = "PROVISIONAL_CREDIT_PARTIALLY_WON",
  /** The chargeback provisional credit is pending issued. */
  PROVISIONAL_CREDIT_PENDING_ISSUE = "PROVISIONAL_CREDIT_PENDING_ISSUE",
  /** The Provisional Credit for the chargeback is pending partial award following the partial win of the chargeback. */
  PROVISIONAL_CREDIT_PENDING_PARTIAL_WIN = "PROVISIONAL_CREDIT_PENDING_PARTIAL_WIN",
  /** The Provisional Credit for the chargeback is pending revocation following the loss of the chargeback. */
  PROVISIONAL_CREDIT_PENDING_REVOCATION = "PROVISIONAL_CREDIT_PENDING_REVOCATION",
  /** The Provisional Credit for the chargeback is pending award following the win of the chargeback. */
  PROVISIONAL_CREDIT_PENDING_WIN = "PROVISIONAL_CREDIT_PENDING_WIN",
  /** The Provisional Credit for the chargeback has been revoked following the loss of the chargeback. */
  PROVISIONAL_CREDIT_REVOKED = "PROVISIONAL_CREDIT_REVOKED",
  /** The Provisional Credit for the chargeback has been awarded following the win of the chargeback. */
  PROVISIONAL_CREDIT_WON = "PROVISIONAL_CREDIT_WON",
}

/** The external network reason code of the chargeback. */
export enum PaymentCardChargebackNetworkReasonCode {
  /** The issuing bank can’t find an account with the number used. */
  ACCOUNT_NUMBER_NOT_ON_FILE = "ACCOUNT_NUMBER_NOT_ON_FILE",
  /** A Cardholder Dispute for Dual Message System transactions and Mainland China domestic transactions. */
  AUTHORIZATION_RELATED_FOR_DUAL_MESSAGE_SYSTEM = "AUTHORIZATION_RELATED_FOR_DUAL_MESSAGE_SYSTEM",
  /** Cardholder claims the merchant continued to bill the card after a recurring transaction was cancelled, or without explicit consent from the cardholder. */
  CANCELLED_RECURRING_TRANSACTION = "CANCELLED_RECURRING_TRANSACTION",
  /** A Cardholder Dispute. */
  CARDHOLDER_DISPUTE = "CARDHOLDER_DISPUTE",
  /** A Cardholder Dispute, not elsewhere classified (U.S. Region Only). */
  CARDHOLDER_DISPUTE_US_ONLY = "CARDHOLDER_DISPUTE_US_ONLY",
  /** A fraudulent transaction was processed using a counterfeit EMV chip card, but the chip was not used, which allowed fraud. */
  CHIP_LIABILITY_SHIFT = "CHIP_LIABILITY_SHIFT",
  /** A fraudulent transaction was processed using a lost, stolen, or never received EMV chip card, but the chip was not used, which allowed the fraud. */
  CHIP_PIN_LIABILITY_SHIFT_LOST_STOLEN = "CHIP_PIN_LIABILITY_SHIFT_LOST_STOLEN",
  /** The transaction was not deposited within 30 days of the date a valid authorization code was obtained. */
  CHIP_READ_POS_LATE_PRESENTMENT = "CHIP_READ_POS_LATE_PRESENTMENT",
  /** The Cardholder did not receive an expected credit. */
  CREDIT_NOT_PROCESSED = "CREDIT_NOT_PROCESSED",
  /** The Cardholder contacted the issuer claiming a travel service has not, or will not, be provided, and the merchant is seeking protection from creditors, insolvent, bankrupt or in liquidation. */
  DOMESTIC_CHARGEBACK_INTRA_EUROPEAN_USE = "DOMESTIC_CHARGEBACK_INTRA_EUROPEAN_USE",
  /** The merchant failed to provide adequate currency information or properly process a credit. */
  INCORRECT_CURRENCY = "INCORRECT_CURRENCY",
  /** The merchant failed to provide adequate currency information or properly process a credit or processed a transaction using the wrong transaction code. */
  INCORRECT_CURRENCY_OR_TRANSACTION_CODE = "INCORRECT_CURRENCY_OR_TRANSACTION_CODE",
  /** The amount the Cardholder was charged doesn’t match what’s on the receipt. */
  INCORRECT_TRANSACTION_AMOUNT_OR_ACCOUNT_NUMBER = "INCORRECT_TRANSACTION_AMOUNT_OR_ACCOUNT_NUMBER",
  /** the merchant processed a transaction using the wrong transaction code. */
  INCORRECT_TRANSACTION_CODE = "INCORRECT_TRANSACTION_CODE",
  /** The Cardholder claims an installment charge made to their account was incorrect. */
  INSTALLMENT_BILLING_DISPUTE = "INSTALLMENT_BILLING_DISPUTE",
  /** The transaction was not deposited within 30 days of the date a valid authorization code was obtained. */
  LATE_PRESENTMENT = "LATE_PRESENTMENT",
  /** A Cardholder Dispute with non-receipt of cash at an ATM. */
  NON_RECEIPT_OF_CASH_OR_LOAD_TRANSACTION_VALUE_AT_ATM = "NON_RECEIPT_OF_CASH_OR_LOAD_TRANSACTION_VALUE_AT_ATM",
  /** The cardholder claims the merchandise received (or service provided) differs greatly from the description provided at the time of purchase. */
  NOT_AS_DESCRIBED_OR_DEFECTIVE_MERCHANDISE = "NOT_AS_DESCRIBED_OR_DEFECTIVE_MERCHANDISE",
  /** A Cardholder is claiming that they did not authorize or participate in a card-not-present transaction, and therefore it must be fraudulent. */
  NOT_AUTHORIZED_CARD_ABSENT = "NOT_AUTHORIZED_CARD_ABSENT",
  /** A Cardholder disputes a credit card charge made in a card-not-present environment. */
  NOT_AUTHORIZED_CARD_PRESENT = "NOT_AUTHORIZED_CARD_PRESENT",
  /** The Cardholder claims he or she did not authorize the transaction. */
  NO_AUTHORIZATION = "NO_AUTHORIZATION",
  /**
   * The Cardholder claims to have been charged a no-show fee when they cancelled with a hotel participating in the Mastercard Guaranteed Reservation Service
   * or this is a ATM dispute.
   */
  NO_SHOW_ADDENDUM_OR_ATM_DISPUTE = "NO_SHOW_ADDENDUM_OR_ATM_DISPUTE",
  /** A single transaction was processed more than one time. */
  POINT_OF_INTERACTION_ERRORS = "POINT_OF_INTERACTION_ERRORS",
  /** This transaction violates Mastercard’s rules or the merchant was on a Mastercard security list. */
  QUESTIONABLE_MERCHANT_ACTIVITY = "QUESTIONABLE_MERCHANT_ACTIVITY",
  /** The product never arrived, or the service wasn’t completed. */
  SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED = "SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED",
  /** Issuer is unable to verify that an authorization code was obtained at the time of the transaction. */
  WARNING_BULLETIN_FILE = "WARNING_BULLETIN_FILE",
}

/** The status of the chargeback. */
export enum PaymentCardChargebackStatus {
  /** The chargeback has been cancelled. */
  CANCELLED = "CANCELLED",
  /** The chargeback has been lost. */
  LOST = "LOST",
  /** The chargeback is partially won. */
  PARTIALLY_WON = "PARTIALLY_WON",
  /** The chargeback has been received by the network. */
  RECEIVED = "RECEIVED",
  /** The chargeback has been rejected. */
  REJECTED = "REJECTED",
  /** The chargeback has been resolved by the network. */
  RESOLVED = "RESOLVED",
  /** The chargeback has been submitted to the network. */
  SUBMITTED = "SUBMITTED",
  /** The chargeback has been won. */
  WON = "WON",
}

/** Input to filter by `PaymentCardChargebackStatus`. */
export type PaymentCardChargebackStatusFilterInput = {
  equals?: InputMaybe<PaymentCardChargebackStatus>;
  excludes?: InputMaybe<Array<PaymentCardChargebackStatus>>;
  includes?: InputMaybe<Array<PaymentCardChargebackStatus>>;
  notEquals?: InputMaybe<PaymentCardChargebackStatus>;
};

/** PaymentCardClearedEvent indicates if a Payment Card Transaction has been cleared. This event will be conditionally fired after a `PaymentCardAuthorizationApprovedEvent` | `PaymentCardAuthorizationDeclinedEvent`. This event will not be triggered after a `PaymentCardAuthorizationAndClearApprovedEvent` | `PaymentCardAuthorizationAndClearDeclinedEvent` */
export type PaymentCardClearedEvent = Node &
  PaymentCardTransactionEvent & {
    __typename?: "PaymentCardClearedEvent";
    /** ID of the account holder for the card account. */
    accountHolderId?: Maybe<Scalars["ID"]>;
    /**
     * The direction funds are moving in the perspective of the cardholder.
     *
     * * when DEBIT, funds are moving out of the cardholder's account
     * * when CREDIT, funds are moving into the cardholder's account
     */
    accountingDirection?: Maybe<AccountingDirection>;
    /** Network specific transaction data. */
    additionalNetworkData?: Maybe<AdditionalNetworkData>;
    /** Determines whether this event is an advice. */
    advice?: Maybe<Scalars["Boolean"]>;
    /** Details if event is an advice. */
    adviceDetail?: Maybe<AdviceDetail>;
    /** The `Amount` approved for this `PaymentCardClearedEvent` and posted in the settlement currency. Does not include fees. */
    approvedAmount?: Maybe<Amount>;
    /** Code representing the result of AVS address verification. */
    avsResponseCode?: Maybe<AvsResponseCode>;
    /** ID of the payment card. */
    cardId?: Maybe<Scalars["ID"]>;
    /** The date and time, in ISO 8601 format, this `PaymentCardClearedEvent` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** `Amount` available to spend after this transaction event. */
    currentFinancialAccountAvailableToSpendAmount?: Maybe<Amount>;
    /** Maximum balance allowed for the card account at the time of this transaction event. */
    currentFinancialAccountMaximumBalanceAmount?: Maybe<Amount>;
    /** Code representing the result of CVV (security code) verification. */
    cvvResponseCode?: Maybe<CvvResponseCode>;
    /** Fees applied to the transaction, if any. */
    fees?: Maybe<Array<TransactionFee>>;
    /** ID of the financial account. */
    financialAccountId?: Maybe<Scalars["ID"]>;
    /** The ID of the transaction event. This `id` can be used to later retrieve details of this `PaymentCardClearedEvent` or correlate it with other events on this `Transaction`. */
    id: Scalars["ID"];
    /** The details about the merchant who requested the authorization. */
    merchantDetails?: Maybe<MerchantDetails>;
    /** The original `Amount` of this `PaymentCardClearedEvent`. */
    originalAmount?: Maybe<Amount>;
    /** Determines whether this is a partial or full clear for an authorization. */
    partial?: Maybe<Scalars["Boolean"]>;
    /** A snapshot of the `PaymentCard` at the time of the `PaymentCardTransactionEvent`. */
    paymentCardSnapshot?: Maybe<PaymentCardSnapshot>;
    /** Code representing the result of PIN verification. */
    pinResponseCode?: Maybe<PinResponseCode>;
    /** The Point Of Service Details. */
    pointOfServiceDetails?: Maybe<PointOfServiceDetails>;
    /** Code representing the result of AVS postal code verification. */
    postalCodeResponseCode?: Maybe<PostalCodeResponseCode>;
    /** The `Amount` requested to be approved for this `PaymentCardClearedEvent` and displayed in the transaction's (local) currency. Does not include fees. */
    requestedAmount?: Maybe<Amount>;
    /** The Highnote response code. */
    responseCode?: Maybe<TransactionEventResponseCode>;
    /** ID of the transaction. */
    transactionId?: Maybe<Scalars["ID"]>;
    /** Represents the customer transaction type being processed. */
    transactionProcessingType?: Maybe<CardTransactionProcessingType>;
  };

/** Permissions for a PaymentCard Client Token */
export enum PaymentCardClientTokenPermission {
  /** Setting this permission allow initiating and managing of a card fulfillment. */
  MANAGE_CARD_FULFILLMENT = "MANAGE_CARD_FULFILLMENT",
  /** Setting this permission will allow managing states for a Payment Card. */
  MANAGE_PAYMENT_CARD = "MANAGE_PAYMENT_CARD",
  /**
   * Read the card fulfillment details.
   *
   * Setting this permission will allow querying for fulfillment details.
   */
  READ_FULFILLMENT_DETAILS = "READ_FULFILLMENT_DETAILS",
  /**
   * Read `number` and `cvv` for Payment Card.
   *
   * Setting this permission will allow using the token to query for a Payment Card and read its `restrictedDetails` property.
   */
  READ_RESTRICTED_DETAILS = "READ_RESTRICTED_DETAILS",
  /** Setting this permission will allow using the token to set the PIN number for a Payment Card. */
  SET_PAYMENT_CARD_PIN = "SET_PAYMENT_CARD_PIN",
}

/** The PaymentCardClosedEvent is triggered when a Payment Card has been closed. */
export type PaymentCardClosedEvent = Node &
  PaymentCardEvent & {
    __typename?: "PaymentCardClosedEvent";
    /** The Bank Identification Number of the Payment Card. Usually the first 6 digits of the primary account number (PAN). */
    bin?: Maybe<Scalars["String"]>;
    /** The Card Product ID associated to the Payment Card. */
    cardProductId?: Maybe<Scalars["ID"]>;
    /** The exact date and time the payment card expires. */
    expirationDate?: Maybe<Scalars["String"]>;
    /** Whether the card is PHYSICAL or VIRTUAL */
    formFactor?: Maybe<CardFormFactor>;
    /** Global ID used to reference the Payment Card in operations. */
    id: Scalars["ID"];
    /** The last four digits of the primary account number (PAN). */
    last4?: Maybe<Scalars["String"]>;
    /** The card network that issued the Payment Card. */
    network?: Maybe<PaymentCardNetwork>;
    /** The authorized user of this `PaymentCard`. */
    paymentCardHolder?: Maybe<PaymentCardHolder>;
    /** The previous status of the Payment Card. */
    previousStatus?: Maybe<PaymentCardStatus>;
    /** The current status of the Payment Card. */
    status?: Maybe<PaymentCardStatus>;
    /** The date and time, in ISO 8601 format that the status of the Payment Card was updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** The connection type for Payment Card. */
export type PaymentCardConnection = {
  __typename?: "PaymentCardConnection";
  /** A list of edges. */
  edges?: Maybe<Array<PaymentCardEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The details of the delivery. */
export type PaymentCardDeliveryDetails = {
  __typename?: "PaymentCardDeliveryDetails";
  /** The address to where the shipment should be delivered. */
  address?: Maybe<Address>;
  /** The company to whom the shipment should be delivered. */
  companyName?: Maybe<Scalars["String"]>;
  /** The name of a person to whom the shipment should be delivered. */
  name?: Maybe<Name>;
  /** The ID of validated address to where the shipment should be delivered. */
  validatedAddress?: Maybe<ValidatedAddress>;
};

/** The details of the delivery. */
export type PaymentCardDeliveryDetailsInput = {
  /** The address to where the shipment should be delivered. */
  address: AddressInput;
  /** The company to whom the shipment should be delivered. */
  companyName?: InputMaybe<Scalars["String"]>;
  /** The name of a person to whom the shipment should be delivered. */
  name: NameInput;
};

/** The details of the delivery. */
export type PaymentCardDeliveryDetailsWithValidatedAddressInput = {
  /** The company to whom the shipment should be delivered. */
  companyName?: InputMaybe<Scalars["String"]>;
  /** The name of a person to whom the shipment should be delivered. */
  name: NameInput;
  /** The ID of validated address to where the shipment should be delivered. */
  validatedAddressId: Scalars["ID"];
};

/** The Payment Card Digital Wallet Device Type. */
export enum PaymentCardDigitalWalletDeviceType {
  /** A Mobile Device. Examples include an iPhone, Samsung Galaxy, or Google Pixel. */
  MOBILE = "MOBILE",
  /** A wireless, portable personal computer with a touchscreen interface. Examples include an iPad, Samsung Galaxy Tablet, or Amazon Fire HD. */
  TABLET = "TABLET",
  /** A Digital Watch. Examples include an iWatch, Samsung Galaxy Watch4, or Fitbit. */
  WATCH = "WATCH",
}

/** Return type to push provision a `PaymentCard` to an Apple Pay Enabled Device. */
export type PaymentCardDigitalWalletTokenApplePayDevicePushProvisioning = {
  __typename?: "PaymentCardDigitalWalletTokenApplePayDevicePushProvisioning";
  /** A Base64-encoded cryptographic OTP required to activate the Card by the Network. This data is not interpreted by Apple and the formats and contents are Network-specific. The Network and Highnote are responsible for validating the OTP and activating the Card. */
  activationData?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, this `PaymentCardDigitalWalletTokenApplePayDevicePushProvisioning` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** A Base64-encoded cipher text containing the card data, nonce, and nonce signature generated by Highnote. */
  encryptedPassData?: Maybe<Scalars["String"]>;
  /** A Base64-encoded ephemeral public key. The `ephemeralPublicKey` can be used in `PKEncryptionSchemeECC_V2`. */
  ephemeralPublicKey?: Maybe<Scalars["String"]>;
  /** The `PaymentCard` requested to be push provisioned */
  paymentCard?: Maybe<PaymentCard>;
};

/** Return type to push provision a `PaymentCard` to a Google Pay Enabled Device. */
export type PaymentCardDigitalWalletTokenGooglePayPushProvisioning = {
  __typename?: "PaymentCardDigitalWalletTokenGooglePayPushProvisioning";
  /** The billing address information of the `PaymentCard` */
  billingAddress?: Maybe<Address>;
  /** A structured object representing the name of the Cardholder */
  cardholderName?: Maybe<DigitalWalletPushProvisioningCardholderName>;
  /** The date and time, in ISO 8601 format, this `PaymentCardDigitalWalletTokenGooglePayPushProvisioning` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** A customer friendly name to appear on the Digital Wallet. */
  displayName?: Maybe<Scalars["String"]>;
  /** The card networks that the Highnote platform uses to issue Payment Cards. */
  network?: Maybe<PaymentCardNetwork>;
  /** The Opaque Payment Credential is an encrypted object that is created by Highnote and passed to Google Pay during push provisioning. */
  opaquePaymentCard?: Maybe<Scalars["String"]>;
  /** The `PaymentCard` requested to be push provisioned */
  paymentCard?: Maybe<PaymentCard>;
  /** The Token Service Provider */
  tokenServiceProvider?: Maybe<Scalars["String"]>;
};

/** The type of dispute category. */
export enum PaymentCardDisputeCategoryType {
  /** The Program attempted to collect money that the Account Holder has spent (e.g. clearing transaction without an authorization). */
  AUTHORIZATION = "AUTHORIZATION",
  /** The Account Holder claims they did not receive the goods and services they paid for from the Merchant. */
  CUSTOMER_DISPUTE = "CUSTOMER_DISPUTE",
  /** The Account Holder has claimed a transaction to be fraudulent on their Account. */
  FRAUD = "FRAUD",
  /**
   * The Account Holder claims they did not receive the goods and services they paid for from the Merchant.
   * @deprecated Use CUSTOMER_DISPUTE instead.
   */
  MERCHANT_DISPUTE = "MERCHANT_DISPUTE",
  /** The transaction data is incorrect. */
  PROCESSING_ERROR = "PROCESSING_ERROR",
}

/** The credit status of the dispute credit. */
export enum PaymentCardDisputeCreditStatus {
  /** The dispute credit is issued. */
  ISSUED = "ISSUED",
  /** A dispute credit has not been issued. */
  NOT_ISSUED = "NOT_ISSUED",
  /** The dispute credit is pending issuing. */
  PENDING_ISSUE = "PENDING_ISSUE",
  /** The dispute credit is pending reversal. */
  PENDING_REVERSAL = "PENDING_REVERSAL",
  /** The dispute credit is reversed. */
  REVERSED = "REVERSED",
}

/** The customer claim type of the dispute. */
export enum PaymentCardDisputeCustomerClaimType {
  /** Customer submitted a dispute verbally. */
  VERBAL = "VERBAL",
  /** Customer submitted a dispute with written documentation. */
  WRITTEN = "WRITTEN",
}

/** The customer contact information of the dispute. */
export type PaymentCardDisputeCustomerContact = {
  __typename?: "PaymentCardDisputeCustomerContact";
  /** The email of the customer. */
  email?: Maybe<Scalars["String"]>;
  /** The family name of the customer. */
  familyName?: Maybe<Scalars["String"]>;
  /** The given name of the customer. */
  givenName?: Maybe<Scalars["String"]>;
  /** The phone number of the customer. */
  phone?: Maybe<Phone>;
};

/** The possible dispute liability types for a payment card transaction. */
export enum PaymentCardDisputeLiability {
  /** The Issuer is liable for the dispute. */
  ISSUER_LIABLE = "ISSUER_LIABLE",
  /** The Merchant is liable for the dispute. */
  MERCHANT_LIABLE = "MERCHANT_LIABLE",
}

/** The status of the dispute. */
export enum PaymentCardDisputeStatus {
  /** The dispute has been cancelled. */
  CANCELLED = "CANCELLED",
  /** The dispute has been initiated. */
  INITIATED = "INITIATED",
  /** The dispute is in progress. */
  IN_PROGRESS = "IN_PROGRESS",
  /** The dispute has been lost. */
  LOST = "LOST",
  /** The dispute is pending resolution without a chargeback to the network by issuing credit. */
  PENDING_RESOLUTION = "PENDING_RESOLUTION",
  /** The dispute has been rejected. */
  REJECTED = "REJECTED",
  /** The dispute has been resolved without a chargeback to the network by issuing credit. */
  RESOLVED = "RESOLVED",
  /** The dispute has been won. */
  WON = "WON",
}

/** Input to filter by `PaymentCardDisputeStatus`. */
export type PaymentCardDisputeStatusFilterInput = {
  equals?: InputMaybe<PaymentCardDisputeStatus>;
  excludes?: InputMaybe<Array<PaymentCardDisputeStatus>>;
  includes?: InputMaybe<Array<PaymentCardDisputeStatus>>;
  notEquals?: InputMaybe<PaymentCardDisputeStatus>;
};

/** The edge type for a PaymentCard. */
export type PaymentCardEdge = {
  __typename?: "PaymentCardEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The Payment Card. */
  node?: Maybe<PaymentCard>;
};

/** Possible Payment Card EMV types. */
export enum PaymentCardEmvType {
  /** Contact EMV type. */
  CONTACT = "CONTACT",
  /** Contactless EMV type. */
  CONTACTLESS = "CONTACTLESS",
  /** No EMV type configured. */
  NONE = "NONE",
}

/** PaymentCardEnhancedDataEvent indicates if enhanced data for a Payment Card Transaction has been received. This event will be conditionally fired after a `PaymentCardClearedEvent`. This event will not be triggered after a `PaymentCardAuthorizationAndClearApprovedEvent` | `PaymentCardAuthorizationAndClearDeclinedEvent` */
export type PaymentCardEnhancedDataEvent = Node &
  PaymentCardTransactionEvent & {
    __typename?: "PaymentCardEnhancedDataEvent";
    /** ID of the account holder for the card account */
    accountHolderId?: Maybe<Scalars["ID"]>;
    /** Not used for this `PaymentCardEnhancedDataEvent` */
    accountingDirection?: Maybe<AccountingDirection>;
    /** Network specific transaction data. */
    additionalNetworkData?: Maybe<AdditionalNetworkData>;
    /** The `Amount` approved for this `PaymentCardEnhancedDataEvent` and posted in the settlement currency. Does not include fees. */
    approvedAmount?: Maybe<Amount>;
    /** Not used for this `PaymentCardEnhancedDataEvent` */
    avsResponseCode?: Maybe<AvsResponseCode>;
    /** ID of the payment card. */
    cardId?: Maybe<Scalars["ID"]>;
    /** The date and time, in ISO 8601 format, this `PaymentCardEnhancedDataEvent` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Not used for this `PaymentCardEnhancedDataEvent` */
    currentFinancialAccountAvailableToSpendAmount?: Maybe<Amount>;
    /** Not used for this `PaymentCardEnhancedDataEvent` */
    currentFinancialAccountMaximumBalanceAmount?: Maybe<Amount>;
    /** Not used for this `PaymentCardEnhancedDataEvent` */
    cvvResponseCode?: Maybe<CvvResponseCode>;
    /** Not used for this `PaymentCardEnhancedDataEvent` */
    fees?: Maybe<Array<TransactionFee>>;
    /** ID of the financial account. */
    financialAccountId?: Maybe<Scalars["ID"]>;
    /** The ID of the transaction event. This `id` can be used to later retrieve details of this `PaymentCardEnhancedDataEvent` or correlate it with other events on this `Transaction`. */
    id: Scalars["ID"];
    /** Not used for this `PaymentCardEnhancedDataEvent` */
    merchantDetails?: Maybe<MerchantDetails>;
    /** Not used for this `PaymentCardEnhancedDataEvent` */
    originalAmount?: Maybe<Amount>;
    /** Not used for this `PaymentCardEnhancedDataEvent` */
    pinResponseCode?: Maybe<PinResponseCode>;
    /** Not used for this `PaymentCardEnhancedDataEvent` */
    pointOfServiceDetails?: Maybe<PointOfServiceDetails>;
    /** Not used for this `PaymentCardEnhancedDataEvent` */
    postalCodeResponseCode?: Maybe<PostalCodeResponseCode>;
    /** Not used for this `PaymentCardEnhancedDataEvent` */
    requestedAmount?: Maybe<Amount>;
    /** The Highnote response code. */
    responseCode?: Maybe<TransactionEventResponseCode>;
    /** ID of the transaction */
    transactionId?: Maybe<Scalars["ID"]>;
    /** Represents the customer transaction type or the center function being processed. */
    transactionProcessingType?: Maybe<CardTransactionProcessingType>;
  };

export type PaymentCardEvent = {
  /** The Bank Identification Number of the Payment Card. Usually the first 6 digits of the primary account number (PAN). */
  bin?: Maybe<Scalars["String"]>;
  /** The Card Product ID associated to the Payment Card. */
  cardProductId?: Maybe<Scalars["ID"]>;
  /** The exact date and time the payment card expires. */
  expirationDate?: Maybe<Scalars["String"]>;
  /** The last four digits of the primary account number (PAN). */
  last4?: Maybe<Scalars["String"]>;
  /** The card network that issued the Payment Card. */
  network?: Maybe<PaymentCardNetwork>;
  /** The authorized user of this `PaymentCard`. */
  paymentCardHolder?: Maybe<PaymentCardHolder>;
  /** The previous status of the Payment Card. */
  previousStatus?: Maybe<PaymentCardStatus>;
  /** The current status of the Payment Card. */
  status?: Maybe<PaymentCardStatus>;
  /** The date and time, in ISO 8601 format that the status of the Payment Card was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Inputs for filtering based on `PaymentCard` details. */
export type PaymentCardFilterInput = {
  /** Input to filter by account holder ID. */
  accountHolderId?: InputMaybe<IdFilterInput>;
  /** Input to filter by payment card bank identification number. */
  bin?: InputMaybe<StringFilterInput>;
  /** Input to filter by card profile set ID. */
  cardProfileSetId?: InputMaybe<IdFilterInput>;
  /** Input to filter by last 4 digits of payment card number. */
  last4?: InputMaybe<StringFilterInput>;
  /** Input to filter by payment card holder ID. */
  paymentCardHolderId?: InputMaybe<IdFilterInput>;
  /** Input to filter by payment card ID */
  paymentCardId?: InputMaybe<IdFilterInput>;
  /** Input to filter by first line of personalization on physical payment card. */
  paymentCardPersonalizationLine1?: InputMaybe<StringFilterInput>;
  /** Input to filter by second line of personalization on physical payment card. */
  paymentCardPersonalizationLine2?: InputMaybe<StringFilterInput>;
  /** Input to filter by third line of personalization on physical payment card. */
  paymentCardPersonalizationLine3?: InputMaybe<StringFilterInput>;
  /** Input to filter by payment card status. */
  paymentCardStatus?: InputMaybe<PaymentCardStatusFilterInput>;
};

/** Group order status detail. */
export type PaymentCardGroupOrderStateDetail = {
  __typename?: "PaymentCardGroupOrderStateDetail";
  /** Current order status. */
  status?: Maybe<PaymentCardGroupOrderStatus>;
};

/** Group order detail history. */
export type PaymentCardGroupOrderStateDetailHistory = {
  __typename?: "PaymentCardGroupOrderStateDetailHistory";
  /** The date and time, in ISO 8601 format the status changed. */
  createdAt?: Maybe<Scalars["String"]>;
  /** New order status. */
  newStatus?: Maybe<PaymentCardGroupOrderStatus>;
  /** Previous order status. */
  previousStatus?: Maybe<PaymentCardGroupOrderStatus>;
};

/** Group order status. */
export enum PaymentCardGroupOrderStatus {
  /** Vendor approved the fulfillment request but has not yet shipped. */
  APPROVED = "APPROVED",
  /** Group order was canceled by the client. */
  CANCELED = "CANCELED",
  /** Group order was created but is not yet ready to ship. */
  NEW = "NEW",
  /** Group order is ready to ship but has not yet been sent to the vendor. */
  PENDING = "PENDING",
  /** Group order was sent to the vendor but the vendor has not yet approved. */
  SENT_TO_PRINTER = "SENT_TO_PRINTER",
  /** The vendor shipped the card to the delivery address. */
  SHIPPED = "SHIPPED",
  /** The vendor was not able to ship the card. */
  SHIP_FAILED = "SHIP_FAILED",
}

/** Inputs for filtering by `PaymentCardGroupOrderStatus` */
export type PaymentCardGroupOrderStatusFilterInput = {
  equals?: InputMaybe<PaymentCardGroupOrderStatus>;
  excludes?: InputMaybe<Array<PaymentCardGroupOrderStatus>>;
  includes?: InputMaybe<Array<PaymentCardGroupOrderStatus>>;
  notEquals?: InputMaybe<PaymentCardGroupOrderStatus>;
};

/** The identity type of a payment card holder. */
export type PaymentCardHolder =
  | UsBusinessAuthorizedPerson
  | UsPersonAccountHolder
  | UsPersonAuthorizedUser;

/** Card holder details for a payment card. */
export type PaymentCardHolderDetails = {
  __typename?: "PaymentCardHolderDetails";
  /** The USBusinessAccountHolder or USPersonAccountHolder associated with the payment card. */
  associatedPaymentCardAccountHolder?: Maybe<AccountHolder>;
  /** The billing address on the card for AVS and Postal Code Matching. Depending on account holder updates, this could differ from billing address on the account. */
  billingAddressOnCard?: Maybe<Address>;
  /** Identity of payment card holder. This may either be an account holder or an authorized user. */
  paymentCardHolder?: Maybe<PaymentCardHolder>;
};

/** Used to represent a Payment Card. */
export type PaymentCardInput = {
  /** The primary account number for the payment card. */
  cardNumber: Scalars["String"];
  /**
   * The month the payment card expires.
   *
   * Must be formatted as MM.
   */
  expiryMonth: Scalars["String"];
  /**
   * The year the payment card expires.
   *
   * Must be formatted as YY.
   */
  expiryYear: Scalars["String"];
  /**
   * The card security code for the payment card.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Card_security_code).
   */
  securityCode?: InputMaybe<Scalars["String"]>;
};

/** Used to represent data available on a Payment Card. */
export type PaymentCardInstrument = {
  __typename?: "PaymentCardInstrument";
  /** The payment card brand. */
  brand?: Maybe<AcquiringPaymentCardBrand>;
  /** A list of capabilities this `PaymentCardInstrument` supports. */
  capabilities?: Maybe<Array<PaymentCardInstrumentCapability>>;
  /** The cardHolder data for the payment card. */
  cardHolder?: Maybe<CardHolder>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /**
   * The month the payment card expires.
   *
   * Formatted as MM.
   */
  expiryMonth?: Maybe<Scalars["String"]>;
  /**
   * The year the payment card expires.
   *
   * Formatted as YYYY.
   */
  expiryYear?: Maybe<Scalars["String"]>;
  /** The last 4 digits of the payment card. */
  last4?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

export type PaymentCardInstrumentCapability =
  | AccessDeniedError
  | InstantNetworkTransferDestinationPaymentInstrumentCapability
  | InstantNetworkTransferSourcePaymentInstrumentCapability
  | UserError;

/** The `PaymentCardIssuedEvent` is triggered when a Payment Card has been activated. */
export type PaymentCardIssuedEvent = Node &
  PaymentCardEvent & {
    __typename?: "PaymentCardIssuedEvent";
    /** The Bank Identification Number of the Payment Card. Usually the first 6 digits of the primary account number (PAN). */
    bin?: Maybe<Scalars["String"]>;
    /** The Card Product ID associated to the Payment Card. */
    cardProductId?: Maybe<Scalars["ID"]>;
    /** The exact date and time the payment card expires. */
    expirationDate?: Maybe<Scalars["String"]>;
    /** Whether the card is PHYSICAL or VIRTUAL */
    formFactor?: Maybe<CardFormFactor>;
    /** Global ID used to reference the Payment Card in operations. */
    id: Scalars["ID"];
    /** The last four digits of the primary account number (PAN). */
    last4?: Maybe<Scalars["String"]>;
    /** The card network that issued the Payment Card. */
    network?: Maybe<PaymentCardNetwork>;
    /** The authorized user of this `PaymentCard`. */
    paymentCardHolder?: Maybe<PaymentCardHolder>;
    /** The previous status of the Payment Card. */
    previousStatus?: Maybe<PaymentCardStatus>;
    /** The current status of the Payment Card. */
    status?: Maybe<PaymentCardStatus>;
    /** The date and time, in ISO 8601 format that the status of the Payment Card was updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** The card networks that the Highnote platform uses to issue Payment Cards. */
export enum PaymentCardNetwork {
  /** MASTERCARD */
  MASTERCARD = "MASTERCARD",
  /** VISA */
  VISA = "VISA",
}

/** Input for filtering by `PaymentCardNetwork`. */
export type PaymentCardNetworkFilterInput = {
  equals?: InputMaybe<PaymentCardNetwork>;
  excludes?: InputMaybe<Array<PaymentCardNetwork>>;
  includes?: InputMaybe<Array<PaymentCardNetwork>>;
  notEquals?: InputMaybe<PaymentCardNetwork>;
};

/** Payment card order status detail. */
export type PaymentCardOrderStateDetail = {
  __typename?: "PaymentCardOrderStateDetail";
  /** Current order status. */
  status?: Maybe<PaymentCardOrderStatus>;
};

/** Payment card order date detail history. */
export type PaymentCardOrderStateDetailHistory = {
  __typename?: "PaymentCardOrderStateDetailHistory";
  /** The date and time, in ISO 8601 format the status changed. */
  createdAt?: Maybe<Scalars["String"]>;
  /** New order status. */
  newStatus?: Maybe<PaymentCardOrderStatus>;
  /** Previous order status. */
  previousStatus?: Maybe<PaymentCardOrderStatus>;
};

/** Payment card order status. */
export enum PaymentCardOrderStatus {
  /** Printer approved the fulfillment request but has not yet shipped. */
  APPROVED = "APPROVED",
  /** Fulfillment was canceled by client. */
  CANCELED = "CANCELED",
  /** External physical payment card order is complete. */
  COMPLETED = "COMPLETED",
  /** Fulfillment was created but not yet sent to printer. */
  NEW = "NEW",
  /** Fulfillment was sent to printer but printer has not yet approved. */
  SENT_TO_PRINTER = "SENT_TO_PRINTER",
  /** Vendor shipped the card to the delivery address. */
  SHIPPED = "SHIPPED",
  /** Printer was not able to ship the card. */
  SHIP_FAILED = "SHIP_FAILED",
}

/** Input for filtering by `PaymentCardOrderStatus`. */
export type PaymentCardOrderStatusFilterInput = {
  equals?: InputMaybe<PaymentCardOrderStatus>;
  excludes?: InputMaybe<Array<PaymentCardOrderStatus>>;
  includes?: InputMaybe<Array<PaymentCardOrderStatus>>;
  notEquals?: InputMaybe<PaymentCardOrderStatus>;
};

/** Payment card personalization. */
export type PaymentCardPersonalization = {
  __typename?: "PaymentCardPersonalization";
  /** Personalization text lines. */
  textLines: PaymentCardPersonalizationTextLines;
};

/** Payment card personalization input. */
export type PaymentCardPersonalizationInput = {
  /** Personalization text lines. */
  textLines: PaymentCardPersonalizationTextLinesInput;
};

/** Payment card personalization text lines. */
export type PaymentCardPersonalizationTextLines = {
  __typename?: "PaymentCardPersonalizationTextLines";
  /**
   * First line.
   *
   * This value will always be capitalized.
   *
   * Example: `"JANE"`, `"BOB"`
   */
  line1: Scalars["String"];
  /**
   * Second line.
   *
   * This value will always be capitalized.
   *
   * Example: `"FOO"`
   */
  line2?: Maybe<Scalars["String"]>;
  /**
   * Third line.
   *
   * This value will always be capitalized.
   *
   * Example: `"BAR"`
   */
  line3?: Maybe<Scalars["String"]>;
};

/** Payment card personalization text lines input. */
export type PaymentCardPersonalizationTextLinesInput = {
  /**
   * First line.
   *
   * The value provided will be stored and returned fully capitalized.
   *
   * For example, `Jane` will be stored as `JANE`.
   *
   * Minimum length is 1 and maximum length is 23. Valid characters are all alphanumeric characters, `,`,
   * `.`, `'`, `&`, `-`, `\`, `$`, and space. The regex used to validate is `^[0-9A-Za-z \&\-\,\.\/\'\$]*$`.
   */
  line1: Scalars["String"];
  /**
   * Second line.
   *
   * The value provided will be stored and returned fully capitalized.
   *
   * For example, `Jane` will be stored as `JANE`.
   *
   * Minimum length is 1 and maximum length is 23. Valid characters are all alphanumeric characters, `,`,
   * `.`, `'`, `&`, `-`, `\`, `$`, and space. The regex used to validate is `^[0-9A-Za-z \&\-\,\.\/\'\$]*$`.
   */
  line2?: InputMaybe<Scalars["String"]>;
  /**
   * Third line.
   *
   * The value provided will be stored and returned fully capitalized.
   *
   * For example, `Jane` will be stored as `JANE`.
   *
   * Minimum length is 1 and maximum length is 23. Valid characters are all alphanumeric characters, `,`,
   * `.`, `'`, `&`, `-`, `\`, `$`, and space. The regex used to validate is `^[0-9A-Za-z \&\-\,\.\/\'\$]*$`.
   */
  line3?: InputMaybe<Scalars["String"]>;
};

/** PIN details for the `PaymentCard`. */
export type PaymentCardPinDetails = {
  __typename?: "PaymentCardPinDetails";
  /** Denotes whether the `PaymentCard` has a PIN set. */
  isSet?: Maybe<Scalars["Boolean"]>;
  /** List of PIN updates. */
  pinUpdateHistory?: Maybe<Array<PaymentCardPinUpdate>>;
};

/** Update details for the `PaymentCardPinDetails`. */
export type PaymentCardPinUpdate = {
  __typename?: "PaymentCardPinUpdate";
  /** The date and time, in ISO 8601 format, the PIN was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The provisional credit status of the dispute. */
export enum PaymentCardProvisionalCreditStatus {
  /** The Provisional Credit for is not finalized */
  FINALIZATION_FAILED = "FINALIZATION_FAILED",
  /** The Provisional Credit for is finalized */
  FINALIZED = "FINALIZED",
  /** The Provisional Credit for the chargeback has been issued. */
  ISSUED = "ISSUED",
  /** A chargeback credit has not been issued. */
  NOT_ISSUED = "NOT_ISSUED",
  /** The chargeback provisional credit is pending finalized. */
  PENDING_FINALIZATION = "PENDING_FINALIZATION",
  /** The chargeback provisional credit is pending issued. */
  PENDING_ISSUE = "PENDING_ISSUE",
}

/**
 * Raw payment card details.
 *
 * **Note:** This is only available to users/organizations who have provided an AOC (attestation of compliance).
 */
export type PaymentCardRestrictedDetails = {
  __typename?: "PaymentCardRestrictedDetails";
  /**
   * The card verification code for the payment card.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Card_security_code).
   */
  cvv?: Maybe<Scalars["String"]>;
  /** The primary account number for the payment card. */
  number?: Maybe<Scalars["String"]>;
};

export type PaymentCardRestrictedDetailsResult =
  | AccessDeniedError
  | PaymentCardRestrictedDetails;

/** The details of the sender. */
export type PaymentCardSenderDetails = {
  __typename?: "PaymentCardSenderDetails";
  /** Sender address. The address to where the shipment should be returned. */
  address?: Maybe<Address>;
  /** The company who is sending the shipment. */
  companyName?: Maybe<Scalars["String"]>;
  /** The name of a person to who is sending the shipment. */
  name?: Maybe<Name>;
};

/** PaymentCardShipment */
export type PaymentCardShipment = {
  __typename?: "PaymentCardShipment";
  /** Courier information. */
  courier?: Maybe<PaymentCardShipmentCourier>;
  /** Delivery details. */
  deliveryDetails?: Maybe<PaymentCardDeliveryDetails>;
  /** Requested ship date in YYYY-MM-DD format. */
  requestedShipDate?: Maybe<Scalars["String"]>;
  /** Sender details. */
  senderDetails?: Maybe<PaymentCardDeliveryDetails>;
};

/** The details of the shipment. */
export type PaymentCardShipmentCourier = {
  __typename?: "PaymentCardShipmentCourier";
  /** Shipping method. */
  method?: Maybe<PaymentCardShippingMethod>;
  /** Whether signature is required on delivery. */
  signatureRequiredOnDelivery?: Maybe<Scalars["Boolean"]>;
  /** Tracking information. */
  tracking?: Maybe<PaymentCardShipmentTracking>;
};

/** The details specifying the shipment. */
export type PaymentCardShipmentCourierInput = {
  /** Shipping method. */
  method: PaymentCardShippingMethod;
  /** Whether signature is required on delivery. */
  signatureRequiredOnDelivery: Scalars["Boolean"];
};

/** PaymentCardShipmentTracking */
export type PaymentCardShipmentTracking = {
  __typename?: "PaymentCardShipmentTracking";
  /** Actual ship date in YYYY-MM-DD format provided by the shipper. */
  actualShipDateLocal?: Maybe<Scalars["String"]>;
  /** Shipment tracking number. */
  trackingNumber?: Maybe<Scalars["String"]>;
};

/** Payment card shipping method. */
export enum PaymentCardShippingMethod {
  /** FedEx 2 Day. */
  FEDEX_2_DAY = "FEDEX_2_DAY",
  /** FedEx Ground. */
  FEDEX_GROUND = "FEDEX_GROUND",
  /** FedEx International Priority. */
  FEDEX_INTERNATIONAL_PRIORITY = "FEDEX_INTERNATIONAL_PRIORITY",
  /**
   * FedEx One Rate.
   *
   * Please contact Highnote support to find out if this option is available to your program.
   */
  FEDEX_ONE_RATE = "FEDEX_ONE_RATE",
  /**
   * FedEx Standard Overnight.
   *
   * Please contact Highnote support to find out if this option is available to your program.
   */
  FEDEX_OVERNIGHT = "FEDEX_OVERNIGHT",
  /** FedEx Priority Overnight. */
  FEDEX_PRIORITY_OVERNIGHT = "FEDEX_PRIORITY_OVERNIGHT",
  /**
   * FedEx 1 Day - Processed Same Day.
   *
   * Additional fees apply to Same Day options. Please contact Highnote support to find out if this option is available to your program.
   */
  SAME_DAY_FEDEX_1_DAY = "SAME_DAY_FEDEX_1_DAY",
  /**
   * FedEx Ground - Processed Same Day.
   *
   * Additional fees apply to Same Day options. Please contact Highnote support to find out if this option is available to your program.
   */
  SAME_DAY_FEDEX_GROUND = "SAME_DAY_FEDEX_GROUND",
  /**
   * UPS Ground Shipping - Processed Same Day.
   *
   * Additional fees apply to Same Day options. Please contact Highnote support to find out if this option is available to your program.
   */
  SAME_DAY_UPS_GROUND = "SAME_DAY_UPS_GROUND",
  /**
   * UPS Next Day Air Shipping - Processed Same Day.
   *
   * Additional fees apply to Same Day options. Please contact Highnote support to find out if this option is available to your program.
   */
  SAME_DAY_UPS_NEXT_DAY = "SAME_DAY_UPS_NEXT_DAY",
  /**
   * UPS 2nd Day Air - Processed Same Day.
   *
   * Additional fees apply to Same Day options. Please contact Highnote support to find out if this option is available to your program.
   */
  SAME_DAY_UPS_SECOND_DAY = "SAME_DAY_UPS_SECOND_DAY",
  /**
   * USPS Retail Ground ® - Processed Same Day.
   *
   * Additional fees apply to Same Day options. Please contact Highnote support to find out if this option is available to your program.
   */
  SAME_DAY_USPS_GROUND = "SAME_DAY_USPS_GROUND",
  /**
   * USPS Priority Mail ® - Processed Same Day.
   *
   * Additional fees apply to Same Day options. Please contact Highnote support to find out if this option is available to your program.
   */
  SAME_DAY_USPS_PRIORITY = "SAME_DAY_USPS_PRIORITY",
  /** UPS Ground Shipping. */
  UPS_GROUND = "UPS_GROUND",
  /** UPS Next Day Air Shipping. */
  UPS_NEXT_DAY = "UPS_NEXT_DAY",
  /** UPS 2nd Day Air. */
  UPS_SECOND_DAY = "UPS_SECOND_DAY",
  /**
   * USPS Priority Mail Express ®.
   *
   * USPS Priority Mail Express ®. Includes Signature Confirmation at no extra charge. If you wish to ship your order without signature confirmation, we recommend using a different shipping method.
   */
  USPS_EXPRESS = "USPS_EXPRESS",
  /** USPS Retail Ground ®. */
  USPS_GROUND = "USPS_GROUND",
  /** USPS Priority Mail ®. */
  USPS_PRIORITY = "USPS_PRIORITY",
}

/** Input for filtering by `PaymentCardShippingMethod` */
export type PaymentCardShippingMethodFilterInput = {
  equals?: InputMaybe<PaymentCardShippingMethod>;
  excludes?: InputMaybe<Array<PaymentCardShippingMethod>>;
  includes?: InputMaybe<Array<PaymentCardShippingMethod>>;
  notEquals?: InputMaybe<PaymentCardShippingMethod>;
};

/** A snapshot of the `PaymentCard` at the time of a transaction event. */
export type PaymentCardSnapshot = Node & {
  __typename?: "PaymentCardSnapshot";
  /** The UTC date on which the card was lost. e.g. 2026-01-01T23:59:59Z */
  cardLostDate?: Maybe<Scalars["String"]>;
  /**
   * The date and time, in ISO 8601 format, when this snapshot was created.
   * This is also the date that the `PaymentCard` was created.
   */
  createdAt?: Maybe<Scalars["String"]>;
  /** The exact date and time in UTC when the `PaymentCard` expires. */
  expirationDate?: Maybe<Scalars["String"]>;
  /** The expiration month to display to the card holder. This value would be printed on the physical card. */
  expirationMonth?: Maybe<Scalars["String"]>;
  /** The expiration year to display to the card holder. This value would be printed on the physical card. */
  expirationYear?: Maybe<Scalars["String"]>;
  /** Whether the card is `PHYSICAL` or `VIRTUAL`. */
  formFactor?: Maybe<CardFormFactor>;
  /** Global ID used to reference the `PaymentCardSnapshot`. */
  id: Scalars["ID"];
  /** The `PaymentCard`. */
  paymentCardCurrent?: Maybe<PaymentCard>;
  /**
   * Source card for the `PaymentCard` if replaced. When this happens, a new card ID is generated.
   * The source card tells us that card A came from card B through this attribute.
   */
  sourceCard?: Maybe<PaymentCard>;
  /** The status of the card when the snapshot was captured. */
  status?: Maybe<PaymentCardStatus>;
  /** Memo for the change. */
  statusChangeMemo?: Maybe<Scalars["String"]>;
  /** The reason for the status change. */
  statusChangeReason?: Maybe<PaymentCardStatusChangeReason>;
  /**
   * The date and time, in ISO 8601 format, when this snapshot was updated.
   * This is also the date that the `PaymentCard` was modified.
   */
  updatedAt?: Maybe<Scalars["String"]>;
  /** Whether the card is `MULTI_USE` or `SINGLE_USE`. */
  usage?: Maybe<CardUsage>;
};

/** The connection type for `PaymentCardSnapshotConnection`. */
export type PaymentCardSnapshotConnection = {
  __typename?: "PaymentCardSnapshotConnection";
  /** A list of edges. */
  edges?: Maybe<Array<PaymentCardSnapshotEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a `PaymentCardSnapshot`. */
export type PaymentCardSnapshotEdge = {
  __typename?: "PaymentCardSnapshotEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The details of the revision made to a `PaymentCard`. */
  node?: Maybe<PaymentCardSnapshot>;
};

/** Possible statuses of a Payment Card. */
export enum PaymentCardStatus {
  /** The Payment Card needs activation before it can be used successfully. */
  ACTIVATION_REQUIRED = "ACTIVATION_REQUIRED",
  /** The Payment Card is active and ready for use. */
  ACTIVE = "ACTIVE",
  /** The Payment Card has been closed and all future authorizations will fail. */
  CLOSED = "CLOSED",
  /** The Payment Card has been suspended and authorizations will fail until the Payment Card is `ACTIVE` again. */
  SUSPENDED = "SUSPENDED",
}

/** The different reasons for a `PaymentCard` status change */
export enum PaymentCardStatusChangeReason {
  /** The `PaymentCard` created. */
  CREATED = "CREATED",
  /** The `PaymentCard` expired. */
  EXPIRED = "EXPIRED",
  /** The `PaymentCard` was lost. */
  LOST = "LOST",
  /** The `PaymentCard` state was changed for another reason. */
  OTHER = "OTHER",
  /** The `PaymentCard` was stolen. */
  STOLEN = "STOLEN",
  /** The `PaymentCard` state was changed for unknown reason. */
  UNSPECIFIED = "UNSPECIFIED",
}

/** Input for filtering by `PaymentCardStatus`. */
export type PaymentCardStatusFilterInput = {
  equals?: InputMaybe<PaymentCardStatus>;
  excludes?: InputMaybe<Array<PaymentCardStatus>>;
  includes?: InputMaybe<Array<PaymentCardStatus>>;
  notEquals?: InputMaybe<PaymentCardStatus>;
};

/** The PaymentCardSuspendedEvent is triggered when a Payment Card has been suspended. */
export type PaymentCardSuspendedEvent = Node &
  PaymentCardEvent & {
    __typename?: "PaymentCardSuspendedEvent";
    /** The Bank Identification Number of the Payment Card. Usually the first 6 digits of the primary account number (PAN). */
    bin?: Maybe<Scalars["String"]>;
    /** The Card Product ID associated to the Payment Card. */
    cardProductId?: Maybe<Scalars["ID"]>;
    /** The exact date and time the payment card expires. */
    expirationDate?: Maybe<Scalars["String"]>;
    /** Whether the card is PHYSICAL or VIRTUAL */
    formFactor?: Maybe<CardFormFactor>;
    /** Global ID used to reference the Payment Card in operations. */
    id: Scalars["ID"];
    /** The last four digits of the primary account number (PAN). */
    last4?: Maybe<Scalars["String"]>;
    /** The card network that issued the Payment Card. */
    network?: Maybe<PaymentCardNetwork>;
    /** The authorized user of this `PaymentCard`. */
    paymentCardHolder?: Maybe<PaymentCardHolder>;
    /** The previous status of the Payment Card. */
    previousStatus?: Maybe<PaymentCardStatus>;
    /** The current status of the Payment Card. */
    status?: Maybe<PaymentCardStatus>;
    /** The date and time, in ISO 8601 format that the status of the Payment Card was updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/**
 * A suspension flag on a `PaymentCard`.
 *
 * Payment Card Suspension Flags are used to denote the type of suspension on a `PaymentCard`.
 */
export enum PaymentCardSuspensionFlag {
  /** The `PaymentCard` has been suspended by the issuer i.e. Highnote. This suspension can only be lifed by the issuer i.e. Highnote. */
  ISSUER_INITIATED_SUSPENSION = "ISSUER_INITIATED_SUSPENSION",
  /** The `PaymentCard` has been suspended by Highnote customer or account holder. This suspension can be lifted by Highnote customer or account holder. */
  PROGRAM_OWNER_INITIATED_SUSPENSION = "PROGRAM_OWNER_INITIATED_SUSPENSION",
}

/** Describes the metrics for transactions. */
export type PaymentCardTransactionBusinessMetric = {
  __typename?: "PaymentCardTransactionBusinessMetric";
  /** The approved authorized transaction attributes. */
  approvedAuthorization?: Maybe<TransactionBusinessMetricAttribute>;
  /** The cleared transaction attributes. */
  clearedTransactions?: Maybe<ClearedTransactionBusinessMetricAttribute>;
  /** The declined transaction attributes. */
  declinedAuthorization?: Maybe<DeclinedTransactionBusinessMetricAttribute>;
  /** An ISO 8601 value (inclusive) for the beginning and end date. */
  timeRange?: Maybe<BusinessMetricTimeRange>;
};

/** Used to filter which transaction metrics are requested. */
export type PaymentCardTransactionBusinessMetricFilterInput = {
  /** Filters transaction metrics by CardProductId, optional. */
  cardProductIds?: InputMaybe<Array<Scalars["String"]>>;
  /** Filters transaction metrics by merchant category codes, optional. */
  merchantCategoryCodes?: InputMaybe<Array<Scalars["String"]>>;
  /** Filters transaction metrics by merchant name, optional. */
  merchantNames?: InputMaybe<Array<Scalars["String"]>>;
  /** Filters transaction metrics by TimeRange, start and end are inclusive. */
  timeRange?: InputMaybe<TimestampFilterInputRange>;
};

/** Describes metric Result of card product transaction metric. */
export type PaymentCardTransactionBusinessMetricResult =
  BusinessMetricResult & {
    __typename?: "PaymentCardTransactionBusinessMetricResult";
    /** Data freshness timestamp of metrics. */
    asOf?: Maybe<Scalars["String"]>;
    /** Returned list of PaymentCardTransactionBusinessMetric. */
    paymentCardTransactionBusinessMetrics?: Maybe<
      Array<PaymentCardTransactionBusinessMetric>
    >;
    /** An ISO 8601 value (inclusive) for the beginning and end date. */
    timeRange?: Maybe<BusinessMetricTimeRange>;
  };

/** The payment card transaction chargeback. */
export type PaymentCardTransactionChargeback = Node & {
  __typename?: "PaymentCardTransactionChargeback";
  /** The external network id of the chargeback. */
  chargebackExternalNetwork?: Maybe<ChargebackExternalNetwork>;
  /** The date and time, in ISO 8601 format, this chargeback was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, from which this chargeback credit is issued. */
  creditIssueFromDate?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, through which this chargeback credit is issued. */
  creditIssueThroughDate?: Maybe<Scalars["String"]>;
  /** The credit status of the chargeback. */
  creditStatus?: Maybe<PaymentCardChargebackCreditStatus>;
  /** The payment card transaction dispute for the chargeback. */
  dispute?: Maybe<PaymentCardTransactionDispute>;
  /** The date and time, in ISO 8601 format, from which this chargeback is submitted. */
  fromDate?: Maybe<Scalars["String"]>;
  /** The Global ID of the chargeback. */
  id: Scalars["ID"];
  /** The external network reason code of the chargeback. */
  networkReasonCode?: Maybe<PaymentCardChargebackNetworkReasonCode>;
  /** The received amount for the chargeback. */
  receivedAmount?: Maybe<Amount>;
  /** The requested amount for the chargeback. */
  requestedAmount?: Maybe<Amount>;
  /** The status of the chargeback. */
  status?: Maybe<PaymentCardChargebackStatus>;
  /** The date and time, in ISO 8601 format, through which this chargeback is resolved. */
  throughDate?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, this chargeback was most recently updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The connection type for a `PaymentCardTransactionChargeback`. */
export type PaymentCardTransactionChargebackConnection = {
  __typename?: "PaymentCardTransactionChargebackConnection";
  /** A list of edges. */
  edges?: Maybe<Array<PaymentCardTransactionChargebackEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for the `PaymentCardTransactionChargeback`. */
export type PaymentCardTransactionChargebackEdge = {
  __typename?: "PaymentCardTransactionChargebackEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The payment card transaction chargeback. */
  node?: Maybe<PaymentCardTransactionChargeback>;
};

/** Input for filtering `PaymentCardTransactionChargeback` */
export type PaymentCardTransactionChargebacksFilterInput = {
  /** Input to filter by `FinancialAccount` ID. */
  accountId?: InputMaybe<IdFilterInput>;
  /** Input to filter by `PaymentCardTransactionChargeback` created date. */
  chargebackCreatedAt?: InputMaybe<TimestampFilterInput>;
  /** Input to filter by `PaymentCardTransactionChargeback` ID. */
  chargebackId?: InputMaybe<IdFilterInput>;
  /** Input to filter by `PaymentCardTransactionChargeback` status. */
  chargebackStatus?: InputMaybe<PaymentCardChargebackStatusFilterInput>;
  /** Chargeback externalNetworkId filter */
  externalNetworkId?: InputMaybe<StringFilterInput>;
  /** Input to filter by `CardProduct` ID. */
  productId?: InputMaybe<IdFilterInput>;
};

/** The payment card transaction dispute. */
export type PaymentCardTransactionDispute = Node & {
  __typename?: "PaymentCardTransactionDispute";
  /** The disputed amount. */
  amount?: Maybe<Amount>;
  /** The category type of the dispute. */
  category?: Maybe<PaymentCardDisputeCategoryType>;
  /** The chargebacks for the dispute. */
  chargebacks?: Maybe<Array<PaymentCardTransactionChargeback>>;
  /** The date and time, in ISO 8601 format, this dispute was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The customer claim type of the dispute. */
  customerClaimType?: Maybe<PaymentCardDisputeCustomerClaimType>;
  /** The customer contact information of the dispute. */
  customerContact?: Maybe<PaymentCardDisputeCustomerContact>;
  /** The date, in YYYY-MM-DD format, from which this dispute is initiated by the customer. */
  customerInitiatedOn?: Maybe<Scalars["String"]>;
  /** The payment card transaction credit status for the dispute. */
  disputeCreditHistory?: Maybe<Array<PaymentCardTransactionDisputeCredit>>;
  /** The date and time, in ISO 8601 format, from which this dispute is effective. */
  fromDate?: Maybe<Scalars["String"]>;
  /** The Global ID of the dispute. */
  id: Scalars["ID"];
  /** Whether the issuer is liable for the dispute. */
  liability?: Maybe<PaymentCardDisputeLiability>;
  /** The payment card transaction provisional credit for the dispute. */
  provisionalCreditHistory?: Maybe<
    Array<PaymentCardTransactionDisputeProvisionalCredit>
  >;
  /** The status of the dispute. */
  status?: Maybe<PaymentCardDisputeStatus>;
  /** The subscriber note of the dispute. */
  subscriberNote?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, through which this dispute is effective. */
  throughDate?: Maybe<Scalars["String"]>;
  /** The payment card transaction event for the dispute. */
  transactionEvent?: Maybe<TransactionEvent>;
  /** The date and time, in ISO 8601 format, this dispute was most recently updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The connection type for a `PaymentCardTransactionDispute`. */
export type PaymentCardTransactionDisputeConnection = {
  __typename?: "PaymentCardTransactionDisputeConnection";
  /** A list of edges. */
  edges?: Maybe<Array<PaymentCardTransactionDisputeEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The possible return types of `PaymentCardTransactionDisputeConnectionPayload`. */
export type PaymentCardTransactionDisputeConnectionPayload =
  | AccessDeniedError
  | PaymentCardTransactionDisputeConnection
  | UserError;

/** The payment card transaction dispute credit. */
export type PaymentCardTransactionDisputeCredit = {
  __typename?: "PaymentCardTransactionDisputeCredit";
  /** The date and time, in ISO 8601 format, from which this dispute credit is created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The amount for the dispute credit. */
  creditAmount?: Maybe<Amount>;
  /** The credit status of the dispute credit. */
  creditStatus?: Maybe<PaymentCardDisputeCreditStatus>;
  /** The date and time, in ISO 8601 format, from which this dispute credit is updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The edge type for the `PaymentCardTransactionDispute`. */
export type PaymentCardTransactionDisputeEdge = {
  __typename?: "PaymentCardTransactionDisputeEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The payment card transaction dispute. */
  node?: Maybe<PaymentCardTransactionDispute>;
};

/** The possible return types of `PaymentCardTransactionDisputePayload`. */
export type PaymentCardTransactionDisputePayload =
  | AccessDeniedError
  | PaymentCardTransactionDispute
  | UserError;

/** The payment card transaction chargeback credit. */
export type PaymentCardTransactionDisputeProvisionalCredit = {
  __typename?: "PaymentCardTransactionDisputeProvisionalCredit";
  /** The date and time, in ISO 8601 format, from which this chargeback credit is created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The amount for the chargeback credit. */
  creditAmount?: Maybe<Amount>;
  /** The credit status of the dispute credit. */
  creditStatus?: Maybe<PaymentCardProvisionalCreditStatus>;
  /** The date and time, in ISO 8601 format, from which this chargeback credit is updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Input for filtering `PaymentCardTransactionDispute` */
export type PaymentCardTransactionDisputesFilterInput = {
  /** Input to filter by `FinancialAccount` ID. */
  accountId?: InputMaybe<IdFilterInput>;
  /** Input to filter by `PaymentCardTransactionChargeback` created date. */
  chargebackCreatedAt?: InputMaybe<TimestampFilterInput>;
  /** Input to filter by `PaymentCardTransactionChargeback` ID. */
  chargebackId?: InputMaybe<IdFilterInput>;
  /** Input to filter by `PaymentCardTransactionChargeback` status. */
  chargebackStatus?: InputMaybe<PaymentCardChargebackStatusFilterInput>;
  /** Input to filter by `PaymentCardTransactionDispute` created date. */
  disputeCreatedAt?: InputMaybe<TimestampFilterInput>;
  /** Input to filter disputes by whether a `PaymentCardTransactionDispute` has an associated `PaymentCardTransactionChargeback`. */
  disputeHasChargeback?: InputMaybe<BooleanFilterInput>;
  /** Input to filter by `PaymentCardTransactionDispute` ID. */
  disputeId?: InputMaybe<IdFilterInput>;
  /** Input to filter by `PaymentCardTransactionDispute` status. */
  disputeStatus?: InputMaybe<PaymentCardDisputeStatusFilterInput>;
  /** Chargeback externalNetworkId filter */
  externalNetworkId?: InputMaybe<StringFilterInput>;
  /** Input to filter by `CardProduct` ID. */
  productId?: InputMaybe<IdFilterInput>;
};

export type PaymentCardTransactionEvent = {
  /** ID of the account holder for the card account. */
  accountHolderId?: Maybe<Scalars["ID"]>;
  /**
   * The direction funds are moving in the perspective of the cardholder.
   *
   * * when DEBIT, funds are moving out of the cardholder's account
   * * when CREDIT, funds are moving into the cardholder's account
   */
  accountingDirection?: Maybe<AccountingDirection>;
  /** Network specific transaction data. */
  additionalNetworkData?: Maybe<AdditionalNetworkData>;
  /** The `Amount` approved for this `PaymentCardTransactionEvent` and posted in the settlement currency. Does not include fees. */
  approvedAmount?: Maybe<Amount>;
  /** Code representing the result of AVS address verification. */
  avsResponseCode?: Maybe<AvsResponseCode>;
  /** ID of the payment card. */
  cardId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, this `AuthorizationEvent` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** `Amount` available to spend after this transaction event. */
  currentFinancialAccountAvailableToSpendAmount?: Maybe<Amount>;
  /** Maximum balance allowed for the card account at the time of this transaction event. */
  currentFinancialAccountMaximumBalanceAmount?: Maybe<Amount>;
  /** Code representing the result of CVV (security code) verification. */
  cvvResponseCode?: Maybe<CvvResponseCode>;
  /** Fees applied to the transaction, if any. */
  fees?: Maybe<Array<TransactionFee>>;
  /** ID of the financial account. */
  financialAccountId?: Maybe<Scalars["ID"]>;
  /** The details about the merchant who requested the authorization. */
  merchantDetails?: Maybe<MerchantDetails>;
  /** The original `Amount` of this `PaymentCardTransactionEvent`. */
  originalAmount?: Maybe<Amount>;
  /** Code representing the result of PIN verification. */
  pinResponseCode?: Maybe<PinResponseCode>;
  /** The Point Of Service Details. */
  pointOfServiceDetails?: Maybe<PointOfServiceDetails>;
  /** Code representing the result of AVS postal code verification. */
  postalCodeResponseCode?: Maybe<PostalCodeResponseCode>;
  /** The `Amount` requested to be approved for this `PaymentCardTransactionEvent` and displayed in the transaction's (local) currency. Does not include fees. */
  requestedAmount?: Maybe<Amount>;
  /** The Highnote response code. */
  responseCode?: Maybe<TransactionEventResponseCode>;
  /** ID of the transaction. */
  transactionId?: Maybe<Scalars["ID"]>;
  /** Represents the customer transaction type being processed. */
  transactionProcessingType?: Maybe<CardTransactionProcessingType>;
};

/** Inputs for filtering transaction events. */
export type PaymentCardTransactionEventsFilterInput = {
  approvedAmount?: InputMaybe<MoneyFilterInput>;
  /** Authorization expiration date */
  authorizationExpiration?: InputMaybe<TimestampFilterInput>;
  avsResponseCode?: InputMaybe<AvsResponseCodeFilterInput>;
  createdAt?: InputMaybe<TimestampFilterInput>;
  cvvResponseCode?: InputMaybe<CvvResponseCodeFilterInput>;
  eventType?: InputMaybe<TransactionEventFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  merchantDetails?: InputMaybe<MerchantDetailsFilterInput>;
  /**
   * Open authorizations events have the following properties:
   * * Are the first transaction event with a particular public transaction
   * identifier. This means they are the first event in a sequence of events with
   * the same public transaction identifier.
   * * Authorization expiration date is not empty and not in the past.
   * * The approved amount has not been fully reversed or cleared to zero by
   * subsequent transaction events with the same public transaction identifier.
   */
  onlyOpenAuthorizations?: InputMaybe<BooleanFilterInput>;
  operationalCurrency?: InputMaybe<Iso4217Alpha3CurrencyCode>;
  paymentCardId?: InputMaybe<IdFilterInput>;
  postalCodeResponseCode?: InputMaybe<PostalCodeResponseCodeFilterInput>;
  requestedAmount?: InputMaybe<MoneyFilterInput>;
  responseCode?: InputMaybe<TransactionEventResponseCodeFilterInput>;
  transactionId?: InputMaybe<IdFilterInput>;
  transactionType?: InputMaybe<TransactionTypeFilterInput>;
  updatedAt?: InputMaybe<TimestampFilterInput>;
};

/** The PaymentCardUnsuspendedEvent is triggered when a Payment Card has been unsuspended. */
export type PaymentCardUnsuspendedEvent = Node &
  PaymentCardEvent & {
    __typename?: "PaymentCardUnsuspendedEvent";
    /** The Bank Identification Number of the Payment Card. Usually the first 6 digits of the primary account number (PAN). */
    bin?: Maybe<Scalars["String"]>;
    /** The Card Product ID associated to the Payment Card. */
    cardProductId?: Maybe<Scalars["ID"]>;
    /** The exact date and time the payment card expires. */
    expirationDate?: Maybe<Scalars["String"]>;
    /** Whether the card is PHYSICAL or VIRTUAL */
    formFactor?: Maybe<CardFormFactor>;
    /** Global ID used to reference the Payment Card in operations. */
    id: Scalars["ID"];
    /** The last four digits of the primary account number (PAN). */
    last4?: Maybe<Scalars["String"]>;
    /** The card network that issued the Payment Card. */
    network?: Maybe<PaymentCardNetwork>;
    /** The authorized user of this `PaymentCard`. */
    paymentCardHolder?: Maybe<PaymentCardHolder>;
    /** The previous status of the Payment Card. */
    previousStatus?: Maybe<PaymentCardStatus>;
    /** The current status of the Payment Card. */
    status?: Maybe<PaymentCardStatus>;
    /** The date and time, in ISO 8601 format that the status of the Payment Card was updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** The result of a verification check ran against a payment card. */
export type PaymentCardVerification = {
  __typename?: "PaymentCardVerification";
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The result of the verification ran on the payment card. */
  responseCode?: Maybe<PaymentCardVerificationResponseCode>;
  /** The `PaymentDebitTransactionSummary` associated with this verification. */
  transaction?: Maybe<PaymentDebitTransactionSummary>;
};

/** PaymentCardVerificationApprovedEvent indicates that a PaymentCard Transaction Verification has been approved. */
export type PaymentCardVerificationApprovedEvent = Node &
  PaymentCardTransactionEvent & {
    __typename?: "PaymentCardVerificationApprovedEvent";
    /** ID of the account holder for the card account. */
    accountHolderId?: Maybe<Scalars["ID"]>;
    /**
     * The direction funds are moving in the perspective of the cardholder.
     *
     * * when DEBIT, funds are moving out of the cardholder's account
     * * when CREDIT, funds are moving into the cardholder's account
     */
    accountingDirection?: Maybe<AccountingDirection>;
    /** Network specific transaction data. */
    additionalNetworkData?: Maybe<AdditionalNetworkData>;
    /** The `Amount` verified for this `PaymentCardVerificationApprovedEvent` and posted in the settlement currency. Does not include fees. */
    approvedAmount?: Maybe<Amount>;
    /** Code representing the result of AVS address verification. */
    avsResponseCode?: Maybe<AvsResponseCode>;
    /** ID of the payment card. */
    cardId?: Maybe<Scalars["ID"]>;
    /** The date and time, in ISO 8601 format, this `PaymentCardVerificationApprovedEvent` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** `Amount` available to spend after this transaction event. */
    currentFinancialAccountAvailableToSpendAmount?: Maybe<Amount>;
    /** Maximum balance allowed for the card account at the time of this transaction event. */
    currentFinancialAccountMaximumBalanceAmount?: Maybe<Amount>;
    /** Code representing the result of CVV (security code) verification. */
    cvvResponseCode?: Maybe<CvvResponseCode>;
    /** Fees applied to the transaction, if any. */
    fees?: Maybe<Array<TransactionFee>>;
    /** ID of the financial account. */
    financialAccountId?: Maybe<Scalars["ID"]>;
    /** The ID of the transaction event. This `id` can be used to later retrieve details of this `PaymentCardVerificationApprovedEvent` or correlate it with other events on this `Transaction`. */
    id: Scalars["ID"];
    /** The details about the merchant who requested the authorization. */
    merchantDetails?: Maybe<MerchantDetails>;
    /** The original `Amount` of this `PaymentCardVerificationApprovedEvent`. */
    originalAmount?: Maybe<Amount>;
    /** A snapshot of the `PaymentCard` at the time of the `PaymentCardTransactionEvent`. */
    paymentCardSnapshot?: Maybe<PaymentCardSnapshot>;
    /** Code representing the result of PIN verification. */
    pinResponseCode?: Maybe<PinResponseCode>;
    /** The Point Of Service Details. */
    pointOfServiceDetails?: Maybe<PointOfServiceDetails>;
    /** Code representing the result of AVS postal code verification. */
    postalCodeResponseCode?: Maybe<PostalCodeResponseCode>;
    /** The `Amount` requested to be verified for this `PaymentCardVerificationApprovedEvent` and displayed in the transaction's (local) currency. Does not include fees. */
    requestedAmount?: Maybe<Amount>;
    /** The Highnote response code. */
    responseCode?: Maybe<TransactionEventResponseCode>;
    /** ID of the transaction. */
    transactionId?: Maybe<Scalars["ID"]>;
    /** Represents the customer transaction type being processed. */
    transactionProcessingType?: Maybe<CardTransactionProcessingType>;
  };

/** PaymentCardVerificationDeclinedEvent indicates that a PaymentCard Transaction Verification has been declined. */
export type PaymentCardVerificationDeclinedEvent = Node &
  PaymentCardTransactionEvent & {
    __typename?: "PaymentCardVerificationDeclinedEvent";
    /** ID of the account holder for the card account. */
    accountHolderId?: Maybe<Scalars["ID"]>;
    /**
     * The direction funds are moving in the perspective of the cardholder.
     *
     * * when DEBIT, funds are moving out of the cardholder's account
     * * when CREDIT, funds are moving into the cardholder's account
     */
    accountingDirection?: Maybe<AccountingDirection>;
    /** Network specific transaction data. */
    additionalNetworkData?: Maybe<AdditionalNetworkData>;
    /** The `Amount` verified for this `PaymentCardVerificationDeclinedEvent` and posted in the settlement currency. Does not include fees. */
    approvedAmount?: Maybe<Amount>;
    /** Code representing the result of AVS address verification. */
    avsResponseCode?: Maybe<AvsResponseCode>;
    /** ID of the payment card. */
    cardId?: Maybe<Scalars["ID"]>;
    /** The date and time, in ISO 8601 format, this `PaymentCardVerificationDeclinedEvent` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** `Amount` available to spend after this transaction event. */
    currentFinancialAccountAvailableToSpendAmount?: Maybe<Amount>;
    /** Maximum balance allowed for the card account at the time of this transaction event. */
    currentFinancialAccountMaximumBalanceAmount?: Maybe<Amount>;
    /** Code representing the result of CVV (security code) verification. */
    cvvResponseCode?: Maybe<CvvResponseCode>;
    /** Fees applied to the transaction, if any. */
    fees?: Maybe<Array<TransactionFee>>;
    /** ID of the financial account. */
    financialAccountId?: Maybe<Scalars["ID"]>;
    /** The ID of the transaction event. This `id` can be used to later retrieve details of this `PaymentCardVerificationDeclinedEvent` or correlate it with other events on this `Transaction`. */
    id: Scalars["ID"];
    /** The details about the merchant who requested the authorization. */
    merchantDetails?: Maybe<MerchantDetails>;
    /** The original `Amount` of this `PaymentCardVerificationDeclinedEvent`. */
    originalAmount?: Maybe<Amount>;
    /** A snapshot of the `PaymentCard` at the time of the `PaymentCardTransactionEvent`. */
    paymentCardSnapshot?: Maybe<PaymentCardSnapshot>;
    /** Code representing the result of PIN verification. */
    pinResponseCode?: Maybe<PinResponseCode>;
    /** The Point Of Service Details. */
    pointOfServiceDetails?: Maybe<PointOfServiceDetails>;
    /** Code representing the result of AVS postal code verification. */
    postalCodeResponseCode?: Maybe<PostalCodeResponseCode>;
    /** The `Amount` requested to be verified for this `PaymentCardVerificationDeclinedEvent`. */
    requestedAmount?: Maybe<Amount>;
    /** The Highnote response code. */
    responseCode?: Maybe<TransactionEventResponseCode>;
    /** ID of the transaction. */
    transactionId?: Maybe<Scalars["ID"]>;
    /** Represents the customer transaction type being processed. */
    transactionProcessingType?: Maybe<CardTransactionProcessingType>;
  };

/** Response codes for a payment card verification. */
export type PaymentCardVerificationResponseCode = {
  __typename?: "PaymentCardVerificationResponseCode";
  /** The address code response code for this verification. */
  addressCode?: Maybe<PaymentTransactionAddressCodeResponseCode>;
  /** The postal code response code for this verification. */
  postalCode?: Maybe<PaymentTransactionPostalCodeResponseCode>;
  /** The response code from the processor for this verification. */
  processorResponseCode?: Maybe<PaymentTransactionResponseCodeProcessorResponseCode>;
  /** The security code response code for this verification. */
  securityCode?: Maybe<PaymentTransactionSecurityCodeResponseCode>;
};

/** A payment transaction for a refund. This is a record of a payment being refunded. */
export type PaymentCreditTransaction = Node &
  PaymentTransaction & {
    __typename?: "PaymentCreditTransaction";
    /**
     * The direction funds are moving in the perspective of the customer.
     *
     * For a `PaymentCreditTransaction`, this will always be `CREDIT`.
     */
    accountingDirection?: Maybe<AccountingDirection>;
    /** The total amount authorized for this `PaymentTransaction`. */
    authorizedAmount?: Maybe<Amount>;
    /** The total authorized amount remaining for this `PaymentTransaction`. */
    authorizedRemainingAmount?: Maybe<Amount>;
    /** The total authorized amount that has been canceled for this `PaymentTransaction`. */
    canceledAmount?: Maybe<Amount>;
    /** The total amount captured for this `PaymentTransaction`. */
    capturedAmount?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, this object was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The total amount disbursed for this `PaymentTransaction`. */
    disbursedAmount?: Maybe<Amount>;
    /** Events that have occurred on this `PaymentTransaction`. */
    events?: Maybe<Array<PaymentTransactionEvent>>;
    /** The fee breakdown for this `PaymentTransaction`. */
    fees?: Maybe<Array<PaymentTransactionFee>>;
    /** Global ID used to reference this object. */
    id: Scalars["ID"];
    /** The payment instrument used for the `PaymentTransaction`. Instrument data can be used to display information to the user without violating PCI compliance. */
    instrument?: Maybe<PaymentInstrument>;
    /** The originating `PaymentOrder` that this transaction was initiated from. */
    order?: Maybe<PaymentOrder>;
    /** The originating `PaymentDebitTransaction` that this refund was initiated from. */
    originatedPaymentTransaction?: Maybe<PaymentDebitTransaction>;
    /** Include additional information regarding the refund for tracking and analysis */
    refundNote?: Maybe<Scalars["String"]>;
    /** The reason why the `PaymentTransaction` was refunded to the original payment method */
    refundReason?: Maybe<PaymentCreditTransactionRefundReason>;
    /** The total amount refunded for this `PaymentTransaction`. */
    refundedAmount?: Maybe<Amount>;
    /** The total authorization amount requested for this `PaymentTransaction`. */
    requestedAuthorizationAmount?: Maybe<Amount>;
    /** The response codes for this `PaymentTransaction`. */
    responseCode?: Maybe<PaymentTransactionResponseCode>;
    /** The total amount settled for this `PaymentTransaction`. */
    settledAmount?: Maybe<Amount>;
    /** The status of this `PaymentTransaction`. */
    status?: Maybe<PaymentTransactionStatus>;
    /** Lifecycle steps that have occurred on this `PaymentTransaction`. */
    steps?: Maybe<Array<PaymentTransactionLifecycleStep>>;
    /** The total amount of fees associated with this `PaymentTransaction`. */
    totalFeeAmount?: Maybe<Amount>;
    /** The total payable amount for this `PaymentTransaction`. */
    totalPayableAmount?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, this object was updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** The reason why the `PaymentTransaction` was refunded to the original payment method */
export enum PaymentCreditTransactionRefundReason {
  /** The transaction was refunded at the behest of the customer. */
  CUSTOMER_REQUESTED = "CUSTOMER_REQUESTED",
  /** The transaction was refunded since it was a duplicate of a previous transaction. */
  DUPLICATE_TRANSACTION = "DUPLICATE_TRANSACTION",
  /** The transaction was refunded due the determination that the payment was fraudulent. */
  FRAUD = "FRAUD",
  /** The transaction was refunded as the payment was directed to the wrong recipient. */
  INCORRECT_RECIPIENT = "INCORRECT_RECIPIENT",
  /** The transaction was refunded for another reason. */
  OTHER = "OTHER",
}

export type PaymentCreditTransactionSummary = PaymentTransactionSummary & {
  __typename?: "PaymentCreditTransactionSummary";
  /**
   * The direction funds are moving in the perspective of the customer.
   * * when DEBIT, funds are moving out of the customer's account
   * * when CREDIT, funds are moving into the customer's account
   */
  accountingDirection?: Maybe<AccountingDirection>;
  /** The total amount authorized for this `PaymentTransaction`. */
  authorizedAmount?: Maybe<Amount>;
  /** The total authorized amount remaining for this `PaymentTransaction`. */
  authorizedRemainingAmount?: Maybe<Amount>;
  /** The total authorized amount that has been canceled for this `PaymentTransaction`. */
  canceledAmount?: Maybe<Amount>;
  /** The total amount captured for this `PaymentTransaction`. */
  capturedAmount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The total amount disbursed for this `PaymentTransaction`. */
  disbursedAmount?: Maybe<Amount>;
  /** Global ID used to reference this object. */
  id: Scalars["ID"];
  /** The payment instrument used for the `PaymentTransaction`. Instrument data can be used to display information to the user without violating PCI compliance. */
  instrument?: Maybe<PaymentInstrument>;
  /** The ID for the originating `PaymentDebitTransaction` that this refund was initiated from. */
  originatedPaymentTransactionId: Scalars["ID"];
  /** Include additional information regarding the refund for tracking and analysis */
  refundNote?: Maybe<Scalars["String"]>;
  /** The reason why the `PaymentCreditTransaction` was refunded to the original payment method */
  refundReason?: Maybe<PaymentCreditTransactionRefundReason>;
  /** The total amount refunded for this `PaymentTransaction`. */
  refundedAmount?: Maybe<Amount>;
  /** The total authorization amount requested for this `PaymentTransaction`. */
  requestedAuthorizationAmount?: Maybe<Amount>;
  /** The response codes for this `PaymentTransaction`. */
  responseCode?: Maybe<PaymentTransactionResponseCode>;
  /** The total amount settled for this `PaymentTransaction`. */
  settledAmount?: Maybe<Amount>;
};

/** A payment transaction for a purchase. This is a record of a payment being made. */
export type PaymentDebitTransaction = Node &
  PaymentTransaction & {
    __typename?: "PaymentDebitTransaction";
    /**
     * The direction funds are moving in the perspective of the customer.
     *
     * For a `PaymentDebitTransaction`, this will always be `DEBIT`.
     */
    accountingDirection?: Maybe<AccountingDirection>;
    /** The total amount authorized for this `PaymentTransaction`. */
    authorizedAmount?: Maybe<Amount>;
    /** The total authorized amount remaining for this `PaymentTransaction`. */
    authorizedRemainingAmount?: Maybe<Amount>;
    /** The total authorized amount that has been canceled for this `PaymentTransaction`. */
    canceledAmount?: Maybe<Amount>;
    /** The total amount captured for this `PaymentTransaction`. */
    capturedAmount?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, this object was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The total amount disbursed for this `PaymentTransaction`. */
    disbursedAmount?: Maybe<Amount>;
    /** Events that have occurred on this `PaymentTransaction`. */
    events?: Maybe<Array<PaymentTransactionEvent>>;
    /** The fee breakdown for this `PaymentTransaction`. */
    fees?: Maybe<Array<PaymentTransactionFee>>;
    /** Global ID used to reference this object. */
    id: Scalars["ID"];
    /** Installment payment information for merchant-managed installment payments. */
    installmentPayment?: Maybe<MerchantManagedInstallmentPayment>;
    /** The payment instrument used for the `PaymentTransaction`. Instrument data can be used to display information to the user without violating PCI compliance. */
    instrument?: Maybe<PaymentInstrument>;
    /** The Network Transaction ID for this `PaymentTransaction`. */
    networkTransactionIdentifier?: Maybe<Scalars["String"]>;
    /** The originating `PaymentOrder` that this transaction was initiated from. */
    order?: Maybe<PaymentOrder>;
    /** The total amount refunded for this `PaymentTransaction`. */
    refundedAmount?: Maybe<Amount>;
    /** Any refunds that were initiated from this PaymentTransaction. */
    refunds?: Maybe<Array<PaymentCreditTransaction>>;
    /** The total authorization amount requested for this `PaymentTransaction`. */
    requestedAuthorizationAmount?: Maybe<Amount>;
    /** The response codes for this `PaymentTransaction`. */
    responseCode?: Maybe<PaymentTransactionResponseCode>;
    /** The total amount settled for this `PaymentTransaction`. */
    settledAmount?: Maybe<Amount>;
    /** The status of this `PaymentTransaction`. */
    status?: Maybe<PaymentTransactionStatus>;
    /** Lifecycle steps that have occurred on this `PaymentTransaction`. */
    steps?: Maybe<Array<PaymentTransactionLifecycleStep>>;
    /** The total amount of fees associated with this `PaymentTransaction`. */
    totalFeeAmount?: Maybe<Amount>;
    /** The total payable amount for this `PaymentTransaction`. */
    totalPayableAmount?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, this object was updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

export type PaymentDebitTransactionSummary = PaymentTransactionSummary & {
  __typename?: "PaymentDebitTransactionSummary";
  /**
   * The direction funds are moving in the perspective of the customer.
   * * when DEBIT, funds are moving out of the customer's account
   * * when CREDIT, funds are moving into the customer's account
   */
  accountingDirection?: Maybe<AccountingDirection>;
  /** The total amount authorized for this `PaymentTransaction`. */
  authorizedAmount?: Maybe<Amount>;
  /** The total authorized amount remaining for this `PaymentTransaction`. */
  authorizedRemainingAmount?: Maybe<Amount>;
  /** The total authorized amount that has been canceled for this `PaymentTransaction`. */
  canceledAmount?: Maybe<Amount>;
  /** The total amount captured for this `PaymentTransaction`. */
  capturedAmount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The total amount disbursed for this `PaymentTransaction`. */
  disbursedAmount?: Maybe<Amount>;
  /** Global ID used to reference this object. */
  id: Scalars["ID"];
  /** Installment payment information for merchant-managed installment payments. */
  installmentPayment?: Maybe<MerchantManagedInstallmentPayment>;
  /** The payment instrument used for the `PaymentTransaction`. Instrument data can be used to display information to the user without violating PCI compliance. */
  instrument?: Maybe<PaymentInstrument>;
  /** The Network Transaction ID for this `PaymentTransaction`. */
  networkTransactionIdentifier?: Maybe<Scalars["String"]>;
  /** The total amount refunded for this `PaymentTransaction`. */
  refundedAmount?: Maybe<Amount>;
  /** The total authorization amount requested for this `PaymentTransaction`. */
  requestedAuthorizationAmount?: Maybe<Amount>;
  /** The response codes for this `PaymentTransaction`. */
  responseCode?: Maybe<PaymentTransactionResponseCode>;
  /** The total amount settled for this `PaymentTransaction`. */
  settledAmount?: Maybe<Amount>;
};

/** The `PaymentInstruction` type defines where funds dirbused to, and the amount to disburse for an `PaymentOrderItem`. */
export type PaymentInstruction = {
  __typename?: "PaymentInstruction";
  /** The Highnote `Node` that funds will be disbursed to. */
  disburseTo?: Maybe<PaymentInstructionDisbursementTarget>;
  /**
   * The amount to disburse for this `PaymentOrderItem` by `Amount`, and the `FinancialAccount` to disburse to.
   *
   * Will be `null` if the payment instructions were provided as a percentage.
   */
  disbursementAmount?: Maybe<Amount>;
  /**
   * The amount to disburse for this `PaymentOrderItem` in percentage, and the `FinancialAccount` to disburse to.
   *
   * Will be `null` if the payment instructions were provided as an amount.
   */
  disbursementPercent?: Maybe<Scalars["Int"]>;
};

/** The `Node` types that `PaymentInstruction` can disburse funds to. */
export type PaymentInstructionDisbursementTarget = FinancialAccount;

/**
 * Allows for the specification of payment instructions for `PaymentOrder`s, which allows choice on how to disburse funds for each `PaymentOrderItem`.
 *
 * Must define either `disbursementPercent` or `disbursementAmount`, but not both.
 *
 * If choosing to specify an amount to disburse, the amount must be in the same currency as the `PaymentOrderItem` and all disbursementAmount must sum to the total amount of the `PaymentOrderItem`.
 * If choosing to specify a percentage to disburse, the sum of all disbursementPercent must equal 100.
 */
export type PaymentInstructionInput = {
  /** The Highnote `Node` ID to disburse funds to. This must be a Highnote `FinancialAccount`. */
  disburseToId: Scalars["ID"];
  /**
   * The amount to disburse for this `PaymentOrderItem`.
   *
   * The amount must be in the same currency as the `PaymentOrderItem` and all disbursementAmount must sum to the total amount of the `PaymentOrderItem`.
   */
  disbursementAmount?: InputMaybe<AmountInput>;
  /**
   * The amount to disburse for this `PaymentOrderItem` in percentage.
   *
   * Where `100` is 100% of the total amount of the `PaymentOrderItem`.
   */
  disbursementPercent?: InputMaybe<Scalars["Int"]>;
};

/** Used to represent the payment method data. */
export type PaymentInstrument = PaymentCardInstrument;

/** The Card Processing Network that will process a payment */
export enum PaymentMethod {
  /** Pay by credit or debit card */
  CARD = "CARD",
}

/** The connection type for Payment Method. */
export type PaymentMethodConnection = {
  __typename?: "PaymentMethodConnection";
  /** A list of edges. */
  edges?: Maybe<Array<PaymentMethodEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** Types to expect for payment method connection */
export type PaymentMethodConnectionPayload =
  | AccessDeniedError
  | PaymentMethodConnection
  | UserError;

/** The edge type for a Payment Method. */
export type PaymentMethodEdge = {
  __typename?: "PaymentMethodEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The Payment Method. */
  node?: Maybe<PaymentMethodVariant>;
};

/** A token representing a payment method. */
export type PaymentMethodToken = Node & {
  __typename?: "PaymentMethodToken";
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the payment method token will expire. */
  expiresAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference this object. */
  id: Scalars["ID"];
  /** The payment instrument used for the `PaymentMethodToken`. Instrument data can be used to display information to the user without violating PCI compliance. */
  instrument?: Maybe<PaymentInstrument>;
  /** A short lived scoped payment method token for the `PaymentMethodToken`. */
  token?: Maybe<ScopedPaymentMethodTokenPayload>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** How many times this `PaymentMethodToken` can be used. */
  usage?: Maybe<PaymentMethodTokenUsage>;
};

/** A token representing a payment method. */
export type PaymentMethodTokenTokenArgs = {
  scope: TokenScope;
};

/** How many times this `PaymentMethodToken` can be used. */
export enum PaymentMethodTokenUsage {
  /** This `PaymentMethodToken` can be used multiple times. */
  REUSABLE = "REUSABLE",
  /** This `PaymentMethodToken` can only be used once and then becomes invalid. */
  SINGLE_USE = "SINGLE_USE",
}

/** Possible payment method types. */
export enum PaymentMethodType {
  /** Payment card based payment method. */
  PAYMENT_CARD = "PAYMENT_CARD",
}

/** The input to filter by payment method type. */
export type PaymentMethodTypeInput = {
  /** Value matches the provided payment method type. */
  equals?: InputMaybe<PaymentMethodType>;
};

/** Types which can be returned while fetching payment method. */
export type PaymentMethodVariant = PaymentMethodToken;

/** An `PaymentOrder` is used to represent a collection of items that a customer wants to purchase. */
export type PaymentOrder = Node & {
  __typename?: "PaymentOrder";
  /** Global ID used to reference this object. */
  id: Scalars["ID"];
  /** Line items associated with this `PaymentOrder`. */
  lineItems?: Maybe<Array<PaymentOrderLineItem>>;
  /** The total amount for this `PaymentOrder`. This is the amount that the customer will be charged. */
  totalAmount?: Maybe<Amount>;
  /** `PaymentTransaction`s associated with this `PaymentOrder`. */
  transactions?: Maybe<Array<PaymentTransaction>>;
};

export type PaymentOrderItem = {
  /** The amount for this `PaymentOrderItem` per individual item. */
  amountPerItem?: Maybe<Amount>;
  /** The product description for this `PaymentOrderItem`. */
  description?: Maybe<Scalars["String"]>;
  /** An optional external reference ID for this `PaymentOrderItem`. */
  externalIdentifier?: Maybe<Scalars["String"]>;
  /** The product name for this `PaymentOrderItem`. */
  name?: Maybe<Scalars["String"]>;
  /** Breakdown of the payment instructions for the `PaymentOrderItem` by `Amount`. */
  paymentInstructions?: Maybe<Array<PaymentInstruction>>;
};

/** A catalog item that is added to an `PaymentOrder`. */
export type PaymentOrderItemFromCatalogItem = PaymentOrderItem & {
  __typename?: "PaymentOrderItemFromCatalogItem";
  /** The amount for this `PaymentOrderItemFromCatalogItem` per individual item. */
  amountPerItem?: Maybe<Amount>;
  /** Reference to the original `CatalogItem` for this `PaymentOrderItemFromCatalogItem`. */
  catalogItem?: Maybe<CatalogItem>;
  /** The product description for this `PaymentOrderItemFromCatalogItem`. */
  description?: Maybe<Scalars["String"]>;
  /** An optional external reference ID for this `PaymentOrderItem`. */
  externalIdentifier?: Maybe<Scalars["String"]>;
  /** The product name for this `PaymentOrderItemFromCatalogItem`. */
  name?: Maybe<Scalars["String"]>;
  /** Breakdown of the payment instructions for the `PaymentOrderItemFromCatalogItem` by `Amount`. */
  paymentInstructions?: Maybe<Array<PaymentInstruction>>;
};

/** Input for creating a new `PaymentOrderItemFromCatalogItem`. */
export type PaymentOrderItemFromCatalogItemInput = {
  /** Overwritten amount for this `PaymentOrderItemFromCatalogItem` per individual item. */
  amountPerItem?: InputMaybe<AmountInput>;
  /**
   * Overwrite the product description for this `PaymentOrderItemFromCustomItem`.
   *
   * Supports up to 255 alphanumeric characters.
   */
  description?: InputMaybe<Scalars["String"]>;
  /**
   * An optional external reference ID for this `PaymentOrderItemFromCatalogItem`.
   *
   * Supports up to 255 alphanumeric characters.
   */
  externalIdentifier?: InputMaybe<Scalars["String"]>;
  /** The `CatalogItem` ID to add to the `PaymentOrder`. */
  id: Scalars["ID"];
  /**
   * Overwrite product name for this `PaymentOrderItemFromCustomItem`.
   *
   * Supports up to 255 alphanumeric characters.
   */
  name?: InputMaybe<Scalars["String"]>;
  /** Specifies the payment instructions for this `PaymentOrderItemFromCatalogItem`. */
  paymentInstructions?: InputMaybe<Array<PaymentInstructionInput>>;
  /** The quantity of the this `PaymentOrderItemFromCatalogItem`. */
  quantity: Scalars["UnsignedInt"];
};

/** A custom one time item that is added to an `PaymentOrder`. These are one-off items defined at the time the order is created. They cannot be queried outside of the `PaymentOrder`. */
export type PaymentOrderItemFromCustomItem = PaymentOrderItem & {
  __typename?: "PaymentOrderItemFromCustomItem";
  /** The amount for this `PaymentOrderItemFromCustomItem` per individual item. */
  amountPerItem?: Maybe<Amount>;
  /** The product description for this `PaymentOrderItemFromCustomItem`. */
  description?: Maybe<Scalars["String"]>;
  /** An optional external reference ID for this `PaymentOrderItem`. */
  externalIdentifier?: Maybe<Scalars["String"]>;
  /** The product name for this `PaymentOrderItemFromCustomItem`. */
  name?: Maybe<Scalars["String"]>;
  /** Breakdown of the payment instructions for the `PaymentOrderItemFromCustomItem` by `Amount`. */
  paymentInstructions?: Maybe<Array<PaymentInstruction>>;
};

/** Input for creating a new `PaymentOrderItemFromCustomItem`. */
export type PaymentOrderItemFromCustomItemInput = {
  /** The amount for this `PaymentOrderItemFromCustomItem` per individual item. */
  amountPerItem: AmountInput;
  /**
   * The product description for this `PaymentOrderItemFromCustomItem`.
   *
   * Supports up to 255 alphanumeric characters.
   */
  description?: InputMaybe<Scalars["String"]>;
  /**
   * An optional external reference ID for this `PaymentOrderItemFromCustomItem`.
   *
   * Supports up to 255 alphanumeric characters.
   */
  externalIdentifier?: InputMaybe<Scalars["String"]>;
  /**
   * The product name for this `PaymentOrderItemFromCustomItem`.
   *
   * Supports up to 255 alphanumeric characters.
   */
  name: Scalars["String"];
  /** Specifies the payment instructions for this `PaymentOrderItemFromCustomItem`. */
  paymentInstructions?: InputMaybe<Array<PaymentInstructionInput>>;
  /** The quantity of the this `PaymentOrderItemFromCustomItem`. */
  quantity: Scalars["UnsignedInt"];
};

/** The `PaymentOrderLineItem` type defines an item and the quantity of that item for an `PaymentOrder`. */
export type PaymentOrderLineItem = {
  __typename?: "PaymentOrderLineItem";
  /** Reference to the item for this `PaymentOrderLineItem`. */
  item?: Maybe<PaymentOrderItem>;
  /** The quantity of the item for this `PaymentOrderLineItem`. */
  quantity?: Maybe<Scalars["UnsignedInt"]>;
};

/** A payment transaction. This is a record of a payment being made. */
export type PaymentTransaction = {
  /**
   * The direction funds are moving in the perspective of the customer.
   * * when DEBIT, funds are moving out of the customer's account
   * * when CREDIT, funds are moving into the customer's account
   */
  accountingDirection?: Maybe<AccountingDirection>;
  /** The total amount authorized for this `PaymentTransaction`. */
  authorizedAmount?: Maybe<Amount>;
  /** The total authorized amount remaining for this `PaymentTransaction`. */
  authorizedRemainingAmount?: Maybe<Amount>;
  /** The total authorized amount that has been canceled for this `PaymentTransaction`. */
  canceledAmount?: Maybe<Amount>;
  /** The total amount captured for this `PaymentTransaction`. */
  capturedAmount?: Maybe<Amount>;
  /** The date and time, in ISO 8602 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The total amount disbursed for this `PaymentTransaction`. */
  disbursedAmount?: Maybe<Amount>;
  /** Events that have occurred on this `PaymentTransaction`. */
  events?: Maybe<Array<PaymentTransactionEvent>>;
  /** The fee breakdown for this `PaymentTransaction`. */
  fees?: Maybe<Array<PaymentTransactionFee>>;
  /** Global ID used to reference this object. */
  id: Scalars["ID"];
  /** The payment instrument used for the `PaymentTransaction`. Instrument data can be used to display information to the user without violating PCI compliance. */
  instrument?: Maybe<PaymentInstrument>;
  /** The originating `PaymentOrder` that this transaction was initiated from. */
  order?: Maybe<PaymentOrder>;
  /** The total amount refunded for this `PaymentTransaction`. */
  refundedAmount?: Maybe<Amount>;
  /** The total authorization amount requested for this `PaymentTransaction`. */
  requestedAuthorizationAmount?: Maybe<Amount>;
  /** The response codes for this `PaymentTransaction`. */
  responseCode?: Maybe<PaymentTransactionResponseCode>;
  /** The total amount settled for this `PaymentTransaction`. */
  settledAmount?: Maybe<Amount>;
  /** The status of this `PaymentTransaction`. */
  status?: Maybe<PaymentTransactionStatus>;
  /** Lifecycle steps that have occurred on this `PaymentTransaction`. */
  steps?: Maybe<Array<PaymentTransactionLifecycleStep>>;
  /** The total amount of fees associated with this `PaymentTransaction`. */
  totalFeeAmount?: Maybe<Amount>;
  /** The total payable amount for this `PaymentTransaction`. */
  totalPayableAmount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Possible values for the `PaymentTransactionAccountNameVerificationResponseCode` enum. */
export enum PaymentTransactionAccountNameVerificationResponseCode {
  /** The name does match the processor's records. */
  MATCHED = "MATCHED",
  /** The name verification was not applicable for this transaction. */
  NOT_APPLICABLE = "NOT_APPLICABLE",
  /** The name does not match the processor's records. */
  NOT_MATCHED = "NOT_MATCHED",
  /** The name was not provided for verification. */
  NOT_PROVIDED = "NOT_PROVIDED",
  /** The name partially matches the processor's records. */
  PARTIALLY_MATCHED = "PARTIALLY_MATCHED",
}

/** Possible values for the `PaymentTransactionAddressCodeResponseCode` enum. */
export enum PaymentTransactionAddressCodeResponseCode {
  /** The address does match the processor's records. */
  MATCHED = "MATCHED",
  /** The address does not match the processor's records. */
  NOT_MATCHED = "NOT_MATCHED",
  /** The address was not provided at the time of the transaction. */
  NOT_PROVIDED = "NOT_PROVIDED",
  /** The address check was not verified by the processor. */
  NOT_VERIFIED = "NOT_VERIFIED",
  /** The check was requested to be skipped in the API. */
  SKIPPED = "SKIPPED",
  /** The address was provided but the processor was unable to verify it. */
  UNKNOWN = "UNKNOWN",
}

/** Represents a synchronous payment event for an acquiring `PaymentTransaction`. */
export type PaymentTransactionEvent = {
  /**
   * The acquirer reference number associated with this event. This is a unique
   * identifier assigned by the acquiring processor to track the transaction.
   */
  acquirerReferenceNumber?: Maybe<Scalars["String"]>;
  /** The amount associated with the `PaymentTransactionEvent`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Reference to the parent `PaymentTransaction` that this event was created for. */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Fee associated with a `PaymentTransaction`. */
export type PaymentTransactionFee = {
  /**
   * The direction the fees are moving in the perspective of the subscriber.
   * * when DEBIT, this fee is deducted from the total payable amount.
   * * when CREDIT, this fee is credited to the total payable amount.
   */
  accountingDirection?: Maybe<AccountingDirection>;
  /** The amount of the fee. */
  feeAmount?: Maybe<Amount>;
};

/** The filters used to scope the type of `PaymentTransaction`s returned. */
export type PaymentTransactionFilterInput = {
  /** Filter `PaymentTransaction`s by `authorizationCode` created when a `PaymentTransaction` is captured. */
  authorizationCode?: InputMaybe<StringFilterInput>;
  /**
   * Filter `PaymentTransaction`s by `authorizationIdentifier` created when a `PaymentTransaction` is captured.
   *
   * DEPRECATED: Use authorizationCode instead.
   */
  authorizationIdentifier?: InputMaybe<StringFilterInput>;
  /**
   * Filter `PaymentTransaction`s by the `CardHolder`s email used to make the payment.
   *
   * **Note:** This filter only supports `equals` currently, all other comparison operators will be ignored.
   */
  cardHolderEmail?: InputMaybe<StringFilterInput>;
  /**
   * Filter `PaymentTransaction`s by the `CardHolder`s name used to make the payment.
   *
   * **Note:** This filter only supports `equals` currently, all other comparison operators will be ignored.
   */
  cardHolderName?: InputMaybe<StringFilterInput>;
  /**
   * Filter `PaymentTransaction`s by the `CardProduct` used to make the payment.
   *
   * **Note:** This filter only supports `equals` currently, all other comparison operators will be ignored.
   */
  cardProductId?: InputMaybe<IdFilterInput>;
  /**
   * Filter `PaymentTransaction`s by the `contractId` used to make the payment.
   *
   * **Note:** This filter only supports `equals` currently, all other comparison operators will be ignored.
   */
  contractId?: InputMaybe<IdFilterInput>;
  /**
   * Filter `PaymentTransaction`s by it's `PaymentInstruction.disburseTo` ID.
   *
   * **Note:** This filter only supports `equals` currently, all other comparison operators will be ignored.
   */
  disburseToId?: InputMaybe<IdFilterInput>;
  /**
   * Used to search using the Highnote `SearchQueryLanguage`.
   * Cannot be used in conjunction with other filters.
   */
  searchQueryLanguage?: InputMaybe<SearchQueryLanguageInput>;
  /** Filter `PaymentTransaction`s by transfer IDs created when `PaymentInstruction`s resolve. */
  transferId?: InputMaybe<IdFilterInput>;
};

/** A payment transaction event. This is a record of a payment transaction moving money. */
export type PaymentTransactionLifecycleStep = {
  /** The amount for this `PaymentTransaction`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Events associated with this step. */
  events?: Maybe<Array<PaymentTransactionEvent>>;
  /** The current status for this step. */
  status?: Maybe<PaymentTransactionLifecycleStepStatus>;
  /** The `PaymentTransaction` associated with this step. */
  transaction?: Maybe<PaymentTransaction>;
};

/** The status of a `PaymentTransactionLifecycleStep` */
export enum PaymentTransactionLifecycleStepStatus {
  /** The step has completed. No further events are expected for this step. */
  COMPLETED = "COMPLETED",
  /** The step has been declined. An event has returned for this step that prevents the step from continuing. */
  DECLINED = "DECLINED",
  /** The step has not completed yet. Further events are expected for this step. */
  PENDING = "PENDING",
  /** The step status does not match any of the other statuses. */
  UNKNOWN = "UNKNOWN",
}

/**
 * A payment transaction lifecycle step summary. This is a summary record of a payment transaction moving money returned
 * from a mutation.
 */
export type PaymentTransactionLifecycleStepSummary = {
  /** The amount for this `PaymentTransaction`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The `PaymentTransaction` associated with this step. */
  transaction?: Maybe<PaymentTransactionSummary>;
};

/** Possible values for the `PaymentTransactionCardCodeResponseCode` enum. */
export enum PaymentTransactionPostalCodeResponseCode {
  /** The postal code does match the processor's records. */
  MATCHED = "MATCHED",
  /** The postal code does not match the processor's records. */
  NOT_MATCHED = "NOT_MATCHED",
  /** The postal code was not provided at the time of the transaction. */
  NOT_PROVIDED = "NOT_PROVIDED",
  /** The postal code check was not verified by the processor. */
  NOT_VERIFIED = "NOT_VERIFIED",
  /** The check was requested to be skipped in the API. */
  SKIPPED = "SKIPPED",
  /** The postal code was provided but the processor was unable to verify it. */
  UNKNOWN = "UNKNOWN",
}

/** Response codes for a payment transaction. */
export type PaymentTransactionResponseCode = {
  __typename?: "PaymentTransactionResponseCode";
  /** The address code response code for this `PaymentTransaction`. */
  addressCode?: Maybe<PaymentTransactionAddressCodeResponseCode>;
  /** The authorization code provided by the processor for this `PaymentTransaction` on a successful authorization. */
  authorizationCode?: Maybe<Scalars["String"]>;
  /**
   * The authorization response code identifier provided by the processor for this `PaymentTransaction` on a successful authorization.
   * @deprecated Use authorizationCode instead.
   */
  authorizationIdentifier?: Maybe<Scalars["String"]>;
  /** The first name match result for this `PaymentTransaction`. */
  firstNameCode?: Maybe<PaymentTransactionAccountNameVerificationResponseCode>;
  /** The full name match result for this `PaymentTransaction`. */
  fullNameCode?: Maybe<PaymentTransactionAccountNameVerificationResponseCode>;
  /** The last name match result for this `PaymentTransaction`. */
  lastNameCode?: Maybe<PaymentTransactionAccountNameVerificationResponseCode>;
  /** The middle name match result for this `PaymentTransaction`. */
  middleNameCode?: Maybe<PaymentTransactionAccountNameVerificationResponseCode>;
  /** The postal code response code for this `PaymentTransaction`. */
  postalCode?: Maybe<PaymentTransactionPostalCodeResponseCode>;
  /**
   * The response code from the processor for this `PaymentTransaction`.
   * This will include both approval and decline codes.
   */
  processorResponseCode?: Maybe<PaymentTransactionResponseCodeProcessorResponseCode>;
  /** The security code response code for this `PaymentTransaction`. */
  securityCode?: Maybe<PaymentTransactionSecurityCodeResponseCode>;
};

/** Possible response codes from the processor for a payment transaction. */
export enum PaymentTransactionResponseCodeProcessorResponseCode {
  /** The authorization was approved. */
  APPROVED = "APPROVED",
  /** The authorization was declined due to an incorrect CVC3 or DCVV. */
  BAD_CVC3_DCVV = "BAD_CVC3_DCVV",
  /** The authorization was declined due to a security code mismatch. */
  BAD_CVV = "BAD_CVV",
  /** The authorization was declined due to a security code mismatch. */
  BAD_CVV2 = "BAD_CVV2",
  /** The authorization was declined due to the card being blocked from transacting. */
  BLOCKED_CARD = "BLOCKED_CARD",
  /** The authorization was declined due to a chip card ARQC validation failure. */
  CHIP_CARD_ARQC_VALIDATION_FAILURE = "CHIP_CARD_ARQC_VALIDATION_FAILURE",
  /** The authorization was declined due to the card being closed. */
  CLOSED_ACCOUNT = "CLOSED_ACCOUNT",
  /**
   * The authorization was declined. The customer should contact their
   * bank for more information on the decline.
   */
  DO_NOT_HONOR = "DO_NOT_HONOR",
  /** The authorization was declined due to the approval amount being over the limit. */
  EXCEEDS_APPROVAL_AMOUNT_LIMIT = "EXCEEDS_APPROVAL_AMOUNT_LIMIT",
  /** The authorization was declined because number of transaction exceeded the issuer or approved limit over a set period of time. */
  EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT = "EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT",
  /** The authorization was declined due to the card being expired. */
  EXPIRED_CARD = "EXPIRED_CARD",
  /** The authorization was declined due to the card being inactive. */
  INACTIVE_CARD = "INACTIVE_CARD",
  /** The authorization was declined due to an incorrect expiration date. */
  INCORRECT_EXPIRATION_DATE = "INCORRECT_EXPIRATION_DATE",
  /** The authorization was declined because instant network pull capability is not enabled. */
  INSTANT_NETWORK_PULL_CAPABILITY_NOT_ENABLED = "INSTANT_NETWORK_PULL_CAPABILITY_NOT_ENABLED",
  /** The authorization was declined because instant network push capability is not enabled. */
  INSTANT_NETWORK_PUSH_CAPABILITY_NOT_ENABLED = "INSTANT_NETWORK_PUSH_CAPABILITY_NOT_ENABLED",
  /** The authorization was declined due to the insufficient funds in the account. */
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  /** The authorization was declined due to the authorization expiration being invalid. */
  INVALID_AUTHORIZATION_EXPIRATION = "INVALID_AUTHORIZATION_EXPIRATION",
  /** The authorization was declined due to the card number being invalid. */
  INVALID_CARD_NUMBER = "INVALID_CARD_NUMBER",
  /** The authorization was declined due to the merchant not being authorized to process the transaction. */
  INVALID_MERCHANT = "INVALID_MERCHANT",
  /** The authorization was declined due to an invalid payment credential. */
  INVALID_PAYMENT_CREDENTIAL = "INVALID_PAYMENT_CREDENTIAL",
  /** The authorization was declined due to invalid track data. */
  INVALID_TRACK_DATA = "INVALID_TRACK_DATA",
  /**
   * The authorization was declined due to incorrect information being provided, or attempting a faulty operation such as refunding a refund.
   * This is a generic catch-all response code for a transaction that cannot be declined under other specific response codes.
   */
  INVALID_TRANSACTION = "INVALID_TRANSACTION",
  /** The authorization was declined because the processor network is not available. */
  PROCESSOR_NETWORK_NOT_AVAILABLE = "PROCESSOR_NETWORK_NOT_AVAILABLE",
  /** The authorization was declined due to the card being restricted from transacting in this region or country. */
  RESTRICTED_LOCATION = "RESTRICTED_LOCATION",
  /** The authorization was declined due to the card's address verification failing. */
  RE_ENTER_TRANSACTION = "RE_ENTER_TRANSACTION",
  /**
   * The authorization was declined because of a special condition on the card.
   * This could be due to the card being temporarily suspended or having an issue with the financial account.
   */
  SPECIAL_CONDITION_NO_PICK_UP = "SPECIAL_CONDITION_NO_PICK_UP",
  /** The authorization was declined due to the card being suspended. */
  SUSPENDED_CARD = "SUSPENDED_CARD",
  /** The authorization was declined due to the card being terminated. */
  TERMINATED_CARD = "TERMINATED_CARD",
  /** The authorization was declined due to the card being restricted. */
  TRANSACTION_NOT_PERMITTED = "TRANSACTION_NOT_PERMITTED",
  /** The authorization was declined because the transaction type is not supported. */
  TRANSACTION_NOT_SUPPORTED = "TRANSACTION_NOT_SUPPORTED",
  /** The authorization was declined due to the card not being activiated. */
  UNACTIVATED_CARD = "UNACTIVATED_CARD",
  /** The authorization response code did not match any of the other codes. */
  UNKNOWN = "UNKNOWN",
}

/** Possible values for the `PaymentTransactionSecurityCodeResponseCode` enum. */
export enum PaymentTransactionSecurityCodeResponseCode {
  /** The security code does match the processor's records. */
  MATCHED = "MATCHED",
  /** The security code does not match the processor's records. */
  NOT_MATCHED = "NOT_MATCHED",
  /** The security code was not provided at the time of the transaction. */
  NOT_PROVIDED = "NOT_PROVIDED",
  /** The security code check was not verified by the processor. */
  NOT_VERIFIED = "NOT_VERIFIED",
  /** The check was requested to be skipped in the API. */
  SKIPPED = "SKIPPED",
  /** The security code was provided but the processor was unable to verify it. */
  UNKNOWN = "UNKNOWN",
}

/** Different statuses that a `PaymentTransaction` can be. */
export enum PaymentTransactionStatus {
  /** COMPLETED indicates that the `PaymentTransactionLifecycleStep` has finished with required states and disbursed the funds. */
  COMPLETED = "COMPLETED",
  /** DECLINED indicates that the `PaymentTransaction` was declined. This can happen if the payment method was invalid, or the payment method has insufficient funds. */
  DECLINED = "DECLINED",
  /** DISPUTED indicates that the `PaymentTransaction` has a dispute. */
  DISPUTED = "DISPUTED",
  /** PENDING indicates that there are required `PaymentTransactionLifecycleStep`s that have not yet been completed. Once all the required steps are completed, this state will transition. */
  PENDING = "PENDING",
  /** PENDING_DISPUTE indicates that the `PaymentTransaction` has a pending dispute. */
  PENDING_DISPUTE = "PENDING_DISPUTE",
  /** REVERSED indicates that all remaining authorized amounts on this `PaymentTransaction` have been reversed. */
  REVERSED = "REVERSED",
}

export type PaymentTransactionSummary = {
  /**
   * The direction funds are moving in the perspective of the customer.
   * * when DEBIT, funds are moving out of the customer's account
   * * when CREDIT, funds are moving into the customer's account
   */
  accountingDirection?: Maybe<AccountingDirection>;
  /** The total amount authorized for this `PaymentTransaction`. */
  authorizedAmount?: Maybe<Amount>;
  /** The total authorized amount remaining for this `PaymentTransaction`. */
  authorizedRemainingAmount?: Maybe<Amount>;
  /** The total authorized amount that has been canceled for this `PaymentTransaction`. */
  canceledAmount?: Maybe<Amount>;
  /** The total amount captured for this `PaymentTransaction`. */
  capturedAmount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The total amount disbursed for this `PaymentTransaction`. */
  disbursedAmount?: Maybe<Amount>;
  /** Global ID used to reference this object. */
  id: Scalars["ID"];
  /** The payment instrument used for the `PaymentTransaction`. Instrument data can be used to display information to the user without violating PCI compliance. */
  instrument?: Maybe<PaymentInstrument>;
  /** The total amount refunded for this `PaymentTransaction`. */
  refundedAmount?: Maybe<Amount>;
  /** The total authorization amount requested for this `PaymentTransaction`. */
  requestedAuthorizationAmount?: Maybe<Amount>;
  /** The response codes for this `PaymentTransaction`. */
  responseCode?: Maybe<PaymentTransactionResponseCode>;
  /** The total amount settled for this `PaymentTransaction`. */
  settledAmount?: Maybe<Amount>;
};

/** The connection type for the `paymentTransactions` query. */
export type PaymentTransactionsConnection = {
  __typename?: "PaymentTransactionsConnection";
  /** A list of edges. */
  edges?: Maybe<Array<PaymentTransactionsEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for the `paymentTransactions` query. */
export type PaymentTransactionsEdge = {
  __typename?: "PaymentTransactionsEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The `PaymentTransaction` */
  node?: Maybe<PaymentTransaction>;
};

/**
 * Represents a completed payout transfer event for an acquiring `PaymentTransaction`.
 *
 * This event is created when the funds are transferred.
 *
 * See `transferedTo` for more details in where it transferred to.
 */
export type PayoutTransferCompletedEvent = PaymentTransactionEvent & {
  __typename?: "PayoutTransferCompletedEvent";
  /**
   * The acquirer reference number associated with this event. This is a unique
   * identifier assigned by the acquiring processor to track the transaction.
   */
  acquirerReferenceNumber?: Maybe<Scalars["String"]>;
  /** The amount associated with the `PaymentTransactionEvent`. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Reference to the parent `PaymentTransaction` that this event was created for. */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** The node where the funds were transferred to. */
  transferredTo?: Maybe<TransferredEventNode>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** A financial event that represents a `PayrollTransfer`. */
export type PayrollAchTransferEvent = AchTransferEvent &
  Node & {
    __typename?: "PayrollACHTransferEvent";
    /** The amount of the transfer. */
    amount?: Maybe<Amount>;
    /** Company entered value for the type of ACH. */
    companyEntryDescription?: Maybe<Scalars["String"]>;
    /**
     * The Company Identifier is a 10-position alphameric code used to identify an Originator of the ACH transaction. It may begin with an ANSI one-digit Identification Code Designator (ICD), followed by the Identification Number.
     *
     * |`Identification Code Designator (ICD)`    | `ANSI Identification Number` | Example                                                                         |
     * | ---------------------------------------- | ---------------------------- | ------------------------------------------------------------------------------- |
     * |`IRS Employer Identification Number (EIN)`| 1                            | 1234567890 for an Originator with 234567890 EIN                                 |
     * |`Data Universal Numbering Systems (DUNS)` | 3                            | 30008016958 for an Originator with 0008016958 DUNS                              |
     * |`User Assigned Number`                    | 9                            | 9111111111 for an Originator with 111111111 under assigned Identification Number|
     */
    companyIdentifier?: Maybe<Scalars["String"]>;
    /** The name of the company that initiated the ACH transfer. */
    companyName?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the transfer was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the transfer in operations. */
    id: Scalars["ID"];
    /** The date this transaction was returned, in ISO 8601 format. */
    returnDate?: Maybe<Scalars["String"]>;
    /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
    settlementDate?: Maybe<Scalars["String"]>;
    /** The status of the externally initiated ACH transfer. */
    status?: Maybe<ExternallyInitiatedAchStatusDetails>;
    /** The account receiving the funds. */
    toFinancialAccount?: Maybe<FinancialAccount>;
    /** The `ElectronicFundsTransfer` that triggered this event. */
    transfer?: Maybe<ElectronicFundsTransfer>;
  };

/** The Payroll Payment Advance within the Highnote platform. */
export type PayrollAdvance = Node &
  PaymentAdvance & {
    __typename?: "PayrollAdvance";
    /** The original amount of the Payroll Payment Advance. */
    advanceAmount?: Maybe<Amount>;
    /** The amount that should be deducted from the Payroll Payment Advance outstanding balance. */
    amountApplied?: Maybe<Amount>;
    /** The amount of the Payroll Payment Advance that has yet to be repaid. */
    amountBefore?: Maybe<Amount>;
    /** The balance amount due after `amountApplied` has been applied and deducted from the Payroll Payment Advance outstanding balance. */
    balanceAfter?: Maybe<Amount>;
    /** Global ID used to reference the Payroll Payment Advance. */
    id: Scalars["ID"];
    /** The status of Payroll Payment Advance. */
    paymentAdvanceStatus?: Maybe<PaymentAdvanceStatus>;
    /** Count of repayment attempts. */
    repaymentAttemptCount: Scalars["UnsignedInt"];
    /** Amount that will be written off from the Payroll Payment Advance outstanding balance. */
    writeOffAmount?: Maybe<Amount>;
    /** Will be set if the PaymentAdvanceStatus is of type `WRITTEN_OFF`, explains the reason for write off. Limit of 1024 characters. */
    writeOffReason?: Maybe<PaymentAdvanceWriteOffReason>;
  };

export type PayrollAdvanceEvent = {
  /**
   * The ID of an employer financial account.
   *
   * This must be a `FinancialAccount` ID.
   */
  employerFinancialAccountId: Scalars["ID"];
  /** The ID of the financial account receiving funds. */
  financialAccountId?: Maybe<Scalars["ID"]>;
  /** Global ID used to reference the Financial Event Id in operations. */
  id: Scalars["ID"];
  /** The `PayrollAdvance` related to this `PayrollAdvanceEvent` */
  payrollAdvance?: Maybe<PayrollAdvance>;
  /** The ID of a payroll Transfer */
  payrollTransferId?: Maybe<Scalars["ID"]>;
};

/** Whether or not the Financial Account supports Payroll Advance. */
export type PayrollAdvanceFinancialAccountFeature = FinancialAccountFeature & {
  __typename?: "PayrollAdvanceFinancialAccountFeature";
  /** The date and time, in ISO 8601 format, the feature was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective from. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective through. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Whether or not the feature is enabled for the Financial Account. */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** The date and time, in ISO 8601 format, the feature was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The PayrollAdvanceRepaymentCompletedEvent is triggered when an amount pertaining to a `PayrollAdvance` is has been repaid. */
export type PayrollAdvanceRepaymentCompletedEvent = Node &
  PayrollAdvanceEvent & {
    __typename?: "PayrollAdvanceRepaymentCompletedEvent";
    /**
     * The ID of an employer financial account.
     *
     * This must be a `FinancialAccount` ID.
     */
    employerFinancialAccountId: Scalars["ID"];
    /** The ID of the financial account receiving funds. */
    financialAccountId?: Maybe<Scalars["ID"]>;
    /** Global ID used to reference the Financial Event Id in operations. */
    id: Scalars["ID"];
    /** The `PayrollAdvance` related to this `PayrollAdvanceWriteOffCompletedEvent` */
    payrollAdvance?: Maybe<PayrollAdvance>;
    /** The ID of a payroll Transfer */
    payrollTransferId?: Maybe<Scalars["ID"]>;
  };

/** A movement of money to repay payroll advance */
export type PayrollAdvanceRepaymentTransfer = Node & {
  __typename?: "PayrollAdvanceRepaymentTransfer";
  /** The amount repaid. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the transfer in operations. */
  id: Scalars["ID"];
  /** The ledgers affected by the transfer. */
  ledgers?: Maybe<Array<Ledger>>;
  /** A description of the transfer for reference. */
  memo?: Maybe<Scalars["String"]>;
  /** The current status of the transfer. */
  status?: Maybe<InterFinancialAccountTransferStatus>;
  /** The reason for the current status. */
  statusReason?: Maybe<InterFinancialAccountTransferStatusReasonCode>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** A movement of money to repay payroll advance */
export type PayrollAdvanceRepaymentTransferLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** The PayrollAdvanceWriteOffCompletedEvent is triggered when an amount pertaining to a `PayrollAdvance` is has been written off. */
export type PayrollAdvanceWriteOffCompletedEvent = Node &
  PayrollAdvanceEvent & {
    __typename?: "PayrollAdvanceWriteOffCompletedEvent";
    /**
     * The ID of an employer financial account.
     *
     * This must be a `FinancialAccount` ID.
     */
    employerFinancialAccountId: Scalars["ID"];
    /** The ID of the financial account receiving funds. */
    financialAccountId?: Maybe<Scalars["ID"]>;
    /** Global ID used to reference the Financial Event Id in operations. */
    id: Scalars["ID"];
    /** The `PayrollAdvance` related to this `PayrollAdvanceWriteOffCompletedEvent` */
    payrollAdvance?: Maybe<PayrollAdvance>;
    /** The ID of a payroll Transfer */
    payrollTransferId?: Maybe<Scalars["ID"]>;
  };

/** A movement of money to write off payroll advance */
export type PayrollAdvanceWriteoffTransfer = Node & {
  __typename?: "PayrollAdvanceWriteoffTransfer";
  /** The written off amount. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the transfer in operations. */
  id: Scalars["ID"];
  /** The ledgers affected by the transfer. */
  ledgers?: Maybe<Array<Ledger>>;
  /** A description of the transfer for reference. */
  memo?: Maybe<Scalars["String"]>;
  /** The current status of the transfer. */
  status?: Maybe<InterFinancialAccountTransferStatus>;
  /** The reason for the current status. */
  statusReason?: Maybe<InterFinancialAccountTransferStatusReasonCode>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** A movement of money to write off payroll advance */
export type PayrollAdvanceWriteoffTransferLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** Whether or not the Financial Account supports Payroll Employer Advance. */
export type PayrollEmployerAdvanceFinancialAccountFeature =
  FinancialAccountFeature & {
    __typename?: "PayrollEmployerAdvanceFinancialAccountFeature";
    /** The date and time, in ISO 8601 format, the feature was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective from. */
    effectiveFrom?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective through. */
    effectiveThrough?: Maybe<Scalars["String"]>;
    /** Whether or not the feature is enabled for the Financial Account. */
    enabled?: Maybe<Scalars["Boolean"]>;
    /** The date and time, in ISO 8601 format, the feature was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** A transfer for the purposes of payroll. */
export type PayrollTransfer = ElectronicFundsTransfer &
  ExternallyInitiatedAchTransfer &
  Node & {
    __typename?: "PayrollTransfer";
    /** The amount of the transfer. */
    amount?: Maybe<Amount>;
    /** The Card Product associated to the Financial Account. */
    cardProduct?: Maybe<CardProduct>;
    /** The ID of the company that initiated the ACH transfer, ISO 8601 format. */
    companyIdentifier?: Maybe<Scalars["String"]>;
    /** The name of the company that initiated the ACH transfer. */
    companyName?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the transfer was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Descriptive fields about the transfer which may show up on bank reports. */
    descriptor?: Maybe<AchDescriptor>;
    /** Global ID used to reference the transfer in operations. */
    id: Scalars["ID"];
    /** The ledgers affected by the transfer. */
    ledgers?: Maybe<Array<Ledger>>;
    /** The date this transaction was returned, in ISO 8601 format. */
    returnDate?: Maybe<Scalars["String"]>;
    /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
    settlementDate?: Maybe<Scalars["String"]>;
    /** The status of the externally initiated ACH transfer. */
    status?: Maybe<ExternallyInitiatedAchStatusDetails>;
    /** The Highnote account receiving the credit. */
    toFinancialAccount?: Maybe<FinancialAccount>;
    /** A unique 15 digit number assigned by the originator to identify the transfer. */
    traceNumber?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the transfer was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** A transfer for the purposes of payroll. */
export type PayrollTransferLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** The base fields for all PersonAccountHolders (regardless of region or snapshot) */
export type PersonAccountHolder = {
  /** The default billing addresses of the account holder */
  billingAddress?: Maybe<Address>;
  /** The account holder's name, represented as different parts. */
  name?: Maybe<Name>;
};

/** Permissions for a `PersonAccountHolder` Client Token */
export enum PersonAccountHolderClientTokenPermission {
  /**
   * Read the person account holder information.
   *
   * Setting this permission will allow visibility to the account holder's information.
   */
  READ_PERSON_ACCOUNT_HOLDER_DETAILS = "READ_PERSON_ACCOUNT_HOLDER_DETAILS",
}

/**
 * Inputs for filtering person account holder data.
 *
 * **Note:** Filtering by a single field will yield accurate results. You may also
 * combine the `dateOfBirth` and `name` fields within the same query for successful
 * search results. However, combining other fields may not yield the expected results
 * and is not supported.
 */
export type PersonAccountHolderFilterInput = {
  billingAddress?: InputMaybe<AddressFilterInput>;
  dateOfBirth?: InputMaybe<DateFilterInput>;
  email?: InputMaybe<StringSearchFilterInput>;
  name?: InputMaybe<PersonAccountHolderNameFilterInput>;
  phone?: InputMaybe<PhoneFilterInput>;
  socialSecurityNumber?: InputMaybe<HashedFilterInput>;
};

/** Indicates that identity verification documents have been requested for a `USPersonAccountHolder`. */
export type PersonAccountHolderIdentityDocumentsRequestedEvent = {
  __typename?: "PersonAccountHolderIdentityDocumentsRequestedEvent";
  /** The date and time, in ISO 8601 format, this event was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The `IdentityVerificationDocumentUploadSession` created for the requested documents. */
  documentUploadSession?: Maybe<IdentityVerificationDocumentUploadSession>;
  /** The `USPersonAccountHolder` for which documents have been requested. */
  personAccountHolder?: Maybe<UsPersonAccountHolder>;
  /** The reason identity verification documents are being requested. */
  reason?: Maybe<IdentityVerificationDocumentRequestReason>;
};

/** The type of identifying information which has been modified in a `PersonAccountHolderIdentityUpdatedEvent`. */
export enum PersonAccountHolderIdentityUpdateType {
  /** The billing address was modified. */
  BILLING_ADDRESS = "BILLING_ADDRESS",
  /** The current debt obligations were modified. */
  CURRENT_DEBT_OBLIGATIONS = "CURRENT_DEBT_OBLIGATIONS",
  /** The date of birth was modified. */
  DATE_OF_BIRTH = "DATE_OF_BIRTH",
  /** The employment status was modified. */
  EMPLOYMENT_STATUS = "EMPLOYMENT_STATUS",
  /** The full legal name was modified. */
  FULL_LEGAL_NAME = "FULL_LEGAL_NAME",
  /** The social security number was modified. */
  SOCIAL_SECURITY_NUMBER = "SOCIAL_SECURITY_NUMBER",
  /** The total annual income was modified. */
  TOTAL_ANNUAL_INCOME = "TOTAL_ANNUAL_INCOME",
}

/** Indicates that the identifying information of a `USPersonAccountHolder` has been updated. */
export type PersonAccountHolderIdentityUpdatedEvent = {
  __typename?: "PersonAccountHolderIdentityUpdatedEvent";
  /** The date and time, in ISO 8601 format, this event was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The `USPersonAccountHolder` which was updated. */
  personAccountHolder?: Maybe<UsPersonAccountHolder>;
  /** The type of each update made, indicating which fields were modified on the `USPersonAccountHolder`. */
  updateTypes?: Maybe<Array<PersonAccountHolderIdentityUpdateType>>;
};

/**
 * Input for filtering Account Holders by name.
 * The matching for these name fields are performed using similar sounding scores.
 * e.g. keywords like Mayer, mayer, Mire & Mary will lead to the same score.
 */
export type PersonAccountHolderNameFilterInput = {
  familyName?: InputMaybe<SoundsLikeFilterInput>;
  givenName?: InputMaybe<SoundsLikeFilterInput>;
  middleName?: InputMaybe<SoundsLikeFilterInput>;
  suffix?: InputMaybe<SoundsLikeFilterInput>;
  title?: InputMaybe<SoundsLikeFilterInput>;
};

/** Input representing common fields of a PersonAccountHolder's name. */
export type PersonAccountHolderNameInput = {
  /**
   * Part of a personal name that identifies a family, tribe, or community.
   *
   * **Minimum length:** 2 characters
   * **Maximum length:** 255 characters
   * **Allowed characters:** Lower and upper case Latin letters (without [diacritical marks](https://en.wikipedia.org/wiki/Diacritic)) and any of: ''', ',', '.', ' ','-'
   */
  familyName: Scalars["String"];
  /**
   * The part of the name that identifies a person.
   *
   * **Minimum length:** 1 character
   * **Maximum length:** 255 characters
   * **Allowed characters:** Lower and upper case Latin letters (without [diacritical marks](https://en.wikipedia.org/wiki/Diacritic)) and any of: ''', ',', '.', ' ','-'
   */
  givenName: Scalars["String"];
  /**
   * Additional part of name that identifies a person.
   *
   * **Minimum length:** 1 character
   * **Maximum length:** 255 characters
   * **Allowed characters:** Lower and upper case Latin letters (without [diacritical marks](https://en.wikipedia.org/wiki/Diacritic)) and any of: ''', ',', '.', ' ','-'
   */
  middleName?: InputMaybe<Scalars["String"]>;
  /** Provides additional information about the person (e.g. Jr., Sr.) */
  suffix?: InputMaybe<Scalars["String"]>;
  /** One or more words used before the person's name (e.g. Mx., Dr.). */
  title?: InputMaybe<Scalars["String"]>;
};

/** The base fields for all PersonAuthorizedUser (regardless of region or snapshot) */
export type PersonAuthorizedUser = {
  /** The default billing addresses of the authorized user. */
  billingAddress?: Maybe<Address>;
  /** The authorized user's name, represented as different parts. */
  name?: Maybe<Name>;
};

/** Permissions for a `PersonAuthorizedUser` Client Token */
export enum PersonAuthorizedUserClientTokenPermission {
  /**
   * Read the person authorized user information.
   *
   * Setting this permission will allow visibility to the authorized user's information.
   */
  READ_PERSON_AUTHORIZED_USER_DETAILS = "READ_PERSON_AUTHORIZED_USER_DETAILS",
}

/** Inputs for filtering person authorized user data. */
export type PersonAuthorizedUserFilterInput = {
  billingAddress?: InputMaybe<AddressFilterInput>;
  dateOfBirth?: InputMaybe<DateFilterInput>;
  name?: InputMaybe<PersonAuthorizedUserNameFilterInput>;
  socialSecurityNumberLast4?: InputMaybe<HashedFilterInput>;
};

/**
 * Input for filtering authorized users by name.
 * The matching for these name fields are performed using similar sounding scores.
 * e.g. keywords like Mayer, mayer, Mire & Mary will lead to the same score.
 */
export type PersonAuthorizedUserNameFilterInput = {
  familyName?: InputMaybe<SoundsLikeFilterInput>;
  givenName?: InputMaybe<SoundsLikeFilterInput>;
  middleName?: InputMaybe<SoundsLikeFilterInput>;
  suffix?: InputMaybe<SoundsLikeFilterInput>;
  title?: InputMaybe<SoundsLikeFilterInput>;
};

/** Input representing common fields of a PersonAuthorizedUser's name. */
export type PersonAuthorizedUserNameInput = {
  /**
   * Part of a personal name that identifies a family, tribe, or community.
   *
   * **Minimum length:** 2 characters
   * **Maximum length:** 255 characters
   * **Allowed characters:** Lower and upper case Latin letters (without [diacritical marks](https://en.wikipedia.org/wiki/Diacritic)) and any of: ''', ',', '.', ' ','-'
   */
  familyName: Scalars["String"];
  /**
   * The part of the name that identifies a person.
   *
   * **Minimum length:** 1 character
   * **Maximum length:** 255 characters
   * **Allowed characters:** Lower and upper case Latin letters (without [diacritical marks](https://en.wikipedia.org/wiki/Diacritic)) and any of: ''', ',', '.', ' ','-'
   */
  givenName: Scalars["String"];
  /**
   * Additional part of name that identifies a person.
   *
   * **Minimum length:** 1 character
   * **Maximum length:** 255 characters
   * **Allowed characters:** Lower and upper case Latin letters (without [diacritical marks](https://en.wikipedia.org/wiki/Diacritic)) and any of: ''', ',', '.', ' ','-'
   */
  middleName?: InputMaybe<Scalars["String"]>;
  /** Provides additional information about the person (e.g. Jr., Sr.) */
  suffix?: InputMaybe<Scalars["String"]>;
  /** One or more words used before the person's name (e.g. Mx., Dr.). */
  title?: InputMaybe<Scalars["String"]>;
};

/** A type representing credit risk attributes for person underwriting. */
export type PersonCreditRiskAttributes = {
  __typename?: "PersonCreditRiskAttributes";
  /** Current debt obligations expressed as an Amount. */
  currentDebtObligations?: Maybe<Array<Amount>>;
  /** Person's employment status. */
  employmentStatus?: Maybe<EmploymentStatus>;
  /** The rent, mortgage, or other type of housing payment made on a monthly basis as an `Amount`. */
  monthlyHousingPayment?: Maybe<Array<Amount>>;
  /** Total annual income expressed as an Amount. */
  totalAnnualIncome?: Maybe<Array<Amount>>;
};

/** Input representing credit risk attributes for person underwriting. */
export type PersonCreditRiskAttributesInput = {
  /** Current debt obligations expressed as an Amount. */
  currentDebtObligations?: InputMaybe<Array<AmountInput>>;
  /** Person's employment status. */
  employmentStatus?: InputMaybe<EmploymentStatus>;
  /** The rent, mortgage, or other type of housing payment made on a monthly basis as an `Amount`. */
  monthlyHousingPayment?: InputMaybe<Array<AmountInput>>;
  /** Total annual income expressed as an Amount. */
  totalAnnualIncome?: InputMaybe<Array<AmountInput>>;
};

/** `Person` identification document types. */
export type PersonIdentificationDocument = NationalIdentificationDocument;

/** The locality details for a `Person`. */
export type PersonLocality = {
  __typename?: "PersonLocality";
  /** The country of residence in [ISO 3166-1 alpha-3](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3) format (for example, "USA", "GBR", "ISR", "CAN"). */
  countryOfResidence?: Maybe<Scalars["String"]>;
};

/**
 * Input for filtering persons by name.
 * The matching for these name fields are performed using similar sounding scores.
 * e.g. keywords like Mayer, mayer, Mire & Mary will lead to the same score.
 */
export type PersonNameFilterInput = {
  familyName?: InputMaybe<SoundsLikeFilterInput>;
  givenName?: InputMaybe<SoundsLikeFilterInput>;
  middleName?: InputMaybe<SoundsLikeFilterInput>;
  suffix?: InputMaybe<SoundsLikeFilterInput>;
  title?: InputMaybe<SoundsLikeFilterInput>;
};

/** Type representing parts of a phone number. */
export type Phone = {
  __typename?: "Phone";
  /** The assigned country code for the number. */
  countryCode?: Maybe<Scalars["String"]>;
  /** A classification for the type of the device the phone number is attached or how the phone number is used (e.g. home or work) */
  label?: Maybe<PhoneLabel>;
  /** The phone number in a country specific format. */
  number?: Maybe<Scalars["String"]>;
};

/** Input for filtering phone number. */
export type PhoneFilterInput = {
  extension?: InputMaybe<StringFilterInput>;
  label?: InputMaybe<PhoneLabelFilterInput>;
  number?: InputMaybe<StringFilterInput>;
};

/** Input representing parts of a phone number. */
export type PhoneInput = {
  /** The assigned country code for the number. */
  countryCode: Scalars["String"];
  /** A number representing a specific phone on the same number as the main line. */
  extension?: InputMaybe<Scalars["String"]>;
  /** A classification for the type of the device the phone number is attached or how the phone number is used (e.g. home or work) */
  label: PhoneLabel;
  /** The phone number in a country specific format. */
  number: Scalars["String"];
};

/** The types or usages of a phone number. */
export enum PhoneLabel {
  /** The phone number is attached to a residence. */
  HOME = "HOME",
  /** The phone number is attached to a mobile or cellular device. */
  MOBILE = "MOBILE",
  /** The phone number represents a support number */
  SUPPORT = "SUPPORT",
  /** The phone number is attached to a place of business. */
  WORK = "WORK",
}

/** Input for filtering by `PhoneLabel`. */
export type PhoneLabelFilterInput = {
  equals?: InputMaybe<PhoneLabel>;
  excludes?: InputMaybe<Array<PhoneLabel>>;
  includes?: InputMaybe<Array<PhoneLabel>>;
  notEquals?: InputMaybe<PhoneLabel>;
};

/** A created PhysicalCardGroupOrder. */
export type PhysicalCardGroupOrder = Node & {
  __typename?: "PhysicalCardGroupOrder";
  /** Number of cards in the group order */
  cardCount?: Maybe<Scalars["UnsignedInt"]>;
  /** Id of the product with which the group order will be associated. */
  cardProductId?: Maybe<Scalars["ID"]>;
  /** The `CardProfileSet` associated to this physical payment card group order. */
  cardProfileSet?: Maybe<CardProfileSet>;
  /** The date and time, in ISO 8601 format, the PaymentCardShipment was created at. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the PhysicalCardGroupOrder in operations. */
  id: Scalars["ID"];
  /** Order state details. */
  orderState?: Maybe<PaymentCardGroupOrderStateDetail>;
  /** Payment card shipment */
  paymentCardShipment?: Maybe<PaymentCardShipment>;
  /** The physical payment card orders for this PhysicalCardGroupOrder. */
  physicalPaymentCardOrders?: Maybe<PhysicalPaymentCardOrderConnection>;
  /** Fulfillment state detail history. */
  stateHistory?: Maybe<Array<Maybe<PaymentCardGroupOrderStateDetailHistory>>>;
  /** The date and time, in ISO 8601 format, the PaymentCardShipment was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** A created PhysicalCardGroupOrder. */
export type PhysicalCardGroupOrderPhysicalPaymentCardOrdersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The connection type for `PhysicalCardGroupOrder`. */
export type PhysicalCardGroupOrderConnection = {
  __typename?: "PhysicalCardGroupOrderConnection";
  /** A list of edges. */
  edges?: Maybe<Array<PhysicalCardGroupOrderEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a `PhysicalCardGroupOrder`. */
export type PhysicalCardGroupOrderEdge = {
  __typename?: "PhysicalCardGroupOrderEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The Physical Card Group Order. */
  node?: Maybe<PhysicalCardGroupOrder>;
};

/** Inputs for filtering physical payment card group orders. */
export type PhysicalCardGroupOrderFilterInput = {
  /**
   * Input to filter by physical card group order actual shipping date.
   * Actual ship date should be provided in YYYY-MM-DD format.
   */
  actualShipDateLocal?: InputMaybe<DateFilterInput>;
  /** Input to filter by card product ID. */
  cardProductId?: InputMaybe<IdFilterInput>;
  /** Input to filter by physical card group order creation date. */
  createdAt?: InputMaybe<TimestampFilterInput>;
  /** Input to filter by physical card group order ID. */
  groupOrderId?: InputMaybe<IdFilterInput>;
  /** Input to filter by payment card group order status. */
  groupOrderState?: InputMaybe<PaymentCardGroupOrderStatusFilterInput>;
  /** Input to filter by shipping method. */
  shippingMethod?: InputMaybe<PaymentCardShippingMethodFilterInput>;
};

/** Types which can be returned for creating a group order. */
export type PhysicalCardGroupOrderPayload =
  | AccessDeniedError
  | PhysicalCardGroupOrder
  | UserError;

/** Physical Card Material */
export enum PhysicalCardMaterial {
  /** Metal */
  METAL = "METAL",
  /** Plastic */
  PLASTIC = "PLASTIC",
}

/** The personalization line for a physical card */
export type PhysicalCardPersonalization = {
  __typename?: "PhysicalCardPersonalization";
  /** The format for the physical card profile look and feel. */
  format: PhysicalCardPersonalizationFormat;
  /** The line 1 personalization for the physical card. */
  line1: PhysicalCardPersonalizationLine;
  /** The line 2 personalization for the physical card. */
  line2: PhysicalCardPersonalizationLine;
  /** The line 3 personalization for the physical card. An optional additional line of custom text. */
  line3?: Maybe<PhysicalCardPersonalizationLine>;
  /** The type of physical card */
  physicalCardType?: Maybe<PhysicalCardType>;
};

/** the format of a physical card */
export enum PhysicalCardPersonalizationFormat {
  /** Embossed */
  EMBOSSED = "EMBOSSED",
  /** Printed */
  PRINTED = "PRINTED",
}

/** The personalization for a line. */
export type PhysicalCardPersonalizationLine = {
  __typename?: "PhysicalCardPersonalizationLine";
  /** The line value for the physical card line. */
  line?: Maybe<Scalars["String"]>;
  /** The line type for the physical card line. */
  type?: Maybe<PhysicalCardPersonalizationLineType>;
};

/** The line type for the physical card profile */
export enum PhysicalCardPersonalizationLineType {
  /** The physical card profile is track has default Cardholder Name */
  ACCOUNT_HOLDER_NAME = "ACCOUNT_HOLDER_NAME",
  /** The physical card profile is track has default Business Name */
  BUSINESS_NAME = "BUSINESS_NAME",
  /** The physical card profile track has Custom Name */
  CUSTOM = "CUSTOM",
}

/** Physical Card Profile attributes */
export type PhysicalCardProfile = CardProfile &
  Node & {
    __typename?: "PhysicalCardProfile";
    /** Bank Status of the physical card profile. */
    bankStatus?: Maybe<CardProfileBankStatus>;
    /** Card art */
    cardArt?: Maybe<Array<CardArtDocument>>;
    /** Card Holder Agreement ID of the physical card profile. */
    cardHolderAgreementId?: Maybe<Scalars["ID"]>;
    /** Card personalization. */
    cardPersonalization?: Maybe<PhysicalCardPersonalization>;
    /** Card Product of the physical card profile. */
    cardProduct?: Maybe<CardProduct>;
    /** The list of `CardProfileSet` related to this `PhysicalCardProfile`. */
    cardProfileSetRelationships?: Maybe<Array<CardProfileSetRelationship>>;
    /** Carrier for the physical card profile. */
    carrier?: Maybe<Scalars["String"]>;
    /** Chip profile id */
    chipProfileIdentifier?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, this `physical card profile` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Payment card shipment */
    defaultPaymentCardShipment?: Maybe<CardProfileShipment>;
    /** Description about the `PhysicalCardProfile`. */
    description?: Maybe<Scalars["String"]>;
    /** External contactless profile id */
    externalContactlessProfileIdentifier?: Maybe<Scalars["String"]>;
    /** The fleet option configuration ID */
    fleetOptionConfigurationId?: Maybe<Scalars["ID"]>;
    /** The fleet option configuration version */
    fleetOptionConfigurationVersion?: Maybe<Scalars["Int"]>;
    /** Form factor */
    formFactor?: Maybe<FormFactorType>;
    /** ID of the physical card profile. */
    id: Scalars["ID"];
    /** Whether the billing postal code should be included in the order file. */
    includeBillingPostalCodeInOrderFile?: Maybe<Scalars["Boolean"]>;
    /** Name of the `PhysicalCardProfile`. */
    name?: Maybe<Scalars["String"]>;
    /** Packaging for the physical card profile. */
    packaging?: Maybe<Scalars["String"]>;
    /** Payment Network Status of the physical card profile. */
    paymentNetworkStatus?: Maybe<CardProfilePaymentNetworkStatus>;
    /** Card Material of the physical card profile. */
    physicalCardMaterial?: Maybe<PhysicalCardMaterial>;
    /** Status of the physical card profile. */
    status?: Maybe<CardProfileStatus>;
    /** The date and time, in ISO 8601 format, this `physical card profile` was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** Vendor Name of the physical card profile. */
    vendorName?: Maybe<PhysicalCardVendorName>;
    /** Vendor program external id for the physical card profile */
    vendorProgramExternalIdentifier?: Maybe<Scalars["String"]>;
    /** Vendor Status of the physical card profile. */
    vendorStatus?: Maybe<CardProfileVendorStatus>;
  };

/** The type of physical card. */
export enum PhysicalCardType {
  /** Contactless Only */
  CONTACTLESS_ONLY = "CONTACTLESS_ONLY",
  /** EMV Chip Contactless */
  EMV_CHIP_CONTACTLESS = "EMV_CHIP_CONTACTLESS",
  /** EMV Chip Contact Only */
  EMV_CHIP_CONTACT_ONLY = "EMV_CHIP_CONTACT_ONLY",
  /** Magnetic Stripe Only */
  MAGNETIC_STRIPE_ONLY = "MAGNETIC_STRIPE_ONLY",
}

/** The vendors for a physical card */
export enum PhysicalCardVendorName {
  /** ARROW_EYE */
  ARROW_EYE = "ARROW_EYE",
  /** DIGISEQ */
  DIGISEQ = "DIGISEQ",
  /** TAG */
  TAG = "TAG",
}

/**
 * The input object that defines the fields for the recipient input.
 *
 * There are multiple ways to provide recipient information:
 * * One of `validatedAddressTokenId`, or `address` needs to be provided.
 */
export type PhysicalCheckPaymentRecipientInput = {
  /** The address of the recipient of the check. */
  address?: InputMaybe<AddressInput>;
  /** Externally provided ID (255 character limit) to associate this recipient with an external system. */
  externalIdentifier?: InputMaybe<Scalars["String"]>;
  /** The name of recipient of the check. */
  name: Scalars["String"];
  /** The ID of a `ValidatedAddressToken` to associate with the recipient. */
  validatedAddressTokenId?: InputMaybe<Scalars["ID"]>;
};

/** Inputs for filtering physical payment card group orders. */
export type PhysicalPaymentCardGroupOrderFilterInput = {
  /**
   * Input to filter by physical card group order actual shipping date.
   * Actual ship date should be provided in YYYY-MM-DD format.
   */
  actualShipDateLocal?: InputMaybe<DateFilterInput>;
  /** Input to filter by card product ID. */
  cardProductId?: InputMaybe<IdFilterInput>;
  /** Input to filter by physical card group order creation date. */
  createdAt?: InputMaybe<TimestampFilterInput>;
  /** Input to filter by physical card group order ID. */
  groupOrderId?: InputMaybe<IdFilterInput>;
  /** Input to filter by payment card group order status. */
  groupOrderState?: InputMaybe<PaymentCardGroupOrderStatusFilterInput>;
  /** Input to filter by shipping method. */
  shippingMethod?: InputMaybe<PaymentCardShippingMethodFilterInput>;
};

/** PhysicalPaymentCardGroupOrderShipFailedEvent indicates when a Physical Payment Card Group Order has failed to ship */
export type PhysicalPaymentCardGroupOrderShipFailedEvent = Node & {
  __typename?: "PhysicalPaymentCardGroupOrderShipFailedEvent";
  /** Number of cards in the group order */
  cardCount?: Maybe<Scalars["UnsignedInt"]>;
  /** Card product ID. */
  cardProductId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the PaymentCardShipment was created at. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Order state details. */
  groupOrderState?: Maybe<PaymentCardGroupOrderStateDetail>;
  /** Global ID used to reference the PhysicalPaymentCardGroupOrder in operations. */
  id: Scalars["ID"];
  /** The date and time, in ISO 8601 format, the PaymentCardShipment was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** PhysicalPaymentCardGroupOrderShippedEvent indicates when a Physical Payment Card Group Order has shipped successfully */
export type PhysicalPaymentCardGroupOrderShippedEvent = Node & {
  __typename?: "PhysicalPaymentCardGroupOrderShippedEvent";
  /** Number of cards in the group order */
  cardCount?: Maybe<Scalars["UnsignedInt"]>;
  /** Card product ID. */
  cardProductId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the PaymentCardShipment was created at. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Order state details. */
  groupOrderState?: Maybe<PaymentCardGroupOrderStateDetail>;
  /** Global ID used to reference the PhysicalPaymentCardGroupOrder in operations. */
  id: Scalars["ID"];
  /** The date and time, in ISO 8601 format, the PaymentCardShipment was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** A created PhysicalPaymentCardOrder. */
export type PhysicalPaymentCardOrder = Node & {
  __typename?: "PhysicalPaymentCardOrder";
  /** Card personalization. */
  cardPersonalization?: Maybe<PaymentCardPersonalization>;
  /** The date and time, in ISO 8601 format, the PaymentCardShipment was created at. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Physical card group order details */
  groupOrder?: Maybe<PhysicalCardGroupOrder>;
  /** Global ID used to reference the PaymentCardShipment in operations. */
  id: Scalars["ID"];
  /** Order state details. */
  orderState?: Maybe<PaymentCardOrderStateDetail>;
  /** Payment card details. */
  paymentCard?: Maybe<PaymentCard>;
  /** Payment card shipment */
  paymentCardShipment?: Maybe<PaymentCardShipment>;
  /** Fulfillment state detail history. */
  stateHistory?: Maybe<Array<Maybe<PaymentCardOrderStateDetailHistory>>>;
  /** The date and time, in ISO 8601 format, the PaymentCardShipment was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The connection type for `PhysicalPaymentCardOrder`. */
export type PhysicalPaymentCardOrderConnection = {
  __typename?: "PhysicalPaymentCardOrderConnection";
  /** A list of edges. */
  edges?: Maybe<Array<PhysicalPaymentCardOrderEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a `PhysicalPaymentCardOrder`. */
export type PhysicalPaymentCardOrderEdge = {
  __typename?: "PhysicalPaymentCardOrderEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The Physical Payment Card Order. */
  node?: Maybe<PhysicalPaymentCardOrder>;
};

/** Inputs for filtering PhysicalPaymentCardOrders. */
export type PhysicalPaymentCardOrderFilterInput = {
  /**
   * Input to filter by physical payment card order actual shipping date.
   * Actual ship date should be provided in YYYY-MM-DD format.
   */
  actualShipDateLocal?: InputMaybe<DateFilterInput>;
  /** Input to filter by card product ID. */
  cardProductId?: InputMaybe<IdFilterInput>;
  /** Input to filter by physical payment card order creation date. */
  createdAt?: InputMaybe<TimestampFilterInput>;
  /** Input to filter by physical card group order ID. */
  groupOrderId?: InputMaybe<IdFilterInput>;
  /** Input to filter based on payment card details. */
  paymentCardFilterBy?: InputMaybe<PaymentCardFilterInput>;
  /** Input to filter by physical payment card order status. */
  paymentCardOrderStatus?: InputMaybe<PaymentCardOrderStatusFilterInput>;
  /** Input to filter by physical payment card order ID */
  physicalPaymentCardOrderId?: InputMaybe<IdFilterInput>;
  /** Input to filter by shipping method. */
  shippingMethod?: InputMaybe<PaymentCardShippingMethodFilterInput>;
};

/** PhysicalPaymentCardShipFailedEvent indicates when a Physical Payment Card has failed to ship */
export type PhysicalPaymentCardShipFailedEvent = Node & {
  __typename?: "PhysicalPaymentCardShipFailedEvent";
  /** The date and time, in ISO 8601 format, the PaymentCardShipment was created at. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the PaymentCardShipment in operations. */
  id: Scalars["ID"];
  /** Order state details. */
  orderState?: Maybe<PaymentCardOrderStateDetail>;
  /** Payment card ID. */
  paymentCardId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the PaymentCardShipment was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** PhysicalPaymentCardShippedEvent indicates when a Physical Payment Card has shipped successfully */
export type PhysicalPaymentCardShippedEvent = Node & {
  __typename?: "PhysicalPaymentCardShippedEvent";
  /** The date and time, in ISO 8601 format, the PaymentCardShipment was created at. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the PaymentCardShipment in operations. */
  id: Scalars["ID"];
  /** Order state details. */
  orderState?: Maybe<PaymentCardOrderStateDetail>;
  /** Payment card ID. */
  paymentCardId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the PaymentCardShipment was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The PIN entry mode. */
export enum PinEntryMode {
  /** No PIN entry capability */
  NO_PIN_ENTRY_CAPABILITY = "NO_PIN_ENTRY_CAPABILITY",
  /** PIN entry capability */
  PIN_ENTRY_CAPABILITY = "PIN_ENTRY_CAPABILITY",
  /** PIN pad inoperative */
  PIN_PAD_INOPERATIVE = "PIN_PAD_INOPERATIVE",
  /** PIN verified by terminal device */
  PIN_VERIFIED_BY_TERMINAL_DEVICE = "PIN_VERIFIED_BY_TERMINAL_DEVICE",
  /** Reserved for ISO, national, or private use */
  RESERVED = "RESERVED",
}

/** The PIN Response Code value outlines whether the cardholder entered a PIN during the transaction, whether the PIN was validated, and the result of the validation. */
export enum PinResponseCode {
  /** PIN Validation failed due to temporary network connectivity issues. */
  DECRYPTION_ISSUE = "DECRYPTION_ISSUE",
  /** The cardholder-provided PIN was correct. */
  MATCH = "MATCH",
  /** PIN validation not performed since transaction was declined for another reason. */
  NOT_PERFORMED = "NOT_PERFORMED",
  /** The cardholder did not enter a PIN. */
  NOT_PROVIDED = "NOT_PROVIDED",
  /** The cardholder-provided PIN was incorrect. */
  NO_MATCH = "NO_MATCH",
}

/** An identification as to where a payment initiated */
export enum PointOfServiceCategory {
  /** A terminal used for administrative purposes. */
  ADMINISTRATIVE_TERMINAL = "ADMINISTRATIVE_TERMINAL",
  /** The initial step in a card payment which defines whether the card payment may continue. */
  AUTHORIZATION = "AUTHORIZATION",
  /** A terminal used for self-service fuel purchases. */
  AUTOMATED_FUEL_DISPENSER = "AUTOMATED_FUEL_DISPENSER",
  /** A machine that dispenses cash or performs other banking services. */
  AUTOMATED_TELLER_MACHINE = "AUTOMATED_TELLER_MACHINE",
  /** A terminal which produces or processes coupons. */
  COUPON_MACHINE = "COUPON_MACHINE",
  /** A terminal that processes payment card transactions over a standard phone line. */
  DIAL_TERMINAL = "DIAL_TERMINAL",
  /** A commercial transaction conducted electronically online. */
  ECOMMERCE = "ECOMMERCE",
  /** A device used to process cash and payment card transactions. */
  ELECTRONIC_CASH_REGISTER = "ELECTRONIC_CASH_REGISTER",
  /** A device used by franchised financial instititions' bank branches to handle with customer transactions. */
  FRANCHISE_TELLER = "FRANCHISE_TELLER",
  /** A terminal used at a home rather than a business location. */
  HOME_TERMINAL = "HOME_TERMINAL",
  /** A television that accepts input from account holders for card payments. */
  INTERACTIVE_TELEVISION = "INTERACTIVE_TELEVISION",
  /** A device used to convert an electronic check for deposits. */
  MICR_TERMINAL = "MICR_TERMINAL",
  /** A mobile devices utilized to process card payments (Mobile Point of Sale). */
  MPOS = "MPOS",
  /** A transaction in which funds are transferred for goods and/or services. */
  PAYMENT = "PAYMENT",
  /** A terminal utilized for general banking processing such as ATM withdrawals. */
  PERSONAL_BANKING = "PERSONAL_BANKING",
  /** A mobile device utilized for a variety of functions including card payments. */
  PERSONAL_DIGITAL_ASSISTANCE = "PERSONAL_DIGITAL_ASSISTANCE",
  /** A device presented at a teller where an account holder inserts their card for verification and authorization. */
  POINT_OF_BANKING_TERMINAL = "POINT_OF_BANKING_TERMINAL",
  /** A terminal used for making a sale. */
  POS_TERMINAL = "POS_TERMINAL",
  /** A terminal used by a public utility to process card payments. */
  PUBLIC_UTILITY = "PUBLIC_UTILITY",
  /** A phone with a digital display. */
  SCREEN_PHONE = "SCREEN_PHONE",
  /** A terminal which produces or processes scrips. */
  SCRIP_MACHINE = "SCRIP_MACHINE",
  /** A terminal operated by the account holder to process a card payment. */
  SELF_SERVICE = "SELF_SERVICE",
  /** A mobile phone that performs many functions of a personal computer. */
  SMART_PHONE = "SMART_PHONE",
  /** A device that provides telephone functions. */
  TELEPHONE_DEVICE = "TELEPHONE_DEVICE",
  /** A device used by financial instititions' bank branches to handle with customer transactions. */
  TELLER = "TELLER",
  /** A terminal which produces or processes tickets. */
  TICKET_MACHINE = "TICKET_MACHINE",
  /** A terminal that processes travelers' checks. */
  TRAVELERS_CHECK_MACHINE = "TRAVELERS_CHECK_MACHINE",
  /** A terminal activated by an account holder for a card payment that requires authorization. */
  UNATTENDED_CARDHOLDER_ACTIVATED_AUTHORIZED = "UNATTENDED_CARDHOLDER_ACTIVATED_AUTHORIZED",
  /** A terminal activated by an account holder for a card payment that does not require authorization. */
  UNATTENDED_CARDHOLDER_ACTIVATED_NO_AUTHORIZATION = "UNATTENDED_CARDHOLDER_ACTIVATED_NO_AUTHORIZATION",
  /** A terminal used for unattended chip and PIN transactions. */
  UNATTENDED_CHIP_PIN_TERMINAL = "UNATTENDED_CHIP_PIN_TERMINAL",
  /** A terminal activated by an account holder for a card payment. */
  UNATTENDED_CUSTOMER_TERMINAL = "UNATTENDED_CUSTOMER_TERMINAL",
  /** A machine that dispenses small goods, such as food and drinks. */
  VENDING = "VENDING",
  /** A Voice Response Unit that interacts with account holders. */
  VRU = "VRU",
}

/** A condition for the point of service category, which serves as acceptable input arguments for creating an authorization control. */
export enum PointOfServiceCategoryCondition {
  /** A terminal used for administrative purposes. */
  ADMINISTRATIVE_TERMINAL = "ADMINISTRATIVE_TERMINAL",
  /** A device which allows account holders to pay for their gas and pump it themselves. */
  AUTOMATED_FUEL_DISPENSER = "AUTOMATED_FUEL_DISPENSER",
  /** A machine that dispenses cash or performs other banking services when an account holder inserts a bank card. */
  AUTOMATED_TELLER_MACHINE = "AUTOMATED_TELLER_MACHINE",
  /** A commercial transaction conducted electronically on the internet. */
  ECOMMERCE = "ECOMMERCE",
  /** A device that enables a person employed at franchised financial institition to deal with customers' transactions. */
  FRANCHISE_TELLER = "FRANCHISE_TELLER",
  /** A device used to convert an electronic check for deposits. */
  MICR_TERMINAL = "MICR_TERMINAL",
  /** A device presented at a teller where an account holder inserts their card for verification and authorization. */
  POINT_OF_BANKING_TERMINAL = "POINT_OF_BANKING_TERMINAL",
  /** A terminal used for making a sale. */
  POS_TERMINAL = "POS_TERMINAL",
  /** A device that enables a person employed at financial institition to deal with customers' transactions. */
  TELLER = "TELLER",
  /** A machine that dispenses small articles such as food, drinks, or cigarettes when a coin, bill, or token is inserted. */
  VENDING = "VENDING",
}

/** A Spend Control rule that allows or blocks certain point of service categories during authorizations. */
export type PointOfServiceCategorySpendRule = Node &
  SpendRule & {
    __typename?: "PointOfServiceCategorySpendRule";
    /** The point of services that will be allowed during authorizations. */
    allowed?: Maybe<Array<PointOfServiceCategoryCondition>>;
    /** The point of services that will result in declined authorizations. */
    blocked?: Maybe<Array<PointOfServiceCategoryCondition>>;
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the Merchant Category Spend Rule in operations. */
    id: Scalars["ID"];
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/** A Spend Control rule that allows or blocks certain point of service categories during authorizations. */
export type PointOfServiceCategorySpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The result of applying a point of service category spend rule to an event. */
export type PointOfServiceCategorySpendRuleResult = SpendRuleResult & {
  __typename?: "PointOfServiceCategorySpendRuleResult";
  /** The attached level. */
  attachedLevel?: Maybe<AttachedLevel>;
  /** A message describing the result. */
  message?: Maybe<Scalars["String"]>;
  /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
  recommendation?: Maybe<SpendRuleRecommendation>;
  /** The spend rule attached at the time of the event. */
  spendRule?: Maybe<PointOfServiceCategorySpendRule>;
  /** The tested points of service of the event. */
  valuesTested?: Maybe<Array<PointOfServiceCategory>>;
};

/** Details about the point of service for the transaction. */
export type PointOfServiceDetails = {
  __typename?: "PointOfServiceDetails";
  /** Tha capabilities of the terminal to read card data */
  cardDataInputCapability?: Maybe<CardDataInputCapability>;
  /** The point of service category. */
  category?: Maybe<PointOfServiceCategory>;
  /** Represents whether the cardholder is present or not. */
  isCardHolderPresent?: Maybe<Scalars["Boolean"]>;
  /** Represents whether the card is present or not. */
  isCardPresent?: Maybe<Scalars["Boolean"]>;
  /** Represents whether this transaction is recurring or not. */
  isRecurring?: Maybe<Scalars["Boolean"]>;
  /** The PAN entry mode. */
  panEntryMode?: Maybe<PanEntryMode>;
  /** The PIN entry mode. */
  pinEntryMode?: Maybe<PinEntryMode>;
  /** The attendance at the terminal. */
  terminalAttendance?: Maybe<TerminalAttendance>;
  /** Represents whether the terminal supports partial approval or not. */
  terminalSupportsPartialApproval?: Maybe<Scalars["Boolean"]>;
};

/** Details about the point of service for the transaction. */
export type PointOfServiceDetailsInput = {
  /** Tha capabilities of the terminal to read card data. */
  cardDataInputCapability?: InputMaybe<CardDataInputCapability>;
  /** The point of service category. */
  category?: InputMaybe<PointOfServiceCategory>;
  /** Represents whether the cardholder is present or not. */
  isCardHolderPresent?: InputMaybe<Scalars["Boolean"]>;
  /** Represents whether the card is present or not. */
  isCardPresent?: InputMaybe<Scalars["Boolean"]>;
  /**
   * Represents whether this transaction is recurring or not.
   * When this field is set to `true`, `isCardholderPresent` and `isCardPresent` should be false.
   */
  isRecurring?: InputMaybe<Scalars["Boolean"]>;
  /** The PAN entry mode. */
  panEntryMode?: InputMaybe<PanEntryMode>;
  /** The PIN entry mode. */
  pinEntryMode?: InputMaybe<PinEntryMode>;
  /** The attendance at the terminal. */
  terminalAttendance?: InputMaybe<TerminalAttendance>;
  /** Represents whether the terminal supports partial approval or not. */
  terminalSupportsPartialApproval?: InputMaybe<Scalars["Boolean"]>;
};

/** Whether or not the `CardProduct` supports rewards. */
export type PointRewardCardProductFeature = CardProductFeature &
  ProductFeature & {
    __typename?: "PointRewardCardProductFeature";
    /** The date and time, in ISO 8601 format, the feature was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective from. */
    effectiveFrom?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective through. */
    effectiveThrough?: Maybe<Scalars["String"]>;
    /** Whether or not the feature is enabled for the `CardProduct`. */
    enabled?: Maybe<Scalars["Boolean"]>;
    /** The date and time, in ISO 8601 format, the feature was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Whether or not the Financial Account supports Point Rewards. */
export type PointRewardFinancialAccountFeature = FinancialAccountFeature & {
  __typename?: "PointRewardFinancialAccountFeature";
  /** The date and time, in ISO 8601 format, the feature was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective from. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective through. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Whether or not the feature is enabled for the Financial Account. */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** The date and time, in ISO 8601 format, the feature was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Code representing the result of AVS postal code verification */
export enum PostalCodeResponseCode {
  /** The postal code provided on the authorization matched a postal code on file for the Cardholder. */
  MATCH = "MATCH",
  /**
   * The postal code was not checked for verification.
   *
   * This typically occurs when a postal code is provided during authorization but we were unable to locate the same value in our vault.
   */
  NOT_PERFORMED = "NOT_PERFORMED",
  /** The postal code was not provided on the authorization. */
  NOT_PROVIDED = "NOT_PROVIDED",
  /** The postal code provided on the authorization did not match a postal code on file for the Cardholder. */
  NO_MATCH = "NO_MATCH",
  /** The 5-digit zip code provided on the authorization matched the zip code on file for the Cardholder. */
  ZIP5_MATCH = "ZIP5_MATCH",
  /** The 9-digit zip code provided on the authorization matched the zip code on file for the Cardholder. */
  ZIP9_MATCH = "ZIP9_MATCH",
}

/** Input for filtering Postal code response code */
export type PostalCodeResponseCodeFilterInput = {
  /** Value matches the provided Postal code response code */
  equals?: InputMaybe<PostalCodeResponseCode>;
  /** Value does not match any of the provided Postal code response code */
  excludes?: InputMaybe<Array<PostalCodeResponseCode>>;
  /** Value exactly matches all of the provided Postal code response code */
  includes?: InputMaybe<Array<PostalCodeResponseCode>>;
  /** Value does not match the provided Postal code response code */
  notEquals?: InputMaybe<PostalCodeResponseCode>;
};

/** A Spend Control rule that allows or blocks certain postal code response codes during authorizations. */
export type PostalCodeVerificationSpendRule = Node &
  SpendRule & {
    __typename?: "PostalCodeVerificationSpendRule";
    /** The postal code response codes that will be allowed during authorizations. */
    allowed?: Maybe<Array<PostalCodeResponseCode>>;
    /** The postal code response codes that will result in declined authorizations. */
    blocked?: Maybe<Array<PostalCodeResponseCode>>;
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the Postal Code Verification Spend Rule in operations. */
    id: Scalars["ID"];
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/** A Spend Control rule that allows or blocks certain postal code response codes during authorizations. */
export type PostalCodeVerificationSpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The result of applying a `PostalCodeVerificationSpendRule` to an event. */
export type PostalCodeVerificationSpendRuleResult = SpendRuleResult & {
  __typename?: "PostalCodeVerificationSpendRuleResult";
  /** The attached level. */
  attachedLevel?: Maybe<AttachedLevel>;
  /** A message describing the result. */
  message?: Maybe<Scalars["String"]>;
  /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
  recommendation?: Maybe<SpendRuleRecommendation>;
  /** The spend rule attached at the time of the event. */
  spendRule?: Maybe<PostalCodeVerificationSpendRule>;
  /** The tested `PostalCodeResponseCode` of the event. */
  valuesTested?: Maybe<Array<PostalCodeResponseCode>>;
};

/** Whether or not the Financial Account supports a PrePaid Payment Card. */
export type PrePaidPaymentCardFinancialAccountFeature =
  FinancialAccountFeature & {
    __typename?: "PrePaidPaymentCardFinancialAccountFeature";
    /** The date and time, in ISO 8601 format, the feature was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective from. */
    effectiveFrom?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective through. */
    effectiveThrough?: Maybe<Scalars["String"]>;
    /** Whether or not the feature is enabled for the Financial Account. */
    enabled?: Maybe<Scalars["Boolean"]>;
    /** The date and time, in ISO 8601 format, the feature was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Whether or not the `FinancialAccount` supports preprinted cards. */
export type PreprintedCardFinancialAccountFeature = FinancialAccountFeature & {
  __typename?: "PreprintedCardFinancialAccountFeature";
  /** The date and time, in ISO 8601 format, the feature was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective from. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective through. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Whether or not the feature is enabled for the Financial Account. */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** The date and time, in ISO 8601 format, the feature was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** a type representing a previous application */
export type PreviousProductApplication =
  | AccountHolderCardProductApplication
  | AuthorizedUserCardProductApplication;

/** The connection type for previous applications */
export type PreviousProductApplicationConnection = {
  __typename?: "PreviousProductApplicationConnection";
  /** A list of edges. */
  edges?: Maybe<Array<PreviousProductApplicationEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** An edge for a previous product application */
export type PreviousProductApplicationEdge = {
  __typename?: "PreviousProductApplicationEdge";
  /** The cursor for this edge for use in pagination. */
  cursor?: Maybe<Scalars["String"]>;
  /** The node representing an application. */
  node?: Maybe<PreviousProductApplication>;
};

/** Filter input for previous applications */
export type PreviousProductApplicationFilterInput = {
  /** The create date of the previous application */
  createdAt?: InputMaybe<TimestampFilterInput>;
  /** The current relationship status with the previous application */
  includes?: InputMaybe<Array<AccountHolderApplicationStatusCode>>;
};

/** Associates a `PricingPlan` with specific parties and a validity period. */
export type PricingConfiguration = Node & {
  __typename?: "PricingConfiguration";
  /** The timestamp, in ISO 8601 format, from which this configuration is effective. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /**
   * The timestamp, in ISO 8601 format, through which this configuration is effective.
   * If not set, the configuration has no expiration.
   */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** The unique identifier of the `PricingConfiguration`. */
  id: Scalars["ID"];
  /** The identifier of the payee entity associated with this configuration. */
  payeeEntityId?: Maybe<Scalars["ID"]>;
  /** The identifier of the payer entity associated with this configuration. */
  payerEntityId?: Maybe<Scalars["ID"]>;
  /** The `PricingPlan` associated with this configuration. */
  pricingPlan?: Maybe<PricingPlan>;
};

/** The pricing plan available for an organization. */
export type PricingPlan = Node & {
  __typename?: "PricingPlan";
  /** The timestamp, in ISO 8601 format, when this plan was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** A description of the pricing plan. */
  description?: Maybe<Scalars["String"]>;
  /** The unique identifier of the `PricingPlan`. */
  id: Scalars["ID"];
  /** The name of the pricing plan. */
  name?: Maybe<Scalars["String"]>;
  /** The list of `PricingRule` records that dictate how charges are calculated. */
  rules?: Maybe<PricingRuleConnection>;
  /**
   * The current lifecycle state of the plan.
   * Rules are only modifiable when status is `DRAFT`.
   */
  status?: Maybe<PricingPlanStatus>;
  /** The timestamp, in ISO 8601 format, when this plan was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The pricing plan available for an organization. */
export type PricingPlanRulesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The lifecycle states for a `PricingPlan`. */
export enum PricingPlanStatus {
  /** Plan is no longer in use and preserved for historical records. */
  ARCHIVED = "ARCHIVED",
  /** Plan is being drafted or modified. Rules can only be changed in this state. */
  DRAFT = "DRAFT",
  /** Plan is currently live and applied to transactions. */
  PUBLISHED = "PUBLISHED",
}

/** A pricing rule within a `PricingPlan`, referencing a template and containing trigger, frequency, and parameter values. */
export type PricingRule = Node & {
  __typename?: "PricingRule";
  /** The timestamp, in ISO 8601 format, when this rule was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** How often the rule is evaluated. */
  frequency?: Maybe<PricingRuleFrequency>;
  /** The unique identifier of the `PricingRule`. */
  id: Scalars["ID"];
  /** The list of `PricingRuleParameter` records mapped to the template's placeholders. */
  parameters?: Maybe<Array<PricingRuleParameter>>;
  /** The ID of the pricing rule template providing the logic for this rule. */
  templateId?: Maybe<Scalars["ID"]>;
  /** The event that triggers this rule. */
  trigger?: Maybe<PricingRuleTrigger>;
};

/** The connection type for `PricingRule`. */
export type PricingRuleConnection = {
  __typename?: "PricingRuleConnection";
  /** A list of edges. */
  edges?: Maybe<Array<PricingRuleEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a `PricingRule`. */
export type PricingRuleEdge = {
  __typename?: "PricingRuleEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The `PricingRule` node. */
  node?: Maybe<PricingRule>;
};

/** The frequency at which a `PricingRule` is evaluated and billed. */
export enum PricingRuleFrequency {
  /** Rule is evaluated per transaction. */
  TRANSACTIONAL = "TRANSACTIONAL",
}

/** A key-value pair used to inject data into a `PricingRuleTemplate` script. */
export type PricingRuleParameter = {
  __typename?: "PricingRuleParameter";
  /** The name of the placeholder in the template script. */
  name?: Maybe<Scalars["String"]>;
  /** The value to substitute for the placeholder. */
  value?: Maybe<PricingRuleParameterValue>;
};

/** The value of a `PricingRuleParameter`. */
export type PricingRuleParameterValue = PricingRuleParameterValueSingle;

/** A single value for a `PricingRuleParameter`. */
export type PricingRuleParameterValueSingle = {
  __typename?: "PricingRuleParameterValueSingle";
  /** The value. */
  value?: Maybe<Scalars["String"]>;
};

/** The event that triggers a `PricingRule`. */
export enum PricingRuleTrigger {
  /** Rule is triggered for batch processing. */
  BATCH = "BATCH",
  /** Rule is triggered for each individual transaction. */
  TRANSACTION = "TRANSACTION",
}

export type ProcessingCapability = CardProcessingCapability;

/** The status of a `CardProcessingCapability`. */
export enum ProcessingCapabilityStatus {
  /** The `CardProcessingCapability` is active. */
  ACTIVE = "ACTIVE",
  /** The `CardProcessingCapability` is deactivated. */
  DEACTIVATED = "DEACTIVATED",
  /** The `CardProcessingCapability` is pending. */
  PENDING = "PENDING",
  /** The `CardProcessingCapability` is rejected. */
  REJECTED = "REJECTED",
}

/** Snapshot of the product applicant's business profile. */
export type ProductApplicantBusinessProfileSnapshot = UsBusinessProfileSnapshot;

/** An Application for an `ApplicationProduct`. */
export type ProductApplication = Node & {
  __typename?: "ProductApplication";
  /** The affiliate `Organization` associated with this `ProductApplication`, such as an Independent Sales Org (ISO) or Independent Software Vendor (ISV). */
  affiliateOrganization?: Maybe<Organization>;
  /** The current state of the application. */
  applicationState?: Maybe<ProductApplicationState>;
  /** The contract for the `ApplicationProduct` used for this `ProductApplication`. */
  contract?: Maybe<ApplicationContract>;
  /** The date and time, in ISO 8601 format, the application was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the application in operations. */
  id: Scalars["ID"];
  /** The `Organization` associated with this `ProductApplication`. */
  organization?: Maybe<Organization>;
  /** The Product to which the account holder is applying. */
  product?: Maybe<ApplicationProduct>;
  /** The date and time, in ISO 8601 format, the application was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The connection type for `ProductApplication`. */
export type ProductApplicationConnection = {
  __typename?: "ProductApplicationConnection";
  /** A list of edges. */
  edges?: Maybe<Array<ProductApplicationEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The return types when querying a paginated list of `ProductApplication`; */
export type ProductApplicationConnectionPayload =
  | AccessDeniedError
  | ProductApplicationConnection
  | UserError;

/** The edge type for `ProductApplication`. */
export type ProductApplicationEdge = {
  __typename?: "ProductApplicationEdge";
  /** The cursor for this edge for use in pagination. */
  cursor?: Maybe<Scalars["String"]>;
  /** The `ProductApplication`. */
  node?: Maybe<ProductApplication>;
};

/** A type representing a state of a `ProductApplication` */
export type ProductApplicationState = {
  __typename?: "ProductApplicationState";
  /** Status of application. */
  status: ProductApplicationStatusCode;
};

/** The High-level status of a `ProductApplication`. */
export enum ProductApplicationStatusCode {
  /** The application was approved. */
  APPROVED = "APPROVED",
  /** The application was closed. */
  CLOSED = "CLOSED",
  /** The application was denied. */
  DENIED = "DENIED",
  /** The application requires further review. */
  IN_REVIEW = "IN_REVIEW",
  /** The application is currently being processed. */
  PENDING = "PENDING",
}

export type ProductApplicationWorkflow = {
  __typename?: "ProductApplicationWorkflow";
  /** The order in which this workflow will be executed within the set of workflows associated with the application */
  executionOrder?: Maybe<Scalars["UnsignedInt"]>;
  /** The current status of this workflow */
  status?: Maybe<ProductApplicationWorkflowStatus>;
  /** The type of workflow */
  workflowType?: Maybe<ProductApplicationWorkflowType>;
};

/** The status of an `ProductApplicationWorkflow` */
export enum ProductApplicationWorkflowStatus {
  /** The workflow has completed processing */
  COMPLETED = "COMPLETED",
  /** The workflow is currently being processed */
  IN_PROGRESS = "IN_PROGRESS",
  /** The workflow has yet to begin execution */
  PENDING = "PENDING",
}

/** The type of `ProductApplicationWorkflow` */
export enum ProductApplicationWorkflowType {
  /** The workflow that evaluates business rules associated with the application */
  BUSINESS_RULE_VALIDATION = "BUSINESS_RULE_VALIDATION",
  /** The workflow for provisioning a VPA buyer in the Visa system */
  CREATE_VPA_BUYER = "CREATE_VPA_BUYER",
  /** A workflow for performing credit underwriting */
  CREDIT_UNDERWRITING = "CREDIT_UNDERWRITING",
  /** The workflow that performs provisioning actions within the external bank associated with the application */
  EXTERNAL_BANK_ONBOARDING = "EXTERNAL_BANK_ONBOARDING",
  /** A workflow for verifying identity information associated with the application */
  IDENTITY = "IDENTITY",
  /** The workflow for managing offers associated with the application */
  OFFER_MANAGEMENT = "OFFER_MANAGEMENT",
  /** A workflow for performing risk-assesment related activities */
  RISK = "RISK",
}

/** Defines the abilities of a `Product`. */
export type ProductFeature = {
  /** The date and time, in ISO 8601 format, this `ProductFeature` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, this `ProductFeature` was effective from. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, this `ProductFeature` was effective through. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Whether or not this `ProductFeature` is enabled for the `Product`. */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** The date and time, in ISO 8601 format, this `ProductFeature` was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Whether or not the Financial Account supports Product Funding. */
export type ProductFundingFinancialAccountFeature = FinancialAccountFeature & {
  __typename?: "ProductFundingFinancialAccountFeature";
  /** The date and time, in ISO 8601 format, the feature was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective from. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective through. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Whether or not the feature is enabled for the Financial Account. */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** The date and time, in ISO 8601 format, the feature was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Represents a profile for a `Product` which is a collection of `ProductFeature`s. */
export type ProductProfile = Node & {
  __typename?: "ProductProfile";
  /** The date and time, in ISO 8602 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, from which the `ProductProfile` is active. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, from which the `ProductProfile` becomes inactive. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** The features that are available on this `ProductProfile`. */
  features?: Maybe<Array<ProductFeature>>;
  /** Global ID used to reference this object. */
  id: Scalars["ID"];
  /** The name for this `ProductProfile`. */
  name?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, this object was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The Product Reserve is held to cover deficits in the product such as card activity settlement. Funds may not be transferred out of the Product Reserve */
export type ProductReserveFinancialAccountFeature = FinancialAccountFeature & {
  __typename?: "ProductReserveFinancialAccountFeature";
  /** The date and time, in ISO 8601 format, the feature was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective from. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective through. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Whether or not the feature is enabled for the Financial Account. */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** The date and time, in ISO 8601 format, the feature was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Whether or not the `FinancialAccount` supports product secured deposits. */
export type ProductSecuredDepositFinancialAccountFeature =
  FinancialAccountFeature & {
    __typename?: "ProductSecuredDepositFinancialAccountFeature";
    /** The date and time, in ISO 8601 format, the feature was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective from. */
    effectiveFrom?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective through. */
    effectiveThrough?: Maybe<Scalars["String"]>;
    /** Whether or not the feature is enabled for the Financial Account. */
    enabled?: Maybe<Scalars["Boolean"]>;
    /** The date and time, in ISO 8601 format, the feature was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/**
 * Defines the different actions that can be performed during the provisioning process for an account holder.
 *
 * Each action represents a specific step or operation to be executed.
 */
export enum ProvisionAccountHolderAction {
  /** Creates an application for an Account Holder. This action starts the application process. */
  CREATE_APPLICATION = "CREATE_APPLICATION",
  /** Issues an account based on an application. When used in conjunction with `CREATE_APPLICATION`, this action will use the provided `AccountHolderCardProductApplication` to issue the account. */
  ISSUE_FINANCIAL_ACCOUNT = "ISSUE_FINANCIAL_ACCOUNT",
  /** Issues a Payment Card for a `FinancialAccount`. When used with `ISSUE_FINANCIAL_ACCOUNT`, this action will issue the `PaymentCard` to the specified `FinancialAccount` */
  ISSUE_PAYMENT_CARD = "ISSUE_PAYMENT_CARD",
  /** Link verified external bank account with a `FinancialAccount` */
  LINK_VERIFIED_EXTERNAL_BANK_ACCOUNT = "LINK_VERIFIED_EXTERNAL_BANK_ACCOUNT",
  /**
   * Notifies the configured provider that the workflow has been completed. Provider configurations are determined as part of the technical solution.
   *
   * Note: This action will only be executed upon approval of the technical solution.
   */
  NOTIFY_PROVIDER = "NOTIFY_PROVIDER",
  /** Registers the Account Holder with Visa's Payable Automation solution, facilitating integration with Visa's payment systems. */
  REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT = "REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT",
  /** Sets a credit limit on a `FinancialAccount`. When used with `ISSUE_FINANCIAL_ACCOUNT`, this action will apply the credit limit to the specified `FinancialAccount`. */
  SET_CREDIT_LIMIT = "SET_CREDIT_LIMIT",
}

/**
 * Represents the details of an account holder provisioning action.
 *
 * This type includes the various inputs required for different provisioning actions, such as creating an application, setting a credit limit, or issuing a payment card.
 */
export type ProvisionAccountHolderActionDetail = {
  __typename?: "ProvisionAccountHolderActionDetail";
  /** Input details for creating an account holder application. This field contains the parameters needed to process the application. */
  createAccountHolderCardProductApplicationInput?: Maybe<ProvisionCreateAccountHolderCardProductApplicationActionDetail>;
  /** Input details for setting a credit limit on a financial account. This field specifies the parameters required to update the credit limit for the financial account. */
  initiateFinancialAccountCreditLimitUpdateFromProductFundingInput?: Maybe<ProvisionInitiateFinancialAccountCreditLimitUpdateFromProductFundingActionDetail>;
  /** Input details for creating a financial account. This field includes the parameters necessary to establish a new financial account for the account holder. */
  issueFinancialAccountForApplicationInput?: Maybe<ProvisionIssueFinancialAccountForApplicationActionDetail>;
  /** Input details for issuing a payment card for a financial account. This field contains the parameters needed to issue a new payment card associated with the specified financial account. */
  issuePaymentCardForFinancialAccountInput?: Maybe<ProvisionIssuePaymentCardForFinancialAccountActionDetail>;
  /** Input details for linking external bank account. */
  linkVerifiedExternalBankAccountInput?: Maybe<ProvisionLinkVerifiedExternalBankAccountActionDetail>;
};

/**
 * Input object for specifying actions during the provisioning of an account holder.
 *
 * This type contains the inputs required for various provisioning actions, such as creating an application, setting a financial account credit limit, or issuing a payment card.
 */
export type ProvisionAccountHolderActionInput = {
  /**
   * Input details required to create an account holder application.
   *
   * This field provides the necessary parameters for processing an application for the account holder.
   */
  createAccountHolderCardProductApplicationInput?: InputMaybe<ProvisionCreateAccountHolderCardProductApplicationInput>;
  /**
   * Input details for setting or updating the credit limit of a financial account.
   *
   * This field contains the parameters needed to define or modify the credit limit for the account holder’s financial account.
   */
  initiateFinancialAccountCreditLimitUpdateFromProductFundingInput?: InputMaybe<ProvisionInitiateFinancialAccountCreditLimitUpdateFromProductFundingInput>;
  /**
   * Input details required to issue a financial account for the account holder.
   *
   * This field includes the necessary parameters to establish and configure a new financial account.
   */
  issueFinancialAccountForApplicationInput?: InputMaybe<ProvisionIssueFinancialAccountForApplicationInput>;
  /**
   * Input details required to issue a payment card associated with the account holder’s financial account.
   *
   * This field provides the necessary parameters for issuing a payment card.
   */
  issuePaymentCardForFinancialAccountInput?: InputMaybe<ProvisionIssuePaymentCardForFinancialAccountInput>;
  /** Input details for linking an account holder with verified external bank account. */
  linkVerifiedExternalBankAccountInput?: InputMaybe<LinkVerifiedExternalBankInput>;
};

/** Input to provision an Account Holder */
export type ProvisionAccountHolderInput = {
  /** The unique identifier of the account holder being provisioned. This field should be a valid ID representing the account holder. */
  accountHolderId: Scalars["ID"];
  /** Required input specific to the actions being performed. This allows for additional details or parameters needed for the actions. */
  actionInput: ProvisionAccountHolderActionInput;
  /** A list of actions to be performed during the provisioning process. Each action represents a specific operation or step to be executed. */
  actions: Array<ProvisionAccountHolderAction>;
  /**
   * A UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey: Scalars["IdempotencyKey"];
};

/**
 * Union type representing the possible payloads for provisioning an account holder.
 *
 * This union includes the outcomes of provisioning actions, error messages, and access permissions.
 */
export type ProvisionAccountHolderPayload =
  | AccessDeniedError
  | AccountHolderProvisioning
  | UserError;

/** Details for an account holder's application process. */
export type ProvisionCreateAccountHolderCardProductApplicationActionDetail = {
  __typename?: "ProvisionCreateAccountHolderCardProductApplicationActionDetail";
  /** Details on the account holder's consent to pull their credit report as part of the card product application. This field captures the applicant's consent for this specific action. */
  accountHolderCreditReportPullConsent?: Maybe<ConsentAgreement>;
  /**
   * Optional application-level configuration provided by the applicant at the start of the application,
   * such as billing cycle preferences.
   */
  applicationConfiguration?: Maybe<ApplicationConfiguration>;
  /** Details on the acceptance of the terms and conditions of the card holder agreement. This field captures the applicant's consent to the agreement. */
  cardHolderAgreementConsent?: Maybe<ConsentAgreement>;
};

/**
 * Input for an account holder's application process.
 *
 * This input type includes fields for consent to terms and conditions, IP address details, and credit report pull consent.
 */
export type ProvisionCreateAccountHolderCardProductApplicationInput = {
  /** Details on the account holder's consent to pull their credit report as part of the card product application. This field captures the applicant's consent for this specific action. */
  accountHolderCreditReportPullConsent?: InputMaybe<ConsentInput>;
  /**
   * Optional application-level configuration provided by the applicant at the start of the application,
   * such as billing cycle preferences.
   */
  applicationConfiguration?: InputMaybe<ApplicationConfigurationInput>;
  /** Details on the acceptance of the terms and conditions of the card holder agreement. This field captures the applicant's consent to the agreement. */
  cardHolderAgreementConsent: ConsentInput;
  /** The unique identifier of the card product associated with the account holder. This field should be a valid ID representing the card product. */
  cardProductId: Scalars["ID"];
};

/**
 * Input for setting the credit limit of a financial account.
 *
 * This input type includes details for specifying the credit limit amount and an optional description.
 */
export type ProvisionInitiateFinancialAccountCreditLimitUpdateFromProductFundingActionDetail =
  {
    __typename?: "ProvisionInitiateFinancialAccountCreditLimitUpdateFromProductFundingActionDetail";
    /** The amount of credit limit to be set for the payment card. This field specifies the new credit limit amount. */
    amount?: Maybe<Amount>;
    /** An optional description or memo for the credit limit update. This field provides context or notes about the credit limit change for future reference. */
    memo?: Maybe<Scalars["String"]>;
  };

/**
 * Input for setting the credit limit of a financial account.
 *
 * This input type includes details for specifying the credit limit amount and an optional description.
 */
export type ProvisionInitiateFinancialAccountCreditLimitUpdateFromProductFundingInput =
  {
    /** The amount of credit limit to be set for the payment card. This field specifies the new credit limit amount. */
    amount: AmountInput;
    /** An optional description or memo for the credit limit update. This field provides context or notes about the credit limit change for future reference. */
    memo?: InputMaybe<Scalars["String"]>;
  };

/** Request contents for ProvisionIssueFinancialAccountForApplicationAction */
export type ProvisionIssueFinancialAccountForApplicationActionDetail = {
  __typename?: "ProvisionIssueFinancialAccountForApplicationActionDetail";
  /** The name of the financial account. This field is required and should provide a meaningful name for the account. */
  name?: Maybe<Scalars["String"]>;
};

/**
 * Input for issuing a new financial account.
 *
 * This input type includes fields for specifying an external identifier and the name of the financial account.
 */
export type ProvisionIssueFinancialAccountForApplicationInput = {
  /** The name of the financial account. This field is required and should provide a meaningful name for the account. */
  name: Scalars["String"];
};

/**
 * Input for provisioning an issued payment card for a financial account.
 *
 * This input type includes options for configuring the newly issued payment card.
 */
export type ProvisionIssuePaymentCardForFinancialAccountActionDetail = {
  __typename?: "ProvisionIssuePaymentCardForFinancialAccountActionDetail";
  /** Options for the newly issued payment card. This field specifies the configuration details and preferences for the card issuance. */
  options?: Maybe<IssuePaymentCardOptionsDetail>;
};

/**
 * Input for provisioning an issued payment card for a financial account.
 *
 * This input type includes options for configuring the newly issued payment card.
 */
export type ProvisionIssuePaymentCardForFinancialAccountInput = {
  /** Options for the newly issued payment card. This field specifies the configuration details and preferences for the card issuance. */
  options: IssuePaymentCardOptionsInput;
};

/** Details for linking verified external bank account. */
export type ProvisionLinkVerifiedExternalBankAccountActionDetail = {
  __typename?: "ProvisionLinkVerifiedExternalBankAccountActionDetail";
  /** The token provided by account holder as part of the GenerateVerifiedExternalBankAccountLinkToken process */
  publicToken?: Maybe<Scalars["String"]>;
};

/**
 * Defines the providers involved in the provisioning workflow.
 *
 * Currently supported providers are listed, with their associated configuration and usage details.
 */
export enum ProvisionWorkflowProvider {
  /** Bottom Line: A provider that may offer services related to provisioning, such as payment solutions or account management. */
  BOTTOM_LINE = "BOTTOM_LINE",
}

/**
 * Indicates whether an amount should be added to or subtracted from the pseudo balance.
 * Used for balance adjustments and limit calculations.
 */
export enum PseudoBalanceAmountSign {
  /**
   * Subtracts the specified amount from the current pseudo balance.
   * Decreases the balance (less spending or lower limit).
   */
  NEGATIVE = "NEGATIVE",
  /**
   * Adds the specified amount to the current pseudo balance.
   * Increases the balance (more spending or higher limit).
   */
  POSITIVE = "POSITIVE",
}

/**
 * Defines how frequently the pseudo balance resets automatically.
 * Controls the rollover period for balance tracking and limit enforcement.
 *
 * Defaults to LIFETIME.
 */
export enum PseudoBalanceCadence {
  /**
   * Resets daily at the time specified in resetTime.
   * Example: "2000-01-15T08:30:00Z" → resets every day at 8:30 AM UTC
   *
   * Default resetTime would be midnight UTC.
   */
  DAILY = "DAILY",
  /**
   * Never resets automatically - resetTime is ignored.
   * Manual reset via resetPseudoBalance mutation required.
   *
   * This is the default `PseudoBalanceCadence`.
   *
   * Default resetTime would be undefined, since there is no reset time for LIFETIME.
   */
  LIFETIME = "LIFETIME",
  /**
   * Resets monthly on the same day-of-month and time as resetTime.
   * Example: "2000-01-15T09:00:00Z" → resets on the 15th of every month at 9:00 AM UTC
   * Note: For months without the specified day (e.g., Feb 30th), resets on the last day of the month
   *
   * Default resetTime would be midnight on the 1st of the month UTC.
   */
  MONTHLY = "MONTHLY",
  /**
   * Resets every 90 calendar days from the resetTime date and time.
   * Example: "2000-01-15T12:00:00Z" → next reset on "2000-04-14T12:00:00Z" (90 days later)
   *
   * Default resetTime would be midnight on the 91st day UTC.
   */
  NINETY_DAYS = "NINETY_DAYS",
  /**
   * Resets quarterly (every 3 months) on the same day and time as resetTime.
   * Example: "2000-01-15T10:00:00Z" → resets Apr 15th, Jul 15th, Oct 15th at 10:00 AM UTC
   * Note: For Feb 29th, non-leap years reset on Mar 1st
   *
   * Default resetTime would be at the start of the quarter UTC.
   */
  QUARTERLY = "QUARTERLY",
  /**
   * Resets weekly on the same weekday and time as resetTime.
   * Example: "2000-01-17T14:00:00Z" (Monday) → resets every Monday at 2:00 PM UTC
   *
   * Default resetTime would be midnight on Sunday UTC.
   */
  WEEKLY = "WEEKLY",
  /**
   * Resets annually on the same date and time as resetTime.
   * Example: "2000-01-15T16:00:00Z" → resets Jan 15th every year at 4:00 PM UTC
   *
   * Default resetTime would be at the start of the year UTC.
   */
  YEARLY = "YEARLY",
}

/** All Queries that can be performed. */
export type Query = {
  __typename?: "Query";
  /** A paginated list of `ApplicationContracts`. */
  applicationContracts?: Maybe<ApplicationContractConnectionPayload>;
  /**
   * A paginated list of businessAccountHolders.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  businessAccountHolders?: Maybe<UsBusinessAccountHolderConnection>;
  /**
   * A paginated list of business `Organization`s.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  businessOrganizations?: Maybe<BusinessOrganizationConnectionPayload>;
  /** Finds application metrics that match the given filter. */
  cardProductApplicationBusinessMetric?: Maybe<CardProductApplicationBusinessMetricResult>;
  /** A paginated list of Card Products. */
  cardProducts?: Maybe<CardProductConnection>;
  /**
   * A paginated list of all card profile sets filtered by name, status and card product.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  cardProfileSets?: Maybe<CardProfileSetConnectionPayload>;
  /** Find a customer */
  customer?: Maybe<CustomerPayload>;
  /**
   * A paginated list of FeeTransferEvents.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  feeTransferEvents?: Maybe<FeeTransferEventConnection>;
  /** Determine whether `TransactionEvent`s are eligible for any available `InstallmentOffers`. These must be `AuthorizationAndClearEvent`s or `ClearingEvent`s, and they must have an `Amount` within the range defined by an active `CreditPlan` with a `CreditBalanceType` of `INSTALLMENT`. */
  installmentEligibilityForTransactionEvents?: Maybe<InstallmentEligibilityForTransactionEventsPayload>;
  /** Retrieve the available `InstallmentOffer`s for a `Transaction` by providing a `TransactionEvent`. This must be either an `AuthorizationAndClearEvent` or a `ClearingEvent`. */
  installmentOffersForTransactionEvent?: Maybe<InstallmentOffersForTransactionEventPayload>;
  /** A list of merchant categories. */
  merchantCategories?: Maybe<MerchantCategoryDetailsContainer>;
  /** Obtains data points formatted for a Sankey diagram, illustrating flows between account holders and merchant categories. */
  merchantCategoryCodeSankeyDataPoints?: Maybe<MerchantCategoryCodeSankeyDataPointsPayload>;
  /** Retrieves detailed Sankey diagram data points, including flows between account holders, merchant categories, and merchants. */
  merchantDrilldownSankeyDataPoints?: Maybe<MerchantDrilldownSankeyDataPointsPayload>;
  /** Query to fetch any type by its globally unique ID. */
  node?: Maybe<Node>;
  /** A paginated list of notification events. */
  notificationEvents?: Maybe<NotificationEventsConnection>;
  /**
   * A paginated list of Organizations that have an existing business relationship.
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  organizationBusinessRelationships?: Maybe<OrganizationBusinessRelationshipConnection>;
  /** A list of organizations. */
  organizations?: Maybe<Array<Organization>>;
  /** Finds transaction metrics that match the given filter. */
  paymentCardTransactionBusinessMetric?: Maybe<PaymentCardTransactionBusinessMetricResult>;
  /** A paginated list of `PaymentTransaction`s. */
  paymentTransactions?: Maybe<PaymentTransactionsConnection>;
  /**
   * A paginated list of personAccountHolders.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   */
  personAccountHolders?: Maybe<UsPersonAccountHolderConnection>;
  /**
   * A paginated list of personAuthorizedUsers.
   *
   * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
   * @deprecated No longer supported.
   */
  personAuthorizedUsers?: Maybe<AuthorizedUserConnection>;
  /** Simple query that returns a static value of `pong` */
  ping: Scalars["String"];
  /** A paginated list of `ProductApplication`. */
  productApplications?: Maybe<ProductApplicationConnectionPayload>;
  /** Finds report usage metrics for the current Organization. */
  reportUsage?: Maybe<Array<ReportUsage>>;
  /** Finds reports that match the given filter. */
  reports?: Maybe<ReportConnection>;
  /** Provides density data points for geolocation visualization, showing the distribution of locations on a map. */
  riskGeolocationDensity?: Maybe<RiskGeolocationDensityPayload>;
  /** Retrieves paths of geolocation data points for visualizing account holder movements on a map. */
  riskGeolocationPaths?: Maybe<RiskGeolocationPathsPayload>;
  /** Fetches scatter plot data for risk analysis, allowing visualization of data points in two-dimensional space. */
  riskScatterDataPoints?: Maybe<RiskScatterDataPointsPayload>;
  /** A paginated list of schema changelogs */
  schemaChangelogs?: Maybe<SchemaChangelogConnection>;
};

/** All Queries that can be performed. */
export type QueryApplicationContractsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<ApplicationContractFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** All Queries that can be performed. */
export type QueryBusinessAccountHoldersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<BusinessAccountHolderFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** All Queries that can be performed. */
export type QueryBusinessOrganizationsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<BusinessOrganizationFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** All Queries that can be performed. */
export type QueryCardProductApplicationBusinessMetricArgs = {
  filterBy?: InputMaybe<CardProductApplicationBusinessMetricFilterInput>;
};

/** All Queries that can be performed. */
export type QueryCardProductsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** All Queries that can be performed. */
export type QueryCardProfileSetsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy: FilteredCardProfileSetsInput;
  first?: InputMaybe<Scalars["Int"]>;
};

/** All Queries that can be performed. */
export type QueryCustomerArgs = {
  customerIdentifier: Scalars["String"];
};

/** All Queries that can be performed. */
export type QueryFeeTransferEventsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<FeeTransferEventFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** All Queries that can be performed. */
export type QueryInstallmentEligibilityForTransactionEventsArgs = {
  input?: InputMaybe<InstallmentEligibilityForTransactionEventsInput>;
};

/** All Queries that can be performed. */
export type QueryInstallmentOffersForTransactionEventArgs = {
  input?: InputMaybe<InstallmentOffersForTransactionEventInput>;
};

/** All Queries that can be performed. */
export type QueryMerchantCategoryCodeSankeyDataPointsArgs = {
  input: MerchantCategoryCodeSankeyDataPointsFilterInput;
};

/** All Queries that can be performed. */
export type QueryMerchantDrilldownSankeyDataPointsArgs = {
  input: MerchantDrilldownSankeyDataPointsFilterInput;
};

/** All Queries that can be performed. */
export type QueryNodeArgs = {
  id: Scalars["ID"];
};

/** All Queries that can be performed. */
export type QueryNotificationEventsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<NotificationEventsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** All Queries that can be performed. */
export type QueryOrganizationBusinessRelationshipsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<OrganizationBusinessRelationshipFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** All Queries that can be performed. */
export type QueryPaymentCardTransactionBusinessMetricArgs = {
  filterBy?: InputMaybe<PaymentCardTransactionBusinessMetricFilterInput>;
};

/** All Queries that can be performed. */
export type QueryPaymentTransactionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<PaymentTransactionFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** All Queries that can be performed. */
export type QueryPersonAccountHoldersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<PersonAccountHolderFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** All Queries that can be performed. */
export type QueryPersonAuthorizedUsersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<PersonAuthorizedUserFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** All Queries that can be performed. */
export type QueryProductApplicationsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** All Queries that can be performed. */
export type QueryReportsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<ReportFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** All Queries that can be performed. */
export type QueryRiskGeolocationDensityArgs = {
  input: RiskGeolocationDensityFilterInput;
};

/** All Queries that can be performed. */
export type QueryRiskGeolocationPathsArgs = {
  input: RiskGeolocationPathsFilterInput;
};

/** All Queries that can be performed. */
export type QueryRiskScatterDataPointsArgs = {
  input: RiskScatterDataPointsFilterInput;
};

/** All Queries that can be performed. */
export type QuerySchemaChangelogsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/**
 * Additional details for bank-to-bank transfers used in `createUnifiedFundsTransferQuote`.
 *
 * Consent is not required at quote time. Provide consent on `InitiateUnifiedFundsTransferInput.consent` when initiating the transfer.
 */
export type QuoteBankTransferDetailsInput = {
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** Invoice 0123456789 Payment 999.99 USD
   *
   * Please note that payment-related information may or may not be displayed to the recipient. Availability and presentation depend on the receiving financial institution's system capabilities and the access channel used (e.g., online banking, mobile banking, account statement, or integrated receivables systems).
   */
  paymentRelatedInformation: Scalars["String"];
};

/** The interface for a realtime risk rule. These rules execute in realtime during the authorization of a card transaction. */
export type RealtimeRiskRule = {
  /** The date and time, in ISO 8601 format, the realtime risk rule was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The `User` who created the entity. */
  createdBy?: Maybe<UserPayload>;
  /** Global ID used to reference the Realtime Risk Rule in operations. */
  id: Scalars["ID"];
  /** The name assigned to the rule. */
  name?: Maybe<Scalars["String"]>;
  /** The list of revisions for this realtime risk rule. */
  revisions?: Maybe<RealtimeRiskRuleConnectionPayload>;
  /** The date and time, in ISO 8601 format, the realtime risk rule was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** The `User` who last updated the entity. */
  updatedBy?: Maybe<UserPayload>;
  /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
  version?: Maybe<Scalars["String"]>;
};

/** The interface for a realtime risk rule. These rules execute in realtime during the authorization of a card transaction. */
export type RealtimeRiskRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The connection type for Realtime Risk Rule. */
export type RealtimeRiskRuleConnection = {
  __typename?: "RealtimeRiskRuleConnection";
  /** A list of edges. */
  edges?: Maybe<Array<RealtimeRiskRuleEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The return types for searching for realtime risk rules. */
export type RealtimeRiskRuleConnectionPayload =
  | AccessDeniedError
  | RealtimeRiskRuleConnection
  | UserError;

/** The edge type for a `RealtimeRiskRule`. */
export type RealtimeRiskRuleEdge = {
  __typename?: "RealtimeRiskRuleEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The Realtime Risk Rule. */
  node?: Maybe<RealtimeRiskRule>;
};

/** A scheduled recurring ACH transfer */
export type RecurringAchTransfer = Node &
  ScheduledTransfer & {
    __typename?: "RecurringACHTransfer";
    /** The type of balance payment to be scheduled */
    balanceAmountType?: Maybe<TransferBalanceAmountCode>;
    /** The date and time, in ISO 8601 format, this `RecurringACHTransfer` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Descriptive fields about the transfer which may show up on bank reports. */
    descriptor?: Maybe<AchDescriptor>;
    /** The frequency of the scheduled payment */
    frequency?: Maybe<RecurringAchTransferFrequencyCode>;
    /**
     * The account sending the funds.
     *
     * Exactly one of fromFinancialAccount and toFinancialAccount will be an ExternalFinancialAccount and the other will be a FinancialAccount.
     */
    fromFinancialAccount?: Maybe<AllFinancialAccount>;
    /** Global ID used to reference the recurring transfer */
    id: Scalars["ID"];
    /** The date and time, in ISO 8601 format, the next scheduled transfer is to be executed. */
    nextScheduledTransferDate?: Maybe<Scalars["String"]>;
    /** The status of the scheduled transfer */
    status?: Maybe<ScheduledTransferStatusCode>;
    /**
     * The account receiving the funds.
     *
     * Exactly one of fromFinancialAccount and toFinancialAccount will be an ExternalFinancialAccount and the other will be a FinancialAccount.
     */
    toFinancialAccount?: Maybe<AllFinancialAccount>;
    /** The amount to be transferred. */
    transferAmount?: Maybe<TransferAmountStrategy>;
    /** The day the transfer is scheduled to be executed. Optional; only set if transfer day is calculated (for example, payment due date). */
    transferDayCalculationType?: Maybe<TransferDateCode>;
    /** The transfers executed as a result of the recurring transfer */
    transferEvents?: Maybe<ScheduledTransferEventConnection>;
    /** The date and time, in ISO 8601 format, this `RecurringACHTransfer` was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** A scheduled recurring ACH transfer */
export type RecurringAchTransferTransferEventsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The frequency of the scheduled transfer */
export enum RecurringAchTransferFrequencyCode {
  /** A monthly recurring transfer */
  MONTHLY = "MONTHLY",
}

/** Input type for redeeming reward points. */
export type RedeemRewardsForStatementCreditInput = {
  /** An optional tracker for external transaction identifier. Max character length is 255. */
  externalTransactionIdentifier?: InputMaybe<Scalars["String"]>;
  /** Identifier for the `FinancialAccount` to use for this reward redemption. */
  financialAccountId: Scalars["ID"];
  /** Note to be attached to the redemption. Max character length is 1024. */
  memo?: InputMaybe<Scalars["String"]>;
  /** Redemption Criteria that will dictate how reward points will be redeemed. */
  redemption: RedemptionCriteriaInput;
};

/** Method of Redemption for Rewards Points. */
export enum RedemptionConfigurationType {
  /** Redeem points for statement credit. */
  STATEMENT_CREDIT = "STATEMENT_CREDIT",
}

/** Redemption information required to redeem points. */
export type RedemptionCriteriaInput = {
  /** Number of points to redeem. Value should be greater than 0 and less than the reward point balance of the relevant account. */
  pointsToRedeem?: InputMaybe<Scalars["UnsignedInt"]>;
  /** Identifier of the `RewardRedemptionConfiguration` to use for this redemption. Note this `RewardRedemptionConfiguration` must have an attachment that is available for the target `FinancialAccount`" */
  redemptionConfigurationId: Scalars["ID"];
};

/** The input for reevaluating a pre-existing, approved application */
export type ReevaluateApplicationInput = {
  /** The id of the application to be be reevaluated */
  applicationId: Scalars["ID"];
  /** The applicant's consent to reevaluating the existing application. */
  consentAgreement: ConsentInput;
  /** The id of the `ProductApplicationWorkflowConfiguration` */
  productApplicationWorkflowConfigurationId: Scalars["ID"];
};

/** The response type for reevaluating an existing, APPROVED application. */
export type ReevaluateApplicationPayload =
  | AccessDeniedError
  | AccountHolderCardProductApplication
  | AuthorizedUserCardProductApplication
  | UserError;

/** Input for refunding a payment transaction. */
export type RefundPaymentTransactionInput = {
  /** The amount to refund. */
  amount: AmountInput;
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /** The payment transaction to refund. */
  paymentTransactionId: Scalars["ID"];
  /** Include additional information regarding the refund for tracking and analysis */
  refundNote?: InputMaybe<Scalars["String"]>;
  /** The reason why the `PaymentTransaction` was refunded to the original payment method */
  refundReason: PaymentCreditTransactionRefundReason;
};

/** Result of refunding a payment transaction. */
export type RefundPaymentTransactionPayload =
  | AccessDeniedError
  | CardCreditStepSummary
  | UserError;

/** Options for specifying which attributes of the original card should be copied. */
export type ReissuePaymentCardFeaturesInput = {
  /** Whether or not to copy the number from the original card. False if not specified. */
  copyNumber?: InputMaybe<Scalars["Boolean"]>;
  /** Whether or not to copy the pin from the original card. False if not specified. */
  copyPin?: InputMaybe<Scalars["Boolean"]>;
};

/** Details for issuing a new Payment Card based on an existing card. */
export type ReissuePaymentCardInput = {
  /** The `CustomFields` for the Payment Card. */
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  /**
   * A value to distinguish unique reissue request.
   *
   * This helps prevent duplicate cards from be reissued. If a failure happens and it is unclear
   * if a reissue payment card request went through, it is safe to repeat the request with the same idempotency key.
   * If the reissue process has already happened, the request will be deduped and the original response will be
   * returned instead.
   *
   * **Minimum length:** 10 characters
   * **Maximum length:** 255 characters
   */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /** Options for the newly issued Payment Card. */
  options: ReissuePaymentCardOptionsInput;
  /**
   * The ID of the card to issue this Payment Card against.
   *
   * **Note:** The card cannot be CLOSED.
   */
  originalPaymentCardId: Scalars["ID"];
};

/** Options for the newly issued Payment Card. */
export type ReissuePaymentCardOptionsInput = {
  /** Whether or not to activate the card when created. If **not** activated on creation, the card must be activated separately before use. */
  activateOnCreate: Scalars["Boolean"];
  /** The date on which the card was lost. e.g. 2026-01-01T23:59:59Z */
  cardLostDate?: InputMaybe<Scalars["String"]>;
  /**
   * The exact date and time the payment card will expire. e.g. 2026-01-01T23:59:59Z
   * If copying the number, cannot be in the same month/year (in UTC timezone) as the original card.
   */
  expirationDate: Scalars["String"];
  /** The reason why a card is being reissued */
  reason?: InputMaybe<ReissueReason>;
  /**
   * Options for specifying which attributes of the original card should be copied.
   * If not specified, no attributes will be copied.
   */
  reissueFeatures?: InputMaybe<ReissuePaymentCardFeaturesInput>;
};

/** The return types when creating a new Payment Card based on an existing card. */
export type ReissuePaymentCardPayload =
  | AccessDeniedError
  | PaymentCard
  | UserError;

/** The different reasons for a `PaymentCard` to be reissued */
export enum ReissueReason {
  /** The `PaymentCard` expired and needs to be reissued */
  EXPIRED = "EXPIRED",
  /** The `PaymentCard` was lost and needs to be reissued */
  LOST = "LOST",
  /** The `PaymentCard` needs to be reissued for another reason */
  OTHER = "OTHER",
  /**
   * The `PaymentCard` was stolen and needs to be reissued
   * @deprecated If card is stolen, terminate the old card and issue a new card to establish a new card lineage.
   */
  STOLEN = "STOLEN",
}

/** The input to remove a `CollaborativeAuthorizationEndpoint`. */
export type RemoveCollaborativeAuthorizationEndpointInput = {
  /** The Global ID of the `CollaborativeAuthorizationEndpoint` to remove. */
  endpointId: Scalars["ID"];
};

/** The return types when removing a `CollaborativeAuthorizationEndpoint`. */
export type RemoveCollaborativeAuthorizationEndpointPayload =
  | AccessDeniedError
  | CollaborativeAuthorizationEndpoint
  | UserError;

/** Input for removing the email for a notification target. */
export type RemoveEmailFromNotificationTargetInput = {
  /** The notification target ID. */
  targetId: Scalars["ID"];
};

/** The return types when unsetting the email for a notification target. */
export type RemoveEmailFromNotificationTargetPayload =
  | AccessDeniedError
  | UserError
  | WebhookNotificationTarget;

/** The input to delete a notification target. */
export type RemoveNotificationTargetInput = {
  targetId: Scalars["ID"];
};

/** The return types when delete a notification target. */
export type RemoveNotificationTargetPayload =
  | AccessDeniedError
  | UserError
  | WebhookNotificationTarget;

/** The input to remove subscriptions from a notification target. */
export type RemoveSubscriptionsFromNotificationTargetInput = {
  /** The event names to no longer receive notifications about. */
  subscriptions: Array<NotificationEventName>;
  /** Target Id */
  targetId: Scalars["ID"];
};

/** The return types when removing subscriptions from a notification target. */
export type RemoveSubscriptionsFromNotificationTargetPayload =
  | AccessDeniedError
  | UserError
  | WebhookNotificationTarget;

/** Data needed to remove a new User. */
export type RemoveUserInput = {
  /** E-mail of the user to remove. */
  email: Scalars["String"];
};

/** The possible return types of `removeUser`. */
export type RemoveUserPayload = AccessDeniedError | User | UserError;

/** The input to rename a `CollaborativeAuthorizationEndpoint`. */
export type RenameCollaborativeAuthorizationEndpointInput = {
  /** The Global ID of the `CollaborativeAuthorizationEndpoint` to rename. */
  endpointId: Scalars["ID"];
  /**
   * The new, human-friendly name for your `CollaborativeAuthorizationEndpoint`.
   *
   * This value can contain any characters but cannot exceed a length of 255.
   */
  name: Scalars["String"];
};

/** The return types when renaming a `CollaborativeAuthorizationEndpoint`. */
export type RenameCollaborativeAuthorizationEndpointPayload =
  | AccessDeniedError
  | CollaborativeAuthorizationEndpoint
  | UserError;

/** The input to update the name of an existing notification target. */
export type RenameNotificationTargetInput = {
  /**
   * A name for the target.
   * Must be between 1 and 255 characters.
   */
  name: Scalars["String"];
  /** The notification target ID. */
  targetId: Scalars["ID"];
};

/** The return types when updating the name of an existing notification target. */
export type RenameNotificationTargetPayload =
  | AccessDeniedError
  | UserError
  | WebhookNotificationTarget;

/** The category of this `Repayment`. For example, `PURCHASE`, `INTEREST`, or `FEES`. */
export enum RepaymentCategory {
  FEES = "FEES",
  INTEREST = "INTEREST",
  PURCHASE = "PURCHASE",
}

/** The RepaymentFailedEvent notifies when ACH Repayments have failed to process. */
export type RepaymentFailedEvent = Node & {
  __typename?: "RepaymentFailedEvent";
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The ID for Highnote. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /**
   * The name of the company that initiated the ACH transfer.
   *
   * This will always be Highnote.
   */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the account sending the funds. Will always be an `ExternalFinancialBankAccount`. */
  fromFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
  fundsAvailableDate?: Maybe<Scalars["String"]>;
  /** The ID of the transaction event. This `id` can be used to later retrieve details of this `RepaymentFailedEvent` or correlate it with other events on this `Transaction`. */
  id: Scalars["ID"];
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
  /** Additional details about why an ACH Repayments failed. */
  repaymentACHReasonCode?: Maybe<IntegratorInitiatedAchStatusReasonCode>;
  /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
  settlementDate?: Maybe<Scalars["String"]>;
  /** The ID of the account receiving the funds. Will always be a `FinancialAccount` */
  toFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The ID of the Electronic Funds Transfer that trigger this event. */
  transactionId?: Maybe<Scalars["ID"]>;
  /**
   * The status of the ACH transfer.
   * @deprecated use repaymentACHReasonCode instead
   */
  transferStatus?: Maybe<AchTransferStatusDetails>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Whether or not the `FinancialAccount` supports repayment account feature. */
export type RepaymentFinancialAccountFeature = FinancialAccountFeature & {
  __typename?: "RepaymentFinancialAccountFeature";
  /** The date and time, in ISO 8601 format, the feature was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective from. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective through. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Whether or not the feature is enabled for the Financial Account. */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** The date and time, in ISO 8601 format, the feature was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The RepaymentProcessedEvent notifies when ACH Repayments are finished processing. */
export type RepaymentProcessedEvent = Node & {
  __typename?: "RepaymentProcessedEvent";
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The ID for Highnote. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /**
   * The name of the company that initiated the ACH transfer.
   *
   * This will always be Highnote.
   */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the account sending the funds. Will always be an `ExternalFinancialBankAccount`. */
  fromFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
  fundsAvailableDate?: Maybe<Scalars["String"]>;
  /** The ID of the transaction event. This `id` can be used to later retrieve details of this `RepaymentProcessedEvent` or correlate it with other events on this `Transaction`. */
  id: Scalars["ID"];
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
  /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
  settlementDate?: Maybe<Scalars["String"]>;
  /** The ID of the account receiving the funds. Will always be a `FinancialAccount` */
  toFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The ID of the Electronic Funds Transfer that trigger this event. */
  transactionId?: Maybe<Scalars["ID"]>;
  /**
   * The status of the ACH transfer.
   * @deprecated transfer status only needed for failed or returned events
   */
  transferStatus?: Maybe<AchTransferStatusDetails>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The RepaymentProcessingEvent notifies when ACH Repayments are processing. */
export type RepaymentProcessingEvent = Node & {
  __typename?: "RepaymentProcessingEvent";
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The ID for Highnote. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /**
   * The name of the company that initiated the ACH transfer.
   *
   * This will always be Highnote.
   */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the account sending the funds. Will always be an `ExternalFinancialBankAccount`. */
  fromFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
  fundsAvailableDate?: Maybe<Scalars["String"]>;
  /** The ID of the transaction event. This `id` can be used to later retrieve details of this `RepaymentProcessingEvent` or correlate it with other events on this `Transaction`. */
  id: Scalars["ID"];
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
  /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
  settlementDate?: Maybe<Scalars["String"]>;
  /** The ID of the account receiving the funds. Will always be a `FinancialAccount` */
  toFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The ID of the Electronic Funds Transfer that trigger this event. */
  transactionId?: Maybe<Scalars["ID"]>;
  /**
   * The status of the ACH transfer.
   * @deprecated transfer status only needed for failed or returned events
   */
  transferStatus?: Maybe<AchTransferStatusDetails>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The RepaymentReturnedEvent notifies when ACH Repayments are returned. */
export type RepaymentReturnedEvent = Node & {
  __typename?: "RepaymentReturnedEvent";
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The ID for Highnote. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /**
   * The name of the company that initiated the ACH transfer.
   *
   * This will always be Highnote.
   */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the account sending the funds. Will always be an `ExternalFinancialBankAccount`. */
  fromFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
  fundsAvailableDate?: Maybe<Scalars["String"]>;
  /** The ID of the transaction event. This `id` can be used to later retrieve details of this `RepaymentReturnedEvent` or correlate it with other events on this `Transaction`. */
  id: Scalars["ID"];
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
  /** Additional details about why an ACH Repayments was returned. */
  repaymentACHReasonCode?: Maybe<IntegratorInitiatedAchStatusReasonCode>;
  /** The date this transaction was returned, in ISO 8601 format. */
  returnDate?: Maybe<Scalars["String"]>;
  /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
  settlementDate?: Maybe<Scalars["String"]>;
  /** The ID of the account receiving the funds. Will always be a `FinancialAccount` */
  toFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The ID of the Electronic Funds Transfer that trigger this event. */
  transactionId?: Maybe<Scalars["ID"]>;
  /**
   * The status of the ACH transfer.
   * @deprecated use repaymentACHReasonCode instead
   */
  transferStatus?: Maybe<AchTransferStatusDetails>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The input to replay a Notification Event. */
export type ReplayNotificationEventInput = {
  /** The id of the event to replay. */
  notificationEventId: Scalars["ID"];
  /**
   * Optional list of target IDs to replay the event for. If absent or empty,
   * the event will be sent to all active targets that subscribe to this event
   * type. If a target ID is provided for a target that does not subscribe to this
   * event type or is not active, the replay request for that target will be
   * ignored.
   */
  targetIds?: InputMaybe<Array<Scalars["ID"]>>;
};

/** The return types when replaying a Notification Event. */
export type ReplayNotificationEventPayload =
  | AccessDeniedError
  | NotificationEvent
  | UserError;

/** Describes the current status of a report and where it can be downloaded from. */
export type Report = Node & {
  __typename?: "Report";
  /** The date and time, in ISO 8601 format, this was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Used to download the contents of the report, if available. */
  download?: Maybe<ReportDownload>;
  /** The end date and time, in ISO 8601 format, that the report was generated for. */
  end?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the Report in operations. */
  id: Scalars["ID"];
  /** Describes which type of report was generated. */
  reportType?: Maybe<ReportType>;
  /** The start date and time, in ISO 8601 format, that the report was generated for. */
  start?: Maybe<Scalars["String"]>;
  /** The current status of an Report. */
  status?: Maybe<ReportStatus>;
  /** Describes why the report is in a failed state, if applicable. */
  statusReason?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, this was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The connection type for Report. */
export type ReportConnection = {
  __typename?: "ReportConnection";
  /** A list of edges. */
  edges?: Maybe<Array<ReportEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** Contains information related to downloading a report. */
export type ReportDownload = {
  __typename?: "ReportDownload";
  /** The URL to download the report from. */
  url?: Maybe<Scalars["String"]>;
};

/** The edge type for a Report. */
export type ReportEdge = {
  __typename?: "ReportEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The report object. */
  node?: Maybe<Report>;
};

/** Used to filter which reports are requested. */
export type ReportFilterInput = {
  /** Filter reports by timestamp range for createDate */
  createDateFilter?: InputMaybe<TimestampFilterInputRange>;
  /** Filters reports by ReportType. */
  reportType?: InputMaybe<ReportTypeFilterInput>;
  /** Filters reports by ReportStatus. */
  status?: InputMaybe<ReportStatusFilterInput>;
};

/**
 * The time range used to generate a report.
 * All external report requests must be supplied with this Parameter.
 * Timestamp value range in ISO 8601 format.
 */
export type ReportParameterTimestampRangeInput = {
  /** ISO 8601 format and inclusive. */
  end: Scalars["String"];
  /** ISO 8601 format and inclusive */
  start: Scalars["String"];
};

/** The parameters used to generate Report. */
export type ReportParametersInput = {
  /** The date range used to generate the report. */
  between: ReportParameterTimestampRangeInput;
  /** ledger report specific parameters. */
  ledgerReportParameters?: InputMaybe<LedgerReportParametersInput>;
};

/** Represents the current status of a Report. */
export enum ReportStatus {
  /** Indicates the report has been generated and is ready to be downloaded. */
  COMPLETED = "COMPLETED",
  /** Indicates the report failed to generate. */
  FAILED = "FAILED",
  /** Indicates the report is still being generated. */
  IN_PROGRESS = "IN_PROGRESS",
}

/** Filters reports by `ReportStatus`. */
export type ReportStatusFilterInput = {
  includes?: InputMaybe<Array<ReportStatus>>;
};

/** All available report types. */
export enum ReportType {
  /** This report contains all ACH event activities across all financial accounts for the organization. */
  ACH_EVENT_ACTIVITY = "ACH_EVENT_ACTIVITY",
  /** This report contains card interchange and transaction settlement activity across all financial accounts for the organization. */
  CARD_INTERCHANGE_ACTIVITY = "CARD_INTERCHANGE_ACTIVITY",
  /** This report contains all card transaction event activities across all financial accounts for the organization. */
  CARD_TRANSACTION_ACTIVITY = "CARD_TRANSACTION_ACTIVITY",
  /** This is the credit loan tape report across all financial accounts for the organization. */
  CREDIT_LOAN_TAPE = "CREDIT_LOAN_TAPE",
  /** Metro2 file formatted for credit report furnishing with Experian. */
  EXPERIAN_CREDIT_REPORT = "EXPERIAN_CREDIT_REPORT",
  /** This report contains all the enhanced data (level 2/3) sent by the payment networks for cleared fleet transactions for a specific time period */
  FLEET_ENHANCED_DATA_SUMMARY = "FLEET_ENHANCED_DATA_SUMMARY",
  /** This report contains ledger entries across all financial accounts for the organization. */
  LEDGER_ENTRY = "LEDGER_ENTRY",
  /** This is the negative balance report across all financial accounts for the organization. */
  NEGATIVE_ACCOUNT_BALANCE = "NEGATIVE_ACCOUNT_BALANCE",
  /** This report contains the breakdown of each financial account’s receivable being sold on a given business day (sum to the amount in the Receivable Sale report) */
  RECEIVABLE_ACCOUNTS_SALE = "RECEIVABLE_ACCOUNTS_SALE",
  /** This report contains the overall amount(s) being sold on a given business day */
  RECEIVABLE_SALE = "RECEIVABLE_SALE",
  /** This is the RPA purchase agreement for a given day */
  RECEIVABLE_SALE_AGREEMENT = "RECEIVABLE_SALE_AGREEMENT",
  /** This report contains the breakdown of each transaction’s receivable being sold on a given business day (sum to the amount in the Receivable Sale report) */
  RECEIVABLE_SALE_TRANSACTIONS = "RECEIVABLE_SALE_TRANSACTIONS",
  /** This report contains all transfer event activities across all financial accounts for the organization. */
  TRANSFER_EVENT_ACTIVITY = "TRANSFER_EVENT_ACTIVITY",
}

/** Filters reports by `ReportType`. */
export type ReportTypeFilterInput = {
  includes?: InputMaybe<Array<ReportType>>;
};

/** Provides information about the current usage of a report type. */
export type ReportUsage = {
  __typename?: "ReportUsage";
  /**
   * The limit of the number of reports that can be generated within a 24 hour period. The 24 hour
   * period is defined as midnight to midnight, Eastern Time.
   */
  limit?: Maybe<Scalars["UnsignedInt"]>;
  /** The number of reports remaining for the report type in the given period. */
  limitRemaining?: Maybe<Scalars["UnsignedInt"]>;
  /** The date and time, in ISO 8601 format, for the end of the current period. */
  periodEnd?: Maybe<Scalars["String"]>;
  /** The report type that the usage metrics applies to. */
  reportType?: Maybe<ReportType>;
};

/** Input for agent servicing application manual review requested documents. */
export type RequestedDocuments = {
  /** The ID of the applicant. */
  applicantId: Scalars["ID"];
  /** The requested document types for the applicant. */
  documentTypes?: InputMaybe<Array<DocumentType>>;
};

/** Changes applied to a requested identity update. */
export type RequestedIdentityAppliedUpdate = {
  __typename?: "RequestedIdentityAppliedUpdate";
  /** The change types for the applied update. */
  appliedChanges?: Maybe<Array<RequestedIdentityUpdateType>>;
  /** The date and time, in ISO 8601 format, the requested update was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The supplied information to update on the `RequestedIdentityUpdateParty`. */
  requestedChange?: Maybe<RequestedIdentityUpdateParty>;
  /** The date and time, in ISO 8601 format, the requested update was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** A request to update an identity. */
export type RequestedIdentityUpdate = Node & {
  __typename?: "RequestedIdentityUpdate";
  /** Changes applied to the identity as part of this `RequestedIdentityUpdate`. */
  appliedUpdates?: Maybe<Array<RequestedIdentityAppliedUpdate>>;
  /** The changes requested on the identity. */
  changesRequested?: Maybe<Array<RequestedIdentityUpdateType>>;
  /** The date and time, in ISO 8601 format, when the identity update request was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The Global ID for the requested Identity Update */
  id: Scalars["ID"];
  /** The referring system that originated this `RequestedIdentityUpdate`. */
  referredBy?: Maybe<RequestedIdentityUpdateSource>;
  /** The identity which has a requested update. */
  requestedFor?: Maybe<RequestedIdentityUpdateParty>;
  /** The status of the identity update request */
  status?: Maybe<RequestedIdentityUpdateStatus>;
  /** The date and time, in ISO 8601 format, when the identity update request was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Identities that qualify for a requested update. */
export type RequestedIdentityUpdateParty =
  | UsBusinessAuthorizedPerson
  | UsBusinessProfile
  | UsBusinessUltimateBeneficialOwner
  | UsPersonAccountHolder
  | UsPersonAuthorizedUser;

/** Sources that can refer a requested identity update. */
export type RequestedIdentityUpdateSource =
  | AccountHolderCardProductApplication
  | AuthorizedUserCardProductApplication;

/** A status representing the state of the `RequestedIdentityUpdate` */
export enum RequestedIdentityUpdateStatus {
  /** The requested update is canceled, indicating that no updates were supplied even though requested. */
  CANCELED = "CANCELED",
  /** The requested update is confirmed, and the individual or business has acknowledged the accuracy and correctness of the supplied information. */
  CONFIRMED = "CONFIRMED",
  /** The requested update is `INITIATED` and has received input. */
  INITIATED = "INITIATED",
  /** The requested update is `OPEN` and awaiting input. */
  OPEN = "OPEN",
}

/** The types of identity updates requested. */
export enum RequestedIdentityUpdateType {
  /** Request to update the billing address. */
  BILLING_ADDRESS = "BILLING_ADDRESS",
  /** Request to update the date of birth. */
  DATE_OF_BIRTH = "DATE_OF_BIRTH",
  /** Request to update the email address. */
  EMAIL = "EMAIL",
  /** Request to update the employer identification number. */
  EMPLOYER_IDENTIFICATION_NUMBER = "EMPLOYER_IDENTIFICATION_NUMBER",
  /** Request to update the full legal name. */
  FULL_LEGAL_NAME = "FULL_LEGAL_NAME",
  /** Request to update the home address. */
  HOME_ADDRESS = "HOME_ADDRESS",
  /** Request to update the legal business name. */
  LEGAL_BUSINESS_NAME = "LEGAL_BUSINESS_NAME",
  /** Request to add new Ultimate Beneficial Owner to the business */
  NEW_ULTIMATE_BENEFICIAL_OWNER = "NEW_ULTIMATE_BENEFICIAL_OWNER",
  /** Request to update the ownership percentage. */
  OWNERSHIP_PERCENTAGE = "OWNERSHIP_PERCENTAGE",
  /** Request to update the phone number. */
  PHONE = "PHONE",
  /** Request to update the social security number. */
  SOCIAL_SECURITY_NUMBER = "SOCIAL_SECURITY_NUMBER",
}

/** Whether or not the `FinancialAccount` is enabled for reset balance. */
export type ResetBalanceFinancialAccountFeature = FinancialAccountFeature & {
  __typename?: "ResetBalanceFinancialAccountFeature";
  /** The `PseudoBalance` cadence, how often to reset the `PseudoBalance`. */
  cadence?: Maybe<PseudoBalanceCadence>;
  /** The date and time, in ISO 8601 format, the feature was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective from. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective through. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Whether or not the feature is enabled for the `FinancialAccount`. */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** Whether to reset the available balance when the pseudo balance resets according to the cadence. */
  resetAvailableBalance?: Maybe<Scalars["Boolean"]>;
  /**
   * An ISO 8601 formatted timestamp that determines when and how often the balance resets.
   * The date and time components are used differently based on the selected cadence. See `PseudoBalanceCadence` for more details.
   */
  resetTime?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/**
 * Input for resetting a pseudo balance back to zero or a baseline amount.
 * Used to manually trigger a balance reset outside of the automatic cadence.
 */
export type ResetPseudoBalanceInput = {
  /** Allows setting a new pseudo balance cadence, how often to reset the pseudo balance. */
  cadence: PseudoBalanceCadence;
  /** The ID of the FinancialAccount whose pseudo balance should be reset. */
  financialAccountId: Scalars["ID"];
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["String"]>;
  /**
   * Whether to reset the available balance to the pseudo balance limit.
   * - true: The available balance will be reset to the value defined as the pseudo balance limit at the start of the new period.
   * - false: The current balance carries over to the new period (useful for rolling balances when resetting cadence).
   */
  resetAvailableBalance: Scalars["Boolean"];
  /**
   * An ISO 8601 formatted timestamp that determines when and how often the balance resets.
   * The date and time components are used differently based on the selected cadence. See `PseudoBalanceCadence` for more details.
   *
   * If not specified, the current reset time is preserved.
   *
   * If no existing reset time exists, then the value will default depending on the cadence. See `PseudoBalanceCadence` for more details on the default value.
   */
  resetTime?: InputMaybe<Scalars["String"]>;
};

export type ResetPseudoBalancePayload =
  | AccessDeniedError
  | InterFinancialAccountTransfer
  | UserError;

/** A Spend Control rule that blocks certain account holders during authorization. */
export type RestrictedAccountHolderSpendRule = Node &
  SpendRule & {
    __typename?: "RestrictedAccountHolderSpendRule";
    /** The account holders that are allowed during authorization. This is not used. */
    allowed?: Maybe<Array<Scalars["ID"]>>;
    /** The account holders that are blocked during authorization. */
    blocked?: Maybe<Array<Scalars["ID"]>>;
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the `RestrictedAccountHolderSpendRule` in operations. */
    id: Scalars["ID"];
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/** A Spend Control rule that blocks certain account holders during authorization. */
export type RestrictedAccountHolderSpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The result of applying a `RestrictedAccountHolderSpendRule` to an event. */
export type RestrictedAccountHolderSpendRuleResult = SpendRuleResult & {
  __typename?: "RestrictedAccountHolderSpendRuleResult";
  /** The attached level. */
  attachedLevel?: Maybe<AttachedLevel>;
  /** A message describing the result. */
  message?: Maybe<Scalars["String"]>;
  /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
  recommendation?: Maybe<SpendRuleRecommendation>;
  /** The spend rule attached at the time of the event. */
  spendRule?: Maybe<RestrictedAccountHolderSpendRule>;
  /** The account holder of the event. */
  valuesTested?: Maybe<Array<Scalars["ID"]>>;
};

/** A Spend Control rule that blocks certain card holders during authorization. */
export type RestrictedCardHolderSpendRule = Node &
  SpendRule & {
    __typename?: "RestrictedCardHolderSpendRule";
    /** The card holders that are blocked during authorization. */
    blocked?: Maybe<Array<Scalars["ID"]>>;
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the `RestrictedCardholderSpendRule` in operations. */
    id: Scalars["ID"];
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/** A Spend Control rule that blocks certain card holders during authorization. */
export type RestrictedCardHolderSpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The result of applying a `RestrictedCardHolderSpendRule` to an event. */
export type RestrictedCardHolderSpendRuleResult = SpendRuleResult & {
  __typename?: "RestrictedCardHolderSpendRuleResult";
  /** The attached level. */
  attachedLevel?: Maybe<AttachedLevel>;
  /** A message describing the result. */
  message?: Maybe<Scalars["String"]>;
  /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
  recommendation?: Maybe<SpendRuleRecommendation>;
  /** The spend rule attached at the time of the event. */
  spendRule?: Maybe<RestrictedCardHolderSpendRule>;
  /** The card holder of the event. */
  valuesTested?: Maybe<Array<Scalars["ID"]>>;
};

/** An ReversalEvent for a transaction. */
export type ReversalEvent = Node &
  TransactionEvent & {
    __typename?: "ReversalEvent";
    /**
     * The direction funds are moving in the perspective of the cardholder.
     *
     * * when DEBIT, funds are moving out of the cardholder's account
     * * when CREDIT, funds are moving into the cardholder's account
     */
    accountingDirection?: Maybe<AccountingDirection>;
    /** Network specific transaction data. */
    additionalNetworkData?: Maybe<AdditionalNetworkData>;
    /** Additional transaction data for this transaction */
    additionalTransactionData?: Maybe<Array<AdditionalTransactionData>>;
    /** Determines whether this event is an advice. */
    advice?: Maybe<Scalars["Boolean"]>;
    /** Details if event is an advice. */
    adviceDetail?: Maybe<AdviceDetail>;
    /** The `Amount` approved for this `ReversalEvent` and posted in the settlement currency. Does not include fees. */
    approvedAmount?: Maybe<Amount>;
    /** The `CardProduct` associated to this `ReversalEvent`. */
    cardProduct?: Maybe<CardProduct>;
    /** The `Amount` of cashback requested. */
    cashbackAmount?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, this `ReversalEvent` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /**
     * Conversion rate applied to the requestedAmount to get the requestedAmountInSettlementCurrency for this `ReversalEvent`.
     *
     * Can be up to 7 decimal places, e.g. 1.2345678.
     */
    currencyConversionRate?: Maybe<Scalars["Float"]>;
    /** The `Amount` available to spend after this transaction event. */
    currentFinancialAccountAvailableToSpendAmount?: Maybe<Amount>;
    /** Maximum balance allowed for the card account at the time of this transaction event */
    currentFinancialAccountMaximumBalanceAmount?: Maybe<Amount>;
    /** Fees applied to the transaction, if any. */
    fees?: Maybe<Array<TransactionFee>>;
    /** The ID of the transaction event. This `id` can be used to later retrieve details of this Reversal or correlate it with other events on this `Transaction`. */
    id: Scalars["ID"];
    /** Determines whether this is an issuer initiated reversal for an expired authorization. */
    issuerExpiredAuthorization?: Maybe<Scalars["Boolean"]>;
    /** The details about the merchant who requested the reversal. */
    merchantDetails?: Maybe<MerchantDetails>;
    /**
     * The response code from the card network (e.g. Mastercard).
     * @deprecated Use responseCode instead
     */
    networkResponseCode?: Maybe<Scalars["String"]>;
    /**
     * The transaction ID from the card network (e.g. Mastercard).
     * @deprecated No longer supported
     */
    networkTransactionId?: Maybe<Scalars["ID"]>;
    /** The original `Amount` of the `AuthorizationEvent` related to this `ReversalEvent`. */
    originalAmount?: Maybe<Amount>;
    /** Determines whether this is a partial or full reversal for an authorization. */
    partial?: Maybe<Scalars["Boolean"]>;
    /** The `PaymentCard` associated to this `ReversalEvent`. */
    paymentCard?: Maybe<PaymentCard>;
    /** A snapshot of the `PaymentCard` at the time of the `ReversalEvent`. */
    paymentCardSnapshot?: Maybe<PaymentCardSnapshot>;
    /** The Point Of Service Details. */
    pointOfServiceDetails?: Maybe<PointOfServiceDetails>;
    /** The `Amount` requested to be approved for this `ReversalEvent` and displayed in the transaction's (local) currency. Does not include fees. */
    requestedAmount?: Maybe<Amount>;
    /** The `Amount` requested to be approved for this `ReversalEvent` converted to the settlement currency. */
    requestedAmountInSettlementCurrency?: Maybe<Amount>;
    /** The Highnote response code. */
    responseCode?: Maybe<TransactionEventResponseCode>;
    /** The `Transaction` for this event. */
    transaction?: Maybe<Transaction>;
    /**
     * ID of the transaction
     * @deprecated Use transaction instead
     */
    transactionId?: Maybe<Scalars["ID"]>;
    /** Represents the customer transaction type being processed. */
    transactionProcessingType?: Maybe<CardTransactionProcessingType>;
  };

/** Reversed fee transfer. Reversing the charged fee transfer. */
export type ReversedFeeTransfer = {
  __typename?: "ReversedFeeTransfer";
  /** The actual fee amount charged. */
  feeTransferAmount?: Maybe<Amount>;
  /** Memo */
  memo?: Maybe<Scalars["String"]>;
  /** The Financial account from where the fee is reversed. This field is available when status is COMPLETE. */
  originatingAccount?: Maybe<FinancialAccount>;
  /** The Financial account that receives the reversed fee. This field is available when status is COMPLETE. */
  receivingAccount?: Maybe<FinancialAccount>;
  /** The original fee transfer event that was reversed. */
  sourceFeeTransferEvent?: Maybe<FeeTransferEvent>;
  /** The fee transfer event status. */
  status?: Maybe<FeeTransferStatusDetails>;
  /** The date and time, in ISO 8601 format, the fee was reversed. */
  transferDate?: Maybe<Scalars["String"]>;
  /**
   * The actual fee amount reversed. This field is available when status is COMPLETE.
   * @deprecated Use feeTransferAmount instead.
   */
  transferedFeeAmount?: Maybe<Amount>;
};

/**
 * An event representing the review process of a transfer. Use the `reviewState`
 * field to determine the current state of the review.
 */
export type ReviewWorkflowEvent = Node & {
  __typename?: "ReviewWorkflowEvent";
  /** The date and time the review was initiated, in ISO 8601 format, e.g. 2024-01-01T00:00:00.000Z. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the `ReviewWorkflowEvent`. */
  id: Scalars["ID"];
  /** The details of the wire transfer workflow review associated with this event. */
  reviewItem?: Maybe<WireTransferReviewItem>;
  /** The status of the transfer workflow. */
  reviewState?: Maybe<ReviewWorkflowEventStatus>;
  /** The transfer associated with this workflow event. */
  transfer?: Maybe<ReviewWorkflowEventTransfer>;
  /** The date and time the review was last updated, in ISO 8601 format, e.g. 2024-01-01T00:00:00.000Z. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The connection type for `ReviewWorkflowEvent`. */
export type ReviewWorkflowEventConnection = {
  __typename?: "ReviewWorkflowEventConnection";
  /** A list of edges. */
  edges?: Maybe<Array<ReviewWorkflowEventEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The return types for finding `ReviewWorkflowEvents` */
export type ReviewWorkflowEventConnectionPayload =
  | AccessDeniedError
  | ReviewWorkflowEventConnection
  | UserError;

/** The edge type for `ReviewWorkflowEvent */
export type ReviewWorkflowEventEdge = {
  __typename?: "ReviewWorkflowEventEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The `ReviewWorkflowEvent`. */
  node?: Maybe<ReviewWorkflowEvent>;
};

/** Inputs for filtering `ReviewWorkflowEvents`. */
export type ReviewWorkflowEventFilterInput = {
  /** Used to search using the Highnote `SearchQueryLanguage`. */
  searchQueryLanguage?: InputMaybe<SearchQueryLanguageInput>;
};

/** The status of the `ReviewWorkflowEvent` */
export enum ReviewWorkflowEventStatus {
  /** The event under review, e.g. wire transfer has been approved. */
  APPROVED = "APPROVED",
  /** The event under review, e.g. wire transfer was canceled. */
  CANCELED = "CANCELED",
  /** The event under review, e.g. wire transfer has completed. */
  COMPLETED = "COMPLETED",
  /** The event under review, e.g. wire transfer has failed. */
  FAILED = "FAILED",
  /** The event for review, e.g. wire transfer has been initiated. */
  PENDING = "PENDING",
  /** The event under review, e.g. wire transfer has been rejected. */
  REJECTED = "REJECTED",
  /** The event under review, e.g. wire transfer is in an unspecified state. */
  UNSPECIFIED = "UNSPECIFIED",
}

export type ReviewWorkflowEventTransfer = WireTransfer;

/** Data needed to revoke an API Key. */
export type RevokeApiKeyInput = {
  /** The ID of the API Key to revoke. */
  apiKeyId: Scalars["ID"];
};

/** The possible return types of `revokeAPIKey`. */
export type RevokeApiKeyPayload = ApiKey | AccessDeniedError | UserError;

/** Whether or not the `CardProduct` supports revolving. */
export type RevolvingCardProductFeature = CardProductFeature &
  ProductFeature & {
    __typename?: "RevolvingCardProductFeature";
    /** The date and time, in ISO 8601 format, the feature was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective from. */
    effectiveFrom?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective through. */
    effectiveThrough?: Maybe<Scalars["String"]>;
    /** Whether or not the feature is enabled for the `CardProduct`. */
    enabled?: Maybe<Scalars["Boolean"]>;
    /** The date and time, in ISO 8601 format, the feature was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** `RewardEarnRule` that will hold default reward configuration for transfers that have not accrued points from other `RewardEarnRules`s. */
export type RewardDefaultEarnRule = Node &
  RewardEarnRule & {
    __typename?: "RewardDefaultEarnRule";
    /** Objects that a rule is attached to. */
    attachments?: Maybe<RewardRuleAttachmentConnection>;
    /** The date and time, in ISO 8601 format, when the earn rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the reward earn rule. */
    id: Scalars["ID"];
    /** Name of this `RewardDefaultEarnRule`. */
    name?: Maybe<Scalars["String"]>;
    /** Earning Rate. This rate describes the amount of points earn related to the amount of money spent. (i.e., a rate of 1.5 means earning 15 points on a $10 transaction) */
    rewardPointEarning?: Maybe<RewardEarnRate>;
    /** The `EarnRuleType`. For example, `PER_TRANSACTION_SPEND_AMOUNT`. */
    type?: Maybe<EarnRuleType>;
    /** The date and time, in ISO 8601 format, when the earn rule was updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** `RewardEarnRule` that will hold default reward configuration for transfers that have not accrued points from other `RewardEarnRules`s. */
export type RewardDefaultEarnRuleAttachmentsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The earn rate for reward points, describing the number of points earned per dollar spent. */
export type RewardEarnRate = {
  __typename?: "RewardEarnRate";
  /**
   * The number of points earned per `USD` on a transaction.
   * This rate should be between 0.0 and 100.0 with up to 3 digits of precision after the decimal point (i.e. 1.000).
   *
   * Rounding on fractional points will be rounded down.
   * For example:
   *
   * | rate                  | transaction amount | points earned |
   * | --------------------- | ------------------ | ------------- |
   * | 1.0 point per dollar  | $1                 | 1 point       |
   * | 1.5 points per dollar | $10                | 15 points     |
   */
  rate?: Maybe<Scalars["String"]>;
};

/** The earn rate for reward points, describing the number of points earned per dollar spent. */
export type RewardEarnRateInput = {
  /**
   * The number of points earned per `USD` on a transaction.
   * This rate should be between 0.0 and 100.0 with up to 3 digits of precision after the decimal point (i.e. 1.000).
   *
   * Rounding on fractional points will be rounded down.
   * For example:
   *
   * | rate                  | transaction amount | points earned |
   * | --------------------- | ------------------ | ------------- |
   * | 1.0 point per dollar  | $1                 | 1 point       |
   * | 1.5 points per dollar | $10                | 15 points     |
   */
  rate: Scalars["String"];
};

/** Rule that holds configuration for how transactions should earn reward points. */
export type RewardEarnRule = {
  /** Objects that a rule is attached to. */
  attachments?: Maybe<RewardRuleAttachmentConnection>;
  /** The date and time, in ISO 8601 format, when the earn rule was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the reward earn rule. */
  id: Scalars["ID"];
  /** Name of `RewardEarnRule` */
  name?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, when the earn rule was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Rule that holds configuration for how transactions should earn reward points. */
export type RewardEarnRuleAttachmentsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The connection type for `RewardEarnRule`. */
export type RewardEarnRuleConnection = {
  __typename?: "RewardEarnRuleConnection";
  /** A list of edges. */
  edges?: Maybe<Array<RewardEarnRuleEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a `RewardEarnRule`. */
export type RewardEarnRuleEdge = {
  __typename?: "RewardEarnRuleEdge";
  /** The cursor for this edge for use in pagination. */
  cursor?: Maybe<Scalars["String"]>;
  /** The `RewardEarnRule`. */
  node?: Maybe<RewardEarnRule>;
};

/** `RewardEarnRule` that will earn rewards on transfers for specific `MerchantCategory`s. */
export type RewardMerchantCategoryEarnRule = Node &
  RewardEarnRule & {
    __typename?: "RewardMerchantCategoryEarnRule";
    /** Collection of `MerchantCategory` that a transaction's MCC must exist within in order for this rule to earn reward points. This field must have at least one `MerchantCategory`. */
    allowedList?: Maybe<Array<MerchantCategory>>;
    /** Collection of `MerchantCategory` codes that a transaction's MCC must exist within in order for this rule to earn reward points. This field must have at least one `MerchantCategory` code. */
    allowedListCodes?: Maybe<Array<Scalars["String"]>>;
    /** Objects that a rule is attached to. */
    attachments?: Maybe<RewardRuleAttachmentConnection>;
    /** The date and time, in ISO 8601 format, when the earn rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the reward earn rule. */
    id: Scalars["ID"];
    /** Name of `RewardMerchantCategoryEarnRule` */
    name?: Maybe<Scalars["String"]>;
    /** Earning Rate. This rate describes the amount of points earn related to the amount of money spent. (i.e. rate of 1.5 means earning 15 points on a $10 transaction) */
    rewardPointEarning?: Maybe<RewardEarnRate>;
    /** The `EarnRuleType`. For example, `PER_TRANSACTION_SPEND_AMOUNT`. */
    type?: Maybe<EarnRuleType>;
    /** The date and time, in ISO 8601 format, when the earn rule was updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** `RewardEarnRule` that will earn rewards on transfers for specific `MerchantCategory`s. */
export type RewardMerchantCategoryEarnRuleAttachmentsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Reward points activity that was requested during transfer */
export enum RewardPointsActivityType {
  /** Adds reward point(s) to a financial account that has this enabled. */
  AWARD = "AWARD",
  /** Deducts reward point(s) to a financial account that has this enabled. */
  DEDUCT = "DEDUCT",
  /** Redeems reward point(s) to a financial account that has this enabled. */
  REDEEM = "REDEEM",
  /** Refunds reward point(s) to a financial account that has this enabled. */
  REFUND = "REFUND",
}

/** Reward points activity that was requested during transfer */
export enum RewardPointsActivityTypeInput {
  /** Add reward points to an enabled `FinancialAccount`. */
  AWARD = "AWARD",
  /** Deduct reward points from an enabled `FinancialAccount`. */
  DEDUCT = "DEDUCT",
}

/** A transfer for the purposes of reward points */
export type RewardPointsTransfer = Node & {
  __typename?: "RewardPointsTransfer";
  /** Reward activity like AWARD, REDEEM, REFUND, DEDUCT */
  activity?: Maybe<RewardPointsActivityType>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** An optional tracker for external transaction identifier. Max character length is 255. */
  externalTransactionIdentifier?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the transfer in operations. */
  id: Scalars["ID"];
  /** The ledgers affected by the transfer. */
  ledgers?: Maybe<Array<Ledger>>;
  /**
   * Description for the transfer
   * ** Note: ** The maximum size is 1024 characters
   */
  memo?: Maybe<Scalars["String"]>;
  /** Optional; used if the reward point transfer was applied using a redemption configuration. */
  redemptionConfiguration?: Maybe<RewardRedemptionConfiguration>;
  /** Optional; used if the reward point transfer was applied using an earn rule. */
  rewardEarnRule?: Maybe<RewardEarnRule>;
  /** The amount of the transfer. */
  rewardPointsAmount?: Maybe<Amount>;
  /** Reward points monetary value */
  rewardPointsValue?: Maybe<Amount>;
  /** Source for reward points transfer like CARD_TRANSACTION, API */
  source?: Maybe<RewardPointsTransferSource>;
  /** The status of the reward points transfer. */
  status?: Maybe<RewardPointsTransferStatusDetails>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** A transfer for the purposes of reward points */
export type RewardPointsTransferLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** The connection type for `RewardPointsTransfer`. */
export type RewardPointsTransferConnection = {
  __typename?: "RewardPointsTransferConnection";
  /** A list of edges. */
  edges?: Maybe<Array<RewardPointsTransferEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The return types for finding transfer rules */
export type RewardPointsTransferConnectionPayload =
  | AccessDeniedError
  | RewardPointsTransferConnection
  | UserError;

/** The edge type for a `RewardPointsTransfer`. */
export type RewardPointsTransferEdge = {
  __typename?: "RewardPointsTransferEdge";
  /** The cursor for this edge for use in pagination. */
  cursor?: Maybe<Scalars["String"]>;
  /** The `RewardPointsTransfer`. */
  node?: Maybe<RewardPointsTransfer>;
};

/** Additional details regarding a `FAILED` reward points transfer. */
export enum RewardPointsTransferFailureReasonCode {
  /** The receiving account has been closed. */
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  /** The amount of the transfer does not match the currency of the receiving account. */
  ACCOUNT_CURRENCY_MISMATCH = "ACCOUNT_CURRENCY_MISMATCH",
  /** No matching account was found for the receiving account. */
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  /** The account the money was coming from did not have enough funds. */
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  /** The receiving account does not have the reward point feature enabled. */
  REWARD_POINT_FEATURE_NOT_ENABLED = "REWARD_POINT_FEATURE_NOT_ENABLED",
}

/** Information about reward points transfers which have failed. */
export type RewardPointsTransferFailureStatus = {
  __typename?: "RewardPointsTransferFailureStatus";
  /** The status of the failed transfer. This will always be `FAILED`. */
  status?: Maybe<RewardPointsTransferStatus>;
  /** Additional details about why a transfer failed. */
  statusReasonCode?: Maybe<RewardPointsTransferFailureReasonCode>;
};

/** The return types for finding transfer rules */
export type RewardPointsTransferPayload =
  | AccessDeniedError
  | RewardPointsTransfer
  | UserError;

/** Source of transfer request for reward points transfer */
export enum RewardPointsTransferSource {
  /**
   * A transfer request has been initiated using api
   * @deprecated `API` is deprecated in favor of `MANUAL_ADJUSTMENT`
   */
  API = "API",
  /** The transfer was initiated for a card transaction */
  CARD_TRANSACTION = "CARD_TRANSACTION",
  /** The transfer was manually created using API. */
  MANUAL_ADJUSTMENT = "MANUAL_ADJUSTMENT",
}

/** Status of the reward points transfer. */
export enum RewardPointsTransferStatus {
  /** The transfer has successfully completed. */
  COMPLETED = "COMPLETED",
  /** The transfer failed. Additional details are available in `RewardPointsTransferFailureReasonCode`. */
  FAILED = "FAILED",
  /** A transfer request has been initiated. */
  PENDING = "PENDING",
}

/** Details about the status of the reward points transfer. */
export type RewardPointsTransferStatusDetails =
  | RewardPointsTransferFailureStatus
  | RewardPointsTransferSuccessStatus;

/**
 * The status of the reward points transfer that has not failed.
 *
 * This could be statuses which are still pending work or that have successfully completed.
 */
export type RewardPointsTransferSuccessStatus = {
  __typename?: "RewardPointsTransferSuccessStatus";
  /** The status of the reward points transfer. */
  status?: Maybe<RewardPointsTransferStatus>;
};

/** `RewardRedemptionConfiguration` holds configuration for how rewards points could be redeemed. */
export type RewardRedemptionConfiguration = Node & {
  __typename?: "RewardRedemptionConfiguration";
  /** Objects that a `RewardRedemptionConfiguration` is attached to. */
  attachments?: Maybe<RewardRedemptionConfigurationAttachmentConnection>;
  /** The date and time, in ISO 8601 format, when the configuration was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the `RewardRedemptionConfiguration`. */
  id: Scalars["ID"];
  /** Name of `RewardRedemptionConfiguration` */
  name?: Maybe<Scalars["String"]>;
  /** Redemption Rate. This rate describes the value of money that can be redeemed for earned points. See `RewardRedemptionRate`. */
  rewardPointRedemption?: Maybe<RewardRedemptionRate>;
  /** The `RedemptionConfigurationType`. For example, `STATEMENT_CREDIT`. */
  type?: Maybe<RedemptionConfigurationType>;
  /** The date and time, in ISO 8601 format, when the configuration was updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** `RewardRedemptionConfiguration` holds configuration for how rewards points could be redeemed. */
export type RewardRedemptionConfigurationAttachmentsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Attachment object that a `RewardRedemptionConfiguration` is attached to. */
export type RewardRedemptionConfigurationAttachment = {
  /** The date and time in ISO 8601 format, representing when the attachment should start taking effect. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time in ISO 8601 format, representing when the attachment should stop taking effect. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the `RewardRedemptionConfigurationAttachment`. */
  id: Scalars["ID"];
  /** `RewardRedemptionConfiguration` that is attached. */
  redemptionConfiguration?: Maybe<RewardRedemptionConfiguration>;
};

/** The connection type for `RewardRedemptionConfigurationAttachment`. */
export type RewardRedemptionConfigurationAttachmentConnection = {
  __typename?: "RewardRedemptionConfigurationAttachmentConnection";
  /** A list of edges. */
  edges?: Maybe<Array<RewardRedemptionConfigurationAttachmentEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a `RewardRedemptionConfigurationAttachment`. */
export type RewardRedemptionConfigurationAttachmentEdge = {
  __typename?: "RewardRedemptionConfigurationAttachmentEdge";
  /** The cursor for this edge for use in pagination. */
  cursor?: Maybe<Scalars["String"]>;
  /** The `RewardRedemptionConfigurationAttachment`. */
  node?: Maybe<RewardRedemptionConfigurationAttachment>;
};

/** Input for attaching `RewardRedemptionConfiguration` to an object. */
export type RewardRedemptionConfigurationAttachmentInput = {
  /** Global identifier of the `RewardRedemptionConfiguration` to attach. */
  id: Scalars["ID"];
};

/** The connection type for `RewardRedemptionConfiguration`. */
export type RewardRedemptionConfigurationConnection = {
  __typename?: "RewardRedemptionConfigurationConnection";
  /** A list of edges. */
  edges?: Maybe<Array<RewardRedemptionConfigurationEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a `RewardRedemptionConfiguration`. */
export type RewardRedemptionConfigurationEdge = {
  __typename?: "RewardRedemptionConfigurationEdge";
  /** The cursor for this edge for use in pagination. */
  cursor?: Maybe<Scalars["String"]>;
  /** The `RewardRedemptionConfiguration`. */
  node?: Maybe<RewardRedemptionConfiguration>;
};

/** `CardProduct` attachment that a `RewardRedemptionConfiguration` is attached to. */
export type RewardRedemptionConfigurationProductAttachment =
  RewardRedemptionConfigurationAttachment & {
    __typename?: "RewardRedemptionConfigurationProductAttachment";
    /** `CardProduct` that the `RewardRedemptionConfiguration` is attached to. */
    cardProduct?: Maybe<CardProduct>;
    /** The date and time in ISO 8601 format, representing when the attachment should start taking effect. */
    effectiveFrom?: Maybe<Scalars["String"]>;
    /** The date and time in ISO 8601 format, representing when the attachment should stop taking effect. */
    effectiveThrough?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the `RewardRedemptionConfigurationAttachment`. */
    id: Scalars["ID"];
    /** `RewardRedemptionConfiguration` that is attached. */
    redemptionConfiguration?: Maybe<RewardRedemptionConfiguration>;
  };

/** The redemption rate for reward points, describing the monetary value per point. */
export type RewardRedemptionRate = {
  __typename?: "RewardRedemptionRate";
  /**
   * Input for entering `RewardRedemptionRate`. The amount of money that will be redeemed per point earned.
   * This rate should be between 0.0 and 100.0 with up to 3 digits of precision after the decimal point (i.e. 1.000).
   *
   * Redemption value will be rounded down according to the currency precision. For example:
   *   | rate                  | points redeemed  | redemption value |
   *   | --------------------- | ---------------- | ---------------- |
   *   | 1.0 USD per point     | 10 points        | $10.00           |
   *   | 1.5 USD per point     | 10 points        | $15.00           |
   *   | 1.001 USD per point   | 10 points        | $10.01           |
   */
  rate?: Maybe<Scalars["String"]>;
};

/** The redemption rate for reward points, describing the monetary value per point. */
export type RewardRedemptionRateInput = {
  /**
   * Input for entering `RewardRedemptionRate`. The amount of money that will be redeemed per point earned.
   * This rate should be between 0.0 and 100.0 with up to 3 digits of precision after the decimal point (i.e. 1.000).
   *
   * Redemption value will be rounded down according to the currency precision. For example:
   *
   *   | rate                  | points redeemed  | redemption value |
   *   | --------------------- | ---------------- | ---------------- |
   *   | 1.0 USD per point     | 10 points        | $10.00           |
   *   | 1.5 USD per point     | 10 points        | $15.00           |
   *   | 1.001 USD per point   | 10 points        | $10.01           |
   */
  rate: Scalars["String"];
};

/** `RewardEarnRule` attachment object. */
export type RewardRuleAttachment = {
  /** The date and time in ISO 8601 format, representing when the attachment should start taking effect. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time in ISO 8601 format, representing when the attachment should stop taking effect. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the `RewardRuleAttachment`. */
  id: Scalars["ID"];
  /** `RewardEarnRule` that is attached. */
  rewardEarnRule?: Maybe<RewardEarnRule>;
};

/** The connection type for `RewardRuleAttachment`. */
export type RewardRuleAttachmentConnection = {
  __typename?: "RewardRuleAttachmentConnection";
  /** A list of edges. */
  edges?: Maybe<Array<RewardRuleAttachmentEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a `RewardRuleAttachment`. */
export type RewardRuleAttachmentEdge = {
  __typename?: "RewardRuleAttachmentEdge";
  /** The cursor for this edge for use in pagination. */
  cursor?: Maybe<Scalars["String"]>;
  /** The `RewardRuleAttachment`. */
  node?: Maybe<RewardRuleAttachment>;
};

/** Input for attaching reward rules to an object. */
export type RewardRuleAttachmentInput = {
  /** Global identifier of the `RewardEarnRule` to attach. */
  id: Scalars["ID"];
};

/** `RewardEarnRule` attachment object attaching to a `CardProduct` */
export type RewardRuleProductAttachment = RewardRuleAttachment & {
  __typename?: "RewardRuleProductAttachment";
  /** `CardProduct` that the `RewardEarnRule` is attached to. */
  cardProduct?: Maybe<CardProduct>;
  /** The date and time in ISO 8601 format, representing when the attachment should start taking effect. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time in ISO 8601 format, representing when the attachment should stop taking effect. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the `RewardRuleAttachment`. */
  id: Scalars["ID"];
  /** `RewardEarnRule` that is attached. */
  rewardEarnRule?: Maybe<RewardEarnRule>;
};

/** Represents the amplitude or variability in monetary risk metrics. */
export type RiskAmountAmplitude = {
  __typename?: "RiskAmountAmplitude";
  /** Monetary amount reflecting the variability. */
  amount?: Maybe<Amount>;
};

/** The risk application sdk feature permission */
export type RiskApplicationSdk = FeaturePermission &
  Node & {
    __typename?: "RiskApplicationSDK";
    /** When the entity was created */
    createDate?: Maybe<Scalars["String"]>;
    /** The entity that created the feature permission */
    createdBy?: Maybe<Scalars["String"]>;
    /** Indicates if the permission is enabled */
    enabled?: Maybe<Scalars["Boolean"]>;
    /** ID of the `FeaturePermission` */
    id: Scalars["ID"];
    /** The list of revisions for this feature permission. */
    revisions?: Maybe<FeaturePermissionRevisionConnection>;
    /** When the entity was updated */
    updateDate?: Maybe<Scalars["String"]>;
    /** The entity that updated the feature permission */
    updatedBy?: Maybe<Scalars["String"]>;
  };

/** The risk application sdk feature permission */
export type RiskApplicationSdkRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A revision of the risk application sdk feature permission */
export type RiskApplicationSdkRevision = FeaturePermissionRevision &
  Node & {
    __typename?: "RiskApplicationSDKRevision";
    /** When the entity was created */
    createDate?: Maybe<Scalars["String"]>;
    /** The entity that created the feature permission */
    createdBy?: Maybe<Scalars["String"]>;
    /** Indicates if the permission is enabled */
    enabled?: Maybe<Scalars["Boolean"]>;
    /** ID of the `FeaturePermission` that this entity is a revision of */
    featurePermissionId: Scalars["ID"];
    /** ID of the `FeaturePermissionRevision` */
    id: Scalars["ID"];
    /** When the entity was updated */
    updateDate?: Maybe<Scalars["String"]>;
    /** The entity that updated the feature permission */
    updatedBy?: Maybe<Scalars["String"]>;
  };

/** Contains the necessary information to pass into the risk application sdk. */
export type RiskApplicationSdkSessionToken = {
  __typename?: "RiskApplicationSDKSessionToken";
  /** The session token to be used with the risk application sdk. */
  sessionToken?: Maybe<Scalars["String"]>;
};

/** The risk based pricing policy. */
export type RiskBasedPricingPolicy = {
  __typename?: "RiskBasedPricingPolicy";
  /** Whether or not to use risk based pricing. */
  isRiskBased?: Maybe<Scalars["Boolean"]>;
};

/** Represents the amplitude or variability in numerical risk counts. */
export type RiskCountAmplitude = {
  __typename?: "RiskCountAmplitude";
  /** Numerical count reflecting the variability. */
  count?: Maybe<Scalars["UnsignedInt"]>;
};

/** Defines a data point for geolocation scatter plots, including coordinates, label, and associated amplitude. */
export type RiskGeolocationDataPoint = {
  __typename?: "RiskGeolocationDataPoint";
  /**
   * Amplitude (intensity) associated with the data point representing the total times money has been spent at this
   * coordinate.
   */
  countAmplitude?: Maybe<RiskCountAmplitude>;
  /** Text for the data point. */
  label?: Maybe<Scalars["String"]>;
  /** Latitude coordinate of the data point. */
  latitude?: Maybe<Scalars["String"]>;
  /** Longitude coordinate of the data point. */
  longitude?: Maybe<Scalars["String"]>;
  /** Amplitude (intensity) associated with the data point representing the total sum of money spent at this coordinate. */
  moneyAmplitude?: Maybe<RiskAmountAmplitude>;
};

/** Structure for holding geolocation density data points, used in visualizing the distribution of locations. */
export type RiskGeolocationDensity = {
  __typename?: "RiskGeolocationDensity";
  /** Account holder related to the data. */
  accountHolder?: Maybe<AccountHolder>;
  /** List of geolocation data points. */
  geolocationDataPoints?: Maybe<Array<RiskGeolocationDataPoint>>;
  /** Organization associated with the data. */
  organization?: Maybe<Organization>;
};

/** Input filter for querying density of geolocation data points, specifying account holder, aggregation type, and date range. */
export type RiskGeolocationDensityFilterInput = {
  /** Optional filter for focusing on data specific to a certain account holder. */
  accountHolderId?: InputMaybe<Scalars["ID"]>;
  /** Date range for filtering geolocation data points. */
  createdAt: TimestampFilterInput;
};

/** Union type for the response payload of the geolocation density query, which can include density points, user errors, or access denial messages. */
export type RiskGeolocationDensityPayload =
  | AccessDeniedError
  | RiskGeolocationDensity
  | UserError;

/** Represents a geolocation path, comprising a sequence of data points to illustrate movement or trajectories. */
export type RiskGeolocationPath = {
  __typename?: "RiskGeolocationPath";
  /** Starting data point of the path. */
  from?: Maybe<RiskGeolocationDataPoint>;
  /** Ending data point of the path. */
  to?: Maybe<RiskGeolocationDataPoint>;
};

/** Structure for holding geolocation paths data, used in visualizing movement trajectories of the account holder. */
export type RiskGeolocationPaths = {
  __typename?: "RiskGeolocationPaths";
  /** Account holder related to the data. */
  accountHolder?: Maybe<AccountHolder>;
  /** List of ordered geolocation paths. */
  geolocationPaths?: Maybe<Array<RiskGeolocationPath>>;
  /** Organization associated with the data. */
  organization?: Maybe<Organization>;
};

/** Input filter for querying paths of geolocation data points, specifying account holder and date range. */
export type RiskGeolocationPathsFilterInput = {
  /** Required identifier to filter data specific to an account holder. */
  accountHolderId: Scalars["ID"];
  /** Date range for filtering geolocation data points. */
  createdAt: TimestampFilterInput;
};

/** Union type for the response payload of the geolocation paths query, which can include paths, user errors, or access denial messages. */
export type RiskGeolocationPathsPayload =
  | AccessDeniedError
  | RiskGeolocationPaths
  | UserError;

/** Defines a monetary data point's coordinates for a scatter plot, including amount and potential anomalies indicated by error. */
export type RiskMoneyCoordinate = {
  __typename?: "RiskMoneyCoordinate";
  /** X-axis value of the data point. */
  x?: Maybe<Scalars["String"]>;
  /** Y-axis value represented by an amount. */
  y?: Maybe<Amount>;
  /** Indicates the standard deviation for detecting anomalies. */
  yError?: Maybe<Amount>;
};

/** Represents a single data point in a scatter plot, encapsulating the coordinates and other pertinent information for visualization. */
export type RiskMoneyScatterDataPoint = {
  __typename?: "RiskMoneyScatterDataPoint";
  /** Coordinates of the scatter data point. */
  coordinate?: Maybe<RiskMoneyCoordinate>;
};

/** Enumeration of periodicity options for data aggregation, allowing analysis over different time intervals. */
export enum RiskPeriodicityType {
  /** Group data on a monthly basis. */
  MONTHLY = "MONTHLY",
  /** Group data on a weekly basis. */
  WEEKLY = "WEEKLY",
}

/** Defines a data point's coordinates for a scatter plot, including position and potential anomalies indicated by error. */
export type RiskPositionalCoordinate = {
  __typename?: "RiskPositionalCoordinate";
  /** X-axis value of the data point. */
  x?: Maybe<Scalars["String"]>;
  /** Y-axis value of the data point. */
  y?: Maybe<Scalars["Float"]>;
  /** Indicates the standard deviation for detecting anomalies. */
  yError?: Maybe<Scalars["Float"]>;
};

/** Represents a single data point in a scatter plot, encapsulating the coordinates and other pertinent information for visualization. */
export type RiskPositionalScatterDataPoint = {
  __typename?: "RiskPositionalScatterDataPoint";
  /** Coordinates of the scatter data point. */
  coordinate?: Maybe<RiskPositionalCoordinate>;
};

/** Represents the value in monetary risk metrics. */
export type RiskSankeyAmountValue = {
  __typename?: "RiskSankeyAmountValue";
  /** Monetary amount reflecting the variability. */
  amount?: Maybe<Amount>;
};

/** Represents the value in numerical risk counts. */
export type RiskSankeyCountValue = {
  __typename?: "RiskSankeyCountValue";
  /** Numerical count reflecting the variability. */
  count?: Maybe<Scalars["UnsignedInt"]>;
};

/**
 * The `RiskScatterDataPoints` type defines the structure of the response when querying for scatter data points. This type
 * encapsulates various attributes necessary for plotting data points on a scatter plot, including information about each
 * data point and any metadata that may be relevant to the visualization
 */
export type RiskScatterDataPoints = {
  __typename?: "RiskScatterDataPoints";
  /** The accountHolder field returns an `AccountHolder` object, representing an entity that is involved in the data. */
  accountHolder?: Maybe<AccountHolder>;
  /**
   * A non-nullable array of `RiskMoneyScatterDataPoint` objects that represent individual data points to be plotted
   * on the scatter plot.
   */
  moneyScatterDataPoints?: Maybe<Array<RiskMoneyScatterDataPoint>>;
  /** The organization field returns an `Organization` object, representing an entity that is involved in the data. */
  organization?: Maybe<Organization>;
  /** Specifies the frequency or regularity at which certain data or events are recorded or aggregated. */
  periodicityType?: Maybe<RiskPeriodicityType>;
  /**
   * A non-nullable array of `RiskPositionalScatterDataPoint` objects that represent individual data points to be plotted
   * on the scatter plot.
   */
  positionalScatterDataPoints?: Maybe<Array<RiskPositionalScatterDataPoint>>;
};

/** Input filter for retrieving scatter plot data, specifying criteria like account holder, periodicity, aggregation, and date range. */
export type RiskScatterDataPointsFilterInput = {
  /** Optional filter for focusing on data specific to a certain account holder. */
  accountHolderId?: InputMaybe<Scalars["ID"]>;
  /** Sets the date range for the data points to be included in the scatter plot. */
  createdAt: TimestampFilterInput;
  /** Specifies the periodicity of the data points (e.g., weekly, monthly). */
  periodicityType: RiskPeriodicityType;
};

/** Union type for the response payload of the scatter data points query, which can include data points, user errors, or access denial messages. */
export type RiskScatterDataPointsPayload =
  | AccessDeniedError
  | RiskScatterDataPoints
  | UserError;

/** Input for removing the email for a notification target. */
export type RotateNotificationTargetSigningKeyInput = {
  /** The notification target ID. */
  targetId: Scalars["ID"];
};

/**
 * The return types when removing subscriptions from an existing webhook
 * notification target.
 */
export type RotateNotificationTargetSigningKeyPayload =
  | AccessDeniedError
  | UserError
  | WebhookNotificationTarget;

/**
 * The rounding strategy when a value has more minor unit precision than the system can process.
 *
 * i.e. A value may have 5 decimal places, but the transfer only supports 2 decimal places. Highnote would round the value to support the transfer.
 */
export enum RoundingStrategy {
  /** The value is rounded down to the nearest minor unit. */
  ROUND_DOWN = "ROUND_DOWN",
  /** The value is rounded up to the nearest minor unit. */
  ROUND_UP = "ROUND_UP",
}

/** An RTP (Real-Time Payments) transfer via the TCH network. */
export type RtpTransfer = {
  /** Additional details for the bank transfer including payment related information. */
  bankTransferDetails?: Maybe<RtpTransferBankTransferDetails>;
  /** The date and time, in ISO 8601 format, when this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The destination of the funds being transferred. */
  destination?: Maybe<RtpTransferDestination>;
  /** When the `RtpTransfer` has failed, this will be populated with the reason for the failure. */
  failureReason?: Maybe<RtpTransferFailureReason>;
  /** Global ID used to reference this object. */
  id: Scalars["ID"];
  /** The source of the funds being transferred. */
  source?: Maybe<RtpTransferSource>;
  /** The current status of the `RtpTransfer`. */
  status?: Maybe<RtpTransferStatus>;
  /** The date and time, in ISO 8601 format, when this object was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Additional details for an `RtpTransfer`. */
export type RtpTransferBankTransferDetails = {
  __typename?: "RtpTransferBankTransferDetails";
  /**
   * Freeform text provided by the originator of the transfer to describe the purpose of the payment.
   * This can include invoice numbers, account references, or any other relevant payment details.
   *
   * **Example:** "Invoice #12345 - October 2024 payment"
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities and method of access (i.e., online banking, statement, etc.)
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
};

/** The destination of the funds in an `RtpTransfer`. */
export type RtpTransferDestination = {
  __typename?: "RtpTransferDestination";
  /** The amount of funds deposited at the destination. */
  amount?: Maybe<Amount>;
  /** If the destination is a Highnote `Node`, this will be the `Node`. */
  node?: Maybe<RtpTransferDestinationNode>;
};

/** The possible destination nodes for an `RtpTransfer`. */
export type RtpTransferDestinationNode = FinancialAccount | UsBankAccount;

/** Reasons an `RtpTransfer` may have failed. */
export enum RtpTransferFailureReason {
  /** The `RtpTransfer` failed because the account is closed. */
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  /** The `RtpTransfer` failed because the account is frozen. */
  ACCOUNT_FROZEN = "ACCOUNT_FROZEN",
  /** The `RtpTransfer` failed because the account is not active. */
  ACCOUNT_NOT_ACTIVE = "ACCOUNT_NOT_ACTIVE",
  /** The `RtpTransfer` failed because the account was not found. */
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  /** The `RtpTransfer` failed due to a configuration error. */
  CONFIGURATION_ERROR = "CONFIGURATION_ERROR",
  /** The `RtpTransfer` failed because of a currency mismatch. */
  CURRENCY_MISMATCH = "CURRENCY_MISMATCH",
  /** The `RtpTransfer` failed because there were insufficient funds. */
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  /** The `RtpTransfer` failed because the amount is invalid. */
  INVALID_AMOUNT = "INVALID_AMOUNT",
  /** The `RtpTransfer` failed due to a network error. */
  NETWORK_ERROR = "NETWORK_ERROR",
  /** The `RtpTransfer` failed because the network is not supported. */
  NETWORK_NOT_SUPPORTED = "NETWORK_NOT_SUPPORTED",
  /** The `RtpTransfer` failed due to a timeout. */
  TIMEOUT = "TIMEOUT",
  /** The `RtpTransfer` failed because the transfer is not permitted. */
  TRANSFER_NOT_PERMITTED = "TRANSFER_NOT_PERMITTED",
  /** The `RtpTransfer` failed for an unspecified reason. */
  UNSPECIFIED = "UNSPECIFIED",
}

/** The source of the funds in an `RtpTransfer`. */
export type RtpTransferSource = {
  __typename?: "RtpTransferSource";
  /** The amount of funds sourced from this account. */
  amount?: Maybe<Amount>;
  /** If the source is a Highnote `Node`, this will be the `Node`. */
  node?: Maybe<RtpTransferSourceNode>;
};

/** The possible source nodes for an `RtpTransfer`. */
export type RtpTransferSourceNode = FinancialAccount | UsBankAccount;

/** The status of an `RtpTransfer`. */
export enum RtpTransferStatus {
  /** The `RtpTransfer` has been cancelled. */
  CANCELLED = "CANCELLED",
  /** The `RtpTransfer` has completed successfully. */
  COMPLETED = "COMPLETED",
  /** The `RtpTransfer` has failed. */
  FAILED = "FAILED",
  /** The `RtpTransfer` is on hold. */
  HOLD = "HOLD",
  /** The `RtpTransfer` has been initiated. */
  INITIATED = "INITIATED",
  /** The `RtpTransfer` is pending. */
  PENDING = "PENDING",
  /** The `RtpTransfer` is processing. */
  PROCESSING = "PROCESSING",
}

/**
 * A `RuleCollection` is a set of `SpendRule`, `TransferRule`, `InterFinancialAccountTransferRule`, `RiskRule`,
 * `VelocityRule`, `VelocityRiskRule`, `VelocityTransferRule`, and/or `VelocityInterFinancialAccountTransferRule`
 * that can be used as a template to attach to a `PaymentCard`, `FinancialAccount`, `CardProduct` or `Platform`
 * in 1 operation
 */
export type RuleCollection = Node & {
  __typename?: "RuleCollection";
  /** The date and time, in ISO 8601 format, the rule collection was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the `RuleCollection`. */
  id: Scalars["ID"];
  /** The list of `InterFinancialAccountTransferRule` objects in this `RuleCollection` */
  interFinancialAccountTransferRules?: Maybe<
    Array<InterFinancialAccountTransferRule>
  >;
  /** The name assigned to the `RuleCollection`. */
  name?: Maybe<Scalars["String"]>;
  /** The list of `SpendRule` objects in this `RuleCollection`. */
  spendRules?: Maybe<Array<SpendRule>>;
  /** The date and time, in ISO 8601 format, the rule collection was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** The list of `VelocityInterFinancialAccountTransferRule` objects in this `RuleCollection` */
  velocityInterFinancialAccountTransferRules?: Maybe<
    Array<VelocityInterFinancialAccountTransferRule>
  >;
  /**
   * The list of `VelocityRule` objects in this `RuleCollection`.
   * VelocityRules are also known as VelocitySpendRules
   * Note: Up to 5 allowed
   */
  velocitySpendRules?: Maybe<Array<VelocityRule>>;
  /** The rule collection version. */
  version?: Maybe<Scalars["String"]>;
};

/** A `RuleCollectionRevision` is a specific version of a `RuleCollection`. */
export type RuleCollectionRevision = Node & {
  __typename?: "RuleCollectionRevision";
  /** The date and time, in ISO 8601 format, the rule collection revision was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the `RuleCollectionRevision`. */
  id: Scalars["ID"];
  /** The list of `InterFinancialAccountTransferRule` objects in this `RuleCollectionRevision` */
  interFinancialAccountTransferRules?: Maybe<
    Array<InterFinancialAccountTransferRule>
  >;
  /** The name assigned to the `RuleCollectionRevision`. */
  name?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the `RuleCollection` that this revision is of. */
  publicRuleCollectionId: Scalars["ID"];
  /** The list of `SpendRule` objects in this `RuleCollectionRevision`. */
  spendRules?: Maybe<Array<SpendRule>>;
  /** The date and time, in ISO 8601 format, the rule collection revision was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** The list of `VelocityInterFinancialAccountTransferRule` objects in this `RuleCollectionRevision` */
  velocityInterFinancialAccountTransferRules?: Maybe<
    Array<VelocityInterFinancialAccountTransferRule>
  >;
  /**
   * The list of `VelocityRule` objects in this `RuleCollectionRevision`.
   * VelocityRules are also known as VelocitySpendRules
   * Note: Up to 5 allowed
   */
  velocitySpendRules?: Maybe<Array<VelocityRule>>;
  /** The rule collection version. */
  version?: Maybe<Scalars["String"]>;
};

/** Defines a single link in a Sankey diagram, including source and target nodes, and the value representing the flow between them. */
export type SankeyDataLink = {
  __typename?: "SankeyDataLink";
  /** Value representing the number of transactions between nodes. */
  countValue?: Maybe<RiskSankeyCountValue>;
  /** Label for the link. */
  label?: Maybe<Scalars["String"]>;
  /** Value representing the money flow between nodes. */
  moneyValue?: Maybe<RiskSankeyAmountValue>;
  /** Source node of the link. */
  source?: Maybe<Scalars["String"]>;
  /** Target node of the link. */
  target?: Maybe<Scalars["String"]>;
};

/** Structure for Sankey diagram data points, including nodes and links that illustrate the flow of money or other metrics. */
export type SankeyDataPoints = {
  __typename?: "SankeyDataPoints";
  /** Account holder related to the data. */
  accountHolder?: Maybe<AccountHolder>;
  /** Organization associated with the data. */
  organization?: Maybe<Organization>;
  /** List of links representing the flow in the Sankey diagram. */
  sankeyDataLinks?: Maybe<Array<SankeyDataLink>>;
};

/** Values associated with the sardine assessing risk */
export type SardineIdentityRiskScore = AccountHolderIdentityRiskScore & {
  __typename?: "SardineIdentityRiskScore";
  /** The date and time, in ISO 8601 format, when the risk decision was made */
  determinedAt?: Maybe<Scalars["String"]>;
  /** The severity of the risk */
  riskLevel?: Maybe<IdentityRiskLevel>;
  /** The session key associated with this event. */
  sessionKey?: Maybe<Scalars["String"]>;
};

export type ScheduledTransfer = {
  /**
   * The account sending the funds.
   *
   * Exactly one of `fromFinancialAccount` and `toFinancialAccount` will be an `ExternalFinancialAccount` and the other will be a `FinancialAccount`.
   */
  fromFinancialAccount?: Maybe<AllFinancialAccount>;
  /** Global ID used to reference the scheduled transfer */
  id: Scalars["ID"];
  /**
   * The account receiving the funds.
   *
   * Exactly one of `fromFinancialAccount` and `toFinancialAccount` will be an `ExternalFinancialAccount` and the other will be a `FinancialAccount`.
   */
  toFinancialAccount?: Maybe<AllFinancialAccount>;
};

/** A scheduled transfer event that executed on the ACH rails. */
export type ScheduledTransferAchEvent = Node &
  ScheduledTransferEvent & {
    __typename?: "ScheduledTransferAchEvent";
    /** The date and time, in ISO 8601 format, this scheduled transfer event was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /**
     * The financial account sending the funds.
     *
     * Exactly one of `fromFinancialAccount` and `toFinancialAccount` will be an `ExternalFinancialAccount` and the other will be a `FinancialAccount`.
     */
    fromFinancialAccount?: Maybe<AllFinancialAccount>;
    /** The Global ID used to reference the `ScheduledTransferAchEvent` */
    id: Scalars["ID"];
    /** The date and time, in ISO 8601 format, this scheduled transfer event was initiated. */
    paymentInitiatedAt?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, this scheduled transfer event was posted to the account. */
    paymentPostedAt?: Maybe<Scalars["String"]>;
    /** The status of the scheduled transfer event. */
    status?: Maybe<ScheduledTransferEventStatusCode>;
    /**
     * The financial account receiving the funds.
     *
     * Exactly one of `fromFinancialAccount` and `toFinancialAccount` will be an `ExternalFinancialAccount` and the other will be a `FinancialAccount`.
     */
    toFinancialAccount?: Maybe<AllFinancialAccount>;
    /** The amount requested to be transferred. */
    transferAmount?: Maybe<Amount>;
    /** The transfers executed as part of the scheduled payment transfer event. */
    transfers?: Maybe<Array<Maybe<ElectronicFundsTransfer>>>;
    /** The date and time, in ISO 8601 format, this scheduled transfer event was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Permissions for a `ScheduledTransfer` Client Token */
export enum ScheduledTransferClientTokenPermission {
  /** Setting this permission will enable management of the lifecycle of a scheduled transfer. */
  MANAGE_SCHEDULED_TRANSFER = "MANAGE_SCHEDULED_TRANSFER",
}

/** The connection type for Scheduled Transfer. */
export type ScheduledTransferConnection = {
  __typename?: "ScheduledTransferConnection";
  /** A list of edges. */
  edges?: Maybe<Array<ScheduledTransferEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a `ScheduledTransfer`. */
export type ScheduledTransferEdge = {
  __typename?: "ScheduledTransferEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** A Scheduled Transfer Event. */
  node?: Maybe<ScheduledTransfer>;
};

/** An interface for a scheduled transfer event */
export type ScheduledTransferEvent = {
  /** The date and time, in ISO 8601 format, this `ScheduledTransferEvent` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The Global ID used to reference the `ScheduledTransferEvent` */
  id: Scalars["ID"];
  /** The date and time, in ISO 8601 format, this `ScheduledTransferEvent` was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The connection type for Scheduled Transfer Event. */
export type ScheduledTransferEventConnection = {
  __typename?: "ScheduledTransferEventConnection";
  /** A list of edges. */
  edges?: Maybe<Array<ScheduledTransferEventEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a `ScheduledTransferEvent`. */
export type ScheduledTransferEventEdge = {
  __typename?: "ScheduledTransferEventEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The Scheduled Transfer Event. */
  node?: Maybe<ScheduledTransferEvent>;
};

/** The status of the scheduled transfer event */
export enum ScheduledTransferEventStatusCode {
  /** The scheduled transfer event has completed successfully. */
  COMPLETED = "COMPLETED",
  /** The scheduled transfer event has been failed by Highnote. Please look into the `transfer` object to determine the root cause of the failure. */
  FAILED = "FAILED",
  /** The scheduled transfer event has been inititated */
  INITIATED = "INITIATED",
  /** The scheduled transfer event did not execute a transfer. A `NOT_EXECUTED` status can occur if the calculated amount to transfer is `0`. */
  NOT_EXECUTED = "NOT_EXECUTED",
  /** The scheduled transfer event has been rejected. Please look into the `transfer` object to determine the root cause of the failure. */
  REJECTED = "REJECTED",
}

/** The status of the scheduled transfer */
export enum ScheduledTransferStatusCode {
  /** The scheduled transfer is active. A scheduled transfer moves from `SCHEDULED` to `ACTIVE` once the first transfer is initiated. */
  ACTIVE = "ACTIVE",
  /** The scheduled transfer is canceled. Once a scheduled transfer is canceled, any payments in the future will not be executed. */
  CANCELED = "CANCELED",
  /** The scheduled transfer is closed. Once a scheduled transfer is `CLOSED`, all payments requested to be executed have been executed and any payments in the future will not be executed. */
  CLOSED = "CLOSED",
  /** The scheduled transfer has been created and scheduled. `SCHEDULED` state indicates a transfer has yet to be initiated. */
  SCHEDULED = "SCHEDULED",
}

/** Details of a change to a specific schema path */
export type SchemaChange = {
  __typename?: "SchemaChange";
  /** The type of the schema change, e.g. `FIELD_ADDED`. */
  changeType?: Maybe<Scalars["String"]>;
  /** The criticality of the `SchemaChange`. */
  criticality?: Maybe<SchemaChangeCriticality>;
  /** Description of schema change, e.g. `Field 'bar' was added to object type 'Foo'. */
  message?: Maybe<Scalars["String"]>;
  /** The schema path of the change e.g. `Foo.bar`. */
  path?: Maybe<Scalars["String"]>;
};

/** The criticality of the `SchemaChange` */
export type SchemaChangeCriticality = {
  __typename?: "SchemaChangeCriticality";
  /** This code represents the level of criticality of the `SchemaChange`. */
  level?: Maybe<SchemaChangeCriticalityLevel>;
};

/** The level of the `SchemaChange` */
export enum SchemaChangeCriticalityLevel {
  BREAKING = "BREAKING",
  DANGEROUS = "DANGEROUS",
  NON_BREAKING = "NON_BREAKING",
}

/** The schema changes for a specific deploy timestamp. */
export type SchemaChangelog = {
  __typename?: "SchemaChangelog";
  /** The schema changes associated with the specified timestamp */
  changes?: Maybe<Array<SchemaChangesForRootPath>>;
  /** Timestamp associated with a specific deployment */
  createdAt?: Maybe<Scalars["String"]>;
  /** Globally unique identifier for a `SchemaChangelog` */
  id: Scalars["ID"];
};

/** The connection type for `SchemaChangelogs`. */
export type SchemaChangelogConnection = {
  __typename?: "SchemaChangelogConnection";
  /** A list of edges. */
  edges?: Maybe<Array<SchemaChangelogEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for `SchemaChangelogs`. */
export type SchemaChangelogEdge = {
  __typename?: "SchemaChangelogEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The `SchemaChangelog`. */
  node?: Maybe<SchemaChangelog>;
};

/** The schema changes for a specified schema `rootPath` */
export type SchemaChangesForRootPath = {
  __typename?: "SchemaChangesForRootPath";
  /**
   * Schema changes for the specified root path
   * ? Change field name to rootPathChanges?
   */
  changes?: Maybe<Array<SchemaChange>>;
  /** Root path of associated `changes`. */
  rootPath: Scalars["String"];
};

/** A short lived token representing the customer address to a scope of usage. */
export type ScopedCustomerAddressToken = {
  __typename?: "ScopedCustomerAddressToken";
  /** The date and time, in ISO 8601 format, the short lived payment method token will expire. */
  expiresAt?: Maybe<Scalars["String"]>;
  /** Scope of the token */
  scope?: Maybe<AddressTokenScope>;
  /** Global ID used to reference this object. */
  token?: Maybe<Scalars["String"]>;
};

/** Types to expect while requesting a scoped payment method token. */
export type ScopedCustomerAddressTokenPayload =
  | AccessDeniedError
  | ScopedCustomerAddressToken
  | UserError;

/** A short lived token representing the payment method limited to a scope of usage. */
export type ScopedPaymentMethodToken = {
  __typename?: "ScopedPaymentMethodToken";
  /** The date and time, in ISO 8601 format, the short lived payment method token will expire. */
  expiresAt?: Maybe<Scalars["String"]>;
  /** Scope of the token */
  scope?: Maybe<TokenScope>;
  /** Global ID used to reference this object. */
  token?: Maybe<Scalars["String"]>;
};

/** Types to expect while requesting a scoped payment method token. */
export type ScopedPaymentMethodTokenPayload =
  | AccessDeniedError
  | ScopedPaymentMethodToken
  | UserError;

/**
 * A realtime script-based risk rule. These rules execute in realtime during the
 * authorization of a card transaction.
 */
export type ScriptRealtimeRiskRule = Node &
  RealtimeRiskRule & {
    __typename?: "ScriptRealtimeRiskRule";
    /** The date and time, in ISO 8601 format, the realtime risk rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The `User` who created the entity. */
    createdBy?: Maybe<UserPayload>;
    /** Global ID used to reference in operations. */
    id: Scalars["ID"];
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this realtime risk rule. */
    revisions?: Maybe<RealtimeRiskRuleConnectionPayload>;
    /** The MVEL script expression to evaluate. */
    script?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the realtime risk rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `User` who last updated the entity. */
    updatedBy?: Maybe<UserPayload>;
    /**
     * The current version of the rule. Specific versions can be attached and
     * detached from card products and payment cards.
     */
    version?: Maybe<Scalars["String"]>;
  };

/**
 * A realtime script-based risk rule. These rules execute in realtime during the
 * authorization of a card transaction.
 */
export type ScriptRealtimeRiskRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The connection type for `CardProductApplication` search. */
export type SearchCardProductApplicationConnection = {
  __typename?: "SearchCardProductApplicationConnection";
  /** A list of edges. */
  edges?: Maybe<Array<SearchCardProductApplicationEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a `CardProductApplication`. */
export type SearchCardProductApplicationEdge =
  | AccountHolderCardProductApplicationEdge
  | AuthorizedUserCardProductApplicationEdge;

/** Used to search using the Highnote `SearchQueryLanguage`. */
export type SearchQueryLanguageInput = {
  /**
   * The search query that will be used.
   * Example: transactionAmount > USD 50
   */
  query: Scalars["String"];
  /** The version of `SearchQueryLanguage` that will be used. */
  version: SearchQueryLanguageVersion;
};

/** Denotes the version of `SearchQueryLanguage` to be used. */
export enum SearchQueryLanguageVersion {
  /** Version 1 */
  VERSION_1 = "VERSION_1",
}

/** Breakdown of seasonal volumme by month */
export type SeasonalVolumeBreakdown = {
  __typename?: "SeasonalVolumeBreakdown";
  /** April volume for each currency the business transacts with */
  april?: Maybe<Array<Amount>>;
  /** August volume for each currency the business transacts with */
  august?: Maybe<Array<Amount>>;
  /** December volume for each currency the business transacts with */
  december?: Maybe<Array<Amount>>;
  /** February volume for each currency the business transacts with */
  february?: Maybe<Array<Amount>>;
  /** January volume for each currency the business transacts with */
  january?: Maybe<Array<Amount>>;
  /** July volume for each currency the business transacts with */
  july?: Maybe<Array<Amount>>;
  /** June volume for each currency the business transacts with */
  june?: Maybe<Array<Amount>>;
  /** March volume for each currency the business transacts with */
  march?: Maybe<Array<Amount>>;
  /** May volume for each currency the business transacts with */
  may?: Maybe<Array<Amount>>;
  /** November volume for each currency the business transacts with */
  november?: Maybe<Array<Amount>>;
  /** October volume for each currency the business transacts with */
  october?: Maybe<Array<Amount>>;
  /** September volume for each currency the business transacts with */
  september?: Maybe<Array<Amount>>;
};

/** Possible secondary atm network. */
export enum SecondaryAtmNetwork {
  /** Maestro ATM network. */
  MAESTRO = "MAESTRO",
  /** Plus ATM network. */
  PLUS = "PLUS",
  /** Pulse ATM network. */
  PULSE = "PULSE",
}

/** Possible secondart point of sale network. */
export enum SecondaryPointOfSaleNetwork {
  /** Interlink network. */
  INTERLINK = "INTERLINK",
  /** NYCE network. */
  NYCE = "NYCE",
  /** Pulse network. */
  PULSE = "PULSE",
}

/** Possible secondary surcharge free atm network. */
export enum SecondarySurchargeFreeAtmNetwork {
  /** Allpoint Free Surcharge ATM network. */
  ALL_POINT = "ALL_POINT",
  /** MoneyPass Free Surcharge ATM network. */
  MONEY_PASS = "MONEY_PASS",
  /** SUM Free Surcharge ATM network. */
  SUM = "SUM",
}

/** Details of the new Secret Key */
export type SecretApiKeyInput = {
  /** Human-friendly name of the Secret API Key. */
  name: Scalars["String"];
};

/** A transfer that refills the balance on a secure card. */
export type SecureCardBalanceRepaymentAchTransfer = ElectronicFundsTransfer &
  IntegratorInitiatedAchTransfer &
  Node & {
    __typename?: "SecureCardBalanceRepaymentACHTransfer";
    /** The amount of the transfer. */
    amount?: Maybe<Amount>;
    /** The Card Product associated to the Financial Account. */
    cardProduct?: Maybe<CardProduct>;
    /** The ID for Highnote. */
    companyIdentifier?: Maybe<Scalars["String"]>;
    /**
     * The name of the company that initiated the ACH transfer.
     *
     * This will always be Highnote.
     */
    companyName?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the transfer was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Descriptive fields about the transfer which may show up on bank reports. */
    descriptor?: Maybe<AchDescriptor>;
    /**
     * The account sending the funds.
     *
     * Exactly one of fromFinancialAccount and toFinancialAccount will be an `ExternalFinancialBankAccount` and the other will be a `FinancialAccount`.
     */
    fromFinancialAccount?: Maybe<AllFinancialAccount>;
    /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
    fundsAvailableDate?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the transfer in operations. */
    id: Scalars["ID"];
    /** The ledgers affected by the transfer. */
    ledgers?: Maybe<Array<Ledger>>;
    /**
     * This field contains payment-related information provided by the originator of the transaction.
     * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
     * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
     *
     * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
     *
     * Please note that this information may or may not be displayed to the recipient, based on the bank's
     * capabilities, and method of access (i.e., online banking, statement, etc.)
     */
    paymentRelatedInformation?: Maybe<Scalars["String"]>;
    /** The date this transaction was returned, in ISO 8601 format. */
    returnDate?: Maybe<Scalars["String"]>;
    /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
    settlementDate?: Maybe<Scalars["String"]>;
    /** The status of the integrator initiated ACH transfer. */
    status?: Maybe<IntegratorInitiatedAchStatusDetails>;
    /**
     * The account receiving the funds.
     *
     * Exactly one of fromFinancialAccount and toFinancialAccount will be an `ExternalFinancialBankAccount` and the other will be a `FinancialAccount`.
     */
    toFinancialAccount?: Maybe<AllFinancialAccount>;
    /** A unique 15 digit number assigned by the originator to identify the transfer. */
    traceNumber?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the transfer was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** A transfer that refills the balance on a secure card. */
export type SecureCardBalanceRepaymentAchTransferLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** A financial event that represents card balance repayment ACH transfer. */
export type SecureCardBalanceRepaymentAchTransferEvent = AchTransferEvent &
  Node & {
    __typename?: "SecureCardBalanceRepaymentACHTransferEvent";
    /** The amount of the transfer. */
    amount?: Maybe<Amount>;
    /** Company entered value for the type of ACH. */
    companyEntryDescription?: Maybe<Scalars["String"]>;
    /**
     * The Company Identifier is a 10-position alphameric code used to identify an Originator of the ACH transaction. It may begin with an ANSI one-digit Identification Code Designator (ICD), followed by the Identification Number.
     *
     * |`Identification Code Designator (ICD)`    | `ANSI Identification Number` | Example                                                                         |
     * | ---------------------------------------- | ---------------------------- | ------------------------------------------------------------------------------- |
     * |`IRS Employer Identification Number (EIN)`| 1                            | 1234567890 for an Originator with 234567890 EIN                                 |
     * |`Data Universal Numbering Systems (DUNS)` | 3                            | 30008016958 for an Originator with 0008016958 DUNS                              |
     * |`User Assigned Number`                    | 9                            | 9111111111 for an Originator with 111111111 under assigned Identification Number|
     */
    companyIdentifier?: Maybe<Scalars["String"]>;
    /** The name of the company that initiated the ACH transfer. */
    companyName?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the transfer event was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The account sending the funds. */
    fromFinancialAccount?: Maybe<ExternalFinancialBankAccount>;
    /** Global ID used to reference the transfer in operations. */
    id: Scalars["ID"];
    /** The date this transaction was returned, in ISO 8601 format. */
    returnDate?: Maybe<Scalars["String"]>;
    /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
    settlementDate?: Maybe<Scalars["String"]>;
    /** The status of the integrator initiated ACH transfer. */
    status?: Maybe<IntegratorInitiatedAchStatusDetails>;
    /** The account receiving the funds. */
    toFinancialAccount?: Maybe<FinancialAccount>;
    /** The `ElectronicFundsTransfer` that triggered this event. */
    transfer?: Maybe<ElectronicFundsTransfer>;
  };

/** Externally Initiated Secure Deposit transfer */
export type SecureDeposit = ElectronicFundsTransfer &
  ExternallyInitiatedAchTransfer &
  Node & {
    __typename?: "SecureDeposit";
    /** The amount of the transfer. */
    amount?: Maybe<Amount>;
    /** The Card Product associated to the Financial Account. */
    cardProduct?: Maybe<CardProduct>;
    /** The ID for Highnote. */
    companyIdentifier?: Maybe<Scalars["String"]>;
    /**
     * The name of the company that initiated the ACH transfer.
     *
     * This will always be Highnote.
     */
    companyName?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the transfer was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Descriptive fields about the transfer which may show up on bank reports. */
    descriptor?: Maybe<AchDescriptor>;
    /** Global ID used to reference the transfer in operations. */
    id: Scalars["ID"];
    /** The ledgers affected by the transfer. */
    ledgers?: Maybe<Array<Ledger>>;
    /** The date this transaction was returned, in ISO 8601 format. */
    returnDate?: Maybe<Scalars["String"]>;
    /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
    settlementDate?: Maybe<Scalars["String"]>;
    /** The status of the integrator initiated ACH transfer. */
    status?: Maybe<ExternallyInitiatedAchStatusDetails>;
    /**
     * The account receiving the funds.
     *
     * Exactly one of fromFinancialAccount and toFinancialAccount will be an `ExternalFinancialBankAccount` and the other will be a `FinancialAccount`.
     */
    toFinancialAccount?: Maybe<AllFinancialAccount>;
    /** A unique 15 digit number assigned by the originator to identify the transfer. */
    traceNumber?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the transfer was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Externally Initiated Secure Deposit transfer */
export type SecureDepositLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** Originated SecureDeposit transfer */
export type SecureDepositAchTransfer = ElectronicFundsTransfer &
  IntegratorInitiatedAchTransfer &
  Node & {
    __typename?: "SecureDepositACHTransfer";
    /** The amount of the transfer. */
    amount?: Maybe<Amount>;
    /** The Card Product associated to the Financial Account. */
    cardProduct?: Maybe<CardProduct>;
    /** The ID for Highnote. */
    companyIdentifier?: Maybe<Scalars["String"]>;
    /**
     * The name of the company that initiated the ACH transfer.
     *
     * This will always be Highnote.
     */
    companyName?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the transfer was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Descriptive fields about the transfer which may show up on bank reports. */
    descriptor?: Maybe<AchDescriptor>;
    /**
     * The account sending the funds.
     *
     * Exactly one of fromFinancialAccount and toFinancialAccount will be an `ExternalFinancialBankAccount` and the other will be a `FinancialAccount`.
     */
    fromFinancialAccount?: Maybe<AllFinancialAccount>;
    /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
    fundsAvailableDate?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the transfer in operations. */
    id: Scalars["ID"];
    /** The ledgers affected by the transfer. */
    ledgers?: Maybe<Array<Ledger>>;
    /**
     * This field contains payment-related information provided by the originator of the transaction.
     * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
     * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
     *
     * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
     *
     * Please note that this information may or may not be displayed to the recipient, based on the bank's
     * capabilities, and method of access (i.e., online banking, statement, etc.)
     */
    paymentRelatedInformation?: Maybe<Scalars["String"]>;
    /** The date this transaction was returned, in ISO 8601 format. */
    returnDate?: Maybe<Scalars["String"]>;
    /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
    settlementDate?: Maybe<Scalars["String"]>;
    /** The status of the integrator initiated ACH transfer. */
    status?: Maybe<IntegratorInitiatedAchStatusDetails>;
    /**
     * The account receiving the funds.
     *
     * Exactly one of fromFinancialAccount and toFinancialAccount will be an `ExternalFinancialBankAccount` and the other will be a `FinancialAccount`.
     */
    toFinancialAccount?: Maybe<AllFinancialAccount>;
    /** A unique 15 digit number assigned by the originator to identify the transfer. */
    traceNumber?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the transfer was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Originated SecureDeposit transfer */
export type SecureDepositAchTransferLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** A financial event that represents secure deposit transfer. */
export type SecureDepositAchTransferEvent = AchTransferEvent &
  Node & {
    __typename?: "SecureDepositACHTransferEvent";
    /** The amount of the transfer. */
    amount?: Maybe<Amount>;
    /** Company entered value for the type of ACH. */
    companyEntryDescription?: Maybe<Scalars["String"]>;
    /**
     * The Company Identifier is a 10-position alphameric code used to identify an Originator of the ACH transaction. It may begin with an ANSI one-digit Identification Code Designator (ICD), followed by the Identification Number.
     *
     * |`Identification Code Designator (ICD)`    | `ANSI Identification Number` | Example                                                                         |
     * | ---------------------------------------- | ---------------------------- | ------------------------------------------------------------------------------- |
     * |`IRS Employer Identification Number (EIN)`| 1                            | 1234567890 for an Originator with 234567890 EIN                                 |
     * |`Data Universal Numbering Systems (DUNS)` | 3                            | 30008016958 for an Originator with 0008016958 DUNS                              |
     * |`User Assigned Number`                    | 9                            | 9111111111 for an Originator with 111111111 under assigned Identification Number|
     */
    companyIdentifier?: Maybe<Scalars["String"]>;
    /** The name of the company that initiated the ACH transfer. */
    companyName?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the transfer event was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The account sending the funds. */
    fromFinancialAccount?: Maybe<ExternalFinancialBankAccount>;
    /** Global ID used to reference the transfer in operations. */
    id: Scalars["ID"];
    /** The date this transaction was returned, in ISO 8601 format. */
    returnDate?: Maybe<Scalars["String"]>;
    /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
    settlementDate?: Maybe<Scalars["String"]>;
    /** The status of the integrator initiated ACH transfer. */
    status?: Maybe<IntegratorInitiatedAchStatusDetails>;
    /** The account receiving the funds. */
    toFinancialAccount?: Maybe<FinancialAccount>;
    /** The `ElectronicFundsTransfer` that triggered this event. */
    transfer?: Maybe<ElectronicFundsTransfer>;
  };

/** The SecureDepositCanceledEvent notifies when ACH Secure Deposits are canceled. */
export type SecureDepositCanceledEvent = Node & {
  __typename?: "SecureDepositCanceledEvent";
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The ID for Highnote. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /**
   * The name of the company that initiated the ACH transfer.
   *
   * This will always be Highnote.
   */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the account sending the funds. Will always be an `ExternalFinancialBankAccount`. */
  fromFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
  fundsAvailableDate?: Maybe<Scalars["String"]>;
  /** The ID of the transaction event. This `id` can be used to later retrieve details of this `SecureDepositCanceledEvent` or correlate it with other events on this `Transaction`. */
  id: Scalars["ID"];
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
  /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
  settlementDate?: Maybe<Scalars["String"]>;
  /** The ID of the account receiving the funds. Will always be a `FinancialAccount` */
  toFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The ID of the Electronic Funds Transfer that trigger this event. */
  transactionId?: Maybe<Scalars["ID"]>;
  /**
   * The status of the ACH transfer.
   * @deprecated transfer status only needed for failed or returned events
   */
  transferStatus?: Maybe<AchTransferStatusDetails>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Permissions for a `InitiateSecureDeposit` Client Token */
export enum SecureDepositClientTokenPermission {
  /** Setting this permission will enable management of the lifecycle of a secure deposit. */
  MANAGE_SECURE_DEPOSIT = "MANAGE_SECURE_DEPOSIT",
}

/** The SecureDepositFailedEvent notifies when ACH Secure Deposits have failed to process. */
export type SecureDepositFailedEvent = Node & {
  __typename?: "SecureDepositFailedEvent";
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The ID for Highnote. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /**
   * The name of the company that initiated the ACH transfer.
   *
   * This will always be Highnote.
   */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the account sending the funds. Will always be an `ExternalFinancialBankAccount`. */
  fromFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
  fundsAvailableDate?: Maybe<Scalars["String"]>;
  /** The ID of the transaction event. This `id` can be used to later retrieve details of this `SecureDepositFailedEvent` or correlate it with other events on this `Transaction`. */
  id: Scalars["ID"];
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
  /** Additional details about why a secure deposit ACH transfer failed. */
  secureDepositACHReasonCode?: Maybe<IntegratorInitiatedAchStatusReasonCode>;
  /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
  settlementDate?: Maybe<Scalars["String"]>;
  /** The ID of the account receiving the funds. Will always be a `FinancialAccount` */
  toFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The ID of the Electronic Funds Transfer that trigger this event. */
  transactionId?: Maybe<Scalars["ID"]>;
  /**
   * The status of the ACH transfer.
   * @deprecated use secureDepositACHReasonCode instead
   */
  transferStatus?: Maybe<AchTransferStatusDetails>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The SecureDepositInitiatedEvent notifies when ACH Secure Deposits are initiated. */
export type SecureDepositInitiatedEvent = Node & {
  __typename?: "SecureDepositInitiatedEvent";
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The ID for Highnote. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /**
   * The name of the company that initiated the ACH transfer.
   *
   * This will always be Highnote.
   */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the account sending the funds. Will always be an `ExternalFinancialBankAccount`. */
  fromFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
  fundsAvailableDate?: Maybe<Scalars["String"]>;
  /** The ID of the transaction event. This `id` can be used to later retrieve details of this `SecureDepositInitiatedEvent` or correlate it with other events on this `Transaction`. */
  id: Scalars["ID"];
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
  /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
  settlementDate?: Maybe<Scalars["String"]>;
  /** The ID of the account receiving the funds. Will always be a `FinancialAccount` */
  toFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The ID of the Electronic Funds Transfer that trigger this event. */
  transactionId?: Maybe<Scalars["ID"]>;
  /**
   * The status of the ACH transfer.
   * @deprecated transfer status only needed for failed or returned events
   */
  transferStatus?: Maybe<AchTransferStatusDetails>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The SecureDepositProcessedEvent notifies when ACH Secure Deposits are finished processing. */
export type SecureDepositProcessedEvent = Node & {
  __typename?: "SecureDepositProcessedEvent";
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The ID for Highnote. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /**
   * The name of the company that initiated the ACH transfer.
   *
   * This will always be Highnote.
   */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the account sending the funds. Will always be an `ExternalFinancialBankAccount`. */
  fromFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
  fundsAvailableDate?: Maybe<Scalars["String"]>;
  /** The ID of the transaction event. This `id` can be used to later retrieve details of this `SecureDepositProcessedEvent` or correlate it with other events on this `Transaction`. */
  id: Scalars["ID"];
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
  /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
  settlementDate?: Maybe<Scalars["String"]>;
  /** The ID of the account receiving the funds. Will always be a `FinancialAccount` */
  toFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The ID of the Electronic Funds Transfer that trigger this event. */
  transactionId?: Maybe<Scalars["ID"]>;
  /**
   * The status of the ACH transfer.
   * @deprecated transfer status only needed for failed or returned events
   */
  transferStatus?: Maybe<AchTransferStatusDetails>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The SecureDepositProcessingEvent notifies when ACH Secure Deposits are processing. */
export type SecureDepositProcessingEvent = Node & {
  __typename?: "SecureDepositProcessingEvent";
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The ID for Highnote. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /**
   * The name of the company that initiated the ACH transfer.
   *
   * This will always be Highnote.
   */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the account sending the funds. Will always be an `ExternalFinancialBankAccount`. */
  fromFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
  fundsAvailableDate?: Maybe<Scalars["String"]>;
  /** The ID of the transaction event. This `id` can be used to later retrieve details of this `SecureDepositProcessingEvent` or correlate it with other events on this `Transaction`. */
  id: Scalars["ID"];
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
  /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
  settlementDate?: Maybe<Scalars["String"]>;
  /** The ID of the account receiving the funds. Will always be a `FinancialAccount` */
  toFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The ID of the Electronic Funds Transfer that trigger this event. */
  transactionId?: Maybe<Scalars["ID"]>;
  /**
   * The status of the ACH transfer.
   * @deprecated transfer status only needed for failed or returned events
   */
  transferStatus?: Maybe<AchTransferStatusDetails>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The SecureDepositReturnedEvent notifies when ACH Secure Deposits are returned. */
export type SecureDepositReturnedEvent = Node & {
  __typename?: "SecureDepositReturnedEvent";
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The ID for Highnote. */
  companyIdentifier?: Maybe<Scalars["String"]>;
  /**
   * The name of the company that initiated the ACH transfer.
   *
   * This will always be Highnote.
   */
  companyName?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The ID of the account sending the funds. Will always be an `ExternalFinancialBankAccount`. */
  fromFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The date and time, in ISO 8601 format, the transfer will be transitioned to PROCESSED and the funds are available. */
  fundsAvailableDate?: Maybe<Scalars["String"]>;
  /** The ID of the transaction event. This `id` can be used to later retrieve details of this `SecureDepositReturnedEvent` or correlate it with other events on this `Transaction`. */
  id: Scalars["ID"];
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   */
  paymentRelatedInformation?: Maybe<Scalars["String"]>;
  /** The date this transaction was returned, in ISO 8601 format. */
  returnDate?: Maybe<Scalars["String"]>;
  /** Additional details about why a secure deposit ACH transfer was returned. */
  secureDepositACHReasonCode?: Maybe<IntegratorInitiatedAchStatusReasonCode>;
  /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
  settlementDate?: Maybe<Scalars["String"]>;
  /** The ID of the account receiving the funds. Will always be a `FinancialAccount` */
  toFinancialAccountId?: Maybe<Scalars["ID"]>;
  /** The ID of the Electronic Funds Transfer that trigger this event. */
  transactionId?: Maybe<Scalars["ID"]>;
  /**
   * The status of the ACH transfer.
   * @deprecated use secureDepositACHReasonCode instead
   */
  transferStatus?: Maybe<AchTransferStatusDetails>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** A financial event that represents a non-originated secure deposit transfer. */
export type SecureDepositTransferEvent = AchTransferEvent &
  Node & {
    __typename?: "SecureDepositTransferEvent";
    /** The amount of the transfer. */
    amount?: Maybe<Amount>;
    /** Company entered value for the type of ACH. */
    companyEntryDescription?: Maybe<Scalars["String"]>;
    /**
     * The Company Identifier is a 10-position alphameric code used to identify an Originator of the ACH transaction. It may begin with an ANSI one-digit Identification Code Designator (ICD), followed by the Identification Number.
     *
     * |`Identification Code Designator (ICD)`    | `ANSI Identification Number` | Example                                                                         |
     * | ---------------------------------------- | ---------------------------- | ------------------------------------------------------------------------------- |
     * |`IRS Employer Identification Number (EIN)`| 1                            | 1234567890 for an Originator with 234567890 EIN                                 |
     * |`Data Universal Numbering Systems (DUNS)` | 3                            | 30008016958 for an Originator with 0008016958 DUNS                              |
     * |`User Assigned Number`                    | 9                            | 9111111111 for an Originator with 111111111 under assigned Identification Number|
     */
    companyIdentifier?: Maybe<Scalars["String"]>;
    /** The name of the company that initiated the ACH transfer. */
    companyName?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the transfer event was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the transfer in operations. */
    id: Scalars["ID"];
    /** The date this transaction was returned, in ISO 8601 format. */
    returnDate?: Maybe<Scalars["String"]>;
    /** The settlement date as specified by the company that initiated the ACH transfer, ISO 8601 format. */
    settlementDate?: Maybe<Scalars["String"]>;
    /** The status of the integrator initiated ACH transfer. */
    status?: Maybe<ExternallyInitiatedAchStatusDetails>;
    /** The account receiving the funds. */
    toFinancialAccount?: Maybe<FinancialAccount>;
    /** The `ElectronicFundsTransfer` that triggered this event. */
    transfer?: Maybe<ElectronicFundsTransfer>;
  };

/** Whether or not the Financial Account supports a Secured Credit Deposit funded Credit Payment Card. */
export type SecuredCreditPaymentCardFinancialAccountFeature =
  FinancialAccountFeature & {
    __typename?: "SecuredCreditPaymentCardFinancialAccountFeature";
    /** The date and time, in ISO 8601 format, the feature was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The credit limit on the `SecuredCreditPaymentCardFinancialAccountFeature` */
    creditLimit?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, the feature was effective from. */
    effectiveFrom?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective through. */
    effectiveThrough?: Maybe<Scalars["String"]>;
    /** Whether or not the feature is enabled for the Financial Account. */
    enabled?: Maybe<Scalars["Boolean"]>;
    /** The date and time, in ISO 8601 format, the feature was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Whether or not the `CardProduct` supports secured deposits. */
export type SecuredDepositCardProductFeature = CardProductFeature &
  ProductFeature & {
    __typename?: "SecuredDepositCardProductFeature";
    /** The date and time, in ISO 8601 format, the feature was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective from. */
    effectiveFrom?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective through. */
    effectiveThrough?: Maybe<Scalars["String"]>;
    /** Whether or not the feature is enabled for the `CardProduct`. */
    enabled?: Maybe<Scalars["Boolean"]>;
    /** The date and time, in ISO 8601 format, the feature was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Statement for secured deposit commercial credit card accounts */
export type SecuredDepositCommercialCreditCardFinancialAccountStatement =
  FinancialAccountStatement &
    Node & {
      __typename?: "SecuredDepositCommercialCreditCardFinancialAccountStatement";
      /** The timestamp, in ISO 8601 format, the statement was closed. */
      closedAt?: Maybe<Scalars["String"]>;
      /** The date and time, in ISO 8601 format, this was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** The credit limit at the end of the period. */
      endingCreditLimit?: Maybe<Amount>;
      /** The credit balance at the end of the period for the primary ledger. */
      endingPrimaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the end of the period for the primary ledger. */
      endingPrimaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the end of the period for the secondary ledger. */
      endingSecondaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the end of the period for the secondary ledger. */
      endingSecondaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the end of the period for the tertiary ledger. */
      endingTertiaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the end of the period for the tertiary ledger. */
      endingTertiaryDebitBalance?: Maybe<Amount>;
      /** The unique id of the `FinancialAccountStatement`. */
      id: Scalars["ID"];
      /** The timestamp, in ISO 8601 format, the statement was opened. */
      openedAt?: Maybe<Scalars["String"]>;
      /** The date, in ISO 8601 format, payment is due on end of day. */
      paymentDueOn?: Maybe<Scalars["String"]>;
      /** The date, in ISO 8601 format, the statement period ends. */
      periodEnd?: Maybe<Scalars["String"]>;
      /** The total fee credit (for example due to waiving fees) for the statement period. */
      periodFeeCredit?: Maybe<Amount>;
      /** The total from fees for the statement period. */
      periodFeesAmount?: Maybe<Amount>;
      /** The total from purchases for the statement period. */
      periodPurchasesAmount?: Maybe<Amount>;
      /** The total refunds and payments for the statement period. */
      periodRefundsAndPaymentsAmount?: Maybe<Amount>;
      /** The date, in ISO 8601 format, the statement period starts. */
      periodStart?: Maybe<Scalars["String"]>;
      /** The ledger associated with the primary balance */
      primaryLedger?: Maybe<Ledger>;
      /** History of repayments per statement */
      repaymentHistory?: Maybe<Array<CreditRepaymentStatementApplication>>;
      /** The ledger associated with the primary balance */
      secondaryLedger?: Maybe<Ledger>;
      /** The credit balance at the start of the period for the primary ledger. */
      startingPrimaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the start of the period for the primary ledger. */
      startingPrimaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the start of the period for the secondary ledger. */
      startingSecondaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the start of the period for the secondary ledger. */
      startingSecondaryDebitBalance?: Maybe<Amount>;
      /** The credit balance at the start of the period for the tertiary ledger. */
      startingTertiaryCreditBalance?: Maybe<Amount>;
      /** The debit balance at the start of the period for the tertiary ledger. */
      startingTertiaryDebitBalance?: Maybe<Amount>;
      /**
       * statement entries.
       *
       * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
       */
      statementEntries?: Maybe<FinancialAccountStatementEntryConnection>;
      /** The ledger associated with the tertiary balance */
      tertiaryLedger?: Maybe<Ledger>;
      /** The date and time, in ISO 8601 format, this was most recently updated. */
      updatedAt?: Maybe<Scalars["String"]>;
    };

/** Statement for secured deposit commercial credit card accounts */
export type SecuredDepositCommercialCreditCardFinancialAccountStatementStatementEntriesArgs =
  {
    after?: InputMaybe<Scalars["String"]>;
    filterBy?: InputMaybe<FinancialAccountStatementEntriesFilterInput>;
    first?: InputMaybe<Scalars["Int"]>;
  };

/** Statement entry for secured commercial credit card */
export type SecuredDepositCommercialCreditCardFinancialAccountStatementEntry =
  FinancialAccountStatementEntry & {
    __typename?: "SecuredDepositCommercialCreditCardFinancialAccountStatementEntry";
    /** The date and time, in ISO 8601 format, this was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Credit amount of the transaction. */
    creditAmount?: Maybe<Amount>;
    /** Debit amount of the transaction. */
    debitAmount?: Maybe<Amount>;
    /** Ledger Entry for the entry */
    ledgerEntry?: Maybe<LedgerEntry>;
    /** The date, in ISO 8601 format, the transaction was posted. (Different word for 'posted'?) */
    postDate?: Maybe<Scalars["String"]>;
    /** Credit balance of the account. */
    primaryCreditBalance?: Maybe<Amount>;
    /** Debit balance of the account. */
    primaryDebitBalance?: Maybe<Amount>;
    /** The date and time, in ISO 8601 format, this was most recently updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Current account snapshot for a secured deposit commercial credit card */
export type SecuredDepositCommercialCreditCardFinancialAccountStatementSnapshot =
  FinancialAccountStatementSnapshot & {
    __typename?: "SecuredDepositCommercialCreditCardFinancialAccountStatementSnapshot";
    /**
     * The date and time, in ISO 8601 format, the snapshot was calculated.
     * Note that this will be the date/time of the last impactful event.
     */
    asOf?: Maybe<Scalars["String"]>;
    /** The ending balance from the `latestClosedStatement`, minus any payments that have been cleared and processed. */
    currentAmountDue?: Maybe<Amount>;
    /** The current open statement */
    currentOpenStatement?: Maybe<FinancialAccountStatement>;
    /** The most recently closed statement */
    latestClosedStatement?: Maybe<FinancialAccountStatement>;
    /** The date and time, in ISO 8601 format, this was most recently updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** Whether or not the `FinancialAccount` supports secured deposits. */
export type SecuredDepositFinancialAccountFeature = FinancialAccountFeature & {
  __typename?: "SecuredDepositFinancialAccountFeature";
  /** The date and time, in ISO 8601 format, the feature was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective from. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective through. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Whether or not the feature is enabled for the Financial Account. */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** The date and time, in ISO 8601 format, the feature was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Specify intended POS behavior for card */
export enum ServiceCode {
  /** International use EMV chip card. */
  INTERNATIONAL_ICC_NORMAL_NO_RESTRICTION = "INTERNATIONAL_ICC_NORMAL_NO_RESTRICTION",
  /** International use magnetic stripe card. */
  INTERNATIONAL_NORMAL_NO_RESTRICTION = "INTERNATIONAL_NORMAL_NO_RESTRICTION",
  /** Magnetic stripe only card. */
  NATIONAL_NORMAL_NO_RESTRICTION = "NATIONAL_NORMAL_NO_RESTRICTION",
}

/** The Servicemembers Civil Relief Act (SCRA) configuration. */
export type ServicemembersCivilReliefActConfiguration = {
  __typename?: "ServicemembersCivilReliefActConfiguration";
  /** The start date of active duty, in YYYY-MM-DD (ISO 8601 RFC 3339) date format. For example, `2023-01-15`. */
  activeDutyFrom?: Maybe<Scalars["Date"]>;
  /**
   * The end date of active duty, in YYYY-MM-DD (ISO 8601 RFC 3339) date format. For example, `2023-01-15`.
   *   Optional; if not present, active duty is treated as indefinite, with no set ending. Cannot be in the past. Must be after `activeDutyFromDate`.
   */
  activeDutyThrough?: Maybe<Scalars["Date"]>;
  /** The date and time, in ISO 8601 format, this was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The start date for this configuration, in YYYY-MM-DD (ISO 8601 RFC 3339) date format. For example, `2023-01-15`. */
  effectiveFrom?: Maybe<Scalars["Date"]>;
  /** The end date for this configuration, in YYYY-MM-DD (ISO 8601 RFC 3339) date format. For example, `2023-01-15`. Optional; if not present, this configuration is treated as indefinite, with no set end date. */
  effectiveThrough?: Maybe<Scalars["Date"]>;
  /** The status of this configuration. For example, `PENDING`, `APPROVED`, or `REJECTED`. */
  status?: Maybe<ServicemembersCivilReliefActStatus>;
  /** The date and time when this was updated, in ISO 8601 format. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** Possible status values for a `ServicemembersCivilReliefActConfiguration`. */
export enum ServicemembersCivilReliefActStatus {
  APPROVED = "APPROVED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

/** Input for setting the email for a notification target. */
export type SetEmailForNotificationTargetInput = {
  /** The email address to which target deactivation emails are sent. */
  email: Scalars["String"];
  /** The notification target ID. */
  targetId: Scalars["ID"];
};

/** The return types when setting the email for a notification target. */
export type SetEmailForNotificationTargetPayload =
  | AccessDeniedError
  | UserError
  | WebhookNotificationTarget;

/** Input fields for setting the pin on a payment card */
export type SetPinForPaymentCardInput = {
  /** New pin to set on the payment card. Must be 4 digits in length. */
  newPin: Scalars["String"];
  /** Id of the payment card. */
  paymentCardId: Scalars["ID"];
};

/** Types which can be returned when setting the pin on a payment card */
export type SetPinForPaymentCardPayload =
  | AccessDeniedError
  | PaymentCard
  | UserError;

/**
 * Input for setting an absolute spending limit on a pseudo balance.
 * Replaces the current limit with a new fixed amount.
 */
export type SetPseudoLimitInput = {
  /**
   * The new absolute limit amount for the pseudo balance.
   * This replaces any existing limit.
   */
  amount: AmountInput;
  /** Allows setting a new pseudo balance cadence, how often to reset the pseudo balance. */
  cadence?: InputMaybe<PseudoBalanceCadence>;
  /** The ID of the `FinancialAccount` whose pseudo balance limit should be set. */
  financialAccountId: Scalars["ID"];
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["String"]>;
  /**
   * Whether to reset the available balance to the pseudo balance limit.
   * - true: The available balance will be reset to the value defined as the pseudo balance limit at the start of the new period.
   * - false: The current balance carries over to the new period (useful for rolling balances when resetting cadence).
   */
  resetAvailableBalance: Scalars["Boolean"];
  /**
   * An ISO 8601 formatted timestamp that determines when and how often the balance resets.
   * The date and time components are used differently based on the selected cadence. See `PseudoBalanceCadence` for more details.
   *
   * If not specified, the current reset time is preserved.
   *
   * If no existing reset time exists, then the value will default depending on the cadence. See `PseudoBalanceCadence` for more details on the default value.
   */
  resetTime?: InputMaybe<Scalars["String"]>;
};

export type SetPseudoLimitPayload =
  | AccessDeniedError
  | InterFinancialAccountTransfer
  | UserError;

/** Money value type the allows for positive or negative values */
export type SignedMoneyFilterInput = {
  /** Filter to values that fall between the provided `Ints`. */
  between?: InputMaybe<SignedMoneyFilterInputRange>;
  currencyCode: Iso4217Alpha3CurrencyCode;
  /** A value that exactly matches the provided `Int`. */
  equals?: InputMaybe<Scalars["Int"]>;
  /** Filter to values that do not match any of the provided `Ints`. */
  excludes?: InputMaybe<Array<Scalars["Int"]>>;
  /** A value to filter to numbers greater than the given `Int`. */
  greaterThan?: InputMaybe<Scalars["Int"]>;
  /** A value to filter to numbers greater than or equal to the given `Int`. */
  greaterThanOrEquals?: InputMaybe<Scalars["Int"]>;
  /** Filter to values that exactly match any of the provided `Ints`. */
  includes?: InputMaybe<Array<Scalars["Int"]>>;
  /** A value to filter to numbers less than the given `Int`. */
  lessThan?: InputMaybe<Scalars["Int"]>;
  /** A value to filter to numbers less than or equal to the given `Int`. */
  lessThanOrEquals?: InputMaybe<Scalars["Int"]>;
  /** A value that does not exactly match the provided `Int`. */
  notEquals?: InputMaybe<Scalars["Int"]>;
};

/** Money value range (inclusive) */
export type SignedMoneyFilterInputRange = {
  /** An `Int` value (inclusive) for the end of the range. */
  end?: InputMaybe<Scalars["Int"]>;
  /** An `Int` value (inclusive) for the beginning of the range. */
  start?: InputMaybe<Scalars["Int"]>;
};

/** A key used to sign the notification payload. */
export type SigningKey = Node & {
  __typename?: "SigningKey";
  /** The date and time, in ISO 8601 format, this was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /**
   * Expiration date and time, in ISO 8601 format, for this key.
   * If this is set, it means that the `rotateNotificationTargetSigningKey` mutation was called for this key's target.
   */
  expiresAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the SigningKey in operations. */
  id: Scalars["ID"];
  /** The shared secret to use to verify a notification payload. */
  secret?: Maybe<Scalars["String"]>;
};

/** Input details when simulating the processing of an `OriginatedAchTransfer` or `NonOriginatedAchTransfer`. */
export type SimulateAchTransferProcessingInput = {
  /** The Global ID of the `NonOriginatedAchTransfer` to simulate processing. */
  id: Scalars["ID"];
};

/** The return types when simulating the processing of an `OriginatedAchTransfer` or `NonOriginatedAchTransfer`. */
export type SimulateAchTransferProcessingPayload =
  | AccessDeniedError
  | NonOriginatedAchTransfer
  | OriginatedAchTransfer
  | UserError;

/** Input details when simulating the return of an `OriginatedAchTransfer` or `NonOriginatedAchTransfer`. */
export type SimulateAchTransferReturnInput = {
  /** The Global ID of the ACH transfer to simulate processing. */
  id: Scalars["ID"];
  /** Additional details about why the `OriginatedAchTransfer` or `NonOriginatedAchTransfer` was returned. */
  statusFailureReason: AchTransferStatusFailureReason;
};

/** The return types when simulating the return of an `OriginatedAchTransfer` or `NonOriginatedAchTransfer`. */
export type SimulateAchTransferReturnPayload =
  | AccessDeniedError
  | NonOriginatedAchTransfer
  | OriginatedAchTransfer
  | UserError;

/** Simulate network specific transaction data. */
export type SimulateAdditionalNetworkDataInput = {
  /** Simulate Mastercard network specific transaction data. */
  mastercard?: InputMaybe<SimulateMastercardAdditionalNetworkDataInput>;
  /** Simulate Visa network specific transaction data. */
  visa?: InputMaybe<SimulateVisaAdditionalNetworkDataInput>;
};

/** Details to simulate an adjustment event for a transaction. */
export type SimulateAdjustmentInput = {
  /** The `Amount` of the Authorization to clear. Cannot be above the total amount of the related Authorizations. */
  amount: AmountInput;
  /** The `transactionId` from the original `ClearingEvent` or 'AuthorizationAndClearEvent'. */
  transactionId: Scalars["ID"];
  /** The type of Adjustment being simulated, should be `ADJUSTMENT_CREDIT` or `ADJUSTMENT_DEBIT`. */
  transactionProcessingType: CardTransactionProcessingType;
};

export type SimulateAdjustmentPayload =
  | AccessDeniedError
  | AdjustmentEvent
  | UserError;

/** An input representing the parts of a simulated update to review status on a previously created AccountHolderApplicationDocument. */
export type SimulateApplicationDocumentReviewInput = {
  /** The ID of the application containing the document to be reviewed. */
  applicationId: Scalars["ID"];
  /** The ID for a `DocumentUploadLink` returned by `createDocumentUploadLink`. This ID represents an `AccountHolderApplicationDocument` and serves to specify the document being reviewed. */
  documentUploadLinkId: Scalars["ID"];
  /**
   * The ID for an initiated `DocumentUploadSession` containing the document to be reviewed.
   *
   * Expected format: `du_*` (use `documentUploadSession.id`)
   */
  documentUploadSessionId: Scalars["ID"];
  /** The given reasons for the file review status. */
  fileReviewReasons?: InputMaybe<Array<ApplicationDocumentReviewReason>>;
  /** The target status representing the decision made by an Agent after reviewing the applicant's uploaded document. */
  newReviewStatus: ApplicationDocumentUploadStatus;
};

/** Response type for a simulated update to an `ApplicationDocument`. */
export type SimulateApplicationDocumentReviewPayload =
  | AccessDeniedError
  | AccountHolderApplicationDocument
  | UserError;

/** The possible return types of `SimulateApplicationManualReviewPayload`. */
export type SimulateApplicationManualReviewPayload =
  | AccessDeniedError
  | AccountHolderCardProductApplication
  | UserError;

/** An input representing the parts of a simulated update to application status on a previously created Card Product Application. */
export type SimulateApplicationStatusChangeInput = {
  /** The ID of the application to be updated. */
  applicationId: Scalars["ID"];
  /** The target application status for the specified application representing the outcome of manual identity review by an Agent. */
  newApplicationStatus: AccountHolderApplicationStatusCode;
};

/** Response type for a simulated update to an `AccountHolderCardProductApplication`. */
export type SimulateApplicationUpdatePayload =
  | AccessDeniedError
  | AccountHolderCardProductApplication
  | UserError;

/** An input representing the parts of a simulated update to verification status for an Account Holder on a previously created Card Product Application. */
export type SimulateApplicationVerificationStatusChangeInput = {
  /** The ID of the applicant whose verification status will be updated. */
  applicantId: Scalars["ID"];
  /** The ID of the application containing the applicant whose verification status will be updated. */
  applicationId: Scalars["ID"];
  /** The target verification status for the specified applicant representing the outcome of manual identity review by an Agent. */
  newVerificationStatus: AccountHolderVerificationStatusReasonCode;
};

export type SimulateAuthAndClearPayload =
  | AccessDeniedError
  | AuthorizationAndClearEvent
  | UserError;

export type SimulateAuthorizationAdvicePayload =
  | AccessDeniedError
  | AuthorizationEvent
  | ReversalEvent
  | UserError;

/** Details to simulate the authorization. */
export type SimulateAuthorizationInput = {
  /** Simulate network specific transaction data. */
  additionalNetworkData?: InputMaybe<SimulateAdditionalNetworkDataInput>;
  /** The `Amount` of the authorization provided as per the specifications of the given currency. */
  amount: AmountInput;
  /** The ID of the payment card to be used. */
  cardId: Scalars["ID"];
  /** The `Amount` of cashback requested during the transaction. */
  cashbackAmount?: InputMaybe<AmountInput>;
  /** Optionally simulate fees applied to the transaction. */
  fees?: InputMaybe<Array<TransactionFeeInput>>;
  /**
   * The optional ID of a previous authorization.
   *
   * Typically, this is only used to simulate "incremental authorization".
   */
  id?: InputMaybe<Scalars["ID"]>;
  /**
   * Details to set about a Merchant submitting the authorization.
   *
   * You can use these details to test merchant specific spend rules.
   */
  merchantDetails?: InputMaybe<MerchantDetailsInput>;
  /** The Point Of Service Details Input. */
  pointOfServiceDetails?: InputMaybe<PointOfServiceDetailsInput>;
  /** Represents the customer transaction type being processed. */
  transactionProcessingType?: InputMaybe<CardTransactionProcessingType>;
  /** Details to override about a `PaymentCard` or card holder to test Spend Control Rules. */
  verificationOverrides?: InputMaybe<VerificationOverridesInput>;
};

export type SimulateAuthorizationPayload =
  | AccessDeniedError
  | AuthorizationEvent
  | UserError;

/** Input fields for shifting the current statement period backward and aging the Financial Account. */
export type SimulateBackwardShiftAndAgeCurrentFinancialAccountStatementPeriodInput =
  {
    /** `FinancialAccount` id */
    financialAccountId: Scalars["ID"];
    /** The number of billing cycles to shift the current statement backward. */
    numberOfCyclesToShiftCurrentStatementBackward: Scalars["UnsignedInt"];
  };

/** Input to simulate a card digital wallet token activation. */
export type SimulateCardDigitalWalletTokenActivatedInput = {
  /** The ID of the card digital wallet token to be activated. */
  cardDigitalWalletTokenId: Scalars["ID"];
};

/** Input to simulate a card digital wallet token activation. */
export type SimulateCardDigitalWalletTokenActivationInput = {
  /** The ID of the payment card to create digital wallet token. */
  paymentCardId: Scalars["ID"];
  /** The requester identifier assigned to a Digital Wallet Token. If none provided we would default it to requester identifier of Google Pay. */
  requesterIdentifier?: InputMaybe<Scalars["String"]>;
  /** The Card Digital Wallet Token source entry method. If none provided then we would default it to `MANUAL_ENTRY`. */
  sourceEntryMethod?: InputMaybe<CardDigitalWalletTokenSourceEntryMethod>;
  /** The Card Digital Wallet Token type. If none provided then we would default it to `DEVICE_SECURE_ELEMENT`. */
  tokenType?: InputMaybe<CardDigitalWalletTokenType>;
};

/** Simulate card digital wallet token payload. */
export type SimulateCardDigitalWalletTokenPayload =
  | AccessDeniedError
  | CardDigitalWalletToken
  | UserError;

export type SimulateCheckPaymentEventChangePayload =
  | AccessDeniedError
  | CheckPayment
  | UserError;

/** The input for `simulateCheckPaymentEvent`. This will trigger a webhook. */
export type SimulateCheckPaymentEventInput = {
  /** The event to update the `CheckPayment` to. */
  checkEventType: CheckPaymentEventType;
  /** The `CheckPayment` ID to simulate a `CheckPaymentEvent`. */
  checkPaymentId: Scalars["ID"];
};

/** Details to simulate the clearing. */
export type SimulateClearingInput = {
  /** Simulate network specific transaction data. */
  additionalNetworkData?: InputMaybe<SimulateAdditionalNetworkDataInput>;
  /** The `Amount` of the Authorization to clear. Cannot be above the total amount of the related Authorizations. */
  amount?: InputMaybe<AmountInput>;
  /** The `Amount` of cashback to be cleared. */
  cashbackAmount?: InputMaybe<AmountInput>;
  /** Optionally simulate fees applied to the transaction. */
  fees?: InputMaybe<Array<TransactionFeeInput>>;
  /** Details to set about a Merchant submitting the clearing. */
  merchantDetails?: InputMaybe<MerchantDetailsInput>;
  /** The Point Of Service Details Input. */
  pointOfServiceDetails?: InputMaybe<PointOfServiceDetailsInput>;
  /** The `transactionId` from the original `AuthorizationEvent`. */
  transactionId: Scalars["ID"];
  /** Represents the customer transaction type being processed. */
  transactionProcessingType?: InputMaybe<CardTransactionProcessingType>;
};

export type SimulateClearingPayload =
  | AccessDeniedError
  | ClearingEvent
  | UserError;

/** Details for simulating `FinancialAccount` closure. */
export type SimulateCloseFinancialAccountInput = {
  /** The ID of the `FinancialAccount` to move into `CLOSED` status. */
  financialAccountId: Scalars["ID"];
};

/** The return types for `simulateCloseFinancialAccount` */
export type SimulateCloseFinancialAccountPayload =
  | AccessDeniedError
  | FinancialAccount
  | UserError;

/** Simulated fee schedule input. */
export type SimulateCreateAndActivateFeeScheduleInput = {
  /** Fee schedule associated to a card product. */
  cardProductId: Scalars["ID"];
  /** Fee configuration details about activity and fee amount to be charged. */
  feeConfigurations?: InputMaybe<Array<SimulateFeeConfigurationInput>>;
};

/** Response type for simulate create fee schedule. */
export type SimulateCreateAndActivateFeeSchedulePayload =
  | AccessDeniedError
  | FeeSchedule
  | UserError;

/** Input for simulate creating application documents upload sessions. */
export type SimulateCreateApplicationDocumentsUploadSessionsInput = {
  /** The ID of the application. */
  applicationId: Scalars["ID"];
  /** The memo of the manual review. */
  memo?: InputMaybe<Scalars["String"]>;
  /** The requested documents for each applicant. */
  requestedDocuments?: InputMaybe<Array<RequestedDocuments>>;
};

/** The details to simulate a electronic fund transfer in the test environment. */
export type SimulateDepositInput = {
  /** The amount to add to an Organization's account. */
  amount: AmountInput;
  /** A description of the transfer for later reference. */
  memo?: InputMaybe<Scalars["String"]>;
  /** Source used for fund transfer. */
  source: ElectronicFundTransferSource;
  /** The ID of the Organization's Financial Account for transfer. */
  toFinancialAccountId: Scalars["ID"];
};

/**
 * The return types when simulating electronic funds transfers into an Organization's account.
 *
 * WARNING: Transfer is deprecated. ElectronicFundsTransfer should be used instead.
 */
export type SimulateDepositPayload =
  | AccessDeniedError
  | Transfer
  | UserError
  | WireTransfer;

/** Details to simulate authorization using a digital wallet token. */
export type SimulateDigitalWalletTokenAuthorizationInput = {
  /** Simulate network specific transaction data. */
  additionalNetworkData?: InputMaybe<SimulateAdditionalNetworkDataInput>;
  /** The `Amount` of the authorization provided as per the specifications of the given currency. */
  amount: AmountInput;
  /** The digital wallet token details to be simulated for this authorization. */
  cardDigitalWalletTokenDetails?: InputMaybe<CardDigitalWalletTokenDetailsInput>;
  /** The digital wallet token identifier to use for this authorization. */
  cardDigitalWalletTokenId: Scalars["ID"];
  /** The `Amount` of cashback requested during the transaction. */
  cashbackAmount?: InputMaybe<AmountInput>;
  /** Optionally simulate fees applied to the transaction. */
  fees?: InputMaybe<Array<TransactionFeeInput>>;
  /**
   * The optional ID of a previous authorization.
   *
   * Typically, this is only used to simulate "incremental authorization".
   */
  id?: InputMaybe<Scalars["ID"]>;
  /**
   * Details to set about a Merchant submitting the authorization.
   *
   * You can use these details to test merchant specific spend rules.
   */
  merchantDetails?: InputMaybe<MerchantDetailsInput>;
  /** The Point Of Service Details Input. */
  pointOfServiceDetails?: InputMaybe<PointOfServiceDetailsInput>;
  /** Represents the customer transaction type being processed. */
  transactionProcessingType?: InputMaybe<CardTransactionProcessingType>;
  /** Details to override about a `PaymentCard` or card holder to test Spend Control Rules. */
  verificationOverrides?: InputMaybe<VerificationOverridesInput>;
};

/** Details to simulate a Mastercard Fleet authorization using a digital wallet token. */
export type SimulateDigitalWalletTokenMastercardFleetAuthorizationInput = {
  /** Simulate network specific transaction data. */
  additionalNetworkData?: InputMaybe<SimulateAdditionalNetworkDataInput>;
  /** The `Amount` of the authorization provided as per the specifications of the given currency. */
  amount: AmountInput;
  /** The digital wallet token details to be simulated for this authorization. */
  cardDigitalWalletTokenDetails?: InputMaybe<CardDigitalWalletTokenDetailsInput>;
  /** The digital wallet token identifier to use for this authorization. */
  cardDigitalWalletTokenId: Scalars["ID"];
  /** Optionally simulate fees applied to the transaction. */
  fees?: InputMaybe<Array<TransactionFeeInput>>;
  /** Fleet specific details for this authorization. */
  fleetAuthorizationData?: InputMaybe<SimulateMastercardFleetAuthorizationDataInput>;
  /**
   * Details to set about a Merchant submitting the authorization.
   *
   * You can use these details to test merchant specific spend rules.
   */
  merchantDetails?: InputMaybe<MerchantDetailsInput>;
  /** The Point Of Service Details Input. */
  pointOfServiceDetails?: InputMaybe<PointOfServiceDetailsInput>;
  /** Details to override about a `PaymentCard` or card holder to test Spend Control Rules. */
  verificationOverrides?: InputMaybe<VerificationOverridesInput>;
};

/** Details to simulate authorization and clear using a digital wallet token. */
export type SimulateDigitalWalletTokenSingleStepAuthAndClearInput = {
  /** Simulate network specific transaction data. */
  additionalNetworkData?: InputMaybe<SimulateAdditionalNetworkDataInput>;
  /** The `Amount` of the authorization provided as per the specifications of the given currency. */
  amount: AmountInput;
  /** The digital wallet token details to be simulated for this transaction. */
  cardDigitalWalletTokenDetails?: InputMaybe<CardDigitalWalletTokenDetailsInput>;
  /** The digital wallet token identifier to use for this transaction. */
  cardDigitalWalletTokenId: Scalars["ID"];
  /** The `Amount` of cashback requested during the transaction. */
  cashbackAmount?: InputMaybe<AmountInput>;
  /** Optionally simulate fees applied to the transaction. */
  fees?: InputMaybe<Array<TransactionFeeInput>>;
  /**
   * Details to set about a Merchant submitting the authorization.
   *
   * You can use these details to test merchant specific spend rules.
   */
  merchantDetails?: InputMaybe<MerchantDetailsInput>;
  /** The Point Of Service Details Input. */
  pointOfServiceDetails?: InputMaybe<PointOfServiceDetailsInput>;
  /** Represents the customer transaction type being processed. */
  transactionProcessingType?: InputMaybe<CardTransactionProcessingType>;
  /** Details to override about a `PaymentCard` or card holder to test Spend Control Rules. */
  verificationOverrides?: InputMaybe<VerificationOverridesInput>;
};

/** Details to simulate a Visa Fleet authorization using a digital wallet token. Allows for partial authorizations. */
export type SimulateDigitalWalletTokenVisaFleetAuthorizationInput = {
  /** Simulate network specific transaction data. */
  additionalNetworkData?: InputMaybe<SimulateAdditionalNetworkDataInput>;
  /** The `Amount` of the authorization provided as per the specifications of the given currency. */
  amount: AmountInput;
  /** The digital wallet token details to be simulated for this authorization. */
  cardDigitalWalletTokenDetails?: InputMaybe<CardDigitalWalletTokenDetailsInput>;
  /** The digital wallet token identifier to use for this authorization. */
  cardDigitalWalletTokenId: Scalars["ID"];
  /** Optionally simulate fees applied to the transaction. */
  fees?: InputMaybe<Array<TransactionFeeInput>>;
  /** Fleet specific details for this authorization. */
  fleetAuthorizationData?: InputMaybe<SimulateVisaFleetAuthorizationDataInput>;
  /**
   * The optional ID of a previous authorization.
   *
   * Typically, this is only used to simulate "incremental authorization".
   */
  id?: InputMaybe<Scalars["ID"]>;
  /**
   * Details to set about a Merchant submitting the authorization.
   *
   * You can use these details to test merchant specific spend rules.
   */
  merchantDetails?: InputMaybe<MerchantDetailsInput>;
  /** The Point Of Service Details Input. */
  pointOfServiceDetails?: InputMaybe<PointOfServiceDetailsInput>;
  /** Represents the customer transaction type being processed. */
  transactionProcessingType?: InputMaybe<CardTransactionProcessingType>;
  /** Details to override about a `PaymentCard` or card holder to test Spend Control Rules. */
  verificationOverrides?: InputMaybe<VerificationOverridesInput>;
};

export type SimulateEnhancedDataPayload =
  | AccessDeniedError
  | EnhancedDataEvent
  | UserError;

/**
 * Input for creating a new simulated `ExternallyInitiatedACHTransfer`.
 *
 * This is used only for testing.
 */
export type SimulateExternallyInitiatedAchTransferInput = {
  /**
   * The amount of money being transferred.
   * If not specified, it will be populated as `USD 1000`
   */
  amount?: InputMaybe<AmountInput>;
  /**
   * Arbitrary value describing the transfer entered by the simulated external organization.
   *
   * It can be up to 10 alphanumeric characters.
   * If not specified, it will be populated as `ENTRYDSCPT`
   */
  companyEntryDescription?: InputMaybe<Scalars["String"]>;
  /**
   * The identifier of the simulated external organization initiating the transfer.
   *
   * It can be up to 10 alphanumeric characters.
   * If not specified, it will be populated as `1234567890`
   */
  companyIdentifier?: InputMaybe<Scalars["String"]>;
  /**
   * The name of the simulated external organization initiating the transfer.
   *
   * It can be up to 16 alphanumeric characters.
   * If not specified, it will be populated as `THESAMPLECOMPANY`
   */
  companyName?: InputMaybe<Scalars["String"]>;
  /** The internal `FinancialAccount` involved in the transfer. */
  financialAccountId: Scalars["ID"];
  /**
   * The identification number of the simulated external party initiating the transfer.
   *
   * This could be either a business or an individual. It can be up to 15 alphanumeric characters.
   * If not specified, it will be populated as `RECEIVER_NUMBER`
   */
  individualIdentificationNumber?: InputMaybe<Scalars["String"]>;
  /**
   * The name of the simulated external party initiating the transfer.
   *
   * This could be either a business or an individual. It can be up to 22 alphanumric characters.
   * If not specified, it will be populated as `THISISTHERECIEVEROFACH`
   */
  individualName?: InputMaybe<Scalars["String"]>;
  /** Settlement date in YYYY-MM-DD format. If not specified, current date will be used. */
  settlementDate?: InputMaybe<Scalars["String"]>;
  /**
   * Transfer type denoting the direction of the money, either into or out of the `FinancialAccount`.
   * If not specified, it will be populated as `CREDIT`
   */
  transferType?: InputMaybe<TransferType>;
};

/** Simulated fee configuration input. */
export type SimulateFeeConfigurationInput = {
  /** The activity for which the fee is charged. */
  feeActivityType: FeeTransferEventFeeActivityTypeInput;
  /** Fee amount to be charged. */
  feeAmount: SimulatedFeeAmountInput;
};

/** Input for `simulateFinalizeProvisionalCreditForCardTransactionDispute`. */
export type SimulateFinalizeProvisionalCreditForCardTransactionDisputeInput = {
  /** The amount to finalize the provisional credit. */
  amount: AmountInput;
  /** The ID of the dispute. */
  id: Scalars["ID"];
  /**
   * Indicates whether the Issuer or Merchant is liable for the dispute.
   * Defaults to MERCHANT_LIABLE if not specified.
   */
  liability?: InputMaybe<PaymentCardDisputeLiability>;
};

/** Types which can be returned for simulating account aging. */
export type SimulateFinancialAccountAgingPayload =
  | AccessDeniedError
  | FinancialAccount
  | UserError;

/** Types which can be returned for simulating statement period shift and rollover */
export type SimulateFinancialAccountStatementPayload =
  | AccessDeniedError
  | FinancialAccount
  | UserError;

/** Input for `simulateInitiateCardTransactionChargeback`. */
export type SimulateInitiateCardTransactionChargebackInput = {
  /** The requested amount. */
  amount: AmountInput;
  /** The ID of the dispute. */
  disputeId: Scalars["ID"];
};

/** Input for `simulateInitiateCardTransactionDispute`. */
export type SimulateInitiateCardTransactionDisputeInput = {
  /** The disputed amount. */
  amount: AmountInput;
  /** The ID of the transaction event (AuthorizationAndClearEvent or ClearingEvent). */
  cardTransactionEventId: Scalars["ID"];
  /** The category type of the dispute. */
  category: PaymentCardDisputeCategoryType;
};

/** Details for simulating initiation of `FinancialAccount` closure. */
export type SimulateInitiateFinancialAccountClosureInput = {
  /**
   * Whether to close the financial account with a balance.
   * A value of `true` is only allowed for accounts with at least one credit `FinancialAccountFeature` (such as `CreditCardAccountFeature`) enabled.
   */
  closeWithBalance?: InputMaybe<Scalars["Boolean"]>;
  /** The ID of the `FinancialAccount` to move into `PENDING_CLOSURE` status. */
  financialAccountId: Scalars["ID"];
};

/** The return types for `simulateInitiateFinancialAccountClosure` */
export type SimulateInitiateFinancialAccountClosurePayload =
  | AccessDeniedError
  | FinancialAccount
  | UserError;

/** Input for `simulateIssueCreditForCardTransactionDispute`. */
export type SimulateIssueCreditForCardTransactionDisputeInput = {
  /** The ID of the dispute. */
  id: Scalars["ID"];
  /** Indicates whether the Issuer or Merchant is liable for the dispute. */
  liability?: InputMaybe<PaymentCardDisputeLiability>;
};

/** Input for `simulateIssueProvisionalCreditForCardTransactionDispute`. */
export type SimulateIssueProvisionalCreditForCardTransactionDisputeInput = {
  /** The ID of the chargeback. */
  chargebackId: Scalars["ID"];
  /** The ID of the dispute. */
  id: Scalars["ID"];
};

/** Details about the fuel location used in a fleet transaction. */
export type SimulateMastercardAdditionalFuelLocationDetailsInput = {
  /** This fuel location has alternative fuel pumps. */
  alternativeFuel?: InputMaybe<Scalars["Boolean"]>;
  /** This fuel location has an aviation location. */
  aviationLocation?: InputMaybe<Scalars["Boolean"]>;
  /** This fuel location has a convenience store. */
  convenienceStore?: InputMaybe<Scalars["Boolean"]>;
  /** This fuel location has diesel sites. */
  dieselSites?: InputMaybe<Scalars["Boolean"]>;
  /** This fuel location has access for 18 wheelers. */
  eighteenWheelerAccess?: InputMaybe<Scalars["Boolean"]>;
  /** This fuel location has a hotel. */
  hotel?: InputMaybe<Scalars["Boolean"]>;
  /** This fuel location has interstate highway access. */
  interstateAccess?: InputMaybe<Scalars["Boolean"]>;
  /** This fuel location has a marina location. */
  marinaLocation?: InputMaybe<Scalars["Boolean"]>;
  /** This fuel location is open 24 hours. */
  openTwentyFourHours?: InputMaybe<Scalars["Boolean"]>;
  /** This fuel location has pay-at-pump support. */
  payAtPump?: InputMaybe<Scalars["Boolean"]>;
  /** This fuel location has repair bays. */
  repairBays?: InputMaybe<Scalars["Boolean"]>;
  /** This fuel location has a restaurant. */
  restaurant?: InputMaybe<Scalars["Boolean"]>;
  /** This fuel location has showers. */
  showers?: InputMaybe<Scalars["Boolean"]>;
  /** This fuel location has a vehicle washing station. */
  vehicleWash?: InputMaybe<Scalars["Boolean"]>;
};

/** Simulate Mastercard network specific transaction data. */
export type SimulateMastercardAdditionalNetworkDataInput = {
  /** Validation result for Mastercard's Accountholder Authentication Value. */
  aavResultCode?: InputMaybe<MastercardAavResultCode>;
  /** A number used by Mastercard to identify the acquiring institution. */
  acquiringInstitutionIdentificationCode?: InputMaybe<Scalars["String"]>;
  /** The fraud score for the transaction provided by Mastercard. Values are between 0-999. */
  fraudScore?: InputMaybe<Scalars["UnsignedInt"]>;
  /**
   * Payment facilitator identifier for the transaction.
   * **Maximum length:** 11
   */
  paymentFacilitatorIdentifier?: InputMaybe<Scalars["String"]>;
  /** Information about the 3DSecure Cardholder Authentication. */
  threeDSecureCardholderAuthentication?: InputMaybe<MastercardThreeDSecureCardholderAuthentication>;
  /** Information about the collection capabilities of the Universal Cardholder Authentication Field. */
  ucafCollectionIndicator?: InputMaybe<MastercardUcafCollectionIndicator>;
};

/** Details to simulate the authorization advice of a Mastercard Fleet transaction. */
export type SimulateMastercardFleetAuthorizationAdviceInput = {
  /** Simulate network specific transaction data. */
  additionalNetworkData?: InputMaybe<SimulateAdditionalNetworkDataInput>;
  /** The `Amount` of the Authorization to clear. Cannot be above the total amount of the related Authorizations. */
  amount: AmountInput;
  /** Optionally simulate fees applied to the transaction. */
  fees?: InputMaybe<Array<TransactionFeeInput>>;
  /** Fleet specific details for this authorization. */
  fleetAuthorizationData?: InputMaybe<SimulateMastercardFleetAuthorizationDataInput>;
  /**
   * Details to set about a Merchant submitting the authorization.
   *
   * You can use these details to test merchant specific spend rules.
   */
  merchantDetails?: InputMaybe<MerchantDetailsInput>;
  /** The Point Of Service Details Input. */
  pointOfServiceDetails?: InputMaybe<PointOfServiceDetailsInput>;
  /** The `transactionId` from the original `AuthorizationEvent`. */
  transactionId: Scalars["ID"];
  /** Details to override about a `PaymentCard` or card holder to test Spend Control Rules. */
  verificationOverrides?: InputMaybe<VerificationOverridesInput>;
};

/** Details of a Mastercard Fleet fuel product available at Authorization and Authorization Advice time */
export type SimulateMastercardFleetAuthorizationDataFuelProductInput = {
  /** Indicates the type of fuel product purchased */
  code?: InputMaybe<MastercardFleetFuelProductCode>;
  /** The quantity for the product purchased as a whole number */
  quantity?: InputMaybe<Scalars["UnsignedInt"]>;
  /** The precision of the `Quantity` value */
  quantityPrecision?: InputMaybe<Scalars["UnsignedInt"]>;
  /** Contains the sale amount of the product purchased */
  saleAmount?: InputMaybe<AmountInput>;
  /** The unit of measure for the product purchased */
  unitOfMeasure?: InputMaybe<MastercardFleetUnitOfMeasure>;
  /** The unit price of the fuel product as a whole number */
  unitPrice?: InputMaybe<Scalars["UnsignedInt"]>;
  /** The precision of the `UnitPrice` value */
  unitPricePrecision?: InputMaybe<Scalars["UnsignedInt"]>;
};

/** Details pertaining to a Mastercard Fleet transaction available at Authorization and Authorization Advice time */
export type SimulateMastercardFleetAuthorizationDataInput = {
  /**
   * An alphanumeric value representing a Driver ID provided by the cardholder
   *
   * **Maximum length:** 255 characters
   */
  driverIdentifier?: InputMaybe<Scalars["String"]>;
  /** A list of fuel products purchased */
  fuelProducts?: InputMaybe<
    Array<SimulateMastercardFleetAuthorizationDataFuelProductInput>
  >;
  /** A list of non-fuel products purchased */
  nonFuelProducts?: InputMaybe<
    Array<SimulateMastercardFleetAuthorizationDataNonFuelProductInput>
  >;
  /** A list of prompt codes and cardholder-entered values */
  prompts?: InputMaybe<Array<SimulateMastercardFleetPromptInput>>;
  /** Indicates whether the POS supports overriding the fleet spend controls on the card */
  spendControlOverrideFlag?: InputMaybe<Scalars["Boolean"]>;
  /**
   * An alphanumeric value representing a Vehicle ID provided by the cardholder
   *
   * **Maximum length:** 255 characters
   */
  vehicleIdentifier?: InputMaybe<Scalars["String"]>;
};

/** Details of a Mastercard Fleet non-fuel product available at Authorization and Authorization Advice time */
export type SimulateMastercardFleetAuthorizationDataNonFuelProductInput = {
  /** Indicates the type of fuel product purchased */
  code?: InputMaybe<MastercardFleetNonFuelProductCode>;
  /** Contains the individual item amount that is normally calculated as price multiplied by quantity */
  extendedItemAmount?: InputMaybe<AmountInput>;
  /** The quantity for the product purchased as a whole number */
  quantity?: InputMaybe<Scalars["UnsignedInt"]>;
  /** The precision of the `Quantity` value */
  quantityPrecision?: InputMaybe<Scalars["UnsignedInt"]>;
  /**
   * The unit of measure for the product purchased
   *
   * **Maximum length:** 255 characters
   */
  unitOfMeasure?: InputMaybe<Scalars["String"]>;
};

/** Details to simulate a Mastercard Fleet authorization. Allows for partial authorizations */
export type SimulateMastercardFleetAuthorizationInput = {
  /** Simulate network specific transaction data. */
  additionalNetworkData?: InputMaybe<SimulateAdditionalNetworkDataInput>;
  /** The `Amount` of the authorization provided as per the specifications of the given currency. */
  amount: AmountInput;
  /** The ID of the payment card to be used. */
  cardId: Scalars["ID"];
  /** Optionally simulate fees applied to the transaction. */
  fees?: InputMaybe<Array<TransactionFeeInput>>;
  /** Fleet specific details for this authorization. */
  fleetAuthorizationData?: InputMaybe<SimulateMastercardFleetAuthorizationDataInput>;
  /**
   * Details to set about a Merchant submitting the authorization.
   *
   * You can use these details to test merchant specific spend rules.
   */
  merchantDetails?: InputMaybe<MerchantDetailsInput>;
  /** The Point Of Service Details Input. */
  pointOfServiceDetails?: InputMaybe<PointOfServiceDetailsInput>;
  /** Details to override about a `PaymentCard` or card holder to test Spend Control Rules. */
  verificationOverrides?: InputMaybe<VerificationOverridesInput>;
};

/** Details to simulate Mastercard Fleet enhanced transaction data included with a clearing. Same as `SimulateMastercardFleetEnhancedDataInput` but without the `transactionId` since it is already provided on the parent input. */
export type SimulateMastercardFleetClearingEnhancedDataInput = {
  /**
   * Driver Identification Number. Only included if POS prompts for this value
   *
   * **Maximum length:** 255 characters
   */
  driverIdentification?: InputMaybe<Scalars["String"]>;
  /** Oil Company Brand Name */
  fuelBrand?: InputMaybe<MastercardFleetFuelBrand>;
  /** Fuel Discount Amount */
  fuelDiscountAmount?: InputMaybe<AmountInput>;
  /** Details about the fuel location */
  fuelLocationDetails?: InputMaybe<SimulateMastercardAdditionalFuelLocationDetailsInput>;
  /** Motor Fuel Quantity */
  fuelQuantity?: InputMaybe<Scalars["Float"]>;
  /** Motor Fuel Sale Amount */
  fuelSaleAmount?: InputMaybe<AmountInput>;
  /** Motor Fuel Service Type */
  fuelServiceType?: InputMaybe<MastercardFleetFuelServiceType>;
  /** Motor Fuel Product Code */
  fuelType?: InputMaybe<MastercardFleetProductCode>;
  /** Motor Fuel Unit of Measure */
  fuelUnitOfMeasure?: InputMaybe<MastercardFleetUnitOfMeasure>;
  /** The raw value received from the network for the motor fuel unit price */
  fuelUnitPriceValue?: InputMaybe<Scalars["UnsignedInt"]>;
  /**
   * The decimal precision for the `fuelUnitPriceValue`
   *
   * Precision should be in the range 0–5
   */
  fuelUnitPriceValuePrecision?: InputMaybe<Scalars["UnsignedInt"]>;
  /** Line items on the invoice */
  lineItems?: InputMaybe<
    Array<SimulateMastercardFleetEnhancedDataLineItemInput>
  >;
  /** Odometer Reading. Only included if POS prompts for this value */
  odometerReading?: InputMaybe<Scalars["String"]>;
  /** Product Type Code */
  productType?: InputMaybe<MastercardFleetProductType>;
  /** The local time the purchase was made. Should be in the format hhmm, with hours in the range 00–23 and minutes in the range 00–59 */
  purchaseTime?: InputMaybe<Scalars["String"]>;
  /** Tax Amount 1 */
  taxAmount1?: InputMaybe<AmountInput>;
  /** Tax Amount 2 */
  taxAmount2?: InputMaybe<AmountInput>;
  /**
   * Vehicle Identification Number. Only included if POS prompts for this value
   *
   * **Maximum length:** 255 characters
   */
  vehicleNumber?: InputMaybe<Scalars["String"]>;
};

/** Details to simulate the clearing of a Mastercard Fleet transaction. */
export type SimulateMastercardFleetClearingInput = {
  /** Simulate network specific transaction data. */
  additionalNetworkData?: InputMaybe<SimulateAdditionalNetworkDataInput>;
  /** The `Amount` of the Authorization to clear. Cannot be above the total amount of the related Authorizations. */
  amount: AmountInput;
  /** Optionally simulate fees applied to the transaction. */
  fees?: InputMaybe<Array<TransactionFeeInput>>;
  /** Mastercard Fleet enhanced transaction data to include with the clearing. */
  mastercardFleetData?: InputMaybe<SimulateMastercardFleetClearingEnhancedDataInput>;
  /** Details to set about a merchant submitting the clearing. */
  merchantDetails?: InputMaybe<MerchantDetailsInput>;
  /** The Point Of Service Details Input. */
  pointOfServiceDetails?: InputMaybe<PointOfServiceDetailsInput>;
  /** The `transactionId` from the original `AuthorizationEvent`. */
  transactionId: Scalars["ID"];
};

/** Details to simulate Mastercard Fleet enhanced transaction data. These are relevant additional transaction data items pertaining to a fleet transaction. */
export type SimulateMastercardFleetEnhancedDataInput = {
  /**
   * Driver Identification Number. Only included if POS prompts for this value
   *
   * **Maximum length:** 255 characters
   */
  driverIdentification?: InputMaybe<Scalars["String"]>;
  /** Oil Company Brand Name */
  fuelBrand?: InputMaybe<MastercardFleetFuelBrand>;
  /** Fuel Discount Amount */
  fuelDiscountAmount?: InputMaybe<AmountInput>;
  /** Details about the fuel location */
  fuelLocationDetails?: InputMaybe<SimulateMastercardAdditionalFuelLocationDetailsInput>;
  /** Motor Fuel Quantity */
  fuelQuantity?: InputMaybe<Scalars["Float"]>;
  /** Motor Fuel Sale Amount */
  fuelSaleAmount?: InputMaybe<AmountInput>;
  /** Motor Fuel Service Type */
  fuelServiceType?: InputMaybe<MastercardFleetFuelServiceType>;
  /** Motor Fuel Product Code */
  fuelType?: InputMaybe<MastercardFleetProductCode>;
  /** Motor Fuel Unit of Measure */
  fuelUnitOfMeasure?: InputMaybe<MastercardFleetUnitOfMeasure>;
  /** The raw value received from the network for the motor fuel unit price */
  fuelUnitPriceValue?: InputMaybe<Scalars["UnsignedInt"]>;
  /**
   * The decimal precision for the `fuelUnitPriceValue`
   *
   * Precision should be in the range 0–5
   */
  fuelUnitPriceValuePrecision?: InputMaybe<Scalars["UnsignedInt"]>;
  /** Line items on the invoice */
  lineItems?: InputMaybe<
    Array<SimulateMastercardFleetEnhancedDataLineItemInput>
  >;
  /** Odometer Reading. Only included if POS prompts for this value */
  odometerReading?: InputMaybe<Scalars["String"]>;
  /** Product Type Code */
  productType?: InputMaybe<MastercardFleetProductType>;
  /** The local time the purchase was made. Should be in the format hhmm, with hours in the range 00–23 and minutes in the range 00–59 */
  purchaseTime?: InputMaybe<Scalars["String"]>;
  /** Tax Amount 1 */
  taxAmount1?: InputMaybe<AmountInput>;
  /** Tax Amount 2 */
  taxAmount2?: InputMaybe<AmountInput>;
  /** The `transactionId` from the original `AuthorizationEvent`. */
  transactionId: Scalars["ID"];
  /**
   * Vehicle Identification Number. Only included if POS prompts for this value
   *
   * **Maximum length:** 255 characters
   */
  vehicleNumber?: InputMaybe<Scalars["String"]>;
};

/** An single simulated line item within a `MastercardFleetEnhancedData` */
export type SimulateMastercardFleetEnhancedDataLineItemInput = {
  /** Indicates whether the item amount, net of discount, taxes, and price, is a debit or credit */
  creditOrDebit?: InputMaybe<MastercardFleetCreditOrDebitIndicator>;
  /**
   * Description of the individual item purchased
   *
   * **Maximum length:** 255 characters
   */
  description?: InputMaybe<Scalars["String"]>;
  /** The raw value received from the network for the individual item amount */
  itemAmountValue?: InputMaybe<Scalars["UnsignedInt"]>;
  /**
   * The decimal precision for the `itemAmountValue`
   *
   * Precision should be in the range 0–5
   */
  itemAmountValuePrecision?: InputMaybe<Scalars["UnsignedInt"]>;
  /** The product code of the individual item purchased */
  productCode?: InputMaybe<MastercardFleetProductCode>;
  /** Quantity of the item purchased */
  quantity?: InputMaybe<Scalars["Float"]>;
  /**
   * The unit of measurement for the item purchased
   *
   * **Maximum length:** 255 characters
   */
  unitOfMeasure?: InputMaybe<Scalars["String"]>;
  /** The raw value received from the network for the line item unit price */
  unitPriceValue?: InputMaybe<Scalars["UnsignedInt"]>;
  /**
   * The decimal precision for the `unitPriceValuePrecision`
   *
   * Precision should be in the range 0–5
   */
  unitPriceValuePrecision?: InputMaybe<Scalars["UnsignedInt"]>;
};

/** Details of a Mastercard Fleet Prompt. Contains a prompt code and cardholder-entered value */
export type SimulateMastercardFleetPromptInput = {
  /** Indicates the type of prompted information */
  code?: InputMaybe<MastercardFleetPromptType>;
  /**
   * An alphanumeric value indicating the value entered by the cardholder
   *
   * **Maximum length:** 255 characters
   */
  value?: InputMaybe<Scalars["String"]>;
};

/**
 * Input for creating a new simulated `ExternallyInitiatedACHTransfer`.
 *
 * This is used only for testing.
 */
export type SimulateNonOriginatedAchTransferInput = {
  /** The amount of money being transferred. */
  amount: AmountInput;
  /**
   * Arbitrary value describing the transfer entered by the simulated external organization.
   *
   * It can be up to 20 alphanumeric characters.
   * If not specified, it will be undefined.
   */
  companyDiscretionaryData?: InputMaybe<Scalars["String"]>;
  /**
   * Provides the receiving financial institution with information about the nature or purpose of the transaction.
   * Examples include "ACCTVERIFY". "PAYROLL", "PAYMENT", etc.
   *
   * It can be up to 10 alphanumeric characters.
   */
  companyEntryDescription: Scalars["String"];
  /**
   * The identifier of the simulated external organization initiating the transfer, e.g. 1234567890.
   *
   * It can be up to 10 alphanumeric characters.
   */
  companyIdentifier: Scalars["String"];
  /**
   * The name of the simulated external organization initiating the transfer, e.g. THESAMPLECOMPANY.
   *
   * It can be up to 16 alphanumeric characters.
   */
  companyName: Scalars["String"];
  /**
   * The Highnote `FinancialAccount` to pull funds from or push funds to.
   *
   * This must be a Highnote `FinancialAccount`.
   */
  financialAccountId: Scalars["ID"];
  /**
   * A value to uniquely distinguish transfers, e.g. a UUID.
   *
   * This helps prevent duplicate transfers in error scenarios. If a failure happens and it is unclear
   * if a transfer went through, it is safe to repeat the request with the same idempotency key. If the
   * transfer already exists, the request will be deduped and the original transfer will be returned
   * instead of a new transfer getting created for the same amount. If idempotency key is the same between
   * two requests, the other fields will be ignored and the original transfer will be returned.
   *
   * This value is required. Maximum length: 255 characters.
   */
  idempotencyKey: Scalars["String"];
  /**
   * Receiver’s identification number. This could be a person or a business.
   *
   * This could be either a business or an individual. It can be up to 15 alphanumeric characters.
   * If not specified, it will be undefined.
   */
  individualIdentificationNumber?: InputMaybe<Scalars["String"]>;
  /**
   * Receiver’s individual name. This could be a person or a business.
   *
   * This could be either a business or an individual. It can be up to 22 alphanumric characters.
   * If not specified, it will be populated as `THISISTHERECIEVEROFACH`
   */
  individualName: Scalars["String"];
  /**
   * Contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** RMR\*IV\*0123456789\*\*999.99\\.
   *
   * Please note that this information may or may not be displayed to the recipient, based on the bank's
   * capabilities, and method of access (i.e., online banking, statement, etc.)
   *
   * **Maximum length:** 80 characters
   */
  paymentRelatedInformation?: InputMaybe<Scalars["String"]>;
  /** The purpose of the transfer, e.g. deposit. */
  purpose: AchTransferPurpose;
  /** Settlement date in YYYY-MM-DD format. If not specified, current date will be used. */
  settlementDate?: InputMaybe<Scalars["String"]>;
};

/** The return types when simulating receiving a `NonOriginatedAchTransfer`. */
export type SimulateNonOriginatedAchTransferPayload =
  | AccessDeniedError
  | NonOriginatedAchTransfer
  | UserError;

/** The possible return types of `SimulatePaymentCardTransactionDisputePayload`. */
export type SimulatePaymentCardTransactionDisputePayload =
  | AccessDeniedError
  | PaymentCardTransactionDispute
  | UserError;

/** Input fields for simulating approval */
export type SimulatePhysicalCardGroupOrderApprovalInput = {
  /** Id of the group order. */
  groupOrderId: Scalars["ID"];
};

/** Types which can be returned for simulating physical card group orders */
export type SimulatePhysicalCardGroupOrderPayload =
  | AccessDeniedError
  | PhysicalCardGroupOrder
  | UserError;

/** Input fields for simulating sending to printer */
export type SimulatePhysicalCardGroupOrderSendToPrinterInput = {
  /** Id of the group order. */
  groupOrderId: Scalars["ID"];
};

/** Input fields for simulating shipment failed */
export type SimulatePhysicalCardGroupOrderShipmentFailedInput = {
  /** Id of the group order. */
  groupOrderId: Scalars["ID"];
};

/** Input fields for simulating shipped */
export type SimulatePhysicalCardGroupOrderShippedInput = {
  /** Actual ship date in YYYY-MM-DD format. */
  actualShipDate?: InputMaybe<Scalars["String"]>;
  /** Id of the group order. */
  groupOrderId: Scalars["ID"];
  /**
   * Tracking number
   *
   * **Maximum length:** 50 characters
   */
  trackingNumber?: InputMaybe<Scalars["String"]>;
};

/** Input fields for simulating approval */
export type SimulatePhysicalPaymentCardApprovalInput = {
  /** Physical Payment Card ID */
  physicalPaymentCardOrderId: Scalars["ID"];
};

/** Types which can be returned for simulating physical payment card orders */
export type SimulatePhysicalPaymentCardPayload =
  | AccessDeniedError
  | PhysicalPaymentCardOrder
  | UserError;

/** Input fields for simulating sending to printer */
export type SimulatePhysicalPaymentCardSendToPrinterInput = {
  /** Physical Payment Card ID */
  physicalPaymentCardOrderId: Scalars["ID"];
};

/** Input fields for simulating shipment failed */
export type SimulatePhysicalPaymentCardShipmentFailedInput = {
  /** Physical Payment Card ID */
  physicalPaymentCardOrderId: Scalars["ID"];
};

/** Input fields for simulating shipped */
export type SimulatePhysicalPaymentCardShippedInput = {
  /** Actual ship date in YYYY-MM-DD format. */
  actualShipDate?: InputMaybe<Scalars["String"]>;
  /** Physical Payment Card ID */
  physicalPaymentCardOrderId: Scalars["ID"];
  /**
   * Tracking number
   *
   * **Maximum length:** 50 characters
   */
  trackingNumber?: InputMaybe<Scalars["String"]>;
};

/**
 * Input for changing the status of an `IntegratorInitiatedACHTransfer` to `PROCESSED`.
 *
 * This will fail if the status of the transfer is not `PROCESSING`.
 */
export type SimulateProcessedIntegratorInitiatedStatusChangeInput = {
  /** The global ID of the transfer to be changed. */
  id: Scalars["ID"];
};

/** The return types when changing an `IntegratorInitiatedACHTransfer` from `PROCESSING` to `PROCESSED`. */
export type SimulateProcessedIntegratorInitiatedStatusChangePayload =
  | AccessDeniedError
  | IntegratorInitiatedFundsDepositAchTransfer
  | IntegratorInitiatedFundsWithdrawalAchTransfer
  | SecureCardBalanceRepaymentAchTransfer
  | SecureDepositAchTransfer
  | UserError;

/**
 * Input for changing the status of an `ExternallyInitiatedACHTransfer` to `PROCESSING`.
 *
 * This will fail if the status of the transfer is not `PENDING`.
 */
export type SimulateProcessingExternallyInitiatedStatusChangeInput = {
  /** The global ID of the transfer to be changed. */
  id: Scalars["ID"];
};

/**
 * Input for changing the status of an `IntegratorInitiatedACHTransfer` to `PROCESSING`.
 *
 * This will fail if the status of the transfer is not `INITIATED`.
 */
export type SimulateProcessingIntegratorInitiatedStatusChangeInput = {
  /** The global ID of the transfer to be changed. */
  id: Scalars["ID"];
};

/** The return types when changing an `IntegratorInitiatedACHTransfer` from `INITIATED` to `PROCESSING`. */
export type SimulateProcessingIntegratorInitiatedStatusChangePayload =
  | AccessDeniedError
  | IntegratorInitiatedFundsDepositAchTransfer
  | IntegratorInitiatedFundsWithdrawalAchTransfer
  | SecureCardBalanceRepaymentAchTransfer
  | SecureDepositAchTransfer
  | UserError;

/** Details to simulate the authorization reversal. */
export type SimulateRefundInput = {
  /** Simulate network specific transaction data. */
  additionalNetworkData?: InputMaybe<SimulateAdditionalNetworkDataInput>;
  /** The `Amount` of the original `AuthorizationEvent` to refund. */
  amount?: InputMaybe<AmountInput>;
  /** The `Amount` of cashback requested to be refunded. */
  cashbackAmount?: InputMaybe<AmountInput>;
  /** Fees to be reversed, if any. */
  fees?: InputMaybe<Array<TransactionFeeInput>>;
  /**
   * Details to set about a Merchant submitting the refund.
   *
   * You can use these details to test merchant specific spend rules.
   */
  merchantDetails?: InputMaybe<MerchantDetailsInput>;
  /** The Point Of Service Details Input. */
  pointOfServiceDetails?: InputMaybe<PointOfServiceDetailsInput>;
  /** The `transactionId` from the original `AuthorizationEvent`. */
  transactionId: Scalars["ID"];
  /** Represents the customer transaction type being processed. */
  transactionProcessingType?: InputMaybe<CardTransactionProcessingType>;
};

export type SimulateRefundPayload =
  | AccessDeniedError
  | ClearingEvent
  | UserError;

/** Input for `simulateResolvePaymentCardTransactionChargeback` */
export type SimulateResolvePaymentCardTransactionChargebackInput = {
  /** The ID of the dispute. */
  disputeId: Scalars["ID"];
  /** The ID of the chargeback. */
  id: Scalars["ID"];
  /**
   * The received amount from the external network.
   * If received amount is 0, the chargeback is resolved as a loss.
   */
  receivedAmount: AmountInput;
};

/**
 * Input for changing the status of an `IntegratorInitiatedACHTransfer` to `RETURNED`.
 *
 * This will fail if the status of the transfer is not `PROCESSING`.
 */
export type SimulateReturnedIntegratorInitiatedStatusChangeInput = {
  /** The global ID of the transfer to be changed. */
  id: Scalars["ID"];
  /** The reason for the `RETURNED` status. */
  reasonCode: IntegratorInitiatedAchStatusReasonCode;
};

/** The return types when changing an `IntegratorInitiatedACHTransfer` from `PROCESSING` to `RETURNED`. */
export type SimulateReturnedIntegratorInitiatedStatusChangePayload =
  | AccessDeniedError
  | IntegratorInitiatedFundsDepositAchTransfer
  | IntegratorInitiatedFundsWithdrawalAchTransfer
  | SecureCardBalanceRepaymentAchTransfer
  | SecureDepositAchTransfer
  | UserError;

/** Details to simulate the authorization reversal. */
export type SimulateReversalInput = {
  /** Simulate network specific transaction data. */
  additionalNetworkData?: InputMaybe<SimulateAdditionalNetworkDataInput>;
  /** The `Amount` of the Authorization to reverse. Cannot be above the total amount of the related Authorizations. */
  amount?: InputMaybe<AmountInput>;
  /** The `Amount` of cashback to be reversed. */
  cashbackAmount?: InputMaybe<AmountInput>;
  /** Fees to be reversed, if any. */
  fees?: InputMaybe<Array<TransactionFeeInput>>;
  /** Determines whether this is an issuer initiated reversal for an expired authorization. */
  issuerExpiredAuthorization?: InputMaybe<Scalars["Boolean"]>;
  /** Details to set about a Merchant submitting the reversal. */
  merchantDetails?: InputMaybe<MerchantDetailsInput>;
  /** The Point Of Service Details Input. */
  pointOfServiceDetails?: InputMaybe<PointOfServiceDetailsInput>;
  /** The `transactionId` from the original `AuthorizationEvent`. */
  transactionId: Scalars["ID"];
  /** Represents the customer transaction type being processed. */
  transactionProcessingType?: InputMaybe<CardTransactionProcessingType>;
};

export type SimulateReversalPayload =
  | AccessDeniedError
  | ReversalEvent
  | UserError;

/** Input fields for rolling over the current statement period */
export type SimulateRolloverCurrentFinancialAccountStatementPeriodInput = {
  /** Financial Account Id */
  financialAccountId: Scalars["ID"];
};

/** Input fields for shifting the current statement period */
export type SimulateShiftCurrentFinancialAccountStatementPeriodInput = {
  /** Financial Account Id */
  financialAccountId: Scalars["ID"];
  /**
   * The new statement period boundary, in ISO 8601 format.
   * Defaults to 60 seconds from now.
   *
   * **Note:** The new period boundary must be at least 60 second from now.
   */
  periodBoundary?: InputMaybe<Scalars["String"]>;
};

/** Details to simulate the authorization and clear. */
export type SimulateSingleStepAuthAndClearInput = {
  /** Simulate network specific transaction data. */
  additionalNetworkData?: InputMaybe<SimulateAdditionalNetworkDataInput>;
  /** The `Amount` of the authorization provided as per the specifications of the given currency. */
  amount: AmountInput;
  /** The ID of the payment card to be used. */
  cardId: Scalars["ID"];
  /** The `Amount` of cashback requested during the transaction. */
  cashbackAmount?: InputMaybe<AmountInput>;
  /** Optionally simulate fees applied to the transaction. */
  fees?: InputMaybe<Array<TransactionFeeInput>>;
  /**
   * Details to set about a Merchant submitting the authorization.
   *
   * You can use these details to test merchant specific spend rules.
   */
  merchantDetails?: InputMaybe<MerchantDetailsInput>;
  /** The Point Of Service Details Input. */
  pointOfServiceDetails?: InputMaybe<PointOfServiceDetailsInput>;
  /** Represents the customer transaction type being processed. */
  transactionProcessingType?: InputMaybe<CardTransactionProcessingType>;
  /** Details to override about a `PaymentCard` or card holder to test Spend Control Rules. */
  verificationOverrides?: InputMaybe<VerificationOverridesInput>;
};

/** Input for `simulateUpdateCardTransactionDispute`. */
export type SimulateUpdateCardTransactionDisputeInput = {
  /** The ID of the PaymentCardTransactionDispute */
  id: Scalars["ID"];
  /** The status of the dispute. */
  status?: InputMaybe<PaymentCardDisputeStatus>;
};

/** Input for `SimulateUpdatePaymentCardTransactionChargebackInput`. */
export type SimulateUpdatePaymentCardTransactionChargebackInput = {
  /** The ID of the dispute. */
  disputeId: Scalars["ID"];
  /** The ID of the chargeback. */
  id: Scalars["ID"];
  /** The status of the chargeback */
  status?: InputMaybe<PaymentCardChargebackStatus>;
};

/** Simulate Visa network specific transaction data. */
export type SimulateVisaAdditionalNetworkDataInput = {
  /** A number used by Visa to identify the acquiring institution. */
  acquiringInstitutionIdentificationCode?: InputMaybe<Scalars["String"]>;
  /** Information about the Cardholder Authentication Verification Value (CAVV) for this transaction. */
  cavvResultCode?: InputMaybe<VisaCavvResultCode>;
  /** Classification information for Mail Order/Telephone Order (MOTO) and Electronic Commerce transactions. */
  motoAndElectronicCommerceIndicator?: InputMaybe<VisaMotoAndElectronicCommerceIndicator>;
  /**
   * Payment facilitator identifier for the transaction.
   * **Maximum length:** 11
   */
  paymentFacilitatorIdentifier?: InputMaybe<Scalars["String"]>;
  /** The risk score for the transaction provided by Visa. Values are between 0-99. */
  riskScore?: InputMaybe<Scalars["UnsignedInt"]>;
  /** Information about the verification method used in this transaction. */
  threeDSecureIndicator?: InputMaybe<VisaThreeDSecureIndicator>;
};

/** Details to simulate the authorization advice of a Visa Fleet transaction. */
export type SimulateVisaFleetAuthorizationAdviceInput = {
  /** Simulate network specific transaction data. */
  additionalNetworkData?: InputMaybe<SimulateAdditionalNetworkDataInput>;
  /** The `Amount` of the Authorization to clear. Cannot be above the total amount of the related Authorizations. */
  amount: AmountInput;
  /** Optionally simulate fees applied to the transaction. */
  fees?: InputMaybe<Array<TransactionFeeInput>>;
  /** Fleet specific details for this authorization advice. */
  fleetAuthorizationData?: InputMaybe<SimulateVisaFleetAuthorizationDataInput>;
  /**
   * Details to set about a Merchant submitting the authorization.
   *
   * You can use these details to test merchant specific spend rules.
   */
  merchantDetails?: InputMaybe<MerchantDetailsInput>;
  /** The Point Of Service Details Input. */
  pointOfServiceDetails?: InputMaybe<PointOfServiceDetailsInput>;
  /** The `transactionId` from the original `AuthorizationEvent`. */
  transactionId: Scalars["ID"];
  /** Represents the customer transaction type being processed. */
  transactionProcessingType?: InputMaybe<CardTransactionProcessingType>;
  /** Details to override about a `PaymentCard` or card holder to test Spend Control Rules. */
  verificationOverrides?: InputMaybe<VerificationOverridesInput>;
  /** Visa Fleet details to be simulated */
  visaFleetL2TransactionData?: InputMaybe<VisaFleetL2TransactionDataInput>;
};

/** Details pertaining to a Visa Fleet transaction available at Authorization and Authorization Advice time */
export type SimulateVisaFleetAuthorizationDataInput = {
  /**
   * An alphanumeric value representing the answer to a custom prompt
   *
   * **Maximum length:** 255 characters
   */
  customPrompt1?: InputMaybe<Scalars["String"]>;
  /**
   * An alphanumeric value representing the answer to a custom prompt
   *
   * **Maximum length:** 255 characters
   */
  customPrompt2?: InputMaybe<Scalars["String"]>;
  /**
   * An alphanumeric value representing the employee’s ID number
   *
   * **Maximum length:** 255 characters
   */
  employeeNumber?: InputMaybe<Scalars["String"]>;
  /**
   * An alphanumeric value representing either a Vehicle, Driver, or Generic ID provided by the cardholder
   *
   * **Maximum length:** 255 characters
   */
  fleetIdentifier?: InputMaybe<Scalars["String"]>;
  /** A list of non-fuel product codes for the products purchased */
  nonFuelProductCodes?: InputMaybe<Array<VisaNonFuelProductCode>>;
  /**
   * The odometer value provided by the cardholder
   *
   * **Maximum length:** 255 characters
   */
  odometer?: InputMaybe<Scalars["String"]>;
  /**
   * An alphanumeric value representing either an Order Number or an Invoice Number provided by the cardholder
   *
   * **Maximum length:** 255 characters
   */
  purchaseIdentifier?: InputMaybe<Scalars["String"]>;
  /** Indicates whether `purchaseIdentifier` is an Order Number or a Invoice Number provided by the cardholder */
  purchaseIdentifierFormat?: InputMaybe<VisaFleetPurchaseIdentifierFormat>;
  /** Indicates whether the POS supports host-based restriction processing */
  purchaseRestrictonsFlag?: InputMaybe<Scalars["Boolean"]>;
  /** Indicates whether fuel or non-fuel items are included in the transaction */
  purchaseType?: InputMaybe<VisaFuelPurchaseType>;
  /** Indicates whether the transaction occurred at a self-service or a full-service station */
  serviceType?: InputMaybe<VisaFuelServiceType>;
  /**
   * An alphanumeric value representing the trailer’s ID number
   *
   * **Maximum length:** 255 characters
   */
  trailerNumber?: InputMaybe<Scalars["String"]>;
};

/** Details to simulate a Visa Fleet authorization. Allows for partial authorizations */
export type SimulateVisaFleetAuthorizationInput = {
  /** Simulate network specific transaction data. */
  additionalNetworkData?: InputMaybe<SimulateAdditionalNetworkDataInput>;
  /** The `Amount` of the authorization provided as per the specifications of the given currency. */
  amount: AmountInput;
  /** The ID of the payment card to be used. */
  cardId: Scalars["ID"];
  /** Optionally simulate fees applied to the transaction. */
  fees?: InputMaybe<Array<TransactionFeeInput>>;
  /** Fleet specific details for this authorization. */
  fleetAuthorizationData?: InputMaybe<SimulateVisaFleetAuthorizationDataInput>;
  /**
   * The optional ID of a previous authorization.
   *
   * Typically, this is only used to simulate "incremental authorization".
   */
  id?: InputMaybe<Scalars["ID"]>;
  /**
   * Details to set about a Merchant submitting the authorization.
   *
   * You can use these details to test merchant specific spend rules.
   */
  merchantDetails?: InputMaybe<MerchantDetailsInput>;
  /** The Point Of Service Details Input. */
  pointOfServiceDetails?: InputMaybe<PointOfServiceDetailsInput>;
  /** Represents the customer transaction type being processed. */
  transactionProcessingType?: InputMaybe<CardTransactionProcessingType>;
  /** Details to override about a `PaymentCard` or card holder to test Spend Control Rules. */
  verificationOverrides?: InputMaybe<VerificationOverridesInput>;
  /** Visa Fleet details to be simulated */
  visaFleetL2TransactionData?: InputMaybe<VisaFleetL2TransactionDataInput>;
};

/** Details to simulate the clearing of a Visa Fleet transaction. */
export type SimulateVisaFleetClearingInput = {
  /** Simulate network specific transaction data. */
  additionalNetworkData?: InputMaybe<SimulateAdditionalNetworkDataInput>;
  /** The `Amount` of the Authorization to clear. Cannot be above the total amount of the related Authorizations. */
  amount: AmountInput;
  /** Optionally simulate fees applied to the transaction. */
  fees?: InputMaybe<Array<TransactionFeeInput>>;
  /** Details to set about a merchant submitting the clearing. */
  merchantDetails?: InputMaybe<MerchantDetailsInput>;
  /** The Point Of Service Details Input. */
  pointOfServiceDetails?: InputMaybe<PointOfServiceDetailsInput>;
  /** The `transactionId` from the original `AuthorizationEvent`. */
  transactionId: Scalars["ID"];
  /** Represents the customer transaction type being processed. */
  transactionProcessingType?: InputMaybe<CardTransactionProcessingType>;
  /** Visa Fleet details to be simulated */
  visaFleetL2TransactionData?: InputMaybe<VisaFleetL2TransactionDataInput>;
};

/** Discount fields for simulating Visa Fleet Level 3 transaction data. */
export type SimulateVisaFleetL3EnhancedDataDiscountInput = {
  /** Total amount of discount at invoice level according to the `visaDiscountTreatment` and the `visaTaxTreatment`. This figure excludes any discount amounts defined at line item level. */
  amount?: InputMaybe<AmountInput>;
  /** This field specifies if the invoice-level Discount Amount is a credit or debit value. */
  amountSignage?: InputMaybe<VisaAmountSignage>;
  /** Identifies how to treat the discount if one was applied at the invoice level. */
  treatment?: InputMaybe<VisaDiscountTreatment>;
};

/** Duty fields for simulating Visa Fleet Level 3 transaction data. */
export type SimulateVisaFleetL3EnhancedDataDutyInput = {
  /** The price of duty. */
  amount?: InputMaybe<AmountInput>;
  /** This field specifies if the Duty Amount is a credit or debit value. */
  amountSignage?: InputMaybe<VisaAmountSignage>;
};

/** Simulated Visa Fleet Level 3 transaction data. These are relevant additional transaction data items pertaining to a fleet transaction. */
export type SimulateVisaFleetL3EnhancedDataInput = {
  /** Discount input for this transaction. */
  discount?: InputMaybe<SimulateVisaFleetL3EnhancedDataDiscountInput>;
  /** Duty input for this transaction. */
  duty?: InputMaybe<SimulateVisaFleetL3EnhancedDataDutyInput>;
  /** Invoice input for this transaction. */
  invoice?: InputMaybe<SimulateVisaFleetL3EnhancedDataInvoiceInput>;
  /** Shipping input for this transaction. */
  shipping?: InputMaybe<SimulateVisaFleetL3EnhancedDataShippingInput>;
  /** Tax input for this transaction. */
  tax?: InputMaybe<SimulateVisaFleetL3EnhancedDataTaxInput>;
  /** The `transactionId` from the original `AuthorizationEvent`. */
  transactionId: Scalars["ID"];
};

/** Invoice fields for simulating Visa Fleet Level 3 transaction data. */
export type SimulateVisaFleetL3EnhancedDataInvoiceInput = {
  /** The Authorization Code of the transaction. */
  authorizationCode?: InputMaybe<Scalars["String"]>;
  /** Country code of the destination. The field may contain spaces. */
  destinationCountryCode?: InputMaybe<Scalars["String"]>;
  /** Postal code of the destination. The field may contain spaces. */
  destinationPostalCode?: InputMaybe<Scalars["String"]>;
  /** Line items on the invoice. */
  lineItems?: InputMaybe<Array<SimulateVisaFleetL3EnhancedDataLineItemInput>>;
  /** Date the order was taken. The entry should be in the format YYYY-MM-DD. */
  orderDate?: InputMaybe<Scalars["String"]>;
  /** The VAT invoice number. */
  referenceNumber?: InputMaybe<Scalars["String"]>;
  /** Postal code of the location being shipped from. The field may contain spaces. */
  shipFromPostalCode?: InputMaybe<Scalars["String"]>;
};

/** An single simulated line item within a `VisaFleetL3EnhancedData` */
export type SimulateVisaFleetL3EnhancedDataLineItemInput = {
  /** The commodity code for the line item. */
  commodityCode?: InputMaybe<VisaItemCommodityCode>;
  /** Freeform text description of item or service */
  descriptor?: InputMaybe<Scalars["String"]>;
  /** Defines the type of line item */
  detailIndicator?: InputMaybe<VisaLineItemDetailIndicator>;
  /** Amount of discount if provided for this line item according to the `discountTreatment`. */
  discountPerItem?: InputMaybe<AmountInput>;
  /** Identifies how to treat the discount if one was applied at the line item level */
  discountTreatment?: InputMaybe<VisaDiscountTreatment>;
  /** Typically, an SKU or identifier from the Merchant */
  productCode?: InputMaybe<Scalars["String"]>;
  /**
   * The number of items.
   *
   * There are 4 implied decimal places, thus a value of “1” is populated in this field as 10000.
   */
  quantity?: InputMaybe<Scalars["UnsignedInt"]>;
  /** Amount of sales tax for this item or service in accordance with the `taxTreatment`. */
  taxAmount?: InputMaybe<AmountInput>;
  /**
   * Rate of sales tax charged on the item or service (in accordance with the `taxTreatment`).
   *
   * The last two digits are implied decimal places.
   */
  taxRate?: InputMaybe<Scalars["UnsignedInt"]>;
  /** Formula: (`quantity` * `unitCost`) - `discountPerItem` */
  total?: InputMaybe<AmountInput>;
  /** Unit cost for this item or service in accordance with the `taxTreatment`. */
  unitCost?: InputMaybe<AmountInput>;
  /** A readable unit of measure */
  unitOfMeasure?: InputMaybe<Scalars["String"]>;
};

export type SimulateVisaFleetL3EnhancedDataPayload =
  | AccessDeniedError
  | EnhancedDataEvent
  | UserError;

/** Shipping related fields for simulating Visa Fleet Level 3 transaction data. */
export type SimulateVisaFleetL3EnhancedDataShippingInput = {
  /** The price of freight/shipping. */
  amount?: InputMaybe<AmountInput>;
  /** This field specifies if the Shipping Amount is a credit or debit value. */
  amountSignage?: InputMaybe<VisaAmountSignage>;
  /** Amount of Sales Tax charged on the shipping amount (in accordance with the `visaTaxTreatment`). */
  taxAmount?: InputMaybe<AmountInput>;
  /** This field specifies if the Duty Amount is a credit or debit value. */
  taxAmountSignage?: InputMaybe<VisaAmountSignage>;
  /**
   * Rate of sales tax charged on the shipping amount (in accordance with the `visaTaxTreatment`).
   * The last two digits are implied decimal places.
   */
  taxRate?: InputMaybe<Scalars["UnsignedInt"]>;
};

/** Tax fields for simulating Visa Fleet Level 3 transaction data. */
export type SimulateVisaFleetL3EnhancedDataTaxInput = {
  /** Describes how the tax is calculated on the invoice */
  treatment?: InputMaybe<VisaTaxTreatment>;
};

/** Fee amount to be charged. */
export type SimulatedFeeAmountInput = {
  /** Fee amount to be charged. It cannot be combined with feePercentage or feeBasisPoints. */
  feeAmount?: InputMaybe<AmountInput>;
  /** Basis points representation of the fee percentage to be charged. eg: 125 basis points = 1.25% */
  feeBasisPoints?: InputMaybe<Scalars["UnsignedInt"]>;
};

/** String value type accepting similar sounding data */
export type SoundsLikeFilterInput = {
  /** Value matches the data that sounds like the provided `Strings`. */
  soundsLike?: InputMaybe<Array<Scalars["String"]>>;
};

export type SpendRule = {
  /** The date and time, in ISO 8601 format, the spend rule was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the Spend Rule in operations. */
  id: Scalars["ID"];
  /** The name assigned to the rule. */
  name?: Maybe<Scalars["String"]>;
  /** The list of revisions for this spend rule. */
  revisions?: Maybe<SpendRuleConnection>;
  /** The date and time, in ISO 8601 format, the spend rule was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: Maybe<ApplicableRuleUserType>;
  /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
  version?: Maybe<Scalars["String"]>;
};

export type SpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The connection type for Spend Rule. */
export type SpendRuleConnection = {
  __typename?: "SpendRuleConnection";
  /** A list of edges. */
  edges?: Maybe<Array<SpendRuleEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** A container that holds a `SpendRule`. */
export type SpendRuleContainer = {
  __typename?: "SpendRuleContainer";
  /** A Spending Rule. */
  spendRule?: Maybe<SpendRule>;
};

/** The edge type for a SpendRule. */
export type SpendRuleEdge = {
  __typename?: "SpendRuleEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The Spend Rule. */
  node?: Maybe<SpendRule>;
};

/** The recommendation to `ALLOW` or `BLOCK` an event based on the application of the spend rule. */
export enum SpendRuleRecommendation {
  /** Allow the event. */
  ALLOW = "ALLOW",
  /** Block the event. */
  BLOCK = "BLOCK",
  /** A recommendation could not be determined. */
  NONE = "NONE",
}

/** The result of applying a spend rule to an event. */
export type SpendRuleResult = {
  /** The attached level. (Platform, Product, Card) */
  attachedLevel?: Maybe<AttachedLevel>;
  /** A message describing the result. */
  message?: Maybe<Scalars["String"]>;
  /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
  recommendation?: Maybe<SpendRuleRecommendation>;
};

/** The connection type for `SpendRuleResult`. */
export type SpendRuleResultConnection = {
  __typename?: "SpendRuleResultConnection";
  /** A list of edges. */
  edges?: Maybe<Array<SpendRuleResultEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** Edge for `SpendRuleResult`. */
export type SpendRuleResultEdge = {
  __typename?: "SpendRuleResultEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The `SpendRuleResult`. */
  node?: Maybe<SpendRuleResult>;
};

/** The input to start a document upload session. */
export type StartDocumentUploadSessionInput = {
  /** The ID of the document upload session */
  documentUploadSessionId: Scalars["ID"];
};

/** The return types when a document upload session is started. */
export type StartDocumentUploadSessionPayload =
  | AccessDeniedError
  | CardProfileDocumentUploadSession
  | CheckPaymentDocumentUploadSession
  | IdentityVerificationDocumentUploadSession
  | ManualDocumentRequestUploadSession
  | UsAccountHolderApplicationDocumentUploadSession
  | UserError;

/** Public stock exchanges. */
export enum StockExchange {
  /** Nasdaq (National Association of Securities Dealers Automated Quotation System) */
  NASDAQ = "NASDAQ",
  /** New York Stock Exchange */
  NYSE = "NYSE",
}

/**
 * A Spend Control rule that allows or blocks certain AVS response codes during authorizations.
 *
 * **Note** A `StreetAddressSpendRule` only applies to street numbers. To control postal codes, use `PostalCodeSpendRule`.
 */
export type StreetAddressSpendRule = Node &
  SpendRule & {
    __typename?: "StreetAddressSpendRule";
    /** The `AVSResponseCode` values that will be allowed during authorizations. */
    allowed?: Maybe<Array<AvsResponseCode>>;
    /** The `AVSResponseCode` values that will result in declined authorizations. */
    blocked?: Maybe<Array<AvsResponseCode>>;
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the spend rule in operations. */
    id: Scalars["ID"];
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/**
 * A Spend Control rule that allows or blocks certain AVS response codes during authorizations.
 *
 * **Note** A `StreetAddressSpendRule` only applies to street numbers. To control postal codes, use `PostalCodeSpendRule`.
 */
export type StreetAddressSpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The result of applying a street address spend rule to an event. */
export type StreetAddressSpendRuleResult = SpendRuleResult & {
  __typename?: "StreetAddressSpendRuleResult";
  /** The attached level. */
  attachedLevel?: Maybe<AttachedLevel>;
  /** A message describing the result. */
  message?: Maybe<Scalars["String"]>;
  /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
  recommendation?: Maybe<SpendRuleRecommendation>;
  /** The spend rule attached at the time of the event. */
  spendRule?: Maybe<StreetAddressSpendRule>;
  /** The AVS response codes of the event. */
  valuesTested?: Maybe<Array<AvsResponseCode>>;
};

/** String value type */
export type StringFilterInput = {
  /** Value matches the provided `String`. */
  equals?: InputMaybe<Scalars["String"]>;
  /** Value does not match any of the provided `Strings`. */
  excludes?: InputMaybe<Array<Scalars["String"]>>;
  /** Value exactly matches any of the provided `Strings`. */
  includes?: InputMaybe<Array<Scalars["String"]>>;
  /** Value does not match the provided `String`. */
  notEquals?: InputMaybe<Scalars["String"]>;
};

/** String value type to provide matching of the text */
export type StringSearchFilterInput = {
  /** Value contains provided `String`. */
  contains?: InputMaybe<Scalars["String"]>;
  /** Value ends with provided `String`. */
  endsWith?: InputMaybe<Scalars["String"]>;
  /** Value matches the provided `String`. */
  equals?: InputMaybe<Scalars["String"]>;
  /** Value does not match any of the provided `Strings`. */
  excludes?: InputMaybe<Array<Scalars["String"]>>;
  /** Value exactly matches any of the provided `Strings`. */
  includes?: InputMaybe<Array<Scalars["String"]>>;
  /** Value does not match the provided `String`. */
  notEquals?: InputMaybe<Scalars["String"]>;
  /** Value starts with provided `String`. */
  startsWith?: InputMaybe<Scalars["String"]>;
};

/** The input to suspend a card digital wallet token. */
export type SuspendCardDigitalWalletTokenInput = {
  /** The ID of the card digital wallet token to suspend. */
  cardDigitalWalletTokenId: Scalars["ID"];
  /** The reason for the card digital wallet token to be suspended. */
  reason: SuspendCardDigitalWalletTokenReason;
};

/** The return types when suspending a card digital wallet token. */
export type SuspendCardDigitalWalletTokenPayload =
  | AccessDeniedError
  | CardDigitalWalletToken
  | UserError;

/** Reasons for a card digital wallet token to be suspended. */
export enum SuspendCardDigitalWalletTokenReason {
  /** Device is reported as lost. */
  DEVICE_LOST = "DEVICE_LOST",
  /** Device is reported as stolen. */
  DEVICE_STOLEN = "DEVICE_STOLEN",
  /** Fraudulent transactions have been reported by `Highnote` or the account holder. */
  FRAUDULENT_TRANSACTIONS = "FRAUDULENT_TRANSACTIONS",
  /** Any other reason for suspending the card digital wallet token. */
  OTHER = "OTHER",
}

/** The input details for suspending a `FinancialAccount`. */
export type SuspendFinancialAccountInput = {
  /** The `FinancialAccount` ID to be suspended. */
  id: Scalars["ID"];
  /**
   * The memo for suspending the `FinancialAccount`.
   *
   * Regex: ^[a-zA-Z\d$ ',.\-\_!@#$%^&*+=`?"\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\n]+$
   * Memo has a max length of 2048 characters.
   * For compliance and security reasons, memo should not contain any sensitive information, such as PII or PCI.
   */
  memo: Scalars["String"];
  /** The reason for suspending the `FinancialAccount`. */
  suspensionReason: FinancialAccountSuspensionReasonInput;
};

/** The details of the Payment Card to suspend. */
export type SuspendPaymentCardInput = {
  /** The ID of the Payment Card to suspend. */
  paymentCardId: Scalars["ID"];
};

/** The return types when suspending a Payment Card. */
export type SuspendPaymentCardPayload =
  | AccessDeniedError
  | PaymentCard
  | UserError;

/** Whether or not the `FinancialAccount` is enabled as a suspense account. */
export type SuspenseFinancialAccountFeature = FinancialAccountFeature & {
  __typename?: "SuspenseFinancialAccountFeature";
  /** The date and time, in ISO 8601 format, the feature was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective from. */
  effectiveFrom?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the feature was effective through. */
  effectiveThrough?: Maybe<Scalars["String"]>;
  /** Whether or not the feature is enabled for the `FinancialAccount`. */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** The date and time, in ISO 8601 format, the feature was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** A type representing the parts of a tax identification number (e.g. SSN, TIN, EIN). */
export type TaxIdentificationDocument = {
  __typename?: "TaxIdentificationDocument";
  /** The three character country code of the issuing country. */
  countryCodeAlpha3?: Maybe<Scalars["String"]>;
  /** A cryptographically hashed representation of the number. */
  numberHash?: Maybe<Scalars["String"]>;
  /** Whether a tax identification number has been previously stored */
  taxIdentificationNumberStored?: Maybe<Scalars["Boolean"]>;
  /** The type of tax identification number. */
  taxIdentificationNumberType?: Maybe<TaxIdentificationNumberType>;
};

/** An input representing the parts of a tax identification number (e.g. SSN, TIN, EIN). */
export type TaxIdentificationDocumentInput = {
  /** The three character country code of the issuing country. */
  countryCodeAlpha3: Scalars["String"];
  /** The full tax identification number. */
  number: Scalars["String"];
  /** The type of tax identification number. */
  taxIdentificationNumberType?: InputMaybe<TaxIdentificationNumberType>;
};

/** The type of tax identification number. */
export enum TaxIdentificationNumberType {
  /**
   * Employer Identification Number
   * @deprecated Use EMPLOYER_IDENTIFICATION_NUMBER instead
   */
  EIN = "EIN",
  /** Employer Identification Number */
  EMPLOYER_IDENTIFICATION_NUMBER = "EMPLOYER_IDENTIFICATION_NUMBER",
  /** Individual Taxpayer Identification Number */
  INDIVIDUAL_TAXPAYER_IDENTIFICATION_NUMBER = "INDIVIDUAL_TAXPAYER_IDENTIFICATION_NUMBER",
  /**
   * Individual Taxpayer Identification Number
   * @deprecated Use INDIVIDUAL_TAXPAYER_IDENTIFICATION_NUMBER instead
   */
  ITIN = "ITIN",
  /** Social Security Number */
  SOCIAL_SECURITY_NUMBER = "SOCIAL_SECURITY_NUMBER",
  /**
   * Social Security Number
   * @deprecated Use SOCIAL_SECURITY_NUMBER instead
   */
  SSN = "SSN",
}

/** The possible values for attendance at the terminal. */
export enum TerminalAttendance {
  /** The terminal was attended */
  ATTENDED = "ATTENDED",
  /** The terminal was unattended */
  UNATTENDED = "UNATTENDED",
}

/** The input to terminate a card digital wallet token. */
export type TerminateCardDigitalWalletTokenInput = {
  /** The ID of the card digital wallet token to terminate. */
  cardDigitalWalletTokenId: Scalars["ID"];
  /** The reason for the card digital wallet token to be terminated. */
  reason: TerminateCardDigitalWalletTokenReason;
};

/** The return types when terminating a card digital wallet token. */
export type TerminateCardDigitalWalletTokenPayload =
  | AccessDeniedError
  | CardDigitalWalletToken
  | UserError;

/** Reasons for a card digital wallet token to be terminated. */
export enum TerminateCardDigitalWalletTokenReason {
  /** Account holder has been deleted. */
  ACCOUNT_HOLDER_DELETED = "ACCOUNT_HOLDER_DELETED",
  /** Device is reported as lost. */
  DEVICE_LOST = "DEVICE_LOST",
  /** Device is reported as stolen. */
  DEVICE_STOLEN = "DEVICE_STOLEN",
  /** Fraudulent transactions have been reported by `Highnote` or the account holder. */
  FRAUDULENT_TRANSACTIONS = "FRAUDULENT_TRANSACTIONS",
  /** Any other reason for terminating the card digital wallet token. */
  OTHER = "OTHER",
}

/** Timestamp value type in ISO 8601 format */
export type TimestampFilterInput = {
  between?: InputMaybe<TimestampFilterInputRange>;
  equals?: InputMaybe<Scalars["String"]>;
  greaterThan?: InputMaybe<Scalars["String"]>;
  greaterThanOrEquals?: InputMaybe<Scalars["String"]>;
  lessThan?: InputMaybe<Scalars["String"]>;
  lessThanOrEquals?: InputMaybe<Scalars["String"]>;
  notEquals?: InputMaybe<Scalars["String"]>;
};

/** Timestamp value range in ISO 8601 format */
export type TimestampFilterInputRange = {
  end?: InputMaybe<Scalars["String"]>;
  start?: InputMaybe<Scalars["String"]>;
};

/** Possible scope of the token. */
export enum TokenScope {
  /** E-Commerce scope. */
  ECOMMERCE = "ECOMMERCE",
}

/** The type of application where a digital wallet token is provisioned for use. */
export enum TokenUserApplicationType {
  /** Token provisioned for use with biometric authentication. */
  BIOMETRIC_APPLICATION = "BIOMETRIC_APPLICATION",
  /** Token provisioned for use in a marketplace or third-party application. */
  MARKETPLACE_APPLICATION = "MARKETPLACE_APPLICATION",
  /** Token provisioned for use in a native mobile application (iOS/Android). */
  MOBILE_APPLICATION = "MOBILE_APPLICATION",
  /** Token provisioned for use in a mobile web browser application. */
  MOBILE_WEB = "MOBILE_WEB",
  /** Token provisioned for use in a voice-activated application. */
  VOICE_APPLICATION = "VOICE_APPLICATION",
  /** Token provisioned for use in a web browser application. */
  WEB = "WEB",
}

/** Input representing parts of an address for tokenization. */
export type TokenizeAddressInput = {
  /** The [three letter country code](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3) where the address resides. */
  countryCodeAlpha3?: InputMaybe<Scalars["String"]>;
  /**
   * Additional data about the address, e.g. apartment or unit numbers.
   *
   * The validation for the `extendedAddress` uses the following regex pattern `^[a-zA-Z\d',. \-#]+(([',. \-#][a-zA-Z ])?[a-zA-Z.]*)*$`.
   *
   * It checks for numeric string with special characters and whitespace.
   */
  extendedAddress?: InputMaybe<Scalars["String"]>;
  /**
   * The locality of the address (e.g. town, city)
   *
   * The validation for the `locality` uses the following regex pattern `^['\p{L}]+(?:[ \p{L},'-:])*$`.
   *
   * It checks to ensure it begins with a single quote or any letter, followed by whitespace, commas, single quote, any letter, or character in this set '()*+,-./0123456789: .
   */
  locality?: InputMaybe<Scalars["String"]>;
  /** The postal code of the address.  The value can include 5 numbers only or a hyphen - and 4 numbers */
  postalCode: Scalars["String"];
  /** A region for the address based on the two letter state [IS0 3166 standard](https://en.wikipedia.org/wiki/ISO_3166-2:US), including districts and outlying areas. */
  region?: InputMaybe<Scalars["String"]>;
  /**
   * The number and street of the address.
   *
   * The validation for the `address` uses the following regex pattern `^\s*\S+(?:\s+\S+){1,3} `.
   *
   * This pattern matches two to four groups of non-whitespace characters. These can include special characters like dashes or slashes. For example, 'Cozy Cottage', '200 Lake Road', '123 Second Street NW', and '111 1/2 Center Street' all match.
   *
   * When the field is used for creating an application, it will also validate that a PO Box is not included using this regex pattern `^(?:((\S([^pPOo])+)|(?:[0-9]+)))\s(?:[0-9A-Za-z\.]|[^\S\r\n])+$`.
   */
  streetAddress?: InputMaybe<Scalars["String"]>;
};

/** Input for tokenizing a card payment method's card holder information. */
export type TokenizeCardPaymentMethodCardHolderInput = {
  /** The billing address associated with the card. */
  billingAddress?: InputMaybe<TokenizeAddressInput>;
  /** The e-mail address associated to the card. */
  email?: InputMaybe<Scalars["String"]>;
  /**
   * The full name as represented on the card.
   * **Minimum length:** 1 character
   * **Maximum length:** 255 characters
   */
  fullName?: InputMaybe<Scalars["String"]>;
  /** The name of the cardholder, represented in different parts. */
  name?: InputMaybe<NameInput>;
  /** The phone number associated to the card. */
  phoneNumber?: InputMaybe<TokenizePhoneInput>;
};

/** Input for tokenizing a payment card. */
export type TokenizeCardPaymentMethodInput = {
  /** The cardHolder to associate the tokenized payment card with. */
  cardHolder?: InputMaybe<TokenizeCardPaymentMethodCardHolderInput>;
  /** The payment card to tokenize. */
  paymentCard: PaymentCardInput;
};

/** Result of tokenizing a payment card. */
export type TokenizeCardPaymentMethodPayload =
  | AccessDeniedError
  | PaymentMethodToken
  | UserError;

/** Input representing parts of a phone number for tokenization. */
export type TokenizePhoneInput = {
  /** The assigned country code for the number. */
  countryCode: Scalars["String"];
  /** A number representing a specific phone on the same number as the main line. */
  extension?: InputMaybe<Scalars["String"]>;
  /** The phone number in a country specific format. */
  number: Scalars["String"];
};

/** Response type for tokenizing a USBusinessAccountHolder. */
export type TokenizeUsBusinessAccountHolderPayload =
  | AccessDeniedError
  | UsBusinessAccountHolderToken
  | UserError;

/** Response type for tokenizing a USPersonAccountHolder. */
export type TokenizeUsPersonAccountHolderPayload =
  | AccessDeniedError
  | UsPersonAccountHolderToken
  | UserError;

/** Response type for tokenizing a USPersonAuthorizedUser. */
export type TokenizeUsPersonAuthorizedUserPayload =
  | AccessDeniedError
  | UsPersonAuthorizedUserToken;

/** The possible types of transactions. */
export type Transaction = CreditTransaction | DebitTransaction;

/** The response code provided on an advice message. */
export enum TransactionAdviceEventResponseCode {
  /** The event was approved. */
  APPROVED = "APPROVED",
  /** The event was declined. */
  DO_NOT_HONOR = "DO_NOT_HONOR",
  /** The event was declined for suspected fraud. */
  SUSPECTED_FRAUD = "SUSPECTED_FRAUD",
}

/** Describes attributes of a transaction metric. */
export type TransactionBusinessMetricAttribute = {
  __typename?: "TransactionBusinessMetricAttribute";
  /** The amount field attributes of a transaction. */
  amount?: Maybe<Amount>;
  /** The count field attributes of a transaction. */
  count?: Maybe<Scalars["UnsignedInt"]>;
};

export type TransactionEvent = {
  /**
   * The direction funds are moving in the perspective of the cardholder.
   *
   * * when DEBIT, funds are moving out of the cardholder's account
   * * when CREDIT, funds are moving into the cardholder's account
   */
  accountingDirection?: Maybe<AccountingDirection>;
  /** Network specific transaction data. */
  additionalNetworkData?: Maybe<AdditionalNetworkData>;
  /** The `Amount` approved for this `TransactionEvent` and posted in the settlement currency. Does not include fees. */
  approvedAmount?: Maybe<Amount>;
  /** The `CardProduct` associated to the `TransactionEvent`. */
  cardProduct?: Maybe<CardProduct>;
  /** The date and time, in ISO 8601 format, this `ReversalEvent` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The `Amount` available to spend after this transaction event. */
  currentFinancialAccountAvailableToSpendAmount?: Maybe<Amount>;
  /** Maximum balance allowed for the card account at the time of this transaction event */
  currentFinancialAccountMaximumBalanceAmount?: Maybe<Amount>;
  /** Globally unique id of the `TransactionEvent. */
  id: Scalars["ID"];
  /**
   * The response code from the card network (e.g. Mastercard).
   * @deprecated Use responseCode instead
   */
  networkResponseCode?: Maybe<Scalars["String"]>;
  /**
   * The transaction ID from the card network (e.g. Mastercard).
   * @deprecated No longer supported
   */
  networkTransactionId?: Maybe<Scalars["ID"]>;
  /** The `PaymentCard` associated to the `TransactionEvent`. */
  paymentCard?: Maybe<PaymentCard>;
  /** The Point Of Service Details. */
  pointOfServiceDetails?: Maybe<PointOfServiceDetails>;
  /** The Highnote response code. */
  responseCode?: Maybe<TransactionEventResponseCode>;
  /** The associated Transaction. */
  transaction?: Maybe<Transaction>;
  /** Represents the customer transaction type being processed. */
  transactionProcessingType?: Maybe<CardTransactionProcessingType>;
};

/** The connection type for `TransactionEvent`. */
export type TransactionEventConnection = {
  __typename?: "TransactionEventConnection";
  /** A list of edges. */
  edges?: Maybe<Array<TransactionEventEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a `TransactionEvent`. */
export type TransactionEventEdge = {
  __typename?: "TransactionEventEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The Transaction Event. */
  node?: Maybe<TransactionEvent>;
};

/** The filters used to scope the type of TransactionEvents returned. */
export enum TransactionEventFilter {
  /** Scope the results to contain `AdjustmentEvent`. */
  ADJUSTMENT_EVENT = "ADJUSTMENT_EVENT",
  /** Scope the results to contain `AuthorizationAndClearEvent`. */
  AUTHORIZATION_AND_CLEAR_EVENT = "AUTHORIZATION_AND_CLEAR_EVENT",
  /** Scope the results to contain `AuthorizationEvent`. */
  AUTHORIZATION_EVENT = "AUTHORIZATION_EVENT",
  /** Scope the results to contain `BalanceInquiryEvent`. */
  BALANCE_INQUIRY_EVENT = "BALANCE_INQUIRY_EVENT",
  /** Scope the results to contain `ClearingEvent`. */
  CLEARING_EVENT = "CLEARING_EVENT",
  /** Scope the results to contain `EnhancedDataEvent`. */
  ENHANCED_DATA_EVENT = "ENHANCED_DATA_EVENT",
  /** Scope the results to contain `IssuerPreliminaryAuthorizationEvent`. */
  ISSUER_PRELIMINARY_AUTHORIZATION_EVENT = "ISSUER_PRELIMINARY_AUTHORIZATION_EVENT",
  /** Scope the results to contain `ReversalEvent`. */
  REVERSAL_EVENT = "REVERSAL_EVENT",
  /** Scope the results to contain `VerificationEvent`. */
  VERIFICATION_EVENT = "VERIFICATION_EVENT",
}

/** TransactionEventFilter value type */
export type TransactionEventFilterInput = {
  equals?: InputMaybe<TransactionEventFilter>;
  excludes?: InputMaybe<Array<TransactionEventFilter>>;
  includes?: InputMaybe<Array<TransactionEventFilter>>;
  notEquals?: InputMaybe<TransactionEventFilter>;
};

/** The Highnote provided response code. */
export enum TransactionEventResponseCode {
  /** A catchall for all approved `TransactionEventResponseCode` values */
  ALL_APPROVED_CODES = "ALL_APPROVED_CODES",
  /** A catchall for all issuer declined `TransactionEventResponseCode` values */
  ALL_ISSUER_DECLINED_CODES = "ALL_ISSUER_DECLINED_CODES",
  /** The event was approved. */
  APPROVED = "APPROVED",
  /** The event was approved for only part of the requested amount. */
  APPROVED_FOR_PARTIAL_AMOUNT = "APPROVED_FOR_PARTIAL_AMOUNT",
  /** The event was approved for only the purchase portion of requested amount. */
  APPROVED_FOR_PURCHASE_AMOUNT_ONLY = "APPROVED_FOR_PURCHASE_AMOUNT_ONLY",
  /** The event was declined because the provided CVC3 code was not valid. */
  BAD_CVC3 = "BAD_CVC3",
  /** The event was declined because the provided CVV code was not valid. */
  BAD_CVV = "BAD_CVV",
  /** The event was declined because the provided CVV2 code was not valid. */
  BAD_CVV2 = "BAD_CVV2",
  /** The event was declined because the `PaymentCard` is blocked from transacting. */
  BLOCKED_CARD = "BLOCKED_CARD",
  /** Cash request exceeded issuer or approved limit. */
  CASH_BACK_LIMIT_EXCEEDED = "CASH_BACK_LIMIT_EXCEEDED",
  /** The event was declined by the Collaborative Authorization Partner */
  CA_DECLINED = "CA_DECLINED",
  /** The Authorization Request Cryptogram (ARQC) validation failed for a chip card transaction. */
  CHIP_CARD_ARQC_VALIDATION_FAILURE = "CHIP_CARD_ARQC_VALIDATION_FAILURE",
  /** The account was closed at the time of event. */
  CLOSED_ACCOUNT = "CLOSED_ACCOUNT",
  /**
   * The event was declined due to enforcement of internal rules such as spend controls.
   * The `Amount` on this event will not be applied to the balance of the card and any clearing event will not move money.
   */
  DO_NOT_HONOR = "DO_NOT_HONOR",
  /** Purchase or withdrawal amount exceeded issuer or approved limit over a set period of time. */
  EXCEEDS_APPROVAL_AMOUNT_LIMIT = "EXCEEDS_APPROVAL_AMOUNT_LIMIT",
  /** The event was declined because number of transaction exceeded the issuer or approved limit over a set period of time. */
  EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT = "EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT",
  /** The card was expired at the time of event. */
  EXPIRED_CARD = "EXPIRED_CARD",
  /** The expiration date provided does not match the expiration date assigned to the Payment Card. */
  INCORRECT_EXPIRATION_DATE = "INCORRECT_EXPIRATION_DATE",
  /** The pin provided for this event was incorrect */
  INCORRECT_PIN = "INCORRECT_PIN",
  /** The card had insufficient funds at the time of event. */
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  /** The event was declined because the 3-D Secure (3DS) Authentication failed. */
  INVALID_3DS_VERIFICATION = "INVALID_3DS_VERIFICATION",
  /** The event was declined because the provided authorization expiration is invalid. */
  INVALID_AUTHORIZATION_EXPIRATION = "INVALID_AUTHORIZATION_EXPIRATION",
  /** The card number provided for this event was invalid. */
  INVALID_CARD_NUMBER = "INVALID_CARD_NUMBER",
  /** The event was declined because the merchant is not authorized for this card. */
  INVALID_MERCHANT = "INVALID_MERCHANT",
  /** The verification data for a payment card is invalid. */
  INVALID_TRACK_DATA = "INVALID_TRACK_DATA",
  /**
   * The event was declined because of incorrect information or faulty operation, including trying to refund a refund.
   * A generic catch-all response code for a transaction that cannot be declined under other specific response codes.
   */
  INVALID_TRANSACTION = "INVALID_TRANSACTION",
  /** The card provided was not on file with Highnote. */
  NO_CARD_RECORD = "NO_CARD_RECORD",
  /** The event was declined because the PIN decryption failed due to technical error. */
  PIN_DECRYPTION_ERROR = "PIN_DECRYPTION_ERROR",
  /** The pre-authorization expiration date for a transaction passed. */
  PRE_AUTHORIZATION_EXPIRED = "PRE_AUTHORIZATION_EXPIRED",
  /** Indicates the transaction was declined based on a real-time risk assessment decision. */
  REAL_TIME_RISK_DECISION_DECLINE = "REAL_TIME_RISK_DECISION_DECLINE",
  /** The card is restricted in the region or country. */
  RESTRICTED_LOCATION = "RESTRICTED_LOCATION",
  /** The event was declined because the transaction temporarily cannot be processed due to Address Verification failure or enforcement of internal rules such as spend controls. */
  RE_ENTER_TRANSACTION = "RE_ENTER_TRANSACTION",
  /** The event was declined due to special condition - new card not activated or card is temporarily blocked. */
  SPECIAL_CONDITION_NO_PICK_UP = "SPECIAL_CONDITION_NO_PICK_UP",
  /** The event was declined because the card provided has been suspended. */
  SUSPENDED_CARD = "SUSPENDED_CARD",
  /** The event was declined because the digital wallet token for the `PaymentCard` is suspended. */
  SUSPENDED_DIGITAL_WALLET_TOKEN = "SUSPENDED_DIGITAL_WALLET_TOKEN",
  /** The event was declined because the card provided has been terminated. */
  TERMINATED_CARD = "TERMINATED_CARD",
  /** The event was declined because the digital wallet token for the `PaymentCard` is terminated. */
  TERMINATED_DIGITAL_WALLET_TOKEN = "TERMINATED_DIGITAL_WALLET_TOKEN",
  /** The event was declined due to a permanent restriction placed at the program or account level. This may be due to enforcement of internal rules such as spend controls. */
  TRANSACTION_NOT_PERMITTED = "TRANSACTION_NOT_PERMITTED",
  /** The event was declined because it is not supported by the `PaymentCard`’s Program. */
  TRANSACTION_NOT_SUPPORTED = "TRANSACTION_NOT_SUPPORTED",
  /** The event was declined because the card provided has not been activated. */
  UNACTIVATED_CARD = "UNACTIVATED_CARD",
  /** The event was declined because the digital wallet token for the `PaymentCard` is not activated. */
  UNACTIVATED_DIGITAL_WALLET_TOKEN = "UNACTIVATED_DIGITAL_WALLET_TOKEN",
  /** The account is valid but had insufficient funds for the anticipated amount. */
  VALID_ACCOUNT_AMOUNT_NOT_SUPPORTED = "VALID_ACCOUNT_AMOUNT_NOT_SUPPORTED",
}

/** Input for filtering transaction event response code */
export type TransactionEventResponseCodeFilterInput = {
  /** Value matches the provided transaction event response code. */
  equals?: InputMaybe<TransactionEventResponseCode>;
  /** Value does not match any of the provided transaction event response code. */
  excludes?: InputMaybe<Array<TransactionEventResponseCode>>;
  /** Value exactly matches all of the provided transaction event response code. */
  includes?: InputMaybe<Array<TransactionEventResponseCode>>;
  /** Value does not match the provided transaction event response code. */
  notEquals?: InputMaybe<TransactionEventResponseCode>;
};

/** Inputs for filtering transaction events. */
export type TransactionEventsFilterInput = {
  approvedAmount?: InputMaybe<MoneyFilterInput>;
  /** Authorization expiration date */
  authorizationExpiration?: InputMaybe<TimestampFilterInput>;
  avsResponseCode?: InputMaybe<AvsResponseCodeFilterInput>;
  cardProductId?: InputMaybe<IdFilterInput>;
  createdAt?: InputMaybe<TimestampFilterInput>;
  cvvResponseCode?: InputMaybe<CvvResponseCodeFilterInput>;
  eventType?: InputMaybe<TransactionEventFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  merchantDetails?: InputMaybe<MerchantDetailsFilterInput>;
  /**
   * Open authorizations events have the following properties:
   * * Are the first transaction event with a particular public transaction
   * identifier. This means they are the first event in a sequence of events with
   * the same public transaction identifier.
   * * Authorization expiration date is not empty and not in the past.
   * * The approved amount has not been fully reversed or cleared to zero by
   * subsequent transaction events with the same public transaction identifier.
   */
  onlyOpenAuthorizations?: InputMaybe<BooleanFilterInput>;
  operationalCurrency?: InputMaybe<Iso4217Alpha3CurrencyCode>;
  paymentCardId?: InputMaybe<IdFilterInput>;
  postalCodeResponseCode?: InputMaybe<PostalCodeResponseCodeFilterInput>;
  requestedAmount?: InputMaybe<MoneyFilterInput>;
  responseCode?: InputMaybe<TransactionEventResponseCodeFilterInput>;
  transactionId?: InputMaybe<IdFilterInput>;
  transactionType?: InputMaybe<TransactionTypeFilterInput>;
  updatedAt?: InputMaybe<TimestampFilterInput>;
};

/** Details about a fee applied to a transaction. */
export type TransactionFee = {
  __typename?: "TransactionFee";
  /** The approved fee amount. Note that requestedFeeAmount and approvedFeeAmount may be different currencies. */
  approvedFeeAmount?: Maybe<Amount>;
  /** The requested fee amount. Note that requestedFeeAmount and approvedFeeAmount may be different currencies. */
  requestedFeeAmount?: Maybe<Amount>;
  /** The type of fee charged. */
  transactionFeeType?: Maybe<TransactionFeeType>;
};

/** Details about a fee applied to a simulated transaction. */
export type TransactionFeeInput = {
  /** The approved fee amount. Note that requestedFeeAmount and approvedFeeAmount may be different currencies. */
  approvedFeeAmount: AmountInput;
  /** The requested fee amount. Note that requestedFeeAmount and approvedFeeAmount may be different currencies. */
  requestedFeeAmount: AmountInput;
  /** The type of fee charged. */
  transactionFeeType: TransactionFeeType;
};

/** The type of fee that was applied to a transaction. */
export enum TransactionFeeType {
  /** A surcharge fee applied to a transaction such as an ATM network charge for a cash withdrawal or balance inquiry. */
  SURCHARGE = "SURCHARGE",
}

/** Inputs for filtering `TransactionSearchResults`. */
export type TransactionSearchFilterInput = {
  /** Used to search using the Highnote `SearchQueryLanguage`. */
  searchQueryLanguage?: InputMaybe<SearchQueryLanguageInput>;
};

/**
 * A more granular logical grouping that different transaction objects are categorized
 * as to narrow searches down even further than `TransactionSearchType`.
 */
export enum TransactionSearchObjectType {
  ACH_TRANSFER = "ACH_TRANSFER",
  CARD_TRANSACTION = "CARD_TRANSACTION",
  CHECK_PAYMENT = "CHECK_PAYMENT",
  DISBURSEMENT = "DISBURSEMENT",
  INSTANT_NETWORK_TRANSFER = "INSTANT_NETWORK_TRANSFER",
  INSTANT_SETTLEMENT_TRANSACTION = "INSTANT_SETTLEMENT_TRANSACTION",
  /** @deprecated Use INTER_FINANCIAL_ACCOUNT_TRANSFER instead. */
  INTERNAL_ACCOUNT_TRANSFER = "INTERNAL_ACCOUNT_TRANSFER",
  INTER_FINANCIAL_ACCOUNT_TRANSFER = "INTER_FINANCIAL_ACCOUNT_TRANSFER",
  MANUAL_ADJUSTMENT = "MANUAL_ADJUSTMENT",
  RTP_TRANSFER = "RTP_TRANSFER",
  WIRE_TRANSFER = "WIRE_TRANSFER",
}

/**
 * Represents a normalized object that has common fields shared
 * across all `Transaction` and `TransactionEvent` types
 */
export type TransactionSearchResult = {
  __typename?: "TransactionSearchResult";
  /** The amount of the transaction. */
  amount?: Maybe<Amount>;
  /**
   * The unique identifier for the search result object. This value corresponds
   * to a Node that can be queried for more information.
   */
  source?: Maybe<TransactionSearchSource>;
  /** The status of the `TransactionSearchResult`. */
  status?: Maybe<TransactionSearchStatus>;
  /** The search object type that this search result is categorized as. */
  transactionSearchObjectType?: Maybe<TransactionSearchObjectType>;
  /** The search type that this search result is categorized as. */
  transactionSearchType?: Maybe<TransactionSearchType>;
};

/** The connection type for `TransactionSearchResult` */
export type TransactionSearchResultConnection = {
  __typename?: "TransactionSearchResultConnection";
  /** A list of edges. */
  edges?: Maybe<Array<TransactionSearchResultEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for `TransactionSearchResult` */
export type TransactionSearchResultEdge = {
  __typename?: "TransactionSearchResultEdge";
  /** The cursor for this edge for use in pagination. */
  cursor?: Maybe<Scalars["String"]>;
  /** The search result. */
  node?: Maybe<TransactionSearchResult>;
};

export type TransactionSearchResultPayload =
  | AccessDeniedError
  | TransactionSearchResultConnection
  | UserError;

export type TransactionSearchSource =
  | AdjustmentEvent
  | AuthorizationAndClearEvent
  | AuthorizationEvent
  | BalanceInquiryEvent
  | CheckPayment
  | CheckPaymentEvent
  | ClearingEvent
  | CreditFunds
  | CreditFundsAchTransferEvent
  | DebitFunds
  | DebitFundsAchTransferEvent
  | DisbursementTransferEvent
  | EnhancedDataEvent
  | ExternallyInitiatedWireTransfer
  | InstantNetworkTransfer
  | InstantNetworkTransferEvent
  | InstantSettlementTransaction
  | InstantSettlementTransactionEvent
  | IntegratorInitiatedFundsDepositAchTransfer
  | IntegratorInitiatedFundsDepositAchTransferEvent
  | IntegratorInitiatedFundsWithdrawalAchTransfer
  | IntegratorInitiatedFundsWithdrawalAchTransferEvent
  | InterFinancialAccountTransfer
  | IssuerPreliminaryAuthorizationEvent
  | ManualAdjustmentEvent
  | NonOriginatedAchTransfer
  | OriginatedAchTransfer
  | OriginatedRtpTransfer
  | OriginatedRtpTransferEvent
  | PayrollAchTransferEvent
  | PayrollTransfer
  | ReversalEvent
  | SecureCardBalanceRepaymentAchTransfer
  | SecureCardBalanceRepaymentAchTransferEvent
  | SecureDeposit
  | SecureDepositAchTransfer
  | SecureDepositAchTransferEvent
  | SecureDepositTransferEvent
  | Transfer
  | VerificationEvent
  | WireTransfer;

/** A normalized status value that is shared across transaction types. */
export enum TransactionSearchStatus {
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  PENDING = "PENDING",
}

/**
 * A top level logical grouping that different transaction objects are categorized
 * as to make searching across transaction types easier.
 */
export enum TransactionSearchType {
  ACTIVITY = "ACTIVITY",
  EVENT = "EVENT",
  TRANSACTION = "TRANSACTION",
}

/** The filters used to scope TransactionEvents to specific types of Transactions. */
export enum TransactionTypeFilter {
  /** Scope the results to contain types related to `CreditTransaction`. */
  CREDIT = "CREDIT",
  /** Scope the results to contain types related to `DebitTransaction`. */
  DEBIT = "DEBIT",
}

/** Input for filtering transaction type */
export type TransactionTypeFilterInput = {
  /** Value matches the provided transaction type */
  equals?: InputMaybe<TransactionTypeFilter>;
  /** Value does not match any of the provided transaction type */
  excludes?: InputMaybe<Array<TransactionTypeFilter>>;
  /** Value exactly matches all of the provided transaction type */
  includes?: InputMaybe<Array<TransactionTypeFilter>>;
  /** Value does not match the provided transaction type */
  notEquals?: InputMaybe<TransactionTypeFilter>;
};

/**
 * A movement of money within the Highnote platform.
 *
 * DEPRECATED: Use type ElectronicFundsTransfer instead.
 */
export type Transfer = Node & {
  __typename?: "Transfer";
  /** The amount of the Transfer. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, the Transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the Transfer in operations. */
  id: Scalars["ID"];
  /** The ledgers affected by the transfer. */
  ledgers?: Maybe<Array<Ledger>>;
  /** The current status of the Transfer. */
  status?: Maybe<TransferStatus>;
  /** The reason for the current status. */
  statusReason?: Maybe<TransferStatusReasonCode>;
  /** The date and time, in ISO 8601 format, the Transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/**
 * A movement of money within the Highnote platform.
 *
 * DEPRECATED: Use type ElectronicFundsTransfer instead.
 */
export type TransferLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** Input to consent to the transfer agreement. */
export type TransferAgreementConsentInput = {
  /** The ID of the individual who is authorizing the transfer */
  authorizedPersonId: Scalars["ID"];
  /**
   * The date and time, in ISO 8601 format, marking when the primary authorized person or person account holder gave consent for the transfer.
   *
   * For example, `2022-01-01T22:00:00.000Z`.
   */
  consentTimestamp: Scalars["String"];
  /** The template of the consent */
  template: TransferAgreementConsentTemplateInput;
};

/** The template of the transfer agreement consent. */
export type TransferAgreementConsentTemplateInput = {
  /** The id indicating which consent was recorded. */
  consentTemplateId: Scalars["String"];
  /** The version of the template id. */
  consentTemplateVersion: Scalars["String"];
};

/** The strategy used to calculate the amount to be transferred */
export type TransferAmountCalculation = {
  __typename?: "TransferAmountCalculation";
  /** The type used to calculate the total amount to be transferred */
  calculatedType?: Maybe<CalculatedTransferAmountType>;
};

export type TransferAmountStrategy =
  | ManualTransferAmount
  | TransferAmountCalculation;

/** The transfer balance strategy for a transfer */
export enum TransferBalanceAmountCode {
  /** The minimum payment due from the latest statement billing period */
  MINIMUM_PAYMENT = "MINIMUM_PAYMENT",
  /** The outstanding balance on the account */
  OUTSTANDING_BALANCE = "OUTSTANDING_BALANCE",
  /** The remaining balance due from the latest statement billing period */
  OUTSTANDING_STATEMENT_BALANCE = "OUTSTANDING_STATEMENT_BALANCE",
}

/** The date strategy for a transfer */
export enum TransferDateCode {
  /**
   * The payment due date. This represents the payment due date of the next available statement. For accounts that have closed statements,
   * this will be the latest closed statement; for other accounts, it will be the current open statement.
   */
  PAYMENT_DUE_DATE = "PAYMENT_DUE_DATE",
}

/** A strategy for scheduling the transfer date. Only one of the strategies below should be requested. */
export type TransferDateStrategyInput = {
  /**
   * The date, in ISO 8601 format, the transfer should be scheduled.
   *
   * **Note: ** One time payments cannot be scheduled more than 90 days in advance.
   */
  transferDate?: InputMaybe<Scalars["String"]>;
  /** A calculated day to schedule the transfer, such as the payment due date from the next available statement. */
  transferDateCalculationType?: InputMaybe<TransferDateCode>;
};

/** A strategy for scheduling the transfer day. Only one of the strategies below should be requested. */
export type TransferDayStrategyInput = {
  /**
   * A calculated day to schedule the transfer, such as the payment due date. For payment due date,
   * each time a transfer completes the system will determine the day for the next transfer
   * based on the payment due date of the latest closed statement.
   */
  transferDayCalculationType?: InputMaybe<TransferDateCode>;
  /**
   * The day of the month to schedule the transfer
   *
   * **Note: ** The scheduled day of transfer should fall between the 1st and the 28th.
   */
  transferDayOfMonth?: InputMaybe<Scalars["UnsignedInt"]>;
};

/** Additional details for bank-to-bank transfers (RTP, ACH). */
export type TransferFundsBankTransferDetailsInput = {
  /**
   * Transfer agreement consent information.
   * Required when the end user must authorize the transfer.
   */
  consent: TransferAgreementConsentInput;
  /**
   * This field contains payment-related information provided by the originator of the transaction.
   * It can include free-form text, structured data, or codes. The field supports alphanumeric characters,
   * including the following symbols: ! " & ' ( ) \* + , - . / : ; ? = % ~ @ [ ] { } \\ | < > # $.
   *
   * **Example:** Invoice 0123456789 Payment 999.99 USD
   *
   * Please note that payment-related information may or may not be displayed to the recipient. Availability and presentation depend on the receiving financial institution's system capabilities and the access channel used (e.g., online banking, mobile banking, account statement, or integrated receivables systems).
   */
  paymentRelatedInformation: Scalars["String"];
};

/** Destination for a direct transfer. */
export type TransferFundsDestinationInput = {
  /**
   * The amount of funds to deposit at the destination.
   * If provided, source.amount will be calculated based on fees.
   */
  amount?: InputMaybe<AmountInput>;
  /** Additional details for bank-to-bank transfers (RTP, ACH). */
  bankTransferDetails?: InputMaybe<TransferFundsBankTransferDetailsInput>;
  /** A Highnote `Node` ID to transfer funds to. */
  id?: InputMaybe<Scalars["ID"]>;
  /** Raw US bank account details (account/routing number). */
  usBankAccount?: InputMaybe<TransferFundsUsBankAccountInput>;
};

/**
 * Input for `transferFunds` mutation.
 *
 * One of `source.amount` or `destination.amount` must be provided, but not both.
 * The other amount will be calculated based on the remaining amount after fees.
 */
export type TransferFundsInput = {
  /** Destination for the funds. Required when quoteId is not provided. */
  destination?: InputMaybe<TransferFundsDestinationInput>;
  /** External identifier for tracking in your system (max 255 chars). */
  externalIdentifier?: InputMaybe<Scalars["String"]>;
  /**
   * Idempotency key to prevent duplicate transfers.
   * Must be a valid UUID v4.
   */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /** Optional memo/description for the transfer. */
  memo?: InputMaybe<Scalars["String"]>;
  /** Optional: a previously created quote ID to use for this transfer instead of creating new quotes. */
  quoteId?: InputMaybe<Scalars["ID"]>;
  /** Source of funds for the transfer. Required when quoteId is not provided. */
  source?: InputMaybe<TransferFundsSourceInput>;
  /** Payment strategy configuration. */
  strategy?: InputMaybe<TransferFundsPaymentStrategyInput>;
};

/** The possible results of `transferFunds`. */
export type TransferFundsPayload =
  | AccessDeniedError
  | UnifiedFundsTransfer
  | UserError;

/** Payment rail preferences. */
export enum TransferFundsPaymentPreference {
  /** Instant Network Transfer - fast push-to-card payments via card networks. */
  INSTANT_NETWORK_TRANSFER = "INSTANT_NETWORK_TRANSFER",
  /** Real-Time Payments - fastest, typically seconds. */
  RTP = "RTP",
}

/** Payment strategy configuration. */
export type TransferFundsPaymentStrategyInput = {
  /**
   * Ordered list of payment preferences.
   *
   * The system evaluates each preference in order and uses the first one that is
   * supported for the given source and destination combination.
   *
   * If no preference in the list is supported for the source and destination,
   * the request will fail with a `USER_ERROR` indicating which payment strategies
   * are supported for the given input.
   *
   * If not specified, the request will fail with a `USER_ERROR` indicating which
   * payment strategies are supported for the given input.
   *
   * **Examples**:
   * - `[RTP]` => Uses RTP if supported, otherwise fails with supported strategies
   * - `[RTP, INSTANT_NETWORK_TRANSFER]` => Uses RTP if supported, otherwise Instant Network Transfer if supported
   */
  preferredPaymentStrategy?: InputMaybe<Array<TransferFundsPaymentPreference>>;
};

/** Source of funds for a direct transfer. */
export type TransferFundsSourceInput = {
  /**
   * The amount of funds to transfer from the source.
   * If provided, destination.amount will be calculated based on fees.
   */
  amount?: InputMaybe<AmountInput>;
  /** Additional details for bank-to-bank transfers (RTP, ACH). */
  bankTransferDetails?: InputMaybe<TransferFundsBankTransferDetailsInput>;
  /** A Highnote `Node` ID to transfer funds from. */
  id?: InputMaybe<Scalars["ID"]>;
  /** Raw US bank account details (account/routing number). */
  usBankAccount?: InputMaybe<TransferFundsUsBankAccountInput>;
};

/** Raw US bank account input. */
export type TransferFundsUsBankAccountInput = {
  /** Bank account number. */
  accountNumber: Scalars["String"];
  /** Type of bank account. */
  accountType: BankAccountType;
  /** Account holder's first name. */
  firstName: Scalars["String"];
  /** Account holder's last name. */
  lastName: Scalars["String"];
  /** Account holder's middle name (optional). */
  middleName?: InputMaybe<Scalars["String"]>;
  /** Bank routing number (ABA). */
  routingNumber: Scalars["String"];
};

/** Purpose for the transfer. */
export enum TransferPurpose {
  /** Transfer for adjustment. */
  ADJUSTMENT = "ADJUSTMENT",
  /** Decreasing the pseudo balance for a `FinancialAccount`. */
  DECREASE_PSEUDO_BALANCE = "DECREASE_PSEUDO_BALANCE",
  /** Decreasing an existing pseudo limit for a `FinancialAccount`. */
  DECREASE_PSEUDO_LIMIT = "DECREASE_PSEUDO_LIMIT",
  /** Transfer for earned credits. */
  EARNED_CREDIT = "EARNED_CREDIT",
  /** Reverse earned credit transfer. */
  EARNED_CREDIT_REVERSAL = "EARNED_CREDIT_REVERSAL",
  /** Transfer for general purpose. */
  GENERAL = "GENERAL",
  /** Transfer for goods and services. */
  GOODS_AND_SERVICES = "GOODS_AND_SERVICES",
  /** Increasing the pseudo balance for a `FinancialAccount`. */
  INCREASE_PSEUDO_BALANCE = "INCREASE_PSEUDO_BALANCE",
  /** Increasing an existing pseudo limit for a `FinancialAccount`. */
  INCREASE_PSEUDO_LIMIT = "INCREASE_PSEUDO_LIMIT",
  /** Intra company transfer */
  INTRA_COMPANY = "INTRA_COMPANY",
  /** transfer for issuer balance migration. */
  ISSUER_BALANCE_MIGRATION = "ISSUER_BALANCE_MIGRATION",
  /** Transfer for merchant payout. */
  MERCHANT_PAYOUT = "MERCHANT_PAYOUT",
  /** Transfer for payout. */
  PAYOUT = "PAYOUT",
  /** Transfer for payroll. */
  PAYROLL = "PAYROLL",
  /** Transfer for payroll advance. */
  PAYROLL_ADVANCE = "PAYROLL_ADVANCE",
  /** Transfer for payroll advance repayment. */
  PAYROLL_ADVANCE_REPAYMENT = "PAYROLL_ADVANCE_REPAYMENT",
  /** Transfer for payroll advance repayment reversal. */
  PAYROLL_ADVANCE_REPAYMENT_REVERSAL = "PAYROLL_ADVANCE_REPAYMENT_REVERSAL",
  /** Transfer for payroll advance reversal. */
  PAYROLL_ADVANCE_REVERSAL = "PAYROLL_ADVANCE_REVERSAL",
  /** Transfer for payroll reversal. */
  PAYROLL_REVERSAL = "PAYROLL_REVERSAL",
  /** transfer for peer to peer payment. */
  PEER_TO_PEER = "PEER_TO_PEER",
  /** transfer for peer to peer payment reversal. */
  PEER_TO_PEER_REVERSAL = "PEER_TO_PEER_REVERSAL",
  /** transfer for account repayment. */
  REPAYMENT = "REPAYMENT",
  /** transfer for account repayment reversal. */
  REPAYMENT_REVERSAL = "REPAYMENT_REVERSAL",
  /** Resetting the pseudo balance for a `FinancialAccount`. */
  RESET_PSEUDO_BALANCE = "RESET_PSEUDO_BALANCE",
  /** Transfer for earned rewards. */
  REWARD = "REWARD",
  /** Reverse earned rewards transfer. */
  REWARD_REVERSAL = "REWARD_REVERSAL",
  /** Transfer for secured deposit. */
  SECURED_DEPOSIT = "SECURED_DEPOSIT",
  /** Transfer for secured deposit reversal. */
  SECURED_DEPOSIT_REVERSAL = "SECURED_DEPOSIT_REVERSAL",
  /** Setting a pseudo limit for a `FinancialAccount`. */
  SET_PSEUDO_LIMIT = "SET_PSEUDO_LIMIT",
  /** Transfer for earned tips. */
  TIP_DISBURSEMENT = "TIP_DISBURSEMENT",
  /** Reverse earned tips transfer. */
  TIP_DISBURSEMENT_REVERSAL = "TIP_DISBURSEMENT_REVERSAL",
}

/** A `InterFinancialAccountTransferRule` that will block an inter financial account transfer if the transfer purpose is not allowed or blocked. */
export type TransferPurposeInterFinancialAccountTransferRule =
  InterFinancialAccountTransferRule &
    Node & {
      __typename?: "TransferPurposeInterFinancialAccountTransferRule";
      /** The transfer purposes that will be allowed. */
      allowed?: Maybe<Array<TransferPurpose>>;
      /** The transfer purposes that will be blocked. */
      blocked?: Maybe<Array<TransferPurpose>>;
      /** The date and time, in ISO 8601 format, the transfer rule was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** Global ID used to reference the `TransferPurposeInterFinancialAccountTransferRule` in operations. */
      id: Scalars["ID"];
      /** The name assigned to the rule. */
      name?: Maybe<Scalars["String"]>;
      /** The list of revisions for this transfer rule. */
      revisions?: Maybe<InterFinancialAccountTransferRuleConnection>;
      /** The date and time, in ISO 8601 format, the transfer rule was last updated. */
      updatedAt?: Maybe<Scalars["String"]>;
      /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
      version?: Maybe<Scalars["String"]>;
    };

/** A `InterFinancialAccountTransferRule` that will block an inter financial account transfer if the transfer purpose is not allowed or blocked. */
export type TransferPurposeInterFinancialAccountTransferRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Result of `TransferPurposeInterFinancialAccountTransferRule` */
export type TransferPurposeInterFinancialAccountTransferRuleResult =
  InterFinancialAccountTransferRuleResult & {
    __typename?: "TransferPurposeInterFinancialAccountTransferRuleResult";
    /** Transfer purpose inter financial account transfer rule */
    interFinancialAccountTransferRule?: Maybe<TransferPurposeInterFinancialAccountTransferRule>;
    /** A message describing the result. */
    message?: Maybe<Scalars["String"]>;
    /** A status representing the result of the rule’s evaluation. */
    status?: Maybe<InterFinancialAccountTransferRuleResultStatus>;
  };

/**
 * The states of a Transfer.
 *
 * DEPRECATED: See ElectronicFundsTransfer and the types that implement it. They each have their own more specific version of status.
 */
export enum TransferStatus {
  /** The platform has completed the money movement. */
  COMPLETED = "COMPLETED",
  /** The platform was not able to complete the money movement. See `statusReasonCode` for more information. */
  FAILED = "FAILED",
  /** The platform has started processing the Transfer. */
  PENDING = "PENDING",
  /** The platform is currently validating and executing the Transfer. */
  PROCESSING = "PROCESSING",
}

/**
 * The reasons a Transfer could fail.
 *
 * DEPRECATED: See ElectronicFundsTransfer and the types that implement it. They each have their own more specific version of status reason code.
 */
export enum TransferStatusReasonCode {
  /** The source or receiving account is closed. */
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  /** The receiving account holder is not an Organization. */
  ACCOUNT_HOLDER_IS_NOT_AN_ORGANIZATION = "ACCOUNT_HOLDER_IS_NOT_AN_ORGANIZATION",
  /** The source or receiving account was not found. */
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  /** The source and receiving account have different currency. */
  CURRENCY_MISMATCH = "CURRENCY_MISMATCH",
  /** The source account of the Transfer did not have enough funds to cover the requested amount. */
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  /** The receiving account does not have PayrollAdvanceFinancialAccountFeature as enabled. */
  PAYROLL_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED",
}

/** Denotes the type of transfer to create on a simulated `ExternallyInitiatedACHTransfer`. */
export enum TransferType {
  /**
   * The transfer will result in a credit to the internal account.
   *
   * The `amount` from `SimulateExternallyInitiatedACHTransferInput` will be added to the `FinancialAccount`.
   */
  CREDIT = "CREDIT",
  /**
   * The transfer will result in a debit to the internal account.
   *
   * The `amount` from `SimulateExternallyInitiatedACHTransferInput` will be removed from the `FinancialAccount`.
   */
  DEBIT = "DEBIT",
  /**
   * This is a transfer of funds into an internal account for the purposes of payroll.
   *
   * the `amount` from `SimulateExternallyInitiatedACHTransferInput` will be added to the `FinancialAccount`.
   */
  PAYROLL = "PAYROLL",
  /** This is a transfer of funds into an internal account for the purpose of funding individual accounts */
  SECURE_DEPOSIT = "SECURE_DEPOSIT",
}

export type TransferredEventNode =
  | InterFinancialAccountTransfer
  | ManualAdjustmentEvent;

/** A document upload session for a US Account Holder Application */
export type UsAccountHolderApplicationDocumentUploadSession =
  DocumentUploadSession &
    Node & {
      __typename?: "USAccountHolderApplicationDocumentUploadSession";
      /** The date and time, in ISO 8601 format, this `document upload session` was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** A context to represent rules and configurations for the `USAccountHolderApplicationDocumentUploadSession` */
      documentContext?: Maybe<DocumentUploadSessionContext>;
      /** A list of documents uploaded via a secure document upload link */
      documents?: Maybe<Array<UploadLink>>;
      /** Global ID used to reference the document upload session */
      id: Scalars["ID"];
      /** A list of primary document types that are compliant for upload. A primary document is a verifiable document used to provide evidence of identity containing personally identifiable information. */
      primaryDocumentTypes?: Maybe<Array<DocumentType>>;
      /** A recommended list of documents to collect during this `USAccountHolderApplicationDocumentUploadSession`. */
      recommendedDocumentTypes?: Maybe<Array<DocumentType>>;
      /** A list of secondary document types that are compliant for upload. A secondary document is additional substantiating evidence to verify the identity of the entity. */
      secondaryDocumentTypes?: Maybe<Array<DocumentType>>;
      /** The current state of the document upload session */
      status?: Maybe<DocumentUploadSessionStatusCode>;
      /** A list of supporting document types that are compliant for upload. A supporting document contains information to correlate the identity of the entity. */
      supportingDocumentTypes?: Maybe<Array<DocumentType>>;
      /** The date and time, in ISO 8601 format, this `document upload session` was last updated. */
      updatedAt?: Maybe<Scalars["String"]>;
      /** A list of upload requirements, dependent upon the type of document upload */
      uploadRequirements?: Maybe<Array<UploadRequirement>>;
    };

/** Input representing common fields of the name of a person associated with a business. */
export type UsAssociatedPersonNameInput = {
  /**
   * Part of a personal name that identifies a family, tribe, or community.
   *
   * **Minimum length:** 2 characters
   * **Maximum length:** 255 characters
   * **Allowed characters:** Lower and upper case Latin letters (without [diacritical marks](https://en.wikipedia.org/wiki/Diacritic)) and any of: ''', ',', '.', ' ','-'
   */
  familyName: Scalars["String"];
  /**
   * The part of the name that identifies a person.
   *
   * **Minimum length:** 1 character
   * **Maximum length:** 255 characters
   * **Allowed characters:** Lower and upper case Latin letters (without [diacritical marks](https://en.wikipedia.org/wiki/Diacritic)) and any of: ''', ',', '.', ' ','-'
   */
  givenName: Scalars["String"];
  /**
   * Additional part of name that identifies a person.
   *
   * **Minimum length:** 1 character
   * **Maximum length:** 255 characters
   * **Allowed characters:** Lower and upper case Latin letters (without [diacritical marks](https://en.wikipedia.org/wiki/Diacritic)) and any of: ''', ',', '.', ' ','-'
   */
  middleName?: InputMaybe<Scalars["String"]>;
  /** Provides additional information about the person (e.g. Jr., Sr.) */
  suffix?: InputMaybe<Scalars["String"]>;
  /** One or more words used before the person's name (e.g. Mx., Dr.). */
  title?: InputMaybe<Scalars["String"]>;
};

/** Input representing common fields to update the name of a person associated with a business. */
export type UsAssociatedPersonNameUpdateInput = {
  /**
   * Part of a personal name that identifies a family, tribe, or community.
   *
   * **Minimum length:** 2 characters
   * **Maximum length:** 255 characters
   * **Allowed characters:** Lower and upper case Latin letters (without [diacritical marks](https://en.wikipedia.org/wiki/Diacritic)) and any of: ''', ',', '.', ' ','-'
   */
  familyName?: InputMaybe<Scalars["String"]>;
  /**
   * The part of the name that identifies a person.
   *
   * **Minimum length:** 1 character
   * **Maximum length:** 255 characters
   * **Allowed characters:** Lower and upper case Latin letters (without [diacritical marks](https://en.wikipedia.org/wiki/Diacritic)) and any of: ''', ',', '.', ' ','-'
   */
  givenName?: InputMaybe<Scalars["String"]>;
  /**
   * Additional part of name that identifies a person.
   *
   * **Minimum length:** 1 character
   * **Maximum length:** 255 characters
   * **Allowed characters:** Lower and upper case Latin letters (without [diacritical marks](https://en.wikipedia.org/wiki/Diacritic)) and any of: ''', ',', '.', ' ','-'
   */
  middleName?: InputMaybe<Scalars["String"]>;
  /** Provides additional information about the person (e.g. Jr., Sr.) */
  suffix?: InputMaybe<Scalars["String"]>;
  /** One or more words used before the person's name (e.g. Mx., Dr.). */
  title?: InputMaybe<Scalars["String"]>;
};

/** The details of the USAuthorizedPersonInput. */
export type UsAuthorizedPersonInput = {
  /** Authorized person's title. */
  authorizingPersonTitle?: InputMaybe<BusinessTitle>;
  /**
   * Date of birth in YYYY-MM-DD format.
   * **Minimum age:** 18 years. **Maximum age:** 100 years, in place to combat fraud and potential elder financial abuse.
   */
  dateOfBirth: Scalars["String"];
  /**
   * The authorized person's e-mail address.
   *
   * **Note:** Highnote does not verify the e-mail address.
   */
  email: Scalars["String"];
  /**
   * The authorized person's U.S. physical address.
   *
   * Exactly one of `homeAddress` or `homeAddressToken` must be provided.
   */
  homeAddress?: InputMaybe<AddressInput>;
  /**
   * A token representing the authorized person's U.S. physical address.
   *
   * Exactly one of `homeAddress` or `homeAddressToken` must be provided.
   */
  homeAddressToken?: InputMaybe<Scalars["ID"]>;
  /** The identification document used to verify the authorized person. */
  identificationDocument: UsIdentificationDocumentInput;
  /** The authorized person's legal name. */
  name: UsAssociatedPersonNameInput;
  /** Percentage ownership of this authorized person in business if any. */
  percentageOwnership?: InputMaybe<Scalars["Int"]>;
  /** The primary phone number for this authorized person. */
  phoneNumber: PhoneInput;
};

/** Input fields for updating a USAuthorizedPerson. */
export type UsAuthorizedPersonUpdateInput = {
  /**
   * Date of birth in YYYY-MM-DD format.
   * **Minimum age:** 18 years. **Maximum age:** 100 years, in place to combat fraud and potential elder financial abuse.
   *
   * Note: Only fields provided as part of the input will be updated. Fields not provided will remain unchanged.
   */
  dateOfBirth?: InputMaybe<Scalars["String"]>;
  /**
   * The authorized person's U.S. physical address.
   *
   * Note: Only fields provided as part of the input will be updated. Fields not provided will remain unchanged.
   */
  homeAddress?: InputMaybe<AddressInput>;
  /**
   * The identification document used to verify the authorized person.
   *
   * Note: Only fields provided as part of the input will be updated. Fields not provided will remain unchanged.
   */
  identificationDocument?: InputMaybe<UsIdentificationDocumentInput>;
  /**
   * The authorized person's legal name.
   *
   * Note: Only fields provided as part of the input will be updated. Fields not provided will remain unchanged.
   */
  name?: InputMaybe<UsAssociatedPersonNameUpdateInput>;
};

/** A US bank account used for RTP transfers. */
export type UsBankAccount = {
  __typename?: "USBankAccount";
  /** The type of bank account. */
  accountType?: Maybe<UsBankAccountType>;
  /** The last four digits of the bank account number. */
  last4?: Maybe<Scalars["String"]>;
  /** The account holder's name. */
  name?: Maybe<Name>;
  /** The bank routing number (ABA). */
  routingNumber?: Maybe<Scalars["String"]>;
};

/** The type of US bank account. */
export enum UsBankAccountType {
  /** A checking account. */
  CHECKING = "CHECKING",
  /** A savings account. */
  SAVINGS = "SAVINGS",
}

/** A USBusinessAccountHolder. */
export type UsBusinessAccountHolder = BusinessAccountHolder &
  Node & {
    __typename?: "USBusinessAccountHolder";
    /**
     * Returns the list of authorized account holder relationships associated with the `USBusinessAccountHolder`.
     *
     * Only active relationships are returned. A relationship is considered active if it has not been explicitly
     * revoked, expired, or marked inactive in the system.
     *
     * Use this field to access currently valid relationships from this `USBusinessAccountHolder`
     */
    authorizedAccountHolderRelationships?: Maybe<AuthorizedAccountHolderRelationshipConnection>;
    /** Information about the business. */
    businessProfile?: Maybe<UsBusinessProfile>;
    /** The Applications for this Account Holder. */
    cardProductApplications?: Maybe<AccountHolderCardProductApplicationConnection>;
    /** The date and time, in ISO 8601 format, the business account holder was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Contains all document uploads associated with this business */
    documents?: Maybe<Array<DocumentUploadCollection>>;
    /** The external financial account for this Account Holder. */
    externalFinancialAccounts?: Maybe<ExternalFinancialAccountConnection>;
    /** An ID associated with the account holder provided by an external party. Highnote does not validate the ID. */
    externalId?: Maybe<Scalars["String"]>;
    /**
     * The financial accounts associated with the account holder.
     *
     * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
     */
    financialAccounts?: Maybe<FinancialAccountConnection>;
    /** All global notes for this `USBusinessAccountHolder`. */
    globalNotes?: Maybe<GlobalNoteConnectionPayload>;
    /** Global ID used to reference the business in operations. */
    id: Scalars["ID"];
    /**
     * The Payment Cards issued for this Account Holder.
     *
     * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
     */
    paymentCards?: Maybe<PaymentCardConnection>;
    /** The details of the person authorized to act on behalf of business. */
    primaryAuthorizedPerson?: Maybe<UsBusinessAuthorizedPerson>;
    /** A list of risk scores associated with the account holder. */
    riskScores?: Maybe<AccountHolderRiskScore>;
    /** The date and time, in ISO 8601 format, the business account holder was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** A USBusinessAccountHolder. */
export type UsBusinessAccountHolderAuthorizedAccountHolderRelationshipsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A USBusinessAccountHolder. */
export type UsBusinessAccountHolderCardProductApplicationsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A USBusinessAccountHolder. */
export type UsBusinessAccountHolderExternalFinancialAccountsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  externalFinancialAccountId?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A USBusinessAccountHolder. */
export type UsBusinessAccountHolderFinancialAccountsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<AccountHolderFinancialAccountsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A USBusinessAccountHolder. */
export type UsBusinessAccountHolderGlobalNotesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A USBusinessAccountHolder. */
export type UsBusinessAccountHolderPaymentCardsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<AccountHolderPaymentCardsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The connection type for USBusinessAccountHolder. */
export type UsBusinessAccountHolderConnection = {
  __typename?: "USBusinessAccountHolderConnection";
  /** A list of edges. */
  edges?: Maybe<Array<UsBusinessAccountHolderEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a USBusinessAccountHolder. */
export type UsBusinessAccountHolderEdge = {
  __typename?: "USBusinessAccountHolderEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The account holder. */
  node?: Maybe<UsBusinessAccountHolder>;
};

/** The details of a USBusinessAccountHolder at the time of application. */
export type UsBusinessAccountHolderSnapshot = BusinessAccountHolder & {
  __typename?: "USBusinessAccountHolderSnapshot";
  /** The account holder. */
  accountHolderCurrent?: Maybe<UsBusinessAccountHolder>;
  /** Business. */
  businessProfile?: Maybe<UsBusinessProfileSnapshot>;
  /**
   * The current verification attempt, if any, of the account holder.
   * Deprecated. Check the `currentVerification` field under `USBusinessProfileSnapshot` instead.
   * @deprecated use `businessProfile.currentVerification` instead.
   */
  currentVerification?: Maybe<AccountHolderVerification>;
  /** Authorized person */
  primaryAuthorizedPerson?: Maybe<UsBusinessAuthorizedPersonSnapshot>;
};

/** A reference to a tokenized USBusinessAccountHolder. */
export type UsBusinessAccountHolderToken = {
  __typename?: "USBusinessAccountHolderToken";
  /**
   * The reference to the tokenized UsBusinessAccountHolder.
   *
   * The tokenized `USBusinessAccountHolder` data to be used as input to subsequent mutations (e.g. `createUSBusinessAccountHolderFromToken`).
   *
   * Expires after 1 hour.
   */
  token: Scalars["String"];
};

/** The details of the person authorized to act on behalf of business. */
export type UsBusinessAuthorizedPerson = AuthorizedPerson & {
  __typename?: "USBusinessAuthorizedPerson";
  /** Authorized person's business title. */
  authorizingPersonTitle?: Maybe<BusinessTitle>;
  /** The date and time, in ISO 8601 format, the authorized person was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date of birth of the authorized person represented in YYYY-MM-DD format. */
  dateOfBirth?: Maybe<Scalars["String"]>;
  /** The email address of the authorized person. */
  email?: Maybe<Scalars["String"]>;
  /** The default physical address of the authorized person. */
  homeAddress?: Maybe<Address>;
  /** Global ID used to reference the authorized person. */
  id: Scalars["ID"];
  /** Identification Document associated with the authorized person. */
  identificationDocument?: Maybe<UsIdentificationDocument>;
  /** Indicates whether or not the authorized person is a guarantor. */
  isGuarantor?: Maybe<Scalars["Boolean"]>;
  /** The authorized person's name. */
  name?: Maybe<Name>;
  /** Percentage ownership of authorized person. */
  percentageOwnership?: Maybe<Scalars["Int"]>;
  /** List of phone numbers associated with the authorized person. */
  phoneNumbers?: Maybe<Array<Phone>>;
  /** The date and time, in ISO 8601 format, the authorized person was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The details of the person authorized to act on behalf of business. */
export type UsBusinessAuthorizedPersonSnapshot = AuthorizedPerson & {
  __typename?: "USBusinessAuthorizedPersonSnapshot";
  /** Authorized person's business title. */
  authorizingPersonTitle?: Maybe<BusinessTitle>;
  /** The date and time, in ISO 8601 format, the authorized person was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The current verification attempt, if any, of the authorized person. */
  currentVerification?: Maybe<AccountHolderVerification>;
  /** The date of birth of the authorized person represented in YYYY-MM-DD format. */
  dateOfBirth?: Maybe<Scalars["String"]>;
  /** The email address of the authorized person. */
  email?: Maybe<Scalars["String"]>;
  /** The default physical address of the authorized person. */
  homeAddress?: Maybe<Address>;
  /** Identification Document associated with the authorized person. */
  identificationDocument?: Maybe<UsIdentificationDocument>;
  /** The authorized person's name. */
  name?: Maybe<Name>;
  /** Percentage ownership of authorized person. */
  percentageOwnership?: Maybe<Scalars["Int"]>;
  /** List of phone numbers associated with the authorized person. */
  phoneNumbers?: Maybe<Array<Phone>>;
  /** The date and time, in ISO 8601 format, the authorized person was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /**
   * Verification status of authorized person.
   * @deprecated Use currentVerification instead.
   */
  verificationState?: Maybe<AccountHolderVerificationStatusCode>;
};

/** The US business identification document attached to a Business. */
export type UsBusinessIdentificationDocument = {
  __typename?: "USBusinessIdentificationDocument";
  /** Employer Identification Number (USA only). */
  employerIdentificationNumber?: Maybe<TaxIdentificationDocument>;
};

/** The US Business identification documents for verification. */
export type UsBusinessIdentificationDocumentInput = {
  /**
   * Business's employer identification number (USA only).
   *
   * The validation for the input uses the following regex pattern `^\d{2}-\d{7}$`.
   */
  employerIdentificationNumber: TaxIdentificationDocumentInput;
};

/** Information about the US business. */
export type UsBusinessProfile = BusinessProfile & {
  __typename?: "USBusinessProfile";
  /**
   * Authorized users of the business.
   * @deprecated Use UsBusinessAccountHolder.authorizedAccountHolderRelationships instead.
   */
  authorizedUsers?: Maybe<AuthorizedUserConnection>;
  /** The default physical address of the business. */
  billingAddress?: Maybe<Address>;
  /** The business' credit risk attributes such as annual revenue, used for underwriting decisions. */
  businessCreditRiskAttributes?: Maybe<BusinessCreditRiskAttributes>;
  /** A short description of what the business does, its purpose, and the products or services it provides. */
  businessDescription?: Maybe<Scalars["String"]>;
  /** Type of business. */
  businessType?: Maybe<BusinessStructure>;
  /** The date and time, in ISO 8601 format, the business was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /**
   * The business' credit risk attributes such as annual revenue, used for underwriting decisions.
   * @deprecated Use businessCreditRiskAttributes instead.
   */
  creditRiskAttributes?: Maybe<CreditRiskAttributes>;
  /** An ID representing this business organization in an external system. */
  externalId?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the business. */
  id: Scalars["ID"];
  /** Identification document associated with the business. */
  identificationDocument?: Maybe<UsBusinessIdentificationDocument>;
  /**
   * The date this business was incorporated
   *
   * Format: `YYYY-MM-DD`
   */
  incorporationDate?: Maybe<Scalars["Date"]>;
  /** The industry type for the business */
  industryType?: Maybe<BusinessPlanOperatingGoodsAndServiceCategory>;
  /** The address supplied for the business' registration. */
  legalAddress?: Maybe<Address>;
  /** Name of the business. */
  name?: Maybe<BusinessName>;
  /** Operating Details */
  operatingDetails?: Maybe<BusinessPlanOperatingDetails>;
  /** List of phone numbers associated with the business. */
  phoneNumbers?: Maybe<Array<Phone>>;
  /**
   * A region for the address based on the codes for identifying the principle subdivisions, e.g. provinces and states, of countries
   * [IS0 3166 standard](https://en.wikipedia.org/wiki/ISO_3166-2), including districts and outlying areas.
   */
  regionOfFormation?: Maybe<Scalars["String"]>;
  /** Ultimate beneficial owners of the business. */
  ultimateBeneficialOwners?: Maybe<
    Array<Maybe<UsBusinessUltimateBeneficialOwner>>
  >;
  /** The date and time, in ISO 8601 format, the business was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** Business website. */
  website?: Maybe<Scalars["String"]>;
};

/** Information about the US business. */
export type UsBusinessProfileAuthorizedUsersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Input fields for creating a USBusinessProfile. */
export type UsBusinessProfileInput = {
  /**
   * The business' U.S. billing address.
   *
   * Exactly one of `billingAddress` or `billingAddressToken` must be provided.
   */
  billingAddress?: InputMaybe<AddressInput>;
  /**
   * A token representing the business' U.S. billing address.
   *
   * Exactly one of `billingAddress` or `billingAddressToken` must be provided.
   */
  billingAddressToken?: InputMaybe<Scalars["ID"]>;
  /** The business' credit risk attributes. Only used for unsecured credit applications. */
  businessCreditRiskAttributes?: InputMaybe<BusinessCreditRiskAttributesInput>;
  /**
   * A short description of what the business does, its purpose, and the products or services it provides.
   *
   * Max length: 140 characters.
   * Min length: 1 character.
   * Input Regex Validation: `^[a-zA-Z\d$ ',.\-\_!@#$%^&*+=`?"\n]+$`
   */
  businessDescription?: InputMaybe<Scalars["String"]>;
  /** Business plan indicator attributes for this business. */
  businessPlanAttributes?: InputMaybe<Array<BusinessPlanAttributeInput>>;
  /** Type of business. */
  businessType: BusinessStructure;
  /**
   * The business' credit risk attributes. Only used for unsecured credit applications.
   * ***Note** This attribute is deprecated and will be removed in a future release. Please use `businessCreditRiskAttributes`.
   */
  creditRiskAttributes?: InputMaybe<CreditRiskAttributesInput>;
  /**
   * Business identification document such as employer identification number in USA.
   *
   * A business identification document is not required for SOLE_PROPRIETORSHIP.
   *
   * Highnote recommends passing an identification document when available to streamline the onboarding and future product approval processes.
   */
  identificationDocument?: InputMaybe<UsBusinessIdentificationDocumentInput>;
  /**
   * The address supplied for the business' registration.
   * Supplying the address associated with the business primary SOS filing location is recommended.
   *
   * **Note**:  Depending on the product that the Account Holder is applying for, the legal entity address may be required.
   * During your implementation review, requirements around conditionally mandatory fields will be outlined.
   */
  legalAddress?: InputMaybe<AddressInput>;
  /** The business' name fields. */
  name: BusinessAccountHolderNameInput;
  /** The primary phone number for this business. */
  phoneNumber: PhoneInput;
  /** Ultimate beneficial owners of business information */
  ultimateBeneficialOwners?: InputMaybe<
    Array<InputMaybe<UsUltimateBeneficialOwnerInput>>
  >;
  /**
   * Business website URL.
   *
   * The validation for the `website` URL uses the following regex pattern `^((((https?|ftps?|gopher|telnet|nntp)://)|(mailto:|news:))(%[0-9A-Fa-f]{2}|[-()_.!~*';/?:@&=+$,A-Za-z0-9])+)([).!';/?:,][[:blank:|:blank:]])?$`
   */
  website?: InputMaybe<Scalars["String"]>;
};

/** Information about the US business. */
export type UsBusinessProfileSnapshot = BusinessProfile & {
  __typename?: "USBusinessProfileSnapshot";
  /** The default physical addresses of the business. */
  billingAddress?: Maybe<Address>;
  /** The business' credit risk attributes, such as annual revenue. Used for underwriting decisions. */
  businessCreditRiskAttributes?: Maybe<BusinessCreditRiskAttributes>;
  /** A short description of what the business does, its purpose, and the products or services it provides. */
  businessDescription?: Maybe<Scalars["String"]>;
  /** Type of business. */
  businessType?: Maybe<BusinessStructure>;
  /** The date and time, in ISO 8601 format, the business was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /**
   * The business' credit risk attributes, such as annual revenue. Used for underwriting decisions.
   * @deprecated Use businessCreditRiskAttributes instead.
   */
  creditRiskAttributes?: Maybe<CreditRiskAttributes>;
  /** The business' current credit underwriting status and details. */
  currentCreditUnderwritingVerification?: Maybe<CreditUnderwritingVerification>;
  /** The current verification attempt, if any, on the business profile. */
  currentVerification?: Maybe<AccountHolderVerification>;
  /** Identification document associated with the business. */
  identificationDocument?: Maybe<UsBusinessIdentificationDocument>;
  /** The address supplied for the business' registration. */
  legalAddress?: Maybe<Address>;
  /** Name of the business. */
  name?: Maybe<BusinessName>;
  /** Operating Details */
  operatingDetails?: Maybe<BusinessPlanOperatingDetails>;
  /** List of phone numbers associated with the business. */
  phoneNumbers?: Maybe<Array<Phone>>;
  /** Ultimate beneficial owners of the business. */
  ultimateBeneficialOwners?: Maybe<
    Array<Maybe<UsBusinessUltimateBeneficialOwnerSnapshot>>
  >;
  /** The date and time, in ISO 8601 format, the business was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /**
   * Verification status of business.
   * @deprecated Use currentVerification instead.
   */
  verificationState?: Maybe<AccountHolderVerificationStatusCode>;
  /** Business website. */
  website?: Maybe<Scalars["String"]>;
};

/** Input fields for updating a `USBusinessProfile`. */
export type UsBusinessProfileUpdateInput = {
  /**
   * The business' U.S. billing address.
   *
   * Note: Only fields provided as part of the input will be updated. Fields not provided will remain unchanged.
   */
  billingAddress?: InputMaybe<AddressInput>;
  /**
   * Business identification document such as employer identification number in USA.
   *
   * A business identification document is not required for SOLE_PROPRIETORSHIP.
   *
   * Highnote recommends passing an identification document when available to streamline the onboarding and future product approval processes.
   *
   * Note: Only fields provided as part of the input will be updated. Fields not provided will remain unchanged.
   */
  identificationDocument?: InputMaybe<UsBusinessIdentificationDocumentInput>;
  /**
   * The business' name fields.
   *
   * Note: Only fields provided as part of the input will be updated. Fields not provided will remain unchanged.
   */
  name?: InputMaybe<BusinessAccountHolderNameUpdateInput>;
};

/** Ultimate beneficial owner for the business owning 25% or more of the business. */
export type UsBusinessUltimateBeneficialOwner = {
  __typename?: "USBusinessUltimateBeneficialOwner";
  /** The date and time, in ISO 8601 format, the ultimate beneficial owner was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date of birth of the ultimate beneficial owner represented in YYYY-MM-DD format. */
  dateOfBirth?: Maybe<Scalars["String"]>;
  /** The email address of the ultimate beneficial owner. */
  email?: Maybe<Scalars["String"]>;
  /** The default physical address of the ultimate beneficial owner. */
  homeAddress?: Maybe<Address>;
  /** Global ID used to reference the ultimate beneficial owner. */
  id: Scalars["ID"];
  /** Identification Document associated with the ultimate beneficial owner. */
  identificationDocument?: Maybe<UsIdentificationDocument>;
  /** Indicates whether or not the ultimate beneficial owner is a guarantor. */
  isGuarantor?: Maybe<Scalars["Boolean"]>;
  /** Indicates whether or not the ultimate beneficial owner is the primary authorized person. */
  isPrimaryAuthorizedPerson?: Maybe<Scalars["Boolean"]>;
  /** The ultimate beneficial owner's full name. */
  name?: Maybe<Name>;
  /** Percentage ownership of ultimate beneficial owner. */
  percentageOwnership?: Maybe<Scalars["Int"]>;
  /** List of phone numbers associated with the ultimate beneficial owner. */
  phoneNumbers?: Maybe<Array<Phone>>;
  /** The date and time, in ISO 8601 format, the ultimate beneficial owner was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** A snapshot of the Ultimate beneficial owner for the business. */
export type UsBusinessUltimateBeneficialOwnerSnapshot = {
  __typename?: "USBusinessUltimateBeneficialOwnerSnapshot";
  /** The date and time, in ISO 8601 format, the ultimate beneficial owner was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The current verification attempt, if any, of the ultimate beneficial owner. */
  currentVerification?: Maybe<AccountHolderVerification>;
  /** The date of birth of the ultimate beneficial owner represented in YYYY-MM-DD format. */
  dateOfBirth?: Maybe<Scalars["String"]>;
  /** The email address of the ultimate beneficial owner. */
  email?: Maybe<Scalars["String"]>;
  /** The default physical address of the ultimate beneficial owner. */
  homeAddress?: Maybe<Address>;
  /** Identification Document associated with the ultimate beneficial owner. */
  identificationDocument?: Maybe<UsIdentificationDocument>;
  /** The ultimate beneficial owner's full name. */
  name?: Maybe<Name>;
  /** Percentage ownership of ultimate beneficial owner. */
  percentageOwnership?: Maybe<Scalars["Int"]>;
  /** List of phone numbers associated with the ultimate beneficial owner. */
  phoneNumbers?: Maybe<Array<Phone>>;
  /** Global ID used to reference the ultimate beneficial owner. */
  ultimateBeneficialOwnerId: Scalars["ID"];
  /** The date and time, in ISO 8601 format, the ultimate beneficial owner was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /**
   * Verification status of ultimate beneficial owner.
   * @deprecated Use currentVerification instead.
   */
  verificationState?: Maybe<AccountHolderVerificationStatusCode>;
};

/** The US identification documents attached to a Person. */
export type UsIdentificationDocument = {
  __typename?: "USIdentificationDocument";
  /**
   * A person's social security number (USA only).
   *
   * Must have 9 digits divided into 3 parts by hyphen. For example, `123-45-6789`.
   * The first part should have 3 digits and should not be 000, 666, or between 900 and 999.
   * The second part should have 2 digits and it should be from 01 to 99.
   * The third part should have 4 digits and it should be from 0001 to 9999.
   *
   * The validation for the input uses the following regex pattern `^(?!666|000|9\d{2})\d{3}-(?!00)\d{2}-(?!0{4})\d{4}$`.
   */
  socialSecurityNumber?: Maybe<TaxIdentificationDocument>;
};

/** The US identification documents for verification. */
export type UsIdentificationDocumentInput = {
  /**
   * A person's social security number (USA only).
   *
   * Can be one of
   * 1. 9 digits divided into 3 parts by hyphen. For example, `123-45-6789`.
   * 2. 9 concurrent digits such as 123456789. When supplied, the SSN will be formatted to 123-45-6789 to enforce social security number validity.
   *
   * The following outlines rules around a valid social security number:
   * 1. The first part should have 3 digits and should not be 000, 666, or between 900 and 999.
   * 2. The second part should have 2 digits and it should be from 01 to 99.
   * 3. The third part should have 4 digits and it should be from 0001 to 9999.
   *
   * The validation for the input uses the following regex pattern `^((?!666|000|9\d{2})\d{3}-(?!00)\d{2}-(?!0{4})\d{4})|(\d{9})$`.
   */
  socialSecurityNumber: TaxIdentificationDocumentInput;
};

/** A USPersonAccountHolder. */
export type UsPersonAccountHolder = Node &
  PersonAccountHolder & {
    __typename?: "USPersonAccountHolder";
    /** The Applications for this Account Holder. */
    applications?: Maybe<CardProductApplicationConnection>;
    /**
     * Returns the list of authorized account holder relationships associated with the `USPersonAccountHolder`.
     *
     * Only active relationships are included. A relationship is considered active if it has not been
     * revoked, expired, or otherwise marked inactive in the system.
     *
     * Use this field to access currently valid relationships from this `USPersonAccountHolder`.
     */
    authorizedAccountHolderRelationships?: Maybe<AuthorizedAccountHolderRelationshipConnection>;
    /** The `FinancialAccount`s for authorized user's managed by `AccountHolder`. */
    authorizedUserFinancialAccounts?: Maybe<FinancialAccountConnection>;
    /** The default billing addresses of the account holder */
    billingAddress?: Maybe<Address>;
    /**
     * The Applications for this Account Holder.
     * @deprecated Use applications instead.
     */
    cardProductApplications?: Maybe<AccountHolderCardProductApplicationConnection>;
    /** The date and time, in ISO 8601 format, the account holder was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The date of birth of the account holder represented in YYYY-MM-DD format. */
    dateOfBirth?: Maybe<Scalars["String"]>;
    /** Contains all document uploads associated with this business */
    documents?: Maybe<Array<DocumentUploadCollection>>;
    /** The email address of the account holder. */
    email?: Maybe<Scalars["String"]>;
    /** The external financial account for this Account Holder. */
    externalFinancialAccounts?: Maybe<ExternalFinancialAccountConnection>;
    /** An ID associated with the account holder provided by an external party. Highnote does not validate the ID. */
    externalId?: Maybe<Scalars["String"]>;
    /**
     * The `FinancialAccount`s associated with the `AccountHolder`.
     *
     * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
     */
    financialAccounts?: Maybe<FinancialAccountConnection>;
    /** All global notes for this `USPersonAccountHolder`. */
    globalNotes?: Maybe<GlobalNoteConnectionPayload>;
    /** Global ID used to reference the account holder in operations. */
    id: Scalars["ID"];
    /** Identification Document associated with the account holder. */
    identificationDocument?: Maybe<UsIdentificationDocument>;
    /** The account holder's name, represented as different parts. */
    name?: Maybe<Name>;
    /**
     * The Payment Cards issued for this Account Holder.
     *
     * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
     */
    paymentCards?: Maybe<PaymentCardConnection>;
    /** The credit risk attributes for the `USPersonAccountHolder`. */
    personCreditRiskAttributes?: Maybe<PersonCreditRiskAttributes>;
    /** List of phone numbers associated with the account holder. */
    phoneNumbers?: Maybe<Array<Phone>>;
    /** A list of risk scores associated with the account holder. */
    riskScores?: Maybe<AccountHolderRiskScore>;
    /** The date and time, in ISO 8601 format, the account holder was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** A USPersonAccountHolder. */
export type UsPersonAccountHolderApplicationsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A USPersonAccountHolder. */
export type UsPersonAccountHolderAuthorizedAccountHolderRelationshipsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A USPersonAccountHolder. */
export type UsPersonAccountHolderAuthorizedUserFinancialAccountsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A USPersonAccountHolder. */
export type UsPersonAccountHolderCardProductApplicationsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A USPersonAccountHolder. */
export type UsPersonAccountHolderExternalFinancialAccountsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A USPersonAccountHolder. */
export type UsPersonAccountHolderFinancialAccountsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<AccountHolderFinancialAccountsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A USPersonAccountHolder. */
export type UsPersonAccountHolderGlobalNotesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A USPersonAccountHolder. */
export type UsPersonAccountHolderPaymentCardsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<AccountHolderPaymentCardsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The connection type for USPersonAccountHolder. */
export type UsPersonAccountHolderConnection = {
  __typename?: "USPersonAccountHolderConnection";
  /** A list of edges. */
  edges?: Maybe<Array<UsPersonAccountHolderEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a USPersonAccountHolder. */
export type UsPersonAccountHolderEdge = {
  __typename?: "USPersonAccountHolderEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The account holder. */
  node?: Maybe<UsPersonAccountHolder>;
};

/** The details of the PersonAccountHolder. */
export type UsPersonAccountHolderInput = {
  /**
   * The account holder's U.S. billing address.
   *
   * Exactly one of `billingAddress` or `billingAddressToken` must be provided.
   */
  billingAddress?: InputMaybe<AddressInput>;
  /**
   * A token representing the account holder's U.S. billing address.
   *
   * Exactly one of `billingAddress` or `billingAddressToken` must be provided.
   */
  billingAddressToken?: InputMaybe<Scalars["ID"]>;
  /**
   * Date of birth in YYYY-MM-DD format.
   * **Minimum age:** 10 years. **Maximum age:** 100 years, in place to combat fraud and potential elder financial abuse.
   */
  dateOfBirth: Scalars["String"];
  /**
   * The account holder's e-mail address.
   *
   * **Note:** Highnote does not verify the e-mail address.
   */
  email?: InputMaybe<Scalars["String"]>;
  /**
   * An ID representing this account holder in an external system. Provide this field if you create identifiers for this person that you would like us to store for easy access to their information.
   * **Maximum length:** 255 characters.
   *
   * The validation for the `externalId` uses the following regex pattern `^([a-zA-Z\d[\s][_][=][,][-][.][^;]])+$`.
   */
  externalId?: InputMaybe<Scalars["String"]>;
  /** The identification documents used to verify the account holder. */
  identificationDocument?: InputMaybe<UsIdentificationDocumentInput>;
  /** The account holder's legal name. */
  name: PersonAccountHolderNameInput;
  /** The credit risk attributes used to verify the `USPersonAccountHolder`'s underwriting details. */
  personCreditRiskAttributes?: InputMaybe<PersonCreditRiskAttributesInput>;
  /** The primary phone number for this account holder. */
  phoneNumber?: InputMaybe<PhoneInput>;
};

/** The details of the PersonAccountHolder at the time of application. */
export type UsPersonAccountHolderSnapshot = PersonAccountHolder & {
  __typename?: "USPersonAccountHolderSnapshot";
  /** The account holder. */
  accountHolderCurrent?: Maybe<UsPersonAccountHolder>;
  /** The default billing addresses of the account holder */
  billingAddress?: Maybe<Address>;
  /** The `USPersonAccountHolder`'s current credit underwriting status and details. */
  currentCreditUnderwritingVerification?: Maybe<CreditUnderwritingVerification>;
  /** The current verification attempt, if any, of the account holder. */
  currentVerification?: Maybe<AccountHolderVerification>;
  /** The date of birth of the account holder represented in YYYY-MM-DD format. */
  dateOfBirth?: Maybe<Scalars["String"]>;
  /** The email address of the account holder. */
  email?: Maybe<Scalars["String"]>;
  /** Identification Document associated with the account holder. */
  identificationDocument?: Maybe<UsIdentificationDocument>;
  /** The account holder's name, represented as different parts. */
  name?: Maybe<Name>;
  /** The `USPersonAccountHolder`'s credit risk attributes, such as annual income. Used for underwriting decisions. */
  personCreditRiskAttributes?: Maybe<PersonCreditRiskAttributes>;
  /** List of phone numbers associated with the account holder. */
  phoneNumbers?: Maybe<Array<Phone>>;
};

/** A reference to a tokenized USPersonAccountHolder. */
export type UsPersonAccountHolderToken = {
  __typename?: "USPersonAccountHolderToken";
  /**
   * The reference to the tokenized USPersonAccountHolder.
   *
   * The tokenized `USPersonAccountHolder` data to be used as input to subsequent mutations (e.g. `createUSPersonAccountHolderFromToken`).
   *
   * Expires after 1 hour.
   */
  token: Scalars["String"];
};

/** Input fields for updating a `USPersonAccountHolder`. */
export type UsPersonAccountHolderUpdateInput = {
  /**
   * The person's U.S. billing address.
   *
   * Note: Only fields provided as part of the input will be updated. Fields not provided will remain unchanged.
   */
  billingAddress?: InputMaybe<AddressInput>;
  /**
   * Date of birth in YYYY-MM-DD format.
   * **Minimum age:** 18 years. **Maximum age:** 100 years, in place to combat fraud and potential elder financial abuse.
   *
   * Note: Only fields provided as part of the input will be updated. Fields not provided will remain unchanged.
   */
  dateOfBirth?: InputMaybe<Scalars["String"]>;
  /**
   * The person account holder's e-mail address.
   *
   * Note: Only fields provided as part of the input will be updated. Fields not provided will remain unchanged.
   */
  email?: InputMaybe<Scalars["String"]>;
  /**
   * The identification document used to verify the person.
   *
   * Note: Only fields provided as part of the input will be updated. Fields not provided will remain unchanged.
   */
  identificationDocument?: InputMaybe<UsIdentificationDocumentInput>;
  /**
   * The person's legal name.
   *
   * Note: Only fields provided as part of the input will be updated. Fields not provided will remain unchanged.
   */
  name?: InputMaybe<PersonAccountHolderNameInput>;
  /**
   * The primary phone number for this person account holder.
   *
   * Note: Only fields provided as part of the input will be updated. Fields not provided will remain unchanged.
   */
  phoneNumber?: InputMaybe<PhoneInput>;
};

/** A USPersonAuthorizedUser. */
export type UsPersonAuthorizedUser = Node &
  PersonAuthorizedUser & {
    __typename?: "USPersonAuthorizedUser";
    /**
     * The account holders associated with the authorized user.
     *
     * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
     */
    associatedAccountHolders?: Maybe<AccountHolderConnection>;
    /** The default billing addresses of the authorized user. */
    billingAddress?: Maybe<Address>;
    /** The Applications for this authorized user. */
    cardProductApplications?: Maybe<AuthorizedUserCardProductApplicationConnection>;
    /** The date and time, in ISO 8601 format, the authorized user was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The date of birth of the authorized user represented in YYYY-MM-DD format. */
    dateOfBirth?: Maybe<Scalars["String"]>;
    /** The email address of the authorized user. */
    email?: Maybe<Scalars["String"]>;
    /** An ID associated with the authorized user provided by an external party. Highnote does not validate the ID. */
    externalId?: Maybe<Scalars["String"]>;
    /** ID used to reference the authorized user in operations. */
    id: Scalars["ID"];
    /** Identification Document associated with the authorized user. */
    identificationDocument?: Maybe<UsIdentificationDocument>;
    /** The authorized user's name, represented as different parts. */
    name?: Maybe<Name>;
    /**
     * The Payment Cards issued for this authorized user.
     *
     * For information on Highnote's Search API, see our [Search guide](https://highnote.com/docs/basics/graphql-api/search).
     */
    paymentCards?: Maybe<PaymentCardConnection>;
    /** List of phone numbers associated with the authorized user. */
    phoneNumbers?: Maybe<Array<Phone>>;
    /** A list of risk scores associated with the account holder. */
    riskScores?: Maybe<AccountHolderRiskScore>;
    /** The date and time, in ISO 8601 format, the authorized user was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/** A USPersonAuthorizedUser. */
export type UsPersonAuthorizedUserAssociatedAccountHoldersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<AccountHolderFinancialAccountsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A USPersonAuthorizedUser. */
export type UsPersonAuthorizedUserCardProductApplicationsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A USPersonAuthorizedUser. */
export type UsPersonAuthorizedUserPaymentCardsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<AuthorizedUserPaymentCardsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The details of the PersonAuthorizedUser. */
export type UsPersonAuthorizedUserInput = {
  /**
   * The authorized user's U.S. billing address.
   *
   * Exactly one of `billingAddress` or `billingAddressToken` must be provided.
   */
  billingAddress?: InputMaybe<AddressInput>;
  /**
   * A token representing the authorized user's U.S. billing address.
   *
   * Exactly one of `billingAddress` or `billingAddressToken` must be provided.
   */
  billingAddressToken?: InputMaybe<Scalars["ID"]>;
  /**
   * Date of birth in YYYY-MM-DD format.
   * **Minimum age:** 18 years. **Maximum age:** 100 years, in place to combat fraud and potential elder financial abuse.
   */
  dateOfBirth: Scalars["String"];
  /**
   * The authorized user's e-mail address.
   *
   * **Note:** Highnote does not verify the e-mail address.
   */
  email: Scalars["String"];
  /**
   * An ID representing this authorized user in an external system. Provide this field if you create identifiers for this person that you would like us to store for easy access to their information.
   * **Maximum length:** 255 characters.
   *
   * The validation for the `externalId` uses the following regex pattern `^([a-zA-Z\d[\s][_][=][,][-][.][^;]])+$`.
   */
  externalId?: InputMaybe<Scalars["String"]>;
  /** The identification documents used to verify the authorized user. */
  identificationDocument?: InputMaybe<UsIdentificationDocumentInput>;
  /** The authorized user's legal name. */
  name: PersonAuthorizedUserNameInput;
  /** The primary phone number for this authorized user. */
  phoneNumber: PhoneInput;
};

/** The details of the AuthorizedUser at the time of application. */
export type UsPersonAuthorizedUserSnapshot = PersonAuthorizedUser & {
  __typename?: "USPersonAuthorizedUserSnapshot";
  /** The authorized user. */
  authorizedUserCurrent?: Maybe<UsPersonAuthorizedUser>;
  /** The default billing addresses of the authorized user */
  billingAddress?: Maybe<Address>;
  /** The date of birth of the authorized user represented in YYYY-MM-DD format. */
  dateOfBirth?: Maybe<Scalars["String"]>;
  /** The email address of the account holder. */
  email?: Maybe<Scalars["String"]>;
  /** Identification Document associated with the authorized user. */
  identificationDocument?: Maybe<UsIdentificationDocument>;
  /** The authorized user's name, represented as different parts. */
  name?: Maybe<Name>;
  /** List of phone numbers associated with the authorized user. */
  phoneNumbers?: Maybe<Array<Phone>>;
};

/** A reference to a tokenized USPersonAuthorizedUser. */
export type UsPersonAuthorizedUserToken = {
  __typename?: "USPersonAuthorizedUserToken";
  /**
   * The reference to the tokenized USPersonAuthorizedUser.
   *
   * The tokenized `USPersonAuthorizedUser` data to be used as input to subsequent mutations (e.g. `createUSPersonAuthorizedUserFromToken`).
   *
   * Expires after 1 hour.
   */
  token: Scalars["String"];
};

/** Input fields for creating a USUltimateBeneficialOwner. */
export type UsUltimateBeneficialOwnerInput = {
  /**
   * Date of birth in YYYY-MM-DD format.
   * **Minimum age:** 18 years. **Maximum age:** 100 years, in place to combat fraud and potential elder financial abuse.
   */
  dateOfBirth: Scalars["String"];
  /**
   * The ultimate beneficial owner's e-mail address.
   *
   * **Note:** Highnote does not verify the e-mail address.
   */
  email: Scalars["String"];
  /**
   * The ultimate beneficial owner's U.S. physical address.
   *
   * Exactly one of `homeAddress` or `homeAddressToken` must be provided.
   */
  homeAddress?: InputMaybe<AddressInput>;
  /**
   * A token representing the ultimate beneficial owner's U.S. physical address.
   *
   * Exactly one of `homeAddress` or `homeAddressToken` must be provided.
   */
  homeAddressToken?: InputMaybe<Scalars["ID"]>;
  /** The identification document used to verify the ultimate beneficial owner. */
  identificationDocument: UsIdentificationDocumentInput;
  /** The ultimate beneficial owner's legal name. */
  name: UsAssociatedPersonNameInput;
  /**
   * Percentage ownership of this ultimate beneficial owner in business if any.
   * **Minimum percentage ownership:** 25%
   */
  percentageOwnership?: InputMaybe<Scalars["Int"]>;
  /** The primary phone number for this ultimate beneficial owner. */
  phoneNumber: PhoneInput;
};

/** Input fields for updating a `USUltimateBeneficialOwner`. */
export type UsUltimateBeneficialOwnerUpdateInput = {
  /**
   * Date of birth in YYYY-MM-DD format.
   * **Minimum age:** 18 years. **Maximum age:** 100 years, in place to combat fraud and potential elder financial abuse.
   *
   * Note: Only fields provided as part of the input will be updated. Fields not provided will remain unchanged.
   */
  dateOfBirth?: InputMaybe<Scalars["String"]>;
  /**
   * The ultimate beneficial owner's e-mail address.
   *
   * Note: Only fields provided as part of the input will be updated. Fields not provided will remain unchanged.
   */
  email?: InputMaybe<Scalars["String"]>;
  /**
   * The ultimate beneficial owner's U.S. physical address.
   *
   * Note: Only fields provided as part of the input will be updated. Fields not provided will remain unchanged.
   */
  homeAddress?: InputMaybe<AddressInput>;
  /**
   * The identification document used to verify the ultimate beneficial owner.
   *
   * Note: Only fields provided as part of the input will be updated. Fields not provided will remain unchanged.
   */
  identificationDocument?: InputMaybe<UsIdentificationDocumentInput>;
  /**
   * The ultimate beneficial owner's legal name.
   *
   * Note: Only fields provided as part of the input will be updated. Fields not provided will remain unchanged.
   */
  name?: InputMaybe<UsAssociatedPersonNameUpdateInput>;
  /**
   * Percentage ownership of this ultimate beneficial owner in business if any.
   * **Minimum percentage ownership:** 25%
   *
   * Note: Only fields provided as part of the input will be updated. Fields not provided will remain unchanged.
   */
  percentageOwnership?: InputMaybe<Scalars["Int"]>;
  /**
   * The primary phone number for this ultimate beneficial owner.
   *
   * Note: Only fields provided as part of the input will be updated. Fields not provided will remain unchanged.
   */
  phoneNumber?: InputMaybe<PhoneInput>;
};

/** Input for filtering by `USBusinessUltimateBeneficialOwner`'s `Address`. */
export type UltimateBeneficialOwnerAddressFilterInput = {
  postalCode?: InputMaybe<StringFilterInput>;
};

/** A type representing an adverse underwriting decision. */
export type UnderwriterAdverseDecision = {
  __typename?: "UnderwriterAdverseDecision";
  /** A list of reasons why the underwriting decision was adverse. */
  adverseActionReasons?: Maybe<Array<Maybe<AdverseActionReason>>>;
};

/** The underwriting decision. Can be positive or adverse. */
export type UnderwriterDecision =
  | UnderwriterAdverseDecision
  | UnderwriterPositiveDecision;

/** A type representing a positive underwriting decision. */
export type UnderwriterPositiveDecision = {
  __typename?: "UnderwriterPositiveDecision";
  /** The approved credit line, based on pre-defined rules. */
  creditLine: Amount;
  /** Terms such as interest rates for each `CreditPlan` associated with this application. */
  creditPlanTerms?: Maybe<Array<CreditPlanTerms>>;
};

/** High-level account holder underwriting verification states. */
export enum UnderwriterVerificationStatusCode {
  /** The account holder was denied. See the results of the underwriter verification for more details. */
  DENIED = "DENIED",
  /** The account holder is currently being reviewed by underwriter. */
  IN_REVIEW = "IN_REVIEW",
  /** The account holder passed the underwriter verification requirements. */
  PASSED = "PASSED",
  /** The account holder is currently being verified by underwriter. */
  PENDING = "PENDING",
}

/** This fee is undetermined. Contact Highnote to get more details about this fee. */
export type UndeterminedFeePaymentTransactionFee = PaymentTransactionFee & {
  __typename?: "UndeterminedFeePaymentTransactionFee";
  /**
   * The direction the fees are moving in the perspective of the subscriber.
   * * when DEBIT, this fee is deducted from the total payable amount.
   * * when CREDIT, this fee is credited to the total payable amount.
   */
  accountingDirection?: Maybe<AccountingDirection>;
  /** The amount of the fee. */
  feeAmount?: Maybe<Amount>;
};

/**
 * `UnifiedFundsTransfer` is a common type object used to transfer money between multiple objects.
 *
 * Once the transfer has started, use `UnifiedFundsTransfer.transfer` to view the actual transfer between the source and destination objects.
 */
export type UnifiedFundsTransfer = Node & {
  __typename?: "UnifiedFundsTransfer";
  /** The date and time, in ISO 8601 format, when this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The destination of the funds to transfer. */
  destination?: Maybe<UnifiedFundsTransferDestination>;
  /** Externally provided ID (255 character limit) to associate this object with an external system. */
  externalIdentifier?: Maybe<Scalars["String"]>;
  /** When the `UnifiedFundsTransfer.status` is `FAILED` during this event, this will be populated with the reason for the failure. */
  failureReason?: Maybe<UnifiedFundsTransferFailureReason>;
  /** Global ID used to reference this object. */
  id: Scalars["ID"];
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: Maybe<Scalars["String"]>;
  /** The reason for the transfer. */
  memo?: Maybe<Scalars["String"]>;
  /** The source of the funds to transfer. */
  source?: Maybe<UnifiedFundsTransferSource>;
  /** The current status of the transfer. */
  status?: Maybe<UnifiedFundsTransferStatus>;
  /** The steps associated with this transfer. */
  steps?: Maybe<Array<UnifiedFundsTransferStep>>;
  /** The date and time, in ISO 8601 format, when this object was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** The destination of the funds being transferred. */
export type UnifiedFundsTransferDestination = {
  __typename?: "UnifiedFundsTransferDestination";
  /** The amount of funds to deposit at the destination. */
  amount?: Maybe<Amount>;
  /** If the source is a Highnote `Node`, this will be the `Node`. */
  node?: Maybe<UnifiedFundsTransferDestinationNode>;
};

/**
 * The destination of the funds to transfer.
 *
 * One of `id` or `usBankAccount` must be provided.
 */
export type UnifiedFundsTransferDestinationInput = {
  /**
   * The amount of funds to deposit in the destination.
   *
   * If this is provided, the `source.amount` will be calculated based on the exchange rate.
   */
  amount?: InputMaybe<AmountInput>;
  /** Additional details for bank-to-bank transfers (RTP, ACH). */
  bankTransferDetails?: InputMaybe<QuoteBankTransferDetailsInput>;
  /**
   * The ID of a Highnote `Node` representing the destination of the funds.
   *
   * Currently these `Node` types are supported as destination IDs:
   * - `FinancialAccount`
   * - `PaymentMethodToken`
   */
  id?: InputMaybe<Scalars["ID"]>;
  /**
   * Raw US bank account details (account/routing number).
   *
   * Use this when the destination is an external bank account not registered as a Highnote `Node`.
   */
  usBankAccount?: InputMaybe<TransferFundsUsBankAccountInput>;
};

/** The possible destinations of the `UnifiedFundsTransfer`. */
export type UnifiedFundsTransferDestinationNode =
  | FinancialAccount
  | PaymentMethodToken
  | UsBankAccount;

/** Detail about the transfer. */
export type UnifiedFundsTransferDetail = {
  __typename?: "UnifiedFundsTransferDetail";
  /** The total fee for the transfer. */
  feeTotal?: Maybe<Amount>;
  /** A human-readable estimate of the time it will take for the transfer to complete. */
  timeEstimate?: Maybe<Scalars["String"]>;
};

/** Reasons an `UnifiedFundsTransfer` may have failed. */
export enum UnifiedFundsTransferFailureReason {
  /** The `UnifiedFundsTransfer` failed because the source and destination accounts do not belong to the same product. */
  ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT = "ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT",
  /** The `UnifiedFundsTransfer` failed because the account is closed. */
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  /** The `UnifiedFundsTransfer` failed because the account is frozen. */
  ACCOUNT_FROZEN = "ACCOUNT_FROZEN",
  /** The `UnifiedFundsTransfer` failed because the account is not active. */
  ACCOUNT_NOT_ACTIVE = "ACCOUNT_NOT_ACTIVE",
  /** The `UnifiedFundsTransfer` failed because the account could not be found. */
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  /** The `UnifiedFundsTransfer` failed because the account was not provided. */
  ACCOUNT_NOT_PROVIDED = "ACCOUNT_NOT_PROVIDED",
  /** The `UnifiedFundsTransfer` failed because ACH loads are not allowed by the program. */
  ACH_LOAD_NOT_ALLOWED_BY_PROGRAM = "ACH_LOAD_NOT_ALLOWED_BY_PROGRAM",
  /** The `UnifiedFundsTransfer` failed because compliance verification failed. */
  ANI_VERIFICATION_FAILED = "ANI_VERIFICATION_FAILED",
  /** The `UnifiedFundsTransfer` failed because the CVC3/DCVV is invalid. */
  BAD_CVC3_DCVV = "BAD_CVC3_DCVV",
  /** The `UnifiedFundsTransfer` failed because the CVV is invalid. */
  BAD_CVV = "BAD_CVV",
  /** The `UnifiedFundsTransfer` failed because the CVV2 is invalid. */
  BAD_CVV2 = "BAD_CVV2",
  /** The `UnifiedFundsTransfer` failed because the bank-managed beta account feature is not enabled. */
  BANK_MANAGED_BETA_ACCOUNT_FEATURE_NOT_ENABLED = "BANK_MANAGED_BETA_ACCOUNT_FEATURE_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because the card has been blocked. */
  BLOCKED_CARD = "BLOCKED_CARD",
  /** The `UnifiedFundsTransfer` failed because the card funding feature is not enabled. */
  CARD_FUNDING_FEATURE_NOT_ENABLED = "CARD_FUNDING_FEATURE_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because the cash back limit has been exceeded. */
  CASH_BACK_LIMIT_EXCEEDED = "CASH_BACK_LIMIT_EXCEEDED",
  /** The `UnifiedFundsTransfer` failed because cash fund-out is not supported on this product. */
  CASH_FUND_OUT_NOT_SUPPORTED_ON_PRODUCT = "CASH_FUND_OUT_NOT_SUPPORTED_ON_PRODUCT",
  /** The `UnifiedFundsTransfer` failed because the charge-off amount exceeds the account balance. */
  CHARGE_OFF_EXCEEDS_BALANCE = "CHARGE_OFF_EXCEEDS_BALANCE",
  /** The `UnifiedFundsTransfer` failed because the check-capable account feature is not enabled. */
  CHECK_CAPABLE_ACCOUNT_FEATURE_NOT_ENABLED = "CHECK_CAPABLE_ACCOUNT_FEATURE_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because check payments are not supported on this product. */
  CHECK_PAYMENT_NOT_SUPPORTED_ON_PRODUCT = "CHECK_PAYMENT_NOT_SUPPORTED_ON_PRODUCT",
  /** The `UnifiedFundsTransfer` failed because of chip card ARQC validation failure. */
  CHIP_CARD_ARQC_VALIDATION_FAILURE = "CHIP_CARD_ARQC_VALIDATION_FAILURE",
  /** The `UnifiedFundsTransfer` failed because the commercial credit (pay-in-full) feature is not enabled. */
  COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED = "COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because compliance verification failed. */
  COMPLIANCE_VERIFICATION_FAILED = "COMPLIANCE_VERIFICATION_FAILED",
  /** The `UnifiedFundsTransfer` failed because the corporate bank account feature is not enabled. */
  CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED = "CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because the credit card feature is not enabled. */
  CREDIT_CARD_FEATURE_NOT_ENABLED = "CREDIT_CARD_FEATURE_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because a credit limit has not been set on the account. */
  CREDIT_LIMIT_NOT_SET_ON_ACCOUNT = "CREDIT_LIMIT_NOT_SET_ON_ACCOUNT",
  /** The `UnifiedFundsTransfer` failed because the source and destination accounts use different currencies. */
  CURRENCY_MISMATCH = "CURRENCY_MISMATCH",
  /** The `UnifiedFundsTransfer` failed because the DDA feature is not enabled. */
  DDA_FEATURE_NOT_ENABLED = "DDA_FEATURE_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because the debit card feature is not enabled. */
  DEBIT_CARD_FEATURE_NOT_ENABLED = "DEBIT_CARD_FEATURE_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because the dispute chargeback feature is not enabled. */
  DISPUTE_CHARGEBACK_NOT_ENABLED = "DISPUTE_CHARGEBACK_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because provisional credit for chargebacks is not enabled. */
  DISPUTE_CHARGEBACK_PROVISIONAL_CREDIT_NOT_ENABLED = "DISPUTE_CHARGEBACK_PROVISIONAL_CREDIT_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because the transaction was declined with 'Do not honor' response. */
  DO_NOT_HONOR = "DO_NOT_HONOR",
  /** The `UnifiedFundsTransfer` failed because the transaction exceeds the approval amount limit. */
  EXCEEDS_APPROVAL_AMOUNT_LIMIT = "EXCEEDS_APPROVAL_AMOUNT_LIMIT",
  /** The `UnifiedFundsTransfer` failed because the transaction exceeds the withdrawal frequency limit. */
  EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT = "EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT",
  /** The `UnifiedFundsTransfer` failed because the card has expired. */
  EXPIRED_CARD = "EXPIRED_CARD",
  /** The `UnifiedFundsTransfer` failed because external money movement is not supported on this product. */
  EXTERNAL_MONEY_MOVEMENT_NOT_SUPPORTED_ON_PRODUCT = "EXTERNAL_MONEY_MOVEMENT_NOT_SUPPORTED_ON_PRODUCT",
  /** The `UnifiedFundsTransfer` failed because fee collection failed. */
  FEE_COLLECTION_FAILED = "FEE_COLLECTION_FAILED",
  /** The `UnifiedFundsTransfer` failed because fee reversal failed. */
  FEE_REVERSAL_FAILED = "FEE_REVERSAL_FAILED",
  /** The `UnifiedFundsTransfer` fee was reversed. */
  FEE_REVERSED = "FEE_REVERSED",
  /** The `UnifiedFundsTransfer` failed because the fleet feature is not enabled. */
  FLEET_FEATURE_NOT_ENABLED = "FLEET_FEATURE_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because the funding account feature is not enabled. */
  FUNDING_ACCOUNT_FEATURE_NOT_ENABLED = "FUNDING_ACCOUNT_FEATURE_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because the funding card is not supported. */
  FUNDING_CARD_NOT_SUPPORTED = "FUNDING_CARD_NOT_SUPPORTED",
  /** The `UnifiedFundsTransfer` failed because the Highnote account feature is not enabled. */
  HIGHNOTE_ACCOUNT_FEATURE_NOT_ENABLED = "HIGHNOTE_ACCOUNT_FEATURE_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because the idempotency key was not provided. */
  IDEMPOTENCY_KEY_NOT_PROVIDED = "IDEMPOTENCY_KEY_NOT_PROVIDED",
  /** The `UnifiedFundsTransfer` failed because the source account has insufficient funds. */
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  /** The `UnifiedFundsTransfer` failed because of an internal server error. */
  INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
  /** The `UnifiedFundsTransfer` failed because inter-financial account transfer rules were not satisfied. */
  INTER_FINANCIAL_ACCOUNT_TRANSFER_RULES_NOT_PASSED = "INTER_FINANCIAL_ACCOUNT_TRANSFER_RULES_NOT_PASSED",
  /** The `UnifiedFundsTransfer` failed because the amount is invalid. */
  INVALID_AMOUNT = "INVALID_AMOUNT",
  /** The `UnifiedFundsTransfer` failed because the authorization has an invalid expiration. */
  INVALID_AUTHORIZATION_EXPIRATION = "INVALID_AUTHORIZATION_EXPIRATION",
  /** The `UnifiedFundsTransfer` failed because the card number is invalid. */
  INVALID_CARD_NUMBER = "INVALID_CARD_NUMBER",
  /** The `UnifiedFundsTransfer` failed because the disbursement amount is invalid. */
  INVALID_DISBURSEMENT_AMOUNT = "INVALID_DISBURSEMENT_AMOUNT",
  /** The `UnifiedFundsTransfer` failed because the merchant is invalid. */
  INVALID_MERCHANT = "INVALID_MERCHANT",
  /** The `UnifiedFundsTransfer` failed because the track data is invalid. */
  INVALID_TRACK_DATA = "INVALID_TRACK_DATA",
  /** The `UnifiedFundsTransfer` failed because the transaction is invalid. */
  INVALID_TRANSACTION = "INVALID_TRANSACTION",
  /** The `UnifiedFundsTransfer` failed because the JIT (Just-In-Time) feature is not enabled. */
  JIT_FEATURE_NOT_ENABLED = "JIT_FEATURE_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because the merchant funding feature is not enabled. */
  MERCHANT_FUNDING_FEATURE_NOT_ENABLED = "MERCHANT_FUNDING_FEATURE_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because the merchant settlement feature is not enabled. */
  MERCHANT_SETTLEMENT_FEATURE_NOT_ENABLED = "MERCHANT_SETTLEMENT_FEATURE_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed due to a network error. */
  NETWORK_ERROR = "NETWORK_ERROR",
  /** The `UnifiedFundsTransfer` failed because the network is not supported. */
  NETWORK_NOT_SUPPORTED = "NETWORK_NOT_SUPPORTED",
  /** The `UnifiedFundsTransfer` failed because the account is not organization-owned as required. */
  NOT_AN_ORGANIZATION_OWNED_ACCOUNT = "NOT_AN_ORGANIZATION_OWNED_ACCOUNT",
  /** The `UnifiedFundsTransfer` failed because the balance is insufficient to reduce the credit limit. */
  NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT = "NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT",
  /** The `UnifiedFundsTransfer` failed because the ODF feature is not enabled. */
  ODF_FEATURE_NOT_ENABLED = "ODF_FEATURE_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because the organization ID was not provided. */
  ORGANIZATION_ID_NOT_PROVIDED = "ORGANIZATION_ID_NOT_PROVIDED",
  /** The `UnifiedFundsTransfer` failed because originated ACH unloads are not supported on this product. */
  ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT = "ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT",
  /** The `UnifiedFundsTransfer` failed because the partial funding feature is not enabled. */
  PARTIAL_FUNDING_FEATURE_NOT_ENABLED = "PARTIAL_FUNDING_FEATURE_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because the payroll advance feature is not enabled on the account. */
  PAYROLL_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because the payroll employer advance feature is not enabled on the account. */
  PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because the prepaid card feature is not enabled. */
  PREPAID_CARD_FEATURE_NOT_ENABLED = "PREPAID_CARD_FEATURE_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because the pre-authorization has expired. */
  PRE_AUTHORIZATION_EXPIRED = "PRE_AUTHORIZATION_EXPIRED",
  /** The `UnifiedFundsTransfer` failed because the product funding feature is not enabled. */
  PRODUCT_FUNDING_FEATURE_NOT_ENABLED = "PRODUCT_FUNDING_FEATURE_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because the product-secured deposit account feature is not enabled. */
  PRODUCT_SECURED_DEPOSIT_ACCOUNT_FEATURE_NOT_ENABLED = "PRODUCT_SECURED_DEPOSIT_ACCOUNT_FEATURE_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because the pseudo balance feature is not enabled. */
  PSEUDO_BALANCE_NOT_ENABLED = "PSEUDO_BALANCE_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because the pull payment did not succeed. */
  PULL_PAYMENT_FAILED = "PULL_PAYMENT_FAILED",
  /** The `UnifiedFundsTransfer` failed because the push payment did not succeed. */
  PUSH_PAYMENT_FAILED = "PUSH_PAYMENT_FAILED",
  /** The `UnifiedFundsTransfer` failed because the receivable purchase feature is not enabled. */
  RECEIVABLE_PURCHASE_NOT_ENABLED = "RECEIVABLE_PURCHASE_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because the repayment account is not present on the product. */
  REPAYMENT_ACCOUNT_NOT_PRESENT_ON_PRODUCT = "REPAYMENT_ACCOUNT_NOT_PRESENT_ON_PRODUCT",
  /** The `UnifiedFundsTransfer` failed because the transaction is from a restricted location. */
  RESTRICTED_LOCATION = "RESTRICTED_LOCATION",
  /** The `UnifiedFundsTransfer` failed because the reward point feature is not enabled. */
  REWARD_POINT_FEATURE_NOT_ENABLED = "REWARD_POINT_FEATURE_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because the transaction needs to be re-entered. */
  RE_ENTER_TRANSACTION = "RE_ENTER_TRANSACTION",
  /** The `UnifiedFundsTransfer` failed because the transaction was declined due to risk assessment. */
  RISK_DECLINE = "RISK_DECLINE",
  /** The `UnifiedFundsTransfer` failed because the secured deposit account feature is not enabled. */
  SECURED_DEPOSIT_ACCOUNT_FEATURE_NOT_ENABLED = "SECURED_DEPOSIT_ACCOUNT_FEATURE_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because the secure card feature is not enabled. */
  SECURE_CARD_FEATURE_NOT_ENABLED = "SECURE_CARD_FEATURE_NOT_ENABLED",
  /** The `UnifiedFundsTransfer` failed because of special conditions that do not require card pickup. */
  SPECIAL_CONDITION_NO_PICK_UP = "SPECIAL_CONDITION_NO_PICK_UP",
  /** The `UnifiedFundsTransfer` failed because the card has been suspended. */
  SUSPENDED_CARD = "SUSPENDED_CARD",
  /** The `UnifiedFundsTransfer` failed because the tenant ID was not provided. */
  TENANT_ID_NOT_PROVIDED = "TENANT_ID_NOT_PROVIDED",
  /** The `UnifiedFundsTransfer` failed because the card has been terminated. */
  TERMINATED_CARD = "TERMINATED_CARD",
  /** The `UnifiedFundsTransfer` failed due to a timeout. */
  TIMEOUT = "TIMEOUT",
  /** The `UnifiedFundsTransfer` failed because the transaction ID was not provided. */
  TRANSACTION_ID_NOT_PROVIDED = "TRANSACTION_ID_NOT_PROVIDED",
  /** The `UnifiedFundsTransfer` failed because the transaction type is not permitted. */
  TRANSACTION_NOT_PERMITTED = "TRANSACTION_NOT_PERMITTED",
  /** The `UnifiedFundsTransfer` failed because the transfer amount is below the program’s minimum reload limit. */
  TRANSFER_AMOUNT_BELOW_MIN_PROGRAM_RELOAD_LIMIT = "TRANSFER_AMOUNT_BELOW_MIN_PROGRAM_RELOAD_LIMIT",
  /** The `UnifiedFundsTransfer` failed because the transfer amount exceeds the maximum allowed for credit distribution. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_AGGREGATE_CREDIT_DISTRIBUTION_AMOUNT = "TRANSFER_AMOUNT_EXCEEDING_MAX_AGGREGATE_CREDIT_DISTRIBUTION_AMOUNT",
  /** The `UnifiedFundsTransfer` failed because the transfer amount exceeds the program’s maximum card balance. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_CARD_BALANCE = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_CARD_BALANCE",
  /** The `UnifiedFundsTransfer` failed because the transfer amount exceeds the program’s maximum load limit. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT",
  /** The `UnifiedFundsTransfer` failed because the transfer amount exceeds the program’s maximum reload limit. */
  TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_RELOAD_LIMIT = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_RELOAD_LIMIT",
  /** The `UnifiedFundsTransfer` failed because the transfer amount is negative or zero. */
  TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO = "TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO",
  /** The `UnifiedFundsTransfer` failed because transfers between different products are not allowed. */
  TRANSFER_BETWEEN_PRODUCTS_NOT_ALLOWED = "TRANSFER_BETWEEN_PRODUCTS_NOT_ALLOWED",
  /** The `UnifiedFundsTransfer` failed because the accounts do not have the same primary account holder. */
  TRANSFER_CONDITION_SAME_PRIMARY_ACCOUNT_HOLDER_NOT_SATISFIED = "TRANSFER_CONDITION_SAME_PRIMARY_ACCOUNT_HOLDER_NOT_SATISFIED",
  /** The `UnifiedFundsTransfer` failed because the transfer is not permitted. */
  TRANSFER_NOT_PERMITTED = "TRANSFER_NOT_PERMITTED",
  /** The `UnifiedFundsTransfer` failed because transfers between the source and destination accounts are not supported. */
  TRANSFER_NOT_SUPPORTED = "TRANSFER_NOT_SUPPORTED",
  /** The `UnifiedFundsTransfer` failed because this product does not support this type of transfer. */
  TRANSFER_NOT_SUPPORTED_ON_PRODUCT = "TRANSFER_NOT_SUPPORTED_ON_PRODUCT",
  /** The `UnifiedFundsTransfer` failed because the transfer orchestration ID was not provided. */
  TRANSFER_ORCHESTRATION_ID_NOT_PROVIDED = "TRANSFER_ORCHESTRATION_ID_NOT_PROVIDED",
  /** The `UnifiedFundsTransfer` failed because the card has not been activated. */
  UNACTIVATED_CARD = "UNACTIVATED_CARD",
  /** The `UnifiedFundsTransfer` failed because the valid account amount is not supported. */
  VALID_ACCOUNT_AMOUNT_NOT_SUPPORTED = "VALID_ACCOUNT_AMOUNT_NOT_SUPPORTED",
}

/** A step associated with a `UnifiedFundsTransfer` when the request was initiated. */
export type UnifiedFundsTransferInitiateRequestStep = {
  __typename?: "UnifiedFundsTransferInitiateRequestStep";
  /** The date and time, in ISO 8601 format, when this step occurred. */
  createdAt?: Maybe<Scalars["String"]>;
  /** When the `UnifiedFundsTransfer.status` is `FAILED` during this event, this will be populated with the reason for the failure. */
  failureReason?: Maybe<UnifiedFundsTransferFailureReason>;
  /** The global ID of the step. */
  id?: Maybe<Scalars["ID"]>;
  /** The status of the transfer at the time of this step. */
  status?: Maybe<UnifiedFundsTransferStatus>;
};

/** A step associated with a `UnifiedFundsTransfer` when a transfer has initiated. */
export type UnifiedFundsTransferInstantNetworkTransferStep = {
  __typename?: "UnifiedFundsTransferInstantNetworkTransferStep";
  /** The date and time, in ISO 8601 format, when this step occurred. */
  createdAt?: Maybe<Scalars["String"]>;
  /** When the `UnifiedFundsTransfer.status` is `FAILED` during this event, this will be populated with the reason for the failure. */
  failureReason?: Maybe<UnifiedFundsTransferFailureReason>;
  /** The global ID of the step. */
  id?: Maybe<Scalars["ID"]>;
  /** The status of the transfer at the time of this step. */
  status?: Maybe<UnifiedFundsTransferStatus>;
  /** The transfer associated with this step. */
  transfer?: Maybe<UnifiedFundsTransferStepTransfer>;
};

/**
 * A quote generated by `createUnifiedFundsTransferQuote`. This is the first step towards transferring funds.
 * Show this quote to your customer for them to accept.
 *
 * Once the quote is accepted, call `initiateUnifiedFundsTransfer` with the `UnifiedFundsTransferQuote.id` to initiate the transfer.
 */
export type UnifiedFundsTransferQuote = {
  __typename?: "UnifiedFundsTransferQuote";
  /** The date and time, in ISO 8601 format, when this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The destination of the funds to transfer. */
  destination?: Maybe<UnifiedFundsTransferDestination>;
  /** The date and time, in ISO 8601 format, when this transfer will expire. */
  expiresAt?: Maybe<Scalars["String"]>;
  /** Identifier used to reference the quote. Will need to be passed into `initiateUnifiedFundsTransfer` to start a transfer */
  id: Scalars["ID"];
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: Maybe<Scalars["String"]>;
  /** The reason for the transfer. */
  memo?: Maybe<Scalars["String"]>;
  /** The source of the funds to transfer. */
  source?: Maybe<UnifiedFundsTransferSource>;
  /** The detail of the transfer including the fee and time estimate. */
  transferDetail?: Maybe<UnifiedFundsTransferDetail>;
  /** The date and time, in ISO 8601 format, when this object was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/** A step associated with a `UnifiedFundsTransfer` when an RTP (Real-Time Payments) transfer has initiated. */
export type UnifiedFundsTransferRtpStep = {
  __typename?: "UnifiedFundsTransferRtpStep";
  /** The date and time, in ISO 8601 format, when this step occurred. */
  createdAt?: Maybe<Scalars["String"]>;
  /** When the `UnifiedFundsTransfer.status` is `FAILED` during this event, this will be populated with the reason for the failure. */
  failureReason?: Maybe<UnifiedFundsTransferFailureReason>;
  /** The global ID of the step. */
  id?: Maybe<Scalars["ID"]>;
  /** The status of the transfer at the time of this step. */
  status?: Maybe<UnifiedFundsTransferStatus>;
  /** The `OriginatedRtpTransfer` associated with this step. */
  transfer?: Maybe<OriginatedRtpTransfer>;
};

/** The source of the funds to transfer. */
export type UnifiedFundsTransferSource = {
  __typename?: "UnifiedFundsTransferSource";
  /** The amount of funds to source the transfer. */
  amount?: Maybe<Amount>;
  /** If the source is a Highnote `Node`, this will be the `Node`. */
  node?: Maybe<UnifiedFundsTransferSourceNode>;
};

/**
 * The source of the funds to transfer.
 *
 * One of `id` or `usBankAccount` must be provided.
 */
export type UnifiedFundsTransferSourceInput = {
  /**
   * The amount of funds to source the transfer.
   *
   * If this is provided, the `destination.amount` will be calculated based on the exchange rate.
   */
  amount?: InputMaybe<AmountInput>;
  /** Additional details for bank-to-bank transfers (RTP, ACH). */
  bankTransferDetails?: InputMaybe<QuoteBankTransferDetailsInput>;
  /**
   * The ID of a Highnote `Node` representing the source of the funds.
   *
   * Currently these `Node` types are supported as source IDs:
   * - `FinancialAccount`
   * - `PaymentMethodToken`
   */
  id?: InputMaybe<Scalars["ID"]>;
  /**
   * Raw US bank account details (account/routing number).
   *
   * Use this when the source is an external bank account not registered as a Highnote `Node`.
   */
  usBankAccount?: InputMaybe<TransferFundsUsBankAccountInput>;
};

/** The possible sources of the `UnifiedFundsTransfer`. */
export type UnifiedFundsTransferSourceNode =
  | FinancialAccount
  | PaymentMethodToken
  | UsBankAccount;

/** The status of a `UnifiedFundsTransfer`. */
export enum UnifiedFundsTransferStatus {
  /** The `UnifiedFundsTransfer` has been completed. */
  COMPLETED = "COMPLETED",
  /** The `UnifiedFundsTransfer` has failed. */
  FAILED = "FAILED",
  /** The `UnifiedFundsTransfer` has been initiated and is being processed. */
  PROCESSING = "PROCESSING",
}

export type UnifiedFundsTransferStep =
  | UnifiedFundsTransferInitiateRequestStep
  | UnifiedFundsTransferInstantNetworkTransferStep
  | UnifiedFundsTransferRtpStep;

/** The types of transfers that the `UnifiedFundsTransfer` may start. */
export type UnifiedFundsTransferStepTransfer = InstantNetworkTransfer;

/** The range type for `UnsignedInt`. */
export type UnsignedIntegerRange = {
  __typename?: "UnsignedIntegerRange";
  /** The maximum value (exclusive). */
  maximumExclusive?: Maybe<Scalars["UnsignedInt"]>;
  /** The maximum value (inclusive). */
  maximumInclusive?: Maybe<Scalars["UnsignedInt"]>;
  /** The minimum value (exclusive). */
  minimumExclusive?: Maybe<Scalars["UnsignedInt"]>;
  /** The minimum value (inclusive). */
  minimumInclusive?: Maybe<Scalars["UnsignedInt"]>;
};

/** The input to unsuspend a card digital wallet token. */
export type UnsuspendCardDigitalWalletTokenInput = {
  /** The ID of the card digital wallet token to reactivate. */
  cardDigitalWalletTokenId: Scalars["ID"];
  /** The reason for the card digital wallet token to be reactivated. */
  reason: UnsuspendCardDigitalWalletTokenReason;
};

/** The return types when unsuspending a card digital wallet token. */
export type UnsuspendCardDigitalWalletTokenPayload =
  | AccessDeniedError
  | CardDigitalWalletToken
  | UserError;

/** Reasons for a card digital wallet token to be unsuspended/reactivated. */
export enum UnsuspendCardDigitalWalletTokenReason {
  /** A lost or stolen device has been found or recovered. */
  DEVICE_FOUND = "DEVICE_FOUND",
  /**
   * After reviewing transaction history,
   * the account holder or `Highnote` confirmed that there were no fraudulent transactions.
   */
  NON_FRAUDULENT_TRANSACTIONS = "NON_FRAUDULENT_TRANSACTIONS",
  /** Any other reason for reactivating the card digital wallet token. */
  OTHER = "OTHER",
}

/** The input details for unsuspending a `FinancialAccount`. */
export type UnsuspendFinancialAccountInput = {
  /** The `FinancialAccount` ID to be unsuspended. */
  id: Scalars["ID"];
  /**
   * The memo for unsuspending the `FinancialAccount`.
   *
   * Regex: ^[a-zA-Z\d$ ',.\-\_!@#$%^&*+=`?"\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\n]+$
   * Memo has a max length of 2048 characters.
   * For compliance and security reasons, memo should not contain any sensitive information, such as PII or PCI.
   */
  memo: Scalars["String"];
};

/** The anticipated configuration values for the next upcoming billing cycle. */
export type UpcomingBillingCycleConfiguration = {
  __typename?: "UpcomingBillingCycleConfiguration";
  /**
   * Billing cycle end day of the month.
   *
   * Min: 4
   * Max: 24
   */
  billingCycleEndDayOfMonth?: Maybe<Scalars["Int"]>;
  /**
   * Billing cycle start day of the month. The billing cycle starts the day the Financial Account is created.
   *
   * The `billingCycleStartDayOfMonth` range is between 1 and 31.
   */
  billingCycleStartDayOfMonth?: Maybe<Scalars["Int"]>;
  /**
   * Payment due day of the month.
   *
   * Min: 1
   * Max: 21
   */
  paymentDueDayOfMonth?: Maybe<Scalars["Int"]>;
};

/** Event generated when a `FinancialAccountStatement` has an upcoming due date. */
export type UpcomingStatementDueDateEvent = {
  __typename?: "UpcomingStatementDueDateEvent";
  /** The date and time, in ISO 8601 format, this was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The `FinancialAccount` with an upcoming due date. */
  financialAccount?: Maybe<FinancialAccount>;
  /** The number of days remaining until the upcoming due date, as of this event creation. */
  numberOfDaysUntilDueDate?: Maybe<Scalars["UnsignedInt"]>;
  /** The day of the month when payment is due. Will be an integer between 1 and 28. */
  paymentDueDayOfMonth?: Maybe<Scalars["UnsignedInt"]>;
  /** The date and time, in ISO 8601 format, of the upcoming due date. */
  upcomingStatementDueDate?: Maybe<Scalars["String"]>;
};

/** The input to request to update `AccountHolderCardProductApplicationOffer` on an `AccountHolderCardProductApplication` */
export type UpdateAccountHolderCardProductApplicationOffersInput = {
  /** Global ID of the `AccountHolderCardProductApplication` */
  applicationId: Scalars["ID"];
  /** The list of updates to the `AccountHolderCardProductApplicationOffer`s on the Application */
  offerUpdates: Array<UpdateApplicationOfferInput>;
};

/** The details of the `AccountSpendRule` you want to update. */
export type UpdateAccountSpendRuleInput = {
  /**
   * The `Account` IDs to allow during authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  allowed?: InputMaybe<Array<Scalars["ID"]>>;
  /**
   * The `Account` IDs to block during authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  blocked?: InputMaybe<Array<Scalars["ID"]>>;
  /** The name for the rule for future reference. */
  name?: InputMaybe<Scalars["String"]>;
  /** The Global ID of the `AccountSpendRule` to update. */
  spendRuleId: Scalars["ID"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when updating an existing `AccountSpendRule`. */
export type UpdateAccountSpendRulePayload =
  | AccessDeniedError
  | AccountSpendRule
  | UserError;

/** The details of the `AccountTransactionCountSpendRule` spend rule you want to update. */
export type UpdateAccountTransactionCountSpendRuleInput = {
  /**
   * The maximum number of transactions allowed for an account before transactions are declined.
   * **Minimum:** 0
   */
  maximumAccountTransactionCount: Scalars["UnsignedInt"];
  /** The name for the rule for future reference. */
  name?: InputMaybe<Scalars["String"]>;
  /** The Global ID of the `AccountTransactionCountSpendRule` to update. */
  spendRuleId: Scalars["ID"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when updating an existing `AccountTransactionCountSpendRule`. */
export type UpdateAccountTransactionCountSpendRulePayload =
  | AccessDeniedError
  | AccountTransactionCountSpendRule
  | UserError;

/** The details of the `AmountLimitSpendRule` spend rule you want to update. */
export type UpdateAmountLimitSpendRuleInput = {
  /** The maximum amount to allow for a single authorization. */
  maximumAmount: AmountInput;
  /** The name for the rule for future reference. */
  name?: InputMaybe<Scalars["String"]>;
  /** The Global ID of the Amount Limit Spend Rule to update. */
  spendRuleId: Scalars["ID"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when updating an existing amount limit rule. */
export type UpdateAmountLimitSpendRulePayload =
  | AccessDeniedError
  | AmountLimitSpendRule
  | UserError;

/** A single offer update. */
export type UpdateApplicationOfferInput = {
  /** The ID of the offer to accept. */
  offerId: Scalars["ID"];
  /** The requested status update to the offer. */
  offerStatus: CardProductApplicationOfferStatus;
};

/** The details of the `CVVSpendRule` spend rule you want to update. */
export type UpdateCvvSpendRuleInput = {
  /**
   * The `CVVResponseCode` values you want to allow during authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  allowed?: InputMaybe<Array<CvvResponseCode>>;
  /**
   * The `CVVResponseCode` values that will result in declined authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  blocked?: InputMaybe<Array<CvvResponseCode>>;
  /** The name for the rule for future reference. */
  name?: InputMaybe<Scalars["String"]>;
  /** The Global ID of the CVV Spend Rule to update. */
  spendRuleId: Scalars["ID"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when updating an existing CVV rule. */
export type UpdateCvvSpendRulePayload =
  | AccessDeniedError
  | CvvSpendRule
  | UserError;

/** The details of the `CardDataInputCapabilitySpendRule` spend rule to update. */
export type UpdateCardDataInputCapabilitySpendRuleInput = {
  /**
   * The `CardDataInputCapability` values you want to allow during authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  allowed?: InputMaybe<Array<CardDataInputCapability>>;
  /**
   * The `CardDataInputCapability` values that will result in declined authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  blocked?: InputMaybe<Array<CardDataInputCapability>>;
  /** A name for the rule for future reference. */
  name?: InputMaybe<Scalars["String"]>;
  /** The Global ID of the `CardDataInputCapabilitySpendRule` to update. */
  spendRuleId: Scalars["ID"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when updating an existing `CardDataInputCapabilitySpendRule`. */
export type UpdateCardDataInputCapabilitySpendRulePayload =
  | AccessDeniedError
  | CardDataInputCapabilitySpendRule
  | UserError;

/** The details of the Card Product name change. */
export type UpdateCardProductNameInput = {
  /** The ID of the Card Product to update. */
  cardProductId: Scalars["ID"];
  /**
   * The value to update the name to.
   *
   * Maximum length is 50 characters.
   */
  name: Scalars["String"];
};

/** The return types when updating a Card Product name. */
export type UpdateCardProductNamePayload =
  | AccessDeniedError
  | CardProduct
  | UserError;

/** The details of the `CardTransactionProcessingTypeConditionSpendRule` to update */
export type UpdateCardTransactionProcessingTypeConditionSpendRuleInput = {
  /**
   * The list of possible `CardTransactionProcessingType` that will be allowed.
   * Min: 1
   * Max: 5000
   */
  allowed?: InputMaybe<Array<CardTransactionProcessingType>>;
  /**
   * The list of possible `CardTransactionProcessingType` that will result in a decline.
   * Min: 1
   * Max: 5000
   */
  blocked?: InputMaybe<Array<CardTransactionProcessingType>>;
  /** The name of the `CardTransactionProcessingTypeConditionSpendRule` */
  name?: InputMaybe<Scalars["String"]>;
  /** Global ID of the `CardTransactionProcessingTypeConditionSpendRule` to update. */
  spendRuleId: Scalars["ID"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when updating an existing `CardTransactionProcessingTypeConditionSpendRule`. */
export type UpdateCardTransactionProcessingTypeConditionSpendRulePayload =
  | AccessDeniedError
  | CardTransactionProcessingTypeConditionSpendRule
  | UserError;

/** The details of the `ConditionalRuleSetSpendRule` to update */
export type UpdateConditionalRuleSetSpendRuleInput = {
  /** The action to apply to the transaction event, if the rule passes */
  allow: Scalars["Boolean"];
  /** The name of the `ConditionalRuleSetSpendRule` */
  name?: InputMaybe<Scalars["String"]>;
  /** Global ID of the `ConditionalRuleSetSpendRule` to update. */
  spendRuleId: Scalars["ID"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when updating a conditional rule set rule. */
export type UpdateConditionalRuleSetSpendRulePayload =
  | AccessDeniedError
  | ConditionalRuleSetSpendRule
  | UserError;

/** The details of the `CountLimitSpendRule` spend rule you want to update. */
export type UpdateCountLimitSpendRuleInput = {
  /** The maximum count of transactions. */
  maximumCount: Scalars["Int"];
  /** The name for the rule for future reference. */
  name?: InputMaybe<Scalars["String"]>;
  /** The Global ID of the Count Limit Spend Rule to update. */
  spendRuleId: Scalars["ID"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when updating an existing count limit rule. */
export type UpdateCountLimitSpendRulePayload =
  | AccessDeniedError
  | CountLimitSpendRule
  | UserError;

/** The details of the `CreditLimitPercentageSpendRule` spend rule you want to update. */
export type UpdateCreditLimitPercentageSpendRuleInput = {
  /**
   * The maximum percentage of the credit limit allowed for a transaction before transactions are declined.
   * **Minimum:** 0
   * **Maximum:** 100
   */
  maximumPercentageOfCreditLimit: Scalars["UnsignedInt"];
  /** The name for the rule for future reference. */
  name?: InputMaybe<Scalars["String"]>;
  /** The Global ID of the `CreditLimitPercentageSpendRule` to update. */
  spendRuleId: Scalars["ID"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when updating an existing `CreditLimitPercentageSpendRule`. */
export type UpdateCreditLimitPercentageSpendRulePayload =
  | AccessDeniedError
  | CreditLimitPercentageSpendRule
  | UserError;

/** The input to update existing `CustomFields`. */
export type UpdateCustomFieldsInput = {
  /** The input to specify `CustomFields` key value pairs. */
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  /**
   *   The ID of the object associated with the `CustomFields`.
   * C
   */
  id: Scalars["ID"];
};

/** The details of the `DaysWithinAccountCreateDateSpendRule` spend rule you want to update. */
export type UpdateDaysWithinAccountCreateDateSpendRuleInput = {
  /** The maximum number of days since the creation of the `FinancialAccount` before transactions are declined. */
  maximumDaysAccountCreated: Scalars["UnsignedInt"];
  /** The name for the rule for future reference. */
  name?: InputMaybe<Scalars["String"]>;
  /** The Global ID of the `DaysWithinAccountCreateDateSpendRule` to update. */
  spendRuleId: Scalars["ID"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when updating an existing `DaysWithinAccountCreateDateSpendRule`. */
export type UpdateDaysWithinAccountCreateDateSpendRulePayload =
  | AccessDeniedError
  | DaysWithinAccountCreateDateSpendRule
  | UserError;

/** The details of the `DaysWithinCardCreateDateSpendRule` spend rule you want to update. */
export type UpdateDaysWithinCardCreateDateSpendRuleInput = {
  /** The maximum number of days elapsed since the creation of the `PaymentCard` before transactions are declined. */
  maximumDaysCardCreated: Scalars["UnsignedInt"];
  /** The name for the rule for future reference. */
  name?: InputMaybe<Scalars["String"]>;
  /** The Global ID of the `DaysWithinCardCreateDateSpendRule` to update. */
  spendRuleId: Scalars["ID"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when updating an existing `DaysWithinCardCreateDateSpendRule`. */
export type UpdateDaysWithinCardCreateDateSpendRulePayload =
  | AccessDeniedError
  | DaysWithinCardCreateDateSpendRule
  | UserError;

/** The details of the `DepositAmountLimitSpendRule` to update. */
export type UpdateDepositAmountLimitSpendRuleInput = {
  /** The maximum amount to allow for a single deposit. */
  maximumAmount: AmountInput;
  /** A name for the rule for future reference. */
  name?: InputMaybe<Scalars["String"]>;
  /** Global ID of the `DepositAmountLimitSpendRule` to update. */
  spendRuleId: Scalars["ID"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when updating a deposit amount limit rule. */
export type UpdateDepositAmountLimitSpendRulePayload =
  | AccessDeniedError
  | DepositAmountLimitSpendRule
  | UserError;

/** The details of the `DepositCountLimitSpendRule` to update. */
export type UpdateDepositCountLimitSpendRuleInput = {
  /** The maximum count of deposits. */
  maximumCount: Scalars["UnsignedInt"];
  /** A name for the rule for future reference. */
  name?: InputMaybe<Scalars["String"]>;
  /** Global ID of the `DepositCountLimitSpendRule` to update. */
  spendRuleId: Scalars["ID"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when updating a deposit count limit rule. */
export type UpdateDepositCountLimitSpendRulePayload =
  | AccessDeniedError
  | DepositCountLimitSpendRule
  | UserError;

/** The details of the `DepositProcessingNetworkSpendRule` spend rule to update. */
export type UpdateDepositProcessingNetworkSpendRuleInput = {
  /**
   * The list of possible `DepositProcessingNetwork` that will be allowed during cash deposits.
   * Min: 1
   * Max: 5000
   */
  allowed?: InputMaybe<Array<DepositProcessingNetwork>>;
  /**
   * The list of possible `DepositProcessingNetwork` that will result in declined cash deposits.
   * Min: 1
   * Max: 5000
   */
  blocked?: InputMaybe<Array<DepositProcessingNetwork>>;
  /** A name for the rule for future reference. */
  name: Scalars["String"];
  /** The Global ID of the `DepositProcessingNetworkSpendRule` to update. */
  spendRuleId: Scalars["ID"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when updating a cash deposit processing network rule. */
export type UpdateDepositProcessingNetworkSpendRulePayload =
  | AccessDeniedError
  | DepositProcessingNetworkSpendRule
  | UserError;

/** The input to update the billing cycle configuration for a `FinancialAccount`. */
export type UpdateFinancialAccountBillingCycleConfigurationInput = {
  /** The Global ID of the `FinancialAccount` to update. */
  financialAccountId: Scalars["ID"];
  /**
   * The day of the month when payment will be due for this `FinancialAccount`. Must be an integer between 1 and 28.
   * Must be different from the current due date. Any change will only apply to future billing cycles, not the current open cycle or any past cycles.
   */
  paymentDueDayOfMonth: Scalars["UnsignedInt"];
};

/** The return types when calling `updateFinancialAccountBillingCycleConfiguration`. */
export type UpdateFinancialAccountBillingCycleConfigurationPayload =
  | AccessDeniedError
  | FinancialAccount
  | UserError;

/** The details of the Card Product name change. */
export type UpdateFinancialAccountNameInput = {
  /** The ID of the Financial Account to update. */
  financialAccountId: Scalars["ID"];
  /** The value to update the name to. */
  name: Scalars["String"];
};

/** The return types when updating a Financial Account name. */
export type UpdateFinancialAccountNamePayload =
  | AccessDeniedError
  | FinancialAccount
  | UserError;

/** The details of the `MastercardFraudScoreSpendRule` spend rule you want to update. */
export type UpdateMastercardFraudScoreSpendRuleInput = {
  /**
   * The maximum Mastercard Fraud Score allowed for a transaction before transaction is declined.
   * **Minimum:** 0
   * **Maximum:** 999
   */
  maximumMastercardFraudScore: Scalars["UnsignedInt"];
  /** The name for the rule for future reference. */
  name?: InputMaybe<Scalars["String"]>;
  /** The Global ID of the `MastercardFraudScoreSpendRule` to update. */
  spendRuleId: Scalars["ID"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when updating an existing `MastercardFraudScoreSpendRule`. */
export type UpdateMastercardFraudScoreSpendRulePayload =
  | AccessDeniedError
  | MastercardFraudScoreSpendRule
  | UserError;

/** The details of the `MaximumAmountVarianceOnPseudoBalanceSpendRule` spend rule you want to update. */
export type UpdateMaximumAmountVarianceOnPseudoBalanceSpendRuleInput = {
  /** The `Amount` over the account's original balance that is permitted for additional spending. */
  amountVariance: AmountInput;
  /** The name for the rule for future reference. */
  name?: InputMaybe<Scalars["String"]>;
  /** The Global ID of the `MaximumAmountVarianceOnPseudoBalanceSpendRule` to update. */
  spendRuleId: Scalars["ID"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when updating an existing `MaximumAmountVarianceOnPseudoBalanceSpendRule`. */
export type UpdateMaximumAmountVarianceOnPseudoBalanceSpendRulePayload =
  | AccessDeniedError
  | MaximumAmountVarianceOnPseudoBalanceSpendRule
  | UserError;

/** The details of the `MaximumPercentVarianceOnPseudoBalanceSpendRule` spend rule you want to update. */
export type UpdateMaximumPercentVarianceOnPseudoBalanceSpendRuleInput = {
  /** The name for the rule for future reference. */
  name?: InputMaybe<Scalars["String"]>;
  /** The percentage over the account's original balance that is permitted for additional spending. */
  percentVariance: Scalars["Int"];
  /** The Global ID of the `MaximumPercentVarianceOnPseudoBalanceSpendRule` to update. */
  spendRuleId: Scalars["ID"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when updating an existing `MaximumPercentVarianceOnPseudoBalanceSpendRule`. */
export type UpdateMaximumPercentVarianceOnPseudoBalanceSpendRulePayload =
  | AccessDeniedError
  | MaximumPercentVarianceOnPseudoBalanceSpendRule
  | UserError;

/** The details of the `MerchantCategorySpendRule` spend rule you want to update. */
export type UpdateMerchantCategorySpendRuleInput = {
  /**
   * The merchant categories that will be allowed during authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  allowed?: InputMaybe<Array<MerchantCategory>>;
  /**
   * The merchant category codes that will be allowed during authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  allowedMcc?: InputMaybe<Array<Scalars["String"]>>;
  /**
   * The merchant categories that will result in declined authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  blocked?: InputMaybe<Array<MerchantCategory>>;
  /**
   * The merchant category codes that will result in declined authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  blockedMcc?: InputMaybe<Array<Scalars["String"]>>;
  /** The name for the rule for future reference. */
  name?: InputMaybe<Scalars["String"]>;
  /** The Global ID of the Merchant Category Spend Rule to update. */
  spendRuleId: Scalars["ID"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when updating an existing category rule. */
export type UpdateMerchantCategorySpendRulePayload =
  | AccessDeniedError
  | MerchantCategorySpendRule
  | UserError;

/** The details of the `MerchantCountrySpendRule` spend rule you want to update. */
export type UpdateMerchantCountrySpendRuleInput = {
  /**
   * The merchant countries that will be allowed during authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  allowed?: InputMaybe<Array<Iso3166Alpha3Country>>;
  /**
   * The merchant countries that will result in declined authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  blocked?: InputMaybe<Array<Iso3166Alpha3Country>>;
  /** The name for the rule for future reference. */
  name?: InputMaybe<Scalars["String"]>;
  /** The Global ID of the Merchant Country Spend Rule to update. */
  spendRuleId: Scalars["ID"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when updating an existing country rule. */
export type UpdateMerchantCountrySpendRulePayload =
  | AccessDeniedError
  | MerchantCountrySpendRule
  | UserError;

/** The details of the `MerchantIdentifierSpendRule` spend rule you want to update. */
export type UpdateMerchantIdentifierSpendRuleInput = {
  /**
   * The merchant identifiers you want to allow during authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  allowed?: InputMaybe<Array<Scalars["String"]>>;
  /**
   * The merchant identifiers you want to block during authorizations.
   *
   * Matching values will result in a declined authorization.
   *
   * Min: 1
   * Max: 5000
   */
  blocked?: InputMaybe<Array<Scalars["String"]>>;
  /** The name for the rule for future reference. */
  name?: InputMaybe<Scalars["String"]>;
  /** The Global ID of the `MerchantIdentifierSpendRule` to update. */
  spendRuleId: Scalars["ID"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when updating an existing merchant identifier rule. */
export type UpdateMerchantIdentifierSpendRulePayload =
  | AccessDeniedError
  | MerchantIdentifierSpendRule
  | UserError;

/** The details of the `MinimumAmountLimitSpendRule` spend rule you want to update. */
export type UpdateMinimumAmountLimitSpendRuleInput = {
  /** The exact amount to allow for a single authorization. */
  minimumAmount: AmountInput;
  /** The name for the rule for future reference. */
  name?: InputMaybe<Scalars["String"]>;
  /** The Global ID of the `MinimumAmountLimitSpendRule` to update. */
  spendRuleId: Scalars["ID"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when updating an existing `MinimumAmountLimitSpendRule`. */
export type UpdateMinimumAmountLimitSpendRulePayload =
  | AccessDeniedError
  | MinimumAmountLimitSpendRule
  | UserError;

/** Input for updating organization display name. */
export type UpdateOrganizationProfileDisplayNameInput = {
  /** The new display name for the Organization profile. This value must be at least one character. */
  displayName: Scalars["String"];
  /** The ID of the organization to update. */
  id: Scalars["ID"];
};

export type UpdateOrganizationProfileDisplayNamePayload =
  | AccessDeniedError
  | Organization
  | UserError;

/** The details of the `PanEntryModeSpendRule` to be updated. */
export type UpdatePanEntryModeSpendRuleInput = {
  /**
   * The `PanEntryMode` values you want to allow during authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  allowed?: InputMaybe<Array<PanEntryMode>>;
  /**
   * The `PanEntryMode` values that will result in declined authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  blocked?: InputMaybe<Array<PanEntryMode>>;
  /** A name for the rule for future reference. */
  name?: InputMaybe<Scalars["String"]>;
  /** The Global ID of the `PanEntryModeSpendRule` to update. */
  spendRuleId: Scalars["ID"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when updating an existing `PanEntryModeSpendRule`. */
export type UpdatePanEntryModeSpendRulePayload =
  | AccessDeniedError
  | PanEntryModeSpendRule
  | UserError;

/** The details of the `PointOfServiceCategorySpendRule` spend rule to update. */
export type UpdatePointOfServiceCategorySpendRuleInput = {
  /**
   * The `PointOfServiceCondition` values you want to allow during authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  allowed?: InputMaybe<Array<PointOfServiceCategoryCondition>>;
  /**
   * The `PointOfServiceCondition` values that will result in declined authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  blocked?: InputMaybe<Array<PointOfServiceCategoryCondition>>;
  /** A name for the rule for future reference. */
  name?: InputMaybe<Scalars["String"]>;
  /** The Global ID of the Merchant Category Spend Rule to update. */
  spendRuleId: Scalars["ID"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when updating an existing a point of service category rule. */
export type UpdatePointOfServiceCategorySpendRulePayload =
  | AccessDeniedError
  | PointOfServiceCategorySpendRule
  | UserError;

/** The details of the `PostalCodeVerificationSpendRule` spend rule to update. */
export type UpdatePostalCodeVerificationSpendRuleInput = {
  /**
   * The `PostalCodeResponseCode` values you want to allow during authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  allowed?: InputMaybe<Array<PostalCodeResponseCode>>;
  /**
   * The `PostalCodeResponseCode` values that will result in declined authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  blocked?: InputMaybe<Array<PostalCodeResponseCode>>;
  /** A name for the rule for future reference. */
  name?: InputMaybe<Scalars["String"]>;
  /** The Global ID of the Postal Code Verification Spend Rule to update. */
  spendRuleId: Scalars["ID"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when updating an existing postal code verification rule. */
export type UpdatePostalCodeVerificationSpendRulePayload =
  | AccessDeniedError
  | PostalCodeVerificationSpendRule
  | UserError;

/**
 * Input for adjusting the current pseudo balance amount.
 * Allows manual increases or decreases to the tracked spending balance.
 */
export type UpdatePseudoBalanceInput = {
  /** The amount to add or subtract from the current pseudo balance. */
  amount: AmountInput;
  /** The ID of the FinancialAccount whose pseudo balance should be updated. */
  financialAccountId: Scalars["ID"];
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["String"]>;
  /** Whether to increase (POSITIVE) or decrease (NEGATIVE) the current balance. */
  sign: PseudoBalanceAmountSign;
};

export type UpdatePseudoBalancePayload =
  | AccessDeniedError
  | InterFinancialAccountTransfer
  | UserError;

/**
 * Input for updating the pseudo limit.
 * Allows increasing or decreasing the maximum allowed balance.
 */
export type UpdatePseudoLimitInput = {
  /** The amount to add or subtract from the current limit. */
  amount: AmountInput;
  /** The ID of the FinancialAccount whose pseudo balance limit should be updated. */
  financialAccountId: Scalars["ID"];
  /**
   * The idempotency key for this request.
   *
   * This is a UUIDv4 string used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   */
  idempotencyKey?: InputMaybe<Scalars["String"]>;
  /** Whether to increase (POSITIVE) or decrease (NEGATIVE) the current limit. */
  sign: PseudoBalanceAmountSign;
};

export type UpdatePseudoLimitPayload =
  | AccessDeniedError
  | InterFinancialAccountTransfer
  | UserError;

/** Input for updating a `RewardRedemptionConfigurationAttachment`. Note: only the effective through date is modifiable. */
export type UpdateRewardRedemptionConfigurationAttachmentInput = {
  /** Global ID used to reference the `RewardRedemptionConfigurationAttachment`. */
  attachmentId: Scalars["ID"];
  /** The date and time in ISO 8601 format, representing when the attachment should stop taking effect. This should be a date in the future. Leaving this field blank will result in the attachment remaining in effect indefinitely. */
  effectiveThrough?: InputMaybe<Scalars["String"]>;
};

/** Types which can be returned for updating a `RewardRedemptionConfigurationAttachment`'s effective through date. */
export type UpdateRewardRedemptionConfigurationAttachmentPayload =
  | AccessDeniedError
  | RewardRedemptionConfigurationProductAttachment
  | UserError;

/** Input for updating a `RewardRuleAttachment`. Note: only the effective through date is modifiable. */
export type UpdateRewardRuleAttachmentInput = {
  /** Global ID used to reference the `RewardRuleAttachment`. */
  attachmentId: Scalars["ID"];
  /** The date and time in ISO 8601 format, representing when the attachment should stop taking effect. This should be a date in the future. Leaving this field blank will result in the attachment remaining in effect indefinitely. */
  effectiveThrough: Scalars["String"];
};

/** Types which can be returned for `UpdateRewardRuleAttachment` */
export type UpdateRewardRuleAttachmentPayload =
  | AccessDeniedError
  | RewardRuleProductAttachment
  | UserError;

/** The details of the `StreetAddressSpendRule` spend rule you want to update. */
export type UpdateStreetAddressSpendRuleInput = {
  /**
   * The `AVSResponseCode` values you want to allow during authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  allowed?: InputMaybe<Array<AvsResponseCode>>;
  /**
   * The `AVSResponseCode` values that will result in declined authorizations.
   *
   * Min: 1
   * Max: 5000
   */
  blocked?: InputMaybe<Array<AvsResponseCode>>;
  /** The name for the rule for future reference. */
  name?: InputMaybe<Scalars["String"]>;
  /** The Global ID of the `StreetAddressSpendRule` to update. */
  spendRuleId: Scalars["ID"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when updating an existing street address rule. */
export type UpdateStreetAddressSpendRulePayload =
  | AccessDeniedError
  | StreetAddressSpendRule
  | UserError;

/** An input representing the parts of an update for an associated person's account holder email */
export type UpdateUsAssociatedPersonAccountHolderEmailInput = {
  /** The identifier of an account holder */
  accountHolderId: Scalars["ID"];
  /** The identifier of the business account holder that the associated person falls under */
  businessAccountHolderId: Scalars["ID"];
  /** The account holder's email. */
  email: Scalars["String"];
};

/** An input representing the parts of an update for an associated person's account holder home address */
export type UpdateUsAssociatedPersonAccountHolderHomeAddressInput = {
  /** The identifier of an account holder */
  accountHolderId: Scalars["ID"];
  /** The identifier of the business account holder that the associated person falls under */
  businessAccountHolderId: Scalars["ID"];
  /** The account holder's U.S. home address. */
  homeAddress: AddressInput;
  /**
   * Setting this value to `true` will update the billing address for all payment cards belonging to this account holder.
   *
   * **Note:** The update to the payment card may not be reflected immediately.
   */
  updatePaymentCardBillingAddress?: InputMaybe<Scalars["Boolean"]>;
};

/** Response type for update of a USAssociatedPersonAccountHolder containing the updates or errors. */
export type UpdateUsAssociatedPersonAccountHolderPayload =
  | AccessDeniedError
  | UsBusinessAuthorizedPerson
  | UserError;

/** An input representing the parts of an update for an associated person's account holder phone */
export type UpdateUsAssociatedPersonAccountHolderPhoneInput = {
  /** The identifier of an account holder */
  accountHolderId: Scalars["ID"];
  /** The identifier of the business account holder that the associated person falls under */
  businessAccountHolderId: Scalars["ID"];
  /** The account holder's phone. */
  phoneNumber: PhoneInput;
};

/** An input representing the parts of an update for a business account holder billing address */
export type UpdateUsBusinessAccountHolderBillingAddressInput = {
  /** The identifier of an account holder */
  accountHolderId: Scalars["ID"];
  /** The account holder's U.S. billing address. */
  billingAddress: AddressInput;
  /**
   * Setting this value to `true` will update the billing address for all payment cards belonging to this account holder.
   *
   * **Note:** The update to the payment card may not be reflected immediately.
   */
  updatePaymentCardBillingAddress?: InputMaybe<Scalars["Boolean"]>;
};

/** An input representing the parts of an update for a business account holder credit risk attributes */
export type UpdateUsBusinessAccountHolderCreditRiskAttributeInput = {
  /** The identifier of an account holder */
  accountHolderId: Scalars["ID"];
  /** The credit risk attributes of a business. Only used for unsecured credit applications. */
  businessCreditRiskAttributes: BusinessCreditRiskAttributesInput;
};

/** Response type for updating a USBusinessAccountHolder containing the updates or errors. */
export type UpdateUsBusinessAccountHolderPayload =
  | AccessDeniedError
  | UsBusinessAccountHolder
  | UserError;

/** An input representing the parts of an update for a business account holder phone */
export type UpdateUsBusinessAccountHolderPhoneInput = {
  /** The identifier of an account holder */
  accountHolderId: Scalars["ID"];
  /** The account holder's phone. */
  phoneNumber: PhoneInput;
};

/** An input representing the parts of an update for a business account holder website */
export type UpdateUsBusinessAccountHolderWebsiteInput = {
  /** The identifier of an account holder */
  accountHolderId: Scalars["ID"];
  /** The account holder's website. */
  website: Scalars["String"];
};

/** An input representing the parts of an update for a person account holder billing address */
export type UpdateUsPersonAccountHolderBillingAddressInput = {
  /** The global ID  of an Account holder */
  accountHolderId: Scalars["ID"];
  /** The account holder's U.S. billing address. */
  billingAddress: AddressInput;
  /**
   * Setting this value to `true` will update the billing address for all payment cards belonging to this account holder.
   *
   * **Note:** The update to the payment card may not be reflected immediately.
   */
  updatePaymentCardBillingAddress?: InputMaybe<Scalars["Boolean"]>;
};

/** An input representing the parts of an update for a person account holder credit risk attributes */
export type UpdateUsPersonAccountHolderCreditRiskAttributeInput = {
  /** The identifier of an account holder */
  accountHolderId: Scalars["ID"];
  /** The `USPersonAccountHolder`'s credit risk attributes. Only used for unsecured credit applications. */
  personCreditRiskAttributes: PersonCreditRiskAttributesInput;
};

/** An input representing the parts of an update for a person account holder email */
export type UpdateUsPersonAccountHolderEmailInput = {
  /** The global ID  of an Account holder */
  accountHolderId: Scalars["ID"];
  /** The account holder's email. */
  email: Scalars["String"];
};

/** Response type for updating a USPersonAccountHolder containing the updates or errors. */
export type UpdateUsPersonAccountHolderPayload =
  | AccessDeniedError
  | UsPersonAccountHolder
  | UserError;

/** An input representing the parts of an update for a person account holder phone */
export type UpdateUsPersonAccountHolderPhoneInput = {
  /** The global ID  of an Account holder */
  accountHolderId: Scalars["ID"];
  /** The account holder's phone. */
  phoneNumber: PhoneInput;
};

/** An input representing the parts of an update for a person authorized user billing address */
export type UpdateUsPersonAuthorizedUserBillingAddressInput = {
  /** The identifier of the business account holder that the authorized user falls under */
  accountHolderId: Scalars["ID"];
  /** The Id of an authorized user. */
  authorizedUserId: Scalars["ID"];
  /** The authorized user's U.S. billing address. */
  billingAddress: AddressInput;
  /**
   * Setting this value to `true` will update the billing address for all payment cards belonging to this authorized user.
   *
   * **Note:** The update to the payment card may not be reflected immediately.
   */
  updatePaymentCardBillingAddress?: InputMaybe<Scalars["Boolean"]>;
};

/** An input representing the parts of an update for a person authorized user email */
export type UpdateUsPersonAuthorizedUserEmailInput = {
  /** The identifier of the business account holder that the authorized user falls under */
  accountHolderId: Scalars["ID"];
  /** The Id of an authorized user. */
  authorizedUserId: Scalars["ID"];
  /** The authorized user's email. */
  email: Scalars["String"];
};

/** Response type for update of a `USPersonAuthorizedUser`. */
export type UpdateUsPersonAuthorizedUserPayload =
  | AccessDeniedError
  | UsPersonAuthorizedUser
  | UserError;

/** An input representing the parts of an update for a person authorized user phone */
export type UpdateUsPersonAuthorizedUserPhoneInput = {
  /** The identifier of the business account holder that the authorized user falls under */
  accountHolderId: Scalars["ID"];
  /** The Id of an authorized user. */
  authorizedUserId: Scalars["ID"];
  /** The authorized user's phone. */
  phoneNumber: PhoneInput;
};

/** The input for updating a `UserDefinedFieldDefinition`. */
export type UpdateUserDefinedFieldDefinitionInput = {
  /** The updated description for the field definition. */
  description?: InputMaybe<Scalars["String"]>;
  /** The ID of the field definition to update. */
  id: Scalars["ID"];
  /** The updated name for the field definition. */
  name?: InputMaybe<Scalars["String"]>;
};

/** The input to update a `UserDefinedField` */
export type UpdateUserDefinedFieldInput = {
  /** The ID of the field instance to update. */
  id: Scalars["ID"];
  /** The new value to store in this field instance. */
  value: UserDefinedFieldValueInput;
};

/** Data needed to login a User. */
export type UpdateUserInput = {
  /** The email address of the User. */
  email: Scalars["String"];
  /** The external ID of the User. */
  externalId?: InputMaybe<Scalars["ID"]>;
  /** The list of users' roles that determine a user's permissions within the organization. All roles must be present. */
  roles: Array<UserRole>;
};

/** The possible return types of `updateUser`. */
export type UpdateUserPayload = AccessDeniedError | User | UserError;

/** The details of the `VelocityRule` to update */
export type UpdateVelocityRuleInput = {
  /** A name for the rule for future reference. */
  name: Scalars["String"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
  /** Global ID of the `VelocityRule` to update. */
  velocityRuleId: Scalars["ID"];
};

/** The return types when updating an existing `VelocityRule`. */
export type UpdateVelocityRulePayload =
  | AccessDeniedError
  | UserError
  | VelocityRule;

/** The details of the `VisaRiskScoreSpendRule` spend rule you want to update. */
export type UpdateVisaRiskScoreSpendRuleInput = {
  /**
   * The maximum Visa Risk Score allowed for a transaction before transaction is declined.
   *
   * **Minimum:** 0
   * **Maximum:** 99
   */
  maximumVisaRiskScore: Scalars["UnsignedInt"];
  /** The name for the rule for future reference. */
  name?: InputMaybe<Scalars["String"]>;
  /** The Global ID of the `VisaRiskScoreSpendRule` to update. */
  spendRuleId: Scalars["ID"];
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: InputMaybe<ApplicableRuleUserType>;
};

/** The return types when updating an existing `VisaRiskScoreSpendRule`. */
export type UpdateVisaRiskScoreSpendRulePayload =
  | AccessDeniedError
  | UserError
  | VisaRiskScoreSpendRule;

/** An interface representing an upload link */
export type UploadLink = {
  /** The date and time, in ISO 8601 format, this `upload link` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the secure upload link */
  id: Scalars["ID"];
  /** The status of the upload */
  status?: Maybe<DocumentUploadLinkStatusCode>;
  /** The date and time, in ISO 8601 format, this `upload link` was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** A url to be used to upload the contents of the document. */
  uploadUrl?: Maybe<Scalars["String"]>;
};

/** Details of the requirements for the upload. */
export type UploadRequirement = {
  __typename?: "UploadRequirement";
  /** A list of a constraints for an upload */
  constraints?: Maybe<Array<Maybe<UploadRequirementConstraint>>>;
};

export type UploadRequirementConstraint = DocumentUploadRequirementConstraint;

/** A human User of the Highnote Platform. */
export type User = Node & {
  __typename?: "User";
  /** Roles assigned to the `User`. */
  assignedRoles?: Maybe<Array<Scalars["String"]>>;
  /** Roles available to be assigned to the `User`. */
  availableRoles?: Maybe<Array<Scalars["String"]>>;
  /** A list of credentials for the User that can be used to make client-side requests. */
  clientCredentials?: Maybe<Array<UserClientCredential>>;
  /** The email address of the User. */
  email?: Maybe<Scalars["String"]>;
  /** The Global ID of the User. */
  id: Scalars["ID"];
  /** The list of users' roles that determine a user's permissions within the organization. */
  roles?: Maybe<Array<UserRole>>;
};

/** A credential for a User that can be used to make a client-side request. The credential is scoped to a specific Organization the User has access to. */
export type UserClientCredential = {
  __typename?: "UserClientCredential";
  /** The Organization this credential is scoped to. */
  organization?: Maybe<Organization>;
  /** A list of roles belonging to the user. */
  roles: Array<UserRole>;
  /** A token used to authenticate requests to Highnote's Platform. Set the `Authorization` HTTP header to `Bearer TOKEN`. */
  token?: Maybe<Scalars["String"]>;
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: "UserConnection";
  /** A list of edges. */
  edges?: Maybe<Array<UserEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

export type UserDefinedBooleanField = Node &
  UserDefinedField & {
    __typename?: "UserDefinedBooleanField";
    /** ISO 8601 timestamp when this field instance was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The `User` profile for the user who created the `UserDefinedField` */
    createdBy?: Maybe<User>;
    /** The field definition that this instance is based on. */
    definition?: Maybe<UserDefinedFieldDefinition>;
    /** Whether this field instance has been deleted. */
    deleted?: Maybe<Scalars["Boolean"]>;
    /** Unique identifier for this field instance. */
    id: Scalars["ID"];
    /** The `Node` entity that this field is attached to. */
    node?: Maybe<UserDefinedFieldNode>;
    /** Historical revisions of this field, ordered by creation time (newest first). */
    revisions?: Maybe<UserDefinedFieldRevisionPayload>;
    /** ISO 8601 timestamp when this field instance was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `User` profile for the user who updated the `UserDefinedField` */
    updatedBy?: Maybe<User>;
    /** The actual value stored in this field instance. */
    value?: Maybe<Scalars["Boolean"]>;
    /** Version number of the `UserDefinedField`. */
    version?: Maybe<Scalars["Int"]>;
  };

export type UserDefinedBooleanFieldRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A historical snapshot of a `UserDefinedBooleanField` at a specific point in time. */
export type UserDefinedBooleanFieldRevision = UserDefinedFieldRevision & {
  __typename?: "UserDefinedBooleanFieldRevision";
  /** ISO 8601 timestamp when this revision was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The User who created this revision (who made the change). */
  createdBy?: Maybe<User>;
  /** The field definition snapshot at the time of this revision. */
  definition?: Maybe<UserDefinedFieldDefinition>;
  /** Whether the field was marked as deleted in this revision. */
  deleted?: Maybe<Scalars["Boolean"]>;
  /** The Node entity that this field was attached to at the time of this revision. */
  node?: Maybe<UserDefinedFieldNode>;
  /** The ID of the `UserDefinedField` this revision belongs to. */
  userDefinedField?: Maybe<UserDefinedField>;
  /** The boolean value of the `UserDefinedBooleanField` for this version. */
  value?: Maybe<Scalars["Boolean"]>;
  /** Version number of this revision (matches the version field on `UserDefinedField` at capture time). */
  version?: Maybe<Scalars["Int"]>;
};

/** A custom field instance with a value, associated with a specific `Node`. */
export type UserDefinedField = {
  /** The `User` profile for the user who created the `UserDefinedField` */
  createdBy?: Maybe<User>;
  /** The field definition that this instance is based on. */
  definition?: Maybe<UserDefinedFieldDefinition>;
  /** Unique identifier for this field instance. */
  id: Scalars["ID"];
  /** The `Node` entity that this field is attached to. */
  node?: Maybe<UserDefinedFieldNode>;
  /** Historical revisions of this field, ordered by creation time (newest first). */
  revisions?: Maybe<UserDefinedFieldRevisionPayload>;
  /** The `User` profile for the user who updated the `UserDefinedField` */
  updatedBy?: Maybe<User>;
  /** Version number of the `UserDefinedField`. */
  version?: Maybe<Scalars["Int"]>;
};

/** A custom field instance with a value, associated with a specific `Node`. */
export type UserDefinedFieldRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The connection type for `UserDefinedField` */
export type UserDefinedFieldConnection = {
  __typename?: "UserDefinedFieldConnection";
  /** A list of edges. */
  edges?: Maybe<Array<UserDefinedFieldEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** Configuration template for creating `UserDefinedField` instances. */
export type UserDefinedFieldDefinition = Node & {
  __typename?: "UserDefinedFieldDefinition";
  /** ISO 8601 timestamp when this definition was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The `User` profile for the user who created the `UserDefinedFieldDefinition` */
  createdBy?: Maybe<User>;
  /** The data type that values of this field must conform to. */
  dataType?: Maybe<UserDefinedFieldDefinitionDataType>;
  /** Whether this field definition has been deleted. */
  deleted?: Maybe<Scalars["Boolean"]>;
  /** Optional description explaining the purpose of this field definition. */
  description?: Maybe<Scalars["String"]>;
  /** Unique identifier for this field definition. */
  id: Scalars["ID"];
  /** Human-readable name for this field definition. */
  name?: Maybe<Scalars["String"]>;
  /** The relationships between the `UserDefinedField` and the applicable entity types. */
  relationships?: Maybe<Array<UserDefinedFieldDefinitionRelationshipType>>;
  /** Historical revisions of this definition, ordered by creation time (newest first). */
  revisions?: Maybe<UserDefinedFieldDefinitionRevisionPayload>;
  /** ISO 8601 timestamp when this definition was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** The `User` profile for the user who updated the `UserDefinedFieldDefinition` */
  updatedBy?: Maybe<User>;
  /** The version of the `UserDefinedFieldDefinition`. */
  version?: Maybe<Scalars["Int"]>;
};

/** Configuration template for creating `UserDefinedField` instances. */
export type UserDefinedFieldDefinitionRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The connection type for `UserDefinedFieldDefinition`. */
export type UserDefinedFieldDefinitionConnection = {
  __typename?: "UserDefinedFieldDefinitionConnection";
  /** A list of edges. */
  edges?: Maybe<Array<UserDefinedFieldDefinitionEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** Defines the type that a `UserDefinedField` is. */
export enum UserDefinedFieldDefinitionDataType {
  /** A boolean */
  BOOLEAN = "BOOLEAN",
  /** An integer */
  INTEGER = "INTEGER",
  /** A string */
  STRING = "STRING",
}

/** The edge type for `UserDefinedFieldDefinition`. */
export type UserDefinedFieldDefinitionEdge = {
  __typename?: "UserDefinedFieldDefinitionEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The `UserDefinedFieldDefinition`. */
  node?: Maybe<UserDefinedFieldDefinition>;
};

export type UserDefinedFieldDefinitionPayload =
  | AccessDeniedError
  | UserDefinedFieldDefinition
  | UserError;

/** The relationship to the `Node` type that the `UserDefinedFieldDefinition` will apply to. */
export enum UserDefinedFieldDefinitionRelationshipType {
  /** The `FinancialAccount` type. */
  FINANCIAL_ACCOUNT = "FINANCIAL_ACCOUNT",
  /** The `PaymentCard` type. */
  PAYMENT_CARD = "PAYMENT_CARD",
  /** The `WireTransfer` type. */
  WIRE_TRANSFER = "WIRE_TRANSFER",
}

/** A historical snapshot of a `UserDefinedFieldDefinition` at a specific point in time. */
export type UserDefinedFieldDefinitionRevision = {
  __typename?: "UserDefinedFieldDefinitionRevision";
  /** ISO 8601 timestamp when this revision was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The User who created this revision (who made the change to the definition). */
  createdBy?: Maybe<User>;
  /** The data type that values of this field must conform to at the time of this revision. */
  dataType?: Maybe<UserDefinedFieldDefinitionDataType>;
  /** Whether this field definition was marked as deleted in this revision. */
  deleted?: Maybe<Scalars["Boolean"]>;
  /** Description explaining the purpose of this field definition at the time of this revision. */
  description?: Maybe<Scalars["String"]>;
  /** Human-readable name for this field definition at the time of this revision. */
  name?: Maybe<Scalars["String"]>;
  /** The relationships between the `UserDefinedField` and the applicable entity types at the time of this revision. */
  relationships?: Maybe<Array<UserDefinedFieldDefinitionRelationshipType>>;
  /** The `UserDefinedFieldDefinition` this revision belongs to. */
  userDefinedFieldDefinition?: Maybe<UserDefinedFieldDefinition>;
  /** Version number of this revision (matches the version field on UserDefinedFieldDefinition at capture time). */
  version?: Maybe<Scalars["Int"]>;
};

/** The connection type for `UserDefinedFieldDefinitionRevision`. */
export type UserDefinedFieldDefinitionRevisionConnection = {
  __typename?: "UserDefinedFieldDefinitionRevisionConnection";
  /** A list of edges. */
  edges?: Maybe<Array<UserDefinedFieldDefinitionRevisionEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for `UserDefinedFieldDefinitionRevision`. */
export type UserDefinedFieldDefinitionRevisionEdge = {
  __typename?: "UserDefinedFieldDefinitionRevisionEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The `UserDefinedFieldDefinitionRevision`. */
  node?: Maybe<UserDefinedFieldDefinitionRevision>;
};

export type UserDefinedFieldDefinitionRevisionPayload =
  | AccessDeniedError
  | UserDefinedFieldDefinitionRevisionConnection
  | UserError;

/** Used to search `UserDefinedFieldDefinitions` using the `SearchQueryLanguage` */
export type UserDefinedFieldDefinitionsFilterInput = {
  /** The search query that will be used */
  query: Scalars["String"];
  /** The version of `SearchQueryLanguage` that will be used. */
  version: SearchQueryLanguageVersion;
};

/** The edge type for `UserDefinedField`. */
export type UserDefinedFieldEdge = {
  __typename?: "UserDefinedFieldEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The `UserDefinedField`. */
  node?: Maybe<UserDefinedField>;
};

/** The possible `Node` entity types for a `UserDefinedField` */
export type UserDefinedFieldNode =
  | FinancialAccount
  | PaymentCard
  | WireTransfer;

export type UserDefinedFieldPayload =
  | AccessDeniedError
  | UserDefinedBooleanField
  | UserDefinedIntegerField
  | UserDefinedStringField
  | UserError;

/** A historical snapshot of a `UserDefinedField` at a specific point in time. */
export type UserDefinedFieldRevision = {
  /** ISO 8601 timestamp when this revision was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The User who created this revision (who made the change). */
  createdBy?: Maybe<User>;
  /** The field definition snapshot at the time of this revision. */
  definition?: Maybe<UserDefinedFieldDefinition>;
  /** Whether the field was marked as deleted in this revision. */
  deleted?: Maybe<Scalars["Boolean"]>;
  /** The Node entity that this field was attached to at the time of this revision. */
  node?: Maybe<UserDefinedFieldNode>;
  /** The ID of the `UserDefinedField` this revision belongs to. */
  userDefinedField?: Maybe<UserDefinedField>;
  /** Version number of this revision (matches the version field on UserDefinedField at capture time). */
  version?: Maybe<Scalars["Int"]>;
};

/** The connection type for `UserDefinedFieldRevision`. */
export type UserDefinedFieldRevisionConnection = {
  __typename?: "UserDefinedFieldRevisionConnection";
  /** A list of edges. */
  edges?: Maybe<Array<UserDefinedFieldRevisionEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for `UserDefinedFieldRevision`. */
export type UserDefinedFieldRevisionEdge = {
  __typename?: "UserDefinedFieldRevisionEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The `UserDefinedFieldRevision`. */
  node?: Maybe<UserDefinedFieldRevision>;
};

export type UserDefinedFieldRevisionPayload =
  | AccessDeniedError
  | UserDefinedFieldRevisionConnection
  | UserError;

/** The input value for the `UserDefinedField`. */
export type UserDefinedFieldValueInput = {
  /** A boolean value. */
  booleanValue?: InputMaybe<Scalars["Boolean"]>;
  /** An integer value. */
  integerValue?: InputMaybe<Scalars["Int"]>;
  /** A string value. */
  stringValue?: InputMaybe<Scalars["String"]>;
};

/** Used to search `UserDefinedFields` using the `SearchQueryLanguage` */
export type UserDefinedFieldsFilterInput = {
  /** The search query that will be used */
  query: Scalars["String"];
  /** The version of `SearchQueryLanguage` that will be used. */
  version: SearchQueryLanguageVersion;
};

export type UserDefinedIntegerField = Node &
  UserDefinedField & {
    __typename?: "UserDefinedIntegerField";
    /** ISO 8601 timestamp when this field instance was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The `User` profile for the user who created the `UserDefinedField` */
    createdBy?: Maybe<User>;
    /** The field definition that this instance is based on. */
    definition?: Maybe<UserDefinedFieldDefinition>;
    /** Whether this field instance has been deleted. */
    deleted?: Maybe<Scalars["Boolean"]>;
    /** Unique identifier for this field instance. */
    id: Scalars["ID"];
    /** The `Node` entity that this field is attached to. */
    node?: Maybe<UserDefinedFieldNode>;
    /** Historical revisions of this field, ordered by creation time (newest first). */
    revisions?: Maybe<UserDefinedFieldRevisionPayload>;
    /** ISO 8601 timestamp when this field instance was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `User` profile for the user who updated the `UserDefinedField` */
    updatedBy?: Maybe<User>;
    /** The actual value stored in this field instance. */
    value?: Maybe<Scalars["Int"]>;
    /** Version number of the `UserDefinedField`. */
    version?: Maybe<Scalars["Int"]>;
  };

export type UserDefinedIntegerFieldRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A historical snapshot of a `UserDefinedIntegerField` at a specific point in time. */
export type UserDefinedIntegerFieldRevision = UserDefinedFieldRevision & {
  __typename?: "UserDefinedIntegerFieldRevision";
  /** ISO 8601 timestamp when this revision was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The User who created this revision (who made the change). */
  createdBy?: Maybe<User>;
  /** The field definition snapshot at the time of this revision. */
  definition?: Maybe<UserDefinedFieldDefinition>;
  /** Whether the field was marked as deleted in this revision. */
  deleted?: Maybe<Scalars["Boolean"]>;
  /** The Node entity that this field was attached to at the time of this revision. */
  node?: Maybe<UserDefinedFieldNode>;
  /** The ID of the `UserDefinedField` this revision belongs to. */
  userDefinedField?: Maybe<UserDefinedField>;
  /** The integer value of the `UserDefinedIntegerField` for this version. */
  value?: Maybe<Scalars["Int"]>;
  /** Version number of this revision (matches the version field on `UserDefinedField` at capture time). */
  version?: Maybe<Scalars["Int"]>;
};

export type UserDefinedStringField = Node &
  UserDefinedField & {
    __typename?: "UserDefinedStringField";
    /** ISO 8601 timestamp when this field instance was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The `User` profile for the user who created the `UserDefinedField` */
    createdBy?: Maybe<User>;
    /** The field definition that this instance is based on. */
    definition?: Maybe<UserDefinedFieldDefinition>;
    /** Whether this field instance has been deleted. */
    deleted?: Maybe<Scalars["Boolean"]>;
    /** Unique identifier for this field instance. */
    id: Scalars["ID"];
    /** The `Node` entity that this field is attached to. */
    node?: Maybe<UserDefinedFieldNode>;
    /** Historical revisions of this field, ordered by creation time (newest first). */
    revisions?: Maybe<UserDefinedFieldRevisionPayload>;
    /** ISO 8601 timestamp when this field instance was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `User` profile for the user who updated the `UserDefinedField` */
    updatedBy?: Maybe<User>;
    /** The actual value stored in this field instance. */
    value?: Maybe<Scalars["String"]>;
    /** Version number of the `UserDefinedField`. */
    version?: Maybe<Scalars["Int"]>;
  };

export type UserDefinedStringFieldRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A historical snapshot of a `UserDefinedStringField` at a specific point in time. */
export type UserDefinedStringFieldRevision = UserDefinedFieldRevision & {
  __typename?: "UserDefinedStringFieldRevision";
  /** ISO 8601 timestamp when this revision was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The User who created this revision (who made the change). */
  createdBy?: Maybe<User>;
  /** The field definition snapshot at the time of this revision. */
  definition?: Maybe<UserDefinedFieldDefinition>;
  /** Whether the field was marked as deleted in this revision. */
  deleted?: Maybe<Scalars["Boolean"]>;
  /** The Node entity that this field was attached to at the time of this revision. */
  node?: Maybe<UserDefinedFieldNode>;
  /** The ID of the `UserDefinedField` this revision belongs to. */
  userDefinedField?: Maybe<UserDefinedField>;
  /** The string value of the `UserDefinedStringField` for this version. */
  value?: Maybe<Scalars["String"]>;
  /** Version number of this revision (matches the version field on `UserDefinedField` at capture time). */
  version?: Maybe<Scalars["Int"]>;
};

/** The edge type for a User. */
export type UserEdge = {
  __typename?: "UserEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The User. */
  node?: Maybe<User>;
};

/** Result type when user errors are present on the request. */
export type UserError = {
  __typename?: "UserError";
  /** The user errors present on the request. */
  errors?: Maybe<Array<FieldUserError>>;
};

/** Payload for user. */
export type UserPayload = AccessDeniedError | Organization | User | UserError;

/** Types of User Roles, full details can be found [here](https://highnote.com/docs/basics/core-concepts/team-members) */
export enum UserRole {
  /** Admin role. This role gives the user all permissions available */
  ADMIN = "ADMIN",
  /** A role given to an individual who is a developer in your organization. Similar to admin without organization settings permission. */
  DEVELOPER = "DEVELOPER",
  /** Finance role. This role gives the user all permissions except developer settings and organization settings. */
  FINANCE = "FINANCE",
  /** Support role. This role gives the user permissions for cards, transactions, applications, financial accounts, and account holders. */
  SUPPORT = "SUPPORT",
  /** Unspecified role for users with no role */
  UNSPECIFIED = "UNSPECIFIED",
  /** User role. This is a generic role that should be applied to all users. */
  USER = "USER",
}

export type ValidAddress = {
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference this object. */
  id: Scalars["ID"];
  /** Additional information about the address. */
  labels?: Maybe<Array<ValidatedAddressLabel>>;
  /** The address as provided to `validateAddress`. */
  provided?: Maybe<Address>;
  /** The standardized version of the provided address. */
  standardized?: Maybe<Address>;
};

/** Input fields for `validateAddress`. */
export type ValidateAddressInput = {
  /** Address to be validated. */
  address: AddressInput;
  /**
   * The idempotency key for this request.
   *
   * This is a random string such as UUIDv4 used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   *
   * Minimum length: 5 characters
   * Maximum length: 255 characters
   */
  idempotencyKey: Scalars["IdempotencyKey"];
  /** The intended scope of the validated address token. Defaults to `SINGLE_USE` if not provided. */
  scope?: InputMaybe<AddressTokenScope>;
};

/** Types which can be returned for `validateAddress`. */
export type ValidateAddressPayload =
  | AccessDeniedError
  | AddressValidationResult
  | UserError;

/** The `ValidatedAddress`. */
export type ValidatedAddress = Node &
  ValidAddress & {
    __typename?: "ValidatedAddress";
    /** The date and time, in ISO 8601 format, this object was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference this object. */
    id: Scalars["ID"];
    /** Additional information about the address. */
    labels?: Maybe<Array<ValidatedAddressLabel>>;
    /** The address as provided to `validateAddress`. */
    provided?: Maybe<Address>;
    /** The standardized version of the provided address. */
    standardized?: Maybe<Address>;
  };

/** Possible labels for a validated address. */
export enum ValidatedAddressLabel {
  /** Business address. */
  BUSINESS = "BUSINESS",
  /** Commercial Mail Receiving Agency address. */
  CMRA = "CMRA",
  /** Inactive address. */
  INACTIVE = "INACTIVE",
  /** PO Box. */
  PO_BOX = "PO_BOX",
  /** Residential address. */
  RESIDENTIAL = "RESIDENTIAL",
  /** Extended portion of the address is unconfirmed. */
  UNCONFIRMED_EXTENDED_ADDRESS = "UNCONFIRMED_EXTENDED_ADDRESS",
  /** Unsecured location address. */
  UNSECURED_LOCATION = "UNSECURED_LOCATION",
  /** Vacant address. */
  VACANT = "VACANT",
}

/** The `ValidatedAddressToken`. */
export type ValidatedAddressToken = ValidAddress & {
  __typename?: "ValidatedAddressToken";
  /** The date and time, in ISO 8601 format, this object was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The delivery status of the validated address, as determined by the USPS Delivery Point Validation (DPV). */
  deliveryStatus?: Maybe<AddressDeliveryStatus>;
  /** A human-readable message providing additional context about the delivery status. */
  deliveryStatusMessage?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, this object will expire. */
  expiresAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference this object. */
  id: Scalars["ID"];
  /** Additional information about the address. */
  labels?: Maybe<Array<ValidatedAddressLabel>>;
  /** The address as provided to `validateAddress`. */
  provided?: Maybe<Address>;
  /** The standardized version of the provided address. */
  standardized?: Maybe<Address>;
};

/** Percentage based fee charge value. */
export type VariableFeeChargeValue = {
  __typename?: "VariableFeeChargeValue";
  /** Basis points representation of the fee percentage to be charged. eg: 125 basis points = 1.25% */
  basisPoints?: Maybe<Scalars["UnsignedInt"]>;
};

/** The level at which a cumulative rule will be evaluated. */
export enum VelocityConstraintLevel {
  /** This constraint level will evaluate the associated cumulative rule at the account level. */
  ACCOUNT = "ACCOUNT",
  /** This constraint level will evaluate the associated cumulative rule at the account holder level. */
  ACCOUNT_HOLDER = "ACCOUNT_HOLDER",
  /** This constraint level will evaluate the associated cumulative rule at the card level. */
  CARD = "CARD",
  /**
   * This constraint level will evaluate the associated cumulative rule at the card level.
   * If the card is reissued all balances will transfer to new card
   */
  CARD_LINEAGE = "CARD_LINEAGE",
  /** This constraint level will evaluate the associated cumulative rule at the platform level. */
  PLATFORM = "PLATFORM",
  /** This constraint level will evaluate the associated cumulative rule at the product level. */
  PRODUCT = "PRODUCT",
}

/**
 * A `VelocityInterFinancialAccountTransferRule` is window constrained inter financial account transfer control that is composed of at most
 * 3 `ConditionalInterFinancialAccountTransferRules` and 1 cumulative `CumulativeInterFinancialAccountTransferRule` (e.g. `AmountLimitInterFinancialAccountTransferRule`)
 */
export type VelocityInterFinancialAccountTransferRule = Node & {
  __typename?: "VelocityInterFinancialAccountTransferRule";
  /** The conditional rules attached to the `VelocityInterFinancialAccountTransferRule` */
  conditionalInterFinancialAccountTransferRules?: Maybe<
    Array<Maybe<ConditionalInterFinancialAccountTransferRule>>
  >;
  /** The date and time, in ISO 8601 format, the `VelocityTransferRule` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The cumulative rule attached to the `VelocityInterFinancialAccountTransferRule` */
  cumulativeInterFinancialAccountTransferRule?: Maybe<CumulativeInterFinancialAccountTransferRule>;
  /** Global ID used to reference the `VelocityInterFinancialAccountTransferRule` in operations. */
  id: Scalars["ID"];
  /** The name assigned to the rule. */
  name?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the `VelocityTransferRule` was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** The evaluation window of a `VelocityInterFinancialAccountTransferRule` */
  velocityRuleWindow?: Maybe<VelocityRuleWindow>;
  /** The current version of the rule. Specific versions can be attached and detached from CardProducts. */
  version?: Maybe<Scalars["String"]>;
};

/**
 * A `VelocityInterFinancialAccountTransferRule` is window constrained inter financial account transfer control that is composed of at most
 * 3 `ConditionalInterFinancialAccountTransferRules` and 1 cumulative `CumulativeInterFinancialAccountTransferRule` (e.g. `AmountLimitInterFinancialAccountTransferRule`)
 */
export type VelocityInterFinancialAccountTransferRuleVersionArgs = {
  filterBy?: InputMaybe<Scalars["String"]>;
};

/** The amount balance details of an amount `VelocityInterFinancialAccountTransferRule`. */
export type VelocityInterFinancialAccountTransferRuleAmountBalance = {
  __typename?: "VelocityInterFinancialAccountTransferRuleAmountBalance";
  /** The date and time, in ISO 8601 format, the balance was last updated. */
  asOfDate?: Maybe<Scalars["String"]>;
  /** The computed current balance for the `VelocityInterFinancialAccountTransferRule` */
  computedCurrentBalance?: Maybe<Amount>;
  /** The computed remaining balance for the `VelocityInterFinancialAccountTransferRule` */
  computedRemainingBalance?: Maybe<Amount>;
  /** The current balance for the `VelocityInterFinancialAccountTransferRule` */
  currentBalance?: Maybe<Amount>;
  /** The remaining balance for the `VelocityInterFinancialAccountTransferRule` */
  remainingBalance?: Maybe<Amount>;
  /** Indicates the `VelocityInterFinancialAccountTransferRule` the balance is associated to. */
  velocityInterFinancialAccountTransferRule?: Maybe<VelocityInterFinancialAccountTransferRule>;
};

/** The balance, tracking either amount or count. */
export type VelocityInterFinancialAccountTransferRuleBalance =
  | VelocityInterFinancialAccountTransferRuleAmountBalance
  | VelocityInterFinancialAccountTransferRuleCountBalance;

/** The connection type for `VelocityInterFinancialAccountTransferRuleBalance`. */
export type VelocityInterFinancialAccountTransferRuleBalanceConnection = {
  __typename?: "VelocityInterFinancialAccountTransferRuleBalanceConnection";
  /** A list of edges. */
  edges?: Maybe<Array<VelocityInterFinancialAccountTransferRuleBalanceEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The return type for finding inter financial account transfer rule balances */
export type VelocityInterFinancialAccountTransferRuleBalanceConnectionPayload =
  VelocityInterFinancialAccountTransferRuleBalanceConnection;

/** The edge type for a `VelocityInterFinancialAccountTransferRuleBalance`. */
export type VelocityInterFinancialAccountTransferRuleBalanceEdge = {
  __typename?: "VelocityInterFinancialAccountTransferRuleBalanceEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The `VelocityInterFinancialAccountTransferRuleBalance`. */
  node?: Maybe<VelocityInterFinancialAccountTransferRuleBalance>;
};

/** The connection type for `VelocityInterFinancialAccountTransferRule`. */
export type VelocityInterFinancialAccountTransferRuleConnection = {
  __typename?: "VelocityInterFinancialAccountTransferRuleConnection";
  /** A list of edges. */
  edges?: Maybe<Array<VelocityInterFinancialAccountTransferRuleEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The return types for finding velocity inter financial account transfer rules */
export type VelocityInterFinancialAccountTransferRuleConnectionPayload =
  | AccessDeniedError
  | VelocityInterFinancialAccountTransferRuleConnection;

/** The count balance details of a count `VelocityInterFinancialAccountTransferRule`. */
export type VelocityInterFinancialAccountTransferRuleCountBalance = {
  __typename?: "VelocityInterFinancialAccountTransferRuleCountBalance";
  /** The date and time, in ISO 8601 format, the balance was last updated. */
  asOfDate?: Maybe<Scalars["String"]>;
  /** The computed current count for the `VelocityInterFinancialAccountTransferRule` */
  computedCurrentCount?: Maybe<Scalars["UnsignedInt"]>;
  /** The computed remaining count for the `VelocityInterFinancialAccountTransferRule` */
  computedRemainingCount?: Maybe<Scalars["UnsignedInt"]>;
  /** The current count for the `VelocityInterFinancialAccountTransferRule` */
  currentCount?: Maybe<Scalars["UnsignedInt"]>;
  /** The remaining count for the `VelocityInterFinancialAccountTransferRule` */
  remainingCount?: Maybe<Scalars["UnsignedInt"]>;
  /** Indicates the `VelocityInterFinancialAccountTransferRule` the balance is associated to. */
  velocityInterFinancialAccountTransferRule?: Maybe<VelocityInterFinancialAccountTransferRule>;
};

/** The edge type for a `VelocityInterFinancialAccountTransferRule`. */
export type VelocityInterFinancialAccountTransferRuleEdge = {
  __typename?: "VelocityInterFinancialAccountTransferRuleEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The `VelocityInterFinancialAccountTransferRule`. */
  node?: Maybe<VelocityInterFinancialAccountTransferRule>;
};

/** The result of applying a `VelocityInterFinancialAccountTransferRule` to an event. */
export type VelocityInterFinancialAccountTransferRuleResult =
  InterFinancialAccountTransferRuleResult & {
    __typename?: "VelocityInterFinancialAccountTransferRuleResult";
    /** This field will be populated if an override is attempted. It will indicate if the override was allowed or denied. */
    feedbackCode?: Maybe<FeedbackCode>;
    /** A message describing the result. */
    message?: Maybe<Scalars["String"]>;
    /** A status representing the result of the rule’s evaluation. */
    status?: Maybe<InterFinancialAccountTransferRuleResultStatus>;
    /** The `VelocityInterFinancialAccountTransferRule` attached at the time of the event. */
    velocityInterFinancialAccountTransferRule?: Maybe<VelocityInterFinancialAccountTransferRule>;
  };

/** A `VelocityRule` is window constrained authorization control that is composed of at most 3 SpendRules and 1 cumulative `SpendRule` (e.g. `AmountLimitSpendRule`) */
export type VelocityRule = Node & {
  __typename?: "VelocityRule";
  /** The date and time, in ISO 8601 format, the `VelocityRule` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The cumulative rule attached to the `VelocityRule` */
  cumulativeRule?: Maybe<SpendRule>;
  /** Global ID used to reference the `VelocityRule` in operations. */
  id: Scalars["ID"];
  /** The name assigned to the rule. */
  name?: Maybe<Scalars["String"]>;
  /** The list of revisions for this `VelocityRule`. */
  revisions?: Maybe<VelocityRuleConnection>;
  /** The SpendRules attached to the `VelocityRule` */
  spendRules?: Maybe<Array<Maybe<SpendRule>>>;
  /** The date and time, in ISO 8601 format, the `VelocityRule` was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
  userType?: Maybe<ApplicableRuleUserType>;
  /**
   * Optional `VelocityConstraintLevel` at which the cumulative spend rule will be evaluated.
   *
   * Defaults to `CARD` when `VelocityRule` is directly attached to a card
   * All other times defaults to `ACCOUNT`
   */
  velocityConstraintLevelOverride?: Maybe<VelocityConstraintLevel>;
  /** The evaluation window of a `VelocityRule` */
  velocityRuleWindow?: Maybe<VelocityRuleWindow>;
  /** The current version of the rule. Specific versions can be attached and detached from CardProducts and PaymentCards. */
  version?: Maybe<Scalars["String"]>;
};

/** A `VelocityRule` is window constrained authorization control that is composed of at most 3 SpendRules and 1 cumulative `SpendRule` (e.g. `AmountLimitSpendRule`) */
export type VelocityRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A `VelocityRule` is window constrained authorization control that is composed of at most 3 SpendRules and 1 cumulative `SpendRule` (e.g. `AmountLimitSpendRule`) */
export type VelocityRuleVersionArgs = {
  filterBy?: InputMaybe<Scalars["String"]>;
};

/** The types that a `VelocityRule` could be associated to. */
export type VelocityRuleAssociatedType = CardProduct | PaymentCard;

/** A `VelocityRule` that is or was attached. */
export type VelocityRuleAssociation = {
  __typename?: "VelocityRuleAssociation";
  /** The associated entity the `VelocityRule` is attached to */
  associatedTo?: Maybe<VelocityRuleAssociatedType>;
  /** The date and time, in ISO 8601 format, the `VelocityRule` was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The name assigned to the rule. */
  name?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, the `VelocityRule` was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** The `VelocityRule` */
  velocityRule?: Maybe<VelocityRule>;
  /** The current version of the rule. Specific versions can be attached and detached. */
  version?: Maybe<Scalars["String"]>;
};

/** DEPRECATED: The balance details of a `VelocityRule` */
export type VelocityRuleBalance = {
  __typename?: "VelocityRuleBalance";
  /** The current amount balance for the `VelocityRule` */
  currentBalance?: Maybe<Amount>;
  /** The remaining amount balance for the `VelocityRule` */
  remainingBalance?: Maybe<Amount>;
  /** Indicates the `VelocityRule` the balance is associated to. */
  velocityRule?: Maybe<VelocityRule>;
};

/** The connection type for `VelocityRule`. */
export type VelocityRuleConnection = {
  __typename?: "VelocityRuleConnection";
  /** A list of edges. */
  edges?: Maybe<Array<VelocityRuleEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** A container that holds a `VelocityRule`. */
export type VelocityRuleContainer = {
  __typename?: "VelocityRuleContainer";
  /** A Velocity Rule. */
  velocityRule?: Maybe<VelocityRule>;
};

/** The edge type for a `VelocityRule`. */
export type VelocityRuleEdge = {
  __typename?: "VelocityRuleEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The `VelocityRule`. */
  node?: Maybe<VelocityRule>;
};

/** The details of the `VelocityRule` */
export type VelocityRuleInput = {
  /** The Global ID of the `VelocityRule`. */
  velocityRuleId: Scalars["ID"];
  /** The specific `VelocityRule` version. If not provided will use the latest */
  version?: InputMaybe<Scalars["String"]>;
};

/** The result of applying an `VelocityRule` to an event. */
export type VelocityRuleResult = SpendRuleResult & {
  __typename?: "VelocityRuleResult";
  /** The attached level. */
  attachedLevel?: Maybe<AttachedLevel>;
  /** A message describing the result. */
  message?: Maybe<Scalars["String"]>;
  /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
  recommendation?: Maybe<SpendRuleRecommendation>;
  /** The `VelocityRule` attached at the time of the event. */
  velocityRule?: Maybe<VelocityRule>;
};

/** A enum of `VelocityRule` evaluation windows */
export enum VelocityRuleWindow {
  /**
   * A cooldown period of one hour. The associated velocity rule will only allow transactions that comply with a
   * one-hour cooldown window. For example, with a count rule of 1, the cardholder must wait one hour between
   * transactions.
   */
  COOLDOWN_HOUR = "COOLDOWN_HOUR",
  /**
   * A cooldown period of one minute. The associated velocity rule will only allow transactions that comply with a
   * one-minute cooldown window. For example, with a count rule of 1, the cardholder must wait one minute between
   * transactions.
   */
  COOLDOWN_MINUTE = "COOLDOWN_MINUTE",
  /** A single calendar day. UTC start to UTC end 00:00:00 UTC to 11:59.59:00 UTC */
  DAILY = "DAILY",
  /** A calendar month. UTC start of month to UTC end of month. */
  MONTHLY = "MONTHLY",
  /** 90 calendar days moving window. One calendar day is from UTC start of day to UTC end of day. */
  NINETY_DAYS = "NINETY_DAYS",
  /** Per transaction (associated velocity rule is evaluated on every transaction individually). */
  PER_TRANSACTION = "PER_TRANSACTION",
  /**
   * A calendar quarter. UTC start of quarter to UTC end of quarter.
   * Q1: January, February, March
   * Q2: April, May, June
   * Q3: July, August September
   * Q4: October, November, December
   */
  QUARTERLY = "QUARTERLY",
  /** A calendar week. UTC start of week to UTC end of week. */
  WEEKLY = "WEEKLY",
  /** A calendar year. UTC start of year to UTC end of year. */
  YEARLY = "YEARLY",
}

/** The amount balance details of a `VelocityRule` */
export type VelocitySpendRuleAmountBalance = {
  __typename?: "VelocitySpendRuleAmountBalance";
  /** The date and time, in ISO 8601 format, the balance was last updated. */
  asOfDate?: Maybe<Scalars["String"]>;
  /** The attached level. (Platform, Product, Card) */
  attachedLevel?: Maybe<AttachedLevel>;
  /** The computed current amount balance for the `VelocityRule` */
  computedCurrentBalance?: Maybe<Amount>;
  /** The computed remaining amount balance for the `VelocityRule` */
  computedRemainingBalance?: Maybe<Amount>;
  /** The current amount balance for the `VelocityRule` */
  currentBalance?: Maybe<Amount>;
  /** The remaining amount balance for the `VelocityRule` */
  remainingBalance?: Maybe<Amount>;
  /** Indicates the `VelocityRule` the balance is associated to. */
  velocityRule?: Maybe<VelocityRule>;
};

/** The return types when getting a `VelocityRule` balance. */
export type VelocitySpendRuleBalance =
  | VelocitySpendRuleAmountBalance
  | VelocitySpendRuleCountBalance;

/** The count balance details of a `VelocityRule` */
export type VelocitySpendRuleCountBalance = {
  __typename?: "VelocitySpendRuleCountBalance";
  /** The date and time, in ISO 8601 format, the balance was last updated. */
  asOfDate?: Maybe<Scalars["String"]>;
  /** The attached level. (Platform, Product, Card) */
  attachedLevel?: Maybe<AttachedLevel>;
  /** The computed current count balance for the `VelocityRule` */
  computedCurrentCountBalance?: Maybe<Scalars["Int"]>;
  /** The computed remaining count balance for the `VelocityRule` */
  computedRemainingCountBalance?: Maybe<Scalars["Int"]>;
  /** The current count balance for the `VelocityRule` */
  currentCountBalance?: Maybe<Scalars["Int"]>;
  /** The remaining count balance for the `VelocityRule` */
  remainingCountBalance?: Maybe<Scalars["Int"]>;
  /** Indicates the `VelocityRule` the balance is associated to. */
  velocityRule?: Maybe<VelocityRule>;
};

/** Whether or not the Financial Account is a Non Verified account */
export type VendorProvidedBankFinancialAccountFeature =
  FinancialAccountFeature & {
    __typename?: "VendorProvidedBankFinancialAccountFeature";
    /** The date and time, in ISO 8601 format, the feature was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective from. */
    effectiveFrom?: Maybe<Scalars["String"]>;
    /** The date and time, in ISO 8601 format, the feature was effective through. */
    effectiveThrough?: Maybe<Scalars["String"]>;
    /** Whether or not the feature is enabled for the Financial Account. */
    enabled?: Maybe<Scalars["Boolean"]>;
    /** The date and time, in ISO 8601 format, the feature was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/**
 * Represents a relationship between an originating organization and a vendor organization.
 * Defines which notification events should be relayed from the originator to the vendor.
 */
export type VendorRelationship = Node & {
  __typename?: "VendorRelationship";
  /** Whether this vendor relationship is active. */
  active?: Maybe<Scalars["Boolean"]>;
  /** The date and time, in ISO 8601 format, when this relationship was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the VendorRelationship. */
  id: Scalars["ID"];
  /** The notification event types that will be relayed to the vendor. */
  notificationEventTypes?: Maybe<Array<NotificationEventName>>;
  /** The organization that originally triggers notification events. */
  originatingOrganization?: Maybe<Organization>;
  /** The date and time, in ISO 8601 format, when this relationship was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** The name of the vendor organization. */
  vendorName?: Maybe<Scalars["String"]>;
  /** The organization that receives relayed notification events. */
  vendorOrganization?: Maybe<Organization>;
};

/** A Verification Event for a transaction. */
export type VerificationEvent = Node &
  TransactionEvent & {
    __typename?: "VerificationEvent";
    /**
     * The direction funds are moving in the perspective of the cardholder.
     *
     * * when DEBIT, funds are moving out of the cardholder's account
     * * when CREDIT, funds are moving into the cardholder's account
     */
    accountingDirection?: Maybe<AccountingDirection>;
    /** Network specific transaction data. */
    additionalNetworkData?: Maybe<AdditionalNetworkData>;
    /** The `Amount` approved for this `VerificationEvent` and posted in the settlement currency. Does not include fees. */
    approvedAmount?: Maybe<Amount>;
    /** Code representing the result of AVS address verification. */
    avsResponseCode?: Maybe<AvsResponseCode>;
    /** The details of the `CardDigitalWalletToken` at the time of the `VerificationEvent` event. */
    cardDigitalWalletTokenDetails?: Maybe<CardDigitalWalletTokenDetails>;
    /** The `CardProduct` associated to this `VerificationEvent`. */
    cardProduct?: Maybe<CardProduct>;
    /** The date and time, in ISO 8601 format, this `VerificationEvent` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** `Amount` available to spend after this transaction event. */
    currentFinancialAccountAvailableToSpendAmount?: Maybe<Amount>;
    /** Maximum balance allowed for the card account at the time of this transaction event. */
    currentFinancialAccountMaximumBalanceAmount?: Maybe<Amount>;
    /** Code representing the result of CVV (security code) verification. */
    cvvResponseCode?: Maybe<CvvResponseCode>;
    /** The ID of the transaction event. */
    id: Scalars["ID"];
    /** The details about the merchant who requested the verification. */
    merchantDetails?: Maybe<MerchantDetails>;
    /**
     * The response code from the card network (e.g. Mastercard).
     * @deprecated Use responseCode instead
     */
    networkResponseCode?: Maybe<Scalars["String"]>;
    /**
     * The transaction ID from the card network (e.g. Mastercard).
     * @deprecated No longer supported
     */
    networkTransactionId?: Maybe<Scalars["ID"]>;
    /** The original `Amount` of the `VerificationEvent`. */
    originalAmount?: Maybe<Amount>;
    /** The `PaymentCard` associated to this `VerificationEvent`. */
    paymentCard?: Maybe<PaymentCard>;
    /** A snapshot of the `PaymentCard` at the time of the `VerificationEvent`. */
    paymentCardSnapshot?: Maybe<PaymentCardSnapshot>;
    /** Code representing the result of PIN verification. */
    pinResponseCode?: Maybe<PinResponseCode>;
    /** The Point Of Service Details. */
    pointOfServiceDetails?: Maybe<PointOfServiceDetails>;
    /** Code representing the result of AVS postal code verification. */
    postalCodeResponseCode?: Maybe<PostalCodeResponseCode>;
    /** The `Amount` requested to be approved for this `VerificationEvent`. */
    requestedAmount?: Maybe<Amount>;
    /** The Highnote response code. */
    responseCode?: Maybe<TransactionEventResponseCode>;
    /** The triggered spend rules and the results for the verification. */
    spendRuleResults?: Maybe<SpendRuleResultConnection>;
    /** The `Transaction` for this event. */
    transaction?: Maybe<Transaction>;
    /** Represents the customer transaction type being processed. */
    transactionProcessingType?: Maybe<CardTransactionProcessingType>;
  };

/** A Verification Event for a transaction. */
export type VerificationEventSpendRuleResultsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** Verification details that can be overridden when simulating an Authorization. */
export type VerificationOverridesInput = {
  /**
   * Optional card holder address to use for AVS verification.
   *
   * Use this field to override the address present on the card holder.
   */
  cardholderAddress?: InputMaybe<AddressInput>;
  /**
   * Optional card security code value to verify (also referred to as CVV, CSC, CVC).
   * Use this field to override the CVV generated when the `PaymentCard` was issued.
   *
   * **Minimum length:** 3 characters
   *
   * **Maximum length:** 4 characters
   */
  cvv?: InputMaybe<Scalars["String"]>;
  /**
   * Optionally simulate a PIN entered during the transaction.
   *
   * **Minimum length:** 4 characters
   *
   * **Maximum length:** 4 characters
   */
  pin?: InputMaybe<Scalars["String"]>;
};

/** The `AccountHolderCardProductApplication` fields that were confirmed. These must all be confirmed in order to move forward with this application. */
export type VerifiedApplicationFieldsForFraudAlertInput = {
  /** Whether or not the `AccountHolder` initiated this application. */
  accountHolderInitiatedApplication: Scalars["Boolean"];
  /** Whether or not the `AccountHolder` mailing address on the application matches the applicant. */
  address: Scalars["Boolean"];
  /** Whether or not the `AccountHolder` date of birth on the application matches the applicant. */
  dateOfBirth: Scalars["Boolean"];
  /** Whether or not the `AccountHolder` name on the application matches the applicant. */
  name: Scalars["Boolean"];
};

/** Link experience configuration. */
export type VerifiedExternalBankAccountLinkExperience = {
  /** The type of link experience. */
  flow: VerifiedExternalBankAccountLinkExperienceFlow;
  /**
   * An optional redirect URI used in the success callback.
   * If a value is provided, it must match the configured URI in the Highnote platform.
   * If no value is provided, we will use the configuration that matches the specified flow.
   */
  redirectUri?: InputMaybe<Scalars["String"]>;
};

/** The type of link experience. */
export enum VerifiedExternalBankAccountLinkExperienceFlow {
  /** Used to support link experience on Android device. */
  ANDROID_SDK = "ANDROID_SDK",
  /** Used to support hosted link experience on an Android device. */
  ANDROID_WEB_HOSTED = "ANDROID_WEB_HOSTED",
  /** Used to support link experience on IOS device. */
  IOS_SDK = "IOS_SDK",
  /** Used to support hosted link experience on an IOS device. */
  IOS_WEB_HOSTED = "IOS_WEB_HOSTED",
  /** Used to support hosted link experience in the browser. */
  WEB_HOSTED = "WEB_HOSTED",
  /** Used to support link experience in the browser. */
  WEB_SDK = "WEB_SDK",
}

/** Input for verifying a `NetworkToken`. */
export type VerifyNetworkTokenInput = {
  /** The cardHolder to associate the `NetworkToken` with. */
  cardHolder?: InputMaybe<CardHolderInput>;
  /**
   * Optional contract ID to use for this transaction.
   *
   * If not provided, the default contract ID will be used.
   *
   * DEPRECATED: This field is no longer needed. If you currently are using `contractId` contact Highnote for details on switching to `merchantAcceptorId`.
   */
  contractId?: InputMaybe<Scalars["ID"]>;
  /** The idempotency key for this request. */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /**
   * Optional merchant acceptor ID for this transaction.
   *
   * This is used to identify the specific merchant location or terminal accepting the payment.
   */
  merchantAcceptorId?: InputMaybe<Scalars["ID"]>;
  /** Optional Merchant descriptor information for this transaction. */
  merchantDescriptor?: InputMaybe<MerchantDescriptorInput>;
  /** The `NetworkToken` to verify. */
  networkToken: NetworkTokenInput;
};

/** Result of verifying a `NetworkToken`. */
export type VerifyNetworkTokenPayload =
  | AccessDeniedError
  | PaymentCardVerification
  | UserError;

/** Input for verifying a `PaymentCard`. */
export type VerifyPaymentCardInput = {
  /** The cardHolder to associate the `PaymentCard` with. */
  cardHolder?: InputMaybe<CardHolderInput>;
  /**
   * Optional contract ID to use for this transaction.
   *
   * If not provided, the default contract ID will be used.
   *
   * DEPRECATED: This field is no longer needed. If you currently are using `contractId` contact Highnote for details on switching to `merchantAcceptorId`.
   */
  contractId?: InputMaybe<Scalars["ID"]>;
  /** The idempotency key for this request. */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /**
   * Optional merchant acceptor ID for this transaction.
   *
   * This is used to identify the specific merchant location or terminal accepting the payment.
   */
  merchantAcceptorId?: InputMaybe<Scalars["ID"]>;
  /** Optional Merchant descriptor information for this transaction. */
  merchantDescriptor?: InputMaybe<MerchantDescriptorInput>;
  /** The `PaymentCard` to verify. */
  paymentCard: PaymentCardInput;
};

/** Result of verifying a `PaymentCard`. */
export type VerifyPaymentCardPayload =
  | AccessDeniedError
  | PaymentCardVerification
  | UserError;

/** Input for verifying a payment method token. */
export type VerifyPaymentMethodTokenInput = {
  /**
   * Optional contract ID to use for this transaction.
   *
   * If not provided, the default contract ID will be used.
   *
   * DEPRECATED: This field is no longer needed. If you currently are using `contractId` contact Highnote for details on switching to `merchantAcceptorId`.
   */
  contractId?: InputMaybe<Scalars["ID"]>;
  /** The idempotency key for this request. */
  idempotencyKey?: InputMaybe<Scalars["IdempotencyKey"]>;
  /**
   * Optional merchant acceptor ID for this transaction.
   *
   * This is used to identify the specific merchant location or terminal accepting the payment.
   */
  merchantAcceptorId?: InputMaybe<Scalars["ID"]>;
  /** Optional Merchant descriptor information for this transaction. */
  merchantDescriptor?: InputMaybe<MerchantDescriptorInput>;
  /** The `PaymentMethodToken` to authorize. */
  paymentMethodTokenId: Scalars["ID"];
};

/** Result of verifying a payment method token. */
export type VerifyPaymentMethodTokenPayload =
  | AccessDeniedError
  | PaymentCardVerification
  | UserError;

/** An input of coordinates to form a viewport */
export type ViewportCoordinatesInput = {
  /** A latitude coordinate representing the northern point of the viewport. */
  northernLatitude: Scalars["String"];
  /** A longitude coordinate representing the northern point of the viewport. */
  northernLongitude: Scalars["String"];
  /** A latitude coordinate representing the southern point of the viewport. */
  southernLatitude: Scalars["String"];
  /** A longitude coordinate representing the southern point of the viewport. */
  southernLongitude: Scalars["String"];
};

/** The subscriber text for 3DS Verifications for Mobile Apps */
export type VirtualCardAppText = {
  __typename?: "VirtualCardAppText";
  /** Text with info on finding help for virtual card mobile transactions */
  appHelpText: Scalars["String"];
  /** Text with app terms of use for virtual card mobile transactions */
  appInfo: Scalars["String"];
};

/** The subscriber text for 3DS Verifications for Browsers */
export type VirtualCardBrowserText = {
  __typename?: "VirtualCardBrowserText";
  /** Text with info on finding help for virtual card online transactions */
  browserHelpText: Scalars["String"];
  /** Text with browser terms of use for virtual card online transactions */
  browserTerms: Scalars["String"];
};

/** The Personalization type for the virtual card profile */
export enum VirtualCardPersonalizationType {
  /** The virtual card profile track has business authorized person Name */
  BUSINESS_AUTHORIZED_PERSON_NAME = "BUSINESS_AUTHORIZED_PERSON_NAME",
  /** The virtual card profile track has default Business Name */
  BUSINESS_NAME = "BUSINESS_NAME",
  /** The virtual card profile track has default person Name */
  PERSON_NAME = "PERSON_NAME",
}

/** Virtual Card Profile attributes */
export type VirtualCardProfile = CardProfile &
  Node & {
    __typename?: "VirtualCardProfile";
    /** The native app text displayed to cardholder during 3DS verification for mobile transactions */
    appText?: Maybe<VirtualCardAppText>;
    /** Bank Status of the virtual card profile. */
    bankStatus?: Maybe<CardProfileBankStatus>;
    /** The browser text displayed to cardholder during 3DS verification for online transactions */
    browserText?: Maybe<VirtualCardBrowserText>;
    /** Card art */
    cardArt?: Maybe<Array<CardArtDocument>>;
    /** Card Holder Agreement ID of the virtual card profile. */
    cardHolderAgreementId?: Maybe<Scalars["ID"]>;
    /** Card Product of the virtual card profile. */
    cardProduct?: Maybe<CardProduct>;
    /** The list of `CardProfileSet` related to this `VirtualCardProfile`. */
    cardProfileSetRelationships?: Maybe<Array<CardProfileSetRelationship>>;
    /** The date and time, in ISO 8601 format, this `virtual card profile` was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Description about the `VirtualCardProfile`. */
    description?: Maybe<Scalars["String"]>;
    /** ID of the virtual card profile. */
    id: Scalars["ID"];
    /** Name of the `VirtualCardProfile`. */
    name?: Maybe<Scalars["String"]>;
    /** Payment Network Status of the virtual card profile. */
    paymentNetworkStatus?: Maybe<CardProfilePaymentNetworkStatus>;
    /** Personalization type for the virtual card profile */
    personalization?: Maybe<VirtualCardPersonalizationType>;
    /** Specify intended POS behavior for card */
    serviceCode?: Maybe<ServiceCode>;
    /** Status of the virtual card profile. */
    status?: Maybe<CardProfileStatus>;
    /** The date and time, in ISO 8601 format, this `virtual card profile` was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
  };

/**
 * Visa Fleet line item amount type (credit/debit)
 *
 * Used for `visaShippingAmountSignage`, `visaDutyAmountSignage`, `visaShippingTaxAmountSignage`
 */
export enum VisaAmountSignage {
  /** A refund on the invoice */
  CREDIT = "CREDIT",
  /** A charge on the invoice */
  DEBIT = "DEBIT",
  /** Not implemented */
  NULL = "NULL",
}

/** Information about the Cardholder Authentication Verification Value (CAVV) for this transaction. */
export enum VisaCavvResultCode {
  /** The CAVV for the 3DS verification failed validation. */
  FAILED = "FAILED",
  /** The CAVV for the 3DS verification failed an issuer validation attempt. */
  FAILED_ISSUER_ATTEMPT = "FAILED_ISSUER_ATTEMPT",
  /** The CAVV for the 3DS verification failed a Visa validation attempt. */
  FAILED_VISA_ATTEMPT = "FAILED_VISA_ATTEMPT",
  /** The CAVV for the 3DS verification failed a Visa validation attempt while the issuer's Access Control Server was unavailable. */
  FAILED_VISA_ATTEMPT_ISSUER_ACS_UNAVAILABLE = "FAILED_VISA_ATTEMPT_ISSUER_ACS_UNAVAILABLE",
  /** The CAVV for the 3DS verification was not validated. */
  NOT_VERIFIED = "NOT_VERIFIED",
  /** The CAVV for the 3DS verification was not validated but authentication was attempted. */
  NOT_VERIFIED_ATTEMPT = "NOT_VERIFIED_ATTEMPT",
  /** The CAVV for the 3DS verification was not validated because the issuer is not participating in 3DS. */
  NOT_VERIFIED_ISSUER_NOT_PARTICIPATING = "NOT_VERIFIED_ISSUER_NOT_PARTICIPATING",
  /** The CAVV for the 3DS verification was not validated but authentication was successful. */
  NOT_VERIFIED_SUCCESS = "NOT_VERIFIED_SUCCESS",
  /** The CAVV for the 3DS verification passed validation. */
  PASSED = "PASSED",
  /** The CAVV for the 3DS verification passed an issuer validation attempt. */
  PASSED_ISSUER_ATTEMPT = "PASSED_ISSUER_ATTEMPT",
  /** The CAVV for the 3DS verification passed validation, but liability shift does not apply. */
  PASSED_NO_LIABILITY_SHIFT = "PASSED_NO_LIABILITY_SHIFT",
  /** The CAVV for the 3DS verification passed a Visa validation attempt. */
  PASSED_VISA_ATTEMPT = "PASSED_VISA_ATTEMPT",
  /** The CAVV for the 3DS verification passed a Visa validation attempt while the issuer's Access Control Server was unavailable. */
  PASSED_VISA_ATTEMPT_ISSUER_ACS_UNAVAILABLE = "PASSED_VISA_ATTEMPT_ISSUER_ACS_UNAVAILABLE",
}

/** Visa specific transaction data. */
export type VisaData = {
  __typename?: "VisaData";
  /** A number used by Visa to identify the acquiring institution. */
  acquiringInstitutionIdentificationCode?: Maybe<Scalars["String"]>;
  /** An alphanumeric value generated by Highnote and shared with Visa when an authorization is approved. */
  authorizationCode?: Maybe<Scalars["String"]>;
  /** Information about the Cardholder Authentication Verification Value (CAVV) for this transaction. */
  cavvResultCode?: Maybe<VisaCavvResultCode>;
  /** Classification information for Mail Order/Telephone Order (MOTO) and Electronic Commerce transactions. */
  motoAndElectronicCommerceIndicator?: Maybe<VisaMotoAndElectronicCommerceIndicator>;
  /** The date and time that the network transmitted the transaction. This value is expressed in Greenwich Mean Time (GMT) with format (MMDDhhmmss) */
  networkTransmissionDateAndTime?: Maybe<Scalars["String"]>;
  /** Payment facilitator identifier for the transaction. */
  paymentFacilitatorIdentifier?: Maybe<Scalars["String"]>;
  /** An value used to identify and track a transaction’s separate messages. */
  retrievalReferenceNumber?: Maybe<Scalars["String"]>;
  /** The risk score for the transaction provided by Visa. Values are between 0-99. */
  riskScore?: Maybe<Scalars["UnsignedInt"]>;
  /** A number assigned by the message initiator that uniquely identifies a transaction. */
  systemTraceAuditNumber?: Maybe<Scalars["String"]>;
  /** Information about the verification method used in this transaction. */
  threeDSecureIndicator?: Maybe<VisaThreeDSecureIndicator>;
  /** The transaction identifier sent by Visa. */
  transactionIdentifier?: Maybe<Scalars["String"]>;
};

/** Visa Fleet discount treatment types */
export enum VisaDiscountTreatment {
  /** No invoice-level discounts apply */
  NO_DISCOUNT = "NO_DISCOUNT",
  /** Tax was calculated on post-discount total */
  POST_DISCOUNT = "POST_DISCOUNT",
  /** Tax was calculated on pre-discount total */
  PRE_DISCOUNT = "PRE_DISCOUNT",
}

/** Visa Electric Vehicle Charging Reason Codes */
export enum VisaEvChargingReasonCode {
  /** Failure to lock or unlock connector */
  CONNECTOR_LOCK_FAILURE = "CONNECTOR_LOCK_FAILURE",
  /** Communication failure with the vehicle */
  EV_COMMUNICATION_ERROR = "EV_COMMUNICATION_ERROR",
  /** Ground fault circuit interrupter has been activated */
  GROUND_FAILURE = "GROUND_FAILURE",
  /** Temperature inside charge point is too high */
  HIGH_TEMPERATURE = "HIGH_TEMPERATURE",
  /** Error in internal hardware orsoftware component */
  INTERNAL_ERROR = "INTERNAL_ERROR",
  /** No error to report */
  NO_ERROR = "NO_ERROR",
  /** Abnormal completion of charging */
  OTHER_ERROR = "OTHER_ERROR",
  /** Over current protection device has tripped */
  OVER_CURRENT_FAILURE = "OVER_CURRENT_FAILURE",
  /** Voltage has risen above an acceptable level */
  OVER_VOLTAGE = "OVER_VOLTAGE",
  /** Abnormal completion of charging related to payment */
  PAYMENT_RELATED_ERROR = "PAYMENT_RELATED_ERROR",
  /** Failure to read power meter */
  POWER_METER_FAILURE = "POWER_METER_FAILURE",
  /** Failure to control power switch */
  POWER_SWITCH_FAILURE = "POWER_SWITCH_FAILURE",
  /** Failure with idTag reader */
  READER_FAILURE = "READER_FAILURE",
  /** Unable to perform a reset */
  RESET_FAILURE = "RESET_FAILURE",
  /** Voltage has dropped below an acceptable level */
  UNDER_VOLTAGE = "UNDER_VOLTAGE",
  /** Wireless communication device reports a weak signal */
  WEAK_SIGNAL = "WEAK_SIGNAL",
}

/** Visa Electric Vehicle Connector Types */
export enum VisaEvConnectorType {
  /** AC - GB/T */
  AC_GBT = "AC_GBT",
  /** AC - J1772 Type 1 */
  AC_J1772 = "AC_J1772",
  /** AC - Mennekes - Type 2 */
  AC_MENNEKES = "AC_MENNEKES",
  /** DC - CCS1 */
  DC_CCS1 = "DC_CCS1",
  /** DC - CCS2 */
  DC_CCS2 = "DC_CCS2",
  /** DC - CHAdeMO */
  DC_CHADEMO = "DC_CHADEMO",
  /** DC - GB/T */
  DC_GBT = "DC_GBT",
  /** North American Charging Standard. Also known as the Tesla charging standard */
  NACS = "NACS",
}

/** Details pertaining to a Visa Fleet transaction available at Authorization and Authorization Advice time */
export type VisaFleetAuthorizationData = AdditionalTransactionData &
  Node & {
    __typename?: "VisaFleetAuthorizationData";
    /** An alphanumeric value representing the answer to a custom prompt */
    customPrompt1?: Maybe<Scalars["String"]>;
    /** An alphanumeric value representing the answer to a custom prompt */
    customPrompt2?: Maybe<Scalars["String"]>;
    /** An alphanumeric value representing the employee’s ID number */
    employeeNumber?: Maybe<Scalars["String"]>;
    /** An alphanumeric value representing either a Vehicle, Driver, or Generic ID provided by the cardholder */
    fleetIdentifier?: Maybe<Scalars["String"]>;
    /** Globally unique id of a `VisaFleetAuthorizationData` */
    id: Scalars["ID"];
    /** A list of non-fuel product codes for the products purchased */
    nonFuelProductCodes?: Maybe<Array<VisaNonFuelProductCode>>;
    /** The odometer value provided by the cardholder */
    odometer?: Maybe<Scalars["String"]>;
    /** An alphanumeric value representing either an Order Number or an Invoice Number provided by the cardholder */
    purchaseIdentifier?: Maybe<Scalars["String"]>;
    /** Indicates whether `purchaseIdentifier` is an Order Number or a Invoice Number provided by the cardholder */
    purchaseIdentifierFormat?: Maybe<VisaFleetPurchaseIdentifierFormat>;
    /** Indicates whether the POS supports host-based restriction processing */
    purchaseRestrictonsFlag?: Maybe<Scalars["Boolean"]>;
    /** Indicates whether fuel or non-fuel items are included in the transaction */
    purchaseType?: Maybe<VisaFuelPurchaseType>;
    /** Indicates whether the transaction occurred at a self-service or a full-service station */
    serviceType?: Maybe<VisaFuelServiceType>;
    /** An alphanumeric value representing the trailer’s ID number */
    trailerNumber?: Maybe<Scalars["String"]>;
  };

/** Entity that calculated the discount */
export enum VisaFleetDiscountAgent {
  /** Discount was calculated by the Merchant */
  MERCHANT = "MERCHANT",
  /** Discount was calculated by Visa */
  VISA = "VISA",
}

/** Visa Fleet discount method */
export enum VisaFleetDiscountMethod {
  /** Best of retail minus or cost plus discount method */
  BEST_OF_RETAIL_MINUS_OR_COST_PLUS = "BEST_OF_RETAIL_MINUS_OR_COST_PLUS",
  /** Cost plus discount method */
  COST_PLUS = "COST_PLUS",
  /** Retail minus discount method */
  RETAIL_MINUS = "RETAIL_MINUS",
}

/** Visa Fleet Level 2 fuel line item data. These are relevant data items describing fuel products purchased in a fleet transaction. Also used to provide EV charging information */
export type VisaFleetL2FuelLineItem = {
  __typename?: "VisaFleetL2FuelLineItem";
  /** Finish time of the charge expressed in local time of the card acceptor location, in the format HHMMSS */
  chargingFinishTime?: Maybe<Scalars["String"]>;
  /** Start time of the charge expressed in local time of the card acceptor location, in the format HHMMSS */
  chargingStartTime?: Maybe<Scalars["String"]>;
  /** The discount amount per transaction */
  discountPerTransaction?: Maybe<Amount>;
  /** The discount amount per unit */
  discountPerUnit?: Maybe<Amount>;
  /** The discount rate in basis points. Two decimal places are implied */
  discountRatePercentage?: Maybe<Scalars["UnsignedInt"]>;
  /** Indicates whether the line item represents a fuel product or service or not */
  fuelIndicator?: Maybe<Scalars["Boolean"]>;
  /** The `Amount` of local tax */
  localTaxAmount?: Maybe<Amount>;
  /** An indicator to show whether the local tax is included in the unit cost or not */
  localTaxIncludedIndicator?: Maybe<Scalars["Boolean"]>;
  /** The VAT/Local tax rate in basis points for fuel purchased. Two decimal places are implied */
  localTaxRate?: Maybe<Scalars["UnsignedInt"]>;
  /** The `Amount` of national tax */
  nationalTaxAmount?: Maybe<Amount>;
  /** An indicator to show whether national tax is included in the unit cost or not */
  nationalTaxIncludedIndicator?: Maybe<Scalars["Boolean"]>;
  /** The national tax rate in basis points for fuel purchased. Two decimal places are implied */
  nationalTaxRate?: Maybe<Scalars["UnsignedInt"]>;
  /** The net line item amount less than tax exempted or discounts */
  netAmount?: Maybe<Amount>;
  /** An indicator to show whether the item is taxable or not */
  notTaxableIndicator?: Maybe<Scalars["Boolean"]>;
  /** The `Amount` of other tax */
  otherTaxAmount?: Maybe<Amount>;
  /** Indicates whether other tax is included in the unit cost or not */
  otherTaxIncludedIndicator?: Maybe<Scalars["Boolean"]>;
  /** The other tax rate in basis points for fuel purchased. Two decimal places are implied */
  otherTaxRate?: Maybe<Scalars["UnsignedInt"]>;
  /** The product category or detail description */
  productCategoryOrDescription?: Maybe<Scalars["String"]>;
  /** Describes one of the fuels purchased in this transaction */
  productCode?: Maybe<VisaFuelType>;
  /** Quantity of fuel purchased */
  quantity?: Maybe<Scalars["UnsignedInt"]>;
  /** The number of places the decimal point shall be moved to the left, starting from the right-most numeric digit of quantity */
  quantityMinorUnit?: Maybe<Scalars["UnsignedInt"]>;
  /** The type of service provided at the card acceptor location */
  serviceType?: Maybe<VisaFuelServiceType>;
  /** Total amount for this fuel code line item, including tax */
  totalAmount?: Maybe<Amount>;
  /** The total discount amount for this line item */
  totalDiscountAmount?: Maybe<Amount>;
  /** Total amount of time taken to charge the vehicle, in the format HHMMSS */
  totalTimeCharging?: Maybe<Scalars["String"]>;
  /** Total amount of time the vehicle was plugged in, in the format HHMMSS */
  totalTimePluggedIn?: Maybe<Scalars["String"]>;
  /** Unit of measure used to measure this fuel item */
  unitOfMeasure?: Maybe<VisaFuelUnitOfMeasure>;
  /** Cost of fuel per unit of measure */
  unitPrice?: Maybe<Scalars["UnsignedInt"]>;
  /** The number of places the decimal point shall be moved to the left, starting from the right-most numeric digit of unit price */
  unitPriceMinorUnit?: Maybe<Scalars["UnsignedInt"]>;
};

/** Visa Fleet Level 2 fuel line item data. These are relevant data items describing fuel products purchased in a fleet transaction. Also used to provide EV charging information */
export type VisaFleetL2FuelLineItemInput = {
  /** Finish time of the charge expressed in local time of the card acceptor location, in the format HHMMSS */
  chargingFinishTime?: InputMaybe<Scalars["String"]>;
  /** Start time of the charge expressed in local time of the card acceptor location, in the format HHMMSS */
  chargingStartTime?: InputMaybe<Scalars["String"]>;
  /** The discount amount per transaction */
  discountPerTransaction?: InputMaybe<AmountInput>;
  /** The discount amount per unit */
  discountPerUnit?: InputMaybe<AmountInput>;
  /** The discount rate in basis points. Two decimal places are implied */
  discountRatePercentage?: InputMaybe<Scalars["UnsignedInt"]>;
  /** Indicates whether the line item represents a fuel product or service or not */
  fuelIndicator?: InputMaybe<Scalars["Boolean"]>;
  /** The `Amount` of local tax */
  localTaxAmount?: InputMaybe<AmountInput>;
  /** An indicator to show whether the local tax is included in the unit cost or not */
  localTaxIncludedIndicator?: InputMaybe<Scalars["Boolean"]>;
  /** The VAT/Local tax rate in basis points for fuel purchased. Two decimal places are implied */
  localTaxRate?: InputMaybe<Scalars["UnsignedInt"]>;
  /** The `Amount` of national tax */
  nationalTaxAmount?: InputMaybe<AmountInput>;
  /** An indicator to show whether national tax is included in the unit cost or not */
  nationalTaxIncludedIndicator?: InputMaybe<Scalars["Boolean"]>;
  /** The national tax rate in basis points for fuel purchased. Two decimal places are implied */
  nationalTaxRate?: InputMaybe<Scalars["UnsignedInt"]>;
  /** The net line item amount less than tax exempted or discounts */
  netAmount?: InputMaybe<AmountInput>;
  /** An indicator to show whether the item is taxable or not */
  notTaxableIndicator?: InputMaybe<Scalars["Boolean"]>;
  /** The `Amount` of other tax */
  otherTaxAmount?: InputMaybe<AmountInput>;
  /** Indicates whether other tax is included in the unit cost or not */
  otherTaxIncludedIndicator?: InputMaybe<Scalars["Boolean"]>;
  /** The other tax rate in basis points for fuel purchased. Two decimal places are implied */
  otherTaxRate?: InputMaybe<Scalars["UnsignedInt"]>;
  /** The product category or detail description */
  productCategoryOrDescription?: InputMaybe<Scalars["String"]>;
  /** Describes one of the fuels purchased in this transaction */
  productCode?: InputMaybe<VisaFuelType>;
  /** Quantity of fuel purchased */
  quantity?: InputMaybe<Scalars["UnsignedInt"]>;
  /** The number of places the decimal point shall be moved to the left, starting from the right-most numeric digit of quantity */
  quantityMinorUnit?: InputMaybe<Scalars["UnsignedInt"]>;
  /** The type of service provided at the card acceptor location */
  serviceType?: InputMaybe<VisaFuelServiceType>;
  /** Total amount for this fuel code line item, including tax */
  totalAmount?: InputMaybe<AmountInput>;
  /** The total discount amount for this line item */
  totalDiscountAmount?: InputMaybe<AmountInput>;
  /** Total amount of time taken to charge the vehicle, in the format HHMMSS */
  totalTimeCharging?: InputMaybe<Scalars["String"]>;
  /** Total amount of time the vehicle was plugged in, in the format HHMMSS */
  totalTimePluggedIn?: InputMaybe<Scalars["String"]>;
  /** Unit of measure used to measure this fuel item */
  unitOfMeasure?: InputMaybe<VisaFuelUnitOfMeasure>;
  /** Cost of fuel per unit of measure */
  unitPrice?: InputMaybe<Scalars["UnsignedInt"]>;
  /** The number of places the decimal point shall be moved to the left, starting from the right-most numeric digit of unit price */
  unitPriceMinorUnit?: InputMaybe<Scalars["UnsignedInt"]>;
};

/** An Visa Fleet L2 additional transaction data */
export type VisaFleetL2TransactionData = AdditionalTransactionData &
  Node & {
    __typename?: "VisaFleetL2TransactionData";
    /** Globally unique id of a `VisaFleetL2TransactionData`. */
    id: Scalars["ID"];
    /** Indicates whether the Merchant will send more additional (Level 3) information in the future */
    visaAdditionalDataIndicator?: Maybe<Scalars["Boolean"]>;
    /** Carbon footprint avoidance (how much was saved from this charge) measurement for the purchase on the transaction – measured in grams of carbon dioxide equivalent (CO2e) */
    visaCarbonFootprintAvoided?: Maybe<Scalars["UnsignedInt"]>;
    /** Charging station power output capacity represented in kW */
    visaChargingPowerCapacity?: Maybe<Scalars["UnsignedInt"]>;
    /**
     * Specific charging reason code for this transaction
     * @deprecated Use visaEvChargingReasonCode instead
     */
    visaChargingReasonCode?: Maybe<Scalars["UnsignedInt"]>;
    /** Identifies the fleet client */
    visaClientIdentifier?: Maybe<Scalars["String"]>;
    /**
     * Visa-defined code for a specific connector type to identify the connection for the charge session
     * @deprecated Use visaEvConnectorType instead
     */
    visaConnectorType?: Maybe<Scalars["String"]>;
    /** Identifies the entity that calculated the discount */
    visaDiscountAgent?: Maybe<VisaFleetDiscountAgent>;
    /** Discount method applied to the transaction */
    visaDiscountMethod?: Maybe<VisaFleetDiscountMethod>;
    /** Identifies the discount plan applied to the transaction */
    visaDiscountPlanIdentifier?: Maybe<Scalars["String"]>;
    /** Estimate of the total distance added in km/miles, based on the kWh added and the type of vehicle engine charged */
    visaEstimatedKmMilesAdded?: Maybe<Scalars["UnsignedInt"]>;
    /** Estimated range in Km/Miles the car will have, after completion of the charge, once it leaves the electric vehicle charging station */
    visaEstimatedKmMilesAvailable?: Maybe<Scalars["UnsignedInt"]>;
    /** Specific charging reason code for this transaction */
    visaEvChargingReasonCode?: Maybe<VisaEvChargingReasonCode>;
    /** Visa-defined code for a specific connector type to identify the connection for the charge session */
    visaEvConnectorType?: Maybe<VisaEvConnectorType>;
    /** An additional identifier to further differentiate the fuel product */
    visaExpandedFuelType?: Maybe<VisaFuelType>;
    /** An alphanumeric value representing the answer to a custom prompt */
    visaFleetCustomPrompt1?: Maybe<Scalars["String"]>;
    /** An alphanumeric value representing the answer to a custom prompt */
    visaFleetCustomPrompt2?: Maybe<Scalars["String"]>;
    /** An alphanumeric value representing the employee’s ID number */
    visaFleetEmployeeNumber?: Maybe<Scalars["String"]>;
    /** A list of fuel products purchased if this transaction contained multiple fuel types */
    visaFleetFuelLineItems?: Maybe<Array<VisaFleetL2FuelLineItem>>;
    /** An alphanumeric value representing either a Vehicle, Driver, or Generic ID */
    visaFleetIdentifier?: Maybe<Scalars["String"]>;
    /** An alphanumeric value representing the trailer’s ID number */
    visaFleetTrailerNumber?: Maybe<Scalars["String"]>;
    /**
     * The total amount for only the fuel purchased in the transaction. The value will equal visaFuelQuantity * visaFuelUnitCost inclusive of taxes.
     *
     * There are 4 implied decimal places, thus a value of “1” is populated in this field as 10000.
     */
    visaFuelGrossAmount?: Maybe<Scalars["UnsignedInt"]>;
    /**
     * The fuel amount less any exempted taxes or discounts. The value will equal visaFuelQuantity * visaFuelUnitCost exclusive of taxes.
     *
     * There are 4 implied decimal places, thus a value of “1” is populated in this field as 10000.
     */
    visaFuelNetAmount?: Maybe<Scalars["UnsignedInt"]>;
    /** Describes the type of items included in the transaction. (Gas, non-fuel, fuel, and non-fuel) */
    visaFuelPurchaseType?: Maybe<VisaFuelPurchaseType>;
    /**
     * The amount of fuel purchased during the transaction.
     *
     * There are 4 implied decimal places, thus a value of “1” is populated in this field as 10000.
     */
    visaFuelQuantity?: Maybe<Scalars["UnsignedInt"]>;
    /** Indicates whether the transaction occurred at a self-service or a full-service station */
    visaFuelServiceType?: Maybe<VisaFuelServiceType>;
    /** The variety of fuel purchased during the transaction */
    visaFuelType?: Maybe<VisaFuelType>;
    /**
     * The price per unit of measure for the fuel.
     *
     * There are 4 implied decimal places, thus a value of “1” is populated in this field as 10000.
     */
    visaFuelUnitCost?: Maybe<Scalars["UnsignedInt"]>;
    /** The dimension utilized in conjunction with quantity */
    visaFuelUnitOfMeasure?: Maybe<VisaFuelUnitOfMeasure>;
    /** Maximum power dispensed during the specific charge session from that charging station. This could be different to the power output capacity of the station based on power management by the site operator */
    visaMaxPowerDispensed?: Maybe<Scalars["UnsignedInt"]>;
    /** The national tax rate in basis points for fuel purchased. Two decimal places are implied */
    visaNationalTaxRate?: Maybe<Scalars["UnsignedInt"]>;
    /**
     * The total amount for only the non-fuel products purchased in the transaction. The value will equal the sum of the line item(s) inclusive of taxes.
     *
     * There are 2 implied decimal places, thus a value of “1” is populated in this field as 100.
     */
    visaNonFuelGrossAmount?: Maybe<Scalars["UnsignedInt"]>;
    /**
     * The non-fuel amount less any exempted taxes or discounts. The value will equal the sum of the line item(s) exclusive of taxes.
     *
     * There are 2 implied decimal places, thus a value of “1” is populated in this field as 100.
     */
    visaNonFuelNetAmount?: Maybe<Scalars["UnsignedInt"]>;
    /** A list of up to eight visaNonFuelProductCode values for products in the transaction */
    visaNonFuelProductCodes?: Maybe<Array<VisaNonFuelProductCode>>;
    /**
     * A numeric value indicating the vehicle’s odometer reading at the time of the transaction.
     *
     * Up to 7 digits.
     */
    visaOdometerReading?: Maybe<Scalars["UnsignedInt"]>;
    /** Other tax rate in basis points for fuel purchased. Two decimal places are implied */
    visaOtherTaxRate?: Maybe<Scalars["UnsignedInt"]>;
    /** An alphanumeric value representing an order or invoice number */
    visaPurchaseIdentifier?: Maybe<Scalars["String"]>;
    /** Indicates whether Purchase Identifier is an order or invoice number */
    visaPurchaseIdentifierFormat?: Maybe<VisaFleetPurchaseIdentifierFormat>;
    /**
     * The VAT or tax rate applied for the transaction
     *
     * There are 2 implied decimal places, thus a value of “1” is populated in this field as 100.
     */
    visaTaxRate?: Maybe<Scalars["UnsignedInt"]>;
  };

/** Simulated Visa Fleet L2 transaction data. These are relevant additional transaction data items pertaining to a fleet transaction. */
export type VisaFleetL2TransactionDataInput = {
  /** Indicates whether the Merchant will send more additional (Level 3) information in the future */
  visaAdditionalDataIndicator?: InputMaybe<Scalars["Boolean"]>;
  /** Carbon footprint avoidance (how much was saved from this charge) measurement for the purchase on the transaction – measured in grams of carbon dioxide equivalent (CO2e) */
  visaCarbonFootprintAvoided?: InputMaybe<Scalars["UnsignedInt"]>;
  /** Charging station power output capacity represented in kW */
  visaChargingPowerCapacity?: InputMaybe<Scalars["UnsignedInt"]>;
  /**
   * Identifies the fleet client
   *
   * **Maximum length:** 255 characters
   */
  visaClientIdentifier?: InputMaybe<Scalars["String"]>;
  /** Identifies the entity that calculated the discount */
  visaDiscountAgent?: InputMaybe<VisaFleetDiscountAgent>;
  /** Discount method applied to the transaction */
  visaDiscountMethod?: InputMaybe<VisaFleetDiscountMethod>;
  /**
   * Identifies the discount plan applied to the transaction
   *
   * **Maximum length:** 255 characters
   */
  visaDiscountPlanIdentifier?: InputMaybe<Scalars["String"]>;
  /** Estimate of the total distance added in km/miles, based on the kWh added and the type of vehicle engine charged */
  visaEstimatedKmMilesAdded?: InputMaybe<Scalars["UnsignedInt"]>;
  /** Estimated range in Km/Miles the car will have, after completion of the charge, once it leaves the electric vehicle charging station */
  visaEstimatedKmMilesAvailable?: InputMaybe<Scalars["UnsignedInt"]>;
  /** Specific charging reason code for this transaction */
  visaEvChargingReasonCode?: InputMaybe<VisaEvChargingReasonCode>;
  /** Visa-defined code for a specific connector type to identify the connection for the charge session */
  visaEvConnectorType?: InputMaybe<VisaEvConnectorType>;
  /** An additional identifier to further differentiate the fuel product */
  visaExpandedFuelType?: InputMaybe<VisaFuelType>;
  /**
   * An alphanumeric value representing the answer to a custom prompt
   *
   * **Maximum length:** 255 characters
   */
  visaFleetCustomPrompt1?: InputMaybe<Scalars["String"]>;
  /**
   * An alphanumeric value representing the answer to a custom prompt
   *
   * **Maximum length:** 255 characters
   */
  visaFleetCustomPrompt2?: InputMaybe<Scalars["String"]>;
  /**
   * An alphanumeric value representing the employee’s ID number
   *
   * **Maximum length:** 255 characters
   */
  visaFleetEmployeeNumber?: InputMaybe<Scalars["String"]>;
  /** A list of fuel products purchased if this transaction contained multiple fuel types */
  visaFleetFuelLineItems?: InputMaybe<Array<VisaFleetL2FuelLineItemInput>>;
  /**
   * An alphanumeric value representing either a Vehicle, Driver, or Generic ID
   *
   * **Maximum length:** 255 characters
   */
  visaFleetIdentifier?: InputMaybe<Scalars["String"]>;
  /**
   * An alphanumeric value representing the trailer’s ID number
   *
   * **Maximum length:** 255 characters
   */
  visaFleetTrailerNumber?: InputMaybe<Scalars["String"]>;
  /**
   * The total amount for only the fuel purchased in the transaction. The value will equal visaFuelQuantity * visaFuelUnitCost inclusive of taxes.
   *
   * There are 4 implied decimal places, thus a value of “1” is populated in this field as 10000.
   */
  visaFuelGrossAmount?: InputMaybe<Scalars["UnsignedInt"]>;
  /**
   * The fuel amount less any exempted taxes or discounts. The value will equal visaFuelQuantity * visaFuelUnitCost exclusive of taxes.
   *
   * There are 4 implied decimal places, thus a value of “1” is populated in this field as 10000.
   */
  visaFuelNetAmount?: InputMaybe<Scalars["UnsignedInt"]>;
  /** Describes the type of items included in the transaction. (Gas, non-fuel, fuel, and non-fuel) */
  visaFuelPurchaseType?: InputMaybe<VisaFuelPurchaseType>;
  /**
   * The amount of fuel purchased during the transaction.
   *
   * There are 4 implied decimal places, thus a value of “1” is populated in this field as 10000.
   */
  visaFuelQuantity?: InputMaybe<Scalars["UnsignedInt"]>;
  /** Indicates whether the transaction occurred at a self-service or a full-service station */
  visaFuelServiceType?: InputMaybe<VisaFuelServiceType>;
  /** The variety of fuel purchased during the transaction */
  visaFuelType?: InputMaybe<VisaFuelType>;
  /**
   * The price per unit of measure for the fuel.
   *
   * There are 4 implied decimal places, thus a value of “1” is populated in this field as 10000.
   */
  visaFuelUnitCost?: InputMaybe<Scalars["UnsignedInt"]>;
  /** The dimension utilized in conjunction with quantity */
  visaFuelUnitOfMeasure?: InputMaybe<VisaFuelUnitOfMeasure>;
  /** Maximum power dispensed during the specific charge session from that charging station. This could be different to the power output capacity of the station based on power management by the site operator */
  visaMaxPowerDispensed?: InputMaybe<Scalars["UnsignedInt"]>;
  /** The national tax rate in basis points for fuel purchased. Two decimal places are implied */
  visaNationalTaxRate?: InputMaybe<Scalars["UnsignedInt"]>;
  /**
   * The total amount for only the non-fuel products purchased in the transaction. The value will equal the sum of the line item(s) inclusive of taxes.
   *
   * There are 2 implied decimal places, thus a value of “1” is populated in this field as 100.
   */
  visaNonFuelGrossAmount?: InputMaybe<Scalars["UnsignedInt"]>;
  /**
   * The non-fuel amount less any exempted taxes or discounts. The value will equal the sum of the line item(s) exclusive of taxes.
   *
   * There are 2 implied decimal places, thus a value of “1” is populated in this field as 100.
   */
  visaNonFuelNetAmount?: InputMaybe<Scalars["UnsignedInt"]>;
  /** A list of up to eight visaNonFuelProductCode values for products in the transaction */
  visaNonFuelProductCodes?: InputMaybe<Array<VisaNonFuelProductCode>>;
  /**
   * A numeric value indicating the vehicle’s odometer reading at the time of the transaction.
   *
   * Up to 7 digits.
   */
  visaOdometerReading?: InputMaybe<Scalars["UnsignedInt"]>;
  /** Other tax rate in basis points for fuel purchased. Two decimal places are implied */
  visaOtherTaxRate?: InputMaybe<Scalars["UnsignedInt"]>;
  /**
   * An alphanumeric value representing an order or invoice number
   *
   * **Maximum length:** 255 characters
   */
  visaPurchaseIdentifier?: InputMaybe<Scalars["String"]>;
  /** Indicates whether Purchase Identifier is an order or invoice number */
  visaPurchaseIdentifierFormat?: InputMaybe<VisaFleetPurchaseIdentifierFormat>;
  /**
   * The VAT or tax rate applied for the transaction
   *
   * There are 2 implied decimal places, thus a value of “1” is populated in this field as 100.
   */
  visaTaxRate?: InputMaybe<Scalars["UnsignedInt"]>;
};

/** Visa Fleet Level 3 enhanced transaction Data. These are relevant additional transaction data items pertaining to a fleet transaction. */
export type VisaFleetL3EnhancedData = AdditionalTransactionData &
  Node & {
    __typename?: "VisaFleetL3EnhancedData";
    /** Discount data for this transaction. */
    discount?: Maybe<VisaFleetL3EnhancedDataDiscount>;
    /** Duty data for this transaction. */
    duty?: Maybe<VisaFleetL3EnhancedDataDuty>;
    /** The ID of this `VisaFleetL3EnhancedData`. This `id` cannot be used to later retrieve details of this `EnhancedDataEvent`. Please use the `id` of the `EnhancedDataEvent`. */
    id: Scalars["ID"];
    /** Invoice data for this transaction. */
    invoice?: Maybe<VisaFleetL3EnhancedDataInvoice>;
    /** Shipping data for this transaction. */
    shipping?: Maybe<VisaFleetL3EnhancedDataShipping>;
    /** Tax data for this transaction. */
    tax?: Maybe<VisaFleetL3EnhancedDataTax>;
  };

/** Discount data for this transaction. */
export type VisaFleetL3EnhancedDataDiscount = {
  __typename?: "VisaFleetL3EnhancedDataDiscount";
  /**
   * Total amount of discount at invoice level according to the `treatment` and the `tax.treatment`.
   *
   * This figure excludes any discount amounts defined at line item level.
   *
   * The last two digits are implied decimal places.
   */
  amount?: Maybe<Amount>;
  /** This field specifies if the invoice-level Discount Amount is a credit or debit value. */
  signage?: Maybe<VisaAmountSignage>;
  /** Identifies how to treat the discount if one was applied at the invoice level */
  treatment?: Maybe<VisaDiscountTreatment>;
};

/** Duty data for this transaction. */
export type VisaFleetL3EnhancedDataDuty = {
  __typename?: "VisaFleetL3EnhancedDataDuty";
  /**
   * The price of duty.
   * The last two digits are implied decimal places.
   */
  amount?: Maybe<Amount>;
  /** This field specifies if the Duty Amount is a credit or debit value. */
  signage?: Maybe<VisaAmountSignage>;
};

/** Invoice data for this transaction. */
export type VisaFleetL3EnhancedDataInvoice = {
  __typename?: "VisaFleetL3EnhancedDataInvoice";
  /** The Authorization Code of the transaction. */
  authorizationCode?: Maybe<Scalars["String"]>;
  /** Country code of the destination. The field may contain spaces. */
  destinationCountryCode?: Maybe<Scalars["String"]>;
  /** Postal code of the destination. The field may contain spaces. */
  destinationPostalCode?: Maybe<Scalars["String"]>;
  /** List of `VisaFleetL3EnhancedDataLineItem` objects */
  lineItems?: Maybe<Array<VisaFleetL3EnhancedDataLineItem>>;
  /** Date the order was taken. The entry should be in the format YYYY-MM-DD. */
  orderDate?: Maybe<Scalars["String"]>;
  /** The VAT invoice reference number */
  referenceNumber?: Maybe<Scalars["String"]>;
  /** Postal code of the location being shipped from. The field may contain spaces. */
  shipFromPostalCode?: Maybe<Scalars["String"]>;
};

/** An single line item within a `VisaFleetL3EnhancedData` */
export type VisaFleetL3EnhancedDataLineItem = {
  __typename?: "VisaFleetL3EnhancedDataLineItem";
  /** The value holds either a `fuelType` or a `nonFuelProductCode` value. */
  commodityCode?: Maybe<VisaItemCommodityCode>;
  /** Freeform text description of item or service */
  descriptor?: Maybe<Scalars["String"]>;
  /**
   * Amount of discount if provided for this line item according to the `discountTreatment`.
   *
   * The last two digits are implied decimal places.
   */
  discountPerItem?: Maybe<Amount>;
  /** Defines the type of line item */
  lineItemDetailIndicator?: Maybe<VisaLineItemDetailIndicator>;
  /** Identifies how to treat the discount if one was applied at the line item level */
  lineItemDiscountTreatment?: Maybe<VisaDiscountTreatment>;
  /**
   * Formula: (`quantity` * `unitCost`) - `discountPerItem`
   *
   * The last two digits are implied decimal places.
   */
  lineItemTotal?: Maybe<Amount>;
  /** Typically, an SKU or identifier from the Merchant */
  productCode?: Maybe<Scalars["String"]>;
  /**
   * The number of items.
   *
   * There are 4 implied decimal places, thus a value of “1” is populated in this field as 10000.
   */
  quantity?: Maybe<Scalars["UnsignedInt"]>;
  /**
   * Amount of sales tax for this item or service in accordance with the `taxTreatment`.
   *
   * The last two digits are implied decimal places.
   */
  taxAmount?: Maybe<Amount>;
  /**
   * Rate of sales tax charged on the item or service (in accordance with the `taxTreatment`).
   *
   * The last two digits are implied decimal places.
   */
  taxRate?: Maybe<Scalars["UnsignedInt"]>;
  /**
   * Unit cost for this item or service in accordance with the `taxTreatment`.
   *
   * There are 4 implied decimal places, thus a value of “1” is populated in this field as 10000.
   */
  unitCost?: Maybe<Amount>;
  /** A readable unit of measure */
  unitOfMeasure?: Maybe<Scalars["String"]>;
};

/** Shipping data for this transaction. */
export type VisaFleetL3EnhancedDataShipping = {
  __typename?: "VisaFleetL3EnhancedDataShipping";
  /**
   * The price of freight/shipping.
   * The last two digits are implied decimal places.
   */
  amount?: Maybe<Amount>;
  /** This field specifies if the Shipping Amount is a credit or debit value. */
  signage?: Maybe<VisaAmountSignage>;
  /**
   * Amount of Sales Tax charged on the shipping amount (in accordance with the `tax.treatment`).
   *
   * The last two digits are implied decimal places.
   */
  taxAmount?: Maybe<Amount>;
  /** This field specifies if the Duty Amount is a credit or debit value. */
  taxAmountSignage?: Maybe<VisaAmountSignage>;
  /**
   * Rate of sales tax charged on the shipping amount (in accordance with the `tax.treatment`).
   *
   * The last two digits are implied decimal places.
   */
  taxRate?: Maybe<Scalars["UnsignedInt"]>;
};

/** Tax data for this transaction. */
export type VisaFleetL3EnhancedDataTax = {
  __typename?: "VisaFleetL3EnhancedDataTax";
  /** Describes how the tax is calculated on the invoice. */
  treatment?: Maybe<VisaTaxTreatment>;
};

/** Visa Fleet purchase Identifier format */
export enum VisaFleetPurchaseIdentifierFormat {
  /** The Purchase Identifier represents an Invoice Number */
  INVOICE = "INVOICE",
  /** The Purchase Identifier represents an Order Number */
  ORDER = "ORDER",
}

/** Visa Fleet fuel purchase types */
export enum VisaFuelPurchaseType {
  /** Purchase includes only fuel */
  FUEL_PURCHASE = "FUEL_PURCHASE",
  /** Purchase includes fuel and non-fuel items */
  MIXED = "MIXED",
  /** Purchase includes only non-fuel items */
  NON_FUEL_PURCHASE = "NON_FUEL_PURCHASE",
}

/** Visa Fleet fuel service types */
export enum VisaFuelServiceType {
  /** Transaction occurred at a full-service fuel station */
  FULL_SERVICE = "FULL_SERVICE",
  /** Transaction occurred at a high speed dispense fuel station */
  HIGH_SPEED_DISPENSE = "HIGH_SPEED_DISPENSE",
  /** Transaction occurred at a self-service fuel station */
  SELF_SERVICE = "SELF_SERVICE",
}

/** Visa Fleet fuel types */
export enum VisaFuelType {
  /** Additive Dosage */
  ADDITIVE_DOSAGE = "ADDITIVE_DOSAGE",
  /** Aviation Biofuel (Gasoline) */
  AV_BIOFUEL = "AV_BIOFUEL",
  /** Aviation Fuel 4 */
  AV_FUEL_4 = "AV_FUEL_4",
  /** Aviation Fuel 5 */
  AV_FUEL_5 = "AV_FUEL_5",
  /** Aviation Fuel JP8 */
  AV_FUEL_JP8 = "AV_FUEL_JP8",
  /** Aviation Fuel Premium */
  AV_FUEL_PREMIUM = "AV_FUEL_PREMIUM",
  /** Aviation Fuel Regular */
  AV_FUEL_REGULAR = "AV_FUEL_REGULAR",
  /** Undefined Aviation Fuel */
  AV_FUEL_UNDEFINED_1 = "AV_FUEL_UNDEFINED_1",
  /** Undefined Aviation Fuel */
  AV_FUEL_UNDEFINED_2 = "AV_FUEL_UNDEFINED_2",
  /** Undefined Aviation Fuel */
  AV_FUEL_UNDEFINED_3 = "AV_FUEL_UNDEFINED_3",
  /** Undefined Aviation Fuel */
  AV_FUEL_UNDEFINED_4 = "AV_FUEL_UNDEFINED_4",
  /** Undefined Aviation Fuel */
  AV_FUEL_UNDEFINED_5 = "AV_FUEL_UNDEFINED_5",
  /** Undefined Aviation Fuel */
  AV_FUEL_UNDEFINED_6 = "AV_FUEL_UNDEFINED_6",
  /** Undefined Aviation Fuel */
  AV_FUEL_UNDEFINED_7 = "AV_FUEL_UNDEFINED_7",
  /** Undefined Aviation Fuel */
  AV_FUEL_UNDEFINED_8 = "AV_FUEL_UNDEFINED_8",
  /** Undefined Aviation Fuel */
  AV_FUEL_UNDEFINED_9 = "AV_FUEL_UNDEFINED_9",
  /** Undefined Aviation Fuel */
  AV_FUEL_UNDEFINED_10 = "AV_FUEL_UNDEFINED_10",
  /** Undefined Aviation Fuel */
  AV_FUEL_UNDEFINED_11 = "AV_FUEL_UNDEFINED_11",
  /** B2 Diesel Blend 2% Biodiesel */
  B2_DIESEL = "B2_DIESEL",
  /** B5 Diesel Blend 5% Biodiesel */
  B5_DIESEL = "B5_DIESEL",
  /** B10 Diesel Blend 10% Biodiesel */
  B10_DIESEL = "B10_DIESEL",
  /** B11 Diesel Blend 11% Biodiesel */
  B11_DIESEL = "B11_DIESEL",
  /** B15 Diesel Blend 15% Biodiesel */
  B15_DIESEL = "B15_DIESEL",
  /** B20 Diesel Blend 20% Biodiesel */
  B20_DIESEL = "B20_DIESEL",
  /** B75 Diesel Blend 75% Biodiesel */
  B75_DIESEL = "B75_DIESEL",
  /** B99 Diesel Blend 99% Biodiesel */
  B99_DIESEL = "B99_DIESEL",
  /** B100 Diesel Blend 100% Biodiesel */
  B100_DIESEL = "B100_DIESEL",
  /** Biodiesel Blend 2% Off-Road (Non-Taxable) */
  BIODIESEL_BLEND_2_OR_NT = "BIODIESEL_BLEND_2_OR_NT",
  /** Biodiesel Blend 5% Off-Road (Non-Taxable) */
  BIODIESEL_BLEND_5_OR_NT = "BIODIESEL_BLEND_5_OR_NT",
  /** Biodiesel Blend 10% Off-Road (Non-Taxable) */
  BIODIESEL_BLEND_10_OR_NT = "BIODIESEL_BLEND_10_OR_NT",
  /** Biodiesel Blend 11% Off-Road (Non-Taxable) */
  BIODIESEL_BLEND_11_OR_NT = "BIODIESEL_BLEND_11_OR_NT",
  /** Biodiesel Blend 15% Off-Road (Non-Taxable) */
  BIODIESEL_BLEND_15_OR_NT = "BIODIESEL_BLEND_15_OR_NT",
  /** Biodiesel Blend 20% Off-Road (Non-Taxable) */
  BIODIESEL_BLEND_20_OR_NT = "BIODIESEL_BLEND_20_OR_NT",
  /** Biodiesel Blend Off-Road (Non-Taxable) */
  BIODIESEL_OFF_ROAD_NON_TAXABLE = "BIODIESEL_OFF_ROAD_NON_TAXABLE",
  /** <Deprecated> Biodiesel Blend Off-Road (Non-Taxable) */
  BIODIESEL_OFF_ROAD_NON_TAXABLE_35 = "BIODIESEL_OFF_ROAD_NON_TAXABLE_35",
  /** Biojet (Diesel) */
  BIOJET = "BIOJET",
  /** Blended Diesel (#1 and #2) */
  BLENDED_DIESEL_1_2 = "BLENDED_DIESEL_1_2",
  /** <Deprecated> Bottled Propane */
  BOTTLED_PROPANE = "BOTTLED_PROPANE",
  /** Compressed Natural Gas */
  COMPRESSED_NAT_GAS = "COMPRESSED_NAT_GAS",
  /** DEF (Diesel Exhaust Fluid) */
  DEF = "DEF",
  /** Diesel #1 Off-Road (Non-Taxable) */
  DIESEL_1_OR_NT = "DIESEL_1_OR_NT",
  /** Diesel #1 Premium Off-Road (Non-Taxable) */
  DIESEL_1_PREMIUM_OR_NT = "DIESEL_1_PREMIUM_OR_NT",
  /** Diesel #2 Off-Road (Non-Taxable) */
  DIESEL_2_OR_NT = "DIESEL_2_OR_NT",
  /** Diesel #2 Premium Off-Road (Non-Taxable) */
  DIESEL_2_PREMIUM_OR_NT = "DIESEL_2_PREMIUM_OR_NT",
  /** Diesel Off-Road (Non-Taxable)* */
  DIESEL_OFF_ROAD_NON_TAXABLE = "DIESEL_OFF_ROAD_NON_TAXABLE",
  /** Diesel Off-Road (#1 and #2 Non-Taxable)* */
  DIESEL_OFF_ROAD_TAXABLE = "DIESEL_OFF_ROAD_TAXABLE",
  /** Ethanol Blends E16-E84 */
  E16_E84 = "E16_E84",
  /** E-85 */
  E85 = "E85",
  /** <Deprecated> Ethanol (5.7% blend) */
  ETHANOL_57 = "ETHANOL_57",
  /** <Deprecated> Ethanol (7.7% blend) */
  ETHANOL_77 = "ETHANOL_77",
  /** EVC-1 – Level 1 charge = 110v 15 amp */
  EVC_1 = "EVC_1",
  /** EVC-2 – Level 2 charge = 240v 15-40 amp */
  EVC_2 = "EVC_2",
  /** EVC-3 – Level 3 charge = 480v 3 phase charge */
  EVC_3 = "EVC_3",
  /** Green Gasoline Mid/Plus (Plant based not petroleum based) */
  GREEN_GAS_PLUS = "GREEN_GAS_PLUS",
  /** Green Gasoline Regular (Plant based not petroleum based) */
  GREEN_GAS_REGULAR = "GREEN_GAS_REGULAR",
  /** Green Gasoline Premium/Super (Plant based not petroleum based) */
  GREEN_GAS_SUPER = "GREEN_GAS_SUPER",
  /** Hydrogen H35 */
  H35 = "H35",
  /** Hydrogen H70 */
  H70 = "H70",
  /** Heating Oil */
  HEATING_OIL = "HEATING_OIL",
  /** Jet Fuel */
  JET_FUEL = "JET_FUEL",
  /** Kerosene – Low Sulfur */
  KEROSENE = "KEROSENE",
  /** Kerosene – Low Sulfur (Non-Taxable) */
  KEROSENE_LS_NT = "KEROSENE_LS_NT",
  /** Kerosene – Ultra Low Sulfur */
  KEROSENE_ULS = "KEROSENE_ULS",
  /** Kerosene – Ultra Low Sulfur (Non-Taxable) */
  KEROSENE_ULS_NT = "KEROSENE_ULS_NT",
  /** Liquid Natural Gas */
  LNG = "LNG",
  /** Low Octane UNL */
  LO_UNL = "LO_UNL",
  /** Liquid Propane Gas */
  LPG = "LPG",
  /** <Deprecated> M-85 */
  M85 = "M85",
  /** Marine Diesel */
  MARINE_DIESEL = "MARINE_DIESEL",
  /** Marine Fuel 1 */
  MARINE_FUEL_1 = "MARINE_FUEL_1",
  /** Marine Fuel 2 */
  MARINE_FUEL_2 = "MARINE_FUEL_2",
  /** Marine Fuel 3 */
  MARINE_FUEL_3 = "MARINE_FUEL_3",
  /** Marine Fuel 4 */
  MARINE_FUEL_4 = "MARINE_FUEL_4",
  /** Marine Fuel 5 */
  MARINE_FUEL_5 = "MARINE_FUEL_5",
  /** Marine – Other */
  MARINE_FUEL_OTHER = "MARINE_FUEL_OTHER",
  /** Mid/Plus Gasoline */
  MID_PLUS = "MID_PLUS",
  /** Mid/Plus 2 Gasoline */
  MID_PLUS_2 = "MID_PLUS_2",
  /** Mid/Plus 2 (10% Blend) */
  MID_PLUS_2_10 = "MID_PLUS_2_10",
  /** <Deprecated> Mid/Plus Ethanol (5.7% blend) */
  MID_PLUS_ETHANOL_57 = "MID_PLUS_ETHANOL_57",
  /** <Deprecated> Mid/Plus Ethanol (7.7% blend) */
  MID_PLUS_ETHANOL_77 = "MID_PLUS_ETHANOL_77",
  /** Miscellaneous Aviation Fuel */
  MISC_AV_FUEL = "MISC_AV_FUEL",
  /** Miscellaneous Fuel */
  MISC_FUEL = "MISC_FUEL",
  /** Miscellaneous Fuel */
  MISC_FUEL_1 = "MISC_FUEL_1",
  /** Miscellaneous Fuel */
  MISC_FUEL_2 = "MISC_FUEL_2",
  /** Miscellaneous Fuel */
  MISC_FUEL_3 = "MISC_FUEL_3",
  /** Miscellaneous Fuel */
  MISC_FUEL_4 = "MISC_FUEL_4",
  /** Miscellaneous Fuel */
  MISC_FUEL_5 = "MISC_FUEL_5",
  /** Miscellaneous Marine Fuel */
  MISC_MARINE_FUEL = "MISC_MARINE_FUEL",
  /** Miscellaneous Other Fuel */
  MISC_OTHER_FUEL = "MISC_OTHER_FUEL",
  /** Miscellaneous Packaged Fuels */
  MISC_PACKAGED_FUEL = "MISC_PACKAGED_FUEL",
  /** Other Fuel (Non-Taxable) */
  OTHER_FUEL_NT = "OTHER_FUEL_NT",
  /** Packaged Additive */
  PACKAGED_ADDITIVE = "PACKAGED_ADDITIVE",
  /** Packaged B99 */
  PACKAGED_B99 = "PACKAGED_B99",
  /** Packaged B100 */
  PACKAGED_B100 = "PACKAGED_B100",
  /** Packaged DEF (Diesel Exhaust Fluid) */
  PACKAGED_DEF = "PACKAGED_DEF",
  /** Packaged Kerosene */
  PACKAGED_KEROSENE = "PACKAGED_KEROSENE",
  /** Packaged Propane */
  PACKAGED_PROPANE = "PACKAGED_PROPANE",
  /** Off-Road Mid/Plus 2 (Non-Taxable) */
  PLUS_2_OR_NT = "PLUS_2_OR_NT",
  /** Mid/Plus Ethanol 2 (15% Blend) */
  PLUS_ETHANOL_2_15 = "PLUS_ETHANOL_2_15",
  /** Mid/Plus Ethanol (10% Blend) */
  PLUS_ETHANOL_10 = "PLUS_ETHANOL_10",
  /** Mid/Plus Ethanol (15% Blend) */
  PLUS_ETHANOL_15 = "PLUS_ETHANOL_15",
  /** Off-Road Mid/Plus (Non-Taxable) */
  PLUS_OR_NT = "PLUS_OR_NT",
  /** Premium Diesel Blend >= 20% Biodiesel */
  PREMIUM_BIODIESEL_BLEND_OVER_20 = "PREMIUM_BIODIESEL_BLEND_OVER_20",
  /** Premium Diesel Blend <20% Biodiesel */
  PREMIUM_BIODIESEL_BLEND_UNDER_20 = "PREMIUM_BIODIESEL_BLEND_UNDER_20",
  /** Premium Diesel #1 */
  PREMIUM_DIESEL_1 = "PREMIUM_DIESEL_1",
  /** Premium Diesel #2 */
  PREMIUM_DIESEL_2 = "PREMIUM_DIESEL_2",
  /** Premium/Super Gasoline */
  PREMIUM_SUPER = "PREMIUM_SUPER",
  /** Premium/Super 2 Gasoline */
  PREMIUM_SUPER_2 = "PREMIUM_SUPER_2",
  /** Premium/Super 2 (10% Blend) */
  PREMIUM_SUPER_2_10 = "PREMIUM_SUPER_2_10",
  /** <Deprecated> Premium/Super Ethanol (5.7% blend) */
  PREMIUM_SUPER_ETHANOL_57 = "PREMIUM_SUPER_ETHANOL_57",
  /** Racing Fuel */
  RACING_FUEL = "RACING_FUEL",
  /** Recreational Fuel (90 Octane) */
  RECREATIONAL_FUEL = "RECREATIONAL_FUEL",
  /** Reformulated 1 */
  REFORMULATED_1 = "REFORMULATED_1",
  /** Reformulated 2 */
  REFORMULATED_2 = "REFORMULATED_2",
  /** Reformulated 3 */
  REFORMULATED_3 = "REFORMULATED_3",
  /** Reformulated 4 */
  REFORMULATED_4 = "REFORMULATED_4",
  /** Reformulated 5 */
  REFORMULATED_5 = "REFORMULATED_5",
  /** Regular Gasoline */
  REGULAR = "REGULAR",
  /** Regular Diesel #1 */
  REGULAR_DIESEL_1 = "REGULAR_DIESEL_1",
  /** Regular Diesel #2 */
  REGULAR_DIESEL_2 = "REGULAR_DIESEL_2",
  /** Regular Ethanol (10% Blend) */
  REGULAR_ETHANOL_10 = "REGULAR_ETHANOL_10",
  /** Regular Ethanol (15% Blend) */
  REGULAR_ETHANOL_15 = "REGULAR_ETHANOL_15",
  /** Off-Road Regular (Non-Taxable) */
  REGULAR_OR_NT = "REGULAR_OR_NT",
  /** Reserved For Future Use */
  RESERVED_1 = "RESERVED_1",
  /** Reserved For Future Use */
  RESERVED_2 = "RESERVED_2",
  /** Reserved For Future Use */
  RESERVED_3 = "RESERVED_3",
  /** Reserved For Future Use */
  RESERVED_4 = "RESERVED_4",
  /** Reserved For Future Use */
  RESERVED_5 = "RESERVED_5",
  /** Reserved For Future Use */
  RESERVED_6 = "RESERVED_6",
  /** Reserved For Future Use */
  RESERVED_7 = "RESERVED_7",
  /** Reserved For Future Use */
  RESERVED_8 = "RESERVED_8",
  /** Reserved For Future Use */
  RESERVED_9 = "RESERVED_9",
  /** Reserved For Future Use */
  RESERVED_10 = "RESERVED_10",
  /** Reserved For Future Use */
  RESERVED_11 = "RESERVED_11",
  /** Reserved For Future Use */
  RESERVED_12 = "RESERVED_12",
  /** Reserved For Future Use */
  RESERVED_13 = "RESERVED_13",
  /** Reserved For Future Use */
  RESERVED_14 = "RESERVED_14",
  /** Reserved For Future Use */
  RESERVED_15 = "RESERVED_15",
  /** Reserved For Future Use */
  RESERVED_16 = "RESERVED_16",
  /** Reserved For Future Use */
  RESERVED_17 = "RESERVED_17",
  /** Reserved For Future Use */
  RESERVED_18 = "RESERVED_18",
  /** Reserved For Future Use */
  RESERVED_19 = "RESERVED_19",
  /** Reserved For Future Use */
  RESERVED_20 = "RESERVED_20",
  /** Reserved For Future Use */
  RESERVED_21 = "RESERVED_21",
  /** Reserved For Future Use */
  RESERVED_22 = "RESERVED_22",
  /** Reserved For Future Use */
  RESERVED_23 = "RESERVED_23",
  /** Reserved For Future Use */
  RESERVED_24 = "RESERVED_24",
  /** Reserved For Future Use */
  RESERVED_25 = "RESERVED_25",
  /** Off-Road Premium/Super 2 (Non-Taxable) */
  SUPER_2_OR_NT = "SUPER_2_OR_NT",
  /** Premium/Super Ethanol 2 (15% Blend) */
  SUPER_ETHANOL_2_15 = "SUPER_ETHANOL_2_15",
  /** Premium/Super Ethanol (10% Blend) */
  SUPER_ETHANOL_10 = "SUPER_ETHANOL_10",
  /** Premium/Super Ethanol (15% Blend) */
  SUPER_ETHANOL_15 = "SUPER_ETHANOL_15",
  /** Off-Road Premium/Super (Non-Taxable) */
  SUPER_OR_NT = "SUPER_OR_NT",
  /** <Deprecated> Ultra Low Sulfur #1 */
  ULTRA_LOW_SULFUR_1 = "ULTRA_LOW_SULFUR_1",
  /** <Deprecated> Ultra Low Sulfur #2 */
  ULTRA_LOW_SULFUR_2 = "ULTRA_LOW_SULFUR_2",
  /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 2% */
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_2 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_2",
  /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 5% */
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_5 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_5",
  /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 10% */
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_10 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_10",
  /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 11% */
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_11 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_11",
  /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 15% */
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_15 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_15",
  /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 20% */
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_20 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_20",
  /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 100% */
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_100 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_100",
  /** <Deprecated> Ultra Low Sulfur Premium Diesel #2 */
  ULTRA_LOW_SULFUR_PREMIUM_1 = "ULTRA_LOW_SULFUR_PREMIUM_1",
  /** Undefined Fuel – Reserved for Proprietary Use */
  UNDEFINED_FUEL_1 = "UNDEFINED_FUEL_1",
  /** Undefined Fuel – Reserved for Proprietary Use */
  UNDEFINED_FUEL_2 = "UNDEFINED_FUEL_2",
  /** Undefined Fuel – Reserved for Proprietary Use */
  UNDEFINED_FUEL_3 = "UNDEFINED_FUEL_3",
  /** Undefined Fuel – Reserved for Proprietary Use */
  UNDEFINED_FUEL_4 = "UNDEFINED_FUEL_4",
  /** Undefined Fuel – Reserved for Proprietary Use */
  UNDEFINED_FUEL_5 = "UNDEFINED_FUEL_5",
  /** Undefined Fuel – Reserved for Proprietary Use */
  UNDEFINED_FUEL_6 = "UNDEFINED_FUEL_6",
  /** Undefined Fuel – Reserved for Proprietary Use */
  UNDEFINED_FUEL_7 = "UNDEFINED_FUEL_7",
  /** Undefined Fuel – Reserved for Proprietary Use */
  UNDEFINED_FUEL_8 = "UNDEFINED_FUEL_8",
  /** Undefined Fuel – Reserved for Proprietary Use */
  UNDEFINED_FUEL_9 = "UNDEFINED_FUEL_9",
  /** Undefined Fuel – Reserved for Proprietary Use */
  UNDEFINED_FUEL_10 = "UNDEFINED_FUEL_10",
  /** Undefined Fuel – Reserved for Proprietary Use */
  UNDEFINED_FUEL_11 = "UNDEFINED_FUEL_11",
  /** Undefined Fuel – Reserved for Proprietary Use */
  UNDEFINED_FUEL_12 = "UNDEFINED_FUEL_12",
  /** Undefined Fuel – Reserved for Proprietary Use */
  UNDEFINED_FUEL_13 = "UNDEFINED_FUEL_13",
  /** Undefined Fuel – Reserved for Proprietary Use */
  UNDEFINED_FUEL_14 = "UNDEFINED_FUEL_14",
  /** Undefined Fuel – Reserved for Proprietary Use */
  UNDEFINED_FUEL_15 = "UNDEFINED_FUEL_15",
  /** Undefined Fuel – Reserved for Proprietary Use */
  UNDEFINED_FUEL_16 = "UNDEFINED_FUEL_16",
  /** Undefined Fuel – Reserved for Proprietary Use */
  UNDEFINED_FUEL_17 = "UNDEFINED_FUEL_17",
  /** Undefined Fuel – Reserved for Proprietary Use */
  UNDEFINED_FUEL_18 = "UNDEFINED_FUEL_18",
  /** Undefined Fuel – Reserved for Proprietary Use */
  UNDEFINED_FUEL_19 = "UNDEFINED_FUEL_19",
  /** Undefined Fuel – Reserved for Proprietary Use */
  UNDEFINED_FUEL_20 = "UNDEFINED_FUEL_20",
  /** Undefined Fuel – Reserved for Proprietary Use */
  UNDEFINED_FUEL_21 = "UNDEFINED_FUEL_21",
  /** Undefined Fuel – Reserved for Proprietary Use */
  UNDEFINED_FUEL_22 = "UNDEFINED_FUEL_22",
  /** Undefined Fuel – Reserved for Proprietary Use */
  UNDEFINED_FUEL_23 = "UNDEFINED_FUEL_23",
  /** Undefined Other Fuel */
  UNDEFINED_OTHER_FUEL_1 = "UNDEFINED_OTHER_FUEL_1",
  /** Undefined Other Fuel */
  UNDEFINED_OTHER_FUEL_2 = "UNDEFINED_OTHER_FUEL_2",
  /** Undefined Other Fuel */
  UNDEFINED_OTHER_FUEL_3 = "UNDEFINED_OTHER_FUEL_3",
  /** Undefined Other Fuel */
  UNDEFINED_OTHER_FUEL_4 = "UNDEFINED_OTHER_FUEL_4",
  /** Undefined Other Fuel */
  UNDEFINED_OTHER_FUEL_5 = "UNDEFINED_OTHER_FUEL_5",
  /** Undefined Other Fuel */
  UNDEFINED_OTHER_FUEL_6 = "UNDEFINED_OTHER_FUEL_6",
  /** Undefined Other Fuel */
  UNDEFINED_OTHER_FUEL_7 = "UNDEFINED_OTHER_FUEL_7",
  /** Undefined Other Fuel */
  UNDEFINED_OTHER_FUEL_8 = "UNDEFINED_OTHER_FUEL_8",
  /** Undefined Other Fuel */
  UNDEFINED_OTHER_FUEL_9 = "UNDEFINED_OTHER_FUEL_9",
  /** Undefined Other Fuel */
  UNDEFINED_OTHER_FUEL_10 = "UNDEFINED_OTHER_FUEL_10",
  /** Undefined Other Fuel */
  UNDEFINED_OTHER_FUEL_11 = "UNDEFINED_OTHER_FUEL_11",
  /** Undefined Other Fuel */
  UNDEFINED_OTHER_FUEL_12 = "UNDEFINED_OTHER_FUEL_12",
  /** Undefined Other Fuel */
  UNDEFINED_OTHER_FUEL_13 = "UNDEFINED_OTHER_FUEL_13",
  /** Undefined Other Fuel */
  UNDEFINED_OTHER_FUEL_14 = "UNDEFINED_OTHER_FUEL_14",
  /** Undefined Other Fuel */
  UNDEFINED_OTHER_FUEL_15 = "UNDEFINED_OTHER_FUEL_15",
  /** Undefined Other Fuel */
  UNDEFINED_OTHER_FUEL_16 = "UNDEFINED_OTHER_FUEL_16",
  /** Undefined Other Fuel */
  UNDEFINED_OTHER_FUEL_17 = "UNDEFINED_OTHER_FUEL_17",
  /** Undefined Other Fuel */
  UNDEFINED_OTHER_FUEL_18 = "UNDEFINED_OTHER_FUEL_18",
  /** Undefined Packaged Fuels */
  UNDEFINED_PACKAGED_FUEL_1 = "UNDEFINED_PACKAGED_FUEL_1",
  /** Undefined Packaged Fuels */
  UNDEFINED_PACKAGED_FUEL_2 = "UNDEFINED_PACKAGED_FUEL_2",
  /** Undefined Packaged Fuels */
  UNDEFINED_PACKAGED_FUEL_3 = "UNDEFINED_PACKAGED_FUEL_3",
  /** Undefined Packaged Fuels */
  UNDEFINED_PACKAGED_FUEL_4 = "UNDEFINED_PACKAGED_FUEL_4",
  /** Undefined Packaged Fuels */
  UNDEFINED_PACKAGED_FUEL_5 = "UNDEFINED_PACKAGED_FUEL_5",
  /** Undefined Packaged Fuels */
  UNDEFINED_PACKAGED_FUEL_6 = "UNDEFINED_PACKAGED_FUEL_6",
  /** Undefined Packaged Fuels */
  UNDEFINED_PACKAGED_FUEL_7 = "UNDEFINED_PACKAGED_FUEL_7",
  /** Undefined Packaged Fuels */
  UNDEFINED_PACKAGED_FUEL_8 = "UNDEFINED_PACKAGED_FUEL_8",
  /** Undefined Packaged Fuels */
  UNDEFINED_PACKAGED_FUEL_9 = "UNDEFINED_PACKAGED_FUEL_9",
  /** Undefined Packaged Fuels */
  UNDEFINED_PACKAGED_FUEL_10 = "UNDEFINED_PACKAGED_FUEL_10",
  /** Undefined Packaged Fuels */
  UNDEFINED_PACKAGED_FUEL_11 = "UNDEFINED_PACKAGED_FUEL_11",
  /** Undefined Packaged Fuels */
  UNDEFINED_PACKAGED_FUEL_12 = "UNDEFINED_PACKAGED_FUEL_12",
  /** Undefined Packaged Fuels */
  UNDEFINED_PACKAGED_FUEL_13 = "UNDEFINED_PACKAGED_FUEL_13",
  /** Undefined Packaged Fuels */
  UNDEFINED_PACKAGED_FUEL_14 = "UNDEFINED_PACKAGED_FUEL_14",
  /** Undefined Packaged Fuels */
  UNDEFINED_PACKAGED_FUEL_15 = "UNDEFINED_PACKAGED_FUEL_15",
  /** Undefined Packaged Fuels */
  UNDEFINED_PACKAGED_FUEL_16 = "UNDEFINED_PACKAGED_FUEL_16",
  /** Undefined Packaged Fuels */
  UNDEFINED_PACKAGED_FUEL_17 = "UNDEFINED_PACKAGED_FUEL_17",
  /** Undefined Packaged Fuels */
  UNDEFINED_PACKAGED_FUEL_18 = "UNDEFINED_PACKAGED_FUEL_18",
  /** Unknown/Undefined */
  UNKNOWN = "UNKNOWN",
  /** <Deprecated> Unleaded Methanol (5.7% blend) */
  UNLEADED_METHANOL_57 = "UNLEADED_METHANOL_57",
  /** <Deprecated> Unleaded Methanol (7.7% blend) */
  UNLEADED_METHANOL_77 = "UNLEADED_METHANOL_77",
  /** <Deprecated> Unleaded Plus Methanol (5.7% blend) */
  UNLEADED_PLUS_METHANOL_57 = "UNLEADED_PLUS_METHANOL_57",
  /** <Deprecated> Unleaded Plus Methanol (7.7% blend) */
  UNLEADED_PLUS_METHANOL_77 = "UNLEADED_PLUS_METHANOL_77",
  /** <Deprecated> Super Unleaded Methanol (5.7% blend) */
  UNLEADED_SUPER_METHANOL_57 = "UNLEADED_SUPER_METHANOL_57",
  /** White Gas */
  WHITE_GAS = "WHITE_GAS",
}

/** Visa Fleet fuel unit of measure types */
export enum VisaFuelUnitOfMeasure {
  /** Charging Minutes */
  CHARGING_MINUTES = "CHARGING_MINUTES",
  /** U.S. Gallon */
  GALLON = "GALLON",
  /** Imperial Gallon */
  IMPERIAL = "IMPERIAL",
  /** Kilo */
  KILO = "KILO",
  /** Kilowatt Hour */
  KILOWATT_HOUR = "KILOWATT_HOUR",
  /** Liter */
  LITER = "LITER",
  /** Pound */
  POUND = "POUND",
}

/** All the Visa Fleet commodity codes. */
export enum VisaItemCommodityCode {
  /** AC Parts 052-061 */
  AC_PARTS = "AC_PARTS",
  /** Air Conditioning Service */
  AC_SERVICE = "AC_SERVICE",
  /** Additive Dosage */
  ADDITIVE_DOSAGE = "ADDITIVE_DOSAGE",
  /** Aircraft Accessories */
  AIRCRAFT_ACC = "AIRCRAFT_ACC",
  /** Aircraft Cleaning */
  AIRCRAFT_CLEANING = "AIRCRAFT_CLEANING",
  /** Aircraft Fuel Additive */
  AIRCRAFT_FUEL_ADDITIVE = "AIRCRAFT_FUEL_ADDITIVE",
  /** Aircraft Ground Hauling */
  AIRCRAFT_GROUND_HAULING = "AIRCRAFT_GROUND_HAULING",
  /** Aircraft Ground Power Unit */
  AIRCRAFT_GROUND_PU = "AIRCRAFT_GROUND_PU",
  /** Aircraft Labor */
  AIRCRAFT_LABOR = "AIRCRAFT_LABOR",
  /** Aircraft Maintenance */
  AIRCRAFT_MAINTENANCE = "AIRCRAFT_MAINTENANCE",
  /** Aircraft Parking Fees */
  AIRCRAFT_PARKING_FEE = "AIRCRAFT_PARKING_FEE",
  /** Aircraft Rental */
  AIRCRAFT_RENTAL = "AIRCRAFT_RENTAL",
  /** Aircraft Sanitation Fees */
  AIRCRAFT_SANITATION = "AIRCRAFT_SANITATION",
  /** Aircraft Service */
  AIRCRAFT_SERVICE = "AIRCRAFT_SERVICE",
  /** Aircraft Tie Down Fees */
  AIRCRAFT_TIE_DOWN_FEE = "AIRCRAFT_TIE_DOWN_FEE",
  /** Aircraft Work Order */
  AIRCRAFT_WO = "AIRCRAFT_WO",
  /** Airport Fees */
  AIRPORT_FEE = "AIRPORT_FEE",
  /** Air Filter */
  AIR_FILTER = "AIR_FILTER",
  /** Alternative Snacks */
  ALT_SNACKS = "ALT_SNACKS",
  /** Anti-Freeze */
  ANTI_FREEZE = "ANTI_FREEZE",
  /** <Deprecated> APU or Aircraft Jump Seat */
  APU = "APU",
  /** <Deprecated> Avionics */
  AVIONICS = "AVIONICS",
  /** Aviation Biofuel (Gasoline) */
  AV_BIOFUEL = "AV_BIOFUEL",
  /** Aviation Fuel 4 */
  AV_FUEL_4 = "AV_FUEL_4",
  /** Aviation Fuel 5 */
  AV_FUEL_5 = "AV_FUEL_5",
  /** Aviation Fuel JP8 */
  AV_FUEL_JP8 = "AV_FUEL_JP8",
  /** Aviation Fuel Premium */
  AV_FUEL_PREMIUM = "AV_FUEL_PREMIUM",
  /** Aviation Fuel Regular */
  AV_FUEL_REGULAR = "AV_FUEL_REGULAR",
  /** AvGas Federal Excise Tax */
  AV_GAS_FED_E_TAX = "AV_GAS_FED_E_TAX",
  /** B2 Diesel Blend 2% Biodiesel */
  B2_DIESEL = "B2_DIESEL",
  /** B5 Diesel Blend 5% Biodiesel */
  B5_DIESEL = "B5_DIESEL",
  /** B10 Diesel Blend 10% Biodiesel */
  B10_DIESEL = "B10_DIESEL",
  /** B11 Diesel Blend 11% Biodiesel */
  B11_DIESEL = "B11_DIESEL",
  /** B15 Diesel Blend 15% Biodiesel */
  B15_DIESEL = "B15_DIESEL",
  /** B20 Diesel Blend 20% Biodiesel */
  B20_DIESEL = "B20_DIESEL",
  /** B75 Diesel Blend 75% Biodiesel */
  B75_DIESEL = "B75_DIESEL",
  /** B99 Diesel Blend 99% Biodiesel */
  B99_DIESEL = "B99_DIESEL",
  /** B100 Diesel Blend 100% Biodiesel */
  B100_DIESEL = "B100_DIESEL",
  /** Batteries */
  BATTERIES = "BATTERIES",
  /** Beer - Alcoholic */
  BEER = "BEER",
  /** Beer - Non-Alcoholic */
  BEER_NA = "BEER_NA",
  /** Biodiesel Blend 2% Off-Road (Non-Taxable) */
  BIODIESEL_BLEND_2_OR_NT = "BIODIESEL_BLEND_2_OR_NT",
  /** Biodiesel Blend 5% Off-Road (Non-Taxable) */
  BIODIESEL_BLEND_5_OR_NT = "BIODIESEL_BLEND_5_OR_NT",
  /** Biodiesel Blend 10% Off-Road (Non-Taxable) */
  BIODIESEL_BLEND_10_OR_NT = "BIODIESEL_BLEND_10_OR_NT",
  /** Biodiesel Blend 11% Off-Road (Non-Taxable) */
  BIODIESEL_BLEND_11_OR_NT = "BIODIESEL_BLEND_11_OR_NT",
  /** Biodiesel Blend 15% Off-Road (Non-Taxable) */
  BIODIESEL_BLEND_15_OR_NT = "BIODIESEL_BLEND_15_OR_NT",
  /** Biodiesel Blend 20% Off-Road (Non-Taxable) */
  BIODIESEL_BLEND_20_OR_NT = "BIODIESEL_BLEND_20_OR_NT",
  /** Biodiesel Blend Off-Road (Non-Taxable) */
  BIODIESEL_OFF_ROAD_NON_TAXABLE = "BIODIESEL_OFF_ROAD_NON_TAXABLE",
  /** <Deprecated> Biodiesel Blend Off-Road (Non-Taxable) */
  BIODIESEL_OFF_ROAD_NON_TAXABLE_35 = "BIODIESEL_OFF_ROAD_NON_TAXABLE_35",
  /** Biojet (Diesel) */
  BIOJET = "BIOJET",
  /** Blended Diesel (#1 and #2) */
  BLENDED_DIESEL_1_2 = "BLENDED_DIESEL_1_2",
  /** Body Work */
  BODY_WORK = "BODY_WORK",
  /** <Deprecated> Bottled Propane */
  BOTTLED_PROPANE = "BOTTLED_PROPANE",
  /** Brake Fluid */
  BRAKE_FLUID = "BRAKE_FLUID",
  /** Brake Service */
  BRAKE_SERVICE = "BRAKE_SERVICE",
  /** Call Out Fee */
  CALL_OUT_FEE = "CALL_OUT_FEE",
  /** Cargo Handling */
  CARGO_HANDLING = "CARGO_HANDLING",
  /** Car Wash */
  CAR_WASH = "CAR_WASH",
  /** Cash Back */
  CASH_BACK = "CASH_BACK",
  /** Cash Back Fee */
  CASH_BACK_FEE = "CASH_BACK_FEE",
  /** Catering */
  CATERING = "CATERING",
  /** Cannabidiol (CBD) */
  CBD = "CBD",
  /** Charity */
  CHARITY = "CHARITY",
  /** Charter Fee */
  CHARTER_FEE = "CHARTER_FEE",
  /** Cigarettes */
  CIGARETTES = "CIGARETTES",
  /** Cold Dispensed Beverages */
  COLD_DISPENSED_BEV = "COLD_DISPENSED_BEV",
  /** Communication Fee */
  COMMUNICATION_FEE = "COMMUNICATION_FEE",
  /** Compressed Natural Gas */
  COMPRESSED_NAT_GAS = "COMPRESSED_NAT_GAS",
  /** Corrosion Inhibitor */
  CORROSION_INHIBITOR = "CORROSION_INHIBITOR",
  /** Coupon 1 */
  COUPON_1 = "COUPON_1",
  /** Coupon 2 */
  COUPON_2 = "COUPON_2",
  /** Coupon 3 */
  COUPON_3 = "COUPON_3",
  /** Coupon 4 */
  COUPON_4 = "COUPON_4",
  /** Coupon 5 */
  COUPON_5 = "COUPON_5",
  /** DEF (Diesel Exhaust Fluid) */
  DEF = "DEF",
  /** Deli Items */
  DELI_ITEMS = "DELI_ITEMS",
  /** De-fuel */
  DE_FUEL = "DE_FUEL",
  /** De-icing */
  DE_ICING = "DE_ICING",
  /** Diesel #1 Off-Road (Non-Taxable) */
  DIESEL_1_OR_NT = "DIESEL_1_OR_NT",
  /** Diesel #1 Premium Off-Road (Non-Taxable) */
  DIESEL_1_PREMIUM_OR_NT = "DIESEL_1_PREMIUM_OR_NT",
  /** Diesel #2 Off-Road (Non-Taxable) */
  DIESEL_2_OR_NT = "DIESEL_2_OR_NT",
  /** Diesel #2 Premium Off-Road (Non-Taxable) */
  DIESEL_2_PREMIUM_OR_NT = "DIESEL_2_PREMIUM_OR_NT",
  /** Diesel Off-Road (Non-Taxable)* */
  DIESEL_OFF_ROAD_NON_TAXABLE = "DIESEL_OFF_ROAD_NON_TAXABLE",
  /** Diesel Off-Road (#1 and #2 Non-Taxable)* */
  DIESEL_OFF_ROAD_TAXABLE = "DIESEL_OFF_ROAD_TAXABLE",
  /** Disable Device/Handset Lock */
  DISABLE_HANDSET = "DISABLE_HANDSET",
  /** Discount 1 */
  DISCOUNT_1 = "DISCOUNT_1",
  /** Discount 2 */
  DISCOUNT_2 = "DISCOUNT_2",
  /** Discount 3 */
  DISCOUNT_3 = "DISCOUNT_3",
  /** Discount 4 */
  DISCOUNT_4 = "DISCOUNT_4",
  /** Discount 5 */
  DISCOUNT_5 = "DISCOUNT_5",
  /** Ethanol Blends E16-E84 */
  E16_E84 = "E16_E84",
  /** E-85 */
  E85 = "E85",
  /** Enable Device/Handset Unlock */
  ENABLE_HANDSET = "ENABLE_HANDSET",
  /** Engine Service */
  ENGINE_SERVICE = "ENGINE_SERVICE",
  /** <Deprecated> Ethanol (5.7% blend) */
  ETHANOL_57 = "ETHANOL_57",
  /** <Deprecated> Ethanol (7.7% blend) */
  ETHANOL_77 = "ETHANOL_77",
  /** EVC-1 – Level 1 charge = 110v 15 amp */
  EVC_1 = "EVC_1",
  /** EVC-2 – Level 2 charge = 240v 15-40 amp */
  EVC_2 = "EVC_2",
  /** EVC-3 – Level 3 charge = 480v 3 phase charge */
  EVC_3 = "EVC_3",
  /** EV Battery Exchanges */
  EV_BATTERY_ECH = "EV_BATTERY_ECH",
  /** EV Charging Fee */
  EV_CHARGE = "EV_CHARGE",
  /** Exhaust Service */
  EXHAUST_SERVICE = "EXHAUST_SERVICE",
  /** Fee 1 */
  FEE_1 = "FEE_1",
  /** Fee 2 */
  FEE_2 = "FEE_2",
  /** Fee 3 */
  FEE_3 = "FEE_3",
  /** Fee 4 */
  FEE_4 = "FEE_4",
  /** Fee 5 */
  FEE_5 = "FEE_5",
  /** Financial Prepaid Card Activate */
  FIN_PREPAID_ACT = "FIN_PREPAID_ACT",
  /** Financial Prepaid Card Reload */
  FIN_PREPAID_REL = "FIN_PREPAID_REL",
  /** <Deprecated> Flight Planning Fees */
  FLIGHT_PLANNING_FEES = "FLIGHT_PLANNING_FEES",
  /** Flight Plans/Weather Brief */
  FLIGHT_PLANS = "FLIGHT_PLANS",
  /** Flow Fee */
  FLOW_FEE = "FLOW_FEE",
  /** Fluid Milk Products */
  FLUID_MILK = "FLUID_MILK",
  /** Frozen Dispensed Beverages */
  FROZEN_DISPENSED_BEV = "FROZEN_DISPENSED_BEV",
  /** Frozen Foods */
  FROZEN_FOOD = "FROZEN_FOOD",
  /** Fuel System */
  FUEL_SYSTEM = "FUEL_SYSTEM",
  /** General Alcohol */
  GEN_ALCOHOL = "GEN_ALCOHOL",
  /** General Automotive Merchandise */
  GEN_AUTO_MERCH = "GEN_AUTO_MERCH",
  /** General Candy */
  GEN_CANDY = "GEN_CANDY",
  /** General Dairy */
  GEN_DAIRY = "GEN_DAIRY",
  /** General Deli */
  GEN_DELI = "GEN_DELI",
  /** General Dispensed Beverage */
  GEN_DISPENSED_BEV = "GEN_DISPENSED_BEV",
  /** General Foodservice */
  GEN_FOODSERVICE = "GEN_FOODSERVICE",
  /** General Grocery */
  GEN_GROCERY = "GEN_GROCERY",
  /** General Health & Beauty Care */
  GEN_HEALTH = "GEN_HEALTH",
  /** General Ice */
  GEN_ICE = "GEN_ICE",
  /** General Lottery */
  GEN_LOTTERY = "GEN_LOTTERY",
  /** General Merchandise */
  GEN_MERCH = "GEN_MERCH",
  /** General Money Order */
  GEN_MONEY_ORDER = "GEN_MONEY_ORDER",
  /** General Packaged Beverage */
  GEN_PACKAGED_BEV = "GEN_PACKAGED_BEV",
  /** General Publications */
  GEN_PUBLICATIONS = "GEN_PUBLICATIONS",
  /** General Purpose Activate */
  GEN_PURPOSE_ACT = "GEN_PURPOSE_ACT",
  /** General Purpose Reload */
  GEN_PURPOSE_REL = "GEN_PURPOSE_REL",
  /** General Snacks */
  GEN_SNACKS = "GEN_SNACKS",
  /** General Store Service */
  GEN_STORE_SERVICE = "GEN_STORE_SERVICE",
  /** General Tobacco */
  GEN_TOBACCO = "GEN_TOBACCO",
  /** General Undefined – Reserved for Future Use. */
  GEN_UNDEFINED_1 = "GEN_UNDEFINED_1",
  /** General Undefined – Reserved for Future Use. */
  GEN_UNDEFINED_2 = "GEN_UNDEFINED_2",
  /** General Undefined – Reserved for Future Use. */
  GEN_UNDEFINED_3 = "GEN_UNDEFINED_3",
  /** General Undefined – Reserved for Future Use. */
  GEN_UNDEFINED_4 = "GEN_UNDEFINED_4",
  /** General Undefined – Reserved for Future Use. */
  GEN_UNDEFINED_5 = "GEN_UNDEFINED_5",
  /** General Undefined – Reserved for Future Use. */
  GEN_UNDEFINED_6 = "GEN_UNDEFINED_6",
  /** General Undefined – Reserved for Future Use. */
  GEN_UNDEFINED_7 = "GEN_UNDEFINED_7",
  /** General Undefined – Reserved for Future Use. */
  GEN_UNDEFINED_8 = "GEN_UNDEFINED_8",
  /** Ground Equipment Service Fees */
  GES_FEE = "GES_FEE",
  /** Gratuity */
  GRATUITY = "GRATUITY",
  /** Green Gasoline Mid/Plus (Plant based not petroleum based) */
  GREEN_GAS_PLUS = "GREEN_GAS_PLUS",
  /** Green Gasoline Regular (Plant based not petroleum based) */
  GREEN_GAS_REGULAR = "GREEN_GAS_REGULAR",
  /** Green Gasoline Premium/Super (Plant based not petroleum based) */
  GREEN_GAS_SUPER = "GREEN_GAS_SUPER",
  /** Groceries - Edible */
  GROCERY_EDIBLE = "GROCERY_EDIBLE",
  /** Groceries - Non-Edible */
  GROCERY_NON_EDIBLE = "GROCERY_NON_EDIBLE",
  /** Groceries - Perishable */
  GROCERY_PERISHABLE = "GROCERY_PERISHABLE",
  /** GST/HST (Canadian)/VAT 1 */
  GST_HST_VAT_1 = "GST_HST_VAT_1",
  /** Hydrogen H35 */
  H35 = "H35",
  /** Hydrogen H70 */
  H70 = "H70",
  /** Hangar Fee */
  HANGAR_FEE = "HANGAR_FEE",
  /** Heating Oil */
  HEATING_OIL = "HEATING_OIL",
  /** Home Delivery */
  HOME_DELIVERY = "HOME_DELIVERY",
  /** Hoses */
  HOSES = "HOSES",
  /** Hot Dispensed Beverages */
  HOT_DISPENSED_BEV = "HOT_DISPENSED_BEV",
  /** Inspection */
  INSPECTION = "INSPECTION",
  /** Instruction Fee */
  INSTRUCTION_FEE = "INSTRUCTION_FEE",
  /** IT/Bladder */
  IT_BLADDER = "IT_BLADDER",
  /** Jet Federal Excise Tax */
  JET_FD_E_TAX = "JET_FD_E_TAX",
  /** Jet Fuel */
  JET_FUEL = "JET_FUEL",
  /** Kerosene – Low Sulfur */
  KEROSENE = "KEROSENE",
  /** Kerosene – Low Sulfur (Non-Taxable) */
  KEROSENE_LS_NT = "KEROSENE_LS_NT",
  /** Kerosene – Ultra Low Sulfur */
  KEROSENE_ULS = "KEROSENE_ULS",
  /** Kerosene – Ultra Low Sulfur (Non-Taxable) */
  KEROSENE_ULS_NT = "KEROSENE_ULS_NT",
  /** Labor */
  LABOR = "LABOR",
  /** Lamps */
  LAMPS = "LAMPS",
  /** Landing Fee */
  LANDING_FEE = "LANDING_FEE",
  /** Launch Fee */
  LAUNCH_FEE = "LAUNCH_FEE",
  /** Liquor */
  LIQUOR = "LIQUOR",
  /** Liquid Natural Gas */
  LNG = "LNG",
  /** Local Discount 1 */
  LOCAL_DISCOUNT_1 = "LOCAL_DISCOUNT_1",
  /** Local Discount 2 */
  LOCAL_DISCOUNT_2 = "LOCAL_DISCOUNT_2",
  /** Local Discount 3 */
  LOCAL_DISCOUNT_3 = "LOCAL_DISCOUNT_3",
  /** Local Discount 4 */
  LOCAL_DISCOUNT_4 = "LOCAL_DISCOUNT_4",
  /** Local Discount 5 */
  LOCAL_DISCOUNT_5 = "LOCAL_DISCOUNT_5",
  /** Lodging */
  LODGING = "LODGING",
  /** Lottery - Instant */
  LOTTERY_IN = "LOTTERY_IN",
  /** Lottery - Online */
  LOTTERY_ON = "LOTTERY_ON",
  /** Lottery - Other */
  LOTTERY_OTHER = "LOTTERY_OTHER",
  /** Lottery Pay Out - Instant */
  LOTTERY_PO_IN = "LOTTERY_PO_IN",
  /** Lottery Pay Out - Online */
  LOTTERY_PO_ON = "LOTTERY_PO_ON",
  /** Lottery Pay Out - Other */
  LOTTERY_PO_OT = "LOTTERY_PO_OT",
  /** Low Octane UNL */
  LO_UNL = "LO_UNL",
  /** Liquid Propane Gas */
  LPG = "LPG",
  /** Lube */
  LUBE = "LUBE",
  /** <Deprecated> M-85 */
  M85 = "M85",
  /** Marine Diesel */
  MARINE_DIESEL = "MARINE_DIESEL",
  /** Marine Fuel 1 */
  MARINE_FUEL_1 = "MARINE_FUEL_1",
  /** Marine Fuel 2 */
  MARINE_FUEL_2 = "MARINE_FUEL_2",
  /** Marine Fuel 3 */
  MARINE_FUEL_3 = "MARINE_FUEL_3",
  /** Marine Fuel 4 */
  MARINE_FUEL_4 = "MARINE_FUEL_4",
  /** Marine Fuel 5 */
  MARINE_FUEL_5 = "MARINE_FUEL_5",
  /** Marine – Other */
  MARINE_FUEL_OTHER = "MARINE_FUEL_OTHER",
  /** Marine Labor */
  MARINE_LABOR = "MARINE_LABOR",
  /** Marine Service */
  MARINE_SERVICE = "MARINE_SERVICE",
  /** Marine Work Order */
  MARINE_WO = "MARINE_WO",
  /** Membership/Loyalty */
  MEMBERSHIP = "MEMBERSHIP",
  /** Mid/Plus Gasoline */
  MID_PLUS = "MID_PLUS",
  /** Mid/Plus 2 Gasoline */
  MID_PLUS_2 = "MID_PLUS_2",
  /** Mid/Plus 2 (10% Blend) */
  MID_PLUS_2_10 = "MID_PLUS_2_10",
  /** <Deprecated> Mid/Plus Ethanol (5.7% blend) */
  MID_PLUS_ETHANOL_57 = "MID_PLUS_ETHANOL_57",
  /** <Deprecated> Mid/Plus Ethanol (7.7% blend) */
  MID_PLUS_ETHANOL_77 = "MID_PLUS_ETHANOL_77",
  /** <Deprecated> Miscellaneous */
  MISC = "MISC",
  /** Miscellaneous Administrative */
  MISC_ADMIN = "MISC_ADMIN",
  /** Miscellaneous Aviation Fuel */
  MISC_AV_FUEL = "MISC_AV_FUEL",
  /** Miscellaneous Aviation Products/Services */
  MISC_AV_PS = "MISC_AV_PS",
  /** Miscellaneous Aviation Tax */
  MISC_AV_TAX = "MISC_AV_TAX",
  /** Miscellaneous Fuel */
  MISC_FUEL = "MISC_FUEL",
  /** Miscellaneous Marine Fuel */
  MISC_MARINE_FUEL = "MISC_MARINE_FUEL",
  /** Miscellaneous Marine Products/Services */
  MISC_MARINE_PS = "MISC_MARINE_PS",
  /** Miscellaneous Negative Administrative */
  MISC_NEG_ADMIN = "MISC_NEG_ADMIN",
  /** Miscellaneous Other Fuel */
  MISC_OTHER_FUEL = "MISC_OTHER_FUEL",
  /** Miscellaneous Packaged Fuels */
  MISC_PACKAGED_FUEL = "MISC_PACKAGED_FUEL",
  /** Miscellaneous Vehicle Products / Services */
  MISC_VEHICLE_PS = "MISC_VEHICLE_PS",
  /** Money Order - Dividend Check */
  MONEY_ORDER_DC = "MONEY_ORDER_DC",
  /** Money Order - Gift Certificate */
  MONEY_ORDER_GC = "MONEY_ORDER_GC",
  /** Money Order - Official Check */
  MONEY_ORDER_OC = "MONEY_ORDER_OC",
  /** Money Order - Payroll Check */
  MONEY_ORDER_PC = "MONEY_ORDER_PC",
  /** Money Order - Rebate Check */
  MONEY_ORDER_REBC = "MONEY_ORDER_REBC",
  /** Money Order - Refund Check */
  MONEY_ORDER_REFC = "MONEY_ORDER_REFC",
  /** Money Order - Utility Check */
  MONEY_ORDER_UC = "MONEY_ORDER_UC",
  /** Money Order - Vendor Payment */
  MONEY_ORDER_VP = "MONEY_ORDER_VP",
  /** Motor Oil */
  MOTOR_OIL = "MOTOR_OIL",
  /** Multiple Payee Bill Pay */
  MULTI_BILL_PAY = "MULTI_BILL_PAY",
  /** Oil Change */
  OIL_CHANGE = "OIL_CHANGE",
  /** Oil Filter */
  OIL_FILTER = "OIL_FILTER",
  /** Other Dairy */
  OTHER_DAIRY = "OTHER_DAIRY",
  /** Other Dispensed Beverages */
  OTHER_DISPENSED_BEV = "OTHER_DISPENSED_BEV",
  /** Other Fuel (Non-Taxable) */
  OTHER_FUEL_NT = "OTHER_FUEL_NT",
  /** Other Lubricants */
  OTHER_LUBE = "OTHER_LUBE",
  /** Other Packaged Beverages */
  OTHER_PACKAGED_BEV = "OTHER_PACKAGED_BEV",
  /** Overtime Fees */
  OVERTIME_FEE = "OVERTIME_FEE",
  /** Oxygen */
  OXYGEN = "OXYGEN",
  /** Packaged Additive */
  PACKAGED_ADDITIVE = "PACKAGED_ADDITIVE",
  /** Packaged B99 */
  PACKAGED_B99 = "PACKAGED_B99",
  /** Packaged B100 */
  PACKAGED_B100 = "PACKAGED_B100",
  /** Packaged Beverages (non-alcoholic) */
  PACKAGED_BEV_NA = "PACKAGED_BEV_NA",
  /** Bread - Packaged */
  PACKAGED_BREAD = "PACKAGED_BREAD",
  /** Packaged DEF (Diesel Exhaust Fluid) */
  PACKAGED_DEF = "PACKAGED_DEF",
  /** Packaged Sandwiches/Deli Products */
  PACKAGED_DELI = "PACKAGED_DELI",
  /** Packaged Ice Cream/Novelties */
  PACKAGED_ICE_CREAM = "PACKAGED_ICE_CREAM",
  /** Packaged Juice */
  PACKAGED_JUICE = "PACKAGED_JUICE",
  /** Packaged Kerosene */
  PACKAGED_KEROSENE = "PACKAGED_KEROSENE",
  /** Packaged Propane */
  PACKAGED_PROPANE = "PACKAGED_PROPANE",
  /** Pilot Supplies */
  PILOT_SUPPLIES = "PILOT_SUPPLIES",
  /** PIN Activate Prepaid Card */
  PIN_PREPAID_ACT = "PIN_PREPAID_ACT",
  /** PIN Return Prepaid Card */
  PIN_PREPAID_RET = "PIN_PREPAID_RET",
  /** Off-Road Mid/Plus 2 (Non-Taxable) */
  PLUS_2_OR_NT = "PLUS_2_OR_NT",
  /** Mid/Plus Ethanol 2 (15% Blend) */
  PLUS_ETHANOL_2_15 = "PLUS_ETHANOL_2_15",
  /** Mid/Plus Ethanol (10% Blend) */
  PLUS_ETHANOL_10 = "PLUS_ETHANOL_10",
  /** Mid/Plus Ethanol (15% Blend) */
  PLUS_ETHANOL_15 = "PLUS_ETHANOL_15",
  /** Off-Road Mid/Plus (Non-Taxable) */
  PLUS_OR_NT = "PLUS_OR_NT",
  /** POS/Loyalty Reserved Discount 1 */
  POS_RES_DISCOUNT_1 = "POS_RES_DISCOUNT_1",
  /** POS/Loyalty Reserved Discount 2 */
  POS_RES_DISCOUNT_2 = "POS_RES_DISCOUNT_2",
  /** POS/Loyalty Reserved Discount 3 */
  POS_RES_DISCOUNT_3 = "POS_RES_DISCOUNT_3",
  /** POS/Loyalty Reserved Discount 4 */
  POS_RES_DISCOUNT_4 = "POS_RES_DISCOUNT_4",
  /** POS/Loyalty Reserved Discount 5 */
  POS_RES_DISCOUNT_5 = "POS_RES_DISCOUNT_5",
  /** Premium Diesel Blend >= 20% Biodiesel */
  PREMIUM_BIODIESEL_BLEND_OVER_20 = "PREMIUM_BIODIESEL_BLEND_OVER_20",
  /** Premium Diesel Blend <20% Biodiesel */
  PREMIUM_BIODIESEL_BLEND_UNDER_20 = "PREMIUM_BIODIESEL_BLEND_UNDER_20",
  /** Premium Diesel #1 */
  PREMIUM_DIESEL_1 = "PREMIUM_DIESEL_1",
  /** Premium Diesel #2 */
  PREMIUM_DIESEL_2 = "PREMIUM_DIESEL_2",
  /** Premium/Super Gasoline */
  PREMIUM_SUPER = "PREMIUM_SUPER",
  /** Premium/Super 2 Gasoline */
  PREMIUM_SUPER_2 = "PREMIUM_SUPER_2",
  /** Premium/Super 2 (10% Blend) */
  PREMIUM_SUPER_2_10 = "PREMIUM_SUPER_2_10",
  /** <Deprecated> Premium/Super Ethanol (5.7% blend) */
  PREMIUM_SUPER_ETHANOL_57 = "PREMIUM_SUPER_ETHANOL_57",
  /** Prepaid Cards - Activation/Recharge */
  PREPAID_ACT = "PREPAID_ACT",
  /** Prepaid Cards - Purchase */
  PREPAID_PURCHASE = "PREPAID_PURCHASE",
  /** Prepared Foods */
  PREPARED_FOOD = "PREPARED_FOOD",
  /** Preventative Maintenance */
  PREV_MAINTENANCE = "PREV_MAINTENANCE",
  /** Proprietary Prepaid Card Activate */
  PROP_PREPAID_ACT = "PROP_PREPAID_ACT",
  /** Proprietary Prepaid Card Reload */
  PROP_PREPAID_REL = "PROP_PREPAID_REL",
  /** PST/QST (Canadian) VAT 2 */
  PST_HST_VAT_2 = "PST_HST_VAT_2",
  /** Racing Fuel */
  RACING_FUEL = "RACING_FUEL",
  /** Ramp Fees */
  RAMP_FEES = "RAMP_FEES",
  /** Real Time Recharge */
  REAL_TIME_RECHARGE = "REAL_TIME_RECHARGE",
  /** Recreational Fuel (90 Octane) */
  RECREATIONAL_FUEL = "RECREATIONAL_FUEL",
  /** Reformulated 1 */
  REFORMULATED_1 = "REFORMULATED_1",
  /** Reformulated 2 */
  REFORMULATED_2 = "REFORMULATED_2",
  /** Reformulated 3 */
  REFORMULATED_3 = "REFORMULATED_3",
  /** Reformulated 4 */
  REFORMULATED_4 = "REFORMULATED_4",
  /** Reformulated 5 */
  REFORMULATED_5 = "REFORMULATED_5",
  /** Regular Gasoline */
  REGULAR = "REGULAR",
  /** Regular Diesel #1 */
  REGULAR_DIESEL_1 = "REGULAR_DIESEL_1",
  /** Regular Diesel #2 */
  REGULAR_DIESEL_2 = "REGULAR_DIESEL_2",
  /** Regular Ethanol (10% Blend) */
  REGULAR_ETHANOL_10 = "REGULAR_ETHANOL_10",
  /** Regular Ethanol (15% Blend) */
  REGULAR_ETHANOL_15 = "REGULAR_ETHANOL_15",
  /** Off-Road Regular (Non-Taxable) */
  REGULAR_OR_NT = "REGULAR_OR_NT",
  /** Repairs */
  REPAIRS = "REPAIRS",
  /** Re-service */
  RE_SERVICE = "RE_SERVICE",
  /** Road Service */
  ROAD_SERVICE = "ROAD_SERVICE",
  /** RV Dump Fee */
  RV_DUMP_FEE = "RV_DUMP_FEE",
  /** <Deprecated> Sales Tax as Shown for Non-Fuel Products */
  SALES_TAX_NON_FUEL = "SALES_TAX_NON_FUEL",
  /** Salty Snacks */
  SALTY_SNACKS = "SALTY_SNACKS",
  /** Scales */
  SCALES = "SCALES",
  /** Secure Fees */
  SECURE_FEE = "SECURE_FEE",
  /** Service Package */
  SERVICE_PACKAGE = "SERVICE_PACKAGE",
  /** Shower */
  SHOWER = "SHOWER",
  /** Single Payee Bill Pay */
  SINGLE_BILL_PAY = "SINGLE_BILL_PAY",
  /** Slip Rental */
  SLIP_RENTAL = "SLIP_RENTAL",
  /** Soda */
  SODA = "SODA",
  /** Split Tender */
  SPLIT_TENDER = "SPLIT_TENDER",
  /** Static Dissipater Additive */
  STATIC_DISSIPATER_ADDITIVE = "STATIC_DISSIPATER_ADDITIVE",
  /** Storage */
  STORAGE = "STORAGE",
  /** Off-Road Premium/Super 2 (Non-Taxable) */
  SUPER_2_OR_NT = "SUPER_2_OR_NT",
  /** Premium/Super Ethanol 2 (15% Blend) */
  SUPER_ETHANOL_2_15 = "SUPER_ETHANOL_2_15",
  /** Premium/Super Ethanol (10% Blend) */
  SUPER_ETHANOL_10 = "SUPER_ETHANOL_10",
  /** Premium/Super Ethanol (15% Blend) */
  SUPER_ETHANOL_15 = "SUPER_ETHANOL_15",
  /** Off-Road Premium/Super (Non-Taxable) */
  SUPER_OR_NT = "SUPER_OR_NT",
  /** Sweet Snacks - Packaged */
  SWEET_SNACKS = "SWEET_SNACKS",
  /** SWT Rate (Canadian) */
  SWT_RATE = "SWT_RATE",
  /** Synthetic Oil */
  SYNTHETIC_OIL = "SYNTHETIC_OIL",
  /** Tax 1 */
  TAX_1 = "TAX_1",
  /** Tax 2 */
  TAX_2 = "TAX_2",
  /** Tax 3 */
  TAX_3 = "TAX_3",
  /** Tax 4 */
  TAX_4 = "TAX_4",
  /** Tax 5 */
  TAX_5 = "TAX_5",
  /** Tax 6 */
  TAX_6 = "TAX_6",
  /** Tax 7 */
  TAX_7 = "TAX_7",
  /** Tax 8 */
  TAX_8 = "TAX_8",
  /** Tax Discount/Forgiven */
  TAX_DISCOUNT_F = "TAX_DISCOUNT_F",
  /** 3rd Party Prepaid Card Activate */
  THIRD_PARTY_PREPAID_ACT = "THIRD_PARTY_PREPAID_ACT",
  /** 3rd Party Prepaid Card Reload */
  THIRD_PARTY_PREPAID_REL = "THIRD_PARTY_PREPAID_REL",
  /** Tires */
  TIRES = "TIRES",
  /** <Deprecated> Tires, Batteries, and Accessories */
  TIRES_BATTERIES_ACCESSORIES = "TIRES_BATTERIES_ACCESSORIES",
  /** Federal Excise Tax (Tires) */
  TIRES_FET = "TIRES_FET",
  /** Tire-related (Wheel Balance, Valve Stem) */
  TIRE_RELATED = "TIRE_RELATED",
  /** Tire Repair */
  TIRE_REPAIR = "TIRE_REPAIR",
  /** Tire Rotation */
  TIRE_ROTATION = "TIRE_ROTATION",
  /** Tobacco - Other */
  TOBACCO_OTHER = "TOBACCO_OTHER",
  /** Toll Payments */
  TOLL = "TOLL",
  /** Towing */
  TOWING = "TOWING",
  /** Trailer Wash */
  TRAILER_WASH = "TRAILER_WASH",
  /** Transmission Service */
  TRANSMISSION_SERVICE = "TRANSMISSION_SERVICE",
  /** Transportation */
  TRANSPORTATION = "TRANSPORTATION",
  /** Truck Tank Cleaning */
  TRUNK_TANK_CLEANING = "TRUNK_TANK_CLEANING",
  /** <Deprecated> Ultra Low Sulfur #1 */
  ULTRA_LOW_SULFUR_1 = "ULTRA_LOW_SULFUR_1",
  /** <Deprecated> Ultra Low Sulfur #2 */
  ULTRA_LOW_SULFUR_2 = "ULTRA_LOW_SULFUR_2",
  /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 2% */
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_2 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_2",
  /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 5% */
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_5 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_5",
  /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 10% */
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_10 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_10",
  /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 11% */
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_11 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_11",
  /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 15% */
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_15 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_15",
  /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 20% */
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_20 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_20",
  /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 100% */
  ULTRA_LOW_SULFUR_BIODIESEL_BLEND_100 = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_100",
  /** <Deprecated> Ultra Low Sulfur Premium Diesel #2 */
  ULTRA_LOW_SULFUR_PREMIUM_1 = "ULTRA_LOW_SULFUR_PREMIUM_1",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_1 = "UNASSIGNED_1",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_2 = "UNASSIGNED_2",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_3 = "UNASSIGNED_3",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_4 = "UNASSIGNED_4",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_5 = "UNASSIGNED_5",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_6 = "UNASSIGNED_6",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_7 = "UNASSIGNED_7",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_8 = "UNASSIGNED_8",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_9 = "UNASSIGNED_9",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_10 = "UNASSIGNED_10",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_11 = "UNASSIGNED_11",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_12 = "UNASSIGNED_12",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_13 = "UNASSIGNED_13",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_14 = "UNASSIGNED_14",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_15 = "UNASSIGNED_15",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_16 = "UNASSIGNED_16",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_17 = "UNASSIGNED_17",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_18 = "UNASSIGNED_18",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_19 = "UNASSIGNED_19",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_20 = "UNASSIGNED_20",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_21 = "UNASSIGNED_21",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_22 = "UNASSIGNED_22",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_23 = "UNASSIGNED_23",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_24 = "UNASSIGNED_24",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_25 = "UNASSIGNED_25",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_26 = "UNASSIGNED_26",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_27 = "UNASSIGNED_27",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_28 = "UNASSIGNED_28",
  /** Unassigned. Reserved for Future Use. */
  UNASSIGNED_29 = "UNASSIGNED_29",
  /** Unassigned. Reserved for Future Use */
  UNASSIGNED_30 = "UNASSIGNED_30",
  /** Unassigned. Reserved for Future Use */
  UNASSIGNED_31 = "UNASSIGNED_31",
  /** Unassigned. Reserved for Future Use */
  UNASSIGNED_32 = "UNASSIGNED_32",
  /** Unassigned. Reserved for Future Use */
  UNASSIGNED_33 = "UNASSIGNED_33",
  /** Unassigned. Reserved for Future Use */
  UNASSIGNED_34 = "UNASSIGNED_34",
  /** Unassigned. Reserved for Future Use */
  UNASSIGNED_35 = "UNASSIGNED_35",
  /** Unassigned. Reserved for Future Use */
  UNASSIGNED_36 = "UNASSIGNED_36",
  /** Unassigned. Reserved for Future Use */
  UNASSIGNED_37 = "UNASSIGNED_37",
  /** Unassigned Automotive Products and Services */
  UNASSIGNED_AUTO_PS_1 = "UNASSIGNED_AUTO_PS_1",
  /** Unassigned Automotive Products and Services */
  UNASSIGNED_AUTO_PS_2 = "UNASSIGNED_AUTO_PS_2",
  /** Unassigned Automotive Products and Services */
  UNASSIGNED_AUTO_PS_3 = "UNASSIGNED_AUTO_PS_3",
  /** Unassigned Automotive Products and Services */
  UNASSIGNED_AUTO_PS_4 = "UNASSIGNED_AUTO_PS_4",
  /** Unassigned Beverage Items - Reserved for Future Use */
  UNASSIGNED_BEV_1 = "UNASSIGNED_BEV_1",
  /** Unassigned Beverage Items - Reserved for Future Use */
  UNASSIGNED_BEV_2 = "UNASSIGNED_BEV_2",
  /** Unassigned Beverage Items - Reserved for Future Use */
  UNASSIGNED_BEV_3 = "UNASSIGNED_BEV_3",
  /** Unassigned Beverage Items - Reserved for Future Use */
  UNASSIGNED_BEV_4 = "UNASSIGNED_BEV_4",
  /** Unassigned Beverage Items - Reserved for Future Use */
  UNASSIGNED_BEV_5 = "UNASSIGNED_BEV_5",
  /** Unassigned Beverage Items - Reserved for Future Use */
  UNASSIGNED_BEV_6 = "UNASSIGNED_BEV_6",
  /** Unassigned Beverage Items - Reserved for Future Use */
  UNASSIGNED_BEV_7 = "UNASSIGNED_BEV_7",
  /** Unassigned Food and Grocery Items */
  UNASSIGNED_GROCERY_1 = "UNASSIGNED_GROCERY_1",
  /** Unassigned Food and Grocery Items */
  UNASSIGNED_GROCERY_2 = "UNASSIGNED_GROCERY_2",
  /** Unassigned Food and Grocery Items */
  UNASSIGNED_GROCERY_3 = "UNASSIGNED_GROCERY_3",
  /** Unassigned Food and Grocery Items */
  UNASSIGNED_GROCERY_4 = "UNASSIGNED_GROCERY_4",
  /** Unassigned Food and Grocery Items */
  UNASSIGNED_GROCERY_5 = "UNASSIGNED_GROCERY_5",
  /** Unassigned Food and Grocery Items */
  UNASSIGNED_GROCERY_6 = "UNASSIGNED_GROCERY_6",
  /** Unassigned Repair Value - Reserved for Future Use */
  UNASSIGNED_REPAIR_1 = "UNASSIGNED_REPAIR_1",
  /** Unassigned Repair Value - Reserved for Future Use */
  UNASSIGNED_REPAIR_2 = "UNASSIGNED_REPAIR_2",
  /** Unassigned Repair Value - Reserved for Future Use */
  UNASSIGNED_REPAIR_3 = "UNASSIGNED_REPAIR_3",
  /** Unassigned Repair Value - Reserved for Future Use */
  UNASSIGNED_REPAIR_4 = "UNASSIGNED_REPAIR_4",
  /** Undefined Alcohol - Reserved for Future Use */
  UNDEFINED_ALCOHOL_1 = "UNDEFINED_ALCOHOL_1",
  /** Undefined Alcohol - Reserved for Future Use */
  UNDEFINED_ALCOHOL_2 = "UNDEFINED_ALCOHOL_2",
  /** Undefined Alcohol - Reserved for Future Use */
  UNDEFINED_ALCOHOL_3 = "UNDEFINED_ALCOHOL_3",
  /** Undefined Alcohol - Reserved for Future Use */
  UNDEFINED_ALCOHOL_4 = "UNDEFINED_ALCOHOL_4",
  /** Undefined Alcohol - Reserved for Future Use */
  UNDEFINED_ALCOHOL_5 = "UNDEFINED_ALCOHOL_5",
  /** Undefined Administrative – Reserved for Future Use. */
  UNDEFINED_AMIN_1 = "UNDEFINED_AMIN_1",
  /** Undefined Administrative – Reserved for Future Use. */
  UNDEFINED_AMIN_2 = "UNDEFINED_AMIN_2",
  /** Undefined Administrative – Reserved for Future Use. */
  UNDEFINED_AMIN_3 = "UNDEFINED_AMIN_3",
  /** Undefined Administrative – Reserved for Future Use. */
  UNDEFINED_AMIN_4 = "UNDEFINED_AMIN_4",
  /** Undefined Administrative – Reserved for Future Use. */
  UNDEFINED_AMIN_5 = "UNDEFINED_AMIN_5",
  /** Undefined Administrative – Reserved for Future Use. */
  UNDEFINED_AMIN_6 = "UNDEFINED_AMIN_6",
  /** Undefined Administrative – Reserved for Future Use. */
  UNDEFINED_AMIN_7 = "UNDEFINED_AMIN_7",
  /** Undefined Administrative – Reserved for Future Use. */
  UNDEFINED_AMIN_8 = "UNDEFINED_AMIN_8",
  /** Undefined Administrative – Reserved for Future Use. */
  UNDEFINED_AMIN_9 = "UNDEFINED_AMIN_9",
  /** Undefined Administrative – Reserved for Future Use. */
  UNDEFINED_AMIN_10 = "UNDEFINED_AMIN_10",
  /** Undefined Administrative – Reserved for Future Use. */
  UNDEFINED_AMIN_11 = "UNDEFINED_AMIN_11",
  /** Undefined Administrative – Reserved for Future Use. */
  UNDEFINED_AMIN_12 = "UNDEFINED_AMIN_12",
  /** Undefined Administrative – Reserved for Future Use. */
  UNDEFINED_AMIN_13 = "UNDEFINED_AMIN_13",
  /** Undefined Administrative – Reserved for Future Use. */
  UNDEFINED_AMIN_14 = "UNDEFINED_AMIN_14",
  /** Undefined Administrative – Reserved for Future Use. */
  UNDEFINED_AMIN_15 = "UNDEFINED_AMIN_15",
  /** Undefined Administrative – Reserved for Future Use. */
  UNDEFINED_AMIN_16 = "UNDEFINED_AMIN_16",
  /** Undefined Administrative – Reserved for Future Use. */
  UNDEFINED_AMIN_17 = "UNDEFINED_AMIN_17",
  /** Undefined Administrative – Reserved for Future Use. */
  UNDEFINED_AMIN_18 = "UNDEFINED_AMIN_18",
  /** Undefined Administrative – Reserved for Future Use. */
  UNDEFINED_AMIN_19 = "UNDEFINED_AMIN_19",
  /** Undefined Administrative – Reserved for Future Use. */
  UNDEFINED_AMIN_20 = "UNDEFINED_AMIN_20",
  /** Undefined Administrative – Reserved for Future Use. */
  UNDEFINED_AMIN_21 = "UNDEFINED_AMIN_21",
  /** Undefined Administrative – Reserved for Future Use. */
  UNDEFINED_AMIN_22 = "UNDEFINED_AMIN_22",
  /** Undefined Administrative – Reserved for Future Use. */
  UNDEFINED_AMIN_23 = "UNDEFINED_AMIN_23",
  /** Undefined Administrative – Reserved for Future Use. */
  UNDEFINED_AMIN_24 = "UNDEFINED_AMIN_24",
  /** Undefined Administrative – Reserved for Future Use. */
  UNDEFINED_AMIN_25 = "UNDEFINED_AMIN_25",
  /** Undefined Administrative – Reserved for Future Use. */
  UNDEFINED_AMIN_26 = "UNDEFINED_AMIN_26",
  /** Undefined Aviation - Reserved for Future Use. */
  UNDEFINED_AVIATION_1 = "UNDEFINED_AVIATION_1",
  /** Undefined Aviation - Reserved for Future Use. */
  UNDEFINED_AVIATION_2 = "UNDEFINED_AVIATION_2",
  /** Undefined Aviation - Reserved for Future Use. */
  UNDEFINED_AVIATION_3 = "UNDEFINED_AVIATION_3",
  /** Undefined Aviation - Reserved for Future Use. */
  UNDEFINED_AVIATION_4 = "UNDEFINED_AVIATION_4",
  /** Undefined Aviation - Reserved for Future Use. */
  UNDEFINED_AVIATION_5 = "UNDEFINED_AVIATION_5",
  /** Undefined Aviation - Reserved for Future Use. */
  UNDEFINED_AVIATION_6 = "UNDEFINED_AVIATION_6",
  /** Undefined Aviation - Reserved for Future Use. */
  UNDEFINED_AVIATION_7 = "UNDEFINED_AVIATION_7",
  /** Undefined Aviation - Reserved for Future Use. */
  UNDEFINED_AVIATION_8 = "UNDEFINED_AVIATION_8",
  /** Undefined Aviation - Reserved for Future Use. */
  UNDEFINED_AVIATION_9 = "UNDEFINED_AVIATION_9",
  /** Undefined Aviation - Reserved for Future Use. */
  UNDEFINED_AVIATION_10 = "UNDEFINED_AVIATION_10",
  /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */
  UNDEFINED_BILL_PAY_1 = "UNDEFINED_BILL_PAY_1",
  /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */
  UNDEFINED_BILL_PAY_2 = "UNDEFINED_BILL_PAY_2",
  /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */
  UNDEFINED_BILL_PAY_3 = "UNDEFINED_BILL_PAY_3",
  /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */
  UNDEFINED_BILL_PAY_4 = "UNDEFINED_BILL_PAY_4",
  /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */
  UNDEFINED_BILL_PAY_5 = "UNDEFINED_BILL_PAY_5",
  /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */
  UNDEFINED_BILL_PAY_6 = "UNDEFINED_BILL_PAY_6",
  /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */
  UNDEFINED_BILL_PAY_7 = "UNDEFINED_BILL_PAY_7",
  /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */
  UNDEFINED_BILL_PAY_8 = "UNDEFINED_BILL_PAY_8",
  /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */
  UNDEFINED_BILL_PAY_9 = "UNDEFINED_BILL_PAY_9",
  /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */
  UNDEFINED_BILL_PAY_10 = "UNDEFINED_BILL_PAY_10",
  /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */
  UNDEFINED_BILL_PAY_11 = "UNDEFINED_BILL_PAY_11",
  /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */
  UNDEFINED_BILL_PAY_12 = "UNDEFINED_BILL_PAY_12",
  /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */
  UNDEFINED_BILL_PAY_13 = "UNDEFINED_BILL_PAY_13",
  /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */
  UNDEFINED_BILL_PAY_14 = "UNDEFINED_BILL_PAY_14",
  /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */
  UNDEFINED_BILL_PAY_15 = "UNDEFINED_BILL_PAY_15",
  /** Undefined Candy - Reserved for Future Use. */
  UNDEFINED_CANDY_1 = "UNDEFINED_CANDY_1",
  /** Undefined Candy - Reserved for Future Use. */
  UNDEFINED_CANDY_2 = "UNDEFINED_CANDY_2",
  /** Undefined Candy - Reserved for Future Use. */
  UNDEFINED_CANDY_3 = "UNDEFINED_CANDY_3",
  /** Undefined Candy - Reserved for Future Use. */
  UNDEFINED_CANDY_4 = "UNDEFINED_CANDY_4",
  /** Undefined Candy - Reserved for Future Use. */
  UNDEFINED_CANDY_5 = "UNDEFINED_CANDY_5",
  /** Undefined Candy - Reserved for Future Use. */
  UNDEFINED_CANDY_6 = "UNDEFINED_CANDY_6",
  /** Undefined Candy - Reserved for Future Use. */
  UNDEFINED_CANDY_7 = "UNDEFINED_CANDY_7",
  /** Undefined Candy - Reserved for Future Use. */
  UNDEFINED_CANDY_8 = "UNDEFINED_CANDY_8",
  /** Undefined Candy - Reserved for Future Use. */
  UNDEFINED_CANDY_9 = "UNDEFINED_CANDY_9",
  /** Undefined Cannabinoid – Reserved for Future Use. */
  UNDEFINED_CBD_1 = "UNDEFINED_CBD_1",
  /** Undefined Cannabinoid – Reserved for Future Use. */
  UNDEFINED_CBD_2 = "UNDEFINED_CBD_2",
  /** Undefined Cannabinoid – Reserved for Future Use. */
  UNDEFINED_CBD_3 = "UNDEFINED_CBD_3",
  /** Undefined Cannabinoid – Reserved for Future Use. */
  UNDEFINED_CBD_4 = "UNDEFINED_CBD_4",
  /** Undefined Cannabinoid – Reserved for Future Use. */
  UNDEFINED_CBD_5 = "UNDEFINED_CBD_5",
  /** Undefined Cannabinoid – Reserved for Future Use. */
  UNDEFINED_CBD_6 = "UNDEFINED_CBD_6",
  /** Undefined Cannabinoid – Reserved for Future Use. */
  UNDEFINED_CBD_7 = "UNDEFINED_CBD_7",
  /** Undefined Cannabinoid – Reserved for Future Use. */
  UNDEFINED_CBD_8 = "UNDEFINED_CBD_8",
  /** Undefined Cannabinoid – Reserved for Future Use. */
  UNDEFINED_CBD_9 = "UNDEFINED_CBD_9",
  /** Undefined Cannabinoid – Reserved for Future Use. */
  UNDEFINED_CBD_10 = "UNDEFINED_CBD_10",
  /** Undefined Cannabinoid – Reserved for Future Use. */
  UNDEFINED_CBD_11 = "UNDEFINED_CBD_11",
  /** Undefined Cannabinoid – Reserved for Future Use. */
  UNDEFINED_CBD_12 = "UNDEFINED_CBD_12",
  /** Undefined Cannabinoid – Reserved for Future Use. */
  UNDEFINED_CBD_13 = "UNDEFINED_CBD_13",
  /** Undefined Cannabinoid – Reserved for Future Use. */
  UNDEFINED_CBD_14 = "UNDEFINED_CBD_14",
  /** Undefined Cannabinoid – Reserved for Future Use. */
  UNDEFINED_CBD_15 = "UNDEFINED_CBD_15",
  /** Undefined Cannabinoid – Reserved for Future Use. */
  UNDEFINED_CBD_16 = "UNDEFINED_CBD_16",
  /** Undefined Cannabinoid – Reserved for Future Use. */
  UNDEFINED_CBD_17 = "UNDEFINED_CBD_17",
  /** Undefined Cannabinoid – Reserved for Future Use. */
  UNDEFINED_CBD_18 = "UNDEFINED_CBD_18",
  /** Undefined Cannabinoid – Reserved for Future Use. */
  UNDEFINED_CBD_19 = "UNDEFINED_CBD_19",
  /** Undefined Dairy - Reserved for Future Use */
  UNDEFINED_DAIRY_1 = "UNDEFINED_DAIRY_1",
  /** Undefined Dairy - Reserved for Future Use */
  UNDEFINED_DAIRY_2 = "UNDEFINED_DAIRY_2",
  /** Undefined Dairy - Reserved for Future Use */
  UNDEFINED_DAIRY_3 = "UNDEFINED_DAIRY_3",
  /** Undefined Dairy - Reserved for Future Use */
  UNDEFINED_DAIRY_4 = "UNDEFINED_DAIRY_4",
  /** Undefined Dairy - Reserved for Future Use */
  UNDEFINED_DAIRY_5 = "UNDEFINED_DAIRY_5",
  /** Undefined Dairy - Reserved for Future Use */
  UNDEFINED_DAIRY_6 = "UNDEFINED_DAIRY_6",
  /** Undefined Deli - Reserved for Future Use */
  UNDEFINED_DELI_1 = "UNDEFINED_DELI_1",
  /** Undefined Deli - Reserved for Future Use */
  UNDEFINED_DELI_2 = "UNDEFINED_DELI_2",
  /** Undefined Deli - Reserved for Future Use */
  UNDEFINED_DELI_3 = "UNDEFINED_DELI_3",
  /** Undefined Deli - Reserved for Future Use */
  UNDEFINED_DELI_4 = "UNDEFINED_DELI_4",
  /** Undefined Deli - Reserved for Future Use */
  UNDEFINED_DELI_5 = "UNDEFINED_DELI_5",
  /** Undefined Deli - Reserved for Future Use */
  UNDEFINED_DELI_6 = "UNDEFINED_DELI_6",
  /** Undefined Dispensed Beverages - Reserved for Future Use */
  UNDEFINED_DISPENSED_BEV_1 = "UNDEFINED_DISPENSED_BEV_1",
  /** Undefined Dispensed Beverages - Reserved for Future Use */
  UNDEFINED_DISPENSED_BEV_2 = "UNDEFINED_DISPENSED_BEV_2",
  /** Undefined Dispensed Beverages - Reserved for Future Use */
  UNDEFINED_DISPENSED_BEV_3 = "UNDEFINED_DISPENSED_BEV_3",
  /** Undefined Dispensed Beverages - Reserved for Future Use */
  UNDEFINED_DISPENSED_BEV_4 = "UNDEFINED_DISPENSED_BEV_4",
  /** Undefined Dispensed Beverages - Reserved for Future Use */
  UNDEFINED_DISPENSED_BEV_5 = "UNDEFINED_DISPENSED_BEV_5",
  /** Undefined Foodservice – Reserved for Future Use. */
  UNDEFINED_FOODSERVICE_1 = "UNDEFINED_FOODSERVICE_1",
  /** Undefined Foodservice – Reserved for Future Use. */
  UNDEFINED_FOODSERVICE_2 = "UNDEFINED_FOODSERVICE_2",
  /** Undefined Foodservice – Reserved for Future Use. */
  UNDEFINED_FOODSERVICE_3 = "UNDEFINED_FOODSERVICE_3",
  /** Undefined Foodservice – Reserved for Future Use. */
  UNDEFINED_FOODSERVICE_4 = "UNDEFINED_FOODSERVICE_4",
  /** Undefined Foodservice – Reserved for Future Use. */
  UNDEFINED_FOODSERVICE_5 = "UNDEFINED_FOODSERVICE_5",
  /** Undefined Foodservice – Reserved for Future Use. */
  UNDEFINED_FOODSERVICE_6 = "UNDEFINED_FOODSERVICE_6",
  /** Undefined Foodservice – Reserved for Future Use. */
  UNDEFINED_FOODSERVICE_7 = "UNDEFINED_FOODSERVICE_7",
  /** Undefined Foodservice – Reserved for Future Use. */
  UNDEFINED_FOODSERVICE_8 = "UNDEFINED_FOODSERVICE_8",
  /** Undefined Foodservice – Reserved for Future Use. */
  UNDEFINED_FOODSERVICE_9 = "UNDEFINED_FOODSERVICE_9",
  /** Undefined Grocery - Reserved for Future Use */
  UNDEFINED_GROCERY_1 = "UNDEFINED_GROCERY_1",
  /** Undefined Grocery - Reserved for Future Use */
  UNDEFINED_GROCERY_2 = "UNDEFINED_GROCERY_2",
  /** Undefined Grocery - Reserved for Future Use */
  UNDEFINED_GROCERY_3 = "UNDEFINED_GROCERY_3",
  /** Undefined Grocery - Reserved for Future Use */
  UNDEFINED_GROCERY_4 = "UNDEFINED_GROCERY_4",
  /** Undefined Health & Beauty Care – Reserved for Future Use. */
  UNDEFINED_HEALTH_1 = "UNDEFINED_HEALTH_1",
  /** Undefined Health & Beauty Care – Reserved for Future Use. */
  UNDEFINED_HEALTH_2 = "UNDEFINED_HEALTH_2",
  /** Undefined Health & Beauty Care – Reserved for Future Use. */
  UNDEFINED_HEALTH_3 = "UNDEFINED_HEALTH_3",
  /** Undefined Health & Beauty Care – Reserved for Future Use. */
  UNDEFINED_HEALTH_4 = "UNDEFINED_HEALTH_4",
  /** Undefined Health & Beauty Care – Reserved for Future Use. */
  UNDEFINED_HEALTH_5 = "UNDEFINED_HEALTH_5",
  /** Undefined Health & Beauty Care – Reserved for Future Use. */
  UNDEFINED_HEALTH_6 = "UNDEFINED_HEALTH_6",
  /** Undefined Health & Beauty Care – Reserved for Future Use. */
  UNDEFINED_HEALTH_7 = "UNDEFINED_HEALTH_7",
  /** Undefined Health & Beauty Care – Reserved for Future Use. */
  UNDEFINED_HEALTH_8 = "UNDEFINED_HEALTH_8",
  /** Undefined Health & Beauty Care – Reserved for Future Use. */
  UNDEFINED_HEALTH_9 = "UNDEFINED_HEALTH_9",
  /** Undefined Lottery - Reserved for Future Use */
  UNDEFINED_LOTTERY_1 = "UNDEFINED_LOTTERY_1",
  /** Undefined Lottery - Reserved for Future Use */
  UNDEFINED_LOTTERY_2 = "UNDEFINED_LOTTERY_2",
  /** Undefined Lottery - Reserved for Future Use */
  UNDEFINED_LOTTERY_3 = "UNDEFINED_LOTTERY_3",
  /** Undefined Lottery - Reserved for Future Use */
  UNDEFINED_LOTTERY_4 = "UNDEFINED_LOTTERY_4",
  /** Undefined Lottery - Reserved for Future Use */
  UNDEFINED_LOTTERY_5 = "UNDEFINED_LOTTERY_5",
  /** Undefined Lottery - Reserved for Future Use */
  UNDEFINED_LOTTERY_6 = "UNDEFINED_LOTTERY_6",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_1 = "UNDEFINED_MARINE_SERVICES_1",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_2 = "UNDEFINED_MARINE_SERVICES_2",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_3 = "UNDEFINED_MARINE_SERVICES_3",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_4 = "UNDEFINED_MARINE_SERVICES_4",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_5 = "UNDEFINED_MARINE_SERVICES_5",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_6 = "UNDEFINED_MARINE_SERVICES_6",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_7 = "UNDEFINED_MARINE_SERVICES_7",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_8 = "UNDEFINED_MARINE_SERVICES_8",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_9 = "UNDEFINED_MARINE_SERVICES_9",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_10 = "UNDEFINED_MARINE_SERVICES_10",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_11 = "UNDEFINED_MARINE_SERVICES_11",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_12 = "UNDEFINED_MARINE_SERVICES_12",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_13 = "UNDEFINED_MARINE_SERVICES_13",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_14 = "UNDEFINED_MARINE_SERVICES_14",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_15 = "UNDEFINED_MARINE_SERVICES_15",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_16 = "UNDEFINED_MARINE_SERVICES_16",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_17 = "UNDEFINED_MARINE_SERVICES_17",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_18 = "UNDEFINED_MARINE_SERVICES_18",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_19 = "UNDEFINED_MARINE_SERVICES_19",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_20 = "UNDEFINED_MARINE_SERVICES_20",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_21 = "UNDEFINED_MARINE_SERVICES_21",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_22 = "UNDEFINED_MARINE_SERVICES_22",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_23 = "UNDEFINED_MARINE_SERVICES_23",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_24 = "UNDEFINED_MARINE_SERVICES_24",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_25 = "UNDEFINED_MARINE_SERVICES_25",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_26 = "UNDEFINED_MARINE_SERVICES_26",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_27 = "UNDEFINED_MARINE_SERVICES_27",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_28 = "UNDEFINED_MARINE_SERVICES_28",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_29 = "UNDEFINED_MARINE_SERVICES_29",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_30 = "UNDEFINED_MARINE_SERVICES_30",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_31 = "UNDEFINED_MARINE_SERVICES_31",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_32 = "UNDEFINED_MARINE_SERVICES_32",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_33 = "UNDEFINED_MARINE_SERVICES_33",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_34 = "UNDEFINED_MARINE_SERVICES_34",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_35 = "UNDEFINED_MARINE_SERVICES_35",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_36 = "UNDEFINED_MARINE_SERVICES_36",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_37 = "UNDEFINED_MARINE_SERVICES_37",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_38 = "UNDEFINED_MARINE_SERVICES_38",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_39 = "UNDEFINED_MARINE_SERVICES_39",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_40 = "UNDEFINED_MARINE_SERVICES_40",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_41 = "UNDEFINED_MARINE_SERVICES_41",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_42 = "UNDEFINED_MARINE_SERVICES_42",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_43 = "UNDEFINED_MARINE_SERVICES_43",
  /** Undefined Marine Services – Reserved for Future Use. */
  UNDEFINED_MARINE_SERVICES_44 = "UNDEFINED_MARINE_SERVICES_44",
  /** Undefined Merchandise – Reserved for Future Use. */
  UNDEFINED_MERCHANDISE_1 = "UNDEFINED_MERCHANDISE_1",
  /** Undefined Merchandise – Reserved for Future Use. */
  UNDEFINED_MERCHANDISE_2 = "UNDEFINED_MERCHANDISE_2",
  /** Undefined Merchandise – Reserved for Future Use. */
  UNDEFINED_MERCHANDISE_3 = "UNDEFINED_MERCHANDISE_3",
  /** Undefined Merchandise – Reserved for Future Use. */
  UNDEFINED_MERCHANDISE_4 = "UNDEFINED_MERCHANDISE_4",
  /** Undefined Merchandise – Reserved for Future Use. */
  UNDEFINED_MERCHANDISE_5 = "UNDEFINED_MERCHANDISE_5",
  /** Undefined Merchandise – Reserved for Future Use. */
  UNDEFINED_MERCHANDISE_6 = "UNDEFINED_MERCHANDISE_6",
  /** Undefined Merchandise – Reserved for Future Use. */
  UNDEFINED_MERCHANDISE_7 = "UNDEFINED_MERCHANDISE_7",
  /** Undefined Merchandise – Reserved for Future Use. */
  UNDEFINED_MERCHANDISE_8 = "UNDEFINED_MERCHANDISE_8",
  /** Undefined Merchandise – Reserved for Future Use. */
  UNDEFINED_MERCHANDISE_9 = "UNDEFINED_MERCHANDISE_9",
  /** Undefined Money Order - Reserved for Future Use */
  UNDEFINED_MONEY_ORDER = "UNDEFINED_MONEY_ORDER",
  /** Undefined Negative – Reserved for Future Use. */
  UNDEFINED_NEG_1 = "UNDEFINED_NEG_1",
  /** Undefined Negative – Reserved for Future Use. */
  UNDEFINED_NEG_2 = "UNDEFINED_NEG_2",
  /** Undefined Negative – Reserved for Future Use. */
  UNDEFINED_NEG_3 = "UNDEFINED_NEG_3",
  /** Undefined Negative – Reserved for Future Use. */
  UNDEFINED_NEG_4 = "UNDEFINED_NEG_4",
  /** Undefined Negative – Reserved for Future Use. */
  UNDEFINED_NEG_5 = "UNDEFINED_NEG_5",
  /** Undefined Negative – Reserved for Future Use. */
  UNDEFINED_NEG_6 = "UNDEFINED_NEG_6",
  /** Undefined Negative – Reserved for Future Use. */
  UNDEFINED_NEG_7 = "UNDEFINED_NEG_7",
  /** Undefined Negative – Reserved for Future Use. */
  UNDEFINED_NEG_8 = "UNDEFINED_NEG_8",
  /** Undefined Negative – Reserved for Future Use. */
  UNDEFINED_NEG_9 = "UNDEFINED_NEG_9",
  /** Undefined Negative – Reserved for Future Use. */
  UNDEFINED_NEG_10 = "UNDEFINED_NEG_10",
  /** Undefined Negative – Reserved for Future Use. */
  UNDEFINED_NEG_11 = "UNDEFINED_NEG_11",
  /** Undefined Negative – Reserved for Future Use. */
  UNDEFINED_NEG_12 = "UNDEFINED_NEG_12",
  /** Undefined Negative – Reserved for Future Use. */
  UNDEFINED_NEG_13 = "UNDEFINED_NEG_13",
  /** Undefined Negative – Reserved for Future Use. */
  UNDEFINED_NEG_14 = "UNDEFINED_NEG_14",
  /** Undefined Negative – Reserved for Future Use. */
  UNDEFINED_NEG_15 = "UNDEFINED_NEG_15",
  /** Undefined Negative – Reserved for Future Use. */
  UNDEFINED_NEG_16 = "UNDEFINED_NEG_16",
  /** Undefined Negative – Reserved for Future Use. */
  UNDEFINED_NEG_17 = "UNDEFINED_NEG_17",
  /** Undefined Negative – Reserved for Future Use. */
  UNDEFINED_NEG_18 = "UNDEFINED_NEG_18",
  /** Undefined Negative – Reserved for Future Use. */
  UNDEFINED_NEG_19 = "UNDEFINED_NEG_19",
  /** Undefined Negative – Reserved for Future Use. */
  UNDEFINED_NEG_20 = "UNDEFINED_NEG_20",
  /** Undefined Negative – Reserved for Future Use. */
  UNDEFINED_NEG_21 = "UNDEFINED_NEG_21",
  /** Undefined Negative – Reserved for Future Use. */
  UNDEFINED_NEG_22 = "UNDEFINED_NEG_22",
  /** Undefined Negative – Reserved for Future Use. */
  UNDEFINED_NEG_23 = "UNDEFINED_NEG_23",
  /** Undefined Negative – Reserved for Future Use. */
  UNDEFINED_NEG_24 = "UNDEFINED_NEG_24",
  /** Undefined Packaged Beverages - Reserved for Future Use */
  UNDEFINED_PACKAGED_BEV_1 = "UNDEFINED_PACKAGED_BEV_1",
  /** Undefined Packaged Beverages - Reserved for Future Use */
  UNDEFINED_PACKAGED_BEV_2 = "UNDEFINED_PACKAGED_BEV_2",
  /** Undefined Packaged Beverages - Reserved for Future Use */
  UNDEFINED_PACKAGED_BEV_3 = "UNDEFINED_PACKAGED_BEV_3",
  /** Undefined Packaged Beverages - Reserved for Future Use */
  UNDEFINED_PACKAGED_BEV_4 = "UNDEFINED_PACKAGED_BEV_4",
  /** Undefined Packaged Beverages - Reserved for Future Use */
  UNDEFINED_PACKAGED_BEV_5 = "UNDEFINED_PACKAGED_BEV_5",
  /** Undefined Packaged Beverages - Reserved for Future Use */
  UNDEFINED_PACKAGED_BEV_6 = "UNDEFINED_PACKAGED_BEV_6",
  /** Undefined General Publications – Reserved for Future Use. */
  UNDEFINED_PUBLICATIONS_1 = "UNDEFINED_PUBLICATIONS_1",
  /** Undefined General Publications – Reserved for Future Use. */
  UNDEFINED_PUBLICATIONS_2 = "UNDEFINED_PUBLICATIONS_2",
  /** Undefined General Publications – Reserved for Future Use. */
  UNDEFINED_PUBLICATIONS_3 = "UNDEFINED_PUBLICATIONS_3",
  /** Undefined General Publications – Reserved for Future Use. */
  UNDEFINED_PUBLICATIONS_4 = "UNDEFINED_PUBLICATIONS_4",
  /** Undefined General Publications – Reserved for Future Use. */
  UNDEFINED_PUBLICATIONS_5 = "UNDEFINED_PUBLICATIONS_5",
  /** Undefined General Publications – Reserved for Future Use. */
  UNDEFINED_PUBLICATIONS_6 = "UNDEFINED_PUBLICATIONS_6",
  /** Undefined General Publications – Reserved for Future Use. */
  UNDEFINED_PUBLICATIONS_7 = "UNDEFINED_PUBLICATIONS_7",
  /** Undefined General Publications – Reserved for Future Use. */
  UNDEFINED_PUBLICATIONS_8 = "UNDEFINED_PUBLICATIONS_8",
  /** Undefined General Publications – Reserved for Future Use. */
  UNDEFINED_PUBLICATIONS_9 = "UNDEFINED_PUBLICATIONS_9",
  /** Undefined Snacks - Reserved for Future Use */
  UNDEFINED_SNACKS_1 = "UNDEFINED_SNACKS_1",
  /** Undefined Snacks - Reserved for Future Use */
  UNDEFINED_SNACKS_2 = "UNDEFINED_SNACKS_2",
  /** Undefined Snacks - Reserved for Future Use */
  UNDEFINED_SNACKS_3 = "UNDEFINED_SNACKS_3",
  /** Undefined Snacks - Reserved for Future Use */
  UNDEFINED_SNACKS_4 = "UNDEFINED_SNACKS_4",
  /** Undefined Snacks - Reserved for Future Use */
  UNDEFINED_SNACKS_5 = "UNDEFINED_SNACKS_5",
  /** Undefined Snacks - Reserved for Future Use */
  UNDEFINED_SNACKS_6 = "UNDEFINED_SNACKS_6",
  /** Undefined Store Services - Reserved for Future Use */
  UNDEFINED_STORE_SERVICES_1 = "UNDEFINED_STORE_SERVICES_1",
  /** Undefined Store Services - Reserved for Future Use */
  UNDEFINED_STORE_SERVICES_2 = "UNDEFINED_STORE_SERVICES_2",
  /** Undefined Store Services - Reserved for Future Use */
  UNDEFINED_STORE_SERVICES_3 = "UNDEFINED_STORE_SERVICES_3",
  /** Undefined Store Services - Reserved for Future Use */
  UNDEFINED_STORE_SERVICES_4 = "UNDEFINED_STORE_SERVICES_4",
  /** Undefined Store Services - Reserved for Future Use */
  UNDEFINED_STORE_SERVICES_5 = "UNDEFINED_STORE_SERVICES_5",
  /** Undefined Tobacco - Reserved for Future Use */
  UNDEFINED_TOBACCO_1 = "UNDEFINED_TOBACCO_1",
  /** Undefined Tobacco - Reserved for Future Use */
  UNDEFINED_TOBACCO_2 = "UNDEFINED_TOBACCO_2",
  /** Undefined Tobacco - Reserved for Future Use */
  UNDEFINED_TOBACCO_3 = "UNDEFINED_TOBACCO_3",
  /** Undefined Tobacco - Reserved for Future Use */
  UNDEFINED_TOBACCO_4 = "UNDEFINED_TOBACCO_4",
  /** Undefined Tobacco - Reserved for Future Use */
  UNDEFINED_TOBACCO_5 = "UNDEFINED_TOBACCO_5",
  /** Undefined Tobacco - Reserved for Future Use */
  UNDEFINED_TOBACCO_6 = "UNDEFINED_TOBACCO_6",
  /** Undefined Tobacco - Reserved for Future Use */
  UNDEFINED_TOBACCO_7 = "UNDEFINED_TOBACCO_7",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_1 = "UNDEFINED_VEHICLE_PS_1",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_2 = "UNDEFINED_VEHICLE_PS_2",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_3 = "UNDEFINED_VEHICLE_PS_3",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_4 = "UNDEFINED_VEHICLE_PS_4",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_5 = "UNDEFINED_VEHICLE_PS_5",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_6 = "UNDEFINED_VEHICLE_PS_6",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_7 = "UNDEFINED_VEHICLE_PS_7",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_8 = "UNDEFINED_VEHICLE_PS_8",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_9 = "UNDEFINED_VEHICLE_PS_9",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_10 = "UNDEFINED_VEHICLE_PS_10",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_11 = "UNDEFINED_VEHICLE_PS_11",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_12 = "UNDEFINED_VEHICLE_PS_12",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_13 = "UNDEFINED_VEHICLE_PS_13",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_14 = "UNDEFINED_VEHICLE_PS_14",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_15 = "UNDEFINED_VEHICLE_PS_15",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_16 = "UNDEFINED_VEHICLE_PS_16",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_17 = "UNDEFINED_VEHICLE_PS_17",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_18 = "UNDEFINED_VEHICLE_PS_18",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_19 = "UNDEFINED_VEHICLE_PS_19",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_20 = "UNDEFINED_VEHICLE_PS_20",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_21 = "UNDEFINED_VEHICLE_PS_21",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_22 = "UNDEFINED_VEHICLE_PS_22",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_23 = "UNDEFINED_VEHICLE_PS_23",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_24 = "UNDEFINED_VEHICLE_PS_24",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_25 = "UNDEFINED_VEHICLE_PS_25",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_26 = "UNDEFINED_VEHICLE_PS_26",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_27 = "UNDEFINED_VEHICLE_PS_27",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_28 = "UNDEFINED_VEHICLE_PS_28",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_29 = "UNDEFINED_VEHICLE_PS_29",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_30 = "UNDEFINED_VEHICLE_PS_30",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_31 = "UNDEFINED_VEHICLE_PS_31",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_32 = "UNDEFINED_VEHICLE_PS_32",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_33 = "UNDEFINED_VEHICLE_PS_33",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_34 = "UNDEFINED_VEHICLE_PS_34",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_35 = "UNDEFINED_VEHICLE_PS_35",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_36 = "UNDEFINED_VEHICLE_PS_36",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_37 = "UNDEFINED_VEHICLE_PS_37",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_38 = "UNDEFINED_VEHICLE_PS_38",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_39 = "UNDEFINED_VEHICLE_PS_39",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_40 = "UNDEFINED_VEHICLE_PS_40",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_41 = "UNDEFINED_VEHICLE_PS_41",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_42 = "UNDEFINED_VEHICLE_PS_42",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_43 = "UNDEFINED_VEHICLE_PS_43",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_44 = "UNDEFINED_VEHICLE_PS_44",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_45 = "UNDEFINED_VEHICLE_PS_45",
  /** Undefined Vehicle Products / Services */
  UNDEFINED_VEHICLE_PS_46 = "UNDEFINED_VEHICLE_PS_46",
  /** Unknown/Undefined */
  UNKNOWN = "UNKNOWN",
  /** <Deprecated> Unleaded Methanol (5.7% blend) */
  UNLEADED_METHANOL_57 = "UNLEADED_METHANOL_57",
  /** <Deprecated> Unleaded Methanol (7.7% blend) */
  UNLEADED_METHANOL_77 = "UNLEADED_METHANOL_77",
  /** <Deprecated> Unleaded Plus Methanol (5.7% blend) */
  UNLEADED_PLUS_METHANOL_57 = "UNLEADED_PLUS_METHANOL_57",
  /** <Deprecated> Unleaded Plus Methanol (7.7% blend) */
  UNLEADED_PLUS_METHANOL_77 = "UNLEADED_PLUS_METHANOL_77",
  /** <Deprecated> Super Unleaded Methanol (5.7% blend) */
  UNLEADED_SUPER_METHANOL_57 = "UNLEADED_SUPER_METHANOL_57",
  /** Vehicle Accessories */
  VEHICLE_ACC = "VEHICLE_ACC",
  /** Vehicle Fuel Additives/Treatment (Injected) */
  VEHICLE_FUEL_ADDITIVES = "VEHICLE_FUEL_ADDITIVES",
  /** Vehicle Glass */
  VEHICLE_GLASS = "VEHICLE_GLASS",
  /** Vehicle Parking */
  VEHICLE_PARKING = "VEHICLE_PARKING",
  /** Vehicle Parts */
  VEHICLE_PARTS = "VEHICLE_PARTS",
  /** Vehicle Prep */
  VEHICLE_PREP = "VEHICLE_PREP",
  /** Vehicle Rental */
  VEHICLE_RENTAL = "VEHICLE_RENTAL",
  /** Washer Fluid */
  WASHER_FLUID = "WASHER_FLUID",
  /** Wash Out */
  WASH_OUT = "WASH_OUT",
  /** <Deprecated> Weather Fees */
  WEATHER_FEES = "WEATHER_FEES",
  /** White Gas */
  WHITE_GAS = "WHITE_GAS",
  /** Wine */
  WINE = "WINE",
  /** Wipers */
  WIPERS = "WIPERS",
  /** Wireless Real Time Recharge */
  WL_REAL_TIME_RECHARGE = "WL_REAL_TIME_RECHARGE",
  /** Work Order */
  WORK_ORDER = "WORK_ORDER",
}

/** Visa Fleet line item detail indicator */
export enum VisaLineItemDetailIndicator {
  /** Credit line item */
  CREDIT = "CREDIT",
  /** Normal line item */
  NORMAL = "NORMAL",
  /** Payment line item */
  PAYMENT = "PAYMENT",
}

/** Classification information for Mail Order/Telephone Order (MOTO) and Electronic Commerce transactions. */
export enum VisaMotoAndElectronicCommerceIndicator {
  /** Installment-multiple payments for a specified term, usually until payment has been satisfied. */
  INSTALLMENT_PAYMENT = "INSTALLMENT_PAYMENT",
  /** Non-authenticated security transaction. */
  NON_AUTHENTICATED_SECURITY_TRANSACTION = "NON_AUTHENTICATED_SECURITY_TRANSACTION",
  /** Non-authenticated security transaction at a 3-D secure-capable merchant, and merchant attempted to authenticate the cardholder using 3-D secure. */
  NON_AUTHENTICATED_SECURITY_TRANSACTION_WITH_3D_SECURE = "NON_AUTHENTICATED_SECURITY_TRANSACTION_WITH_3D_SECURE",
  /** Non-secure transaction. */
  NON_SECURE_TRANSACTION = "NON_SECURE_TRANSACTION",
  /** The transaction type does not support classification. */
  NOT_APPLICABLE = "NOT_APPLICABLE",
  /** Recurring-multiple, ongoing payments for an indefinite term, until the cardholder or biller cancels the recurring payment arrangement. */
  RECURRING_TRANSACTION = "RECURRING_TRANSACTION",
  /** Secure electronic commerce transaction. */
  SECURE_ELECTRONIC_COMMERCE_TRANSACTION = "SECURE_ELECTRONIC_COMMERCE_TRANSACTION",
  /** Manual-one-time, single payment initiated by the cardholder. */
  SINGLE_TRANSACTION_OF_MAIL_OR_PHONE_ORDER = "SINGLE_TRANSACTION_OF_MAIL_OR_PHONE_ORDER",
  /** The transaction could not be classified. */
  UNKNOWN_CLASSIFICATION = "UNKNOWN_CLASSIFICATION",
}

/** Visa Fleet non fuel product codes */
export enum VisaNonFuelProductCode {
  /** AC Parts 052-061 */
  AC_PARTS = "AC_PARTS",
  /** Air Conditioning Service */
  AC_SERVICE = "AC_SERVICE",
  /** Aircraft Accessories */
  AIRCRAFT_ACC = "AIRCRAFT_ACC",
  /** Aircraft Cleaning */
  AIRCRAFT_CLEANING = "AIRCRAFT_CLEANING",
  /** Aircraft Fuel Additive */
  AIRCRAFT_FUEL_ADDITIVE = "AIRCRAFT_FUEL_ADDITIVE",
  /** Aircraft Ground Hauling */
  AIRCRAFT_GROUND_HAULING = "AIRCRAFT_GROUND_HAULING",
  /** Aircraft Ground Power Unit */
  AIRCRAFT_GROUND_PU = "AIRCRAFT_GROUND_PU",
  /** Aircraft Labor */
  AIRCRAFT_LABOR = "AIRCRAFT_LABOR",
  /** Aircraft Maintenance */
  AIRCRAFT_MAINTENANCE = "AIRCRAFT_MAINTENANCE",
  /** Aircraft Parking Fees */
  AIRCRAFT_PARKING_FEE = "AIRCRAFT_PARKING_FEE",
  /** Aircraft Rental */
  AIRCRAFT_RENTAL = "AIRCRAFT_RENTAL",
  /** Aircraft Sanitation Fees */
  AIRCRAFT_SANITATION = "AIRCRAFT_SANITATION",
  /** Aircraft Service */
  AIRCRAFT_SERVICE = "AIRCRAFT_SERVICE",
  /** Aircraft Tie Down Fees */
  AIRCRAFT_TIE_DOWN_FEE = "AIRCRAFT_TIE_DOWN_FEE",
  /** Aircraft Work Order */
  AIRCRAFT_WO = "AIRCRAFT_WO",
  /** Airport Fees */
  AIRPORT_FEE = "AIRPORT_FEE",
  /** Air Filter */
  AIR_FILTER = "AIR_FILTER",
  /** Alternative Snacks */
  ALT_SNACKS = "ALT_SNACKS",
  /** Anti-Freeze */
  ANTI_FREEZE = "ANTI_FREEZE",
  /** <Deprecated> APU or Aircraft Jump Seat */
  APU = "APU",
  /** <Deprecated> Avionics */
  AVIONICS = "AVIONICS",
  /** AvGas Federal Excise Tax */
  AV_GAS_FED_E_TAX = "AV_GAS_FED_E_TAX",
  /** Batteries */
  BATTERIES = "BATTERIES",
  /** Beer - Alcoholic */
  BEER = "BEER",
  /** Beer - Non-Alcoholic */
  BEER_NA = "BEER_NA",
  /** Body Work */
  BODY_WORK = "BODY_WORK",
  /** Brake Fluid */
  BRAKE_FLUID = "BRAKE_FLUID",
  /** Brake Service */
  BRAKE_SERVICE = "BRAKE_SERVICE",
  /** Call Out Fee */
  CALL_OUT_FEE = "CALL_OUT_FEE",
  /** Cargo Handling */
  CARGO_HANDLING = "CARGO_HANDLING",
  /** Car Wash */
  CAR_WASH = "CAR_WASH",
  /** Cash Back */
  CASH_BACK = "CASH_BACK",
  /** Cash Back Fee */
  CASH_BACK_FEE = "CASH_BACK_FEE",
  /** Catering */
  CATERING = "CATERING",
  /** Cannabidiol (CBD) */
  CBD = "CBD",
  /** Charity */
  CHARITY = "CHARITY",
  /** Charter Fee */
  CHARTER_FEE = "CHARTER_FEE",
  /** Cigarettes */
  CIGARETTES = "CIGARETTES",
  /** Cold Dispensed Beverages */
  COLD_DISPENSED_BEV = "COLD_DISPENSED_BEV",
  /** Communication Fee */
  COMMUNICATION_FEE = "COMMUNICATION_FEE",
  /** Corrosion Inhibitor */
  CORROSION_INHIBITOR = "CORROSION_INHIBITOR",
  /** Coupon 1 */
  COUPON_1 = "COUPON_1",
  /** Coupon 2 */
  COUPON_2 = "COUPON_2",
  /** Coupon 3 */
  COUPON_3 = "COUPON_3",
  /** Coupon 4 */
  COUPON_4 = "COUPON_4",
  /** Coupon 5 */
  COUPON_5 = "COUPON_5",
  /** Deli Items */
  DELI_ITEMS = "DELI_ITEMS",
  /** De-fuel */
  DE_FUEL = "DE_FUEL",
  /** De-icing */
  DE_ICING = "DE_ICING",
  /** Disable Device/Handset Lock */
  DISABLE_HANDSET = "DISABLE_HANDSET",
  /** Discount 1 */
  DISCOUNT_1 = "DISCOUNT_1",
  /** Discount 2 */
  DISCOUNT_2 = "DISCOUNT_2",
  /** Discount 3 */
  DISCOUNT_3 = "DISCOUNT_3",
  /** Discount 4 */
  DISCOUNT_4 = "DISCOUNT_4",
  /** Discount 5 */
  DISCOUNT_5 = "DISCOUNT_5",
  /** Enable Device/Handset Unlock */
  ENABLE_HANDSET = "ENABLE_HANDSET",
  /** Engine Service */
  ENGINE_SERVICE = "ENGINE_SERVICE",
  /** EV Battery Exchanges */
  EV_BATTERY_ECH = "EV_BATTERY_ECH",
  /** EV Charging Fee */
  EV_CHARGE = "EV_CHARGE",
  /** Exhaust Service */
  EXHAUST_SERVICE = "EXHAUST_SERVICE",
  /** Fee 1 */
  FEE_1 = "FEE_1",
  /** Fee 2 */
  FEE_2 = "FEE_2",
  /** Fee 3 */
  FEE_3 = "FEE_3",
  /** Fee 4 */
  FEE_4 = "FEE_4",
  /** Fee 5 */
  FEE_5 = "FEE_5",
  /** Financial Prepaid Card Activate */
  FIN_PREPAID_ACT = "FIN_PREPAID_ACT",
  /** Financial Prepaid Card Reload */
  FIN_PREPAID_REL = "FIN_PREPAID_REL",
  /** <Deprecated> Flight Planning Fees */
  FLIGHT_PLANNING_FEES = "FLIGHT_PLANNING_FEES",
  /** Flight Plans/Weather Brief */
  FLIGHT_PLANS = "FLIGHT_PLANS",
  /** Flow Fee */
  FLOW_FEE = "FLOW_FEE",
  /** Fluid Milk Products */
  FLUID_MILK = "FLUID_MILK",
  /** Frozen Dispensed Beverages */
  FROZEN_DISPENSED_BEV = "FROZEN_DISPENSED_BEV",
  /** Frozen Foods */
  FROZEN_FOOD = "FROZEN_FOOD",
  /** Fuel System */
  FUEL_SYSTEM = "FUEL_SYSTEM",
  /** General Alcohol */
  GEN_ALCOHOL = "GEN_ALCOHOL",
  /** General Automotive Merchandise */
  GEN_AUTO_MERCH = "GEN_AUTO_MERCH",
  /** General Candy */
  GEN_CANDY = "GEN_CANDY",
  /** General Dairy */
  GEN_DAIRY = "GEN_DAIRY",
  /** General Deli */
  GEN_DELI = "GEN_DELI",
  /** General Dispensed Beverage */
  GEN_DISPENSED_BEV = "GEN_DISPENSED_BEV",
  /** General Foodservice */
  GEN_FOODSERVICE = "GEN_FOODSERVICE",
  /** General Grocery */
  GEN_GROCERY = "GEN_GROCERY",
  /** General Health & Beauty Care */
  GEN_HEALTH = "GEN_HEALTH",
  /** General Ice */
  GEN_ICE = "GEN_ICE",
  /** General Lottery */
  GEN_LOTTERY = "GEN_LOTTERY",
  /** General Merchandise */
  GEN_MERCH = "GEN_MERCH",
  /** General Money Order */
  GEN_MONEY_ORDER = "GEN_MONEY_ORDER",
  /** General Packaged Beverage */
  GEN_PACKAGED_BEV = "GEN_PACKAGED_BEV",
  /** General Publications */
  GEN_PUBLICATIONS = "GEN_PUBLICATIONS",
  /** General Purpose Activate */
  GEN_PURPOSE_ACT = "GEN_PURPOSE_ACT",
  /** General Purpose Reload */
  GEN_PURPOSE_REL = "GEN_PURPOSE_REL",
  /** General Snacks */
  GEN_SNACKS = "GEN_SNACKS",
  /** General Store Service */
  GEN_STORE_SERVICE = "GEN_STORE_SERVICE",
  /** General Tobacco */
  GEN_TOBACCO = "GEN_TOBACCO",
  /** General Undefined – Reserved for Conexxus Future Use */
  GEN_UNDEFINED = "GEN_UNDEFINED",
  /** General Undefined – Reserved for Conexxus Future Use */
  GEN_UNDEFINED_2 = "GEN_UNDEFINED_2",
  /** General Undefined – Reserved for Conexxus Future Use */
  GEN_UNDEFINED_3 = "GEN_UNDEFINED_3",
  /** General Undefined – Reserved for Conexxus Future Use */
  GEN_UNDEFINED_4 = "GEN_UNDEFINED_4",
  /** General Undefined – Reserved for Conexxus Future Use */
  GEN_UNDEFINED_5 = "GEN_UNDEFINED_5",
  /** General Undefined – Reserved for Conexxus Future Use */
  GEN_UNDEFINED_6 = "GEN_UNDEFINED_6",
  /** General Undefined – Reserved for Conexxus Future Use */
  GEN_UNDEFINED_7 = "GEN_UNDEFINED_7",
  /** General Undefined – Reserved for Conexxus Future Use */
  GEN_UNDEFINED_8 = "GEN_UNDEFINED_8",
  /** Ground Equipment Service Fees */
  GES_FEE = "GES_FEE",
  /** Gratuity */
  GRATUITY = "GRATUITY",
  /** Groceries - Edible */
  GROCERY_EDIBLE = "GROCERY_EDIBLE",
  /** Groceries - Non-Edible */
  GROCERY_NON_EDIBLE = "GROCERY_NON_EDIBLE",
  /** Groceries - Perishable */
  GROCERY_PER_EDIBLE = "GROCERY_PER_EDIBLE",
  /** GST/HST (Canadian)/VAT 1 */
  GST_HST_VAT_1 = "GST_HST_VAT_1",
  /** Hangar Fee */
  HANGAR_FEE = "HANGAR_FEE",
  /** Home Delivery */
  HOME_DELIVERY = "HOME_DELIVERY",
  /** Hoses */
  HOSES = "HOSES",
  /** Hot Dispensed Beverages */
  HOT_DISPENSED_BEV = "HOT_DISPENSED_BEV",
  /** Inspection */
  INSPECTION = "INSPECTION",
  /** Instruction Fee */
  INSTRUCTION_FEE = "INSTRUCTION_FEE",
  /** IT/Bladder */
  IT_BLADDER = "IT_BLADDER",
  /** Jet Federal Excise Tax */
  JET_FD_E_TAX = "JET_FD_E_TAX",
  /** Labor */
  LABOR = "LABOR",
  /** Lamps */
  LAMPS = "LAMPS",
  /** Landing Fee */
  LANDING_FEE = "LANDING_FEE",
  /** Launch Fee */
  LAUNCH_FEE = "LAUNCH_FEE",
  /** Liquor */
  LIQUOR = "LIQUOR",
  /** Local Discount 1 */
  LOCAL_DISCOUNT_1 = "LOCAL_DISCOUNT_1",
  /** Local Discount 2 */
  LOCAL_DISCOUNT_2 = "LOCAL_DISCOUNT_2",
  /** Local Discount 3 */
  LOCAL_DISCOUNT_3 = "LOCAL_DISCOUNT_3",
  /** Local Discount 4 */
  LOCAL_DISCOUNT_4 = "LOCAL_DISCOUNT_4",
  /** Local Discount 5 */
  LOCAL_DISCOUNT_5 = "LOCAL_DISCOUNT_5",
  /** Lodging */
  LODGING = "LODGING",
  /** Lottery - Other */
  LOTTERT_OT = "LOTTERT_OT",
  /** Lottery - Instant */
  LOTTERY_IN = "LOTTERY_IN",
  /** Lottery - Online */
  LOTTERY_ON = "LOTTERY_ON",
  /** Lottery Pay Out - Instant */
  LOTTERY_PO_IN = "LOTTERY_PO_IN",
  /** Lottery Pay Out - Online */
  LOTTERY_PO_ON = "LOTTERY_PO_ON",
  /** Lottery Pay Out - Other */
  LOTTERY_PO_OT = "LOTTERY_PO_OT",
  /** Lube */
  LUBE = "LUBE",
  /** Marine Labor */
  MARINE_LABOR = "MARINE_LABOR",
  /** Marine Service */
  MARINE_SERVICE = "MARINE_SERVICE",
  /** Marine Work Order */
  MARINE_WO = "MARINE_WO",
  /** Membership/Loyalty */
  MEMBERSHIP = "MEMBERSHIP",
  /** <Deprecated> Miscellaneous */
  MISC = "MISC",
  /** Miscellaneous Administrative */
  MISC_ADMIN = "MISC_ADMIN",
  /** Miscellaneous Aviation Products/Services */
  MISC_AV_PS = "MISC_AV_PS",
  /** Miscellaneous Aviation Tax */
  MISC_AV_TAX = "MISC_AV_TAX",
  /** Miscellaneous Marine Products/Services */
  MISC_MARINE_PS = "MISC_MARINE_PS",
  /** Miscellaneous Negative Administrative */
  MISC_NEG_ADMIN = "MISC_NEG_ADMIN",
  /** Miscellaneous Vehicle Products / Services */
  MISC_VEHICLE_PS = "MISC_VEHICLE_PS",
  /** Money Order - Dividend Check */
  MONEY_ORDER_DC = "MONEY_ORDER_DC",
  /** Money Order - Gift Certificate */
  MONEY_ORDER_GC = "MONEY_ORDER_GC",
  /** Money Order - Official Check */
  MONEY_ORDER_OC = "MONEY_ORDER_OC",
  /** Money Order - Payroll Check */
  MONEY_ORDER_PC = "MONEY_ORDER_PC",
  /** Money Order - Rebate Check */
  MONEY_ORDER_REBC = "MONEY_ORDER_REBC",
  /** Money Order - Refund Check */
  MONEY_ORDER_REFC = "MONEY_ORDER_REFC",
  /** Money Order - Utility Check */
  MONEY_ORDER_UC = "MONEY_ORDER_UC",
  /** Money Order - Vendor Payment */
  MONEY_ORDER_VP = "MONEY_ORDER_VP",
  /** Motor Oil */
  MOTOR_OIL = "MOTOR_OIL",
  /** Multiple Payee Bill Pay */
  MULTI_BILL_PAY = "MULTI_BILL_PAY",
  /** Oil Change */
  OIL_CHANGE = "OIL_CHANGE",
  /** Oil Filter */
  OIL_FILTER = "OIL_FILTER",
  /** Other Dairy */
  OTHER_DAIRY = "OTHER_DAIRY",
  /** Other Dispensed Beverages */
  OTHER_DISPENSED_BEV = "OTHER_DISPENSED_BEV",
  /** Other Lubricants */
  OTHER_LUBE = "OTHER_LUBE",
  /** Other Packaged Beverages */
  OTHER_PACKAGED_BEV = "OTHER_PACKAGED_BEV",
  /** Overtime Fees */
  OVERTIME_FEE = "OVERTIME_FEE",
  /** Oxygen */
  OXYGEN = "OXYGEN",
  /** Packaged Beverages (non-alcoholic) */
  PACKAGED_BEV_NA = "PACKAGED_BEV_NA",
  /** Bread - Packaged */
  PACKAGED_BREAD = "PACKAGED_BREAD",
  /** Packaged Sandwiches/Deli Products */
  PACKAGED_DELI = "PACKAGED_DELI",
  /** Packaged Ice Cream/Novelties */
  PACKAGED_ICE_CREAM = "PACKAGED_ICE_CREAM",
  /** Packaged Juice */
  PACKAGED_JUICE = "PACKAGED_JUICE",
  /** Pilot Supplies */
  PILOT_SUPPLIES = "PILOT_SUPPLIES",
  /** PIN Activate Prepaid Card */
  PIN_PREPAID_ACT = "PIN_PREPAID_ACT",
  /** PIN Return Prepaid Card */
  PIN_PREPAID_RET = "PIN_PREPAID_RET",
  /** POS/Loyalty Reserved Discount 1 */
  POS_RES_DISCOUNT_1 = "POS_RES_DISCOUNT_1",
  /** POS/Loyalty Reserved Discount 2 */
  POS_RES_DISCOUNT_2 = "POS_RES_DISCOUNT_2",
  /** POS/Loyalty Reserved Discount 3 */
  POS_RES_DISCOUNT_3 = "POS_RES_DISCOUNT_3",
  /** POS/Loyalty Reserved Discount 4 */
  POS_RES_DISCOUNT_4 = "POS_RES_DISCOUNT_4",
  /** POS/Loyalty Reserved Discount 5 */
  POS_RES_DISCOUNT_5 = "POS_RES_DISCOUNT_5",
  /** Prepaid Cards - Activation/Recharge */
  PREPAID_ACT = "PREPAID_ACT",
  /** Prepaid Cards - Purchase */
  PREPAID_PURCHASE = "PREPAID_PURCHASE",
  /** Prepared Foods */
  PREPARED_FOOD = "PREPARED_FOOD",
  /** Preventative Maintenance */
  PREV_MAINTENANCE = "PREV_MAINTENANCE",
  /** Proprietary Prepaid Card Activate */
  PROP_PREPAID_ACT = "PROP_PREPAID_ACT",
  /** Proprietary Prepaid Card Reload */
  PROP_PREPAID_REL = "PROP_PREPAID_REL",
  /** PST/QST (Canadian) VAT 2 */
  PST_HST_VAT_2 = "PST_HST_VAT_2",
  /** Ramp Fees */
  RAMP_FEES = "RAMP_FEES",
  /** Real Time Recharge */
  REAL_TIME_RECHARGE = "REAL_TIME_RECHARGE",
  /** Repairs */
  REPAIRS = "REPAIRS",
  /** Reserved for future use */
  RESERVED_1 = "RESERVED_1",
  /** Reserved for future use */
  RESERVED_2 = "RESERVED_2",
  /** Reserved for future use */
  RESERVED_3 = "RESERVED_3",
  /** Reserved for future use */
  RESERVED_4 = "RESERVED_4",
  /** Reserved for future use */
  RESERVED_5 = "RESERVED_5",
  /** Reserved for future use */
  RESERVED_6 = "RESERVED_6",
  /** Reserved for future use */
  RESERVED_7 = "RESERVED_7",
  /** Reserved for future use */
  RESERVED_8 = "RESERVED_8",
  /** Re-service */
  RE_SERVICE = "RE_SERVICE",
  /** Road Service */
  ROAD_SERVICE = "ROAD_SERVICE",
  /** RV Dump Fee */
  RV_DUMP_FEE = "RV_DUMP_FEE",
  /** <Deprecated> Sales Tax as Shown for Non-Fuel Products */
  SALES_TAX_NON_FUEL = "SALES_TAX_NON_FUEL",
  /** Salty Snacks */
  SALTY_SNACKS = "SALTY_SNACKS",
  /** Scales */
  SCALES = "SCALES",
  /** Secure Fees */
  SECURE_FEE = "SECURE_FEE",
  /** Service Package */
  SERVICE_PACKAGE = "SERVICE_PACKAGE",
  /** Shower */
  SHOWER = "SHOWER",
  /** Single Payee Bill Pay */
  SINGLE_BILL_PAY = "SINGLE_BILL_PAY",
  /** Slip Rental */
  SLIP_RENTAL = "SLIP_RENTAL",
  /** Soda */
  SODA = "SODA",
  /** Split Tender */
  SPLIT_TENDER = "SPLIT_TENDER",
  /** Static Dissipater Additive */
  STATIC_DISSIPATER_ADDITIVE = "STATIC_DISSIPATER_ADDITIVE",
  /** Storage */
  STORAGE = "STORAGE",
  /** Sweet Snacks - Packaged */
  SWEET_SNACKS = "SWEET_SNACKS",
  /** SWT Rate (Canadian) */
  SWT_RATE = "SWT_RATE",
  /** Synthetic Oil */
  SYNTHETIC_OIL = "SYNTHETIC_OIL",
  /** Tax 1 */
  TAX_1 = "TAX_1",
  /** Tax 2 */
  TAX_2 = "TAX_2",
  /** Tax 3 */
  TAX_3 = "TAX_3",
  /** Tax 4 */
  TAX_4 = "TAX_4",
  /** Tax 5 */
  TAX_5 = "TAX_5",
  /** Tax 6 */
  TAX_6 = "TAX_6",
  /** Tax 7 */
  TAX_7 = "TAX_7",
  /** Tax 8 */
  TAX_8 = "TAX_8",
  /** Tax Discount/Forgiven */
  TAX_DISCOUNT_F = "TAX_DISCOUNT_F",
  /** 3rd Party Prepaid Card Activate */
  THREE_P_PREPAID_ACT = "THREE_P_PREPAID_ACT",
  /** 3rd Party Prepaid Card Reload */
  THREE_P_PREPAID_REL = "THREE_P_PREPAID_REL",
  /** Tires */
  TIRES = "TIRES",
  /** <Deprecated> Tires, Batteries, and Accessories */
  TIRES_BATTERIES_ACCESSORIES = "TIRES_BATTERIES_ACCESSORIES",
  /** Federal Excise Tax (Tires) */
  TIRES_FET = "TIRES_FET",
  /** Tire-related (Wheel Balance, Valve Stem) */
  TIRE_RELATED = "TIRE_RELATED",
  /** Tire Repair */
  TIRE_REPAIR = "TIRE_REPAIR",
  /** Tire Rotation */
  TIRE_ROTATION = "TIRE_ROTATION",
  /** Tobacco - Other */
  TOBACCO_OTHER = "TOBACCO_OTHER",
  /** Toll Payments */
  TOLL = "TOLL",
  /** Towing */
  TOWING = "TOWING",
  /** Trailer Wash */
  TRAILER_WASH = "TRAILER_WASH",
  /** Transmission Service */
  TRANSMISSION_SERVICE = "TRANSMISSION_SERVICE",
  /** Transportation */
  TRANSPORTATION = "TRANSPORTATION",
  /** Truck Tank Cleaning */
  TRUNK_TANK_CLEANING = "TRUNK_TANK_CLEANING",
  /** Unassigned Beverage Items */
  UNASSIGNED_BEV = "UNASSIGNED_BEV",
  /** Unassigned Beverage Items */
  UNASSIGNED_BEV_2 = "UNASSIGNED_BEV_2",
  /** Unassigned Beverage Items */
  UNASSIGNED_BEV_3 = "UNASSIGNED_BEV_3",
  /** Unassigned Beverage Items */
  UNASSIGNED_BEV_4 = "UNASSIGNED_BEV_4",
  /** Unassigned Beverage Items */
  UNASSIGNED_BEV_5 = "UNASSIGNED_BEV_5",
  /** Unassigned Beverage Items */
  UNASSIGNED_BEV_6 = "UNASSIGNED_BEV_6",
  /** Unassigned Beverage Items */
  UNASSIGNED_BEV_7 = "UNASSIGNED_BEV_7",
  /** Unassigned Food and Grocery Items */
  UNASSIGNED_GROCERY = "UNASSIGNED_GROCERY",
  /** Unassigned Food and Grocery Items */
  UNASSIGNED_GROCERY_2 = "UNASSIGNED_GROCERY_2",
  /** Unassigned Food and Grocery Items */
  UNASSIGNED_GROCERY_3 = "UNASSIGNED_GROCERY_3",
  /** Unassigned Food and Grocery Items */
  UNASSIGNED_GROCERY_4 = "UNASSIGNED_GROCERY_4",
  /** Unassigned Food and Grocery Items */
  UNASSIGNED_GROCERY_5 = "UNASSIGNED_GROCERY_5",
  /** Unassigned Food and Grocery Items */
  UNASSIGNED_GROCERY_6 = "UNASSIGNED_GROCERY_6",
  /** Unknown/Undefined */
  UNKNOWN = "UNKNOWN",
  /** Vehicle Accessories */
  VEHICLE_ACC = "VEHICLE_ACC",
  /** Vehicle Fuel Additives/Treatment (Injected) */
  VEHICLE_FUEL_ADDITIVES = "VEHICLE_FUEL_ADDITIVES",
  /** Vehicle Glass */
  VEHICLE_GLASS = "VEHICLE_GLASS",
  /** Vehicle Parking */
  VEHICLE_PARKING = "VEHICLE_PARKING",
  /** Vehicle Parts */
  VEHICLE_PARTS = "VEHICLE_PARTS",
  /** Vehicle Prep */
  VEHICLE_PREP = "VEHICLE_PREP",
  /** Vehicle Rental */
  VEHICLE_RENTAL = "VEHICLE_RENTAL",
  /** Washer Fluid */
  WASHER_FLUID = "WASHER_FLUID",
  /** Wash Out */
  WASH_OUT = "WASH_OUT",
  /** <Deprecated> Weather Fees */
  WEATHER_FEES = "WEATHER_FEES",
  /** Wine */
  WINE = "WINE",
  /** Wipers */
  WIPERS = "WIPERS",
  /** Wireless Real Time Recharge */
  WL_REAL_TIME_RECHARGE = "WL_REAL_TIME_RECHARGE",
  /** Work Order */
  WORK_ORDER = "WORK_ORDER",
}

/** A Spend Control rule that blocks transactions if the Visa Risk Score is above a configured threshold. */
export type VisaRiskScoreSpendRule = Node &
  SpendRule & {
    __typename?: "VisaRiskScoreSpendRule";
    /** The date and time, in ISO 8601 format, the spend rule was created. */
    createdAt?: Maybe<Scalars["String"]>;
    /** Global ID used to reference the `VisaRiskScoreSpendRule` in operations. */
    id: Scalars["ID"];
    /** The maximum Visa Risk Score allowed for a transaction before transaction is declined. */
    maximumVisaRiskScore?: Maybe<Scalars["UnsignedInt"]>;
    /** The name assigned to the rule. */
    name?: Maybe<Scalars["String"]>;
    /** The list of revisions for this spend rule. */
    revisions?: Maybe<SpendRuleConnection>;
    /** The date and time, in ISO 8601 format, the spend rule was last updated. */
    updatedAt?: Maybe<Scalars["String"]>;
    /** The `ApplicableRuleUserType` for which the rule will be evaluated. */
    userType?: Maybe<ApplicableRuleUserType>;
    /** The current version of the rule. Specific versions can be attached and detached from card products and payment cards. */
    version?: Maybe<Scalars["String"]>;
  };

/** A Spend Control rule that blocks transactions if the Visa Risk Score is above a configured threshold. */
export type VisaRiskScoreSpendRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The result of applying a `VisaRiskScoreSpendRule` to an event. */
export type VisaRiskScoreSpendRuleResult = SpendRuleResult & {
  __typename?: "VisaRiskScoreSpendRuleResult";
  /** The attached level. */
  attachedLevel?: Maybe<AttachedLevel>;
  /** A message describing the result. */
  message?: Maybe<Scalars["String"]>;
  /** The recommendation to `ALLOW` or `BLOCK` an event based on the result of the rule. */
  recommendation?: Maybe<SpendRuleRecommendation>;
  /** The spend rule attached at the time of the event. */
  spendRule?: Maybe<VisaRiskScoreSpendRule>;
  /** The Visa Risk Score for this transaction. */
  visaRiskScore?: Maybe<Scalars["UnsignedInt"]>;
};

/** Visa Fleet tax treatment types */
export enum VisaTaxTreatment {
  /** Gross prices with taxes calculated at the invoice level */
  GIL = "GIL",
  /** Gross prices with taxes calculated at the line item level */
  GLL = "GLL",
  /** Net prices with taxes calculated at the invoice level */
  NIL = "NIL",
  /** Net prices with taxes calculated at the line item level */
  NLL = "NLL",
  /** No tax applies on the invoice */
  NON = "NON",
}

/** Information about the verification method used in this transaction. */
export enum VisaThreeDSecureIndicator {
  /** Visa’s Attempt Server for 3DS verification stand-in. */
  ATTEMPTS_SERVER_RESPONDING = "ATTEMPTS_SERVER_RESPONDING",
  /** Behavior Biometrics. */
  BEHAVIORAL_BIOMETRICS = "BEHAVIORAL_BIOMETRICS",
  /** The cardholder received an identity verification request through the Knowledge-Based Authentication method. */
  CHALLENGE_KBA = "CHALLENGE_KBA",
  /** The cardholder received an identity verification request through the Out-of-Band Authentication method via an application. */
  CHALLENGE_OOB_APP = "CHALLENGE_OOB_APP",
  /** The cardholder received an identity verification request through the Out-of-Band Authentication method via a biometric device. */
  CHALLENGE_OOB_BIOMETRIC = "CHALLENGE_OOB_BIOMETRIC",
  /** The cardholder received an identity verification request through the Out-of-Band Authentication method via a method other than a biometric device or an application. */
  CHALLENGE_OOB_OTHER = "CHALLENGE_OOB_OTHER",
  /** The cardholder received an identity verification request. */
  CHALLENGE_OTHER = "CHALLENGE_OTHER",
  /** The cardholder received an identity verification request with a one-time passcode via an application. */
  CHALLENGE_OTP_APP = "CHALLENGE_OTP_APP",
  /** The cardholder received an identity verification request with a one-time passcode via key fob. */
  CHALLENGE_OTP_FOB = "CHALLENGE_OTP_FOB",
  /** The cardholder received an identity verification request with a one-time passcode via a form other than SMS, email, fob, or application. */
  CHALLENGE_OTP_OTHER = "CHALLENGE_OTP_OTHER",
  /** The cardholder received an identity verification request with a one-time passcode via SMS. */
  CHALLENGE_OTP_SMS = "CHALLENGE_OTP_SMS",
  /** The cardholder received an identity verification request with a static passcode. */
  CHALLENGE_STATIC_PASSCODE = "CHALLENGE_STATIC_PASSCODE",
  /** Decoupled authentication. */
  DECOUPLED = "DECOUPLED",
  /** Delegated trusted authentication. */
  DELEGATED_TRUSTED = "DELEGATED_TRUSTED",
  /** Frictionless 3DS Verification */
  FRICTIONLESS = "FRICTIONLESS",
  /** Frictionless 3DS verification, Risk-Based Authentication. */
  FRICTIONLESS_RBA = "FRICTIONLESS_RBA",
  /** Frictionless 3DS verification with Risk-Based Authentication review. */
  FRICTIONLESS_RBA_REVIEW = "FRICTIONLESS_RBA_REVIEW",
  /** Frictionless flow, Smart Attempts. */
  FRICTIONLESS_SMART_ATTEMPTS = "FRICTIONLESS_SMART_ATTEMPTS",
  /** Frictionless flow, FIDO Standard. */
  FRICTIONLESS_USING_FIDO_STANDARD = "FRICTIONLESS_USING_FIDO_STANDARD",
  /** Frictionless flow, Visa Secure on behalf of issuer. */
  FRICTIONLESS_VISA_SECURE_ON_BEHALF_OF_ISSUER = "FRICTIONLESS_VISA_SECURE_ON_BEHALF_OF_ISSUER",
  /** 3DS verification followed an issuer-defined method. */
  ISSUER_DEFINED_1 = "ISSUER_DEFINED_1",
  /** 3DS verification followed an issuer-defined method. */
  ISSUER_DEFINED_2 = "ISSUER_DEFINED_2",
  /** 3DS verification followed an issuer-defined method. */
  ISSUER_DEFINED_3 = "ISSUER_DEFINED_3",
  /** 3DS verification followed an issuer-defined method. */
  ISSUER_DEFINED_4 = "ISSUER_DEFINED_4",
  /** 3DS verification followed an issuer-defined method. */
  ISSUER_DEFINED_5 = "ISSUER_DEFINED_5",
  /** The cardholder received an identity verification request with a push confirmation. */
  PUSH_CONFIRMATION = "PUSH_CONFIRMATION",
  /** Secure Payment Confirmation. */
  SECURE_PAYMENT_CONFIRMATION = "SECURE_PAYMENT_CONFIRMATION",
  /** The cardholder received an identity verification request through an unrecognized method. */
  UNRECOGNIZED_METHOD = "UNRECOGNIZED_METHOD",
  /** Web Authentication. */
  WEBAUTHN = "WEBAUTHN",
}

/** Waive fee input. */
export type WaiveFeeTransferInput = {
  /** Fee transfer event to be reversed. */
  feeTransferEventId: Scalars["ID"];
  /**
   * The idempotency key for this request.
   *
   * This is a random string such as UUIDv4 used to uniquely identify requests.
   *
   * If a request with the same `IdempotencyKey` is received multiple times, only the first request will be processed. Subsequent requests will return the same response as the first request.
   *
   * [See this link for more](https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_(random))
   *
   * Minimum length: 5 characters
   * Maximum length: 255 characters
   */
  idempotencyKey: Scalars["IdempotencyKey"];
  /**
   * The optional memo of the `WaiveFeeTransfer`.
   *
   * Maximum length: 1024 characters
   */
  memo?: InputMaybe<Scalars["String"]>;
};

/** Input type for waiving interest for a `CreditCardTransferEvent` associated with a closed `FinancialAccountStatement`. */
export type WaiveInterestAmountForClosedStatementInput = {
  /** The `InterestAssessmentEvent` associated with the `FinancialAccountStatement`. */
  cardTransactionEventId: Scalars["ID"];
};

/** Types which can be returned when waiving full interest for a given `InterestAssessmentEvent` associated with a closed `FinancialAccountStatement` */
export type WaiveInterestAmountForClosedStatementPayload =
  | AccessDeniedError
  | CreditCardTransferEvent
  | UserError;

/** Token provisioning wallet details */
export type WalletDetailsInput = {
  /** Stable device identification set by Wallet Provider. Could be computer identifier or ID tied to hardware such as TEE_ID or SE_ID. */
  clientDeviceIdentifier?: InputMaybe<Scalars["String"]>;
  /** Client-provided consumer ID that identifies the Wallet Account Holder entity. */
  clientWalletAccountIdentifier: Scalars["String"];
  /** The client wallet providers defined in 'WalletProviderType' */
  clientWalletProvider: WalletProviderType;
};

/** Highnote supported Client Wallet Providers. */
export enum WalletProviderType {
  /** Google Pay Wallet */
  GOOGLE_PAY = "GOOGLE_PAY",
  /** Samsung Pay Wallet */
  SAMSUNG_PAY = "SAMSUNG_PAY",
}

/** A inter account transfer rule that is connected to the watchlist. */
export type WatchlistInterFinancialAccountTransferRule =
  InterFinancialAccountTransferRule &
    Node & {
      __typename?: "WatchlistInterFinancialAccountTransferRule";
      /** The date and time, in ISO 8601 format, the transfer rule was created. */
      createdAt?: Maybe<Scalars["String"]>;
      /** Global ID used to reference the `WatchlistInterFinancialAccountTransferRule` in operations. */
      id: Scalars["ID"];
      /** The name assigned to the rule. */
      name?: Maybe<Scalars["String"]>;
      /** The list of revisions for this transfer rule. */
      revisions?: Maybe<InterFinancialAccountTransferRuleConnection>;
      /** The date and time, in ISO 8601 format, the transfer rule was last updated. */
      updatedAt?: Maybe<Scalars["String"]>;
      /** The current version of the rule. */
      version?: Maybe<Scalars["String"]>;
    };

/** A inter account transfer rule that is connected to the watchlist. */
export type WatchlistInterFinancialAccountTransferRuleRevisionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The result of applying a `WatchlistInterFinancialAccountTransferRule` to an event. */
export type WatchlistInterFinancialAccountTransferRuleResult =
  InterFinancialAccountTransferRuleResult & {
    __typename?: "WatchlistInterFinancialAccountTransferRuleResult";
    /** This field will be populated if an override is attempted. It will indicate if the override was allowed or denied. */
    feedbackCode?: Maybe<FeedbackCode>;
    /** The `WatchlistInterFinancialAccountTransferRule` attached at the time of the event. */
    interFinancialAccountTransferRule?: Maybe<WatchlistInterFinancialAccountTransferRule>;
    /** A message describing the result. */
    message?: Maybe<Scalars["String"]>;
    /** A status representing the result of the rule’s evaluation. */
    status?: Maybe<InterFinancialAccountTransferRuleResultStatus>;
  };

/** Web push provisioning asset type */
export enum WebPushAssetType {
  /** Card templates */
  CARD_TEMPLATES = "CARD_TEMPLATES",
  /** Network card assets */
  NETWORK_CARD_ASSETS = "NETWORK_CARD_ASSETS",
}

/** A webhook notification target. */
export type WebhookNotificationTarget = Node & {
  __typename?: "WebhookNotificationTarget";
  /** The date and time, in ISO 8601 format, the WebhookNotificationTarget was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The date and time, in ISO 8601 format, this was most recently deactivated. */
  deactivatedAt?: Maybe<Scalars["String"]>;
  /** The history of delivery attempts for this notification target. */
  deliveryAttempts?: Maybe<DeliveryAttemptConnection>;
  /**
   * The email address to which target deactivation emails are sent.
   * This data is only stored in the live environment. Deactivation emails are not sent in the test environment.
   */
  email?: Maybe<Scalars["String"]>;
  /** Global ID used to reference the WebhookNotificationTarget in operations. */
  id: Scalars["ID"];
  /** The name of the WebhookNotificationTarget. */
  name?: Maybe<Scalars["String"]>;
  /** The signing keys used for this target. */
  signingKeys?: Maybe<Array<SigningKey>>;
  /** The status of the target. */
  status: NotificationTargetStatus;
  /** The history of status changes for this notification target. */
  statusHistory?: Maybe<NotificationTargetStatusHistoryConnection>;
  /** The event names this target is subscribed to. */
  subscriptions?: Maybe<Array<NotificationEventName>>;
  /** The date and time, in ISO 8601 format, this was most recently updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** The URI to send notifications. */
  uri?: Maybe<Scalars["String"]>;
  /** The events that should have been delivered to this target. */
  webhookNotificationTargetEvents?: Maybe<WebhookNotificationTargetEventConnection>;
};

/** A webhook notification target. */
export type WebhookNotificationTargetDeliveryAttemptsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A webhook notification target. */
export type WebhookNotificationTargetStatusHistoryArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** A webhook notification target. */
export type WebhookNotificationTargetWebhookNotificationTargetEventsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<WebhookNotificationTargetEventFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The connection type for Webhook Notification Targets. */
export type WebhookNotificationTargetConnection = {
  __typename?: "WebhookNotificationTargetConnection";
  /** A list of edges. */
  edges?: Maybe<Array<WebhookNotificationTargetEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for Webhook Notification Target. */
export type WebhookNotificationTargetEdge = {
  __typename?: "WebhookNotificationTargetEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The Webhook Notification Target. */
  node?: Maybe<WebhookNotificationTarget>;
};

/** This type wraps a notification event to indicate that this event should have been delivered to a particular target based on its subscriptions. */
export type WebhookNotificationTargetEvent = {
  __typename?: "WebhookNotificationTargetEvent";
  /** The delivery attempts for this event to this target. */
  deliveryAttempts?: Maybe<DeliveryAttemptConnection>;
  /** The notification event that should have been delivered to the target. */
  event?: Maybe<NotificationEvent>;
  /** Indicates whether the event was delivered to the target. If false, the latest delivery attempt was unsuccessful OR skipped because the target was deactivated. */
  hasSuccessfulDelivery?: Maybe<Scalars["Boolean"]>;
};

/** This type wraps a notification event to indicate that this event should have been delivered to a particular target based on its subscriptions. */
export type WebhookNotificationTargetEventDeliveryAttemptsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The connection type for a `WebhookNotificationTargetEvent` */
export type WebhookNotificationTargetEventConnection = {
  __typename?: "WebhookNotificationTargetEventConnection";
  /** A list of edges. */
  edges?: Maybe<Array<WebhookNotificationTargetEventEdge>>;
  /** Information about the current page. */
  pageInfo: PageInfo;
};

/** The edge type for a `WebhookNotificationTargetEvent` */
export type WebhookNotificationTargetEventEdge = {
  __typename?: "WebhookNotificationTargetEventEdge";
  /** The cursor for this edge for use in pagination. */
  cursor: Scalars["String"];
  /** The WebhookNotificationTargetEvent */
  node?: Maybe<WebhookNotificationTargetEvent>;
};

/** Input for filtering `WebhookNotificationTargetEvent`. */
export type WebhookNotificationTargetEventFilterInput = {
  /** Filter by the createdAt timestamp of the original notification event. */
  eventCreatedAt?: InputMaybe<NotificationTimestampFilterInput>;
  /** Filter for the hasSuccessfulDelivery field on the WebhookNotificationTargetEvent object. */
  hasSuccessfulDelivery?: InputMaybe<Scalars["Boolean"]>;
  /** Filter by the name of the original notification event. */
  name?: InputMaybe<Array<NotificationEventName>>;
};

/** Additional details for wire transfer errors. This will only be relevant when the `WireTransferStatus` is FAILED. */
export enum WireStatusReasonCode {
  /** The Highnote account is closed. */
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  /** The wire was sent to an individual instead of an organization. */
  ACCOUNT_HOLDER_IS_NOT_AN_ORGANIZATION = "ACCOUNT_HOLDER_IS_NOT_AN_ORGANIZATION",
  /** No matching Highnote account. */
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  /** The currency of the wire does not match the currency of the destination account. */
  CURRENCY_MISMATCH = "CURRENCY_MISMATCH",
  /** The receiving account does not have the payroll advance feature enabled. */
  PAYROLL_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED",
}

/** Represents money being moved via wire. */
export type WireTransfer = Node & {
  __typename?: "WireTransfer";
  /** The amount of the transfer. */
  amount?: Maybe<Amount>;
  /** The date and time, in ISO 8601 format, the transfer was created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The `FinancialAccount` effected for this `WireTransfer`. */
  financialAccount?: Maybe<FinancialAccount>;
  /** Global ID used to reference the transfer in operations. */
  id: Scalars["ID"];
  /** The ledgers affected by the transfer. */
  ledgers?: Maybe<Array<Ledger>>;
  /** A memo for the `WireTransfer`. */
  memo?: Maybe<Scalars["String"]>;
  /** The current status of this `WireTransfer`. */
  status?: Maybe<WireTransferStatus>;
  /** The reason for the current status. */
  statusReason?: Maybe<WireTransferStatusReasonCode>;
  /** The type that this `WireTransfer` is. */
  type?: Maybe<WireTransferType>;
  /** The date and time, in ISO 8601 format, the transfer was last updated. */
  updatedAt?: Maybe<Scalars["String"]>;
  /** The `UserDefinedFields` associated with this `WireTransfer`. */
  userDefinedFields?: Maybe<UserDefinedFieldConnection>;
};

/** Represents money being moved via wire. */
export type WireTransferLedgersArgs = {
  ledgerNames?: InputMaybe<Array<LedgerName>>;
};

/** Represents money being moved via wire. */
export type WireTransferUserDefinedFieldsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  filterBy?: InputMaybe<UserDefinedFieldsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
};

/** The details of an `WireTransferReview` initiated by Highnote. */
export type WireTransferReview = Node & {
  __typename?: "WireTransferReview";
  /** The monetary amount wired. */
  amount?: Maybe<Amount>;
  /** The direction of the `WireTransfer` */
  direction?: Maybe<WireTransferReviewDirection>;
  /** The externally generated ID associated with the wire transfer. */
  externalIdentifier?: Maybe<Scalars["String"]>;
  /** The `FinancialAccount` unloading the funds. Only applies to `OUTGOING` `WireTransferReviewDirections`. */
  fromFinancialAccount?: Maybe<FinancialAccount>;
  /** Global ID used to reference the `WireTransferReview`. */
  id: Scalars["ID"];
  /** The memo for this request. */
  memo?: Maybe<Scalars["String"]>;
  /** The `FinancialAccount` receiving funds. Only applies to `INCOMING` `WireTransferReviewDirections`. */
  toFinancialAccount?: Maybe<FinancialAccount>;
};

/** The direction of the `WireTransferReview`. */
export enum WireTransferReviewDirection {
  /** Represents funds being wired into a `FinancialAccount`. */
  INCOMING = "INCOMING",
  /** Represents funds being wired out of a `FinancialAccount`. */
  OUTGOING = "OUTGOING",
}

export type WireTransferReviewItem = WireTransferReview;

/** The status of the wire transfer. */
export enum WireTransferStatus {
  /** The `WireTransfer` is complete. */
  COMPLETED = "COMPLETED",
  /** The `WireTransfer` has failed. */
  FAILED = "FAILED",
  /** The `WireTransfer` is pending. */
  PENDING = "PENDING",
  /** The wire is being processed. */
  PROCESSING = "PROCESSING",
}

/** Details about the status of the wire transfer. */
export type WireTransferStatusDetails =
  | FailureWireTransferStatus
  | NonFailureWireTransferStatus;

/** The reasons a `WireTransfer` could fail. */
export enum WireTransferStatusReasonCode {
  /** The source or receiving account is closed. */
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  /** The receiving account holder is not an Organization. */
  ACCOUNT_HOLDER_IS_NOT_AN_ORGANIZATION = "ACCOUNT_HOLDER_IS_NOT_AN_ORGANIZATION",
  /** The source or receiving account was not found. */
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  /** The source and receiving account have different currency. */
  CURRENCY_MISMATCH = "CURRENCY_MISMATCH",
  /** The source account of the WireTransfer did not have enough funds to cover the requested amount. */
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  /** The receiving account does not have PayrollAdvanceFinancialAccountFeature as enabled. */
  PAYROLL_ADVANCE_FEATURE_NOT_ENABLED = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED",
}

/** The possible types of `WireTransfer`. */
export enum WireTransferType {
  /** Represents an incoming wire transfer. */
  INCOMING_WIRE_TRANSFER = "INCOMING_WIRE_TRANSFER",
  /** Represents an incoming wire transfer reversal. */
  INCOMING_WIRE_TRANSFER_REVERSAL = "INCOMING_WIRE_TRANSFER_REVERSAL",
  /** Represents an outgoing wire transfer. */
  OUTGOING_WIRE_TRANSFER = "OUTGOING_WIRE_TRANSFER",
  /** Represents an incoming wire transfer reversal. */
  OUTGOING_WIRE_TRANSFER_REVERSAL = "OUTGOING_WIRE_TRANSFER_REVERSAL",
}

/**
 * Results from a workflow action related to sending an email notification.
 *
 * This type includes details about the email, such as recipients, sender, provider, and delivery time.
 */
export type WorkflowActionEmailNotificationResult = {
  __typename?: "WorkflowActionEmailNotificationResult";
  /** The date and time when the email notification was delivered, represented as an ISO 8601 string. This field indicates when the email was successfully sent. */
  deliveredAt?: Maybe<Scalars["String"]>;
  /** The sender's email address. This field indicates who sent the email notification. */
  from?: Maybe<Scalars["String"]>;
  /** The provider used to send the email notification. This field references the provider involved in the email delivery process. */
  provider?: Maybe<ProvisionWorkflowProvider>;
  /** The recipient's email addresses. This field specifies where the email notification was sent. */
  to?: Maybe<Array<Scalars["String"]>>;
};

/** Results from a workflow action related to linking an account holder with a verified external bank account. */
export type WorkflowActionLinkVerifiedExternalBankAccountResult = {
  __typename?: "WorkflowActionLinkVerifiedExternalBankAccountResult";
  /** a list of ExternalFinancialBankAccount */
  externalFinancialBankAccounts?: Maybe<Array<ExternalFinancialBankAccount>>;
};

/**
 * Union type representing the possible results from a workflow action.
 *
 * This union can be one of several result types, including email notification results or Visa Payable Automation results.
 */
export type WorkflowActionResult =
  | WorkflowActionEmailNotificationResult
  | WorkflowActionLinkVerifiedExternalBankAccountResult
  | WorkflowActionVisaPayableAutomationResult;

/**
 * Represents the outcome of a workflow action, including metadata and the result.
 *
 * This type includes information about the action's creation and update timestamps, as well as the result of the action.
 */
export type WorkflowActionResultOutcome = {
  __typename?: "WorkflowActionResultOutcome";
  /** The date and time when this result outcome was created, represented in ISO 8601 format. This timestamp indicates when the record was initially created. */
  createdAt?: Maybe<Scalars["String"]>;
  /** The result of the workflow action, which can be one of several possible result types. This field provides the details specific to the action performed. */
  result?: Maybe<WorkflowActionResult>;
  /** The date and time when this result outcome was last updated, represented in ISO 8601 format. This timestamp reflects the most recent modification to the record. */
  updatedAt?: Maybe<Scalars["String"]>;
};

/**
 * Results from a workflow action related to Visa's Payable Automation solution.
 *
 * This type includes details specific to the Visa Payable Automation process, such as buyer and account IDs.
 */
export type WorkflowActionVisaPayableAutomationResult = {
  __typename?: "WorkflowActionVisaPayableAutomationResult";
  /** The unique identifier for the buyer in Visa's Payable Automation system. This ID is used to reference the buyer's account or profile. */
  buyerIdentifier?: Maybe<Scalars["String"]>;
  /** The unique identifier for the proxy pool account in Visa's Payable Automation system. This ID is associated with the proxy account used for transactions or funding. */
  proxyPoolAccountIdentifier?: Maybe<Scalars["String"]>;
};

export type CreateDocumentUploadLinkMutationVariables = Exact<{
  input: CreateDocumentUploadLinkInput;
}>;

export type CreateDocumentUploadLinkMutation = {
  __typename?: "Mutation";
  createDocumentUploadLink?:
    | { __typename: "AccessDeniedError"; message: string }
    | { __typename: "CardArtDocument" }
    | { __typename: "CheckPaymentDocumentUploadSession" }
    | {
        __typename: "DocumentUploadLink";
        id: string;
        uploadUrl?: string | undefined;
        status?: DocumentUploadLinkStatusCode | undefined;
        documentUploadSession?:
          | { __typename?: "CardProfileDocumentUploadSession" }
          | {
              __typename?: "CheckPaymentDocumentUploadSession";
              id: string;
              status?: DocumentUploadSessionStatusCode | undefined;
            }
          | { __typename?: "IdentityVerificationDocumentUploadSession" }
          | { __typename?: "ManualDocumentRequestUploadSession" }
          | {
              __typename?: "USAccountHolderApplicationDocumentUploadSession";
              id: string;
              status?: DocumentUploadSessionStatusCode | undefined;
            }
          | undefined;
      }
    | {
        __typename: "UserError";
        errors?:
          | Array<{
              __typename?: "FieldUserError";
              path?: Array<string> | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type CreateUsPersonAccountHolderMutationVariables = Exact<{
  input: CreateUsPersonAccountHolderInput;
}>;

export type CreateUsPersonAccountHolderMutation = {
  __typename?: "Mutation";
  createUSPersonAccountHolder?:
    | { __typename: "AccessDeniedError" }
    | {
        __typename: "USPersonAccountHolder";
        id: string;
        email?: string | undefined;
        dateOfBirth?: string | undefined;
        externalId?: string | undefined;
        updatedAt?: string | undefined;
        createdAt?: string | undefined;
        name?:
          | {
              __typename?: "Name";
              givenName?: string | undefined;
              familyName?: string | undefined;
              title?: string | undefined;
              suffix?: string | undefined;
              middleName?: string | undefined;
            }
          | undefined;
        billingAddress?:
          | {
              __typename?: "Address";
              streetAddress?: string | undefined;
              extendedAddress?: string | undefined;
              postalCode?: string | undefined;
              region?: string | undefined;
              locality?: string | undefined;
              countryCodeAlpha3?: string | undefined;
            }
          | undefined;
        phoneNumbers?:
          | Array<{
              __typename?: "Phone";
              countryCode?: string | undefined;
              number?: string | undefined;
              label?: PhoneLabel | undefined;
            }>
          | undefined;
        identificationDocument?:
          | {
              __typename?: "USIdentificationDocument";
              socialSecurityNumber?:
                | {
                    __typename?: "TaxIdentificationDocument";
                    numberHash?: string | undefined;
                    countryCodeAlpha3?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | {
        __typename: "UserError";
        errors?:
          | Array<{
              __typename?: "FieldUserError";
              code?: string | undefined;
              description?: string | undefined;
              path?: Array<string> | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type EndDocumentUploadSessionMutationVariables = Exact<{
  input: EndDocumentUploadSessionInput;
}>;

export type EndDocumentUploadSessionMutation = {
  __typename?: "Mutation";
  endDocumentUploadSession?:
    | { __typename: "AccessDeniedError"; message: string }
    | { __typename: "CardProfileDocumentUploadSession" }
    | {
        __typename: "CheckPaymentDocumentUploadSession";
        id: string;
        status?: DocumentUploadSessionStatusCode | undefined;
      }
    | { __typename: "IdentityVerificationDocumentUploadSession" }
    | { __typename: "ManualDocumentRequestUploadSession" }
    | {
        __typename: "USAccountHolderApplicationDocumentUploadSession";
        id: string;
        status?: DocumentUploadSessionStatusCode | undefined;
        primaryDocumentTypes?: Array<DocumentType> | undefined;
        secondaryDocumentTypes?: Array<DocumentType> | undefined;
        supportingDocumentTypes?: Array<DocumentType> | undefined;
        uploadRequirements?:
          | Array<{
              __typename?: "UploadRequirement";
              constraints?:
                | Array<
                    | {
                        __typename?: "DocumentUploadRequirementConstraint";
                        documentType?: DocumentCategoryType | undefined;
                        numberOfDocuments?: number | undefined;
                      }
                    | undefined
                  >
                | undefined;
            }>
          | undefined;
      }
    | {
        __typename: "UserError";
        errors?:
          | Array<{
              __typename?: "FieldUserError";
              path?: Array<string> | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type FindDocumentUploadSessionQueryVariables = Exact<{
  id: Scalars["ID"];
}>;

export type FindDocumentUploadSessionQuery = {
  __typename?: "Query";
  node?:
    | { __typename: "APIKey" }
    | { __typename: "AccountHolderApplicationDocument" }
    | { __typename: "AccountHolderCardProductApplication" }
    | { __typename: "AccountHolderCardProductApplicationOffer" }
    | { __typename: "AccountHolderProvisioning" }
    | { __typename: "AccountHolderProvisioningWorkflowAction" }
    | { __typename: "AccountRelationship" }
    | { __typename: "AccountSpendRule" }
    | { __typename: "AccountStatusActiveEvent" }
    | { __typename: "AccountStatusClosedEvent" }
    | { __typename: "AccountStatusPendingClosureEvent" }
    | { __typename: "AccountStatusSuspendedEvent" }
    | { __typename: "AccountStatusUnderReviewEvent" }
    | { __typename: "AccountTransactionCountSpendRule" }
    | { __typename: "AchExternallyInitatedDepositFailedEvent" }
    | { __typename: "AchExternallyInitatedDepositProcessedEvent" }
    | { __typename: "AchExternallyInitatedDepositReceivedEvent" }
    | { __typename: "AchExternallyInitiatedWithdrawalFailedEvent" }
    | { __typename: "AchExternallyInitiatedWithdrawalProcessedEvent" }
    | { __typename: "AchExternallyInitiatedWithdrawalReceivedEvent" }
    | { __typename: "AchHoldAddedEvent" }
    | { __typename: "AchHoldRemovedEvent" }
    | { __typename: "AchTransferHoldAddedEvent" }
    | { __typename: "AchTransferHoldRemovedEvent" }
    | { __typename: "AdjustmentEvent" }
    | { __typename: "AdminAgentOrganization" }
    | { __typename: "AmountLimitCheckRule" }
    | { __typename: "AmountLimitInterFinancialAccountTransferRule" }
    | { __typename: "AmountLimitSpendRule" }
    | { __typename: "ApplicationContract" }
    | { __typename: "AuthorizationAndClearEvent" }
    | { __typename: "AuthorizationEvent" }
    | { __typename: "AuthorizedUserCardProductApplication" }
    | { __typename: "BalanceInquiryEvent" }
    | { __typename: "Business" }
    | { __typename: "CVVSpendRule" }
    | { __typename: "CardArtDocument" }
    | { __typename: "CardDataInputCapabilitySpendRule" }
    | { __typename: "CardDigitalWalletToken" }
    | { __typename: "CardDigitalWalletTokenActivatedEvent" }
    | { __typename: "CardDigitalWalletTokenSuspendedEvent" }
    | { __typename: "CardDigitalWalletTokenTerminatedEvent" }
    | { __typename: "CardPaymentDispute" }
    | { __typename: "CardPaymentDisputeStageAction" }
    | { __typename: "CardProduct" }
    | { __typename: "CardProfileDocumentUploadSession" }
    | { __typename: "CardProfileSet" }
    | { __typename: "CardProfileSetRestricted" }
    | { __typename: "CardTransactionProcessingTypeConditionSpendRule" }
    | { __typename: "CheckPayment" }
    | {
        __typename: "CheckPaymentDocumentUploadSession";
        id: string;
        status?: DocumentUploadSessionStatusCode | undefined;
        allowedDocumentTypes?: Array<CheckPaymentDocumentType> | undefined;
        documents?:
          | Array<
              | { __typename?: "CardArtDocument" }
              | {
                  __typename: "DocumentUploadLink";
                  id: string;
                  status?: DocumentUploadLinkStatusCode | undefined;
                  documentCategoryType?: DocumentCategoryType | undefined;
                  documentType?: DocumentType | undefined;
                  uploadUrl?: string | undefined;
                  documentUploadSession?:
                    | {
                        __typename?: "CardProfileDocumentUploadSession";
                        id: string;
                        status?: DocumentUploadSessionStatusCode | undefined;
                      }
                    | {
                        __typename?: "CheckPaymentDocumentUploadSession";
                        id: string;
                        status?: DocumentUploadSessionStatusCode | undefined;
                      }
                    | {
                        __typename?: "IdentityVerificationDocumentUploadSession";
                        id: string;
                        status?: DocumentUploadSessionStatusCode | undefined;
                      }
                    | {
                        __typename?: "ManualDocumentRequestUploadSession";
                        id: string;
                        status?: DocumentUploadSessionStatusCode | undefined;
                      }
                    | {
                        __typename?: "USAccountHolderApplicationDocumentUploadSession";
                        id: string;
                        status?: DocumentUploadSessionStatusCode | undefined;
                      }
                    | undefined;
                }
            >
          | undefined;
      }
    | { __typename: "CheckPaymentEvent" }
    | { __typename: "ClearingEvent" }
    | { __typename: "CollaborativeAuthorizationEndpoint" }
    | { __typename: "CommercialChargeCardFinancialAccountStatement" }
    | { __typename: "CommercialRevolvingCardFinancialAccountStatement" }
    | { __typename: "ConditionalRuleSetSpendRule" }
    | { __typename: "ConsumerChargeCardFinancialAccountStatement" }
    | { __typename: "ConsumerPrepaidCardFinancialAccountStatement" }
    | { __typename: "ConsumerRevolvingCardFinancialAccountStatement" }
    | { __typename: "CountLimitCheckRule" }
    | { __typename: "CountLimitInterFinancialAccountTransferRule" }
    | { __typename: "CountLimitSpendRule" }
    | { __typename: "CreditCardTransferEvent" }
    | { __typename: "CreditFunds" }
    | { __typename: "CreditFundsACHTransferEvent" }
    | { __typename: "CreditLedgerEntry" }
    | { __typename: "CreditLimitChangeRequest" }
    | { __typename: "CreditLimitPercentageSpendRule" }
    | { __typename: "CreditPayInFullCardFinancialAccountStatement" }
    | { __typename: "CreditPlan" }
    | { __typename: "CreditPlanTemplate" }
    | { __typename: "CreditTransaction" }
    | { __typename: "CustomerAddress" }
    | { __typename: "CustomerEmailContactMethod" }
    | { __typename: "CustomerName" }
    | { __typename: "CustomerPhone" }
    | { __typename: "CustomerWebsiteContactMethod" }
    | { __typename: "DaysWithinAccountCreateDateSpendRule" }
    | { __typename: "DaysWithinCardCreateDateSpendRule" }
    | { __typename: "DebitFunds" }
    | { __typename: "DebitFundsACHTransferEvent" }
    | { __typename: "DebitLedgerEntry" }
    | { __typename: "DebitTransaction" }
    | { __typename: "DeliveryAttempt" }
    | { __typename: "DepositAmountLimitSpendRule" }
    | { __typename: "DepositCountLimitSpendRule" }
    | { __typename: "DepositProcessingNetworkSpendRule" }
    | { __typename: "DigitalCardProfile" }
    | { __typename: "DirectDepositDetail" }
    | { __typename: "DisbursementTransferEvent" }
    | { __typename: "DocumentUploadLink" }
    | { __typename: "DocumentUploadRequestEvent" }
    | { __typename: "DocumentUploadSessionCompleteEvent" }
    | { __typename: "EmployerFinancialAccount" }
    | { __typename: "EnhancedDataEvent" }
    | { __typename: "ExternalBankAccountAddedEvent" }
    | { __typename: "ExternalBankAccountDetail" }
    | { __typename: "ExternalBankAccountRemovedEvent" }
    | { __typename: "ExternalFinancialBankAccount" }
    | { __typename: "ExternalMoneyMovementTransaction" }
    | { __typename: "ExternalMoneyMovementTransactionEvent" }
    | { __typename: "ExternalPhysicalPaymentCardOrder" }
    | { __typename: "ExternallyInitiatedAchReleaseHoldTransfer" }
    | { __typename: "ExternallyInitiatedWireTransfer" }
    | { __typename: "FeeChargeEvent" }
    | { __typename: "FeeChargeRule" }
    | { __typename: "FeeReversalEvent" }
    | { __typename: "FeeSchedule" }
    | { __typename: "FeeTransferEvent" }
    | { __typename: "FileUploadCompleteEvent" }
    | { __typename: "FinancialAccount" }
    | { __typename: "FinancialAccountCreditLimitUpdateFromProductFunding" }
    | { __typename: "FinancialAccountPseudoBalanceUpdate" }
    | { __typename: "FinancialAccountSnapshot" }
    | { __typename: "FinancialAccountStatementReadyEvent" }
    | { __typename: "FundsDepositCanceledEvent" }
    | { __typename: "FundsDepositFailedEvent" }
    | { __typename: "FundsDepositInitiatedEvent" }
    | { __typename: "FundsDepositProcessedEvent" }
    | { __typename: "FundsDepositProcessingEvent" }
    | { __typename: "FundsDepositReturnedEvent" }
    | { __typename: "FundsWithdrawalCanceledEvent" }
    | { __typename: "FundsWithdrawalFailedEvent" }
    | { __typename: "FundsWithdrawalInitiatedEvent" }
    | { __typename: "FundsWithdrawalProcessedEvent" }
    | { __typename: "FundsWithdrawalProcessingEvent" }
    | { __typename: "FundsWithdrawalReturnedEvent" }
    | { __typename: "IdentityVerificationDocumentUploadSession" }
    | { __typename: "InstallmentAgreement" }
    | { __typename: "InstantNetworkTransfer" }
    | { __typename: "InstantNetworkTransferEvent" }
    | { __typename: "InstantSettlementTransaction" }
    | { __typename: "InstantSettlementTransactionEvent" }
    | { __typename: "IntegratorInitiatedFundsDepositACHTransfer" }
    | { __typename: "IntegratorInitiatedFundsDepositACHTransferEvent" }
    | { __typename: "IntegratorInitiatedFundsWithdrawalACHTransfer" }
    | { __typename: "IntegratorInitiatedFundsWithdrawalACHTransferEvent" }
    | { __typename: "InterFinancialAccountTransfer" }
    | {
        __typename: "InternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountCompletedEvent";
      }
    | {
        __typename: "InternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountFailedEvent";
      }
    | {
        __typename: "InternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountPendingEvent";
      }
    | {
        __typename: "InternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountCompletedEvent";
      }
    | {
        __typename: "InternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountFailedEvent";
      }
    | {
        __typename: "InternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountPendingEvent";
      }
    | { __typename: "IssuerPreliminaryAuthorizationEvent" }
    | { __typename: "JournalEntry" }
    | { __typename: "Ledger" }
    | { __typename: "LinkVerifiedExternalBankAccountFailedEvent" }
    | { __typename: "ManualAdjustmentEvent" }
    | { __typename: "ManualDocumentRequestUploadSession" }
    | { __typename: "MastercardFleetAuthorizationData" }
    | { __typename: "MastercardFleetEnhancedData" }
    | { __typename: "MastercardFraudScoreSpendRule" }
    | { __typename: "MaximumAmountVarianceOnPseudoBalanceSpendRule" }
    | { __typename: "MaximumPercentVarianceOnPseudoBalanceSpendRule" }
    | { __typename: "MerchantCategorySpendRule" }
    | { __typename: "MerchantCountrySpendRule" }
    | { __typename: "MerchantIdentifierSpendRule" }
    | { __typename: "MinimumAmountLimitSpendRule" }
    | { __typename: "NonOriginatedAchTransfer" }
    | { __typename: "NonOriginatedAchTransferFailedEvent" }
    | { __typename: "NonOriginatedAchTransferProcessedEvent" }
    | { __typename: "NonOriginatedAchTransferReceivedEvent" }
    | { __typename: "NonOriginatedAchTransferReturnedEvent" }
    | { __typename: "NonOriginatedAchTransferSnapshot" }
    | { __typename: "NonOriginatedRtpTransfer" }
    | { __typename: "NonOriginatedRtpTransferEvent" }
    | { __typename: "NonVerifiedExternalUSFinancialBankAccount" }
    | { __typename: "NonVerifiedExternalUSFinancialBankAccountDetail" }
    | { __typename: "NotificationEvent" }
    | { __typename: "OnboardingBusinessOrganizationInformation" }
    | { __typename: "OnboardingPreliminaryBusinessInformation" }
    | { __typename: "OneTimeACHTransfer" }
    | { __typename: "Organization" }
    | { __typename: "OriginatedAchTransfer" }
    | { __typename: "OriginatedAchTransferCanceledEvent" }
    | { __typename: "OriginatedAchTransferFailedEvent" }
    | { __typename: "OriginatedAchTransferInitiatedEvent" }
    | { __typename: "OriginatedAchTransferPendingEvent" }
    | { __typename: "OriginatedAchTransferProcessedEvent" }
    | { __typename: "OriginatedAchTransferProcessingEvent" }
    | { __typename: "OriginatedAchTransferReturnedEvent" }
    | { __typename: "OriginatedAchTransferSnapshot" }
    | { __typename: "OriginatedRtpTransfer" }
    | { __typename: "OriginatedRtpTransferEvent" }
    | { __typename: "PanEntryModeSpendRule" }
    | { __typename: "PaymentCard" }
    | { __typename: "PaymentCardActivatedEvent" }
    | { __typename: "PaymentCardAdjustmentEvent" }
    | { __typename: "PaymentCardAuthorizationAndClearApprovedEvent" }
    | { __typename: "PaymentCardAuthorizationAndClearDeclinedEvent" }
    | { __typename: "PaymentCardAuthorizationApprovedEvent" }
    | { __typename: "PaymentCardAuthorizationCreatedEvent" }
    | { __typename: "PaymentCardAuthorizationDeclinedEvent" }
    | { __typename: "PaymentCardAuthorizationReversedEvent" }
    | { __typename: "PaymentCardBinRange" }
    | { __typename: "PaymentCardClearedEvent" }
    | { __typename: "PaymentCardClosedEvent" }
    | { __typename: "PaymentCardEnhancedDataEvent" }
    | { __typename: "PaymentCardIssuedEvent" }
    | { __typename: "PaymentCardSnapshot" }
    | { __typename: "PaymentCardSuspendedEvent" }
    | { __typename: "PaymentCardTransactionChargeback" }
    | { __typename: "PaymentCardTransactionDispute" }
    | { __typename: "PaymentCardUnsuspendedEvent" }
    | { __typename: "PaymentCardVerificationApprovedEvent" }
    | { __typename: "PaymentCardVerificationDeclinedEvent" }
    | { __typename: "PaymentCreditTransaction" }
    | { __typename: "PaymentDebitTransaction" }
    | { __typename: "PaymentMethodToken" }
    | { __typename: "PaymentOrder" }
    | { __typename: "PayrollACHTransferEvent" }
    | { __typename: "PayrollAdvance" }
    | { __typename: "PayrollAdvanceRepaymentCompletedEvent" }
    | { __typename: "PayrollAdvanceRepaymentTransfer" }
    | { __typename: "PayrollAdvanceWriteOffCompletedEvent" }
    | { __typename: "PayrollAdvanceWriteoffTransfer" }
    | { __typename: "PayrollTransfer" }
    | { __typename: "PhysicalCardGroupOrder" }
    | { __typename: "PhysicalCardProfile" }
    | { __typename: "PhysicalPaymentCardGroupOrderShipFailedEvent" }
    | { __typename: "PhysicalPaymentCardGroupOrderShippedEvent" }
    | { __typename: "PhysicalPaymentCardOrder" }
    | { __typename: "PhysicalPaymentCardShipFailedEvent" }
    | { __typename: "PhysicalPaymentCardShippedEvent" }
    | { __typename: "PointOfServiceCategorySpendRule" }
    | { __typename: "PostalCodeVerificationSpendRule" }
    | { __typename: "PricingConfiguration" }
    | { __typename: "PricingPlan" }
    | { __typename: "PricingRule" }
    | { __typename: "ProductApplication" }
    | { __typename: "ProductProfile" }
    | { __typename: "RecurringACHTransfer" }
    | { __typename: "RepaymentFailedEvent" }
    | { __typename: "RepaymentProcessedEvent" }
    | { __typename: "RepaymentProcessingEvent" }
    | { __typename: "RepaymentReturnedEvent" }
    | { __typename: "Report" }
    | { __typename: "RequestedIdentityUpdate" }
    | { __typename: "RestrictedAccountHolderSpendRule" }
    | { __typename: "RestrictedCardHolderSpendRule" }
    | { __typename: "ReversalEvent" }
    | { __typename: "ReviewWorkflowEvent" }
    | { __typename: "RewardDefaultEarnRule" }
    | { __typename: "RewardMerchantCategoryEarnRule" }
    | { __typename: "RewardPointsTransfer" }
    | { __typename: "RewardRedemptionConfiguration" }
    | { __typename: "RiskApplicationSDK" }
    | { __typename: "RiskApplicationSDKRevision" }
    | { __typename: "RuleCollection" }
    | { __typename: "RuleCollectionRevision" }
    | { __typename: "ScheduledTransferAchEvent" }
    | { __typename: "ScriptRealtimeRiskRule" }
    | { __typename: "SecureCardBalanceRepaymentACHTransfer" }
    | { __typename: "SecureCardBalanceRepaymentACHTransferEvent" }
    | { __typename: "SecureDeposit" }
    | { __typename: "SecureDepositACHTransfer" }
    | { __typename: "SecureDepositACHTransferEvent" }
    | { __typename: "SecureDepositCanceledEvent" }
    | { __typename: "SecureDepositFailedEvent" }
    | { __typename: "SecureDepositInitiatedEvent" }
    | { __typename: "SecureDepositProcessedEvent" }
    | { __typename: "SecureDepositProcessingEvent" }
    | { __typename: "SecureDepositReturnedEvent" }
    | { __typename: "SecureDepositTransferEvent" }
    | {
        __typename: "SecuredDepositCommercialCreditCardFinancialAccountStatement";
      }
    | { __typename: "SigningKey" }
    | { __typename: "StreetAddressSpendRule" }
    | { __typename: "Transfer" }
    | { __typename: "TransferPurposeInterFinancialAccountTransferRule" }
    | {
        __typename: "USAccountHolderApplicationDocumentUploadSession";
        id: string;
        status?: DocumentUploadSessionStatusCode | undefined;
        primaryDocumentTypes?: Array<DocumentType> | undefined;
        secondaryDocumentTypes?: Array<DocumentType> | undefined;
        supportingDocumentTypes?: Array<DocumentType> | undefined;
        recommendedDocumentTypes?: Array<DocumentType> | undefined;
        uploadRequirements?:
          | Array<{
              __typename?: "UploadRequirement";
              constraints?:
                | Array<
                    | {
                        __typename?: "DocumentUploadRequirementConstraint";
                        documentType?: DocumentCategoryType | undefined;
                        numberOfDocuments?: number | undefined;
                      }
                    | undefined
                  >
                | undefined;
            }>
          | undefined;
        documents?:
          | Array<
              | { __typename?: "CardArtDocument" }
              | {
                  __typename: "DocumentUploadLink";
                  id: string;
                  status?: DocumentUploadLinkStatusCode | undefined;
                  documentCategoryType?: DocumentCategoryType | undefined;
                  documentType?: DocumentType | undefined;
                  uploadUrl?: string | undefined;
                  documentUploadSession?:
                    | {
                        __typename?: "CardProfileDocumentUploadSession";
                        id: string;
                        status?: DocumentUploadSessionStatusCode | undefined;
                      }
                    | {
                        __typename?: "CheckPaymentDocumentUploadSession";
                        id: string;
                        status?: DocumentUploadSessionStatusCode | undefined;
                      }
                    | {
                        __typename?: "IdentityVerificationDocumentUploadSession";
                        id: string;
                        status?: DocumentUploadSessionStatusCode | undefined;
                      }
                    | {
                        __typename?: "ManualDocumentRequestUploadSession";
                        id: string;
                        status?: DocumentUploadSessionStatusCode | undefined;
                      }
                    | {
                        __typename?: "USAccountHolderApplicationDocumentUploadSession";
                        id: string;
                        status?: DocumentUploadSessionStatusCode | undefined;
                      }
                    | undefined;
                }
            >
          | undefined;
      }
    | { __typename: "USBusinessAccountHolder" }
    | { __typename: "USPersonAccountHolder" }
    | { __typename: "USPersonAuthorizedUser" }
    | { __typename: "UnifiedFundsTransfer" }
    | { __typename: "User" }
    | { __typename: "UserDefinedBooleanField" }
    | { __typename: "UserDefinedFieldDefinition" }
    | { __typename: "UserDefinedIntegerField" }
    | { __typename: "UserDefinedStringField" }
    | { __typename: "ValidatedAddress" }
    | { __typename: "VelocityInterFinancialAccountTransferRule" }
    | { __typename: "VelocityRule" }
    | { __typename: "VendorRelationship" }
    | { __typename: "VerificationEvent" }
    | { __typename: "VirtualCardProfile" }
    | { __typename: "VisaFleetAuthorizationData" }
    | { __typename: "VisaFleetL2TransactionData" }
    | { __typename: "VisaFleetL3EnhancedData" }
    | { __typename: "VisaRiskScoreSpendRule" }
    | { __typename: "WatchlistInterFinancialAccountTransferRule" }
    | { __typename: "WebhookNotificationTarget" }
    | { __typename: "WireTransfer" }
    | { __typename: "WireTransferReview" }
    | undefined;
};

export type StartDocumentUploadSessionMutationVariables = Exact<{
  input: StartDocumentUploadSessionInput;
}>;

export type StartDocumentUploadSessionMutation = {
  __typename?: "Mutation";
  startDocumentUploadSession?:
    | { __typename: "AccessDeniedError"; message: string }
    | { __typename: "CardProfileDocumentUploadSession" }
    | {
        __typename: "CheckPaymentDocumentUploadSession";
        id: string;
        status?: DocumentUploadSessionStatusCode | undefined;
        documents?:
          | Array<
              | {
                  __typename?: "CardArtDocument";
                  id: string;
                  status?: DocumentUploadLinkStatusCode | undefined;
                }
              | {
                  __typename?: "DocumentUploadLink";
                  id: string;
                  status?: DocumentUploadLinkStatusCode | undefined;
                }
            >
          | undefined;
      }
    | { __typename: "IdentityVerificationDocumentUploadSession" }
    | { __typename: "ManualDocumentRequestUploadSession" }
    | {
        __typename: "USAccountHolderApplicationDocumentUploadSession";
        id: string;
        status?: DocumentUploadSessionStatusCode | undefined;
        primaryDocumentTypes?: Array<DocumentType> | undefined;
        secondaryDocumentTypes?: Array<DocumentType> | undefined;
        supportingDocumentTypes?: Array<DocumentType> | undefined;
        documents?:
          | Array<
              | {
                  __typename?: "CardArtDocument";
                  id: string;
                  status?: DocumentUploadLinkStatusCode | undefined;
                }
              | {
                  __typename?: "DocumentUploadLink";
                  id: string;
                  status?: DocumentUploadLinkStatusCode | undefined;
                }
            >
          | undefined;
        uploadRequirements?:
          | Array<{
              __typename?: "UploadRequirement";
              constraints?:
                | Array<
                    | {
                        __typename?: "DocumentUploadRequirementConstraint";
                        documentType?: DocumentCategoryType | undefined;
                        numberOfDocuments?: number | undefined;
                      }
                    | undefined
                  >
                | undefined;
            }>
          | undefined;
      }
    | {
        __typename: "UserError";
        errors?:
          | Array<{
              __typename?: "FieldUserError";
              path?: Array<string> | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type TokenizePaymentCardMutationVariables = Exact<{
  input: TokenizeCardPaymentMethodInput;
}>;

export type TokenizePaymentCardMutation = {
  __typename?: "Mutation";
  tokenizeCardPaymentMethod?:
    | { __typename: "AccessDeniedError" }
    | {
        __typename: "PaymentMethodToken";
        id: string;
        usage?: PaymentMethodTokenUsage | undefined;
        instrument?:
          | {
              __typename?: "PaymentCardInstrument";
              brand?: AcquiringPaymentCardBrand | undefined;
              last4?: string | undefined;
              cardHolder?:
                | {
                    __typename?: "CardHolder";
                    fullName?: string | undefined;
                    billingAddress?:
                      | {
                          __typename?: "Address";
                          streetAddress?: string | undefined;
                          countryCodeAlpha3?: string | undefined;
                          extendedAddress?: string | undefined;
                          locality?: string | undefined;
                          region?: string | undefined;
                          postalCode?: string | undefined;
                        }
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | {
        __typename: "UserError";
        errors?:
          | Array<{
              __typename?: "FieldUserError";
              code?: string | undefined;
              description?: string | undefined;
              errorPath?: Array<string> | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type UpdatePinForPaymentCardInSecureInputsSdkMutationVariables = Exact<{
  input: SetPinForPaymentCardInput;
}>;

export type UpdatePinForPaymentCardInSecureInputsSdkMutation = {
  __typename?: "Mutation";
  setPinForPaymentCard?:
    | { __typename: "AccessDeniedError" }
    | {
        __typename: "PaymentCard";
        id: string;
        bin?: string | undefined;
        last4?: string | undefined;
      }
    | {
        __typename: "UserError";
        errors?:
          | Array<{
              __typename?: "FieldUserError";
              path?: Array<string> | undefined;
              code?: string | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type ViewPaymentCardForSdkQueryVariables = Exact<{
  id: Scalars["ID"];
}>;

export type ViewPaymentCardForSdkQuery = {
  __typename?: "Query";
  node?:
    | { __typename?: "APIKey" }
    | { __typename?: "AccountHolderApplicationDocument" }
    | { __typename?: "AccountHolderCardProductApplication" }
    | { __typename?: "AccountHolderCardProductApplicationOffer" }
    | { __typename?: "AccountHolderProvisioning" }
    | { __typename?: "AccountHolderProvisioningWorkflowAction" }
    | { __typename?: "AccountRelationship" }
    | { __typename?: "AccountSpendRule" }
    | { __typename?: "AccountStatusActiveEvent" }
    | { __typename?: "AccountStatusClosedEvent" }
    | { __typename?: "AccountStatusPendingClosureEvent" }
    | { __typename?: "AccountStatusSuspendedEvent" }
    | { __typename?: "AccountStatusUnderReviewEvent" }
    | { __typename?: "AccountTransactionCountSpendRule" }
    | { __typename?: "AchExternallyInitatedDepositFailedEvent" }
    | { __typename?: "AchExternallyInitatedDepositProcessedEvent" }
    | { __typename?: "AchExternallyInitatedDepositReceivedEvent" }
    | { __typename?: "AchExternallyInitiatedWithdrawalFailedEvent" }
    | { __typename?: "AchExternallyInitiatedWithdrawalProcessedEvent" }
    | { __typename?: "AchExternallyInitiatedWithdrawalReceivedEvent" }
    | { __typename?: "AchHoldAddedEvent" }
    | { __typename?: "AchHoldRemovedEvent" }
    | { __typename?: "AchTransferHoldAddedEvent" }
    | { __typename?: "AchTransferHoldRemovedEvent" }
    | { __typename?: "AdjustmentEvent" }
    | { __typename?: "AdminAgentOrganization" }
    | { __typename?: "AmountLimitCheckRule" }
    | { __typename?: "AmountLimitInterFinancialAccountTransferRule" }
    | { __typename?: "AmountLimitSpendRule" }
    | { __typename?: "ApplicationContract" }
    | { __typename?: "AuthorizationAndClearEvent" }
    | { __typename?: "AuthorizationEvent" }
    | { __typename?: "AuthorizedUserCardProductApplication" }
    | { __typename?: "BalanceInquiryEvent" }
    | { __typename?: "Business" }
    | { __typename?: "CVVSpendRule" }
    | { __typename?: "CardArtDocument" }
    | { __typename?: "CardDataInputCapabilitySpendRule" }
    | { __typename?: "CardDigitalWalletToken" }
    | { __typename?: "CardDigitalWalletTokenActivatedEvent" }
    | { __typename?: "CardDigitalWalletTokenSuspendedEvent" }
    | { __typename?: "CardDigitalWalletTokenTerminatedEvent" }
    | { __typename?: "CardPaymentDispute" }
    | { __typename?: "CardPaymentDisputeStageAction" }
    | { __typename?: "CardProduct" }
    | { __typename?: "CardProfileDocumentUploadSession" }
    | { __typename?: "CardProfileSet" }
    | { __typename?: "CardProfileSetRestricted" }
    | { __typename?: "CardTransactionProcessingTypeConditionSpendRule" }
    | { __typename?: "CheckPayment" }
    | { __typename?: "CheckPaymentDocumentUploadSession" }
    | { __typename?: "CheckPaymentEvent" }
    | { __typename?: "ClearingEvent" }
    | { __typename?: "CollaborativeAuthorizationEndpoint" }
    | { __typename?: "CommercialChargeCardFinancialAccountStatement" }
    | { __typename?: "CommercialRevolvingCardFinancialAccountStatement" }
    | { __typename?: "ConditionalRuleSetSpendRule" }
    | { __typename?: "ConsumerChargeCardFinancialAccountStatement" }
    | { __typename?: "ConsumerPrepaidCardFinancialAccountStatement" }
    | { __typename?: "ConsumerRevolvingCardFinancialAccountStatement" }
    | { __typename?: "CountLimitCheckRule" }
    | { __typename?: "CountLimitInterFinancialAccountTransferRule" }
    | { __typename?: "CountLimitSpendRule" }
    | { __typename?: "CreditCardTransferEvent" }
    | { __typename?: "CreditFunds" }
    | { __typename?: "CreditFundsACHTransferEvent" }
    | { __typename?: "CreditLedgerEntry" }
    | { __typename?: "CreditLimitChangeRequest" }
    | { __typename?: "CreditLimitPercentageSpendRule" }
    | { __typename?: "CreditPayInFullCardFinancialAccountStatement" }
    | { __typename?: "CreditPlan" }
    | { __typename?: "CreditPlanTemplate" }
    | { __typename?: "CreditTransaction" }
    | { __typename?: "CustomerAddress" }
    | { __typename?: "CustomerEmailContactMethod" }
    | { __typename?: "CustomerName" }
    | { __typename?: "CustomerPhone" }
    | { __typename?: "CustomerWebsiteContactMethod" }
    | { __typename?: "DaysWithinAccountCreateDateSpendRule" }
    | { __typename?: "DaysWithinCardCreateDateSpendRule" }
    | { __typename?: "DebitFunds" }
    | { __typename?: "DebitFundsACHTransferEvent" }
    | { __typename?: "DebitLedgerEntry" }
    | { __typename?: "DebitTransaction" }
    | { __typename?: "DeliveryAttempt" }
    | { __typename?: "DepositAmountLimitSpendRule" }
    | { __typename?: "DepositCountLimitSpendRule" }
    | { __typename?: "DepositProcessingNetworkSpendRule" }
    | { __typename?: "DigitalCardProfile" }
    | { __typename?: "DirectDepositDetail" }
    | { __typename?: "DisbursementTransferEvent" }
    | { __typename?: "DocumentUploadLink" }
    | { __typename?: "DocumentUploadRequestEvent" }
    | { __typename?: "DocumentUploadSessionCompleteEvent" }
    | { __typename?: "EmployerFinancialAccount" }
    | { __typename?: "EnhancedDataEvent" }
    | { __typename?: "ExternalBankAccountAddedEvent" }
    | { __typename?: "ExternalBankAccountDetail" }
    | { __typename?: "ExternalBankAccountRemovedEvent" }
    | { __typename?: "ExternalFinancialBankAccount" }
    | { __typename?: "ExternalMoneyMovementTransaction" }
    | { __typename?: "ExternalMoneyMovementTransactionEvent" }
    | { __typename?: "ExternalPhysicalPaymentCardOrder" }
    | { __typename?: "ExternallyInitiatedAchReleaseHoldTransfer" }
    | { __typename?: "ExternallyInitiatedWireTransfer" }
    | { __typename?: "FeeChargeEvent" }
    | { __typename?: "FeeChargeRule" }
    | { __typename?: "FeeReversalEvent" }
    | { __typename?: "FeeSchedule" }
    | { __typename?: "FeeTransferEvent" }
    | { __typename?: "FileUploadCompleteEvent" }
    | { __typename?: "FinancialAccount" }
    | { __typename?: "FinancialAccountCreditLimitUpdateFromProductFunding" }
    | { __typename?: "FinancialAccountPseudoBalanceUpdate" }
    | { __typename?: "FinancialAccountSnapshot" }
    | { __typename?: "FinancialAccountStatementReadyEvent" }
    | { __typename?: "FundsDepositCanceledEvent" }
    | { __typename?: "FundsDepositFailedEvent" }
    | { __typename?: "FundsDepositInitiatedEvent" }
    | { __typename?: "FundsDepositProcessedEvent" }
    | { __typename?: "FundsDepositProcessingEvent" }
    | { __typename?: "FundsDepositReturnedEvent" }
    | { __typename?: "FundsWithdrawalCanceledEvent" }
    | { __typename?: "FundsWithdrawalFailedEvent" }
    | { __typename?: "FundsWithdrawalInitiatedEvent" }
    | { __typename?: "FundsWithdrawalProcessedEvent" }
    | { __typename?: "FundsWithdrawalProcessingEvent" }
    | { __typename?: "FundsWithdrawalReturnedEvent" }
    | { __typename?: "IdentityVerificationDocumentUploadSession" }
    | { __typename?: "InstallmentAgreement" }
    | { __typename?: "InstantNetworkTransfer" }
    | { __typename?: "InstantNetworkTransferEvent" }
    | { __typename?: "InstantSettlementTransaction" }
    | { __typename?: "InstantSettlementTransactionEvent" }
    | { __typename?: "IntegratorInitiatedFundsDepositACHTransfer" }
    | { __typename?: "IntegratorInitiatedFundsDepositACHTransferEvent" }
    | { __typename?: "IntegratorInitiatedFundsWithdrawalACHTransfer" }
    | { __typename?: "IntegratorInitiatedFundsWithdrawalACHTransferEvent" }
    | { __typename?: "InterFinancialAccountTransfer" }
    | {
        __typename?: "InternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountCompletedEvent";
      }
    | {
        __typename?: "InternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountFailedEvent";
      }
    | {
        __typename?: "InternalTransferFromFundingFinancialAccountToPaymentCardFinancialAccountPendingEvent";
      }
    | {
        __typename?: "InternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountCompletedEvent";
      }
    | {
        __typename?: "InternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountFailedEvent";
      }
    | {
        __typename?: "InternalTransferFromPaymentCardFinancialAccountToFundingFinancialAccountPendingEvent";
      }
    | { __typename?: "IssuerPreliminaryAuthorizationEvent" }
    | { __typename?: "JournalEntry" }
    | { __typename?: "Ledger" }
    | { __typename?: "LinkVerifiedExternalBankAccountFailedEvent" }
    | { __typename?: "ManualAdjustmentEvent" }
    | { __typename?: "ManualDocumentRequestUploadSession" }
    | { __typename?: "MastercardFleetAuthorizationData" }
    | { __typename?: "MastercardFleetEnhancedData" }
    | { __typename?: "MastercardFraudScoreSpendRule" }
    | { __typename?: "MaximumAmountVarianceOnPseudoBalanceSpendRule" }
    | { __typename?: "MaximumPercentVarianceOnPseudoBalanceSpendRule" }
    | { __typename?: "MerchantCategorySpendRule" }
    | { __typename?: "MerchantCountrySpendRule" }
    | { __typename?: "MerchantIdentifierSpendRule" }
    | { __typename?: "MinimumAmountLimitSpendRule" }
    | { __typename?: "NonOriginatedAchTransfer" }
    | { __typename?: "NonOriginatedAchTransferFailedEvent" }
    | { __typename?: "NonOriginatedAchTransferProcessedEvent" }
    | { __typename?: "NonOriginatedAchTransferReceivedEvent" }
    | { __typename?: "NonOriginatedAchTransferReturnedEvent" }
    | { __typename?: "NonOriginatedAchTransferSnapshot" }
    | { __typename?: "NonOriginatedRtpTransfer" }
    | { __typename?: "NonOriginatedRtpTransferEvent" }
    | { __typename?: "NonVerifiedExternalUSFinancialBankAccount" }
    | { __typename?: "NonVerifiedExternalUSFinancialBankAccountDetail" }
    | { __typename?: "NotificationEvent" }
    | { __typename?: "OnboardingBusinessOrganizationInformation" }
    | { __typename?: "OnboardingPreliminaryBusinessInformation" }
    | { __typename?: "OneTimeACHTransfer" }
    | { __typename?: "Organization" }
    | { __typename?: "OriginatedAchTransfer" }
    | { __typename?: "OriginatedAchTransferCanceledEvent" }
    | { __typename?: "OriginatedAchTransferFailedEvent" }
    | { __typename?: "OriginatedAchTransferInitiatedEvent" }
    | { __typename?: "OriginatedAchTransferPendingEvent" }
    | { __typename?: "OriginatedAchTransferProcessedEvent" }
    | { __typename?: "OriginatedAchTransferProcessingEvent" }
    | { __typename?: "OriginatedAchTransferReturnedEvent" }
    | { __typename?: "OriginatedAchTransferSnapshot" }
    | { __typename?: "OriginatedRtpTransfer" }
    | { __typename?: "OriginatedRtpTransferEvent" }
    | { __typename?: "PanEntryModeSpendRule" }
    | {
        __typename: "PaymentCard";
        id: string;
        bin?: string | undefined;
        last4?: string | undefined;
        expirationMonth?: string | undefined;
        expirationYear?: string | undefined;
        restrictedDetails?:
          | { __typename?: "AccessDeniedError" }
          | {
              __typename: "PaymentCardRestrictedDetails";
              number?: string | undefined;
              cvv?: string | undefined;
            }
          | undefined;
      }
    | { __typename?: "PaymentCardActivatedEvent" }
    | { __typename?: "PaymentCardAdjustmentEvent" }
    | { __typename?: "PaymentCardAuthorizationAndClearApprovedEvent" }
    | { __typename?: "PaymentCardAuthorizationAndClearDeclinedEvent" }
    | { __typename?: "PaymentCardAuthorizationApprovedEvent" }
    | { __typename?: "PaymentCardAuthorizationCreatedEvent" }
    | { __typename?: "PaymentCardAuthorizationDeclinedEvent" }
    | { __typename?: "PaymentCardAuthorizationReversedEvent" }
    | { __typename?: "PaymentCardBinRange" }
    | { __typename?: "PaymentCardClearedEvent" }
    | { __typename?: "PaymentCardClosedEvent" }
    | { __typename?: "PaymentCardEnhancedDataEvent" }
    | { __typename?: "PaymentCardIssuedEvent" }
    | { __typename?: "PaymentCardSnapshot" }
    | { __typename?: "PaymentCardSuspendedEvent" }
    | { __typename?: "PaymentCardTransactionChargeback" }
    | { __typename?: "PaymentCardTransactionDispute" }
    | { __typename?: "PaymentCardUnsuspendedEvent" }
    | { __typename?: "PaymentCardVerificationApprovedEvent" }
    | { __typename?: "PaymentCardVerificationDeclinedEvent" }
    | { __typename?: "PaymentCreditTransaction" }
    | { __typename?: "PaymentDebitTransaction" }
    | { __typename?: "PaymentMethodToken" }
    | { __typename?: "PaymentOrder" }
    | { __typename?: "PayrollACHTransferEvent" }
    | { __typename?: "PayrollAdvance" }
    | { __typename?: "PayrollAdvanceRepaymentCompletedEvent" }
    | { __typename?: "PayrollAdvanceRepaymentTransfer" }
    | { __typename?: "PayrollAdvanceWriteOffCompletedEvent" }
    | { __typename?: "PayrollAdvanceWriteoffTransfer" }
    | { __typename?: "PayrollTransfer" }
    | { __typename?: "PhysicalCardGroupOrder" }
    | { __typename?: "PhysicalCardProfile" }
    | { __typename?: "PhysicalPaymentCardGroupOrderShipFailedEvent" }
    | { __typename?: "PhysicalPaymentCardGroupOrderShippedEvent" }
    | { __typename?: "PhysicalPaymentCardOrder" }
    | { __typename?: "PhysicalPaymentCardShipFailedEvent" }
    | { __typename?: "PhysicalPaymentCardShippedEvent" }
    | { __typename?: "PointOfServiceCategorySpendRule" }
    | { __typename?: "PostalCodeVerificationSpendRule" }
    | { __typename?: "PricingConfiguration" }
    | { __typename?: "PricingPlan" }
    | { __typename?: "PricingRule" }
    | { __typename?: "ProductApplication" }
    | { __typename?: "ProductProfile" }
    | { __typename?: "RecurringACHTransfer" }
    | { __typename?: "RepaymentFailedEvent" }
    | { __typename?: "RepaymentProcessedEvent" }
    | { __typename?: "RepaymentProcessingEvent" }
    | { __typename?: "RepaymentReturnedEvent" }
    | { __typename?: "Report" }
    | { __typename?: "RequestedIdentityUpdate" }
    | { __typename?: "RestrictedAccountHolderSpendRule" }
    | { __typename?: "RestrictedCardHolderSpendRule" }
    | { __typename?: "ReversalEvent" }
    | { __typename?: "ReviewWorkflowEvent" }
    | { __typename?: "RewardDefaultEarnRule" }
    | { __typename?: "RewardMerchantCategoryEarnRule" }
    | { __typename?: "RewardPointsTransfer" }
    | { __typename?: "RewardRedemptionConfiguration" }
    | { __typename?: "RiskApplicationSDK" }
    | { __typename?: "RiskApplicationSDKRevision" }
    | { __typename?: "RuleCollection" }
    | { __typename?: "RuleCollectionRevision" }
    | { __typename?: "ScheduledTransferAchEvent" }
    | { __typename?: "ScriptRealtimeRiskRule" }
    | { __typename?: "SecureCardBalanceRepaymentACHTransfer" }
    | { __typename?: "SecureCardBalanceRepaymentACHTransferEvent" }
    | { __typename?: "SecureDeposit" }
    | { __typename?: "SecureDepositACHTransfer" }
    | { __typename?: "SecureDepositACHTransferEvent" }
    | { __typename?: "SecureDepositCanceledEvent" }
    | { __typename?: "SecureDepositFailedEvent" }
    | { __typename?: "SecureDepositInitiatedEvent" }
    | { __typename?: "SecureDepositProcessedEvent" }
    | { __typename?: "SecureDepositProcessingEvent" }
    | { __typename?: "SecureDepositReturnedEvent" }
    | { __typename?: "SecureDepositTransferEvent" }
    | {
        __typename?: "SecuredDepositCommercialCreditCardFinancialAccountStatement";
      }
    | { __typename?: "SigningKey" }
    | { __typename?: "StreetAddressSpendRule" }
    | { __typename?: "Transfer" }
    | { __typename?: "TransferPurposeInterFinancialAccountTransferRule" }
    | { __typename?: "USAccountHolderApplicationDocumentUploadSession" }
    | { __typename?: "USBusinessAccountHolder" }
    | { __typename?: "USPersonAccountHolder" }
    | { __typename?: "USPersonAuthorizedUser" }
    | { __typename?: "UnifiedFundsTransfer" }
    | { __typename?: "User" }
    | { __typename?: "UserDefinedBooleanField" }
    | { __typename?: "UserDefinedFieldDefinition" }
    | { __typename?: "UserDefinedIntegerField" }
    | { __typename?: "UserDefinedStringField" }
    | { __typename?: "ValidatedAddress" }
    | { __typename?: "VelocityInterFinancialAccountTransferRule" }
    | { __typename?: "VelocityRule" }
    | { __typename?: "VendorRelationship" }
    | { __typename?: "VerificationEvent" }
    | { __typename?: "VirtualCardProfile" }
    | { __typename?: "VisaFleetAuthorizationData" }
    | { __typename?: "VisaFleetL2TransactionData" }
    | { __typename?: "VisaFleetL3EnhancedData" }
    | { __typename?: "VisaRiskScoreSpendRule" }
    | { __typename?: "WatchlistInterFinancialAccountTransferRule" }
    | { __typename?: "WebhookNotificationTarget" }
    | { __typename?: "WireTransfer" }
    | { __typename?: "WireTransferReview" }
    | undefined;
};

export const CreateDocumentUploadLinkDocument = gql`
  mutation createDocumentUploadLink($input: CreateDocumentUploadLinkInput!) {
    createDocumentUploadLink(input: $input) {
      __typename
      ... on DocumentUploadLink {
        id
        uploadUrl
        documentUploadSession {
          ... on CheckPaymentDocumentUploadSession {
            id
            status
          }
          ... on USAccountHolderApplicationDocumentUploadSession {
            id
            status
          }
        }
        status
      }
      ... on UserError {
        errors {
          path
        }
      }
      ... on AccessDeniedError {
        message
      }
    }
  }
`;
export const CreateUsPersonAccountHolderDocument = gql`
  mutation createUSPersonAccountHolder(
    $input: CreateUSPersonAccountHolderInput!
  ) {
    createUSPersonAccountHolder(input: $input) {
      __typename
      ... on UserError {
        errors {
          code
          description
          path
        }
      }
      ... on USPersonAccountHolder {
        id
        email
        dateOfBirth
        externalId
        updatedAt
        createdAt
        name {
          givenName
          familyName
          title
          suffix
          middleName
        }
        billingAddress {
          streetAddress
          extendedAddress
          postalCode
          region
          locality
          countryCodeAlpha3
        }
        phoneNumbers {
          countryCode
          number
          label
        }
        identificationDocument {
          socialSecurityNumber {
            numberHash
            countryCodeAlpha3
          }
        }
      }
    }
  }
`;
export const EndDocumentUploadSessionDocument = gql`
  mutation endDocumentUploadSession($input: EndDocumentUploadSessionInput!) {
    endDocumentUploadSession(input: $input) {
      __typename
      ... on CheckPaymentDocumentUploadSession {
        id
        status
      }
      ... on USAccountHolderApplicationDocumentUploadSession {
        __typename
        id
        status
        primaryDocumentTypes
        secondaryDocumentTypes
        supportingDocumentTypes
        uploadRequirements {
          constraints {
            ... on DocumentUploadRequirementConstraint {
              documentType
              numberOfDocuments
            }
          }
        }
      }
      ... on UserError {
        __typename
        errors {
          path
        }
      }
      ... on AccessDeniedError {
        __typename
        message
      }
    }
  }
`;
export const FindDocumentUploadSessionDocument = gql`
  query FindDocumentUploadSession($id: ID!) {
    node(id: $id) {
      __typename
      ... on CheckPaymentDocumentUploadSession {
        id
        status
        allowedDocumentTypes
        documents {
          ... on DocumentUploadLink {
            __typename
            id
            status
            documentCategoryType
            documentType
            status
            documentUploadSession {
              id
              status
            }
            uploadUrl
          }
        }
      }
      ... on USAccountHolderApplicationDocumentUploadSession {
        __typename
        id
        status
        primaryDocumentTypes
        secondaryDocumentTypes
        supportingDocumentTypes
        recommendedDocumentTypes
        uploadRequirements {
          constraints {
            ... on DocumentUploadRequirementConstraint {
              documentType
              numberOfDocuments
            }
          }
        }
        documents {
          ... on DocumentUploadLink {
            __typename
            id
            status
            documentCategoryType
            documentType
            status
            documentUploadSession {
              id
              status
            }
            uploadUrl
          }
        }
      }
    }
  }
`;
export const StartDocumentUploadSessionDocument = gql`
  mutation startDocumentUploadSession(
    $input: StartDocumentUploadSessionInput!
  ) {
    startDocumentUploadSession(input: $input) {
      __typename
      ... on CheckPaymentDocumentUploadSession {
        id
        status
        documents {
          id
          status
        }
      }
      ... on USAccountHolderApplicationDocumentUploadSession {
        id
        status
        primaryDocumentTypes
        secondaryDocumentTypes
        supportingDocumentTypes
        documents {
          id
          status
        }
        uploadRequirements {
          constraints {
            ... on DocumentUploadRequirementConstraint {
              documentType
              numberOfDocuments
            }
          }
        }
      }
      ... on UserError {
        errors {
          path
        }
      }
      ... on AccessDeniedError {
        message
      }
    }
  }
`;
export const TokenizePaymentCardDocument = gql`
  mutation TokenizePaymentCard($input: TokenizeCardPaymentMethodInput!) {
    tokenizeCardPaymentMethod(input: $input) {
      __typename
      ... on UserError {
        errors {
          code
          description
          errorPath
        }
      }
      ... on PaymentMethodToken {
        id
        instrument {
          ... on PaymentCardInstrument {
            brand
            last4
            cardHolder {
              fullName
              billingAddress {
                streetAddress
                countryCodeAlpha3
                extendedAddress
                locality
                region
                postalCode
              }
            }
          }
        }
        usage
      }
    }
  }
`;
export const UpdatePinForPaymentCardInSecureInputsSdkDocument = gql`
  mutation UpdatePinForPaymentCardInSecureInputsSdk(
    $input: SetPinForPaymentCardInput!
  ) {
    setPinForPaymentCard(input: $input) {
      __typename
      ... on PaymentCard {
        id
        bin
        last4
      }
      ... on UserError {
        errors {
          path
          code
        }
      }
    }
  }
`;
export const ViewPaymentCardForSdkDocument = gql`
  query ViewPaymentCardForSdk($id: ID!) {
    node(id: $id) {
      ... on PaymentCard {
        __typename
        id
        bin
        last4
        expirationMonth
        expirationYear
        restrictedDetails {
          ... on PaymentCardRestrictedDetails {
            __typename
            number
            cvv
          }
        }
      }
    }
  }
`;

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string
) => Promise<T>;

const defaultWrapper: SdkFunctionWrapper = (
  action,
  _operationName,
  _operationType
) => action();
const CreateDocumentUploadLinkDocumentString = print(
  CreateDocumentUploadLinkDocument
);
const CreateUsPersonAccountHolderDocumentString = print(
  CreateUsPersonAccountHolderDocument
);
const EndDocumentUploadSessionDocumentString = print(
  EndDocumentUploadSessionDocument
);
const FindDocumentUploadSessionDocumentString = print(
  FindDocumentUploadSessionDocument
);
const StartDocumentUploadSessionDocumentString = print(
  StartDocumentUploadSessionDocument
);
const TokenizePaymentCardDocumentString = print(TokenizePaymentCardDocument);
const UpdatePinForPaymentCardInSecureInputsSdkDocumentString = print(
  UpdatePinForPaymentCardInSecureInputsSdkDocument
);
const ViewPaymentCardForSdkDocumentString = print(
  ViewPaymentCardForSdkDocument
);
export function getSdk(
  client: GraphQLClient,
  withWrapper: SdkFunctionWrapper = defaultWrapper
) {
  return {
    createDocumentUploadLink(
      variables: CreateDocumentUploadLinkMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"]
    ): Promise<{
      data: CreateDocumentUploadLinkMutation;
      extensions?: any;
      headers: Dom.Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<CreateDocumentUploadLinkMutation>(
            CreateDocumentUploadLinkDocumentString,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        "createDocumentUploadLink",
        "mutation"
      );
    },
    createUSPersonAccountHolder(
      variables: CreateUsPersonAccountHolderMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"]
    ): Promise<{
      data: CreateUsPersonAccountHolderMutation;
      extensions?: any;
      headers: Dom.Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<CreateUsPersonAccountHolderMutation>(
            CreateUsPersonAccountHolderDocumentString,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        "createUSPersonAccountHolder",
        "mutation"
      );
    },
    endDocumentUploadSession(
      variables: EndDocumentUploadSessionMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"]
    ): Promise<{
      data: EndDocumentUploadSessionMutation;
      extensions?: any;
      headers: Dom.Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<EndDocumentUploadSessionMutation>(
            EndDocumentUploadSessionDocumentString,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        "endDocumentUploadSession",
        "mutation"
      );
    },
    FindDocumentUploadSession(
      variables: FindDocumentUploadSessionQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"]
    ): Promise<{
      data: FindDocumentUploadSessionQuery;
      extensions?: any;
      headers: Dom.Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<FindDocumentUploadSessionQuery>(
            FindDocumentUploadSessionDocumentString,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        "FindDocumentUploadSession",
        "query"
      );
    },
    startDocumentUploadSession(
      variables: StartDocumentUploadSessionMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"]
    ): Promise<{
      data: StartDocumentUploadSessionMutation;
      extensions?: any;
      headers: Dom.Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<StartDocumentUploadSessionMutation>(
            StartDocumentUploadSessionDocumentString,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        "startDocumentUploadSession",
        "mutation"
      );
    },
    TokenizePaymentCard(
      variables: TokenizePaymentCardMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"]
    ): Promise<{
      data: TokenizePaymentCardMutation;
      extensions?: any;
      headers: Dom.Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<TokenizePaymentCardMutation>(
            TokenizePaymentCardDocumentString,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        "TokenizePaymentCard",
        "mutation"
      );
    },
    UpdatePinForPaymentCardInSecureInputsSdk(
      variables: UpdatePinForPaymentCardInSecureInputsSdkMutationVariables,
      requestHeaders?: Dom.RequestInit["headers"]
    ): Promise<{
      data: UpdatePinForPaymentCardInSecureInputsSdkMutation;
      extensions?: any;
      headers: Dom.Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<UpdatePinForPaymentCardInSecureInputsSdkMutation>(
            UpdatePinForPaymentCardInSecureInputsSdkDocumentString,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        "UpdatePinForPaymentCardInSecureInputsSdk",
        "mutation"
      );
    },
    ViewPaymentCardForSdk(
      variables: ViewPaymentCardForSdkQueryVariables,
      requestHeaders?: Dom.RequestInit["headers"]
    ): Promise<{
      data: ViewPaymentCardForSdkQuery;
      extensions?: any;
      headers: Dom.Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<ViewPaymentCardForSdkQuery>(
            ViewPaymentCardForSdkDocumentString,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        "ViewPaymentCardForSdk",
        "query"
      );
    },
  };
}
export type Sdk = ReturnType<typeof getSdk>;
